webpackJsonp([213534597649335,201563372448855,183328146348521],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = deprecated;
	
	var _warning = __webpack_require__(41);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getField;
	/** @module utils/getField */
	
	/**
	 * Gets the current field for a component that can the field
	 * as either uncontrolled or controlled.
	 *
	 * @param {Object} props - the props object.
	 * @param {Object} state = the state object.
	 * @param {string=} field - the field to extract a value from. Defaults to 'value'.
	 *
	 * @return the field's value.
	 */
	function getField(props, state) {
	  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
	
	  return typeof props[field] !== 'undefined' ? props[field] : state[field];
	}
	//# sourceMappingURL=getField.js.map

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = themeColors;
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This is a utility function to apply the different text colors as a class name.
	 *
	 * @param {Object} options - The options to use to figure out which styles to apply.
	 * @param {boolean?} options.text - Boolean if the base text color should attempt to be
	 *    applied. This will only be applied if all the other states are not true.
	 * @param {boolean?} options.disabled - Boolean if the text should be disabled.
	 * @param {boolean?} options.error - Boolean if the error color should attempt to be applied.
	 *    This will only be applied if the disabled state is false.
	 * @param {boolean?} options.primary - Boolean if the primary color should be applied. This
	 *    will only be applied if all the other states are false.
	 * @param {boolean?} options.secondary - Boolean if the secondary color should be applied.
	 *    This will only be applied if all the other states are false.
	 * @param {boolean?} options.inherit - Boolean if the color should be inherited by a parent.
	 *    This will only be applied if the error and disabled states are false.
	 * @return {String} the class name
	 */
	function themeColors() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$themeText = _ref.themeText,
	      themeText = _ref$themeText === undefined ? true : _ref$themeText,
	      _ref$text = _ref.text,
	      text = _ref$text === undefined ? false : _ref$text,
	      _ref$background = _ref.background,
	      background = _ref$background === undefined ? false : _ref$background,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === undefined ? false : _ref$disabled,
	      _ref$error = _ref.error,
	      error = _ref$error === undefined ? false : _ref$error,
	      _ref$hint = _ref.hint,
	      hint = _ref$hint === undefined ? false : _ref$hint,
	      _ref$primary = _ref.primary,
	      primary = _ref$primary === undefined ? false : _ref$primary,
	      _ref$secondary = _ref.secondary,
	      secondary = _ref$secondary === undefined ? false : _ref$secondary,
	      _ref$inherit = _ref.inherit,
	      inherit = _ref$inherit === undefined ? false : _ref$inherit,
	      _ref$ink = _ref.ink,
	      ink = _ref$ink === undefined ? false : _ref$ink,
	      _ref$card = _ref.card,
	      card = _ref$card === undefined ? false : _ref$card,
	      _ref$hover = _ref.hover,
	      hover = _ref$hover === undefined ? false : _ref$hover;
	
	  var className = arguments[1];
	
	  var colors = '';
	  if (themeText) {
	    if (disabled) {
	      colors = 'md-text--disabled';
	    } else if (error) {
	      colors = 'md-text--error';
	    } else if (inherit) {
	      colors = 'md-text--inherit';
	    } else {
	      colors = (0, _classnames2.default)({
	        'md-text': text && !primary && !secondary && !hint,
	        'md-text--secondary': hint,
	        'md-text--theme-primary': !hint && primary,
	        'md-text--theme-secondary': !hint && secondary,
	        'md-ink--primary': ink && primary,
	        'md-ink--secondary': ink && secondary
	      });
	    }
	  } else {
	    colors = (0, _classnames2.default)({
	      'md-background': background && !primary && !secondary && !card,
	      'md-background--card': card,
	      'md-background--primary': primary,
	      'md-background--primary-hover': primary && hover,
	      'md-background--secondary': secondary,
	      'md-background--secondary-hover': secondary && hover
	    });
	  }
	
	  return (0, _classnames2.default)(colors, className);
	} /** @module utils/themeColors */
	//# sourceMappingURL=themeColors.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ICON_SIZE = 24;
	
	/**
	 * The \`FontIcon\` component is used for rendering a font-icon library's
	 * icon. The default is to use the `material-icons` library, but others
	 * can be used as well.
	 *
	 * If you are using another font-icon library that does not always create
	 * icons with a perfect 1:1 scale (such as font-awesome), it is recommended
	 * to update the `.md-icon` styles to set the width and height to `$md-font-icon-size`.
	 * However, this will prevent different sided icons.
	 *
	 * ```scss
	 * .md-icon.fa {
	 *   height: $md-font-icon-size;
	 *   width: $md-font-icon-size;
	 * }
	 * ```
	 */
	
	var FontIcon = function (_PureComponent) {
	  _inherits(FontIcon, _PureComponent);
	
	  function FontIcon(props) {
	    _classCallCheck(this, FontIcon);
	
	    var _this = _possibleConstructorReturn(this, (FontIcon.__proto__ || Object.getPrototypeOf(FontIcon)).call(this));
	
	    _initialiseProps.call(_this);
	
	    _this.state = { styles: _this._mergeStyles(props) };
	    return _this;
	  }
	
	  _createClass(FontIcon, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          style = _props.style,
	          forceSize = _props.forceSize,
	          forceFontSize = _props.forceFontSize;
	
	      if (style !== nextProps.style || forceSize !== nextProps.forceSize || forceFontSize !== nextProps.forceFontSize) {
	        this.setState({ styles: this._mergeStyles(nextProps) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = this.state.styles;
	
	      var _props2 = this.props,
	          iconClassName = _props2.iconClassName,
	          className = _props2.className,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          primary = _props2.primary,
	          secondary = _props2.secondary,
	          error = _props2.error,
	          inherit = _props2.inherit,
	          style = _props2.style,
	          forceSize = _props2.forceSize,
	          forceFontSize = _props2.forceFontSize,
	          props = _objectWithoutProperties(_props2, ['iconClassName', 'className', 'children', 'disabled', 'primary', 'secondary', 'error', 'inherit', 'style', 'forceSize', 'forceFontSize']);
	
	      var classes = (0, _classnames2.default)('md-icon', iconClassName, (0, _themeColors2.default)({
	        disabled: disabled,
	        error: error,
	        inherit: inherit,
	        primary: primary,
	        secondary: secondary
	      }), className);
	
	      return _react2.default.createElement(
	        'i',
	        _extends({}, props, { style: styles, className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return FontIcon;
	}(_react.PureComponent);
	
	FontIcon.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `FontIcon`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The icon font library className to use to display the icon.
	   */
	  iconClassName: _propTypes2.default.string.isRequired,
	
	  /**
	   * Boolean if the primary theme color should be applied.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the secondary theme color should be applied.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the icon is considered disabled and should inherit the
	   * disabled color.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the error color should be applied to the icon.
	   */
	  error: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the color of the icon should be inherited by parent elements.
	   */
	  inherit: _propTypes2.default.bool,
	
	  /**
	   * Either a boolean that will enforce the 24x24 size of the font icon or a number of the size
	   * to enforce. This is useful when using other font icon libraries that do not have a consistent
	   * size.
	   */
	  forceSize: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),
	
	  /**
	   * Boolean if the `forceSize` prop should also force the `font-size` instead of only `width` and `height`.
	   */
	  forceFontSize: function forceFontSize(props, propName, component) {
	    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      args[_key - 3] = arguments[_key];
	    }
	
	    var error = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, component].concat(args));
	    if (!error && typeof props.forceSize === 'undefined' && props[propName]) {
	      error = new Error('You provided a `forceFontSize` prop to the ' + component + ' component, without specifying the `forceSize` ' + ('prop. Either set the `forceSize` prop to a boolean or a number, or disable `' + propName + '`.'));
	    }
	
	    return error;
	  },
	
	  /**
	   * Any children required to display the icon with the font library.
	   */
	  children: _propTypes2.default.node
	};
	FontIcon.defaultProps = {
	  iconClassName: 'material-icons'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  this._mergeStyles = function (_ref) {
	    var style = _ref.style,
	        forceSize = _ref.forceSize,
	        forceFontSize = _ref.forceFontSize;
	
	    var styles = style;
	    if (typeof forceSize === 'boolean') {
	      styles = _extends({
	        height: ICON_SIZE,
	        width: ICON_SIZE,
	        fontSize: forceFontSize ? ICON_SIZE : undefined
	      }, style);
	    } else if (typeof forceSize === 'number') {
	      styles = _extends({
	        height: forceSize,
	        width: forceSize,
	        fontSize: forceFontSize ? forceSize : undefined
	      }, style);
	    }
	
	    return styles;
	  };
	};
	
	exports.default = FontIcon;
	//# sourceMappingURL=FontIcon.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LEFT_MOUSE = exports.LEFT_MOUSE = 0;
	var RIGHT_MOUSE = exports.RIGHT_MOUSE = 2;
	
	var TAB = exports.TAB = 9;
	var ENTER = exports.ENTER = 13;
	var ESC = exports.ESC = 27;
	var SPACE = exports.SPACE = 32;
	var PAGE_UP = exports.PAGE_UP = 33;
	var PAGE_DOWN = exports.PAGE_DOWN = 34;
	var END = exports.END = 35;
	var HOME = exports.HOME = 36;
	var LEFT = exports.LEFT = 37;
	var UP = exports.UP = 38;
	var RIGHT = exports.RIGHT = 39;
	var DOWN = exports.DOWN = 40;
	
	var ZERO = exports.ZERO = 48;
	var NINE = exports.NINE = 57;
	var KEYPAD_ZERO = exports.KEYPAD_ZERO = 96;
	var KEYPAD_NINE = exports.KEYPAD_NINE = 105;
	//# sourceMappingURL=keyCodes.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = controlled;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Validates the a component is fully controlled or uncontrolled.  If the given prop is not
	 * `undefined`, it will check if the `funcName` is defined and a function. A missing function
	 * will generate an error similar to the built-in React controlled validation message.
	 *
	 * @param {String} funcName - The function name to use for additional validation.
	 * @param {function} validator - The PropTypes validator to use for the given prop.
	 * @return {Error} an error or null.
	 */
	function controlled(validator, funcName) {
	  var fallbackPropName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'defaultValue';
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && typeof props[propName] !== 'undefined' && !props.readOnly && !props.disabled) {
	      var _PropTypes$func;
	
	      var funcError = (_PropTypes$func = _propTypes2.default.func).isRequired.apply(_PropTypes$func, [props, funcName, componentName, location, propFullName].concat(args));
	      if (funcError) {
	        err = new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' without a ' + ('`' + funcName + '` handler. This will render a read only field. Set either the `' + funcName + '` ') + ('or use the `' + fallbackPropName + '` instead.'));
	      }
	    }
	
	    return err;
	  };
	} /** @module utils/PropTypes/controlled */
	//# sourceMappingURL=controlled.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseChildIndex = exports.getReactEventByType = exports.renderByOrder = exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.LEGEND_TYPES = exports.SCALE_TYPES = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = undefined;
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isString2 = __webpack_require__(225);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _isObject2 = __webpack_require__(61);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(24);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DataUtils = __webpack_require__(19);
	
	var _PureRender = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PRESENTATION_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = {
	  alignmentBaseline: _propTypes2.default.string,
	  angle: _propTypes2.default.number,
	  baselineShift: _propTypes2.default.string,
	  clip: _propTypes2.default.string,
	  clipPath: _propTypes2.default.string,
	  clipRule: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  colorInterpolation: _propTypes2.default.string,
	  colorInterpolationFilters: _propTypes2.default.string,
	  colorProfile: _propTypes2.default.string,
	  colorRendering: _propTypes2.default.string,
	  cursor: _propTypes2.default.string,
	  direction: _propTypes2.default.oneOf(['ltr', 'rtl', 'inherit']),
	  display: _propTypes2.default.string,
	  dominantBaseline: _propTypes2.default.string,
	  enableBackground: _propTypes2.default.string,
	  fill: _propTypes2.default.string,
	  fillOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  fillRule: _propTypes2.default.oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _propTypes2.default.string,
	  floodColor: _propTypes2.default.string,
	  floodOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  font: _propTypes2.default.string,
	  fontFamily: _propTypes2.default.string,
	  fontSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  fontSizeAdjust: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  fontStretch: _propTypes2.default.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _propTypes2.default.oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _propTypes2.default.oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _propTypes2.default.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _propTypes2.default.string,
	  glyphOrientationVertical: _propTypes2.default.string,
	  imageRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  letterSpacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  lightingColor: _propTypes2.default.string,
	  markerEnd: _propTypes2.default.string,
	  markerMid: _propTypes2.default.string,
	  markerStart: _propTypes2.default.string,
	  mask: _propTypes2.default.string,
	  opacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  overflow: _propTypes2.default.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _propTypes2.default.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _propTypes2.default.string,
	  stopOpacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  stroke: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeDasharray: _propTypes2.default.string,
	  strokeDashoffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeLinecap: _propTypes2.default.oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _propTypes2.default.oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeOpacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  textAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _propTypes2.default.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _propTypes2.default.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _propTypes2.default.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  writingMode: _propTypes2.default.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  dx: _propTypes2.default.number,
	  dy: _propTypes2.default.number,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  r: _propTypes2.default.number,
	  // The radius of Rectangle
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array])
	};
	
	var EVENT_ATTRIBUTES = exports.EVENT_ATTRIBUTES = {
	  onClick: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  onMouseMove: _propTypes2.default.func,
	  onMouseOut: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchMove: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  onTouchCancel: _propTypes2.default.func
	};
	
	var REACT_BROWSER_EVENT_MAP = {
	  click: 'onClick',
	  mousedown: 'onMouseDown',
	  mouseup: 'onMouseUp',
	  mouseover: 'onMouseOver',
	  mousemove: 'onMouseMove',
	  mouseout: 'onMouseOut',
	  mouseenter: 'onMouseEnter',
	  mouseleave: 'onMouseLeave',
	  touchcancel: 'onTouchCancel',
	  touchend: 'onTouchEnd',
	  touchmove: 'onTouchMove',
	  touchstart: 'onTouchStart'
	};
	
	var SCALE_TYPES = exports.SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold'];
	
	var LEGEND_TYPES = exports.LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
	
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	var getDisplayName = exports.getDisplayName = function getDisplayName(Comp) {
	  if (!Comp) {
	    return '';
	  }
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	var findAllByType = exports.findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	var findChildByType = exports.findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	
	  return result && result[0];
	};
	
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	var withoutType = exports.withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types = void 0;
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	var getPresentationAttributes = exports.getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	  return out;
	};
	
	var getEventHandlerOfElement = function getEventHandlerOfElement(originalHandler, props) {
	  return function (e) {
	    originalHandler(props, e);
	
	    return null;
	  };
	};
	/**
	 * get all the event attribute of svg element
	 * @param  {Object}   el           A react element or the props of a react element
	 * @param  {Function} newHandler   New handler of event
	 * @param  {Boolean}  wrapCallback Wrap callback and return more parameters or not
	 * @return {Object}                attributes or null
	 */
	var filterEventAttributes = exports.filterEventAttributes = function filterEventAttributes(el, newHandler) {
	  var wrapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = newHandler || (wrapCallback ? getEventHandlerOfElement(props[i], props) : props[i]);
	    }
	  }
	  return out;
	};
	
	var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	
	    return null;
	  };
	};
	
	var filterEventsOfChild = exports.filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction3.default)(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandlerOfChild(props[i], data, index);
	    }
	  }
	  return out;
	};
	
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	var validateWidthHeight = exports.validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	var isSsr = exports.isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	
	var isSvgElement = function isSvgElement(child) {
	  return child && child.type && (0, _isString3.default)(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
	};
	
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	var filterSvgElements = exports.filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react2.default.Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString3.default)(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil3.default)(nextChild) && (0, _isNil3.default)(prevChild)) {
	    return true;
	  } else if (!(0, _isNil3.default)(nextChild) && !(0, _isNil3.default)(prevChild)) {
	    var _ref = nextChild.props || {},
	        nextChildren = _ref.children,
	        nextProps = _objectWithoutProperties(_ref, ['children']);
	
	    var _ref2 = prevChild.props || {},
	        prevChildren = _ref2.children,
	        prevProps = _objectWithoutProperties(_ref2, ['children']);
	
	    if (nextChildren && prevChildren) {
	      // eslint-disable-next-line no-use-before-define
	      return (0, _PureRender.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
	    } else if (!nextChildren && !prevChildren) {
	      return (0, _PureRender.shallowEqual)(nextProps, prevProps);
	    }
	
	    return false;
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	exports.isSingleChildEqual = isSingleChildEqual;
	var isChildrenEqual = exports.isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	  if (count === 1) {
	    return isSingleChildEqual((0, _isArray3.default)(nextChildren) ? nextChildren[0] : nextChildren, (0, _isArray3.default)(prevChildren) ? prevChildren[0] : prevChildren);
	  }
	
	  for (var i = 0; i < count; i++) {
	    var nextChild = nextChildren[i];
	    var prevChild = prevChildren[i];
	
	    if ((0, _isArray3.default)(nextChild) || (0, _isArray3.default)(prevChild)) {
	      if (!isChildrenEqual(nextChild, prevChild)) {
	        return false;
	      }
	    } else if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var renderByOrder = exports.renderByOrder = function renderByOrder(children, renderMap) {
	  var elements = [];
	  var record = {};
	
	  _react.Children.forEach(children, function (child, index) {
	    if (child && isSvgElement(child)) {
	      elements.push(child);
	    } else if (child && renderMap[getDisplayName(child.type)]) {
	      var displayName = getDisplayName(child.type);
	      var _renderMap$displayNam = renderMap[displayName],
	          handler = _renderMap$displayNam.handler,
	          once = _renderMap$displayNam.once;
	
	
	      if (once && !record[displayName] || !once) {
	        var results = handler(child, displayName, index);
	
	        if ((0, _isArray3.default)(results)) {
	          elements = [elements].concat(_toConsumableArray(results));
	        } else {
	          elements.push(results);
	        }
	
	        record[displayName] = true;
	      }
	    }
	  });
	
	  return elements;
	};
	
	var getReactEventByType = exports.getReactEventByType = function getReactEventByType(e) {
	  var type = e && e.type;
	
	  if (type && REACT_BROWSER_EVENT_MAP[type]) {
	    return REACT_BROWSER_EVENT_MAP[type];
	  }
	
	  return null;
	};
	
	var parseChildIndex = exports.parseChildIndex = function parseChildIndex(child, children) {
	  var result = -1;
	  _react.Children.forEach(children, function (entry, index) {
	    if (entry === child) {
	      result = index;
	    }
	  });
	
	  return result;
	};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function shouldComponentUpdate(props, state) {
	  return !shallowEqual(props, this.props) || !shallowEqual(state, this.state);
	}
	
	function pureRenderDecorator(component) {
	  // eslint-disable-next-line no-param-reassign
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(9);
	
	var _CSSTransitionGroupTick = __webpack_require__(30);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getBtnStyles2 = __webpack_require__(128);
	
	var _getBtnStyles3 = _interopRequireDefault(_getBtnStyles2);
	
	var _invalidIf = __webpack_require__(37);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _captureNextEvent = __webpack_require__(52);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _IconSeparator = __webpack_require__(44);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _injectInk = __webpack_require__(92);
	
	var _injectInk2 = _interopRequireDefault(_injectInk);
	
	var _injectTooltip = __webpack_require__(72);
	
	var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Button` component can either be a `FlatButton`, `RaisedButton`, `IconButton`, or a
	 * `FloatingButton`.
	 *
	 * A `FlatButton` is a button with no depth on the screen that is ideally used in `Dialog`s
	 * or `CardActions`. The text can be optionally styled with the `primary` or `secondary` colors.
	 *
	 * A `RaisedButton` is a button with some depth to help actions have more prominent in flat
	 * layouts or layouts with varying content. The background can be styled by the light/dark theme,
	 * or optionally the `primary` or `secondary` color.
	 *
	 * An `IconButton` is a button that just displays a `FontIcon` as the child in a circle.
	 * The `FontIcon` can be optionally styled with the `primary` or `secondary` color.
	 *
	 * A `FloatingButton` is a special case. Woop
	 */
	var Button = function (_PureComponent) {
	  _inherits(Button, _PureComponent);
	
	  function Button() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Button);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Button, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.disabled && !nextProps.disabled && this.state.hover) {
	        this.setState({ hover: false });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var _this2 = this;
	
	      if (!this.state.pressed && nextState.pressed) {
	        this._timeout = setTimeout(function () {
	          _this2._timeout = null;
	          if (_this2._attemptedBlur) {
	            _this2._attemptedBlur = false;
	
	            _this2.setState({ pressed: false });
	          }
	        }, 450);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      if (this._snackbarTimeout) {
	        clearTimeout(this._snackbarTimeout);
	      }
	
	      window.removeEventListener('click', this._blur);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          iconClassName = _props.iconClassName,
	          iconChildren = _props.iconChildren,
	          iconBefore = _props.iconBefore,
	          href = _props.href,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          flat = _props.flat,
	          raised = _props.raised,
	          floating = _props.floating,
	          mini = _props.mini,
	          fixed = _props.fixed,
	          fixedPosition = _props.fixedPosition,
	          disabled = _props.disabled,
	          component = _props.component,
	          ink = _props.ink,
	          tooltip = _props.tooltip,
	          icon = _props.icon,
	          forceIconSize = _props.forceIconSize,
	          forceIconFontSize = _props.forceIconFontSize,
	          type = _props.type,
	          children = _props.children,
	          swapTheming = _props.swapTheming,
	          svg = _props.svg,
	          propIconEl = _props.iconEl,
	          label = _props.label,
	          props = _objectWithoutProperties(_props, ['className', 'iconClassName', 'iconChildren', 'iconBefore', 'href', 'primary', 'secondary', 'flat', 'raised', 'floating', 'mini', 'fixed', 'fixedPosition', 'disabled', 'component', 'ink', 'tooltip', 'icon', 'forceIconSize', 'forceIconFontSize', 'type', 'children', 'swapTheming', 'svg', 'iconEl', 'label']);
	
	      var iconEl = this.props.iconEl;
	
	
	      if (!href) {
	        props.type = type;
	      }
	
	      var _state = this.state,
	          pressed = _state.pressed,
	          hover = _state.hover,
	          snackbar = _state.snackbar,
	          snackbarType = _state.snackbarType;
	
	      var iconBtnType = icon || floating;
	
	      var visibleChildren = void 0;
	      if (!iconEl && !svg && (iconClassName || iconChildren || iconBtnType || label && children)) {
	        var resolvedIconChildren = iconChildren;
	        if (typeof iconChildren === 'undefined') {
	          resolvedIconChildren = iconBtnType || label ? children : null;
	        }
	
	        iconEl = _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName, forceSize: forceIconSize, forceFontSize: forceIconFontSize, inherit: true },
	          resolvedIconChildren
	        );
	      } else if (iconEl || svg) {
	        var el = _react2.default.Children.only(iconEl || children);
	        iconEl = _react2.default.cloneElement(el, { inherit: !el.props.error });
	      }
	
	      if (!iconBtnType) {
	        visibleChildren = label || children;
	        if (iconEl) {
	          visibleChildren = _react2.default.createElement(
	            _IconSeparator2.default,
	            { label: visibleChildren, iconBefore: iconBefore },
	            iconEl
	          );
	        }
	      } else {
	        visibleChildren = iconEl;
	      }
	
	      var Component = component || (href ? 'a' : 'button');
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          disabled: disabled,
	          onTouchStart: this._handleTouchStart,
	          onTouchEnd: this._handleTouchEnd,
	          onMouseDown: this._handleMouseDown,
	          onMouseUp: this._handleMouseUp,
	          onKeyDown: this._handleKeyDown,
	          onKeyUp: this._handleKeyUp,
	          onMouseEnter: this._handleMouseEnter,
	          onMouseLeave: this._handleMouseLeave,
	          href: href,
	          className: (0, _getBtnStyles3.default)({
	            flat: flat,
	            raised: raised,
	            icon: icon,
	            floating: floating,
	            disabled: disabled,
	            primary: primary,
	            secondary: secondary,
	            hover: hover,
	            swapTheming: swapTheming,
	            pressed: pressed,
	            mini: mini,
	            fixed: fixed,
	            fixedPosition: fixedPosition
	          }, _defineProperty({
	            'md-btn--tooltip': tooltip,
	            'md-btn--snackbar-floating': snackbar
	          }, 'md-btn--snackbar-floating-' + snackbarType + 'adjust', snackbar && snackbarType !== null), 'md-inline-block', className)
	        }),
	        ink,
	        tooltip,
	        visibleChildren
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.PureComponent);
	
	Button.propTypes = {
	  /**
	   * An optional style to apply to the button.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A boolean if the icon should appear before or after the text for a `FlatButton` or
	   * a `RaisedButton`.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * Any children used to display the button. When the button type is `icon` or `floating`,
	   * this can be used to render the `FontIcon` instead of the `iconChildren` prop.
	   *
	   * When the button type is `raised` or `flat`, this will be the label or any other elements
	   * you'd like to display in the button. This can work hand-in-hand with the `iconClassName`
	   * and `iconChildren` to make a button with an icon and text.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An icon className to use in an optional `FontIcon` in any version of the button. This will
	   * be used with the `children` prop. If the `floating` or `icon` props are set to true, this or
	   * the children are required.
	   *
	   * @see {@link #iconEl}
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to use to display an icon in the button.
	   *
	   * @see {@link #iconEl}
	   */
	  iconChildren: _propTypes2.default.node,
	
	  /**
	   * An optional icon to display. This prop is recommended over the `iconClassName` and `iconChildren`
	   * props since it allows more control for you. There is also better SVG support since it won't wrap
	   * the SVG with the `FontIcon` element.
	   */
	  iconEl: _propTypes2.default.element,
	
	  /**
	   * The type for the button. This is required when the `component` prop is not
	   * the 'a' tag, a `function`, or when the `href` prop is defined.
	   */
	  type: function type(props, propName, component) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      args[_key2 - 3] = arguments[_key2];
	    }
	
	    var c = props.component;
	    var validator = _propTypes2.default.oneOf(['button', 'submit', 'reset']);
	    if (!props.href && c !== 'a' && typeof c !== 'function') {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName, component].concat(args));
	  },
	
	  /**
	   * Boolean if the button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href for the button. This will style the `a` tag as a button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional component to render the button as. This allows you to get all the styles and functionality
	   * of the Button, but as a custom React component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * An optional function to call when the `click` event is triggered.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchstart` event is triggered.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchend` event is triggered.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousedown` event is triggered.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseup` event is triggered.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keyup` event is triggered.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event is triggered.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseenter` event is triggered.
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseleave` event is triggered.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * Boolean if the `FloatingButton` should be fixed to the page. This prop can
	   * only be enabled if the `floating` prop is true.
	   */
	  fixed: (0, _invalidIf2.default)(_propTypes2.default.bool, 'flat', 'raised', 'icon'),
	
	  /**
	   * The position that the `FloatingButton` should be fixed to the page. It will
	   * either be fixed to the top right, top left, bottom right, or bottom left of
	   * the page. This prop is only used if the `floating` prop and `fixed` prop are
	   * `true`.
	   */
	  fixedPosition: _propTypes2.default.oneOf(['tr', 'tl', 'br', 'bl']).isRequired,
	
	  /**
	   * Boolean if the `FloatingButton` should be `mini`. This prop can only be used
	   * when the `floating` prop is true.
	   */
	  mini: (0, _invalidIf2.default)(_propTypes2.default.bool, 'flat', 'raised', 'icon'),
	
	  /**
	   * Boolean if the `Button` should be styled as a `FlatButton`.
	   */
	  flat: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Button` should be styled as a `RaisedButton`.
	   */
	  raised: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Button` should be styled as a `IconButton`.
	   *
	   * @see {@link #svg}
	   */
	  icon: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Button` should be styled as a `FloatingButton`.
	   *
	   * @see {@link #svg}
	   */
	  floating: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the theming of `primary` or `secondary` should be swapped. By default,
	   * only flat and icon buttons can gain the theme colors as text color while the raised
	   * and floating buttons can gain the theme colors as background color.
	   *
	   * If this prop is enabled, the flat and icon buttons will gain the theme background colors
	   * while the raised and icon will gain the theme text colors instead.
	   *
	   * @see {@link #primary}
	   * @see {@link #secondary}
	   */
	  swapTheming: _propTypes2.default.bool,
	
	  /**
	   * An optional label to use for the tooltip. This is normally only used for
	   * `IconButton`s or `FloatingButton`s, but can be used on `FlatButton`s and
	   * `RaisedButton`s if you wish. Knock yourself out!
	   *
	   * If this prop is omitted, no tooltip will be included.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * An optional delay before the tooltip appears on mouse over.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position for the tooltip.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * An ink from `injectInk`.
	   * @access private
	   */
	  ink: _propTypes2.default.node,
	
	  /**
	   * A tooltip from `injectTooltip`
	   * @access private
	   */
	  tooltip: _propTypes2.default.node,
	
	  /**
	   * Custom validator for verifying that only one type is defined and that
	   * at one type is defined.
	   */
	  _typeValidator: function _typeValidator(props, propName, component) {
	    var flat = props.flat,
	        raised = props.raised,
	        icon = props.icon,
	        floating = props.floating;
	
	
	    var defined = [raised, flat, icon, floating].filter(function (d) {
	      return d;
	    });
	    var len = defined.length;
	    if (len === 0) {
	      return new Error('A material design button type must be specified in the `' + component + '` but none were ' + 'given. Valid types are `flat`, `raised`, `icon`, or `floating`.');
	    } else if (len !== 1) {
	      return new Error('Only one material design button type may be specified in the `' + component + '` but `' + len + '` ' + 'were given. Select only one of `flat`, `raised`, `icon`, or `floating`.');
	    }
	
	    return null;
	  },
	
	  /**
	   * Either a boolean that will enforce the 24x24 size of the font icon or a number of the size
	   * to enforce. This is useful when using other font icon libraries that do not have a consistent
	   * size.
	   */
	  forceIconSize: _FontIcon2.default.propTypes.forceSize,
	
	  /**
	   * Boolean if the `forceIconSize` prop should also force the `font-size` instead of only `width` and `height`.
	   */
	  forceIconFontSize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the child is an SVGIcon or FontIcon when using the `icon` or `floating` props. This is only needed
	   * until the next release when the `label` migration can be removed.
	   */
	  svg: _propTypes2.default.bool,
	
	  label: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `children` prop instead'),
	  noIcon: (0, _deprecated2.default)(_propTypes2.default.bool, 'This has been removed during the alpha release. Children will always attempt to be rendered outside of an ' + 'icon by default for flat and raised buttons.')
	};
	Button.defaultProps = {
	  type: 'button',
	  iconBefore: true,
	  fixedPosition: 'br'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.state = {
	    pressed: false,
	    snackbar: false,
	    snackbarType: null
	  };
	
	  this._blur = function () {
	    if (_this3.props.disabled) {
	      return;
	    }
	
	    if (_this3._timeout) {
	      _this3._attemptedBlur = true;
	    } else {
	      _this3.setState({ pressed: false });
	    }
	  };
	
	  this._handleMouseUp = function (e) {
	    if (_this3.props.onMouseUp) {
	      _this3.props.onMouseUp(e);
	    }
	
	    _this3._blur();
	  };
	
	  this._handleMouseDown = function (e) {
	    if (_this3.props.onMouseDown) {
	      _this3.props.onMouseDown(e);
	    }
	
	    if (!_this3.props.disabled) {
	      _this3.setState({ pressed: true });
	    }
	  };
	
	  this._handleTouchStart = function (e) {
	    if (_this3.props.onTouchStart) {
	      _this3.props.onTouchStart(e);
	    }
	
	    if (!_this3.props.disabled) {
	      _this3.setState({ pressed: true });
	    }
	  };
	
	  this._handleTouchEnd = function (e) {
	    if (_this3.props.onTouchEnd) {
	      _this3.props.onTouchEnd(e);
	    }
	
	    _this3._blur();
	    (0, _captureNextEvent2.default)('mouseover');
	  };
	
	  this._handleKeyUp = function (e) {
	    if (_this3.props.onKeyUp) {
	      _this3.props.onKeyUp(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.addEventListener('click', _this3._blur);
	      _this3.setState({ pressed: true });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    if (_this3.props.onKeyDown) {
	      _this3.props.onKeyDown(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.removeEventListener('click', _this3._blur);
	      _this3.setState({ pressed: false });
	    }
	  };
	
	  this._handleMouseEnter = function (e) {
	    if (_this3.props.onMouseEnter) {
	      _this3.props.onMouseEnter(e);
	    }
	
	    if (!_this3.props.disabled) {
	      _this3.setState({ hover: true });
	    }
	  };
	
	  this._handleMouseLeave = function (e) {
	    if (_this3.props.onMouseLeave) {
	      _this3.props.onMouseLeave(e);
	    }
	
	    if (!_this3.props.disabled) {
	      _this3.setState({ hover: false });
	    }
	  };
	
	  this._animateForSnackbar = function (multiline, leaveTimeout) {
	    if (typeof leaveTimeout === 'number') {
	      _this3._snackbarTimeout = setTimeout(function () {
	        _this3._snackbarTimeout = setTimeout(function () {
	          _this3._snackbarTimeout = null;
	
	          _this3.setState({ snackbar: false });
	        }, leaveTimeout + 150);
	
	        _this3.setState({ snackbarType: null });
	      }, _CSSTransitionGroupTick2.default);
	    } else {
	      _this3._snackbarTimeout = setTimeout(function () {
	        _this3._snackbarTimeout = null;
	
	        _this3.setState({ snackbar: true, snackbarType: multiline ? 'multiline-' : '' });
	      }, _CSSTransitionGroupTick2.default);
	    }
	  };
	};
	
	exports.default = (0, _injectInk2.default)((0, _injectTooltip2.default)(Button));
	//# sourceMappingURL=Button.js.map

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(80),
	    isObject = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDeprecatedIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDeprecatedIcon(className, children, icon) {
	  if (className || children) {
	    return _react2.default.createElement(
	      _FontIcon2.default,
	      { iconClassName: className },
	      children
	    );
	  }
	
	  return icon;
	}
	//# sourceMappingURL=getDeprecatedIcon.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.shape({
	  x: _propTypes2.default.object,
	  y: _propTypes2.default.object
	})]);
	//# sourceMappingURL=fixedToShape.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLinearRegression = exports.findEntryInArray = exports.interpolateNumber = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = exports.mathSign = undefined;
	
	var _get2 = __webpack_require__(221);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isArray2 = __webpack_require__(24);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNaN2 = __webpack_require__(195);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _isNumber2 = __webpack_require__(224);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _isString2 = __webpack_require__(225);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mathSign = exports.mathSign = function mathSign(value) {
	  if (value === 0) {
	    return 0;
	  }
	  if (value > 0) {
	    return 1;
	  }
	
	  return -1;
	};
	
	var isPercent = exports.isPercent = function isPercent(value) {
	  return (0, _isString3.default)(value) && value.indexOf('%') === value.length - 1;
	};
	
	var isNumber = exports.isNumber = function isNumber(value) {
	  return (0, _isNumber3.default)(value) && !(0, _isNaN3.default)(value);
	};
	
	var isNumOrStr = exports.isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString3.default)(value);
	};
	
	var idCounter = 0;
	var uniqueId = exports.uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	
	  return '' + (prefix || '') + id;
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	var getPercentValue = exports.getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString3.default)(percent)) {
	    return defaultValue;
	  }
	
	  var value = void 0;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if ((0, _isNaN3.default)(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	var getAnyElementOfObject = exports.getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	var hasDuplicate = exports.hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray3.default)(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	var interpolateNumber = exports.interpolateNumber = function interpolateNumber(numberA, numberB) {
	  if (isNumber(numberA) && isNumber(numberB)) {
	    return function (t) {
	      return numberA + t * (numberB - numberA);
	    };
	  }
	
	  return function () {
	    return numberB;
	  };
	};
	
	var findEntryInArray = exports.findEntryInArray = function findEntryInArray(ary, specifiedKey, specifiedValue) {
	  if (!ary || !ary.length) {
	    return null;
	  }
	
	  return ary.find(function (entry) {
	    return entry && (0, _get3.default)(entry, specifiedKey) === specifiedValue;
	  });
	};
	
	/**
	 * The least square linear regression
	 * @param {Array} data The array of points
	 * @returns {Object} The domain of x, and the parameter of linear function
	 */
	var getLinearRegression = exports.getLinearRegression = function getLinearRegression(data) {
	  if (!data || !data.length) {
	    return null;
	  }
	
	  var len = data.length;
	  var xsum = 0;
	  var ysum = 0;
	  var xysum = 0;
	  var xxsum = 0;
	  var xmin = Infinity;
	  var xmax = -Infinity;
	
	  for (var i = 0; i < len; i++) {
	    xsum += data[i].cx;
	    ysum += data[i].cy;
	    xysum += data[i].cx * data[i].cy;
	    xxsum += data[i].cx * data[i].cx;
	    xmin = Math.min(xmin, data[i].cx);
	    xmax = Math.max(xmax, data[i].cx);
	  }
	
	  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
	
	  return {
	    xmin: xmin,
	    xmax: xmax,
	    a: a,
	    b: (ysum - a * xsum) / len
	  };
	};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccessibleFakeButton = __webpack_require__(50);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	var _injectInk = __webpack_require__(92);
	
	var _injectInk2 = _interopRequireDefault(_injectInk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _injectInk2.default)(_AccessibleFakeButton2.default);
	//# sourceMappingURL=AccessibleFakeInkedButton.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Layer
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ['children', 'className']);
	
	  var layerClass = (0, _classnames2.default)('recharts-layer', className);
	
	  return _react2.default.createElement(
	    'g',
	    _extends({ className: layerClass }, others),
	    children
	  );
	}
	
	Layer.propTypes = propTypes;
	
	exports.default = Layer;

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(402);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ResizeObserver` component is a component hook for the
	 * [ResizeObserver](http://rawgit.com/WICG/ResizeObserver/master/index.html)
	 * using the [resize-observer-polyfill](https://github.com/que-etc/resize-observer-polyfill)
	 * for browsers that don't support it yet.
	 *
	 * This component displays an empty `span` with `aria-hidden` to allow access to the DOM. By
	 * default it will attempt to watch changes on its parent component, but it can be configured
	 * to watch any element by using the `target` prop.
	 */
	var ResizeObserver = function (_PureComponent) {
	  _inherits(ResizeObserver, _PureComponent);
	
	  function ResizeObserver() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResizeObserver);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResizeObserver.__proto__ || Object.getPrototypeOf(ResizeObserver)).call.apply(_ref, [this].concat(args))), _this), _this._container = null, _this._target = null, _this._observer = null, _this._height = null, _this._width = null, _this._scrollHeight = null, _this._scrollWidth = null, _this._measure = function (entries) {
	      if (!_this._observer || !_this._target) {
	        return;
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var entry = _step.value;
	
	          if (!entry) {
	            return;
	          }
	
	          var _entry$contentRect = entry.contentRect,
	              height = _entry$contentRect.height,
	              width = _entry$contentRect.width;
	          var _entry$target = entry.target,
	              scrollHeight = _entry$target.scrollHeight,
	              scrollWidth = _entry$target.scrollWidth;
	
	          if (_this._isHeightChange(height, scrollHeight) || _this._isWidthChange(width, scrollWidth)) {
	            _this._height = height;
	            _this._width = width;
	            _this._scrollHeight = scrollHeight;
	            _this._scrollWidth = scrollWidth;
	            _this.props.onResize({ height: height, width: width, scrollHeight: scrollHeight, scrollWidth: scrollWidth, el: entry.target });
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }, _this._isHeightChange = function (height, scrollHeight) {
	      return _this.props.watchHeight && (height !== _this._height || scrollHeight !== _this._scrollHeight);
	    }, _this._isWidthChange = function (width, scrollWidth) {
	      return _this.props.watchWidth && (width !== _this._width || scrollWidth !== _this._scrollWidth);
	    }, _this._handleRef = function (container) {
	      if (container) {
	        _this._container = container;
	        _this._target = _this._getTarget(container, _this.props.target);
	        _this._observer = new _resizeObserverPolyfill2.default(_this._measure);
	
	        if (_this._target) {
	          _this._observer.observe(_this._target);
	        }
	      } else {
	        if (_this._observer) {
	          _this._observer.disconnect();
	        }
	
	        _this._container = null;
	        _this._target = null;
	        _this._observer = null;
	        _this._height = null;
	        _this._width = null;
	        _this._scrollHeight = null;
	        _this._scrollWidth = null;
	      }
	
	      if (_this.props.elRef) {
	        _this.props.elRef(_this._target);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ResizeObserver, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var target = this.props.target;
	
	      var nextTarget = nextProps.target;
	      if (target === nextTarget) {
	        return;
	      } else if (nextTarget) {
	        if (this._target) {
	          this._observer.unobserve(this._target);
	        }
	        this._target = this._getTarget(this._container, nextTarget);
	        this._observer.observe(this._target);
	      }
	    }
	  }, {
	    key: '_getTarget',
	    value: function _getTarget(container, target) {
	      if (target === null || target && typeof target !== 'string') {
	        return target;
	      }
	
	      var t = null;
	      if (target) {
	        t = document.getElementById(target) || document.querySelector(target);
	      } else {
	        t = container.parentNode;
	      }
	
	      if (!t) {
	        throw new Error('An HTMLDOMNode is required as the `ResizeObserver`\'s watch target but none were provided/found. ' + ('Please update the target prop to find a valid node since the provided target is invalid. `' + target + '`.'));
	      }
	
	      return t;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Component = this.props.component;
	
	      return _react2.default.createElement(Component, { ref: this._handleRef, 'aria-hidden': true });
	    }
	  }]);
	
	  return ResizeObserver;
	}(_react.PureComponent);
	
	ResizeObserver.propTypes = {
	  /**
	   * Boolean if the height should be watched for the resize target.
	   */
	  watchHeight: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the width should be watched for the resize target.
	   */
	  watchWidth: _propTypes2.default.bool,
	
	  /**
	   * An optional target that should be used for detecting resize events. This can either
	   * be a HTMLDOMNode or a string to use with `document.getElementById` or `document.querySelector`.
	   *
	   * If this prop is not provided and not null, it will default to the parent node of this component.
	   * If the provided `target={null}`, the observer will not begin until the `target` is `undefined` or
	   * it has been correctly passed a target string or object.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	
	  /**
	   * The component to be rendered as. This should normally just be the default `span`, but there are cases
	   * where the component should be switched to something else for valid html.
	   */
	  component: _propTypes2.default.string,
	
	  /**
	   * A function to call when the height or width has been changed and that attribute is being watched.
	   * The callback will include the current height, width, scrollHeight and scrollWidth of the target.
	   *
	   * ```js
	   * onResize({
	   *   height: nextHeight,
	   *   width: nextWidth,
	   *   scrollHeight: nextScrollHeight,
	   *   scrollWidth: nextScrollWidth,
	   *   el: resizeTarget,
	   * });
	   * ```
	   */
	  onResize: _propTypes2.default.func.isRequired,
	
	  /**
	   * An optional ref callback that will include the `target` or the parent node of the resize observer. Just
	   * like other refs, this will provide null when it unmounts.
	   *
	   * This is really only helpful if you'd like the DOM node for a parent Component without needing to use
	   * `ReactDOM.findDOMNode(this)`.
	   */
	  elRef: _propTypes2.default.func
	};
	ResizeObserver.defaultProps = {
	  watchHeight: false,
	  watchWidth: false,
	  component: 'span'
	};
	exports.default = ResizeObserver;
	//# sourceMappingURL=ResizeObserver.js.map

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _between = __webpack_require__(55);
	
	var _between2 = _interopRequireDefault(_between);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Paper` component is a simple wrapper that adds box-shadow.
	 *
	 * You can also use the SCSS mixin instead of paper.
	 *
	 * ```scss
	 * @include md-box-shadow(5);
	 * ```
	 */
	var Paper = function (_PureComponent) {
	  _inherits(Paper, _PureComponent);
	
	  function Paper() {
	    _classCallCheck(this, Paper);
	
	    return _possibleConstructorReturn(this, (Paper.__proto__ || Object.getPrototypeOf(Paper)).apply(this, arguments));
	  }
	
	  _createClass(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          zDepth = _props.zDepth,
	          className = _props.className,
	          raiseOnHover = _props.raiseOnHover,
	          props = _objectWithoutProperties(_props, ['component', 'zDepth', 'className', 'raiseOnHover']);
	
	      return _react2.default.createElement(Component, _extends({}, props, {
	        className: (0, _classnames2.default)('md-paper md-paper--' + zDepth, {
	          'md-paper--0-hover': zDepth === 0 && raiseOnHover
	        }, className)
	      }));
	    }
	  }]);
	
	  return Paper;
	}(_react.PureComponent);
	
	Paper.propTypes = {
	  /**
	   * The component to render the paper as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The depth of the paper. This should be a number between 0 - 5. If
	   * the depth is 0, it will raise to a depth of 3 on hover.
	   */
	  zDepth: (0, _between2.default)(_propTypes2.default.number.isRequired, 0, 5),
	
	  /**
	   * Any children to display in the paper.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the paper should raise to the `zDepth` of `3` on hover when the initial
	   * `zDepth` is `0`.
	   */
	  raiseOnHover: _propTypes2.default.bool
	};
	Paper.defaultProps = {
	  zDepth: 1,
	  component: 'div'
	};
	exports.default = Paper;
	//# sourceMappingURL=Paper.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// This will need to keep in sync with the `ReactCSSTransitionGroupChild` `TICK` const.
	// https://github.com/facebook/react/blob/master/src/addons/transitions/ReactCSSTransitionGroupChild.js#L22
	
	exports.default = 17;
	//# sourceMappingURL=CSSTransitionGroupTick.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HorizontalAnchors = __webpack_require__(143);
	
	var _HorizontalAnchors2 = _interopRequireDefault(_HorizontalAnchors);
	
	var _VerticalAnchors = __webpack_require__(145);
	
	var _VerticalAnchors2 = _interopRequireDefault(_VerticalAnchors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	  x: _propTypes2.default.oneOf([_HorizontalAnchors2.default.LEFT, _HorizontalAnchors2.default.INNER_LEFT, _HorizontalAnchors2.default.CENTER, _HorizontalAnchors2.default.RIGHT, _HorizontalAnchors2.default.INNER_RIGHT]).isRequired,
	  y: _propTypes2.default.oneOf([_VerticalAnchors2.default.TOP, _VerticalAnchors2.default.CENTER, _VerticalAnchors2.default.OVERLAP, _VerticalAnchors2.default.BOTTOM]).isRequired
	});
	//# sourceMappingURL=anchorShape.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Positions = __webpack_require__(144);
	
	var _Positions2 = _interopRequireDefault(_Positions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([_propTypes2.default.oneOf([_Positions2.default.TOP_LEFT, _Positions2.default.TOP_RIGHT, _Positions2.default.BOTTOM_LEFT, _Positions2.default.BOTTOM_RIGHT, _Positions2.default.BELOW]), _propTypes2.default.string]);
	//# sourceMappingURL=positionShape.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseDomainOfCategoryAxis = exports.getBandSizeOfAxis = exports.validateCoordinateInRange = exports.parseSpecifiedDomain = exports.MAX_VALUE_REG = exports.MIN_VALUE_REG = exports.getDomainOfStackGroups = exports.getStackedDataOfItem = exports.detectReferenceElementsDomain = exports.getBaseValueOfBar = exports.getCateCoordinateOfBar = exports.getCateCoordinateOfLine = exports.getTicksOfScale = exports.calculateDomainOfTicks = exports.getStackGroupsByAxisId = exports.getStackedData = exports.offsetSign = exports.truncateByDomain = exports.findPositionOfBar = exports.checkDomainOfScale = exports.parseScale = exports.combineEventHandlers = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.parseErrorBarsOfAxis = exports.getDomainOfErrorBars = exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getDomainOfDataByKey = exports.getValueByDataKey = undefined;
	
	var _isEqual2 = __webpack_require__(60);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _sortBy2 = __webpack_require__(456);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isNaN2 = __webpack_require__(195);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _isString2 = __webpack_require__(225);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _max2 = __webpack_require__(667);
	
	var _max3 = _interopRequireDefault(_max2);
	
	var _min2 = __webpack_require__(454);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _isArray2 = __webpack_require__(24);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _flatMap2 = __webpack_require__(661);
	
	var _flatMap3 = _interopRequireDefault(_flatMap2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _get2 = __webpack_require__(221);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rechartsScale = __webpack_require__(727);
	
	var _d3Scale = __webpack_require__(424);
	
	var d3Scales = _interopRequireWildcard(_d3Scale);
	
	var _d3Shape = __webpack_require__(213);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ReferenceDot = __webpack_require__(471);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceLine = __webpack_require__(472);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceArea = __webpack_require__(470);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _ErrorBar = __webpack_require__(180);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _Legend = __webpack_require__(397);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getValueByDataKey = exports.getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil3.default)(obj) || (0, _isNil3.default)(dataKey)) {
	    return defaultValue;
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(dataKey)) {
	    return (0, _get3.default)(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction3.default)(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	var getDomainOfDataByKey = exports.getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = (0, _flatMap3.default)(data, function (entry) {
	    return getValueByDataKey(entry, key);
	  });
	
	  if (type === 'number') {
	    var domain = flattenData.filter(_DataUtils.isNumber);
	
	    return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil3.default)(entry);
	  }) : flattenData;
	
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	var calculateActiveTickIndex = exports.calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks, unsortedTicks, axis) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
	      var range = axis.range;
	      // ticks are distributed in a circle
	
	      for (var i = 0; i < len; i++) {
	        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
	        var cur = unsortedTicks[i].coordinate;
	        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
	        var sameDirectionCoord = void 0;
	
	        if ((0, _DataUtils.mathSign)(cur - before) !== (0, _DataUtils.mathSign)(after - cur)) {
	          var diffInterval = [];
	          if ((0, _DataUtils.mathSign)(after - cur) === (0, _DataUtils.mathSign)(range[1] - range[0])) {
	            sameDirectionCoord = after;
	
	            var curInRange = cur + range[1] - range[0];
	            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
	            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
	          } else {
	            sameDirectionCoord = before;
	
	            var afterInRange = after + range[1] - range[0];
	            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
	            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
	          }
	          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
	
	          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        } else {
	          var min = Math.min(before, after);
	          var max = Math.max(before, after);
	
	          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        }
	      }
	    } else {
	      // ticks are distributed in a single direction
	      for (var _i = 0; _i < len; _i++) {
	        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
	          index = ticks[_i].index;
	          break;
	        }
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	var getMainColorOfGraphicItem = exports.getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var result = void 0;
	
	  switch (displayName) {
	    case 'Line':
	    case 'Area':
	    case 'Radar':
	      result = item.props.stroke;
	      break;
	    default:
	      result = item.props.fill;
	      break;
	  }
	
	  return result;
	};
	
	var getLegendProps = exports.getLegendProps = function getLegendProps(_ref) {
	  var children = _ref.children,
	      formatedGraphicalItems = _ref.formatedGraphicalItems,
	      legendWidth = _ref.legendWidth,
	      legendContent = _ref.legendContent;
	
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData = void 0;
	  if (legendItem.props && legendItem.props.payload) {
	    legendData = legendItem.props && legendItem.props.payload;
	  } else if (legendContent === 'children') {
	    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2) {
	      var item = _ref2.item,
	          props = _ref2.props;
	
	      var data = props.sectors || props.data || [];
	
	      return result.concat(data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || item.props.legendType,
	          value: entry.name,
	          color: entry.fill,
	          payload: entry
	        };
	      }));
	    }, []);
	  } else {
	    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
	      var item = _ref3.item;
	      var _item$props = item.props,
	          dataKey = _item$props.dataKey,
	          name = _item$props.name,
	          legendType = _item$props.legendType,
	          hide = _item$props.hide;
	
	
	      return {
	        inactive: hide,
	        dataKey: dataKey,
	        type: legendItem.props.iconType || legendType || 'square',
	        color: getMainColorOfGraphicItem(item),
	        value: name || dataKey,
	        payload: item.props
	      };
	    });
	  }
	
	  return _extends({}, legendItem.props, _Legend2.default.getWithHeight(legendItem, legendWidth), {
	    payload: legendData,
	    item: legendItem
	  });
	};
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	var getBarSizeList = exports.getBarSizeList = function getBarSizeList(_ref4) {
	  var globalSize = _ref4.barSize,
	      _ref4$stackGroups = _ref4.stackGroups,
	      stackGroups = _ref4$stackGroups === undefined ? {} : _ref4$stackGroups;
	
	  if (!stackGroups) {
	    return {};
	  }
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	
	
	      var barItems = items.filter(function (item) {
	        return (0, _ReactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil3.default)(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	var getBarPosition = exports.getBarPosition = function getBarPosition(_ref5) {
	  var barGap = _ref5.barGap,
	      barCategoryGap = _ref5.barCategoryGap,
	      bandSize = _ref5.bandSize,
	      _ref5$sizeList = _ref5.sizeList,
	      sizeList = _ref5$sizeList === undefined ? [] : _ref5$sizeList,
	      maxBarSize = _ref5.maxBarSize;
	
	  var len = sizeList.length;
	  if (len < 1) return null;
	
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result = void 0;
	
	  // whether or not is barSize setted by user
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    var useFull = false;
	    var fullBarSize = bandSize / len;
	    var sum = sizeList.reduce(function (res, entry) {
	      return res + entry.barSize || 0;
	    }, 0);
	    sum += (len - 1) * realBarGap;
	
	    if (sum >= bandSize) {
	      sum -= (len - 1) * realBarGap;
	      realBarGap = 0;
	    }
	    if (sum >= bandSize && fullBarSize > 0) {
	      useFull = true;
	      fullBarSize *= 0.9;
	      sum = len * fullBarSize;
	    }
	
	    var offset = (bandSize - sum) / 2 >> 0;
	    var prev = { offset: offset - realBarGap, size: 0 };
	
	    result = sizeList.reduce(function (res, entry) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: prev.offset + prev.size + realBarGap,
	          size: useFull ? fullBarSize : entry.barSize
	        }
	      }]);
	
	      prev = newRes[newRes.length - 1].position;
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({ item: item, position: prev });
	        });
	      }
	      return newRes;
	    }, []);
	  } else {
	    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
	      realBarGap = 0;
	    }
	
	    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
	    if (originalSize > 1) {
	      originalSize >>= 0;
	    }
	    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	
	    result = sizeList.reduce(function (res, entry, i) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	          size: size
	        }
	      }]);
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({ item: item, position: newRes[newRes.length - 1].position });
	        });
	      }
	      return newRes;
	    }, []);
	  }
	
	  return result;
	};
	
	var appendOffsetOfLegend = exports.appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps({ children: children, items: items, legendWidth: legendWidth, legendHeight: legendHeight });
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _extends({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _extends({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};
	
	var getDomainOfErrorBars = exports.getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
	  var children = item.props.children;
	
	  var errorBars = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default).filter(function (errorBarChild) {
	    var direction = errorBarChild.props.direction;
	
	
	    return (0, _isNil3.default)(direction) || (0, _isNil3.default)(axisType) ? true : axisType.indexOf(direction) >= 0;
	  });
	
	  if (errorBars && errorBars.length) {
	    var keys = errorBars.map(function (errorBarChild) {
	      return errorBarChild.props.dataKey;
	    });
	
	    return data.reduce(function (result, entry) {
	      var entryValue = getValueByDataKey(entry, dataKey, 0);
	      var mainValue = (0, _isArray3.default)(entryValue) ? [(0, _min3.default)(entryValue), (0, _max3.default)(entryValue)] : [entryValue, entryValue];
	      var errorDomain = keys.reduce(function (prevErrorArr, k) {
	        var errorValue = getValueByDataKey(entry, k, 0);
	        var lowerValue = mainValue[0] - Math.abs((0, _isArray3.default)(errorValue) ? errorValue[0] : errorValue);
	        var upperValue = mainValue[1] + Math.abs((0, _isArray3.default)(errorValue) ? errorValue[1] : errorValue);
	
	        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
	      }, [Infinity, -Infinity]);
	
	      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	var parseErrorBarsOfAxis = exports.parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
	  var domains = items.map(function (item) {
	    return getDomainOfErrorBars(data, item, dataKey, axisType);
	  }).filter(function (entry) {
	    return !(0, _isNil3.default)(entry);
	  });
	
	  if (domains && domains.length) {
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	var getDomainOfItemsWithSameAxis = exports.getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    var dataKey = item.props.dataKey;
	
	
	    if (type === 'number' && dataKey) {
	      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
	    }
	    return getDomainOfDataByKey(data, dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {};
	  // Get the union set of category axis
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	
	        result.push(entry[i]);
	      }
	    }
	    return result;
	  }, []);
	};
	
	var isCategorialAxis = exports.isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
	};
	
	/**
	 * Calculate the Coordinates of grid
	 * @param  {Array} ticks The ticks in axis
	 * @param {Number} min   The minimun value of axis
	 * @param {Number} max   The maximun value of axis
	 * @return {Array}       Coordinates
	 */
	var getCoordinatesOfGrid = exports.getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin = void 0,
	      hasMax = void 0;
	
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	var getTicksOfAxis = exports.getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type,
	      range = axis.range;
	
	  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
	  offset = axis.axisType === 'angleAxis' ? (0, _DataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset;
	
	  // The ticks setted by user should only affect the ticks adjacent to axis line
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index,
	        offset: offset
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return { coordinate: scale(entry) + offset, value: entry, offset: offset };
	    });
	  }
	
	  // When axis has duplicated text, serial numbers are used to generate scale
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index,
	      offset: offset
	    };
	  });
	};
	
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	var combineEventHandlers = exports.combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler = void 0;
	
	  if ((0, _isFunction3.default)(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction3.default)(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction3.default)(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction3.default)(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	      if ((0, _isFunction3.default)(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {Object}   axis          The option of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	var parseScale = exports.parseScale = function parseScale(axis, chartType) {
	  var scale = axis.scale,
	      type = axis.type,
	      layout = axis.layout,
	      axisType = axis.axisType;
	
	  if (scale === 'auto') {
	    if (layout === 'radial' && axisType === 'radiusAxis') {
	      return { scale: d3Scales.scaleBand(), realScaleType: 'band' };
	    } else if (layout === 'radial' && axisType === 'angleAxis') {
	      return { scale: d3Scales.scaleLinear(), realScaleType: 'linear' };
	    }
	
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return { scale: d3Scales.scalePoint(), realScaleType: 'point' };
	    } else if (type === 'category') {
	      return { scale: d3Scales.scaleBand(), realScaleType: 'band' };
	    }
	
	    return { scale: d3Scales.scaleLinear(), realScaleType: 'linear' };
	  } else if ((0, _isString3.default)(scale)) {
	    var name = 'scale' + scale.slice(0, 1).toUpperCase() + scale.slice(1);
	
	    return {
	      scale: (d3Scales[name] || d3Scales.scalePoint)(),
	      realScaleType: d3Scales[name] ? name : 'point'
	    };
	  }
	
	  return (0, _isFunction3.default)(scale) ? { scale: scale } : { scale: d3Scales.scalePoint(), realScaleType: 'point' };
	};
	var EPS = 1e-4;
	var checkDomainOfScale = exports.checkDomainOfScale = function checkDomainOfScale(scale) {
	  var domain = scale.domain();
	
	  if (!domain || domain.length <= 2) {
	    return;
	  }
	
	  var len = domain.length;
	  var range = scale.range();
	  var min = Math.min(range[0], range[1]) - EPS;
	  var max = Math.max(range[0], range[1]) + EPS;
	  var first = scale(domain[0]);
	  var last = scale(domain[len - 1]);
	
	  if (first < min || first > max || last < min || last > max) {
	    scale.domain([domain[0], domain[len - 1]]);
	  }
	};
	
	var findPositionOfBar = exports.findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	var truncateByDomain = exports.truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !(0, _DataUtils.isNumber)(domain[0]) || !(0, _DataUtils.isNumber)(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	
	  var result = [value[0], value[1]];
	  if (!(0, _DataUtils.isNumber)(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!(0, _DataUtils.isNumber)(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};
	
	/* eslint no-param-reassign: 0 */
	var offsetSign = exports.offsetSign = function offsetSign(series) {
	  var n = series.length;
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = (0, _isNaN3.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	    }
	  }
	};
	
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var getStackedData = exports.getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +getValueByDataKey(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	
	  return stack(data);
	};
	
	var getStackGroupsByAxisId = exports.getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
	  if (!data) {
	    return null;
	  }
	
	  // reversing items to affect render order (for layering)
	  var items = reverseStackOrder ? _items.reverse() : _items;
	
	  var stackGroups = items.reduce(function (result, item) {
	    var _item$props2 = item.props,
	        stackId = _item$props2.stackId,
	        hide = _item$props2.hide;
	
	
	    if (hide) {
	      return result;
	    }
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || { hasStack: false, stackGroups: {} };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: []
	      };
	
	      childGroup.items.push(item);
	
	      parentGroup.hasStack = true;
	
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: [item]
	      };
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	
	        return _extends({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	var calculateDomainOfTicks = exports.calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	  }
	
	  return ticks;
	};
	
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	var getTicksOfScale = exports.getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var realScaleType = opts.realScaleType,
	      type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	
	  var scaleType = realScaleType || opts.scale;
	
	  if (scaleType !== 'auto' && scaleType !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	
	    return { niceTicks: tickValues };
	  } else if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return { niceTicks: _tickValues };
	  }
	
	  return null;
	};
	
	var getCateCoordinateOfLine = exports.getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
	  var axis = _ref6.axis,
	      ticks = _ref6.ticks,
	      bandSize = _ref6.bandSize,
	      entry = _ref6.entry,
	      index = _ref6.index;
	
	  if (axis.type === 'category') {
	    // find coordinate of category axis by the value of category
	    if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNil3.default)(entry[axis.dataKey])) {
	      var matchedTick = (0, _DataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
	
	      if (matchedTick) {
	        return matchedTick.coordinate + bandSize / 2;
	      }
	    }
	
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = getValueByDataKey(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) : null;
	};
	
	var getCateCoordinateOfBar = exports.getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
	  var axis = _ref7.axis,
	      ticks = _ref7.ticks,
	      offset = _ref7.offset,
	      bandSize = _ref7.bandSize,
	      entry = _ref7.entry,
	      index = _ref7.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	var getBaseValueOfBar = exports.getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
	  var numericAxis = _ref8.numericAxis;
	
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	var detectReferenceElementsDomain = exports.detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine2.default);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot2.default);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea2.default);
	  var idKey = axisType + 'Id';
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    var key1 = valueKey + '1';
	    var key2 = valueKey + '2';
	
	    finalDomain = areas.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	        var value1 = el.props[key1];
	        var value2 = el.props[key2];
	
	        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  if (specifiedTicks && specifiedTicks.length) {
	    finalDomain = specifiedTicks.reduce(function (result, tick) {
	      if ((0, _DataUtils.isNumber)(tick)) {
	        return [Math.min(result[0], tick), Math.max(result[1], tick)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  return finalDomain;
	};
	
	var getStackedDataOfItem = exports.getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [Math.min.apply(null, entry.concat([result[0]]).filter(_DataUtils.isNumber)), Math.max.apply(null, entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = exports.getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	var MIN_VALUE_REG = exports.MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	var MAX_VALUE_REG = exports.MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	
	var parseSpecifiedDomain = exports.parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray3.default)(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	
	    domain[0] = dataDomain[0] - value;
	  } else if ((0, _isFunction3.default)(specifiedDomain[0])) {
	    domain[0] = specifiedDomain[0](dataDomain[0]);
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else if ((0, _isFunction3.default)(specifiedDomain[1])) {
	    domain[1] = specifiedDomain[1](dataDomain[1]);
	  } else {
	    domain[1] = dataDomain[1];
	  }
	
	  return domain;
	};
	
	var validateCoordinateInRange = exports.validateCoordinateInRange = function validateCoordinateInRange(coordinate, scale) {
	  if (!scale) {
	    return false;
	  }
	
	  var range = scale.range();
	  var first = range[0];
	  var last = range[range.length - 1];
	  var isValidate = first <= last ? coordinate >= first && coordinate <= last : coordinate >= last && coordinate <= first;
	
	  return isValidate;
	};
	
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	var getBandSizeOfAxis = exports.getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && ticks && ticks.length >= 2) {
	    var orderedTicks = (0, _sortBy3.default)(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};
	/**
	 * parse the domain of a category axis when a domain is specified
	 * @param   {Array}        specifiedDomain  The domain specified by users
	 * @param   {Array}        calculatedDomain The domain calculated by dateKey
	 * @param   {ReactElement} axisChild        The axis element
	 * @returns {Array}        domains
	 */
	var parseDomainOfCategoryAxis = exports.parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
	  if (!specifiedDomain || !specifiedDomain.length) {
	    return calculatedDomain;
	  }
	
	  if ((0, _isEqual3.default)(specifiedDomain, (0, _get3.default)(axisChild, 'type.defaultProps.domain'))) {
	    return calculatedDomain;
	  }
	
	  return specifiedDomain;
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bem = exports.Version = exports.Tooltipped = exports.injectTooltip = exports.Toolbar = exports.TextField = exports.TabPanel = exports.MenuTab = exports.Tab = exports.Tabs = exports.TabsContainer = exports.Subheader = exports.SVGIcon = exports.Snackbar = exports.Sidebar = exports.Slider = exports.Switch = exports.Radio = exports.RadioGroup = exports.Checkbox = exports.SelectionControlGroup = exports.SelectionControl = exports.SelectField = exports.LinearProgress = exports.CircularProgress = exports.TimePicker = exports.DatePicker = exports.Paper = exports.JumpToContentLink = exports.CloseButton = exports.NavigationDrawer = exports.MenuButton = exports.DropdownMenu = exports.Menu = exports.MediaOverlay = exports.Media = exports.ListItemControl = exports.ListItem = exports.List = exports.injectInk = exports.ResizeObserver = exports.Portal = exports.Layover = exports.FocusContainer = exports.IconSeparator = exports.Collapse = exports.AccessibleFakeInkedButton = exports.AccessibleFakeButton = exports.GridList = exports.Cell = exports.Grid = exports.FontIcon = exports.FileUpload = exports.FileInput = exports.SpeedDial = exports.ExpansionPanel = exports.ExpansionList = exports.Drawer = exports.Divider = exports.Dialog = exports.DialogContainer = exports.DropdownMenuColumn = exports.MenuButtonColumn = exports.SelectFieldColumn = exports.TablePagination = exports.EditDialogColumn = exports.TableCardHeader = exports.TableColumn = exports.TableRow = exports.TableFooter = exports.TableBody = exports.TableHeader = exports.DataTable = exports.Chip = exports.CardActionOverlay = exports.CardText = exports.CardActions = exports.CardMedia = exports.CardTitle = exports.Card = exports.IconButton = exports.FloatingButton = exports.RaisedButton = exports.FlatButton = exports.Button = exports.Badge = exports.BottomNavigation = exports.Avatar = exports.Autocomplete = undefined;
	
	var _Autocompletes = __webpack_require__(230);
	
	var _Autocompletes2 = _interopRequireDefault(_Autocompletes);
	
	var _Avatars = __webpack_require__(232);
	
	var _Avatars2 = _interopRequireDefault(_Avatars);
	
	var _Badges = __webpack_require__(234);
	
	var _Badges2 = _interopRequireDefault(_Badges);
	
	var _BottomNavigations = __webpack_require__(237);
	
	var _BottomNavigations2 = _interopRequireDefault(_BottomNavigations);
	
	var _Buttons = __webpack_require__(241);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Cards = __webpack_require__(246);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _Chips = __webpack_require__(248);
	
	var _Chips2 = _interopRequireDefault(_Chips);
	
	var _DataTables = __webpack_require__(261);
	
	var _DataTables2 = _interopRequireDefault(_DataTables);
	
	var _Dialogs = __webpack_require__(264);
	
	var _Dialogs2 = _interopRequireDefault(_Dialogs);
	
	var _Dividers = __webpack_require__(265);
	
	var _Dividers2 = _interopRequireDefault(_Dividers);
	
	var _Drawers = __webpack_require__(267);
	
	var _Drawers2 = _interopRequireDefault(_Drawers);
	
	var _ExpansionPanels = __webpack_require__(271);
	
	var _FABTransitions = __webpack_require__(273);
	
	var _FileInputs = __webpack_require__(275);
	
	var _FileInputs2 = _interopRequireDefault(_FileInputs);
	
	var _FontIcons = __webpack_require__(139);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	var _Grids = __webpack_require__(277);
	
	var _Helpers = __webpack_require__(278);
	
	var _Inks = __webpack_require__(281);
	
	var _Inks2 = _interopRequireDefault(_Inks);
	
	var _Lists = __webpack_require__(284);
	
	var _Media = __webpack_require__(285);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _Menus = __webpack_require__(286);
	
	var _Menus2 = _interopRequireDefault(_Menus);
	
	var _NavigationDrawers = __webpack_require__(289);
	
	var _NavigationDrawers2 = _interopRequireDefault(_NavigationDrawers);
	
	var _Papers = __webpack_require__(290);
	
	var _Papers2 = _interopRequireDefault(_Papers);
	
	var _Pickers = __webpack_require__(307);
	
	var _Progress = __webpack_require__(310);
	
	var _SelectionControls = __webpack_require__(322);
	
	var _SelectFields = __webpack_require__(315);
	
	var _SelectFields2 = _interopRequireDefault(_SelectFields);
	
	var _Sliders = __webpack_require__(332);
	
	var _Sliders2 = _interopRequireDefault(_Sliders);
	
	var _Sidebars = __webpack_require__(324);
	
	var _Sidebars2 = _interopRequireDefault(_Sidebars);
	
	var _Snackbars = __webpack_require__(334);
	
	var _Snackbars2 = _interopRequireDefault(_Snackbars);
	
	var _SVGIcons = __webpack_require__(312);
	
	var _SVGIcons2 = _interopRequireDefault(_SVGIcons);
	
	var _Subheaders = __webpack_require__(156);
	
	var _Subheaders2 = _interopRequireDefault(_Subheaders);
	
	var _Tabs = __webpack_require__(340);
	
	var _TextFields = __webpack_require__(345);
	
	var _TextFields2 = _interopRequireDefault(_TextFields);
	
	var _Toolbars = __webpack_require__(347);
	
	var _Toolbars2 = _interopRequireDefault(_Toolbars);
	
	var _Tooltips = __webpack_require__(350);
	
	var _Tooltips2 = _interopRequireDefault(_Tooltips);
	
	var _Version = __webpack_require__(351);
	
	var _Version2 = _interopRequireDefault(_Version);
	
	var _bem = __webpack_require__(101);
	
	var _bem2 = _interopRequireDefault(_bem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Exposes for UMD -> ReactMD.Autocomplete
	exports.Autocomplete = _Autocompletes2.default;
	exports.Avatar = _Avatars2.default;
	exports.BottomNavigation = _BottomNavigations2.default;
	exports.Badge = _Badges2.default;
	exports.Button = _Buttons2.default;
	exports.FlatButton = _Buttons.FlatButton;
	exports.RaisedButton = _Buttons.RaisedButton;
	exports.FloatingButton = _Buttons.FloatingButton;
	exports.IconButton = _Buttons.IconButton;
	exports.Card = _Cards2.default;
	exports.CardTitle = _Cards.CardTitle;
	exports.CardMedia = _Cards.CardMedia;
	exports.CardActions = _Cards.CardActions;
	exports.CardText = _Cards.CardText;
	exports.CardActionOverlay = _Cards.CardActionOverlay;
	exports.Chip = _Chips2.default;
	exports.DataTable = _DataTables2.default;
	exports.TableHeader = _DataTables.TableHeader;
	exports.TableBody = _DataTables.TableBody;
	exports.TableFooter = _DataTables.TableFooter;
	exports.TableRow = _DataTables.TableRow;
	exports.TableColumn = _DataTables.TableColumn;
	exports.TableCardHeader = _DataTables.TableCardHeader;
	exports.EditDialogColumn = _DataTables.EditDialogColumn;
	exports.TablePagination = _DataTables.TablePagination;
	exports.SelectFieldColumn = _DataTables.SelectFieldColumn;
	exports.MenuButtonColumn = _DataTables.MenuButtonColumn;
	exports.DropdownMenuColumn = _DataTables.DropdownMenuColumn;
	exports.DialogContainer = _Dialogs2.default;
	exports.Dialog = _Dialogs.Dialog;
	exports.Divider = _Dividers2.default;
	exports.Drawer = _Drawers2.default;
	exports.ExpansionList = _ExpansionPanels.ExpansionList;
	exports.ExpansionPanel = _ExpansionPanels.ExpansionPanel;
	exports.SpeedDial = _FABTransitions.SpeedDial;
	exports.FileInput = _FileInputs2.default;
	exports.FileUpload = _FileInputs.FileUpload;
	exports.FontIcon = _FontIcons2.default;
	exports.Grid = _Grids.Grid;
	exports.Cell = _Grids.Cell;
	exports.GridList = _Grids.GridList;
	exports.AccessibleFakeButton = _Helpers.AccessibleFakeButton;
	exports.AccessibleFakeInkedButton = _Helpers.AccessibleFakeInkedButton;
	exports.Collapse = _Helpers.Collapse;
	exports.IconSeparator = _Helpers.IconSeparator;
	exports.FocusContainer = _Helpers.FocusContainer;
	exports.Layover = _Helpers.Layover;
	exports.Portal = _Helpers.Portal;
	exports.ResizeObserver = _Helpers.ResizeObserver;
	exports.injectInk = _Inks2.default;
	exports.List = _Lists.List;
	exports.ListItem = _Lists.ListItem;
	exports.ListItemControl = _Lists.ListItemControl;
	exports.Media = _Media2.default;
	exports.MediaOverlay = _Media.MediaOverlay;
	exports.Menu = _Menus2.default;
	exports.DropdownMenu = _Menus.DropdownMenu;
	exports.MenuButton = _Menus.MenuButton;
	exports.NavigationDrawer = _NavigationDrawers2.default;
	exports.CloseButton = _NavigationDrawers.CloseButton;
	exports.JumpToContentLink = _NavigationDrawers.JumpToContentLink;
	exports.Paper = _Papers2.default;
	exports.DatePicker = _Pickers.DatePicker;
	exports.TimePicker = _Pickers.TimePicker;
	exports.CircularProgress = _Progress.CircularProgress;
	exports.LinearProgress = _Progress.LinearProgress;
	exports.SelectField = _SelectFields2.default;
	exports.SelectionControl = _SelectionControls.SelectionControl;
	exports.SelectionControlGroup = _SelectionControls.SelectionControlGroup;
	exports.Checkbox = _SelectionControls.Checkbox;
	exports.RadioGroup = _SelectionControls.RadioGroup;
	exports.Radio = _SelectionControls.Radio;
	exports.Switch = _SelectionControls.Switch;
	exports.Slider = _Sliders2.default;
	exports.Sidebar = _Sidebars2.default;
	exports.Snackbar = _Snackbars2.default;
	exports.SVGIcon = _SVGIcons2.default;
	exports.Subheader = _Subheaders2.default;
	exports.TabsContainer = _Tabs.TabsContainer;
	exports.Tabs = _Tabs.Tabs;
	exports.Tab = _Tabs.Tab;
	exports.MenuTab = _Tabs.MenuTab;
	exports.TabPanel = _Tabs.TabPanel;
	exports.TextField = _TextFields2.default;
	exports.Toolbar = _Toolbars2.default;
	exports.injectTooltip = _Tooltips2.default;
	exports.Tooltipped = _Tooltips.Tooltipped;
	exports.Version = _Version2.default;
	exports.bem = _bem2.default;
	
	// Exposes for ES6 modules
	
	exports.default = {
	  Autocomplete: _Autocompletes2.default,
	  Avatar: _Avatars2.default,
	  Badge: _Badges2.default,
	  BottomNavigation: _BottomNavigations2.default,
	
	  Button: _Buttons2.default,
	  FlatButton: _Buttons.FlatButton,
	  RaisedButton: _Buttons.RaisedButton,
	  FloatingButton: _Buttons.FloatingButton,
	  IconButton: _Buttons.IconButton,
	
	  Card: _Cards2.default,
	  CardTitle: _Cards.CardTitle,
	  CardMedia: _Cards.CardMedia,
	  CardActions: _Cards.CardActions,
	  CardText: _Cards.CardText,
	  CardActionOverlay: _Cards.CardActionOverlay,
	
	  Chip: _Chips2.default,
	
	  DataTable: _DataTables2.default,
	  TableHeader: _DataTables.TableHeader,
	  TableBody: _DataTables.TableBody,
	  TableFooter: _DataTables.TableFooter,
	  TableRow: _DataTables.TableRow,
	  TableColumn: _DataTables.TableColumn,
	  TableCardHeader: _DataTables.TableCardHeader,
	  EditDialogColumn: _DataTables.EditDialogColumn,
	  TablePagination: _DataTables.TablePagination,
	  SelectFieldColumn: _DataTables.SelectFieldColumn,
	  MenuButtonColumn: _DataTables.MenuButtonColumn,
	  DropdownMenuColumn: _DataTables.DropdownMenuColumn,
	
	  DialogContainer: _Dialogs2.default,
	  Dialog: _Dialogs.Dialog,
	  Divider: _Dividers2.default,
	  Drawer: _Drawers2.default,
	
	  ExpansionList: _ExpansionPanels.ExpansionList,
	  ExpansionPanel: _ExpansionPanels.ExpansionPanel,
	
	  SpeedDial: _FABTransitions.SpeedDial,
	
	  FileInput: _FileInputs2.default,
	  FileUpload: _FileInputs.FileUpload,
	
	  FontIcon: _FontIcons2.default,
	
	  Grid: _Grids.Grid,
	  Cell: _Grids.Cell,
	  GridList: _Grids.GridList,
	
	  AccessibleFakeButton: _Helpers.AccessibleFakeButton,
	  AccessibleFakeInkedButton: _Helpers.AccessibleFakeInkedButton,
	  Collapse: _Helpers.Collapse,
	  IconSeparator: _Helpers.IconSeparator,
	  Layover: _Helpers.Layover,
	  FocusContainer: _Helpers.FocusContainer,
	  Portal: _Helpers.Portal,
	  ResizeObserver: _Helpers.ResizeObserver,
	
	  injectInk: _Inks2.default,
	
	  List: _Lists.List,
	  ListItem: _Lists.ListItem,
	  ListItemControl: _Lists.ListItemControl,
	
	  Media: _Media2.default,
	  MediaOverlay: _Media.MediaOverlay,
	
	  Menu: _Menus2.default,
	  DropdownMenu: _Menus.DropdownMenu,
	  MenuButton: _Menus.MenuButton,
	
	  NavigationDrawer: _NavigationDrawers2.default,
	  CloseButton: _NavigationDrawers.CloseButton,
	  JumpToContentLink: _NavigationDrawers.JumpToContentLink,
	
	  Paper: _Papers2.default,
	
	  DatePicker: _Pickers.DatePicker,
	  TimePicker: _Pickers.TimePicker,
	
	  CircularProgress: _Progress.CircularProgress,
	  LinearProgress: _Progress.LinearProgress,
	
	  SelectField: _SelectFields2.default,
	
	  SelectionControl: _SelectionControls.SelectionControl,
	  SelectionControlGroup: _SelectionControls.SelectionControlGroup,
	  Checkbox: _SelectionControls.Checkbox,
	  RadioGroup: _SelectionControls.RadioGroup,
	  Radio: _SelectionControls.Radio,
	  Switch: _SelectionControls.Switch,
	
	  Slider: _Sliders2.default,
	  Sidebar: _Sidebars2.default,
	  Snackbar: _Snackbars2.default,
	
	  SVGIcon: _SVGIcons2.default,
	  Subheader: _Subheaders2.default,
	
	  TabsContainer: _Tabs.TabsContainer,
	  Tabs: _Tabs.Tabs,
	  Tab: _Tabs.Tab,
	  MenuTab: _Tabs.MenuTab,
	  TabPanel: _Tabs.TabPanel,
	
	  TextField: _TextFields2.default,
	  Toolbar: _Toolbars2.default,
	  injectTooltip: _Tooltips2.default,
	  Tooltipped: _Tooltips.Tooltipped,
	
	  Version: _Version2.default,
	
	  bem: _bem2.default
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactMotion = __webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Collapse` component is used to animate a single child entering
	 * or leaving. This uses the `react-motion` library to animate the height,
	 * padding-top, and padding-bottom of an element when the `collapsed` prop
	 * changes.
	 */
	var Collapse = function (_PureComponent) {
	  _inherits(Collapse, _PureComponent);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    _this._setHeight = function (child) {
	      if (_this._child && typeof _this._child.ref === 'function') {
	        _this._child.ref(child);
	      }
	
	      var height = 0;
	      var paddingTop = 0;
	      var paddingBottom = 0;
	      if (child !== null) {
	        var node = (0, _reactDom.findDOMNode)(child);
	        var cs = window.getComputedStyle(node);
	        height = node.offsetHeight;
	        paddingTop = parseInt(cs.getPropertyValue('padding-top'), 10);
	        paddingBottom = parseInt(cs.getPropertyValue('padding-bottom'), 10);
	      }
	
	      height = Math.max(_this.props.minHeight, height);
	
	      _this.setState({ height: height, paddingTop: paddingTop, paddingBottom: paddingBottom });
	    };
	
	    if (!props.collapsed) {
	      _this.state = { initialOpen: true };
	    } else {
	      _this.state = {
	        height: props.minHeight,
	        paddingTop: 0,
	        paddingBottom: 0
	      };
	    }
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.initialOpen && nextProps.collapsed) {
	        this.setState({ initialOpen: false });
	      }
	    }
	  }, {
	    key: '_spring',
	    value: function _spring(collapsed, initialOpen, value, config) {
	      var min = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	      var nextValue = !collapsed ? Math.max(min, value) : min;
	      if (initialOpen && !collapsed) {
	        return nextValue;
	      }
	
	      return (0, _reactMotion.spring)(nextValue, config);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          height = _state.height,
	          paddingTop = _state.paddingTop,
	          paddingBottom = _state.paddingBottom,
	          initialOpen = _state.initialOpen;
	      var _props = this.props,
	          children = _props.children,
	          collapsed = _props.collapsed,
	          defaultStyle = _props.defaultStyle,
	          motionStyle = _props.style,
	          springConfig = _props.springConfig,
	          animate = _props.animate,
	          minHeight = _props.minHeight;
	
	
	      if (!animate) {
	        return collapsed ? null : children;
	      }
	
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        {
	          style: _extends({}, motionStyle, {
	            height: this._spring(collapsed, initialOpen, height, springConfig, minHeight),
	            paddingTop: this._spring(collapsed, initialOpen, paddingTop, springConfig),
	            paddingBottom: this._spring(collapsed, initialOpen, paddingBottom, springConfig)
	          }),
	          defaultStyle: _extends({}, defaultStyle, {
	            height: height,
	            paddingTop: paddingTop,
	            paddingBottom: paddingBottom
	          })
	        },
	        function (style) {
	          if (collapsed && !style.height) {
	            return null;
	          }
	
	          var child = _react.Children.only(children);
	          _this2._child = child;
	          var nextStyle = child.props.style;
	          if (collapsed && (!minHeight || style.height !== minHeight) || style.height !== height) {
	            nextStyle = _extends({}, child.props.style, style, {
	              overflow: 'hidden'
	            });
	          }
	          return (0, _react.cloneElement)(child, {
	            ref: !collapsed && _this2._setHeight,
	            style: nextStyle
	          });
	        }
	      );
	    }
	  }]);
	
	  return Collapse;
	}(_react.PureComponent);
	
	Collapse.propTypes = {
	  /**
	   * An optional style to merge with the `Motion` style.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional default style to merge with the `Motion` default style.
	   */
	  defaultStyle: _propTypes2.default.object,
	
	  /**
	   * Boolean if the children are currently collapsed.
	   */
	  collapsed: _propTypes2.default.bool.isRequired,
	
	  /**
	   * A single child to collapse or expand.
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * The spring config to use for the animation.
	   */
	  springConfig: _propTypes2.default.object.isRequired,
	
	  /**
	   * Boolean if the single child entering or leaving should be animated.
	   */
	  animate: _propTypes2.default.bool,
	
	  /**
	   * The min height to apply for the collapse div.
	   */
	  minHeight: _propTypes2.default.number.isRequired
	};
	Collapse.defaultProps = {
	  animate: true,
	  springConfig: {
	    precision: 0.5
	  },
	  minHeight: 0
	};
	exports.default = Collapse;
	//# sourceMappingURL=Collapse.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = componentDeprecated;
	/** @module utils/PropTypes/componentDeprecated */
	
	/**
	 * A simple PropType validation that shows that a component is deprecated and also prints
	 * a reason for the deprecation.
	 *
	 * @param {String} reason - The reason that the component is deprecated.
	 * @return {Error} a prop type validation error.
	 */
	function componentDeprecated(reason) {
	  return function validate(props, propName, componentName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	
	    return new Error('The `' + componentNameSafe + '` has been deprecated and will be removed in the next release. ' + reason);
	  };
	}
	//# sourceMappingURL=componentDeprecated.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = invalidIf;
	/** @module utils/PropTypes/invalidIf */
	
	/**
	 * A custom validator that will throw an error if any of the `ifDefinedProps` are also defined.
	 *
	 * @param {function} validator - The PropTypes validator to use.
	 * @param {String...} ifDefinedProps - any othe rprop names to validate against
	 * @return {Error} an error or null
	 */
	function invalidIf(validator) {
	  for (var _len = arguments.length, ifDefinedProps = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    ifDefinedProps[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (err) {
	      return err;
	    }
	
	    var defined = typeof props[propName] !== 'undefined' && !!props[propName];
	    var othersDefined = ifDefinedProps.filter(function (name) {
	      return typeof props[name] !== 'undefined' && !!props[name];
	    });
	    if (defined && othersDefined.length) {
	      var names = '`' + othersDefined.join('`, `') + '`';
	      if (othersDefined.length === 1) {
	        return new Error('You provided both a `' + propFullNameSafe + '` and ' + names + ' prop to the ' + componentNameSafe + ' ' + 'but only one can be given.');
	      }
	
	      return new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' when ' + ('the following props were defined: ' + names + '. Either remove the `' + propFullNameSafe + '` ') + 'or use the remove all the other props.');
	    }
	
	    return null;
	  };
	}
	//# sourceMappingURL=invalidIf.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(81);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(391);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _getCollapserStyles = __webpack_require__(75);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _injectTooltip = __webpack_require__(72);
	
	var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _IconSeparator = __webpack_require__(44);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CELL_SCOPE = {
	  header: {
	    scope: 'col'
	  },
	  noop: {}
	};
	
	/**
	 * A column in a table. This is either the `th` or `td` component.
	 */
	
	var TableColumn = function (_PureComponent) {
	  _inherits(TableColumn, _PureComponent);
	
	  function TableColumn() {
	    _classCallCheck(this, TableColumn);
	
	    return _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).apply(this, arguments));
	  }
	
	  _createClass(TableColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          fixedStyle = _props.fixedStyle,
	          fixedClassName = _props.fixedClassName,
	          numeric = _props.numeric,
	          header = _props.header,
	          children = _props.children,
	          sorted = _props.sorted,
	          sortIcon = _props.sortIcon,
	          tooltip = _props.tooltip,
	          selectColumnHeader = _props.selectColumnHeader,
	          adjusted = _props.adjusted,
	          grow = _props.grow,
	          sortIconBefore = _props.sortIconBefore,
	          propPlain = _props.plain,
	          propScope = _props.scope,
	          cellIndex = _props.cellIndex,
	          sortIconChildren = _props.sortIconChildren,
	          sortIconClassName = _props.sortIconClassName,
	          props = _objectWithoutProperties(_props, ['className', 'fixedStyle', 'fixedClassName', 'numeric', 'header', 'children', 'sorted', 'sortIcon', 'tooltip', 'selectColumnHeader', 'adjusted', 'grow', 'sortIconBefore', 'plain', 'scope', 'cellIndex', 'sortIconChildren', 'sortIconClassName']);
	
	      var sortable = typeof sorted === 'boolean';
	      var plain = (0, _getField2.default)(this.props, this.context, 'plain');
	      var Component = header ? 'th' : 'td';
	      var scope = (0, _getField2.default)(this.props, CELL_SCOPE[header ? 'header' : 'noop'], 'scope');
	
	      var displayedChildren = children;
	      var ariaSort = void 0;
	      if (sortable) {
	        ariaSort = sorted ? 'ascending' : 'descending';
	        var icon = _react2.default.Children.only((0, _getDeprecatedIcon2.default)(sortIconClassName, sortIconChildren, sortIcon));
	        displayedChildren = _react2.default.createElement(
	          _IconSeparator2.default,
	          { label: children, iconBefore: sortIconBefore },
	          _react2.default.cloneElement(icon, { className: (0, _getCollapserStyles2.default)({ flipped: !sorted }, icon.props.className) })
	        );
	      }
	
	      var fixedHeader = header && this.context.fixedHeader;
	      var fixedFooter = this.context.footer && this.context.fixedFooter;
	      var fixed = fixedHeader || fixedFooter;
	      var baseClassNames = (0, _themeColors2.default)({ text: !header, hint: header }, {
	        'md-table-column--relative': tooltip,
	        'md-table-column--select-field': selectColumnHeader
	      });
	
	      var mergedClassNames = (0, _classnames2.default)(_defineProperty({
	        'md-table-column--header': header,
	        'md-table-column--data': !header && !plain,
	        'md-table-column--plain': !header && plain,
	        'md-table-column--adjusted': adjusted && !grow && !selectColumnHeader,
	        'md-table-column--grow': grow,
	        'md-table-column--sortable md-pointer--hover': sortable
	      }, baseClassNames, !fixed), className);
	
	      if (fixed) {
	        displayedChildren = _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('md-table-column__fixed', {
	              'md-table-column__fixed--header': fixedHeader,
	              'md-table-column__fixed--footer': fixedFooter
	            })
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              style: fixedStyle,
	              className: (0, _classnames2.default)(baseClassNames, mergedClassNames, 'md-table-column__fixed--flex', {
	                'md-table-column__fixed--flex-right': numeric
	              }, fixedClassName)
	            },
	            tooltip,
	            displayedChildren
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({
	          'aria-sort': ariaSort
	        }, props, {
	          scope: scope,
	          className: (0, _classnames2.default)('md-table-column', {
	            'md-table-column--fixed': fixed,
	            'md-text-left': !numeric && !fixed,
	            'md-text-right': numeric && !fixed
	          }, mergedClassNames)
	        }),
	        !fixedHeader && !fixedFooter && tooltip,
	        displayedChildren
	      );
	    }
	  }]);
	
	  return TableColumn;
	}(_react.PureComponent);
	
	TableColumn.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * The optional className for the table column
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the surrounding div when the DataTable has been
	   * set to include a fixed header or a fixed footer.
	   */
	  fixedStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the surrounding div when the DataTable has been
	   * set to include a fixed header or a fixed footer.
	   */
	  fixedClassName: _propTypes2.default.string,
	
	  /**
	   * The children to display in the column.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the column is currently sorted. If this prop is not `undefined`,
	   * it will add the sort icon unto this column. You will also need to use the
	   * `onClick` function to toggle the `sorted` prop as well as handling the sorting
	   * of data.
	   *
	   * This value should really only be set in the `TableHeader` component.
	   */
	  sorted: _propTypes2.default.bool,
	
	  /**
	   * The icon to show when a column is sortable.
	   */
	  sortIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the sortIcon should appear before the text in the column.
	   */
	  sortIconBefore: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the column has numeric data. It will right-align the data.
	   */
	  numeric: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the table column should gain the `.md-data-table--adjusted` class name. By default,
	   * every column will gain this class name unless it is an `EditDialogColumn`, a `SelectFieldColumn`,
	   * or the `grow` prop is enabled.
	   */
	  adjusted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the column should expand to fill any remaining width in the container. There should
	   * really only be one column with the `grow` prop enabled. In addition, it should really only be
	   * applied to one of the columns in the TableHeader.
	   */
	  grow: _propTypes2.default.bool,
	
	  /**
	   * Boolean if this column is the `th` for a column of `SelectFieldColumn`. This will apply
	   * additional styling to the column to position with the select field.
	   */
	  selectColumnHeader: _propTypes2.default.bool,
	
	  /**
	   * Boolean if this is a `th` component. This value **should** be set
	   * automatically for you if it is in the `TableHeader` component.
	   */
	  header: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The optional tooltip to render on hover.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The injected tooltip.
	   * @access private
	   */
	  tooltip: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `TableColumn` should gain the `plain` styles. This means that the text
	   * in the column can wrap and there is no height limit enforced with some additional padding.
	   */
	  plain: _propTypes2.default.bool,
	
	  /**
	   * An optional scope to apply to the table column. If omitted, the scope will be set to
	   * `'col'` if inside of the `TableHeader` component. This is really only needed for
	   * header columns.
	   */
	  scope: _propTypes2.default.oneOf(['row', 'col']),
	
	  /**
	   * This is injected by the `TableRow` component to help with generating ids
	   * @access private
	   */
	  cellIndex: _propTypes2.default.number,
	  sortIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `sortIcon` prop instead'),
	  sortIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `sortIcon` prop instead')
	};
	TableColumn.defaultProps = {
	  header: false,
	  adjusted: true,
	  sortIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_upward'
	  ),
	  sortIconBefore: true
	};
	TableColumn.contextTypes = {
	  plain: _propTypes2.default.bool,
	  footer: _propTypes2.default.bool,
	  fixedHeader: _propTypes2.default.bool,
	  fixedFooter: _propTypes2.default.bool
	};
	exports.default = (0, _injectTooltip2.default)(TableColumn);
	//# sourceMappingURL=TableColumn.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `IconSeparator` component is a simple helper component to render some text and
	 * an icon with some space between them while centering the text. The icon can either
	 * come before or after the text.
	 */
	var IconSeparator = function (_PureComponent) {
	  _inherits(IconSeparator, _PureComponent);
	
	  function IconSeparator() {
	    _classCallCheck(this, IconSeparator);
	
	    return _possibleConstructorReturn(this, (IconSeparator.__proto__ || Object.getPrototypeOf(IconSeparator)).apply(this, arguments));
	  }
	
	  _createClass(IconSeparator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          labelStyle = _props.labelStyle,
	          labelClassName = _props.labelClassName,
	          component = _props.component,
	          label = _props.label,
	          iconBefore = _props.iconBefore,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'labelStyle', 'labelClassName', 'component', 'label', 'iconBefore', 'children']);
	
	      var text = void 0;
	      if ((0, _react.isValidElement)(label)) {
	        var labelProps = _react.Children.only(label).props;
	        text = (0, _react.cloneElement)(label, {
	          className: (0, _classnames2.default)('md-icon-text', labelClassName, labelProps.className),
	          style: _extends({}, labelStyle, labelProps.style)
	        });
	      } else {
	        text = _react2.default.createElement(
	          'span',
	          { style: labelStyle, className: (0, _classnames2.default)('md-icon-text', labelClassName) },
	          label
	        );
	      }
	
	      var Component = component;
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, { className: (0, _classnames2.default)('md-icon-separator', className) }),
	        iconBefore && children,
	        text,
	        !iconBefore && children
	      );
	    }
	  }]);
	
	  return IconSeparator;
	}(_react.PureComponent);
	
	IconSeparator.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the label.
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the label.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * The label to display.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * The icon to display.
	   */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the icon should appear before or after the text
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * The component to be rendered as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	IconSeparator.defaultProps = {
	  component: 'div'
	};
	exports.default = IconSeparator;
	//# sourceMappingURL=IconSeparator.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isReact16 = typeof _reactDom.createPortal === 'function';
	
	/**
	 * Creates a "Portal" for the children to be rendered in. Basically it will render the
	 * children only when the `visible` prop is `true`. When it is visible, a new `component`
	 * will be rendered as the first child in the body with the children inside.
	 *
	 * Unlike all the other components, `style` will not be applied for the `Portal`.
	 */
	
	var Portal = function (_PureComponent) {
	  _inherits(Portal, _PureComponent);
	
	  function Portal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this._container = null, _this._portal = null, _this._applyStyles = function (props) {
	      if (props.className) {
	        _this._container.className = props.className;
	      }
	    }, _this._renderPortal = function (props) {
	      if (!_this._container) {
	        _this._container = document.createElement(props.component);
	
	        _this._applyStyles(props);
	        var node = props.renderNode || document.body;
	        if (props.lastChild) {
	          node.appendChild(_this._container);
	        } else {
	          node.insertBefore(_this._container, node.firstChild);
	        }
	      } else {
	        _this._applyStyles(props);
	      }
	
	      if (!isReact16) {
	        _this._portal = (0, _reactDom.unstable_renderSubtreeIntoContainer)(_this, props.children, _this._container);
	      }
	    }, _this._removePortal = function () {
	      if (_this.props.onClose) {
	        _this.props.onClose();
	      }
	
	      if (_this._container) {
	        if (!isReact16) {
	          (0, _reactDom.unmountComponentAtNode)(_this._container);
	        }
	
	        (_this.props.renderNode || document.body).removeChild(_this._container);
	      }
	
	      _this._portal = null;
	      _this._container = null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.visible) {
	        this._renderPortal(this.props);
	
	        if (isReact16) {
	          // Need to update after the renderPortal created the DOM element.
	          this.forceUpdate();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var visible = nextProps.visible,
	          onOpen = nextProps.onOpen;
	
	      if (this.props.visible === visible) {
	        if (visible && !isReact16) {
	          // Need to just re-render the subtree
	          this._renderPortal(nextProps);
	        }
	
	        return;
	      }
	
	      if (visible) {
	        if (onOpen) {
	          onOpen();
	        }
	
	        this._renderPortal(nextProps);
	      } else {
	        this._removePortal();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._removePortal();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          className = _props.className,
	          children = _props.children,
	          visible = _props.visible;
	
	      // When doing server side rendering, actually render the component as a direct child of its parent.
	      // Once it has been rendered and working client side, it will be removed correctly.
	
	      if (typeof window === 'undefined' && visible) {
	        return _react2.default.createElement(
	          Component,
	          { className: className },
	          children
	        );
	      } else if (isReact16 && visible && this._container && typeof window !== 'undefined') {
	        return (0, _reactDom.createPortal)(children, this._container);
	      }
	
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.PureComponent);
	
	Portal.propTypes = {
	  /**
	   * An optional className to apply to the newly created `component` when visible.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the children are visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The children to render when visible.
	   */
	  children: _propTypes2.default.element,
	
	  /**
	   * The component to render as. This should be a valid DOM element.
	   */
	  component: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional function to call when the portal is opened.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the portal is closed
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * An optional DOM Node to render the portal into. The default is to render as
	   * the first child in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the portal should render the children as the last child of the `renderNode`
	   * or `body` instead of the first.
	   */
	  lastChild: _propTypes2.default.bool
	};
	Portal.defaultProps = {
	  component: 'span'
	};
	exports.default = Portal;
	//# sourceMappingURL=Portal.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _CSSTransitionGroupTick = __webpack_require__(30);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _handleKeyboardAccessibility = __webpack_require__(53);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _anchorShape = __webpack_require__(31);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(32);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Layover = __webpack_require__(70);
	
	var _Layover2 = _interopRequireDefault(_Layover);
	
	var _List = __webpack_require__(51);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Menu` controlled component is used to display a list of children in the `List`
	 * component once the `visible` prop is true.
	 */
	var Menu = function (_PureComponent) {
	  _inherits(Menu, _PureComponent);
	
	  function Menu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this._handleClose = function (e) {
	      var _this$props = _this.props,
	          close = _this$props.close,
	          onClose = _this$props.onClose;
	
	      if (close || onClose) {
	        (close || onClose)(e);
	      }
	    }, _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      var node = e.target;
	      while (_this._container && _this._container.contains(node)) {
	        if (_this._isIgnoreTarget(node)) {
	          return;
	        } else if (_this._isCloseTarget(node)) {
	          e.persist();
	          // set a timeout so item click events still trigger, and then close
	          _this._timeout = setTimeout(function () {
	            _this._timeout = null;
	            _this._handleClose(e);
	          }, _CSSTransitionGroupTick2.default);
	
	          return;
	        }
	
	        node = node.parentNode;
	      }
	    }, _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      (0, _handleKeyboardAccessibility2.default)(e, _this._handleClick, true, true);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Menu, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          cascading = _props.cascading,
	          id = _props.id,
	          fixedTo = _props.fixedTo,
	          cascadingAnchor = _props.cascadingAnchor;
	
	      var listLevel = this.context.listLevel || 0;
	      var cascadingMenu = typeof cascading !== 'undefined' ? cascading : this.context.cascadingMenu;
	      var cascadingZDepth = (0, _getField2.default)(this.context, this.props, 'cascadingZDepth');
	      var cascadingFixedTo = typeof fixedTo !== 'undefined' ? fixedTo : this.context.cascadingFixedTo;
	
	      return {
	        listLevel: listLevel,
	        cascadingId: id + '-level-' + (listLevel + 1),
	        cascadingMenu: cascadingMenu,
	        cascadingAnchor: cascadingAnchor,
	        cascadingZDepth: cascadingZDepth,
	        cascadingFixedTo: cascadingFixedTo
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._container = (0, _reactDom.findDOMNode)(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: '_isCloseTarget',
	
	
	    /**
	     * Checks if a provided event target or HTML Element is considered a menu click target.
	     * This normally is just a ListItem.
	     */
	    value: function _isCloseTarget(target) {
	      return target.classList.contains('md-list-item') && !target.classList.contains('md-list-item--nested-container');
	    }
	
	    /**
	     * Checks if a provided event target or HTML Element is something that should shortcut/break
	     * out of the click event loop because it **should not** close menus when clicked.
	     */
	
	  }, {
	    key: '_isIgnoreTarget',
	    value: function _isIgnoreTarget(target) {
	      return target.getAttribute('disabled') !== null || target.classList.contains('md-list-control');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          listStyle = _props2.listStyle,
	          listClassName = _props2.listClassName,
	          visible = _props2.visible,
	          children = _props2.children,
	          listProps = _props2.listProps,
	          listZDepth = _props2.listZDepth,
	          listInline = _props2.listInline,
	          listHeightRestricted = _props2.listHeightRestricted,
	          cascading = _props2.cascading,
	          sameWidth = _props2.sameWidth,
	          simplified = _props2.simplified,
	          contained = _props2.contained,
	          isOpen = _props2.isOpen,
	          propFixedTo = _props2.fixedTo,
	          propListId = _props2.listId,
	          cascadingAnchor = _props2.cascadingAnchor,
	          cascadingZDepth = _props2.cascadingZDepth,
	          onClose = _props2.onClose,
	          propPosition = _props2.position,
	          close = _props2.close,
	          autoclose = _props2.autoclose,
	          limitHeight = _props2.limitHeight,
	          expanderIconChildren = _props2.expanderIconChildren,
	          expanderIconClassName = _props2.expanderIconClassName,
	          props = _objectWithoutProperties(_props2, ['id', 'className', 'listStyle', 'listClassName', 'visible', 'children', 'listProps', 'listZDepth', 'listInline', 'listHeightRestricted', 'cascading', 'sameWidth', 'simplified', 'contained', 'isOpen', 'fixedTo', 'listId', 'cascadingAnchor', 'cascadingZDepth', 'onClose', 'position', 'close', 'autoclose', 'limitHeight', 'expanderIconChildren', 'expanderIconClassName']);
	
	      var _props3 = this.props,
	          listId = _props3.listId,
	          position = _props3.position;
	
	      if (!listId) {
	        listId = id + '-list';
	      }
	
	      // can't have a simplified menu for cascading and context menus
	      var simple = !cascading && !props.onContextMenu && position !== 'context' && simplified;
	      if (position === 'context') {
	        position = Menu.Positions.BELOW;
	      }
	
	      var below = position === Menu.Positions.BELOW;
	      var fixedTo = typeof propFixedTo !== 'undefined' ? propFixedTo : this.context.cascadingFixedTo;
	      var listVisible = typeof isOpen !== 'undefined' ? isOpen : visible;
	      return _react2.default.createElement(
	        _Layover2.default,
	        _extends({}, props, {
	          id: id,
	          className: (0, _classnames2.default)('md-menu-container', {
	            'md-menu-container--menu-below': simplified && below
	          }, className),
	          simplified: simple,
	          sameWidth: contained || sameWidth,
	          fixedTo: fixedTo,
	          onClick: this._handleClick,
	          onKeyDown: this._handleKeyDown,
	          onClose: this._handleClose,
	          animationPosition: position,
	          visible: listVisible,
	          'aria-haspopup': true,
	          'aria-expanded': listVisible,
	          'aria-owns': listId
	        }),
	        _react2.default.createElement(
	          _List2.default,
	          _extends({}, listProps, {
	            id: listId,
	            key: 'menu-list',
	            style: listStyle,
	            className: (0, _classnames2.default)('md-list--menu', (_cn = {
	              'md-list--menu-restricted': listHeightRestricted,
	              'md-list--menu-contained': simplified && (sameWidth || contained)
	            }, _defineProperty(_cn, 'md-list--menu-' + position, simplified), _defineProperty(_cn, 'md-paper md-paper--' + listZDepth, listZDepth), _cn), listClassName),
	            inline: listInline
	          }),
	          children
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.PureComponent);
	
	Menu.HorizontalAnchors = _Layover2.default.HorizontalAnchors;
	Menu.VerticalAnchors = _Layover2.default.VerticalAnchors;
	Menu.Positions = {
	  // Can't do ...Layover.Positions since it triggers the get for CONTEXT
	  TOP_LEFT: _Layover2.default.Positions.TOP_LEFT,
	  TOP_RIGHT: _Layover2.default.Positions.TOP_RIGHT,
	  BOTTOM_LEFT: _Layover2.default.Positions.BOTTOM_LEFT,
	  BOTTOM_RIGHT: _Layover2.default.Positions.BOTTOM_RIGHT,
	  BELOW: _Layover2.default.Positions.BELOW,
	  _warned: false,
	  get CONTEXT() {
	    if (!this._warned) {
	      /* eslint-disable no-console */
	      console.error('The `Menu.Positions.CONTEXT` position has been deprecated and will be removed ' + 'in the next major release. To make the `Menu` behave as a context menu, provide ' + 'the `onContextMenu` prop instead.');
	      /* eslint-enable no-console */
	    }
	
	    this._warned = true;
	    return 'context';
	  }
	};
	Menu.propTypes = {
	  /**
	   * An id to provide to the menu's container. This is required for accessibility as it generates
	   * the `aria-` attributes for dynamic content.
	   *
	   * @see {@link #listId}
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional id to provide to the menu's list. If this prop is omitted, the list's id will be
	   * `\`${id}-list\``
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the main container for the menu.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the main container for the menu.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the list once the menu has opened.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the list once the menu has opened.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the main container as.
	   *
	   * @see {@link Helpers/Layover#component}
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * This is how the menu's `List` gets anchored to the `toggle` element.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the optional anchor to use when the `position` is set to `Menu.Positions.BELOW`.
	   * Set this to `null` to use the default `anchor` prop.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position for the list that appears.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is the component/element that should toggle the menu open.
	   *
	   * @see {@link Helpers/Layover#toggle}
	   */
	  toggle: _propTypes2.default.node,
	
	  /**
	   * This is how the menu's list will be "fixed" to the `toggle` component.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Any additional props that should be applied to the list in the menu. This is really used
	   * when additional `aria-` tags need to be applied.
	   */
	  listProps: _propTypes2.default.object,
	
	  /**
	   * Boolean if the menu's list should appear horizontally instead of vertically.
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * The list's z-depth for applying box shadow. This should be a number from 0 to 5.
	   */
	  listZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the list should have its height restricted to the `$md-menu-mobile-max-height`/
	   * `$md-menu-desktop-max-height` values.
	   *
	   * @see [md-menu-mobile-max-height](/components/menus?tab=2#variable-md-menu-mobile-max-height)
	   * @see [md-menu-desktop-max-height](/components/menus?tab=2#variable-md-menu-desktop-max-height)
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list is visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Any children to render in the menu's list. This _should_ normally be `ListItem`, or
	   * `ListItemControl`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional function to call when en element in the menu has been clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when a key is pressed anywhere in the menu.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * A function to call to close the menu. This is used for closing on outside clicks,
	   * closing when a list item has been clicked, or the user presses escape.
	   */
	  onClose: _propTypes2.default.func.isRequired,
	
	  /**
	   * Boolean if the menu should be cascading. This means that the menu will pop the additional
	   * `nestedItems` on any `ListItem` to be appear either to the right or left of the visible list.
	   */
	  cascading: _propTypes2.default.bool,
	
	  /**
	   * This is how the cascading lists get anchored to the list item.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  cascadingAnchor: _Layover2.default.propTypes.anchor,
	
	  /**
	   * This is the z-depth the list should gain for a cascading menu. This only gets applied on
	   * items that are more than 1 level deep.
	   */
	  cascadingZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `md-full-width` class name should get applied to the menu's container.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should be displayed as a block instead of as an inline block.
	   *
	   * @see {@link #fullWidth}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _Layover2.default.propTypes.centered,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _Layover2.default.propTypes.sameWidth,
	
	  /**
	   * If you would like the menu to interact as a context menu, provide this prop.
	   *
	   * @see {@link Helpers/Layover#onContextMenu}
	   */
	  onContextMenu: _Layover2.default.propTypes.onContextMenu,
	
	  /**
	   * Boolean if the default behavior of the context menu should be prevented when using the
	   * `onContextMenu` prop.
	   *
	   * @see {@link Helpers/Layover#preventContextMenu}
	   */
	  preventContextMenu: _Layover2.default.propTypes.preventContextMenu,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#toggleQuery}
	   */
	  toggleQuery: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string]),
	
	  /**
	   * An optional transition name to use for the list appearing/disappearing.
	   *
	   * @see {@link Helpers/Layover#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplified: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  close: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onClose` instead'),
	  autoclose: (0, _deprecated2.default)(_propTypes2.default.bool, 'The menus will always autoclose as according to the specs'),
	  contained: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `sameWidth` instead'),
	  limitHeight: (0, _deprecated2.default)(_propTypes2.default.bool, 'The menus will always be limited in height as according to the specs'),
	  expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon'),
	  expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon')
	};
	Menu.defaultProps = {
	  anchor: {
	    x: _Layover2.default.HorizontalAnchors.INNER_RIGHT,
	    y: _Layover2.default.VerticalAnchors.OVERLAP
	  },
	  cascadingAnchor: {
	    x: _Layover2.default.HorizontalAnchors.RIGHT,
	    y: _Layover2.default.VerticalAnchors.OVERLAP
	  },
	  position: _Layover2.default.Positions.TOP_RIGHT,
	  fixedTo: typeof window !== 'undefined' ? window : {},
	  listZDepth: 2,
	  listHeightRestricted: true,
	  cascadingZDepth: 3,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  simplified: true
	};
	Menu.contextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	Menu.childContextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	exports.default = Menu;
	//# sourceMappingURL=Menu.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(9);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _oneRequiredForA11y = __webpack_require__(74);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _capitalizeFirst = __webpack_require__(371);
	
	var _capitalizeFirst2 = _interopRequireDefault(_capitalizeFirst);
	
	var _AccessibleFakeInkedButton = __webpack_require__(25);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _SwitchTrack = __webpack_require__(321);
	
	var _SwitchTrack2 = _interopRequireDefault(_SwitchTrack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Prevents a second warning from appearing when using the deprecated or a11y required
	 * props by using the `__superSecretProp`.... So secret!
	 */
	function preventDouble(validator) {
	  return function validate(props, propName) {
	    for (var _len = arguments.length, others = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      others[_key - 2] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName].concat(others));
	    if (err && props.__superSecreteProp) {
	      err = null;
	    }
	
	    return err;
	  };
	}
	
	/**
	 * The `SelectionControl` component is used to render any of the `Radio`, `Checkbox`, or `Switch`
	 * selection control type. This component might eventually replace all three since they use this
	 * anyways. I am not sure yet though.
	 */
	
	var SelectionControl = function (_PureComponent) {
	  _inherits(SelectionControl, _PureComponent);
	
	  function SelectionControl(props) {
	    _classCallCheck(this, SelectionControl);
	
	    var _this = _possibleConstructorReturn(this, (SelectionControl.__proto__ || Object.getPrototypeOf(SelectionControl)).call(this, props));
	
	    _this._setInput = function (input) {
	      _this._input = input;
	    };
	
	    _this._setControl = function (control) {
	      _this._control = control;
	    };
	
	    _this._setContainer = function (container) {
	      _this._container = container;
	    };
	
	    _this._getIcon = function () {
	      var _this$props = _this.props,
	          checkedIcon = _this$props.checkedIcon,
	          uncheckedIcon = _this$props.uncheckedIcon,
	          type = _this$props.type;
	
	      var checked = (0, _getField2.default)(_this.props, _this.state, 'checked');
	      if (checkedIcon || uncheckedIcon) {
	        return checked ? checkedIcon : uncheckedIcon;
	      }
	
	      var prefix = (checked ? '' : 'un') + 'checked' + (0, _capitalizeFirst2.default)(type) + 'Icon';
	      var iconClassName = _this.props[prefix + 'ClassName'];
	      var children = _this.props[prefix + 'Children'];
	
	      if (iconClassName || children) {
	        return _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName, inherit: true },
	          children
	        );
	      }
	
	      var icon = _this.props[prefix];
	      return icon ? _react2.default.cloneElement(icon, { inherit: true }) : null;
	    };
	
	    _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      var key = e.which || e.keyCode;
	      if (key === _keyCodes.SPACE) {
	        _this._input.click();
	      }
	    };
	
	    _this._handleChange = function (e) {
	      var _this$props2 = _this.props,
	          type = _this$props2.type,
	          onChange = _this$props2.onChange;
	
	      var checked = !(0, _getField2.default)(_this.props, _this.state, 'checked');
	      if (onChange) {
	        onChange(type === 'radio' ? e.target.value : checked, e);
	      }
	
	      if (typeof _this.props.checked === 'undefined') {
	        _this.setState({ checked: checked });
	      }
	    };
	
	    _this.state = {};
	    if (typeof props.checked === 'undefined') {
	      _this.state.checked = !!props.defaultChecked;
	    }
	    return _this;
	  }
	
	  /**
	   * Gets the current checked value from the selection control. This is used when you have
	   * an uncontrolled selection control and simply need the checked state from a ref callback.
	   *
	   * @return {boolean} the checked state for the selection control.\
	   */
	
	
	  _createClass(SelectionControl, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          style = _props.style,
	          className = _props.className,
	          inline = _props.inline,
	          type = _props.type,
	          name = _props.name,
	          value = _props.value,
	          disabled = _props.disabled,
	          labelBefore = _props.labelBefore,
	          tabIndex = _props.tabIndex,
	          inkDisabled = _props.inkDisabled,
	          disabledInteractions = _props.disabledInteractions,
	          ariaLabel = _props['aria-label'],
	          ariaLabelledBy = _props['aria-labelledby'],
	          propLabel = _props.label,
	          propChildren = _props.checked,
	          onChange = _props.onChange,
	          tooltip = _props.tooltip,
	          checkedCheckboxIcon = _props.checkedCheckboxIcon,
	          uncheckedCheckboxIcon = _props.uncheckedCheckboxIcon,
	          checkedRadioIcon = _props.checkedRadioIcon,
	          uncheckedRadioIcon = _props.uncheckedRadioIcon,
	          __superSecreteProp = _props.__superSecreteProp,
	          checkedIcon = _props.checkedIcon,
	          uncheckedIcon = _props.uncheckedIcon,
	          checkedRadioIconChildren = _props.checkedRadioIconChildren,
	          checkedRadioIconClassName = _props.checkedRadioIconClassName,
	          uncheckedRadioIconChildren = _props.uncheckedRadioIconChildren,
	          uncheckedRadioIconClassName = _props.uncheckedRadioIconClassName,
	          checkedCheckboxIconChildren = _props.checkedCheckboxIconChildren,
	          checkedCheckboxIconClassName = _props.checkedCheckboxIconClassName,
	          uncheckedCheckboxIconChildren = _props.uncheckedCheckboxIconChildren,
	          uncheckedCheckboxIconClassName = _props.uncheckedCheckboxIconClassName,
	          props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'inline', 'type', 'name', 'value', 'disabled', 'labelBefore', 'tabIndex', 'inkDisabled', 'disabledInteractions', 'aria-label', 'aria-labelledby', 'label', 'checked', 'onChange', 'tooltip', 'checkedCheckboxIcon', 'uncheckedCheckboxIcon', 'checkedRadioIcon', 'uncheckedRadioIcon', '__superSecreteProp', 'checkedIcon', 'uncheckedIcon', 'checkedRadioIconChildren', 'checkedRadioIconClassName', 'uncheckedRadioIconChildren', 'uncheckedRadioIconClassName', 'checkedCheckboxIconChildren', 'checkedCheckboxIconClassName', 'uncheckedCheckboxIconChildren', 'uncheckedCheckboxIconClassName']);
	
	      var checked = (0, _getField2.default)(this.props, this.state, 'checked');
	      var isSwitch = type === 'switch';
	      var label = this.props.label && _react2.default.createElement(
	        'span',
	        null,
	        this.props.label
	      );
	
	      var control = void 0;
	      if (isSwitch) {
	        control = _react2.default.createElement(_SwitchTrack2.default, { disabled: disabled, checked: checked });
	      } else {
	        control = _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          {
	            inkDisabled: inkDisabled,
	            disabledInteractions: disabledInteractions,
	            role: type,
	            className: (0, _classnames2.default)('md-selection-control-toggle md-btn md-btn--icon', (0, _themeColors2.default)({
	              disabled: disabled,
	              hint: !checked,
	              secondary: checked
	            })),
	            'aria-checked': checked,
	            tabIndex: tabIndex,
	            disabled: disabled
	          },
	          tooltip,
	          this._getIcon()
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          style: style,
	          className: (0, _classnames2.default)('md-selection-control-container', {
	            'md-selection-control-container--inline': inline,
	            'md-switch-container': isSwitch
	          }, className),
	          onKeyDown: this._handleKeyDown
	        }),
	        _react2.default.createElement('input', {
	          ref: this._setInput,
	          id: id,
	          type: isSwitch ? 'checkbox' : type,
	          checked: checked,
	          onChange: this._handleChange,
	          disabled: disabled,
	          className: 'md-selection-control-input',
	          name: name,
	          value: value,
	          'aria-hidden': true,
	          'aria-label': ariaLabel,
	          'aria-labelledby': ariaLabelledBy
	        }),
	        _react2.default.createElement(
	          'label',
	          {
	            htmlFor: id,
	            className: (0, _classnames2.default)('md-selection-control-label', {
	              'md-pointer--hover': !disabled
	            }, (0, _themeColors2.default)({ disabled: disabled, text: !disabled }))
	          },
	          labelBefore && label,
	          control,
	          !labelBefore && label
	        )
	      );
	    }
	  }, {
	    key: 'checked',
	    get: function get() {
	      return (0, _getField2.default)(this.props, this.state, 'checked');
	    }
	  }]);
	
	  return SelectionControl;
	}(_react.PureComponent);
	
	SelectionControl.propTypes = {
	  /**
	   * An id to use with the selection control. This is used for accessibility and so that the label
	   * triggers the selection control toggle.
	   */
	  id: preventDouble((0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))),
	
	  /**
	   * An optional label to apply to the checkbox when there is no visible label.
	   */
	  'aria-label': (0, _oneRequiredForA11y2.default)(_propTypes2.default.string, 'label', 'aria-labelledby'),
	
	  /**
	   * An optional id that points to a label for the selection control when there is no visible label.
	   */
	  'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the selection control's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the selection control's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The type of selection control to render.
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio', 'switch']).isRequired,
	
	  /**
	   * A label to display with the selection control. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the label should appear before the checkbox/radio icon or switch.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `SelectionControl`. This is required for accessibility. If the `type`
	   * is a `checkbox` and it is part of a group, it is recommended to make this a string ending
	   * in `[]` so that the value can be found from `document.querySelector('input[name="someName[]"]').value`.
	   */
	  name: preventDouble((0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))),
	
	  /**
	   * Boolean if the `Radio` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * A function to call when the `SelectionControl` triggers the `change` event. The `onChange`
	   * callback will either include:
	   * - the currently changed radio's value
	   * - the next checked state for the `Switch` or `Checkbox`.
	   *
	   * as the first parameter followed by the change event.
	   *
	   * ```js
	   * // Radio
	   * onChange(changeEvent.target.value, changeEvent);
	   *
	   * // Checkbox or Switch
	   * onChange(changeEvent.target.checked, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event is triggered.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * The value for the `SelectionControl`. It is not required for `Checkbox` and `Switch`,
	   * but it is recommended.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * A boolean if the `SelectionControl` is currently checked. This _really_ makes the `onChange`
	   * prop required, but since there are cases you might want to have the `onChange` listener on a
	   * `fieldset` or something above the component, it is never set to `required`. It will however
	   * prevent updates if there is no change listener.
	   */
	  checked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Checkbox` or `Switch` are checked by default. This prop is invalid for a
	   * `Radio`.
	   */
	  defaultChecked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `SelectionControl` should be displayed inline instead of a block.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The icon to use for a checked `checkbox` selection control.
	   */
	  checkedCheckboxIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for an unchecked `checkbox` selection control.
	   */
	  uncheckedCheckboxIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for a checked `radio` selection control.
	   */
	  checkedRadioIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for an unchecked `radio` selection control.
	   */
	  uncheckedRadioIcon: _propTypes2.default.element,
	
	  /**
	   * An optional tooltip to render with the control. This is only used if you inject the
	   * tooltip manually yourself.
	   *
	   * `const TooltippedSelectionControl = injectTooltip(SelectionControl);`
	   */
	  tooltip: _propTypes2.default.node,
	
	  /**
	   * Boolean if the ink should be disabled for radios or checkboxes.
	   *
	   * @see {@link Inks#inkDisabled}
	   */
	  inkDisabled: _propTypes2.default.bool,
	
	  /**
	   * An optional list of ink interactions that should be disabled.
	   *
	   * @see {@link Inks#disabledInteractions}
	   */
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'touch', 'mouse'])),
	
	  /**
	   * An optional tab index to apply to the selection control.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  checkedIcon: preventDouble((0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedCheckboxIconChildren` and `checkedCheckboxIconClassName`  or the ' + '`checkedRadioIconChildren` and `checkedRadioIconClassName` props instead')),
	  uncheckedIcon: preventDouble((0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedCheckboxIconChildren` and `uncheckedCheckboxIconClassName`  or the ' + '`uncheckedRadioIconChildren` and `uncheckedRadioIconClassName` props instead')),
	  checkedCheckboxIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedCheckboxIcon` prop instead'),
	  checkedCheckboxIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `checkedCheckboxIcon` prop instead'),
	  uncheckedCheckboxIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedCheckboxIcon` prop instead'),
	  uncheckedCheckboxIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `uncheckedCheckboxIcon` prop instead'),
	  checkedRadioIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedRadioIcon` prop instead'),
	  checkedRadioIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `checkedRadioIcon` prop instead'),
	  uncheckedRadioIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedRadioIcon` prop instead'),
	  uncheckedRadioIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `uncheckedRadioIcon` prop instead'),
	
	  /* maybe removed once upgrade again? */
	  __superSecreteProp: _propTypes2.default.bool
	};
	SelectionControl.defaultProps = {
	  checkedCheckboxIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box'
	  ),
	  uncheckedCheckboxIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box_outline_blank'
	  ),
	  checkedRadioIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_checked'
	  ),
	  uncheckedRadioIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_unchecked'
	  )
	};
	exports.default = SelectionControl;
	//# sourceMappingURL=SelectionControl.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _isValued = __webpack_require__(76);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _getTextWidth = __webpack_require__(99);
	
	var _getTextWidth2 = _interopRequireDefault(_getTextWidth);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _invalidIf = __webpack_require__(37);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _minNumber = __webpack_require__(368);
	
	var _minNumber2 = _interopRequireDefault(_minNumber);
	
	var _addSuffix = __webpack_require__(174);
	
	var _addSuffix2 = _interopRequireDefault(_addSuffix);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FloatingLabel = __webpack_require__(159);
	
	var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);
	
	var _TextFieldMessage = __webpack_require__(161);
	
	var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);
	
	var _PasswordButton = __webpack_require__(343);
	
	var _PasswordButton2 = _interopRequireDefault(_PasswordButton);
	
	var _InputField = __webpack_require__(341);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _TextFieldDivider = __webpack_require__(160);
	
	var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_TEXT_FIELD_SIZE = 180;
	
	var WILL_RECEIVE_KEYS = ['style', 'value', 'resize'];
	var DID_UPDATE_KEYS = ['leftIcon', 'rightIcon', 'passwordIcon', 'inlineIndicator'];
	
	/**
	 * The `TextField` component can either be a single line `input` field or a multiline
	 * `textarea` field. `FontIcon`s, messages, and password indicators can also be added
	 * to this field.
	 *
	 * The optional mouse and touch events will be added to the entire container while the
	 * text specific events will be added to the `input` or `textarea` tags.
	 */
	
	var TextField = function (_PureComponent) {
	  _inherits(TextField, _PureComponent);
	
	  function TextField(props) {
	    _classCallCheck(this, TextField);
	
	    var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var currentLength = _this._getLength(typeof props.value !== 'undefined' ? props.value : props.defaultValue);
	
	    _this._canvas = null;
	    var width = null;
	    if (typeof props.resize !== 'undefined') {
	      width = typeof props.resize.min === 'number' ? props.resize.min : DEFAULT_TEXT_FIELD_SIZE;
	    }
	
	    _this.state = {
	      active: false,
	      error: props.maxLength ? props.maxLength < currentLength : false,
	      floating: (0, _isValued2.default)(props.defaultValue) || (0, _isValued2.default)(props.value),
	      passwordVisible: props.passwordInitiallyVisible,
	      currentLength: currentLength,
	      styles: width ? _extends({ width: width }, props.style) : props.style
	    };
	    return _this;
	  }
	
	  _createClass(TextField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          value = _props.value,
	          defaultValue = _props.defaultValue,
	          resize = _props.resize;
	
	      var v = typeof value !== 'undefined' ? value : defaultValue;
	      if (resize) {
	        // always want to set width on mount
	        this.setState({ width: this._calcWidth(v) }); // eslint-disable-line react/no-did-mount-set-state
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var value = nextProps.value,
	          resize = nextProps.resize,
	          style = nextProps.style;
	
	      var nextState = {};
	      if (value !== this.props.value) {
	        nextState.error = this._isErrored(nextProps);
	        nextState.floating = (0, _isValued2.default)(value);
	        nextState.currentLength = this._getLength(value);
	      }
	
	      if (WILL_RECEIVE_KEYS.some(function (key) {
	        return _this2.props[key] !== nextProps[key];
	      })) {
	        if (!resize) {
	          nextState.styles = style;
	        } else {
	          var width = this._calcWidth(value, nextProps);
	          nextState.styles = _extends({ width: width }, style);
	        }
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          resize = _props2.resize,
	          value = _props2.value,
	          style = _props2.style;
	
	      if (resize && DID_UPDATE_KEYS.some(function (key) {
	        return _this3.props[key] !== prevProps[key];
	      })) {
	        var width = this._calcWidth(value, this.props);
	        this.setState({ styles: _extends({ width: width }, style) }); // eslint-disable-line react/no-did-update-set-state
	      }
	    }
	
	    /**
	     * A helper function for getting the specific `input` field or the `textarea` in the `TextField`.
	     * This is accessible if you use `refs`.
	     *
	     * Example:
	     *
	     * ```js
	     * <TextField ref={field => this._field = field;} label="Hello" />;
	     *
	     * this._field.getField(); // `input` node
	     * ```
	     */
	
	
	    /**
	     * A helper function for focusing the `input` field or the `textarea` in the `TextField`.
	     * This is accessibile if you use `refs`.
	     * Example:
	     *
	     * ```js
	     * <TextField ref={field => this._field = field;} label="Hello" />;
	     *
	     * this._field.focus();
	     * ```
	     */
	
	  }, {
	    key: 'blur',
	
	
	    /**
	     * A helper function for blurring the `input` field or the `textarea` in the `TextField`.
	     * This is accessible if you use `refs`.
	     * Example:
	     *
	     * ```js
	     * <TextField ref={field => this._field = field;} label="Hello" />;
	     *
	     * this._field.blur();
	     * ```
	     */
	    value: function blur() {
	      this._field.blur();
	    }
	  }, {
	    key: '_cloneIcon',
	    value: function _cloneIcon(icon, active, error, disabled, stateful, block, dir) {
	      if (!icon) {
	        return icon;
	      }
	
	      try {
	        var iconEl = _react.Children.only(icon);
	        return (0, _react.cloneElement)(iconEl, {
	          key: iconEl.key || 'icon-' + dir,
	          disabled: stateful ? disabled : undefined,
	          primary: stateful ? !error && active : undefined,
	          error: stateful ? error : undefined,
	          className: (0, _classnames2.default)('md-text-field-icon', {
	            'md-text-field-icon--positioned': !block
	          }, iconEl.props.className)
	        });
	      } catch (e) {
	        return icon;
	      }
	    }
	
	    /**
	     * A small utility function for calculating an inline-icon's width keeping the SVG Icons
	     * in mind and any margin that gets applied for spacing.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          currentLength = _state.currentLength,
	          passwordVisible = _state.passwordVisible,
	          styles = _state.styles;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          type = _props3.type,
	          className = _props3.className,
	          inputStyle = _props3.inputStyle,
	          inputClassName = _props3.inputClassName,
	          block = _props3.block,
	          fullWidth = _props3.fullWidth,
	          required = _props3.required,
	          customSize = _props3.customSize,
	          maxLength = _props3.maxLength,
	          errorText = _props3.errorText,
	          helpText = _props3.helpText,
	          helpOnFocus = _props3.helpOnFocus,
	          disabled = _props3.disabled,
	          leftIconStateful = _props3.leftIconStateful,
	          rightIconStateful = _props3.rightIconStateful,
	          passwordIcon = _props3.passwordIcon,
	          lineDirection = _props3.lineDirection,
	          paddedBlock = _props3.paddedBlock,
	          onDoubleClick = _props3.onDoubleClick,
	          onTouchStart = _props3.onTouchStart,
	          onTouchMove = _props3.onTouchMove,
	          onTouchCancel = _props3.onTouchCancel,
	          onTouchEnd = _props3.onTouchEnd,
	          onMouseDown = _props3.onMouseDown,
	          onMouseUp = _props3.onMouseUp,
	          onMouseOver = _props3.onMouseOver,
	          onMouseLeave = _props3.onMouseLeave,
	          ink = _props3.ink,
	          inlineIndicator = _props3.inlineIndicator,
	          toolbar = _props3.toolbar,
	          icon = _props3.icon,
	          passwordIconChildren = _props3.passwordIconChildren,
	          passwordIconClassName = _props3.passwordIconClassName,
	          style = _props3.style,
	          propLabel = _props3.label,
	          propPlaceholder = _props3.placeholder,
	          propError = _props3.error,
	          propActive = _props3.active,
	          propFloating = _props3.floating,
	          propLeftIcon = _props3.leftIcon,
	          propRightIcon = _props3.rightIcon,
	          onClick = _props3.onClick,
	          onChange = _props3.onChange,
	          onBlur = _props3.onBlur,
	          onFocus = _props3.onFocus,
	          resize = _props3.resize,
	          adjustMinWidth = _props3.adjustMinWidth,
	          propFloatingLabel = _props3.floatingLabel,
	          props = _objectWithoutProperties(_props3, ['id', 'type', 'className', 'inputStyle', 'inputClassName', 'block', 'fullWidth', 'required', 'customSize', 'maxLength', 'errorText', 'helpText', 'helpOnFocus', 'disabled', 'leftIconStateful', 'rightIconStateful', 'passwordIcon', 'lineDirection', 'paddedBlock', 'onDoubleClick', 'onTouchStart', 'onTouchMove', 'onTouchCancel', 'onTouchEnd', 'onMouseDown', 'onMouseUp', 'onMouseOver', 'onMouseLeave', 'ink', 'inlineIndicator', 'toolbar', 'icon', 'passwordIconChildren', 'passwordIconClassName', 'style', 'label', 'placeholder', 'error', 'active', 'floating', 'leftIcon', 'rightIcon', 'onClick', 'onChange', 'onBlur', 'onFocus', 'resize', 'adjustMinWidth', 'floatingLabel']);
	
	      var _props4 = this.props,
	          label = _props4.label,
	          placeholder = _props4.placeholder,
	          error = _props4.error,
	          active = _props4.active,
	          floating = _props4.floating,
	          leftIcon = _props4.leftIcon,
	          rightIcon = _props4.rightIcon;
	
	      active = active || this.state.active;
	      error = error || this.state.error;
	      floating = floating || this.state.floating;
	
	      if (required) {
	        if (label) {
	          label = (0, _addSuffix2.default)(label, '*');
	        }
	
	        if (placeholder && !label) {
	          placeholder = (0, _addSuffix2.default)(placeholder, '*');
	        }
	      }
	
	      if (label && !floating) {
	        placeholder = null;
	      }
	
	      leftIcon = this._cloneIcon(icon || leftIcon, active, error, disabled, leftIconStateful, block, 'left');
	      if (type === 'password' && !disabled) {
	        rightIcon = _react2.default.createElement(_PasswordButton2.default, {
	          key: 'password-btn',
	          onClick: this._togglePasswordField,
	          active: active,
	          passwordVisible: passwordVisible,
	          icon: (0, _getDeprecatedIcon2.default)(passwordIconClassName, passwordIconChildren, passwordIcon),
	          block: block,
	          floating: !!label
	        });
	      } else if (inlineIndicator) {
	        var el = _react.Children.only(inlineIndicator);
	        rightIcon = (0, _react.cloneElement)(inlineIndicator, {
	          key: 'icon-right',
	          className: (0, _classnames2.default)('md-text-field-inline-indicator', {
	            'md-text-field-inline-indicator--floating': label,
	            'md-text-field-inline-indicator--block': block
	          }, el.props.className)
	        });
	      } else {
	        rightIcon = this._cloneIcon(rightIcon, active, error, disabled, rightIconStateful, block, 'right');
	      }
	      var rightIconed = !!rightIcon && type !== 'password' && !inlineIndicator;
	
	      var floatingLabel = _react2.default.createElement(_FloatingLabel2.default, {
	        key: 'label',
	        label: label,
	        htmlFor: id,
	        active: active,
	        error: error,
	        floating: floating,
	        customSize: customSize,
	        disabled: disabled,
	        iconOffset: !!leftIcon
	      });
	
	      var message = _react2.default.createElement(_TextFieldMessage2.default, {
	        key: 'message',
	        active: active,
	        error: error,
	        errorText: errorText,
	        helpText: helpText,
	        helpOnFocus: helpOnFocus,
	        block: block,
	        maxLength: maxLength,
	        leftIcon: !!leftIcon,
	        rightIcon: !!rightIcon,
	        currentLength: currentLength
	      });
	
	      var field = _react2.default.createElement(_InputField2.default, _extends({}, props, {
	        key: 'field',
	        ref: this._setField,
	        id: id,
	        type: type,
	        label: label,
	        style: inputStyle,
	        className: (0, _classnames2.default)({ 'md-text-field--toolbar': toolbar }, inputClassName),
	        disabled: disabled,
	        customSize: customSize,
	        fullWidth: fullWidth,
	        passwordVisible: passwordVisible,
	        placeholder: placeholder,
	        block: block,
	        onFocus: this._handleFocus,
	        onBlur: this._handleBlur,
	        onChange: this._handleChange,
	        inlineIndicator: !!inlineIndicator
	      }));
	
	      var divider = void 0;
	      if (!block) {
	        divider = _react2.default.createElement(_TextFieldDivider2.default, {
	          key: 'text-divider',
	          active: active,
	          error: error,
	          lineDirection: lineDirection
	        });
	      }
	
	      var children = void 0;
	      if (leftIcon || rightIconed) {
	        children = _react2.default.createElement(
	          'div',
	          { key: 'icon-divider', className: 'md-text-field-icon-container' },
	          leftIcon,
	          _react2.default.createElement(
	            'div',
	            {
	              key: 'divider-container',
	              className: (0, _classnames2.default)('md-text-field-divider-container', {
	                'md-text-field-divider-container--grow': fullWidth
	              })
	            },
	            field,
	            divider
	          ),
	          rightIcon
	        );
	      } else {
	        children = [leftIcon, field, divider, rightIcon];
	      }
	
	      children = [floatingLabel, children, message];
	
	      var multiline = typeof props.rows !== 'undefined';
	      return _react2.default.createElement(
	        'div',
	        {
	          style: styles,
	          className: (0, _classnames2.default)('md-text-field-container', {
	            'md-inline-block': !fullWidth && !block,
	            'md-full-width': block || fullWidth,
	            'md-text-field-container--disabled': disabled,
	            'md-text-field-container--input': !multiline,
	            'md-text-field-container--input-block': block && !multiline,
	            'md-text-field-container--multiline': multiline,
	            'md-text-field-container--multiline-block': multiline && block,
	            'md-text-field-container--padded-block': block && paddedBlock
	          }, className),
	          onClick: this._handleContainerClick,
	          onDoubleClick: onDoubleClick,
	          onMouseOver: onMouseOver,
	          onMouseLeave: onMouseLeave,
	          onMouseDown: onMouseDown,
	          onMouseUp: onMouseUp,
	          onTouchStart: onTouchStart,
	          onTouchEnd: onTouchEnd,
	          onTouchCancel: onTouchCancel,
	          onTouchMove: onTouchMove,
	          ref: this._setContainer
	        },
	        ink,
	        children
	      );
	    }
	  }, {
	    key: 'value',
	
	
	    /**
	     * Gets the current value from the text field. This is used when you have an uncontrolled
	     * text field and simply need the value from a ref callback.
	     *
	     * @return {String} the text field's value
	     */
	    get: function get() {
	      return this.getField().value;
	    }
	  }]);
	
	  return TextField;
	}(_react.PureComponent);
	
	TextField.propTypes = {
	  /**
	   * The id for a text field. This is required when using the `label` prop for accessibility,
	   * but normally a good idea to include one anyways.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply to the text field's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the text field's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `input` or `textarea` tag.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `input` or `textarea` tag.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * An optional value to apply to the text field. This will make the component
	   * controlled and require the `onChange` prop.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), 'onChange'),
	
	  /**
	   * An optional default value for the text field.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  /**
	   * Boolean if the text field should be displayed as a `block`. This is equivalent to
	   * the `full width` text field in the Material Design specs. This view will disable
	   * floating labels and remove the text divider from the component.
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `block` text field should include padding to the left and right of
	   * the text field.
	   */
	  paddedBlock: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field is currently disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional label to display with the text field. This will convert the text field
	   * into a floating label text field. You can make it single line by only using the
	   * `placeholder` prop.
	   */
	  label: (0, _invalidIf2.default)(_propTypes2.default.node, 'block'),
	
	  /**
	   * An optional placeholder text to display in the text field. If there is no `label` prop,
	   * the text field will be displayed as a single line text field. If there is a `label` prop,
	   * this will only be visible when there is no value and the user focused the text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * The type for the text field. This is one of the most import props for mobile accessibility
	   * as it will update the keyboard for the text type. This does not get applied on multiline
	   * text fields.
	   */
	  type: _propTypes2.default.oneOf(['text', 'number', 'email', 'search', 'tel', 'url', 'password']).isRequired,
	
	  /**
	   * An optional function to call when the text field's container triggers the `click` event.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `doubleclick`
	   * event.
	   */
	  onDoubleClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchstart`
	   * event.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchmove`
	   * event.
	   */
	  onTouchMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchcancel`
	   * event.
	   */
	  onTouchCancel: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchend`
	   * event.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mousedown`
	   * event.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mouseup`
	   * event.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mouseover`
	   * event.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mouseleave`
	   * event.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional onChange function to call. If the `value` prop is defined, this is
	   * required.
	   *
	   * When the value changes in the text field, this will be called with the new text
	   * field's value and the change event.
	   *
	   * ```js
	   * onChange(e.target.value, e);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field is blurred.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field is focused.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional boolean if the `active` state of the text field can be externally
	   * modified as well. The text field is usually considered active when it gains focus.
	   *
	   * If this prop is set, it will check both the active prop and the active state to
	   * determine if one is true.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * An optional boolean if the `error` state of the text field can be externally
	   * modified as well. The text field is usually considered errored when it is required
	   * and there is no value or the current length of the text field's value is greater
	   * than the `maxLength` prop.
	   *
	   * If this prop is set, it will check both the error prop and the error state to
	   * determine if one is true.
	   */
	  error: _propTypes2.default.bool,
	
	  /**
	   * An optional boolean if the `floating` state of the text field's floating label can be
	   * externally modified as well. The floating state is true when the text field gains focus
	   * or there is a value in the text field.
	   *
	   * If this prop is set, it will check both the floating prop and the floating state to
	   * determine if one is true.
	   */
	  floating: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field is required. If the user blurs the text field while there is
	   * no value and it is required, the `error` state will be set to true.
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * The direction that the underline should appear from.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']).isRequired,
	
	  /**
	   * An optional icon to place to the left of the text field.
	   */
	  leftIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the left icon should be stateful. This means that the icon will
	   * gain the active or error colors with the text field.
	   */
	  leftIconStateful: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to place to the right of the text field.
	   */
	  rightIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the right icon should be stateful. This means that the icon will
	   * gain the active or error colors with the text field.
	   */
	  rightIconStateful: _propTypes2.default.bool,
	
	  /**
	   * The icon to use for a password text field.
	   */
	  passwordIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the password is initially visible.
	   */
	  passwordInitiallyVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field should be displayed as full width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The number of rows for the `multiline` text field. This value must be greater than
	   * or equal to 1. When this value is set, the text field will be converted to a multiline
	   * field.
	   */
	  rows: (0, _minNumber2.default)(1, false),
	
	  /**
	   * The maximum number of rows for a `multiline` text field. If this value is
	   * `undefined`, `0`, or a number less than `0`, the multiline text field will
	   * infinitely expand.
	   */
	  maxRows: _propTypes2.default.number,
	
	  /**
	   * An optional custom size to apply to the text field. This is used along with
	   * the `$md-text-field-custom-sizes` variable. It basically applies a className of
	   * `md-text-field--NAME`.
	   */
	  customSize: _propTypes2.default.string,
	
	  /**
	   * An optional error text to display below the text field. This will only appear when
	   * the text field has the `error` state through the `error` prop, the current length
	   * of the text field's value is greater than the `maxLength` prop, or the field is
	   * required and the user blurs the text field with no value.
	   */
	  errorText: _propTypes2.default.node,
	
	  /**
	   * An optional help text to display below the text field. This will always be visible
	   * unless the `helpOnFocus` prop is set to true. Otherwise it will appear on focus.
	   */
	  helpText: _propTypes2.default.node,
	
	  /**
	   * Boolean if the help text should display on focus only.
	   */
	  helpOnFocus: _propTypes2.default.bool,
	
	  /**
	   * An optional max length for the text field. This will insert a counter underneath the
	   * text field that appears on focus.
	   */
	  maxLength: _propTypes2.default.number,
	
	  /**
	   * The ink when there is an injectInk above the text field. Used from the SelectField.
	   *
	   * @access private
	   */
	  ink: _propTypes2.default.node,
	
	  /**
	   * An optional element to display inside of the `TextField` to the farthest right. This will
	   * position the indicator absolutely and add some additional padding to the `TextField`.
	   */
	  inlineIndicator: _propTypes2.default.element,
	
	  /**
	   * This prop allows the text field to resize its width to stay between the min and max sizes provided. By
	   * default, the field will expand and collapse based on the amount of text provided. The collapsing can
	   * be disabled by providing `disableShrink` to the configuration object.
	   *
	   * If the `min` prop is not provided, it will default to `180` which is about the same size as a default
	   * text field.
	   */
	  resize: _propTypes2.default.shape({
	    min: _propTypes2.default.number,
	    max: _propTypes2.default.number.isRequired,
	    disableShrink: _propTypes2.default.bool
	  }),
	
	  /**
	   * Boolean if the TextField is in a toolbar and acting as a title. This will apply additional styles to the
	   * text field to make it look like the toolbar's title.
	   */
	  toolbar: _propTypes2.default.bool,
	
	  passwordIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `passwordIcon` prop instead'),
	  passwordIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `passwordIcon` prop instead'),
	  icon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `leftIcon` or `rightIcon` prop instead'),
	  floatingLabel: (0, _deprecated2.default)(_propTypes2.default.bool, 'The `label` prop is now always floating. To create a non-floating text field, only use the `placeholder` prop'),
	  adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'Manually add a min width style instead')
	};
	TextField.defaultProps = {
	  type: 'text',
	  lineDirection: 'left',
	  passwordIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'remove_red_eye'
	  ),
	  leftIconStateful: true,
	  rightIconStateful: true,
	  fullWidth: true
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.getField = function () {
	    return _this4._field.getField();
	  };
	
	  this.focus = function () {
	    _this4._field.focus();
	  };
	
	  this._getLength = function (v) {
	    if ((0, _isValued2.default)(v)) {
	      return String(v).length;
	    }
	
	    return 0;
	  };
	
	  this._setContainer = function (div) {
	    _this4._container = div;
	  };
	
	  this._setField = function (field) {
	    if (field !== null) {
	      _this4._field = field;
	    }
	  };
	
	  this._calcIconWidth = function (icon) {
	    var style = window.getComputedStyle(icon);
	
	    return icon.getBoundingClientRect().width + parseInt(style.marginLeft, 10);
	  };
	
	  this._calcWidth = function (value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this4.props;
	
	    var text = value;
	    // if it is a password, use the bullet unicode instead
	    if (props.type === 'password') {
	      text = [].concat(_toConsumableArray(new Array(value.length))).reduce(function (s) {
	        return s + '\u2022';
	      }, '');
	    }
	
	    var field = _this4._field && _this4._field.getField();
	    if (!(0, _isValued2.default)(text) && field) {
	      text = field.value;
	    }
	
	    var width = (0, _getTextWidth2.default)(text, field);
	    if (width === null || !field) {
	      // some error happened, don't do other logic
	      return width;
	    }
	
	    var max = props.resize.max;
	
	    var min = (0, _getField2.default)(props.resize, { min: DEFAULT_TEXT_FIELD_SIZE }, 'min');
	
	    if (_this4._container) {
	      var indicator = _this4._container.querySelector('.md-text-field-inline-indicator');
	      if (indicator) {
	        width += indicator.getBoundingClientRect().width;
	      }
	
	      var iconContainer = _this4._container.querySelector('.md-text-field-icon-container');
	      if (iconContainer) {
	        // There is conditionally an icon before and after the text field, or only an icon before/after
	        var _iconContainer$childr = _slicedToArray(iconContainer.children, 3),
	            first = _iconContainer$childr[0],
	            second = _iconContainer$childr[1],
	            third = _iconContainer$childr[2];
	
	        if (first.classList.contains('md-icon')) {
	          width += first.getBoundingClientRect().width;
	          width += parseInt(window.getComputedStyle(second).marginLeft, 10);
	
	          if (third) {
	            width += _this4._calcIconWidth(third);
	          }
	        } else if (second) {
	          width += _this4._calcIconWidth(second);
	        }
	      }
	    }
	
	    return Math.ceil(Math.min(max, Math.max(min, width)));
	  };
	
	  this._isErrored = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.props,
	        value = _ref.value,
	        maxLength = _ref.maxLength,
	        required = _ref.required;
	
	    var error = _this4.state.error;
	
	    var currentLength = _this4._getLength(value);
	    if (required && error) {
	      error = !(0, _isValued2.default)(value);
	    }
	
	    if (maxLength) {
	      error = error || currentLength > maxLength;
	    }
	
	    return error;
	  };
	
	  this._handleContainerClick = function (e) {
	    if (_this4.props.onClick) {
	      _this4.props.onClick(e);
	    }
	
	    if (!_this4.props.disabled) {
	      _this4.focus();
	    }
	  };
	
	  this._handleBlur = function (e) {
	    var _props5 = _this4.props,
	        required = _props5.required,
	        maxLength = _props5.maxLength,
	        onBlur = _props5.onBlur;
	
	    if (onBlur) {
	      onBlur(e);
	    }
	
	    var value = e.target.value;
	
	    var state = {
	      active: false,
	      error: required && !(0, _isValued2.default)(value) || maxLength && String(value).length > maxLength
	    };
	
	    if (!_this4.props.block) {
	      state.floating = (0, _isValued2.default)(value);
	    }
	
	    _this4.setState(state);
	  };
	
	  this._handleFocus = function (e) {
	    var _props6 = _this4.props,
	        onFocus = _props6.onFocus,
	        block = _props6.block;
	
	    if (onFocus) {
	      onFocus(e);
	    }
	
	    var state = { active: true };
	    if (!block) {
	      state.floating = true;
	    }
	
	    _this4.setState(state);
	  };
	
	  this._handleChange = function (e) {
	    var _props7 = _this4.props,
	        onChange = _props7.onChange,
	        maxLength = _props7.maxLength,
	        required = _props7.required,
	        resize = _props7.resize;
	    var value = e.target.value;
	
	    if (onChange) {
	      onChange(e.target.value, e);
	    }
	
	    var currentLength = value.length;
	    var state = void 0;
	    if (typeof maxLength !== 'undefined') {
	      state = { currentLength: currentLength, error: currentLength > maxLength };
	    } else if (required && _this4.state.error) {
	      state = { error: !currentLength };
	    }
	
	    if (typeof _this4.props.value === 'undefined' && resize) {
	      var width = _this4._calcWidth(value);
	      if (!resize.disableShrink || !_this4.state.styles || width > _this4.state.styles.width) {
	        state = state || {};
	        state.styles = _extends({}, _this4.state.styles, { width: width });
	      }
	    }
	
	    if (state) {
	      _this4.setState(state);
	    }
	  };
	
	  this._togglePasswordField = function () {
	    _this4.setState({ passwordVisible: !_this4.state.passwordVisible }, _this4.focus);
	  };
	};
	
	exports.default = TextField;
	//# sourceMappingURL=TextField.js.map

/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(9);
	
	var _handleKeyboardAccessibility = __webpack_require__(53);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `AccessibleFakeButton` is a generic component that can be used to render
	 * a `div` or any other non `button` components as a button. This should not be
	 * used often.
	 *
	 * The `AccessibleFakeButton` allows the user to tab focus the element, use the
	 * space or enter key to trigger the `onClick` event, and toggles the `aria-pressed`
	 * attribute.
	 */
	var AccessibleFakeButton = function (_PureComponent) {
	  _inherits(AccessibleFakeButton, _PureComponent);
	
	  function AccessibleFakeButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AccessibleFakeButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccessibleFakeButton.__proto__ || Object.getPrototypeOf(AccessibleFakeButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = { pressed: false, tabFocused: false }, _this.focus = function () {
	      if (_this._node) {
	        _this._node.focus();
	      }
	    }, _this.blur = function () {
	      if (_this._node) {
	        _this._node.blur();
	      }
	    }, _this._setNode = function (node) {
	      if (node) {
	        _this._node = (0, _reactDom.findDOMNode)(node);
	      }
	    }, _this._handleClick = function (e) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      _this._node.focus();
	      _this.setState({ pressed: !_this.state.pressed });
	    }, _this._handleKeyDown = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onKeyDown = _this$props.onKeyDown,
	          listenToEnter = _this$props.listenToEnter,
	          listenToSpace = _this$props.listenToSpace;
	
	      if (disabled) {
	        return;
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	
	      (0, _handleKeyboardAccessibility2.default)(e, _this._handleClick, listenToEnter, listenToSpace);
	    }, _this._handleKeyUp = function (e) {
	      var _this$props2 = _this.props,
	          onKeyUp = _this$props2.onKeyUp,
	          onTabFocus = _this$props2.onTabFocus;
	
	      if (onKeyUp) {
	        onKeyUp(e);
	      }
	
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        if (onTabFocus) {
	          onTabFocus(e);
	        }
	
	        _this.setState({ tabFocused: true });
	      }
	    }, _this._handleBlur = function (e) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(e);
	      }
	
	      if (_this.state.tabFocused) {
	        _this.setState({ tabFocused: false });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Focuses the button.
	   */
	
	
	  /**
	   * Blurs the button.
	   */
	
	
	  _createClass(AccessibleFakeButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          children = _props.children,
	          className = _props.className,
	          tabbedClassName = _props.tabbedClassName,
	          disabled = _props.disabled,
	          tabIndex = _props.tabIndex,
	          ink = _props.ink,
	          noFocusOutline = _props.noFocusOutline,
	          onBlur = _props.onBlur,
	          onClick = _props.onClick,
	          onKeyUp = _props.onKeyUp,
	          onKeyDown = _props.onKeyDown,
	          onTabFocus = _props.onTabFocus,
	          listenToEnter = _props.listenToEnter,
	          listenToSpace = _props.listenToSpace,
	          props = _objectWithoutProperties(_props, ['component', 'children', 'className', 'tabbedClassName', 'disabled', 'tabIndex', 'ink', 'noFocusOutline', 'onBlur', 'onClick', 'onKeyUp', 'onKeyDown', 'onTabFocus', 'listenToEnter', 'listenToSpace']);
	
	      var childElements = children;
	      if (ink) {
	        childElements = _react.Children.toArray(children);
	        childElements.unshift(ink);
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          ref: this._setNode,
	          className: (0, _classnames2.default)('md-fake-btn', _defineProperty({
	            'md-pointer--hover': !disabled,
	            'md-fake-btn--no-outline': noFocusOutline
	          }, tabbedClassName, tabbedClassName && this.state.tabFocused), className),
	          disabled: disabled,
	          tabIndex: disabled ? null : tabIndex,
	          onBlur: this._handleBlur,
	          onClick: this._handleClick,
	          onKeyUp: this._handleKeyUp,
	          onKeyDown: this._handleKeyDown,
	          'aria-pressed': this.state.pressed
	        }),
	        childElements
	      );
	    }
	  }]);
	
	  return AccessibleFakeButton;
	}(_react.PureComponent);
	
	AccessibleFakeButton.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional function to call only when the button has been focused with the tab key.
	   */
	  tabbedClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to display in the Accessible Fake Button.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional onClick function to call when the user clicks the
	   * button or presses space || enter.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional onKeyDown function to call.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional onBlur function to call.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * An optional onKeyUp function to call.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the element is focused with the tab key.
	   */
	  onTabFocus: _propTypes2.default.func,
	
	  /**
	   * The component to render the Fake button as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the default outline should be removed the when the fake button has been focused.
	   *
	   * @see {@link #tabbedClassName}
	   */
	  noFocusOutline: _propTypes2.default.bool,
	
	  /**
	   * The tab index to use for the Fake button so it is keyboard focusable.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  /**
	   * Boolean if the Button is disabled. This will prevent tab focus.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * The role for the accessible fake button. It is recommended to keep it
	   * the default of `button` unless you are rendering it as an `a` tag.
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * The ink when coming from the AccessibleFakeInkedButton
	   * @access private
	   */
	  ink: _propTypes2.default.node,
	
	  /**
	   * Boolean if the spacebar should be used to trigger the click event. This _should_ be `true`
	   * is almost all cases.
	   */
	  listenToSpace: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the enter key should be used to trigger the click event. This _should_ be `true`
	   * in most cases. By default, the param will be ignored if the `role` attribute is for a `checkbox`
	   * or `radio`. When it is a checkbox or radio, it will attempt to submit the form on the enter
	   * keypress instead like the native elements.
	   */
	  listenToEnter: _propTypes2.default.bool
	};
	AccessibleFakeButton.defaultProps = {
	  component: 'div',
	  tabIndex: 0,
	  role: 'button',
	  noFocusOutline: true,
	  listenToEnter: true,
	  listenToSpace: true
	};
	exports.default = AccessibleFakeButton;
	//# sourceMappingURL=AccessibleFakeButton.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _Subheaders = __webpack_require__(156);
	
	var _Subheaders2 = _interopRequireDefault(_Subheaders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Lists present multiple line items vertically as a single continuous element.
	 */
	var List = function (_PureComponent) {
	  _inherits(List, _PureComponent);
	
	  function List() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, List);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(List, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _context = this.context,
	          listLevel = _context.listLevel,
	          context = _objectWithoutProperties(_context, ['listLevel']);
	
	      var cascadingFixedTo = (0, _getField2.default)(this.state, this.context, 'cascadingFixedTo');
	      return _extends({}, context, {
	        cascadingFixedTo: cascadingFixedTo,
	        listLevel: typeof listLevel === 'undefined' ? 1 : listLevel + 1
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.context.cascadingMenu) {
	        var list = (0, _reactDom.findDOMNode)(this);
	        if (list.offsetHeight < list.scrollHeight) {
	          var cascadingFixedTo = { y: (0, _reactDom.findDOMNode)(this) };
	          this.setState({ cascadingFixedTo: cascadingFixedTo }); // eslint-disable-line react/no-did-mount-set-state
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          className = _props.className,
	          ordered = _props.ordered,
	          children = _props.children,
	          subheader = _props.subheader,
	          inline = _props.inline,
	          primarySubheader = _props.primarySubheader,
	          props = _objectWithoutProperties(_props, ['className', 'ordered', 'children', 'subheader', 'inline', 'primarySubheader']);
	
	      var _context2 = this.context,
	          cascadingMenu = _context2.cascadingMenu,
	          cascadingZDepth = _context2.cascadingZDepth,
	          listLevel = _context2.listLevel;
	
	
	      var subheaderEl = void 0;
	      if (subheader) {
	        subheaderEl = _react2.default.createElement(_Subheaders2.default, { key: 'subheader', primaryText: subheader, primary: primarySubheader });
	      }
	
	      var Component = ordered ? 'ol' : 'ul';
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-list', (_cn = {
	            'md-list--inline': inline,
	            'md-list--menu-cascading': cascadingMenu
	          }, _defineProperty(_cn, 'md-paper md-paper--' + cascadingZDepth, cascadingZDepth && cascadingMenu && listLevel > 0), _defineProperty(_cn, 'md-list--nested-' + listLevel, listLevel && !cascadingMenu), _cn), className)
	        }),
	        subheaderEl,
	        children
	      );
	    }
	  }]);
	
	  return List;
	}(_react.PureComponent);
	
	List.propTypes = {
	  /**
	   * An optional style to apply to the list.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the list.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if this should be an ordered list (`<ol>`) component. Otherwise, it will
	   * be rendered as `<ul>`.
	   */
	  ordered: _propTypes2.default.bool,
	
	  /**
	   * This *should* be a list of `ListItem`, `ListItemControl`, `Divider`, or
	   * `Subheader`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the list should appear horizontally instead of vertically.
	   */
	  inline: _propTypes2.default.bool,
	  subheader: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `Subheader` component as a child instead'),
	  primarySubheader: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `Subheader` component as a child instead')
	};
	List.childContextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	List.contextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	exports.default = List;
	//# sourceMappingURL=List.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = captureNextEvent;
	/** @module utils/EventUtils/captureNextEvent */
	
	/**
	 * This function will capture the next event and stop propagation during the
	 * bubbling cycle of events. This is really only useful if you want to stop
	 * the default behavior of chained events.
	 *
	 * @param {String} type - The event type to capture.
	 * @param {Object|func=} target - Either the DOM node to target, a callback function
	 *      to call once the event has been captured, or undefined. If this is undefined,
	 *      the event will be captured on the window.
	 * @param {func=} callback - An optional callback function to call once the event
	 *      has been captured.
	 */
	function captureNextEvent(type, target, callback) {
	  var el = typeof target !== 'function' && target ? target : window;
	  var cb = typeof target === 'function' ? target : callback;
	
	  var capture = function capture(e) {
	    e.stopPropagation();
	    if (cb) {
	      cb(e);
	    }
	
	    el.removeEventListener(type, capture, true);
	  };
	
	  el.addEventListener(type, capture, true);
	}
	//# sourceMappingURL=captureNextEvent.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleKeyboardAccessibility;
	
	var _keyCodes = __webpack_require__(9);
	
	var _closest = __webpack_require__(373);
	
	var _closest2 = _interopRequireDefault(_closest);
	
	var _isFormPartRole = __webpack_require__(175);
	
	var _isFormPartRole2 = _interopRequireDefault(_isFormPartRole);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A utility function for adding keyboard accessibility to elements that are not a natively
	 * clickable (div, span, etc). When the space or enter key is pressed while focusing the
	 * element, different flows will happen.
	 *
	 * - space - The click event will be triggered and the default page scrolling behavior of the
	 *      spacebar will be prevented
	 * - enter - If the element has a form role ('checkbox' or 'radio'), the click event will not
	 *      be triggered. Instead, it will find out if the element is inside a form. If it is, it
	 *      will emulate the default behavior of attempting to submit the form. If the element does
	 *      not have a form role, the click event will be triggered.
	 *
	 * @param {Event} e - the keydown event
	 * @param {function} onClick - the on click event to be triggered if space or enter was pressed
	 * @param {boolean=true} listenToEnter - boolean if the enter key should be used to trigger the
	 *      the click event. Even if this is true, the click event will not be triggered if the role
	 *      is for a form role.
	 * @param {boolean=true} listenToSpace - boolean if the space key should be used to trigger the
	 *      click event.
	 * @return {Boolean} true if the enter or space keys were pressed while their listener is also active.
	 */
	function handleKeyboardAccessibility(e, onClick) {
	  var listenToEnter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var listenToSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  var key = e.which || e.keyCode;
	  var space = listenToSpace && key === _keyCodes.SPACE;
	  var enter = key === _keyCodes.ENTER;
	
	  var tagName = e.target.tagName;
	  // it is valid to press space in text fields, contenteditable, and buttons
	
	  if (space && !tagName.match(/input|textarea|button/i) && e.target.getAttribute('contenteditable') !== 'true') {
	    // Stop page scrolling
	    e.preventDefault();
	  }
	
	  if (enter && (0, _isFormPartRole2.default)(e.target)) {
	    var form = (0, _closest2.default)(e.target, 'form');
	    var submit = form ? form.querySelector('*[type="submit"]') : null;
	    if (submit) {
	      submit.click();
	    }
	
	    return true;
	  }
	
	  if (enter && listenToEnter || space) {
	    onClick(e);
	
	    return true;
	  }
	
	  return false;
	} /** @module utils/EventUtils/handleKeyboardAccessibility */
	//# sourceMappingURL=handleKeyboardAccessibility.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.setTouchEvent = setTouchEvent;
	exports.addTouchEvent = addTouchEvent;
	exports.removeTouchEvent = removeTouchEvent;
	// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	var supportsPassive = void 0;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      supportsPassive = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {
	  supportsPassive = false;
	}
	
	/**
	 * A helper function for manually setting touch events on elements with the passive
	 * option (when it is supported).
	 *
	 * @param {boolean} add - Boolean if the event listener should be added or removed.
	 * @param {HTMLElement} el - The element to add the listener to.
	 * @param {String} type - the event type to set. This should be 'start', 'move', or 'end'
	 * @param {function} callback - The event listener callback function.
	 * @param {Object=} options - any additional options to apply.
	 */
	function setTouchEvent(add, el, eventType, callback, options) {
	  return el[(add ? 'add' : 'remove') + 'EventListener']('touch' + eventType, callback, supportsPassive ? _extends({ passive: true }, options) : false);
	}
	
	/**
	 * A helper function for manually adding touch events on elements with the passive
	 * option (when it is supported).
	 *
	 * @param {HTMLElement} el - The element to add the listener to.
	 * @param {String} type - the event type to set. This should be 'start', 'move', or 'end'
	 * @param {function} callback - The event listener callback function.
	 * @param {Object=} options - any additional options to apply.
	 */
	function addTouchEvent(el, type, callback, options) {
	  return setTouchEvent(true, el, type, callback, options);
	}
	
	/**
	 * A helper function for manually removing touch events on elements with the passive
	 * option (when it is supported).
	 *
	 * @param {HTMLElement} el - The element to add the listener to.
	 * @param {String} type - the event type to set. This should be 'start', 'move', or 'end'
	 * @param {function} callback - The event listener callback function.
	 * @param {Object=} options - any additional options to apply.
	 */
	function removeTouchEvent(el, type, callback, options) {
	  return setTouchEvent(false, el, type, callback, options);
	}
	//# sourceMappingURL=touches.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = between;
	
	var _isBetween = __webpack_require__(168);
	
	var _isBetween2 = _interopRequireDefault(_isBetween);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Validates that a number is between a min and max value.
	 *
	 * @param {function} validator - The number validator to use.
	 * @param {number} min - The min number to use.
	 * @param {number} max - The max number to use.
	 * @return {Error} the prop type error or null
	 */
	function between(validator, min, max) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    var value = props[propName];
	    if (!err && typeof value !== 'undefined' && !(0, _isBetween2.default)(value, min, max)) {
	      err = new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' that was ' + ('not within the range from \'' + min + ' - ' + max + '\'. `' + propFullNameSafe + '`: ' + value + '.'));
	    }
	
	    return err;
	  };
	} /** @module utils/PropTypes/between */
	//# sourceMappingURL=between.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inRangeOfSector = exports.formatAngleOfSector = exports.getAngleOfPoint = exports.distanceBetweenPoints = exports.formatAxisMap = exports.getMaxRadius = exports.polarToCartesian = exports.radianToDegree = exports.degreeToRadian = exports.RADIAN = undefined;
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _DataUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var RADIAN = exports.RADIAN = Math.PI / 180;
	
	var degreeToRadian = exports.degreeToRadian = function degreeToRadian(angle) {
	  return angle * Math.PI / 180;
	};
	
	var radianToDegree = exports.radianToDegree = function radianToDegree(angleInRadian) {
	  return angleInRadian * 180 / Math.PI;
	};
	
	var polarToCartesian = exports.polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	var getMaxRadius = exports.getMaxRadius = function getMaxRadius(width, height) {
	  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0, right: 0, bottom: 0, left: 0
	  };
	  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
	};
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = exports.formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height;
	  var startAngle = props.startAngle,
	      endAngle = props.endAngle;
	
	  var cx = (0, _DataUtils.getPercentValue)(props.cx, width, width / 2);
	  var cy = (0, _DataUtils.getPercentValue)(props.cy, height, height / 2);
	  var maxRadius = getMaxRadius(width, height, offset);
	  var innerRadius = (0, _DataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
	  var ids = Object.keys(axisMap);
	
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var domain = axis.domain,
	        reversed = axis.reversed;
	
	    var range = void 0;
	
	    if ((0, _isNil3.default)(axis.range)) {
	      if (axisType === 'angleAxis') {
	        range = [startAngle, endAngle];
	      } else if (axisType === 'radiusAxis') {
	        range = [innerRadius, outerRadius];
	      }
	
	      if (reversed) {
	        range = [range[1], range[0]];
	      }
	    } else {
	      range = axis.range;
	      startAngle = range[0];
	      endAngle = range[1];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        realScaleType = _parseScale.realScaleType,
	        scale = _parseScale.scale;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _extends({}, axis, { realScaleType: realScaleType }));
	
	    var finalAxis = _extends({}, axis, ticks, {
	      range: range,
	      radius: outerRadius,
	      realScaleType: realScaleType, scale: scale, cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    });
	
	    return _extends({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	var distanceBetweenPoints = exports.distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
	  var x1 = point.x,
	      y1 = point.y;
	  var x2 = anotherPoint.x,
	      y2 = anotherPoint.y;
	
	
	  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	};
	
	var getAngleOfPoint = exports.getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
	  var x = _ref.x,
	      y = _ref.y;
	  var cx = _ref2.cx,
	      cy = _ref2.cy;
	
	  var radius = distanceBetweenPoints({ x: x, y: y }, { x: cx, y: cy });
	
	  if (radius <= 0) {
	    return { radius: radius };
	  }
	
	  var cos = (x - cx) / radius;
	  var angleInRadian = Math.acos(cos);
	
	  if (y > cy) {
	    angleInRadian = 2 * Math.PI - angleInRadian;
	  }
	
	  return { radius: radius, angle: radianToDegree(angleInRadian), angleInRadian: angleInRadian };
	};
	
	var formatAngleOfSector = exports.formatAngleOfSector = function formatAngleOfSector(_ref3) {
	  var startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	
	  return {
	    startAngle: startAngle - min * 360,
	    endAngle: endAngle - min * 360
	  };
	};
	
	var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
	  var startAngle = _ref4.startAngle,
	      endAngle = _ref4.endAngle;
	
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	
	  return angle + min * 360;
	};
	
	var inRangeOfSector = exports.inRangeOfSector = function inRangeOfSector(_ref5, sector) {
	  var x = _ref5.x,
	      y = _ref5.y;
	
	  var _getAngleOfPoint = getAngleOfPoint({ x: x, y: y }, sector),
	      radius = _getAngleOfPoint.radius,
	      angle = _getAngleOfPoint.angle;
	
	  var innerRadius = sector.innerRadius,
	      outerRadius = sector.outerRadius;
	
	
	  if (radius < innerRadius || radius > outerRadius) {
	    return false;
	  }
	
	  if (radius === 0) {
	    return true;
	  }
	
	  var _formatAngleOfSector = formatAngleOfSector(sector),
	      startAngle = _formatAngleOfSector.startAngle,
	      endAngle = _formatAngleOfSector.endAngle;
	
	  var formatAngle = angle;
	  var inRange = void 0;
	
	  if (startAngle <= endAngle) {
	    while (formatAngle > endAngle) {
	      formatAngle -= 360;
	    }
	    while (formatAngle < startAngle) {
	      formatAngle += 360;
	    }
	    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
	  } else {
	    while (formatAngle > startAngle) {
	      formatAngle -= 360;
	    }
	    while (formatAngle < endAngle) {
	      formatAngle += 360;
	    }
	    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
	  }
	
	  if (inRange) {
	    return _extends({}, sector, { radius: radius, angle: reverseFormatAngleOfSetor(formatAngle, sector) });
	  }
	
	  return null;
	};

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.trackEvent = trackEvent;
	exports.trackException = trackException;
	
	var _ref = typeof window === 'object' ? window : {},
	    ga = _ref.ga;
	
	function track() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  // Since it can be tough to make sure GA is working right in dev environments,
	  // we can make this easier using the console by disabling eslint here.
	  // eslint-disable-next-line no-console
	  console.info('Analytics', args);
	
	  if (!ga) {
	    return;
	  }
	
	  ga.apply(undefined, args);
	}
	
	/*
	  Track things the user did in Google Analytics. Category and action are required. More docs:
	  https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	  trackEvent({
	    category: 'Typically the object that was interacted with',
	    action: 'The type of interaction',
	  })
	*/
	function trackEvent() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      fieldsObject = _ref2.fieldsObject;
	
	  if (!category || !action) {
	    // eslint-disable-next-line no-console
	    console.error('Attempted to track an Analytics event without category/action. They are required!');
	    return;
	  }
	
	  track('send', 'event', category, action, label, value, fieldsObject);
	}
	
	function trackException(description, isFatal) {
	  track('send', 'exception', { exDescription: description, exFatal: isFatal });
	}

/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(443);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(216);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.translateStyle = exports.AnimateGroup = exports.configBezier = exports.configSpring = undefined;
	
	var _Animate = __webpack_require__(464);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	var _easing = __webpack_require__(465);
	
	var _util = __webpack_require__(198);
	
	var _AnimateGroup = __webpack_require__(718);
	
	var _AnimateGroup2 = _interopRequireDefault(_AnimateGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.configSpring = _easing.configSpring;
	exports.configBezier = _easing.configBezier;
	exports.AnimateGroup = _AnimateGroup2.default;
	exports.translateStyle = _util.translateStyle;
	exports.default = _Animate2.default;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(227)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(65)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  checkedIcon: _propTypes2.default.element,
	  uncheckedIcon: _propTypes2.default.element,
	  indeterminateIcon: _propTypes2.default.element,
	  indeterminate: _propTypes2.default.bool,
	  plain: _propTypes2.default.bool,
	  selectableRows: _propTypes2.default.bool.isRequired,
	  allSelected: _propTypes2.default.bool.isRequired,
	  selectedRows: _propTypes2.default.arrayOf(_propTypes2.default.bool).isRequired,
	  createCheckbox: _propTypes2.default.func.isRequired,
	  removeCheckbox: _propTypes2.default.func.isRequired,
	  toggleSelectedRow: _propTypes2.default.func.isRequired,
	  baseId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  baseName: _propTypes2.default.string,
	  checkboxHeaderLabel: _propTypes2.default.string.isRequired,
	  checkboxLabelTemplate: _propTypes2.default.string.isRequired,
	  fixedHeader: _propTypes2.default.bool.isRequired,
	  fixedFooter: _propTypes2.default.bool.isRequired
	};
	//# sourceMappingURL=contextTypes.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTable;
	/**
	 * Attempts fo find the base table component from an element in the table.
	 * This will either be the wrapper for responsive data tables, or the table element.
	 *
	 * @param {Object} el - The element to traverse from
	 * @param {Object} the table or null.
	 */
	function findTable(el) {
	  var table = void 0;
	  var node = el;
	  while (node && node.parentNode) {
	    if (node.classList) {
	      if (node.classList.contains('md-data-table')) {
	        table = node;
	      } else if (node.classList.contains('md-data-table--responsive')) {
	        return node;
	      } else if (node.classList.contains('md-data-table__scroll-wrapper')) {
	        // fixed-wrapper then responsive
	        return node.parentNode.parentNode;
	      } else if (table) {
	        return table;
	      }
	    }
	
	    node = node.parentNode;
	  }
	
	  return null;
	}
	//# sourceMappingURL=findTable.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FOOTER_PADDING = 8;
	
	var DialogFooter = function (_PureComponent) {
	  _inherits(DialogFooter, _PureComponent);
	
	  function DialogFooter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DialogFooter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DialogFooter.__proto__ || Object.getPrototypeOf(DialogFooter)).call.apply(_ref, [this].concat(args))), _this), _this.state = { stacked: false }, _this._setContainer = function (container) {
	      if (container !== null) {
	        _this._container = container;
	        var maxWidth = (_this._container.offsetWidth - FOOTER_PADDING * 3) / 2;
	
	        var stacked = false;
	        Array.prototype.slice.call(_this._container.querySelectorAll('.md-btn')).some(function (_ref2) {
	          var offsetWidth = _ref2.offsetWidth;
	
	          stacked = offsetWidth > maxWidth;
	          return stacked;
	        });
	
	        _this.setState({ stacked: stacked });
	      }
	    }, _this._generateActions = function () {
	      var actions = _this.props.actions;
	
	      if (!actions) {
	        return null;
	      } else if (Array.isArray(actions)) {
	        return actions.map(_this._toElement);
	      }
	
	      return _this._toElement(actions);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DialogFooter, [{
	    key: '_toElement',
	    value: function _toElement(action, index) {
	      if ((0, _react.isValidElement)(action)) {
	        var button = _react.Children.only(action);
	
	        return (0, _react.cloneElement)(action, {
	          key: button.key || index,
	          className: (0, _classnames2.default)('md-btn--dialog', button.props.className)
	        });
	      }
	
	      // Both label and children are valid for dialog actions
	
	      var label = action.label,
	          children = action.children,
	          remaining = _objectWithoutProperties(action, ['label', 'children']);
	
	      return _react2.default.createElement(
	        _Button2.default,
	        _extends({
	          key: index,
	          flat: true
	        }, remaining, {
	          className: (0, _classnames2.default)('md-btn--dialog', action.className)
	        }),
	        label || children
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          className = _props.className,
	          children = _props.children,
	          propStacked = _props.stacked,
	          props = _objectWithoutProperties(_props, ['actions', 'className', 'children', 'stacked']);
	
	      if (!children && (!actions || Array.isArray(actions) && !actions.length)) {
	        return null;
	      }
	
	      var stacked = this.props.stacked;
	
	      var stackedDefined = typeof propStacked !== 'undefined';
	      if (!stackedDefined) {
	        stacked = this.state.stacked;
	      }
	
	      return _react2.default.createElement(
	        'footer',
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-dialog-footer', {
	            'md-dialog-footer--inline': !stacked,
	            'md-dialog-footer--stacked': stacked
	          }, className),
	          ref: !stackedDefined ? this._setContainer : null
	        }),
	        this._generateActions(),
	        children
	      );
	    }
	  }]);
	
	  return DialogFooter;
	}(_react.PureComponent);
	
	DialogFooter.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),
	  stacked: _propTypes2.default.bool
	};
	exports.default = DialogFooter;
	//# sourceMappingURL=DialogFooter.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _handleWindowClickListeners = __webpack_require__(73);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _getSelectedTextPosition = __webpack_require__(366);
	
	var _getSelectedTextPosition2 = _interopRequireDefault(_getSelectedTextPosition);
	
	var _getScroll = __webpack_require__(365);
	
	var _getScroll2 = _interopRequireDefault(_getScroll);
	
	var _viewport = __webpack_require__(172);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _isOutOfBounds = __webpack_require__(367);
	
	var _isOutOfBounds2 = _interopRequireDefault(_isOutOfBounds);
	
	var _anchorShape = __webpack_require__(31);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(32);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _HorizontalAnchors = __webpack_require__(143);
	
	var _HorizontalAnchors2 = _interopRequireDefault(_HorizontalAnchors);
	
	var _VerticalAnchors = __webpack_require__(145);
	
	var _VerticalAnchors2 = _interopRequireDefault(_VerticalAnchors);
	
	var _Positions = __webpack_require__(144);
	
	var _Positions2 = _interopRequireDefault(_Positions);
	
	var _ResizeObserver = __webpack_require__(28);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Layover component is used to keep a component fixed to another component
	 * while the page is scrolling or a container is scrolling. When the fixed component
	 * is considered out of view, it will be closed.
	 *
	 * > NOTE: Don't look at source code. Plz.
	 */
	var Layover = function (_PureComponent) {
	  _inherits(Layover, _PureComponent);
	
	  function Layover(props) {
	    _classCallCheck(this, Layover);
	
	    var _this = _possibleConstructorReturn(this, (Layover.__proto__ || Object.getPrototypeOf(Layover)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var child = _react2.default.Children.only(props.children);
	    _this.state = {
	      below: false,
	      right: false,
	      styles: child.props.style
	    };
	
	    _this._lastXFix = null;
	    _this._lastYFix = null;
	    _this._initialX = null;
	    _this._initialY = null;
	    _this._initialTop = null;
	    _this._initialLeft = null;
	    _this._child = null;
	    _this._toggle = null;
	    return _this;
	  }
	
	  _createClass(Layover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (false) {
	        window.addEventListener('load', function () {
	          _this2._setContainer(_this2._container);
	        });
	      }
	
	      var _props = this.props,
	          visible = _props.visible,
	          fixedTo = _props.fixedTo,
	          sameWidth = _props.sameWidth,
	          centered = _props.centered,
	          simplified = _props.simplified;
	
	      var anchor = this._getAnchor(this.props);
	      if (visible) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
	
	        // Don't worry about any of the other logic for a "simple" layover
	        if (simplified) {
	          return;
	        }
	
	        var rect = this._contextRect || this._toggle.getBoundingClientRect();
	        if (this._dialog) {
	          this._manageFixedToListener(this._dialog, true);
	        } else if (!this._inFixed) {
	          this._manageFixedToListener(fixedTo, true);
	        }
	
	        this._init(fixedTo, anchor, sameWidth, centered, rect);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var fixedTo = nextProps.fixedTo,
	          visible = nextProps.visible,
	          children = nextProps.children,
	          sameWidth = nextProps.sameWidth,
	          centered = nextProps.centered,
	          simplified = nextProps.simplified;
	
	      if (simplified) {
	        if (this.props.simplified !== simplified) {
	          this._reset();
	        }
	        return;
	      }
	
	      var anchor = this._getAnchor(nextProps);
	      var visibileDiff = visible !== this.props.visible;
	      var childStyle = _react2.default.Children.only(children).props.style;
	
	      if (visibileDiff) {
	        if (!visible) {
	          this._reset();
	        } else {
	          // Initialize the layover logic
	          var rect = this._contextRect || this._toggle.getBoundingClientRect();
	          if (this._dialog) {
	            this._manageFixedToListener(this._dialog, true);
	          } else if (!this._inFixed) {
	            this._manageFixedToListener(fixedTo, true);
	          }
	
	          this._init(fixedTo, anchor, sameWidth, centered, rect);
	        }
	      } else if (fixedTo !== this.props.fixedTo && visible) {
	        // swap the fixedTo listeners
	        this._manageFixedToListener(this.props.fixedTo, false);
	        this._manageFixedToListener(fixedTo, true);
	      } else if (childStyle !== _react2.default.Children.only(this.props.children).props.style) {
	        // Re-merge styles... This is only required if all the others fail since all the other
	        // logic always merges styles with the children styles
	        this.setState({ styles: _extends({}, this.state.styles, childStyle) });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          visible = _props2.visible,
	          closeOnOutsideClick = _props2.closeOnOutsideClick;
	
	      var enabled = visible && closeOnOutsideClick;
	      var prevEnabled = prevProps.visible && prevProps.closeOnOutsideClick;
	      if (enabled !== prevEnabled) {
	        if (this._clickTimeout) {
	          clearTimeout(this._clickTimeout);
	          this._clickTimeout = null;
	        }
	
	        // This is really an arbitrary timeout time, but firefox needs to have a timeout
	        // so the context menu doesn't close automatically due to an "outside click" being
	        // triggered
	        this._clickTimeout = setTimeout(function () {
	          _this3._clickTimeout = null;
	          (0, _handleWindowClickListeners2.default)(_this3._handleOutsideClick, enabled);
	        }, enabled ? 300 : 0);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._clickTimeout) {
	        clearTimeout(this._clickTimeout);
	        this._clickTimeout = null;
	      }
	      (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	
	      if (!this.props.simplified) {
	        this._manageFixedToListener(this.props.fixedTo, false);
	        this._manageWindowResizeListener(false);
	      }
	    }
	  }, {
	    key: '_getAnchor',
	    value: function _getAnchor(_ref) {
	      var anchor = _ref.anchor,
	          belowAnchor = _ref.belowAnchor,
	          animationPosition = _ref.animationPosition;
	
	      return animationPosition === Layover.Positions.BELOW && belowAnchor || anchor;
	    }
	
	    /**
	     * Whew. Ok. So since the fixedTo prop can either be two elements or a single item,
	     * this utility function is used to add/remove the scrolling event listeners for
	     * this prop.
	     *
	     * When the fixedTo prop has a horizontal and/or vertical attribute, the `window`
	     * will be the fallback option. If both the horizontal and vertical attributes are
	     * defined, the `window` still needs to have a scroll listener to make sure it
	     * doesn't go off screen.
	     */
	
	
	    /**
	     * This is just a simple utility function to merge the existing state styles,
	     * any new styles, and the children's styles (with most precedence).
	     */
	
	
	    /**
	     * This initializes the popover with the default styles, and the initial bookkeeping
	     * variables to update while it is open.
	     */
	
	
	    /**
	     * Attempts to fix the child by setting it's location ONLY for the entire
	     * page viewport. I didn't bother attempting to fix it for additional fixedTo
	     * stuff.
	     */
	
	
	    /**
	     * When the child is initially mounted, it will update the styles for centering
	     * the element (if enabled) and then attempt to fix any viewport issues.
	     */
	
	
	    /**
	     * This is the meat of the stuff. Do lots of viewport / container checks to make sure
	     * the element should still be visible. If it is still visible, it will update its
	     * x and y position for the new scroll position.
	     */
	
	
	    /**
	     * Attempts to fix a viewport problem by swapping the positioning. This only does
	     * vertical switching right now.
	     *
	     * @param {Object} vp - The result of the viewport function
	     * @return {boolean} true if the fix was able to be done and successful.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          block = _props3.block,
	          toggle = _props3.toggle,
	          visible = _props3.visible,
	          children = _props3.children,
	          fullWidth = _props3.fullWidth,
	          animationPosition = _props3.animationPosition,
	          simplified = _props3.simplified,
	          fillViewportWidth = _props3.fillViewportWidth,
	          fillViewportHeight = _props3.fillViewportHeight,
	          anchor = _props3.anchor,
	          belowAnchor = _props3.belowAnchor,
	          onClose = _props3.onClose,
	          repositionOnScroll = _props3.repositionOnScroll,
	          repositionOnResize = _props3.repositionOnResize,
	          sameWidth = _props3.sameWidth,
	          centered = _props3.centered,
	          fixedTo = _props3.fixedTo,
	          toggleQuery = _props3.toggleQuery,
	          yThreshold = _props3.yThreshold,
	          xThreshold = _props3.xThreshold,
	          onContextMenu = _props3.onContextMenu,
	          preventContextMenu = _props3.preventContextMenu,
	          closeOnOutsideClick = _props3.closeOnOutsideClick,
	          minLeft = _props3.minLeft,
	          minRight = _props3.minRight,
	          minBottom = _props3.minBottom,
	          props = _objectWithoutProperties(_props3, ['className', 'block', 'toggle', 'visible', 'children', 'fullWidth', 'animationPosition', 'simplified', 'fillViewportWidth', 'fillViewportHeight', 'anchor', 'belowAnchor', 'onClose', 'repositionOnScroll', 'repositionOnResize', 'sameWidth', 'centered', 'fixedTo', 'toggleQuery', 'yThreshold', 'xThreshold', 'onContextMenu', 'preventContextMenu', 'closeOnOutsideClick', 'minLeft', 'minRight', 'minBottom']);
	
	      var child = void 0;
	      var childId = void 0;
	      if (visible) {
	        child = _react2.default.Children.only(children);
	        if (child.props.id) {
	          childId = child.props.id;
	        } else if (props.id) {
	          childId = props.id + '-layover';
	        }
	
	        child = _react2.default.cloneElement(children, {
	          ref: this._fixateChild,
	          id: childId,
	          style: simplified ? child.props.style : this.state.styles,
	          className: (0, _classnames2.default)('md-layover-child md-layover-child--' + animationPosition, {
	            'md-layover-child--simplified': simplified
	          }, child.props.className)
	        });
	      }
	
	      var observer = null;
	      if (!simplified && !fillViewportWidth && !fillViewportHeight) {
	        observer = _react2.default.createElement(_ResizeObserver2.default, {
	          watchWidth: !fillViewportWidth,
	          watchHeight: !fillViewportHeight,
	          target: this._child,
	          onResize: this._handleResize
	        });
	      }
	
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-layover', {
	            'md-layover--simplified': simplified,
	            'md-inline-block': !block && !fullWidth,
	            'md-full-width': fullWidth
	          }, className),
	          ref: this._setContainer,
	          'aria-haspopup': true,
	          'aria-owns': childId,
	          'aria-expanded': visible,
	          transitionEnter: props.transitionEnterTimeout !== 0,
	          transitionLeave: props.transitionLeaveTimeout !== 0,
	          onContextMenu: this._handleContextMenu
	        }),
	        observer,
	        toggle,
	        child
	      );
	    }
	  }]);
	
	  return Layover;
	}(_react.PureComponent);
	
	Layover.HorizontalAnchors = _HorizontalAnchors2.default;
	Layover.VerticalAnchors = _VerticalAnchors2.default;
	Layover.Positions = _Positions2.default;
	Layover.propTypes = {
	  /**
	   * A id to give the layover itself. This is generally recommended for accessibility. If the
	   * child does not have an id, the child will automatically be updated to be `${id}-layover`.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the layover.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the layover.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the layover's child is currently visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * This should either be a single element or two elements that the layover recalculates
	   * its fixed position when scrolling for horizontal and vertical.
	   *
	   * When it is a single element, it will recalculate for both horizontal and vertical
	   * scrolling. Otherwise, you can specify the element for horizontal scrolling and a
	   * separate element for vertical scrolling. If one is omitted, it will default to `window`.
	   *
	   * If the component is no longer considered to be in view after scrolling, the `onClose`
	   * prop will be called.
	   */
	  fixedTo: _fixedToShape2.default.isRequired,
	
	  /**
	   * The renderable item that causes the Layover to become visible. This _should_
	   * most likely be an `element` or `arrayOf(element)`, but anything is allowed.
	   */
	  toggle: _propTypes2.default.node,
	
	  /**
	   * Since the `toggle` prop can be anything, I need a way to be able to find an
	   * element to base all the calculations on. This can either be a string that
	   * gets passed to `layover.querySelector`, a DOM Element, or a function that
	   * returns a DOM Element.
	   */
	  toggleQuery: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string]).isRequired,
	
	  /**
	   * A single child that should be fixed to the toggle element.
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * Boolean if the Layover should be displayed as a block instead of as an inline block.
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `children` should be centered horizontally and vertically while keeping
	   * its height in mind as well. This is *only* valid if both the x and y `anchor` targets
	   * are `CENTER`.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should gain the `md-full-width` class name.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the width of the children should be updated automatically to be the width
	   * of the toggle element.
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * The minimum value the `left` style can be for the child component. This is really just used
	   * to make sure it doesn't scroll off the left of the page. It can also be used to make
	   * full screen layovers on devices when when the `fillViewportWidth` prop is enabled.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #minRight}
	   * @see {@link #fillViewportWidth}
	   */
	  minLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The minimum value the `right` style can be for the child component. This is really just used
	   * to make sure it doesn't scroll off the right of the page when the `fillViewportWidth` prop is
	   * enabled.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #minLeft}
	   * @see {@link #fillViewportWidth}
	   */
	  minRight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The minimum value that can be used for the `bottom` prop when the `fillViewportHeight` prop is enabled.
	   * It is generally recommended to keep this value at `0` to keep it stretched to the bottom of the viewport
	   * or setting it to a small positive number to add some padding.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #fillViewportHeight}
	   */
	  minBottom: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the layover should make the child fill the entire viewport's width. This will just
	   * style the child element with:
	   *
	   * ```js
	   * childStyle = {
	   *   left: this.props.minLeft,
	   *   right: this.props.minRight,
	   * };
	   * ```
	   *
	   * If you add any additional constraints such as `width` or `max-width`, it will not span the entire viewport's
	   * width. This prop should generally really only be used on mobile devices. Using this prop along with
	   * `fillViewportHeight` for Autocompletes can create great Android mobile searches. See the `fillViewportHeight`
	   * for more information about why it is *only Android*.
	   *
	   * @see {@link #minLeft}
	   * @see {@link #minRight}
	   * @see {@link #fillViewportHeight}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should fill the height of the viewport from the current calculated `top`. This will just
	   * style the child element with:
	   *
	   * ```js
	   * childStyle = {
	   *   top: currentCalculatedTop,
	   *   bottom: this.props.minBottom,
	   *   maxHeight: 'none',
	   * };
	   * ```
	   *
	   * This is *super* nice on Android devices since it will allow you to create nice toolbar search autocompletes
	   * in your app and the list of items will grow until it reaches the soft keyboard. It isn't as nice on iOS since
	   * iOS does not subtract the soft keyboard from the viewport's size so the list will still extend to the bottom
	   * of the page.
	   *
	   * @see {@link #minBottom}
	   * @see {@link #fillViewportWidth}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  /**
	   * A function used to hide the visibility of the children when the children are no longer
	   * visible or an element outside of the layover is clicked.
	   */
	  onClose: _propTypes2.default.func.isRequired,
	
	  /**
	   * The component to render the Layover as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The transition name to use for the children appearing/disappearing.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition duration for the enter animation. The animation can be disabled by setting
	   * this value to 0.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition duration for the leave animation. The animation can be disabled by setting
	   * this value to 0.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is a threshold that is used to calculate if the `children` is still in
	   * view by applying this multiplier to the `children`'s width.
	   */
	  xThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is a threshold that is used to calculate if the `children` is still in
	   * view by applying this multiplier to the `toggle`'s height.
	   */
	  yThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `children` should be hidden when an element outside
	   * of the `Layout` component has been clicked.
	   */
	  closeOnOutsideClick: _propTypes2.default.bool.isRequired,
	
	  /**
	   * This is how the children get "anchored" to the `toggle` element and how the
	   * auto-fix attempts will be made. Right now, the auto fixes will only be handled
	   * on viewport boundaries instead of `fixedTo` boundaries. It was too hard for
	   * first attempt.
	   *
	   * The general behavior will be that an equal-opposite of an anchor will be chosen
	   * when that direction is out of viewport. So for example, the children are out
	   * of viewport for the right of the screen, and the `anchor.x` value is
	   * `Layover.HorizontalPositions.RIGHT`, the children will be swapped to be the `LEFT`
	   * of the `toggle` component now.
	   *
	   * So a full list:
	   * - `LEFT` / `RIGHT`
	   * - `INNER_LEFT` / `INNER_RIGHT`
	   * - `TOP` / `BOTTOM`
	   *
	   * The `CENTER` and `OVERLAP` positions can not be automatically adjusted.
	   *
	   * > To be safe, you should use the enum values for the `x` and `y` values.
	   * @see {@link #VerticalAnchors}
	   * @see {@link #HorizontalAnchors}
	   */
	  anchor: _anchorShape2.default.isRequired,
	
	  /**
	   * This is how the children get "anchored" when the `animationPositions` is set to `Layover.Positions.BELOW`.
	   * Set this to `null` to continue using the base `anchor` prop instead of switching to this anchor.
	   *
	   * @see {@link #anchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the position that the children should animate from. It directly ties into
	   * the `$md-layover-child-positions` Sass variable.
	   */
	  animationPosition: _positionShape2.default.isRequired,
	
	  /**
	   * If you would like the layover to interact as a context menu, provide this prop. It will
	   * make the children appear relative to the context menu origin automatically.
	   *
	   * @see {@link #preventContextMenu}
	   */
	  onContextMenu: _propTypes2.default.func,
	
	  /**
	   * Boolean if the default behavior of the context menu should be prevented when using the
	   * `onContextMenu` prop.
	   *
	   * @see {@link #onContextMenu}
	   */
	  preventContextMenu: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should attempt to automatically adjust the position of the element to
	   * keep it within the viewport. If this value is set to `false`, the `onClose` prop will be called
	   * instead.
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should attempt to automatically adjust the position of the element to
	   * keep it within the viewport. If this value is set to `false`, the `onClose` prop will be called
	   * instead.
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should become "simplified". This basically disables all the logic for
	   * keeping the child within the viewport and allows you to manage all the positioning via CSS.
	   *
	   * When this is enabled, it updates the `Layover` to have `position: relative` while the child will
	   * have `position: absolute` which will allow for simple `top`, `right`, `bottom`, and/or `left` CSS
	   * to position as wanted.
	   *
	   * This is really only helpful in cases where the layover can't calculate things correctly due to
	   * being in fixed containers somewhere in the page or some other weird stuff. Hopefully this won't
	   * really need to be used much.
	   */
	  simplified: _propTypes2.default.bool
	};
	Layover.defaultProps = {
	  anchor: {
	    x: Layover.HorizontalAnchors.INNER_LEFT,
	    y: Layover.VerticalAnchors.OVERLAP
	  },
	  belowAnchor: {
	    x: Layover.HorizontalAnchors.CENTER,
	    y: Layover.VerticalAnchors.BOTTOM
	  },
	  animationPosition: Layover.Positions.BELOW,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  component: 'div',
	  fixedTo: typeof window !== 'undefined' ? window : {},
	  toggleQuery: '.md-text-field-container,button,*[role="button"],*[role="listbox"]',
	  transitionName: 'md-layover',
	  transitionEnterTimeout: 200,
	  transitionLeaveTimeout: 200,
	  yThreshold: 0.38,
	  xThreshold: 0.38,
	  closeOnOutsideClick: true,
	  preventContextMenu: true,
	  simplified: false,
	  minLeft: 0,
	  minRight: 0,
	  minBottom: 0,
	  fillViewportWidth: false,
	  fillViewportHeight: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this._isCenteredDialog = function () {
	    return _this4._dialog && _this4._dialog.classList.contains('md-dialog--centered');
	  };
	
	  this._createStyles = function (anchor, centered, child, rect) {
	    var x = anchor.x,
	        y = anchor.y;
	    var offsetWidth = child.offsetWidth,
	        offsetHeight = child.offsetHeight;
	
	
	    var left = void 0;
	    var top = void 0;
	    if (x === _HorizontalAnchors2.default.CENTER) {
	      left = rect.left + rect.width / 2 - offsetWidth / 2;
	    } else if (x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      left = rect.right - offsetWidth;
	    } else if (x === _HorizontalAnchors2.default.LEFT) {
	      left = rect.left - offsetWidth;
	    } else if (x === _HorizontalAnchors2.default.RIGHT) {
	      left = rect.right;
	    }
	
	    if (centered && x === _HorizontalAnchors2.default.CENTER && y === _VerticalAnchors2.default.CENTER) {
	      top = rect.top - offsetHeight / 2 + rect.height / 2;
	    } else if (y === _VerticalAnchors2.default.TOP) {
	      top = rect.top - offsetHeight;
	    } else if (y === _VerticalAnchors2.default.CENTER) {
	      top = rect.top + rect.height / 2;
	    } else if (y === _VerticalAnchors2.default.BOTTOM) {
	      top = rect.bottom;
	    }
	
	    if (_this4._isCenteredDialog()) {
	      var dialogRect = _this4._dialog.getBoundingClientRect();
	      left -= dialogRect.left;
	      top -= dialogRect.top;
	    }
	
	    var style = {};
	    if (top) {
	      style.top = top;
	    }
	
	    if (left) {
	      style.left = left;
	    }
	
	    return style;
	  };
	
	  this._manageFixedToListener = function (fixedTo, add) {
	    var listener = (add ? 'add' : 'remove') + 'EventListener';
	    if (fixedTo !== window && (fixedTo.x || fixedTo.y)) {
	      var x = fixedTo.x,
	          y = fixedTo.y;
	
	      if (x) {
	        x[listener]('scroll', _this4._handleScroll);
	      } else {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	
	      if (y) {
	        y[listener]('scroll', _this4._handleScroll);
	      } else if (!x) {
	        // Only add the window event listener once
	        window[listener]('scroll', _this4._handleScroll);
	      }
	
	      if (y && y !== window && x && x !== window) {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	    } else {
	      fixedTo[listener]('scroll', _this4._handleScroll);
	
	      if (fixedTo !== window) {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	    }
	  };
	
	  this._manageWindowResizeListener = function (enabled) {
	    if (_this4._windowResizeTimeout) {
	      clearTimeout(_this4._windowResizeTimeout);
	      _this4._windowResizeTimeout = null;
	    }
	
	    if (enabled) {
	      // add a 2 second delay before watching resize events since Android soft keyboards trigger a resize event.
	      _this4._windowResizeTimeout = setTimeout(function () {
	        _this4._windowResizeTimeout = null;
	        window.addEventListener('resize', _this4._handleWindowResize);
	      }, 2000);
	    } else {
	      window.removeEventListener('resize', _this4._handleWindowResize);
	    }
	  };
	
	  this._mergeStyles = function (style) {
	    var _props4 = _this4.props,
	        minLeft = _props4.minLeft,
	        minRight = _props4.minRight,
	        minBottom = _props4.minBottom,
	        fillViewportWidth = _props4.fillViewportWidth,
	        fillViewportHeight = _props4.fillViewportHeight;
	
	    if (fillViewportWidth) {
	      style.left = minLeft;
	      style.right = minRight;
	    } else {
	      if (style.left) {
	        style.left = Math.max(minLeft, style.left);
	      }
	
	      if (style.right) {
	        style.right = Math.max(minRight, style.right);
	      }
	    }
	
	    if (fillViewportHeight) {
	      style.bottom = minBottom;
	      style.maxHeight = 'none';
	    } else {
	      // These styles are only created when filling the viewport height, so clear
	      // them out again
	      style.bottom = null;
	      style.maxHeight = null;
	    }
	
	    return _extends({}, _this4.state.styles, style, _react2.default.Children.only(_this4.props.children).props.style);
	  };
	
	  this._init = function (fixedTo, anchor, sameWidth, centered, rect) {
	    if (_this4._child) {
	      // The init function can be called again if the user quickly toggles the layover. If that
	      // is the case, we want the styles that were set after the _positionChild _attemptFix.
	      return;
	    }
	
	    var height = rect.height,
	        width = rect.width;
	    var top = rect.top,
	        left = rect.left,
	        right = rect.right;
	
	    var x = void 0;
	    var y = void 0;
	    if (_this4._dialog) {
	      var scroll = (0, _getScroll2.default)(_this4._dialog);
	      x = scroll.x;
	      y = scroll.y;
	
	      if (_this4._isCenteredDialog()) {
	        var dialogRect = _this4._dialog.getBoundingClientRect();
	        left -= dialogRect.left;
	        top -= dialogRect.top;
	        right -= dialogRect.right;
	      }
	    } else if (fixedTo !== window && (fixedTo.y || fixedTo.x)) {
	      x = (0, _getScroll2.default)(fixedTo.x || window).x;
	      y = (0, _getScroll2.default)(fixedTo.y || window).y;
	    } else {
	      var _scroll = (0, _getScroll2.default)(fixedTo);
	      x = _scroll.x;
	      y = _scroll.y;
	    }
	
	    _this4._initialX = x;
	    _this4._initialY = y;
	    _this4._initialLeft = left;
	    _this4._initialTop = top;
	
	    if (anchor.x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      _this4._initialLeft = left + width;
	    } else if (anchor.x === _HorizontalAnchors2.default.RIGHT) {
	      _this4._initialLeft = right;
	    }
	
	    if (!centered) {
	      _this4._lastYFix = anchor.y === _VerticalAnchors2.default.TOP ? 'bottom' : 'top';
	    } else {
	      // Centered is not fixable
	      _this4._lastYFix = null;
	    }
	    if (anchor.x === _HorizontalAnchors2.default.LEFT || anchor.x === _HorizontalAnchors2.default.INNER_LEFT) {
	      _this4._lastXFix = 'right';
	    } else if (anchor.x === _HorizontalAnchors2.default.RIGHT || anchor.x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      _this4._lastXFix = 'left';
	    } else {
	      // Can't fix others
	      _this4._lastXFix = null;
	    }
	
	    if (anchor.y === _VerticalAnchors2.default.BOTTOM) {
	      _this4._initialTop = top + height;
	    }
	
	    if (fixedTo !== window && !fixedTo.y && !fixedTo.x) {
	      var _scroll2 = (0, _getScroll2.default)(window);
	      _this4._initialWinX = _scroll2.x;
	      _this4._initialWinY = _scroll2.y;
	    }
	
	    var styles = _this4._mergeStyles({
	      left: _this4._initialLeft,
	      top: _this4._initialTop,
	      transformOrigin: undefined,
	      width: sameWidth ? width : undefined
	    });
	
	    _this4.setState({ styles: styles });
	  };
	
	  this._reset = function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.props,
	        fixedTo = _ref2.fixedTo;
	
	    // Reset all the bookkeeping variables for a fresh start on re-visible
	    _this4._lastXFix = null;
	    _this4._lastYFix = null;
	    _this4._initialX = null;
	    _this4._initialY = null;
	    _this4._initialTop = null;
	    _this4._initialLeft = null;
	
	    if (!_this4._inFixed) {
	      if (_this4._dialog) {
	        _this4._manageFixedToListener(_this4._dialog, false);
	      }
	
	      _this4._manageFixedToListener(fixedTo, false);
	    }
	  };
	
	  this._setContainer = function (container) {
	    _this4._container = (0, _reactDom.findDOMNode)(container);
	    _this4._toggle = null;
	    if (!_this4._container) {
	      return;
	    }
	
	    var _props5 = _this4.props,
	        toggleQuery = _props5.toggleQuery,
	        onContextMenu = _props5.onContextMenu;
	
	    if (typeof toggleQuery === 'function') {
	      _this4._toggle = toggleQuery();
	    } else if (typeof toggleQuery === 'string') {
	      _this4._toggle = _this4._container.querySelector(toggleQuery);
	    } else {
	      _this4._toggle = toggleQuery;
	    }
	
	    if (!_this4._toggle && !onContextMenu && ("production") !== 'production') {
	      var error = new Error('Unable to find a toggle component with the provided `toggleQuery` and `toggle` element. \n' + ('`toggleQuery`: `' + toggleQuery + '`'));
	      error.toggleQuery = toggleQuery;
	      error.toggle = _this4.props.toggle;
	
	      throw error;
	    }
	
	    var node = _this4._container;
	    while (node) {
	      var fixed = window.getComputedStyle(node).position === 'fixed';
	      if (fixed && node.className.match(/md-dialog--(full-page|centered)/)) {
	        _this4._dialog = node;
	        return;
	      } else if (fixed && !node.classList.contains('md-layover-child')) {
	        _this4._inFixed = true;
	        return;
	      }
	
	      node = node.offsetParent;
	    }
	  };
	
	  this._initialFix = function () {
	    // Need to make a clone that disables any transitions to calculate positioning stuff
	    var clone = _this4._child.cloneNode(true);
	    clone.style.webkitTransform = 'none';
	    clone.style.transfrom = 'none';
	    clone.style.webkitTransition = 'none';
	    clone.style.transition = 'none';
	
	    _this4._child.parentNode.appendChild(clone);
	    var vp = (0, _viewport2.default)(clone);
	    var childHeight = clone.offsetHeight,
	        childWidth = clone.offsetWidth;
	
	    _this4._child.parentNode.removeChild(clone);
	
	    if (vp === true || !_this4._toggle || !_this4._child) {
	      return;
	    }
	
	    var _getAnchor2 = _this4._getAnchor(_this4.props),
	        x = _getAnchor2.x,
	        y = _getAnchor2.y;
	
	    var toggleHeight = void 0;
	    var toggleWidth = void 0;
	    if (_this4._contextRect) {
	      toggleHeight = _this4._contextRect.height;
	      toggleWidth = _this4._contextRect.width;
	    } else {
	      toggleHeight = _this4._toggle.offsetHeight;
	      toggleWidth = _this4._toggle.offsetWidth;
	    }
	
	    var addToTop = 0;
	    var addToLeft = 0;
	
	    // Android devices will never get this far because they consider the keyboard as part
	    // of the viewport, iOS will and cause it to be a giant negative number. *sigh*
	    // Prevent any additional vertical positioning for iOS
	    if (!_this4.props.fillViewportHeight && (!vp.top || !vp.bottom)) {
	      var multiplier = vp.top ? -1 : 1;
	      if (!vp.bottom && y === _VerticalAnchors2.default.OVERLAP) {
	        addToTop += toggleHeight;
	      } else if (y === _VerticalAnchors2.default.TOP || y === _VerticalAnchors2.default.BOTTOM) {
	        addToTop += multiplier * toggleHeight;
	      }
	
	      addToTop += multiplier * childHeight;
	
	      _this4._lastYFix = vp.top ? 'bottom' : 'top';
	    }
	
	    if (!_this4.props.fillViewportWidth && x !== _HorizontalAnchors2.default.CENTER && (!vp.left || !vp.right)) {
	      if (!vp.left && x === _HorizontalAnchors2.default.LEFT) {
	        addToLeft += toggleWidth + childWidth;
	        _this4._lastXFix = 'left';
	      } else if (!vp.left && x === _HorizontalAnchors2.default.INNER_LEFT) {
	        addToLeft += toggleWidth;
	        _this4._lastXFix = 'left';
	      } else if (!vp.right && x === _HorizontalAnchors2.default.RIGHT) {
	        addToLeft -= toggleWidth + childWidth;
	        _this4._lastXFix = 'right';
	      } else if (!vp.right && x === _HorizontalAnchors2.default.INNER_RIGHT) {
	        addToLeft -= toggleWidth;
	        _this4._lastXFix = 'right';
	      }
	    }
	
	    if (addToTop !== 0 || addToLeft !== 0) {
	      _this4._initialTop += addToTop;
	      _this4._initialLeft += addToLeft;
	
	      _this4.setState({ styles: _this4._mergeStyles({ top: _this4._initialTop, left: _this4._initialLeft }) });
	    }
	  };
	
	  this._fixateChild = function (child) {
	    _this4._child = (0, _reactDom.findDOMNode)(child);
	
	    if (_this4._child !== null) {
	      _this4._childComponent = _react2.default.Children.only(_this4.props.children);
	
	      // If child also has a ref callback, simulate the same thing
	      if (typeof _this4._childComponent.ref === 'function') {
	        _this4._childComponent.ref(child);
	      }
	
	      if (_this4.props.simplified || !_this4._child || !_this4._toggle && !_this4._contextRect) {
	        return;
	      }
	
	      if (_this4._dialog && _this4._dialog.classList.contains('md-dialog--centered')) {
	        return;
	      }
	
	      _this4._manageWindowResizeListener(true);
	      _this4._positionChild();
	    } else if (_this4._childComponent && typeof _this4._childComponent.ref === 'function') {
	      _this4._childComponent.ref(child);
	    }
	  };
	
	  this._positionChild = function () {
	    var centered = _this4.props.centered;
	
	    var anchor = _this4._getAnchor(_this4.props);
	    var rect = _this4._contextRect || _this4._toggle.getBoundingClientRect();
	    _this4._height = rect.height;
	    _this4._width = rect.width;
	    var styles = _this4._createStyles(anchor, centered, _this4._child, rect);
	    if (styles.top || styles.left) {
	      _this4._initialLeft = styles.left || _this4._initialLeft;
	      _this4._initialTop = styles.top || _this4._initialTop;
	      _this4.setState({ styles: _this4._mergeStyles(styles) }, _this4._initialFix);
	    } else {
	      _this4._initialFix();
	    }
	  };
	
	  this._handleResize = function () {
	    if (_this4.props.visible) {
	      _this4._positionChild();
	    }
	  };
	
	  this._handleScroll = function (e) {
	    if (!_this4.props.repositionOnScroll) {
	      _this4._manageFixedToListener(_this4.props.fixedTo, false);
	      _this4.props.onClose(e);
	    }
	
	    if (!_this4._ticking) {
	      requestAnimationFrame(function () {
	        return _this4._handleTick(e);
	      });
	    }
	
	    _this4._ticking = true;
	  };
	
	  this._handleTick = function (e) {
	    var _props6 = _this4.props,
	        fixedTo = _props6.fixedTo,
	        xThreshold = _props6.xThreshold,
	        yThreshold = _props6.yThreshold;
	
	    var vp = (0, _viewport2.default)(_this4._child);
	    if (vp !== true && vp.left && vp.right) {
	      var fixed = !_this4._contextRect && _this4._attemptFix(vp);
	      if (!fixed) {
	        _this4.props.onClose(e);
	        _this4._ticking = false;
	      }
	
	      return;
	    } else if ((0, _isOutOfBounds2.default)(fixedTo, _this4._child, _this4._toggle, yThreshold, xThreshold)) {
	      _this4.props.onClose(e);
	      _this4._ticking = false;
	      return;
	    }
	
	    var x = void 0;
	    var y = void 0;
	    if (_this4._dialog) {
	      var scroll = (0, _getScroll2.default)(_this4._dialog);
	      x = scroll.x;
	      y = scroll.y;
	    } else if (fixedTo !== window && (fixedTo.x || fixedTo.y)) {
	      x = (0, _getScroll2.default)(fixedTo.x || window).x;
	      y = (0, _getScroll2.default)(fixedTo.y || window).y;
	    } else {
	      var _scroll3 = (0, _getScroll2.default)(fixedTo);
	      x = _scroll3.x;
	      y = _scroll3.y;
	    }
	
	    var winX = void 0;
	    var winY = void 0;
	    // When using the additional fixedTo stuff, need to also keep track of the entire
	    // window's scrolling..
	    if (fixedTo !== window && !fixedTo.x && !fixedTo.y) {
	      var _scroll4 = (0, _getScroll2.default)(window);
	      winX = _scroll4.x;
	      winY = _scroll4.y;
	    }
	
	    var styles = _this4.state.styles;
	    var left = styles.left,
	        top = styles.top;
	
	    if (_this4._initialX !== x) {
	      left = _this4._initialX - x + _this4._initialLeft;
	    }
	
	    if (winX && _this4._initialWinX !== winX) {
	      left = _this4._initialWinX - winX + _this4._initialX;
	    }
	
	    if (_this4._initialY !== y) {
	      top = _this4._initialY - y + _this4._initialTop;
	    }
	
	    if (winY && _this4._initialWinY !== winY) {
	      top = _this4._initialWinY - winY + _this4._initialTop + (_this4._initialY - y);
	    }
	
	    if (styles.top !== top || styles.left !== left) {
	      _this4.setState({ styles: _this4._mergeStyles({ left: left, top: top }) }, function () {
	        _this4._ticking = false;
	      });
	    } else {
	      _this4._ticking = false;
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this4._contextRect && _this4._child && !_this4._child.contains(e.target) || _this4._container && !_this4._container.contains(e.target)) {
	      _this4.props.onClose(e);
	    }
	  };
	
	  this._handleWindowResize = function (e) {
	    var _props7 = _this4.props,
	        onClose = _props7.onClose,
	        repositionOnResize = _props7.repositionOnResize;
	
	    if (repositionOnResize) {
	      _this4._handleResize();
	    } else {
	      onClose(e);
	      _this4._manageWindowResizeListener(false);
	    }
	  };
	
	  this._attemptFix = function (vp) {
	    var _getAnchor3 = _this4._getAnchor(_this4.props),
	        x = _getAnchor3.x,
	        y = _getAnchor3.y;
	
	    var centered = x === _HorizontalAnchors2.default.CENTER && y === _VerticalAnchors2.default.CENTER && _this4.props.centered;
	    if (centered || _this4._lastYFix === 'top' && !vp.top || _this4._lastYFix === 'bottom' && !vp.bottom) {
	      return false;
	    }
	
	    var toggleTop = _this4._toggle.getBoundingClientRect().top;
	    var toggleHeight = _this4._toggle.offsetHeight;
	    var childHeight = _this4._child.offsetHeight;
	
	    // Can;t fix if the child can't fit on the page based on the toggle's position
	
	    if (toggleTop + toggleHeight + childHeight > window.innerHeight) {
	      return false;
	    }
	
	    var _child$getBoundingCli = _this4._child.getBoundingClientRect(),
	        top = _child$getBoundingCli.top;
	
	    var newTop = _this4._initialTop;
	    var addToTop = childHeight * (vp.top ? -1 : 1);
	    if (y === _VerticalAnchors2.default.OVERLAP) {
	      addToTop += (vp.top ? 1 : -1) * toggleHeight;
	    } else if (y === _VerticalAnchors2.default.TOP || y === _VerticalAnchors2.default.BOTTOM) {
	      addToTop += (_this4._lastYFix === 'top' ? -1 : 1) * toggleHeight;
	    }
	
	    if (addToTop !== 0) {
	      newTop = top + addToTop;
	      _this4._lastYFix = vp.top ? 'bottom' : 'top';
	    }
	
	    if (newTop !== _this4._initialTop) {
	      _this4._initialTop = newTop;
	      var fixedTo = _this4.props.fixedTo;
	
	      var scrollEl = fixedTo;
	      if (fixedTo !== window && (fixedTo.y || fixedTo.x)) {
	        scrollEl = fixedTo.y || window;
	      }
	
	      _this4._initialY = (0, _getScroll2.default)(scrollEl).y;
	
	      _this4.setState({ styles: _this4._mergeStyles({ top: _this4._initialTop }) }, function () {
	        _this4._ticking = false;
	      });
	      return true;
	    }
	
	    return false;
	  };
	
	  this._handleContextMenu = function (e) {
	    var anchor = _this4._getAnchor(_this4.props);
	    var _props8 = _this4.props,
	        onContextMenu = _props8.onContextMenu,
	        preventContextMenu = _props8.preventContextMenu,
	        fixedTo = _props8.fixedTo,
	        sameWidth = _props8.sameWidth,
	        centered = _props8.centered,
	        visible = _props8.visible;
	
	    if (!onContextMenu) {
	      return;
	    }
	
	    _this4._contextRect = (0, _getSelectedTextPosition2.default)(e);
	    if (preventContextMenu && (!_this4._child || !_this4._child.contains(e.target))) {
	      e.preventDefault();
	    }
	
	    onContextMenu(e);
	    if (visible) {
	      _this4._init(fixedTo, anchor, sameWidth, centered, _this4._contextRect);
	    }
	  };
	};
	
	exports.default = Layover;
	//# sourceMappingURL=Layover.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _getCollapserStyles = __webpack_require__(75);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _keyCodes = __webpack_require__(9);
	
	var _anchorShape = __webpack_require__(31);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _AccessibleFakeInkedButton = __webpack_require__(25);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _Collapse = __webpack_require__(35);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _TileAddon = __webpack_require__(93);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	var _ListItemText = __webpack_require__(146);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _List = __webpack_require__(51);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Menu = __webpack_require__(46);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ListItem` component is used for rendering a `li` tag with text and optional
	 * icons/avatars.
	 */
	var ListItem = function (_PureComponent) {
	  _inherits(ListItem, _PureComponent);
	
	  function ListItem(props) {
	    _classCallCheck(this, ListItem);
	
	    var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = { active: false };
	
	    if (typeof props.isOpen === 'undefined' && typeof props.visible === 'undefined') {
	      var defined = function defined(v) {
	        return typeof v !== 'undefined';
	      };
	      var _this$props = _this.props,
	          initiallyOpen = _this$props.initiallyOpen,
	          defaultOpen = _this$props.defaultOpen,
	          defaultVisible = _this$props.defaultVisible;
	
	      var visible = defined(initiallyOpen) ? initiallyOpen : defaultVisible;
	      visible = defined(defaultOpen) ? defaultOpen : visible;
	      visible = !!visible;
	
	      _this.state.visible = visible;
	    }
	    return _this;
	  }
	
	  _createClass(ListItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.active) {
	        window.removeEventListener('click', this._handleOutsideClick);
	      }
	
	      if (this._touchTimeout) {
	        clearTimeout(this._touchTimeout);
	      }
	    }
	
	    /**
	     * A utility function to focus the `AccessibleFakeInkedButton` in the `ListItem` and also
	     * inject an ink to indicate focus.
	     */
	
	
	    /**
	     * A utility function to blur the `AccessibleFakeInkedButton` in the `ListItem`.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          tileStyle = _props.tileStyle,
	          tileClassName = _props.tileClassName,
	          contentStyle = _props.contentStyle,
	          contentClassName = _props.contentClassName,
	          leftNodeStyle = _props.leftNodeStyle,
	          leftNodeClassName = _props.leftNodeClassName,
	          rightNodeStyle = _props.rightNodeStyle,
	          rightNodeClassName = _props.rightNodeClassName,
	          primaryTextStyle = _props.primaryTextStyle,
	          primaryTextClassName = _props.primaryTextClassName,
	          secondaryTextStyle = _props.secondaryTextStyle,
	          secondaryTextClassName = _props.secondaryTextClassName,
	          nestedListStyle = _props.nestedListStyle,
	          nestedListClassName = _props.nestedListClassName,
	          nestedListHeightRestricted = _props.nestedListHeightRestricted,
	          disabled = _props.disabled,
	          leftIcon = _props.leftIcon,
	          leftAvatar = _props.leftAvatar,
	          inset = _props.inset,
	          rightIcon = _props.rightIcon,
	          rightAvatar = _props.rightAvatar,
	          primaryText = _props.primaryText,
	          secondaryText = _props.secondaryText,
	          threeLines = _props.threeLines,
	          children = _props.children,
	          nestedItems = _props.nestedItems,
	          prependNested = _props.prependNested,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          activeBoxStyle = _props.activeBoxStyle,
	          activeBoxClassName = _props.activeBoxClassName,
	          animateNestedItems = _props.animateNestedItems,
	          expanderIcon = _props.expanderIcon,
	          expanderLeft = _props.expanderLeft,
	          component = _props.component,
	          ItemComponent = _props.itemComponent,
	          itemProps = _props.itemProps,
	          tileProps = _props.tileProps,
	          passPropsToItem = _props.passPropsToItem,
	          ariaSize = _props['aria-setsize'],
	          ariaPos = _props['aria-posinset'],
	          isOpen = _props.isOpen,
	          expanderIconChildren = _props.expanderIconChildren,
	          expanderIconClassName = _props.expanderIconClassName,
	          propVisible = _props.visible,
	          defaultVisible = _props.defaultVisible,
	          itemRef = _props.itemRef,
	          defaultOpen = _props.defaultOpen,
	          initiallyOpen = _props.initiallyOpen,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'contentStyle', 'contentClassName', 'leftNodeStyle', 'leftNodeClassName', 'rightNodeStyle', 'rightNodeClassName', 'primaryTextStyle', 'primaryTextClassName', 'secondaryTextStyle', 'secondaryTextClassName', 'nestedListStyle', 'nestedListClassName', 'nestedListHeightRestricted', 'disabled', 'leftIcon', 'leftAvatar', 'inset', 'rightIcon', 'rightAvatar', 'primaryText', 'secondaryText', 'threeLines', 'children', 'nestedItems', 'prependNested', 'active', 'activeClassName', 'activeBoxStyle', 'activeBoxClassName', 'animateNestedItems', 'expanderIcon', 'expanderLeft', 'component', 'itemComponent', 'itemProps', 'tileProps', 'passPropsToItem', 'aria-setsize', 'aria-posinset', 'isOpen', 'expanderIconChildren', 'expanderIconClassName', 'visible', 'defaultVisible', 'itemRef', 'defaultOpen', 'initiallyOpen']);
	
	      var _context = this.context,
	          cascadingId = _context.cascadingId,
	          cascadingMenu = _context.cascadingMenu,
	          cascadingAnchor = _context.cascadingAnchor,
	          cascadingFixedTo = _context.cascadingFixedTo;
	
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      if (typeof isOpen !== 'undefined') {
	        visible = isOpen;
	      }
	
	      var leftNode = _react2.default.createElement(_TileAddon2.default, {
	        key: 'left-addon',
	        style: leftNodeStyle,
	        className: leftNodeClassName,
	        active: active,
	        activeClassName: activeClassName,
	        icon: leftIcon,
	        avatar: leftAvatar
	      });
	
	      var rightNode = _react2.default.createElement(_TileAddon2.default, {
	        key: 'right-addon',
	        style: rightNodeStyle,
	        className: rightNodeClassName,
	        active: active,
	        activeClassName: activeClassName,
	        icon: rightIcon,
	        avatar: rightAvatar
	      });
	
	      var nestedList = void 0;
	      if (nestedItems) {
	        if (!cascadingMenu) {
	          nestedList = _react2.default.createElement(
	            _Collapse2.default,
	            { collapsed: !visible, animate: animateNestedItems },
	            _react2.default.createElement(
	              _List2.default,
	              { style: nestedListStyle, className: nestedListClassName },
	              nestedItems
	            )
	          );
	        }
	
	        var icon = _react2.default.Children.only((0, _getDeprecatedIcon2.default)(expanderIconClassName, expanderIconChildren, expanderIcon));
	        var collapser = _react2.default.createElement(_TileAddon2.default, {
	          key: 'expander-addon',
	          icon: _react2.default.cloneElement(icon, {
	            className: (0, _getCollapserStyles2.default)({ flipped: visible }, icon.props.className)
	          }),
	          avatar: null
	        });
	
	        if (expanderLeft) {
	          if (!leftIcon && !leftAvatar) {
	            leftNode = collapser;
	          }
	        } else if (!rightIcon && !rightAvatar) {
	          rightNode = collapser;
	        }
	      }
	
	      var icond = !!leftIcon || !!rightIcon || !!nestedItems;
	      var avatard = !!leftAvatar || !!rightAvatar;
	
	      var tile = _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, tileProps, passPropsToItem ? undefined : props, {
	          component: component,
	          __SUPER_SECRET_REF__: this._setTile,
	          key: 'tile',
	          onClick: this._handleClick,
	          onMouseOver: this._handleMouseOver,
	          onMouseLeave: this._handleMouseLeave,
	          onTouchStart: this._handleTouchStart,
	          onTouchEnd: this._handleTouchEnd,
	          onKeyDown: this._handleKeyDown,
	          onKeyUp: this._handleKeyUp,
	          disabled: disabled,
	          style: tileStyle,
	          className: (0, _classnames2.default)('md-list-tile', {
	            'md-list-tile--active': this.state.active && !this._touched,
	            'md-list-tile--icon': !secondaryText && icond && !avatard,
	            'md-list-tile--avatar': !secondaryText && avatard,
	            'md-list-tile--two-lines': secondaryText && !threeLines,
	            'md-list-tile--three-lines': secondaryText && threeLines,
	            'md-list-item--inset': inset && !leftIcon && !leftAvatar
	          }, (0, _themeColors2.default)({ disabled: disabled, text: true }), tileClassName),
	          'aria-expanded': nestedList && !cascadingMenu ? visible : null
	        }),
	        leftNode,
	        _react2.default.createElement(_ListItemText2.default, {
	          active: active,
	          activeClassName: activeClassName,
	          disabled: disabled,
	          primaryText: primaryText,
	          secondaryText: secondaryText,
	          threeLines: threeLines,
	          style: contentStyle,
	          className: (0, _classnames2.default)({
	            'md-tile-content--left-icon': leftIcon || expanderLeft && nestedItems,
	            'md-tile-content--left-avatar': leftAvatar,
	            'md-tile-content--right-padding': rightIcon || rightAvatar
	          }, contentClassName),
	          primaryTextStyle: primaryTextStyle,
	          primaryTextClassName: primaryTextClassName,
	          secondaryTextStyle: secondaryTextStyle,
	          secondaryTextClassName: secondaryTextClassName
	        }),
	        rightNode,
	        children
	      );
	
	      var sharedProps = _extends({}, itemProps, passPropsToItem ? props : undefined, {
	        style: Object.assign({}, style, active ? activeBoxStyle : null),
	        className: (0, _classnames2.default)('md-list-item', _defineProperty({
	          'md-list-item--nested-container': nestedItems
	        }, activeBoxClassName, activeBoxClassName && active), className),
	        'aria-setsize': ariaSize,
	        'aria-posinset': ariaPos,
	        ref: this._setContainer
	      });
	      if (cascadingMenu && nestedItems) {
	        return _react2.default.createElement(
	          _Menu2.default,
	          _extends({
	            id: cascadingId,
	            visible: visible,
	            onClose: this._handleClick,
	            toggle: tile,
	            block: true,
	            simplified: false,
	            anchor: cascadingAnchor,
	            belowAnchor: null,
	            position: _Menu2.default.Positions.BELOW,
	            component: ItemComponent,
	            listStyle: nestedListStyle,
	            listClassName: nestedListClassName,
	            listHeightRestricted: nestedListHeightRestricted
	          }, sharedProps, {
	            fixedTo: cascadingFixedTo
	          }),
	          nestedItems
	        );
	      }
	
	      return _react2.default.createElement(
	        ItemComponent,
	        sharedProps,
	        prependNested ? nestedList : null,
	        tile,
	        prependNested ? null : nestedList
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react.PureComponent);
	
	ListItem.propTypes = {
	  /**
	   * An optional style to apply to the `li` tag.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `li` tag.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `.md-list-tile`.
	   *
	   * @see {@link #component}
	   */
	  tileStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `.md-list-tile`.
	   *
	   * @see {@link #component}
	   */
	  tileClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div that surrounds the `primaryText` and `secondaryText`
	   * nodes.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div that surrounds the `primaryText` and `secondaryText`
	   * nodes.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element that is rendered before content node.
	   */
	  leftNodeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element that is rendered before content node.
	   */
	  leftNodeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element that is rendered after content node.
	   */
	  rightNodeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element that is rendered after content node.
	   */
	  rightNodeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div surrounding the `primaryText`.
	   */
	  primaryTextStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div surrounding the `primaryText`.
	   */
	  primaryTextClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div surrounding the `secondaryText`.
	   */
	  secondaryTextStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div surrounding the `secondaryText`.
	   */
	  secondaryTextClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the nested `List` that gets created when using `nestedItems`.
	   */
	  nestedListStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the nested `List` that gets created when using `nestedItems`.
	   */
	  nestedListClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the nested `List` in a cascading menu should be restricted.
	   */
	  nestedListHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Any additional children to display in the `.md-list-tile`. If you use this prop,
	   * you will most likely need to override the `height` for the `.md-list-tile--icon`,
	   * `.md-list-tile--avatar`, `.md-list-tile--two-lines`, and/or `.md-list-tile--three-lines`
	   * to get it to display correctly unless the children are positioned `absolute`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `ListItem` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional tab index for the `.md-list-tile`. If omitted, it will default to the
	   * `AccessibleFakeButton`'s `tabIndex` default prop value.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  /**
	   * The primary text to display. This will only be rendered as a single line. Any overflown
	   * text will be converted to ellipsis.
	   */
	  primaryText: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional secondary text to display below the `primaryText`. This can be an additional
	   * one or two lines. Like the `primaryText`, and overflown text will be converted to ellipsis.
	   *
	   * You must set the `threeLines` prop to `true` if you want this to be displayed as two lines.
	   */
	  secondaryText: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the left of the text.
	   */
	  leftIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the left of the text. If you have a mixed `List` of
	   * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
	   * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
	   */
	  leftAvatar: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the right of the text.
	   */
	  rightIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the right of the text. If you have a mixed `List` of
	   * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
	   * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
	   */
	  rightAvatar: _propTypes2.default.node,
	
	  /**
	   * Boolean if the list item should be inset as if there is a `leftIcon` or a `leftAvatar`.
	   * This is used for some lists where only a parent contains the icon.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `secondaryText` should span two lines instead of one. This will include
	   * three lines of text in total when including the `primaryText`.
	   */
	  threeLines: _propTypes2.default.bool,
	
	  /**
	   * The component to render the `.md-list-tile` as. This is mostly useful if you
	   * want to use the `ListItem` for navigation and working with the `react-router`'s `Link`
	   * component.
	   *
	   * This prop is **not** the top-most element of the `ListItem` component. To change the
	   * top-most element, see the `itemComponent` prop.
	   *
	   * @see {@link #itemComponent}
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The component to render the top-most element of the `ListItem` component. This is the
	   * `.md-list-item` and defaults to the `<li>` element.
	   *
	   * @see {@link #component}
	   * @see {@link #itemProps}
	   */
	  itemComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * An optional ref callback to get reference to the top-most element of the `ListItem` component.
	   * Just like other refs, this will provide null when it unmounts.
	   */
	  itemRef: _propTypes2.default.func,
	
	  /**
	   * An optional list of `ListItem`, `ListItemControl`, `Divider`, or `Subheader` components
	   * to render in a nested list. This will inject an expander icon to the right of the text
	   * in the `.md-list-tile` that rotates 180 degrees when open.
	   *
	   * The nested items will be visible once the user clicks on the `ListItem`.
	   *
	   * @see {@link #visible}
	   */
	  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.node),
	
	  /**
	   * An optional parameter determining whether `nestedItems` should be placed before or after `ListItemText`
	   */
	  prependNested: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `nestedItems` are visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `nestedItems` are visible. This will make the `nestedItems` controlled
	   * and require the `onClick` function to be defined.
	   *
	   * @see {@link #defaultVisible}
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onClick', 'defaultVisible'),
	
	  /**
	   * An icon to use for the expander icon when there are nested items.
	   */
	  expanderIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the expander icon should appear as the left icon instead of the right.
	   */
	  expanderLeft: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `.md-list-tile` is clicked. This is required if the
	   * `visible` prop is defined.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `mouseover` event.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `mouseleave` event.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `touchstart` event.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `touchend` event.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `keydown` event.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `keyup` event.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * Boolean if the `ListItem` is currently active. This will apply the `activeClassName` prop
	   * to the `leftIcon`, `rightIcon`, and the `primaryText`.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * The className to apply to the `leftIcon`, `rightIcon`, and `primaryText` when the `active`
	   * prop is `true`.
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the top-most element of the `ListItem` component (`.md-list-item`)
	   * when the `active` prop is `true`.
	   */
	  activeBoxStyle: _propTypes2.default.object,
	
	  /**
	   * The className to apply to the top-most element of the `ListItem` component (`.md-list-item`)
	   * when the `active` prop is `true`.
	   */
	  activeBoxClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the nested items should animate when they appear or disappear.
	   */
	  animateNestedItems: _propTypes2.default.bool,
	
	  /**
	   * Defines the number of items in the list. This is only required when all items in the
	   * list are not present in the DOM.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-setsize
	   */
	  'aria-setsize': _propTypes2.default.number,
	
	  /**
	   * Defines the items position in the list. This is only required when all items in the list
	   * are not present in the DOM. The custom validation just requires this prop if the `aria-setsize`
	   * prop is defined as a helpful reminder.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-posinset
	   */
	  'aria-posinset': function ariaPosinset(props, propName) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var validator = _propTypes2.default.number;
	    if (typeof props['aria-setsize'] !== 'undefined') {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName].concat(args));
	  },
	
	  /**
	   * Any additional props you would like to supply to the surrounding `<li>` tag for the `ListItem`.
	   * By default, all props will be provided to the inner `AccessibleFakeButton`. If the `passPropsToItem`
	   * prop is enabled, the remaining props will be provided to the `<li>` tag instead and this prop
	   * is probably useless.
	   */
	  itemProps: _propTypes2.default.object,
	
	  /**
	   * Any additional props you would like to add to the inner `AccessibleFakeButton`. By default, all the
	   * remaining props will be provided to the `AccessibleFakeButton`, so this prop is probably useless.
	   * Enabling the `passPropsToItem` prop will change the default behavior so that the remaining props
	   * are provided to the surrounding `<li>` node instead and this prop becomes useful.
	   */
	  tileProps: _propTypes2.default.object,
	
	  /**
	   * All the remaining props should be passed to the surrounding `<li>` node instead of the `AccessibleFakeButton`.
	   *
	   * > NOTE: This will most likely become the default in the next *major* release. Migration warnings will be added
	   * if that is the case.
	   */
	  passPropsToItem: _propTypes2.default.bool,
	  expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `expanderIcon` instead'),
	  expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `expanderIcon` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  defaultOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead')
	};
	ListItem.defaultProps = {
	  animateNestedItems: true,
	  activeClassName: 'md-text--theme-primary',
	  component: 'div',
	  itemComponent: 'li',
	  expanderIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_down'
	  )
	};
	ListItem.contextTypes = {
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingFixedTo: _fixedToShape2.default
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.focus = function () {
	    if (_this2._tile) {
	      _this2._tile.focus();
	    }
	  };
	
	  this.blur = function () {
	    if (_this2._tile) {
	      _this2._tile.blur();
	    }
	  };
	
	  this._setTile = function (tile) {
	    if (tile) {
	      _this2._tile = tile;
	      _this2._tileNode = (0, _reactDom.findDOMNode)(tile);
	    }
	  };
	
	  this._setContainer = function (container) {
	    var itemRef = _this2.props.itemRef;
	
	    if (container) {
	      _this2._container = (0, _reactDom.findDOMNode)(container);
	    }
	    if (itemRef) {
	      itemRef(container ? _this2._container : null);
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this2._container && !_this2._container.contains(e.target)) {
	      window.removeEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleClick = function (e) {
	    if (_this2.props.onClick) {
	      _this2.props.onClick(e);
	    }
	
	    if (typeof _this2.state.visible !== 'undefined') {
	      _this2.setState({ visible: !_this2.state.visible });
	    }
	  };
	
	  this._handleMouseOver = function (e) {
	    if (_this2.props.onMouseOver) {
	      _this2.props.onMouseOver(e);
	    }
	
	    if (!_this2.props.disabled) {
	      _this2.setState({ active: true });
	    }
	  };
	
	  this._handleMouseLeave = function (e) {
	    if (_this2.props.onMouseLeave) {
	      _this2.props.onMouseLeave(e);
	    }
	
	    if (!_this2.props.disabled) {
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleTouchStart = function (e) {
	    if (_this2.props.onTouchStart) {
	      _this2.props.onTouchStart(e);
	    }
	
	    _this2._touched = true;
	
	    _this2.setState({ active: true, touchedAt: Date.now() });
	  };
	
	  this._handleTouchEnd = function (e) {
	    if (_this2.props.onTouchEnd) {
	      _this2.props.onTouchEnd(e);
	    }
	
	    var time = Date.now() - _this2.state.touchedAt;
	    _this2._touchTimeout = setTimeout(function () {
	      _this2._touchTimeout = null;
	
	      _this2.setState({ active: false });
	    }, time > 450 ? 0 : 450 - time);
	  };
	
	  this._handleKeyUp = function (e) {
	    if (_this2.props.onKeyUp) {
	      _this2.props.onKeyUp(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.addEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: true });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    if (_this2.props.onKeyDown) {
	      _this2.props.onKeyDown(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.removeEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: false });
	    }
	  };
	};
	
	exports.default = ListItem;
	//# sourceMappingURL=ListItem.js.map

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getDisplayName = __webpack_require__(100);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _TooltipContainer = __webpack_require__(163);
	
	var _TooltipContainer2 = _interopRequireDefault(_TooltipContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Takes any component and injects a tooltip container as a prop. The tooltip container
	 * will add event listeners for touch, mouse, and keyboard events so that a tooltip will appear
	 * in the ComposedComponent.
	 *
	 * If the `tooltipLabel` prop is omitted, the tooltip and event listeners will not
	 * be included.
	 *
	 * ```js
	 * @param {function} ComposedComponent the component to compose with the tooltip functionality.
	 * @return {function} the ComposedComponent with a tooltip.
	 * ```
	 */
	exports.default = function (ComposedComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_PureComponent) {
	    _inherits(TooltipedComponent, _PureComponent);
	
	    function TooltipedComponent() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TooltipedComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltipedComponent.__proto__ || Object.getPrototypeOf(TooltipedComponent)).call.apply(_ref, [this].concat(args))), _this), _this._composed = null, _this.getComposedComponent = function () {
	        return _this._composed;
	      }, _this._setComposedComponent = function (component) {
	        _this._composed = component;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    /**
	     * Gets the composed component as a ref. This is useful if you need to access the ref of the
	     * composed component instead of the `injectTooltip` HOC to use some publicly accessible methods.
	     *
	     * ```js
	     * <SomeTooltippedComponent
	     *   ref={tooltipHOC => {
	     *     tooltipHOC.getComposedComponent().focus();
	     *   }}
	     * />
	     * ```
	     *
	     * > NOTE: This can be `null`, so make sure to do a null check before using.
	     */
	
	
	    _createClass(TooltipedComponent, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            tooltipLabel = _props.tooltipLabel,
	            tooltipDelay = _props.tooltipDelay,
	            tooltipPosition = _props.tooltipPosition,
	            tooltipStyle = _props.tooltipStyle,
	            tooltipClassName = _props.tooltipClassName,
	            tooltipContainerStyle = _props.tooltipContainerStyle,
	            tooltipContainerClassName = _props.tooltipContainerClassName,
	            tooltipTransitionEnterTimeout = _props.tooltipTransitionEnterTimeout,
	            tooltipTransitionLeaveTimeout = _props.tooltipTransitionLeaveTimeout,
	            props = _objectWithoutProperties(_props, ['tooltipLabel', 'tooltipDelay', 'tooltipPosition', 'tooltipStyle', 'tooltipClassName', 'tooltipContainerStyle', 'tooltipContainerClassName', 'tooltipTransitionEnterTimeout', 'tooltipTransitionLeaveTimeout']);
	
	        if (tooltipLabel) {
	          props.tooltip = _react2.default.createElement(_TooltipContainer2.default, {
	            key: 'tooltipContainer',
	            label: tooltipLabel,
	            delay: tooltipDelay,
	            position: tooltipPosition,
	            enterTimeout: tooltipTransitionEnterTimeout,
	            leaveTimeout: tooltipTransitionLeaveTimeout,
	            style: tooltipContainerStyle,
	            className: tooltipContainerClassName,
	            tooltipStyle: tooltipStyle,
	            tooltipClassName: tooltipClassName
	          });
	        }
	
	        props.ref = this._setComposedComponent;
	
	        return _react2.default.createElement(ComposedComponent, props);
	      }
	    }]);
	
	    return TooltipedComponent;
	  }(_react.PureComponent), _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'Tooltip'), _class.propTypes = {
	    /**
	     * An optional style to apply to the tooltip container.
	     */
	    tooltipContainerStyle: _propTypes2.default.object,
	
	    /**
	     * An optional className to apply to the tooltip container.
	     */
	    tooltipContainerClassName: _propTypes2.default.string,
	
	    /**
	     * An optional style to apply to the tooltip itself.
	     */
	    tooltipStyle: _propTypes2.default.object,
	
	    /**
	     * An optional className to the tooltip itself.
	     */
	    tooltipClassName: _propTypes2.default.string,
	
	    /**
	     * The tooltip to display. If omitted, the `tooltip` prop will not be injected.
	     */
	    tooltipLabel: _propTypes2.default.node,
	
	    /**
	     * The amount of delay before the tooltip will appear on hover, touch, or keyboard focus.
	     */
	    tooltipDelay: _TooltipContainer2.default.propTypes.delay,
	
	    /**
	     * The position that the tooltip should appear related to the composed component.
	     */
	    tooltipPosition: _TooltipContainer2.default.propTypes.position,
	
	    /**
	     * The transition time for the tooltip appearing.
	     */
	    tooltipTransitionEnterTimeout: _TooltipContainer2.default.propTypes.enterTimeout,
	
	    /**
	     * The transition time for the tooltip disappearing.
	     */
	    tooltipTransitionLeaveTimeout: _TooltipContainer2.default.propTypes.leaveTimeout
	  }, _temp2;
	};
	//# sourceMappingURL=injectTooltip.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleWindowClickListeners;
	/** @module utils/EventUtils/handleWindowClickListeners */
	var mobileSafari = void 0;
	
	/**
	 * Since mobile safari doesn't delegate click events to the window (it only does touch events),
	 * this utility function will hack a fix to allow the delegation by updaging the body's cursor
	 * to be a pointer.
	 *
	 * Hopefully this can be removed one day....
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile
	 * @param {function} cb - the callback function to use for a window click event.
	 * @param {boolean} enabled - boolean if the click event is enabled.
	 */
	function handleWindowClickListeners(cb) {
	  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (typeof mobileSafari === 'undefined' && typeof window !== 'undefined') {
	    var ua = window.navigator.userAgent;
	    var iOS = ua.match(/iP(ad|hone)/i);
	    var webkit = ua.match(/WebKit/i);
	    mobileSafari = iOS && webkit && !ua.match(/CriOS/i);
	
	    if (mobileSafari) {
	      document.body.style.cursor = 'pointer';
	    }
	  }
	
	  var listener = window[(enabled ? 'add' : 'remove') + 'EventListener'];
	  listener('click', cb);
	}
	//# sourceMappingURL=handleWindowClickListeners.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = oneRequiredForA11y;
	/** @module utils/PropTypes/oneRequiredForA11y */
	
	/**
	 * This validator checks that either the current prop is defined and valid or that one of the
	 * other given prop names are defined. If it fails it returns an error for a11y.
	 *
	 * @param {function} validator - The React PropTypes validator to use for the given prop.
	 * @param {String[]} otherPropNames - Any other prop names to validate against.
	 * @return {Error} an error or null
	 */
	function oneRequiredForA11y(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && !allPropNames.filter(function (pn) {
	      return typeof props[pn] !== 'undefined';
	    }).length) {
	      err = new Error('One of the following props are required to make ' + componentNameSafe + ' accessible ' + ('for users of assistive technologies such as screen readers. `' + allPropNames.join('`, `') + '`.'));
	    }
	
	    return err;
	  };
	}
	//# sourceMappingURL=oneRequiredForA11y.js.map

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getCollapserStyles;
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * A simple utility function to get the dynamic collapser styles.
	 */
	function getCollapserStyles(_ref) {
	  var _ref2;
	
	  var flipped = _ref.flipped,
	      suffix = _ref.suffix,
	      suffixFlipped = _ref.suffixFlipped;
	
	  for (var _len = arguments.length, classNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    classNames[_key - 1] = arguments[_key];
	  }
	
	  return _classnames2.default.apply(undefined, ['md-collapser', (_ref2 = {
	    'md-collapser--flipped': flipped && (!suffixFlipped || !suffix)
	  }, _defineProperty(_ref2, 'md-collapser--' + suffix, suffix), _defineProperty(_ref2, 'md-collapser--' + suffix + '-flipped', suffix && flipped && suffixFlipped), _ref2)].concat(classNames));
	}
	//# sourceMappingURL=getCollapserStyles.js.map

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValued;
	/** @module utils/isValied */
	
	/**
	 * A really simple utility function to check if an input's value is considered "valued".
	 *
	 * @param {string|number} v - the value to check
	 * @return {boolean} true if the value is a number or a non-empty string.
	 */
	function isValued(v) {
	  return v === 0 || !!v;
	}
	//# sourceMappingURL=isValued.js.map

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = omit;
	/** @module utils/omit */
	
	/**
	 * This should hopefully be very similar to lodash's omit function. It will
	 * take an object and return a new object without any of the given keys.
	 *
	 * @param {Object} obj - The object to omit keys from.
	 * @param {Array.<String>} keys - a list of keys to remove.
	 */
	function omit(obj, keys) {
	  if (!obj) {
	    return {};
	  } else if (!keys || !keys.length) {
	    return obj;
	  }
	
	  return Object.keys(obj).filter(function (key) {
	    return keys.indexOf(key) === -1;
	  }).reduce(function (newProps, key) {
	    newProps[key] = obj[key];
	
	    return newProps;
	  }, {});
	}
	//# sourceMappingURL=omit.js.map

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(123),
	    getRawTag = __webpack_require__(617),
	    objectToString = __webpack_require__(645);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(208);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(41);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(392);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sortBy2 = __webpack_require__(456);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _range2 = __webpack_require__(455);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _throttle2 = __webpack_require__(675);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(182);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(201);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Legend = __webpack_require__(397);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Cross = __webpack_require__(476);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _Sector = __webpack_require__(204);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Dot = __webpack_require__(107);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _CartesianAxis = __webpack_require__(469);
	
	var _CartesianAxis2 = _interopRequireDefault(_CartesianAxis);
	
	var _Brush = __webpack_require__(468);
	
	var _Brush2 = _interopRequireDefault(_Brush);
	
	var _DOMUtils = __webpack_require__(401);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(33);
	
	var _PolarUtils = __webpack_require__(56);
	
	var _PureRender = __webpack_require__(13);
	
	var _Events = __webpack_require__(746);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	
	var originCoordinate = { x: 0, y: 0 };
	
	var generateCategoricalChart = function generateCategoricalChart(_ref) {
	  var _class, _temp, _initialiseProps;
	
	  var chartName = _ref.chartName,
	      GraphicalChild = _ref.GraphicalChild,
	      _ref$eventType = _ref.eventType,
	      eventType = _ref$eventType === undefined ? 'axis' : _ref$eventType,
	      axisComponents = _ref.axisComponents,
	      legendContent = _ref.legendContent,
	      formatAxisMap = _ref.formatAxisMap,
	      defaultProps = _ref.defaultProps,
	      propTypes = _ref.propTypes;
	  var CategoricalChartWrapper = (_temp = _class = function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    function CategoricalChartWrapper(props) {
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      var _this = _possibleConstructorReturn(this, (CategoricalChartWrapper.__proto__ || Object.getPrototypeOf(CategoricalChartWrapper)).call(this, props));
	
	      _initialiseProps.call(_this);
	
	      var defaultState = _this.constructor.createDefaultState(props);
	      var updateId = 0;
	      _this.state = _extends({}, defaultState, { updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: props }, defaultState, { updateId: updateId })));
	
	      _this.uniqueChartId = (0, _isNil3.default)(props.id) ? (0, _DataUtils.uniqueId)('recharts') : props.id;
	
	      if (props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle3.default)(_this.triggeredAfterMouseMove, props.throttleDelay);
	      }
	      return _this;
	    }
	
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    /**
	     * Returns default, reset state for the categorical chart.
	     * @param {Object} props Props object to use when creating the default state
	     * @return {Object} Whole new state
	     */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.addListener();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            data = _props.data,
	            children = _props.children,
	            width = _props.width,
	            height = _props.height,
	            layout = _props.layout,
	            stackOffset = _props.stackOffset,
	            margin = _props.margin;
	        var updateId = this.state.updateId;
	
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _PureRender.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.constructor.createDefaultState(nextProps);
	          this.setState(_extends({}, defaultState, { updateId: updateId + 1
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, defaultState, { updateId: updateId + 1 }))));
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          // update configuration in chilren
	          var hasGlobalData = !(0, _isNil3.default)(nextProps.data);
	          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
	          var _state = this.state,
	              dataStartIndex = _state.dataStartIndex,
	              dataEndIndex = _state.dataEndIndex;
	          // Don't update brush
	
	          var _defaultState = _extends({}, this.constructor.createDefaultState(nextProps), { dataEndIndex: dataEndIndex, dataStartIndex: dataStartIndex
	          });
	
	          this.setState(_extends({}, _defaultState, {
	            updateId: newUpdateId
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({
	            props: nextProps
	          }, _defaultState, {
	            updateId: newUpdateId
	          }))));
	        }
	        // add syncId
	        if ((0, _isNil3.default)(this.props.syncId) && !(0, _isNil3.default)(nextProps.syncId)) {
	          this.addListener();
	        }
	        // remove syncId
	        if (!(0, _isNil3.default)(this.props.syncId) && (0, _isNil3.default)(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.removeListener();
	        }
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: 'getAxisMap',
	      value: function getAxisMap(props, _ref2) {
	        var _ref2$axisType = _ref2.axisType,
	            axisType = _ref2$axisType === undefined ? 'xAxis' : _ref2$axisType,
	            AxisComp = _ref2.AxisComp,
	            graphicalItems = _ref2.graphicalItems,
	            stackGroups = _ref2.stackGroups,
	            dataStartIndex = _ref2.dataStartIndex,
	            dataEndIndex = _ref2.dataEndIndex;
	        var children = props.children;
	
	        var axisIdKey = axisType + 'Id';
	        // Get all the instance of Axis
	        var axes = (0, _ReactUtils.findAllByType)(children, AxisComp);
	
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, { axes: axes, graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey,
	            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, {
	            Axis: AxisComp,
	            graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey, stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        }
	
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByAxes',
	      value: function getAxisMapByAxes(props, _ref3) {
	        var _this2 = this;
	
	        var axes = _ref3.axes,
	            graphicalItems = _ref3.graphicalItems,
	            axisType = _ref3.axisType,
	            axisIdKey = _ref3.axisIdKey,
	            stackGroups = _ref3.stackGroups,
	            dataStartIndex = _ref3.dataStartIndex,
	            dataEndIndex = _ref3.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            stackOffset = props.stackOffset;
	
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	
	        // Eliminate duplicated axes
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow,
	              allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
	              scale = _child$props.scale,
	              ticks = _child$props.ticks;
	
	          var axisId = child.props[axisIdKey];
	          var displayedData = _this2.constructor.getDisplayedData(props, {
	            graphicalItems: graphicalItems.filter(function (item) {
	              return item.props[axisIdKey] === axisId;
	            }),
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	          var len = displayedData.length;
	
	          if (!result[axisId]) {
	            var domain = void 0,
	                duplicateDomain = void 0,
	                categoricalDomain = void 0;
	
	            if (dataKey) {
	              domain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	
	                if (allowDuplicatedCategory && duplicate) {
	                  duplicateDomain = domain;
	                  // When category axis has duplicated text, serial numbers are used to generate scale
	                  domain = (0, _range3.default)(0, len);
	                } else if (!allowDuplicatedCategory) {
	                  // remove duplicated category
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                }
	              } else if (type === 'category') {
	                if (!allowDuplicatedCategory) {
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNil3.default)(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                } else {
	                  // eliminate undefined or null or empty string
	                  domain = domain.filter(function (entry) {
	                    return entry !== '' && !(0, _isNil3.default)(entry);
	                  });
	                }
	              } else if (type === 'number') {
	                var errorBarsDomain = (0, _ChartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function (item) {
	                  return item.props[axisIdKey] === axisId && !item.props.hide;
	                }), dataKey, axisType);
	
	                if (errorBarsDomain) {
	                  domain = errorBarsDomain;
	                }
	              }
	
	              if (isCategorial && (type === 'number' || scale !== 'auto')) {
	                categoricalDomain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), type, true);
	            }
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
	
	              if (child.props.domain) {
	                domain = (0, _ChartUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial,
	              layout: layout
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByItems',
	      value: function getAxisMapByItems(props, _ref4) {
	        var graphicalItems = _ref4.graphicalItems,
	            Axis = _ref4.Axis,
	            axisType = _ref4.axisType,
	            axisIdKey = _ref4.axisIdKey,
	            stackGroups = _ref4.stackGroups,
	            dataStartIndex = _ref4.dataStartIndex,
	            dataEndIndex = _ref4.dataEndIndex;
	        var layout = props.layout,
	            children = props.children;
	
	        var displayedData = this.constructor.getDisplayedData(props, {
	          graphicalItems: graphicalItems, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex
	        });
	        var len = displayedData.length;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	        var index = -1;
	
	        // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain = void 0;
	
	            if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _ChartUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial,
	              layout: layout
	              // specify scale when no Axis
	              // scale: isCategorial ? 'band' : 'linear',
	            })));
	          }
	
	          return result;
	        }, {});
	
	        return axisMap;
	      }
	    }, {
	      key: 'getActiveCoordinate',
	      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
	        var layout = this.props.layout;
	
	        var entry = tooltipTicks.find(function (tick) {
	          return tick && tick.index === activeIndex;
	        });
	
	        if (entry) {
	          if (layout === 'horizontal') {
	            return { x: entry.coordinate, y: rangeObj.y };
	          } else if (layout === 'vertical') {
	            return { x: rangeObj.x, y: entry.coordinate };
	          } else if (layout === 'centric') {
	            var _angle = entry.coordinate;
	            var _radius = rangeObj.radius;
	
	            return _extends({}, rangeObj, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle), {
	              angle: _angle, radius: _radius
	            });
	          }
	
	          var radius = entry.coordinate;
	          var angle = rangeObj.angle;
	
	          return _extends({}, rangeObj, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle), {
	            angle: angle, radius: radius
	          });
	        }
	
	        return originCoordinate;
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: 'getMouseInfo',
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var rangeObj = this.inRange(e.chartX, e.chartY);
	        if (!rangeObj) {
	          return null;
	        }
	
	        var _state2 = this.state,
	            xAxisMap = _state2.xAxisMap,
	            yAxisMap = _state2.yAxisMap;
	
	
	        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
	          var xScale = (0, _DataUtils.getAnyElementOfObject)(xAxisMap).scale;
	          var yScale = (0, _DataUtils.getAnyElementOfObject)(yAxisMap).scale;
	          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
	          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
	
	          return _extends({}, e, { xValue: xValue, yValue: yValue });
	        }
	
	        var _state3 = this.state,
	            ticks = _state3.orderedTooltipTicks,
	            axis = _state3.tooltipAxis,
	            tooltipTicks = _state3.tooltipTicks;
	
	        var pos = this.calculateTooltipPos(rangeObj);
	        var activeIndex = (0, _ChartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
	
	        if (activeIndex >= 0 && tooltipTicks) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex, activeLabel);
	          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeObj);
	
	          return _extends({}, e, {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel, activePayload: activePayload, activeCoordinate: activeCoordinate
	          });
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @param  {String} activeLabel    Active label of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: 'getTooltipContent',
	      value: function getTooltipContent(activeIndex, activeLabel) {
	        var _state4 = this.state,
	            graphicalItems = _state4.graphicalItems,
	            tooltipAxis = _state4.tooltipAxis;
	
	        var displayedData = this.constructor.getDisplayedData(this.props, this.state);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
	          return null;
	        }
	
	        // get data by activeIndex when the axis don't allow duplicated category
	        return graphicalItems.reduce(function (result, child) {
	          var hide = child.props.hide;
	
	
	          if (hide) {
	            return result;
	          }
	
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter,
	              data = _child$props2.data;
	
	          var payload = void 0;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            // graphic child has data props
	            payload = (0, _DataUtils.findEntryInArray)(data || displayedData, tooltipAxis.dataKey, activeLabel);
	          } else {
	            payload = displayedData[activeIndex];
	          }
	
	          if (!payload) {
	            return result;
	          }
	          return [].concat(_toConsumableArray(result), [_extends({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey, unit: unit, formatter: formatter,
	            name: name || dataKey,
	            color: (0, _ChartUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _ChartUtils.getValueByDataKey)(payload, dataKey),
	            payload: payload
	          })]);
	        }, []);
	      }
	    }, {
	      key: 'getFormatItems',
	      value: function getFormatItems(props, currentState) {
	        var _this3 = this;
	
	        var graphicalItems = currentState.graphicalItems,
	            stackGroups = currentState.stackGroups,
	            offset = currentState.offset,
	            updateId = currentState.updateId,
	            dataStartIndex = currentState.dataStartIndex,
	            dataEndIndex = currentState.dataEndIndex;
	        var barSize = props.barSize,
	            layout = props.layout,
	            barGap = props.barGap,
	            barCategoryGap = props.barCategoryGap,
	            globalMaxBarSize = props.maxBarSize;
	
	        var _getAxisNameByLayout = this.getAxisNameByLayout(layout),
	            numericAxisName = _getAxisNameByLayout.numericAxisName,
	            cateAxisName = _getAxisNameByLayout.cateAxisName;
	
	        var hasBar = this.constructor.hasBar(graphicalItems);
	        var sizeList = hasBar && (0, _ChartUtils.getBarSizeList)({ barSize: barSize, stackGroups: stackGroups });
	        var formatedItems = [];
	
	        graphicalItems.forEach(function (item, index) {
	          var displayedData = _this3.constructor.getDisplayedData(props, { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex }, item);
	          var _item$props = item.props,
	              dataKey = _item$props.dataKey,
	              childMaxBarSize = _item$props.maxBarSize;
	
	          var numericAxisId = item.props[numericAxisName + 'Id'];
	          var cateAxisId = item.props[cateAxisName + 'Id'];
	          var axisObj = axisComponents.reduce(function (result, entry) {
	            var _extends4;
	
	            var axisMap = currentState[entry.axisType + 'Map'];
	            var id = item.props[entry.axisType + 'Id'];
	            var axis = axisMap && axisMap[id];
	
	            return _extends({}, result, (_extends4 = {}, _defineProperty(_extends4, entry.axisType, axis), _defineProperty(_extends4, entry.axisType + 'Ticks', (0, _ChartUtils.getTicksOfAxis)(axis)), _extends4));
	          }, {});
	          var cateAxis = axisObj[cateAxisName];
	          var cateTicks = axisObj[cateAxisName + 'Ticks'];
	          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _ChartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	          var bandSize = (0, _ChartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	          var maxBarSize = (0, _isNil3.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	          var barPosition = hasBar && (0, _ChartUtils.getBarPosition)({
	            barGap: barGap, barCategoryGap: barCategoryGap, bandSize: bandSize, sizeList: sizeList[cateAxisId], maxBarSize: maxBarSize
	          });
	          var componsedFn = item && item.type && item.type.getComposedData;
	
	          if (componsedFn) {
	            var _extends5;
	
	            formatedItems.push({
	              props: _extends({}, componsedFn(_extends({}, axisObj, { displayedData: displayedData, props: props, dataKey: dataKey, item: item, bandSize: bandSize,
	                barPosition: barPosition, offset: offset, stackedData: stackedData, layout: layout, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex,
	                onItemMouseLeave: (0, _ChartUtils.combineEventHandlers)(_this3.handleItemMouseLeave, null, item.props.onMouseLeave),
	                onItemMouseEnter: (0, _ChartUtils.combineEventHandlers)(_this3.handleItemMouseEnter, null, item.props.onMouseEnter)
	              })), (_extends5 = {
	                key: item.key || 'item-' + index
	              }, _defineProperty(_extends5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_extends5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_extends5, 'animationId', updateId), _extends5)),
	              childIndex: (0, _ReactUtils.parseChildIndex)(item, props.children),
	              item: item
	            });
	          }
	        });
	
	        return formatedItems;
	      }
	    }, {
	      key: 'getCursorRectangle',
	      value: function getCursorRectangle() {
	        var layout = this.props.layout;
	        var _state5 = this.state,
	            activeCoordinate = _state5.activeCoordinate,
	            offset = _state5.offset,
	            tooltipAxisBandSize = _state5.tooltipAxisBandSize;
	
	        var halfSize = tooltipAxisBandSize / 2;
	
	        return {
	          stroke: 'none',
	          fill: '#ccc',
	          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
	          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
	          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
	          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
	        };
	      }
	    }, {
	      key: 'getCursorPoints',
	      value: function getCursorPoints() {
	        var layout = this.props.layout;
	        var _state6 = this.state,
	            activeCoordinate = _state6.activeCoordinate,
	            offset = _state6.offset;
	
	        var x1 = void 0,
	            y1 = void 0,
	            x2 = void 0,
	            y2 = void 0;
	
	        if (layout === 'horizontal') {
	          x1 = activeCoordinate.x;
	          x2 = x1;
	          y1 = offset.top;
	          y2 = offset.top + offset.height;
	        } else if (layout === 'vertical') {
	          y1 = activeCoordinate.y;
	          y2 = y1;
	          x1 = offset.left;
	          x2 = offset.left + offset.width;
	        } else if (!(0, _isNil3.default)(activeCoordinate.cx) || !(0, _isNil3.default)(activeCoordinate.cy)) {
	          if (layout === 'centric') {
	            var cx = activeCoordinate.cx,
	                cy = activeCoordinate.cy,
	                innerRadius = activeCoordinate.innerRadius,
	                outerRadius = activeCoordinate.outerRadius,
	                angle = activeCoordinate.angle;
	
	            var innerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
	            var outerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
	            x1 = innerPoint.x;
	            y1 = innerPoint.y;
	            x2 = outerPoint.x;
	            y2 = outerPoint.y;
	          } else {
	            var _cx = activeCoordinate.cx,
	                _cy = activeCoordinate.cy,
	                radius = activeCoordinate.radius,
	                startAngle = activeCoordinate.startAngle,
	                endAngle = activeCoordinate.endAngle;
	
	            var startPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, startAngle);
	            var endPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, endAngle);
	
	            return {
	              points: [startPoint, endPoint],
	              cx: _cx, cy: _cy, radius: radius, startAngle: startAngle, endAngle: endAngle
	            };
	          }
	        }
	
	        return [{ x: x1, y: y1 }, { x: x2, y: y2 }];
	      }
	    }, {
	      key: 'getAxisNameByLayout',
	      value: function getAxisNameByLayout(layout) {
	        if (layout === 'horizontal') {
	          return { numericAxisName: 'yAxis', cateAxisName: 'xAxis' };
	        } else if (layout === 'vertical') {
	          return { numericAxisName: 'xAxis', cateAxisName: 'yAxis' };
	        } else if (layout === 'centric') {
	          return { numericAxisName: 'radiusAxis', cateAxisName: 'angleAxis' };
	        }
	
	        return { numericAxisName: 'angleAxis', cateAxisName: 'radiusAxis' };
	      }
	    }, {
	      key: 'calculateTooltipPos',
	      value: function calculateTooltipPos(rangeObj) {
	        var layout = this.props.layout;
	
	
	        if (layout === 'horizontal') {
	          return rangeObj.x;
	        }
	        if (layout === 'vertical') {
	          return rangeObj.y;
	        }
	        if (layout === 'centric') {
	          return rangeObj.angle;
	        }
	
	        return rangeObj.radius;
	      }
	    }, {
	      key: 'inRange',
	      value: function inRange(x, y) {
	        var layout = this.props.layout;
	
	
	        if (layout === 'horizontal' || layout === 'vertical') {
	          var offset = this.state.offset;
	
	          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
	
	          return isInRange ? { x: x, y: y } : null;
	        }
	
	        var _state7 = this.state,
	            angleAxisMap = _state7.angleAxisMap,
	            radiusAxisMap = _state7.radiusAxisMap;
	
	
	        if (angleAxisMap && radiusAxisMap) {
	          var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	
	          return (0, _PolarUtils.inRangeOfSector)({ x: x, y: y }, angleAxis);
	        }
	
	        return null;
	      }
	    }, {
	      key: 'parseEventsOfWrapper',
	      value: function parseEventsOfWrapper() {
	        var children = this.props.children;
	
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchMove: this.handleTouchMove
	        } : {};
	        var outerEvents = (0, _ReactUtils.filterEventAttributes)(this.props, this.handleOuterEvent);
	
	        return _extends({}, outerEvents, tooltipEvents);
	      }
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props          The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @param {Number} updateId       The update id
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: 'updateStateOfAxisMapsOffsetAndStackGroups',
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref5) {
	        var _this4 = this;
	
	        var props = _ref5.props,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex,
	            updateId = _ref5.updateId;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({ props: props })) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset,
	            data = props.data,
	            reverseStackOrder = props.reverseStackOrder;
	
	        var _getAxisNameByLayout2 = this.getAxisNameByLayout(layout),
	            numericAxisName = _getAxisNameByLayout2.numericAxisName,
	            cateAxisName = _getAxisNameByLayout2.cateAxisName;
	
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _ChartUtils.getStackGroupsByAxisId)(data, graphicalItems, numericAxisName + 'Id', cateAxisName + 'Id', stackOffset, reverseStackOrder);
	        var axisObj = axisComponents.reduce(function (result, entry) {
	          var name = entry.axisType + 'Map';
	
	          return _extends({}, result, _defineProperty({}, name, _this4.getAxisMap(props, _extends({}, entry, {
	            graphicalItems: graphicalItems,
	            stackGroups: entry.axisType === numericAxisName && stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }))));
	        }, {});
	
	        var offset = this.calculateOffset(_extends({}, axisObj, { props: props, graphicalItems: graphicalItems }));
	
	        Object.keys(axisObj).forEach(function (key) {
	          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
	        });
	        var cateAxisMap = axisObj[cateAxisName + 'Map'];
	        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);
	
	        var formatedGraphicalItems = this.getFormatItems(props, _extends({}, axisObj, { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId,
	          graphicalItems: graphicalItems, stackGroups: stackGroups, offset: offset
	        }));
	
	        return _extends({
	          formatedGraphicalItems: formatedGraphicalItems, graphicalItems: graphicalItems, offset: offset, stackGroups: stackGroups
	        }, ticksObj, axisObj);
	      }
	
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: 'addListener',
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: 'removeListener',
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: 'calculateOffset',
	      value: function calculateOffset(_ref6) {
	        var props = _ref6.props,
	            graphicalItems = _ref6.graphicalItems,
	            _ref6$xAxisMap = _ref6.xAxisMap,
	            xAxisMap = _ref6$xAxisMap === undefined ? {} : _ref6$xAxisMap,
	            _ref6$yAxisMap = _ref6.yAxisMap,
	            yAxisMap = _ref6$yAxisMap === undefined ? {} : _ref6$yAxisMap;
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, { left: margin.left || 0, right: margin.right || 0 });
	
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, { top: margin.top || 0, bottom: margin.bottom || 0 });
	
	        var offset = _extends({}, offsetV, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush2.default.defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	
	          offset = (0, _ChartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _extends({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	      /**
	       * The handler of mouse entering chart
	       * @param  {Object} e              Event object
	       * @return {Null}                  null
	       */
	
	      /**
	       * The handler of mouse entering a scatter
	       * @param {Object} el     The active scatter
	       * @return {Object} no return
	       */
	
	      /**
	       * The handler of mouse leaving a scatter
	       * @return {Object} no return
	       */
	
	      /**
	       * The handler of mouse moving in chart
	       * @param  {Object} e        Event object
	       * @return {Null} no return
	       */
	
	      /**
	       * The handler if mouse leaving chart
	       * @param {Object} e Event object
	       * @return {Null} no return
	       */
	
	    }, {
	      key: 'triggerSyncEvent',
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	
	        if (!(0, _isNil3.default)(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: 'filterFormatItem',
	      value: function filterFormatItem(item, displayName, childIndex) {
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	
	
	        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
	          var entry = formatedGraphicalItems[i];
	
	          if (entry.item === item || entry.props.key === item.key || displayName === (0, _ReactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) {
	            return entry;
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: 'renderAxis',
	
	      /**
	       * Draw axis
	       * @param {Object} axisOptions The options of axis
	       * @param {Object} element      The axis element
	       * @param {String} displayName  The display name of axis
	       * @param {Number} index        The index of element
	       * @return {ReactElement}       The instance of x-axes
	       */
	      value: function renderAxis(axisOptions, element, displayName, index) {
	        var _props2 = this.props,
	            width = _props2.width,
	            height = _props2.height;
	
	
	        return _react2.default.createElement(_CartesianAxis2.default, _extends({}, axisOptions, {
	          className: 'recharts-' + axisOptions.axisType + ' ' + axisOptions.axisType,
	          key: element.key || displayName + '-' + index,
	          viewBox: { x: 0, y: 0, width: width, height: height },
	          ticksGenerator: this.axesTicksGenerator
	        }));
	      }
	      /**
	       * Draw grid
	       * @param  {ReactElement} element the grid item
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: 'renderLegend',
	
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	      value: function renderLegend() {
	        var _this5 = this;
	
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	        var _props3 = this.props,
	            children = _props3.children,
	            width = _props3.width,
	            height = _props3.height;
	
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _ChartUtils.getLegendProps)({
	          children: children, formatedGraphicalItems: formatedGraphicalItems, legendWidth: legendWidth, legendHeight: legendHeight, legendContent: legendContent
	        });
	
	        if (!props) {
	          return null;
	        }
	
	        var item = props.item,
	            otherProps = _objectWithoutProperties(props, ['item']);
	
	        return (0, _react.cloneElement)(item, _extends({}, otherProps, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this5.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: 'renderTooltip',
	      value: function renderTooltip() {
	        var children = this.props.children;
	
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _state8 = this.state,
	            isTooltipActive = _state8.isTooltipActive,
	            activeCoordinate = _state8.activeCoordinate,
	            activePayload = _state8.activePayload,
	            activeLabel = _state8.activeLabel,
	            offset = _state8.offset;
	
	
	        return (0, _react.cloneElement)(tooltipItem, {
	          viewBox: _extends({}, offset, { x: offset.left, y: offset.top }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: 'renderActiveDot',
	      value: function renderActiveDot(option, props) {
	        var dot = void 0;
	
	        if ((0, _react.isValidElement)(option)) {
	          dot = (0, _react.cloneElement)(option, props);
	        } else if ((0, _isFunction3.default)(option)) {
	          dot = option(props);
	        } else {
	          dot = _react2.default.createElement(_Dot2.default, props);
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-active-dot', key: props.key },
	          dot
	        );
	      }
	    }, {
	      key: 'renderActivePoints',
	      value: function renderActivePoints(_ref7) {
	        var item = _ref7.item,
	            activePoint = _ref7.activePoint,
	            basePoint = _ref7.basePoint,
	            childIndex = _ref7.childIndex,
	            isRange = _ref7.isRange;
	
	        var result = [];
	        var key = item.props.key;
	        var _item$item$props = item.item.props,
	            activeDot = _item$item$props.activeDot,
	            dataKey = _item$item$props.dataKey;
	
	        var dotProps = _extends({
	          index: childIndex,
	          dataKey: dataKey,
	          cx: activePoint.x,
	          cy: activePoint.y,
	          r: 4,
	          fill: (0, _ChartUtils.getMainColorOfGraphicItem)(item.item),
	          strokeWidth: 2,
	          stroke: '#fff',
	          payload: activePoint.payload,
	          value: activePoint.value,
	          key: key + '-activePoint-' + childIndex
	        }, (0, _ReactUtils.getPresentationAttributes)(activeDot), (0, _ReactUtils.filterEventAttributes)(activeDot));
	
	        result.push(this.renderActiveDot(activeDot, dotProps, childIndex));
	
	        if (basePoint) {
	          result.push(this.renderActiveDot(activeDot, _extends({}, dotProps, {
	            cx: basePoint.x,
	            cy: basePoint.y,
	            key: key + '-basePoint-' + childIndex
	          }), childIndex));
	        } else if (isRange) {
	          result.push(null);
	        }
	
	        return result;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this6 = this;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	          return null;
	        }
	
	        var _props4 = this.props,
	            children = _props4.children,
	            className = _props4.className,
	            width = _props4.width,
	            height = _props4.height,
	            style = _props4.style,
	            compact = _props4.compact,
	            others = _objectWithoutProperties(_props4, ['children', 'className', 'width', 'height', 'style', 'compact']);
	
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	        var map = {
	          CartesianGrid: { handler: this.renderGrid, once: true },
	          ReferenceArea: { handler: this.renderReferenceElement },
	          ReferenceLine: { handler: this.renderReferenceElement },
	          ReferenceDot: { handler: this.renderReferenceElement },
	          XAxis: { handler: this.renderXAxis },
	          YAxis: { handler: this.renderYAxis },
	          Brush: { handler: this.renderBrush, once: true },
	          Bar: { handler: this.renderGraphicChild },
	          Line: { handler: this.renderGraphicChild },
	          Area: { handler: this.renderGraphicChild },
	          Radar: { handler: this.renderGraphicChild },
	          RadialBar: { handler: this.renderGraphicChild },
	          Scatter: { handler: this.renderGraphicChild },
	          Pie: { handler: this.renderGraphicChild },
	          Tooltip: { handler: this.renderCursor, once: true },
	          PolarGrid: { handler: this.renderPolarGrid, once: true },
	          PolarAngleAxis: { handler: this.renderPolarAxis },
	          PolarRadiusAxis: { handler: this.renderPolarAxis }
	        };
	
	        // The "compact" mode is mainly used as the panorama within Brush
	        if (compact) {
	          return _react2.default.createElement(
	            _Surface2.default,
	            _extends({}, attrs, { width: width, height: height }),
	            (0, _ReactUtils.renderByOrder)(children, map)
	          );
	        }
	
	        var events = this.parseEventsOfWrapper();
	        return _react2.default.createElement(
	          'div',
	          _extends({
	            className: (0, _classnames2.default)('recharts-wrapper', className),
	            style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	          }, events, {
	            ref: function ref(node) {
	              _this6.container = node;
	            }
	          }),
	          _react2.default.createElement(
	            _Surface2.default,
	            _extends({}, attrs, { width: width, height: height }),
	            (0, _ReactUtils.renderByOrder)(children, map)
	          ),
	          this.renderLegend(),
	          this.renderTooltip()
	        );
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component), _class.displayName = chartName, _class.propTypes = _extends({
	    syncId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    compact: _propTypes2.default.bool,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	    stackOffset: _propTypes2.default.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _propTypes2.default.number,
	    margin: _propTypes2.default.shape({
	      top: _propTypes2.default.number,
	      right: _propTypes2.default.number,
	      bottom: _propTypes2.default.number,
	      left: _propTypes2.default.number
	    }),
	    barCategoryGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    barGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    barSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    maxBarSize: _propTypes2.default.number,
	    style: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    onClick: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseEnter: _propTypes2.default.func,
	    onMouseMove: _propTypes2.default.func,
	    onMouseDown: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func,
	    reverseStackOrder: _propTypes2.default.bool,
	    id: _propTypes2.default.string
	  }, propTypes), _class.defaultProps = _extends({
	    layout: 'horizontal',
	    stackOffset: 'none',
	    barCategoryGap: '10%',
	    barGap: 4,
	    margin: { top: 5, right: 5, bottom: 5, left: 5 },
	    reverseStackOrder: false
	  }, defaultProps), _class.createDefaultState = function (props) {
	    var children = props.children;
	
	    var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	    return {
	      chartX: 0,
	      chartY: 0,
	      dataStartIndex: startIndex,
	      dataEndIndex: endIndex,
	      activeTooltipIndex: -1,
	      isTooltipActive: false
	    };
	  }, _class.hasBar = function (graphicalItems) {
	    if (!graphicalItems || !graphicalItems.length) {
	      return false;
	    }
	
	    return graphicalItems.some(function (item) {
	      var name = (0, _ReactUtils.getDisplayName)(item && item.type);
	
	      return name && name.indexOf('Bar') >= 0;
	    });
	  }, _class.getDisplayedData = function (props, _ref8, item) {
	    var graphicalItems = _ref8.graphicalItems,
	        dataStartIndex = _ref8.dataStartIndex,
	        dataEndIndex = _ref8.dataEndIndex;
	
	    var itemsData = (graphicalItems || []).reduce(function (result, child) {
	      var itemData = child.props.data;
	
	      if (itemData && itemData.length) {
	        return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
	      }
	
	      return result;
	    }, []);
	    if (itemsData && itemsData.length > 0) {
	      return itemsData;
	    }
	
	    if (item && item.props && item.props.data && item.props.data.length > 0) {
	      return item.props.data;
	    }
	
	    var data = props.data;
	
	
	    if (data && data.length && (0, _DataUtils.isNumber)(dataStartIndex) && (0, _DataUtils.isNumber)(dataEndIndex)) {
	      return data.slice(dataStartIndex, dataEndIndex + 1);
	    }
	
	    return [];
	  }, _initialiseProps = function _initialiseProps() {
	    var _this7 = this;
	
	    this.handleLegendBBoxUpdate = function (box) {
	      if (box && _this7.legendInstance) {
	        var _state9 = _this7.state,
	            dataStartIndex = _state9.dataStartIndex,
	            dataEndIndex = _state9.dataEndIndex,
	            updateId = _state9.updateId;
	
	
	        _this7.setState(_this7.updateStateOfAxisMapsOffsetAndStackGroups({
	          props: _this7.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId
	        }));
	      }
	    };
	
	    this.handleReceiveSyncEvent = function (cId, chartId, data) {
	      var _props5 = _this7.props,
	          syncId = _props5.syncId,
	          layout = _props5.layout;
	      var updateId = _this7.state.updateId;
	
	
	      if (syncId === cId && chartId !== _this7.uniqueChartId) {
	        var dataStartIndex = data.dataStartIndex,
	            dataEndIndex = data.dataEndIndex;
	
	
	        if (!(0, _isNil3.default)(data.dataStartIndex) || !(0, _isNil3.default)(data.dataEndIndex)) {
	          _this7.setState(_extends({
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }, _this7.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this7.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId })));
	        } else if (!(0, _isNil3.default)(data.activeTooltipIndex)) {
	          var chartX = data.chartX,
	              chartY = data.chartY,
	              activeTooltipIndex = data.activeTooltipIndex;
	          var _state10 = _this7.state,
	              offset = _state10.offset,
	              tooltipTicks = _state10.tooltipTicks;
	
	          if (!offset) {
	            return;
	          }
	          var viewBox = _extends({}, offset, { x: offset.left, y: offset.top });
	          // When a categotical chart is combined with another chart, the value of chartX
	          // and chartY may beyond the boundaries.
	          var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	          var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	          var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	          var activePayload = _this7.getTooltipContent(activeTooltipIndex);
	          var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	            x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	            y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	          } : originCoordinate;
	
	          _this7.setState(_extends({}, data, { activeLabel: activeLabel, activeCoordinate: activeCoordinate, activePayload: activePayload }));
	        } else {
	          _this7.setState(data);
	        }
	      }
	    };
	
	    this.handleBrushChange = function (_ref9) {
	      var startIndex = _ref9.startIndex,
	          endIndex = _ref9.endIndex;
	
	      // Only trigger changes if the extents of the brush have actually changed
	      if (startIndex !== _this7.state.dataStartIndex || endIndex !== _this7.state.dataEndIndex) {
	        var updateId = _this7.state.updateId;
	
	
	        _this7.setState(function () {
	          return _extends({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          }, _this7.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this7.props, dataStartIndex: startIndex, dataEndIndex: endIndex, updateId: updateId }));
	        });
	
	        _this7.triggerSyncEvent({
	          dataStartIndex: startIndex,
	          dataEndIndex: endIndex
	        });
	      }
	    };
	
	    this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this7.props.onMouseEnter;
	
	      var mouse = _this7.getMouseInfo(e);
	
	      if (mouse) {
	        var nextState = _extends({}, mouse, { isTooltipActive: true });
	        _this7.setState(nextState);
	        _this7.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction3.default)(onMouseEnter)) {
	          onMouseEnter(nextState, e);
	        }
	      }
	    };
	
	    this.triggeredAfterMouseMove = function (e) {
	      var onMouseMove = _this7.props.onMouseMove;
	
	      var mouse = _this7.getMouseInfo(e);
	      var nextState = mouse ? _extends({}, mouse, { isTooltipActive: true }) : { isTooltipActive: false };
	
	      _this7.setState(nextState);
	      _this7.triggerSyncEvent(nextState);
	
	      if ((0, _isFunction3.default)(onMouseMove)) {
	        onMouseMove(nextState, e);
	      }
	    };
	
	    this.handleItemMouseEnter = function (el) {
	      _this7.setState(function () {
	        return {
	          isTooltipActive: true,
	          activeItem: el,
	          activePayload: el.tooltipPayload,
	          activeCoordinate: el.tooltipPosition || { x: el.cx, y: el.cy }
	        };
	      });
	    };
	
	    this.handleItemMouseLeave = function () {
	      _this7.setState(function () {
	        return {
	          isTooltipActive: false
	        };
	      });
	    };
	
	    this.handleMouseMove = function (e) {
	      if (e && (0, _isFunction3.default)(e.persist)) {
	        e.persist();
	      }
	      _this7.triggeredAfterMouseMove(e);
	    };
	
	    this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this7.props.onMouseLeave;
	
	      var nextState = { isTooltipActive: false };
	
	      _this7.setState(nextState);
	      _this7.triggerSyncEvent(nextState);
	
	      if ((0, _isFunction3.default)(onMouseLeave)) {
	        onMouseLeave(nextState, e);
	      }
	    };
	
	    this.handleOuterEvent = function (e) {
	      var eventName = (0, _ReactUtils.getReactEventByType)(e);
	
	      if (eventName && (0, _isFunction3.default)(_this7.props[eventName])) {
	        var mouse = _this7.getMouseInfo(e);
	        var handler = _this7.props[eventName];
	
	        handler(mouse, e);
	      }
	    };
	
	    this.handleClick = function (e) {
	      var onClick = _this7.props.onClick;
	
	
	      if ((0, _isFunction3.default)(onClick)) {
	        var mouse = _this7.getMouseInfo(e);
	
	        onClick(mouse, e);
	      }
	    };
	
	    this.handleMouseDown = function (e) {
	      var onMouseDown = _this7.props.onMouseDown;
	
	
	      if ((0, _isFunction3.default)(onMouseDown)) {
	        var mouse = _this7.getMouseInfo(e);
	
	        onMouseDown(mouse, e);
	      }
	    };
	
	    this.handleMouseUp = function (e) {
	      var onMouseUp = _this7.props.onMouseUp;
	
	
	      if ((0, _isFunction3.default)(onMouseUp)) {
	        var mouse = _this7.getMouseInfo(e);
	
	        onMouseUp(mouse, e);
	      }
	    };
	
	    this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this7.handleMouseMove(e.changedTouches[0]);
	      }
	    };
	
	    this.verticalCoordinatesGenerator = function (_ref10) {
	      var xAxis = _ref10.xAxis,
	          width = _ref10.width,
	          height = _ref10.height,
	          offset = _ref10.offset;
	      return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, xAxis, {
	        ticks: (0, _ChartUtils.getTicksOfAxis)(xAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.left, offset.left + offset.width);
	    };
	
	    this.horizontalCoordinatesGenerator = function (_ref11) {
	      var yAxis = _ref11.yAxis,
	          width = _ref11.width,
	          height = _ref11.height,
	          offset = _ref11.offset;
	      return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, yAxis, {
	        ticks: (0, _ChartUtils.getTicksOfAxis)(yAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.top, offset.top + offset.height);
	    };
	
	    this.axesTicksGenerator = function (axis) {
	      return (0, _ChartUtils.getTicksOfAxis)(axis, true);
	    };
	
	    this.tooltipTicksGenerator = function (axisMap) {
	      var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	      var tooltipTicks = (0, _ChartUtils.getTicksOfAxis)(axis, false, true);
	
	      return {
	        tooltipTicks: tooltipTicks,
	        orderedTooltipTicks: (0, _sortBy3.default)(tooltipTicks, function (o) {
	          return o.coordinate;
	        }),
	        tooltipAxis: axis,
	        tooltipAxisBandSize: (0, _ChartUtils.getBandSizeOfAxis)(axis)
	      };
	    };
	
	    this.renderCursor = function (element) {
	      var _state11 = _this7.state,
	          isTooltipActive = _state11.isTooltipActive,
	          activeCoordinate = _state11.activeCoordinate,
	          activePayload = _state11.activePayload,
	          offset = _state11.offset;
	
	
	      if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
	        return null;
	      }
	      var layout = _this7.props.layout;
	
	      var restProps = void 0;
	      var cursorComp = _Curve2.default;
	
	      if (chartName === 'ScatterChart') {
	        restProps = activeCoordinate;
	        cursorComp = _Cross2.default;
	      } else if (chartName === 'BarChart') {
	        restProps = _this7.getCursorRectangle();
	        cursorComp = _Rectangle2.default;
	      } else if (layout === 'radial') {
	        var _getCursorPoints = _this7.getCursorPoints(),
	            cx = _getCursorPoints.cx,
	            cy = _getCursorPoints.cy,
	            radius = _getCursorPoints.radius,
	            startAngle = _getCursorPoints.startAngle,
	            endAngle = _getCursorPoints.endAngle;
	
	        restProps = {
	          cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle, innerRadius: radius, outerRadius: radius
	        };
	        cursorComp = _Sector2.default;
	      } else {
	        restProps = { points: _this7.getCursorPoints() };
	        cursorComp = _Curve2.default;
	      }
	      var key = element.key || '_recharts-cursor';
	      var cursorProps = _extends({
	        stroke: '#ccc'
	      }, offset, restProps, (0, _ReactUtils.getPresentationAttributes)(element.props.cursor), {
	        payload: activePayload,
	        key: key,
	        className: 'recharts-tooltip-cursor'
	      });
	
	      return (0, _react.isValidElement)(element.props.cursor) ? (0, _react.cloneElement)(element.props.cursor, cursorProps) : (0, _react.createElement)(cursorComp, cursorProps);
	    };
	
	    this.renderPolarAxis = function (element, displayName, index) {
	      var axisType = element.type.axisType;
	      var axisMap = _this7.state[axisType + 'Map'];
	      var axisOption = axisMap[element.props[axisType + 'Id']];
	
	      return (0, _react.cloneElement)(element, _extends({}, axisOption, {
	        className: axisType,
	        key: element.key || displayName + '-' + index,
	        ticks: (0, _ChartUtils.getTicksOfAxis)(axisOption, true)
	      }));
	    };
	
	    this.renderXAxis = function (element, displayName, index) {
	      var xAxisMap = _this7.state.xAxisMap;
	
	      var axisObj = xAxisMap[element.props.xAxisId];
	
	      return _this7.renderAxis(axisObj, element, displayName, index);
	    };
	
	    this.renderYAxis = function (element, displayName, index) {
	      var yAxisMap = _this7.state.yAxisMap;
	
	      var axisObj = yAxisMap[element.props.yAxisId];
	
	      return _this7.renderAxis(axisObj, element, displayName, index);
	    };
	
	    this.renderGrid = function (element) {
	      var _state12 = _this7.state,
	          xAxisMap = _state12.xAxisMap,
	          yAxisMap = _state12.yAxisMap,
	          offset = _state12.offset;
	      var _props6 = _this7.props,
	          width = _props6.width,
	          height = _props6.height;
	
	      var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	      var yAxis = (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	      var props = element.props || {};
	
	      return (0, _react.cloneElement)(element, {
	        key: element.key || 'grid',
	        x: (0, _DataUtils.isNumber)(props.x) ? props.x : offset.left,
	        y: (0, _DataUtils.isNumber)(props.y) ? props.y : offset.top,
	        width: (0, _DataUtils.isNumber)(props.width) ? props.width : offset.width,
	        height: (0, _DataUtils.isNumber)(props.height) ? props.height : offset.height,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        offset: offset,
	        chartWidth: width,
	        chartHeight: height,
	        verticalCoordinatesGenerator: _this7.verticalCoordinatesGenerator,
	        horizontalCoordinatesGenerator: _this7.horizontalCoordinatesGenerator
	      });
	    };
	
	    this.renderPolarGrid = function (element) {
	      var _state13 = _this7.state,
	          radiusAxisMap = _state13.radiusAxisMap,
	          angleAxisMap = _state13.angleAxisMap;
	
	      var radiusAxis = (0, _DataUtils.getAnyElementOfObject)(radiusAxisMap);
	      var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	      var cx = angleAxis.cx,
	          cy = angleAxis.cy,
	          innerRadius = angleAxis.innerRadius,
	          outerRadius = angleAxis.outerRadius;
	
	
	      return (0, _react.cloneElement)(element, {
	        polarAngles: (0, _ChartUtils.getTicksOfAxis)(angleAxis, true).map(function (entry) {
	          return entry.coordinate;
	        }),
	        polarRadius: (0, _ChartUtils.getTicksOfAxis)(radiusAxis, true).map(function (entry) {
	          return entry.coordinate;
	        }),
	        cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	        key: element.key || 'polar-grid'
	      });
	    };
	
	    this.renderBrush = function (element) {
	      var _props7 = _this7.props,
	          margin = _props7.margin,
	          data = _props7.data;
	      var _state14 = _this7.state,
	          offset = _state14.offset,
	          dataStartIndex = _state14.dataStartIndex,
	          dataEndIndex = _state14.dataEndIndex,
	          updateId = _state14.updateId;
	
	      // TODO: update brush when children update
	
	      return (0, _react.cloneElement)(element, {
	        key: element.key || '_recharts-brush',
	        onChange: (0, _ChartUtils.combineEventHandlers)(_this7.handleBrushChange, null, element.props.onChange),
	        data: data,
	        x: (0, _DataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
	        y: (0, _DataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	        width: (0, _DataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
	        startIndex: dataStartIndex,
	        endIndex: dataEndIndex,
	        updateId: 'brush-' + updateId
	      });
	    };
	
	    this.renderReferenceElement = function (element, displayName, index) {
	      if (!element) {
	        return null;
	      }
	      var _state15 = _this7.state,
	          xAxisMap = _state15.xAxisMap,
	          yAxisMap = _state15.yAxisMap,
	          offset = _state15.offset;
	      var _element$props = element.props,
	          xAxisId = _element$props.xAxisId,
	          yAxisId = _element$props.yAxisId;
	
	
	      return (0, _react.cloneElement)(element, {
	        key: element.key || displayName + '-' + index,
	        xAxis: xAxisMap[xAxisId],
	        yAxis: yAxisMap[yAxisId],
	        viewBox: {
	          x: offset.left,
	          y: offset.top,
	          width: offset.width,
	          height: offset.height
	        }
	      });
	    };
	
	    this.renderGraphicChild = function (element, displayName, index) {
	      var item = _this7.filterFormatItem(element, displayName, index);
	      if (!item) {
	        return null;
	      }
	
	      var graphicalItem = (0, _react.cloneElement)(element, item.props);
	      var _state16 = _this7.state,
	          isTooltipActive = _state16.isTooltipActive,
	          tooltipAxis = _state16.tooltipAxis,
	          activeTooltipIndex = _state16.activeTooltipIndex,
	          activeLabel = _state16.activeLabel;
	      var children = _this7.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      var _item$props2 = item.props,
	          points = _item$props2.points,
	          isRange = _item$props2.isRange,
	          baseLine = _item$props2.baseLine;
	      var _item$item$props2 = item.item.props,
	          activeDot = _item$item$props2.activeDot,
	          hide = _item$item$props2.hide;
	
	      var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
	
	      if (hasActive) {
	        var activePoint = void 0,
	            basePoint = void 0;
	
	        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	          activePoint = (0, _DataUtils.findEntryInArray)(points, 'payload.' + tooltipAxis.dataKey, activeLabel);
	          basePoint = isRange && baseLine && (0, _DataUtils.findEntryInArray)(baseLine, 'payload.' + tooltipAxis.dataKey, activeLabel);
	        } else {
	          activePoint = points[activeTooltipIndex];
	          basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
	        }
	
	        if (!(0, _isNil3.default)(activePoint)) {
	          return [graphicalItem].concat(_toConsumableArray(_this7.renderActivePoints({
	            item: item, activePoint: activePoint, basePoint: basePoint, childIndex: activeTooltipIndex,
	            isRange: isRange
	          })));
	        }
	      }
	
	      if (isRange) {
	        return [graphicalItem, null, null];
	      }
	
	      return [graphicalItem, null];
	    };
	  }, _temp);
	
	
	  return CategoricalChartWrapper;
	};
	
	exports.default = generateCategoricalChart;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isObject2 = __webpack_require__(61);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Text = __webpack_require__(106);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _DataUtils = __webpack_require__(19);
	
	var _PolarUtils = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var cartesianViewBoxShape = _propTypes2.default.shape({
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	});
	var polarViewBoxShape = _propTypes2.default.shape({
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number
	});
	
	var propTypes = {
	  viewBox: _propTypes2.default.oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
	  formatter: _propTypes2.default.func,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.number,
	  position: _propTypes2.default.oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center']),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func])
	};
	
	var defaultProps = {
	  offset: 5
	};
	
	var getLabel = function getLabel(props) {
	  var value = props.value,
	      formatter = props.formatter;
	
	  var label = (0, _isNil3.default)(props.children) ? value : props.children;
	
	  if ((0, _isFunction3.default)(formatter)) {
	    return formatter(label);
	  }
	
	  return label;
	};
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	  return sign * deltaAngle;
	};
	
	var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
	  var position = labelProps.position,
	      viewBox = labelProps.viewBox,
	      offset = labelProps.offset,
	      className = labelProps.className;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle,
	      clockWise = viewBox.clockWise;
	
	  var radius = (innerRadius + outerRadius) / 2;
	  var deltaAngle = getDeltaAngle(startAngle, endAngle);
	  var sign = deltaAngle >= 0 ? 1 : -1;
	  var labelAngle = void 0,
	      direction = void 0;
	
	  if (position === 'insideStart') {
	    labelAngle = startAngle + sign * offset;
	    direction = clockWise;
	  } else if (position === 'insideEnd') {
	    labelAngle = endAngle - sign * offset;
	    direction = !clockWise;
	  } else if (position === 'end') {
	    labelAngle = endAngle + sign * offset;
	    direction = clockWise;
	  }
	
	  direction = deltaAngle <= 0 ? direction : !direction;
	
	  var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
	  var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
	  var path = 'M' + startPoint.x + ',' + startPoint.y + '\n    A' + radius + ',' + radius + ',0,1,' + (direction ? 0 : 1) + ',\n    ' + endPoint.x + ',' + endPoint.y;
	  var id = (0, _isNil3.default)(labelProps.id) ? (0, _DataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
	
	  return _react2.default.createElement(
	    'text',
	    _extends({}, attrs, {
	      dominantBaseline: 'central',
	      className: (0, _classnames2.default)('recharts-radial-bar-label', className)
	    }),
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', { id: id, d: path })
	    ),
	    _react2.default.createElement(
	      'textPath',
	      { xlinkHref: '#' + id },
	      label
	    )
	  );
	};
	
	var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle;
	
	  var midAngle = (startAngle + endAngle) / 2;
	
	  if (position === 'outside') {
	    var _polarToCartesian = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle),
	        _x = _polarToCartesian.x,
	        _y = _polarToCartesian.y;
	
	    return {
	      x: _x,
	      y: _y,
	      textAnchor: _x >= cx ? 'start' : 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'center') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  var r = (innerRadius + outerRadius) / 2;
	
	  var _polarToCartesian2 = (0, _PolarUtils.polarToCartesian)(cx, cy, r, midAngle),
	      x = _polarToCartesian2.x,
	      y = _polarToCartesian2.y;
	
	  return {
	    x: x,
	    y: y,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var x = viewBox.x,
	      y = viewBox.y,
	      width = viewBox.width,
	      height = viewBox.height;
	
	  var sign = height >= 0 ? 1 : -1;
	
	  if (position === 'top') {
	    return {
	      x: x + width / 2,
	      y: y - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'bottom') {
	    return {
	      x: x + width / 2,
	      y: y + height + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'left') {
	    return {
	      x: x - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'right') {
	    return {
	      x: x + width + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideLeft') {
	    return {
	      x: x + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideRight') {
	    return {
	      x: x + width - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideTop') {
	    return {
	      x: x + width / 2,
	      y: y + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottom') {
	    return {
	      x: x + width / 2,
	      y: y + height - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideTopLeft') {
	    return {
	      x: x + offset,
	      y: y + sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideTopRight') {
	    return {
	      x: x + width - offset,
	      y: y + sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottomLeft') {
	    return {
	      x: x + offset,
	      y: y + height - sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideBottomRight') {
	    return {
	      x: x + width - offset,
	      y: y + height - sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if ((0, _isObject3.default)(position) && ((0, _DataUtils.isNumber)(position.x) || (0, _DataUtils.isPercent)(position.x)) && ((0, _DataUtils.isNumber)(position.y) || (0, _DataUtils.isPercent)(position.y))) {
	    return {
	      x: x + (0, _DataUtils.getPercentValue)(position.x, width),
	      y: y + (0, _DataUtils.getPercentValue)(position.y, height),
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  return {
	    x: x + width / 2,
	    y: y + height / 2,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var isPolar = function isPolar(viewBox) {
	  return (0, _DataUtils.isNumber)(viewBox.cx);
	};
	
	function Label(props) {
	  var viewBox = props.viewBox,
	      position = props.position,
	      value = props.value,
	      children = props.children,
	      content = props.content,
	      _props$className = props.className,
	      className = _props$className === undefined ? '' : _props$className;
	
	
	  if (!viewBox || (0, _isNil3.default)(value) && (0, _isNil3.default)(children) && !(0, _react.isValidElement)(content) && !(0, _isFunction3.default)(content)) {
	    return null;
	  }
	
	  if ((0, _react.isValidElement)(content)) {
	    return (0, _react.cloneElement)(content, props);
	  }
	
	  var label = void 0;
	  if ((0, _isFunction3.default)(content)) {
	    label = content(props);
	
	    if ((0, _react.isValidElement)(label)) {
	      return label;
	    }
	  } else {
	    label = getLabel(props);
	  }
	
	  var isPolarLabel = isPolar(viewBox);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(props);
	
	  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
	    return renderRadialLabel(props, label, attrs);
	  }
	
	  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
	
	  return _react2.default.createElement(
	    _Text2.default,
	    _extends({
	      className: (0, _classnames2.default)('recharts-label', className)
	    }, attrs, positionAttrs),
	    label
	  );
	}
	
	Label.displayName = 'Label';
	Label.defaultProps = defaultProps;
	Label.propTypes = propTypes;
	
	var parseViewBox = function parseViewBox(props) {
	  var cx = props.cx,
	      cy = props.cy,
	      angle = props.angle,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      r = props.r,
	      radius = props.radius,
	      innerRadius = props.innerRadius,
	      outerRadius = props.outerRadius,
	      x = props.x,
	      y = props.y,
	      top = props.top,
	      left = props.left,
	      width = props.width,
	      height = props.height,
	      clockWise = props.clockWise;
	
	
	  if ((0, _DataUtils.isNumber)(width) && (0, _DataUtils.isNumber)(height)) {
	    if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	      return { x: x, y: y, width: width, height: height };
	    } else if ((0, _DataUtils.isNumber)(top) && (0, _DataUtils.isNumber)(left)) {
	      return { x: top, y: left, width: width, height: height };
	    }
	  }
	
	  if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	    return { x: x, y: y, width: 0, height: 0 };
	  }
	
	  if ((0, _DataUtils.isNumber)(cx) && (0, _DataUtils.isNumber)(cy)) {
	    return {
	      cx: cx, cy: cy,
	      startAngle: startAngle || angle || 0,
	      endAngle: endAngle || angle || 0,
	      innerRadius: innerRadius || 0,
	      outerRadius: outerRadius || radius || r || 0,
	      clockWise: clockWise
	    };
	  }
	
	  if (props.viewBox) {
	    return props.viewBox;
	  }
	
	  return {};
	};
	
	var parseLabel = function parseLabel(label, viewBox) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react2.default.createElement(Label, { key: 'label-implicit', viewBox: viewBox });
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(label)) {
	    return _react2.default.createElement(Label, { key: 'label-implicit', viewBox: viewBox, value: label });
	  }
	
	  if ((0, _react.isValidElement)(label) || (0, _isFunction3.default)(label)) {
	    return _react2.default.createElement(Label, { key: 'label-implicit', content: label, viewBox: viewBox });
	  }
	
	  if ((0, _isObject3.default)(label)) {
	    return _react2.default.createElement(Label, _extends({ viewBox: viewBox }, label, { key: 'label-implicit' }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	  var children = parentProps.children;
	
	  var parentViewBox = parseViewBox(parentProps);
	
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, Label).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      viewBox: viewBox || parentViewBox,
	      key: 'label-' + index
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
	
	  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
	};
	
	Label.parseViewBox = parseViewBox;
	Label.renderCallByParent = renderCallByParent;
	
	exports.default = Label;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isObject2 = __webpack_require__(61);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _last2 = __webpack_require__(665);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _isArray2 = __webpack_require__(24);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Label = __webpack_require__(83);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  id: _propTypes2.default.string,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  valueAccessor: _propTypes2.default.func,
	  clockWise: _propTypes2.default.bool,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func])
	};
	
	var defaultProps = {
	  valueAccessor: function valueAccessor(entry) {
	    return (0, _isArray3.default)(entry.value) ? (0, _last3.default)(entry.value) : entry.value;
	  }
	};
	
	function LabelList(props) {
	  var data = props.data,
	      valueAccessor = props.valueAccessor,
	      dataKey = props.dataKey,
	      clockWise = props.clockWise,
	      id = props.id,
	      others = _objectWithoutProperties(props, ['data', 'valueAccessor', 'dataKey', 'clockWise', 'id']);
	
	  if (!data || !data.length) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _Layer2.default,
	    { className: 'recharts-label-list' },
	    data.map(function (entry, index) {
	      var value = (0, _isNil3.default)(dataKey) ? valueAccessor(entry, index) : (0, _ChartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
	      var idProps = (0, _isNil3.default)(id) ? {} : {
	        id: id + '-' + index
	      };
	
	      return _react2.default.createElement(_Label2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(entry), others, idProps, {
	        index: index,
	        value: value,
	        viewBox: _Label2.default.parseViewBox((0, _isNil3.default)(clockWise) ? entry : _extends({}, entry, { clockWise: clockWise })),
	        key: 'label-' + index
	      }));
	    })
	  );
	}
	
	LabelList.propTypes = propTypes;
	LabelList.displayName = 'LabelList';
	
	var parseLabelList = function parseLabelList(label, data) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react2.default.createElement(LabelList, { key: 'labelList-implicit', data: data });
	  }
	
	  if (_react2.default.isValidElement(label) || (0, _isFunction3.default)(label)) {
	    return _react2.default.createElement(LabelList, { key: 'labelList-implicit', data: data, content: label });
	  }
	
	  if ((0, _isObject3.default)(label)) {
	    return _react2.default.createElement(LabelList, _extends({ data: data }, label, { key: 'labelList-implicit' }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, data) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	  var children = parentProps.children;
	
	
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, LabelList).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      data: data,
	      key: 'labelList-' + index
	    });
	  });
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabelList = parseLabelList(parentProps.label, data);
	
	  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
	};
	
	LabelList.renderCallByParent = renderCallByParent;
	LabelList.defaultProps = defaultProps;
	
	exports.default = LabelList;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(590),
	    getValue = __webpack_require__(620);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _contextTypes = __webpack_require__(67);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({}, _contextTypes2.default, { header: _propTypes2.default.bool });
	//# sourceMappingURL=headerContextTypes.js.map

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withTableFixes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _findTable = __webpack_require__(68);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	var _findFixedTo = __webpack_require__(135);
	
	var _findFixedTo2 = _interopRequireDefault(_findFixedTo);
	
	var _getDisplayName = __webpack_require__(100);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is a utility HOC to fix the components that use the `Menu` component behind the scenes. This will
	 * correctly add the `id` and `fixedTo` props if they are omitted from the child component's props.
	 *
	 * If the id prop is omitted, it will default to the `${rowId}-${cellIndex}-${suffix}` and when the
	 * `fixedTo` prop is omitted, it will automatically set it to the responsive table wrapper so that
	 * it will stay in viewport as expected.
	 *
	 * This component also attempts to find the `cellIndex` prop if it is not correctly cloned into the
	 * component.
	 *
	 * @param {function|Class} ComposedComponent - the component to compose with the tooltip functionality.
	 * @param {String} suffix - the id suffix to apply.
	 * @return {Class} the ComposedComponent with some fixes applied.
	 */
	function withTableFixes(ComposedComponent, suffix) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_PureComponent) {
	    _inherits(TableFixesComponent, _PureComponent);
	
	    function TableFixesComponent() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TableFixesComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableFixesComponent.__proto__ || Object.getPrototypeOf(TableFixesComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = { cellIndex: undefined }, _this._fixedTo = null, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TableFixesComponent, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _props = this.props,
	            cellIndex = _props.cellIndex,
	            fixedTo = _props.fixedTo,
	            id = _props.id;
	
	        var isIndexed = !!id || cellIndex === 0 || !!cellIndex;
	        var isFixed = fixedTo === null || !!fixedTo;
	        if (isIndexed && isFixed) {
	          // all is good
	          return;
	        }
	
	        var column = (0, _reactDom.findDOMNode)(this);
	        var table = (0, _findTable2.default)(column);
	        this._fixedTo = (0, _findFixedTo2.default)(table);
	
	        // If a developer creates their own component to wrap the component that uses a menu, the cellIndex prop
	        // might not be defined if they don't pass ...props
	        if (!isIndexed) {
	          var columns = [].slice.call(column.parentNode.querySelectorAll('th,td'));
	          this.setState({ cellIndex: columns.indexOf(column) }); // eslint-disable-line react/no-did-mount-set-state
	        } else if (this._fixedTo) {
	          // need to apply the _fixedTo for the select field
	          this.forceUpdate();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var rowId = this.context.rowId;
	
	        var _props2 = this.props,
	            propid = _props2.id,
	            propFixedTo = _props2.fixedTo,
	            propCellIndex = _props2.cellIndex,
	            props = _objectWithoutProperties(_props2, ['id', 'fixedTo', 'cellIndex']);
	
	        var id = this.props.id;
	
	        var fixedTo = this._fixedTo === null || propFixedTo ? propFixedTo : this._fixedTo;
	        var cellIndex = (0, _getField2.default)(this.props, this.state, 'cellIndex');
	        if (!id) {
	          id = rowId + '-' + cellIndex + '-' + suffix;
	        }
	
	        return _react2.default.createElement(ComposedComponent, _extends({}, props, { id: id, fixedTo: fixedTo }));
	      }
	    }]);
	
	    return TableFixesComponent;
	  }(_react.PureComponent), _class.Positions = ComposedComponent.Positions, _class.HorizontalAnchors = ComposedComponent.HorizontalAnchors, _class.VerticalAnchors = ComposedComponent.VerticalAnchors, _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'TableFixes'), _class.propTypes = {
	    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cellIndex: _propTypes2.default.number,
	    fixedTo: _fixedToShape2.default
	  }, _class.contextTypes = {
	    rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }, _temp2;
	}
	//# sourceMappingURL=withTableFixes.js.map

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _oneRequiredForA11y = __webpack_require__(74);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _FocusContainer = __webpack_require__(142);
	
	var _FocusContainer2 = _interopRequireDefault(_FocusContainer);
	
	var _ResizeObserver = __webpack_require__(28);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _Paper = __webpack_require__(29);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _DialogTitle = __webpack_require__(263);
	
	var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	var _DialogFooter = __webpack_require__(69);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['style', 'height', 'width', 'contentStyle'];
	
	/**
	 * The `Dialog` is just a static component for creating dialogs. Dialogs
	 * seemed like they could be used outside of the `DialogContainer` component,
	 * so it was exposed as well. In *most* cases, you will still want to use
	 * the `DialogContainer` component.
	 */
	
	var Dialog = function (_PureComponent) {
	  _inherits(Dialog, _PureComponent);
	
	  function Dialog(props) {
	    _classCallCheck(this, Dialog);
	
	    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var height = props.height,
	        width = props.width;
	
	    var styles = props.style;
	    if (height || width) {
	      styles = styles || {};
	      styles = _extends({ height: height, width: width }, styles);
	    }
	
	    _this.state = {
	      styles: styles,
	      contentStyles: props.contentStyle,
	      contentPadded: false
	    };
	    return _this;
	  }
	
	  _createClass(Dialog, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { renderNode: this._renderNode };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          pageX = _props.pageX,
	          pageY = _props.pageY;
	
	      if (!pageX || !pageY) {
	        return;
	      }
	
	      this.setState({ styles: this._getStyles(this.props) });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onOpen) {
	        this.props.onOpen();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (DIFF_KEYS.some(function (key) {
	        return nextProps[key] !== _this2.props[key];
	      })) {
	        this.setState({
	          styles: this._getStyles(nextProps),
	          contentStyles: _extends({}, this.state.contentStyles, nextProps.contentStyle)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onLeave) {
	        this.props.onLeave();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          contentPadded = _state.contentPadded,
	          styles = _state.styles,
	          contentStyles = _state.contentStyles;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          titleStyle = _props2.titleStyle,
	          titleClassName = _props2.titleClassName,
	          footerStyle = _props2.footerStyle,
	          footerClassName = _props2.footerClassName,
	          contentClassName = _props2.contentClassName,
	          title = _props2.title,
	          Content = _props2.contentComponent,
	          contentProps = _props2.contentProps,
	          actions = _props2.actions,
	          children = _props2.children,
	          fullPage = _props2.fullPage,
	          centered = _props2.centered,
	          autopadContent = _props2.autopadContent,
	          paddedContent = _props2.paddedContent,
	          autosizeContent = _props2.autosizeContent,
	          stackedActions = _props2.stackedActions,
	          style = _props2.style,
	          contentStyle = _props2.contentStyle,
	          pageX = _props2.pageX,
	          pageY = _props2.pageY,
	          containerX = _props2.containerX,
	          containerY = _props2.containerY,
	          onOpen = _props2.onOpen,
	          onLeave = _props2.onLeave,
	          height = _props2.height,
	          width = _props2.width,
	          props = _objectWithoutProperties(_props2, ['id', 'className', 'titleStyle', 'titleClassName', 'footerStyle', 'footerClassName', 'contentClassName', 'title', 'contentComponent', 'contentProps', 'actions', 'children', 'fullPage', 'centered', 'autopadContent', 'paddedContent', 'autosizeContent', 'stackedActions', 'style', 'contentStyle', 'pageX', 'pageY', 'containerX', 'containerY', 'onOpen', 'onLeave', 'height', 'width']);
	
	      var labelledBy = this.props['aria-labelledby'];
	
	      var titleId = id + '-title';
	      if (!labelledBy && title) {
	        labelledBy = titleId;
	      }
	
	      var padDefined = typeof paddedContent !== 'undefined';
	      var dialogChildren = fullPage ? children : [_react2.default.createElement(
	        _DialogTitle2.default,
	        {
	          key: 'title',
	          id: titleId,
	          style: titleStyle,
	          className: titleClassName
	        },
	        title
	      ), _react2.default.createElement(
	        Content,
	        _extends({
	          ref: !padDefined && autopadContent ? this._setContent : null,
	          key: 'content'
	        }, contentProps, {
	          style: contentStyles,
	          className: (0, _classnames2.default)('md-dialog-content', {
	            'md-dialog-content--padded': padDefined ? paddedContent : contentPadded
	          }, contentClassName)
	        }),
	        autosizeContent ? _react2.default.createElement(_ResizeObserver2.default, { watchHeight: true, watchWidth: true, onResize: this._handleContentResize }) : null,
	        children
	      ), _react2.default.createElement(_DialogFooter2.default, {
	        key: 'footer',
	        style: footerStyle,
	        className: footerClassName,
	        actions: actions,
	        stacked: stackedActions
	      })];
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          id: id,
	          component: _FocusContainer2.default,
	          ref: this._setRenderNode,
	          style: styles,
	          className: (0, _classnames2.default)('md-dialog', {
	            'md-dialog--full-page': fullPage,
	            'md-dialog--centered': centered
	          }, className),
	          role: 'dialog',
	          'aria-labelledby': labelledBy
	        }),
	        dialogChildren
	      );
	    }
	  }]);
	
	  return Dialog;
	}(_react.PureComponent);
	
	Dialog.propTypes = {
	  /**
	   * @see {@link Dialogs/DialogContainer#id}
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#aria-describedby}
	   */
	  'aria-describedby': (0, _oneRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'title', 'aria-labelledby', 'aria-label'),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#aria-labelledby}
	   */
	  'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#aria-label}
	   */
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional styke to apply to the title.
	   */
	  titleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the title.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's content.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog's content.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the content as. This is helpful if you would like to use
	   * the CSSTransitionGroup. This really just saves a tiny bit of markup.
	   *
	   * ```js
	   * <Dialog
	   *   contentComponent={CSSTransitionGroup}
	   *   contentProps={{
	   *     transitionName: 'md-cross-fade',
	   *     transitionLeave: false,
	   *     transitionEnterTimeout: 150,
	   *   }}
	   * >
	   *   {dynamicContent}
	   * </Dialog>
	   * ```
	   */
	  contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * Any additional props to pass to the content component.
	   */
	  contentProps: _propTypes2.default.object,
	
	  /**
	   * An optional title to display in the dialog.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * Any children to display in the content of the dialog.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A single action or a list of actions to display in the dialog. This can either be a list
	   * of `FlatButton` props or `<Button flat {...props} />` elements.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),
	
	  /**
	   * @see {@link Helpers/FocusContainer#additionalFocusKeys}
	   */
	  additionalFocusKeys: _FocusContainer2.default.propTypes.additionalFocusKeys,
	
	  /**
	   * @see {@link Helpers/FocusContainer#initialFocus}
	   */
	  initialFocus: _FocusContainer2.default.propTypes.initialFocus,
	
	  /**
	   * @see {@link Helpers/FocusContainer#focusOnMount}
	   */
	  focusOnMount: _FocusContainer2.default.propTypes.focusOnMount,
	
	  /**
	   * @see {@link Helpers/FocusContainer#containFocus}
	   */
	  containFocus: _FocusContainer2.default.propTypes.containFocus,
	
	  /**
	   * An optional x coordinate on the page that caused a full page dialog
	   * to be created. This is really just used for a `transformOrigin` style.
	   */
	  pageX: _propTypes2.default.number,
	
	  /**
	   * An optional y coordinate on the page that caused a full page dialog
	   * to be created. This is really just used for a `transformOrigin` style.
	   */
	  pageY: _propTypes2.default.number,
	
	  /**
	   * An optional x scroll position of the container holding the dialog. This
	   * is really just used for a `transformOrigin` style on full page dialogs.
	   */
	  containerX: _propTypes2.default.number,
	
	  /**
	   * An optional y scroll position of the container holding the dialog. This
	   * is really just used for a `transformOrigin` style on full page dialogs.
	   */
	  containerY: _propTypes2.default.number,
	
	  /**
	   * Boolean if the dialog should be rendered as a full page dialog.
	   */
	  fullPage: _propTypes2.default.bool,
	
	  /**
	   * The zDepth to use for the dialog.
	   */
	  zDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when the dialog has been opened. This is
	   * really just used for the `DialogContainer`.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the dialog has been closed. This is
	   * really just used for the `DialogContainer`.
	   */
	  onLeave: _propTypes2.default.func,
	
	  /**
	   * Boolean if the dialog should be centered in the page.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the content should be padded. This will take precedence
	   * over the `autopadContent` prop. So if this is defined, that value
	   * will be used instead of any thing that was was calculated in this
	   * component.
	   *
	   * @see {@link #autopadContent}
	   */
	  paddedContent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should automatically try to determine if the content
	   * should be padded. It will be padded if the dialog does not contain a `List`.
	   */
	  autopadContent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog content's size should automatically be resized to overflow
	   * correctly when there is a lot of content. This will calculate and apply some `maxHeight`
	   * to the `contentStyle`.
	   */
	  autosizeContent: _propTypes2.default.bool,
	
	  /**
	   * An optional height to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #width}
	   */
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional width to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #height}
	   */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the actions should be stacked on top of each other. If this value is `undefined`, it will
	   * automatically attempt to guess if the items should be stacked.
	   */
	  stackedActions: _propTypes2.default.bool
	};
	Dialog.defaultProps = {
	  autopadContent: true,
	  autosizeContent: true,
	  contentComponent: 'section',
	  zDepth: 5
	};
	Dialog.childContextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this._getStyles = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props,
	        pageX = _ref.pageX,
	        containerX = _ref.containerX,
	        pageY = _ref.pageY,
	        containerY = _ref.containerY,
	        height = _ref.height,
	        width = _ref.width,
	        style = _ref.style;
	
	    return _extends({
	      height: typeof height !== 'undefined' ? height : null,
	      width: typeof width !== 'undefined' ? width : null,
	      transformOrigin: pageX || pageY ? pageX - containerX + 'px ' + (pageY - containerY) + 'px' : null
	    }, style);
	  };
	
	  this._setRenderNode = function (dialog) {
	    _this3._renderNode = (0, _reactDom.findDOMNode)(dialog);
	  };
	
	  this._setContent = function (content) {
	    if (content !== null) {
	      _this3._content = (0, _reactDom.findDOMNode)(content);
	      var contentPadded = _this3._content.querySelectorAll('.md-list').length === 0;
	
	      _this3.setState({ contentPadded: contentPadded });
	    }
	  };
	
	  this._handleContentResize = function (_ref2) {
	    var scrollHeight = _ref2.scrollHeight,
	        content = _ref2.el;
	
	    var maxHeight = content.style.maxHeight;
	    var dialog = content.parentNode;
	    content.style.maxHeight = 'none';
	    var title = _this3.props.title ? dialog.querySelector('.md-title--dialog') : null;
	    var footer = _this3.props.actions ? dialog.querySelector('.md-dialog-footer') : null;
	
	    var totalHeight = dialog.offsetHeight - (title ? title.offsetHeight : 0) - (footer ? footer.offsetHeight : 0);
	    content.style.maxHeight = maxHeight;
	    var equalHeight = totalHeight === scrollHeight;
	    if (equalHeight) {
	      var currentHeight = _this3.state.contentStyles && _this3.state.contentStyles.maxHeight || null;
	      if (currentHeight && currentHeight !== scrollHeight) {
	        _this3.setState({ contentStyles: _this3.props.contentStyle });
	      }
	    } else {
	      _this3.setState({ contentStyles: _extends({ maxHeight: totalHeight }, _this3.props.contentStyle) });
	    }
	  };
	};
	
	exports.default = Dialog;
	//# sourceMappingURL=Dialog.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(9);
	
	var _CSSTransitionGroupTick = __webpack_require__(30);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _toggleScroll = __webpack_require__(377);
	
	var _toggleScroll2 = _interopRequireDefault(_toggleScroll);
	
	var _oneRequiredForA11y = __webpack_require__(74);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _Dialog = __webpack_require__(88);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Portal = __webpack_require__(45);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `DialogContainer` component is used for dynamically creating the `Dialog` with
	 * transitions.
	 */
	var DialogContainer = function (_PureComponent) {
	  _inherits(DialogContainer, _PureComponent);
	
	  function DialogContainer(props) {
	    _classCallCheck(this, DialogContainer);
	
	    var _this = _possibleConstructorReturn(this, (DialogContainer.__proto__ || Object.getPrototypeOf(DialogContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visible = typeof props.isOpen !== 'undefined' ? props.isOpen : props.visible;
	    var dialogVisible = visible && !props.defaultVisibleTransitionable;
	
	    _this.state = {
	      active: visible && !props.fullPage,
	      overlay: visible && !props.fullPage,
	      portalVisible: visible,
	      dialogVisible: dialogVisible
	    };
	    return _this;
	  }
	  /* eslint-disable max-len */
	
	
	  _createClass(DialogContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.isOpen && !this.props.visible) {
	        return;
	      }
	
	      this._mountDialog(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var visible = typeof nextProps.isOpen !== 'undefined' ? nextProps.isOpen : nextProps.visible;
	      if (this.props.isOpen === visible || this.props.visible === visible) {
	        return;
	      }
	
	      var el = (0, _getField2.default)(this.props, this.context, 'renderNode') || window;
	      var pageX = el.scrollX,
	          pageY = el.scrollY;
	
	      if (typeof el.scrollTop !== 'undefined' && typeof el.scrollLeft !== 'undefined') {
	        pageX = el.scrollLeft;
	        pageY = el.scrollTop;
	      } else if (typeof el.scrollY !== 'undefined' && typeof el.scrollX !== 'undefined') {
	        pageX = el.scrollX;
	        pageY = el.scrollY;
	      }
	
	      this._pageX = pageX;
	      this._pageY = pageY;
	
	      if (this._inTimeout) {
	        clearTimeout(this._inTimeout);
	        this._inTimeout = null;
	      }
	
	      if (visible) {
	        this._activeElement = document.activeElement;
	        this._mountPortal(nextProps);
	      } else {
	        this.setState({ dialogVisible: false, active: false });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          visible = _props.visible,
	          closeOnEsc = _props.closeOnEsc,
	          modal = _props.modal;
	
	      var escapable = !modal && closeOnEsc;
	      var prevEscapable = !prevProps.modal && prevProps.closeOnEsc;
	
	      // Only going to support visible here since it was not implemented before.
	      if (visible === prevProps.visible && escapable === prevEscapable) {
	        return;
	      }
	
	      var add = false;
	      var remove = false;
	
	      if (escapable !== prevEscapable) {
	        add = visible && escapable;
	        remove = !visible || prevEscapable && !escapable;
	      } else if (escapable) {
	        add = visible;
	        remove = !visible;
	      }
	
	      if (add) {
	        window.addEventListener('keydown', this._handleEscClose);
	      } else if (remove) {
	        window.removeEventListener('keydown', this._handleEscClose);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.isOpen || this.props.visible) {
	        (0, _toggleScroll2.default)(false);
	      }
	
	      if (this.props.visible && this.props.closeOnEsc && !this.props.modal) {
	        window.removeEventListener('keydown', this._handleEscClose);
	      }
	
	      if (this._inTimeout) {
	        clearTimeout(this._inTimeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          overlay = _state.overlay,
	          active = _state.active,
	          dialogVisible = _state.dialogVisible,
	          portalVisible = _state.portalVisible;
	
	      var _props2 = this.props,
	          style = _props2.style,
	          className = _props2.className,
	          dialogStyle = _props2.dialogStyle,
	          dialogClassName = _props2.dialogClassName,
	          modal = _props2.modal,
	          fullPage = _props2.fullPage,
	          component = _props2.component,
	          transitionEnterTimeout = _props2.transitionEnterTimeout,
	          transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	          lastChild = _props2.lastChild,
	          portal = _props2.portal,
	          propVisible = _props2.visible,
	          propRenderNode = _props2.renderNode,
	          closeOnEsc = _props2.closeOnEsc,
	          onShow = _props2.onShow,
	          onHide = _props2.onHide,
	          disableScrollLocking = _props2.disableScrollLocking,
	          defaultVisibleTransitionable = _props2.defaultVisibleTransitionable,
	          close = _props2.close,
	          isOpen = _props2.isOpen,
	          actionLeft = _props2.actionLeft,
	          actionRight = _props2.actionRight,
	          transitionName = _props2.transitionName,
	          transitionEnter = _props2.transitionEnter,
	          transitionLeave = _props2.transitionLeave,
	          props = _objectWithoutProperties(_props2, ['style', 'className', 'dialogStyle', 'dialogClassName', 'modal', 'fullPage', 'component', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'lastChild', 'portal', 'visible', 'renderNode', 'closeOnEsc', 'onShow', 'onHide', 'disableScrollLocking', 'defaultVisibleTransitionable', 'close', 'isOpen', 'actionLeft', 'actionRight', 'transitionName', 'transitionEnter', 'transitionLeave']);
	
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	      var dialog = _react2.default.createElement(_Dialog2.default, _extends({
	        key: 'dialog',
	        style: dialogStyle,
	        className: (0, _classnames2.default)('md-background--card', dialogClassName),
	        ref: this._handleDialogMounting,
	        centered: !fullPage,
	        fullPage: fullPage
	      }, props, {
	        containerX: this._pageX,
	        containerY: this._pageY,
	        onLeave: this._unmountPortal
	      }));
	
	      var container = _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	          component: component,
	          ref: this._setContainer,
	          style: style,
	          className: (0, _classnames2.default)('md-dialog-container', {
	            'md-overlay': !fullPage && overlay,
	            'md-pointer--hover': !fullPage && overlay && !modal,
	            'md-overlay--active': !fullPage && active && overlay
	          }, className),
	          transitionName: 'md-dialog--' + (fullPage ? 'full-page' : 'centered'),
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout,
	          tabIndex: -1,
	          onClick: this._handleClick
	        },
	        dialogVisible ? dialog : null
	      );
	
	      if (!portal) {
	        return portalVisible ? container : null;
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { visible: portalVisible, renderNode: renderNode, lastChild: lastChild },
	        container
	      );
	    }
	  }]);
	
	  return DialogContainer;
	}(_react.PureComponent);
	
	DialogContainer.propTypes = {
	  /**
	   * An id to use for the `Dialog` once it has been opened. This is used for the
	   * [dialog role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_dialog_role).
	   * This is used to generate an `id` for the `title` prop when it has been defined.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	  /* eslint-enable max-len */
	
	  /**
	   * An optional accessibility prop to use when the `Dialog` is opened. This should be an id
	   * pointing to some text that describes the content of the dialog. For accessibility
	   * reasons, one of the following props must be defined:
	   * - `title`
	   * - `aria-describedby`
	   * - `aria-labelledby`
	   * - `aria-label`
	   *
	   * An example usage:
	   *
	   * ```js
	   * <Dialog id="accessible-example" visible aria-describedby="accessible-content">
	   *   <p id="accessible-content">This is some content that describes the dialog.</p>
	   * </Dialog>
	   * ```
	   */
	  'aria-describedby': (0, _oneRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'title', 'aria-labelledby', 'aria-label'),
	
	  /**
	   * An optional accessibility prop to use when the `title` prop is not given. This should be
	   * an id pointing to a `h` tag that labels the dialog.
	   *
	   * An example usage:
	   *
	   * ```js
	   * <Dialog visible id="accessible-example" aria-labelledby="accessible-dialog-label">
	   *   <h2 id="accessible-dialog-label">Some Accessible Dialog</h2>
	   * </Dialog>
	   * ```
	   */
	  'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional accessibility prop to use when the `title` and `aria-labelledby` props are
	   * not defined. This should be a string that describes what is in the `Dialog`.
	   *
	   * An example usage:
	   *
	   * ```js
	   * <Dialog visible id="accessible-example" aria-label="Some Accessible Dialog">
	   *   <p>Lorem Ipsum</p>
	   * </Dialog>
	   * ```
	   */
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog itself when the `visible` prop is `true`.
	   */
	  dialogStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog itself when the `visible` prop is `true`.
	   */
	  dialogClassName: _propTypes2.default.string,
	
	  /**
	   * An optional styke to apply to the title.
	   */
	  titleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the title.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's content.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog's content.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the dialog's container in.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The component to render the dialog's content in.
	   */
	  contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The content to display in the dialog once open.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A single action or a list of actions to display in the dialog. This can either be a list
	   * of `FlatButton` props or `<Button flat {...props} />` elements.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),
	
	  /**
	   * Boolean if the `Dialog` is current visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional function to call when the `visible` prop is changed from `false` to `true`.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A function to call that will close the dialog. This is required when the `modal` and `fullPage`
	   * props are not `true`.
	   */
	  onHide: function onHide(props, propName) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var validator = _propTypes2.default.func;
	    if (!props.modal && !props.fullPage) {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName].concat(args));
	  },
	
	  /**
	   * Boolean if the dialog should behave like a modal. This means that the dialog can only
	   * be closed by clicking on an action instead of also clicking on the overlay.
	   */
	  modal: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be displayed as a full page dialog.
	   */
	  fullPage: function fullPage(props, propName, componentName) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      args[_key2 - 3] = arguments[_key2];
	    }
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	    var componentNameSafe = componentName || '<<anonymous>>';
	
	    var err = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, componentName].concat(args));
	
	    if (!err && typeof props.title !== 'undefined') {
	      err = new Error('You provided a `title` ' + location + ' to the `' + componentNameSafe + '` when `fullPage` ' + 'has been set to true. A title for a full page dialog should be rendered as a child instead.');
	    }
	
	    return err;
	  },
	
	  /**
	   * An optional pageX location to use when rendering a full page dialog. This is used to set the location
	   * the dialog should appear from.
	   */
	  pageX: _propTypes2.default.number,
	
	  /**
	   * An optional pageY location to use when rendering a full page dialog. This is used to set the location
	   * the dialog should appear from.
	   */
	  pageY: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/FocusContainer#additionalFocusKeys}
	   */
	  additionalFocusKeys: _Dialog2.default.propTypes.additionalFocusKeys,
	
	  /**
	   * @see {@link Helpers/FocusContainer#initialFocus}
	   */
	  initialFocus: _Dialog2.default.propTypes.initialFocus,
	
	  /**
	   * @see {@link Helpers/FocusContainer#focusOnMount}
	   */
	  focusOnMount: _Dialog2.default.propTypes.focusOnMount,
	
	  /**
	   * @see {@link Helpers/FocusContainer#containFocus}
	   */
	  containFocus: _Dialog2.default.propTypes.containFocus,
	
	  /**
	   * The transition enter timeout for the dialog.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition leave timeout for the dialog.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the dialog should be closable by pressing the escape key.
	   * This will always be considered `false` of the `modal` props is `true`.
	   */
	  closeOnEsc: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the dialog.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * Since the `Dialog` uses the `Portal` component, you can pass an optional HTML Node to render
	   * the dialog in instead of the `document.body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the dialog should be rendered as the last child in the `renderNode` or `body` instead
	   * of as the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * An optional title for the dialog.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * Boolean if the dialog should animate into view if it is constructed with `visible` enabled.
	   *
	   * This basically means that if the `Dialog` has `visible` enabled on initial page load, does it animate?
	   * In some cases, it can also mean if the `Dialog` is added to the render tree with `visible` enabled,
	   * does it animate?
	   */
	  defaultVisibleTransitionable: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Dialog should no longer try to prevent the parent container from scrolling while visible.
	   * In most cases, this will attempt to prevent the main window scrolling. If this dialog is nested in another
	   * dialog, it will attempt to prevent the parent dialog from scrolling.
	   */
	  disableScrollLocking: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should automatically try to determine if the content
	   * should be padded. It will be padded if the dialog does not contain a `List`.
	   */
	  autopadContent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog content's size should automatically be resized to overflow
	   * correctly when there is a lot of content. This will calculate and apply some `maxHeight`
	   * to the `contentStyle`.
	   */
	  autosizeContent: _propTypes2.default.bool,
	
	  /**
	   * An optional height to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #width}
	   */
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional width to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #height}
	   */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the actions should be stacked on top of each other. If this value is `undefined`, it will
	   * automatically attempt to guess if the items should be stacked.
	   */
	  stackedActions: _propTypes2.default.bool,
	
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  transitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'The transition name will be managed by the component'),
	  transitionEnter: (0, _deprecated2.default)(_propTypes2.default.bool, 'The transition will always be enforced'),
	  transitionLeave: (0, _deprecated2.default)(_propTypes2.default.bool, 'The transition will always be enforced'),
	  actionLeft: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `fullPage` prop instead'),
	  actionRight: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `fullPage` prop instead'),
	  close: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onHide` instead.')
	};
	DialogContainer.defaultProps = {
	  autopadContent: true,
	  autosizeContent: true,
	  component: 'span',
	  closeOnEsc: true,
	  contentComponent: 'section',
	  focusOnMount: true,
	  transitionEnterTimeout: 300,
	  transitionLeaveTimeout: 300,
	  defaultVisibleTransitionable: false
	};
	DialogContainer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    if (container !== null) {
	      _this2._container = (0, _reactDom.findDOMNode)(container);
	    }
	  };
	
	  this._handleEscClose = function (e) {
	    if ((e.which || e.keyCode) === _keyCodes.ESC) {
	      (_this2.props.onHide || _this2.props.close)(e);
	    }
	  };
	
	  this._mountPortal = function (props) {
	    _this2._mountDialog(props);
	    _this2.setState({ portalVisible: true });
	  };
	
	  this._mountDialog = function (props) {
	    var fullPage = props.fullPage,
	        onShow = props.onShow;
	
	    _this2._inTimeout = setTimeout(function () {
	      _this2._inTimeout = fullPage ? null : setTimeout(function () {
	        _this2._inTimeout = null;
	        _this2.setState({ active: true });
	      }, _CSSTransitionGroupTick2.default);
	      _this2.setState({ dialogVisible: true, overlay: !fullPage }, onShow);
	    }, _CSSTransitionGroupTick2.default);
	  };
	
	  this._unmountPortal = function () {
	    _this2.setState({ portalVisible: false });
	  };
	
	  this._handleClick = function (e) {
	    var visible = typeof _this2.props.isOpen !== 'undefined' ? _this2.props.isOpen : _this2.props.visible;
	    if (_this2.props.modal || !visible || e.target !== _this2._container) {
	      return;
	    }
	
	    (_this2.props.onHide || _this2.props.close)(e);
	  };
	
	  this._handleDialogMounting = function (dialog) {
	    var disableScrollLocking = _this2.props.disableScrollLocking;
	
	    if (dialog === null) {
	      if (_this2._activeElement) {
	        _this2._activeElement.focus();
	      }
	
	      if (!disableScrollLocking) {
	        (0, _toggleScroll2.default)(false, _this2.scrollEl);
	      }
	
	      _this2._activeElement = null;
	      _this2.setState({ overlay: false });
	    } else {
	      var container = document.querySelector('#' + _this2.props.id);
	      if (!container || disableScrollLocking) {
	        return;
	      }
	
	      var el = (0, _getField2.default)(_this2.props, _this2.context, 'renderNode');
	      var node = container.parentNode;
	      while (node && node.classList && !el) {
	        if (node.classList.contains('md-dialog')) {
	          el = node;
	        }
	
	        node = node.parentNode;
	      }
	
	      _this2.scrollEl = el;
	      (0, _toggleScroll2.default)(true, el);
	    }
	  };
	};
	
	exports.default = DialogContainer;
	//# sourceMappingURL=DialogContainer.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The divider component will pass all other props such as style or
	 * event listeners on to the component.
	 */
	var Divider = function (_PureComponent) {
	  _inherits(Divider, _PureComponent);
	
	  function Divider() {
	    _classCallCheck(this, Divider);
	
	    return _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
	  }
	
	  _createClass(Divider, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          inset = _props.inset,
	          vertical = _props.vertical,
	          props = _objectWithoutProperties(_props, ['className', 'inset', 'vertical']);
	
	      var Component = vertical ? 'div' : 'hr';
	
	      return _react2.default.createElement(Component, _extends({}, props, {
	        className: (0, _classnames2.default)('md-divider', {
	          'md-divider--vertical': vertical,
	          'md-divider--inset': inset
	        }, className)
	      }));
	    }
	  }]);
	
	  return Divider;
	}(_react.PureComponent);
	
	Divider.propTypes = {
	  /*
	   * An optional style to apply to the divider.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the divider.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if this divider should be inset relative to it's container
	   * component. This means that if it is in a `List` with `Avatar`, it
	   * will start the divider  to the left of the main text in the list.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the divider should be vertical instead of horizontal.
	   */
	  vertical: _propTypes2.default.bool
	};
	exports.default = Divider;
	//# sourceMappingURL=Divider.js.map

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _media = __webpack_require__(352);
	
	var _CSSTransitionGroupTick = __webpack_require__(30);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _mapToListParts = __webpack_require__(102);
	
	var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _Paper = __webpack_require__(29);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Portal = __webpack_require__(45);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _List = __webpack_require__(51);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Overlay = __webpack_require__(266);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _isType = __webpack_require__(137);
	
	var _DrawerTypes = __webpack_require__(136);
	
	var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var oneOfDrawerTypes = _propTypes2.default.oneOf([_DrawerTypes2.default.FULL_HEIGHT, _DrawerTypes2.default.CLIPPED, _DrawerTypes2.default.FLOATING, _DrawerTypes2.default.PERSISTENT, _DrawerTypes2.default.PERSISTENT_MINI, _DrawerTypes2.default.TEMPORARY, _DrawerTypes2.default.TEMPORARY_MINI]);
	
	/**
	 * The `Drawer` component is used for having a sliding panel of content or navigation
	 * that appears from the side of a screen.
	 *
	 * If the `Drawer` uses any of the `_MINI` drawer types, you will need to also create another
	 * `Drawer` that is not `_MINI`. Transitioning the `width` on mobile devices is very sluggish,
	 * and it isn't much more work to create another drawer.
	 */
	
	var Drawer = function (_PureComponent) {
	  _inherits(Drawer, _PureComponent);
	
	  _createClass(Drawer, null, [{
	    key: 'getCurrentMedia',
	
	
	    /**
	     * Determines the current media and returns an object containing matches for `mobile`, `tablet`, `desktop`,
	     * and the current drawer type. This expects a `props` object of the drawer.
	     *
	     * If this is used server side, it will default to only matching mobile.
	     *
	     * @param {Object=} props - The current drawer's prop shape to extract the mobile, tablet,
	     *    and desktop type/min widths. This defaults to the drawer's default props.
	     * @return {Object} an object containing the media matches and the current type to use for the drawer.
	     */
	    value: function getCurrentMedia() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Drawer.defaultProps;
	      var mobileMinWidth = props.mobileMinWidth,
	          tabletMinWidth = props.tabletMinWidth,
	          desktopMinWidth = props.desktopMinWidth,
	          mobileType = props.mobileType,
	          tabletType = props.tabletType,
	          desktopType = props.desktopType,
	          constantType = props.constantType;
	
	      if (typeof window === 'undefined') {
	        var _type = constantType && props.type ? props.type : mobileType;
	        return { mobile: true, tablet: false, desktop: false, type: _type };
	      }
	
	      var mobile = Drawer.matchesMedia(mobileMinWidth, tabletMinWidth - 1);
	      var tablet = Drawer.matchesMedia(tabletMinWidth, desktopMinWidth);
	      var desktop = Drawer.matchesMedia(desktopMinWidth);
	
	      var type = void 0;
	      if (constantType && props.type && (0, _isType.isTemporary)(props.type)) {
	        type = props.type;
	      } else if (desktop) {
	        type = desktopType;
	      } else if (tablet) {
	        type = tabletType;
	      } else {
	        type = mobileType;
	      }
	
	      return { type: type, mobile: mobile, tablet: tablet, desktop: desktop };
	    }
	
	    /**
	     * Simply does a `window.matchMedia(query)` where the query gets defined as a min width
	     * and optional max width.
	     *
	     * @param {number} min - The min width for the media query.
	     * @param {number=} max - An optional max width to include for the media query.
	     * @return {boolean} true if the media matches.
	     */
	
	  }, {
	    key: 'matchesMedia',
	    value: function matchesMedia(min, max) {
	      var media = 'screen and (min-width: ' + min + 'px)';
	      if (max) {
	        media += ' and (max-width: ' + max + 'px)';
	      }
	
	      return window.matchMedia(media).matches;
	    }
	  }]);
	
	  function Drawer(props) {
	    _classCallCheck(this, Drawer);
	
	    var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultVisible = props.defaultVisible,
	        defaultMedia = props.defaultMedia,
	        overlay = props.overlay;
	
	
	    _this.state = {
	      mobile: defaultMedia === 'mobile',
	      tablet: defaultMedia === 'tablet',
	      desktop: defaultMedia === 'desktop',
	      animating: false,
	      overlayActive: false,
	      drawerActive: false
	    };
	
	    if (typeof props.type === 'undefined') {
	      _this.state.type = props[defaultMedia + 'Type'];
	    }
	
	    var type = (0, _getField2.default)(props, _this.state, 'type');
	    _this._initialFix = true;
	
	    if (typeof props.visible === 'undefined') {
	      var _visible = (0, _isType.isPermanent)(type) || (0, _isType.isMini)(type);
	      if (!_visible && typeof defaultVisible !== 'undefined') {
	        _visible = defaultVisible;
	      }
	
	      _this.state.visible = _visible;
	    }
	
	    var visible = (0, _getField2.default)(props, _this.state, 'visible');
	
	    _this.state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(type) && !_this.state.desktop) && visible;
	    _this.state.drawerActive = visible;
	    return _this;
	  }
	
	  _createClass(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (typeof window !== 'undefined') {
	        this._updateType(this.props);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!(0, _isType.isMini)((0, _getField2.default)(this.props, this.state, 'type'))) {
	        window.addEventListener('resize', this._updateMedia);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          mobileMinWidth = _props.mobileMinWidth,
	          mobileType = _props.mobileType,
	          tabletMinWidth = _props.tabletMinWidth,
	          tabletType = _props.tabletType,
	          desktopMinWidth = _props.desktopMinWidth,
	          desktopType = _props.desktopType;
	
	
	      if (nextProps.mobileMinWidth !== mobileMinWidth || nextProps.mobileType !== mobileType || nextProps.tabletMinWidth !== tabletMinWidth || nextProps.tabletType !== tabletType || nextProps.desktopMinWidth !== desktopMinWidth || nextProps.desktopType !== desktopType) {
	        this._updateType(nextProps);
	      }
	
	      var visible = nextProps.visible,
	          transitionDuration = nextProps.transitionDuration,
	          overlay = nextProps.overlay;
	
	      if (this.props.visible === nextProps.visible) {
	        return;
	      }
	
	      var type = (0, _getField2.default)(nextProps, this.state, 'type');
	      this._animate(visible, type, transitionDuration, overlay, this.state.desktop);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      if (this._closeTimeout) {
	        clearTimeout(this._closeTimeout);
	      }
	
	      window.removeEventListener('resize', this._updateMedia);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _state = this.state,
	          overlayActive = _state.overlayActive,
	          drawerActive = _state.drawerActive,
	          animating = _state.animating;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          style = _props2.style,
	          className = _props2.className,
	          navStyle = _props2.navStyle,
	          navClassName = _props2.navClassName,
	          component = _props2.component,
	          navItems = _props2.navItems,
	          header = _props2.header,
	          children = _props2.children,
	          inline = _props2.inline,
	          position = _props2.position,
	          overlay = _props2.overlay,
	          clickableDesktopOverlay = _props2.clickableDesktopOverlay,
	          lastChild = _props2.lastChild,
	          portal = _props2.portal,
	          overlayStyle = _props2.overlayStyle,
	          overlayClassName = _props2.overlayClassName,
	          propType = _props2.type,
	          propVisible = _props2.visible,
	          propRenderNode = _props2.renderNode,
	          propNavItemsId = _props2.navItemsId,
	          propZDepth = _props2.zDepth,
	          constantType = _props2.constantType,
	          defaultVisible = _props2.defaultVisible,
	          defaultMedia = _props2.defaultMedia,
	          mobileType = _props2.mobileType,
	          mobileMinWidth = _props2.mobileMinWidth,
	          tabletType = _props2.tabletType,
	          tabletMinWidth = _props2.tabletMinWidth,
	          desktopType = _props2.desktopType,
	          desktopMinWidth = _props2.desktopMinWidth,
	          transitionDuration = _props2.transitionDuration,
	          onMediaTypeChange = _props2.onMediaTypeChange,
	          onVisibilityChange = _props2.onVisibilityChange,
	          autoclose = _props2.autoclose,
	          autocloseAfterInk = _props2.autocloseAfterInk,
	          onVisibilityToggle = _props2.onVisibilityToggle,
	          closeOnNavItemClick = _props2.closeOnNavItemClick,
	          props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'navStyle', 'navClassName', 'component', 'navItems', 'header', 'children', 'inline', 'position', 'overlay', 'clickableDesktopOverlay', 'lastChild', 'portal', 'overlayStyle', 'overlayClassName', 'type', 'visible', 'renderNode', 'navItemsId', 'zDepth', 'constantType', 'defaultVisible', 'defaultMedia', 'mobileType', 'mobileMinWidth', 'tabletType', 'tabletMinWidth', 'desktopType', 'desktopMinWidth', 'transitionDuration', 'onMediaTypeChange', 'onVisibilityChange', 'autoclose', 'autocloseAfterInk', 'onVisibilityToggle', 'closeOnNavItemClick']);
	
	      var _props3 = this.props,
	          navItemsId = _props3.navItemsId,
	          zDepth = _props3.zDepth;
	
	      if (!navItemsId && id) {
	        navItemsId = id + '-nav-items';
	      }
	
	      var desktop = this.state.desktop;
	
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	      var type = (0, _getField2.default)(this.props, this.state, 'type');
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      var mini = (0, _isType.isMini)(type);
	      var temporary = (0, _isType.isTemporary)(type);
	      var floating = _DrawerTypes2.default.FLOATING === type;
	      var permanent = (0, _isType.isPermanent)(type);
	
	      var Component = void 0;
	      if (component) {
	        Component = component;
	      } else if (navItems) {
	        Component = 'nav';
	      } else {
	        Component = 'aside';
	      }
	
	      var navigation = void 0;
	      if (navItems) {
	        navigation = _react2.default.createElement(
	          _List2.default,
	          {
	            ref: this._setNavigation,
	            key: 'navigation',
	            id: navItemsId,
	            style: navStyle,
	            className: (0, _classnames2.default)('md-list--drawer', {
	              'md-toolbar-relative': mini && !visible,
	              'md-background': floating
	            }, navClassName),
	            onClick: this._handleNavClick
	          },
	          navItems.map(_mapToListParts2.default)
	        );
	      }
	
	      if (typeof zDepth === 'undefined') {
	        zDepth = 1;
	        if (floating || inline) {
	          zDepth = 0;
	        } else if (!mini && temporary) {
	          zDepth = 5;
	        }
	      }
	
	      var overlayVisible = overlay;
	      if (typeof overlayVisible !== 'boolean') {
	        overlayVisible = temporary && !mini && (!desktop || clickableDesktopOverlay) && (animating || visible);
	      }
	
	      var drawer = _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          id: id,
	          key: 'drawer',
	          component: Component,
	          zDepth: zDepth,
	          raiseOnHover: false,
	          style: style,
	          className: (0, _classnames2.default)('md-drawer', (_cn = {}, _defineProperty(_cn, 'md-drawer--' + position, !inline), _defineProperty(_cn, 'md-drawer--fixed', !inline), _defineProperty(_cn, 'md-drawer--inline', inline), _defineProperty(_cn, 'md-drawer--active', mini || drawerActive), _defineProperty(_cn, 'md-drawer--mini', mini), _defineProperty(_cn, 'md-transition--deceleration', !mini && !permanent && visible), _defineProperty(_cn, 'md-transition--acceleration', !mini && !permanent && !visible), _defineProperty(_cn, 'md-background', inline || floating), _defineProperty(_cn, 'md-background--card', !floating && !inline), _cn), className)
	        }),
	        header,
	        navigation,
	        children,
	        _react2.default.createElement(_Overlay2.default, {
	          style: overlayStyle,
	          className: overlayClassName,
	          active: overlayActive,
	          onClick: this._closeDrawer,
	          visible: overlayVisible,
	          renderNode: renderNode
	        })
	      );
	
	      if (inline || permanent) {
	        return drawer;
	      } else if (!portal) {
	        return mini || animating || visible ? drawer : null;
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { visible: animating || visible, renderNode: renderNode, lastChild: lastChild },
	        drawer
	      );
	    }
	  }]);
	
	  return Drawer;
	}(_react.PureComponent);
	
	Drawer.DrawerTypes = _DrawerTypes2.default;
	Drawer.propTypes = {
	  /**
	   * An optional id to provide to the drawer. This is generally a good idea to provide if
	   * there are any `navItems` defined.
	   *
	   * @see {@link #navItemsId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the navItems list. If this is omitted and the `id` prop is
	   * defined, it will be defaulted to `${id}-nav-items`.
	   */
	  navItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `List` surrounding the `navItems`.
	   */
	  navStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `List` surrounding the `navItems`.
	   */
	  navClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the overlay.
	   */
	  overlayClassName: _propTypes2.default.string,
	
	  /**
	   * An optional component to render the drawer in. When this prop is undefined, the drawer
	   * will be rendered as a `nav` if the `navItems` prop is defined, otherwise an `aside`.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	
	  /**
	   * An optional list of navigation items to display in the drawer. This list can either contain
	   * a valid child component for a `List` or an object used to create a `Divider`, `Subheader`,
	   * or `ListItem`.
	   *
	   * - To create a divider in the list, set a `divider` key to `true`. Any other keys will be
	   * passed to the `Divider` component.
	   * - To create a subheader in the list, set the `subheader` key to `true`. Any other keys will
	   * be passed to the `Subheader` component.
	   * - To create a list item, just create an object with any normal `ListItem` props.
	   */
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])),
	
	  /**
	   * Boolean if a temporary drawer should close when a nav item is clicked.
	   */
	  autoclose: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display. This _should_ normally be a toolbar.
	   */
	  header: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display after the `header` and `navItems`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The drawer type to use when the current device matches the mobile
	   * media query.
	   */
	  mobileType: _propTypes2.default.oneOf([Drawer.DrawerTypes.TEMPORARY, Drawer.DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The min-width to use for the mobile media query.
	   */
	  mobileMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The drawer type to use when the current device matches the tablet
	   * media query.
	   */
	  tabletType: oneOfDrawerTypes.isRequired,
	
	  /**
	   * The min-width to use for the tablet media query.
	   */
	  tabletMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The drawer type to use when the current device matches the desktop media
	   * query.
	   */
	  desktopType: oneOfDrawerTypes.isRequired,
	
	  /**
	   * The min-width for a desktop screen.
	   */
	  desktopMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional type to enforce across all media sizes. Since `mobile` devices are
	   * included, you are required to manually specify when the `type` should be `temporary`.
	   *
	   * When the `type` is not one of the `temporary` types, the `onMediaTypeChange` prop
	   * must be provided.
	   */
	  type: function type(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var type = props[propName];
	    if ((0, _isType.isTemporary)(type)) {
	      return oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
	    }
	
	    var err = oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
	    if (!err && typeof type !== 'undefined' && !(0, _isType.isMini)(type) && typeof props.onMediaTypeChange === 'undefined') {
	      err = new Error('You provided a `' + propName + '` prop to the ' + component + ' without the `onMediaTypeChange` ' + ('handler. The `onMediaTypeChange` prop must be specified when the `' + propName + '` is not ') + 'one of the `temporary` types.');
	    }
	
	    return err;
	  },
	
	  /**
	   * An optional function to call when the drawer's type changes when the screen resizes.
	   * The callback will include the new `type` that should be used for the screen size,
	   * and an object containing the media matches for `mobile`, `tablet`, and `desktop`.
	   *
	   * ```js
	   * this.props.onMediaTypeChange(Drawer.DrawerTypes.TEMPORARY, {
	   *   mobile: true,
	   *   tablet: false,
	   *   desktop: false,
	   * });
	   * ```
	   */
	  onMediaTypeChange: _propTypes2.default.func,
	
	  /**
	   * The default drawer type to display on initial render. The drawer will automatically
	   * adjust itself to the correct media once it has mounted. This prop is really only useful
	   * for server side rendering.
	   */
	  defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']).isRequired,
	
	  /**
	   * Boolean if there should be a visible overlay when the drawer is visible. The default behavior
	   * is to only include a visible overlay when the `type` is `TEMPORARY` or `TEMPORARY_MINI` and
	   * the device is not a desktop.
	   *
	   * Definining this variable as `true` or `false` will override any default behavior. This means that
	   * if this is enabled for a full-height drawer, an overlay will still be created.
	   */
	  overlay: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the drawer. The overlay that appears for temporary type drawers will still appear in the
	   * separate subtree.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the drawer into. The default is to render as
	   * the first child in the `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the drawer should be rendered as the last child instead of the first child
	   * in the `renderNode` or `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the drawer is visible by default. If this is omitted, the drawer will be visible
	   * if the current drawer type is NOT `Drawer.DrawerTypes.TEMPORARY` or `Drawer.DrawerTypes.TEMPORARY_MINI`.
	   *
	   * This basically means that if you are using the default configuration, a mobile device's drawer
	   * will be hidden while tablets and desktops will be visible.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the drawer is visible. This will force the component to define the `onVisibilityChange`
	   * prop as well as manually updating the drawer's visibility.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the visibility of the drawer is changed. The function will
	   * be called with the new visibility state.
	   *
	   * ```js
	   * onVisibilityChange(!currentlyVisible);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * The drawer's position on the page when it is not `inline`. When the drawer's position is `left`,
	   * the width will be `calc(100vw - 56px)` on mobile devices and `$md-drawer-desktop-width` on desktops.
	   *
	   * When the position is `right`, the width will be `100vw` for mobile devices and scaling to the drawer's
	   * children width on desktops.
	   */
	  position: _propTypes2.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * Boolean if the drawer should be displayed inline instead of fixed to the page. When this prop
	   * is enabled, the `position` prop will not be used.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The `$md-drawer-transition-time` value from sass.
	   */
	  transitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the temporary drawer's overlay should be created on desktop screens. This is really used so that
	   * the drawer will close when a user clicks anywhere on the page except in the drawer.
	   */
	  clickableDesktopOverlay: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `autoclose` feature should wait for the ink transition to finish before automatically
	   * closing the drawer. This will add a `300ms` delay. If this is `false`, there will only be a `17ms` delay.
	   *
	   * > The delay is required so that any event listeners will still be correctly invoked when an item is clicked.
	   */
	  autocloseAfterInk: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `type` prop should be constant across all media sizes. This is only valid if the `type` is
	   * one of the temporary types.
	   *
	   * This will basically mean that when attempting to do a media adjustment, it will use the `type` prop instead of
	   * `mobileType`, `tabletType`, and `desktopType` to determine the next drawer type.
	   */
	  constantType: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional zDepth to apply to the drawer. If this is omitted, the value will be set as follows:
	   * - floating || inline = 1
	   * - temporary = 5
	   * - all others = 1
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  zDepth: _propTypes2.default.number,
	
	  closeOnNavItemClick: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `autoclose` instead'),
	  onVisibilityToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead')
	};
	Drawer.defaultProps = {
	  defaultMedia: 'mobile',
	  mobileType: Drawer.DrawerTypes.TEMPORARY,
	  mobileMinWidth: _media.MOBILE_MIN_WIDTH,
	  tabletType: Drawer.DrawerTypes.PERSISTENT,
	  tabletMinWidth: _media.TABLET_MIN_WIDTH,
	  desktopType: Drawer.DrawerTypes.FULL_HEIGHT,
	  desktopMinWidth: _media.DESKTOP_MIN_WIDTH,
	  position: 'left',
	  transitionDuration: 300,
	  autoclose: true,
	  clickableDesktopOverlay: true,
	  constantType: true
	};
	Drawer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._updateType = function (props) {
	    var onMediaTypeChange = props.onMediaTypeChange,
	        overlay = props.overlay,
	        transitionDuration = props.transitionDuration;
	
	
	    var onVisibilityChange = props.onVisibilityToggle || props.onVisibilityChange;
	
	    var state = Drawer.getCurrentMedia(props);
	    var diffType = (0, _getField2.default)(props, _this2.state, 'type') !== state.type;
	    var diffMedia = state.mobile !== _this2.state.mobile || state.tablet !== _this2.state.tablet || state.desktop !== _this2.state.desktop;
	
	    if (onMediaTypeChange && (diffType || diffMedia)) {
	      onMediaTypeChange(state.type, { mobile: state.mobile, tablet: state.tablet, desktop: state.desktop });
	    }
	
	    if (diffType) {
	      var visible = (0, _isType.isPermanent)(state.type);
	      if (_this2._initialFix) {
	        if (props.defaultVisible) {
	          visible = props.defaultVisible;
	        } else if (props.visible) {
	          visible = props.visible;
	        }
	      }
	
	      var prevVisible = (0, _getField2.default)(props, _this2.state, 'visible');
	      if (onVisibilityChange && visible !== prevVisible) {
	        onVisibilityChange(visible);
	      }
	
	      if (typeof props.visible === 'undefined') {
	        state.visible = visible;
	        _this2._animate(visible, state.type, transitionDuration, overlay, state.desktop);
	      }
	    } else if (_this2._initialFix && diffMedia) {
	      state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(state.type) && !state.desktop) && (0, _getField2.default)(props, _this2.state, 'visible');
	    }
	
	    if (typeof props.type !== 'undefined') {
	      var _state2 = state,
	          type = _state2.type,
	          realState = _objectWithoutProperties(_state2, ['type']); // eslint-disable-line no-unused-vars
	
	
	      state = realState;
	    }
	
	    _this2._initialFix = false;
	    _this2.setState(state);
	  };
	
	  this._updateMedia = function () {
	    _this2._updateType(_this2.props);
	  };
	
	  this._animate = function (visible, type, timeout, overlay, desktop) {
	    if (_this2._timeout) {
	      clearTimeout(_this2._timeout);
	    }
	
	    if (visible) {
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        _this2.setState({
	          overlayActive: overlay || (0, _isType.isTemporary)(type) && !desktop,
	          drawerActive: true,
	          animating: true
	        });
	      }, _CSSTransitionGroupTick2.default);
	    } else {
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        _this2.setState({ animating: false });
	      }, timeout);
	      _this2.setState({ animating: true, overlayActive: false, drawerActive: false });
	    }
	  };
	
	  this._setNavigation = function (navigation) {
	    _this2._navigation = (0, _reactDom.findDOMNode)(navigation);
	  };
	
	  this._handleNavClick = function (e) {
	    var _props4 = _this2.props,
	        closeOnNavItemClick = _props4.closeOnNavItemClick,
	        autoclose = _props4.autoclose,
	        autocloseAfterInk = _props4.autocloseAfterInk;
	
	    var enabled = typeof closeOnNavItemClick !== 'undefined' ? closeOnNavItemClick : autoclose;
	    if (!enabled || !(0, _isType.isTemporary)((0, _getField2.default)(_this2.props, _this2.state, 'type'))) {
	      return;
	    }
	
	    var target = e.target;
	
	    while (target && _this2._navigation.contains(target)) {
	      if (target.classList.contains('md-list-tile')) {
	        // Clicked a nav item that has a nested list
	        if (target.getAttribute('aria-expanded') !== null) {
	          return;
	        }
	
	        _this2._closeTimeout = setTimeout(function () {
	          _this2._closeTimeout = null;
	
	          _this2._closeDrawer(e);
	        }, autocloseAfterInk ? 300 : _CSSTransitionGroupTick2.default);
	        return;
	      }
	
	      target = target.parentNode;
	    }
	  };
	
	  this._closeDrawer = function () {
	    var _props5 = _this2.props,
	        onVisibilityChange = _props5.onVisibilityChange,
	        onVisibilityToggle = _props5.onVisibilityToggle,
	        transitionDuration = _props5.transitionDuration,
	        overlay = _props5.overlay;
	
	    var callback = onVisibilityToggle || onVisibilityChange;
	    if (callback) {
	      callback(false);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: false });
	      _this2._animate(false, (0, _getField2.default)(_this2.props, _this2.state, 'type'), transitionDuration, overlay, _this2.state.desktop);
	    }
	  };
	};
	
	exports.default = Drawer;
	//# sourceMappingURL=Drawer.js.map

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _getDisplayName = __webpack_require__(100);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _InkContainer = __webpack_require__(280);
	
	var _InkContainer2 = _interopRequireDefault(_InkContainer);
	
	var _inkContextTypes = __webpack_require__(282);
	
	var _inkContextTypes2 = _interopRequireDefault(_inkContextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Takes any component and injects an ink container for having the Material Design Ink effect.
	 *
	 * The default triggers for an ink are:
	 * - mouse down event
	 * - touch start event
	 * - keyboard focus
	 * - form submit
	 *
	 * The form submit ink will only be triggered if the `ComposedComponent` has the attribute
	 * `type="submit"`, the `ComposedComponent` is in a form, and the user hits the `enter` key
	 * while not actively focusing the `ComposedComponent`.
	 *
	 * ```js
	 * @param {function} ComposedComponent - The React Component to inject an `ink` prop into.
	 * @return {function} a new React class rendering the `ComposedComponent` and adding an
	 *    `ink` pop.
	 * ```
	 */
	exports.default = function (ComposedComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_PureComponent) {
	    _inherits(InkedComponent, _PureComponent);
	
	    function InkedComponent() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, InkedComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InkedComponent.__proto__ || Object.getPrototypeOf(InkedComponent)).call.apply(_ref, [this].concat(args))), _this), _this.createInk = function (pageX, pageY) {
	        if (_this._inkContainer && !_this.props.disabled && !_this.props.inkDisabled) {
	          _this._inkContainer.createInk(pageX, pageY);
	        }
	      }, _this.focus = function () {
	        if (_this.props.inkDisabled) {
	          var composed = (0, _reactDom.findDOMNode)(_this._composed);
	          if (composed) {
	            composed.focus();
	          }
	        } else if (_this._inkContainer) {
	          _this._inkContainer.focus();
	        }
	      }, _this.getComposedComponent = function () {
	        return _this._composed;
	      }, _this._setInkRef = function (inkContainer) {
	        if (inkContainer) {
	          _this._inkContainer = inkContainer;
	        }
	      }, _this._setComposedComponent = function (component) {
	        _this._composed = component;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(InkedComponent, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var ref = this.props.__SUPER_SECRET_REF__;
	        // Emulate the ref callback...
	
	        if (ref) {
	          ref(this);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var ref = this.props.__SUPER_SECRET_REF__;
	        // Emulate the ref callback...
	
	        if (ref) {
	          ref(null);
	        }
	      }
	
	      /**
	       * A publicly accessible way to manually create an ink. This can be used with the `refs`.
	       * The ink can either be created by using the `pageX` and `pageY` from a click/touch event
	       * or it will be created in the center of the `ComposedComponent`.
	       *
	       * ```js
	       * <SomeInkedComponent ref={inkHOC => inkHOC.createInk()} />
	       * ```
	       *
	       * @param {number=} pageX - An optional pageX of the click or touch event.
	       * @param {number=} pageY - An optional pageY of the click or touch event.
	       */
	
	
	      /**
	       * This will attempt to focus the composed component. If the component is disabled, nothing
	       * will happen. If the `disabled` and `inkDisabled` props are not set to `true`, an ink will
	       * also be created.
	       *
	       * ```js
	       * <SomeInkedComponent ref={inkHOC => inkHOC.focus()} />
	       * ```
	       */
	
	
	      /**
	       * Gets the composed component as a ref. This is useful if you need to access the ref of the
	       * composed component instead of the `injectInk` HOC to use some publicly accessible methods.
	       *
	       * ```js
	       * <SomeInkedComponent
	       *   ref={inkHOC => {
	       *     inkHOC.getComposedComponent().focus();
	       *   }}
	       * />
	       * ```
	       */
	
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            transitionOverlap = _props.inkTransitionOverlap,
	            transitionEnterTimeout = _props.inkTransitionEnterTimeout,
	            transitionLeaveTimeout = _props.inkTransitionLeaveTimeout,
	            inkStyle = _props.inkStyle,
	            inkClassName = _props.inkClassName,
	            inkContainerStyle = _props.inkContainerStyle,
	            inkContainerClassName = _props.inkContainerClassName,
	            waitForInkTransition = _props.waitForInkTransition,
	            disabledInteractions = _props.disabledInteractions,
	            pulse = _props.pulse,
	            propInkDisabled = _props.inkDisabled,
	            __SUPER_SECRET_REF__ = _props.__SUPER_SECRET_REF__,
	            props = _objectWithoutProperties(_props, ['inkTransitionOverlap', 'inkTransitionEnterTimeout', 'inkTransitionLeaveTimeout', 'inkStyle', 'inkClassName', 'inkContainerStyle', 'inkContainerClassName', 'waitForInkTransition', 'disabledInteractions', 'pulse', 'inkDisabled', '__SUPER_SECRET_REF__']);
	
	        var inkDisabled = (0, _getField2.default)(this.props, this.context, 'inkDisabled');
	        var inkDisabledInteractions = typeof disabledInteractions !== 'undefined' ? disabledInteractions : this.context.inkDisabledInteractions;
	
	        if (!(props.disabled || inkDisabled)) {
	          props.ink = _react2.default.createElement(_InkContainer2.default, {
	            ref: this._setInkRef,
	            key: 'ink-container',
	            pulse: pulse,
	            style: inkContainerStyle,
	            className: inkContainerClassName,
	            inkStyle: inkStyle,
	            inkClassName: inkClassName,
	            disabledInteractions: inkDisabledInteractions,
	            transitionOverlap: transitionOverlap,
	            transitionEnterTimeout: transitionEnterTimeout,
	            transitionLeaveTimeout: transitionLeaveTimeout,
	            waitForInkTransition: waitForInkTransition
	          });
	        }
	
	        props.ref = this._setComposedComponent;
	
	        return _react2.default.createElement(ComposedComponent, props);
	      }
	    }]);
	
	    return InkedComponent;
	  }(_react.PureComponent), _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'Ink'), _class.propTypes = {
	    /**
	     * An optional style to apply to each ink that gets generated.
	     */
	    inkStyle: _propTypes2.default.object,
	
	    /**
	     * An optional className to apply to each ink that gets generated.
	     */
	    inkClassName: _propTypes2.default.string,
	
	    /**
	     * An optional style to apply to the ink's container.
	     */
	    inkContainerStyle: _propTypes2.default.object,
	
	    /**
	     * An optional className to apply to the ink's container.
	     */
	    inkContainerClassName: _propTypes2.default.string,
	
	    /**
	     * Boolean if the composed component or the ink is disabled.
	     */
	    disabled: _propTypes2.default.bool,
	
	    /**
	     * Boolean if only the ink is disabled for the composed component.
	     */
	    inkDisabled: _propTypes2.default.bool,
	
	    /**
	     * The time (in ms) that the enter and leave transitions for the ink should overlap.
	     * This really just allows for a more _fluid_ looking ink when something is quickly
	     * touched or clicked by having it fade out while growing.
	     */
	    inkTransitionOverlap: _propTypes2.default.number.isRequired,
	
	    /**
	     * The transition time for the ink to be considered fully entered. This should really
	     * map up to whatever value you set for `$md-ink-enter-transition-time`.
	     */
	    inkTransitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	    /**
	     * The transition time for the ink to be considered fully leaved (left?). This should really
	     * map up to whatever value you set for `$md-ink-leave-transition-time`.
	     */
	    inkTransitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	    /**
	     * Boolean if the `ComposedComponent`'s click event only after the ink has finished transitioning
	     * in and out. This is really only to get a more _fluid_ looking click event when clicking on
	     * the `ComposedComponent` ends up taking it out of the view. (ex: Closing a Dialog).
	     */
	    waitForInkTransition: _propTypes2.default.bool,
	
	    /**
	     * An optional array of interactions that can be disabled for the ink. This is a *very* limited
	     * use case where `Switches` needed the ink disabled only when using a mouse.
	     */
	    disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'mouse', 'touch'])),
	
	    /**
	     * Boolean if the ink should do a pulse animation while focused. This was enabled by default in
	     * previous versions.
	     */
	    pulse: _propTypes2.default.bool,
	
	    /**
	     * When using inked components in a `TransitionGroup`, the ref callback is not actually invoked.
	     * This is a little _hack_ to get it to work by not using `ref`, but this name.
	     */
	    __SUPER_SECRET_REF__: _propTypes2.default.func
	  }, _class.defaultProps = {
	    inkTransitionOverlap: 150,
	    inkTransitionEnterTimeout: 450,
	    inkTransitionLeaveTimeout: 300
	  }, _class.contextTypes = _inkContextTypes2.default, _temp2;
	};
	//# sourceMappingURL=injectInk.js.map

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TileAddon` component is used to render either a `FontIcon` or an `Avatar`
	 * next to the `ListTileText` for a `ListItem`.
	 */
	var TileAddon = function (_PureComponent) {
	  _inherits(TileAddon, _PureComponent);
	
	  function TileAddon() {
	    _classCallCheck(this, TileAddon);
	
	    return _possibleConstructorReturn(this, (TileAddon.__proto__ || Object.getPrototypeOf(TileAddon)).apply(this, arguments));
	  }
	
	  _createClass(TileAddon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          avatar = _props.avatar,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          style = _props.style,
	          className = _props.className;
	
	      if (!icon && !avatar) {
	        return null;
	      }
	
	      var avatarIcon = false;
	      if (avatar) {
	        var avatarChild = _react2.default.Children.only(avatar);
	        if (avatarChild.props.iconSized) {
	          avatarIcon = true;
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-tile-addon', _defineProperty({
	            'md-tile-addon--icon': icon || avatarIcon,
	            'md-tile-addon--avatar': avatar && !avatarIcon
	          }, activeClassName, active), className)
	        },
	        icon || avatar
	      );
	    }
	  }]);
	
	  return TileAddon;
	}(_react.PureComponent);
	
	TileAddon.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  icon: _propTypes2.default.node,
	  avatar: _propTypes2.default.node
	};
	exports.default = TileAddon;
	//# sourceMappingURL=TileAddon.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _mapToListParts = __webpack_require__(102);
	
	var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _anchorShape = __webpack_require__(31);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(32);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Menu = __webpack_require__(46);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `DropdownMenu` is just a simple wrapper to the `Menu` component. The main differences
	 * is that the `toggle` component will now be the children and the list of items to display
	 * will be the `menuItems` prop.
	 *
	 * The dropdown menu is mostly used to control the state of the menu and render a single element
	 * as the toggle.
	 */
	var DropdownMenu = function (_PureComponent) {
	  _inherits(DropdownMenu, _PureComponent);
	
	  function DropdownMenu(props) {
	    _classCallCheck(this, DropdownMenu);
	
	    var _this = _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));
	
	    _this._handleClick = function (e) {
	      var _this$props = _this.props,
	          onVisibilityChange = _this$props.onVisibilityChange,
	          children = _this$props.children;
	
	      var visible = !(0, _getField2.default)(_this.props, _this.state, 'visible');
	      if (onVisibilityChange) {
	        onVisibilityChange(visible, e);
	      }
	
	      var toggle = _react2.default.Children.only(children);
	      if (toggle.props.onClick) {
	        toggle.props.onClick(e);
	      }
	
	      if (typeof _this.props.visible === 'undefined') {
	        _this.setState({ visible: visible });
	      }
	    };
	
	    _this._handleClose = function (e) {
	      var onVisibilityChange = _this.props.onVisibilityChange;
	
	      var visible = false;
	      if (onVisibilityChange) {
	        onVisibilityChange(visible, e);
	      }
	
	      if (typeof _this.props.visible === 'undefined') {
	        _this.setState({ visible: visible });
	      }
	    };
	
	    _this.state = {};
	    if (typeof props.visible === 'undefined') {
	      _this.state.visible = props.defaultVisible;
	    }
	    return _this;
	  }
	
	  _createClass(DropdownMenu, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          listId = _props.listId,
	          menuItems = _props.menuItems,
	          propChildren = _props.children,
	          simplifiedMenu = _props.simplifiedMenu,
	          propVisible = _props.visible,
	          onVisibilityChange = _props.onVisibilityChange,
	          defaultVisible = _props.defaultVisible,
	          props = _objectWithoutProperties(_props, ['id', 'listId', 'menuItems', 'children', 'simplifiedMenu', 'visible', 'onVisibilityChange', 'defaultVisible']);
	
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	
	      var children = _react2.default.Children.only(propChildren);
	      var toggle = _react2.default.cloneElement(children, {
	        id: children.props.id || id + '-toggle',
	        onClick: this._handleClick
	      });
	
	      var items = void 0;
	      if (!Array.isArray(menuItems)) {
	        items = (0, _mapToListParts2.default)(menuItems);
	      } else {
	        items = menuItems.map(_mapToListParts2.default);
	      }
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        _extends({}, props, {
	          simplified: simplifiedMenu,
	          id: id,
	          listId: listId,
	          toggle: toggle,
	          visible: visible,
	          onClose: this._handleClose
	        }),
	        items
	      );
	    }
	  }]);
	
	  return DropdownMenu;
	}(_react.PureComponent);
	
	DropdownMenu.Positions = _Menu2.default.Positions;
	DropdownMenu.HorizontalAnchors = _Menu2.default.HorizontalAnchors;
	DropdownMenu.VerticalAnchors = _Menu2.default.VerticalAnchors;
	DropdownMenu.propTypes = {
	  /**
	   * An id to use for the menu. This is required for accessibility.
	   *
	   * @see {@link Menus/Menu#id}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the menu's list.
	   *
	   * @see {@link Menus/Menu#listId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the menu.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the list.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the list.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * Any additional props to provide to the list.
	   *
	   * @see {@link Menus/Menu#listProps}
	   */
	  listProps: _propTypes2.default.object,
	
	  /**
	   * The z-depth to use for the list.
	   *
	   * @see {@link Menus/Menu/listZDepth}
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should be displayed inline.
	   *
	   * @see {@link Lists/List#inline}
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list's height should be restricted.
	   *
	   * @see {@link Menus/Menu#listHeightRestricted}
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list is currently visible. If this is defined, it will
	   * require the `onVisibilityChange` function to be defined since it will become
	   * a controlled component.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * Boolean if the menu's list should be visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the visibility changes for the menu. The callback will
	   * include the next visibility state and the event that triggered the change.
	   *
	   * ```js
	   * onVisibilityChange(visible, event);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * This is a 0 to many relationship of `ListItem` to display in the menu's `List`. If the type
	   * of the item is a number or string, it will be passed to the `ListItem` as the `primaryText`.
	   * If it is an object, it should be the shape of the `ListItem` props. If it is a node, it will
	   * just be rendered in the `List`.
	   *
	   * @see {@link Lists/ListItem}
	   * @see {@link Menus/Menu#children}
	   */
	  menuItems: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.node]))]),
	
	  /**
	   * @see {@link Menus/Menu#toggle}
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * The anchor position of the menu's list.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is how the menu's list is fixed to the toggle.
	   *
	   * @see {@link Menus/Menu#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * This is the animation position for the menu's list.
	   *
	   * @see {@link Menus/Menu#position}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * Boolean if the menu's list should gain the cascading styles.
	   *
	   * @see {@link Menus/Menu#cascading}
	   */
	  cascading: _propTypes2.default.bool,
	
	  /**
	   * The zDepth to use for the lists that appear in cascading menus.
	   *
	   * @see {@link Menus/Menu#cascadingZDepth}
	   */
	  cascadingZDepth: _propTypes2.default.number,
	
	  /**
	   * The anchor position for the cascading lists.
	   *
	   * @see {@link Menus/Menu#cascadingAnchor}
	   */
	  cascadingAnchor: _anchorShape2.default,
	
	  /**
	   * Boolean if the menu should display as a full width container. This will *not* update the button
	   * to be full width as well.
	   *
	   * @see {@link Menus/Menu#fullWidth}
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's container should display as `block` instead of `inline-block`.
	   *
	   * @see {@link Menus/Menu#block}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list should appear centered related to the button.
	   *
	   * @see {@link Menus/Menu#centered}
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list should be the same width as the button.
	   *
	   * @see {@link Menus/Menu#sameWidth}
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Menus/Menu#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Menus/Menu#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu's list should be closed when an element outside of the menu has been clicked.
	   *
	   * @see {@link Menus/Menu#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * The transition name to use for the menu's list visibility changes.
	   *
	   * @see {@link Menus/Menu#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * The transition name to use when the menu's list gains visibility.
	   *
	   * @see {@link Menus/Menu#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition timeout to use when the menu's list loses visibility.
	   *
	   * @see {@link Menus/Menu#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _Menu2.default.propTypes.minBottom,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool
	};
	DropdownMenu.defaultProps = {
	  defaultVisible: false,
	  repositionOnScroll: true,
	  repositionOnResize: false
	};
	exports.default = DropdownMenu;
	//# sourceMappingURL=DropdownMenu.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `PickerControl` component is the button that goes in the header
	 * of a `Picker` component. It is used to switch the view of the `Picker`
	 * from state to state.
	 *
	 * For example, this is the year and date views for the `DatePicker`.
	 */
	var PickerControl = function (_PureComponent) {
	  _inherits(PickerControl, _PureComponent);
	
	  function PickerControl() {
	    _classCallCheck(this, PickerControl);
	
	    return _possibleConstructorReturn(this, (PickerControl.__proto__ || Object.getPrototypeOf(PickerControl)).apply(this, arguments));
	  }
	
	  _createClass(PickerControl, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          active = _props.active,
	          props = _objectWithoutProperties(_props, ['className', 'active']);
	
	      return _react2.default.createElement('button', _extends({}, props, {
	        type: 'button',
	        className: (0, _classnames2.default)('md-btn md-pointer--hover md-picker-control md-picker-text', {
	          'md-picker-text--active': active
	        }, className)
	      }));
	    }
	  }]);
	
	  return PickerControl;
	}(_react.PureComponent);
	
	PickerControl.propTypes = {
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  children: _propTypes2.default.node.isRequired
	};
	exports.default = PickerControl;
	//# sourceMappingURL=PickerControl.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(9);
	
	var _omit = __webpack_require__(77);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _isValued = __webpack_require__(76);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _isBetween = __webpack_require__(168);
	
	var _isBetween2 = _interopRequireDefault(_isBetween);
	
	var _handleKeyboardAccessibility = __webpack_require__(53);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _anchorShape = __webpack_require__(31);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(32);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Menu = __webpack_require__(46);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ListItem = __webpack_require__(71);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _SelectFieldToggle = __webpack_require__(314);
	
	var _SelectFieldToggle2 = _interopRequireDefault(_SelectFieldToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MOBILE_LIST_PADDING = 8;
	var ARIA_ACTIVE = 'aria-activedescendant';
	
	var SelectField = function (_PureComponent) {
	  _inherits(SelectField, _PureComponent);
	
	  function SelectField(props) {
	    _classCallCheck(this, SelectField);
	
	    var _this = _possibleConstructorReturn(this, (SelectField.__proto__ || Object.getPrototypeOf(SelectField)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = _extends({
	      error: false,
	      active: false
	    }, _this._getActive(props, { value: props.defaultValue }), {
	      listProps: _defineProperty({
	        role: 'listbox',
	        ref: _this._scrollActiveIntoView
	      }, ARIA_ACTIVE, null),
	      match: null,
	      lastSearch: null,
	      value: props.defaultValue,
	      visible: props.defaultVisible
	    });
	
	    _this._items = [];
	    _this._activeItem = null;
	    _this._deleteKeys = _this._getDeleteKeys(props);
	    return _this;
	  }
	
	  _createClass(SelectField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._container = (0, _reactDom.findDOMNode)(this);
	      this._field = this._container.querySelector('.md-select-field');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          itemLabel = _props.itemLabel,
	          itemValue = _props.itemValue,
	          deleteKeys = _props.deleteKeys;
	
	      if (deleteKeys !== nextProps.deleteKeys || itemLabel !== nextProps.itemLabel || itemValue !== nextProps.itemValue) {
	        this._deleteKeys = this._getDeleteKeys(nextProps);
	      }
	
	      if (this.props.value !== nextProps.value || this.props.menuItems !== nextProps.menuItems) {
	        this.setState(this._getActive(nextProps, this.state));
	      }
	    }
	
	    /**
	     * Gets the current value from the select field. This is used when you have an uncontrolled
	     * text field and simply need the value from a ref callback.
	     *
	     * @return {String} the select field's value
	     */
	
	  }, {
	    key: '_getItemPart',
	    value: function _getItemPart(item, itemLabel, itemValue) {
	      var preferLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      var type = typeof item === 'undefined' ? 'undefined' : _typeof(item);
	      if (type === 'number' || type === 'string') {
	        return item;
	      } else if (type === 'object') {
	        var key1 = preferLabel ? itemLabel : itemValue;
	        var key2 = preferLabel ? itemValue : itemLabel;
	        return typeof item[key1] !== 'undefined' ? item[key1] : item[key2];
	      }
	
	      return '';
	    }
	  }, {
	    key: '_getDeleteKeys',
	    value: function _getDeleteKeys(_ref) {
	      var itemLabel = _ref.itemLabel,
	          itemValue = _ref.itemValue,
	          itemProps = _ref.itemProps,
	          deleteKeys = _ref.deleteKeys;
	
	      var keys = [itemLabel, itemValue, itemProps];
	      if (deleteKeys) {
	        return keys.concat(Array.isArray(deleteKeys) ? deleteKeys : [deleteKeys]);
	      }
	
	      return keys;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          style = _props2.style,
	          className = _props2.className,
	          listStyle = _props2.listStyle,
	          listClassName = _props2.listClassName,
	          toggleStyle = _props2.toggleStyle,
	          toggleClassName = _props2.toggleClassName,
	          menuItems = _props2.menuItems,
	          anchor = _props2.anchor,
	          belowAnchor = _props2.belowAnchor,
	          fixedTo = _props2.fixedTo,
	          position = _props2.position,
	          xThreshold = _props2.xThreshold,
	          yThreshold = _props2.yThreshold,
	          listZDepth = _props2.listZDepth,
	          listInline = _props2.listInline,
	          listHeightRestricted = _props2.listHeightRestricted,
	          block = _props2.block,
	          centered = _props2.centered,
	          sameWidth = _props2.sameWidth,
	          fullWidth = _props2.fullWidth,
	          repositionOnScroll = _props2.repositionOnScroll,
	          repositionOnResize = _props2.repositionOnResize,
	          simplifiedMenu = _props2.simplifiedMenu,
	          minLeft = _props2.minLeft,
	          minRight = _props2.minRight,
	          minBottom = _props2.minBottom,
	          fillViewportWidth = _props2.fillViewportWidth,
	          fillViewportHeight = _props2.fillViewportHeight,
	          menuTransitionName = _props2.menuTransitionName,
	          menuTransitionEnterTimeout = _props2.menuTransitionEnterTimeout,
	          menuTransitionLeaveTimeout = _props2.menuTransitionLeaveTimeout,
	          isOpen = _props2.isOpen,
	          propError = _props2.error,
	          propMenuId = _props2.menuId,
	          propVisible = _props2.visible,
	          itemLabel = _props2.itemLabel,
	          itemValue = _props2.itemValue,
	          itemProps = _props2.itemProps,
	          getItemProps = _props2.getItemProps,
	          defaultValue = _props2.defaultValue,
	          defaultVisible = _props2.defaultVisible,
	          onClick = _props2.onClick,
	          onKeyDown = _props2.onKeyDown,
	          onVisibilityChange = _props2.onVisibilityChange,
	          deleteKeys = _props2.deleteKeys,
	          stripActiveItem = _props2.stripActiveItem,
	          keyboardMatchingTimeout = _props2.keyboardMatchingTimeout,
	          defaultOpen = _props2.defaultOpen,
	          initiallyOpen = _props2.initiallyOpen,
	          onMenuToggle = _props2.onMenuToggle,
	          stretchList = _props2.stretchList,
	          menuStyle = _props2.menuStyle,
	          menuClassName = _props2.menuClassName,
	          floatingLabel = _props2.floatingLabel,
	          noAutoAdjust = _props2.noAutoAdjust,
	          adjustMinWidth = _props2.adjustMinWidth,
	          props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'listStyle', 'listClassName', 'toggleStyle', 'toggleClassName', 'menuItems', 'anchor', 'belowAnchor', 'fixedTo', 'position', 'xThreshold', 'yThreshold', 'listZDepth', 'listInline', 'listHeightRestricted', 'block', 'centered', 'sameWidth', 'fullWidth', 'repositionOnScroll', 'repositionOnResize', 'simplifiedMenu', 'minLeft', 'minRight', 'minBottom', 'fillViewportWidth', 'fillViewportHeight', 'menuTransitionName', 'menuTransitionEnterTimeout', 'menuTransitionLeaveTimeout', 'isOpen', 'error', 'menuId', 'visible', 'itemLabel', 'itemValue', 'itemProps', 'getItemProps', 'defaultValue', 'defaultVisible', 'onClick', 'onKeyDown', 'onVisibilityChange', 'deleteKeys', 'stripActiveItem', 'keyboardMatchingTimeout', 'defaultOpen', 'initiallyOpen', 'onMenuToggle', 'stretchList', 'menuStyle', 'menuClassName', 'floatingLabel', 'noAutoAdjust', 'adjustMinWidth']);
	
	      var _props3 = this.props,
	          menuId = _props3.menuId,
	          listId = _props3.listId,
	          error = _props3.error;
	
	      error = error || this.state.error;
	      if (!menuId) {
	        menuId = id + '-menu';
	      }
	
	      if (!listId) {
	        listId = menuId + '-options';
	      }
	
	      var _state = this.state,
	          listProps = _state.listProps,
	          active = _state.active,
	          activeLabel = _state.activeLabel;
	
	      var below = position === SelectField.Positions.BELOW;
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	      var value = (0, _getField2.default)(this.props, this.state, 'value');
	      var useSameWidth = typeof sameWidth !== 'undefined' ? sameWidth : below;
	
	      var toggle = _react2.default.createElement(_SelectFieldToggle2.default, _extends({}, props, {
	        id: id,
	        style: toggleStyle,
	        className: toggleClassName,
	        visible: visible,
	        value: value,
	        below: below,
	        error: error,
	        active: active,
	        activeLabel: activeLabel,
	        onClick: this._toggle,
	        onFocus: this._handleFocus,
	        onBlur: this._handleBlur
	      }));
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        {
	          id: menuId,
	          listId: listId,
	          style: style,
	          className: (0, _classnames2.default)('md-menu--select-field', className),
	          listProps: listProps,
	          listStyle: listStyle,
	          listClassName: listClassName,
	          toggle: toggle,
	          visible: visible,
	          onClose: this._close,
	          onKeyDown: this._handleKeyDown,
	          onClick: this._handleClick,
	          simplified: simplifiedMenu,
	          anchor: anchor,
	          belowAnchor: belowAnchor,
	          fixedTo: fixedTo,
	          position: position,
	          xThreshold: xThreshold,
	          yThreshold: yThreshold,
	          listZDepth: listZDepth,
	          listInline: listInline,
	          listHeightRestricted: listHeightRestricted,
	          sameWidth: useSameWidth,
	          block: block,
	          centered: centered,
	          fullWidth: fullWidth,
	          minLeft: minLeft,
	          minRight: minRight,
	          minBottom: minBottom,
	          fillViewportWidth: fillViewportWidth,
	          fillViewportHeight: fillViewportHeight,
	          repositionOnScroll: repositionOnScroll,
	          repositionOnResize: repositionOnResize,
	          transitionName: menuTransitionName,
	          transitionEnterTimeout: menuTransitionEnterTimeout,
	          transitionLeaveTimeout: menuTransitionLeaveTimeout
	        },
	        menuItems.reduce(this._reduceItems, [])
	      );
	    }
	  }, {
	    key: 'value',
	    get: function get() {
	      return (0, _getField2.default)(this.props, this.state, 'value');
	    }
	  }]);
	
	  return SelectField;
	}(_react.PureComponent);
	
	SelectField.HorizontalAnchors = _Menu2.default.HorizontalAnchors;
	SelectField.VerticalAnchors = _Menu2.default.VerticalAnchors;
	SelectField.Positions = _Menu2.default.Positions;
	SelectField.propTypes = {
	  /**
	   * An id to give the select field. This is required for accessibility.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional name to give to the select field.
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * An optional id to provide to the select field's menu. If this is omitted,
	   * it will default to `${id}-menu`.
	   */
	  menuId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the select field's list.
	   *
	   * @see {@link #menuId}
	   * @see {@link Menus/Menu#menuId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the select field's container (the menu).
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field's container (the menu).
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the menu's list.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu's list.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the select field's toggle.
	   */
	  toggleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field's toggle.
	   */
	  toggleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `AccessibleFakeInkedButton` that is the trigger
	   * for the select field.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `AccessibleFakeInkedButton` that is the trigger
	   * for the select field.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the select field should be have the menu's list visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Boolean if the select field should have the menu's list visible. This will make
	   * the select field controlled and require the `onVisibilityChange` prop to be defined,
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the select field's menu has it's visibility changed. The callback
	   * will include the next visible state and the event that triggered it.
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * A list of `number`, `string`, or `object` that should be used to create `ListItem`
	   * in the menu's list. When it is an `object`, it will use the `itemLabel` prop as the
	   * `primaryText` and use the value of `itemValue`.
	   *
	   * @see {@link #itemLabel}
	   * @see {@link #itemValue}
	   */
	  menuItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element])).isRequired,
	
	  /**
	   * The amount of time that a list of letters should be used when finding a menu item
	   * while typing. Since a user can select items by typing multiple letters in a row,
	   * this will be used as the timeout for clearing those letters.
	   *
	   * For example:
	   * - User types `g`
	   *
	   * Full match is now `'g'`.
	   *
	   * - User delays 200ms and types `u`
	   *
	   * Full match is now `'gu'`
	   *
	   * - User delays 1000ms and types `a`.
	   *
	   * Full match is now `'a'`
	   */
	  keyboardMatchingTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The key to use for extracting a menu item's label if the menu item is an object.
	   *
	   * Example:
	   *
	   * ```js
	   * const item = { something: 'My Label', somethingElse: 'value' };
	   * const itemLabel = 'something';
	   * const itemValue = 'somethingElse';
	   * ```
	   */
	  itemLabel: _propTypes2.default.string.isRequired,
	
	  /**
	   * The key to use for extracting a menu item's value if the menu item is an object.
	   *
	   * Example:
	   *
	   * ```js
	   * const item = { something: 'My Label', somethingElse: 'value' };
	   * const itemLabel = 'something';
	   * const itemValue = 'somethingElse';
	   * ```
	   */
	  itemValue: _propTypes2.default.string.isRequired,
	
	  /**
	   * The key to use for extracting a menu item's function
	   * to get additional `ListItem` props if the menu item is an object.
	   *
	   * Example:
	   *
	   * ```js
	   * const item = { something: 'My Label', addProps: ({active}) => active ? {secondaryText: 'some text'} : null };
	   * const itemLabel = 'something';
	   * const itemProps = 'addProps';
	   * ```
	   *
	   * @see {@link #getItemProps}
	   */
	  itemProps: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional function to get additional `ListItem` props if the menu item is an object.
	   *
	   * An object with the following fields will be passed into the function:
	   * - `index` - item's index
	   * - `active` - whether item is active
	   * - `disabled` - whether item is disabled
	   * - `itemValue` - item's value
	   * - `value` - current list value
	   * - `props` - default `ListItem` props
	   * - `item` - source item's data
	   * - `field` - reference to the component instance
	   */
	  getItemProps: _propTypes2.default.func,
	
	  /**
	   * The default value to use for the select field. If this is set, it should either match
	   * one of the `number` or `string` in your `menuItems` list or be the empty string. If
	   * the `menuItems` is a list of `object`, this value should match one of the menu item's
	   * `itemValue` or be the empty string.
	   *
	   * ```js
	   * const menuItems = [{ label: 'Something': value: 0 }, { label: 'Something else', value: 1 }];
	   *
	   * // both valid
	   * defaultValue={0}
	   * defaultValue=""
	   * ```
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The value to use for the select field. If this is defined, it becomes a controlled component
	   * and requires the `onChange` prop to be defined. See the `defaultValue` for more behavior info.
	   *
	   * @see {@link #defaultValue}
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional function to call when the select field's value has been changed either when the user
	   * has click/touched/keyboard selected a value in the list, or the user has selected a value by typing
	   * in the select field while the menu's list is closed.
	   *
	   * The callback will include the next text field value, the selected item's index, the event that
	   * triggered the change, and the id, name, and value of the select field.
	   *
	   * ```js
	   * onChange(value, index, event, { id, name, value });
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional label to use with the select field. This will be a floating label as seen on the text field.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder to use in the select field. This will only appear when no value has been selected.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * Boolean if the select field should be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the select field is required. This will update the label and placeholder to include a `*` suffix.
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the select field is considered to be in an `error` state.
	   *
	   * @see {@link TextFields/TextField#error}
	   */
	  error: _propTypes2.default.bool,
	
	  /**
	   * An optional text to display when the text select field is in an error state.
	   *
	   * @see {@link TextFields/TextField#errorText}
	   */
	  errorText: _propTypes2.default.node,
	
	  /**
	   * An optional text to display below the select field to provide input help to the user.
	   * This will only be displayed if the select field is not in an error state.
	   *
	   * @see {@link #helpOnFocus}
	   * @see {@link TextFields/TextField#errorText}
	   */
	  helpText: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `helpText` should only appear on focus.
	   *
	   * @see {@link #helpText}
	   * @see {@link TextFields/TextField#helpOnFocus}
	   */
	  helpOnFocus: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when any element in the select field has been clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event has been triggered anywhere in the
	   * select field.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the select field's toggle has gained focus.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the select field's toggle has been blurred. This
	   * will be triggered if the user hits the up or down arrow keys to traverse the list
	   * of items.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * The icon to use to display the dropdown arrow.
	   */
	  dropdownIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the select field is in a toolbar. This should automatically be injected by the `Toolbar`
	   * component if being used as a `titleMenu` or one of the `actions`.
	   *
	   * @see {@link Toolbars/Toolbar#titleMenu}
	   * @see {@link Toolbars/Toolbar#actions}
	   */
	  toolbar: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the currently active item should be removed from the list of available `menuItems`.
	   * If this is `undefined`, it will strip out the active one only when the
	   * `position === SelectField.Positions.BELOW`.
	   */
	  stripActiveItem: _propTypes2.default.bool,
	
	  /**
	   * The transition name to use when a new value has been selected. By default, it will have the
	   * new item _drop_ into the select field's input location.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition time to use when a new value has been selected. If this value is `0`, there
	   * will be no transition.
	   */
	  transitionTime: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is how the menu's `List` gets anchored to the select field.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position for the list that appears.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is how the menu's list will be "fixed" to the `toggle` component.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Boolean if the menu's list should appear horizontally instead of vertically.
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * The list's z-depth for applying box shadow. This should be a number from 0 to 5.
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should have its height restricted to the `$md-menu-mobile-max-height`/
	   * `$md-menu-desktop-max-height` values.
	   *
	   * @see [md-menu-mobile-max-height](/components/menus?tab=1#variable-md-menu-mobile-max-height)
	   * @see [md-menu-desktop-max-height](/components/menus?tab=1#variable-md-menu-desktop-max-height)
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * An optional transition name to use for the list appearing/disappearing.
	   *
	   * @see {@link Menus/Menu#transitionName}
	   */
	  menuTransitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  menuTransitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  menuTransitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Menus/Menu#block}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Menus/Menu#fullWidth}
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _Menu2.default.propTypes.centered,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _Menu2.default.propTypes.sameWidth,
	
	  /**
	   * Since the `menuItems` get mapped into `ListItem`, this prop is used to remove
	   * any unnecessary props from the `ListItem` itself. This is where you
	   * would remove parts of your object such as `description` or `__metadata__`.
	   */
	  deleteKeys: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _Menu2.default.propTypes.minBottom,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  /**
	   * The direction that the underline should appear from.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']).isRequired,
	
	  iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `dropdownIcon` instead'),
	  iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `dropdownIcon` instead'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  defaultOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  onMenuToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead'),
	  stretchList: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid after the changes to the `Menu` component. Possibly use `sameWidth` instead'),
	  menuStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'Use `style` instead'),
	  menuClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `className` instead'),
	  floatingLabel: (0, _deprecated2.default)(_propTypes2.default.bool, 'A select field can only have floating labels now. Only provide the `label` prop'),
	  noAutoAdjust: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid to use since select fields are no longer text fields'),
	  adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid to use since select fields are no longer text fields')
	};
	SelectField.defaultProps = {
	  anchor: {
	    x: SelectField.HorizontalAnchors.INNER_LEFT,
	    y: SelectField.VerticalAnchors.OVERLAP
	  },
	  fixedTo: _Menu2.default.defaultProps.fixedTo,
	  position: SelectField.Positions.TOP_LEFT,
	  itemLabel: 'label',
	  itemValue: 'value',
	  itemProps: 'getProps',
	  dropdownIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_drop_down'
	  ),
	  lineDirection: 'left',
	  menuItems: [],
	  defaultValue: '',
	  defaultVisible: false,
	  keyboardMatchingTimeout: 1000,
	  transitionName: 'md-drop',
	  transitionTime: 300,
	  repositionOnScroll: true,
	  repositionOnResize: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._getActiveItemLabel = function (item, value, itemLabel, itemValue) {
	    var v = _this2._getItemPart(item, itemLabel, itemValue);
	    var label = _this2._getItemPart(item, itemLabel, itemValue, true);
	
	    return v === value || v === parseInt(value, 10) ? label : '';
	  };
	
	  this._getActive = function (props, state) {
	    var activeLabel = '';
	    var activeIndex = -1;
	    var value = (0, _getField2.default)(props, state, 'value');
	    if ((0, _isValued2.default)(value)) {
	      var menuItems = props.menuItems,
	          itemLabel = props.itemLabel,
	          itemValue = props.itemValue;
	
	
	      menuItems.some(function (item, index) {
	        activeLabel = _this2._getActiveItemLabel(item, value, itemLabel, itemValue);
	        var found = (0, _isValued2.default)(activeLabel);
	        if (found) {
	          activeIndex = index;
	        }
	
	        return found;
	      });
	    }
	
	    return { activeLabel: activeLabel, activeIndex: activeIndex };
	  };
	
	  this._attemptItemFocus = function (index) {
	    if (index === -1) {
	      return;
	    }
	
	    var item = _this2._items[index];
	    if (item) {
	      item.focus();
	    }
	  };
	
	  this._setListItem = function (item) {
	    if (!item) {
	      return;
	    }
	
	    if (item.props.active) {
	      _this2._activeItem = (0, _reactDom.findDOMNode)(item);
	      item.focus();
	
	      if (!_this2.state.listProps[ARIA_ACTIVE]) {
	        _this2.setState({ listProps: _extends({}, _this2.state.listProps, _defineProperty({}, ARIA_ACTIVE, _this2.props.id + '-options-active')) });
	      }
	    }
	
	    _this2._items.push(item);
	  };
	
	  this._scrollActiveIntoView = function (listRef) {
	    if (listRef === null) {
	      _this2._items = [];
	      return;
	    } else if (!_this2._activeItem) {
	      return;
	    }
	
	    var list = (0, _reactDom.findDOMNode)(listRef);
	    var offsetTop = _this2._activeItem.offsetTop;
	
	    list.scrollTop = offsetTop > MOBILE_LIST_PADDING ? offsetTop : 0;
	  };
	
	  this._toggle = function (e) {
	    var _props4 = _this2.props,
	        isOpen = _props4.isOpen,
	        onVisibilityChange = _props4.onVisibilityChange,
	        onMenuToggle = _props4.onMenuToggle;
	
	    var visible = !(typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible'));
	    if (onMenuToggle || onVisibilityChange) {
	      (onMenuToggle || onVisibilityChange)(visible, e);
	    }
	
	    var state = void 0;
	    if (typeof isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      state = { visible: visible };
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	
	  this._close = function (e) {
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(false, e);
	    }
	
	    if (e.type === 'keydown' && _this2._field) {
	      _this2._field.focus();
	    }
	
	    var state = void 0;
	    if (_this2.props.required && !(0, _getField2.default)(_this2.props, _this2.state, 'value')) {
	      state = { error: true };
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      state = state || {};
	      state.visible = false;
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	
	  this._handleClick = function (e) {
	    if (_this2.props.onClick) {
	      _this2.props.onClick(e);
	    }
	
	    var isOpen = _this2.props.isOpen;
	
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	    if (visible && _this2._container) {
	      var node = e.target;
	      while (_this2._container.contains(node)) {
	        if (node.dataset && typeof node.dataset.id !== 'undefined') {
	          var _node$dataset = node.dataset,
	              id = _node$dataset.id,
	              value = _node$dataset.value;
	
	          _this2._selectItem(parseInt(id, 10), value, e);
	          return;
	        }
	
	        node = node.parentNode;
	      }
	    }
	  };
	
	  this._selectItem = function (dataIndex, dataValue, e) {
	    var _props5 = _this2.props,
	        required = _props5.required,
	        menuItems = _props5.menuItems,
	        itemLabel = _props5.itemLabel,
	        itemValue = _props5.itemValue,
	        onChange = _props5.onChange,
	        id = _props5.id,
	        name = _props5.name;
	
	    var value = _this2._getItemPart(menuItems[dataIndex], itemLabel, itemValue);
	    var prevValue = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    if (prevValue !== value && onChange) {
	      onChange(value, dataIndex, e, { id: id, name: name, value: value });
	    }
	
	    var state = _extends({}, _this2._getActive({ value: value, itemLabel: itemLabel, itemValue: itemValue, menuItems: menuItems }, {}), {
	      error: !!required && !value && value !== 0
	    });
	
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleFocus = function (e) {
	    if (_this2.props.onFocus) {
	      _this2.props.onFocus(e);
	    }
	
	    _this2.setState({ active: true });
	  };
	
	  this._handleBlur = function (e) {
	    if (_this2.props.onBlur) {
	      _this2.props.onBlur(e);
	    }
	
	    var error = _this2.state.error;
	    var _props6 = _this2.props,
	        isOpen = _props6.isOpen,
	        required = _props6.required;
	
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	
	    if (required && !visible) {
	      error = !value;
	    }
	
	    _this2.setState({ active: false, error: error });
	  };
	
	  this._handleKeyDown = function (e) {
	    var _props7 = _this2.props,
	        isOpen = _props7.isOpen,
	        onKeyDown = _props7.onKeyDown;
	
	    if (onKeyDown) {
	      onKeyDown(e);
	    }
	
	    var key = e.which || e.keyCode;
	    var up = key === _keyCodes.UP;
	    var down = key === _keyCodes.DOWN;
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	
	    if (up || down) {
	      e.preventDefault();
	
	      if (!visible) {
	        _this2._toggle(e);
	        return;
	      }
	
	      _this2._advanceFocus(up);
	    } else if (!visible && (0, _handleKeyboardAccessibility2.default)(e, _this2._toggle, true, true)) {
	      return;
	    } else if (visible && (key === _keyCodes.ESC || key === _keyCodes.TAB)) {
	      if (_this2._field && key === _keyCodes.ESC) {
	        _this2._field.focus();
	      }
	
	      _this2._close(e);
	      return;
	    } else {
	      _this2._selectItemByLetter(key, e);
	    }
	  };
	
	  this._advanceFocus = function (decrement) {
	    var _props8 = _this2.props,
	        position = _props8.position,
	        stripActiveItem = _props8.stripActiveItem;
	    var activeIndex = _this2.state.activeIndex;
	
	
	    var below = position === SelectField.Positions.BELOW;
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    var valued = (0, _isValued2.default)(value);
	    var itemStripped = (typeof stripActiveItem !== 'undefined' ? stripActiveItem : below) && valued;
	
	    // If the select field is positioned below and there is no value, need to increment the last index
	    // by one since this select field removes the active item. Need to account for that here when there
	    // is no value.
	    var lastIndex = _this2._items.length - (itemStripped ? 0 : 1);
	    if (decrement && activeIndex <= 0 || !decrement && activeIndex >= lastIndex) {
	      return;
	    }
	
	    var nextIndex = Math.max(-1, Math.min(lastIndex, activeIndex + (decrement ? -1 : 1)));
	    if (nextIndex === activeIndex) {
	      return;
	    }
	
	    _this2._attemptItemFocus(nextIndex - (itemStripped ? 1 : 0));
	    _this2.setState({ activeIndex: nextIndex });
	  };
	
	  this._selectItemByLetter = function (key, e) {
	    var charCode = String.fromCharCode(key);
	    var isLetter = charCode && charCode.match(/[A-Za-z0-9-_ ]/);
	    var isKeypad = (0, _isBetween2.default)(key, _keyCodes.KEYPAD_ZERO, _keyCodes.KEYPAD_NINE);
	    if (!(0, _isBetween2.default)(key, _keyCodes.ZERO, _keyCodes.NINE) && !isKeypad && !isLetter) {
	      return;
	    }
	
	    var letter = isLetter ? charCode : String(key - (isKeypad ? _keyCodes.KEYPAD_ZERO : _keyCodes.ZERO));
	
	    if (_this2._matchingTimeout) {
	      clearTimeout(_this2._matchingTimeout);
	    }
	
	    _this2._matchingTimeout = setTimeout(function () {
	      _this2._matchingTimeout = null;
	
	      _this2.setState({ match: null, lastSearch: null });
	    }, _this2.props.keyboardMatchingTimeout);
	
	    _this2._selectFirstMatch(letter, e);
	  };
	
	  this._selectFirstMatch = function (letter, e) {
	    var _props9 = _this2.props,
	        menuItems = _props9.menuItems,
	        itemLabel = _props9.itemLabel,
	        itemValue = _props9.itemValue,
	        isOpen = _props9.isOpen,
	        onChange = _props9.onChange,
	        id = _props9.id,
	        name = _props9.name;
	    var lastSearch = _this2.state.lastSearch;
	
	    var match = -1;
	    var search = ('' + (lastSearch || '') + letter).toUpperCase();
	    menuItems.some(function (item, index) {
	      if (item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item.disabled) {
	        return false;
	      }
	
	      var label = String(_this2._getItemPart(item, itemLabel, itemValue, true));
	      if (label && label.toUpperCase().replace(/\s/g, '').indexOf(search) === 0) {
	        match = index;
	      }
	
	      return match > -1;
	    });
	
	    var state = {
	      match: match,
	      lastSearch: search
	    };
	
	    if (match !== -1) {
	      var activeItem = menuItems[match];
	      state.activeLabel = _this2._getItemPart(activeItem, itemLabel, itemValue, true);
	      state.activeIndex = match;
	
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	      if (visible) {
	        if (state.match !== _this2.state.match) {
	          _this2._attemptItemFocus(state.activeIndex);
	        }
	      } else {
	        var value = _this2._getItemPart(activeItem, itemLabel, itemValue);
	        var prevValue = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	
	        if (value !== prevValue && onChange) {
	          onChange(value, match, e, { id: id, name: name, value: value });
	        }
	
	        if (typeof _this2.props.value === 'undefined') {
	          state.value = value;
	        }
	      }
	    }
	
	    _this2.setState(state);
	  };
	
	  this._reduceItems = function (items, item, i) {
	    if (item === null) {
	      return items;
	    } else if (_react2.default.isValidElement(item)) {
	      items.push(item);
	      return items;
	    }
	
	    var _props10 = _this2.props,
	        getItemProps = _props10.getItemProps,
	        id = _props10.id,
	        itemLabel = _props10.itemLabel,
	        itemProps = _props10.itemProps,
	        itemValue = _props10.itemValue,
	        position = _props10.position,
	        stripActiveItem = _props10.stripActiveItem;
	
	    var below = position === SelectField.Positions.BELOW;
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	
	    var dataValue = _this2._getItemPart(item, itemLabel, itemValue);
	    var primaryText = _this2._getItemPart(item, itemLabel, itemValue, true);
	
	    var active = dataValue === value || dataValue === parseInt(value, 10);
	    var stripped = (typeof stripActiveItem !== 'undefined' ? stripActiveItem : below) && active;
	    if (!stripped) {
	      var objectType = (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object';
	      var props = objectType ? (0, _omit2.default)(item, _this2._deleteKeys) : {};
	      var disabled = props.disabled || false;
	      props.ref = disabled ? null : _this2._setListItem;
	      props.id = active ? id + '-options-active' : null;
	      props.active = active;
	      props.tabIndex = -1;
	      props.primaryText = primaryText;
	      props.key = item.key || dataValue;
	      props.role = 'option';
	      props['data-id'] = disabled ? null : i;
	      props['data-value'] = disabled ? null : dataValue;
	
	      var getProps = objectType && item[itemProps] || getItemProps;
	      if (typeof getProps === 'function') {
	        Object.assign(props, getProps({
	          index: i,
	          active: active,
	          disabled: disabled,
	          itemValue: itemValue,
	          value: value,
	          props: props,
	          item: item,
	          field: _this2
	        }));
	      }
	
	      items.push(_react2.default.createElement(_ListItem2.default, props));
	    }
	
	    return items;
	  };
	};
	
	exports.default = SelectField;
	//# sourceMappingURL=SelectField.js.map

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDate;
	/** @module utils/DateUtils/addDate */
	
	/**
	 * Adds a given amount to a date.
	 *
	 * @param {date} sourceDate the date to add
	 * @param {number} amt the amount to add
	 * @param {string} part the date part to add to. ['D', 'M', 'Y']
	 * @return a new Date with the part added or the date if the part is not valid.
	 */
	function addDate(sourceDate, amt, part) {
	  var date = new Date(sourceDate);
	
	  switch (part) {
	    case 'D':
	      return new Date(date.setDate(date.getDate() + amt));
	    case 'M':
	      date.setDate(1);
	      return new Date(date.setMonth(date.getMonth() + amt));
	    case 'Y':
	      return new Date(date.setFullYear(date.getFullYear() + amt));
	    default:
	      return date;
	  }
	}
	//# sourceMappingURL=addDate.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidClick;
	
	var _keyCodes = __webpack_require__(9);
	
	/**
	 * Checks if an event is a valid click event by ignoring
	 * any clisk that are not the left mouse button and not
	 * clicks that involve the shift key.
	 *
	 * @param {Object} e - the event to check
	 * @return {Boolean} true if the event is valid.
	 */
	function isValidClick(e) {
	  return e.button === _keyCodes.LEFT_MOUSE && !e.shiftKey;
	} /** @module utils/EventUtils/isValidClick */
	//# sourceMappingURL=isValidClick.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTextWidth;
	/** @module utils/Positioning/getTextWidth */
	
	var cachedCanvas = void 0;
	
	/**
	 * A utility function to measure the width (in px) of any text. It will require a canvas
	 * and an element to use to determine the current fonts to apply since different fonts will
	 * have different widths.
	 *
	 * This isn't fully accurate since some browsers handle the calculations a bit differently so
	 * they are off by a 0-3px
	 *
	 * @param {String} text - The text to measure the width
	 * @param {HTMLElement} el - The element to use to determine the current font for the text.
	 * @param {HTMLElement=} canvas - An optional canvas to use for doing the calculations. If this
	 *    is omitted, it will just use the locally created canvas to do the calculations.
	 * @return {number} this will either return null if there is a problem calculating the width or
	 *    the length (in px) of the text.
	 */
	function getTextWidth(text, el, canvas) {
	  if (!el) {
	    return null;
	  }
	
	  if (!canvas) {
	    if (!cachedCanvas) {
	      cachedCanvas = document.createElement('canvas');
	    }
	
	    canvas = cachedCanvas;
	  }
	
	  var context = canvas.getContext('2d');
	  if (!context) {
	    // context doesn't exist in testing without complicated mocks
	    return null;
	  }
	
	  var styles = window.getComputedStyle(el);
	  var font = styles.font;
	  // Some browsers do not actually supply the font style since they are on an older version of CSSProperties,
	  // so the font string needs to be made manually.
	  if (!font) {
	    // font-style font-variant font-weight font-size/line-height font-family
	    var sizing = styles.fontSize + ' / ' + styles.lineHeight + ' ' + styles.fontFamily;
	    font = styles.fontStyle + ' ' + styles.fontVariant + ' ' + styles.fontWeight + ' ' + sizing;
	  }
	
	  context.font = font;
	  return context.measureText(text).width;
	}
	//# sourceMappingURL=getTextWidth.js.map

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDisplayName;
	/** @module utils/StringUtils/getDisplayName */
	
	/**
	 * Gets the display name for a composed component.
	 *
	 * @param {function|Object} ComposedComponent - The composed component to use
	 * @param {String} hoc - The higher order component's name to use.
	 * @return {String} the new name of the component.
	 */
	function getDisplayName(ComposedComponent, hoc) {
	  var name = '' + (ComposedComponent.displayName || ComposedComponent.name || 'Component');
	
	  return 'with' + hoc + '(' + name + ')';
	}
	//# sourceMappingURL=getDisplayName.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/bem */
	
	
	exports.default = bem;
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A utility function to apply BEM class names to an element.
	 *
	 * ### Examples:
	 * ```js
	 * bem('class') === 'class'
	 * bem('block', 'element') === 'block__element'
	 * bem('block', 'element', 'sub-element') === 'block__element__sub-element'
	 * bem('block', { 'mod-1': true, 'mod-2': false }) === 'block block--mod-1'
	 * bem('block', 'element', { 'mod-1': false, 'mod-2': true }) === 'block__element block__element--mod-2'
	 * bem('block', 'element', {
	 *   'mod-1': false,
	 *   'mod-2': true,
	 * }, 'other', 'class-names') === 'block__element block__element--mod-2 other class-names'
	 * ```
	 *
	 * @param {...String} blocks - 1 to many blocks to use. These names will be joined
	 *    with underscores.
	 * @param {Object=} modifiers - Any conditional modifiers to apply to the blocks. Each
	 *    key in this object will be applied as a `--suffix` to the blocks ONLY when
	 *    their value is true-ish.
	 * @param {...String} others - Any additional class names to apply.
	 * @return {String} the bem-formatted className string.
	 */
	function bem() {
	  var base = [];
	  var modifiers = null;
	  var remaining = -1;
	
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  args.some(function (arg, i) {
	    if (arg) {
	      var type = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	      if (type === 'number' || type === 'string') {
	        base.push(arg);
	      } else if (type === 'object') {
	        modifiers = arg;
	        remaining = i + 1;
	      }
	    }
	    return modifiers;
	  });
	
	  var element = base.join('__');
	  if (modifiers) {
	    modifiers = Object.keys(modifiers).reduce(function (obj, key) {
	      obj[element + '--' + key] = modifiers[key];
	      return obj;
	    }, {});
	  }
	  var classes = remaining > -1 ? args.slice(remaining) : null;
	  return (0, _classnames2.default)(element, modifiers, classes).trim();
	}
	//# sourceMappingURL=bem.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapToListParts;
	
	var _react = __webpack_require__(1);
	
	var _Divider = __webpack_require__(90);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Subheader = __webpack_require__(155);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _ListItem = __webpack_require__(71);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /** @module utils/mapToListParts */
	
	/**
	 * A utility function to convert any "item" into a valid React element that is used
	 * within the `List` component.
	 *
	 * Use cases:
	 * - is a valid React element -> item returned unmodified
	 * - `number` or `string` -> `ListItem` with the item as the `primaryText`
	 * - an `object` with a key `divider: true` -> a `Divider` component with the remaining
	 *    keys applied as props.
	 * - an `object` with a key `subheader: true` -> a `Subheader` component with the remianing
	 *    keys applied as props. This one technically requires the `primaryText` key to be defined.
	 * - an `object` -> all keys passed into the `ListItem` component.
	 *
	 * Examples:
	 * ```js
	 * mapToListParts('Hello') == <ListItem primaryText="Hello" />
	 * mapToListParts(100)     == <ListItem primaryText={100} />
	 * mapToListParts({ primaryText: 'Item' }) == <ListItem primaryText="Item" />
	 * mapToListParts({ divider: true }) == <Divider />
	 * mapToListParts({ subheader: true, primaryText: 'Subheader' }) == <Subheader primaryText="Subheader" />
	 * ```
	 *
	 * @param {string|number|Object} item - the item to convert
	 * @param {number|string=} index - the current index in the array (if used in an array)
	 * @return {Object} a React element
	 */
	function mapToListParts(item, index) {
	  if (typeof item === 'string' || typeof item === 'number') {
	    return (0, _react.createElement)(_ListItem2.default, { key: item, primaryText: item });
	  } else if ((0, _react.isValidElement)(item)) {
	    return item;
	  }
	
	  var divider = item.divider,
	      subheader = item.subheader,
	      nestedItems = item.nestedItems,
	      remainingProps = _objectWithoutProperties(item, ['divider', 'subheader', 'nestedItems']);
	
	  var component = void 0;
	  if (divider) {
	    component = _Divider2.default;
	  } else if (subheader) {
	    component = _Subheader2.default;
	  } else {
	    component = _ListItem2.default;
	  }
	
	  var props = _extends({}, remainingProps, { key: item.key || index });
	  if (nestedItems) {
	    props.nestedItems = nestedItems.map(mapToListParts);
	  }
	
	  return (0, _react.createElement)(component, props);
	}
	//# sourceMappingURL=mapToListParts.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduceCssCalc = __webpack_require__(747);
	
	var _reduceCssCalc2 = _interopRequireDefault(_reduceCssCalc);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _DOMUtils = __webpack_require__(401);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return { word: word, width: (0, _DOMUtils.getStringSize)(word, props.style).width };
	    });
	
	    var spaceWidth = (0, _DOMUtils.getStringSize)('\xA0', props.style).width;
	
	    return { wordsWithComputedWidth: wordsWithComputedWidth, spaceWidth: spaceWidth };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text = (_temp2 = _class = function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Text);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      wordsByLines: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Text, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var needCalculate = this.props.children !== nextProps.children || this.props.style !== nextProps.style;
	      this.updateWordsByLines(nextProps, needCalculate);
	    }
	  }, {
	    key: 'updateWordsByLines',
	    value: function updateWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	
	
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            this.updateWordsWithoutCalculate(props);
	
	            return;
	          }
	        }
	
	        var wordsByLines = this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	        this.setState({ wordsByLines: wordsByLines });
	      } else {
	        this.updateWordsWithoutCalculate(props);
	      }
	    }
	  }, {
	    key: 'updateWordsWithoutCalculate',
	    value: function updateWordsWithoutCalculate(props) {
	      var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	      this.setState({ wordsByLines: [{ words: words }] });
	    }
	  }, {
	    key: 'calculateWordsByLines',
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	
	      return wordsWithComputedWidth.reduce(function (result, _ref2) {
	        var word = _ref2.word,
	            width = _ref2.width;
	
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = { words: [word], width: width };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          dx = _props.dx,
	          dy = _props.dy,
	          textAnchor = _props.textAnchor,
	          verticalAnchor = _props.verticalAnchor,
	          scaleToFit = _props.scaleToFit,
	          angle = _props.angle,
	          lineHeight = _props.lineHeight,
	          capHeight = _props.capHeight,
	          className = _props.className,
	          textProps = _objectWithoutProperties(_props, ['dx', 'dy', 'textAnchor', 'verticalAnchor', 'scaleToFit', 'angle', 'lineHeight', 'capHeight', 'className']);
	
	      var wordsByLines = this.state.wordsByLines;
	
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	
	      var startDy = void 0;
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + capHeight + ')');
	          break;
	        case 'middle':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) / 2 + ' * -' + lineHeight + ' + (' + capHeight + ' / 2))');
	          break;
	        default:
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) + ' * -' + lineHeight + ')');
	          break;
	      }
	
	      var transforms = [];
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push('scale(' + this.props.width / lineWidth + ')');
	      }
	      if (angle) {
	        transforms.push('rotate(' + angle + ', ' + x + ', ' + y + ')');
	      }
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react2.default.createElement(
	        'text',
	        _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), {
	          x: x,
	          y: y,
	          className: (0, _classnames2.default)('recharts-text', className),
	          textAnchor: textAnchor
	        }),
	        wordsByLines.map(function (line, index) {
	          return _react2.default.createElement(
	            'tspan',
	            { x: x, dy: index === 0 ? startDy : lineHeight, key: index },
	            line.words.join(' ')
	          );
	        })
	      );
	    }
	  }]);
	
	  return Text;
	}(_react.Component), _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _propTypes2.default.bool,
	  angle: _propTypes2.default.number,
	  textAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end']),
	  style: _propTypes2.default.object
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em', // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior
	}, _temp2);
	exports.default = Text;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Dot
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Dot, _Component);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          r = _props.r,
	          className = _props.className;
	
	      var layerClass = (0, _classnames2.default)('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react2.default.createElement('circle', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.Component), _class2.displayName = 'Dot', _class2.propTypes = {
	  className: _propTypes2.default.string,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  r: _propTypes2.default.number
	}, _temp)) || _class;
	
	exports.default = Dot;

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(593),
	    baseMatchesProperty = __webpack_require__(594),
	    identity = __webpack_require__(113),
	    isArray = __webpack_require__(24),
	    property = __webpack_require__(671);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(80),
	    isObjectLike = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview X Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var XAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(XAxis, _Component);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, (XAxis.__proto__ || Object.getPrototypeOf(XAxis)).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.Component), _class2.displayName = 'XAxis', _class2.propTypes = {
	  allowDecimals: _propTypes2.default.bool,
	  allowDuplicatedCategory: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of x-axis
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // The width of axis which is usually calculated internally
	  width: _propTypes2.default.number,
	  // The height of axis, which need to be setted by user
	  height: _propTypes2.default.number,
	  mirror: _propTypes2.default.bool,
	  // The orientation of axis
	  orientation: _propTypes2.default.oneOf(['top', 'bottom']),
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes2.default.array,
	  // The count of ticks
	  tickCount: _propTypes2.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes2.default.func,
	  padding: _propTypes2.default.shape({
	    left: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  }),
	  allowDataOverflow: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(_ReactUtils.SCALE_TYPES), _propTypes2.default.func]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  minTickGap: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: { left: 0, right: 0 },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false,
	  allowDuplicatedCategory: true
	}, _temp)) || _class;
	
	exports.default = XAxis;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Y Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(YAxis, _Component);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, (YAxis.__proto__ || Object.getPrototypeOf(YAxis)).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.Component), _class2.displayName = 'YAxis', _class2.propTypes = {
	  allowDecimals: _propTypes2.default.bool,
	  allowDuplicatedCategory: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of y-axis
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes2.default.array,
	  // The count of ticks
	  tickCount: _propTypes2.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes2.default.func,
	  // The width of axis, which need to be setted by user
	  width: _propTypes2.default.number,
	  // The height of axis which is usually calculated in Chart
	  height: _propTypes2.default.number,
	  mirror: _propTypes2.default.bool,
	  // The orientation of axis
	  orientation: _propTypes2.default.oneOf(['left', 'right']),
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  padding: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    bottom: _propTypes2.default.number
	  }),
	  allowDataOverflow: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  minTickGap: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  allowDuplicatedCategory: true,
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: { top: 0, bottom: 0 },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	}, _temp)) || _class;
	
	exports.default = YAxis;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(24);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(213);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _DataUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed, curveBasisOpen: _d3Shape.curveBasisOpen, curveBasis: _d3Shape.curveBasis, curveLinearClosed: _d3Shape.curveLinearClosed, curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX, curveMonotoneY: _d3Shape.curveMonotoneY, curveNatural: _d3Shape.curveNatural, curveStep: _d3Shape.curveStep, curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	var getX = function getX(p) {
	  return p.x;
	};
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction3.default)(type)) {
	    return type;
	  }
	
	  var name = 'curve' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES['' + name + (layout === 'vertical' ? 'Y' : 'X')];
	  }
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Curve, _Component);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, (Curve.__proto__ || Object.getPrototypeOf(Curve)).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: 'getPath',
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          type = _props.type,
	          points = _props.points,
	          baseLine = _props.baseLine,
	          layout = _props.layout,
	          connectNulls = _props.connectNulls;
	
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction = void 0;
	
	      if ((0, _isArray3.default)(baseLine)) {
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _extends({}, entry, { base: baseLine[index] });
	        });
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	        lineFunction.defined(defined).curve(curveFactory);
	
	        return lineFunction(areaPoints);
	      } else if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          points = _props2.points,
	          path = _props2.path,
	          pathRef = _props2.pathRef;
	
	
	      if ((!points || !points.length) && !path) {
	        return null;
	      }
	
	      var realPath = points && points.length ? this.getPath() : path;
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	        className: (0, _classnames2.default)('recharts-curve', className),
	        d: realPath,
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.Component), _class2.displayName = 'Curve', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  points: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  connectNulls: _propTypes2.default.bool,
	  path: _propTypes2.default.string,
	  pathRef: _propTypes2.default.func
	}), _class2.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	}, _temp)) || _class;
	
	exports.default = Curve;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Rectangle
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(63);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var sign = height >= 0 ? 1 : -1;
	  var clockWise = height >= 0 ? 1 : 0;
	  var path = void 0;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = 'M' + x + ',' + (y + sign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += 'A ' + newRadius[0] + ',' + newRadius[0] + ',0,0,' + clockWise + ',' + (x + newRadius[0]) + ',' + y;
	    }
	
	    path += 'L ' + (x + width - newRadius[1]) + ',' + y;
	
	    if (newRadius[1] > 0) {
	      path += 'A ' + newRadius[1] + ',' + newRadius[1] + ',0,0,' + clockWise + ',\n        ' + (x + width) + ',' + (y + sign * newRadius[1]);
	    }
	    path += 'L ' + (x + width) + ',' + (y + height - sign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += 'A ' + newRadius[2] + ',' + newRadius[2] + ',0,0,' + clockWise + ',\n        ' + (x + width - newRadius[2]) + ',' + (y + height);
	    }
	    path += 'L ' + (x + newRadius[3]) + ',' + (y + height);
	
	    if (newRadius[3] > 0) {
	      path += 'A ' + newRadius[3] + ',' + newRadius[3] + ',0,0,' + clockWise + ',\n        ' + x + ',' + (y + height - sign * newRadius[3]);
	    }
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = 'M ' + x + ',' + (y + sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + _newRadius) + ',' + y + '\n            L ' + (x + width - _newRadius) + ',' + y + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width) + ',' + (y + sign * _newRadius) + '\n            L ' + (x + width) + ',' + (y + height - sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width - _newRadius) + ',' + (y + height) + '\n            L ' + (x + _newRadius) + ',' + (y + height) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + x + ',' + (y + height - sign * _newRadius) + ' Z';
	  } else {
	    path = 'M ' + x + ',' + y + ' h ' + width + ' v ' + height + ' h ' + -width + ' Z';
	  }
	
	  return path;
	};
	
	var Rectangle = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Rectangle, _Component);
	
	  function Rectangle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      totalLength: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Rectangle, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {
	          // calculate total length error
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          radius = _props.radius,
	          className = _props.className;
	      var totalLength = this.state.totalLength;
	      var _props2 = this.props,
	          animationEasing = _props2.animationEasing,
	          animationDuration = _props2.animationDuration,
	          animationBegin = _props2.animationBegin,
	          isAnimationActive = _props2.isAnimationActive,
	          isUpdateAnimationActive = _props2.isUpdateAnimationActive;
	
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          canBegin: totalLength > 0,
	          from: { width: width, height: height, x: x, y: y },
	          to: { width: width, height: height, x: x, y: y },
	          duration: animationDuration,
	          animationEasing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref2) {
	          var currWidth = _ref2.width,
	              currHeight = _ref2.height,
	              currX = _ref2.x,
	              currY = _ref2.y;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              canBegin: totalLength > 0,
	              from: '0px ' + (totalLength === -1 ? 1 : totalLength) + 'px',
	              to: totalLength + 'px 0px',
	              attributeName: 'strokeDasharray',
	              begin: animationBegin,
	              duration: animationDuration,
	              isActive: isAnimationActive,
	              easing: animationEasing
	            },
	            _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	              className: layerClass,
	              d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	              ref: function ref(node) {
	                _this2.node = node;
	              }
	            }))
	          );
	        }
	      );
	    }
	  }]);
	
	  return Rectangle;
	}(_react.Component), _class2.displayName = 'Rectangle', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  isAnimationActive: _propTypes2.default.bool,
	  isUpdateAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = Rectangle;

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  siteTitle: 'TrustKit Analytics',
	  siteSubtitle: '(Free-Forever Edition)',
	
	  attacks: {
	    ordering: ['device_spyware', 'corporate_appliance', 'captive_portal', 'unknown', 'misconfiguration'],
	    catMapping: {
	      'device_spyware': 'User Device Spyware',
	      'captive_portal': 'Insecure Public WiFi',
	      'misconfiguration': 'App Misconfiguration',
	      'corporate_appliance': 'Employer Eavesdropping',
	      'unknown': 'Unknown Actors',
	      'projection': 'Additional Projected (by end-of-month)'
	    },
	    catColors: {
	      'device_spyware': '#EF476F',
	      'captive_portal': '#26547C',
	      'misconfiguration': '#FFD166',
	      'corporate_appliance': '#06D6A0',
	      'unknown': '#E6AA68'
	    }
	  }
	
	};

/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(59);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(16),
	    isLength = __webpack_require__(223);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentDeprecated = __webpack_require__(36);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _injectTooltip = __webpack_require__(72);
	
	var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `IconButton` component automatically includes ink and a tooltip.
	 * The tooltip will only be included if the `tooltipLabel` prop is given.
	 *
	 * Any other props (such as style or event listeners) will also be
	 * applied.
	 */
	var IconButton = function (_PureComponent) {
	  _inherits(IconButton, _PureComponent);
	
	  function IconButton() {
	    _classCallCheck(this, IconButton);
	
	    return _possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).apply(this, arguments));
	  }
	
	  _createClass(IconButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          iconClassName = _props.iconClassName,
	          children = _props.children,
	          tooltip = _props.tooltip,
	          floating = _props.floating,
	          props = _objectWithoutProperties(_props, ['iconClassName', 'children', 'tooltip', 'floating']);
	
	      delete props.tooltipLabel;
	      delete props.tooltipPosition;
	
	      return _react2.default.createElement(
	        _Button2.default,
	        _extends({}, props, { icon: !floating, floating: floating }),
	        tooltip,
	        _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName },
	          children
	        )
	      );
	    }
	  }]);
	
	  return IconButton;
	}(_react.PureComponent);
	
	IconButton.propTypes = {
	  /**
	   * The className to use for rendering the `FontIcon`.
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to use to render the `FontIcon`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Boolean if the IconButton is floating
	  floating: PropTypes.bool,
	   /**
	   * An optional label to use if you would like a tooltip to display
	   * on hover or touch hold.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * The position that the tooltip should be displayed relative to
	   * the button.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * An optional amount of delay before the tooltip appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  // Inject from injectTooltip
	  tooltip: _propTypes2.default.node,
	  floating: _propTypes2.default.bool,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `IconButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `icon`.')
	};
	IconButton.defaultProps = {
	  type: 'button'
	};
	exports.default = (0, _injectTooltip2.default)(IconButton);
	//# sourceMappingURL=IconButton.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBtnStyles;
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Since it can be helpful to apply button styles on other components, this is a utlity function
	 * to apply those styles based on props.
	 */
	function getBtnStyles(_ref) {
	  var _ref2;
	
	  var flat = _ref.flat,
	      raised = _ref.raised,
	      icon = _ref.icon,
	      floating = _ref.floating,
	      disabled = _ref.disabled,
	      primary = _ref.primary,
	      secondary = _ref.secondary,
	      hover = _ref.hover,
	      swapTheming = _ref.swapTheming,
	      pressed = _ref.pressed,
	      mini = _ref.mini,
	      fixed = _ref.fixed,
	      fixedPosition = _ref.fixedPosition;
	
	  var flatStyles = flat || icon;
	  var raisedStyles = raised || floating;
	  var textTheming = flatStyles && !swapTheming || raisedStyles && swapTheming;
	  var backgroundTheming = (!disabled && raisedStyles && !swapTheming || flatStyles && swapTheming) && (primary || secondary);
	
	  for (var _len = arguments.length, classNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    classNames[_key - 1] = arguments[_key];
	  }
	
	  return _classnames2.default.apply(undefined, ['md-btn', (_ref2 = {
	    'md-btn--flat': flat || disabled && raised,
	    'md-btn--raised': !disabled && raised,
	    'md-btn--icon': icon || floating,
	    'md-btn--floating': floating,
	    'md-btn--text': flat || raised,
	    'md-btn--hover': !disabled && hover,
	    'md-btn--raised-disabled': disabled && raised,
	    'md-btn--raised-pressed': !disabled && raisedStyles && pressed,
	    'md-btn--fixed': fixed
	  }, _defineProperty(_ref2, 'md-btn--fixed-' + fixedPosition, floating && fixed), _defineProperty(_ref2, 'md-btn--floating-mini', floating && mini), _defineProperty(_ref2, 'md-btn--color-primary-active', !disabled && primary && hover && textTheming), _defineProperty(_ref2, 'md-btn--color-secondary-active', !disabled && secondary && hover && textTheming), _defineProperty(_ref2, 'md-pointer--hover', !disabled), _defineProperty(_ref2, 'md-paper md-paper--2', !disabled && floating), _defineProperty(_ref2, 'md-paper--4', !disabled && floating && pressed), _ref2), (0, _themeColors2.default)({
	    text: !icon && !floating && !backgroundTheming,
	    themeText: !backgroundTheming,
	    disabled: disabled,
	    primary: primary,
	    secondary: secondary,
	    hover: true,
	    ink: true
	  })].concat(classNames));
	}
	//# sourceMappingURL=getBtnStyles.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _CardExpander = __webpack_require__(130);
	
	var _CardExpander2 = _interopRequireDefault(_CardExpander);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardActions` component is used for adding actions on your card.
	 * The actions should be `FlatButton`s or `IconButton`s.
	 *
	 * This component can act as a `CardExpander`.
	 */
	var CardActions = function (_Component) {
	  _inherits(CardActions, _Component);
	
	  function CardActions() {
	    _classCallCheck(this, CardActions);
	
	    return _possibleConstructorReturn(this, (CardActions.__proto__ || Object.getPrototypeOf(CardActions)).apply(this, arguments));
	  }
	
	  _createClass(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          isExpander = _props.isExpander,
	          expander = _props.expander,
	          centered = _props.centered,
	          stacked = _props.stacked,
	          props = _objectWithoutProperties(_props, ['className', 'children', 'isExpander', 'expander', 'centered', 'stacked']);
	
	      return _react2.default.createElement(
	        'section',
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-dialog-footer--card', {
	            'md-dialog-footer--inline': !stacked,
	            'md-dialog-footer--stacked': stacked,
	            'md-dialog-footer--card-centered': centered
	          }, className)
	        }),
	        children,
	        isExpander || expander && _react2.default.createElement(_CardExpander2.default, null)
	      );
	    }
	  }]);
	
	  return CardActions;
	}(_react.Component);
	
	CardActions.propTypes = {
	  /**
	   * Boolean if this component should act as an expander and inject the
	   * `CardExpander`.
	   */
	  expander: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to the actions container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An actions to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the actions should be centered.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the actions should be stacked.
	   */
	  stacked: _propTypes2.default.bool,
	
	  isExpander: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expander` instead')
	};
	exports.default = CardActions;
	//# sourceMappingURL=CardActions.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contextTypes = __webpack_require__(133);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _getCollapserStyles = __webpack_require__(75);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The CardExpander component is just a simple `IconButton` that
	 * gets generated through the `Card`'s `contextTypes`. Props are not used
	 * at all.
	 *
	 * Any component below a component that has this component inject into it
	 * and has the prop `expandable={true}` will be toggleable when this is clicked.
	 *
	 * You can manually inject the `CardExpander` component yourself if you want to
	 * use a component that is not a `CardActions` or a `CardTitle`.
	 */
	var CardExpander = function (_Component) {
	  _inherits(CardExpander, _Component);
	
	  function CardExpander() {
	    _classCallCheck(this, CardExpander);
	
	    return _possibleConstructorReturn(this, (CardExpander.__proto__ || Object.getPrototypeOf(CardExpander)).apply(this, arguments));
	  }
	
	  _createClass(CardExpander, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context,
	          expanded = _context.expanded,
	          onExpandClick = _context.onExpandClick,
	          icon = _context.icon,
	          tooltipPosition = _context.tooltipPosition,
	          tooltipLabel = _context.tooltipLabel,
	          tooltipDelay = _context.tooltipDelay;
	
	
	      return _react2.default.createElement(_Button2.default, {
	        icon: true,
	        className: (0, _getCollapserStyles2.default)({ flipped: expanded }, 'md-collapser--card'),
	        onClick: onExpandClick,
	        tooltipLabel: tooltipLabel,
	        tooltipDelay: tooltipDelay,
	        tooltipPosition: tooltipPosition,
	        iconEl: icon
	      });
	    }
	  }]);
	
	  return CardExpander;
	}(_react.Component);
	
	CardExpander.contextTypes = _contextTypes2.default;
	exports.default = CardExpander;
	//# sourceMappingURL=CardExpander.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _CardTitleBlock = __webpack_require__(132);
	
	var _CardTitleBlock2 = _interopRequireDefault(_CardTitleBlock);
	
	var _CardExpander = __webpack_require__(130);
	
	var _CardExpander2 = _interopRequireDefault(_CardExpander);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardTitle` component is used to render a title in a Card along
	 * with an optional subtitle or avatar.
	 */
	var CardTitle = function (_Component) {
	  _inherits(CardTitle, _Component);
	
	  function CardTitle() {
	    _classCallCheck(this, CardTitle);
	
	    return _possibleConstructorReturn(this, (CardTitle.__proto__ || Object.getPrototypeOf(CardTitle)).apply(this, arguments));
	  }
	
	  _createClass(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          style = _props.style,
	          className = _props.className,
	          title = _props.title,
	          subtitle = _props.subtitle,
	          expander = _props.expander,
	          isExpander = _props.isExpander,
	          children = _props.children,
	          propAvatar = _props.avatar,
	          props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'title', 'subtitle', 'expander', 'isExpander', 'children', 'avatar']);
	
	      var avatar = this.props.avatar;
	
	      if (avatar) {
	        var avatarClassName = _react.Children.only(avatar).props.className;
	
	        avatar = (0, _react.cloneElement)(avatar, {
	          className: (0, _classnames2.default)('md-avatar--card', avatarClassName)
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          style: style,
	          className: (0, _classnames2.default)('md-card-title', {
	            'md-card-title--primary': !avatar
	          }, className)
	        }),
	        avatar,
	        _react2.default.createElement(_CardTitleBlock2.default, { id: id, title: title, subtitle: subtitle, avatar: !!avatar }),
	        children,
	        isExpander || expander && _react2.default.createElement(_CardExpander2.default, null)
	      );
	    }
	  }]);
	
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.propTypes = {
	  /**
	   * An optional id to add to the `title`.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The title to display.
	   */
	  title: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional subtitle to display.
	   */
	  subtitle: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display in the title block
	   * after the avatar, title, and subtitle.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional avatar to display before the title and subtitle.
	   */
	  avatar: _propTypes2.default.element,
	
	  /**
	   * Boolean if the `CardTitle` component should inject a button
	   * for expanding all children below it.
	   */
	  expander: _propTypes2.default.bool,
	
	  isExpander: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expander` instead')
	};
	exports.default = CardTitle;
	//# sourceMappingURL=CardTitle.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardTitleBlock = function (_PureComponent) {
	  _inherits(CardTitleBlock, _PureComponent);
	
	  function CardTitleBlock() {
	    _classCallCheck(this, CardTitleBlock);
	
	    return _possibleConstructorReturn(this, (CardTitleBlock.__proto__ || Object.getPrototypeOf(CardTitleBlock)).apply(this, arguments));
	  }
	
	  _createClass(CardTitleBlock, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          subtitle = _props.subtitle,
	          avatar = _props.avatar;
	      var title = this.props.title;
	
	      title = _react2.default.createElement(
	        'h2',
	        {
	          id: id,
	          className: (0, _classnames2.default)('md-card-title--title', {
	            'md-card-title--large': !avatar
	          }, (0, _themeColors2.default)({ text: true })),
	          tabIndex: id ? -1 : null
	        },
	        title
	      );
	
	      if (!subtitle) {
	        return title;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('md-card-title--title-block', {
	            'md-card-title--one-line': avatar
	          })
	        },
	        title,
	        _react2.default.createElement(
	          'h3',
	          { className: 'md-card-title--title ' + (0, _themeColors2.default)({ hint: true }) },
	          subtitle
	        )
	      );
	    }
	  }]);
	
	  return CardTitleBlock;
	}(_react.PureComponent);
	
	CardTitleBlock.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  title: _propTypes2.default.node.isRequired,
	  subtitle: _propTypes2.default.node,
	  avatar: _propTypes2.default.bool
	};
	exports.default = CardTitleBlock;
	//# sourceMappingURL=CardTitleBlock.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  onExpandClick: _propTypes2.default.func,
	  expanded: _propTypes2.default.bool,
	  icon: _propTypes2.default.element,
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  tooltipLabel: _propTypes2.default.node,
	  tooltipDelay: _propTypes2.default.number
	};
	//# sourceMappingURL=contextTypes.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is just a simple <tfoot> component.
	 */
	var TableFooter = function (_PureComponent) {
	  _inherits(TableFooter, _PureComponent);
	
	  function TableFooter() {
	    _classCallCheck(this, TableFooter);
	
	    return _possibleConstructorReturn(this, (TableFooter.__proto__ || Object.getPrototypeOf(TableFooter)).apply(this, arguments));
	  }
	
	  _createClass(TableFooter, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { footer: true };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'children']);
	
	      return _react2.default.createElement(
	        'tfoot',
	        _extends({ className: (0, _classnames2.default)('md-table-footer', className) }, props),
	        children
	      );
	    }
	  }]);
	
	  return TableFooter;
	}(_react.PureComponent);
	
	TableFooter.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children to display. This should really be one or a list of `TableRow`
	   * components.
	   */
	  children: _propTypes2.default.node
	};
	TableFooter.childContextTypes = {
	  footer: _propTypes2.default.bool
	};
	exports.default = TableFooter;
	//# sourceMappingURL=TableFooter.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findFixedTo;
	function findFixedTo(table) {
	  if (table && table.firstChild.firstChild.classList.contains('md-data-table__scroll-wrapper')) {
	    return {
	      x: table,
	      y: table.firstChild.firstChild
	    };
	  }
	
	  return table;
	}
	//# sourceMappingURL=findFixedTo.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Drawers/DrawerTypes */
	
	/**
	 * An enum for all the different type of drawers.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var DrawerTypes = {
	  // Permanent drawers
	  /**
	   * This is the default drawer type. It will always be on the screen and takes
	   * up the entire height. This is very helpful for main navigation on desktops
	   * when you do not need an expandable workspace.
	   */
	  FULL_HEIGHT: 'full-height',
	
	  /**
	   * This drawer type will always be on the screen, but it will appear under the
	   * main toolbar.
	   */
	  CLIPPED: 'clipped',
	
	  /**
	   * This drawer type will always be on the screen, but it will appear under the
	   * main toolbar and have a transparent background. This is useful if you want
	   * a persistent drawer on desktop screens, but do not want the main focus to be
	   * the drawer.
	   */
	  FLOATING: 'floating',
	
	  // Persistent drawers
	  /**
	   * A persistent drawer changes between being hidden and being fixed on the page like
	   * a permanent drawer. When it is visible, it will take up the same amount of room
	   * as a permanent drawer, and will not go away until closed.
	   *
	   * This drawer type is helpful when you need to have a dynamic workspace size.
	   */
	  PERSISTENT: 'persistent',
	
	  /**
	   * This is a modification of the persistent drawer. It will behave as the persistent drawer
	   * but it will always have a "mini" drawer visible. This is helpful when you want to have
	   * a dynamic workspace size and keep certain actions available at all times.
	   */
	  PERSISTENT_MINI: 'persistent-mini',
	
	  // Temporary
	  /**
	   * A temporary drawer will not be visible by default. When it is visible, it will overlay
	   * the page to get the main focus on the drawer. When the user touches the overlay or
	   * one of the navigation items, the drawer will be closed. The overlay can be disabled on
	   * desktop and tablets.
	   */
	  TEMPORARY: 'temporary',
	
	  /**
	   * This is a modification of the temporary drawer. It will behave like a temporary drawer,
	   * but it will always have a "mini" drawer visible. Just like the `PERSISTENT_MINI` drawer
	   * type, this is useful when certain actions should be available at all times but additional
	   * actions are available when the drawer is visible.
	   */
	  TEMPORARY_MINI: 'temporary-mini'
	};
	
	exports.default = DrawerTypes;
	//# sourceMappingURL=DrawerTypes.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isTemporary = isTemporary;
	exports.isPersistent = isPersistent;
	exports.isPermanent = isPermanent;
	exports.isMini = isMini;
	
	var _DrawerTypes = __webpack_require__(136);
	
	var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FULL_HEIGHT = _DrawerTypes2.default.FULL_HEIGHT,
	    CLIPPED = _DrawerTypes2.default.CLIPPED,
	    FLOATING = _DrawerTypes2.default.FLOATING,
	    PERSISTENT = _DrawerTypes2.default.PERSISTENT,
	    PERSISTENT_MINI = _DrawerTypes2.default.PERSISTENT_MINI,
	    TEMPORARY = _DrawerTypes2.default.TEMPORARY,
	    TEMPORARY_MINI = _DrawerTypes2.default.TEMPORARY_MINI;
	function isTemporary(type) {
	  return [TEMPORARY, TEMPORARY_MINI].indexOf(type) !== -1;
	}
	
	function isPersistent(type) {
	  return [PERSISTENT, PERSISTENT_MINI].indexOf(type) !== -1;
	}
	
	function isPermanent(type) {
	  return [FULL_HEIGHT, CLIPPED, FLOATING].indexOf(type) !== -1;
	}
	
	function isMini(type) {
	  return [PERSISTENT_MINI, TEMPORARY_MINI].indexOf(type) !== -1;
	}
	//# sourceMappingURL=isType.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(9);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _captureNextEvent = __webpack_require__(52);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _getBtnStyles = __webpack_require__(128);
	
	var _getBtnStyles2 = _interopRequireDefault(_getBtnStyles);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _IconSeparator = __webpack_require__(44);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _AccessibleFakeInkedButton = __webpack_require__(25);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `FileInput` component is used as simple styling for the `<input type="file" />`.
	 * It will style the input as a raised button by default.
	 */
	var FileInput = function (_PureComponent) {
	  _inherits(FileInput, _PureComponent);
	
	  function FileInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FileInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileInput.__proto__ || Object.getPrototypeOf(FileInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false, pressed: false, value: '' }, _this._handleChange = function (e) {
	      var _this$props = _this.props,
	          multiple = _this$props.multiple,
	          onChange = _this$props.onChange,
	          allowDuplicates = _this$props.allowDuplicates;
	      var _e$target = e.target,
	          files = _e$target.files,
	          value = _e$target.value;
	
	      if (onChange) {
	        if (!multiple) {
	          onChange(files[0] || null, e);
	        } else {
	          onChange(Array.prototype.slice.call(files), e);
	        }
	      }
	
	      if (!allowDuplicates) {
	        _this.setState({ value: value });
	      }
	    }, _this._blur = function () {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (_this._timeout) {
	        _this._attemptedBlur = true;
	      } else {
	        _this.setState({ pressed: false });
	      }
	    }, _this._handleMouseUp = function (e) {
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(e);
	      }
	
	      _this._blur();
	    }, _this._handleMouseDown = function (e) {
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ pressed: true });
	      }
	    }, _this._handleTouchStart = function (e) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ pressed: true });
	      }
	    }, _this._handleTouchEnd = function (e) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(e);
	      }
	
	      _this._blur();
	      (0, _captureNextEvent2.default)('mouseover');
	    }, _this._handleKeyUp = function (e) {
	      if (_this.props.onKeyUp) {
	        _this.props.onKeyUp(e);
	      }
	
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        window.addEventListener('click', _this._blur);
	        _this.setState({ pressed: true });
	      }
	    }, _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      var key = e.which || e.keyCode;
	
	      if (key === _keyCodes.TAB) {
	        window.removeEventListener('click', _this._blur);
	        _this.setState({ pressed: false });
	      } else if (key === _keyCodes.SPACE || key === _keyCodes.ENTER) {
	        e.preventDefault();
	        e.target.click();
	      }
	    }, _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ hover: true });
	      }
	    }, _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ hover: false });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FileInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.disabled && !nextProps.disabled && this.state.hover) {
	        this.setState({ hover: false });
	      }
	
	      if (nextProps.allowDuplicates && this.state.value) {
	        this.setState({ value: '' });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var _this2 = this;
	
	      // I honestly don't remember why this was implemented, but it was copied from the Button
	      // component
	      if (!this.state.pressed && nextState.pressed) {
	        this._timeout = setTimeout(function () {
	          _this2._timeout = null;
	          if (_this2._attemptedBlur) {
	            _this2._attemptedBlur = false;
	
	            _this2.setState({ pressed: false });
	          }
	        }, 450);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      window.removeEventListener('click', this._blur);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          hover = _state.hover,
	          pressed = _state.pressed;
	
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          labelStyle = _props.labelStyle,
	          labelClassName = _props.labelClassName,
	          label = _props.label,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          flat = _props.flat,
	          id = _props.id,
	          name = _props.name,
	          iconBefore = _props.iconBefore,
	          disabled = _props.disabled,
	          accept = _props.accept,
	          multiple = _props.multiple,
	          swapTheming = _props.swapTheming,
	          iconChildren = _props.iconChildren,
	          iconClassName = _props.iconClassName,
	          propIcon = _props.icon,
	          propValue = _props.value,
	          allowDuplicates = _props.allowDuplicates,
	          onChange = _props.onChange,
	          onKeyUp = _props.onKeyUp,
	          onKeyDown = _props.onKeyDown,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseOver = _props.onMouseOver,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'labelStyle', 'labelClassName', 'label', 'primary', 'secondary', 'flat', 'id', 'name', 'iconBefore', 'disabled', 'accept', 'multiple', 'swapTheming', 'iconChildren', 'iconClassName', 'icon', 'value', 'allowDuplicates', 'onChange', 'onKeyUp', 'onKeyDown', 'onMouseUp', 'onMouseDown', 'onMouseOver', 'onMouseLeave', 'onTouchStart', 'onTouchEnd']);
	
	      var value = (0, _getField2.default)(this.props, this.state, 'value');
	      var icon = this.props.icon;
	
	      if (iconClassName || iconChildren) {
	        icon = _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName },
	          iconChildren
	        );
	      }
	
	      var labelChildren = label;
	      if (icon) {
	        icon = _react2.default.cloneElement(icon, { inherit: true });
	        labelChildren = _react2.default.createElement(
	          _IconSeparator2.default,
	          { label: label, iconBefore: iconBefore },
	          icon
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          style: style,
	          className: (0, _classnames2.default)('md-inline-block md-file-input-container', className)
	        }),
	        _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          {
	            component: 'label',
	            htmlFor: id,
	            disabled: disabled,
	            onTouchStart: this._handleTouchStart,
	            onTouchEnd: this._handleTouchEnd,
	            onMouseDown: this._handleMouseDown,
	            onMouseUp: this._handleMouseUp,
	            onKeyDown: this._handleKeyDown,
	            onKeyUp: this._handleKeyUp,
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave,
	            style: labelStyle,
	            className: (0, _getBtnStyles2.default)({
	              flat: flat,
	              raised: !flat,
	              disabled: disabled,
	              primary: primary,
	              secondary: secondary,
	              hover: hover,
	              swapTheming: swapTheming,
	              pressed: pressed
	            }, labelClassName)
	          },
	          labelChildren
	        ),
	        _react2.default.createElement('input', {
	          id: id,
	          name: name,
	          accept: accept,
	          type: 'file',
	          multiple: multiple,
	          disabled: disabled,
	          'aria-hidden': 'true',
	          className: 'md-file-input',
	          onChange: this._handleChange,
	          value: value,
	          tabIndex: -1
	        })
	      );
	    }
	  }]);
	
	  return FileInput;
	}(_react.PureComponent);
	
	FileInput.propTypes = {
	  /**
	   * The id for the text field. This is required for a11y and to get the `input type="file"` to
	   * open.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional name to provide to the input.
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the label.
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the label.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled as a flat button instead of a
	   * raised button.
	   */
	  flat: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the theming should be swapped from text to background or vice-versa.
	   *
	   * @see {@link Buttons/Button#swapTheming}
	   */
	  swapTheming: _propTypes2.default.bool,
	
	  /**
	   * This should be a comma separated list of Media Types that the `FileInput` can
	   * accept. If this prop is left blank, any file will be accepted.
	   *
	   * The values can either be:
	   * - A file extension
	   * - audio/*
	   * - video/*
	   * - image/*
	   * - any valid [IANA Media Type](http://www.iana.org/assignments/media-types/media-types.xhtml)
	   *
	   * > NOTE: IE does not enforce this.
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Boolean if the same file is allowed to be uploaded multiple times. This will basically make the
	   * `value` of the file input always blank.
	   */
	  allowDuplicates: _propTypes2.default.bool,
	
	  /**
	   * Boolean if multiple files will be accepted.
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * A label to display on the `FileInput`. This will be used with the `AccessibleFakeInkedButton` component to
	   * create a `<label>` for the `<input type="file">`.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the icons should appear before the label.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to display with the file download. This can be a `FontIcon` or an `SVGIcon`.
	   */
	  icon: _propTypes2.default.element,
	
	  /**
	   * A function to call when the value of the input changes. This will
	   * be triggered when the user selects a new file or cancels the new file selection.
	   *
	   * This function will be given the new [FileList](https://developer.mozilla.org/en-US/docs/Web/API/FileList)
	   * as an array and the change event. If this is not a multiple file input, only the
	   * newly selected File will be given instead of a list of one file. Since this is an
	   * `input` tag, the user will not be able to select the same file multiple times unless
	   * you manually clear the input's value.
	   *
	   * > NOTE: If the user hits cancel, null will be given for a single file input.
	   *
	   * ```js
	   * onChange(files, e);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional value to apply to the `FileInput`. This is usually not needed and the
	   * `allowDuplicates` is what you are probably looking for instead.
	   *
	   * @see {@link #allowDuplicates}
	   */
	  value: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `FileInput` is currently disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when they keyup event is triggered on the file input's label.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they keydown event is triggered on the file input's label.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mouseup event is triggered on the file input's label.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mousedown event is triggered on the file input's label.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mouseover event is triggered on the file input's label.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mouseleave event is triggered on the file input's label.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they touchend event is triggered on the file input's label.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they touchstart event is triggered on the file input's label.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `icon` instead'),
	  iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `icon` instead')
	};
	FileInput.defaultProps = {
	  label: 'Select a file',
	  icon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'file_upload'
	  ),
	  allowDuplicates: false
	};
	exports.default = FileInput;
	//# sourceMappingURL=FileInput.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontIcon = undefined;
	
	var _FontIcon2 = __webpack_require__(8);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon3.default;
	exports.FontIcon = _FontIcon3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bem2 = __webpack_require__(101);
	
	var _bem3 = _interopRequireDefault(_bem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['className', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden'];
	
	var Cell = function (_PureComponent) {
	  _inherits(Cell, _PureComponent);
	
	  _createClass(Cell, null, [{
	    key: 'getClassName',
	
	
	    /**
	     * A utility function to get the cell's className based on the Cell's props. This is
	     * used behind the scenes to merge and create the className for the cell.
	     *
	     * ### Example:
	     * ```js
	     * <div className={Cell.getClassName()}>A simple cell</div>
	     * <div className={Cell.getClassName({ size: 1 })}>A cell with size 1</div>
	     * ```
	     *
	     * @param {Object=} props - This should be an object of the `Cell`'s props. It
	     *    will extract the needed keys and generate the className.
	     * @return {String} the full className to use for the cell
	     */
	    value: function getClassName() {
	      var _bem;
	
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var className = props.className,
	          align = props.align,
	          position = props.position,
	          size = props.size,
	          order = props.order,
	          offset = props.offset,
	          phoneSize = props.phoneSize,
	          phoneOrder = props.phoneOrder,
	          phoneOffset = props.phoneOffset,
	          phoneHidden = props.phoneHidden,
	          tabletSize = props.tabletSize,
	          tabletOrder = props.tabletOrder,
	          tabletOffset = props.tabletOffset,
	          tabletHidden = props.tabletHidden,
	          desktopSize = props.desktopSize,
	          desktopOrder = props.desktopOrder,
	          desktopOffset = props.desktopOffset,
	          desktopHidden = props.desktopHidden;
	
	
	      return (0, _bem3.default)('md-cell', (_bem = {}, _defineProperty(_bem, align, align), _defineProperty(_bem, position, position), _defineProperty(_bem, size, size), _defineProperty(_bem, 'order-' + order, order), _defineProperty(_bem, offset + '-offset', offset), _defineProperty(_bem, phoneSize + '-phone', phoneSize), _defineProperty(_bem, 'order-' + phoneOrder + '-phone', phoneOrder), _defineProperty(_bem, phoneOffset + '-phone-offset', phoneOffset), _defineProperty(_bem, 'phone-hidden', phoneHidden), _defineProperty(_bem, tabletSize + '-tablet', tabletSize), _defineProperty(_bem, 'order-' + tabletOrder + '-tablet', tabletOrder), _defineProperty(_bem, tabletOffset + '-tablet-offset', tabletOffset), _defineProperty(_bem, 'tablet-hidden', tabletHidden), _defineProperty(_bem, desktopSize + '-desktop', desktopSize), _defineProperty(_bem, 'order-' + desktopOrder + '-desktop', desktopOrder), _defineProperty(_bem, desktopOffset + '-desktop-offset', desktopOffset), _defineProperty(_bem, 'desktop-hidden', desktopHidden), _bem), className);
	    }
	  }]);
	
	  function Cell(props) {
	    _classCallCheck(this, Cell);
	
	    var _this = _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).call(this));
	
	    _this.state = { className: Cell.getClassName(props) };
	    return _this;
	  }
	
	  _createClass(Cell, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ className: Cell.getClassName(this.props) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (DIFF_KEYS.some(function (key) {
	        return _this2.props[key] !== nextProps[key];
	      })) {
	        this.setState({ className: Cell.getClassName(nextProps) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.state.className;
	
	      var _props = this.props,
	          style = _props.style,
	          Component = _props.component,
	          children = _props.children,
	          propClassName = _props.className,
	          align = _props.align,
	          position = _props.position,
	          size = _props.size,
	          offset = _props.offset,
	          order = _props.order,
	          phoneSize = _props.phoneSize,
	          phoneOrder = _props.phoneOrder,
	          phoneOffset = _props.phoneOffset,
	          phoneHidden = _props.phoneHidden,
	          tabletSize = _props.tabletSize,
	          tabletOrder = _props.tabletOrder,
	          tabletOffset = _props.tabletOffset,
	          tabletHidden = _props.tabletHidden,
	          desktopSize = _props.desktopSize,
	          desktopOrder = _props.desktopOrder,
	          desktopOffset = _props.desktopOffset,
	          desktopHidden = _props.desktopHidden,
	          props = _objectWithoutProperties(_props, ['style', 'component', 'children', 'className', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden']);
	
	      if (typeof children === 'function') {
	        return children({ style: style, className: className });
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, { style: style, className: className }),
	        children
	      );
	    }
	  }]);
	
	  return Cell;
	}(_react.PureComponent);
	
	Cell.propTypes = {
	  /**
	   * An optional style to apply to the Cell component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the Cell component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render the Cell as. This should probably not be used as much
	   * as the `children` callback function.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * The children can either be renderable React elements or a callback function
	   * that accepts the style and className props to apply so that the styles can
	   * be manually added to whichever component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	
	  /**
	   * An optional cell alignment to apply. When the `Grid` is not `stacked`,
	   * this will apply to vertical alignment within each "row" of the grid.
	   *
	   * Alignments:
	   * - `top` - This will align to the top of the row
	   * - `middle` - This will align to the middle of the row
	   * - `bottom` - This will align to the bottom of the row
	   * - `stretch` - This will make the cell stretch to fill all the available space
	   *   in the row.
	   *
	   * @see {@link #position}
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom', 'stretch']),
	
	  /**
	   * An optional cell position to apply. When the `Grid` is not `stacked`,
	   * this will apply to horizontal alignment within each "row" of the grid.
	   *
	   * Positions:
	   * - `center` - This will align the cell to be within the center of the row. This really
	   *    just applies `margin-left: auto; margin-right: auto`.
	   * - `right` - This will align the cell to the end of the row. This really just applies `margin-left: auto`.
	   *
	   * @see {@link #align}
	   */
	  position: _propTypes2.default.oneOf(['center', 'right']),
	
	  /**
	   * An optional size to apply to the cell. This sizing will be applied across all media sizes.
	   * If the size is greater than the number of columns allowed for the media size, it will just
	   * span the entire width.
	   */
	  size: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell. This order will be applied across all media sizes.
	   */
	  order: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell. This will add spacing to the left of the cell.
	   */
	  offset: _propTypes2.default.number,
	
	  /**
	   * An optional size to apply to the cell only on phones.
	   */
	  phoneSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on phones.
	   */
	  phoneOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on phones.
	   */
	  phoneOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on phones only.
	   */
	  phoneHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on tablets.
	   */
	  tabletSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on tablets.
	   */
	  tabletOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on tablets.
	   */
	  tabletOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on tablets only.
	   */
	  tabletHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on desktops.
	   */
	  desktopSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on desktops.
	   */
	  desktopOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on desktops.
	   */
	  desktopOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on desktops only.
	   */
	  desktopHidden: _propTypes2.default.bool
	};
	Cell.defaultProps = {
	  component: 'div',
	  phoneHidden: false,
	  tabletHidden: false,
	  desktopHidden: false
	};
	exports.default = Cell;
	//# sourceMappingURL=Cell.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bem2 = __webpack_require__(101);
	
	var _bem3 = _interopRequireDefault(_bem2);
	
	var _isValued = __webpack_require__(76);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['className', 'stacked', 'container', 'noSpacing', 'gutter', 'spacing'];
	
	var Grid = function (_PureComponent) {
	  _inherits(Grid, _PureComponent);
	
	  _createClass(Grid, null, [{
	    key: 'getClassName',
	
	
	    /**
	     * A utility function to get the grid's className based on the Grid's props. This is
	     * used behind the scenes to merge and create the className for the grid.
	     *
	     * ### Example:
	     * ```js
	     * <div className={Grid.getClassName()}>A base grid</div>
	     * <div className={Grid.getClassName({ stacked: true })}>A stacked Grid</div>
	     * ```
	     *
	     * @param {Object=} props - This should be an object of the `Grid`'s props. It
	     *    will extract the needed keys and generate the className.
	     * @return {String} the full className to use for the grid
	     */
	    value: function getClassName() {
	      var _bem;
	
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var className = props.className,
	          stacked = props.stacked,
	          noSpacing = props.noSpacing,
	          gutter = props.gutter,
	          spacing = props.spacing,
	          container = props.container;
	
	      return (0, _bem3.default)('md-grid', (_bem = {
	        'stacked': stacked,
	        'no-spacing': noSpacing
	      }, _defineProperty(_bem, gutter + '-' + spacing, (0, _isValued2.default)(gutter) && (0, _isValued2.default)(spacing)), _defineProperty(_bem, container, container), _bem), className);
	    }
	  }]);
	
	  function Grid(props) {
	    _classCallCheck(this, Grid);
	
	    var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this));
	
	    _this.state = { className: Grid.getClassName(props) };
	    return _this;
	  }
	
	  _createClass(Grid, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ className: Grid.getClassName(this.props) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (DIFF_KEYS.some(function (key) {
	        return _this2.props[key] !== nextProps[key];
	      })) {
	        this.setState({ className: Grid.getClassName(nextProps) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.state.className;
	
	      var _props = this.props,
	          style = _props.style,
	          Component = _props.component,
	          children = _props.children,
	          propClassName = _props.className,
	          container = _props.container,
	          stacked = _props.stacked,
	          noSpacing = _props.noSpacing,
	          gutter = _props.gutter,
	          spacing = _props.spacing,
	          props = _objectWithoutProperties(_props, ['style', 'component', 'children', 'className', 'container', 'stacked', 'noSpacing', 'gutter', 'spacing']);
	
	      if (typeof children === 'function') {
	        return children({ style: style, className: className });
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, { style: style, className: className }),
	        children
	      );
	    }
	  }]);
	
	  return Grid;
	}(_react.PureComponent);
	
	Grid.propTypes = {
	  /**
	   * An optional style to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render the Grid as. This should probably not be used as much
	   * as the `children` callback function.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * The children can either be renderable React elements or a callback function
	   * that accepts the style and className props to apply so that the styles can
	   * be manually added to whichever component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	
	  /**
	   * An optional container name to apply to the Grid. This should be the same name as provided
	   * to the [react-md-make-grid-container](/components/grids?tab=2#mixin-react-md-make-grid-container) mixin.
	   */
	  container: _propTypes2.default.string,
	
	  /**
	   * Boolean if the grid should be placed vertically instead of horizontally.
	   */
	  stacked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if all the gutters and spacing should be removed from the grid.
	   */
	  noSpacing: _propTypes2.default.bool,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  gutter: _propTypes2.default.number,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  spacing: _propTypes2.default.number
	};
	Grid.defaultProps = {
	  component: 'div',
	  stacked: false,
	  noSpacing: false
	};
	exports.default = Grid;
	//# sourceMappingURL=Grid.js.map

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _isValidFocusKeypress = __webpack_require__(358);
	
	var _isValidFocusKeypress2 = _interopRequireDefault(_isValidFocusKeypress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hrefables = ['a', 'area'].map(function (tag) {
	  return tag + '[href],';
	}).join('');
	var disableables = ['button', 'input', 'textarea', 'select'].map(function (tag) {
	  return tag + ':not([disabled]),';
	}).join('');
	var FOCUSABLE_QUERY = '' + hrefables + disableables + '*[tabIndex]';
	
	/**
	 * This component is used for keeping the focus within some container. When the container
	 * is mounted and the `focusOnMount` prop is `true`, it will attempt to focus either:
	 * - an element that matches `document.getElementById(this.props.initialFocus)`
	 * - an element that matches `this._container.querySelector(this.props.initialFocus)`
	 * - the first focusable element in it's children (if `this.props.initialFocus` is omitted)
	 */
	
	var FocusContainer = function (_PureComponent) {
	  _inherits(FocusContainer, _PureComponent);
	
	  function FocusContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FocusContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FocusContainer.__proto__ || Object.getPrototypeOf(FocusContainer)).call.apply(_ref, [this].concat(args))), _this), _this._enableFocusTrap = function () {
	      window.addEventListener('keydown', _this._handleKeyDown, true);
	    }, _this._disableFocusTrap = function () {
	      window.removeEventListener('keydown', _this._handleKeyDown, true);
	    }, _this._attemptInitialFocus = function () {
	      if (!_this._container) {
	        return;
	      }
	
	      var initialFocus = _this.props.initialFocus;
	
	
	      var toFocus = initialFocus ? document.getElementById(initialFocus) || _this._container.querySelector(initialFocus) : _this._focusables[0];
	
	      var debugError = void 0;
	      if (!toFocus && initialFocus) {
	        debugError = ' The `initialFocus` did not match a document\'s `id` or was an invalid ';
	        debugError += '`querySelector` for the container. `initialFocus`: `' + initialFocus + '`. ';
	        debugError += 'If this was supposed to be an `id`, make sure to prefix with the `#` symbol.';
	      }
	
	      if (false) {
	        throw new Error('You specified that the `FocusContainer` should focus an element on mount, ' + 'but a focusable element was not found in the children. This could be because ' + 'the `initialFocus` prop is an invalid id or query selector, or the children ' + ('do not contain a valid focusable element.' + debugError));
	      }
	
	      if (toFocus) {
	        toFocus.focus();
	      }
	    }, _this._containFocus = function (containerRef) {
	      if (containerRef === null) {
	        _this._container = null;
	        _this._disableFocusTrap();
	        return;
	      }
	
	      var _this$props = _this.props,
	          focusOnMount = _this$props.focusOnMount,
	          containFocus = _this$props.containFocus;
	
	      _this._container = (0, _reactDom.findDOMNode)(containerRef);
	      _this._focusables = Array.prototype.slice.call(_this._container.querySelectorAll(FOCUSABLE_QUERY)).filter(function (el) {
	        return el.tabIndex !== -1;
	      });
	
	      if (focusOnMount) {
	        _this._attemptInitialFocus();
	      }
	
	      if (containFocus) {
	        _this._enableFocusTrap();
	      }
	    }, _this._handleKeyDown = function (e) {
	      _this._shifted = e.shiftKey;
	      if (!(0, _isValidFocusKeypress2.default)(e, _this.props.additionalFocusKeys)) {
	        return;
	      } else if (_this._focusables.length === 1) {
	        e.preventDefault();
	        return;
	      }
	
	      var target = e.target,
	          shiftKey = e.shiftKey;
	
	      var _this$_focusables = _toArray(_this._focusables),
	          first = _this$_focusables[0],
	          focusables = _this$_focusables.slice(1);
	
	      var last = focusables[focusables.length - 1];
	
	      if (shiftKey && target === first) {
	        e.preventDefault();
	        last.focus();
	      } else if (!shiftKey && target === last) {
	        e.preventDefault();
	        first.focus();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FocusContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.containFocus === nextProps.containFocus) {
	        return;
	      }
	
	      if (nextProps.containFocus) {
	        this._enableFocusTrap();
	        this._attemptInitialFocus();
	      } else {
	        this._disableFocusTrap();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.containFocus && this._container) {
	        this._focusables = Array.prototype.slice.call(this._container.querySelectorAll(FOCUSABLE_QUERY)).filter(function (el) {
	          return el.tabIndex !== -1;
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.containFocus) {
	        this._disableFocusTrap();
	      }
	    }
	
	    /**
	     * Manages the event listeners to contain the focus within some container.  When the container
	     * ref is not null, the container has mounted and then attempts to focus an element inside
	     * if the `focusOnMount` prop is `true`.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          initialFocus = _props.initialFocus,
	          focusOnMount = _props.focusOnMount,
	          containFocus = _props.containFocus,
	          additionalFocusKeys = _props.additionalFocusKeys,
	          props = _objectWithoutProperties(_props, ['component', 'initialFocus', 'focusOnMount', 'containFocus', 'additionalFocusKeys']);
	
	      return _react2.default.createElement(Component, _extends({}, props, { ref: this._containFocus }));
	    }
	  }]);
	
	  return FocusContainer;
	}(_react.PureComponent);
	
	FocusContainer.propTypes = {
	  /**
	   * The component to render as. This can be a React DOM element or
	   * a react Component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional id string or a query selector string to use for the initial focus.
	   * This will only be triggered if the `focusOnMount` prop is `true`. If this is
	   * omitted and the `focusOnMount` prop is `true`, the first focusable element in the
	   * container will be focused.
	   *
	   * Examples:
	   *
	   * ```js
	   * initialFocus="#someAmazingId"
	   * // or
	   * initialFocus=".md-btn,.md-list-tile"
	   * ```
	   */
	  initialFocus: _propTypes2.default.string,
	
	  /**
	   * Boolean if an element in the container should be focused when mounted.
	   */
	  focusOnMount: _propTypes2.default.bool,
	
	  /**
	   * An optional list of additional key codes to use for focus events.
	   */
	  additionalFocusKeys: _propTypes2.default.arrayOf(_propTypes2.default.number),
	
	  /**
	   * Boolean if the focus container should start or stop containing the focus within the container.
	   * This is useful for changing the focus requirements after mount.
	   */
	  containFocus: _propTypes2.default.bool
	};
	FocusContainer.defaultProps = {
	  component: 'div',
	  containFocus: true
	};
	exports.default = FocusContainer;
	//# sourceMappingURL=FocusContainer.js.map

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Helpers/HorizontalAnchors */
	
	/**
	 * An enum for all the different types of horizontal anchors on a layover.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var HorizontalAnchors = {
	  /**
	   * Positions the layover to the outside left on the toggle component
	   * so that it does not overlap.
	   */
	  LEFT: 'left',
	
	  /**
	   * Positions the layover to the inner left of the toggle component so
	   * that it will overlap.
	   */
	  INNER_LEFT: 'inner left',
	
	  /**
	   * Positions the layover so that it overlaps the toggle component
	   * by positioning itself in the cetner of the toggle component's width.
	   */
	  CENTER: 'center',
	
	  /**
	   * Positions the layover to the outside right on the toggle component
	   * so that it does not overlap.
	   */
	  RIGHT: 'right',
	
	  /**
	   * Positions the layover to the outside right on the toggle component
	   * so that it will overlap.
	   */
	  INNER_RIGHT: 'inner right'
	};
	
	exports.default = HorizontalAnchors;
	//# sourceMappingURL=HorizontalAnchors.js.map

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Helpers/Positions */
	
	/**
	 * An enum for all the animation positions for a layover appearing.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var Positions = {
	  /**
	   * The layover will appear by transitioning from the top left and expand
	   * down right.
	   */
	  TOP_LEFT: 'tl',
	
	  /**
	   * The layover will appear by transitioning from the top right and expand
	   * down left.
	   */
	  TOP_RIGHT: 'tr',
	
	  /**
	   * The layover will appear by transitioning from the bottom left and expand
	   * top right.
	   */
	  BOTTOM_LEFT: 'bl',
	
	  /**
	   * The layover will appear by transitioning from the bottom right and expand
	   * top left.
	   */
	  BOTTOM_RIGHT: 'br',
	
	  /**
	   * The layover will appear by just transitioning downwards from the bottom
	   * of the toggle component.
	   */
	  BELOW: 'below'
	};
	
	exports.default = Positions;
	//# sourceMappingURL=Positions.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Helpers/VerticalAnchors */
	
	/**
	 * An enum for all the different types of horizontal anchors on a layover.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var VerticalAnchors = {
	  /**
	   * Positions the layover to be placed over the toggle component so that
	   * it will never overlay the toggle component.
	   */
	  TOP: 'top',
	
	  /**
	   * Positions the layover so that it will be centered over the toggle component
	   * based on the layover's height.
	   */
	  CENTER: 'center',
	
	  /**
	   * Positions the layover so that it will overlap the toggle component by
	   * fixing to the top of the toggle.
	   */
	  OVERLAP: 'overlap',
	
	  /**
	   * Positions the layover to be placed below the toggle component so that
	   * it will never overlay the toggle component.
	   */
	  BOTTOM: 'bottom'
	};
	
	exports.default = VerticalAnchors;
	//# sourceMappingURL=VerticalAnchors.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ListItemText` component is used to render the `primaryText` and an optional
	 * `secondaryText` for a `ListItem`.
	 */
	var ListItemText = function (_PureComponent) {
	  _inherits(ListItemText, _PureComponent);
	
	  function ListItemText() {
	    _classCallCheck(this, ListItemText);
	
	    return _possibleConstructorReturn(this, (ListItemText.__proto__ || Object.getPrototypeOf(ListItemText)).apply(this, arguments));
	  }
	
	  _createClass(ListItemText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          disabled = _props.disabled,
	          primaryText = _props.primaryText,
	          primaryTextStyle = _props.primaryTextStyle,
	          primaryTextClassName = _props.primaryTextClassName,
	          secondaryText = _props.secondaryText,
	          secondaryTextStyle = _props.secondaryTextStyle,
	          secondaryTextClassName = _props.secondaryTextClassName,
	          className = _props.className,
	          threeLines = _props.threeLines,
	          props = _objectWithoutProperties(_props, ['active', 'activeClassName', 'disabled', 'primaryText', 'primaryTextStyle', 'primaryTextClassName', 'secondaryText', 'secondaryTextStyle', 'secondaryTextClassName', 'className', 'threeLines']);
	
	      var secondaryTextNode = void 0;
	      if (secondaryText) {
	        secondaryTextNode = _react2.default.createElement(
	          'div',
	          {
	            style: secondaryTextStyle,
	            className: (0, _classnames2.default)('md-tile-text--secondary', {
	              'md-tile-text--three-lines': threeLines
	            }, (0, _themeColors2.default)({ disabled: disabled, hint: !disabled }), secondaryTextClassName)
	          },
	          secondaryText
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: (0, _classnames2.default)('md-tile-content', className) }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: primaryTextStyle,
	            className: (0, _classnames2.default)('md-tile-text--primary', _defineProperty({}, activeClassName, !disabled && active), (0, _themeColors2.default)({ disabled: disabled, text: !active }), primaryTextClassName)
	          },
	          primaryText
	        ),
	        secondaryTextNode
	      );
	    }
	  }]);
	
	  return ListItemText;
	}(_react.PureComponent);
	
	ListItemText.propTypes = {
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  primaryText: _propTypes2.default.node.isRequired,
	  primaryTextStyle: _propTypes2.default.object,
	  primaryTextClassName: _propTypes2.default.string,
	  secondaryText: _propTypes2.default.node,
	  secondaryTextStyle: _propTypes2.default.object,
	  secondaryTextClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  threeLines: _propTypes2.default.bool
	};
	exports.default = ListItemText;
	//# sourceMappingURL=ListItemText.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function validateAspectRatio(props, propName, component) {
	  var _PropTypes$string;
	
	  var value = props[propName];
	
	  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var err = (_PropTypes$string = _propTypes2.default.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(args));
	  if (!err && value.split('-').length !== 2) {
	    err = new Error('Your provided an `' + propName + '` prop to the ' + component + ' that is not a valid ' + ('aspect ratio `' + value + '`. This should be in the form of \'{width}-{height}\'.'));
	  }
	
	  return err;
	}
	
	/**
	 * The `Media` component is used to display images, iframes, ...media. Who'da thunk?
	 */
	
	var Media = function (_PureComponent) {
	  _inherits(Media, _PureComponent);
	
	  function Media() {
	    _classCallCheck(this, Media);
	
	    return _possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).apply(this, arguments));
	  }
	
	  _createClass(Media, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          className = _props.className,
	          children = _props.children,
	          forceAspect = _props.forceAspect,
	          aspectRatio = _props.aspectRatio,
	          expandable = _props.expandable,
	          props = _objectWithoutProperties(_props, ['component', 'className', 'children', 'forceAspect', 'aspectRatio', 'expandable']);
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-media', _defineProperty({}, 'md-media--' + aspectRatio, forceAspect), className)
	        }),
	        children
	      );
	    }
	  }]);
	
	  return Media;
	}(_react.PureComponent);
	
	Media.propTypes = {
	  /**
	   * An optional className to apply to the card media component.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Any media to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the aspect ratio should be forced.
	   */
	  forceAspect: _propTypes2.default.bool,
	
	  /**
	   * The aspect ratio to use.
	   */
	  aspectRatio: validateAspectRatio,
	
	  /**
	   * Boolean if this component should be expandable when there is a `CardExpander`
	   * above it in the `Card`.
	   */
	  expandable: _propTypes2.default.bool,
	
	  /**
	   * The component to render the card media as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Media.defaultProps = {
	  forceAspect: true,
	  aspectRatio: '16-9',
	  component: 'section'
	};
	exports.default = Media;
	//# sourceMappingURL=Media.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `MediaOverlay` component is just a very simple wrapper that adds the
	 * `.md-media-overlay` class name to a div. The overlay will be positioned
	 * at the bottom of the `Media` by default.
	 */
	var MediaOverlay = function (_PureComponent) {
	  _inherits(MediaOverlay, _PureComponent);
	
	  function MediaOverlay() {
	    _classCallCheck(this, MediaOverlay);
	
	    return _possibleConstructorReturn(this, (MediaOverlay.__proto__ || Object.getPrototypeOf(MediaOverlay)).apply(this, arguments));
	  }
	
	  _createClass(MediaOverlay, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          Component = _props.component,
	          props = _objectWithoutProperties(_props, ['className', 'component']);
	
	      return _react2.default.createElement(Component, _extends({ className: (0, _classnames2.default)('md-media-overlay', className) }, props));
	    }
	  }]);
	
	  return MediaOverlay;
	}(_react.PureComponent);
	
	MediaOverlay.propTypes = {
	  /**
	   * An optional style to apply to the overlay.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the overlay.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Any children to display in the overlay. This is _normally_ a `CardTitle` component
	   * or some buttons.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to be rendered as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	MediaOverlay.defaultProps = {
	  component: 'div'
	};
	exports.default = MediaOverlay;
	//# sourceMappingURL=MediaOverlay.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _anchorShape = __webpack_require__(31);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(32);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DropdownMenu = __webpack_require__(94);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `MenuButton` is a simple wrapper / combination of the `Button` and the `Menu`
	 * components that can be uncontrolled.
	 */
	var MenuButton = function (_PureComponent) {
	  _inherits(MenuButton, _PureComponent);
	
	  function MenuButton() {
	    _classCallCheck(this, MenuButton);
	
	    return _possibleConstructorReturn(this, (MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).apply(this, arguments));
	  }
	
	  _createClass(MenuButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          listId = _props.listId,
	          buttonId = _props.buttonId,
	          menuStyle = _props.menuStyle,
	          menuClassName = _props.menuClassName,
	          listStyle = _props.listStyle,
	          listClassName = _props.listClassName,
	          listProps = _props.listProps,
	          listZDepth = _props.listZDepth,
	          listInline = _props.listInline,
	          listHeightRestricted = _props.listHeightRestricted,
	          menuItems = _props.menuItems,
	          buttonChildren = _props.buttonChildren,
	          children = _props.children,
	          anchor = _props.anchor,
	          belowAnchor = _props.belowAnchor,
	          fixedTo = _props.fixedTo,
	          position = _props.position,
	          cascading = _props.cascading,
	          cascadingAnchor = _props.cascadingAnchor,
	          cascadingZDepth = _props.cascadingZDepth,
	          fullWidth = _props.fullWidth,
	          block = _props.block,
	          centered = _props.centered,
	          sameWidth = _props.sameWidth,
	          repositionOnScroll = _props.repositionOnScroll,
	          repositionOnResize = _props.repositionOnResize,
	          xThreshold = _props.xThreshold,
	          yThreshold = _props.yThreshold,
	          closeOnOutsideClick = _props.closeOnOutsideClick,
	          transitionName = _props.transitionName,
	          transitionEnterTimeout = _props.transitionEnterTimeout,
	          transitionLeaveTimeout = _props.transitionLeaveTimeout,
	          visible = _props.visible,
	          defaultVisible = _props.defaultVisible,
	          onVisibilityChange = _props.onVisibilityChange,
	          simplifiedMenu = _props.simplifiedMenu,
	          minLeft = _props.minLeft,
	          minRight = _props.minRight,
	          minBottom = _props.minBottom,
	          fillViewportWidth = _props.fillViewportWidth,
	          fillViewportHeight = _props.fillViewportHeight,
	          onMenuClick = _props.onMenuClick,
	          onMenuMouseDown = _props.onMenuMouseDown,
	          onMenuMouseUp = _props.onMenuMouseUp,
	          onMenuMouseEnter = _props.onMenuMouseEnter,
	          onMenuMouseMove = _props.onMenuMouseMove,
	          onMenuMouseLeave = _props.onMenuMouseLeave,
	          onMenuTouchStart = _props.onMenuTouchStart,
	          onMenuTouchMove = _props.onMenuTouchMove,
	          onMenuTouchCancel = _props.onMenuTouchCancel,
	          onMenuTouchEnd = _props.onMenuTouchEnd,
	          onMenuFocus = _props.onMenuFocus,
	          onMenuBlur = _props.onMenuBlur,
	          onMenuKeyDown = _props.onMenuKeyDown,
	          onMenuKeyUp = _props.onMenuKeyUp,
	          isOpen = _props.isOpen,
	          defaultOpen = _props.defaultOpen,
	          onMenuToggle = _props.onMenuToggle,
	          props = _objectWithoutProperties(_props, ['id', 'listId', 'buttonId', 'menuStyle', 'menuClassName', 'listStyle', 'listClassName', 'listProps', 'listZDepth', 'listInline', 'listHeightRestricted', 'menuItems', 'buttonChildren', 'children', 'anchor', 'belowAnchor', 'fixedTo', 'position', 'cascading', 'cascadingAnchor', 'cascadingZDepth', 'fullWidth', 'block', 'centered', 'sameWidth', 'repositionOnScroll', 'repositionOnResize', 'xThreshold', 'yThreshold', 'closeOnOutsideClick', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'visible', 'defaultVisible', 'onVisibilityChange', 'simplifiedMenu', 'minLeft', 'minRight', 'minBottom', 'fillViewportWidth', 'fillViewportHeight', 'onMenuClick', 'onMenuMouseDown', 'onMenuMouseUp', 'onMenuMouseEnter', 'onMenuMouseMove', 'onMenuMouseLeave', 'onMenuTouchStart', 'onMenuTouchMove', 'onMenuTouchCancel', 'onMenuTouchEnd', 'onMenuFocus', 'onMenuBlur', 'onMenuKeyDown', 'onMenuKeyUp', 'isOpen', 'defaultOpen', 'onMenuToggle']);
	
	      var items = children;
	      var toggleChildren = buttonChildren;
	      if (typeof menuItems !== 'undefined') {
	        toggleChildren = children;
	        items = menuItems;
	      }
	
	      return _react2.default.createElement(
	        _DropdownMenu2.default,
	        {
	          id: id,
	          listId: listId,
	          style: menuStyle,
	          className: menuClassName,
	          listStyle: listStyle,
	          listClassName: listClassName,
	          listProps: listProps,
	          listInline: listInline,
	          listZDepth: listZDepth,
	          listHeightRestricted: listHeightRestricted,
	          visible: typeof isOpen !== 'undefined' ? isOpen : visible,
	          defaultVisible: typeof defaultOpen !== 'undefined' ? defaultOpen : defaultVisible,
	          menuItems: items,
	          simplifiedMenu: simplifiedMenu,
	          anchor: anchor,
	          belowAnchor: belowAnchor,
	          fixedTo: fixedTo,
	          position: position,
	          cascading: cascading,
	          cascadingAnchor: cascadingAnchor,
	          cascadingZDepth: cascadingZDepth,
	          fullWidth: fullWidth,
	          block: block,
	          centered: centered,
	          sameWidth: sameWidth,
	          minLeft: minLeft,
	          minRight: minRight,
	          minBottom: minBottom,
	          fillViewportWidth: fillViewportWidth,
	          fillViewportHeight: fillViewportHeight,
	          repositionOnScroll: repositionOnScroll,
	          repositionOnResize: repositionOnResize,
	          xThreshold: xThreshold,
	          yThreshold: yThreshold,
	          closeOnOutsideClick: closeOnOutsideClick,
	          transitionName: transitionName,
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout,
	          onVisibilityChange: onMenuToggle || onVisibilityChange,
	          onClick: onMenuClick,
	          onMouseDown: onMenuMouseDown,
	          onMouseUp: onMenuMouseUp,
	          onMouseEnter: onMenuMouseEnter,
	          onMouseMove: onMenuMouseMove,
	          onMouseLeave: onMenuMouseLeave,
	          onTouchStart: onMenuTouchStart,
	          onTouchMove: onMenuTouchMove,
	          onTouchCancel: onMenuTouchCancel,
	          onTouchEnd: onMenuTouchEnd,
	          onFocus: onMenuFocus,
	          onBlur: onMenuBlur,
	          onKeyDown: onMenuKeyDown,
	          onKeyUp: onMenuKeyUp
	        },
	        _react2.default.createElement(
	          _Button2.default,
	          _extends({}, props, { id: buttonId }),
	          toggleChildren
	        )
	      );
	    }
	  }]);
	
	  return MenuButton;
	}(_react.PureComponent);
	
	MenuButton.Positions = _DropdownMenu2.default.Positions;
	MenuButton.HorizontalAnchors = _DropdownMenu2.default.HorizontalAnchors;
	MenuButton.VerticalAnchors = _DropdownMenu2.default.VerticalAnchors;
	MenuButton.propTypes = {
	  /**
	   * An id to use for the menu button. This is required for accessibility.
	   *
	   * @see {@link Menus/Menu#id}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the menu's list.
	   *
	   * @see {@link Menus/Menu#listId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the button. If this is omitted, the button will automatically
	   * gain an id of `${id}-toggle`.
	   */
	  buttonId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the button.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the surrounding menu.
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the surrounding menu.
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the list.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the list.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * Any additional props to provide to the list.
	   *
	   * @see {@link Menus/Menu#listProps}
	   */
	  listProps: _propTypes2.default.object,
	
	  /**
	   * The z-depth to use for the list.
	   *
	   * @see {@link Menus/Menu/listZDepth}
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should be displayed inline.
	   *
	   * @see {@link Lists/List#inline}
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list's height should be restricted.
	   *
	   * @see {@link Menus/Menu#listHeightRestricted}
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list is currently visible. If this is defined, it will
	   * require the `onVisibilityChange` function to be defined since it will become
	   * a controlled component.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * Boolean if the menu's list should be visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional function to call when the button is clicked.
	   *
	   * @see {@link #onMenuClick}
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousedown` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseDown}
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseup` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseUp}
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseenter` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseEnter}
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousemove` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseMove}
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseleave` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseLeave}
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchstart` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchStart}
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchmove` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchMove}
	   */
	  onTouchMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchend` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchEnd}
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchcancel` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchCancel}
	   */
	  onTouchCancel: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `focus` event is triggered by the button.
	   *
	   * @see {@link #onMenuFocus}
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `blur` event is triggered by the button.
	   *
	   * @see {@link #onMenuBlur}
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event is triggered by the button.
	   *
	   * @see {@link #onMenuKeyDown}
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keyup` event is triggered by the button.
	   *
	   * @see {@link #onMenuKeyUp}
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the entire `MenuButton` is clicked. This can be triggered
	   * by clicking the button or any list item that appears in the menu list.
	   *
	   * @see {@link #onClick}
	   */
	  onMenuClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mousedown` event.
	   *
	   * @see {@link #onMouseDown}
	   */
	  onMenuMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mouseup` event.
	   *
	   * @see {@link #onMouseUp}
	   */
	  onMenuMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mouseenter` event.
	   *
	   * @see {@link #onMouseEnter}
	   */
	  onMenuMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mousemove` event.
	   *
	   * @see {@link #onMouseMove}
	   */
	  onMenuMouseMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mouseleave` event.
	   *
	   * @see {@link #onMouseLeave}
	   */
	  onMenuMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchstart` event.
	   *
	   * @see {@link @onTouchStart}
	   */
	  onMenuTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchmove` event.
	   *
	   * @see {@link @onTouchMove}
	   */
	  onMenuTouchMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchend` event.
	   *
	   * @see {@link @onTouchEnd}
	   */
	  onMenuTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchcancel` event.
	   *
	   * @see {@link @onTouchCancel}
	   */
	  onMenuTouchCancel: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `focus` event.
	   *
	   * @see {@link #onFocus}
	   */
	  onMenuFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `blur` event.
	   *
	   * @see {@link #onBlur}
	   */
	  onMenuBlur: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `keydown` event.
	   *
	   * @see {@link #onKeyDown}
	   */
	  onMenuKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `keyup` event.
	   *
	   * @see {@link #onKeyUp}
	   */
	  onMenuKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the visibility changes for the menu. The callback will
	   * include the next visibility state and the event that triggered the change.
	   *
	   * ```js
	   * onVisibilityChange(visible, event);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * This is a 0 to many relationship of `ListItem` to display in the menu's `List`. If the type
	   * of the item is a number or string, it will be passed to the `ListItem` as the `primaryText`.
	   * If it is an object, it should be the shape of the `ListItem` props. If it is a node, it will
	   * just be rendered in the `List`.
	   *
	   * @see {@link Lists/ListItem}
	   * @see {@link Menus/Menu#children}
	   */
	  menuItems: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.node]))]),
	
	  /**
	   * This should be the children to use in the `Button` that gets created as the menu's toggle.
	   *
	   * @see {@link Buttons/Button}
	   * @see {@link Menus/Menu#toggle}
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The anchor position of the menu's list.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is how the menu's list is fixed to the toggle.
	   *
	   * @see {@link Menus/Menu#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * This is the animation position for the menu's list.
	   *
	   * @see {@link Menus/Menu#position}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * Boolean if the menu's list should gain the cascading styles.
	   *
	   * @see {@link Menus/Menu#cascading}
	   */
	  cascading: _propTypes2.default.bool,
	
	  /**
	   * The zDepth to use for the lists that appear in cascading menus.
	   *
	   * @see {@link Menus/Menu#cascadingZDepth}
	   */
	  cascadingZDepth: _propTypes2.default.number,
	
	  /**
	   * The anchor position for the cascading lists.
	   *
	   * @see {@link Menus/Menu#cascadingAnchor}
	   */
	  cascadingAnchor: _anchorShape2.default,
	
	  /**
	   * Boolean if the menu should display as a full width container. This will *not* update the button
	   * to be full width as well.
	   *
	   * @see {@link Menus/Menu#fullWidth}
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's container should display as `block` instead of `inline-block`.
	   *
	   * @see {@link Menus/Menu#block}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list should appear centered related to the button.
	   *
	   * @see {@link Menus/Menu#centered}
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list should be the same width as the button.
	   *
	   * @see {@link Menus/Menu#sameWidth}
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Menus/Menu#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Menus/Menu#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu's list should be closed when an element outside of the menu has been clicked.
	   *
	   * @see {@link Menus/Menu#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * The transition name to use for the menu's list visibility changes.
	   *
	   * @see {@link Menus/Menu#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * The transition name to use when the menu's list gains visibility.
	   *
	   * @see {@link Menus/Menu#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition timeout to use when the menu's list loses visibility.
	   *
	   * @see {@link Menus/Menu#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _DropdownMenu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _DropdownMenu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _DropdownMenu2.default.propTypes.minBottom,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  buttonChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'To build a button, put any elements in the `children`. The `ListItem` have been moved to the `menuItems` prop'),
	  onMenuToggle: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `onVisibilityChange` instead'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  defaultOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead')
	};
	MenuButton.defaultProps = {
	  defaultVisible: false,
	  repositionOnScroll: true,
	  repositionOnResize: false
	};
	exports.default = MenuButton;
	//# sourceMappingURL=MenuButton.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A button used to close the persistent navigation drawer. The button will
	 * be generated based on the `NavigationDrawer`'s `contextTypes`.
	 *
	 * This component is really only used if you are using a `persistent` drawer and you
	 * manually created the `drawerHeader` for the `NavigationDrawer`.
	 */
	var CloseButton = function (_PureComponent) {
	  _inherits(CloseButton, _PureComponent);
	
	  function CloseButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CloseButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      if (_this.context.onCloseClick) {
	        _this.context.onCloseClick(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CloseButton, [{
	    key: 'render',
	    value: function render() {
	      var closeIcon = this.context.closeIcon;
	
	
	      return _react2.default.createElement(_Button2.default, _extends({}, this.props, {
	        icon: true,
	        key: 'close',
	        onClick: this._handleClick,
	        iconEl: closeIcon
	      }));
	    }
	  }]);
	
	  return CloseButton;
	}(_react.PureComponent);
	
	CloseButton.propTypes = {
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional additional function to call when the `click` event is triggered.
	   */
	  onClick: _propTypes2.default.func
	};
	CloseButton.contextTypes = {
	  closeIcon: _propTypes2.default.element,
	  onCloseClick: _propTypes2.default.func
	};
	exports.default = CloseButton;
	//# sourceMappingURL=CloseButton.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is an accessibility only component that should be used in the `NavigationDrawer`
	 * component. It allows keyboard users to quickly jump to the main content.
	 *
	 * This component relies on the `contextTypes` of the `NavigationDrawer` to work. If this is going
	 * to be used outside of that component, you will need to specify an `id` and `label` contextType
	 * to pass to this component.
	 */
	var JumpToContentLink = function (_PureComponent) {
	  _inherits(JumpToContentLink, _PureComponent);
	
	  function JumpToContentLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JumpToContentLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JumpToContentLink.__proto__ || Object.getPrototypeOf(JumpToContentLink)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      document.getElementById(_this.context.id).focus();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JumpToContentLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['className']);
	
	      var _context = this.context,
	          id = _context.id,
	          label = _context.label;
	
	      return _react2.default.createElement(
	        'a',
	        _extends({}, props, {
	          id: 'jump-to-' + id,
	          href: '#' + id,
	          onClick: this._handleClick,
	          className: (0, _classnames2.default)('md-content-jump', className)
	        }),
	        label
	      );
	    }
	  }]);
	
	  return JumpToContentLink;
	}(_react.PureComponent);
	
	JumpToContentLink.propTypes = {
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the linked is clicked.
	   */
	  onClick: _propTypes2.default.func
	};
	JumpToContentLink.contextTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  label: _propTypes2.default.node.isRequired
	};
	exports.default = JumpToContentLink;
	//# sourceMappingURL=JumpToContentLink.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(9);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _minMaxLoop = __webpack_require__(363);
	
	var _minMaxLoop2 = _interopRequireDefault(_minMaxLoop);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _SelectionControl = __webpack_require__(47);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A custom PropTypes validator to make sure that each `control` in the `controls` prop
	 * contains the given `propName`, or the `SelectionControlGroup` has defined that prop.
	 */
	function requiredByAllControls(validator) {
	  return function validate(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName, component].concat(others));
	
	    if (!err && typeof props[propName] === 'undefined') {
	      var invalids = props.controls.filter(function (c) {
	        return !c[propName];
	      }).map(function (_, i) {
	        return i;
	      });
	      if (invalids.length) {
	        var invalidPrefix = invalids.length === props.controls.length ? 'All `controls`' : 'The `controls` at indexes `' + invalids.join('`, `') + '`';
	        var invalidMsg = invalidPrefix + ' are missing the `' + propName + '` prop.';
	
	        err = new Error('The `' + propName + '` prop is required to make `' + component + '` accessible for users of ' + ('assistive technologies such as screen readers. Either add the `' + propName + '` to the `' + component + '` ') + ('or add the `' + propName + '` to each `control` in the `controls` prop. ' + invalidMsg));
	      }
	    }
	
	    return err;
	  };
	}
	
	/**
	 * The `SelectionControlGroup` component is used to simplify the generation of a list
	 * of `SelectionControl`. Any common props are extracted to this component and passed
	 * to the `SelectionControl`.
	 */
	
	var SelectionControlGroup = function (_PureComponent) {
	  _inherits(SelectionControlGroup, _PureComponent);
	
	  function SelectionControlGroup(props) {
	    _classCallCheck(this, SelectionControlGroup);
	
	    var _this = _possibleConstructorReturn(this, (SelectionControlGroup.__proto__ || Object.getPrototypeOf(SelectionControlGroup)).call(this, props));
	
	    _this._setGroup = function (group) {
	      _this._group = group;
	    };
	
	    _this._handleChange = function (e) {
	      var value = e.target.value;
	      if (_this.props.type === 'checkbox') {
	        var checked = e.target.checked;
	
	
	        var values = (0, _getField2.default)(_this.props, _this.state, 'value').split(',');
	        var index = values.indexOf(value);
	        if (checked) {
	          values.push(value);
	        } else {
	          values.splice(index, 1);
	        }
	
	        value = values.join(',');
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(value, e);
	      }
	
	      if (typeof _this.props.value === 'undefined') {
	        _this.setState({ value: value });
	      }
	    };
	
	    _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      var key = e.which || e.keyCode;
	      var dec = key === _keyCodes.UP || key === _keyCodes.LEFT;
	      var inc = key === _keyCodes.DOWN || key === _keyCodes.RIGHT;
	      if (!_this._group || !dec && !inc) {
	        return;
	      }
	
	      e.preventDefault();
	      var radios = _this._group.querySelectorAll('*[role="radio"]');
	      _this._activeIndex = (0, _minMaxLoop2.default)(_this._activeIndex, 0, radios.length - 1, inc);
	      radios[_this._activeIndex].focus();
	      var value = _this.props.controls[_this._activeIndex].value;
	
	      if ((0, _getField2.default)(_this.props, _this.state, 'value') !== value) {
	        if (_this.props.onChange) {
	          _this.props.onChange(value, e);
	        }
	
	        if (typeof _this.props.value === 'undefined') {
	          _this.setState({ value: value });
	        }
	      }
	    };
	
	    var radio = props.type === 'radio';
	    _this.state = {};
	
	    if (typeof props.value === 'undefined') {
	      var value = props.defaultValue;
	
	      if (typeof value === 'undefined') {
	        value = radio ? props.controls[0].value : '';
	      }
	
	      _this.state.value = value;
	    }
	
	    var groupValue = (0, _getField2.default)(props, _this.state, 'value');
	    _this._activeIndex = -1;
	    props.controls.some(function (_ref, i) {
	      var value = _ref.value;
	
	      if (value === groupValue) {
	        _this._activeIndex = i;
	      }
	
	      return _this._activeIndex > -1;
	    });
	    return _this;
	  }
	
	  _createClass(SelectionControlGroup, [{
	    key: '_isChecked',
	    value: function _isChecked(value, controlValue, type) {
	      return type === 'radio' ? value === controlValue : value.split(',').indexOf(controlValue) !== -1;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          id = _props.id,
	          name = _props.name,
	          type = _props.type,
	          label = _props.label,
	          labelClassName = _props.labelClassName,
	          className = _props.className,
	          controlStyle = _props.controlStyle,
	          controlClassName = _props.controlClassName,
	          Component = _props.component,
	          LabelComponent = _props.labelComponent,
	          inline = _props.inline,
	          disabled = _props.disabled,
	          checkedRadioIcon = _props.checkedRadioIcon,
	          uncheckedRadioIcon = _props.uncheckedRadioIcon,
	          checkedCheckboxIcon = _props.checkedCheckboxIcon,
	          uncheckedCheckboxIcon = _props.uncheckedCheckboxIcon,
	          propValue = _props.value,
	          propControls = _props.controls,
	          defaultValue = _props.defaultValue,
	          props = _objectWithoutProperties(_props, ['id', 'name', 'type', 'label', 'labelClassName', 'className', 'controlStyle', 'controlClassName', 'component', 'labelComponent', 'inline', 'disabled', 'checkedRadioIcon', 'uncheckedRadioIcon', 'checkedCheckboxIcon', 'uncheckedCheckboxIcon', 'value', 'controls', 'defaultValue']);
	
	      var value = (0, _getField2.default)(this.props, this.state, 'value');
	      var radio = type === 'radio';
	
	      var controls = this.props.controls.map(function (control, i) {
	        var style = control.style;
	        if (controlStyle) {
	          style = style ? _extends({}, controlStyle, style) : controlStyle;
	        }
	
	        var checked = _this2._isChecked(value, control.value, type);
	        var controlProps = _extends({
	          id: '' + id + i,
	          key: 'control' + i,
	          name: '' + name + (type === 'checkbox' ? '[]' : ''),
	          type: type,
	          inline: inline,
	          disabled: disabled,
	          checked: checked,
	          tabIndex: !radio || checked || i === 0 && _this2._activeIndex === -1 ? undefined : -1,
	          checkedRadioIcon: checkedRadioIcon,
	          uncheckedRadioIcon: uncheckedRadioIcon,
	          checkedCheckboxIcon: checkedCheckboxIcon,
	          uncheckedCheckboxIcon: uncheckedCheckboxIcon
	        }, control, {
	          style: style,
	          className: (0, _classnames2.default)(controlClassName, control.className)
	        });
	
	        return _react2.default.createElement(_SelectionControl2.default, controlProps);
	      });
	
	      var ariaLabel = void 0;
	      if (label) {
	        ariaLabel = _react2.default.createElement(
	          LabelComponent,
	          { className: labelClassName },
	          label
	        );
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          ref: this._setGroup,
	          className: (0, _classnames2.default)('md-selection-control-group', className),
	          onChange: this._handleChange,
	          onKeyDown: radio ? this._handleKeyDown : null
	        }),
	        ariaLabel,
	        controls
	      );
	    }
	  }]);
	
	  return SelectionControlGroup;
	}(_react.PureComponent);
	
	SelectionControlGroup.propTypes = {
	  /**
	   * An optional style to apply to the container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to every `SelectionControl`. This will be merged with any `style`
	   * that a `control` might have.
	   */
	  controlStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to every `SelectionControl`. This will be merged with any
	   * `className` that a `control` might have.
	   */
	  controlClassName: _propTypes2.default.string,
	
	  /**
	   * An optional base id to apply to each `SelectionControl`. When this is included, the id for
	   * each control will start with this and end with their current index. If this is omitted,
	   * each `control` in the `controls` prop *must* have an `id` prop. This is required for
	   * accessibility.
	   */
	  id: requiredByAllControls(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The type to apply to each `SelectionControl` in the group. Only `checkbox` and `radio` is
	   * valid for a grouping.
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']).isRequired,
	
	  /**
	   * The component to render the `SelectionControlGroup` in. This can only be a valid dom element
	   * since it relies on the ref callback to add keyboard accessibility.
	   */
	  component: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional label to display above the group of `SelectionControl`s.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply to the node surrounding the `label` prop.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the optional `label` in.
	   */
	  labelComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * An optional function to call when any `SelectionControl`'s `checked` state is changed
	   * in the group. If the `type` of the group is `radio`, the `value` of the `checked` radio
	   * will be given in the callback. If the `type` of the group is `checkbox`, a comma-delimited
	   * string of all `checked` checkboxes values will be given.
	   *
	   * ```js
	   * // checkbox
	   * onChange('Alpha,Omega', changeEvent);
	   *
	   * // radio
	   * onChange('Omega', changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * A name to use for each `SelectionControl` in the group. If the `type` of the group is
	   * `checkbox`, the name will be updated to be an array name so that using
	   * `document.querySelector('input[name="yourName[]"].value` will give the comma-delimited
	   * string of checked checkboxes.
	   *
	   * It is either required to have this prop set or every `control` in the `controls` prop to
	   * have the `name` prop.
	   */
	  name: requiredByAllControls(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The default value for the `SelectionControlGroup`. This can either be a single value
	   * or a comma-delimited string of checkbox values. When the `type` of the group is `radio`
	   * and the group is uncontrolled, it is recommended to set this prop. Otherwise the first
	   * value of the `controls` prop will be used as the default value.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional value to use for the `SelectionControlGroup`. This will make the component
	   * controlled and require the `onChange` prop to be defined. Like the `defaultValue`, this
	   * can either be a single value or a comma-delimited list of checkbox values.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]), 'onChange'),
	
	  /**
	   * A list of objects to create the `SelectionControl` components. The shape of the object
	   * is the `propTypes` of the `SelectionControl` component, except that `value` prop is
	   * now required.
	   *
	   * The `SelectionControl` will inherit any inheritable props from the `SelectionControlGroup`.
	   */
	  controls: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    label: _propTypes2.default.node.isRequired,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]).isRequired
	  })).isRequired,
	
	  /**
	   * Boolean if the `SelectionControl` should be displayed inline.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if all the selection controls in the group are disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the keydown event is triggered.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An icon to use for a checked `radio` control. This will be applied to each
	   * control that has a `type="radio"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each radio in the list.
	   *
	   * This will default to the `checkedRadioIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #uncheckedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedRadioIcon}
	   */
	  checkedRadioIcon: _propTypes2.default.node,
	
	  /**
	   * An icon to use for an unchecked `radio` control. This will be applied to each
	   * control that has a `type="radio"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each radio in the list.
	   *
	   * This will default to the `uncheckedRadioIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #checkedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedRadioIcon}
	   */
	  uncheckedRadioIcon: _propTypes2.default.node,
	
	  /**
	   * An icon to use for a checked `checkbox` control. This will be applied to each
	   * control that has a `type="checkbox"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each checkbox in the list.
	   *
	   * This will default to the `checkedCheckboxIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #uncheckedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedCheckboxIcon}
	   */
	  checkedCheckboxIcon: _propTypes2.default.node,
	
	  /**
	   * An icon to use for an unchecked `checkbox` control. This will be applied to each
	   * control that has a `type="checkbox"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each checkbox in the list.
	   *
	   * This will default to the `uncheckedCheckboxIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #checkedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedCheckboxIcon}
	   */
	  uncheckedCheckboxIcon: _propTypes2.default.node
	};
	SelectionControlGroup.defaultProps = {
	  component: 'fieldset',
	  labelComponent: 'legend',
	  labelClassName: 'md-subheading-1'
	};
	exports.default = SelectionControlGroup;
	//# sourceMappingURL=SelectionControlGroup.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _isInvalidAnimate = __webpack_require__(154);
	
	var _isInvalidAnimate2 = _interopRequireDefault(_isInvalidAnimate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Snackbar = function (_PureComponent) {
	  _inherits(Snackbar, _PureComponent);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      var _this$props = _this.props,
	          onDismiss = _this$props.onDismiss,
	          action = _this$props.toast.action,
	          leaveTimeout = _this$props.leaveTimeout,
	          multiline = _this$props.multiline;
	
	      if (typeof action.onClick === 'function') {
	        action.onClick(e);
	      }
	
	      if (_this._fab) {
	        _this._fab._animateForSnackbar(multiline, leaveTimeout);
	      }
	
	      onDismiss();
	    }, _this._clearTimeout = function () {
	      if (_this._timeout) {
	        clearTimeout(_this._timeout);
	        _this._timeout = null;
	      }
	    }, _this._handleAutohide = function () {
	      var _this$props2 = _this.props,
	          autohide = _this$props2.autohide,
	          autohideTimeout = _this$props2.autohideTimeout,
	          onDismiss = _this$props2.onDismiss,
	          multiline = _this$props2.multiline,
	          leaveTimeout = _this$props2.leaveTimeout;
	
	      if (!autohide) {
	        return;
	      }
	
	      window.addEventListener('blur', _this._handleWindowBlur);
	      _this._eventType = 'blur';
	      _this._timeout = setTimeout(function () {
	        _this._timeout = null;
	        _this._eventType = null;
	
	        window.removeEventListener('blur', _this._handleWindowBlur);
	
	        if (_this._fab) {
	          _this._fab._animateForSnackbar(multiline, leaveTimeout);
	        }
	
	        onDismiss();
	      }, autohideTimeout || _this.state.toast);
	    }, _this._handleWindowBlur = function () {
	      _this._clearTimeout();
	      window.removeEventListener('blur', _this._handleWindowBlur);
	      window.addEventListener('focus', _this._handleWindowFocus);
	      _this._eventType = 'focus';
	    }, _this._handleWindowFocus = function () {
	      window.removeEventListener('focus', _this._handleWindowFocus);
	      _this._eventType = null;
	      _this._handleAutohide();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          fab = _props.fab,
	          multiline = _props.multiline,
	          onAppear = _props.toast.onAppear;
	
	      if (onAppear) {
	        onAppear();
	      }
	
	      if (!fab || (0, _isInvalidAnimate2.default)(fab)) {
	        return;
	      }
	
	      this._fab = fab.getComposedComponent().getComposedComponent();
	      this._fab._animateForSnackbar(multiline);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._handleAutohide();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._clearTimeout();
	
	      if (this._eventType === 'focus') {
	        window.removeEventListener('focus', this._handleWindowFocus);
	      } else if (this._eventType === 'blur') {
	        window.removeEventListener('blur', this._handleWindowBlur);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          toast = _props2.toast,
	          multiline = _props2.multiline,
	          propId = _props2.id,
	          fab = _props2.fab,
	          autohide = _props2.autohide,
	          autohideTimeout = _props2.autohideTimeout,
	          leaveTimeout = _props2.leaveTimeout,
	          onDismiss = _props2.onDismiss,
	          props = _objectWithoutProperties(_props2, ['className', 'toast', 'multiline', 'id', 'fab', 'autohide', 'autohideTimeout', 'leaveTimeout', 'onDismiss']);
	
	      var text = toast.text,
	          action = toast.action;
	      var id = this.props.id;
	
	
	      var Component = 'p';
	      if (action) {
	        Component = 'section';
	        text = _react2.default.createElement(
	          'p',
	          { className: 'md-snackbar--toast md-snackbar--action' },
	          text
	        );
	
	        var btnProps = {
	          flat: true,
	          onClick: this._handleClick,
	          children: action,
	          secondary: true,
	          className: 'md-btn--snackbar'
	        };
	
	        if (typeof action !== 'string') {
	          btnProps = Object.assign(btnProps, action, {
	            className: (0, _classnames2.default)(btnProps.className, action.className),
	            onClick: this._handleClick
	          });
	        }
	
	        action = _react2.default.createElement(_Button2.default, btnProps);
	      }
	
	      if (!id) {
	        id = 'snackbar-alert' + (action ? '-dialog' : '');
	      }
	
	      var role = 'alert' + (action ? 'dialog' : '');
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          id: id,
	          role: role,
	          className: (0, _classnames2.default)('md-snackbar', {
	            'md-snackbar--multiline': multiline,
	            'md-snackbar--toast': !action
	          }, className)
	        }),
	        text,
	        action
	      );
	    }
	  }]);
	
	  return Snackbar;
	}(_react.PureComponent);
	
	Snackbar.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  onDismiss: _propTypes2.default.func.isRequired,
	  toast: _propTypes2.default.shape({
	    text: _propTypes2.default.node.isRequired,
	    action: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
	      label: _propTypes2.default.node,
	      children: _propTypes2.default.node,
	      onClick: _propTypes2.default.func
	    })]),
	    onAppear: _propTypes2.default.func
	  }).isRequired,
	  multiline: _propTypes2.default.bool,
	  autohide: _propTypes2.default.bool,
	  autohideTimeout: _propTypes2.default.number,
	  fab: _propTypes2.default.object,
	  leaveTimeout: _propTypes2.default.number.isRequired
	};
	exports.default = Snackbar;
	//# sourceMappingURL=Snackbar.js.map

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInvalidAnimate;
	var gcc = 'getComposedComponent';
	
	/**
	 * Just checks if the fab is actually a ref to the FAB Button.
	 */
	function isInvalidAnimate(fab) {
	  return typeof fab[gcc] !== 'function' || typeof fab[gcc]()[gcc] !== 'function' || typeof fab[gcc]()[gcc]()._animateForSnackbar !== 'function';
	}
	//# sourceMappingURL=isInvalidAnimate.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Subheader` component is generally used inside of lists or menus.
	 */
	var Subheader = function (_PureComponent) {
	  _inherits(Subheader, _PureComponent);
	
	  function Subheader() {
	    _classCallCheck(this, Subheader);
	
	    return _possibleConstructorReturn(this, (Subheader.__proto__ || Object.getPrototypeOf(Subheader)).apply(this, arguments));
	  }
	
	  _createClass(Subheader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          inset = _props.inset,
	          primary = _props.primary,
	          primaryText = _props.primaryText,
	          className = _props.className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['component', 'inset', 'primary', 'primaryText', 'className', 'children']);
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-subheader', {
	            'md-list-item--inset': inset
	          }, (0, _themeColors2.default)({ primary: primary, hint: !primary }), className)
	        }),
	        primaryText,
	        children
	      );
	    }
	  }]);
	
	  return Subheader;
	}(_react.PureComponent);
	
	Subheader.propTypes = {
	  /**
	   * An optional style to apply to the subheader.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the subheader.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the subheader should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the subheader is inset in the list. This will add additional
	   * spacing to align the subheader.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * The primary text to use in the subheader.
	   */
	  primaryText: _propTypes2.default.node.isRequired,
	
	  /**
	   * Any optional children to display after the `primaryText`. This prop is
	   * not recommended.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to render the Subheader as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	Subheader.defaultProps = {
	  component: 'li'
	};
	exports.default = Subheader;
	//# sourceMappingURL=Subheader.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Subheader = undefined;
	
	var _Subheader2 = __webpack_require__(155);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader3.default;
	exports.Subheader = _Subheader3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _Menu = __webpack_require__(46);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _AccessibleFakeInkedButton = __webpack_require__(25);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _mapToListParts = __webpack_require__(102);
	
	var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `MenuTab` component is used when there are too many desktop tabs
	 * to be displayed without any overflow. If the `Tabs` component is used,
	 * this will automatically be included when the `menuOverflow` prop is true.
	 */
	var MenuTab = function (_PureComponent) {
	  _inherits(MenuTab, _PureComponent);
	
	  function MenuTab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MenuTab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuTab.__proto__ || Object.getPrototypeOf(MenuTab)).call.apply(_ref, [this].concat(args))), _this), _this.state = { visible: false }, _this._toggleVisible = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      _this.setState({ visible: !_this.state.visible });
	    }, _this._handleClose = function () {
	      _this.setState({ visible: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MenuTab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          style = _props.style,
	          className = _props.className,
	          tabStyle = _props.tabStyle,
	          tabClassName = _props.tabClassName,
	          tabs = _props.tabs,
	          label = _props.label,
	          activeTabIndex = _props.activeTabIndex,
	          overflowAtIndex = _props.overflowAtIndex,
	          props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'tabStyle', 'tabClassName', 'tabs', 'label', 'activeTabIndex', 'overflowAtIndex']);
	
	      var active = activeTabIndex >= overflowAtIndex;
	
	      var tab = _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, props, {
	          onClick: this._toggleVisible,
	          style: tabStyle,
	          className: (0, _classnames2.default)('md-tab md-tab--menu', tabClassName)
	        }),
	        label
	      );
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        {
	          id: id,
	          style: style,
	          className: (0, _classnames2.default)('md-menu--tab', {
	            'md-tab--active': active,
	            'md-tab--inactive': !active
	          }, className),
	          toggle: tab,
	          visible: this.state.visible,
	          onClose: this._handleClose
	        },
	        tabs.map(_mapToListParts2.default)
	      );
	    }
	  }]);
	
	  return MenuTab;
	}(_react.PureComponent);
	
	MenuTab.propTypes = {
	  /**
	   * An id to give the tab's menu.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The current active tab index. This is used to determine which list item
	   * is active in the menu, and if the styles for an active tab should be applied
	   * to the menu.
	   */
	  activeTabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * An tab index that caused the overflow to happen.
	   */
	  overflowAtIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * A list of tabs that should be rendered in the menu once opened. This can either
	   * be:
	   *
	   * - a `ListItem`, `Divider`, or `Subheader` component
	   * - a string to use as the `primaryText` for a list item
	   * - an object that defines props to generate a `ListItem`, `Divider`, or `Subheader` component
	   */
	  tabs: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])).isRequired,
	
	  /**
	   * An optional style to apply to the menu.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the tab in the menu.
	   */
	  tabStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the tab in the menu.
	   */
	  tabClassName: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the tab is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * The label to display in the tab. This should normally be some text with
	   * a drop down arrow next to it.
	   */
	  label: _propTypes2.default.node.isRequired
	};
	exports.default = MenuTab;
	//# sourceMappingURL=MenuTab.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component is just a simple accessibility wrapper when using tabs. If you use the
	 * `TabsContainer` component, you *should* not manually use this as the `TabsContainer`
	 * generates this for you.
	 */
	var TabPanel = function (_PureComponent) {
	  _inherits(TabPanel, _PureComponent);
	
	  function TabPanel() {
	    _classCallCheck(this, TabPanel);
	
	    return _possibleConstructorReturn(this, (TabPanel.__proto__ || Object.getPrototypeOf(TabPanel)).apply(this, arguments));
	  }
	
	  _createClass(TabPanel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          id = _props.id,
	          active = _props.active,
	          className = _props.className,
	          controlledById = _props.controlledById,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['component', 'id', 'active', 'className', 'controlledById', 'children']);
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          id: id,
	          className: (0, _classnames2.default)('md-tab-panel', className),
	          role: 'tabpanel',
	          'aria-hidden': !active,
	          'aria-labelledby': controlledById
	        }),
	        children
	      );
	    }
	  }]);
	
	  return TabPanel;
	}(_react.PureComponent);
	
	TabPanel.propTypes = {
	  /**
	   * An id for the panel. This is used for a11y. This should equal the `controlsId`
	   * of whichever tab's children will be placed in here.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An id for the tab that owns this panel. This should equal the `id` of whichever
	   * tab's children will be placed in here.
	   */
	  controlledById: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render the panel as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the panel is currently active. This is used to generated the `aria-hidden`
	   * attribute.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * Any children to display.
	   */
	  children: _propTypes2.default.node
	};
	TabPanel.defaultProps = {
	  component: 'div'
	};
	exports.default = TabPanel;
	//# sourceMappingURL=TabPanel.js.map

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FloatingLabel = function (_PureComponent) {
	  _inherits(FloatingLabel, _PureComponent);
	
	  function FloatingLabel() {
	    _classCallCheck(this, FloatingLabel);
	
	    return _possibleConstructorReturn(this, (FloatingLabel.__proto__ || Object.getPrototypeOf(FloatingLabel)).apply(this, arguments));
	  }
	
	  _createClass(FloatingLabel, [{
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          label = _props.label,
	          htmlFor = _props.htmlFor,
	          className = _props.className,
	          floating = _props.floating,
	          active = _props.active,
	          error = _props.error,
	          disabled = _props.disabled,
	          iconOffset = _props.iconOffset,
	          customSize = _props.customSize,
	          props = _objectWithoutProperties(_props, ['label', 'htmlFor', 'className', 'floating', 'active', 'error', 'disabled', 'iconOffset', 'customSize']);
	
	      if (!label) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'label',
	        _extends({}, props, {
	          htmlFor: htmlFor,
	          className: (0, _classnames2.default)('md-floating-label', (_cn = {
	            'md-floating-label--inactive': !floating,
	            'md-floating-label--inactive-sized': !floating && !customSize
	          }, _defineProperty(_cn, 'md-floating-label--' + customSize, customSize), _defineProperty(_cn, 'md-floating-label--inactive-' + customSize, customSize && !floating), _defineProperty(_cn, 'md-floating-label--floating', floating), _defineProperty(_cn, 'md-floating-label--icon-offset', iconOffset), _cn), (0, _themeColors2.default)({
	            disabled: disabled,
	            error: error,
	            hint: !active,
	            primary: active
	          }, className))
	        }),
	        label
	      );
	    }
	  }]);
	
	  return FloatingLabel;
	}(_react.PureComponent);
	
	FloatingLabel.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  label: _propTypes2.default.node,
	  floating: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  iconOffset: _propTypes2.default.bool,
	  customSize: _propTypes2.default.string,
	  htmlFor: _propTypes2.default.string
	};
	exports.default = FloatingLabel;
	//# sourceMappingURL=FloatingLabel.js.map

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Divider = __webpack_require__(90);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextFieldDivider = function (_PureComponent) {
	  _inherits(TextFieldDivider, _PureComponent);
	
	  function TextFieldDivider() {
	    _classCallCheck(this, TextFieldDivider);
	
	    return _possibleConstructorReturn(this, (TextFieldDivider.__proto__ || Object.getPrototypeOf(TextFieldDivider)).apply(this, arguments));
	  }
	
	  _createClass(TextFieldDivider, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          error = _props.error,
	          lineDirection = _props.lineDirection,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['active', 'error', 'lineDirection', 'className']);
	
	      return _react2.default.createElement(_Divider2.default, _extends({}, props, {
	        className: (0, _classnames2.default)('md-divider--text-field md-divider--expand-from-' + lineDirection, {
	          'md-divider--text-field-expanded': active,
	          'md-divider--text-field-active': !error && active,
	          'md-divider--text-field-error': error
	        }, className)
	      }));
	    }
	  }]);
	
	  return TextFieldDivider;
	}(_react.PureComponent);
	
	TextFieldDivider.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right'])
	};
	exports.default = TextFieldDivider;
	//# sourceMappingURL=TextFieldDivider.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _Message = __webpack_require__(342);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextFieldMessage = function (_PureComponent) {
	  _inherits(TextFieldMessage, _PureComponent);
	
	  function TextFieldMessage(props) {
	    _classCallCheck(this, TextFieldMessage);
	
	    var _this = _possibleConstructorReturn(this, (TextFieldMessage.__proto__ || Object.getPrototypeOf(TextFieldMessage)).call(this, props));
	
	    _this.state = {
	      message: props.error && props.errorText || props.helpText || props.errorText,
	      isMessageVisible: _this._isMessageVisible(props)
	    };
	    return _this;
	  }
	
	  _createClass(TextFieldMessage, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var keys = ['active', 'error', 'helpOnFocus', 'helpText', 'errorText'];
	      if (this._anyChanges(keys, this.props, nextProps)) {
	        this.setState({
	          isMessageVisible: this._isMessageVisible(nextProps),
	          message: nextProps.error && nextProps.errorText || nextProps.helpText || nextProps.errorText
	        });
	      }
	    }
	  }, {
	    key: '_anyChanges',
	    value: function _anyChanges(keys, p1, p2) {
	      var changed = false;
	      keys.some(function (key) {
	        if (p1[key] !== p2[key]) {
	          changed = true;
	        }
	
	        return changed;
	      });
	
	      return changed;
	    }
	  }, {
	    key: '_isMessageVisible',
	    value: function _isMessageVisible(props) {
	      var error = props.error,
	          errorText = props.errorText,
	          helpText = props.helpText,
	          helpOnFocus = props.helpOnFocus,
	          active = props.active;
	
	      if (error && errorText) {
	        return true;
	      }
	
	      return !!(helpText && (!helpOnFocus || active));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          maxLength = _props.maxLength,
	          error = _props.error,
	          className = _props.className,
	          errorText = _props.errorText,
	          helpText = _props.helpText,
	          currentLength = _props.currentLength,
	          leftIcon = _props.leftIcon,
	          rightIcon = _props.rightIcon,
	          block = _props.block,
	          active = _props.active;
	      var _state = this.state,
	          isMessageVisible = _state.isMessageVisible,
	          message = _state.message;
	
	
	      if (currentLength === 'undefined' || !helpText && !errorText && !maxLength) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('md-text-field-message-container', {
	            'md-text-field-message-container--count-only': !message || !isMessageVisible,
	            'md-text-field-message-container--left-icon-offset': leftIcon,
	            'md-text-field-message-container--right-icon-offset': rightIcon,
	            'md-full-width': !block
	          }, (0, _themeColors2.default)({ error: error, disabled: !error }), className)
	        },
	        _react2.default.createElement(
	          _Message2.default,
	          { key: 'message', active: isMessageVisible },
	          message
	        ),
	        _react2.default.createElement(
	          _Message2.default,
	          { key: 'counter', className: 'md-text-field-message--counter', active: active },
	          maxLength ? currentLength + ' / ' + maxLength : null
	        )
	      );
	    }
	  }]);
	
	  return TextFieldMessage;
	}(_react.PureComponent);
	
	TextFieldMessage.propTypes = {
	  className: _propTypes2.default.string,
	  error: _propTypes2.default.bool,
	  helpText: _propTypes2.default.node,
	  errorText: _propTypes2.default.node,
	  active: _propTypes2.default.bool,
	  helpOnFocus: _propTypes2.default.bool,
	  maxLength: _propTypes2.default.number,
	  currentLength: _propTypes2.default.number,
	  leftIcon: _propTypes2.default.bool,
	  rightIcon: _propTypes2.default.bool,
	  block: _propTypes2.default.bool
	};
	exports.default = TextFieldMessage;
	//# sourceMappingURL=TextFieldMessage.js.map

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _invalidIf = __webpack_require__(37);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _between = __webpack_require__(55);
	
	var _between2 = _interopRequireDefault(_between);
	
	var _Paper = __webpack_require__(29);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _ToolbarTitle = __webpack_require__(346);
	
	var _ToolbarTitle2 = _interopRequireDefault(_ToolbarTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toolbar = function (_PureComponent) {
	  _inherits(Toolbar, _PureComponent);
	
	  function Toolbar() {
	    _classCallCheck(this, Toolbar);
	
	    return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
	  }
	
	  _createClass(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          component = _props.component,
	          titleStyle = _props.titleStyle,
	          titleClassName = _props.titleClassName,
	          prominentTitle = _props.prominentTitle,
	          themed = _props.themed,
	          singleColor = _props.singleColor,
	          actions = _props.actions,
	          fixed = _props.fixed,
	          children = _props.children,
	          inset = _props.inset,
	          titleId = _props.titleId,
	          propNav = _props.nav,
	          propTitle = _props.title,
	          propTitleMenu = _props.titleMenu,
	          propZDepth = _props.zDepth,
	          propColored = _props.colored,
	          propProminent = _props.prominent,
	          containerStyle = _props.containerStyle,
	          containerClassName = _props.containerClassName,
	          actionLeft = _props.actionLeft,
	          actionsRight = _props.actionsRight,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'component', 'titleStyle', 'titleClassName', 'prominentTitle', 'themed', 'singleColor', 'actions', 'fixed', 'children', 'inset', 'titleId', 'nav', 'title', 'titleMenu', 'zDepth', 'colored', 'prominent', 'containerStyle', 'containerClassName', 'actionLeft', 'actionsRight', 'primary', 'secondary']);
	
	      var _props2 = this.props,
	          colored = _props2.colored,
	          title = _props2.title,
	          titleMenu = _props2.titleMenu,
	          nav = _props2.nav,
	          prominent = _props2.prominent,
	          zDepth = _props2.zDepth;
	
	
	      colored = colored || primary || secondary;
	      prominent = prominent || prominentTitle;
	
	      title = _react2.default.createElement(_ToolbarTitle2.default, {
	        key: 'title',
	        style: titleStyle,
	        className: titleClassName,
	        prominent: prominentTitle,
	        offset: prominentTitle,
	        id: typeof titleId === 'undefined' && props.id ? props.id + '-title' : titleId,
	        title: title
	      });
	
	      if (nav || actionLeft) {
	        var navEl = _react.Children.only(nav || actionLeft);
	        nav = (0, _react.cloneElement)(nav, {
	          className: (0, _classnames2.default)('md-btn--toolbar md-toolbar--action-left', navEl.props.className)
	        });
	      }
	
	      var rightActions = void 0;
	      if (actions || actionsRight) {
	        rightActions = _react.Children.map(_react.Children.toArray(actions || actionsRight), function (action) {
	          return (0, _react.cloneElement)(action, {
	            className: (0, _classnames2.default)('md-btn--toolbar', action.props.className)
	          });
	        });
	
	        rightActions = _react2.default.createElement(
	          'div',
	          { key: 'actions', className: 'md-cell--right md-toolbar--action-right' },
	          rightActions
	        );
	      }
	
	      if (titleMenu) {
	        titleMenu = _react.Children.only(titleMenu);
	        titleMenu = (0, _react.cloneElement)(titleMenu, {
	          className: (0, _classnames2.default)('md-title md-title--toolbar md-select-field--toolbar', {
	            'md-title--toolbar-offset': prominentTitle,
	            'md-title--toolbar-prominent': prominentTitle
	          }, titleMenu.props.className),
	          position: titleMenu.props.position || 'tl',
	          toolbar: true
	        });
	      }
	
	      if (typeof zDepth !== 'number') {
	        zDepth = fixed ? 2 : 0;
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          component: component,
	          zDepth: zDepth,
	          style: style,
	          className: (0, _classnames2.default)('md-toolbar', {
	            'md-background--primary': colored,
	            'md-toolbar--themed': themed,
	            'md-toolbar--text-white': singleColor && colored,
	            'md-toolbar--prominent': prominent,
	            'md-toolbar--fixed': fixed,
	            'md-toolbar--inset': inset
	          }, className)
	        }),
	        nav,
	        title,
	        titleMenu,
	        children,
	        rightActions
	      );
	    }
	  }]);
	
	  return Toolbar;
	}(_react.PureComponent);
	
	Toolbar.propTypes = {
	  /**
	   * An optional id to provide to the toolbar. If this is specified and the `titleId` is not, the title
	   * will gain an id of `${id}-title`. This will not be applied to the `titleMenu`.
	   *
	   * @see {@link #titleId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the toolbar.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the toolbar,
	   */
	  className: _propTypes2.default.string,
	
	  /*
	   * An optional style to apply to the `h2` surrounding the `title` prop.
	   */
	  titleStyle: _propTypes2.default.object,
	
	  /*
	   * An optional className to apply to the `h2` surrounding the `title` prop.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the toolbar should more prominent. This will double the height of the toolbar.
	   */
	  prominent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar's title should be more prominent. This will move the title to the
	   * second line of the toolbar. This only works when the `prominent` prop is true as well.
	   */
	  prominentTitle: _propTypes2.default.bool,
	
	  /**
	   * The current title of the page to show in the toolbar. It is invalid to specify both a
	   * `title` and a `titleMenu`. Only one should be given.
	   */
	  title: (0, _invalidIf2.default)(_propTypes2.default.node, 'titleMenu'),
	
	  /**
	   * An optional id to give the main title in the toolbar. This will not be applied to the
	   * `titleMenu`.
	   */
	  titleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional title menu to display instead of the title. This should be a `SelectField` component.
	   * It is cloned with some additional props, so if the `SelectField` is separated into a separate
	   * component, the following props must be passed to get the correct styling: `className`, `block`,
	   * `paddedBlock`, `position`.
	   */
	  titleMenu: _propTypes2.default.element,
	
	  /**
	   * This prop is used for rendering an optional navigation button to the left of the `title`
	   * or the `titleMenu` component. This needs to be an icon `Button` because some additional props
	   * are cloned into it.
	   */
	  nav: _propTypes2.default.element,
	
	  /**
	   * Any additional actions to display to the right of the title. This should be a list or a single
	   * `Button` to display. The buttons get cloned with an additional className for toolbar styling.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	
	  /**
	   * Any children to display in the toolbar. This will be displayed between the optional title and
	   * actions.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the toolbar should be fixed to the top of the page. This will add some additional box shadow.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the nav, actions, and title should share the same color. For a `colored` or dark `themed`
	   * toolbar, they will all be colored white. For a transparent or light `themed` toolbar, the colors will
	   * be the `rgba(0, 0, 0, .87)`. Setting this to false will only style the title to the specific color
	   * stated above.
	   */
	  singleColor: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar should be colored based off the current theme. This will either style the background
	   * to be fairly white, or fairly black. You can not specify both `themed` and `colored`.
	   */
	  themed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar should be colored with the `$md-primary-color`.
	   */
	  colored: (0, _invalidIf2.default)(_propTypes2.default.bool, 'themed'),
	
	  /**
	   * The component to render the toolbar as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the toolbar is inset in the page. This will just add some margin around
	   * it.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * An optional zDepth to enforce for the toolbar. This should be a number between 0 and 5.
	   * If this is omitted, the toolbar will gain a zDepth of 2 when `fixed`.
	   */
	  zDepth: (0, _between2.default)(_propTypes2.default.number, 0, 5),
	  containerStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'The `container` no longer exists in the `Toolbar`. Use the `style` prop instead'),
	  containerClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'The `container` no longer exists in the `Toolbar`. Use the `className` prop instead'),
	  primary: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `colored` prop instead'),
	  secondary: (0, _deprecated2.default)(_propTypes2.default.bool, 'Toolbars can no longer be themed to the secondary color. Use the `colored` prop instead'),
	  actionLeft: (0, _deprecated2.default)(_propTypes2.default.element, 'Use the `nav` prop instead'),
	  actionsRight: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `menu` prop and/or the `actions` prop instead')
	};
	Toolbar.defaultProps = {
	  singleColor: true,
	  component: 'header'
	};
	exports.default = Toolbar;
	//# sourceMappingURL=Toolbar.js.map

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(81);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(9);
	
	var _captureNextEvent = __webpack_require__(52);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _touches = __webpack_require__(54);
	
	var _Tooltip = __webpack_require__(348);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getContainer(tooltip) {
	  return tooltip.parentNode;
	}
	
	var TooltipContainer = function (_PureComponent) {
	  _inherits(TooltipContainer, _PureComponent);
	
	  function TooltipContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TooltipContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltipContainer.__proto__ || Object.getPrototypeOf(TooltipContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = { visible: false }, _this._delayedTimeout = null, _this._unlinkTarget = function () {
	      var target = _this._target;
	      if (target) {
	        (0, _touches.removeTouchEvent)(target, 'start', _this._showTooltip);
	        (0, _touches.removeTouchEvent)(target, 'end', _this._hideTooltip);
	        target.removeEventListener('mouseover', _this._showTooltip);
	        target.removeEventListener('mouseleave', _this._hideTooltip);
	        target.removeEventListener('keyup', _this._handleKeyUp);
	        target.removeEventListener('blur', _this._hideTooltip);
	      }
	    }, _this._setTarget = function () {
	      var container = _this._container;
	      var target = _this.props.target;
	
	
	      _this._unlinkTarget();
	
	      if (typeof target === 'function') {
	        target = target(container, _this);
	      }
	      target = target ? (0, _reactDom.findDOMNode)(target) : container;
	      _this._target = target || null;
	
	      if (target) {
	        (0, _touches.addTouchEvent)(target, 'start', _this._showTooltip);
	        (0, _touches.addTouchEvent)(target, 'end', _this._hideTooltip);
	        target.addEventListener('mouseover', _this._showTooltip);
	        target.addEventListener('mouseleave', _this._hideTooltip);
	        target.addEventListener('keyup', _this._handleKeyUp);
	        target.addEventListener('blur', _this._hideTooltip);
	      }
	    }, _this._setContainers = function (span) {
	      if (span) {
	        _this._container = _this.props.container(span.parentNode, _this);
	      }
	    }, _this._stopContextMenu = function (e) {
	      e.preventDefault();
	      window.removeEventListener('contextmenu', _this._stopContextMenu, true);
	      (0, _captureNextEvent2.default)('click');
	      _this.setState({ visible: true });
	    }, _this._showTooltip = function (e) {
	      if (e.type === 'mouseover' && _this._touched) {
	        return;
	      }
	
	      if (e.type === 'touchstart') {
	        _this._touched = true;
	
	        window.addEventListener('contextmenu', _this._stopContextMenu, true);
	        return;
	      }
	
	      var delay = _this.props.delay;
	
	      if (_this._delayedTimeout) {
	        clearTimeout(_this._delayedTimeout);
	      }
	
	      if (delay) {
	        _this._delayedTimeout = setTimeout(function () {
	          _this._delayedTimeout = null;
	
	          _this.setState({ visible: true });
	        }, delay);
	      } else {
	        _this.setState({ visible: true });
	      }
	    }, _this._hideTooltip = function (e) {
	      if (_this._delayedTimeout) {
	        clearTimeout(_this._delayedTimeout);
	      }
	
	      if (e.type === 'mouseover' && _this._touched) {
	        return;
	      }
	
	      _this.setState({ visible: false });
	    }, _this._handleKeyUp = function (e) {
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        _this._showTooltip(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TooltipContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._setTarget();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.target !== prevProps.target) {
	        this._setTarget();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unlinkTarget();
	      this._target = null;
	
	      if (this._delayedTimeout) {
	        clearTimeout(this._delayedTimeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var visible = this.state.visible;
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          tooltipStyle = _props.tooltipStyle,
	          tooltipClassName = _props.tooltipClassName,
	          label = _props.label,
	          position = _props.position,
	          enterTimeout = _props.enterTimeout,
	          leaveTimeout = _props.leaveTimeout;
	
	
	      var tooltip = _react2.default.createElement(
	        _Tooltip2.default,
	        {
	          key: 'tooltip',
	          style: tooltipStyle,
	          className: tooltipClassName,
	          position: position,
	          enterTimeout: enterTimeout,
	          leaveTimeout: leaveTimeout
	        },
	        label
	      );
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-tooltip-container', className),
	          component: 'div'
	        },
	        _react2.default.createElement('span', { ref: this._setContainers, 'aria-hidden': true }),
	        visible ? tooltip : null
	      );
	    }
	  }]);
	
	  return TooltipContainer;
	}(_react.PureComponent);
	
	TooltipContainer.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  tooltipStyle: _propTypes2.default.object,
	  tooltipClassName: _propTypes2.default.string,
	  label: _propTypes2.default.node.isRequired,
	  position: _Tooltip2.default.propTypes.position,
	  delay: _propTypes2.default.number,
	  enterTimeout: _Tooltip2.default.propTypes.enterTimeout,
	  leaveTimeout: _Tooltip2.default.propTypes.leaveTimeout,
	  /**
	   * A function that returns a DOM element that will be used as the tooltip's container.
	   * A ref to the tooltip's DOM element will be passed into the function.
	   */
	  container: _propTypes2.default.func,
	  /**
	   * A component/element the tooltip should be linked to,
	   * or a function that returns such a component/element.
	   * A ref to the tooltip's container will be passed into the function.
	   *
	   * By default the tooltip's container will be used as the target.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
	};
	TooltipContainer.defaultProps = {
	  container: getContainer,
	  delay: 0
	};
	exports.default = TooltipContainer;
	//# sourceMappingURL=TooltipContainer.js.map

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** @module utils/DateUtils/DateTimeFormat */
	
	/**
	 * A _really_ terrible DateTimeFormat mock if it is not available in
	 * the browser or node version.
	 */
	var DateTimeFormat = function () {
	  if (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat !== 'undefined') {
	    return Intl.DateTimeFormat;
	  }
	
	  // Very bad 'mock' of Intl.DateTimeFormat
	  return function () {
	    // eslint-disable-line no-shadow
	    function DateTimeFormat(locales, formatOptions) {
	      _classCallCheck(this, DateTimeFormat);
	
	      this.locales = locales;
	      this.options = formatOptions;
	    }
	
	    _createClass(DateTimeFormat, [{
	      key: 'format',
	      value: function format(date) {
	        return date.toLocaleString();
	      }
	    }]);
	
	    return DateTimeFormat;
	  }();
	}();
	
	exports.default = DateTimeFormat;
	//# sourceMappingURL=DateTimeFormat.js.map

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatTime;
	/** @module utils/DateUtils/formatTime */
	
	/**
	 * Formats a date as a time string using the DateTimeFormat function and locales.
	 *
	 * @param {function} DateTimeFormat the DateTimeFormat function to use.
	 * @param {string|string[]} locales the locales to use.
	 * @param {Date} time the time to format into a string.
	 * @return a string of the formatted time.
	 */
	function formatTime(DateTimeFormat, locales, time) {
	  return new DateTimeFormat(locales, { hour: 'numeric', minute: '2-digit' }).format(time);
	}
	//# sourceMappingURL=formatTime.js.map

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDayOfWeek;
	/** @module utils/DateUtils/getDayOfWeek */
	
	/**
	 * Gets a day in the week. 0 = Sunday 6 = Saturday
	 *
	 * @param {date} sourceDate the date to find a relative day of week from
	 * @param {number} dow the day of the week to find
	 * @return a new Date as the given day of week
	 */
	function getDayOfWeek(sourceDate) {
	  var dow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var date = new Date(sourceDate);
	  var day = date.getDay();
	
	  var diff = date.getDate() - day + dow;
	  return new Date(date.setDate(diff));
	}
	//# sourceMappingURL=getDayOfWeek.js.map

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripTime;
	/** @module utils/DateUtils/stripTime */
	
	/**
	 * Removes all time from a date. Only keeps year, month, and date.
	 * @param {Date} date the date to strip
	 * @return a new Date with the time stripped.
	 */
	function stripTime(date) {
	  if (!date || !(date instanceof Date)) {
	    return null;
	  }
	
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	}
	//# sourceMappingURL=stripTime.js.map

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBetween;
	/** @module utils/NumberUtils/isBetween */
	
	/**
	 * Checks if a number is between a min and maximum (inclusive)
	 *
	 * @param {Number} num the number to check
	 * @param {Number} min the minimum
	 * @param {Number} max the maximum
	 * @return {Boolean} true if the number is between the min and max (inclusive)
	 */
	function isBetween(num, min, max) {
	  return num >= min && num <= max;
	}
	//# sourceMappingURL=isBetween.js.map

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calcPageOffset;
	
	var _getPagePosition = __webpack_require__(170);
	
	var _getPagePosition2 = _interopRequireDefault(_getPagePosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Calculates the page offset of an element. If the element
	 * is false-ish, an empty object will be returned.
	 *
	 * This is really only used for calculating an ink position.
	 *
	 * @param {Node} el - An html node to find a page offset for.
	 * @return {Object} an object with a left and top attribute for the page
	 *    offset.
	 */
	function calcPageOffset(el) {
	  if (!el) {
	    return { left: null, right: null };
	  }
	
	  var rect = el.getBoundingClientRect();
	  return {
	    left: rect.left + (0, _getPagePosition2.default)('x'),
	    top: rect.top + (0, _getPagePosition2.default)('y')
	  };
	} /** @module utils/Positioning/calcPageOffset */
	//# sourceMappingURL=calcPageOffset.js.map

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPagePosition;
	/** @module utils/Positioning/getPagePosition */
	
	/**
	 * Gets the current page position.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
	 * @param {String} direction - The direction that should be retrieved. This
	 *    should be either 'x' or 'y'.
	 * @return {number} the position of the direction on the page.
	 */
	function getPagePosition(direction) {
	  var scroll = 'scroll' + (direction === 'x' ? 'Left' : 'Top');
	  if (typeof window.pageXOffset !== 'undefined') {
	    return window['page' + direction.toUpperCase() + 'Offset'];
	  } else if ((document.compatMode || '') === 'CSS1Compat') {
	    return document.documentElement[scroll];
	  } else {
	    return document.body[scroll];
	  }
	}
	//# sourceMappingURL=getPagePosition.js.map

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScreenSize;
	/** @module utils/Positioning/getScreenSize */
	
	/**
	 * A utility function to get the height or width of the of the browser with
	 * a fallback for older browsers.
	 *
	 * @param {String} position - the position to get the screen size for
	 * @return {number} the screen size for the provided position.
	 */
	function getScreenSize(position) {
	  if (position !== 'Height' && position !== 'Width' && ("production") !== 'production') {
	    throw new Error('The \'getScreenSize\' function requires either a position of \'Height\' or \'Width\' ' + ('but received `' + position + '`'));
	  }
	
	  return window['inner' + position] || document.documentElement['client' + position];
	}
	//# sourceMappingURL=getScreenSize.js.map

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = viewport;
	
	var _getScreenSize = __webpack_require__(171);
	
	var _getScreenSize2 = _interopRequireDefault(_getScreenSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Determines if an element is still in the viewport. If it is,
	 * it will return a `true` boolean. If it is not, it will return
	 * an object containing booleans for top, right, bottom, and left
	 * where a `false` value will mean it is out of the viewport for that
	 * position.
	 *
	 * @param {Object} el - The element to test.
	 * @return {boolean|Object} the results.
	 */
	function viewport(el) {
	  if (!el) {
	    return {};
	  }
	
	  var rect = el.getBoundingClientRect();
	  var top = rect.top >= 0;
	  var right = rect.right <= (0, _getScreenSize2.default)('Width');
	  var bottom = rect.bottom <= (0, _getScreenSize2.default)('Height');
	  var left = rect.left >= 0;
	
	  return top && right && bottom && left || { top: top, right: right, bottom: bottom, left: left };
	} /** @module utils/Positioning/viewport */
	//# sourceMappingURL=viewport.js.map

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = oneRequired;
	/** @module utils/PropTypes/oneRequired */
	
	/**
	 * A simple prop type validation that makes sure that at least this prop or one of the
	 * other defined prop names are defined for a component.
	 *
	 * @param {function} validator - The PropType validator for the current prop.
	 * @param {...String} otherPropNames - A single or list of prop names that could be defined
	 * @return {Error} a prop type validation error or null.
	 */
	function oneRequired(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && !allPropNames.filter(function (pn) {
	      return typeof props[pn] !== 'undefined';
	    }).length) {
	      err = new Error('One of the following props are required for the ' + componentNameSafe + ' component. ' + ('`' + allPropNames.join('`, `') + '`.'));
	    }
	
	    return err;
	  };
	}
	//# sourceMappingURL=oneRequired.js.map

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addSuffix;
	/** @module utils/StringUtils/addSuffix */
	
	/**
	 * Optionally adds a suffix to a string if it does
	 * not already contain that string.
	 *
	 * @param {String} str - The string to modify
	 * @param {String} suffix - The suffix to add
	 *
	 * @return {String} the string with a suffix
	 */
	function addSuffix(str, suffix) {
	  if (!str || typeof str !== 'string') {
	    return str;
	  }
	
	  return str.indexOf(suffix) === -1 ? str.trim() + ' ' + suffix : str;
	}
	//# sourceMappingURL=addSuffix.js.map

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFormPartRole;
	/** @module utils/isFormPartRole */
	
	/**
	 * A simple utility function to determine if an element has a role that should
	 * be used as a form part. This is mostly used for changing the behavior of keyboard
	 * events.
	 *
	 * A form part role is one of the following:
	 * - checkbox
	 * - radio
	 * - listbox
	 * - input
	 *
	 * @param {HTMLElement} el - the element to check.
	 * @return {boolean} true if the element is considered an element part of a form.
	 */
	function isFormPartRole(el) {
	  if (!el) {
	    return false;
	  } else if (el.nodeName === 'INPUT') {
	    return true;
	  }
	
	  var role = el.getAttribute('role');
	  return role === 'checkbox' || role === 'radio' || role === 'listbox';
	}
	//# sourceMappingURL=isFormPartRole.js.map

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(378);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(379);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(380);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(383);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(176);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(78);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(382);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  RESISTANCE_COEF: 0.6,
	
	  // This value is closed to what browsers are using internally to
	  // trigger a native scroll.
	  UNCERTAINTY_THRESHOLD: 3 // px
	};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Render a group of error bar
	                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorBar = (_temp = _class = function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, (ErrorBar.__proto__ || Object.getPrototypeOf(ErrorBar)).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: 'renderErrorBars',
	    value: function renderErrorBars() {
	      var _props = this.props,
	          offset = _props.offset,
	          layout = _props.layout,
	          width = _props.width,
	          dataKey = _props.dataKey,
	          data = _props.data,
	          dataPointFormatter = _props.dataPointFormatter,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          others = _objectWithoutProperties(_props, ['offset', 'layout', 'width', 'dataKey', 'data', 'dataPointFormatter', 'xAxis', 'yAxis']);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid = void 0,
	            yMid = void 0,
	            xMin = void 0,
	            yMin = void 0,
	            xMax = void 0,
	            yMax = void 0,
	            scale = void 0,
	            coordsTop = void 0,
	            coordsMid = void 0,
	            coordsBot = void 0,
	            lowBound = void 0,
	            highBound = void 0;
	
	        if (Array.isArray(errorVal)) {
	          lowBound = errorVal[0];
	          highBound = errorVal[1];
	        } else {
	          lowBound = errorVal;
	          highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = { x1: xMax, y1: yMin, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMin, y1: yMid, x2: xMax, y2: yMid };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMin, y2: yMax };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = { x1: xMin, y1: yMax, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMid, y1: yMin, x2: xMid, y2: yMax };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMax, y2: yMin };
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({ className: 'recharts-errorBar', key: i }, props),
	          _react2.default.createElement('line', coordsTop),
	          _react2.default.createElement('line', coordsMid),
	          _react2.default.createElement('line', coordsBot)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-errorBars' },
	        this.renderErrorBars()
	      );
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component), _class.propTypes = {
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  data: _propTypes2.default.array,
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	  layout: _propTypes2.default.string,
	  dataPointFormatter: _propTypes2.default.func,
	  stroke: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  offset: _propTypes2.default.number
	}, _class.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	}, _temp);
	exports.default = ErrorBar;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Cross
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cell() {
	  return null;
	}
	
	Cell.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES);
	Cell.displayName = 'Cell';
	
	exports.default = Cell;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Surface
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ['children', 'width', 'height', 'viewBox', 'className', 'style']);
	
	  var svgView = viewBox || { width: width, height: height, x: 0, y: 0 };
	  var layerClass = (0, _classnames2.default)('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({}, attrs, {
	      className: layerClass,
	      width: width,
	      height: height,
	      style: style,
	      viewBox: svgView.x + ' ' + svgView.y + ' ' + svgView.width + ' ' + svgView.height,
	      version: '1.1'
	    }),
	    children
	  );
	}
	
	Surface.propTypes = propTypes;
	
	exports.default = Surface;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatAxisMap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ChartUtils = __webpack_require__(33);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {String} axisType  The type of axes, x-axis or y-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = exports.formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height,
	      layout = props.layout;
	
	  var ids = Object.keys(axisMap);
	  var steps = {
	    left: offset.left,
	    leftMirror: offset.left,
	    right: width - offset.right,
	    rightMirror: width - offset.right,
	    top: offset.top,
	    topMirror: offset.top,
	    bottom: height - offset.bottom,
	    bottomMirror: height - offset.bottom
	  };
	
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var orientation = axis.orientation,
	        domain = axis.domain,
	        _axis$padding = axis.padding,
	        padding = _axis$padding === undefined ? {} : _axis$padding,
	        mirror = axis.mirror,
	        reversed = axis.reversed;
	
	    var offsetKey = '' + orientation + (mirror ? 'Mirror' : '');
	
	    var range = void 0,
	        x = void 0,
	        y = void 0,
	        needSpace = void 0;
	
	    if (axisType === 'xAxis') {
	      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	    } else if (axisType === 'yAxis') {
	      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	    } else {
	      range = axis.range;
	    }
	
	    if (reversed) {
	      range = [range[1], range[0]];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        scale = _parseScale.scale,
	        realScaleType = _parseScale.realScaleType;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _extends({}, axis, { realScaleType: realScaleType }));
	
	    if (axisType === 'xAxis') {
	      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	      x = offset.left;
	      y = steps[offsetKey] - needSpace * axis.height;
	    } else if (axisType === 'yAxis') {
	      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	      x = steps[offsetKey] - needSpace * axis.width;
	      y = offset.top;
	    }
	
	    var finalAxis = _extends({}, axis, ticks, {
	      realScaleType: realScaleType, x: x, y: y, scale: scale,
	      width: axisType === 'xAxis' ? offset.width : axis.width,
	      height: axisType === 'yAxis' ? offset.height : axis.height
	    });
	
	    finalAxis.bandSize = (0, _ChartUtils.getBandSizeOfAxis)(finalAxis, ticks);
	
	    if (!axis.hide && axisType === 'xAxis') {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	    } else if (!axis.hide) {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	    }
	
	    return _extends({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};

/***/ }),
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(631),
	    listCacheDelete = __webpack_require__(632),
	    listCacheGet = __webpack_require__(633),
	    listCacheHas = __webpack_require__(634),
	    listCacheSet = __webpack_require__(635);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(220);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(114);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(628);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(85);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(114);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(224);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ }),
/* 197 */,
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = undefined;
	
	var _intersection2 = __webpack_require__(663);
	
	var _intersection3 = _interopRequireDefault(_intersection2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = exports.getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection3.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	var identity = exports.identity = function identity(param) {
	  return param;
	};
	
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	var getDashCase = exports.getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return '-' + v.toLowerCase();
	  });
	};
	
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	var generatePrefixStyle = exports.generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, IN_LINE_PREFIX_LIST[i] + '$1');
	    }
	
	    return _extends({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	var log = exports.log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	var debug = exports.debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	
	    return item;
	  };
	};
	
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	var debugf = exports.debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(undefined, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = '(' + args.map(JSON.stringify).join(', ') + ')';
	
	    log(name + ': ' + argNames + ' => ' + JSON.stringify(res));
	
	    return res;
	  };
	};
	
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	var mapObject = exports.mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	var translateStyle = exports.translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _extends({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	var compose = exports.compose = function compose() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var getTransitionVal = exports.getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return getDashCase(prop) + ' ' + duration + 'ms ' + easing;
	  }).join(',');
	};
	
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};

/***/ }),
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Z Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ZAxis, _Component);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, (ZAxis.__proto__ || Object.getPrototypeOf(ZAxis)).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.Component), _class2.displayName = 'ZAxis', _class2.propTypes = {
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of z-axis
	  zAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // The range of axis
	  range: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func])
	}, _class2.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto',
	  type: 'number'
	}, _temp)) || _class;
	
	exports.default = ZAxis;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Tooltip
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(63);
	
	var _DefaultTooltipContent = __webpack_require__(741);
	
	var _DefaultTooltipContent2 = _interopRequireDefault(_DefaultTooltipContent);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _DataUtils = __webpack_require__(19);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EPS = 1;
	
	var propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  active: _propTypes2.default.bool,
	  separator: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  offset: _propTypes2.default.number,
	
	  itemStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  wrapperStyle: _propTypes2.default.object,
	  cursor: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.element, _propTypes2.default.object]),
	
	  coordinate: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  position: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	
	  label: _propTypes2.default.any,
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.any,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    unit: _propTypes2.default.any
	  })),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _propTypes2.default.func,
	  filterNull: _propTypes2.default.bool,
	  useTranslate3d: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  active: false,
	  offset: 10,
	  viewBox: { x1: 0, x2: 0, y1: 0, y2: 0 },
	  coordinate: { x: 0, y: 0 },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  itemSorter: function itemSorter() {
	    return -1;
	  },
	  filterNull: true,
	  useTranslate3d: false
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultTooltipContent2.default, props);
	};
	
	var Tooltip = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          isAnimationActive = _props.isAnimationActive,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing,
	          filterNull = _props.filterNull;
	
	      var finalPayload = filterNull && payload && payload.length ? payload.filter(function (entry) {
	        return !(0, _isNil3.default)(entry.value);
	      }) : payload;
	      var hasPayload = finalPayload && finalPayload.length;
	      var _props2 = this.props,
	          content = _props2.content,
	          viewBox = _props2.viewBox,
	          coordinate = _props2.coordinate,
	          position = _props2.position,
	          active = _props2.active,
	          offset = _props2.offset,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	      var translateX = void 0,
	          translateY = void 0;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _state2 = this.state,
	            boxWidth = _state2.boxWidth,
	            boxHeight = _state2.boxHeight;
	
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = position && (0, _DataUtils.isNumber)(position.x) ? position.x : Math.max(coordinate.x + boxWidth + offset > viewBox.x + viewBox.width ? coordinate.x - boxWidth - offset : coordinate.x + offset, viewBox.x);
	
	          translateY = position && (0, _DataUtils.isNumber)(position.y) ? position.y : Math.max(coordinate.y + boxHeight + offset > viewBox.y + viewBox.height ? coordinate.y - boxHeight - offset : coordinate.y + offset, viewBox.y);
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	        transform: this.props.useTranslate3d ? 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0)' : 'translate(' + translateX + 'px, ' + translateY + 'px)'
	      }));
	
	      if (isAnimationActive && active) {
	        outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	          transition: 'transform ' + animationDuration + 'ms ' + animationEasing
	        }));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-tooltip-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, _extends({}, this.props, { payload: finalPayload }))
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component), _class2.displayName = 'Tooltip', _class2.propTypes = propTypes, _class2.defaultProps = defaultProps, _temp2)) || _class;
	
	exports.default = Tooltip;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Axis of radial direction
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _Dot = __webpack_require__(107);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Polygon = __webpack_require__(399);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Text = __webpack_require__(106);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PolarUtils = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarAngleAxis, _Component);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, (PolarAngleAxis.__proto__ || Object.getPrototypeOf(PolarAngleAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: 'getTickLineCoord',
	
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          radius = _props.radius,
	          orientation = _props.orientation,
	          tickLine = _props.tickLine;
	
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
	
	      return { x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	
	      var cos = Math.cos(-data.coordinate * RADIAN);
	      var textAnchor = void 0;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          radius = _props2.radius,
	          axisLine = _props2.axisLine,
	          axisLineType = _props2.axisLineType;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react2.default.createElement(_Dot2.default, _extends({
	          className: 'recharts-polar-angle-axis-line'
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	      var ticks = this.props.ticks;
	
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
	      });
	
	      return _react2.default.createElement(_Polygon2.default, _extends({ className: 'recharts-polar-angle-axis-line' }, props, { points: points }));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-angle-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          ticks = _props3.ticks,
	          tick = _props3.tick,
	          tickLine = _props3.tickLine,
	          tickFormatter = _props3.tickFormatter,
	          stroke = _props3.stroke;
	
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this2.getTickLineCoord(entry);
	        var textAnchor = _this2.getTickTextAnchor(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i, payload: entry,
	          x: lineCoord.x2, y: lineCoord.y2
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-angle-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-polar-angle-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          radius = _props4.radius,
	          axisLine = _props4.axisLine;
	
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis' },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks()
	      );
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.Component), _class2.displayName = 'PolarAngleAxis', _class2.axisType = 'angleAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  angleAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  hide: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(_ReactUtils.SCALE_TYPES), _propTypes2.default.func]),
	
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  axisLineType: _propTypes2.default.oneOf(['polygon', 'circle']),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	
	  ticks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    coordinate: _propTypes2.default.number
	  })),
	  stroke: _propTypes2.default.string,
	  orientation: _propTypes2.default.oneOf(['inner', 'outer']),
	  tickFormatter: _propTypes2.default.func,
	  allowDuplicatedCategory: _propTypes2.default.bool
	}), _class2.defaultProps = {
	  type: 'category',
	  angleAxisId: 0,
	  scale: 'auto',
	  cx: 0,
	  cy: 0,
	  domain: [0, 'auto'],
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false,
	  allowDuplicatedCategory: true
	}, _temp)) || _class;
	
	exports.default = PolarAngleAxis;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _minBy2 = __webpack_require__(669);
	
	var _minBy3 = _interopRequireDefault(_minBy2);
	
	var _maxBy2 = __webpack_require__(453);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview The axis of polar coordinate system
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Text = __webpack_require__(106);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Label = __webpack_require__(83);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _PolarUtils = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarRadiusAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarRadiusAxis, _Component);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, (PolarRadiusAxis.__proto__ || Object.getPrototypeOf(PolarRadiusAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: 'getTickValueCoord',
	
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Number} coordinate The radius of tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var coordinate = _ref.coordinate;
	      var _props = this.props,
	          angle = _props.angle,
	          cx = _props.cx,
	          cy = _props.cy;
	
	
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, coordinate, angle);
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	        case 'right':
	          textAnchor = 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'getViewBox',
	    value: function getViewBox() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          angle = _props2.angle,
	          ticks = _props2.ticks;
	
	      var maxRadiusTick = (0, _maxBy3.default)(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      var minRadiusTick = (0, _minBy3.default)(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	
	      return {
	        cx: cx, cy: cy,
	        startAngle: angle,
	        endAngle: angle,
	        innerRadius: minRadiusTick.coordinate || 0,
	        outerRadius: maxRadiusTick.coordinate || 0
	      };
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy,
	          angle = _props3.angle,
	          ticks = _props3.ticks,
	          axisLine = _props3.axisLine,
	          others = _objectWithoutProperties(_props3, ['cx', 'cy', 'angle', 'ticks', 'axisLine']);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-polar-radius-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-radius-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          tick = _props4.tick,
	          angle = _props4.angle,
	          tickFormatter = _props4.tickFormatter,
	          stroke = _props4.stroke,
	          others = _objectWithoutProperties(_props4, ['ticks', 'tick', 'angle', 'tickFormatter', 'stroke']);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var items = ticks.map(function (entry, i) {
	        var coord = _this2.getTickValueCoord(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-radius-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          ticks = _props5.ticks,
	          axisLine = _props5.axisLine,
	          tick = _props5.tick;
	
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis' },
	        axisLine && this.renderAxisLine(),
	        tick && this.renderTicks(),
	        _Label2.default.renderCallByParent(this.props, this.getViewBox())
	      );
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.Component), _class2.displayName = 'PolarRadiusAxis', _class2.axisType = 'radiusAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  hide: _propTypes2.default.bool,
	  radiusAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  angle: _propTypes2.default.number,
	  tickCount: _propTypes2.default.number,
	  ticks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    coordinate: _propTypes2.default.number
	  })),
	  orientation: _propTypes2.default.oneOf(['left', 'right', 'middle']),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	  stroke: _propTypes2.default.string,
	  tickFormatter: _propTypes2.default.func,
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func]),
	  allowDataOverflow: _propTypes2.default.bool,
	  allowDuplicatedCategory: _propTypes2.default.bool
	}), _class2.defaultProps = {
	  type: 'number',
	  radiusAxisId: 0,
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto',
	  allowDuplicatedCategory: true
	}, _temp)) || _class;
	
	exports.default = PolarRadiusAxis;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Sector
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _PolarUtils = __webpack_require__(56);
	
	var _DataUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius;
	
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	  var centerAngle = angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
	  // The coordinate of point which is tangent to the circle
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
	  // The coordinate of point which is tangent to the radius line
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), angle);
	
	  return { center: center, circleTangency: circleTangency, lineTangency: lineTangency, theta: theta };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	
	  var angle = getDeltaAngle(startAngle, endAngle);
	
	  // When the angle of sector equals to 360, star point and end point coincide
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	
	  var path = 'M ' + outerStartPoint.x + ',' + outerStartPoint.y + '\n    A ' + outerRadius + ',' + outerRadius + ',0,\n    ' + +(Math.abs(angle) > 180) + ',' + +(startAngle > tempEndAngle) + ',\n    ' + outerEndPoint.x + ',' + outerEndPoint.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += 'L ' + innerEndPoint.x + ',' + innerEndPoint.y + '\n            A ' + innerRadius + ',' + innerRadius + ',0,\n            ' + +(Math.abs(angle) > 180) + ',' + +(startAngle <= tempEndAngle) + ',\n            ' + innerStartPoint.x + ',' + innerStartPoint.y + ' Z';
	  } else {
	    path += 'L ' + cx + ',' + cy + ' Z';
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: startAngle, sign: sign, cornerRadius: cornerRadius
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: endAngle, sign: -sign, cornerRadius: cornerRadius
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    return getSectorPath({
	      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    });
	  }
	
	  var path = 'M ' + solt.x + ',' + solt.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + soct.x + ',' + soct.y + '\n    A' + outerRadius + ',' + outerRadius + ',0,' + +(outerArcAngle > 180) + ',' + +(sign < 0) + ',' + eoct.x + ',' + eoct.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eolt.x + ',' + eolt.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: startAngle, sign: sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: endAngle, sign: -sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return path + 'L' + cx + ',' + cy + 'Z';
	    }
	
	    path += 'L' + eilt.x + ',' + eilt.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eict.x + ',' + eict.y + '\n      A' + innerRadius + ',' + innerRadius + ',0,' + +(innerArcAngle > 180) + ',' + +(sign > 0) + ',' + sict.x + ',' + sict.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + silt.x + ',' + silt.y + 'Z';
	  } else {
	    path += 'L' + cx + ',' + cy + 'Z';
	  }
	
	  return path;
	};
	
	var Sector = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sector, _Component);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, (Sector.__proto__ || Object.getPrototypeOf(Sector)).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          innerRadius = _props.innerRadius,
	          outerRadius = _props.outerRadius,
	          cornerRadius = _props.cornerRadius,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle,
	          className = _props.className;
	
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path = void 0;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          startAngle: startAngle, endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({ cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle });
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.Component), _class2.displayName = 'Sector', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0
	}, _temp)) || _class;
	
	exports.default = Sector;

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(557)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var lineRadial$1 = function() {
	  return lineRadial(line().curve(curveRadialLinear));
	};
	
	var areaRadial = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var pointRadial = function(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = ((function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	}))(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var diverging = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(85),
	    root = __webpack_require__(59);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(636),
	    mapCacheDelete = __webpack_require__(637),
	    mapCacheGet = __webpack_require__(638),
	    mapCacheHas = __webpack_require__(639),
	    mapCacheSet = __webpack_require__(640);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(587),
	    isObjectLike = __webpack_require__(64);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(24),
	    isSymbol = __webpack_require__(114);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(435);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(586),
	    isObjectLike = __webpack_require__(64);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(80),
	    isObjectLike = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(80),
	    isArray = __webpack_require__(24),
	    isObjectLike = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(576),
	    baseKeys = __webpack_require__(592),
	    isArrayLike = __webpack_require__(125);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _omit = __webpack_require__(77);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _findIgnoreCase = __webpack_require__(374);
	
	var _findIgnoreCase2 = _interopRequireDefault(_findIgnoreCase);
	
	var _fuzzyFilter = __webpack_require__(375);
	
	var _fuzzyFilter2 = _interopRequireDefault(_fuzzyFilter);
	
	var _caseInsensitiveFilter = __webpack_require__(372);
	
	var _caseInsensitiveFilter2 = _interopRequireDefault(_caseInsensitiveFilter);
	
	var _getTextWidth = __webpack_require__(99);
	
	var _getTextWidth2 = _interopRequireDefault(_getTextWidth);
	
	var _oneRequiredForA11y = __webpack_require__(74);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _invalidIf = __webpack_require__(37);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _keyCodes = __webpack_require__(9);
	
	var _anchorShape = __webpack_require__(31);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(32);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _ListItem = __webpack_require__(71);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(46);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _TextField = __webpack_require__(48);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Autocomplete` component is useful for presenting real-time suggestions, completions,
	 * or filtering.
	 */
	var Autocomplete = function (_PureComponent) {
	  _inherits(Autocomplete, _PureComponent);
	
	  function Autocomplete(props) {
	    _classCallCheck(this, Autocomplete);
	
	    var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultValue = props.defaultValue,
	        data = props.data,
	        dataLabel = props.dataLabel,
	        filter = props.filter;
	
	
	    var matches = [];
	    if (defaultValue && filter) {
	      matches = filter(data, defaultValue, dataLabel);
	    } else if (!filter) {
	      matches = data;
	    }
	
	    _this.state = {
	      value: defaultValue,
	      matches: matches,
	      visible: false,
	      matchIndex: -1,
	      manualFocus: false,
	      suggestion: '',
	      suggestionIndex: -1
	    };
	    return _this;
	  }
	
	  _createClass(Autocomplete, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextValue = nextProps.value,
	          data = nextProps.data,
	          filter = nextProps.filter,
	          dataLabel = nextProps.dataLabel;
	
	      var dataDiff = data !== this.props.data;
	      if (nextValue !== this.props.value || dataDiff) {
	        var _state = this.state,
	            visible = _state.visible,
	            matches = _state.matches;
	
	        var value = (0, _getField2.default)(nextProps, this.state, 'value');
	
	        if (filter) {
	          matches = filter(data, value, dataLabel);
	        } else if (dataDiff) {
	          matches = data;
	        }
	
	        if (this.state.focus) {
	          visible = !!matches.length;
	        }
	
	        this.setState({ matches: matches, visible: visible });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.state.visible !== nextState.visible) {
	        var menuFn = nextProps['onMenu' + (nextState.visible ? 'Open' : 'Close')];
	        if (menuFn) {
	          menuFn();
	        }
	      }
	    }
	
	    /**
	     * Gets the current value from the text field. This is used when you have an uncontrolled
	     * text field and simply need the value from a ref callback.
	     *
	     * @return {String} the text field's value
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          visible = _state2.visible,
	          matches = _state2.matches,
	          tabbed = _state2.tabbed,
	          focus = _state2.focus,
	          suggestionStyle = _state2.suggestionStyle;
	
	      var _props = this.props,
	          fullWidth = _props.fullWidth,
	          block = _props.block,
	          style = _props.style,
	          className = _props.className,
	          listStyle = _props.listStyle,
	          listClassName = _props.listClassName,
	          textFieldStyle = _props.textFieldStyle,
	          textFieldClassName = _props.textFieldClassName,
	          inlineSuggestionStyle = _props.inlineSuggestionStyle,
	          inlineSuggestionClassName = _props.inlineSuggestionClassName,
	          menuId = _props.menuId,
	          inline = _props.inline,
	          anchor = _props.anchor,
	          belowAnchor = _props.belowAnchor,
	          position = _props.position,
	          fixedTo = _props.fixedTo,
	          listId = _props.listId,
	          listInline = _props.listInline,
	          listZDepth = _props.listZDepth,
	          listHeightRestricted = _props.listHeightRestricted,
	          xThreshold = _props.xThreshold,
	          yThreshold = _props.yThreshold,
	          closeOnOutsideClick = _props.closeOnOutsideClick,
	          transitionName = _props.transitionName,
	          transitionEnterTimeout = _props.transitionEnterTimeout,
	          transitionLeaveTimeout = _props.transitionLeaveTimeout,
	          centered = _props.centered,
	          sameWidth = _props.sameWidth,
	          repositionOnScroll = _props.repositionOnScroll,
	          repositionOnResize = _props.repositionOnResize,
	          simplifiedMenu = _props.simplifiedMenu,
	          minLeft = _props.minLeft,
	          minRight = _props.minRight,
	          minBottom = _props.minBottom,
	          fillViewportWidth = _props.fillViewportWidth,
	          fillViewportHeight = _props.fillViewportHeight,
	          propValue = _props.value,
	          total = _props.total,
	          offset = _props.offset,
	          filter = _props.filter,
	          data = _props.data,
	          dataLabel = _props.dataLabel,
	          dataValue = _props.dataValue,
	          deleteKeys = _props.deleteKeys,
	          defaultValue = _props.defaultValue,
	          clearOnAutocomplete = _props.clearOnAutocomplete,
	          autocompleteWithLabel = _props.autocompleteWithLabel,
	          findInlineSuggestion = _props.findInlineSuggestion,
	          inlineSuggestionPadding = _props.inlineSuggestionPadding,
	          onAutocomplete = _props.onAutocomplete,
	          onMenuOpen = _props.onMenuOpen,
	          onMenuClose = _props.onMenuClose,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onKeyDown = _props.onKeyDown,
	          onMouseDown = _props.onMouseDown,
	          onChange = _props.onChange,
	          props = _objectWithoutProperties(_props, ['fullWidth', 'block', 'style', 'className', 'listStyle', 'listClassName', 'textFieldStyle', 'textFieldClassName', 'inlineSuggestionStyle', 'inlineSuggestionClassName', 'menuId', 'inline', 'anchor', 'belowAnchor', 'position', 'fixedTo', 'listId', 'listInline', 'listZDepth', 'listHeightRestricted', 'xThreshold', 'yThreshold', 'closeOnOutsideClick', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'centered', 'sameWidth', 'repositionOnScroll', 'repositionOnResize', 'simplifiedMenu', 'minLeft', 'minRight', 'minBottom', 'fillViewportWidth', 'fillViewportHeight', 'value', 'total', 'offset', 'filter', 'data', 'dataLabel', 'dataValue', 'deleteKeys', 'defaultValue', 'clearOnAutocomplete', 'autocompleteWithLabel', 'findInlineSuggestion', 'inlineSuggestionPadding', 'onAutocomplete', 'onMenuOpen', 'onMenuClose', 'onBlur', 'onFocus', 'onKeyDown', 'onMouseDown', 'onChange']);
	
	      delete props.focusInputOnAutocomplete;
	
	      var value = (0, _getField2.default)(this.props, this.state, 'value');
	
	      var autocomplete = _react2.default.createElement(_TextField2.default, _extends({}, props, {
	        'aria-autocomplete': inline ? 'inline' : 'list',
	        style: textFieldStyle,
	        className: (0, _classnames2.default)('md-autocomplete', textFieldClassName),
	        key: 'autocomplete',
	        ref: this._setField,
	        value: value,
	        onKeyDown: this._handleTextFieldKeyDown,
	        onMouseDown: this._toggleMenu,
	        onChange: this._handleChange,
	        onFocus: this._handleFocus,
	        onBlur: this._handleBlur,
	        fullWidth: fullWidth,
	        block: block
	      }));
	
	      if (inline) {
	        var suggestion = void 0;
	        if (focus && this.state.suggestion) {
	          suggestion = _react2.default.createElement(
	            'span',
	            {
	              key: 'suggestion',
	              style: _extends({}, suggestionStyle, inlineSuggestionStyle),
	              className: (0, _classnames2.default)('md-autocomplete-suggestion', {
	                'md-autocomplete-suggestion--floating': props.label,
	                'md-autocomplete-suggestion--block': block
	              }, inlineSuggestionClassName)
	            },
	            this.state.suggestion
	          );
	        }
	
	        return _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            style: style,
	            className: (0, _classnames2.default)('md-menu-container md-autocomplete-container', className, {
	              'md-full-width': fullWidth || block
	            }),
	            transitionName: 'opacity',
	            transitionEnterTimeout: 150,
	            transitionLeave: !tabbed,
	            transitionLeaveTimeout: 150,
	            onTouchStart: this._handleTouchStart
	          },
	          autocomplete,
	          suggestion
	        );
	      }
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        {
	          id: menuId || props.id + '-menu',
	          listId: listId,
	          ref: this._setMenu,
	          toggle: autocomplete,
	          visible: visible,
	          onClick: this._handleClick,
	          onClose: this._close,
	          onKeyDown: this._handleMenuKeyDown,
	          simplified: simplifiedMenu,
	          sameWidth: sameWidth,
	          centered: centered,
	          anchor: anchor,
	          belowAnchor: belowAnchor,
	          position: position,
	          fixedTo: fixedTo,
	          listInline: listInline,
	          listZDepth: listZDepth,
	          listHeightRestricted: listHeightRestricted,
	          xThreshold: xThreshold,
	          yThreshold: yThreshold,
	          closeOnOutsideClick: closeOnOutsideClick,
	          transitionName: transitionName,
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout,
	          fullWidth: fullWidth || block,
	          style: style,
	          className: (0, _classnames2.default)('md-autocomplete-container', className),
	          listStyle: listStyle,
	          listClassName: (0, _classnames2.default)('md-autocomplete-list', listClassName),
	          repositionOnScroll: repositionOnScroll,
	          repositionOnResize: repositionOnResize,
	          minLeft: minLeft,
	          minRight: minRight,
	          minBottom: minBottom,
	          fillViewportWidth: fillViewportWidth,
	          fillViewportHeight: fillViewportHeight
	        },
	        matches.map(this._mapToListItem)
	      );
	    }
	  }, {
	    key: 'value',
	    get: function get() {
	      return (0, _getField2.default)(this.props, this.state, 'value');
	    }
	
	    /**
	     * Just check if the click target is in a list item.. if it is, autocomplete the text field
	     * with that item.
	     */
	
	
	    /**
	     * The `mousedown` event is used instead of `click` because of the order
	     * of the `mousedown`, `focus`, and `click` events.
	     */
	
	
	    /**
	     * Allows touch devices to autocomplete the inline view by tapping:
	     * - the suggestion text
	     * - the text field IF there is a suggestion visible
	     */
	
	  }]);
	
	  return Autocomplete;
	}(_react.PureComponent);
	
	Autocomplete.HorizontalAnchors = _Menu2.default.HorizontalAnchors;
	Autocomplete.VerticalAnchors = _Menu2.default.VerticalAnchors;
	Autocomplete.Positions = _Menu2.default.Positions;
	Autocomplete.fuzzyFilter = _fuzzyFilter2.default;
	Autocomplete.caseInsensitiveFilter = _caseInsensitiveFilter2.default;
	Autocomplete.findIgnoreCase = _findIgnoreCase2.default;
	Autocomplete.propTypes = {
	  /**
	   * An id to give the autocomplete. Either this or the `menuId` is required for accessibility.
	   *
	   * @see {@link #menuId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The menu id to provide to the autocomplete. Either this prop or the `id` prop is required. If
	   * this props is omitted, the menuId will become: `${id}-menu`
	   */
	  menuId: (0, _oneRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'id'),
	
	  /**
	   * An optional id to provide to the menu's list.
	   *
	   * @see {@link Menus/Menu#listId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the menu that contains the autocomplete.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu that contains the autocomplete.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the autocomplete's text field.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the autocomplete's text field.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the autocomplete's text field input itself.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the autocomplete's input field itself.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * The optional style to apply to the opened menu List if the
	   * `Autocomplete` is not using `inline` suggestions.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * The optional className to apply to the opened menu List if the
	   * `Autocomplete` is not using `inline` suggestions.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the inline suggestion when using `inline` mode.
	   */
	  inlineSuggestionStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the inline suggestion when using `inline` mode.
	   */
	  inlineSuggestionClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the autocomplete is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * A label to display with the autocomplete.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional value to use for the text field. This will force this component
	   * to be controlled and require the `onChange` function.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), 'onChange'),
	
	  /**
	   * The default value for the autocomplete's text field.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  /**
	   * An object key to use to extract the text to be compared for filtering.
	   * This will only be applied if the given `data` prop is an array of objects.
	   */
	  dataLabel: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional object key to use to extract the `value` of the given `data` prop.
	   * This is really only used with generating a unique react key. The unique react
	   * key with either be:
	   * - the datum if it is a string or number
	   * - the `key` attribute of the datum object
	   * - the `datum[dataValue]`
	   * - or the `datum[dataLabel]`
	   */
	  dataValue: _propTypes2.default.string,
	
	  /**
	   * A single key or an array of keys to delete from your data object before passing
	   * to the `ListItem` component.
	   */
	  deleteKeys: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	
	  /**
	   * The data that will be used for autocomplete suggestions. This can either be
	   * an array of string, number, or object. If it is an array of objects, the key
	   * `dataLabel` is required.
	   *
	   * ```docgen
	   * PropTypes.arrayOf(PropTypes.oneOfType([
	   *   PropTypes.element,
	   *   PropTypes.string,
	   *   PropTypes.number,
	   *   PropTypes.shape({
	   *     [dataLabel]: PropTypes.oneOfType([
	   *       PropTypes.string,
	   *       PropTypes.number,
	   *       PropTypes.node,
	   *     ]).isRequired,
	   *   }),
	   * ])).isRequired
	   * ```
	   */
	  data: function data(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var _PropTypes$arrayOf;
	
	    var dataLabel = props.dataLabel;
	
	    return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.shape(_defineProperty({}, dataLabel, _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.node]).isRequired))]))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(others));
	  },
	
	  /**
	   * An optional number representing the total number of results in the `data` prop.
	   * This should really only be used when the data is paginated. When this is set,
	   * each item in the suggestion menu will be updated with the `aria-setsize` and
	   * `aria-posinset`.
	   *
	   * @see {@link #offset}
	   */
	  total: (0, _invalidIf2.default)(_propTypes2.default.number, 'inline'),
	
	  /**
	   * An optional number representing the data's offset if the results were paginated.
	   * This is used for accessibility with the `aria-posinset` attribute.
	   *
	   * @see {@link #total}
	   */
	  offset: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to use to filter the `data`. If you have a sexy backend
	   * using solr or some other search/indexer, it is recommended to set this prop to
	   * `null`.
	   */
	  filter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field has a `keydown` event.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field has a `mousedown` event.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field value changes.
	   * The callback will be given the new value and the change event.
	   *
	   * `onChange(textFeldValue, event)`
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field is focused.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the entire `Autocomplete` component is blurred.
	   * This will be triggered when the window is clicked or when a user tabs away from
	   * the autocomplete.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * Boolean if this text field should be styled as a full width text field.
	   * Floating labels and the text field indicator will be removed automatically.
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the autocomplete should span the entire width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Autocomplete` should display suggestions inline instead
	   * of in a `Menu`.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The amount of padding to use between the current text and the inline suggestion text.
	   */
	  inlineSuggestionPadding: _propTypes2.default.number.isRequired,
	
	  /**
	   * The function to call to find a suggestion for an inline autocomplete. This function
	   * expects to return a single result of a number or a string.
	   *
	   * ```js
	   * @param {Array<Object|String|Number>} data - The data prop to search.
	   * @param {String} value - The current value to use for searching.
	   * @param {String} dataLabel - The `dataLabel` prop to use if a datum is an object.
	   * @return {String|Number} the found suggestion or false-ish
	   * ```
	   */
	  findInlineSuggestion: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when an autocomplete suggestion is clicked either
	   * by using the mouse, the enter/space key, or touch. The match index and current
	   * `dataLabel` will be given back.
	   *
	   * `onAutocomplete(suggestion, suggestionIndex, matches);`
	   *
	   * @see {@link #autocompleteWithLabel}
	   */
	  onAutocomplete: _propTypes2.default.func,
	
	  /**
	   * Boolean if the `onAutocomplete` should attempt send the `suggestion[dataLabel]` instead
	   * of `suggestion[dataValue]` when the data is an object.
	   *
	   * @see {@link #onAutocomplete}
	   */
	  autocompleteWithLabel: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the text field's value should be reset to the empty string when
	   * an item is auto-completed. This is useful if you do not want a fully controlled
	   * component and the values are stored outside of the `TextField`. (like `Chips`).
	   */
	  clearOnAutocomplete: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `Autocomplete` suggestion menu opens.
	   */
	  onMenuOpen: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete` suggestion menu closes.
	   */
	  onMenuClose: _propTypes2.default.func,
	
	  /**
	   * This prop is used for disabling the browser's default autocomplete suggestions
	   * of previously typed values in the text field. By default, this is disabled.
	   */
	  autoComplete: _propTypes2.default.oneOf(['on', 'off']),
	
	  /**
	   * Boolean if the `input` should be focused again after a suggestion was clicked.
	   *
	   * This is really only added for keyboard support and the fact that each of suggestions
	   * are focusable.
	   */
	  focusInputOnAutocomplete: _propTypes2.default.bool,
	
	  /**
	   * This is how the menu's `List` gets anchored to the `toggle` element.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position for the list that appears.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is how the menu's list will be "fixed" to the `toggle` component.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Boolean if the menu's list should appear horizontally instead of vertically.
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * The list's z-depth for applying box shadow. This should be a number from 0 to 5.
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should have its height restricted to the `$md-menu-mobile-max-height`/
	   * `$md-menu-desktop-max-height` values.
	   *
	   * @see [md-menu-mobile-max-height](/components/menus?tab=2#variable-md-menu-mobile-max-height)
	   * @see [md-menu-desktop-max-height](/components/menus?tab=2#variable-md-menu-desktop-max-height)
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * An optional transition name to use for the list appearing/disappearing.
	   *
	   * @see {@link Helpers/Layover#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _Menu2.default.propTypes.centered,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _Menu2.default.propTypes.sameWidth,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  /**
	   * @see {@link TextFields#toolbar}
	   */
	  toolbar: _propTypes2.default.bool
	};
	Autocomplete.defaultProps = {
	  autocompleteWithLabel: false,
	  position: _Menu2.default.Positions.BELOW,
	  sameWidth: true,
	  offset: 0,
	  fullWidth: true,
	  defaultValue: '',
	  dataLabel: 'primaryText',
	  filter: Autocomplete.fuzzyFilter,
	  findInlineSuggestion: Autocomplete.findIgnoreCase,
	  autoComplete: 'off',
	  repositionOnScroll: true,
	  repositionOnResize: true,
	  inlineSuggestionPadding: 6
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._close = function (e) {
	    if (_this2.props.onBlur) {
	      _this2.props.onBlur(e);
	    }
	
	    _this2.setState({ visible: false });
	  };
	
	  this._handleChange = function (value, event) {
	    var _props2 = _this2.props,
	        onChange = _props2.onChange,
	        filter = _props2.filter,
	        findInlineSuggestion = _props2.findInlineSuggestion,
	        data = _props2.data,
	        dataLabel = _props2.dataLabel,
	        inline = _props2.inline;
	
	
	    if (onChange) {
	      onChange(value, event);
	    }
	
	    if (inline) {
	      // If findInlineSuggestion does not exist, assume that `onChange` will handle it.
	      return findInlineSuggestion ? _this2._findInlineSuggestions(value) : null;
	    }
	
	    var visible = _this2.state.visible;
	
	    var matches = value || !filter ? _this2.state.matches : [];
	    if (value && filter) {
	      matches = filter(data, value, dataLabel);
	    }
	
	    if (filter) {
	      visible = !!matches.length;
	    }
	
	    return _this2.setState({ matches: matches, visible: visible, value: value });
	  };
	
	  this._handleFocus = function (e) {
	    if (_this2.props.onFocus) {
	      _this2.props.onFocus(e);
	    }
	
	    var value = e.target.value;
	
	    if (_this2.props.inline && value) {
	      if (_this2.props.findInlineSuggestion) {
	        _this2._findInlineSuggestions(value);
	      }
	
	      return;
	    }
	
	    _this2.setState({
	      matchIndex: -1,
	      visible: !_this2.state.manualFocus && !!value && !!_this2.state.matches.length,
	      manualFocus: false,
	      focus: true
	    });
	  };
	
	  this._handleBlur = function (e) {
	    if (_this2.props.inline || !_this2.state.matches.length) {
	      if (_this2.props.onBlur) {
	        _this2.props.onBlur(e);
	      }
	    }
	
	    _this2.setState({ focus: false });
	  };
	
	  this._handleInlineAutocomplete = function () {
	    var _state3 = _this2.state,
	        suggestionIndex = _state3.suggestionIndex,
	        matches = _state3.matches;
	
	    if (suggestionIndex === -1) {
	      return;
	    }
	
	    var _props3 = _this2.props,
	        data = _props3.data,
	        dataLabel = _props3.dataLabel,
	        dataValue = _props3.dataValue,
	        label = _props3.autocompleteWithLabel,
	        onAutocomplete = _props3.onAutocomplete;
	
	
	    var value = data[suggestionIndex];
	    if (onAutocomplete) {
	      var v = value;
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        if (!label) {
	          v = value[dataValue];
	        } else {
	          v = value[dataLabel];
	        }
	      }
	
	      onAutocomplete(v, suggestionIndex, matches);
	    }
	
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      value = value[dataLabel];
	    }
	
	    _this2.setState({
	      value: value,
	      suggestion: '',
	      suggestionIndex: -1,
	      tabbed: true
	    });
	  };
	
	  this._handleTextFieldKeyDown = function (e) {
	    var _props4 = _this2.props,
	        inline = _props4.inline,
	        onKeyDown = _props4.onKeyDown;
	    var suggestionIndex = _this2.state.suggestionIndex;
	
	
	    var key = e.which || e.keyCode;
	    if (onKeyDown) {
	      onKeyDown(e);
	    }
	
	    if (inline && key === _keyCodes.TAB && suggestionIndex !== -1) {
	      // Autocomplete the text field
	      e.preventDefault();
	      _this2._handleInlineAutocomplete();
	    }
	  };
	
	  this._handleMenuKeyDown = function (e) {
	    var key = e.which || e.keyCode;
	    if (key === _keyCodes.TAB) {
	      if (_this2.props.onBlur) {
	        _this2.props.onBlur(e);
	      }
	
	      _this2.setState({ visible: false });
	    } else if (key === _keyCodes.UP || key === _keyCodes.DOWN) {
	      _this2._focusSuggestion(key === _keyCodes.UP, e);
	    }
	  };
	
	  this._handleClick = function (e) {
	    var target = e.target;
	    while (_this2._menu && _this2._menu.contains(target)) {
	      if (target.classList.contains('md-list-item')) {
	        var items = target.parentNode.querySelectorAll('.md-list-item');
	        items = Array.prototype.slice.call(items);
	
	        return _this2._handleItemClick(items.indexOf(target));
	      }
	
	      target = target.parentNode;
	    }
	
	    return null;
	  };
	
	  this._handleItemClick = function (index) {
	    if (index === -1) {
	      return;
	    }
	
	    var matches = _this2.state.matches;
	    var _props5 = _this2.props,
	        data = _props5.data,
	        dataLabel = _props5.dataLabel,
	        dataValue = _props5.dataValue,
	        filter = _props5.filter,
	        onAutocomplete = _props5.onAutocomplete,
	        clearOnAutocomplete = _props5.clearOnAutocomplete,
	        focusInputOnAutocomplete = _props5.focusInputOnAutocomplete,
	        label = _props5.autocompleteWithLabel;
	
	
	    var value = matches.filter(function (m) {
	      return !_react2.default.isValidElement(m);
	    })[index];
	    if (onAutocomplete) {
	      var v = value;
	      if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object') {
	        if (!label) {
	          v = value[dataValue];
	        } else {
	          v = value[dataLabel];
	        }
	      }
	
	      onAutocomplete(v, index, matches);
	    }
	
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      value = value[dataLabel];
	    }
	
	    value = clearOnAutocomplete ? '' : value;
	    var callback = void 0;
	    if (focusInputOnAutocomplete) {
	      callback = function callback() {
	        _this2._field.focus();
	      };
	    }
	
	    _this2.setState({
	      visible: false,
	      manualFocus: focusInputOnAutocomplete,
	      matches: filter ? filter(data, value, dataLabel) : matches,
	      value: value
	    }, callback);
	  };
	
	  this._focusSuggestion = function (negative, e) {
	    e.preventDefault();
	    var _state4 = _this2.state,
	        matchIndex = _state4.matchIndex,
	        matches = _state4.matches;
	
	    var l = matches.length;
	
	    var index = void 0;
	    if (negative && matchIndex === -1 || !negative && matchIndex >= l) {
	      return;
	    } else if (negative) {
	      index = matchIndex - 1;
	      if (index === -1) {
	        _this2._field.focus();
	      }
	    } else {
	      index = Math.min(l, matchIndex + 1);
	    }
	
	    if (index !== -1 && index !== matchIndex) {
	      var item = _this2._menu.querySelectorAll('.md-list-tile')[index];
	      if (item) {
	        item.focus();
	      }
	    }
	
	    _this2.setState({ matchIndex: index });
	  };
	
	  this._findInlineSuggestions = function (value) {
	    var _props6 = _this2.props,
	        data = _props6.data,
	        dataLabel = _props6.dataLabel,
	        findInlineSuggestion = _props6.findInlineSuggestion,
	        inlineSuggestionPadding = _props6.inlineSuggestionPadding;
	
	
	    var suggestion = findInlineSuggestion(data, value, dataLabel);
	    if ((typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
	      throw new Error('`findInlineSuggestion` should return a string or a number, but got an object.', suggestion);
	    }
	
	    var suggestionStyle = _this2.state.suggestionStyle;
	
	    var suggestionIndex = -1;
	    if (suggestion) {
	      // Find index of suggestion
	      data.some(function (datum, i) {
	        var d = (typeof dataum === 'undefined' ? 'undefined' : _typeof(dataum)) === 'object' ? datum[dataLabel] : datum;
	        if (d === suggestion) {
	          suggestionIndex = i;
	        }
	
	        return suggestionIndex !== -1;
	      });
	
	      // Strip already used letters
	      suggestion = suggestion.toString().substring(value.length, suggestion.length);
	
	      // Position the inline suggestion next to the text
	      var width = (0, _getTextWidth2.default)(value, _this2._field);
	      if (width !== null) {
	        width += inlineSuggestionPadding;
	      }
	
	      if (width !== null && (!suggestionStyle || suggestionStyle.left !== width)) {
	        suggestionStyle = { left: width };
	      }
	    }
	
	    _this2.setState({
	      value: value,
	      suggestion: suggestion,
	      suggestionIndex: suggestionIndex,
	      suggestionStyle: suggestionStyle,
	      tabbed: false,
	      focus: true
	    });
	  };
	
	  this._mapToListItem = function (match, i) {
	    if (_react2.default.isValidElement(match)) {
	      return match;
	    }
	
	    var _props7 = _this2.props,
	        dataLabel = _props7.dataLabel,
	        dataValue = _props7.dataValue,
	        deleteKeys = _props7.deleteKeys,
	        total = _props7.total,
	        offset = _props7.offset,
	        data = _props7.data;
	
	    var props = void 0;
	    switch (typeof match === 'undefined' ? 'undefined' : _typeof(match)) {
	      case 'string':
	      case 'number':
	        props = {
	          key: match,
	          primaryText: match
	        };
	        break;
	      default:
	        if (deleteKeys) {
	          props = (0, _omit2.default)(match, typeof deleteKeys === 'string' ? [deleteKeys] : deleteKeys);
	        } else {
	          props = match;
	        }
	
	        props = _extends({}, props, {
	          key: match.key || dataValue && match[dataValue] || match[dataLabel],
	          primaryText: match[dataLabel]
	        });
	    }
	
	    if (typeof total !== 'undefined' && data.length < total) {
	      props['aria-setsize'] = total;
	      props['aria-posinset'] = i + 1 + offset;
	    }
	
	    // Allows focus, but does not let tab focus. This is so up and down keys work.
	    return _react2.default.createElement(_ListItem2.default, _extends({ tabIndex: -1 }, props));
	  };
	
	  this._toggleMenu = function (e) {
	    if (_this2.props.onMouseDown) {
	      _this2.props.onMouseDown(e);
	    }
	
	    if (!_this2.props.inline && _this2.state.matches.length && (0, _getField2.default)(_this2.props, _this2.state, 'value')) {
	      _this2.setState({ visible: !_this2.state.visible });
	    }
	  };
	
	  this._handleTouchStart = function (e) {
	    var target = e.target;
	    var suggestion = _this2.state.suggestion;
	
	    if (target.classList.contains('md-autocomplete-suggestion') && suggestion) {
	      _this2._handleInlineAutocomplete();
	    }
	  };
	
	  this._setField = function (field) {
	    if (field) {
	      _this2._field = field.getField();
	    }
	  };
	
	  this._setMenu = function (menu) {
	    _this2._menu = (0, _reactDom.findDOMNode)(menu);
	  };
	};
	
	exports.default = Autocomplete;
	//# sourceMappingURL=Autocomplete.js.map

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Autocomplete = undefined;
	
	var _Autocomplete2 = __webpack_require__(229);
	
	var _Autocomplete3 = _interopRequireDefault(_Autocomplete2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Autocomplete3.default;
	exports.Autocomplete = _Autocomplete3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _oneRequiredForA11yIf = __webpack_require__(369);
	
	var _oneRequiredForA11yIf2 = _interopRequireDefault(_oneRequiredForA11yIf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The avatar component is used to convert a `FontIcon`, an image, or
	 * a letter into an avatar.
	 *
	 * Any other props given to the Avatar component such as event listeners
	 * or styles will also be applied.
	 */
	var Avatar = function (_PureComponent) {
	  _inherits(Avatar, _PureComponent);
	
	  function Avatar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Avatar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { color: null }, _this._setRandomColor = function () {
	      var suffixes = _this.props.suffixes;
	
	
	      var i = Math.floor(Math.random() * (suffixes.length - 1)) + 1;
	      _this.setState({ color: suffixes[i] });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Avatar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.random) {
	        this._setRandomColor();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.random && (this.props.src !== nextProps.src || this.props.icon !== nextProps.icon)) {
	        this._setRandomColor();
	      } else if (this.props.random && !nextProps.random) {
	        this.setState({ color: null });
	      }
	    }
	  }, {
	    key: '_getColor',
	    value: function _getColor(suffix, suffixes, color) {
	      if (suffix) {
	        return 'md-avatar--' + suffix;
	      } else if (!!suffixes && !color) {
	        return 'md-avatar--default';
	      }
	
	      return 'md-avatar--' + color;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          contentStyle = _props.contentStyle,
	          contentClassName = _props.contentClassName,
	          src = _props.src,
	          alt = _props.alt,
	          icon = _props.icon,
	          children = _props.children,
	          suffix = _props.suffix,
	          suffixes = _props.suffixes,
	          iconSized = _props.iconSized,
	          role = _props.role,
	          random = _props.random,
	          props = _objectWithoutProperties(_props, ['className', 'contentStyle', 'contentClassName', 'src', 'alt', 'icon', 'children', 'suffix', 'suffixes', 'iconSized', 'role', 'random']);
	
	      var content = void 0;
	      if (src) {
	        content = _react2.default.createElement('img', {
	          src: src,
	          alt: alt,
	          role: role,
	          style: contentStyle,
	          className: (0, _classnames2.default)('md-avatar-img', contentClassName)
	        });
	      } else {
	        content = _react2.default.createElement(
	          'div',
	          {
	            style: contentStyle,
	            className: (0, _classnames2.default)('md-avatar-content', contentClassName)
	          },
	          icon || children
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-inline-block md-avatar', this._getColor(suffix, suffixes, this.state.color), {
	            'md-avatar--icon-sized': iconSized
	          }, className)
	        }),
	        content
	      );
	    }
	  }]);
	
	  return Avatar;
	}(_react.PureComponent);
	
	Avatar.propTypes = {
	  /**
	   * An optional className to apply to the avatar.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to either the `<img>` or `<div>` surrounding the content. The `<img>` tag
	   * will be used with the `src` prop is defined.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to either the `<img>` or `<div>` surrounding the content. The `<img>` tag
	   * will be used with the `src` prop is defined.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional image source to use for the avatar.
	   */
	  src: (0, _oneRequiredForA11yIf2.default)(_propTypes2.default.string, 'role', 'alt'),
	
	  /**
	   * An optional image alt to use for the avatar if it is
	   * an image.
	   */
	  alt: _propTypes2.default.string,
	
	  /**
	   * An optional `FontIcon` to convert into an avatar.
	   */
	  icon: _propTypes2.default.node,
	
	  /**
	   * An optional letter to display in the avatar.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A boolean if a random color should be applied to the avatar.
	   * This will be one of the `suffixes`.
	   */
	  random: _propTypes2.default.bool,
	
	  /**
	   * A list of available suffixes to use when generating a random
	   * color for the avatar.
	   */
	  suffixes: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  /**
	   * The suffix to use for a color. This can be any value but
	   * *should* be one of the available `suffixes`.
	   */
	  suffix: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `Avatar` should be sized to a `FontIcon` size. This
	   * will just set the width and height to the `$md-font-icon-size`.
	   */
	  iconSized: _propTypes2.default.bool,
	
	  /**
	   * A role for the avatar's image. When the `src` prop is set, either a `role` of `presentation`
	   * or the `alt` prop must be defined for a11y.
	   */
	  role: _propTypes2.default.oneOf(['presentation'])
	};
	Avatar.defaultProps = {
	  suffixes: ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber', 'orange', 'deep-orange', 'brown', 'grey', 'blue-grey']
	};
	exports.default = Avatar;
	//# sourceMappingURL=Avatar.js.map

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Avatar = undefined;
	
	var _Avatar2 = __webpack_require__(231);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar3.default;
	exports.Avatar = _Avatar3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The main use case of the `Badge` component is for notifications. It can
	 * however also place any content floating to whatever children are supplied.
	 */
	var Badge = function (_PureComponent) {
	  _inherits(Badge, _PureComponent);
	
	  function Badge(props) {
	    _classCallCheck(this, Badge);
	
	    var _this = _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).call(this, props));
	
	    var single = _this._isSingleChild(props);
	    _this.state = {
	      single: single,
	      element: single && (0, _react.isValidElement)(props.children),
	      count: _this._normalizeCount(props)
	    };
	    return _this;
	  }
	
	  _createClass(Badge, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          badgeContent = _props.badgeContent,
	          max = _props.max,
	          children = _props.children;
	
	      var nextState = void 0;
	      if (badgeContent !== nextProps.badgeContent || max !== nextProps.max) {
	        nextState = { count: this._normalizeCount(nextProps) };
	      }
	
	      if (children !== nextProps.children) {
	        nextState = nextState || {};
	        nextState.single = this._isSingleChild(nextProps);
	        nextState.element = nextState.single && (0, _react.isValidElement)(nextProps.children);
	      }
	
	      if (nextState) {
	        this.setState(nextState);
	      }
	    }
	  }, {
	    key: '_isSingleChild',
	    value: function _isSingleChild(_ref) {
	      var children = _ref.children;
	
	      return _react.Children.count(children) === 1;
	    }
	  }, {
	    key: '_normalizeCount',
	    value: function _normalizeCount(_ref2) {
	      var badgeContent = _ref2.badgeContent,
	          max = _ref2.max;
	
	      var count = void 0;
	      if (max) {
	        var n = parseInt(badgeContent, 10);
	        if (!Number.isNaN(n) && n.toString() === badgeContent.toString()) {
	          count = n > max ? max + '+' : n;
	        }
	      }
	
	      return count;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          count = _state.count,
	          single = _state.single,
	          element = _state.element;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          badgeStyle = _props2.badgeStyle,
	          badgeClassName = _props2.badgeClassName,
	          badgeContent = _props2.badgeContent,
	          Component = _props2.component,
	          children = _props2.children,
	          primary = _props2.primary,
	          secondary = _props2.secondary,
	          defaultTheme = _props2.default,
	          circular = _props2.circular,
	          badgeId = _props2.badgeId,
	          invisibleOnZero = _props2.invisibleOnZero,
	          max = _props2.max,
	          props = _objectWithoutProperties(_props2, ['className', 'badgeStyle', 'badgeClassName', 'badgeContent', 'component', 'children', 'primary', 'secondary', 'default', 'circular', 'badgeId', 'invisibleOnZero', 'max']);
	
	      var useCircular = typeof circular !== 'undefined' ? circular : typeof count !== 'undefined';
	      var content = children;
	      if (single && element) {
	        var c = _react.Children.only(content);
	        if (!c.props['aria-describedby']) {
	          content = (0, _react.cloneElement)(c, { 'aria-describedby': badgeId });
	        }
	      } else if (single && !element && !props['aria-describedby']) {
	        props['aria-describedby'] = badgeId;
	      }
	
	      var badge = _react2.default.createElement(
	        'span',
	        {
	          id: badgeId,
	          key: 'badge',
	          role: 'status',
	          style: badgeStyle,
	          className: (0, _classnames2.default)('md-badge', {
	            'md-badge--circular': useCircular,
	            'md-badge--default': defaultTheme
	          }, (0, _themeColors2.default)({
	            primary: primary,
	            secondary: secondary,
	            text: useCircular,
	            themeText: !primary && !secondary
	          }, badgeClassName))
	        },
	        count || badgeContent
	      );
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-badge-container md-inline-block', className)
	        }),
	        content,
	        invisibleOnZero && count === 0 ? null : badge
	      );
	    }
	  }]);
	
	  return Badge;
	}(_react.PureComponent);
	
	Badge.propTypes = {
	  /**
	   * An optional style to apply to the badge's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the badge's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the badge.
	   */
	  badgeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the badge.
	   */
	  badgeClassName: _propTypes2.default.string,
	
	  /**
	   * The id to give the badge's content. This is required to help with the
	   * `aria-describedby` attribute that should be applied to one of the children.
	   *
	   * If there is only one child that is a valid React element, the `aria-describedby`
	   * will automatically be cloned into that child (so make sure your component passes
	   * that prop correctly).
	   *
	   * If there is only one child, but it is a string or number, the badge's container
	   * will be updated to include the `aria-describedby`.
	   *
	   * If there is more than child, you are required to add it to a child yourself.
	   */
	  badgeId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The content to display with the badge's content. The size of this
	   * element is determinate of the location of the content. You might have
	   * to update the positioning yourself.
	   */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * The component to render the badge as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The content to display in the badge. If the content is a number or a number string,
	   * the number will be normalized if `normalizeContent` is enabled.
	   */
	  badgeContent: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.node]).isRequired,
	
	  /**
	   * This will basically update the display value of the content to only be 2 digits. If
	   * a number is greater than 99, 99+ will be displayed instead. This is really just to
	   * keep the count inside the circular bubble.
	   */
	  max: _propTypes2.default.number,
	
	  /**
	   * Boolean if the primary color background should get applied to the badge's content.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the secondary color background should get applied to the badge's content.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the default styles should be applied.
	   */
	  default: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the badge's content should appear in a circular container. If this is
	   * undefined, the content will be in a circular container if the badgeContent is a number.
	   */
	  circular: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the badge's notification should be invisible when the count is 0.
	   */
	  invisibleOnZero: _propTypes2.default.bool
	};
	Badge.defaultProps = {
	  max: 99,
	  component: 'div'
	};
	exports.default = Badge;
	//# sourceMappingURL=Badge.js.map

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Badge = undefined;
	
	var _Badge2 = __webpack_require__(233);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge3.default;
	exports.Badge = _Badge3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _AccessibleFakeInkedButton = __webpack_require__(25);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _Collapse = __webpack_require__(35);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcons = __webpack_require__(139);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `BottomNav` component is used for rendering the navigation tab/link in the `BottomNavigation`
	 * component.
	 */
	var BottomNav = function (_PureComponent) {
	  _inherits(BottomNav, _PureComponent);
	
	  function BottomNav() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BottomNav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BottomNav.__proto__ || Object.getPrototypeOf(BottomNav)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onNavChange = _this$props.onNavChange,
	          index = _this$props.index;
	
	      if (onClick) {
	        onClick(index, e);
	      }
	
	      if (onNavChange) {
	        onNavChange(index, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BottomNav, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          fixed = _props.fixed,
	          className = _props.className,
	          colored = _props.colored,
	          animate = _props.animate,
	          iconClassName = _props.iconClassName,
	          iconChildren = _props.iconChildren,
	          index = _props.index,
	          propIcon = _props.icon,
	          propLabel = _props.label,
	          onClick = _props.onClick,
	          onNavChange = _props.onNavChange,
	          props = _objectWithoutProperties(_props, ['active', 'fixed', 'className', 'colored', 'animate', 'iconClassName', 'iconChildren', 'index', 'icon', 'label', 'onClick', 'onNavChange']);
	
	      var _props2 = this.props,
	          label = _props2.label,
	          icon = _props2.icon;
	
	      var labelClassName = (0, _classnames2.default)('md-bottom-nav-label', { 'md-bottom-nav-label--shifting-inactive': !active && !fixed });
	      if (_react.Children.count(label) === 1 && (0, _react.isValidElement)(label)) {
	        var labelEl = _react.Children.only(label);
	        label = (0, _react.cloneElement)(label, {
	          className: (0, _classnames2.default)(labelClassName, labelEl.props.className)
	        });
	      } else {
	        label = _react2.default.createElement(
	          'div',
	          { className: labelClassName },
	          label
	        );
	      }
	
	      if (!icon && (iconClassName || iconChildren)) {
	        // Deprecated
	        icon = _react2.default.createElement(
	          _FontIcons2.default,
	          { iconClassName: iconClassName, inherit: true },
	          iconChildren
	        );
	      } else if (icon) {
	        icon = _react2.default.cloneElement(icon, { inherit: true });
	      }
	
	      return _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, props, {
	          onClick: this._handleClick,
	          className: (0, _classnames2.default)('md-bottom-nav', {
	            'md-bottom-nav--active': active,
	            'md-bottom-nav--fixed': fixed,
	            'md-bottom-nav--shifting': !fixed,
	            'md-bottom-nav--shifting-active': !fixed && active,
	            'md-bottom-nav--shifting-inactive': !fixed && !active
	          }, (0, _themeColors2.default)({ primary: !colored && active, text: !active && !colored }, className))
	        }),
	        icon,
	        _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: !fixed && !active, animate: animate },
	          label
	        )
	      );
	    }
	  }]);
	
	  return BottomNav;
	}(_react.PureComponent);
	
	BottomNav.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  active: _propTypes2.default.bool,
	  fixed: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  index: _propTypes2.default.number.isRequired,
	  label: _propTypes2.default.node.isRequired,
	  colored: _propTypes2.default.bool,
	  iconChildren: _propTypes2.default.node,
	  iconClassName: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onNavChange: _propTypes2.default.func,
	  role: _propTypes2.default.string,
	  animate: _propTypes2.default.bool,
	  icon: _propTypes2.default.element
	};
	BottomNav.defaultProps = {
	  component: 'a',
	  role: null
	};
	exports.default = BottomNav;
	//# sourceMappingURL=BottomNav.js.map

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _touches = __webpack_require__(54);
	
	var _Portal = __webpack_require__(45);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Paper = __webpack_require__(29);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _BottomNav = __webpack_require__(235);
	
	var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `BottomNavigation` component is an alternative to the `NavigationDrawer` for handling navigation
	 * only on mobile devices.
	 */
	var BottomNavigation = function (_PureComponent) {
	  _inherits(BottomNavigation, _PureComponent);
	
	  function BottomNavigation(props) {
	    _classCallCheck(this, BottomNavigation);
	
	    var _this = _possibleConstructorReturn(this, (BottomNavigation.__proto__ || Object.getPrototypeOf(BottomNavigation)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visible = typeof props.initiallyVisible === 'boolean' ? props.initiallyVisible : props.defaultVisible;
	    _this.state = {
	      visible: visible,
	      portalVisible: visible
	    };
	
	    if (typeof props.activeIndex === 'undefined') {
	      _this.state.activeIndex = props.defaultActiveIndex;
	    }
	    return _this;
	  }
	
	  _createClass(BottomNavigation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.dynamic) {
	        this._addTouchEvents();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var dynamic = nextProps.dynamic;
	
	      if (this.props.dynamic === dynamic) {
	        return;
	      }
	
	      if (dynamic) {
	        this._addTouchEvents();
	      } else {
	        this._removeTouchEvents();
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.state.visible !== nextState.visible && nextProps.onVisibilityChange) {
	        nextProps.onVisibilityChange(nextState.visible);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.dynamic) {
	        this._removeTouchEvents();
	      }
	
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          visible = _state.visible,
	          portalVisible = _state.portalVisible;
	
	      var _props = this.props,
	          className = _props.className,
	          actions = _props.actions,
	          colored = _props.colored,
	          dynamic = _props.dynamic,
	          lastChild = _props.lastChild,
	          animate = _props.animate,
	          portal = _props.portal,
	          propLinks = _props.links,
	          propActiveIndex = _props.activeIndex,
	          propRenderNode = _props.renderNode,
	          onNavChange = _props.onNavChange,
	          onVisibilityChange = _props.onVisibilityChange,
	          defaultVisible = _props.defaultVisible,
	          defaultActiveIndex = _props.defaultActiveIndex,
	          dynamicThreshold = _props.dynamicThreshold,
	          transitionDuration = _props.transitionDuration,
	          onChange = _props.onChange,
	          initiallyVisible = _props.initiallyVisible,
	          containerStyle = _props.containerStyle,
	          containerClassName = _props.containerClassName,
	          transitionName = _props.transitionName,
	          transitionEnterTimeout = _props.transitionEnterTimeout,
	          transitionLeaveTimeout = _props.transitionLeaveTimeout,
	          props = _objectWithoutProperties(_props, ['className', 'actions', 'colored', 'dynamic', 'lastChild', 'animate', 'portal', 'links', 'activeIndex', 'renderNode', 'onNavChange', 'onVisibilityChange', 'defaultVisible', 'defaultActiveIndex', 'dynamicThreshold', 'transitionDuration', 'onChange', 'initiallyVisible', 'containerStyle', 'containerClassName', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout']);
	
	      var links = this.props.links;
	
	      if (actions) {
	        links = actions;
	      }
	
	      var fixed = links.length === 3;
	      var activeIndex = (0, _getField2.default)(this.props, this.state, 'activeIndex');
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	      var navigation = _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          key: 'navigation',
	          className: (0, _classnames2.default)('md-bottom-navigation', {
	            'md-background--card': !colored,
	            'md-background--primary': colored,
	            'md-bottom-navigation--dynamic': dynamic,
	            'md-bottom-navigation--dynamic-inactive': dynamic && !visible
	          }, className),
	          role: 'navigation'
	        }),
	        links.map(function (action, index) {
	          return _react2.default.createElement(_BottomNav2.default, _extends({}, action, {
	            animate: animate,
	            key: action.key || index,
	            index: index,
	            onNavChange: _this2._handleNavChange,
	            active: activeIndex === index,
	            colored: colored,
	            fixed: fixed
	          }));
	        })
	      );
	
	      if (!portal) {
	        return portalVisible ? navigation : null;
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { renderNode: renderNode, visible: portalVisible, lastChild: lastChild },
	        navigation
	      );
	    }
	  }]);
	
	  return BottomNavigation;
	}(_react.PureComponent);
	
	BottomNavigation.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A list of objects to generate a bottom navigation link. There must be at least 3 and no more
	   * than 5 links. A link gets rendered as the `AccessibleFakeButton` component, so any additional
	   * props in the link's shape will be passed along.
	   *
	   * ```docgen
	   * PropTypes.arrayOf(PropTypes.shape({
	   *   label: PropTypes.node.isRequired,
	   *   icon: PropTypes.element,
	   *   component: PropTypes.oneOfType([
	   *      PropTypes.func,
	   *      PropTypes.string,
	   *   ]),
	   * }).isRequired
	   * ```
	   */
	  links: function links(props, propName, component) {
	    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      args[_key - 3] = arguments[_key];
	    }
	
	    var _PropTypes$arrayOf;
	
	    var links = props[propName] || props.actions;
	    var len = links.length;
	
	    if (len < 3) {
	      return new Error('Only ' + len + ' `' + propName + '` were given to the ' + component + '. At least 3 are required.');
	    } else if (len > 5) {
	      return new Error(len + ' `' + propName + '` were given to the ' + component + '. No more than 5 may be given.');
	    }
	
	    return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      label: _propTypes2.default.node.isRequired,
	      icon: _propTypes2.default.element,
	      iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `icon` instead'),
	      iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `icon` instead'),
	      component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	    }))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(args));
	  },
	
	  /**
	   * Boolean if the bottom navigation should be colored with the primary color or whatever color
	   * was a result of the `react-md-theme-bottom-navigations-colored` mixin.
	   */
	  colored: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the bottom navigation should dynamically appear based on scrolling. When the user
	   * scrolls the `dynamicThreshold` amount, this component will either disappear (scrolling down)
	   * or appear (scrolling up).
	   */
	  dynamic: _propTypes2.default.bool,
	
	  /**
	   * The distance a user must scroll before the bottom navigation appears or disappears when it is `dynamic`.
	   */
	  dynamicThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when a link has been clicked. The callback will
	   * include the new active index and the click event.
	   *
	   * ```js
	   * onNavChange(newActiveIndex, event);
	   * ```
	   */
	  onNavChange: _propTypes2.default.func,
	
	  /**
	   * An optional active index to use. This will make the component controlled and require the
	   * `onNavChange` prop to be defined.
	   */
	  activeIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onNavChange', 'defaultActiveIndex'),
	
	  /**
	   * The index for the link that is active by default.
	   */
	  defaultActiveIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the bottom navigation is visible by default. This *should* probably always
	   * be true.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The component to render the bottom navigation as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the bottom navigation.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * Since the `BottomNavigation` component uses the `Portal` component, you can pass an optional
	   * HTML Node to render in.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the bottom navigation should render as the last child in the `renderNode` or `body`
	   * instead of as the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * The transition duration for the dynamic bottom navigation to appear or disappear. This should
	   * match the `$md-bottom-navigation-transition-time` variable.
	   */
	  transitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when the visibility of the bottom navigation changes. The callback
	   * will include the new visibility.
	   *
	   * ```js
	   * onVisibilityChange(!visible);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the label on a shifting navigation should animate in and out.
	   */
	  animate: _propTypes2.default.bool,
	
	  onChange: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onNavChange` instead'),
	  initiallyVisible: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initialActiveIndex: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `defaultActiveIndex` instead'),
	  containerStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'Use `style` instead'),
	  containerClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `className` instead'),
	  transitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'There is no CSSTransitionGroup used anymore'),
	  transitionEnterTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transitionDuration` instead'),
	  transitionLeaveTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transitionDuration` instead'),
	  actions: (0, _deprecated2.default)(_propTypes2.default.array, 'Use `links` instead')
	};
	BottomNavigation.defaultProps = {
	  animate: true,
	  defaultActiveIndex: 0,
	  component: 'footer',
	  defaultVisible: true,
	  transitionDuration: 300,
	  portal: false,
	  dynamicThreshold: 5
	};
	BottomNavigation.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this._addTouchEvents = function () {
	    (0, _touches.addTouchEvent)(window, 'start', _this3._handleTouchStart);
	    (0, _touches.addTouchEvent)(window, 'move', _this3._handleTouchMove);
	    (0, _touches.addTouchEvent)(window, 'end', _this3._handleTouchEnd);
	  };
	
	  this._removeTouchEvents = function () {
	    (0, _touches.removeTouchEvent)(window, 'start', _this3._handleTouchStart);
	    (0, _touches.removeTouchEvent)(window, 'move', _this3._handleTouchMove);
	    (0, _touches.removeTouchEvent)(window, 'end', _this3._handleTouchEnd);
	  };
	
	  this._animateIn = function () {
	    if (_this3._timeout) {
	      clearTimeout(_this3._timeout);
	    }
	
	    _this3._timeout = setTimeout(function () {
	      _this3._timeout = null;
	      _this3.setState({ visible: true });
	    }, 17);
	
	    _this3.setState({ portalVisible: true });
	  };
	
	  this._animateOut = function () {
	    if (_this3._timeout) {
	      clearTimeout(_this3._timeout);
	    }
	
	    _this3._timeout = setTimeout(function () {
	      _this3._timeout = null;
	      _this3.setState({ portalVisible: false });
	    }, _this3.props.transitionDuration);
	
	    _this3.setState({ visible: false });
	  };
	
	  this._handleTouchStart = function (e) {
	    var pageY = e.changedTouches[0].pageY;
	
	
	    _this3._pageY = pageY;
	    _this3._scrolling = true;
	  };
	
	  this._handleTouchMove = function (e) {
	    var visible = _this3.state.visible;
	
	    if (!_this3._scrolling) {
	      return;
	    }
	
	    var touchY = e.changedTouches[0].pageY;
	    var dynamicThreshold = _this3.props.dynamicThreshold;
	
	    var passedThreshold = Math.abs(_this3._pageY - touchY) >= dynamicThreshold;
	    if (_this3._pageY > touchY && visible && passedThreshold) {
	      _this3._pageY = touchY;
	      _this3._animateOut();
	    } else if (_this3._pageY < touchY && !visible && passedThreshold) {
	      _this3._pageY = touchY;
	      _this3._animateIn();
	    }
	  };
	
	  this._handleTouchEnd = function () {
	    _this3._scrolling = false;
	  };
	
	  this._handleNavChange = function (index, e) {
	    if (_this3.props.onNavChange || _this3.props.onChange) {
	      (_this3.props.onNavChange || _this3.props.onChange)(index, e);
	    }
	
	    if (typeof _this3.props.activeIndex === 'undefined') {
	      _this3.setState({ activeIndex: index });
	    }
	  };
	};
	
	exports.default = BottomNavigation;
	//# sourceMappingURL=BottomNavigation.js.map

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BottomNavigation = undefined;
	
	var _BottomNavigation2 = __webpack_require__(236);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BottomNavigation3.default;
	exports.BottomNavigation = _BottomNavigation3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentDeprecated = __webpack_require__(36);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FlatButton = function (_PureComponent) {
	  _inherits(FlatButton, _PureComponent);
	
	  function FlatButton() {
	    _classCallCheck(this, FlatButton);
	
	    return _possibleConstructorReturn(this, (FlatButton.__proto__ || Object.getPrototypeOf(FlatButton)).apply(this, arguments));
	  }
	
	  _createClass(FlatButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_Button2.default, _extends({}, this.props, { flat: true }));
	    }
	  }]);
	
	  return FlatButton;
	}(_react.PureComponent);
	
	FlatButton.propTypes = {
	  /**
	   * The label to display in the button.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the icon should be displayed before the label.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * A `FontIcon` to display in the button. It can be placed before
	   * or after the label.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `FlatButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `flat`.')
	};
	FlatButton.defaultProps = {
	  type: 'button',
	  iconBefore: true
	};
	exports.default = FlatButton;
	//# sourceMappingURL=FlatButton.js.map

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentDeprecated = __webpack_require__(36);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _IconButton = __webpack_require__(127);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A `FloatingButton` is an extension of the `IconButton`.
	 * A tooltip can be displayed on hover or touch hold if the
	 * `tooltipLabel` prop is given.
	 *
	 * Another name for this button is a `FloatingActionButton` (FAB).
	 *
	 * Any other props (such as style or event listeners) will also be
	 * applied.
	 */
	var FloatingButton = function (_PureComponent) {
	  _inherits(FloatingButton, _PureComponent);
	
	  function FloatingButton() {
	    _classCallCheck(this, FloatingButton);
	
	    return _possibleConstructorReturn(this, (FloatingButton.__proto__ || Object.getPrototypeOf(FloatingButton)).apply(this, arguments));
	  }
	
	  _createClass(FloatingButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          fixed = _props.fixed,
	          mini = _props.mini,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          props = _objectWithoutProperties(_props, ['className', 'fixed', 'mini', 'children', 'iconClassName']);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        _extends({}, props, {
	          className: (0, _classnames2.default)({
	            'md-btn--floating-fixed': fixed,
	            'md-btn--floating-mini': mini
	          }, className),
	          iconClassName: iconClassName,
	          floating: true
	        }),
	        children
	      );
	    }
	  }]);
	
	  return FloatingButton;
	}(_react.PureComponent);
	
	FloatingButton.propTypes = {
	  /**
	   * The className to use for rendering the `FontIcon`.
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to use to render the `FontIcon`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional label to use if you would like a tooltip to display
	   * on hover or touch hold.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * The position that the tooltip should be displayed relative to
	   * the button.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * An optional amount of delay before the tooltip appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * Boolean if the floating button is fixed.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the floating button should be displayed as the mini
	   * version.
	   */
	  mini: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the floating button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the floating button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `FloatingButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `floating`.')
	};
	exports.default = FloatingButton;
	//# sourceMappingURL=FloatingButton.js.map

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentDeprecated = __webpack_require__(36);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RaisedButton = function (_PureComponent) {
	  _inherits(RaisedButton, _PureComponent);
	
	  function RaisedButton() {
	    _classCallCheck(this, RaisedButton);
	
	    return _possibleConstructorReturn(this, (RaisedButton.__proto__ || Object.getPrototypeOf(RaisedButton)).apply(this, arguments));
	  }
	
	  _createClass(RaisedButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_Button2.default, _extends({}, this.props, { raised: true }));
	    }
	  }]);
	
	  return RaisedButton;
	}(_react.PureComponent);
	
	RaisedButton.propTypes = {
	  /**
	   * The label to display in the button.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the icon should be displayed before the label.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * A `FontIcon` to display in the button. It can be placed before
	   * or after the label.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `RaisedButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `raised`.')
	};
	RaisedButton.defaultProps = {
	  type: 'button',
	  iconBefore: true
	};
	exports.default = RaisedButton;
	//# sourceMappingURL=RaisedButton.js.map

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconButton = exports.FloatingButton = exports.RaisedButton = exports.FlatButton = exports.Button = undefined;
	
	var _Button2 = __webpack_require__(14);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _FlatButton2 = __webpack_require__(238);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _RaisedButton2 = __webpack_require__(240);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _FloatingButton2 = __webpack_require__(239);
	
	var _FloatingButton3 = _interopRequireDefault(_FloatingButton2);
	
	var _IconButton2 = __webpack_require__(127);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Button3.default;
	exports.Button = _Button3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.FloatingButton = _FloatingButton3.default;
	exports.IconButton = _IconButton3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _contextTypes = __webpack_require__(133);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(29);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Collapse = __webpack_require__(35);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Card = function (_PureComponent) {
	  _inherits(Card, _PureComponent);
	
	  function Card(props) {
	    _classCallCheck(this, Card);
	
	    var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));
	
	    _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (_this.props.raise && !_this._touched) {
	        _this.setState({ zDepth: 4 });
	      }
	    };
	
	    _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      _this._touched = false;
	      if (_this.props.raise && _this.state.zDepth !== 1) {
	        _this.setState({ zDepth: 1 });
	      }
	    };
	
	    _this._handleTouchStart = function (e) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(e);
	      }
	
	      _this._touched = true;
	    };
	
	    _this._handleExpandClick = function (e) {
	      var onExpanderClick = _this.props.onExpanderClick;
	
	      var expanded = !(0, _getField2.default)(_this.props, _this.state, 'expanded');
	      if (onExpanderClick) {
	        onExpanderClick(expanded, e);
	      }
	
	      if (typeof _this.props.expanded === 'undefined') {
	        _this.setState({ expanded: expanded });
	      }
	    };
	
	    _this.state = {
	      zDepth: 1,
	      expanded: typeof props.initiallyExpanded !== 'undefined' ? props.initiallyExpanded : !!props.defaultExpanded
	    };
	    return _this;
	  }
	
	  _createClass(Card, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          expanderTooltipLabel = _props.expanderTooltipLabel,
	          expanderTooltipDelay = _props.expanderTooltipDelay,
	          expanderTooltipPosition = _props.expanderTooltipPosition,
	          expanderIcon = _props.expanderIcon,
	          iconClassName = _props.iconClassName,
	          iconChildren = _props.iconChildren,
	          expanderIconClassName = _props.expanderIconClassName,
	          expanderIconChildren = _props.expanderIconChildren;
	
	
	      var expanded = typeof this.props.isExpanded !== 'undefined' ? this.props.isExpanded : (0, _getField2.default)(this.props, this.state, 'expanded');
	
	      return {
	        expanded: expanded,
	        onExpandClick: this._handleExpandClick,
	        icon: (0, _getDeprecatedIcon2.default)(iconChildren || expanderIconChildren, iconClassName || expanderIconClassName, expanderIcon),
	        tooltipLabel: expanderTooltipLabel,
	        tooltipDelay: expanderTooltipDelay,
	        tooltipPosition: expanderTooltipPosition
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var zDepth = this.state.zDepth;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          raise = _props2.raise,
	          tableCard = _props2.tableCard,
	          children = _props2.children,
	          animate = _props2.animate,
	          propExpanded = _props2.expanded,
	          onExpanderClick = _props2.onExpanderClick,
	          defaultExpanded = _props2.defaultExpanded,
	          expanderIcon = _props2.expanderIcon,
	          expanderIconChildren = _props2.expanderIconChildren,
	          expanderIconClassName = _props2.expanderIconClassName,
	          expanderTooltipLabel = _props2.expanderTooltipLabel,
	          expanderTooltipDelay = _props2.expanderTooltipDelay,
	          expanderTooltipPosition = _props2.expanderTooltipPosition,
	          iconChildren = _props2.iconChildren,
	          iconClassName = _props2.iconClassName,
	          isExpanded = _props2.isExpanded,
	          initiallyExpanded = _props2.initiallyExpanded,
	          props = _objectWithoutProperties(_props2, ['className', 'raise', 'tableCard', 'children', 'animate', 'expanded', 'onExpanderClick', 'defaultExpanded', 'expanderIcon', 'expanderIconChildren', 'expanderIconClassName', 'expanderTooltipLabel', 'expanderTooltipDelay', 'expanderTooltipPosition', 'iconChildren', 'iconClassName', 'isExpanded', 'initiallyExpanded']);
	
	      var expanded = typeof this.props.isExpanded !== 'undefined' ? this.props.isExpanded : (0, _getField2.default)(this.props, this.state, 'expanded');
	      var expanderIndex = -1;
	      var parts = _react.Children.map(_react.Children.toArray(children), function (child, i) {
	        if (!child || !child.props) {
	          return child;
	        } else if (expanderIndex < 0 && (child.props.isExpander || child.props.expander)) {
	          expanderIndex = i;
	        }
	
	        if (!child.props.expandable) {
	          return child;
	        }
	
	        var collapsed = expanderIndex === -1 || expanderIndex === i || !expanded;
	        return _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: collapsed, animate: animate },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          zDepth: zDepth,
	          className: (0, _classnames2.default)('md-card', {
	            'md-card--raise': raise,
	            'md-card--table': tableCard
	          }, 'md-background--card', className),
	          onMouseOver: this._handleMouseOver,
	          onMouseLeave: this._handleMouseLeave,
	          onTouchStart: this._handleTouchStart
	        }),
	        parts
	      );
	    }
	  }]);
	
	  return Card;
	}(_react.PureComponent);
	
	Card.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the card.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Any Card parts that should be rendered.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the card is expanded by default when there is an expander
	   * component.
	   */
	  defaultExpanded: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the card should raise on hover when on a desktop display.
	   */
	  raise: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the card is currently expanded. This will require the `onExpanderClick` function
	   * to toggle the state. The card will become controlled if this is not `undefined`.
	   */
	  expanded: (0, _controlled2.default)(_propTypes2.default.bool, 'onExpanderClick', 'defaultExpanded'),
	
	  /**
	   * An optional function to call when the expander is clicked.
	   */
	  onExpanderClick: _propTypes2.default.func,
	
	  /**
	   * The icon to use for the expander button. It is recommended to use this prop over
	   * the `expaderIconChildren` and `expanderIconClassName` since it provides more control.
	   */
	  expanderIcon: _propTypes2.default.element,
	
	  /**
	   * The tooltip position for the expander icon.
	   */
	  expanderTooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The optional tooltip to display for the expander icon.
	   */
	  expanderTooltipLabel: _propTypes2.default.node,
	
	  /**
	   * An optional delay before the tooltip appears for the expander icon on hover.
	   */
	  expanderTooltipDelay: _propTypes2.default.number,
	
	  /**
	   * Boolean if the card contains a table. It will update the styling accordingly.
	   * When using the `DataTable` component, do not wrap it in a `CardText` component.
	   *
	   * ```js
	   * <Card tableCard={true}>
	   *   <CardTitle title="Example />
	   *   <DataTable>
	   *     ...
	   *   </DataTable>
	   * </Card>
	   * ```
	   */
	  tableCard: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the mouseover event is triggered.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the mouseleave event is triggered.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the touchstart event is triggered.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * Boolean if the card expansion should be animated.
	   */
	  animate: _propTypes2.default.bool,
	
	  expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `expanderIcon` instead'),
	  expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `expanderIcon` instead'),
	  initiallyExpanded: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultExpanded` instead'),
	  isExpanded: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expanded` instead'),
	  iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `expanderIconChildren` prop instead'),
	  iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `expanderIconClassName` prop instead')
	};
	Card.defaultProps = {
	  animate: true,
	  expanderIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_down'
	  ),
	  expanderTooltipPosition: 'left'
	};
	Card.childContextTypes = _contextTypes2.default;
	exports.default = Card;
	//# sourceMappingURL=Card.js.map

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CardTitle = __webpack_require__(131);
	
	var _CardTitle2 = _interopRequireDefault(_CardTitle);
	
	var _CardActions = __webpack_require__(129);
	
	var _CardActions2 = _interopRequireDefault(_CardActions);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _componentDeprecated = __webpack_require__(36);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardActionOverlay` component is a simple wrapper for generating an overlay
	 * for the `CardMedia` component by having a `CardTitle` and an array of props
	 * for generating `FlatButton` for the `CardActions` component.
	 */
	var CardActionOverlay = function (_PureComponent) {
	  _inherits(CardActionOverlay, _PureComponent);
	
	  function CardActionOverlay() {
	    _classCallCheck(this, CardActionOverlay);
	
	    return _possibleConstructorReturn(this, (CardActionOverlay.__proto__ || Object.getPrototypeOf(CardActionOverlay)).apply(this, arguments));
	  }
	
	  _createClass(CardActionOverlay, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          titleProps = _objectWithoutProperties(_props, ['actions']);
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_CardTitle2.default, titleProps),
	        _react2.default.createElement(
	          _CardActions2.default,
	          null,
	          actions.map(function (actionProps, i) {
	            return _react2.default.createElement(_Button2.default, _extends({ flat: true, key: i }, actionProps));
	          })
	        )
	      );
	    }
	  }]);
	
	  return CardActionOverlay;
	}(_react.PureComponent);
	
	CardActionOverlay.propTypes = {
	  /**
	   * The title to use.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * The optional subtitle to use.
	   */
	  subtitle: _propTypes2.default.node,
	
	  /**
	   * An array of flat button props.
	   */
	  actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    label: _propTypes2.default.node.isRequired
	  })),
	
	  /**
	   * Any children to display in the `CardTitle` component.
	   */
	  children: _propTypes2.default.node,
	  deprecated: (0, _componentDeprecated2.default)('It is not a worthwhile component since the same thing can be accomplished with the `MediaOverlay` component.')
	};
	exports.default = CardActionOverlay;
	//# sourceMappingURL=CardActionOverlay.js.map

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _componentDeprecated = __webpack_require__(36);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _Media = __webpack_require__(147);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _MediaOverlay = __webpack_require__(148);
	
	var _MediaOverlay2 = _interopRequireDefault(_MediaOverlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardMedia` component is used to display images or some sort
	 * media.
	 */
	var CardMedia = function (_PureComponent) {
	  _inherits(CardMedia, _PureComponent);
	
	  function CardMedia() {
	    _classCallCheck(this, CardMedia);
	
	    return _possibleConstructorReturn(this, (CardMedia.__proto__ || Object.getPrototypeOf(CardMedia)).apply(this, arguments));
	  }
	
	  _createClass(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'children']);
	
	      delete props.overlay;
	
	      var overlay = this.props.overlay;
	
	      if (overlay) {
	        overlay = _react2.default.createElement(
	          _MediaOverlay2.default,
	          null,
	          overlay
	        );
	      }
	
	      return _react2.default.createElement(
	        _Media2.default,
	        _extends({ className: (0, _classnames2.default)('md-card-media', className) }, props),
	        children,
	        overlay
	      );
	    }
	  }]);
	
	  return CardMedia;
	}(_react.PureComponent);
	
	CardMedia.aspect = {
	  equal: '1-1',
	  wide: '16-9'
	};
	CardMedia.propTypes = {
	  /**
	   * An optional className to apply to the card media component.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional overlay component to be rendered over the media. This *should*
	   * be A `CardTitle`, `CardActions` or both.
	   */
	  overlay: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `MediaOverlay` component as a child instead'),
	
	  /**
	   * Any media to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the aspect ratio should be forced.
	   */
	  forceAspect: _propTypes2.default.bool,
	
	  /**
	   * The aspect ratio to use.
	   */
	  aspectRatio: _propTypes2.default.oneOf([CardMedia.aspect.equal, CardMedia.aspect.wide]).isRequired,
	
	  /**
	   * Boolean if this component should be expandable when there is a `CardExpander`
	   * above it in the `Card`.
	   */
	  expandable: _propTypes2.default.bool,
	
	  /**
	   * The component to render the card media as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  deprecated: (0, _componentDeprecated2.default)('There were no unique styles for media in cards so it is simpler to just use the ' + '`Media` component.')
	};
	CardMedia.defaultProps = {
	  forceAspect: true,
	  aspectRatio: CardMedia.aspect.wide,
	  component: 'section'
	};
	exports.default = CardMedia;
	//# sourceMappingURL=CardMedia.js.map

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardText` component is a simple wrapper for text or any content in a `Card`.
	 * It really just adds correct padding and font color.
	 */
	var CardText = function (_PureComponent) {
	  _inherits(CardText, _PureComponent);
	
	  function CardText() {
	    _classCallCheck(this, CardText);
	
	    return _possibleConstructorReturn(this, (CardText.__proto__ || Object.getPrototypeOf(CardText)).apply(this, arguments));
	  }
	
	  _createClass(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          className = _props.className,
	          expandable = _props.expandable,
	          props = _objectWithoutProperties(_props, ['component', 'className', 'expandable']);
	
	      return _react2.default.createElement(Component, _extends({}, props, { className: (0, _classnames2.default)('md-card-text', className) }));
	    }
	  }]);
	
	  return CardText;
	}(_react.PureComponent);
	
	CardText.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to render as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * Boolean if this component should be expandable when there is a `CardExpander`
	   * above it in the `Card`.
	   */
	  expandable: _propTypes2.default.bool
	};
	CardText.defaultProps = {
	  component: 'section'
	};
	exports.default = CardText;
	//# sourceMappingURL=CardText.js.map

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardActionOverlay = exports.CardText = exports.CardActions = exports.CardMedia = exports.CardTitle = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(242);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardTitle2 = __webpack_require__(131);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(244);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardActions2 = __webpack_require__(129);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardText2 = __webpack_require__(245);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActionOverlay2 = __webpack_require__(243);
	
	var _CardActionOverlay3 = _interopRequireDefault(_CardActionOverlay2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Card3.default;
	exports.Card = _Card3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardText = _CardText3.default;
	exports.CardActionOverlay = _CardActionOverlay3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chip = function (_PureComponent) {
	  _inherits(Chip, _PureComponent);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Chip.__proto__ || Object.getPrototypeOf(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this._handleMouseEnter = function (e) {
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(e);
	      }
	
	      _this.setState({ hover: true });
	    }, _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      _this.setState({ hover: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Chip, [{
	    key: 'render',
	    value: function render() {
	      var hover = this.state.hover;
	
	      var _props = this.props,
	          label = _props.label,
	          className = _props.className,
	          labelStyle = _props.labelStyle,
	          labelClassName = _props.labelClassName,
	          avatar = _props.avatar,
	          children = _props.children,
	          removable = _props.removable,
	          remove = _props.remove,
	          onClick = _props.onClick,
	          rotateIcon = _props.rotateIcon,
	          iconClassName = _props.iconClassName,
	          removeIconChildren = _props.removeIconChildren,
	          removeIconClassName = _props.removeIconClassName,
	          props = _objectWithoutProperties(_props, ['label', 'className', 'labelStyle', 'labelClassName', 'avatar', 'children', 'removable', 'remove', 'onClick', 'rotateIcon', 'iconClassName', 'removeIconChildren', 'removeIconClassName']);
	
	      var icon = void 0;
	      if (removable || remove) {
	        var chipIconCN = (0, _classnames2.default)('md-chip-icon', {
	          'md-chip-icon--rotate': rotateIcon,
	          'md-chip-text--hover': hover
	        });
	
	        if (_react2.default.isValidElement(children)) {
	          icon = _react2.default.Children.only(children);
	          icon = _react2.default.cloneElement(icon, { className: (0, _classnames2.default)(chipIconCN, icon.props.className) });
	        } else {
	          icon = _react2.default.createElement(
	            _FontIcon2.default,
	            { className: chipIconCN, iconClassName: iconClassName },
	            children
	          );
	        }
	      }
	
	      return _react2.default.createElement(
	        'button',
	        _extends({
	          type: 'button'
	        }, props, {
	          className: (0, _classnames2.default)('md-chip', {
	            'md-chip--avatar': avatar,
	            'md-chip--remove': removable,
	            'md-chip--hover': hover
	          }, className),
	          onClick: remove || onClick,
	          onMouseEnter: this._handleMouseEnter,
	          onMouseLeave: this._handleMouseLeave
	        }),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          {
	            style: labelStyle,
	            className: (0, _classnames2.default)('md-chip-text', {
	              'md-chip-text--hover': hover
	            }, labelClassName)
	          },
	          label
	        ),
	        icon
	      );
	    }
	  }]);
	
	  return Chip;
	}(_react.PureComponent);
	
	Chip.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the chip's label.
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the chip's label.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `.md-chip-icon--rotate` style should be applied to the remove icon.
	   * The `.md-chip-icon--rotate` just rotates the icon 45 degrees.
	   */
	  rotateIcon: _propTypes2.default.bool,
	
	  /**
	   * Any children used to display the remove icon when `removable`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The label to display on the chip.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the chip is removable.
	   */
	  removable: _propTypes2.default.bool,
	
	  /**
	   * An optional avatar to display on the chip.
	   */
	  avatar: _propTypes2.default.element,
	
	  /**
	   * An optional function to call when the `click` event is triggered.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseenter` event is triggered.
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseleave` event is triggered.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `children` prop as a single FontIcon or SVGIcon instead'),
	  remove: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `removable` and `onClick` instead'),
	  removeIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `children` instead'),
	  removeIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `children` prop as a single FontIcon or SVGIcon instead')
	};
	Chip.defaultProps = {
	  rotateIcon: true,
	  children: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'add_circle'
	  )
	};
	exports.default = Chip;
	//# sourceMappingURL=Chip.js.map

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chip = undefined;
	
	var _Chip2 = __webpack_require__(247);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chip3.default;
	exports.Chip = _Chip3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _requiredForA11yIfNot = __webpack_require__(370);
	
	var _requiredForA11yIfNot2 = _interopRequireDefault(_requiredForA11yIfNot);
	
	var _invalidIf = __webpack_require__(37);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _contextTypes = __webpack_require__(67);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `DataTable` component is used to manage the state of all rows.
	 * This can either be a __plain__ table or a __data__ table.
	 *
	 * A __data__ table will include checkboxes on each row while a __plain__ table
	 * will not.
	 */
	var DataTable = function (_PureComponent) {
	  _inherits(DataTable, _PureComponent);
	
	  function DataTable(props) {
	    _classCallCheck(this, DataTable);
	
	    var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var rows = props.defaultSelectedRows;
	    _this.state = {
	      header: false,
	      indeterminate: props.indeterminate ? false : undefined,
	      allSelected: _this._allSelected(rows),
	      selectedRows: rows
	    };
	
	    _this._removed = 0;
	    _this._initial = true;
	    return _this;
	  }
	
	  _createClass(DataTable, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          uncheckedIcon = _props.uncheckedIcon,
	          indeterminateIcon = _props.indeterminateIcon,
	          plain = _props.plain,
	          baseId = _props.baseId,
	          selectableRows = _props.selectableRows,
	          checkboxHeaderLabel = _props.checkboxHeaderLabel,
	          checkboxLabelTemplate = _props.checkboxLabelTemplate,
	          fixedHeader = _props.fixedHeader,
	          fixedFooter = _props.fixedFooter,
	          checkedIconChildren = _props.checkedIconChildren,
	          checkedIconClassName = _props.checkedIconClassName,
	          uncheckedIconChildren = _props.uncheckedIconChildren,
	          uncheckedIconClassName = _props.uncheckedIconClassName,
	          indeterminateIconChildren = _props.indeterminateIconChildren,
	          indeterminateIconClassName = _props.indeterminateIconClassName;
	
	
	      return {
	        checkedIcon: (0, _getDeprecatedIcon2.default)(checkedIconClassName, checkedIconChildren, checkedIcon),
	        uncheckedIcon: (0, _getDeprecatedIcon2.default)(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon),
	        indeterminateIcon: (0, _getDeprecatedIcon2.default)(indeterminateIconClassName, indeterminateIconChildren, indeterminateIcon),
	        indeterminate: this.state.indeterminate,
	        plain: plain,
	        allSelected: this.state.allSelected,
	        selectedRows: this.state.selectedRows,
	        toggleSelectedRow: this._toggleSelectedRow,
	        createCheckbox: this._createCheckbox,
	        removeCheckbox: this._removeCheckbox,
	        baseId: baseId,
	        baseName: baseId + '-control',
	        selectableRows: selectableRows,
	        checkboxHeaderLabel: checkboxHeaderLabel,
	        checkboxLabelTemplate: checkboxLabelTemplate,
	        fixedHeader: fixedHeader,
	        fixedFooter: fixedFooter
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._removed = 0;
	      this._initial = false;
	    }
	  }, {
	    key: '_allSelected',
	    value: function _allSelected(rows) {
	      var all = rows.length !== 0;
	      rows.some(function (checked) {
	        if (!checked) {
	          all = false;
	        }
	
	        return !all;
	      });
	
	      return all;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props2 = this.props,
	          style = _props2.style,
	          className = _props2.className,
	          tableStyle = _props2.tableStyle,
	          tableClassName = _props2.tableClassName,
	          fixedWrapperStyle = _props2.fixedWrapperStyle,
	          fixedWrapperClassName = _props2.fixedWrapperClassName,
	          fixedScrollWrapperStyle = _props2.fixedScrollWrapperStyle,
	          fixedScrollWrapperClassName = _props2.fixedScrollWrapperClassName,
	          children = _props2.children,
	          plain = _props2.plain,
	          responsive = _props2.responsive,
	          fixedHeader = _props2.fixedHeader,
	          fixedFooter = _props2.fixedFooter,
	          fixedDividers = _props2.fixedDividers,
	          fixedHeight = _props2.fixedHeight,
	          fixedWidth = _props2.fixedWidth,
	          headerHeight = _props2.headerHeight,
	          footerHeight = _props2.footerHeight,
	          fullWidth = _props2.fullWidth,
	          indeterminate = _props2.indeterminate,
	          indeterminateIcon = _props2.indeterminateIcon,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          defaultSelectedRows = _props2.defaultSelectedRows,
	          baseId = _props2.baseId,
	          onRowToggle = _props2.onRowToggle,
	          selectableRows = _props2.selectableRows,
	          checkboxHeaderLabel = _props2.checkboxHeaderLabel,
	          checkboxLabelTemplate = _props2.checkboxLabelTemplate,
	          checkedIconChildren = _props2.checkedIconChildren,
	          checkedIconClassName = _props2.checkedIconClassName,
	          uncheckedIconChildren = _props2.uncheckedIconChildren,
	          uncheckedIconClassName = _props2.uncheckedIconClassName,
	          indeterminateIconChildren = _props2.indeterminateIconChildren,
	          indeterminateIconClassName = _props2.indeterminateIconClassName,
	          props = _objectWithoutProperties(_props2, ['style', 'className', 'tableStyle', 'tableClassName', 'fixedWrapperStyle', 'fixedWrapperClassName', 'fixedScrollWrapperStyle', 'fixedScrollWrapperClassName', 'children', 'plain', 'responsive', 'fixedHeader', 'fixedFooter', 'fixedDividers', 'fixedHeight', 'fixedWidth', 'headerHeight', 'footerHeight', 'fullWidth', 'indeterminate', 'indeterminateIcon', 'checkedIcon', 'uncheckedIcon', 'defaultSelectedRows', 'baseId', 'onRowToggle', 'selectableRows', 'checkboxHeaderLabel', 'checkboxLabelTemplate', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName', 'indeterminateIconChildren', 'indeterminateIconClassName']);
	
	      var table = _react2.default.createElement(
	        'table',
	        _extends({}, props, {
	          ref: this._setTable,
	          style: responsive ? tableStyle : style,
	          className: (0, _classnames2.default)('md-data-table', (_cn = {
	            'md-data-table--plain': plain,
	            'md-data-table--full-width': fullWidth
	          }, _defineProperty(_cn, className, !responsive && className), _defineProperty(_cn, tableClassName, responsive && tableClassName), _cn))
	        }),
	        children
	      );
	
	      if (!responsive) {
	        return table;
	      }
	
	      var content = table;
	      if (fixedHeader || fixedFooter) {
	        var height = fixedHeight;
	        if (fixedHeight) {
	          if (fixedHeader) {
	            height -= headerHeight;
	          }
	
	          if (fixedFooter) {
	            height -= footerHeight;
	          }
	        }
	
	        var borderTop = fixedHeader;
	        var borderBot = fixedFooter;
	        if (typeof fixedDividers === 'boolean') {
	          borderTop = borderTop && fixedDividers;
	          borderBot = borderBot && fixedDividers;
	        } else {
	          borderTop = borderTop && (typeof fixedDividers.header === 'undefined' || fixedDividers.header);
	          borderBot = borderBot && (typeof fixedDividers.footer === 'undefined' || fixedDividers.footer);
	        }
	
	        content = _react2.default.createElement(
	          'div',
	          {
	            style: fixedWrapperStyle,
	            className: (0, _classnames2.default)('md-data-table__fixed-wrapper', {
	              'md-data-table__fixed-wrapper--header': fixedHeader,
	              'md-data-table__fixed-wrapper--footer': fixedFooter
	            }, fixedWrapperClassName)
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              style: _extends({ height: height }, fixedScrollWrapperStyle),
	              className: (0, _classnames2.default)('md-data-table__scroll-wrapper', {
	                'md-divider-border': fixedDividers,
	                'md-divider-border--top': borderTop,
	                'md-divider-border--bottom': borderBot
	              }, fixedScrollWrapperClassName)
	            },
	            table
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: _extends({ width: fixedWidth }, style),
	          className: (0, _classnames2.default)('md-data-table--responsive', {
	            'md-data-table--fixed': fixedHeader || fixedFooter
	          }, className)
	        },
	        content
	      );
	    }
	  }]);
	
	  return DataTable;
	}(_react.PureComponent);
	
	DataTable.propTypes = {
	  /**
	   * A base id to use for every checkbox or `EditDialogColumn` in the data table. This is
	   * required for a11y if the data table is not plain. It is recommended to always provide
	   * this prop if you are using any of the advanced table components to auto-generate unique
	   * ids for each element.
	   *
	   * @see {@link DataTables/EditDialogColumn}
	   * @see {@link DataTables/SelectFieldColumn}
	   * @see {@link DataTables/DropdownMenuColumn}
	   * @see {@link DataTables/MenuButtonColumn}
	   * @see {@link DataTables/TablePagination}
	   */
	  baseId: (0, _requiredForA11yIfNot2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'plain'),
	
	  /**
	   * Optional style to apply to the table. If the table is `responsive`, this will be applied to the surrounding `div`
	   * instead of the table itself. Use the `tableStyle` in this case.
	   *
	   * @see {@link #tableStyle}
	   * @see {@link #responsive}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the table. If the table is `responsive`, this will be applied to the
	   * surrounding `div` instead of the table itself. Use the `tableClassName` in this case.
	   *
	   * @see {@link #tableClassName}
	   * @see {@link #responsive}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `table` itself when the `responsive` prop is enabled. If the table is not
	   * `responsive`, use the `style` prop.
	   *
	   * @see {@link #style}
	   * @see {@link #responsive}
	   */
	  tableStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `table` itself when the `responsive` prop is enabled. If the table is not
	   * `responsive`, use the `className` prop.
	   *
	   * @see {@link #className}
	   * @see {@link #responsive}
	   */
	  tableClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the fixed table wrapper that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperClassName}
	   * @see {@link #fixedScrollWrapperStyle}
	   * @see {@link #fixedScrollWrapperClassName}
	   */
	  fixedWrapperStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the fixed table wrapper that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperStyle}
	   * @see {@link #fixedScrollWrapperStyle}
	   * @see {@link #fixedScrollWrapperClassName}
	   */
	  fixedWrapperClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the fixed table wrapper's scroll container that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperStyle}
	   * @see {@link #fixedWrapperClassName}
	   * @see {@link #fixedScrollWrapperStyle}
	   */
	  fixedScrollWrapperStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the fixed table wrapper's scroll container that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperStyle}
	   * @see {@link #fixedWrapperClassName}
	   * @see {@link #fixedScrollWrapperStyle}
	   */
	  fixedScrollWrapperClassName: _propTypes2.default.string,
	
	  /**
	   * The table contents to display. This *should* be a list of `TableHeader` and `TableBody`
	   * components.
	   */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional array of booleans denoting if a row is selected.
	   * This is an associative array so the index must match the row
	   * number in the `TableBody` component.
	   */
	  defaultSelectedRows: _propTypes2.default.arrayOf(_propTypes2.default.bool).isRequired,
	
	  /**
	   * Boolean if the table is responsive. This will wrap the table in a container
	   * that allows scrolling to the right if overflow exists.
	   */
	  responsive: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Boolean if this table should not include the checkboxes on each row.
	   * This really means that the entire table is unselectable and you wish
	   * to display as a normal table.
	   */
	  plain: _propTypes2.default.bool,
	
	  /**
	   * The checked checkbox icon to display when a row is selected. This really defaults
	   * to the `checkedCheckboxIcon` prop from the `SelectionControl`.
	   *
	   * @see {@link SelectionControls/SelectionControl#checkedCheckboxIcon}
	   */
	  checkedIcon: _propTypes2.default.element,
	
	  /**
	   * The unchecked checkbox icon to display when a row is selected. This really defaults
	   * to the `uncheckedCheckboxIcon` prop from the `SelectionControl`.
	   *
	   * @see {@link SelectionControls/SelectionControl#uncheckedCheckboxIcon}
	   */
	  uncheckedIcon: _propTypes2.default.element,
	
	  /**
	   * An optional function to call when a non-plain data table has a row toggled. The callback
	   * will include:
	   * - the row id
	   * - boolean if the row is now checked
	   * - the total count of rows selected
	   * - the change event
	   *
	   * All rows will be toggled on or off when the row id is 0 and a `thead` exists in the table.
	   */
	  onRowToggle: (0, _invalidIf2.default)(_propTypes2.default.func, 'plain'),
	
	  /**
	   * Boolean if the `DataTable` should inject checkboxes at the start of each row.
	   */
	  selectableRows: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the checkboxes in the table should also include an _indeterminate_ state.
	   * It will use the `indeterminateIconChildren` and `indeterminateIconClassName` when at least
	   * 1 row has been checked, but not all rows.
	   */
	  indeterminate: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to display when the selected state is indeterminate.
	   *
	   * @see {@link #indeterminate}
	   */
	  indeterminateIcon: _propTypes2.default.element,
	
	  /**
	   * This is the aria-label to apply to the checkbox in the table's header. This
	   * is just used for accessibility since the checkboxes have no visible label.
	   */
	  checkboxHeaderLabel: _propTypes2.default.string.isRequired,
	
	  /**
	   * This is the aria-label to apply to a checkbox in the table's body. This can either
	   * be a constant string that will replace `{{row}}` with the current row index, or
	   * a function that takes the row index and returns a string.
	   *
	   * ```js
	   * checkboxLabelTemplate={rowIndex => `Toggle row ${row}`}
	   * ```
	   */
	  checkboxLabelTemplate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the table should include a fixed header. This will allow the `TableHeader` component
	   * to stay fixed to the top of the table while the `TableBody` scrolls horizontally.
	   *
	   * @see {@link #fixedFooter}
	   * @see [react-md-make-fixed-table](/components/data-tables?tab=2#mixin-react-md-make-fixed-table)
	   */
	  fixedHeader: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the table should include a fixed footer. This will allow the `TableFooter` component
	   * to stay fixed to the bottom of the table while the `TableBody` scrolls horizontally.
	   *
	   * @see {@link #fixedHeader}
	   * @see [react-md-make-fixed-table](/components/data-tables?tab=2#mixin-react-md-make-fixed-table)
	   */
	  fixedFooter: _propTypes2.default.bool,
	
	  /**
	   * Either a boolean or a shape of booleans for if a divider should appear at the top or bottom of the table
	   * when there is a fixed header/footer. By default, this will automatically create dividers.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   */
	  fixedDividers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
	    header: _propTypes2.default.bool,
	    footer: _propTypes2.default.bool
	  })]),
	
	  /**
	   * An optional height to set for a table with a fixed header and/or a fixed footer. It is recommended to use
	   * the related `react-md-make-fixed-table` mixin instead.
	   *
	   * @see {@link #headerHeight}
	   * @see {@link #footerHeight}
	   */
	  fixedHeight: _propTypes2.default.number,
	
	  /**
	   * An optional width to set for a table with a fixed header and/or a fixed footer. It is recommended to use
	   * the related `react-md-make-fixed-table` mixin instead.
	   */
	  fixedWidth: _propTypes2.default.number,
	
	  /**
	   * This is the height of the table's header columns. This should be equal to the `md-data-table-header-height`
	   * variable.
	   *
	   * @see [md-data-table-header-height](/components/data-tables?tab=2#variable-md-data-table-header-height)
	   * @see {@link #fixedHeight}
	   */
	  headerHeight: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is the height of the table's header columns. This should be equal to the `md-data-table-header-height`
	   * variable.
	   *
	   * @see [md-data-table-column-height](/components/data-tables?tab=2#variable-md-data-table-column-height)
	   * @see {@link #fixedHeight}
	   */
	  footerHeight: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `<table>` element should always span the entire width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  indeterminateIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `indeterminateIcon` prop instead'),
	  indeterminateIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `indeterminateIcon` prop instead'),
	  checkedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `checkedIcon` prop instead'),
	  checkedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedIcon` prop instead'),
	  uncheckedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `uncheckedIcon` prop instead'),
	  uncheckedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedIcon` prop instead')
	};
	DataTable.defaultProps = {
	  indeterminateIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'indeterminate_check_box'
	  ),
	  defaultSelectedRows: [],
	  responsive: true,
	  selectableRows: true,
	  checkboxHeaderLabel: 'Toggle All Rows',
	  checkboxLabelTemplate: 'Toggle row {{row}}',
	  fixedHeader: false,
	  fixedFooter: false,
	  fixedDividers: true,
	  headerHeight: 56,
	  footerHeight: 48,
	  fullWidth: true
	};
	DataTable.childContextTypes = _contextTypes2.default;
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setTable = function (table) {
	    _this2._table = table;
	  };
	
	  this._createCheckbox = function (index) {
	    _this2.setState(function (state, props) {
	      var selectedRows = state.selectedRows.slice();
	      // Only use the default selected rows prop on first mount. If other changes occur after,
	      // default to false.
	      var selected = _this2._initial && props.defaultSelectedRows[index] || false;
	      selectedRows.splice(index, 0, selected);
	      return { selectedRows: selectedRows, allSelected: _this2._allSelected(selectedRows) };
	    });
	  };
	
	  this._removeCheckbox = function (index) {
	    _this2.setState(function (state) {
	      // When multiple checkboxes are removed in a render cycle, they are removed in list order.
	      // So to keep the index correct while removing, need to keep subtract the provided index by
	      // the current number of removed elements. This value gets reset to 0 after a finished cycle.
	      var selectedRows = state.selectedRows.slice();
	
	      // This is really ugly. React 16 doesn't need to track all this while React 15 does
	      if (_react2.default.version && _react2.default.version.match(/^16\./)) {
	        selectedRows.splice(index, 1);
	      } else {
	        selectedRows.splice(index - _this2._removed, 1);
	        _this2._removed += 1;
	      }
	      return { selectedRows: selectedRows, allSelected: _this2._allSelected(selectedRows) };
	    });
	  };
	
	  this._toggleSelectedRow = function (row, header, e) {
	    var selectedRows = void 0;
	    var allSelected = _this2.state.allSelected;
	    var selectedCount = 0;
	    var i = _this2._table && _this2._table.querySelector('.md-table-header') ? row - 1 : row;
	    var checked = e.target.checked;
	
	    if (header) {
	      selectedRows = _this2.state.selectedRows.map(function () {
	        return checked;
	      });
	      allSelected = checked;
	      selectedCount = !checked ? 0 : selectedRows.length;
	    } else {
	      selectedRows = _this2.state.selectedRows.slice();
	      selectedRows[i] = !selectedRows[i];
	      selectedCount = selectedRows.filter(function (b) {
	        return b;
	      }).length;
	      allSelected = selectedCount === selectedRows.length;
	    }
	
	    if (_this2.props.onRowToggle) {
	      _this2.props.onRowToggle(row, checked, selectedCount, e);
	    }
	
	    var indeterminate = _this2.props.indeterminate && !allSelected && selectedCount > 0;
	
	    _this2.setState({ selectedRows: selectedRows, allSelected: allSelected, indeterminate: indeterminate });
	  };
	};
	
	exports.default = DataTable;
	//# sourceMappingURL=DataTable.js.map

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _withTableFixes = __webpack_require__(87);
	
	var _withTableFixes2 = _interopRequireDefault(_withTableFixes);
	
	var _DropdownMenu = __webpack_require__(94);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _TableColumn = __webpack_require__(43);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownMenuColumn = function (_PureComponent) {
	  _inherits(DropdownMenuColumn, _PureComponent);
	
	  function DropdownMenuColumn() {
	    _classCallCheck(this, DropdownMenuColumn);
	
	    return _possibleConstructorReturn(this, (DropdownMenuColumn.__proto__ || Object.getPrototypeOf(DropdownMenuColumn)).apply(this, arguments));
	  }
	
	  _createClass(DropdownMenuColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          menuStyle = _props.menuStyle,
	          menuClassName = _props.menuClassName,
	          header = _props.header,
	          adjusted = _props.adjusted,
	          tooltipLabel = _props.tooltipLabel,
	          tooltipDelay = _props.tooltipDelay,
	          tooltipPosition = _props.tooltipPosition,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'header', 'adjusted', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition']);
	
	      return _react2.default.createElement(
	        _TableColumn2.default,
	        {
	          style: style,
	          className: className,
	          header: header,
	          adjusted: adjusted,
	          tooltipLabel: tooltipLabel,
	          tooltipDelay: tooltipDelay,
	          tooltipPosition: tooltipPosition
	        },
	        _react2.default.createElement(_DropdownMenu2.default, _extends({}, props, { style: menuStyle, className: menuClassName }))
	      );
	    }
	  }]);
	
	  return DropdownMenuColumn;
	}(_react.PureComponent);
	
	DropdownMenuColumn.Positions = _DropdownMenu2.default.Positions;
	DropdownMenuColumn.HorizontalAnchors = _DropdownMenu2.default.HorizontalAnchors;
	DropdownMenuColumn.VerticalAnchors = _DropdownMenu2.default.VerticalAnchors;
	DropdownMenuColumn.propTypes = {
	  /**
	   * An optional id to use for the menu button in the column. If this is omitted, it's value will be
	   * `${rowId}-${cellIndex}-menu-button`
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * This is the optional style to apply to the `TableColumn`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * This is the optional className to apply to the `TableColumn`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The is the optional style to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/DropdownMenu#style}
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * The is the optional class name to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/DropdownMenu#className}
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * This is how the select field should be fixed within the table. When this is omitted,
	   * it will automatically use the responsive table as the fixture so that the select field
	   * will close/adjust itself to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * The optional tooltip to render on hover.
	   *
	   * @see {@link DataTables/TableColumn#tooltipLabel}
	   */
	  tooltipLabel: _propTypes2.default.string,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   *
	   * @see {@link DataTables/TableColumn#tooltipDelay}
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   *
	   * @see {@link DataTables/TableColumn#tooltipPosition}
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool
	};
	DropdownMenuColumn.defaultProps = {
	  simplifiedMenu: false
	};
	exports.default = (0, _withTableFixes2.default)(DropdownMenuColumn, 'menu-button');
	//# sourceMappingURL=DropdownMenuColumn.js.map

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _AccessibleFakeButton = __webpack_require__(50);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	var _Layover = __webpack_require__(70);
	
	var _Layover2 = _interopRequireDefault(_Layover);
	
	var _Dialog = __webpack_require__(88);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditDialog = function (_PureComponent) {
	  _inherits(EditDialog, _PureComponent);
	
	  function EditDialog() {
	    _classCallCheck(this, EditDialog);
	
	    return _possibleConstructorReturn(this, (EditDialog.__proto__ || Object.getPrototypeOf(EditDialog)).apply(this, arguments));
	  }
	
	  _createClass(EditDialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          dialogStyle = _props.dialogStyle,
	          dialogClassName = _props.dialogClassName,
	          dialogContentStyle = _props.dialogContentStyle,
	          dialogContentClassName = _props.dialogContentClassName,
	          textFieldId = _props.textFieldId,
	          visible = _props.visible,
	          header = _props.header,
	          onOpen = _props.onOpen,
	          children = _props.children,
	          label = _props.label,
	          title = _props.title,
	          large = _props.large,
	          actions = _props.actions,
	          placeholder = _props.placeholder,
	          dialogZDepth = _props.dialogZDepth,
	          props = _objectWithoutProperties(_props, ['id', 'dialogStyle', 'dialogClassName', 'dialogContentStyle', 'dialogContentClassName', 'textFieldId', 'visible', 'header', 'onOpen', 'children', 'label', 'title', 'large', 'actions', 'placeholder', 'dialogZDepth']);
	
	      var field = _react2.default.createElement(
	        _AccessibleFakeButton2.default,
	        {
	          className: (0, _classnames2.default)('md-edit-dialog__label', {
	            'md-edit-dialog__header': header
	          }, (0, _themeColors2.default)({ hint: placeholder || header })),
	          noFocusOutline: visible,
	          onClick: onOpen,
	          onFocus: onOpen
	        },
	        label
	      );
	
	      return _react2.default.createElement(
	        _Layover2.default,
	        _extends({}, props, {
	          id: id + '-layover',
	          toggle: field,
	          visible: visible,
	          block: true,
	          belowAnchor: null
	        }),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            id: id,
	            'aria-labelledby': !large ? textFieldId : undefined,
	            style: dialogStyle,
	            className: (0, _classnames2.default)('md-edit-dialog', (0, _themeColors2.default)({ background: true, themeText: false }), dialogClassName),
	            contentStyle: dialogContentStyle,
	            contentClassName: (0, _classnames2.default)('md-edit-dialog__content', dialogContentClassName),
	            title: large ? title : null,
	            focusOnMount: true,
	            containFocus: !!large,
	            paddedContent: false,
	            actions: large ? actions : null,
	            zDepth: dialogZDepth
	          },
	          children
	        )
	      );
	    }
	  }]);
	
	  return EditDialog;
	}(_react.PureComponent);
	
	EditDialog.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  textFieldId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  dialogStyle: _propTypes2.default.object,
	  dialogClassName: _propTypes2.default.string,
	  dialogContentStyle: _propTypes2.default.object,
	  dialogContentClassName: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  onOpen: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  visible: _propTypes2.default.bool.isRequired,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  placeholder: _propTypes2.default.bool,
	  title: _propTypes2.default.node,
	  large: _propTypes2.default.bool,
	  actions: _Dialog2.default.propTypes.actions,
	  dialogZDepth: _propTypes2.default.number,
	  header: _propTypes2.default.bool
	};
	exports.default = EditDialog;
	//# sourceMappingURL=EditDialog.js.map

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(9);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _viewport = __webpack_require__(172);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _anchorShape = __webpack_require__(31);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(32);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Layover = __webpack_require__(70);
	
	var _Layover2 = _interopRequireDefault(_Layover);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _TextField = __webpack_require__(48);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _TableColumn = __webpack_require__(43);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	var _EditDialog = __webpack_require__(251);
	
	var _EditDialog2 = _interopRequireDefault(_EditDialog);
	
	var _findTable = __webpack_require__(68);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	var _findFixedTo = __webpack_require__(135);
	
	var _findFixedTo2 = _interopRequireDefault(_findFixedTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `EditDialogColumn` is used when there should be used when a table column's value
	 * can be changed. It can either be displayed as a dialog or inline.
	 *
	 * All props that are not documented but provided will be passed on to the `TextField`
	 * component.
	 */
	var EditDialogColumn = function (_PureComponent) {
	  _inherits(EditDialogColumn, _PureComponent);
	
	  function EditDialogColumn(props) {
	    _classCallCheck(this, EditDialogColumn);
	
	    var _this = _possibleConstructorReturn(this, (EditDialogColumn.__proto__ || Object.getPrototypeOf(EditDialogColumn)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      visible: props.defaultVisible,
	      value: props.defaultValue,
	      cancelValue: props.defaultValue,
	      actions: _this._makeActions(props),
	      cellIndex: undefined
	    };
	    return _this;
	  }
	
	  _createClass(EditDialogColumn, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._column = (0, _reactDom.findDOMNode)(this);
	      this._table = (0, _findTable2.default)(this._column);
	      this._fixedTo = (0, _findFixedTo2.default)(this._table);
	
	      // If a developer creates their own component to wrap the EditDialogColumn, the cellIndex prop
	      // might not be defined if they don't pass ...props
	      var cellIndex = this.props.cellIndex;
	
	      if (!cellIndex && cellIndex !== 0) {
	        var columns = [].slice.call(this._column.parentNode.querySelectorAll('th,td'));
	        this.setState({ cellIndex: columns.indexOf(this._column) }); // eslint-disable-line react/no-did-mount-set-state
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          okLabel = _props.okLabel,
	          okPrimary = _props.okPrimary,
	          okSecondary = _props.okSecondary,
	          okProps = _props.okProps,
	          cancelLabel = _props.cancelLabel,
	          cancelPrimary = _props.cancelPrimary,
	          cancelSecondary = _props.cancelSecondary,
	          cancelProps = _props.cancelProps;
	
	
	      if (okLabel !== nextProps.okLabel || okPrimary !== nextProps.okPrimary || okSecondary !== nextProps.okSecondary || cancelLabel !== nextProps.cancelLabel || cancelPrimary !== nextProps.cancelPrimary || cancelSecondary !== nextProps.cancelSecondary || okProps !== nextProps.okProps || cancelProps !== nextProps.cancelProps) {
	        this.setState({ actions: this._makeActions(nextProps) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var rowId = this.context.rowId;
	
	      var _props2 = this.props,
	          style = _props2.style,
	          className = _props2.className,
	          layoverStyle = _props2.layoverStyle,
	          layoverClassName = _props2.layoverClassName,
	          dialogStyle = _props2.dialogStyle,
	          dialogClassName = _props2.dialogClassName,
	          dialogContentStyle = _props2.dialogContentStyle,
	          dialogContentClassName = _props2.dialogContentClassName,
	          dialogZDepth = _props2.dialogZDepth,
	          textFieldStyle = _props2.textFieldStyle,
	          textFieldClassName = _props2.textFieldClassName,
	          inputClassName = _props2.inputClassName,
	          large = _props2.large,
	          title = _props2.title,
	          inline = _props2.inline,
	          inlineIcon = _props2.inlineIcon,
	          maxLength = _props2.maxLength,
	          label = _props2.label,
	          placeholder = _props2.placeholder,
	          header = _props2.header,
	          anchor = _props2.anchor,
	          belowAnchor = _props2.belowAnchor,
	          fixedTo = _props2.fixedTo,
	          animationPosition = _props2.animationPosition,
	          xThreshold = _props2.xThreshold,
	          yThreshold = _props2.yThreshold,
	          centered = _props2.centered,
	          sameWidth = _props2.sameWidth,
	          repositionOnScroll = _props2.repositionOnScroll,
	          repositionOnResize = _props2.repositionOnResize,
	          transitionName = _props2.transitionName,
	          transitionEnterTimeout = _props2.transitionEnterTimeout,
	          transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	          tooltipLabel = _props2.tooltipLabel,
	          tooltipDelay = _props2.tooltipDelay,
	          tooltipPosition = _props2.tooltipPosition,
	          onClick = _props2.onClick,
	          onMouseDown = _props2.onMouseDown,
	          onMouseUp = _props2.onMouseUp,
	          onTouchStart = _props2.onTouchStart,
	          onTouchEnd = _props2.onTouchEnd,
	          onMouseEnter = _props2.onMouseEnter,
	          onMouseOver = _props2.onMouseOver,
	          onMouseLeave = _props2.onMouseLeave,
	          onTouchMove = _props2.onTouchMove,
	          simplifiedDialog = _props2.simplifiedDialog,
	          minLeft = _props2.minLeft,
	          minRight = _props2.minRight,
	          minBottom = _props2.minBottom,
	          noIcon = _props2.noIcon,
	          inlineIconChildren = _props2.inlineIconChildren,
	          inlineIconClassName = _props2.inlineIconClassName,
	          propId = _props2.id,
	          propDialogId = _props2.dialogId,
	          propCellIndex = _props2.cellIndex,
	          onOkClick = _props2.onOkClick,
	          okLabel = _props2.okLabel,
	          okPrimary = _props2.okPrimary,
	          okSecondary = _props2.okSecondary,
	          okProps = _props2.okProps,
	          onCancelClick = _props2.onCancelClick,
	          cancelLabel = _props2.cancelLabel,
	          cancelPrimary = _props2.cancelPrimary,
	          cancelSecondary = _props2.cancelSecondary,
	          cancelProps = _props2.cancelProps,
	          okOnOutsideClick = _props2.okOnOutsideClick,
	          defaultValue = _props2.defaultValue,
	          adjusted = _props2.adjusted,
	          scrollIntoView = _props2.scrollIntoView,
	          scrollIntoViewPadding = _props2.scrollIntoViewPadding,
	          defaultVisible = _props2.defaultVisible,
	          visibleOnFocus = _props2.visibleOnFocus,
	          scrollThreshold = _props2.scrollThreshold,
	          enforceMinWidth = _props2.enforceMinWidth,
	          transitionDuration = _props2.transitionDuration,
	          props = _objectWithoutProperties(_props2, ['style', 'className', 'layoverStyle', 'layoverClassName', 'dialogStyle', 'dialogClassName', 'dialogContentStyle', 'dialogContentClassName', 'dialogZDepth', 'textFieldStyle', 'textFieldClassName', 'inputClassName', 'large', 'title', 'inline', 'inlineIcon', 'maxLength', 'label', 'placeholder', 'header', 'anchor', 'belowAnchor', 'fixedTo', 'animationPosition', 'xThreshold', 'yThreshold', 'centered', 'sameWidth', 'repositionOnScroll', 'repositionOnResize', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition', 'onClick', 'onMouseDown', 'onMouseUp', 'onTouchStart', 'onTouchEnd', 'onMouseEnter', 'onMouseOver', 'onMouseLeave', 'onTouchMove', 'simplifiedDialog', 'minLeft', 'minRight', 'minBottom', 'noIcon', 'inlineIconChildren', 'inlineIconClassName', 'id', 'dialogId', 'cellIndex', 'onOkClick', 'okLabel', 'okPrimary', 'okSecondary', 'okProps', 'onCancelClick', 'cancelLabel', 'cancelPrimary', 'cancelSecondary', 'cancelProps', 'okOnOutsideClick', 'defaultValue', 'adjusted', 'scrollIntoView', 'scrollIntoViewPadding', 'defaultVisible', 'visibleOnFocus', 'scrollThreshold', 'enforceMinWidth', 'transitionDuration']);
	
	      var _state = this.state,
	          visible = _state.visible,
	          actions = _state.actions;
	
	      var value = (0, _getField2.default)(this.props, this.state, 'value');
	      var cellIndex = (0, _getField2.default)(this.props, this.state, 'cellIndex');
	
	      var _props3 = this.props,
	          id = _props3.id,
	          dialogId = _props3.dialogId;
	
	      if (!dialogId) {
	        dialogId = (id || rowId + '-' + cellIndex) + '-edit-dialog';
	      }
	
	      if (!id) {
	        id = dialogId + '-field';
	      }
	
	      var inlineEditIcon = void 0;
	      if (inline && !noIcon) {
	        var icon = (0, _getDeprecatedIcon2.default)(inlineIconClassName, inlineIconChildren, inlineIcon);
	        if (icon) {
	          inlineEditIcon = _react2.default.cloneElement(icon, { key: 'edit-icon' });
	        }
	      }
	
	      var numeric = props.type === 'number';
	      var field = _react2.default.createElement(_TextField2.default, _extends({}, props, {
	        ref: this._setField,
	        style: textFieldStyle,
	        className: (0, _classnames2.default)({ 'md-edit-dialog__blocked-field': inline }, textFieldClassName),
	        inputClassName: (0, _classnames2.default)({
	          'md-edit-dialog__header': header && inline,
	          'md-text-right': numeric
	        }, (0, _themeColors2.default)({ hint: header && inline }), inputClassName),
	        id: id,
	        label: label,
	        placeholder: placeholder,
	        value: value,
	        onFocus: this._handleFocus,
	        onChange: this._handleChange,
	        onKeyDown: this._handleKeyDown,
	        block: inline,
	        maxLength: visible ? maxLength : null,
	        rightIcon: inlineEditIcon
	      }));
	
	      var children = void 0;
	      if (inline) {
	        children = field;
	      } else {
	        var dialogLabel = value || value === 0 ? value : placeholder || label;
	        children = _react2.default.createElement(
	          _EditDialog2.default,
	          {
	            style: layoverStyle,
	            className: layoverClassName,
	            dialogStyle: dialogStyle,
	            dialogClassName: dialogClassName,
	            dialogContentStyle: dialogContentStyle,
	            dialogContentClassName: dialogContentClassName,
	            id: dialogId,
	            textFieldId: id,
	            visible: visible,
	            onOpen: this._handleOpen,
	            onClose: this._handleClose,
	            label: dialogLabel,
	            actions: actions,
	            large: large,
	            title: title,
	            header: header,
	            placeholder: dialogLabel === placeholder || dialogLabel === label,
	            simplified: simplifiedDialog,
	            anchor: anchor,
	            belowAnchor: belowAnchor,
	            animationPosition: animationPosition,
	            xThreshold: xThreshold,
	            yThreshold: yThreshold,
	            centered: centered,
	            sameWidth: sameWidth,
	            minLeft: minLeft,
	            minRight: minRight,
	            minBottom: minBottom,
	            fixedTo: typeof fixedTo !== 'undefined' ? fixedTo : this._fixedTo,
	            dialogZDepth: dialogZDepth,
	            repositionOnScroll: repositionOnScroll,
	            repositionOnResize: repositionOnResize,
	            transitionName: transitionName,
	            transitionEnterTimeout: transitionEnterTimeout,
	            transitionLeaveTimeout: transitionLeaveTimeout
	          },
	          field
	        );
	      }
	
	      return _react2.default.createElement(
	        _TableColumn2.default,
	        {
	          style: style,
	          numeric: numeric,
	          className: (0, _classnames2.default)('md-edit-dialog-column', className),
	          header: header,
	          adjusted: false,
	          tooltipLabel: tooltipLabel,
	          tooltipDelay: tooltipDelay,
	          tooltipPosition: tooltipPosition,
	          onClick: onClick,
	          onMouseDown: onMouseDown,
	          onMouseUp: onMouseUp,
	          onTouchStart: onTouchStart,
	          onTouchMove: onTouchMove,
	          onMouseEnter: onMouseEnter,
	          onMouseOver: onMouseOver,
	          onMouseLeave: onMouseLeave,
	          onTouchEnd: onTouchEnd
	        },
	        children
	      );
	    }
	  }]);
	
	  return EditDialogColumn;
	}(_react.PureComponent);
	
	EditDialogColumn.VerticalAnchors = _Layover2.default.VerticalAnchors;
	EditDialogColumn.HorizontalAnchors = _Layover2.default.HorizontalAnchors;
	EditDialogColumn.Positions = _Layover2.default.Positions;
	EditDialogColumn.propTypes = {
	  /**
	   * An optional id to use for the text field in the column. If this is omitted,
	   * the id will be `${dialogId}-field`.
	   *
	   * @see {@link #dialogId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to use for the dialog that appears in the column. If this is omitted,
	   * the id will be `${rowId}-${cellIndex}-edit-dialog-field`.
	   */
	  dialogId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The optional style to apply to the edit dialog's column.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * The optional className to apply to the edit dialog's column.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's surrounding `Layover` component.
	   */
	  layoverStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to the dialog's surrounding `Layover` component.
	   */
	  layoverClassName: _propTypes2.default.string,
	
	  /**
	   * The optional style to apply to the edit dialog.
	   */
	  dialogStyle: _propTypes2.default.object,
	
	  /**
	   * The optional className to apply to the edit dialog.
	   */
	  dialogClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's content area. This is the area
	   * that holds the text field.
	   */
	  dialogContentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the dialog's content area. This is the area
	   * that holds the text field.
	   */
	  dialogContentClassName: _propTypes2.default.string,
	
	  /**
	   * The zDepth to apply to the dialog when not inline.
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  dialogZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional style to apply to the text field.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the text field.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the text field's input.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the text field's input.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the edit dialog is currently disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field should be editable inline instead of in a dialog.
	   *
	   * @see {@link #inlineIcon}
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to set for the inline edit dialog column. Setting this prop to null
	   * will not render an icon.
	   */
	  inlineIcon: _propTypes2.default.element,
	
	  /**
	   * The default value to use for the text field.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * A value to use for the edit dialog text field. This will make the component controlled
	   * so you will need to provide an `onChange` function.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional function to call when the text field's value has changed. This is required
	   * if the `value` prop has been defined.
	   *
	   * @see {@link TextFields/TextField#onChange}
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the keydown event is triggered on the text field.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional label for the text field. When displaying an `inline` edit dialog column,
	   * the `placeholder` prop should be used instead. This is because the text field changes
	   * to the `block` type when `inline`.
	   *
	   * @see {@link #inline}
	   * @see {@link #placeholder}
	   * @see {@link TextFields/TextField#block}
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder for the text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * Boolean if the edit dialog should become a large dialog. When the dialog is large,
	   * the `title` prop is required.
	   *
	   * A large dialog has a Title followed by the text field, and then a cancel and ok action
	   * buttons below.
	   */
	  large: _propTypes2.default.bool,
	
	  /**
	   * The title to use for the large edit dialog. This prop is required if the `large` prop
	   * is enabled.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * An optional `maxLength` to apply to the text field.
	   *
	   * @see {@link TextFields/TextField#maxLength}
	   */
	  maxLength: _propTypes2.default.number,
	
	  /**
	   * An optional function to call when the "Ok" button has been clicked, the user presses enter
	   * on * the text field or when the `okOnOutsideClick` prop has been enabled and the user clicks
	   * somewhere on the page.
	   *
	   * The callback will include the current value and the click or keypress event.
	   * ```js
	   * onOkClick(value, event)
	   * ```
	   *
	   * @see {@link #large}
	   */
	  onOkClick: _propTypes2.default.func,
	
	  /**
	   * The label to use for the "Ok" button in large dialogs.
	   *
	   * @see {@link #large}
	   */
	  okLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the "Ok" button in large dialogs should be styled with the primary color.
	   * To get a `default` styled button, set both `okPrimary` and `okSecondary` (or omit `okSecondary`)
	   * to `false`.
	   *
	   * @see {@link #large}
	   * @see {@link #okSecondary}
	   */
	  okPrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the "Ok" button in large dialogs should be styled with the secondary color.
	   *
	   * @see {@link #large}
	   * @see {@link #okPrimary}
	   */
	  okSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to apply to the "Ok" button. This will override any of the other
	   * button props.
	   *
	   * @see {@link #okLabel}
	   * @see {@link #okPrimary}
	   * @see {@link #okSecondary}
	   */
	  okProps: _propTypes2.default.object,
	
	  /**
	   * An optional function to call when the "Cancel" button has been clicked in large edit dialogs.
	   * The callback will include the text field's value before any edits occurred and the click event.
	   *
	   * ```js
	   * onCancelClick(previousValue, event)
	   * ```
	   *
	   * @see {@link #large}
	   */
	  onCancelClick: _propTypes2.default.func,
	
	  /**
	   * The label to give to the "Cancel" button in large edit dialogs.
	   *
	   * @see {@link #large}
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the "Cancel" button in large dialogs should be styled with the primary color.
	   * To get a `default` styled button, set both `cancelPrimary` and `cancelSecondary` (or
	   * omit `cancelSecondary`) to `false`.
	   *
	   * @see {@link #large}
	   * @see {@link #cancelSecondary}
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the "Cancel" button in large dialogs should be styled with the secondary color.
	   *
	   * @see {@link #large}
	   * @see {@link #cancelPrimary}
	   */
	  cancelSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to apply to the "Cancel" button. This will override any of the other
	   * button props.
	   *
	   * @see {@link #cancelLabel}
	   * @see {@link #cancelPrimary}
	   * @see {@link #cancelSecondary}
	   */
	  cancelProps: _propTypes2.default.object,
	
	  /**
	   * Boolean if the action for clicking somewhere on on the page while the dialog is open
	   * saves the changes or cancels to the previous value before opening the dialog.
	   *
	   * @see {@link #onOkClick}
	   * @see {@link #onCancelClick}
	   */
	  okOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when a user clicks out of the text field.
	   */
	  onOutsideClick: _propTypes2.default.func,
	
	  /**
	   * Boolean if the edit dialog should be closed if the user clicks somewhere else on the page
	   * while the dialog is open.
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Edit Dialog should be visible by default. This only applies when the `inline` prop
	   * is not enabled.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the edit dialog should automatically open when the text field is focused for non-inline
	   * dialogs. This is enabled by default for backwards compatibility.
	   */
	  visibleOnFocus: _propTypes2.default.bool,
	
	  /**
	   * The type for the text field in the edit dialog.
	   *
	   * @see {@link TextFields/TextField#type}
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * This is how the dialog gets "anchored" to the table column.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position to use for the dialog.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  animationPosition: _positionShape2.default,
	
	  /**
	   * This is how the dialog should be fixed within the table. When this is omitted, it will
	   * automatically use the responsive table as the fixture so that the dialog will close/adjust itself
	   * to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * The optional tooltip to render on hover.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the dialog.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedDialog: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _Layover2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _Layover2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _Layover2.default.propTypes.minBottom,
	
	  /**
	   * Boolean if the edit dialog should attempt to scroll into view if the full
	   * dialog can not be displayed in the viewport when it was toggled open.
	   *
	   * @see {@link #scrollIntoViewPadding}
	   */
	  scrollIntoView: _propTypes2.default.bool,
	
	  /**
	   * The amount of padding that should be applied when the cell is scrolled into view.
	   * This will be applied to the left of the cell.
	   */
	  scrollIntoViewPadding: _propTypes2.default.number,
	
	  /**
	   * An optional function to call when the `click` event is triggered in the column.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousedown` event is triggered in the column.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseup` event is triggered in the column.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchstart` event is triggered in the column.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchend` event is triggered in the column.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseenter` event is triggered in the column.
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseover` event is triggered in the column.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseleave` event is triggered in the column.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchmove` event is triggered in the column.
	   */
	  onTouchMove: _propTypes2.default.func,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * This is injected by the `TableRow` component and used to help generate the unique id for the text
	   * field.
	   *
	   * @access private
	   */
	  cellIndex: _propTypes2.default.number,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool,
	
	  inlineIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `inlineIcon` prop instead'),
	  inlineIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `inlineIcon` prop instead'),
	  noIcon: (0, _deprecated2.default)(_propTypes2.default.bool, 'Set the `inlineIcon` prop to `null` instead'),
	  enforceMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'The min width will always be enforced based on the `$md-edit-dialog-min-width` Sass variable.'),
	  scrollThreshold: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `xThreshold` and `yThreshold` instead'),
	  transitionDuration: (0, _deprecated2.default)(_propTypes2.default.number, 'use `transitionEnterTimeout` and `transitionLeaveTimeout` instead')
	};
	EditDialogColumn.defaultProps = {
	  type: 'text',
	  defaultValue: '',
	  okOnOutsideClick: true,
	  inlineIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'edit'
	  ),
	  okLabel: 'Save',
	  okPrimary: true,
	  cancelLabel: 'Cancel',
	  cancelPrimary: true,
	  animationPosition: EditDialogColumn.Positions.BELOW,
	  dialogZDepth: 1,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  scrollIntoView: true,
	  scrollIntoViewPadding: 16,
	  minLeft: 0,
	  minRight: 0,
	  minBottom: 0,
	  visibleOnFocus: true,
	  defaultVisible: false
	};
	EditDialogColumn.contextTypes = {
	  rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setField = function (field) {
	    _this2._field = field;
	  };
	
	  this._makeActions = function (props) {
	    var okLabel = props.okLabel,
	        okPrimary = props.okPrimary,
	        okSecondary = props.okSecondary,
	        okProps = props.okProps,
	        cancelLabel = props.cancelLabel,
	        cancelPrimary = props.cancelPrimary,
	        cancelSecondary = props.cancelSecondary,
	        cancelProps = props.cancelProps;
	
	
	    return [_extends({
	      key: 'cancel',
	      children: cancelLabel,
	      primary: cancelPrimary && !cancelSecondary,
	      secondary: cancelSecondary
	    }, cancelProps, {
	      onClick: _this2._handleCancel
	    }), _extends({
	      key: 'ok',
	      children: okLabel,
	      primary: okPrimary && !okSecondary,
	      secondary: okSecondary
	    }, okProps, {
	      onClick: _this2._handleOk
	    })];
	  };
	
	  this._handleOpen = function (e) {
	    if (_this2._skipNextOpen) {
	      _this2._skipNextOpen = false;
	    } else if (_this2.props.visibleOnFocus || !e || e.type !== 'focus') {
	      var _props4 = _this2.props,
	          scrollIntoView = _props4.scrollIntoView,
	          scrollIntoViewPadding = _props4.scrollIntoViewPadding;
	
	      if (scrollIntoView) {
	        var vp = (0, _viewport2.default)(_this2._column);
	        if (vp !== true && _this2._table && _this2._column && !_this2.props.inline) {
	          _this2._table.scrollLeft = _this2._column.offsetLeft - scrollIntoViewPadding;
	        }
	      }
	
	      _this2.setState({ visible: true, cancelValue: (0, _getField2.default)(_this2.props, _this2.state, 'value') });
	    }
	  };
	
	  this._handleClose = function (e) {
	    var _props5 = _this2.props,
	        onOutsideClick = _props5.onOutsideClick,
	        okOnOutsideClick = _props5.okOnOutsideClick;
	
	    if (onOutsideClick) {
	      onOutsideClick(e);
	    }
	
	    if (okOnOutsideClick) {
	      _this2._handleOk(e);
	    } else {
	      _this2._handleCancel(e);
	    }
	  };
	
	  this._handleChange = function (value, e) {
	    if (_this2.props.onChange) {
	      _this2.props.onChange(value, e);
	    }
	
	    if (typeof _this2.props.value === 'undefined') {
	      _this2.setState({ value: value });
	    }
	  };
	
	  this._handleFocus = function (e) {
	    if (_this2.props.onFocus) {
	      _this2.props.onFocus(e);
	    }
	
	    if (_this2.props.inline) {
	      _this2.setState({ cancelValue: e.target.value });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    var _props6 = _this2.props,
	        onKeyDown = _props6.onKeyDown,
	        okOnOutsideClick = _props6.okOnOutsideClick,
	        large = _props6.large;
	
	    if (onKeyDown) {
	      onKeyDown(e);
	    }
	
	    var key = e.which || e.keyCode;
	    if (key === _keyCodes.ENTER) {
	      _this2._handleOk(e);
	    } else if (key === _keyCodes.ESC) {
	      _this2._handleCancel(e);
	    } else if (key === _keyCodes.TAB && !large) {
	      // infinitely opens otherwise...
	      _this2._skipNextOpen = e.shiftKey;
	
	      if (okOnOutsideClick) {
	        _this2._handleOk(e);
	      } else {
	        _this2._handleCancel(e);
	      }
	    }
	  };
	
	  this._handleOk = function (e) {
	    if (_this2.props.onOkClick) {
	      _this2.props.onOkClick((0, _getField2.default)(_this2.props, _this2.state, 'value'), e);
	    }
	
	    _this2.setState({ visible: false });
	  };
	
	  this._handleCancel = function (e) {
	    var value = _this2.state.cancelValue;
	    if (_this2.props.onCancelClick) {
	      _this2.props.onCancelClick(value, e);
	    }
	
	    var state = { visible: false };
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    _this2.setState(state);
	  };
	};
	
	exports.default = EditDialogColumn;
	//# sourceMappingURL=EditDialogColumn.js.map

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _withTableFixes = __webpack_require__(87);
	
	var _withTableFixes2 = _interopRequireDefault(_withTableFixes);
	
	var _MenuButton = __webpack_require__(149);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _TableColumn = __webpack_require__(43);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuButtonColumn = function (_PureComponent) {
	  _inherits(MenuButtonColumn, _PureComponent);
	
	  function MenuButtonColumn() {
	    _classCallCheck(this, MenuButtonColumn);
	
	    return _possibleConstructorReturn(this, (MenuButtonColumn.__proto__ || Object.getPrototypeOf(MenuButtonColumn)).apply(this, arguments));
	  }
	
	  _createClass(MenuButtonColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          menuStyle = _props.menuStyle,
	          menuClassName = _props.menuClassName,
	          header = _props.header,
	          adjusted = _props.adjusted,
	          tooltipLabel = _props.tooltipLabel,
	          tooltipDelay = _props.tooltipDelay,
	          tooltipPosition = _props.tooltipPosition,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'header', 'adjusted', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition']);
	
	      return _react2.default.createElement(
	        _TableColumn2.default,
	        {
	          style: style,
	          className: className,
	          header: header,
	          adjusted: adjusted,
	          tooltipLabel: tooltipLabel,
	          tooltipDelay: tooltipDelay,
	          tooltipPosition: tooltipPosition
	        },
	        _react2.default.createElement(_MenuButton2.default, _extends({}, props, { style: menuStyle, className: menuClassName }))
	      );
	    }
	  }]);
	
	  return MenuButtonColumn;
	}(_react.PureComponent);
	
	MenuButtonColumn.Positions = _MenuButton2.default.Positions;
	MenuButtonColumn.HorizontalAnchors = _MenuButton2.default.HorizontalAnchors;
	MenuButtonColumn.VerticalAnchors = _MenuButton2.default.VerticalAnchors;
	MenuButtonColumn.propTypes = {
	  /**
	   * An optional id to use for the menu button in the column. If this is omitted, it's value will be
	   * `${rowId}-${cellIndex}-menu-button`
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * This is the optional style to apply to the `TableColumn`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * This is the optional className to apply to the `TableColumn`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The is the optional style to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/MenuButton#style}
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * The is the optional class name to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/MenuButton#className}
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * This is how the select field should be fixed within the table. When this is omitted,
	   * it will automatically use the responsive table as the fixture so that the select field
	   * will close/adjust itself to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * The optional tooltip to render on hover.
	   *
	   * @see {@link DataTables/TableColumn#tooltipLabel}
	   */
	  tooltipLabel: _propTypes2.default.string,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   *
	   * @see {@link DataTables/TableColumn#tooltipDelay}
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   *
	   * @see {@link DataTables/TableColumn#tooltipPosition}
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool
	};
	MenuButtonColumn.defaultProps = {
	  simplifiedMenu: false
	};
	exports.default = (0, _withTableFixes2.default)(MenuButtonColumn, 'menu-button');
	//# sourceMappingURL=MenuButtonColumn.js.map

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _fixedToShape = __webpack_require__(18);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(32);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _SelectField = __webpack_require__(96);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _withTableFixes = __webpack_require__(87);
	
	var _withTableFixes2 = _interopRequireDefault(_withTableFixes);
	
	var _TableColumn = __webpack_require__(43);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `SelectFieldColumn` component is just a simple wrapper between a `SelectField` and
	 * the `TableColumn` components.
	 *
	 * All props that are on the `SelectField` are also available here (except the naming of style or className).
	 * See the [SelectField](/components/select-fields?tab=1#select-field-proptypes) for remaining prop descriptions.
	 */
	var SelectFieldColumn = function (_PureComponent) {
	  _inherits(SelectFieldColumn, _PureComponent);
	
	  function SelectFieldColumn() {
	    _classCallCheck(this, SelectFieldColumn);
	
	    return _possibleConstructorReturn(this, (SelectFieldColumn.__proto__ || Object.getPrototypeOf(SelectFieldColumn)).apply(this, arguments));
	  }
	
	  _createClass(SelectFieldColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          menuStyle = _props.menuStyle,
	          menuClassName = _props.menuClassName,
	          header = _props.header,
	          tooltipLabel = _props.tooltipLabel,
	          tooltipDelay = _props.tooltipDelay,
	          tooltipPosition = _props.tooltipPosition,
	          adjusted = _props.adjusted,
	          wrapperStyle = _props.wrapperStyle,
	          wrapperClassName = _props.wrapperClassName,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'header', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition', 'adjusted', 'wrapperStyle', 'wrapperClassName']);
	
	      return _react2.default.createElement(
	        _TableColumn2.default,
	        {
	          header: header,
	          style: style,
	          className: (0, _classnames2.default)('md-select-field-column', className),
	          adjusted: false,
	          tooltipLabel: tooltipLabel,
	          tooltipDelay: tooltipDelay,
	          tooltipPosition: tooltipPosition
	        },
	        _react2.default.createElement(_SelectField2.default, _extends({}, props, { style: menuStyle, className: menuClassName }))
	      );
	    }
	  }]);
	
	  return SelectFieldColumn;
	}(_react.PureComponent);
	
	SelectFieldColumn.VerticalAnchors = _SelectField2.default.VerticalAnchors;
	SelectFieldColumn.HorizontalAnchors = _SelectField2.default.HorizontalAnchors;
	SelectFieldColumn.Positions = _SelectField2.default.Positions;
	SelectFieldColumn.propTypes = {
	  /**
	   * An optional id to use for the select field in the column. If this is omitted, it's value will be
	   * `${rowId}-${cellIndex}-select-field`
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * This is the optional style to apply to the `TableColumn`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * This is the optional className to apply to the `TableColumn`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The is the optional style to apply to the select field's menu container.
	   *
	   * @see {@link SelectFields/SelectField#style}
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * The is the optional class name to apply to the select field's menu container.
	   *
	   * @see {@link SelectFields/SelectField#className}
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * This is how the select field should be fixed within the table. When this is omitted,
	   * it will automatically use the responsive table as the fixture so that the select field
	   * will close/adjust itself to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Boolean if the select field should span the entire width of the column.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The position for the select field.
	   *
	   * @see {@link SelectFields/SelectField#position}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool,
	
	  /**
	   * The optional tooltip to render on hover.
	   *
	   * @see {@link DataTables/TableColumn#tooltipLabel}
	   */
	  tooltipLabel: _propTypes2.default.string,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   *
	   * @see {@link DataTables/TableColumn#tooltipDelay}
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   *
	   * @see {@link DataTables/TableColumn#tooltipPosition}
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  wrapperStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'There is no longer a wrapper'),
	  wrapperClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'There is no longer a wrapper')
	};
	SelectFieldColumn.defaultProps = {
	  position: SelectFieldColumn.Positions.BELOW,
	  fullWidth: true,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  simplifiedMenu: false
	};
	exports.default = (0, _withTableFixes2.default)(SelectFieldColumn, 'select-field');
	//# sourceMappingURL=SelectFieldColumn.js.map

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _contextTypes = __webpack_require__(67);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TableBody` component is used for managing the state of all
	 * `TableRow` inside of it.
	 */
	var TableBody = function (_Component) {
	  _inherits(TableBody, _Component);
	
	  function TableBody() {
	    _classCallCheck(this, TableBody);
	
	    return _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).apply(this, arguments));
	  }
	
	  _createClass(TableBody, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var selectedRows = this.context.selectedRows;
	
	
	      var rows = children ? _react.Children.map(_react.Children.toArray(children), function (row, i) {
	        var uncontrolled = typeof row.props.selected === 'undefined';
	        return _react2.default.cloneElement(row, {
	          selected: uncontrolled ? selectedRows[i] : row.props.selected
	        });
	      }) : null;
	
	      return _react2.default.createElement(
	        'tbody',
	        _extends({}, props, { className: (0, _classnames2.default)('md-table-body', className) }),
	        rows
	      );
	    }
	  }]);
	
	  return TableBody;
	}(_react.Component);
	
	TableBody.propTypes = {
	  /**
	   * An optional style to apply to the tbody.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the tbody.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A list or a single item of `TableRow` components to render.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
	};
	TableBody.contextTypes = _contextTypes2.default;
	exports.default = TableBody;
	//# sourceMappingURL=TableBody.js.map

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroupTick = __webpack_require__(30);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _oneRequired = __webpack_require__(173);
	
	var _oneRequired2 = _interopRequireDefault(_oneRequired);
	
	var _invalidIf = __webpack_require__(37);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _CardTitleBlock = __webpack_require__(132);
	
	var _CardTitleBlock2 = _interopRequireDefault(_CardTitleBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TableCardHeader` is used when contextual actions should appear when
	 * a user selects a row.
	 */
	var TableCardHeader = function (_PureComponent) {
	  _inherits(TableCardHeader, _PureComponent);
	
	  function TableCardHeader(props) {
	    _classCallCheck(this, TableCardHeader);
	
	    var _this = _possibleConstructorReturn(this, (TableCardHeader.__proto__ || Object.getPrototypeOf(TableCardHeader)).call(this, props));
	
	    _this.state = { animating: false };
	    return _this;
	  }
	
	  _createClass(TableCardHeader, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var visible = this.props.visible;
	      var nVisible = nextProps.visible,
	          transitionEnterTimeout = nextProps.transitionEnterTimeout,
	          transitionLeaveTimeout = nextProps.transitionLeaveTimeout;
	
	      var timeout = !nVisible ? transitionLeaveTimeout : transitionEnterTimeout;
	      if (visible !== nVisible) {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	
	        this._timeout = setTimeout(function () {
	          _this2._timeout = setTimeout(function () {
	            _this2._timeout = null;
	            _this2.setState({ animating: false });
	          }, timeout);
	        }, _CSSTransitionGroupTick2.default);
	
	        if (!this.state.animating) {
	          this.setState({ animating: true });
	        }
	      }
	    }
	  }, {
	    key: '_cloneCellRight',
	    value: function _cloneCellRight(noAdjust, children) {
	      if (noAdjust || !children) {
	        return children;
	      }
	
	      return _react.Children.map(_react.Children.toArray(children), function (child, i) {
	        if (i === 0) {
	          return (0, _react.cloneElement)(child, { className: (0, _classnames2.default)('md-cell--right', child.props.className) });
	        }
	
	        return child;
	      });
	    }
	  }, {
	    key: '_cloneLeftChildren',
	    value: function _cloneLeftChildren(noClone, children) {
	      if (noClone || !children) {
	        return children;
	      }
	
	      return _react.Children.map(_react.Children.toArray(children), function (child) {
	        return (0, _react.cloneElement)(child, {
	          className: (0, _classnames2.default)('md-btn--dialog', child.props.className)
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animating = this.state.animating;
	
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          title = _props.title,
	          titleId = _props.titleId,
	          actions = _props.actions,
	          contextualTitleId = _props.contextualTitleId,
	          contextualChildren = _props.contextualChildren,
	          noActionsAdjust = _props.noActionsAdjust,
	          noChildrenAdjust = _props.noChildrenAdjust,
	          noLeftChildrenClone = _props.noLeftChildrenClone,
	          visible = _props.visible,
	          propChildren = _props.children,
	          propLeftChildren = _props.leftChildren,
	          propContextualTitle = _props.contextualTitle,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'title', 'titleId', 'actions', 'contextualTitleId', 'contextualChildren', 'noActionsAdjust', 'noChildrenAdjust', 'noLeftChildrenClone', 'visible', 'children', 'leftChildren', 'contextualTitle']);
	
	      var _props2 = this.props,
	          children = _props2.children,
	          leftChildren = _props2.leftChildren,
	          contextualTitle = _props2.contextualTitle;
	
	      children = this._cloneCellRight(noChildrenAdjust, children);
	      leftChildren = this._cloneLeftChildren(noLeftChildrenClone, leftChildren);
	
	      if (title) {
	        children = _react2.default.createElement(
	          'div',
	          { className: 'md-card-title', key: 'main-title' },
	          _react2.default.createElement(_CardTitleBlock2.default, { id: titleId, title: title }),
	          children
	        );
	      } else if (leftChildren) {
	        leftChildren = _react.Children.toArray(leftChildren);
	
	        if (children) {
	          children = leftChildren.concat(_react.Children.toArray(children));
	        } else {
	          children = leftChildren;
	        }
	      }
	
	      if (contextualTitle) {
	        contextualTitle = _react2.default.createElement(
	          'h2',
	          {
	            id: contextualTitleId,
	            className: 'md-card-title--title md-card-title--title-contextual',
	            tabIndex: contextualTitleId ? -1 : null
	          },
	          contextualTitle
	        );
	      }
	
	      var contextualHeader = _react2.default.createElement(
	        'div',
	        { key: 'contextual-header', className: 'md-card-title md-card-title--contextual' },
	        contextualTitle,
	        contextualChildren,
	        this._cloneCellRight(noActionsAdjust, actions)
	      );
	
	      var mergedStyles = style;
	      if (animating) {
	        mergedStyles = Object.assign({}, style, { overflow: 'hidden' });
	      }
	
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        _extends({}, props, {
	          style: mergedStyles,
	          className: (0, _classnames2.default)('md-table-card-header', {
	            'md-table-card-header--no-title': !title
	          }, className)
	        }),
	        children,
	        visible ? contextualHeader : null
	      );
	    }
	  }]);
	
	  return TableCardHeader;
	}(_react.PureComponent);
	
	TableCardHeader.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The transition name to use when the contextual header appears.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition time to use when the contextual header appears.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition time to use when the contextual header disappears.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional title to display. It is invalid to have both `title` and `leftChildren`
	   * defined as only one will be used.
	   */
	  title: (0, _oneRequired2.default)(_propTypes2.default.node, 'leftChildren', 'children'),
	
	  /**
	   * An optional id to provide to the title.
	   */
	  titleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional title to display in the contextual header. This will get wrapped in an `h2`
	   * tag and additional styles applied.
	   */
	  contextualTitle: _propTypes2.default.node,
	
	  /**
	   * An optional id to provide to the contextual title.
	   */
	  contextualTitleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Any additional children to display in the contextual header. This will be displayed after
	   * the optional `contextualTile` and before the `actions`.
	   */
	  contextualChildren: _propTypes2.default.node,
	
	  /**
	   * An optional button or list of buttons to display instead of a title.
	   */
	  leftChildren: (0, _invalidIf2.default)(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]), 'title'),
	
	  /**
	   * An additional children to display after the `title` or `leftChildren` prop.
	   * This is _normally_ a list of icon button or menu button.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	
	  /**
	   * An optional button/menu button or a list of button/menu button to display in the
	   * contextual header once the user has selected a row or multiple rows.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	
	  /**
	   * Boolean if the `actions` prop should not have each element cloned with additional
	   * class names.
	   */
	  noActionsAdjust: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `children` prop should not have each element cloned with additional
	   * class names.
	   */
	  noChildrenAdjust: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `leftChildren` prop should not have each element cloned with additional
	   * class names.
	   */
	  noLeftChildrenClone: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the contextual header is currently visible.
	   */
	  visible: _propTypes2.default.bool.isRequired
	};
	TableCardHeader.defaultProps = {
	  component: 'header',
	  transitionName: 'md-drop-down',
	  transitionEnterTimeout: 150,
	  transitionLeaveTimeout: 150
	};
	exports.default = TableCardHeader;
	//# sourceMappingURL=TableCardHeader.js.map

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectionControl = __webpack_require__(47);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	var _findTable = __webpack_require__(68);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableCheckbox = function (_Component) {
	  _inherits(TableCheckbox, _Component);
	
	  function TableCheckbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableCheckbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableCheckbox.__proto__ || Object.getPrototypeOf(TableCheckbox)).call.apply(_ref, [this].concat(args))), _this), _this._td = null, _this._header = false, _this._handleMount = function (td) {
	      if (td) {
	        var header = (0, _findTable2.default)(td).querySelector('thead');
	        var index = td.parentNode.rowIndex - (header ? 1 : 0);
	
	        if (td.parentNode.parentNode.tagName === 'TBODY') {
	          _this.context.createCheckbox(index);
	        }
	        _this._td = td;
	        _this._header = header;
	      } else if (_this._td) {
	        var _index = _this._td.parentNode.rowIndex;
	        _this.context.removeCheckbox(_index - (_this._header ? 1 : 0));
	        _this._td = null;
	        _this._header = false;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TableCheckbox, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          index = _props.index,
	          props = _objectWithoutProperties(_props, ['checked', 'index']);
	
	      var _context = this.context,
	          checkedIcon = _context.checkedIcon,
	          uncheckedIcon = _context.uncheckedIcon,
	          indeterminateIcon = _context.indeterminateIcon,
	          indeterminate = _context.indeterminate,
	          header = _context.header,
	          footer = _context.footer,
	          rowId = _context.rowId,
	          baseName = _context.baseName,
	          checkboxHeaderLabel = _context.checkboxHeaderLabel,
	          checkboxLabelTemplate = _context.checkboxLabelTemplate;
	
	
	      var Cell = header ? 'th' : 'td';
	      var label = void 0;
	      if (header) {
	        label = checkboxHeaderLabel;
	      } else if (typeof checkboxLabelTemplate === 'function') {
	        label = checkboxLabelTemplate(index);
	      } else {
	        label = checkboxLabelTemplate.replace(/{{row}}/g, index);
	      }
	
	      var content = _react2.default.createElement(_SelectionControl2.default, _extends({}, props, {
	        id: rowId,
	        name: baseName + '-checkbox',
	        type: 'checkbox',
	        checked: checked,
	        checkedCheckboxIcon: checkedIcon,
	        uncheckedCheckboxIcon: header && indeterminate ? indeterminateIcon : uncheckedIcon,
	        'aria-label': label
	      }));
	      var fixedHeader = header && this.context.fixedHeader;
	      var fixedFooter = footer && this.context.fixedFooter;
	
	      if (fixedHeader) {
	        content = _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('md-table-column__fixed', {
	              'md-table-column__fixed--header': fixedHeader,
	              'md-table-column__fixed--footer': fixedFooter
	            })
	          },
	          _react2.default.cloneElement(content, {
	            className: (0, _classnames2.default)({
	              'md-table-checkbox--header': header,
	              'md-table-checkbox--footer': footer
	            })
	          })
	        );
	      }
	
	      return _react2.default.createElement(
	        Cell,
	        {
	          className: (0, _classnames2.default)('md-table-checkbox', {
	            'md-table-column--fixed': fixedHeader
	          }),
	          scope: header ? 'col' : undefined,
	          ref: this._handleMount
	        },
	        content
	      );
	    }
	  }]);
	
	  return TableCheckbox;
	}(_react.Component);
	
	TableCheckbox.propTypes = {
	  index: _propTypes2.default.number,
	  checked: _propTypes2.default.bool
	};
	TableCheckbox.contextTypes = {
	  rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  baseName: _propTypes2.default.string.isRequired,
	  indeterminate: _propTypes2.default.bool,
	  checkedIcon: _propTypes2.default.element,
	  uncheckedIcon: _propTypes2.default.element,
	  indeterminateIcon: _propTypes2.default.element,
	  checkboxHeaderLabel: _propTypes2.default.string.isRequired,
	  checkboxLabelTemplate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	  createCheckbox: _propTypes2.default.func.isRequired,
	  removeCheckbox: _propTypes2.default.func.isRequired,
	  header: _propTypes2.default.bool,
	  footer: _propTypes2.default.bool,
	  fixedHeader: _propTypes2.default.bool.isRequired,
	  fixedFooter: _propTypes2.default.bool.isRequired
	};
	exports.default = TableCheckbox;
	//# sourceMappingURL=TableCheckbox.js.map

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _contextTypes = __webpack_require__(67);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	var _headerContextTypes = __webpack_require__(86);
	
	var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A `thead` component to use in the `DataTable` component. This
	 * will automatically update the header row to check if it is selected
	 * and inject a function to toggle all rows selected if the row is
	 * uncontrolled. It will also automatically attempt to set the `TableColumn`
	 * components to be the header type.
	 */
	var TableHeader = function (_Component) {
	  _inherits(TableHeader, _Component);
	
	  function TableHeader() {
	    _classCallCheck(this, TableHeader);
	
	    return _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
	  }
	
	  _createClass(TableHeader, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return _extends({}, this.context, {
	        header: true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'children']);
	
	      var allSelected = this.context.allSelected;
	
	      var header = _react2.default.Children.only(children);
	      var selected = typeof header.props.selected === 'undefined' ? allSelected : header.props.selected;
	
	      var row = _react2.default.cloneElement(header, { selected: selected });
	
	      return _react2.default.createElement(
	        'thead',
	        _extends({}, props, { className: (0, _classnames2.default)('md-table-header', className) }),
	        row
	      );
	    }
	  }]);
	
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.contextTypes = _contextTypes2.default;
	TableHeader.childContextTypes = _headerContextTypes2.default;
	TableHeader.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the table header
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * This should be a single `TableRow` component. The `custom` validation will
	   * warn you if there are more than one children given or none at all.
	   */
	  children: function children(props, propName, component) {
	    try {
	      _react2.default.Children.only(props.children);
	      return null;
	    } catch (e) {
	      var amt = props.children ? props.children.length : 0;
	      return new Error('There must only be one child in a \'' + component + '\', but ' + amt + ' were given.');
	    }
	  }
	};
	exports.default = TableHeader;
	//# sourceMappingURL=TableHeader.js.map

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _ResizeObserver = __webpack_require__(28);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _SelectField = __webpack_require__(96);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _findTable = __webpack_require__(68);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	var _TableFooter = __webpack_require__(134);
	
	var _TableFooter2 = _interopRequireDefault(_TableFooter);
	
	var _TableColumn = __webpack_require__(43);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TablePagination` component is used to generate the table footer that helps
	 * pagination through a large dataset by limiting the number of rows per page.
	 * The pagination will always be placed persistently at the bottom of the table
	 * so that when a user scrolls to the right, they will always be able to use the
	 * pagination.
	 */
	var TablePagination = function (_PureComponent) {
	  _inherits(TablePagination, _PureComponent);
	
	  function TablePagination(props, context) {
	    _classCallCheck(this, TablePagination);
	
	    var _this = _possibleConstructorReturn(this, (TablePagination.__proto__ || Object.getPrototypeOf(TablePagination)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var controlledPage = typeof props.page !== 'undefined';
	    var controlledRowsPerPage = typeof props.rowsPerPage !== 'undefined';
	    var rowsPerPage = controlledRowsPerPage ? props.rowsPerPage : props.defaultRowsPerPage;
	    var page = controlledPage ? props.page : props.defaultPage;
	    _this.state = {
	      start: (page - 1) * rowsPerPage,
	      controlsMarginLeft: 0
	    };
	
	    if (!controlledPage) {
	      _this.state.page = page;
	    }
	
	    if (!controlledRowsPerPage) {
	      _this.state.rowsPerPage = props.defaultRowsPerPage;
	    }
	
	    _this._table = null;
	    _this._ticking = false;
	    return _this;
	  }
	
	  _createClass(TablePagination, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          rowsPerPage = _props.rowsPerPage,
	          page = _props.page;
	
	      if (page !== nextProps.page || rowsPerPage !== nextProps.rowsPerPage) {
	        var rpp = (0, _getField2.default)(nextProps, this.state, 'rowsPerPage');
	        var p = (0, _getField2.default)(nextProps, this.state, 'page');
	
	        this.setState({ start: (p - 1) * rpp });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          controlsMarginLeft = _state.controlsMarginLeft,
	          start = _state.start;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          selectFieldStyle = _props2.selectFieldStyle,
	          selectFieldClassName = _props2.selectFieldClassName,
	          selectFieldInputStyle = _props2.selectFieldInputStyle,
	          selectFieldInputClassName = _props2.selectFieldInputClassName,
	          rows = _props2.rows,
	          rowsPerPageLabel = _props2.rowsPerPageLabel,
	          rowsPerPageItems = _props2.rowsPerPageItems,
	          incrementIcon = _props2.incrementIcon,
	          decrementIcon = _props2.decrementIcon,
	          simplifiedMenu = _props2.simplifiedMenu,
	          incrementIconChildren = _props2.incrementIconChildren,
	          incrementIconClassName = _props2.incrementIconClassName,
	          decrementIconChildren = _props2.decrementIconChildren,
	          decrementIconClassName = _props2.decrementIconClassName,
	          propId = _props2.id,
	          propIncrementId = _props2.incrementId,
	          propDecrementId = _props2.decrementId,
	          onPagination = _props2.onPagination,
	          propRowsPerPage = _props2.rowsPerPage,
	          propPage = _props2.page,
	          defaultPage = _props2.defaultPage,
	          defaultRowsPerPage = _props2.defaultRowsPerPage,
	          props = _objectWithoutProperties(_props2, ['className', 'selectFieldStyle', 'selectFieldClassName', 'selectFieldInputStyle', 'selectFieldInputClassName', 'rows', 'rowsPerPageLabel', 'rowsPerPageItems', 'incrementIcon', 'decrementIcon', 'simplifiedMenu', 'incrementIconChildren', 'incrementIconClassName', 'decrementIconChildren', 'decrementIconClassName', 'id', 'incrementId', 'decrementId', 'onPagination', 'rowsPerPage', 'page', 'defaultPage', 'defaultRowsPerPage']);
	
	      var baseId = this.context.baseId;
	
	      var rowsPerPage = (0, _getField2.default)(this.props, this.state, 'rowsPerPage');
	      var _props3 = this.props,
	          id = _props3.id,
	          incrementId = _props3.incrementId,
	          decrementId = _props3.decrementId;
	
	      if (!id) {
	        id = baseId + '-pagination';
	      }
	
	      if (!incrementId) {
	        incrementId = id + '-increment-btn';
	      }
	
	      if (!decrementId) {
	        decrementId = id + '-decrement-btn';
	      }
	
	      var pagination = start + 1 + '-' + Math.min(rows, start + rowsPerPage) + ' of ' + rows;
	      return _react2.default.createElement(
	        _TableFooter2.default,
	        _extends({}, props, { className: (0, _classnames2.default)('md-table-footer--pagination', className) }),
	        _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, component: 'tr', onResize: this._throttledPosition }),
	        _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, component: 'tr', target: this._table, onResize: this._throttledPosition }),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            _TableColumn2.default,
	            { colSpan: '100%' },
	            _react2.default.createElement(
	              'div',
	              {
	                ref: this._setControls,
	                className: 'md-table-pagination md-table-pagination--controls md-text',
	                style: { marginLeft: controlsMarginLeft }
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'md-table-pagination__label' },
	                rowsPerPageLabel
	              ),
	              _react2.default.createElement(_SelectField2.default, {
	                id: id,
	                menuItems: rowsPerPageItems,
	                position: _SelectField2.default.Positions.BELOW,
	                style: selectFieldStyle,
	                className: selectFieldClassName,
	                inputStyle: selectFieldInputStyle,
	                inputClassName: (0, _classnames2.default)('md-select-field--pagination', selectFieldInputClassName),
	                value: rowsPerPage,
	                onChange: this._setRowsPerPage,
	                simplifiedMenu: simplifiedMenu
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: 'md-table-pagination--label' },
	                pagination
	              ),
	              _react2.default.createElement(_Button2.default, {
	                id: decrementId,
	                icon: true,
	                onClick: this._decrement,
	                disabled: start === 0,
	                iconEl: (0, _getDeprecatedIcon2.default)(decrementIconClassName, decrementIconChildren, decrementIcon)
	              }),
	              _react2.default.createElement(_Button2.default, {
	                id: incrementId,
	                icon: true,
	                onClick: this._increment,
	                disabled: start + rowsPerPage >= rows,
	                iconEl: (0, _getDeprecatedIcon2.default)(incrementIconClassName, incrementIconChildren, incrementIcon)
	              })
	            ),
	            _react2.default.createElement('div', { className: 'md-table-pagination' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TablePagination;
	}(_react.PureComponent);
	
	TablePagination.propTypes = {
	  /**
	   * An optional id to provide to the select field. If this is omitted, it will be
	   * the `DataTable`'s `baseId` with '-pagination'.
	   *
	   * @see {@link DataTables/DataTable#baseId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the increment icon button. If this is omitted, it will be
	   * the `id` with '-increment-btn'.
	   *
	   * @see {@link #id}
	   */
	  incrementId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the decrement icon button. If this is omitted, it will be
	   * the `id` with '-decrement-btn'.
	   *
	   * @see {@link #id}
	   */
	  decrementId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the `tfoot` tag.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `tfoot` tag.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the select field.
	   *
	   * @see {@link SelectFields/SelectField#style}
	   */
	  selectFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field.
	   *
	   * @see {@link SelectFields/SelectField#className}
	   */
	  selectFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the select field's input.
	   *
	   * @see {@link SelectFields/SelectField#inputStyle}
	   */
	  selectFieldInputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field's input.
	   *
	   * @see {@link SelectFields/SelectField#inputClassName}
	   */
	  selectFieldInputClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the select field should use the simplified menu logic.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * A function to call when a user clicks the increment or decrement pagination
	   * icon button. This function will be given the new start index and the number
	   * or rows per page as well as the current page.
	   *
	   * ```js
	   * onPagination(newStart, rowsPerPage, currentPage);
	   * ```
	   */
	  onPagination: _propTypes2.default.func.isRequired,
	
	  /**
	   * The current value for the select field holding the number of rows per page.
	   */
	  rowsPerPage: _propTypes2.default.number,
	
	  /**
	   * The current page for the pagination. This will make the component controlled, so the only way to get pagination
	   * is making sure you are updating this prop after the `onPagination` callback is called.
	   *
	   * Pages start from 1 instead of 0.
	   */
	  page: _propTypes2.default.number,
	
	  /**
	   * The default page to start from for the pagination. Pages start from 1 instead of 0.
	   */
	  defaultPage: _propTypes2.default.number.isRequired,
	
	  /**
	   * The default number of rows per page to display. This will be the value for the
	   * `SelectField`.
	   */
	  defaultRowsPerPage: _propTypes2.default.number.isRequired,
	
	  /**
	   * The label to use for the rows per page `SelectField`.
	   */
	  rowsPerPageLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * A list of numbers for the amount of rows per page to display at a time.
	   * This will be rendered into the `SelectField`.
	   */
	  rowsPerPageItems: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	
	  /**
	   * The total number of rows that can be displayed. This is the unfiltered/non-subset
	   * number of rows. This is used to help calculate the increment/decrement values to
	   * display and determine if the user can increment/decrement again.
	   */
	  rows: _propTypes2.default.number.isRequired,
	
	  /**
	   * The icon to use for the increment icon button.
	   */
	  incrementIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for the decrement icon button.
	   */
	  decrementIcon: _propTypes2.default.element,
	
	  incrementIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `incrementIcon` prop instead'),
	  incrementIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `incrementIcon` prop instead'),
	  decrementIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `decrementIcon` prop instead'),
	  decrementIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `decrementIcon` prop instead')
	};
	TablePagination.contextTypes = {
	  baseId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  fixedFooter: _propTypes2.default.bool
	};
	TablePagination.defaultProps = {
	  defaultPage: 1,
	  defaultRowsPerPage: 10,
	  rowsPerPageLabel: 'Rows per page:',
	  rowsPerPageItems: [10, 20, 30, 40, 50, 100],
	  incrementIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_right'
	  ),
	  decrementIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_left'
	  ),
	  simplifiedMenu: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setControls = function (controls) {
	    _this2._controls = controls;
	    _this2._table = (0, _findTable2.default)(controls);
	
	    if (_this2._table && _this2.context.fixedFooter) {
	      _this2._table.addEventListener('scroll', _this2._throttledPosition);
	    }
	  };
	
	  this._position = function () {
	    if (_this2._table) {
	      var fixedFooter = _this2.context.fixedFooter;
	      var _table = _this2._table,
	          offsetWidth = _table.offsetWidth,
	          scrollLeft = _table.scrollLeft;
	
	
	      var controlsMarginLeft = offsetWidth - _this2._controls.offsetWidth;
	      if (fixedFooter) {
	        controlsMarginLeft += scrollLeft;
	      }
	
	      _this2.setState({
	        controlsMarginLeft: Math.max(24, controlsMarginLeft)
	      });
	    }
	  };
	
	  this._throttledPosition = function () {
	    if (!_this2._ticking) {
	      requestAnimationFrame(function () {
	        _this2._ticking = false;
	        _this2._position();
	      });
	    }
	
	    _this2._ticking = true;
	  };
	
	  this._increment = function () {
	    var _props4 = _this2.props,
	        rows = _props4.rows,
	        onPagination = _props4.onPagination;
	    var start = _this2.state.start;
	
	    var rowsPerPage = (0, _getField2.default)(_this2.props, _this2.state, 'rowsPerPage');
	    var page = (0, _getField2.default)(_this2.props, _this2.state, 'page');
	
	    // Only correct multiple of rows per page
	    var max = rows - rows % rowsPerPage;
	
	    var newStart = Math.min(start + rowsPerPage, max);
	    var nextPage = page + 1;
	
	    onPagination(newStart, rowsPerPage, nextPage);
	    if (typeof _this2.props.page === 'undefined') {
	      _this2.setState({ start: newStart, page: nextPage });
	    }
	  };
	
	  this._decrement = function () {
	    var start = _this2.state.start;
	
	    var page = (0, _getField2.default)(_this2.props, _this2.state, 'page');
	    var rowsPerPage = (0, _getField2.default)(_this2.props, _this2.state, 'rowsPerPage');
	    var newStart = Math.max(0, start - rowsPerPage);
	    var nextPage = page - 1;
	
	    _this2.props.onPagination(newStart, rowsPerPage, nextPage);
	    if (typeof _this2.props.page === 'undefined') {
	      _this2.setState({ start: newStart, page: nextPage });
	    }
	  };
	
	  this._setRowsPerPage = function (rowsPerPage) {
	    var page = 1;
	    var newStart = 0;
	    _this2.props.onPagination(newStart, rowsPerPage, page);
	    var nextState = void 0;
	    if (typeof _this2.props.rowsPerPage === 'undefined') {
	      nextState = { rowsPerPage: rowsPerPage };
	    }
	
	    if (typeof _this2.props.page === 'undefined') {
	      nextState = nextState || {};
	      nextState.start = newStart;
	    }
	
	    if (nextState) {
	      _this2.setState(nextState);
	    }
	  };
	};
	
	exports.default = TablePagination;
	//# sourceMappingURL=TablePagination.js.map

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _headerContextTypes = __webpack_require__(86);
	
	var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	var _rowContextTypes = __webpack_require__(262);
	
	var _rowContextTypes2 = _interopRequireDefault(_rowContextTypes);
	
	var _TableCheckbox = __webpack_require__(257);
	
	var _TableCheckbox2 = _interopRequireDefault(_TableCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A component for displaying a row in a `DataTable`. This will
	 * automatically add a `Checkbox` component to the row if it is not
	 * a `plain` table.
	 */
	var TableRow = function (_Component) {
	  _inherits(TableRow, _Component);
	
	  function TableRow(props, context) {
	    _classCallCheck(this, TableRow);
	
	    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props, context));
	
	    _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (_this.context.header) {
	        return;
	      }
	
	      var target = e.target;
	      while (target && target.parentNode) {
	        if (target.classList && _this._ignoreHoverState(target.classList)) {
	          _this.setState({ hover: false });
	          return;
	        }
	
	        target = target.parentNode;
	      }
	
	      _this.setState({ hover: true });
	    };
	
	    _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      if (_this.context.header) {
	        return;
	      }
	
	      _this.setState({ hover: false });
	    };
	
	    _this._handleCheckboxClick = function (checked, e) {
	      var rowIndex = _this._row.rowIndex;
	
	      if (_this.props.onCheckboxClick) {
	        _this.props.onCheckboxClick(rowIndex, checked, e);
	      }
	
	      _this.context.toggleSelectedRow(rowIndex, _this.context.header, e);
	    };
	
	    _this._setRow = function (row) {
	      _this._row = row;
	    };
	
	    _this.state = { hover: false };
	    return _this;
	  }
	
	  _createClass(TableRow, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _context = this.context,
	          baseId = _context.baseId,
	          context = _objectWithoutProperties(_context, ['baseId']);
	
	      var id = baseId + '-' + (this._row ? this._row.rowIndex : null);
	      return _extends({}, context, {
	        rowId: context.header ? baseId + '-toggle-all' : id
	      });
	    }
	
	    /**
	     * Need to ignore adding the hover state if the mouse is over a menu/menu item
	     * or the edit dialog is open.
	     *
	     * @param {Function} classList - the classList to use for checking cn
	     * @return {Boolean} true if the hover state should be ignored for this classList
	     */
	
	  }, {
	    key: '_ignoreHoverState',
	    value: function _ignoreHoverState(classList) {
	      return classList.contains('md-list--menu') || classList.contains('md-edit-dialog');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          selected = _props.selected,
	          selectable = _props.selectable,
	          onCheckboxClick = _props.onCheckboxClick,
	          autoAdjust = _props.autoAdjust,
	          props = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'selectable', 'onCheckboxClick', 'autoAdjust']);
	
	      var hover = this.state.hover;
	
	
	      var checkbox = void 0;
	      if (typeof selectable !== 'undefined' ? selectable : !this.context.plain && this.context.selectableRows) {
	        checkbox = _react2.default.createElement(_TableCheckbox2.default, {
	          key: 'checkbox',
	          checked: selected,
	          onChange: this._handleCheckboxClick,
	          index: this._row ? this._row.rowIndex : null
	        });
	      }
	
	      var length = _react.Children.count(children) - 1;
	      var columns = _react.Children.map(_react.Children.toArray(children), function (col, i) {
	        var adjusted = col.props.adjusted;
	        if (typeof adjusted === 'undefined') {
	          adjusted = i === length ? false : undefined;
	        }
	
	        return (0, _react.cloneElement)(col, {
	          cellIndex: i + (checkbox ? 1 : 0),
	          header: (0, _getField2.default)(col.props, _this2.context, 'header'),
	          adjusted: adjusted
	        });
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        _extends({}, props, {
	          ref: this._setRow,
	          className: (0, _classnames2.default)('md-table-row', className, {
	            'md-table-row--hover': hover,
	            'md-table-row--active': !this.context.header && selected
	          }),
	          onMouseOver: this._handleMouseOver,
	          onMouseLeave: this._handleMouseLeave
	        }),
	        checkbox,
	        columns
	      );
	    }
	  }]);
	
	  return TableRow;
	}(_react.Component);
	
	TableRow.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the row.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A single or list of `TableColumn` to display in the table.
	   *
	   * > The specs "require" at least 3 columns for a non-plain data table, but that isn't
	   * strictly enforced here.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired,
	
	  /**
	   * An optional onClick function to call when a row is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * A function to call when the checkbox is clicked. This
	   * function will will be called with `(rowIndex, checked, event)`.
	   * The `TableBody` and `TableHeader` components will automatically
	   * merge in a function to toggle the checkbox.
	   */
	  onCheckboxClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call onMouseOver.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call onMouseLeave.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * Boolean if the row is currently selected. If this value will be
	   * injected by the `TableHeader` or `TableBody` component.
	   */
	  selected: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the current row is selectable. This value will take precedence over anything inherited
	   * by the `DataTable`.
	   */
	  selectable: _propTypes2.default.bool,
	
	  autoAdjust: (0, _deprecated2.default)(_propTypes2.default.bool, 'Manually specify `grow` on one of the columns instead')
	};
	TableRow.contextTypes = _headerContextTypes2.default;
	TableRow.childContextTypes = _rowContextTypes2.default;
	exports.default = TableRow;
	//# sourceMappingURL=TableRow.js.map

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropdownMenuColumn = exports.MenuButtonColumn = exports.SelectFieldColumn = exports.EditDialogColumn = exports.TableCardHeader = exports.TablePagination = exports.TableFooter = exports.TableColumn = exports.TableRow = exports.TableBody = exports.TableHeader = exports.DataTable = undefined;
	
	var _DataTable2 = __webpack_require__(249);
	
	var _DataTable3 = _interopRequireDefault(_DataTable2);
	
	var _TableHeader2 = __webpack_require__(258);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableBody2 = __webpack_require__(255);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableRow2 = __webpack_require__(260);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableColumn2 = __webpack_require__(43);
	
	var _TableColumn3 = _interopRequireDefault(_TableColumn2);
	
	var _TableFooter2 = __webpack_require__(134);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TablePagination2 = __webpack_require__(259);
	
	var _TablePagination3 = _interopRequireDefault(_TablePagination2);
	
	var _TableCardHeader2 = __webpack_require__(256);
	
	var _TableCardHeader3 = _interopRequireDefault(_TableCardHeader2);
	
	var _EditDialogColumn2 = __webpack_require__(252);
	
	var _EditDialogColumn3 = _interopRequireDefault(_EditDialogColumn2);
	
	var _SelectFieldColumn2 = __webpack_require__(254);
	
	var _SelectFieldColumn3 = _interopRequireDefault(_SelectFieldColumn2);
	
	var _MenuButtonColumn2 = __webpack_require__(253);
	
	var _MenuButtonColumn3 = _interopRequireDefault(_MenuButtonColumn2);
	
	var _DropdownMenuColumn2 = __webpack_require__(250);
	
	var _DropdownMenuColumn3 = _interopRequireDefault(_DropdownMenuColumn2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DataTable3.default;
	exports.DataTable = _DataTable3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableColumn = _TableColumn3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TablePagination = _TablePagination3.default;
	exports.TableCardHeader = _TableCardHeader3.default;
	exports.EditDialogColumn = _EditDialogColumn3.default;
	exports.SelectFieldColumn = _SelectFieldColumn3.default;
	exports.MenuButtonColumn = _MenuButtonColumn3.default;
	exports.DropdownMenuColumn = _DropdownMenuColumn3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _headerContextTypes = __webpack_require__(86);
	
	var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	var _omit = __webpack_require__(77);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowContextTypes = (0, _omit2.default)(_extends({}, _headerContextTypes2.default, {
	  rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	}), ['baseId']);
	
	exports.default = rowContextTypes;
	//# sourceMappingURL=rowContextTypes.js.map

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogTitle = function (_PureComponent) {
	  _inherits(DialogTitle, _PureComponent);
	
	  function DialogTitle() {
	    _classCallCheck(this, DialogTitle);
	
	    return _possibleConstructorReturn(this, (DialogTitle.__proto__ || Object.getPrototypeOf(DialogTitle)).apply(this, arguments));
	  }
	
	  _createClass(DialogTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      if (!children) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'h2',
	        _extends({}, props, { className: (0, _classnames2.default)('md-title md-title--dialog', className) }),
	        children
	      );
	    }
	  }]);
	
	  return DialogTitle;
	}(_react.PureComponent);
	
	DialogTitle.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	exports.default = DialogTitle;
	//# sourceMappingURL=DialogTitle.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dialog = exports.DialogContainer = undefined;
	
	var _DialogContainer2 = __webpack_require__(89);
	
	var _DialogContainer3 = _interopRequireDefault(_DialogContainer2);
	
	var _Dialog2 = __webpack_require__(88);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DialogContainer3.default;
	exports.DialogContainer = _DialogContainer3.default;
	exports.Dialog = _Dialog3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Divider = undefined;
	
	var _Divider2 = __webpack_require__(90);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider3.default;
	exports.Divider = _Divider3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Portal = __webpack_require__(45);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_PureComponent) {
	  _inherits(Overlay, _PureComponent);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
	  }
	
	  _createClass(Overlay, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      // Always want the overlay to render in a separate subtree until 1.1.0
	      return { isInPortal: false };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          visible = _props.visible,
	          renderNode = _props.renderNode,
	          onClick = _props.onClick,
	          style = _props.style,
	          className = _props.className;
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { visible: visible, renderNode: renderNode },
	        _react2.default.createElement('div', {
	          style: style,
	          className: (0, _classnames2.default)('md-overlay md-overlay--drawer md-pointer--hover', {
	            'md-overlay--active': active
	          }, className),
	          onClick: onClick
	        })
	      );
	    }
	  }]);
	
	  return Overlay;
	}(_react.PureComponent);
	
	Overlay.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  visible: _propTypes2.default.bool.isRequired,
	  renderNode: _propTypes2.default.object,
	  onClick: _propTypes2.default.func
	};
	Overlay.childContextTypes = {
	  isInPortal: _propTypes2.default.bool
	};
	exports.default = Overlay;
	//# sourceMappingURL=Overlay.js.map

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Drawer = undefined;
	
	var _Drawer2 = __webpack_require__(91);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer3.default;
	exports.Drawer = _Drawer3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(9);
	
	var _handleWindowClickListeners = __webpack_require__(73);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _ResizeObserver = __webpack_require__(28);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ExpansionList` component is a wrapper for the `ExpansionPanel` that helps
	 * determine which `ExpansionPanel` currently has tab focus and adjusts the column
	 * sizes in the header of the `ExpansionPanel`.
	 *
	 * The `ExpansionList` and `ExpansionPanel` components should have probably been
	 * implemented as a `table` instead of a `ul || ol` since it is more column based,
	 * but it would complicate the API to have dynamic row generation for the expanded
	 * panels. The expanded panels _might_ not follow the same column widths as their labels
	 * so a singular row with a div for expanded content might not work correctly.
	 */
	var ExpansionList = function (_PureComponent) {
	  _inherits(ExpansionList, _PureComponent);
	
	  function ExpansionList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ExpansionList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExpansionList.__proto__ || Object.getPrototypeOf(ExpansionList)).call.apply(_ref, [this].concat(args))), _this), _this.state = { columnWidths: [], focusedIndex: -1, overflown: false }, _this._setContainer = function (container) {
	      if (container !== null) {
	        _this._container = (0, _reactDom.findDOMNode)(container);
	        window.addEventListener('keyup', _this._determineTabFocus);
	
	        _this._width = _this._container.offsetWidth;
	        _this._calcColumnWidths();
	      }
	    }, _this._determineTabFocus = function (e) {
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        var panels = Array.prototype.slice.call((0, _reactDom.findDOMNode)(_this).querySelectorAll('.md-panel-header'));
	        _this.setState({ focusedIndex: panels.indexOf(e.target) });
	      }
	    }, _this._removeFocus = function () {
	      _this.setState({ focusedIndex: -1 });
	    }, _this._isOverflown = function (widths) {
	      if (!_this._container) {
	        return false;
	      }
	
	      var panel = _this._container.querySelector('.md-panel-header');
	      if (!panel) {
	        return false;
	      }
	
	      var collapser = _this._container.querySelector('.md-expansion-panel__collapser');
	      var collapserWidth = collapser ? collapser.offsetWidth : 0;
	      var styles = window.getComputedStyle(panel);
	      var maxWidth = panel.offsetWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight) - collapserWidth;
	
	      var totalWidth = widths.reduce(function (total, w) {
	        return total + w;
	      }, 0);
	      return totalWidth > maxWidth;
	    }, _this._getColumnWidths = function () {
	      if (!_this._container) {
	        return _this.state.columnWidths;
	      }
	
	      return [].slice.call(_this._container.querySelectorAll('.md-panel-header')).reduce(function (maxes, row) {
	        var columns = row.querySelectorAll('.md-panel-column');
	        for (var i = 0; i < columns.length; i++) {
	          var col = columns[i];
	          // Need to reset the widths if it has already been calculated to get a more accurate measurement.
	          var _col$style = col.style,
	              width = _col$style.width,
	              minWidth = _col$style.minWidth;
	
	          col.style.width = 'auto';
	          col.style.minWidth = 'auto';
	
	          // Only need to include the offsetWidth of the column because the child will really
	          // determine the width of the column. Since it has already been defined at this point,
	          // no additional work needs to be done.
	          maxes[i] = Math.max(col.offsetWidth, maxes[i] || 0);
	          col.style.width = width;
	          col.style.minWidth = minWidth;
	        }
	
	        return maxes;
	      }, [0]);
	    }, _this._calcColumnWidths = function () {
	      var columnWidths = _this.state.columnWidths;
	
	      var nextWidths = _this._getColumnWidths();
	      var overflown = _this._isOverflown(nextWidths);
	      if (_this.state.overflown !== overflown || columnWidths.length !== nextWidths.length || nextWidths.some(function (w, i) {
	        return w !== columnWidths[i];
	      })) {
	        _this.setState({ columnWidths: nextWidths, overflown: overflown });
	      }
	    }, _this._handleResize = function (_ref2) {
	      var width = _ref2.width;
	      var recalculateThreshold = _this.props.recalculateThreshold;
	
	      if (_this._width !== width && Math.abs(width - _this._width) >= recalculateThreshold) {
	        _this._width = width;
	        _this._calcColumnWidths();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ExpansionList, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var animateContent = this.props.animateContent;
	
	      return { animateContent: animateContent };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.children !== nextProps.children) {
	        this._calcColumnWidths();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var focusedIndex = this.state.focusedIndex;
	
	      if (prevState.focusedIndex === focusedIndex || prevState.focusedIndex > -1 && focusedIndex > -1) {
	        return;
	      }
	
	      (0, _handleWindowClickListeners2.default)(this._removeFocus, this.state.focusedIndex !== -1);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.focusedIndex === -1) {
	        (0, _handleWindowClickListeners2.default)(this._removeFocus, false);
	      }
	
	      window.removeEventListener('keyup', this._determineTabFocus);
	    }
	
	    /**
	     * Since this should really be rendered as a table, need to calculate the max width for each _column_
	     * on the panel's header and apply that as a min width for the other panels.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          columnWidths = _state.columnWidths,
	          focusedIndex = _state.focusedIndex,
	          overflown = _state.overflown;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          Component = _props.component,
	          animateContent = _props.animateContent,
	          recalculateThreshold = _props.recalculateThreshold,
	          props = _objectWithoutProperties(_props, ['children', 'className', 'component', 'animateContent', 'recalculateThreshold']);
	
	      var panels = _react.Children.map(children, function (child, i) {
	        return (0, _react.cloneElement)(child, {
	          key: child.key || i,
	          overflown: overflown,
	          columnWidths: columnWidths,
	          focused: focusedIndex === i
	        });
	      });
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          ref: this._setContainer,
	          className: (0, _classnames2.default)('md-expansion-panel-list', className)
	        }),
	        _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, onResize: this._handleResize }),
	        panels
	      );
	    }
	  }]);
	
	  return ExpansionList;
	}(_react.PureComponent);
	
	ExpansionList.propTypes = {
	  /**
	   * An optional style object to apply to the list.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the list.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children should be a list or singular `ExpansionPanel` component
	   * to render with some additional props injected.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to render the list as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * Boolean if all the expansion panels in the list should animate when their content's visibility
	   * changes. This is just a quicker way to disable all animations instead of having to toggle it off
	   * on each panel.
	   *
	   * > The default value is really `true` since it gets passed down to the `Collapse` component.
	   */
	  animateContent: _propTypes2.default.bool,
	
	  /**
	   * The threshold that should be used for when the list should recalculate the positioning of all
	   * the columns. This will only compare the difference between updates.
	   * So if the size changes from 80 -> 120 -> 160 -> 140. It will only update on the third resize (160)
	   */
	  recalculateThreshold: _propTypes2.default.number.isRequired
	};
	ExpansionList.defaultProps = {
	  component: 'ul',
	  recalculateThreshold: 80
	};
	ExpansionList.childContextTypes = {
	  animateContent: _propTypes2.default.bool
	};
	exports.default = ExpansionList;
	//# sourceMappingURL=ExpansionList.js.map

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _getCollapserStyles = __webpack_require__(75);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _Paper = __webpack_require__(29);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _AccessibleFakeButton = __webpack_require__(50);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	var _Collapse = __webpack_require__(35);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _PanelContent = __webpack_require__(270);
	
	var _PanelContent2 = _interopRequireDefault(_PanelContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LABEL_FONT_SIZE = 15;
	var LINE_HEIGHT = 1.42857;
	var SINGLE_LINE_HEIGHT = LABEL_FONT_SIZE * LINE_HEIGHT;
	
	/**
	 * The `ExpansionPanel` component needs to be used with the `ExpansionList`
	 * component. The only reason is that the `ExpansionPanel` should really
	 * be rendered as a table, but it was a bit hard to have a single component
	 * dynamically rendering another row when expanded. It couldn't be in the
	 * same row since the expanded content might not have the same columns.
	 */
	
	var ExpansionPanel = function (_PureComponent) {
	  _inherits(ExpansionPanel, _PureComponent);
	
	  function ExpansionPanel(props, context) {
	    _classCallCheck(this, ExpansionPanel);
	
	    var _this = _possibleConstructorReturn(this, (ExpansionPanel.__proto__ || Object.getPrototypeOf(ExpansionPanel)).call(this, props, context));
	
	    _this._determineIfTwoLine = function () {
	      var twoLine = false;
	      Array.prototype.slice.call((0, _reactDom.findDOMNode)(_this).querySelectorAll('.md-panel-column')).some(function (el) {
	        return twoLine = el.offsetHeight > SINGLE_LINE_HEIGHT;
	      });
	
	      _this.setState({ twoLine: twoLine });
	    };
	
	    _this._handleClick = function () {
	      var expanded = !_this._isExpanded(_this.props, _this.state);
	      if (_this.props.onExpandToggle) {
	        _this.props.onExpandToggle(expanded);
	      }
	
	      if (typeof _this.props.expanded === 'undefined') {
	        _this.setState({ expanded: expanded });
	      }
	    };
	
	    _this._handleSave = function (e) {
	      var _this$props = _this.props,
	          onSave = _this$props.onSave,
	          onExpandToggle = _this$props.onExpandToggle,
	          closeOnSave = _this$props.closeOnSave;
	
	      if (onSave) {
	        onSave(e);
	      }
	
	      if (closeOnSave) {
	        if (onExpandToggle) {
	          onExpandToggle(false);
	        }
	
	        if (typeof _this.props.expanded === 'undefined') {
	          _this.setState({ expanded: false });
	        }
	      }
	    };
	
	    _this._handleCancel = function (e) {
	      var _this$props2 = _this.props,
	          onCancel = _this$props2.onCancel,
	          onExpandToggle = _this$props2.onExpandToggle,
	          closeOnCancel = _this$props2.closeOnCancel;
	
	      if (onCancel) {
	        onCancel(e);
	      }
	
	      if (closeOnCancel) {
	        if (onExpandToggle) {
	          onExpandToggle(false);
	        }
	
	        if (typeof _this.props.expanded === 'undefined') {
	          _this.setState({ expanded: false });
	        }
	      }
	    };
	
	    _this.state = {
	      received: false,
	      twoLine: false
	    };
	
	    if (typeof props.expanded === 'undefined') {
	      _this.state.expanded = props.defaultExpanded;
	    }
	    return _this;
	  }
	
	  _createClass(ExpansionPanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._determineIfTwoLine();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (false) {
	        if (nextProps.columnWidths.length === 0) {
	          // Hopefully a nice warning about fixing the missing props injected from ExpansionList
	          /* eslint-disable no-console */
	          console.error('The `ExpansionPanel` component expects the `columnWidths` prop to be injected from the ' + '`ExpansionList` component. It could be missing because:' + '\n - you have a wrapper component with extra functionality' + '\n - the `ExpansionPanel` is not a direct child of the `ExpansionList` component' + '\n\nYou can fix this by making sure to pass `this.props.focused` and `this.props.columnWidths` ' + 'within your wrapper component and making the `ExpansionPanel` a direct child of `ExpansionList`.');
	        }
	
	        this.setState({ received: true });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.label === prevProps.label && this.props.secondaryLabel === prevProps.secondaryLabel) {
	        return;
	      }
	
	      this._determineIfTwoLine();
	    }
	  }, {
	    key: '_isExpanded',
	    value: function _isExpanded(props, state) {
	      return typeof props.expanded === 'undefined' ? state.expanded : props.expanded;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          label = _props.label,
	          secondaryLabel = _props.secondaryLabel,
	          expandedSecondaryLabel = _props.expandedSecondaryLabel,
	          children = _props.children,
	          focused = _props.focused,
	          columnWidths = _props.columnWidths,
	          saveType = _props.saveType,
	          saveLabel = _props.saveLabel,
	          savePrimary = _props.savePrimary,
	          saveSecondary = _props.saveSecondary,
	          saveProps = _props.saveProps,
	          cancelType = _props.cancelType,
	          cancelLabel = _props.cancelLabel,
	          cancelPrimary = _props.cancelPrimary,
	          cancelSecondary = _props.cancelSecondary,
	          cancelProps = _props.cancelProps,
	          headerStyle = _props.headerStyle,
	          headerClassName = _props.headerClassName,
	          contentStyle = _props.contentStyle,
	          contentClassName = _props.contentClassName,
	          tabIndex = _props.tabIndex,
	          overflown = _props.overflown,
	          footer = _props.footer,
	          footerChildren = _props.footerChildren,
	          footerStyle = _props.footerStyle,
	          footerClassName = _props.footerClassName,
	          expandIconChildren = _props.expandIconChildren,
	          expandIconClassName = _props.expandIconClassName,
	          propAnimateContent = _props.animateContent,
	          propExpanded = _props.expanded,
	          propExpanderIcon = _props.expanderIcon,
	          defaultExpanded = _props.defaultExpanded,
	          closeOnSave = _props.closeOnSave,
	          closeOnCancel = _props.closeOnCancel,
	          onSave = _props.onSave,
	          onCancel = _props.onCancel,
	          onExpandToggle = _props.onExpandToggle,
	          props = _objectWithoutProperties(_props, ['className', 'label', 'secondaryLabel', 'expandedSecondaryLabel', 'children', 'focused', 'columnWidths', 'saveType', 'saveLabel', 'savePrimary', 'saveSecondary', 'saveProps', 'cancelType', 'cancelLabel', 'cancelPrimary', 'cancelSecondary', 'cancelProps', 'headerStyle', 'headerClassName', 'contentStyle', 'contentClassName', 'tabIndex', 'overflown', 'footer', 'footerChildren', 'footerStyle', 'footerClassName', 'expandIconChildren', 'expandIconClassName', 'animateContent', 'expanded', 'expanderIcon', 'defaultExpanded', 'closeOnSave', 'closeOnCancel', 'onSave', 'onCancel', 'onExpandToggle']);
	
	      var twoLine = this.state.twoLine;
	
	      var expanded = this._isExpanded(this.props, this.state);
	      var animateContent = (0, _getField2.default)(this.props, this.context, 'animateContent');
	
	      var columns = _react.Children.map(expanded && expandedSecondaryLabel || secondaryLabel, function (panelLabel, i) {
	        return _react2.default.createElement(
	          'div',
	          {
	            style: _defineProperty({}, '' + (overflown ? 'width' : 'minWidth'), columnWidths[i + 1]),
	            className: (0, _classnames2.default)('md-panel-column', {
	              'md-panel-column--overflown': overflown
	            }, (0, _themeColors2.default)({ text: true }))
	          },
	          panelLabel
	        );
	      });
	
	      if (!Array.isArray(columns)) {
	        columns = [columns];
	      }
	
	      columns.unshift(_react2.default.createElement(
	        'div',
	        {
	          key: 'main-label',
	          style: { minWidth: columnWidths[0] },
	          className: (0, _classnames2.default)('md-panel-column', (0, _themeColors2.default)({ text: true }))
	        },
	        label
	      ));
	
	      var expanderIcon = (0, _getDeprecatedIcon2.default)(expandIconClassName, expandIconChildren, this.props.expanderIcon);
	      expanderIcon = _react2.default.Children.only(expanderIcon);
	      expanderIcon = _react2.default.cloneElement(expanderIcon, {
	        className: (0, _getCollapserStyles2.default)({
	          flipped: expanded
	        }, 'md-expansion-panel__collapser md-cell--right', expanderIcon.props.className)
	      });
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-expansion-panel', {
	            'md-expansion-panel--expanded': expanded
	          }, className),
	          'aria-expanded': expanded
	        }),
	        _react2.default.createElement(
	          _AccessibleFakeButton2.default,
	          {
	            onClick: this._handleClick,
	            style: headerStyle,
	            className: (0, _classnames2.default)('md-panel-header', {
	              'md-panel-header--expanded': expanded || twoLine,
	              'md-panel-header--focused': focused
	            }, headerClassName),
	            tabIndex: tabIndex
	          },
	          columns,
	          expanderIcon
	        ),
	        _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: !expanded, animate: animateContent },
	          _react2.default.createElement(
	            _PanelContent2.default,
	            {
	              style: contentStyle,
	              className: contentClassName,
	              footerStyle: footerStyle,
	              footerClassName: footerClassName,
	              onSave: this._handleSave,
	              onCancel: this._handleCancel,
	              saveType: saveType,
	              saveLabel: saveLabel,
	              savePrimary: savePrimary,
	              saveSecondary: saveSecondary,
	              saveProps: saveProps,
	              cancelType: cancelType,
	              cancelLabel: cancelLabel,
	              cancelPrimary: cancelPrimary,
	              cancelSecondary: cancelSecondary,
	              cancelProps: cancelProps,
	              footer: footer,
	              footerChildren: footerChildren
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExpansionPanel;
	}(_react.PureComponent);
	
	ExpansionPanel.propTypes = {
	  /**
	   * An optional style to apply to the panel.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the panel.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An options style to apply to the panel's header content. This is the
	   * section that toggles the children to be visible and label columns.
	   */
	  headerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the panel's header content. This is the
	   * section that toggles the children to be visible and label columns.
	   */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element surrounding the children when expanded.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element surrounding the children when expanded.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the footer when the `footer` prop is `undefined`.
	   *
	   * @see {@link #footer}
	   */
	  footerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the footer when the `footer` prop is `undefined`.
	   *
	   * @see {@link #footer}
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * The main label to display in the unexpanded panel.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * Any additional columns to display after the main label. If this is a `list`
	   * instead of a singular item, they will each be formatted as a column.
	   */
	  secondaryLabel: _propTypes2.default.node,
	
	  /**
	   * Any additional columns to display after the main label when the panel is
	   * expanded. If this is omitted, the default `secondaryLabel` will be displayed
	   * instead.
	   */
	  expandedSecondaryLabel: _propTypes2.default.node,
	
	  /**
	   * The component to render the panel as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The content to display once the panel is toggled open.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A boolean if the panel is currently expanded. This will force the component
	   * to be controlled and require's the `onExpandToggle` function to be defined.
	   */
	  expanded: (0, _controlled2.default)(_propTypes2.default.bool, 'onExpandToggle', 'defaultExpanded'),
	
	  /**
	   * Boolean if an uncontrolled panel should be expanded by default.
	   */
	  defaultExpanded: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The icon to display for expanding the expansion panel.
	   */
	  expanderIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the `ExpansionPanel` is currently tab focused. This is injected
	   * and managed by the `ExpansionList` component. Do not set yourself.
	   */
	  focused: _propTypes2.default.bool.isRequired,
	
	  /**
	   * A list of min-widths to apply to each column in the panel header. This is injected
	   * and managed by the `ExpansionList` component. Do not set yourself.
	   */
	  columnWidths: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	
	  /**
	   * Boolean if the panel has too much content so that it overflowns. This is injected
	   * and managed by the `ExpansionList` component. Do not set yourself.
	   *
	   * When this is active, it will truncate all columns except for the main label and the
	   * toggle icon.
	   */
	  overflown: _propTypes2.default.bool,
	
	  /**
	   * A function to call when the expansion panel's expanded state is toggled.
	   * The callback for this function will include the new expanded state.
	   *
	   * `onExpandToggle(expanded)`
	   */
	  onExpandToggle: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the Save button is clicked on the expanded panel.
	   */
	  onSave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the Cancel button is clicked on the expanded panel.
	   */
	  onCancel: _propTypes2.default.func,
	
	  /**
	   * Boolean if the panel should close when the Save button is clicked.
	   */
	  closeOnSave: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the panel should close when the Cancel button is clicked.
	   */
	  closeOnCancel: _propTypes2.default.bool,
	
	  /**
	   * An optional button type to apply to the Save button. This will get
	   * passed to the `FlatButton`.
	   */
	  saveType: _propTypes2.default.oneOf(['button', 'submit', 'reset']),
	
	  /**
	   * The label for the Save button.
	   */
	  saveLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the Save button should be styled with the primary color.
	   */
	  savePrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Save button should be styled with the secondary color,
	   */
	  saveSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to provide/override for the save button in the
	   * footer of the panel.
	   */
	  saveProps: _propTypes2.default.object,
	
	  /**
	   * An optional button type to apply to the Cancel button. This will get
	   * passed to the `FlatButton`.
	   */
	  cancelType: _propTypes2.default.oneOf(['button', 'submit', 'reset']),
	
	  /**
	   * The label for the Cancel button.
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the Cancel button should be styled with the primary color,
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Cancel button should be styled with the secondary color,
	   */
	  cancelSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to provide/override for the cancel button in the
	   * footer of the panel.
	   */
	  cancelProps: _propTypes2.default.object,
	
	  /**
	   * The tab index for the panel's header. This allows keyboard navigation.
	   */
	  tabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the panel's content should animate when the content's visibility changes. This
	   * can also be toggled from the `ExpansionList` component if all `ExpansionPanel` in the list
	   * should not animate. This only affects the height transition.
	   *
	   * > The default value is really `true` since it gets passed down to the `Collapse` component.
	   */
	  animateContent: _propTypes2.default.bool,
	
	  /**
	   * This prop controls the footer for the expansion panel. If this prop is `undefined`, it will
	   * go with the default behavior of generating the save and cancel buttons with the save and cancel
	   * props.
	   *
	   * If this value is `null`, there will be no footer created.
	   *
	   * Finally, if this prop is defined as any renderable item, it will be displayed in place of the
	   * footer.
	   *
	   * @see {@link #footerChildren}
	   */
	  footer: _propTypes2.default.node,
	
	  /**
	   * Any additional children that should be displayed in the footer of the panel. These children
	   * will be placed after the action buttons.
	   */
	  footerChildren: _propTypes2.default.node,
	  expandIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `expanderIcon` instead'),
	  expandIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `expanderIcon` instead')
	};
	ExpansionPanel.defaultProps = {
	  defaultExpanded: false,
	  expanderIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_down'
	  ),
	  component: 'li',
	  saveLabel: 'Save',
	  cancelLabel: 'Cancel',
	  savePrimary: true,
	  tabIndex: 0,
	  closeOnSave: true,
	  closeOnCancel: true,
	  focused: false,
	  columnWidths: []
	};
	ExpansionPanel.contextTypes = {
	  animateContent: _propTypes2.default.bool
	};
	exports.default = ExpansionPanel;
	//# sourceMappingURL=ExpansionPanel.js.map

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DialogFooter = __webpack_require__(69);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `PanelContent` component is for displaying the expanded content
	 * for an `ExpansionPanel`. It will display any children in a `md-panel-content`
	 * container followed by a `Divider` and the `PanelControls` .
	 */
	var PanelContent = function (_PureComponent) {
	  _inherits(PanelContent, _PureComponent);
	
	  function PanelContent() {
	    _classCallCheck(this, PanelContent);
	
	    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
	  }
	
	  _createClass(PanelContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          footerStyle = _props.footerStyle,
	          footerClassName = _props.footerClassName,
	          contentStyle = _props.contentStyle,
	          className = _props.className,
	          children = _props.children,
	          onSave = _props.onSave,
	          onCancel = _props.onCancel,
	          saveProps = _props.saveProps,
	          saveType = _props.saveType,
	          saveLabel = _props.saveLabel,
	          savePrimary = _props.savePrimary,
	          saveSecondary = _props.saveSecondary,
	          cancelProps = _props.cancelProps,
	          cancelType = _props.cancelType,
	          cancelLabel = _props.cancelLabel,
	          cancelPrimary = _props.cancelPrimary,
	          cancelSecondary = _props.cancelSecondary,
	          footer = _props.footer,
	          footerChildren = _props.footerChildren;
	
	
	      var actions = [_extends({
	        type: cancelType,
	        label: cancelLabel,
	        primary: cancelPrimary,
	        secondary: cancelSecondary
	      }, cancelProps, {
	        onClick: onCancel
	      }), _extends({
	        type: saveType,
	        label: saveLabel,
	        primary: savePrimary,
	        secondary: saveSecondary
	      }, saveProps, {
	        onClick: onSave
	      })];
	
	      var actionFooter = null;
	      if (typeof footer === 'undefined') {
	        actionFooter = _react2.default.createElement(
	          _DialogFooter2.default,
	          {
	            actions: actions,
	            style: footerStyle,
	            className: (0, _classnames2.default)('md-divider-border md-divider-border--top', footerClassName)
	          },
	          footerChildren
	        );
	      } else if (footer !== null) {
	        actionFooter = footer;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: style },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('md-panel-content', className), style: contentStyle },
	          children
	        ),
	        actionFooter
	      );
	    }
	  }]);
	
	  return PanelContent;
	}(_react.PureComponent);
	
	PanelContent.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  footerStyle: _propTypes2.default.object,
	  footerClassName: _propTypes2.default.string,
	  contentStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  onSave: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired,
	  saveProps: _propTypes2.default.object,
	  saveType: _propTypes2.default.string,
	  saveLabel: _propTypes2.default.node.isRequired,
	  savePrimary: _propTypes2.default.bool,
	  saveSecondary: _propTypes2.default.bool,
	  cancelProps: _propTypes2.default.object,
	  cancelType: _propTypes2.default.string,
	  cancelLabel: _propTypes2.default.node.isRequired,
	  cancelPrimary: _propTypes2.default.bool,
	  cancelSecondary: _propTypes2.default.bool,
	  footer: _propTypes2.default.node,
	  footerChildren: _propTypes2.default.node
	};
	exports.default = PanelContent;
	//# sourceMappingURL=PanelContent.js.map

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExpansionList = exports.ExpansionPanel = undefined;
	
	var _ExpansionPanel2 = __webpack_require__(269);
	
	var _ExpansionPanel3 = _interopRequireDefault(_ExpansionPanel2);
	
	var _ExpansionList2 = __webpack_require__(268);
	
	var _ExpansionList3 = _interopRequireDefault(_ExpansionList2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ExpansionPanel3.default;
	exports.ExpansionPanel = _ExpansionPanel3.default;
	exports.ExpansionList = _ExpansionList3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Any props such as style or event listeners will be applied to the
	 * main floating action button. If you want props applied to the `SpeedDial`
	 * itself, you will need to set them in the `containerProps` prop.
	 */
	var SpeedDial = function (_PureComponent) {
	  _inherits(SpeedDial, _PureComponent);
	
	  function SpeedDial(props) {
	    _classCallCheck(this, SpeedDial);
	
	    var _this = _possibleConstructorReturn(this, (SpeedDial.__proto__ || Object.getPrototypeOf(SpeedDial)).call(this, props));
	
	    _this.state = { isOpen: props.initiallyOpen };
	    _this._handleClick = _this._handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(SpeedDial, [{
	    key: '_isOpen',
	    value: function _isOpen(props, state) {
	      return typeof props.isOpen === 'undefined' ? state.isOpen : props.isOpen;
	    }
	  }, {
	    key: '_handleClick',
	    value: function _handleClick(e) {
	      var _props = this.props,
	          onClick = _props.onClick,
	          onPassiveClick = _props.onPassiveClick,
	          onActiveClick = _props.onActiveClick;
	
	      if (onClick) {
	        onClick(e);
	      }
	
	      var isOpen = this._isOpen(this.props, this.state);
	      if (isOpen && onActiveClick) {
	        onActiveClick(e);
	      } else if (!isOpen && onPassiveClick) {
	        onPassiveClick(e);
	      }
	
	      if (typeof this.props.isOpen === 'undefined') {
	        this.setState({ isOpen: !isOpen });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          fabs = _props2.fabs,
	          passiveIconChildren = _props2.passiveIconChildren,
	          passiveIconClassName = _props2.passiveIconClassName,
	          activeIconChildren = _props2.activeIconChildren,
	          activeIconClassName = _props2.activeIconClassName,
	          transitionName = _props2.transitionName,
	          transitionEnterTimeout = _props2.transitionEnterTimeout,
	          speedDialTransitionName = _props2.speedDialTransitionName,
	          speedDialTransitionEnterTimeout = _props2.speedDialTransitionEnterTimeout,
	          speedDialTransitionLeaveTimeout = _props2.speedDialTransitionLeaveTimeout,
	          containerProps = _props2.containerProps,
	          props = _objectWithoutProperties(_props2, ['fabs', 'passiveIconChildren', 'passiveIconClassName', 'activeIconChildren', 'activeIconClassName', 'transitionName', 'transitionEnterTimeout', 'speedDialTransitionName', 'speedDialTransitionEnterTimeout', 'speedDialTransitionLeaveTimeout', 'containerProps']);
	
	      delete props.isOpen;
	      delete props.initiallyOpen;
	
	      var isOpen = this._isOpen(this.props, this.state);
	
	      var speedDialFabs = void 0;
	      if (isOpen) {
	        speedDialFabs = fabs.map(function (fab, i) {
	          var fn = void 0;
	          var el = void 0;
	          var fabProps = void 0;
	          if (_react2.default.isValidElement(fab)) {
	            el = _react2.default.Children.only(fab);
	            fn = _react2.default.cloneElement;
	            fabProps = fab.props;
	          } else {
	            el = _Button2.default;
	            fn = _react2.default.createElement;
	            fabProps = fab;
	          }
	
	          var created = fn(el, _extends({
	            floating: true,
	            mini: true
	          }, fabProps));
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'md-speed-dial-fab' },
	            created
	          );
	        });
	      }
	
	      props.iconClassName = isOpen ? activeIconClassName : passiveIconClassName;
	      props.children = isOpen ? activeIconChildren : passiveIconChildren;
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        _extends({}, containerProps, {
	          component: 'div',
	          className: (0, _classnames2.default)('md-speed-dial', !!containerProps && containerProps.className),
	          transitionName: transitionName + '-' + (isOpen ? 'right' : 'left'),
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeave: false,
	          ref: 'container'
	        }),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            key: 'speed-dial-fabs',
	            transitionName: speedDialTransitionName,
	            transitionEnterTimeout: speedDialTransitionEnterTimeout,
	            transitionLeaveTimeout: speedDialTransitionLeaveTimeout
	          },
	          speedDialFabs
	        ),
	        _react2.default.createElement(_Button2.default, _extends({}, props, {
	          floating: true,
	          key: (isOpen ? 'open' : 'closed') + '-fab',
	          onClick: this._handleClick
	        }))
	      );
	    }
	  }]);
	
	  return SpeedDial;
	}(_react.PureComponent);
	
	SpeedDial.propTypes = {
	  /**
	   * A boolean if the speed dial is currently open. This will make
	   * the speed dial into a controlled component.
	   */
	  isOpen: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the uncontrolled speed dial is initially open.
	   */
	  initiallyOpen: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to the speed dial.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The speed dial's floating action button transition name when the button's
	   * open state changes. If the button is open, `-right` is appened, otherwise
	   * `-left`.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The timeout for the speed dial's floating action button transition.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The name for the flinging animation of the speed dial.
	   */
	  speedDialTransitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The timeout for the flinging animation of the speed dial when opening.
	   */
	  speedDialTransitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The timeout for the flinging animation when the speed dial is closing.
	   */
	  speedDialTransitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The optional children to display for unopened speed dial floating action button.
	   */
	  passiveIconChildren: _propTypes2.default.node,
	
	  /**
	   * The optional icon className to display for unopened speed dial floating action button.
	   */
	  passiveIconClassName: _propTypes2.default.node,
	
	  /**
	   * The optional children to display for opened speed dial floating action button.
	   */
	  activeIconChildren: _propTypes2.default.node,
	
	  /**
	   * The optional icon className to display for opened speed dial floating action button.
	   */
	  activeIconClassName: _propTypes2.default.string,
	
	  /**
	   * A list of `FloatingButton` or props to generate the `FloatinButton` when the
	   * `SpeedDial` is open. The buttons will automatically be converted to the `mini`
	   * version.
	   */
	  fabs: function fabs(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var size = props.fabs.length;
	    if (size >= 3 && size <= 5) {
	      var _PropTypes$arrayOf;
	
	      return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
	        onClick: _propTypes2.default.func,
	        iconClassName: _propTypes2.default.string,
	        children: _propTypes2.default.node
	      })]))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(others));
	    }
	
	    var middle = size < 3 ? 'at least 3' : 'no more than 5';
	    return new Error('A speed dial requires ' + middle + ' floating action buttons to fling. ' + ('However, only ' + size + ' were given.'));
	  },
	
	  /**
	   * An optional function to call when the main floating action button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the main floating action button is clicked.
	   */
	  onPassiveClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the main floating action button is clicked.
	   */
	  onActiveClick: _propTypes2.default.func,
	
	  /**
	   * Any additional props to apply to the speed dial itself.
	   */
	  containerProps: _propTypes2.default.object
	};
	SpeedDial.defaultProps = {
	  initiallyOpen: false,
	  transitionName: 'md-fab-rotate',
	  transitionEnterTimeout: 150,
	  speedDialTransitionName: 'md-speed-dial',
	  speedDialTransitionEnterTimeout: 450,
	  speedDialTransitionLeaveTimeout: 150,
	  passiveIconClassName: 'material-icons',
	  activeIconClassName: 'material-icons'
	};
	exports.default = SpeedDial;
	//# sourceMappingURL=SpeedDial.js.map

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SpeedDial = undefined;
	
	var _SpeedDial2 = __webpack_require__(272);
	
	var _SpeedDial3 = _interopRequireDefault(_SpeedDial2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SpeedDial = _SpeedDial3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _FileInput = __webpack_require__(138);
	
	var _FileInput2 = _interopRequireDefault(_FileInput);
	
	var _omit = __webpack_require__(77);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `FileUpload` component is used to upload files locally This is a wrapper of the `FileInput` component
	 * with some additional functionality so any props that are undocumented on `FileUpload` but are present
	 * on `FileInput` are correctly provided. If you want to upload files to a server, use
	 * [FormData](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
	 * by attaching the `File`.
	 *
	 * Quick example:
	 *
	 * ```js
	 * function upload(file) {
	 *   fetch('/api/images', {
	 *     method: 'POST',
	 *     body: new FormData().append('file', file),
	 *   });
	 * }
	 * ```
	 *
	 * An upload can be aborted by calling the `abort(file || fileName)` function. If
	 * the file or fileName are omitted, it will *attempt* to abort the current
	 * file that is uploading. Unreliable for multi-select.
	 *
	 * ```js
	 * <FileUpload ref="upload" />
	 * <Button raised onClick={() => this.refs.upload.abort()} label="Abort! Abort!" />
	 * ```
	 */
	var FileUpload = function (_PureComponent) {
	  _inherits(FileUpload, _PureComponent);
	
	  function FileUpload() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FileUpload);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.abort = function (file) {
	      var fileName = file;
	      if (!file) {
	        // Attempt to remove first file added...
	        fileName = Object.keys(_this.state)[0];
	      } else if (typeof file.name === 'string') {
	        fileName = file.name;
	      }
	
	      var reader = _this.state[fileName];
	      if (reader) {
	        reader.abort();
	        (0, _reactDom.findDOMNode)(_this).querySelector('.md-file-input').value = '';
	
	        _this.setState((0, _omit2.default)(_this.state, [fileName]));
	      }
	    }, _this._uploadFile = function (file) {
	      var _this$props = _this.props,
	          onAbort = _this$props.onAbort,
	          onError = _this$props.onError,
	          onLoad = _this$props.onLoad,
	          onLoadStart = _this$props.onLoadStart,
	          onLoadEnd = _this$props.onLoadEnd,
	          onProgress = _this$props.onProgress,
	          readAs = _this$props.readAs;
	      var name = file.name,
	          type = file.type;
	
	
	      var fr = new FileReader();
	      if (onError) {
	        fr.onerror = function (e) {
	          onError(file, e.target.error, e);
	        };
	      }
	
	      if (onAbort) {
	        fr.onabort = function (e) {
	          onAbort(file, e);
	        };
	      }
	
	      if (onLoadStart) {
	        fr.onloadstart = function (e) {
	          onLoadStart(file, e);
	        };
	      }
	
	      if (onLoadEnd) {
	        fr.onloadend = function (e) {
	          onLoadEnd(file, e);
	        };
	      }
	
	      fr.onload = function (e) {
	        if (onLoad) {
	          onLoad(file, e.target.result, e);
	        }
	
	        _this.setState((0, _omit2.default)(_this.state, [name]));
	      };
	
	      if (onProgress) {
	        fr.onprogress = function (e) {
	          if (e.lengthComputable) {
	            onProgress(file, e.loaded / e.total * 100, e);
	          }
	        };
	      }
	
	      if (readAs) {
	        if (typeof readAs === 'function') {
	          readAs(type, file, fr);
	        } else {
	          fr['readAs' + readAs](file);
	        }
	      } else if (type.match(/image|video|audio|application\/pdf/) || name.match(/\.mkv$/)) {
	        fr.readAsDataURL(file);
	      } else if (type.match(/application\/json/)) {
	        fr.readAsText(file);
	      } else if (type.match(/application|model|multipart/) || name.match(/(w|e)ar$/)) {
	        fr.readAsArrayBuffer(file);
	      } else {
	        fr.readAsText(file);
	      }
	
	      return fr;
	    }, _this._handleUpload = function (fileList, e) {
	      if (_this.props.onChange) {
	        _this.props.onChange(fileList, e);
	      }
	
	      if (!fileList) {
	        return;
	      }
	      var _this$props2 = _this.props,
	          maxSize = _this$props2.maxSize,
	          onSizeError = _this$props2.onSizeError;
	
	      var files = Array.isArray(fileList) ? fileList : [fileList];
	
	      var errorFiles = [];
	      if (maxSize) {
	        errorFiles = files.filter(function (file) {
	          return file.size > maxSize;
	        });
	        files = files.filter(function (file) {
	          return file.size <= maxSize;
	        });
	      }
	
	      if (errorFiles.length) {
	        onSizeError(errorFiles);
	      }
	
	      if (!files.length) {
	        return;
	      }
	
	      var nextState = {};
	      files.forEach(function (file) {
	        var fileReader = _this._uploadFile(file);
	        nextState[file.name] = fileReader;
	      });
	
	      _this.setState(nextState);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Attempts to abort the upload of a file. This function takes an optional `file` or `fileName`
	   * as it's parameter. If the parameter is omitted, it attempts to abort the first file that was
	   * added. If the `onAbort` function was given, it will be called as well.
	   *
	   * @param {Object|string} file - The file or the file name to use to find the
	   *     correct `FileReader`.
	   */
	
	
	  _createClass(FileUpload, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          maxSize = _props.maxSize,
	          readAs = _props.readAs,
	          onLoad = _props.onLoad,
	          onLoadStart = _props.onLoadStart,
	          onLoadEnd = _props.onLoadEnd,
	          onProgress = _props.onProgress,
	          onAbort = _props.onAbort,
	          onError = _props.onError,
	          onSizeError = _props.onSizeError,
	          props = _objectWithoutProperties(_props, ['maxSize', 'readAs', 'onLoad', 'onLoadStart', 'onLoadEnd', 'onProgress', 'onAbort', 'onError', 'onSizeError']);
	
	      return _react2.default.createElement(_FileInput2.default, _extends({}, props, { onChange: this._handleUpload }));
	    }
	  }]);
	
	  return FileUpload;
	}(_react.PureComponent);
	
	FileUpload.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the label.
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the label.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled as a flat button instead of a
	   * raised button.
	   */
	  flat: _propTypes2.default.bool,
	
	  /**
	   * This should be a comma separated list of Media Types that the `FileInput` can
	   * accept. If this prop is left blank, any file will be accepted.
	   *
	   * The values can either be:
	   * - A file extension
	   * - audio/*
	   * - video/*
	   * - image/*
	   * - any valid [IANA Media Type](http://www.iana.org/assignments/media-types/media-types.xhtml)
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Boolean if multiple files will be accepted.
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * A label to display on the `FileInput`.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * The icon children to use for the upload icon.
	   */
	  iconChildren: _propTypes2.default.node,
	
	  /**
	   * The icon className to use for the upload icon.
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * An optional max size for the file. If the file is greater than
	   * this limit, the file will not be uploaded.
	   */
	  maxSize: _propTypes2.default.number,
	
	  /**
	   * A required function to call when the `maxSize` prop is set. It will
	   * be given a list of files that were too big.
	   */
	  onSizeError: function onSizeError(props, propName, component) {
	    for (var _len2 = arguments.length, others = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      others[_key2 - 3] = arguments[_key2];
	    }
	
	    if (typeof props.maxSize === 'number') {
	      var _PropTypes$func;
	
	      return (_PropTypes$func = _propTypes2.default.func).isRequired.apply(_PropTypes$func, [props, propName, component].concat(others));
	    }
	
	    return null;
	  },
	
	  /**
	   * You can force the `FileReader` to read the file as a specific type
	   * if you do not trust the *amazing* regex I have for choosing the correct
	   * one.
	   *
	   * ```js
	   * if(type.match(/image|video|audio/)) {
	   *   fr.readAsDataURL(file);
	   * } else if(type.match(/application|model|multipart/)) {
	   *   fr.readAsArrayBuffer(file);
	   * } else {
	   *   fr.readAsText(file);
	   * }
	   * ```
	   *
	   * > `.yml` and `.js` both are considered `application`, so it definitely fails there.
	   *
	   * If this prop is a function, you will be given the file's type, the file object, and
	   * the file reader. You will then need to call `fileReader.readAsYOUR_CORRECT_TYPE(file)`.
	   */
	  readAs: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['DataURL', 'ArrayBuffer', 'Text']), _propTypes2.default.func]),
	
	  /**
	   * An optional function to call when the `FileUpload` aborts. The current
	   * file and the abort event are given. This might not be the most useful
	   * function to use since you will need to manually call abort yourself anyways.
	   */
	  onAbort: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` errors. The current
	   * file, the error, and the error event are given.
	   *
	   * ```js
	   * onError(file, event.target.error, event);
	   * ```
	   */
	  onError: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` loads. The current
	   * file, the load result, and the load event are given.
	   *
	   * ```js
	   * onLoad(file, event.target.result, event);
	   * ```
	   *
	   * The load result will either be:
	   * - a data URL
	   * - a plain text string
	   * - an array buffer
	   *
	   * depending on what type the file is.
	   */
	  onLoad: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` starts loading. The current
	   * file and the load start event are given.
	   */
	  onLoadStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` finishes loading. The
	   * current file and the load end event are given.
	   */
	  onLoadEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` progress. The current
	   * file, upload progress, and the progress event are given. The progress
	   * will be a number between 0 and 100 that has not been rounded.
	   *
	   * ```js
	   * onProgress(file, progress, event);
	   * ```
	   */
	  onProgress: _propTypes2.default.func,
	
	  /**
	   * Boolean if the same file is allowed to be uploaded multiple times. This will basically make the
	   * `value` of the file input always blank.
	   */
	  allowDuplicates: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when a file selects or unselects a file.
	   * This will be called before any local uploading occurs.
	   *
	   * ```js
	   * onChange(file(s) || null, event);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional value to apply to the `FileInput`. This is usually not needed and the
	   * `allowDuplicates` is what you are probably looking for instead.
	   *
	   * @see {@link #allowDuplicates}
	   */
	  value: _propTypes2.default.string
	};
	exports.default = FileUpload;
	//# sourceMappingURL=FileUpload.js.map

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FileUpload = exports.FileInput = undefined;
	
	var _FileInput2 = __webpack_require__(138);
	
	var _FileInput3 = _interopRequireDefault(_FileInput2);
	
	var _FileUpload2 = __webpack_require__(274);
	
	var _FileUpload3 = _interopRequireDefault(_FileUpload2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FileInput3.default;
	exports.FileInput = _FileInput3.default;
	exports.FileUpload = _FileUpload3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(141);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Cell = __webpack_require__(140);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['className', 'cellClassName', 'stacked', 'container', 'noSpacing', 'gutter', 'spacing', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden'];
	
	var GridList = function (_PureComponent) {
	  _inherits(GridList, _PureComponent);
	
	  _createClass(GridList, null, [{
	    key: 'getClassNames',
	
	
	    /**
	     * A utility function to get the grid's className based on the `Grid`'s and `Cell`'s
	     * props. This is * used behind the scenes to merge and create the className for the grid.
	     *
	     * ### Example:
	     * ```js
	     * const { className, cellClassName } = GridList.getClassNames();
	     * const { className, cellClassName } = GridList.getClassNames({ size: 1, container: 'custom' });
	     * ```
	     *
	     * @param {Object=} props - This should be an object of the `Grid`'s props. It
	     *    will extract the needed keys and generate the classNames.
	     * @return {Object} an object containing the `className` and `cellClassName` attributes.
	     */
	    value: function getClassNames() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var className = props.className,
	          cellClassName = props.cellClassName,
	          remaining = _objectWithoutProperties(props, ['className', 'cellClassName']);
	
	      return {
	        className: _Grid2.default.getClassName(_extends({ className: className }, remaining)),
	        cellClassName: _Cell2.default.getClassName(_extends({ className: cellClassName }, remaining))
	      };
	    }
	  }]);
	
	  function GridList(props) {
	    _classCallCheck(this, GridList);
	
	    var _this = _possibleConstructorReturn(this, (GridList.__proto__ || Object.getPrototypeOf(GridList)).call(this));
	
	    _this.state = GridList.getClassNames(props);
	    return _this;
	  }
	
	  _createClass(GridList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState(GridList.getClassNames(this.props));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (DIFF_KEYS.some(function (key) {
	        return _this2.props[key] !== nextProps[key];
	      })) {
	        this.setState(GridList.getClassNames(nextProps));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          className = _state.className,
	          cellClassName = _state.cellClassName;
	
	      var _props = this.props,
	          style = _props.style,
	          cellStyle = _props.cellStyle,
	          Component = _props.component,
	          children = _props.children,
	          propClassName = _props.className,
	          propCellClassName = _props.cellClassName,
	          container = _props.container,
	          noSpacing = _props.noSpacing,
	          stacked = _props.stacked,
	          gutter = _props.gutter,
	          spacing = _props.spacing,
	          align = _props.align,
	          position = _props.position,
	          size = _props.size,
	          offset = _props.offset,
	          order = _props.order,
	          phoneSize = _props.phoneSize,
	          phoneOrder = _props.phoneOrder,
	          phoneOffset = _props.phoneOffset,
	          phoneHidden = _props.phoneHidden,
	          tabletSize = _props.tabletSize,
	          tabletOrder = _props.tabletOrder,
	          tabletOffset = _props.tabletOffset,
	          tabletHidden = _props.tabletHidden,
	          desktopSize = _props.desktopSize,
	          desktopOrder = _props.desktopOrder,
	          desktopOffset = _props.desktopOffset,
	          desktopHidden = _props.desktopHidden,
	          props = _objectWithoutProperties(_props, ['style', 'cellStyle', 'component', 'children', 'className', 'cellClassName', 'container', 'noSpacing', 'stacked', 'gutter', 'spacing', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden']);
	
	      if (typeof children === 'function') {
	        return children({ style: style, className: className, cellStyle: cellStyle, cellClassName: cellClassName });
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, { style: style, className: className }),
	        _react2.default.Children.map(children, function (child) {
	          if (!child) {
	            return child;
	          }
	
	          var childStyle = child.props.style;
	          if (cellStyle) {
	            childStyle = childStyle ? _extends({}, cellStyle, childStyle) : cellStyle;
	          }
	
	          return _react2.default.cloneElement(child, {
	            style: childStyle,
	            className: (0, _classnames2.default)(child.props.className, cellClassName)
	          });
	        })
	      );
	    }
	  }]);
	
	  return GridList;
	}(_react.PureComponent);
	
	GridList.propTypes = {
	  /**
	   * An optional style to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to each child. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  cellStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to each child. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  cellClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the Cell as. This should probably not be used as much
	   * as the `children` callback function.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * The children can either be renderable React elements or a callback function
	   * that accepts the style and className props to apply so that the styles can
	   * be manually added to whichever component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	
	  /**
	   * An optional container name to apply to the Grid. This should be the same name as provided
	   * to the [react-md-make-grid-container](/components/grids?tab=2#mixin-react-md-make-grid-container) mixin.
	   */
	  container: _propTypes2.default.string,
	
	  /**
	   * Boolean if the grid should be placed vertically instead of horizontally.
	   */
	  stacked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if all the gutters and spacing should be removed from the grid.
	   */
	  noSpacing: _propTypes2.default.bool,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  gutter: _propTypes2.default.number,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  spacing: _propTypes2.default.number,
	
	  /**
	   * An optional cell alignment to apply. When the `Grid` is not `stacked`,
	   * this will apply to vertical alignment within each "row" of the grid.
	   *
	   * Alignments:
	   * - `top` - This will align to the top of the row
	   * - `middle` - This will align to the middle of the row
	   * - `bottom` - This will align to the bottom of the row
	   * - `stretch` - This will make the cell stretch to fill all the available space
	   *   in the row.
	   *
	   * @see {@link #position}
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom', 'stretch']),
	
	  /**
	   * An optional cell position to apply. When the `Grid` is not `stacked`,
	   * this will apply to horizontal alignment within each "row" of the grid.
	   *
	   * Positions:
	   * - `center` - This will align the cell to be within the center of the row. This really
	   *    just applies `margin-left: auto; margin-right: auto`.
	   * - `right` - This will align the cell to the end of the row. This really just applies `margin-left: auto`.
	   *
	   * @see {@link #align}
	   */
	  position: _propTypes2.default.oneOf(['center', 'right']),
	
	  /**
	   * An optional size to apply to the cell. This sizing will be applied across all media sizes.
	   * If the size is greater than the number of columns allowed for the media size, it will just
	   * span the entire width.
	   */
	  size: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell. This order will be applied across all media sizes.
	   */
	  order: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell. This will add spacing to the left of the cell.
	   */
	  offset: _propTypes2.default.number,
	
	  /**
	   * An optional size to apply to the cell only on phones.
	   */
	  phoneSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on phones.
	   */
	  phoneOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on phones.
	   */
	  phoneOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on phones only.
	   */
	  phoneHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on tablets.
	   */
	  tabletSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on tablets.
	   */
	  tabletOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on tablets.
	   */
	  tabletOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on tablets only.
	   */
	  tabletHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on desktops.
	   */
	  desktopSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on desktops.
	   */
	  desktopOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on desktops.
	   */
	  desktopOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on desktops only.
	   */
	  desktopHidden: _propTypes2.default.bool
	};
	GridList.defaultProps = {
	  component: 'div',
	  stacked: false,
	  noSpacing: false,
	  phoneHidden: false,
	  tabletHidden: false,
	  desktopHidden: false
	};
	exports.default = GridList;
	//# sourceMappingURL=GridList.js.map

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GridList = exports.Cell = exports.Grid = undefined;
	
	var _Grid2 = __webpack_require__(141);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _Cell2 = __webpack_require__(140);
	
	var _Cell3 = _interopRequireDefault(_Cell2);
	
	var _GridList2 = __webpack_require__(276);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Grid3.default;
	exports.Grid = _Grid3.default;
	exports.Cell = _Cell3.default;
	exports.GridList = _GridList3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResizeObserver = exports.Portal = exports.Layover = exports.IconSeparator = exports.FocusContainer = exports.Collapse = exports.AccessibleFakeInkedButton = exports.AccessibleFakeButton = undefined;
	
	var _AccessibleFakeButton2 = __webpack_require__(50);
	
	var _AccessibleFakeButton3 = _interopRequireDefault(_AccessibleFakeButton2);
	
	var _AccessibleFakeInkedButton2 = __webpack_require__(25);
	
	var _AccessibleFakeInkedButton3 = _interopRequireDefault(_AccessibleFakeInkedButton2);
	
	var _Collapse2 = __webpack_require__(35);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _FocusContainer2 = __webpack_require__(142);
	
	var _FocusContainer3 = _interopRequireDefault(_FocusContainer2);
	
	var _IconSeparator2 = __webpack_require__(44);
	
	var _IconSeparator3 = _interopRequireDefault(_IconSeparator2);
	
	var _Layover2 = __webpack_require__(70);
	
	var _Layover3 = _interopRequireDefault(_Layover2);
	
	var _Portal2 = __webpack_require__(45);
	
	var _Portal3 = _interopRequireDefault(_Portal2);
	
	var _ResizeObserver2 = __webpack_require__(28);
	
	var _ResizeObserver3 = _interopRequireDefault(_ResizeObserver2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AccessibleFakeButton = _AccessibleFakeButton3.default;
	exports.AccessibleFakeInkedButton = _AccessibleFakeInkedButton3.default;
	exports.Collapse = _Collapse3.default;
	exports.FocusContainer = _FocusContainer3.default;
	exports.IconSeparator = _IconSeparator3.default;
	exports.Layover = _Layover3.default;
	exports.Portal = _Portal3.default;
	exports.ResizeObserver = _ResizeObserver3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroupTick = __webpack_require__(30);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ink = function (_PureComponent) {
	  _inherits(Ink, _PureComponent);
	
	  function Ink(props) {
	    _classCallCheck(this, Ink);
	
	    var _this = _possibleConstructorReturn(this, (Ink.__proto__ || Object.getPrototypeOf(Ink)).call(this, props));
	
	    _this.state = {
	      active: false,
	      expanded: false,
	      pulsing: false,
	      leaving: false
	    };
	    return _this;
	  }
	
	  _createClass(Ink, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.aborted && nextProps.aborted) {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	
	        if (this._abort) {
	          this._abort();
	        }
	
	        this.setState({ active: false, expanding: false, pulsing: false, leaving: false });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(cb) {
	      var _this2 = this;
	
	      if (this.props.aborted) {
	        cb();
	        return;
	      }
	
	      var _props = this.props,
	          transitionOverlap = _props.transitionOverlap,
	          transitionEnterTimeout = _props.transitionEnterTimeout;
	
	      this._abort = cb;
	
	      this._timeout = setTimeout(function () {
	        _this2._timeout = setTimeout(function () {
	          _this2._timeout = null;
	          _this2._abort = null;
	
	          cb();
	        }, transitionEnterTimeout - transitionOverlap);
	
	        _this2.setState({ expanded: true });
	      }, _CSSTransitionGroupTick2.default);
	
	      this.setState({ active: true });
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var _this3 = this;
	
	      if (this.props.pulse) {
	        this._timeout = setTimeout(function () {
	          _this3._timeout = null;
	
	          _this3.setState({ pulsing: true });
	        }, this.props.transitionEnterTimeout);
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(cb) {
	      var _this4 = this;
	
	      if (this.props.aborted) {
	        cb();
	        return;
	      }
	
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      this._abort = cb;
	      this._timeout = setTimeout(function () {
	        _this4._timeout = null;
	
	        cb();
	      }, this.props.transitionLeaveTimeout);
	
	      this.setState({ pulsing: false, leaving: true });
	    }
	  }, {
	    key: 'componentDidLeave',
	    value: function componentDidLeave() {
	      if (!this.props.aborted && this.props.onRemove) {
	        this.props.onRemove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          style = _props2.style,
	          className = _props2.className,
	          left = _props2.left,
	          top = _props2.top,
	          size = _props2.size;
	      var _state = this.state,
	          active = _state.active,
	          expanded = _state.expanded,
	          pulsing = _state.pulsing,
	          leaving = _state.leaving;
	
	
	      return _react2.default.createElement('span', {
	        style: Object.assign({}, style, {
	          left: left,
	          top: top,
	          height: size,
	          width: size
	        }),
	        className: (0, _classnames2.default)('md-ink', {
	          'md-ink--active': active,
	          'md-ink--expanded': expanded,
	          'md-ink--pulsing': pulsing,
	          'md-ink--leaving': leaving
	        }, className)
	      });
	    }
	  }]);
	
	  return Ink;
	}(_react.PureComponent);
	
	Ink.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  aborted: _propTypes2.default.bool,
	  onRemove: _propTypes2.default.func,
	  left: _propTypes2.default.number.isRequired,
	  top: _propTypes2.default.number.isRequired,
	  size: _propTypes2.default.number.isRequired,
	  transitionOverlap: _propTypes2.default.number.isRequired,
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	  pulse: _propTypes2.default.bool
	};
	exports.default = Ink;
	//# sourceMappingURL=Ink.js.map

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(81);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(9);
	
	var _isFormPartRole = __webpack_require__(175);
	
	var _isFormPartRole2 = _interopRequireDefault(_isFormPartRole);
	
	var _calcPageOffset = __webpack_require__(169);
	
	var _calcPageOffset2 = _interopRequireDefault(_calcPageOffset);
	
	var _isValidClick = __webpack_require__(98);
	
	var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	var _touches = __webpack_require__(54);
	
	var _captureNextEvent = __webpack_require__(52);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _calculateHypotenuse = __webpack_require__(360);
	
	var _calculateHypotenuse2 = _interopRequireDefault(_calculateHypotenuse);
	
	var _Ink = __webpack_require__(279);
	
	var _Ink2 = _interopRequireDefault(_Ink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `InkContainer` is used for holding the list of inks that get created by touch,
	 * click, or keyboard focus.
	 *
	 * If the container element has the `type="submit"` attribute, the ink will also be
	 * triggered when the user presses enter anywhere in the form.
	 */
	var InkContainer = function (_PureComponent) {
	  _inherits(InkContainer, _PureComponent);
	
	  function InkContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InkContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InkContainer.__proto__ || Object.getPrototypeOf(InkContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = { inks: [] }, _this.createInk = function (pageX, pageY) {
	      _this._createInk(pageX, pageY);
	      _this._removeTimeout = setTimeout(function () {
	        _this._removeTimeout = null;
	        _this._removeInk();
	      }, _this.props.transitionOverlap);
	    }, _this.focus = function () {
	      _this._getKeyboardContainer().focus();
	    }, _this._createInk = function (pageX, pageY) {
	      var _this$_inkContainer = _this._inkContainer,
	          offsetWidth = _this$_inkContainer.offsetWidth,
	          offsetHeight = _this$_inkContainer.offsetHeight;
	
	
	      var x = void 0;
	      var y = void 0;
	      if (typeof pageX !== 'undefined' && typeof pageY !== 'undefined') {
	        var pageOffset = (0, _calcPageOffset2.default)(_this._inkContainer);
	
	        x = pageX - pageOffset.left;
	        y = pageY - pageOffset.top;
	      } else {
	        x = offsetWidth / 2;
	        y = offsetHeight / 2;
	      }
	
	      var r = Math.max((0, _calculateHypotenuse2.default)(x, y), (0, _calculateHypotenuse2.default)(offsetWidth - x, y), (0, _calculateHypotenuse2.default)(offsetWidth - x, offsetHeight - y), (0, _calculateHypotenuse2.default)(x, offsetHeight - y));
	
	      var ink = {
	        left: x - r,
	        top: y - r,
	        size: r * 2,
	        key: Date.now()
	      };
	
	      var inks = _this.state.inks.slice();
	      inks.push(ink);
	      _this.setState({ inks: inks });
	    }, _this._removeInk = function () {
	      var inks = _this.state.inks.slice();
	      inks.pop();
	
	      _this.setState({ inks: inks });
	    }, _this._getKeyboardContainer = function () {
	      if (_this._container.classList.contains('md-text-field-container')) {
	        return _this._container.querySelector('.md-text-field');
	      }
	
	      return _this._container;
	    }, _this._setContainers = function (group) {
	      if (group !== null) {
	        _this._inkContainer = (0, _reactDom.findDOMNode)(group);
	        _this._container = _this._inkContainer.parentElement;
	
	        if (_this._container) {
	          _this._initOrRemoveEvents(_this.props);
	        }
	      }
	    }, _this._initOrRemoveEvents = function (props) {
	      var keyboardDiff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var mouseDiff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	      var touchDiff = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	      var mouseDisabled = _this._isListenerDisabled('mouse', props.disabledInteractions);
	      var touchDisabled = _this._isListenerDisabled('touch', props.disabledInteractions);
	      var keyboardDisabled = _this._isListenerDisabled('keyboard', props.disabledInteractions);
	
	      if (keyboardDiff) {
	        var fn = (keyboardDisabled ? 'remove' : 'add') + 'EventListener';
	        _this._getKeyboardContainer()[fn]('focus', _this._handleFocus);
	        _this._getKeyboardContainer()[fn]('keydown', _this._handleKeyDown);
	
	        if (_this._container.getAttribute('type') === 'submit') {
	          window[fn]('submit', _this._handleSubmit);
	        }
	
	        if (mouseDiff) {
	          _this._container[(!mouseDisabled ? 'add' : 'remove') + 'EventListener']('mousedown', _this._stopPropagationToFocus);
	        }
	
	        if (touchDiff) {
	          (0, _touches.setTouchEvent)(!touchDisabled, _this._container, 'start', _this._stopPropagationToFocus);
	        }
	      }
	
	      if (mouseDiff) {
	        var _fn = (mouseDisabled ? 'remove' : 'add') + 'EventListener';
	        _this._container[_fn]('mousedown', _this._handleMouseDown);
	        _this._container[_fn]('mouseup', _this._handleMouseUp);
	      }
	
	      if (touchDiff) {
	        (0, _touches.setTouchEvent)(!touchDisabled, _this._container, 'start', _this._handleTouchStart);
	        (0, _touches.setTouchEvent)(!touchDisabled, _this._container, 'end', _this._handleTouchEnd);
	      }
	    }, _this._maybeDelayClick = function () {
	      if (!_this.props.waitForInkTransition) {
	        return;
	      }
	
	      (0, _captureNextEvent2.default)('click', _this._container);
	    }, _this._handleRemove = function () {
	      if (_this._clicked && _this.props.waitForInkTransition) {
	        // For some reason if the click event will make the ink unmount, it will no longer
	        // have a debug id in the TransitionGroup and it displays a warning. Adding a 1ms timeout
	        // fixes that issue... It only happens on an actual click instead of an enter click.
	        setTimeout(function () {
	          _this._container.click();
	        }, 1);
	      }
	
	      _this._clicked = false;
	    }, _this._handleKeyDown = function (e) {
	      var key = e.which || e.keyCode;
	      var enter = key === _keyCodes.ENTER;
	      var space = key === _keyCodes.SPACE;
	      // Don't trigger ink when enter key is pressed and the target has an input inside of it (SelectField)
	      if (space || enter && !(0, _isFormPartRole2.default)(e.target) && !e.target.querySelector('input')) {
	        _this._clicked = true;
	        _this.createInk();
	        _this._maybeDelayClick();
	      }
	    }, _this._handleFocus = function () {
	      if (_this._clicked) {
	        return;
	      }
	
	      _this._createInk();
	      _this._getKeyboardContainer().addEventListener('blur', _this._handleBlur);
	    }, _this._handleBlur = function () {
	      _this._getKeyboardContainer().removeEventListener('blur', _this._handleBlur);
	      _this._removeInk();
	    }, _this._handleMouseDown = function (e) {
	      _this._clicked = true;
	      if (!(0, _isValidClick2.default)(e) || _this._skipNextMouse) {
	        _this._skipNextMouse = false;
	        return;
	      }
	
	      _this._mouseLeave = false;
	      _this._container.addEventListener('mouseleave', _this._handleMouseLeave);
	      _this._createInk(e.pageX, e.pageY);
	    }, _this._handleMouseLeave = function () {
	      _this._container.removeEventListener('mouseleave', _this._handleMouseLeave);
	      _this._mouseLeave = true;
	      _this._removeInk();
	    }, _this._handleMouseUp = function () {
	      if (_this._mouseLeave) {
	        return;
	      }
	
	      _this._maybeDelayClick();
	      _this._container.removeEventListener('mouseleave', _this._handleMouseLeave);
	      _this._removeInk();
	    }, _this._handleTouchStart = function (e) {
	      _this._aborted = false;
	      _this._clicked = true;
	      _this._skipNextMouse = true;
	      (0, _touches.addTouchEvent)(window, 'move', _this._handleTouchMove);
	
	      var _e$changedTouches$ = e.changedTouches[0],
	          pageX = _e$changedTouches$.pageX,
	          pageY = _e$changedTouches$.pageY;
	
	      _this._createInk(pageX, pageY);
	    }, _this._handleTouchMove = function () {
	      (0, _touches.removeTouchEvent)(window, 'move', _this._handleTouchMove);
	      var lastInk = _this.state.inks[_this.state.inks.length - 1];
	      if (!lastInk || Date.now() > lastInk.key + 200) {
	        _this._aborted = false;
	        return;
	      }
	
	      var inks = _this.state.inks.slice();
	      var index = inks.length - 1;
	
	      var abortedInk = Object.assign({}, lastInk, { aborted: true });
	      inks.splice(index, 1, abortedInk);
	
	      _this._aborted = true;
	      _this.setState({ inks: inks }, _this._removeInk);
	    }, _this._handleTouchEnd = function () {
	      _this._skipNextMouse = true;
	
	      if (_this._aborted) {
	        return;
	      } else {
	        (0, _touches.removeTouchEvent)(window, 'move', _this._handleTouchMove);
	      }
	
	      _this._removeInk();
	    }, _this._handleSubmit = function (e) {
	      if (document.activeElement === _this._container || !e.target.contains(_this._container)) {
	        return;
	      }
	
	      _this._maybeDelayClick();
	      _this.createInk();
	    }, _this._stopPropagationToFocus = function (e) {
	      switch (e.type) {
	        case 'touchstart':
	          (0, _touches.addTouchEvent)(window, 'end', _this._stopPropagationToFocus, { capture: true });
	          break;
	        case 'touchend':
	          (0, _touches.removeTouchEvent)(window, 'end', _this._stopPropagationToFocus, { capture: true });
	          break;
	        case 'mousedown':
	          window.addEventListener('mouseup', _this._stopPropagationToFocus, true);
	          break;
	        case 'mouseup':
	          window.removeEventListener('mouseup', _this._stopPropagationToFocus, true);
	          break;
	        default:
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InkContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var di = this.props.disabledInteractions;
	      var ndi = nextProps.disabledInteractions;
	
	      if (di === ndi || !this._container) {
	        return;
	      }
	
	      var mouseDisabledDiff = this._isListenerDisabledDiff('mouse', di, ndi);
	      var touchDisabledDiff = this._isListenerDisabledDiff('touch', di, ndi);
	      var keyboardDisabledDiff = this._isListenerDisabledDiff('keyboard', di, ndi);
	      this._initOrRemoveEvents(nextProps, keyboardDisabledDiff, mouseDisabledDiff, touchDisabledDiff);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._removeTimeout) {
	        clearTimeout(this._removeTimeout);
	      }
	
	      if (this._container) {
	        this._initOrRemoveEvents({ disabledInteractions: ['keyboard', 'mouse', 'touch'] });
	        this._getKeyboardContainer().removeEventListener('blur', this._handleBlur);
	      }
	    }
	
	    /**
	     * Creates an ink from pageX and pageY coordinates. These values should either come
	     * from the `changedTouches` or just the base event (if clicked). These coordinates
	     * are used to position the ink correctly in the container from touch/click point.
	     * If either value is undefined, an ink will be created from the center of the
	     * container.
	     *
	     * It will also automatically remove the ink.
	     *
	     * @param {number} pageX - The page x coordinate of the click or touch event.
	     * @param {number} pageY - The page y coordinate of the click or touch event.
	     */
	
	
	    /**
	     * Focuses the main element.
	     */
	
	  }, {
	    key: '_isListenerDisabledDiff',
	    value: function _isListenerDisabledDiff(interaction, disabledInteractions, nextDisabledInteractions) {
	      var i = disabledInteractions.indexOf(interaction);
	      var ni = nextDisabledInteractions.indexOf(interaction);
	
	      return i < 0 && ni >= 0 || i >= 0 && ni < 0;
	    }
	  }, {
	    key: '_isListenerDisabled',
	    value: function _isListenerDisabled(interaction, disabledInteractions) {
	      return disabledInteractions && disabledInteractions.indexOf(interaction) !== -1;
	    }
	
	    /**
	     * Creates an ink from pageX and pageY coordinates. These values should either come
	     * from the `changedTouches` or just the base event (if clicked). These coordinates
	     * are used to position the ink correctly in the container from touch/click point.
	     * If either value is undefined, an ink will be created from the center of the
	     * container.
	     *
	     * @param {number} pageX - The page x coordinate of the click or touch event.
	     * @param {number} pageY - The page y coordinate of the click or touch event.
	     */
	
	
	    /**
	     * Removes an ink from the container.
	     */
	
	
	    /**
	     * Gets the container for any keyboard events. This will almost always be the main element,
	     * but text fields will need to be the input itself.
	     */
	
	
	    /**
	     * Sets the ink container and the main container from the ref callback. When the component
	     * is mounting, the keyboard, mouse, and keyboard events will be initialized.
	     */
	
	
	    /**
	     * This function will either add or remove the event listeners for creating inks.
	     *
	     * @param {Object} props - The current props to use for figuring out if the events should
	     *    be added or removed.
	     * @param {bool=} keyboardDiff - Boolean if there was a difference between the current props and either
	     *    the previous or next props for the keyboard interactions being disabled.
	     * @param {bool=} mouseDiff - Boolean if there was a difference between the current props and either
	     *    the previous or next props for the mouse interactions being disabled.
	     * @param {bool=} touchDiff - Boolean if there was a difference between the current props and either
	     *    the previous or next props for the touch interactions being disabled.
	     */
	
	
	    /**
	     * If a form was submitted that contains the container of the ink and the current focus element
	     * is not the container, trigger an ink effect.
	     *
	     * The current focus check is added so that two inks are not created.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          inkStyle = _props.inkStyle,
	          inkClassName = _props.inkClassName,
	          transitionOverlap = _props.transitionOverlap,
	          transitionEnterTimeout = _props.transitionEnterTimeout,
	          transitionLeaveTimeout = _props.transitionLeaveTimeout,
	          pulse = _props.pulse;
	
	      var inks = this.state.inks.map(function (props) {
	        return _react2.default.createElement(_Ink2.default, _extends({}, props, {
	          pulse: pulse,
	          style: inkStyle,
	          className: inkClassName,
	          onRemove: _this2._handleRemove,
	          transitionOverlap: transitionOverlap,
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout
	        }));
	      });
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        {
	          component: 'div',
	          style: style,
	          className: (0, _classnames2.default)('md-ink-container', className),
	          ref: this._setContainers
	        },
	        inks
	      );
	    }
	  }]);
	
	  return InkContainer;
	}(_react.PureComponent);
	
	InkContainer.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  inkStyle: _propTypes2.default.object,
	  inkClassName: _propTypes2.default.string,
	  waitForInkTransition: _propTypes2.default.bool,
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'mouse', 'touch'])),
	  transitionOverlap: _propTypes2.default.number.isRequired,
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	  pulse: _propTypes2.default.bool
	};
	InkContainer.defaultProps = {
	  transitionOverlap: 150,
	  transitionEnterTimeout: 450,
	  transitionLeaveTimeout: 300
	};
	exports.default = InkContainer;
	//# sourceMappingURL=InkContainer.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.injectInk = undefined;
	
	var _injectInk2 = __webpack_require__(92);
	
	var _injectInk3 = _interopRequireDefault(_injectInk2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _injectInk3.default;
	exports.injectInk = _injectInk3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  inkDisabled: _propTypes2.default.bool,
	  inkDisabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'mouse', 'touch']))
	};
	//# sourceMappingURL=inkContextTypes.js.map

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _ListItemText = __webpack_require__(146);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _TileAddon = __webpack_require__(93);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItemControl = function (_PureComponent) {
	  _inherits(ListItemControl, _PureComponent);
	
	  function ListItemControl() {
	    _classCallCheck(this, ListItemControl);
	
	    return _possibleConstructorReturn(this, (ListItemControl.__proto__ || Object.getPrototypeOf(ListItemControl)).apply(this, arguments));
	  }
	
	  _createClass(ListItemControl, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          tileStyle = _props.tileStyle,
	          tileClassName = _props.tileClassName,
	          primaryAction = _props.primaryAction,
	          secondaryAction = _props.secondaryAction,
	          primaryText = _props.primaryText,
	          secondaryText = _props.secondaryText,
	          threeLines = _props.threeLines,
	          leftIcon = _props.leftIcon,
	          leftAvatar = _props.leftAvatar,
	          rightIcon = _props.rightIcon,
	          rightAvatar = _props.rightAvatar,
	          props = _objectWithoutProperties(_props, ['className', 'tileStyle', 'tileClassName', 'primaryAction', 'secondaryAction', 'primaryText', 'secondaryText', 'threeLines', 'leftIcon', 'leftAvatar', 'rightIcon', 'rightAvatar']);
	
	      var control = _react.Children.only(primaryAction || secondaryAction);
	      var text = _react2.default.createElement(_ListItemText2.default, {
	        key: 'text',
	        primaryText: control.props.label || primaryText,
	        secondaryText: secondaryText,
	        className: (0, _classnames2.default)({
	          'md-tile-content--left-icon': leftIcon,
	          'md-tile-content--left-avatar': leftAvatar,
	          'md-tile-content--left-button': primaryAction,
	          'md-tile-content--right-padding': primaryAction
	        })
	      });
	      control = (0, _react.cloneElement)(control, {
	        className: (0, _classnames2.default)('md-list-control', {
	          'md-list-control--right': secondaryAction
	        }, control.props.className),
	        label: text
	      });
	
	      var leftNode = _react2.default.createElement(_TileAddon2.default, {
	        key: 'left-addon',
	        icon: leftIcon,
	        avatar: leftAvatar
	      });
	
	      var rightNode = _react2.default.createElement(_TileAddon2.default, {
	        key: 'right-addon',
	        icon: rightIcon,
	        avatar: rightAvatar
	      });
	
	      var icond = !!leftIcon || !!rightIcon;
	      var avatard = !!leftAvatar || !!rightAvatar;
	
	      return _react2.default.createElement(
	        'li',
	        _extends({}, props, { className: (0, _classnames2.default)('md-list-item', className) }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: tileStyle,
	            className: (0, _classnames2.default)('md-list-tile', {
	              'md-list-tile--icon': !secondaryText && icond && !avatard,
	              'md-list-tile--avatar': !secondaryText && avatard,
	              'md-list-tile--two-lines': secondaryText && !threeLines,
	              'md-list-tile--three-lines': secondaryText && threeLines,
	              'md-list-tile--control-left': primaryAction,
	              'md-list-tile--control-right': secondaryAction
	            }, (0, _themeColors2.default)({ text: true }), tileClassName)
	          },
	          leftNode,
	          control,
	          rightNode
	        )
	      );
	    }
	  }]);
	
	  return ListItemControl;
	}(_react.PureComponent);
	
	ListItemControl.propTypes = {
	  /**
	   * An optional style to apply to the `.md-list-item`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `.md-list-item`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `.md-list-tile`.
	   */
	  tileStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `.md-list-tile`.
	   */
	  tileClassName: _propTypes2.default.string,
	
	  /**
	   * The primary text to display in the `ListItemControl`. The `primaryAction` or
	   * `secondaryAction` will end up getting the `label` prop injected into it with
	   * a combination of the `primaryText` and `secondaryText`. If the `primaryAction`
	   * or `secondaryAction` already have a label prop, the `label` prop will be used
	   * as the `primaryText`.
	   */
	  primaryText: _propTypes2.default.node,
	
	  /**
	   * An optional secondary text that can be displayed in the label of the `primaryAction`
	   * or `secondaryAction`.
	   */
	  secondaryText: _propTypes2.default.node,
	
	  /**
	   * Boolean if the primary and secondary text will span three lines.
	   */
	  threeLines: _propTypes2.default.bool,
	
	  /**
	   * The primary action of the `ListItemControl`. This _should_ normally
	   * be a type of `SelectionControl`
	   */
	  primaryAction: _propTypes2.default.element,
	
	  /**
	   * The secondary action of the `ListItemControl`. This _should_ normally
	   * be a type of `SelectionControl`. If it is a selection control,
	   * make sure to add the `labelBefore` prop to get correct positioning.
	   */
	  secondaryAction: _propTypes2.default.element,
	
	  /**
	   * An optional `FontIcon` to display to the left of the action.
	   */
	  leftIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the left of the action.
	   */
	  leftAvatar: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the right of the action.
	   */
	  rightIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the right of the action.
	   */
	  rightAvatar: _propTypes2.default.node,
	
	  /**
	   * Defines the number of items in the list. This is only required when all items in the
	   * list are not present in the DOM.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-setsize
	   */
	  'aria-setsize': _propTypes2.default.number,
	
	  /**
	   * Defines the items position in the list. This is only required when all items in the list
	   * are not present in the DOM. The custom validation just requires this prop if the `aria-setsize`
	   * prop is defined as a helpful reminder.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-posinset
	   */
	  'aria-posinset': function ariaPosinset(props, propName) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var validator = _propTypes2.default.number;
	    if (typeof props['aria-setsize'] !== 'undefined') {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName].concat(args));
	  }
	};
	exports.default = ListItemControl;
	//# sourceMappingURL=ListItemControl.js.map

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListItemControl = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(51);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(71);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _ListItemControl2 = __webpack_require__(283);
	
	var _ListItemControl3 = _interopRequireDefault(_ListItemControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _List3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.ListItemControl = _ListItemControl3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MediaOverlay = exports.Media = undefined;
	
	var _Media2 = __webpack_require__(147);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MediaOverlay2 = __webpack_require__(148);
	
	var _MediaOverlay3 = _interopRequireDefault(_MediaOverlay2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Media3.default;
	exports.Media = _Media3.default;
	exports.MediaOverlay = _MediaOverlay3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuButton = exports.DropdownMenu = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(46);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _DropdownMenu2 = __webpack_require__(94);
	
	var _DropdownMenu3 = _interopRequireDefault(_DropdownMenu2);
	
	var _MenuButton2 = __webpack_require__(149);
	
	var _MenuButton3 = _interopRequireDefault(_MenuButton2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Menu3.default;
	exports.Menu = _Menu3.default;
	exports.DropdownMenu = _DropdownMenu3.default;
	exports.MenuButton = _MenuButton3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleFakeInkedButton = __webpack_require__(25);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _TileAddon = __webpack_require__(93);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MiniListItem = function (_PureComponent) {
	  _inherits(MiniListItem, _PureComponent);
	
	  function MiniListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MiniListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MiniListItem.__proto__ || Object.getPrototypeOf(MiniListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ active: true });
	      }
	    }, _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ active: false });
	      }
	    }, _this._handleTouchStart = function (e) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(e);
	      }
	
	      _this._touched = true;
	
	      _this.setState({ active: true, touchedAt: Date.now() });
	    }, _this._handleTouchEnd = function (e) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(e);
	      }
	
	      var time = Date.now() - _this.state.touchedAt;
	      _this._touchTimeout = setTimeout(function () {
	        _this._touchTimeout = null;
	
	        _this.setState({ active: false });
	      }, time > 450 ? 0 : 450 - time);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MiniListItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._touchTimeout) {
	        clearTimeout(this._touchTimeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          tileStyle = _props.tileStyle,
	          tileClassName = _props.tileClassName,
	          leftIcon = _props.leftIcon,
	          leftAvatar = _props.leftAvatar,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          ItemComponent = _props.itemComponent,
	          primaryText = _props.primaryText,
	          secondaryText = _props.secondaryText,
	          rightIcon = _props.rightIcon,
	          rightAvatar = _props.rightAvatar,
	          threeLines = _props.threeLines,
	          children = _props.children,
	          defaultOpen = _props.defaultOpen,
	          isOpen = _props.isOpen,
	          inset = _props.inset,
	          nestedItems = _props.nestedItems,
	          animateNestedItems = _props.animateNestedItems,
	          expanderIcon = _props.expanderIcon,
	          expanderIconChildren = _props.expanderIconChildren,
	          expanderIconClassName = _props.expanderIconClassName,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'leftIcon', 'leftAvatar', 'active', 'activeClassName', 'itemComponent', 'primaryText', 'secondaryText', 'rightIcon', 'rightAvatar', 'threeLines', 'children', 'defaultOpen', 'isOpen', 'inset', 'nestedItems', 'animateNestedItems', 'expanderIcon', 'expanderIconChildren', 'expanderIconClassName']);
	
	      return _react2.default.createElement(
	        ItemComponent,
	        { style: style, className: className },
	        _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          _extends({}, props, {
	            style: tileStyle,
	            className: (0, _classnames2.default)('md-list-tile md-list-tile--icon md-list-tile--mini', {
	              'md-list-tile--active': this.state.active && !this._touched
	            }, tileClassName),
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave,
	            onTouchStart: this._handleTouchStart,
	            onTouchEnd: this._handleTouchEnd
	          }),
	          _react2.default.createElement(_TileAddon2.default, {
	            active: active,
	            activeClassName: activeClassName,
	            icon: leftIcon,
	            avatar: leftAvatar
	          })
	        )
	      );
	    }
	  }]);
	
	  return MiniListItem;
	}(_react.PureComponent);
	
	MiniListItem.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  tileStyle: _propTypes2.default.object,
	  tileClassName: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  leftIcon: _propTypes2.default.node,
	  leftAvatar: _propTypes2.default.node,
	  disabled: _propTypes2.default.bool,
	  onTouchStart: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  defaultOpen: _propTypes2.default.bool,
	  itemComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	MiniListItem.defaultProps = {
	  activeClassName: 'md-text--theme-primary',
	  component: 'div',
	  itemComponent: 'li'
	};
	exports.default = MiniListItem;
	//# sourceMappingURL=MiniListItem.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _invalidIf = __webpack_require__(37);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Drawer = __webpack_require__(91);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _List = __webpack_require__(51);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Toolbar = __webpack_require__(162);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _isType = __webpack_require__(137);
	
	var _JumpToContentLink = __webpack_require__(151);
	
	var _JumpToContentLink2 = _interopRequireDefault(_JumpToContentLink);
	
	var _CloseButton = __webpack_require__(150);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _MiniListItem = __webpack_require__(287);
	
	var _MiniListItem2 = _interopRequireDefault(_MiniListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DrawerTypes = _Drawer2.default.DrawerTypes;
	
	
	function getNonMiniType(type) {
	  var pMini = DrawerTypes.PERSISTENT_MINI,
	      tMini = DrawerTypes.TEMPORARY_MINI;
	
	  if ([pMini, tMini].indexOf(type) === -1) {
	    return type;
	  }
	
	  return pMini === type ? DrawerTypes.PERSISTENT : DrawerTypes.TEMPORARY;
	}
	
	function toMiniListItem(item, index) {
	  if ((0, _react.isValidElement)(item)) {
	    return item;
	  }
	
	  var divider = item.divider,
	      subheader = item.subheader,
	      key = item.key,
	      itemProps = _objectWithoutProperties(item, ['divider', 'subheader', 'key']);
	
	  if (divider || subheader) {
	    return null;
	  }
	
	  return _react2.default.createElement(_MiniListItem2.default, _extends({ key: key || index }, itemProps));
	}
	
	/**
	 * The `NavigationDrawer` is used when you want a full layout configuration. It is a combination
	 * of the `Toolbar` component and the `Drawer` component. Any props that are not specifically
	 * listed below will be provided to the `Drawer` component. So if there are props on the `Drawer`
	 * that are not listed here, they will be passed along.
	 *
	 * The main benefit of using this component is that it will manage adding respective offset
	 * classes automatically for you to the content and the drawer. It will also manage using
	 * a mini drawer type for you.
	 */
	
	var NavigationDrawer = function (_PureComponent) {
	  _inherits(NavigationDrawer, _PureComponent);
	
	  _createClass(NavigationDrawer, null, [{
	    key: 'getCurrentMedia',
	
	
	    /**
	     * Determines the current media and returns an object containing matches for `mobile`, `tablet`, `desktop`,
	     * and the current drawer type. This expects a `props` object of the drawer.
	     *
	     * If this is used server side, it will default to only matching mobile.
	     *
	     * @param {Object=} props - The current drawer's prop shape to extract the mobile, tablet, and desktop type/min
	     *    widths. This defaults to the drawer's default props.
	     * @return {Object} an object containing the media matches and the current type to use for the drawer.
	     */
	    value: function getCurrentMedia() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NavigationDrawer.defaultProps;
	
	      var mobileType = props.mobileDrawerType,
	          tabletType = props.tabletDrawerType,
	          desktopType = props.desktopDrawerType,
	          constantType = props.constantDrawerType,
	          others = _objectWithoutProperties(props, ['mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'constantDrawerType']);
	
	      return _Drawer2.default.getCurrentMedia(_extends({ mobileType: mobileType, tabletType: tabletType, desktopType: desktopType, constantType: constantType }, others));
	    }
	  }]);
	
	  function NavigationDrawer(props) {
	    _classCallCheck(this, NavigationDrawer);
	
	    var _this = _possibleConstructorReturn(this, (NavigationDrawer.__proto__ || Object.getPrototypeOf(NavigationDrawer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultMedia = props.defaultMedia,
	        defaultVisible = props.defaultVisible,
	        initialDrawerType = props.initialDrawerType;
	
	
	    _this.state = {
	      mobile: initialDrawerType || defaultMedia === 'mobile',
	      tablet: initialDrawerType || defaultMedia === 'tablet',
	      desktop: initialDrawerType || defaultMedia === 'desktop'
	    };
	
	    if (typeof props.drawerType === 'undefined') {
	      _this.state.drawerType = props[(initialDrawerType || defaultMedia) + 'DrawerType'];
	    }
	
	    var type = (0, _getField2.default)(props, _this.state, 'drawerType');
	
	    if (typeof props.visible === 'undefined') {
	      // The logic for determining the visibility is handled by the created mini drawer
	      _this.state.visible = (0, _isType.isPermanent)(type);
	      if (!_this.state.visible && typeof defaultVisible !== 'undefined') {
	        _this.state.visible = defaultVisible;
	      }
	    }
	    return _this;
	  }
	
	  _createClass(NavigationDrawer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          persistentIcon = _props.persistentIcon,
	          id = _props.contentId,
	          label = _props.jumpLabel,
	          persistentIconChildren = _props.persistentIconChildren,
	          persistentIconClassName = _props.persistentIconClassName,
	          closeIconChildren = _props.closeIconChildren,
	          closeIconClassName = _props.closeIconClassName;
	
	
	      return {
	        id: id,
	        label: label,
	        closeIcon: (0, _getDeprecatedIcon2.default)(closeIconClassName || persistentIconClassName, closeIconChildren || persistentIconChildren, persistentIcon),
	        onCloseClick: this._toggleVisibility,
	        renderNode: this.context.renderNode
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      var nVisible = (0, _getField2.default)(nextProps, this.state, 'visible');
	      if (visible !== nVisible) {
	        this._animate(nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          style = _props2.style,
	          className = _props2.className,
	          toolbarStyle = _props2.toolbarStyle,
	          toolbarClassName = _props2.toolbarClassName,
	          drawerStyle = _props2.drawerStyle,
	          drawerClassName = _props2.drawerClassName,
	          contentStyle = _props2.contentStyle,
	          contentClassName = _props2.contentClassName,
	          Content = _props2.contentComponent,
	          miniDrawerStyle = _props2.miniDrawerStyle,
	          miniDrawerClassName = _props2.miniDrawerClassName,
	          miniNavStyle = _props2.miniNavStyle,
	          miniNavClassName = _props2.miniNavClassName,
	          miniDrawerId = _props2.miniDrawerId,
	          miniNavItemsId = _props2.miniNavItemsId,
	          navItems = _props2.navItems,
	          children = _props2.children,
	          drawerId = _props2.drawerId,
	          drawerTitle = _props2.drawerTitle,
	          drawerZDepth = _props2.drawerZDepth,
	          drawerChildren = _props2.drawerChildren,
	          drawerHeaderChildren = _props2.drawerHeaderChildren,
	          drawerTransitionDuration = _props2.drawerTransitionDuration,
	          toolbarId = _props2.toolbarId,
	          toolbarTitle = _props2.toolbarTitle,
	          toolbarTitleMenu = _props2.toolbarTitleMenu,
	          toolbarTitleStyle = _props2.toolbarTitleStyle,
	          toolbarTitleClassName = _props2.toolbarTitleClassName,
	          toolbarActions = _props2.toolbarActions,
	          toolbarProminent = _props2.toolbarProminent,
	          toolbarProminentTitle = _props2.toolbarProminentTitle,
	          toolbarThemeType = _props2.toolbarThemeType,
	          toolbarSingleColor = _props2.toolbarSingleColor,
	          toolbarChildren = _props2.toolbarChildren,
	          toolbarZDepth = _props2.toolbarZDepth,
	          mobileType = _props2.mobileDrawerType,
	          tabletType = _props2.tabletDrawerType,
	          desktopType = _props2.desktopDrawerType,
	          transitionName = _props2.transitionName,
	          transitionEnterTimeout = _props2.transitionEnterTimeout,
	          transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	          extractMini = _props2.extractMini,
	          miniDrawerHeader = _props2.miniDrawerHeader,
	          miniDrawerChildren = _props2.miniDrawerChildren,
	          footer = _props2.footer,
	          includeDrawerHeader = _props2.includeDrawerHeader,
	          contentId = _props2.contentId,
	          contentProps = _props2.contentProps,
	          constantDrawerType = _props2.constantDrawerType,
	          temporaryIcon = _props2.temporaryIcon,
	          temporaryIconChildren = _props2.temporaryIconChildren,
	          temporaryIconClassName = _props2.temporaryIconClassName,
	          menuIconChildren = _props2.menuIconChildren,
	          menuIconClassName = _props2.menuIconClassName,
	          propDrawerType = _props2.drawerType,
	          propDrawerHeader = _props2.drawerHeader,
	          propRenderNode = _props2.renderNode,
	          jumpLabel = _props2.jumpLabel,
	          persistentIcon = _props2.persistentIcon,
	          onDrawerChange = _props2.onDrawerChange,
	          closeIconChildren = _props2.closeIconChildren,
	          closeIconClassName = _props2.closeIconClassName,
	          persistentIconChildren = _props2.persistentIconChildren,
	          persistentIconClassName = _props2.persistentIconClassName,
	          props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'toolbarStyle', 'toolbarClassName', 'drawerStyle', 'drawerClassName', 'contentStyle', 'contentClassName', 'contentComponent', 'miniDrawerStyle', 'miniDrawerClassName', 'miniNavStyle', 'miniNavClassName', 'miniDrawerId', 'miniNavItemsId', 'navItems', 'children', 'drawerId', 'drawerTitle', 'drawerZDepth', 'drawerChildren', 'drawerHeaderChildren', 'drawerTransitionDuration', 'toolbarId', 'toolbarTitle', 'toolbarTitleMenu', 'toolbarTitleStyle', 'toolbarTitleClassName', 'toolbarActions', 'toolbarProminent', 'toolbarProminentTitle', 'toolbarThemeType', 'toolbarSingleColor', 'toolbarChildren', 'toolbarZDepth', 'mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'extractMini', 'miniDrawerHeader', 'miniDrawerChildren', 'footer', 'includeDrawerHeader', 'contentId', 'contentProps', 'constantDrawerType', 'temporaryIcon', 'temporaryIconChildren', 'temporaryIconClassName', 'menuIconChildren', 'menuIconClassName', 'drawerType', 'drawerHeader', 'renderNode', 'jumpLabel', 'persistentIcon', 'onDrawerChange', 'closeIconChildren', 'closeIconClassName', 'persistentIconChildren', 'persistentIconClassName']);
	
	      var drawerHeader = this.props.drawerHeader;
	      var _state = this.state,
	          desktop = _state.desktop,
	          tablet = _state.tablet,
	          contentActive = _state.contentActive;
	
	
	      var drawerType = (0, _getField2.default)(this.props, this.state, 'drawerType');
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	      var mini = (0, _isType.isMini)(drawerType);
	      var temporary = (0, _isType.isTemporary)(drawerType);
	      var persistent = (0, _isType.isPersistent)(drawerType);
	      var clipped = drawerType === DrawerTypes.CLIPPED;
	      var floating = drawerType === DrawerTypes.FLOATING;
	
	      var offset = desktop || tablet ? !temporary && visible : visible;
	      var toolbarRelative = (0, _classnames2.default)({
	        'md-toolbar-relative': !toolbarProminent && !toolbarProminentTitle,
	        'md-toolbar-relative--prominent': toolbarProminent || toolbarProminentTitle
	      });
	
	      var nav = void 0;
	      if (temporary || persistent) {
	        nav = _react2.default.createElement(_Button2.default, {
	          key: 'nav',
	          onClick: this._toggleVisibility,
	          disabled: persistent && visible,
	          icon: true,
	          iconEl: (0, _getDeprecatedIcon2.default)(menuIconClassName || temporaryIconClassName, menuIconChildren || temporaryIconChildren, temporaryIcon)
	        });
	      }
	
	      var closeButton = void 0;
	      if (persistent) {
	        closeButton = _react2.default.createElement(_CloseButton2.default, null);
	      }
	
	      if (!drawerHeader && includeDrawerHeader) {
	        drawerHeader = _react2.default.createElement(
	          _Toolbar2.default,
	          {
	            key: 'drawer-header',
	            title: drawerTitle,
	            actions: visible && nav ? closeButton : null,
	            className: (0, _classnames2.default)('md-divider-border md-divider-border--bottom', _defineProperty({}, toolbarRelative, clipped || floating))
	          },
	          drawerHeaderChildren,
	          _react2.default.createElement(_JumpToContentLink2.default, null)
	        );
	      }
	      var miniDrawer = void 0;
	      if (mini) {
	        var miniList = void 0;
	        if (extractMini) {
	          miniList = _react2.default.createElement(
	            _List2.default,
	            {
	              id: miniNavItemsId,
	              key: 'mini-nav-items',
	              style: miniNavStyle,
	              className: (0, _classnames2.default)(miniNavClassName, toolbarRelative)
	            },
	            navItems.map(toMiniListItem)
	          );
	        }
	
	        miniDrawer = _react2.default.createElement(
	          _Drawer2.default,
	          {
	            id: miniDrawerId,
	            key: 'mini-drawer',
	            type: drawerType,
	            renderNode: renderNode,
	            'aria-hidden': visible,
	            style: miniDrawerStyle,
	            className: miniDrawerClassName
	          },
	          miniDrawerHeader,
	          miniList,
	          miniDrawerChildren
	        );
	      }
	
	      var desktopOffset = !clipped && !floating && offset;
	
	      return _react2.default.createElement(
	        'div',
	        { id: id, style: style, className: className },
	        _react2.default.createElement(
	          _Toolbar2.default,
	          {
	            id: toolbarId,
	            colored: toolbarThemeType === 'colored',
	            themed: toolbarThemeType === 'themed',
	            singleColor: toolbarSingleColor,
	            style: toolbarStyle,
	            className: (0, _classnames2.default)({
	              'md-toolbar--over-drawer': clipped || floating || mini && !visible
	            }, toolbarClassName),
	            title: toolbarTitle,
	            titleMenu: toolbarTitleMenu,
	            prominent: toolbarProminent,
	            prominentTitle: toolbarProminentTitle,
	            titleStyle: toolbarTitleStyle,
	            titleClassName: (0, _classnames2.default)({
	              'md-title--drawer-active': contentActive,
	              'md-transition--deceleration': offset && visible,
	              'md-transition--acceleration': offset && !visible,
	              'md-title--permanent-offset': desktopOffset && (0, _isType.isPermanent)(drawerType),
	              'md-title--persistent-offset': desktopOffset && persistent
	            }, toolbarTitleClassName),
	            nav: nav,
	            actions: toolbarActions,
	            fixed: true,
	            zDepth: toolbarZDepth
	          },
	          toolbarChildren
	        ),
	        miniDrawer,
	        _react2.default.createElement(
	          _Drawer2.default,
	          _extends({}, props, {
	            id: drawerId,
	            constantType: constantDrawerType,
	            transitionDuration: drawerTransitionDuration,
	            header: drawerHeader,
	            style: drawerStyle,
	            className: drawerClassName,
	            navItems: navItems,
	            renderNode: renderNode,
	            mobileType: mobileType,
	            tabletType: tabletType,
	            desktopType: desktopType,
	            type: getNonMiniType(drawerType),
	            visible: visible,
	            zDepth: drawerZDepth,
	            onVisibilityChange: this._handleVisibility,
	            onMediaTypeChange: this._handleTypeChange
	          }),
	          drawerChildren
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          _extends({}, contentProps, {
	            id: contentId,
	            component: Content,
	            transitionName: transitionName,
	            transitionEnter: !!transitionEnterTimeout,
	            transitionEnterTimeout: transitionEnterTimeout,
	            transitionLeave: !!transitionLeaveTimeout,
	            transitionLeaveTimeout: transitionLeaveTimeout,
	            tabIndex: -1,
	            style: contentStyle,
	            className: (0, _classnames2.default)('md-navigation-drawer-content', {
	              'md-navigation-drawer-content--active': contentActive,
	              'md-navigation-drawer-content--inactive': !visible,
	              'md-navigation-drawer-content--prominent-offset': toolbarProminent || toolbarProminentTitle,
	              'md-transition--deceleration': visible,
	              'md-transition--acceleration': !visible,
	              'md-drawer-relative': offset,
	              'md-drawer-relative--mini': mini && (!visible || temporary)
	            }, toolbarRelative, contentClassName)
	          }),
	          children
	        ),
	        footer
	      );
	    }
	  }]);
	
	  return NavigationDrawer;
	}(_react.PureComponent);
	
	NavigationDrawer.DrawerType = { // deprecated
	  /* eslint-disable no-console */
	  _warned: false,
	  _msg: 'Invalid use of `NavigationDrawer.DrawerType.{{TYPE}}`. The `NavigationDrawer.DrawerType` ' + 'has been deprecated and will be removed in the next major release. Please use the ' + '`NavigationDrawer.DrawerTypes.{{TYPE}}` instead.',
	
	  get FULL_HEIGHT() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'FULL_HEIGHT'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.FULL_HEIGHT;
	  },
	
	  get CLIPPED() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'CLIPPED'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.CLIPPED;
	  },
	
	  get FLOATING() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'FLOATING'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.FLOATING;
	  },
	
	  get PERSISTENT() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.PERSISTENT;
	  },
	
	  get PERSISTENT_MINI() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT_MINI'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.PERSISTENT_MINI;
	  },
	
	  get TEMPORARY() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.TEMPORARY;
	  },
	
	  get TEMPORARY_MINI() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY_MINI'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.TEMPORARY_MINI;
	  }
	};
	NavigationDrawer.DrawerTypes = DrawerTypes;
	NavigationDrawer.propTypes = {
	  /**
	   * An optional id to provide to the entire div wrapper.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the drawer. This is generally a good idea to provide if
	   * there are any `navItems` defined.
	   *
	   * @see {@link #navItemsId}
	   * @see {@link #miniDrawerId}
	   */
	  drawerId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the navItems list. If this is omitted and the `drawerId` prop is
	   * defined, it will be defaulted to `${drawerId}-nav-items`.
	   *
	   * @see {@link #drawerId}
	   * @see {@link Drawer#navItemsId}
	   */
	  navItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to apply to mini drawer that gets created when the `drawerType` is set to
	   * one of the mini types.
	   *
	   * @see {@link #drawerId}
	   * @see {@link #miniNavItemsId}
	   */
	  miniDrawerId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to apply to mini drawer's navigation list that gets created when the `drawerType`
	   * is set to one of the mini types.
	   *
	   * @see {@link #navItemsId}
	   * @see {@link #miniDrawerId}
	   */
	  miniNavItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the main toolbar.
	   */
	  toolbarId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An id to give the main content. A hidden link is created in the main drawer's header that links to the main
	   * content. This is used for keyboard only users to jump the navigation and jump straight to the content.
	   *
	   * If you provide your own `drawerHeader`, it is suggested to include the link yourself.
	   */
	  contentId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply to the surrounding container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the surrounding container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the main toolbar.
	   */
	  toolbarStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the toolbar.
	   */
	  toolbarClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the main toolbar's title.
	   */
	  toolbarTitleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the main toolbar's title.
	   */
	  toolbarTitleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the drawer.
	   */
	  drawerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the drawer.
	   */
	  drawerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `List` surrounding the `navItems`.
	   */
	  navStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `List` surrounding the `navItems`.
	   */
	  navClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the mini drawer that gets created when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerClassName}
	   * @see {@link #miniNavStyle}
	   * @see {@link #miniNavClassName}
	   */
	  miniDrawerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the mini drawer that gets created when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerStyle}
	   * @see {@link #miniNavStyle}
	   * @see {@link #miniNavClassName}
	   */
	  miniDrawerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the mini drawer's navigation list when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerStyle}
	   * @see {@link #miniDrawerClassName}
	   * @see {@link #miniNavClassName}
	   */
	  miniNavStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the mini drawer's navigation list when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerStyle}
	   * @see {@link #miniDrawerClassName}
	   * @see {@link #miniNavStyle}
	   */
	  miniNavClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the content. This is the container surrounding whatever
	   * `children` are passed in.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the content. This is the container surrounding whatever
	   * `children` are passed in.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the overlay.
	   */
	  overlayClassName: _propTypes2.default.string,
	
	  /**
	   * The children to display in the main content.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `drawerHeader` component should be built if the `drawerHeader` prop is not
	   * passed in.
	   */
	  includeDrawerHeader: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display in the drawer. This will normally be the `Toolbar` component
	   * or any other type of header. You can either use this prop with the `CloseButton` component
	   * when displaying a persistent drawer, or use the `drawerTitle` and `drawerHeaderChildren` prop
	   * to build a toolbar.
	   */
	  drawerHeader: _propTypes2.default.node,
	
	  /**
	   * An optional title to use for the drawer's header toolbar. If the `drawerHeader` prop is defined,
	   * this is invalid.
	   */
	  drawerTitle: (0, _invalidIf2.default)(_propTypes2.default.node, 'drawerHeader'),
	
	  /**
	   * An optional zDepth to apply to the drawer. If this is omitted, the value will be set as follows:
	   * - floating || inline = 1
	   * - temporary = 5
	   * - all others = 1
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  drawerZDepth: _propTypes2.default.number,
	
	  /**
	   * Any additional children to display after the `drawerHeader` and `navItems` list in the drawer.
	   */
	  drawerChildren: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display in the drawer's header `Toolbar`. If the `drawerHeader` prop is defined,
	   * this is invalid.
	   */
	  drawerHeaderChildren: (0, _invalidIf2.default)(_propTypes2.default.node, 'drawerHeader'),
	
	  /**
	   * The position for the drawer to be displayed.
	   */
	  position: _propTypes2.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * An optional list of elements or props to use to build a navigational list in the drawer.
	   * When the item is an object of props, it will build a `ListItem` component unless a key of
	   * `divider` or `subheader` is set to true. It will then create the Divider or Subheader component
	   * with any other remaining keys.
	   */
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])),
	
	  /**
	   * The drawer type to use for mobile devices.
	   */
	  mobileDrawerType: _propTypes2.default.oneOf([DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The drawer type to use for tablets.
	   */
	  tabletDrawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The drawer type to use for desktop displays.
	   */
	  desktopDrawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * An optional drawer type to enforce on all screen sizes. If the drawer type is not
	   * `temporary`, you are required to define the `onMediaTypeChange` prop to handle switching
	   * to temporary when the media matches a mobile device.
	   * ```
	   */
	  drawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]),
	
	  /**
	   * The default media match for the drawer. This will be what is displayed on first render.
	   * The component will adjust itself to the current media after it has mounted, but this
	   * is mostly used for server side rendering.
	   */
	  defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']),
	
	  /**
	   * The min width to use for a mobile media query. This prop should match the `md-mobile-min-width`
	   * variable.
	   *
	   * The media query for a mobile device will be:
	   *
	   * ```js
	   * window.matchMedia(
	   *   `screen and (min-width: ${mobileMinWidth}px) and (max-width: ${tabletMinWidth - 1}px`
	   * ).matches;
	   * ```
	   */
	  mobileMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The min width to use for a tablet media query. This prop should match the `md-tablet-min-width`
	   * variable.
	   *
	   * The media query for a tablet device will be:
	   *
	   * ```js
	   * window.matchMedia(
	   *   `screen and (min-width: ${tabletMinWidth}px) and (max-width: ${desktopWidth - 1}px`
	   * ).matches;
	   * ```
	   */
	  tabletMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The min width to use for a desktop media query. This prop should match the `md-desktop-min-width`
	   * variable.
	   *
	   * The media query for a tablet device will be:
	   *
	   * ```js
	   * window.matchMedia(`screen and (min-width: ${tabletMinWidth}px)`).matches;
	   * ```
	   */
	  desktopMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when the type of the drawer changes because of the
	   * new media queries. The callback will include the newly selected drawer type
	   * and an object containing the media matches of `mobile`, `tablet`, and `desktop`.
	   *
	   * ```js
	   * this.props.onMediaTypeChange(NavigationDrawer.DrawerTypes.TEMPORARY, {
	   *   mobile: true,
	   *   tablet: false,
	   *   desktop: false,
	   * });
	   * ```
	   */
	  onMediaTypeChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the temporary or persistent drawers are visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the temporary or persistent drawers are visible. If this is defined,
	   * it will make the component controlled and require the `onVisibilityChange` prop
	   * to be defined.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the visibility of the drawer changes. The callback
	   * will include the new visibility.
	   *
	   * ```js
	   * onVisibilityChange(false);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * A boolean if the mini drawer's list should be generated from the `navItems` prop. When building
	   * the list, it will extract the `leftIcon` or `leftAvatar` from the `navItem` and then create a
	   * mini `ListItem` containing only that icon or image. Any other event listeners will also be applied.
	   *
	   *
	   * @see {@link #miniDrawerHeader}
	   * @see {@link #miniDrawerChildren}
	   */
	  extractMini: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display in the mini drawer. This will be displayed above the optional
	   * mini nav list that get generated if the `extractMini` prop is `true` and the `miniDrawerChildren`.
	   *
	   * @see {@link #extractMini}
	   */
	  miniDrawerHeader: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display in the mini drawer. This will be displayed after the `miniDrawerHeader`
	   * and the optional mini nav list that gets generated if the `extractMini` prop is `true`.
	   *
	   * @see {@link #extractMini}
	   */
	  miniDrawerChildren: _propTypes2.default.node,
	
	  /**
	   * Boolean if the drawer should automatically close after a nav item has been clicked for `temporary` drawers.
	   */
	  autoclose: _propTypes2.default.bool,
	
	  /**
	   * An optional title to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
	   * may be defined, not both.
	   */
	  toolbarTitle: (0, _invalidIf2.default)(_propTypes2.default.node, 'toolbarTitleMenu'),
	
	  /**
	   * An optional select field menu to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
	   * may be defined, not both.
	   */
	  toolbarTitleMenu: _propTypes2.default.element,
	
	  /**
	   * The theme style for the main toolbar.
	   *
	   * @see {@link Toolbars/Toolbar}
	   */
	  toolbarThemeType: _propTypes2.default.oneOf(['default', 'colored', 'themed']).isRequired,
	
	  /**
	   * Boolean if the toolbar's nav, actions, and title should share the same color.
	   */
	  toolbarSingleColor: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the toolbar should be prominent.
	   */
	  toolbarProminent: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the toolbar's title should be prominent.
	   */
	  toolbarProminentTitle: _propTypes2.default.bool,
	
	  /**
	   * A list of elements or a single element to display to the right of the
	   * toolbar's nav, title, and children.
	   *
	   * @see {@link Toolbars/Toolbar#actions}
	   */
	  toolbarActions: _Toolbar2.default.propTypes.actions,
	
	  /**
	   * Any children to display in the toolbar. This will be displayed between the optional title and
	   * actions.
	   */
	  toolbarChildren: _Toolbar2.default.propTypes.children,
	
	  /**
	   * An optional zDepth to apply to the toolbar.
	   *
	   * @see {@link Toolbars/Toolbar#zDepth}
	   */
	  toolbarZDepth: _propTypes2.default.number,
	
	  /**
	   * The component to render the content in.
	   */
	  contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * An optional footer display after the main content.
	   */
	  footer: _propTypes2.default.node,
	
	  /**
	   * The icon to use to render the button that will toggle the visibility of the
	   * navigation drawer for `temporary` and `persistent` drawers. This is normally a
	   * hamburger menu.
	   */
	  temporaryIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use to render the button that appears on a persistent drawer's open
	   * header. This is used to create the `CloseButton` for drawers. When a persistent
	   * drawer is closed, the `temporaryIcon` will be used to create a button to open the drawer.
	   *
	   * If the `drawerHeader` prop is defined, you will have to either include the `CloseButton`
	   * in your header manually, or create your own controlled button to close the drawer.
	   */
	  persistentIcon: _propTypes2.default.element,
	
	  /**
	   * The transition name to use when the page's content changes. If you want to disable
	   * transitions, set both the `transitionEnterTimeout` and `transitionLeaveTimeout` props
	   * to a false-ish value. (`null`, `undefined`, or `0`).
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition enter timeout when the page's content changes. If you want to disable
	   * the enter transition, set this to a false-ish value (`null`, `undefined`, or `0`).
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition leave timeout when the page's content changes. If you want to disable
	   * the leave transition, set this to a false-ish value (`null`, `undefined`, or `0`).
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition duration for the drawer when sliding in and out of view.
	   */
	  drawerTransitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * Any additional props to provide to the main content. This will be applied before any of the generated props,
	   * so this should not include `style`, `className`, or `component`.
	   */
	  contentProps: _propTypes2.default.object,
	
	  /**
	   * The label to use for a keyboard accessibility link that jumps all the navigation and allows a user to focus
	   * the main content. This is created in the drawer's header.
	   */
	  jumpLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the drawer. The overlay that appears for temporary type drawers will still appear in the
	   * separate subtree.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the drawer into. The default is to render as
	   * the first child in the `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the drawer should be rendered as the last child instead of the first child
	   * in the `renderNode` or `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `drawerType` should remain constant across all media. This is really only valid
	   * if the `drawerType` is one of the temporary types.
	   */
	  constantDrawerType: _propTypes2.default.bool,
	
	  menuIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `temporaryIcon` instead'),
	  menuIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `temporaryIcon` instead'),
	  closeIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `persistentIcon` instead'),
	  closeIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `persistentIcon` instead'),
	  temporaryIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `temporaryIcon` instead'),
	  temporaryIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `temporaryIcon` instead.'),
	  persistentIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `persistentIcon` instead'),
	  persistentIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `persistentIcon` prop instead'),
	  onDrawerChange: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` or `onMediaTypeChange` instead'),
	  onVisibilityToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead'),
	  contentTransitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `transitionName` instead'),
	  contentTransitionEnterTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transtionEnterTimeout` instead'),
	  contentTransitionLeaveTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transtionLeaveTimeout` instead'),
	  initialDrawerType: (0, _deprecated2.default)(_propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']), 'Use `defaultMedia` instead')
	};
	NavigationDrawer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	NavigationDrawer.childContextTypes = {
	  closeIcon: _propTypes2.default.element,
	  onCloseClick: _propTypes2.default.func,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  label: _propTypes2.default.node.isRequired,
	  renderNode: _propTypes2.default.object
	};
	NavigationDrawer.defaultProps = {
	  autoclose: _Drawer2.default.defaultProps.autoclose,
	  contentId: 'main-content',
	  // Defaults to false since it keeps the state of the drawerType in sync and makes the Drawer
	  // controlled. On initial mount without any defaultMedia updates, it would always be considered
	  // temporary
	  constantDrawerType: false,
	  jumpLabel: 'Jump to content',
	  extractMini: true,
	  position: _Drawer2.default.defaultProps.position,
	  defaultMedia: _Drawer2.default.defaultProps.defaultMedia,
	  mobileDrawerType: _Drawer2.default.defaultProps.mobileType,
	  tabletDrawerType: _Drawer2.default.defaultProps.tabletType,
	  desktopDrawerType: _Drawer2.default.defaultProps.desktopType,
	  mobileMinWidth: _Drawer2.default.defaultProps.mobileMinWidth,
	  tabletMinWidth: _Drawer2.default.defaultProps.tabletMinWidth,
	  desktopMinWidth: _Drawer2.default.defaultProps.desktopMinWidth,
	  includeDrawerHeader: true,
	  contentComponent: 'main',
	  temporaryIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'menu'
	  ),
	  toolbarThemeType: 'colored',
	  persistentIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_back'
	  ),
	  transitionName: 'md-cross-fade',
	  transitionEnterTimeout: 300,
	  drawerTransitionDuration: _Drawer2.default.defaultProps.transitionDuration
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._animate = function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;
	    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.state;
	
	    if ((0, _isType.isTemporary)((0, _getField2.default)(props, state, 'drawerType'))) {
	      return;
	    }
	
	    if (_this2._timeout) {
	      clearTimeout(_this2._timeout);
	    }
	
	    _this2._timeout = setTimeout(function () {
	      _this2.setState({ contentActive: false });
	    }, props.drawerTransitionDuration);
	
	    _this2.setState({ contentActive: true });
	  };
	
	  this._toggleVisibility = function (e) {
	    var _props3 = _this2.props,
	        onVisibilityToggle = _props3.onVisibilityToggle,
	        onVisibilityChange = _props3.onVisibilityChange,
	        onDrawerChange = _props3.onDrawerChange;
	
	    var visible = !(0, _getField2.default)(_this2.props, _this2.state, 'visible');
	    var callback = onVisibilityChange || onVisibilityToggle || onDrawerChange;
	    if (callback) {
	      callback(visible, e);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	      _this2._animate(_this2.props);
	    }
	  };
	
	  this._handleVisibility = function (visible) {
	    var _props4 = _this2.props,
	        onVisibilityToggle = _props4.onVisibilityToggle,
	        onVisibilityChange = _props4.onVisibilityChange,
	        onDrawerChange = _props4.onDrawerChange;
	
	    var callback = onVisibilityChange || onVisibilityToggle || onDrawerChange;
	    if (callback) {
	      callback(visible);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	      _this2._animate(_this2.props);
	    }
	  };
	
	  this._handleTypeChange = function (drawerType, mediaState) {
	    var onMediaTypeChange = _this2.props.onMediaTypeChange;
	
	    var state = mediaState;
	    if (onMediaTypeChange) {
	      onMediaTypeChange(drawerType, mediaState);
	    }
	
	    if (typeof _this2.props.drawerType === 'undefined') {
	      state = _extends({}, mediaState, { drawerType: drawerType });
	    }
	
	    _this2.setState(state);
	  };
	};
	
	exports.default = NavigationDrawer;
	//# sourceMappingURL=NavigationDrawer.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JumpToContentLink = exports.CloseButton = exports.NavigationDrawer = undefined;
	
	var _NavigationDrawer2 = __webpack_require__(288);
	
	var _NavigationDrawer3 = _interopRequireDefault(_NavigationDrawer2);
	
	var _CloseButton2 = __webpack_require__(150);
	
	var _CloseButton3 = _interopRequireDefault(_CloseButton2);
	
	var _JumpToContentLink2 = __webpack_require__(151);
	
	var _JumpToContentLink3 = _interopRequireDefault(_JumpToContentLink2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavigationDrawer3.default;
	exports.NavigationDrawer = _NavigationDrawer3.default;
	exports.CloseButton = _CloseButton3.default;
	exports.JumpToContentLink = _JumpToContentLink3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Paper = undefined;
	
	var _Paper2 = __webpack_require__(29);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper3.default;
	exports.Paper = _Paper3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component renders a selectable date in the `CalendarMonth` component.
	 */
	var CalendarDate = function (_PureComponent) {
	  _inherits(CalendarDate, _PureComponent);
	
	  function CalendarDate(props) {
	    _classCallCheck(this, CalendarDate);
	
	    var _this = _possibleConstructorReturn(this, (CalendarDate.__proto__ || Object.getPrototypeOf(CalendarDate)).call(this, props));
	
	    _this._setFocus = function (btn) {
	      if (btn && _this.props.active) {
	        btn.focus();
	      }
	    };
	
	    _this._handleClick = function (e) {
	      _this.props.onClick(new Date(_this.props.date), e);
	    };
	
	    _this._setActive = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ desktopActive: true });
	      }
	    };
	
	    _this._setInactive = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ desktopActive: false });
	      }
	    };
	
	    _this.state = _extends({}, _this._getFormattedDate(props), { desktopActive: false });
	    return _this;
	  }
	
	  _createClass(CalendarDate, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          date = _props.date;
	
	      if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || date !== nextProps.date) {
	        this.setState(this._getFormattedDate(nextProps));
	      }
	    }
	  }, {
	    key: '_getFormattedDate',
	    value: function _getFormattedDate(_ref) {
	      var DateTimeFormat = _ref.DateTimeFormat,
	          locales = _ref.locales,
	          date = _ref.date,
	          timeZone = _ref.timeZone;
	
	      return {
	        date: new DateTimeFormat(locales, { day: 'numeric', timeZone: timeZone }).format(date)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          date = _state.date,
	          desktopActive = _state.desktopActive;
	      var _props2 = this.props,
	          disabled = _props2.disabled,
	          active = _props2.active,
	          today = _props2.today,
	          className = _props2.className;
	
	
	      var fullyActive = today && !active && !desktopActive;
	      return _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          ref: this._setFocus,
	          onFocus: this._setActive,
	          onBlur: this._setInactive,
	          onMouseOver: this._setActive,
	          onMouseLeave: this._setInactive,
	          className: (0, _classnames2.default)('md-calendar-date md-calendar-date--btn', {
	            'md-calendar-date--btn-active': active || desktopActive,
	            'md-pointer--hover': !disabled
	          }, (0, _themeColors2.default)({ disabled: disabled, primary: fullyActive }), 'md-btn', className),
	          onClick: this._handleClick,
	          disabled: disabled
	        },
	        _react2.default.createElement(
	          'span',
	          {
	            className: (0, _classnames2.default)('md-calendar-date--date', {
	              'md-picker-text--active': active || desktopActive,
	              'md-font-bold': fullyActive
	            })
	          },
	          date
	        )
	      );
	    }
	  }]);
	
	  return CalendarDate;
	}(_react.PureComponent);
	
	CalendarDate.propTypes = {
	  className: _propTypes2.default.string,
	  date: _propTypes2.default.instanceOf(Date).isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  disabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func.isRequired,
	  active: _propTypes2.default.bool,
	  today: _propTypes2.default.bool,
	  timeZone: _propTypes2.default.string.isRequired
	};
	exports.default = CalendarDate;
	//# sourceMappingURL=CalendarDate.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _isMonthBefore = __webpack_require__(357);
	
	var _isMonthBefore2 = _interopRequireDefault(_isMonthBefore);
	
	var _getDayOfWeek = __webpack_require__(166);
	
	var _getDayOfWeek2 = _interopRequireDefault(_getDayOfWeek);
	
	var _addDate = __webpack_require__(97);
	
	var _addDate2 = _interopRequireDefault(_addDate);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component renders the controls for a `DatePicker`'s Calendar.
	 * This will render a next and previous month button along with the
	 * current month/year. It also renders the abbreviiations for the days
	 * of the week.
	 */
	var CalendarHeader = function (_PureComponent) {
	  _inherits(CalendarHeader, _PureComponent);
	
	  function CalendarHeader(props) {
	    _classCallCheck(this, CalendarHeader);
	
	    var _this = _possibleConstructorReturn(this, (CalendarHeader.__proto__ || Object.getPrototypeOf(CalendarHeader)).call(this, props));
	
	    _this.state = _this._createState(props);
	    return _this;
	  }
	
	  _createClass(CalendarHeader, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          date = _props.date;
	
	      if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || date !== nextProps.date) {
	        this.setState(this._createState(nextProps));
	      }
	    }
	  }, {
	    key: '_createState',
	    value: function _createState() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	          DateTimeFormat = _ref.DateTimeFormat,
	          locales = _ref.locales,
	          date = _ref.date,
	          firstDayOfWeek = _ref.firstDayOfWeek,
	          titleFormat = _ref.titleFormat,
	          weekdayClassName = _ref.weekdayClassName,
	          weekdayFormat = _ref.weekdayFormat,
	          timeZone = _ref.timeZone;
	
	      var firstDay = (0, _getDayOfWeek2.default)(date, firstDayOfWeek);
	      var formatter = new DateTimeFormat(locales, { weekday: weekdayFormat, timeZone: timeZone });
	      var dows = [];
	      for (var i = 0; i < 7; i++) {
	        var dow = formatter.format((0, _addDate2.default)(firstDay, i, 'D'));
	        dows.push(_react2.default.createElement(
	          'h4',
	          {
	            key: i,
	            className: (0, _classnames2.default)('md-calendar-date md-calendar-dow', (0, _themeColors2.default)({ disabled: true }), weekdayClassName)
	          },
	          dow
	        ));
	      }
	
	      return {
	        dows: dows,
	        title: new DateTimeFormat(locales, _extends({}, titleFormat, { timeZone: timeZone })).format(date)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dows = _state.dows,
	          title = _state.title;
	      var _props2 = this.props,
	          date = _props2.date,
	          minDate = _props2.minDate,
	          maxDate = _props2.maxDate,
	          onPreviousClick = _props2.onPreviousClick,
	          previousIcon = _props2.previousIcon,
	          onNextClick = _props2.onNextClick,
	          nextIcon = _props2.nextIcon,
	          titleClassName = _props2.titleClassName;
	
	
	      var isPreviousDisabled = (0, _isMonthBefore2.default)(minDate, date);
	      var isNextDisabled = (0, _isMonthBefore2.default)(date, maxDate);
	      return _react2.default.createElement(
	        'header',
	        { className: 'md-calendar-header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'md-calendar-controls' },
	          _react2.default.createElement(_Button2.default, {
	            icon: true,
	            onClick: onPreviousClick,
	            disabled: isPreviousDisabled,
	            className: 'md-calendar-control',
	            iconEl: previousIcon
	          }),
	          _react2.default.createElement(
	            'h4',
	            { className: (0, _classnames2.default)('md-title', titleClassName) },
	            title
	          ),
	          _react2.default.createElement(_Button2.default, {
	            icon: true,
	            onClick: onNextClick,
	            disabled: isNextDisabled,
	            className: 'md-calendar-control',
	            iconEl: nextIcon
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'md-calendar-dows' },
	          dows
	        )
	      );
	    }
	  }]);
	
	  return CalendarHeader;
	}(_react.PureComponent);
	
	CalendarHeader.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  date: _propTypes2.default.instanceOf(Date).isRequired,
	  minDate: _propTypes2.default.instanceOf(Date),
	  maxDate: _propTypes2.default.instanceOf(Date),
	  previousIcon: _propTypes2.default.element,
	  onPreviousClick: _propTypes2.default.func.isRequired,
	  nextIcon: _propTypes2.default.node,
	  onNextClick: _propTypes2.default.func.isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	  /**
	   * An optional className to apply to the title.
	   */
	  titleClassName: _propTypes2.default.string,
	  /**
	   * The DateTimeFormat options to apply to format the title.
	   */
	  titleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	  /**
	   * An optional className to apply to a weekday.
	   */
	  weekdayClassName: _propTypes2.default.string,
	  /**
	   * The DateTimeFormat option to apply to format a weekday.
	   */
	  weekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	
	  /**
	   * The timeZone to be used in all formatting operations.
	   * For a full list of possible timeZone values check https://www.iana.org/time-zones.
	   */
	  timeZone: _propTypes2.default.string.isRequired
	};
	CalendarHeader.defaultProps = {
	  firstDayOfWeek: 0,
	  titleFormat: { month: 'long', year: 'numeric' },
	  weekdayFormat: 'narrow'
	};
	exports.default = CalendarHeader;
	//# sourceMappingURL=CalendarHeader.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addDate = __webpack_require__(97);
	
	var _addDate2 = _interopRequireDefault(_addDate);
	
	var _stripTime = __webpack_require__(167);
	
	var _stripTime2 = _interopRequireDefault(_stripTime);
	
	var _getLastDay = __webpack_require__(355);
	
	var _getLastDay2 = _interopRequireDefault(_getLastDay);
	
	var _getDayOfWeek = __webpack_require__(166);
	
	var _getDayOfWeek2 = _interopRequireDefault(_getDayOfWeek);
	
	var _CalendarDate = __webpack_require__(291);
	
	var _CalendarDate2 = _interopRequireDefault(_CalendarDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component renders a month for the calendar view of the `DatePicker`.
	 */
	var CalendarMonth = function (_PureComponent) {
	  _inherits(CalendarMonth, _PureComponent);
	
	  function CalendarMonth() {
	    _classCallCheck(this, CalendarMonth);
	
	    return _possibleConstructorReturn(this, (CalendarMonth.__proto__ || Object.getPrototypeOf(CalendarMonth)).apply(this, arguments));
	  }
	
	  _createClass(CalendarMonth, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          calendarDate = _props.calendarDate,
	          calendarTempDate = _props.calendarTempDate,
	          onCalendarDateClick = _props.onCalendarDateClick,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          className = _props.className,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          disableWeekEnds = _props.disableWeekEnds,
	          dateClassName = _props.dateClassName,
	          showAllDays = _props.showAllDays,
	          outerDateClassName = _props.outerDateClassName,
	          disableOuterDates = _props.disableOuterDates,
	          timeZone = _props.timeZone,
	          props = _objectWithoutProperties(_props, ['calendarDate', 'calendarTempDate', 'onCalendarDateClick', 'minDate', 'maxDate', 'DateTimeFormat', 'locales', 'className', 'firstDayOfWeek', 'disableWeekEnds', 'dateClassName', 'showAllDays', 'outerDateClassName', 'disableOuterDates', 'timeZone']);
	
	      var days = [];
	      var firstDay = new Date(calendarDate);
	      firstDay.setDate(1);
	      var lastDay = (0, _getLastDay2.default)(calendarDate);
	      var currentDate = (0, _stripTime2.default)((0, _getDayOfWeek2.default)(firstDay, 0));
	      var endDate = (0, _stripTime2.default)((0, _getDayOfWeek2.default)(lastDay, 6));
	      var activeDateTime = (0, _stripTime2.default)(new Date(calendarTempDate)).getTime();
	      var todayTime = (0, _stripTime2.default)(new Date()).getTime();
	
	      if (firstDayOfWeek) {
	        currentDate = (0, _addDate2.default)(currentDate, firstDayOfWeek > firstDay.getDay() ? firstDayOfWeek - 7 : firstDayOfWeek, 'D');
	        endDate = (0, _addDate2.default)(endDate, firstDayOfWeek > lastDay.getDay() ? firstDayOfWeek - 7 : firstDayOfWeek, 'D');
	      }
	      while (currentDate <= endDate) {
	        var key = currentDate.getMonth() + '-' + currentDate.getDate();
	        var currentMonth = currentDate.getMonth() === calendarDate.getMonth();
	
	        var date = void 0;
	        if (currentMonth || showAllDays) {
	          var time = currentDate.getTime();
	          var isMinDateDisabled = minDate && minDate.getTime() > time;
	          var isMaxDateDisabled = maxDate && maxDate.getTime() < time;
	          var isWeekendDisabled = disableWeekEnds && (currentDate.getDay() === 0 || currentDate.getDay() === 6);
	          var disabled = !currentMonth && disableOuterDates || isMinDateDisabled || isMaxDateDisabled || isWeekendDisabled;
	
	          date = _react2.default.createElement(_CalendarDate2.default, {
	            key: key,
	            className: (0, _classnames2.default)(dateClassName, _defineProperty({}, outerDateClassName, !currentMonth && outerDateClassName)),
	            today: time === todayTime,
	            active: time === activeDateTime,
	            disabled: disabled,
	            onClick: onCalendarDateClick,
	            date: currentDate,
	            DateTimeFormat: DateTimeFormat,
	            locales: locales,
	            timeZone: timeZone
	          });
	        } else {
	          date = _react2.default.createElement('div', { key: key, className: 'md-calendar-date' });
	        }
	
	        days.push(date);
	        // stripTime again to avoid problems when time is forwarded an hour for DST
	        currentDate = (0, _stripTime2.default)((0, _addDate2.default)(currentDate, 1, 'D'));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: (0, _classnames2.default)('md-calendar-month', className) }, props),
	        days
	      );
	    }
	  }]);
	
	  return CalendarMonth;
	}(_react.PureComponent);
	
	CalendarMonth.propTypes = {
	  /**
	   * A className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The current selected date of the calendar. This is
	   * the date after hitting the Ok button or `value` || `defaultValue`.
	   */
	  calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * The current selected date of the calendar before verifying
	   * the new date.
	   */
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * An optional min date for the calendar. This will disable any
	   * dates that come before this date in the month.
	   */
	  minDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * An optional max date for the calendar. This will disable any
	   * dates that come after this date in the month.
	   */
	  maxDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * A function to call that will select a new date.
	   */
	  onCalendarDateClick: _propTypes2.default.func.isRequired,
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date.
	   */
	  dateClassName: _propTypes2.default.string,
	
	  /**
	   * True if dates from adjacent months should be shown.
	   */
	  showAllDays: _propTypes2.default.bool,
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date from an adjacent month.
	   */
	  outerDateClassName: _propTypes2.default.string,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	
	  /**
	   * The timeZone to be used in all formatting operations.
	   * For a full list of possible timeZone values check https://www.iana.org/time-zones.
	   */
	  timeZone: _propTypes2.default.string.isRequired
	};
	CalendarMonth.defaultProps = {
	  firstDayOfWeek: 0
	};
	exports.default = CalendarMonth;
	//# sourceMappingURL=CalendarMonth.js.map

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isValidClick = __webpack_require__(98);
	
	var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	var _captureNextEvent = __webpack_require__(52);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _touches = __webpack_require__(54);
	
	var _calcTimeFromPoint = __webpack_require__(359);
	
	var _calcTimeFromPoint2 = _interopRequireDefault(_calcTimeFromPoint);
	
	var _calcPageOffset = __webpack_require__(169);
	
	var _calcPageOffset2 = _interopRequireDefault(_calcPageOffset);
	
	var _ResizeObserver = __webpack_require__(28);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _ClockTime = __webpack_require__(296);
	
	var _ClockTime2 = _interopRequireDefault(_ClockTime);
	
	var _ClockHand = __webpack_require__(295);
	
	var _ClockHand2 = _interopRequireDefault(_ClockHand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ClockFace` component is used for rendering all the clock's times
	 * and the clock hand.
	 */
	var ClockFace = function (_PureComponent) {
	  _inherits(ClockFace, _PureComponent);
	
	  function ClockFace(props) {
	    _classCallCheck(this, ClockFace);
	
	    var _this = _possibleConstructorReturn(this, (ClockFace.__proto__ || Object.getPrototypeOf(ClockFace)).call(this, props));
	
	    _this._setFace = function (face) {
	      _this._face = face;
	      _this._setPositioning();
	    };
	
	    _this._setPositioning = function () {
	      if (!_this._face) {
	        return;
	      }
	
	      var radius = _this._face.offsetWidth / 2;
	      var offset = (0, _calcPageOffset2.default)(_this._face);
	      _this._center = { x: offset.left + radius, y: offset.top + radius };
	      _this._left = offset.left;
	      _this._top = offset.top;
	
	      if (_this.state.radius !== radius) {
	        _this.setState({ radius: radius });
	      }
	    };
	
	    _this._handleMouseEnter = function () {
	      var hoverMode = _this.props.hoverMode;
	
	
	      if (hoverMode) {
	        _this._enableMouseMoving();
	      }
	    };
	
	    _this._handleMouseLeave = function () {
	      var hoverMode = _this.props.hoverMode;
	
	
	      if (hoverMode) {
	        _this._disableMouseMoving();
	      }
	    };
	
	    _this._handleMouseDown = function (e) {
	      if (!(0, _isValidClick2.default)(e)) {
	        return;
	      }
	
	      var hoverMode = _this.props.hoverMode;
	
	
	      if (!hoverMode) {
	        _this._enableMouseMoving();
	      }
	    };
	
	    _this._handleMouseMove = function (e) {
	      if (!_this.state.moving) {
	        return;
	      }
	
	      e.preventDefault();
	      _this._calcNewTime(e);
	    };
	
	    _this._handleMouseUp = function (e) {
	      if (!(0, _isValidClick2.default)(e)) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          onTimeChosen = _this$props.onTimeChosen,
	          hoverMode = _this$props.hoverMode;
	
	
	      if (_this._face) {
	        if (_this._face.contains(e.target)) {
	          onTimeChosen();
	          _this._calcNewTime(e);
	        } else {
	          (0, _captureNextEvent2.default)('click');
	        }
	      }
	
	      if (!hoverMode) {
	        _this._disableMouseMoving();
	      }
	    };
	
	    _this._handleTouchStart = function () {
	      (0, _captureNextEvent2.default)('mousedown');
	
	      (0, _touches.addTouchEvent)(window, 'move', _this._handleTouchMove);
	      (0, _touches.addTouchEvent)(window, 'end', _this._handleTouchEnd);
	      _this.setState({ moving: true });
	    };
	
	    _this._handleTouchMove = function (e) {
	      if (!_this.state.moving) {
	        return;
	      }
	
	      _this._calcNewTime(e);
	    };
	
	    _this._handleTouchEnd = function (e) {
	      _this._calcNewTime(e);
	      if (_this._face && !_this._face.contains(e.target)) {
	        (0, _captureNextEvent2.default)('click');
	      }
	
	      (0, _touches.removeTouchEvent)(window, 'move', _this._handleTouchMove);
	      (0, _touches.removeTouchEvent)(window, 'end', _this._handleTouchEnd);
	
	      _this.setState({ moving: false });
	    };
	
	    _this._calcNewTime = function (e) {
	      var _ref = e.changedTouches ? e.changedTouches[0] : e,
	          x = _ref.pageX,
	          y = _ref.pageY;
	
	      var innerRadius = _this.state.radius - 48;
	      var _this$props2 = _this.props,
	          onChange = _this$props2.onChange,
	          minutes = _this$props2.minutes,
	          timePeriod = _this$props2.timePeriod;
	
	      onChange((0, _calcTimeFromPoint2.default)({ x: x, y: y }, _this._center, innerRadius, minutes, timePeriod));
	    };
	
	    _this._enableMouseMoving = function () {
	      window.addEventListener('mousemove', _this._handleMouseMove);
	      window.addEventListener('mouseup', _this._handleMouseUp);
	
	      _this.setState({ moving: true });
	    };
	
	    _this._disableMouseMoving = function () {
	      window.removeEventListener('mousemove', _this._handleMouseMove);
	      window.removeEventListener('mouseup', _this._handleMouseUp);
	
	      _this.setState({ moving: false });
	    };
	
	    _this.state = { radius: 136, moving: false };
	    _this._center = {};
	    return _this;
	  }
	
	  _createClass(ClockFace, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('mousemove', this._handleMouseMove);
	      window.removeEventListener('mouseup', this._handleMouseMove);
	
	      (0, _touches.removeTouchEvent)(window, 'move', this._handleTouchMove);
	      (0, _touches.removeTouchEvent)(window, 'end', this._handleTouchEnd);
	      clearInterval(this.interval);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          time = _props.time,
	          minutes = _props.minutes,
	          timePeriod = _props.timePeriod,
	          onChange = _props.onChange,
	          hoverMode = _props.hoverMode;
	      var radius = this.state.radius;
	
	      var size = !minutes && !timePeriod ? 24 : 12;
	      var times = Array.apply(null, new Array(size)).map(function (_, i) {
	        var clockTime = i + 1;
	        if (minutes) {
	          clockTime = clockTime * 5 % 60;
	        } else {
	          clockTime %= 24;
	        }
	
	        return _react2.default.createElement(_ClockTime2.default, {
	          key: 'time-' + i,
	          index: i + 1,
	          time: clockTime,
	          active: clockTime === time,
	          radius: radius,
	          onKeyboardFocus: onChange
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setFace,
	          className: 'md-clock-face md-block-centered md-pointer--hover',
	          onMouseDown: this._handleMouseDown,
	          onMouseEnter: hoverMode ? this._handleMouseEnter : undefined,
	          onMouseLeave: hoverMode ? this._handleMouseLeave : undefined,
	          onTouchStart: this._handleTouchStart
	        },
	        _react2.default.createElement(_ResizeObserver2.default, { watchHeight: true, onResize: this._setPositioning }),
	        times,
	        _react2.default.createElement(_ClockHand2.default, { time: time, coords: radius, minutes: minutes })
	      );
	    }
	  }]);
	
	  return ClockFace;
	}(_react.PureComponent);
	
	ClockFace.propTypes = {
	  /**
	   * The current time for the clock.
	   */
	  time: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the clock is on the minutes view.
	   */
	  minutes: _propTypes2.default.bool.isRequired,
	
	  /**
	   * A function to call when a new time is selected. It gives the
	   * new time value. If it is 12 o'clock, 0 will be given.
	   */
	  onChange: _propTypes2.default.func.isRequired,
	
	  /**
	   * An optional time period string. This should be either AM or PM
	   * if the locale uses them.
	   */
	  timePeriod: _propTypes2.default.string,
	
	  /**
	   * If true the hover mode of the Time Picker is activated.
	   * In hover mode no clicks are required to start selecting an hour
	   * and the timemode switches automatically when a time was chosen.
	   * When a minute is selected the chosen time is applied automatically.
	   */
	  hoverMode: _propTypes2.default.bool,
	
	  onTimeChosen: _propTypes2.default.func.isRequired
	};
	exports.default = ClockFace;
	//# sourceMappingURL=ClockFace.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ClockHand` component is just used to display the hand of the clock
	 * and a ball to surround the selected time.
	 */
	var ClockHand = function (_PureComponent) {
	  _inherits(ClockHand, _PureComponent);
	
	  function ClockHand(props) {
	    _classCallCheck(this, ClockHand);
	
	    var _this = _possibleConstructorReturn(this, (ClockHand.__proto__ || Object.getPrototypeOf(ClockHand)).call(this, props));
	
	    _this.state = { active: false };
	    return _this;
	  }
	
	  _createClass(ClockHand, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.minutes !== nextProps.minutes) {
	        if (this.state.timeout) {
	          clearTimeout(this.state.timeout);
	        }
	
	        this.setState({
	          active: true,
	          timeout: setTimeout(function () {
	            return _this2.setState({ active: false, timeout: null });
	          }, 150)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.timeout) {
	        clearTimeout(this.state.timeout);
	      }
	    }
	  }, {
	    key: '_calcCurrentDegrees',
	    value: function _calcCurrentDegrees(_ref) {
	      var time = _ref.time,
	          minutes = _ref.minutes;
	
	      var timeAt0Deg = minutes ? 15 : 3;
	      var sectors = minutes ? 60 : 12;
	
	      return (time % sectors - timeAt0Deg) * (360 / sectors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          coords = _props.coords,
	          time = _props.time,
	          minutes = _props.minutes;
	
	
	      var degrees = this._calcCurrentDegrees(this.props);
	      var invisibleMinute = false;
	      if (minutes) {
	        invisibleMinute = degrees % (360 / 12) !== 0;
	      }
	
	      var rotateTransform = 'rotate3d(0, 0, 1, ' + degrees + 'deg)';
	      return _react2.default.createElement('div', {
	        className: (0, _classnames2.default)('md-clock-hand md-background--primary', {
	          'md-clock-hand--active': this.state.active,
	          'md-clock-hand--minute-hover': invisibleMinute,
	          'md-clock-hand--inner': !minutes && (time > 12 || time === 0)
	        }),
	        style: {
	          left: coords,
	          top: coords,
	          WebkitTransform: rotateTransform,
	          MozTransform: rotateTransform,
	          msTransform: rotateTransform,
	          transform: rotateTransform
	        }
	      });
	    }
	  }]);
	
	  return ClockHand;
	}(_react.PureComponent);
	
	ClockHand.propTypes = {
	  /**
	   * This is the x and y coordinate to use for the center of the `ClockFace`.
	   * This should really be whatever the radius of the `ClockFace` is.
	   */
	  coords: _propTypes2.default.number,
	
	  /**
	   * The current time of the clock.
	   */
	  time: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the clock is displaying minutes instead of hours.
	   */
	  minutes: _propTypes2.default.bool.isRequired
	};
	exports.default = ClockHand;
	//# sourceMappingURL=ClockHand.js.map

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(9);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLOCK_PADDING = 4;
	
	/**
	 * The `ClockTime` component is used for positioning hours or minutes
	 * in a clock. The time will be positioned based on it's given index
	 * and the radius of the clock.
	 */
	
	var ClockTime = function (_PureComponent) {
	  _inherits(ClockTime, _PureComponent);
	
	  function ClockTime(props) {
	    _classCallCheck(this, ClockTime);
	
	    var _this = _possibleConstructorReturn(this, (ClockTime.__proto__ || Object.getPrototypeOf(ClockTime)).call(this, props));
	
	    _this._handleKeyUp = function (e) {
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        _this.props.onKeyboardFocus(_this.props.time);
	      }
	    };
	
	    _this._setTime = function (time) {
	      _this._time = time;
	      if (time !== null) {
	        _this._setPosition(_this.props, time);
	
	        if (_this.props.active) {
	          time.focus();
	        }
	      }
	    };
	
	    _this._setPosition = function (_ref, time) {
	      var radius = _ref.radius,
	          index = _ref.index;
	
	      // 36 is default size for the time
	      var size = (time.offsetWidth || 36) / 2;
	      var timeRadians = Math.PI / 2 - index * (Math.PI / 6);
	      var innerCircle = index > 12;
	
	      var outerRadius = radius - size;
	      var innerRadius = outerRadius - CLOCK_PADDING - (innerCircle ? size * 2 : 0);
	
	      _this.setState({
	        style: {
	          top: outerRadius - innerRadius * Math.sin(timeRadians),
	          left: outerRadius + innerRadius * Math.cos(timeRadians)
	        }
	      });
	    };
	
	    _this.state = {
	      // default size in scss
	      size: 18
	    };
	    return _this;
	  }
	
	  _createClass(ClockTime, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.radius !== nextProps.radius || this.props.index !== nextProps.index) {
	        this._setPosition(nextProps, this._time);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          time = _props.time,
	          active = _props.active;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setTime,
	          tabIndex: 0,
	          className: (0, _classnames2.default)('md-clock-time md-text-no-select md-pointer--none', {
	            'md-picker-text--active': active
	          }, (0, _themeColors2.default)({ text: !active })),
	          style: this.state.style,
	          onKeyUp: this._handleKeyUp
	        },
	        _react2.default.createElement(
	          'span',
	          { className: 'md-clock-time-value' },
	          time
	        )
	      );
	    }
	  }]);
	
	  return ClockTime;
	}(_react.PureComponent);
	
	ClockTime.propTypes = {
	  /**
	   * The index of the current time to be displayed. This
	   * should be a number between 1 and 24.
	   */
	  index: _propTypes2.default.number.isRequired,
	
	  /**
	   * The time number to display.
	   */
	  time: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if this time is currently selected.
	   */
	  active: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The radius of the clock.
	   */
	  radius: _propTypes2.default.number.isRequired,
	
	  onKeyboardFocus: _propTypes2.default.func.isRequired
	};
	exports.default = ClockTime;
	//# sourceMappingURL=ClockTime.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DialogFooter = __webpack_require__(69);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	var _DatePickerHeader = __webpack_require__(300);
	
	var _DatePickerHeader2 = _interopRequireDefault(_DatePickerHeader);
	
	var _DatePickerCalendar = __webpack_require__(298);
	
	var _DatePickerCalendar2 = _interopRequireDefault(_DatePickerCalendar);
	
	var _YearPicker = __webpack_require__(306);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePicker = function (_PureComponent) {
	  _inherits(DatePicker, _PureComponent);
	
	  function DatePicker() {
	    _classCallCheck(this, DatePicker);
	
	    return _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
	  }
	
	  _createClass(DatePicker, [{
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          okLabel = _props.okLabel,
	          okPrimary = _props.okPrimary,
	          onOkClick = _props.onOkClick,
	          cancelLabel = _props.cancelLabel,
	          cancelPrimary = _props.cancelPrimary,
	          onCancelClick = _props.onCancelClick,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          calendarTempDate = _props.calendarTempDate,
	          calendarMode = _props.calendarMode,
	          changeCalendarMode = _props.changeCalendarMode,
	          style = _props.style,
	          className = _props.className,
	          inline = _props.inline,
	          icon = _props.icon,
	          displayMode = _props.displayMode,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          disableWeekEnds = _props.disableWeekEnds,
	          showAllDays = _props.showAllDays,
	          disableOuterDates = _props.disableOuterDates,
	          headerClassName = _props.headerClassName,
	          contentClassName = _props.contentClassName,
	          footerClassName = _props.footerClassName,
	          calendarClassName = _props.calendarClassName,
	          yearPickerClassName = _props.yearPickerClassName,
	          calendarDateClassName = _props.calendarDateClassName,
	          calendarOuterDateClassName = _props.calendarOuterDateClassName,
	          calendarTitleClassName = _props.calendarTitleClassName,
	          calendarTitleFormat = _props.calendarTitleFormat,
	          calendarWeekdayClassName = _props.calendarWeekdayClassName,
	          calendarWeekdayFormat = _props.calendarWeekdayFormat,
	          timeZone = _props.timeZone,
	          props = _objectWithoutProperties(_props, ['okLabel', 'okPrimary', 'onOkClick', 'cancelLabel', 'cancelPrimary', 'onCancelClick', 'DateTimeFormat', 'locales', 'calendarTempDate', 'calendarMode', 'changeCalendarMode', 'style', 'className', 'inline', 'icon', 'displayMode', 'firstDayOfWeek', 'disableWeekEnds', 'showAllDays', 'disableOuterDates', 'headerClassName', 'contentClassName', 'footerClassName', 'calendarClassName', 'yearPickerClassName', 'calendarDateClassName', 'calendarOuterDateClassName', 'calendarTitleClassName', 'calendarTitleFormat', 'calendarWeekdayClassName', 'calendarWeekdayFormat', 'timeZone']);
	
	      var picker = void 0;
	      if (calendarMode === 'calendar') {
	        picker = _react2.default.createElement(_DatePickerCalendar2.default, _extends({}, props, {
	          key: 'calendar',
	          className: calendarClassName,
	          calendarTempDate: calendarTempDate,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales,
	          firstDayOfWeek: firstDayOfWeek,
	          disableWeekEnds: disableWeekEnds,
	          showAllDays: showAllDays,
	          disableOuterDates: disableOuterDates,
	          dateClassName: calendarDateClassName,
	          outerDateClassName: calendarOuterDateClassName,
	          titleClassName: calendarTitleClassName,
	          titleFormat: calendarTitleFormat,
	          weekdayClassName: calendarWeekdayClassName,
	          weekdayFormat: calendarWeekdayFormat,
	          timeZone: timeZone
	        }));
	      } else {
	        picker = _react2.default.createElement(_YearPicker2.default, _extends({}, props, {
	          key: 'year',
	          className: yearPickerClassName,
	          calendarTempDate: calendarTempDate,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales
	        }));
	      }
	
	      var actions = [{
	        key: 'cancel',
	        onClick: onCancelClick,
	        primary: cancelPrimary,
	        secondary: !cancelPrimary,
	        label: cancelLabel
	      }, {
	        key: 'ok',
	        onClick: onOkClick,
	        primary: okPrimary,
	        secondary: !okPrimary,
	        label: okLabel
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-picker md-picker--date', (_cn = {}, _defineProperty(_cn, 'md-picker--' + displayMode, displayMode), _defineProperty(_cn, 'md-picker--inline', inline), _defineProperty(_cn, 'md-picker--inline-icon', inline && icon), _cn), className)
	        },
	        _react2.default.createElement(_DatePickerHeader2.default, {
	          className: headerClassName,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales,
	          calendarTempDate: calendarTempDate,
	          calendarMode: calendarMode,
	          changeCalendarMode: changeCalendarMode,
	          timeZone: timeZone
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('md-picker-content-container', contentClassName) },
	          picker,
	          _react2.default.createElement(_DialogFooter2.default, {
	            className: footerClassName,
	            actions: actions
	          })
	        )
	      );
	    }
	  }]);
	
	  return DatePicker;
	}(_react.PureComponent);
	
	DatePicker.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  okLabel: _propTypes2.default.node.isRequired,
	  okPrimary: _propTypes2.default.bool.isRequired,
	  onOkClick: _propTypes2.default.func.isRequired,
	  cancelLabel: _propTypes2.default.node.isRequired,
	  cancelPrimary: _propTypes2.default.bool.isRequired,
	  onCancelClick: _propTypes2.default.func.isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarMode: _propTypes2.default.oneOf(['calendar', 'year']).isRequired,
	  changeCalendarMode: _propTypes2.default.func.isRequired,
	  icon: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * True if dates from adjacent months should be shown in calendar.
	   */
	  showAllDays: _propTypes2.default.bool,
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to the header of date picker.
	   */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the content container of date picker.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the footer of date picker.
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the calendar container of date picker.
	   */
	  calendarClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the year picker of date picker.
	   */
	  yearPickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date in calendar.
	   */
	  calendarDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date from an adjacent month in calendar.
	   */
	  calendarOuterDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the title in calendar header.
	   */
	  calendarTitleClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat options to apply to format the title in calendar header.
	   */
	  calendarTitleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	
	  /**
	   * An optional className to apply to a weekday in calendar header.
	   */
	  calendarWeekdayClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat option to apply to format a weekday in calendar header.
	   */
	  calendarWeekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	
	  /**
	   * The timeZone to be used in all formatting operations.
	   * For a full list of possible timeZone values check https://www.iana.org/time-zones.
	   */
	  timeZone: _propTypes2.default.string.isRequired
	};
	exports.default = DatePicker;
	//# sourceMappingURL=DatePicker.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CalendarMonth = __webpack_require__(293);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarHeader = __webpack_require__(292);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePickerCalendar = function (_PureComponent) {
	  _inherits(DatePickerCalendar, _PureComponent);
	
	  function DatePickerCalendar() {
	    _classCallCheck(this, DatePickerCalendar);
	
	    return _possibleConstructorReturn(this, (DatePickerCalendar.__proto__ || Object.getPrototypeOf(DatePickerCalendar)).apply(this, arguments));
	  }
	
	  _createClass(DatePickerCalendar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          previousIcon = _props.previousIcon,
	          onPreviousClick = _props.onPreviousClick,
	          nextIcon = _props.nextIcon,
	          onNextClick = _props.onNextClick,
	          calendarDate = _props.calendarDate,
	          calendarTempDate = _props.calendarTempDate,
	          onCalendarDateClick = _props.onCalendarDateClick,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          disableWeekEnds = _props.disableWeekEnds,
	          showAllDays = _props.showAllDays,
	          disableOuterDates = _props.disableOuterDates,
	          dateClassName = _props.dateClassName,
	          outerDateClassName = _props.outerDateClassName,
	          titleClassName = _props.titleClassName,
	          titleFormat = _props.titleFormat,
	          weekdayClassName = _props.weekdayClassName,
	          weekdayFormat = _props.weekdayFormat,
	          timeZone = _props.timeZone;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: (0, _classnames2.default)('md-picker-content md-picker-content--calendar', className) },
	        _react2.default.createElement(_CalendarHeader2.default, {
	          date: calendarDate,
	          minDate: minDate,
	          maxDate: maxDate,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales,
	          onPreviousClick: onPreviousClick,
	          previousIcon: previousIcon,
	          onNextClick: onNextClick,
	          nextIcon: nextIcon,
	          firstDayOfWeek: firstDayOfWeek,
	          titleClassName: titleClassName,
	          titleFormat: titleFormat,
	          weekdayClassName: weekdayClassName,
	          weekdayFormat: weekdayFormat,
	          timeZone: timeZone
	        }),
	        _react2.default.createElement(_CalendarMonth2.default, {
	          key: new DateTimeFormat(locales).format(calendarDate),
	          calendarDate: calendarDate,
	          calendarTempDate: calendarTempDate,
	          onCalendarDateClick: onCalendarDateClick,
	          minDate: minDate,
	          maxDate: maxDate,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales,
	          firstDayOfWeek: firstDayOfWeek,
	          disableWeekEnds: disableWeekEnds,
	          showAllDays: showAllDays,
	          disableOuterDates: disableOuterDates,
	          dateClassName: dateClassName,
	          outerDateClassName: outerDateClassName,
	          timeZone: timeZone
	        })
	      );
	    }
	  }]);
	
	  return DatePickerCalendar;
	}(_react.PureComponent);
	
	DatePickerCalendar.propTypes = {
	  className: _propTypes2.default.string,
	  previousIcon: _propTypes2.default.element,
	  onPreviousClick: _propTypes2.default.func.isRequired,
	  nextIcon: _propTypes2.default.element,
	  onNextClick: _propTypes2.default.func.isRequired,
	  onCalendarDateClick: _propTypes2.default.func.isRequired,
	  calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  minDate: _propTypes2.default.instanceOf(Date),
	  maxDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * True if dates from adjacent months should be shown.
	   */
	  showAllDays: _propTypes2.default.bool,
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date in calendar.
	   */
	  dateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date from an adjacent month.
	   */
	  outerDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the title in calendar header.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat options to apply to format the title in calendar header.
	   */
	  titleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	
	  /**
	   * An optional className to apply to a weekday in calendar header.
	   */
	  weekdayClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat option to apply to format a weekday in calendar header.
	   */
	  weekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	
	  /**
	   * The timeZone to be used in all formatting operations.
	   * For a full list of possible timeZone values check https://www.iana.org/time-zones.
	   */
	  timeZone: _propTypes2.default.string.isRequired
	};
	exports.default = DatePickerCalendar;
	//# sourceMappingURL=DatePickerCalendar.js.map

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(9);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _handleWindowClickListeners = __webpack_require__(73);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _handleKeyboardAccessibility = __webpack_require__(53);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _isDateEqual = __webpack_require__(356);
	
	var _isDateEqual2 = _interopRequireDefault(_isDateEqual);
	
	var _addDate = __webpack_require__(97);
	
	var _addDate2 = _interopRequireDefault(_addDate);
	
	var _DateTimeFormat = __webpack_require__(164);
	
	var _DateTimeFormat2 = _interopRequireDefault(_DateTimeFormat);
	
	var _Collapse = __webpack_require__(35);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _TextField = __webpack_require__(48);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DialogContainer = __webpack_require__(89);
	
	var _DialogContainer2 = _interopRequireDefault(_DialogContainer);
	
	var _DatePicker = __webpack_require__(297);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable new-cap,no-shadow */
	
	
	/**
	 * The `DatePickerContainer` component is a wrapper for the main `DatePicker` component
	 * to manage the state and _logic_ for rendering the `DatePicker`. This component will
	 * either render inline or in a `Dialog` depending if the `inline` prop is set to `true`.
	 *
	 * NOTE: This component is actually exported as `DatePicker` when using the `import { member }` syntax.
	 * The following two lines are equivalent:
	 *
	 * ```js
	 * import { DatePicker } from 'react-md/lib/Pickers';
	 * import DatePicker from 'react-md/lib/Pickers/DatePickerContainer';
	 * ```
	 */
	var DatePickerContainer = function (_PureComponent) {
	  _inherits(DatePickerContainer, _PureComponent);
	
	  function DatePickerContainer(props) {
	    _classCallCheck(this, DatePickerContainer);
	
	    var _this = _possibleConstructorReturn(this, (DatePickerContainer.__proto__ || Object.getPrototypeOf(DatePickerContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var date = void 0;
	    var value = void 0;
	    var defaultValue = props.defaultValue,
	        DateTimeFormat = props.DateTimeFormat,
	        locales = props.locales,
	        minDate = props.minDate,
	        maxDate = props.maxDate;
	
	
	    if (typeof props.value !== 'undefined') {
	      date = _this._getDate(props.value);
	    } else if (defaultValue) {
	      date = _this._getDate(defaultValue);
	      value = typeof defaultValue === 'string' ? defaultValue : DateTimeFormat(locales, _this._getFormatOptions()).format(defaultValue);
	    } else {
	      date = new Date();
	      value = '';
	    }
	
	    date = _this._validateDateRange(date, minDate, maxDate);
	
	    var defaultCalendarDate = typeof props.initialCalendarDate !== 'undefined' ? props.initialCalendarDate : props.defaultCalendarDate;
	    var calendarTempDate = date;
	    if (typeof defaultCalendarDate !== 'undefined' && !props.value && !props.defaultValue) {
	      calendarTempDate = _this._getDate(defaultCalendarDate);
	      date = calendarTempDate;
	    } else if (calendarTempDate === null) {
	      calendarTempDate = new Date();
	      date = new Date();
	    }
	
	    var visible = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultVisible;
	
	    _this.state = {
	      value: value,
	      visible: visible,
	      calendarDate: date,
	      calendarTempDate: calendarTempDate,
	      calendarMode: props.initialCalendarMode || props.defaultCalendarMode
	    };
	    return _this;
	  }
	
	  _createClass(DatePickerContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = nextProps.value,
	          minDate = nextProps.minDate,
	          maxDate = nextProps.maxDate;
	
	      var minEqual = (0, _isDateEqual2.default)(this.props.minDate, minDate);
	      var maxEqual = (0, _isDateEqual2.default)(this.props.maxDate, maxDate);
	      if (this.props.value !== value || !minEqual || !maxEqual) {
	        var calendarDate = this.state.calendarDate;
	
	        if (typeof value !== 'undefined') {
	          calendarDate = this._getDate(value);
	        }
	
	        calendarDate = this._validateDateRange(calendarDate, minDate, maxDate);
	
	        if (!(0, _isDateEqual2.default)(this.state.calendarDate, calendarDate)) {
	          this.setState({ calendarDate: calendarDate, calendarTempDate: calendarDate });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props,
	          inline = _props.inline,
	          isOpen = _props.isOpen;
	
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	      var pVisible = typeof prevProps.isOpen !== 'undefined' ? prevProps.isOpen : (0, _getField2.default)(prevProps, prevState, 'visible');
	
	      if (visible === pVisible) {
	        return;
	      }
	
	      if (visible) {
	        if (inline) {
	          (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
	          window.addEventListener('keydown', this._closeOnEsc);
	        }
	      } else if (inline) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	        window.removeEventListener('keydown', this._closeOnEsc);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	      if (visible && this.props.inline) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	        window.removeEventListener('keydown', this._closeOnEsc);
	      }
	    }
	  }, {
	    key: '_getDate',
	    value: function _getDate(value) {
	      if (value === '' || value === null) {
	        return new Date();
	      } else if (typeof value === 'string') {
	        return new Date(value);
	      }
	
	      return value;
	    }
	  }, {
	    key: '_getFormatOptions',
	    value: function _getFormatOptions() {
	      var _props2 = this.props,
	          formatOptions = _props2.formatOptions,
	          timeZone = _props2.timeZone;
	
	      return _extends({}, formatOptions, { timeZone: timeZone });
	    }
	  }, {
	    key: '_getFormattedValue',
	
	
	    /**
	     * Gets the current value from the date picker as a formatted string.
	     *
	     * @param {Object} props? the props object to use.
	     * @param {Object} state? the state object to use.
	     * @return {String} a formatted date string or the empty string.
	     */
	    value: function _getFormattedValue(props, state) {
	      var DateTimeFormat = props.DateTimeFormat,
	          locales = props.locales;
	
	      var value = (0, _getField2.default)(props, state, 'value');
	      if (!value) {
	        return '';
	      } else if (value instanceof Date) {
	        return DateTimeFormat(locales, this._getFormatOptions()).format(new Date(value));
	      } else {
	        return value;
	      }
	    }
	
	    /**
	     * Attempts to validate the `calendarDate` in the state against the min and
	     * max dates.
	     *
	     * This will return null if the current calendarDate is still within the range.
	     *
	     * @param {Date} calendarDate - The current calendar date to compare to.
	     * @param {Date} minDate - An optional min date to compare to.
	     * @param {Date} maxDate - An optional max date to compare to.
	     * @return {Object} - The new state object with the updated calendarDate and
	     *    calendarTempDate keys or null.
	     */
	
	  }, {
	    key: '_validateDateRange',
	    value: function _validateDateRange(calendarDate, minDate, maxDate) {
	      var date = calendarDate;
	      if (minDate && minDate > calendarDate) {
	        date = new Date(minDate);
	      }
	
	      if (maxDate && maxDate < calendarDate) {
	        date = new Date(maxDate);
	      }
	
	      return date;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          style = _props3.style,
	          className = _props3.className,
	          pickerStyle = _props3.pickerStyle,
	          pickerClassName = _props3.pickerClassName,
	          pickerHeaderClassName = _props3.pickerHeaderClassName,
	          pickerContentClassName = _props3.pickerContentClassName,
	          pickerFooterClassName = _props3.pickerFooterClassName,
	          inputStyle = _props3.inputStyle,
	          inputClassName = _props3.inputClassName,
	          textFieldStyle = _props3.textFieldStyle,
	          textFieldClassName = _props3.textFieldClassName,
	          label = _props3.label,
	          placeholder = _props3.placeholder,
	          icon = _props3.icon,
	          inline = _props3.inline,
	          displayMode = _props3.displayMode,
	          fullWidth = _props3.fullWidth,
	          lineDirection = _props3.lineDirection,
	          id = _props3.id,
	          disabled = _props3.disabled,
	          closeOnEsc = _props3.closeOnEsc,
	          animateInline = _props3.animateInline,
	          portal = _props3.portal,
	          renderNode = _props3.renderNode,
	          lastChild = _props3.lastChild,
	          block = _props3.block,
	          paddedBlock = _props3.paddedBlock,
	          active = _props3.active,
	          error = _props3.error,
	          floating = _props3.floating,
	          required = _props3.required,
	          leftIconStateful = _props3.leftIconStateful,
	          rightIcon = _props3.rightIcon,
	          rightIconStateful = _props3.rightIconStateful,
	          customSize = _props3.customSize,
	          errorText = _props3.errorText,
	          helpText = _props3.helpText,
	          helpOnFocus = _props3.helpOnFocus,
	          inlineIndicator = _props3.inlineIndicator,
	          disableScrollLocking = _props3.disableScrollLocking,
	          ariaLabel = _props3['aria-label'],
	          propNextIcon = _props3.nextIcon,
	          propPreviousIcon = _props3.previousIcon,
	          isOpen = _props3.isOpen,
	          previousIconChildren = _props3.previousIconChildren,
	          previousIconClassName = _props3.previousIconClassName,
	          nextIconChildren = _props3.nextIconChildren,
	          nextIconClassName = _props3.nextIconClassName,
	          propValue = _props3.value,
	          propVisible = _props3.visible,
	          defaultValue = _props3.defaultValue,
	          defaultVisible = _props3.defaultVisible,
	          onChange = _props3.onChange,
	          readOnly = _props3.readOnly,
	          onVisibilityChange = _props3.onVisibilityChange,
	          defaultCalendarDate = _props3.defaultCalendarDate,
	          initialCalendarDate = _props3.initialCalendarDate,
	          initiallyOpen = _props3.initiallyOpen,
	          adjustMinWidth = _props3.adjustMinWidth,
	          props = _objectWithoutProperties(_props3, ['style', 'className', 'pickerStyle', 'pickerClassName', 'pickerHeaderClassName', 'pickerContentClassName', 'pickerFooterClassName', 'inputStyle', 'inputClassName', 'textFieldStyle', 'textFieldClassName', 'label', 'placeholder', 'icon', 'inline', 'displayMode', 'fullWidth', 'lineDirection', 'id', 'disabled', 'closeOnEsc', 'animateInline', 'portal', 'renderNode', 'lastChild', 'block', 'paddedBlock', 'active', 'error', 'floating', 'required', 'leftIconStateful', 'rightIcon', 'rightIconStateful', 'customSize', 'errorText', 'helpText', 'helpOnFocus', 'inlineIndicator', 'disableScrollLocking', 'aria-label', 'nextIcon', 'previousIcon', 'isOpen', 'previousIconChildren', 'previousIconClassName', 'nextIconChildren', 'nextIconClassName', 'value', 'visible', 'defaultValue', 'defaultVisible', 'onChange', 'readOnly', 'onVisibilityChange', 'defaultCalendarDate', 'initialCalendarDate', 'initiallyOpen', 'adjustMinWidth']);
	
	      var nextIcon = (0, _getDeprecatedIcon2.default)(nextIconClassName, nextIconChildren, propNextIcon);
	      var previousIcon = (0, _getDeprecatedIcon2.default)(previousIconClassName, previousIconChildren, propPreviousIcon);
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	      var picker = _react2.default.createElement(_DatePicker2.default, _extends({}, this.state, props, {
	        nextIcon: nextIcon,
	        previousIcon: previousIcon,
	        icon: !!icon,
	        inline: inline,
	        style: pickerStyle,
	        className: pickerClassName,
	        headerClassName: pickerHeaderClassName,
	        contentClassName: pickerContentClassName,
	        footerClassName: pickerFooterClassName,
	        displayMode: displayMode,
	        onCancelClick: this._handleCancelClick,
	        onOkClick: this._handleOkClick,
	        changeCalendarMode: this._changeCalendarMode,
	        onPreviousClick: this._previousMonth,
	        onNextClick: this._nextMonth,
	        onCalendarDateClick: this._setCalendarTempDate,
	        onCalendarYearClick: this._setCalendarTempYear
	      }));
	
	      var content = void 0;
	      if (inline) {
	        content = _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: !visible, animate: animateInline },
	          picker
	        );
	      } else {
	        content = _react2.default.createElement(
	          _DialogContainer2.default,
	          {
	            id: id + '-dialog',
	            visible: visible,
	            onHide: this._handleCancelClick,
	            dialogClassName: 'md-dialog--picker',
	            contentClassName: 'md-dialog-content--picker',
	            'aria-label': ariaLabel,
	            closeOnEsc: closeOnEsc,
	            renderNode: renderNode,
	            portal: portal,
	            lastChild: lastChild,
	            focusOnMount: false,
	            disableScrollLocking: disableScrollLocking
	          },
	          picker
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: style, className: (0, _classnames2.default)('md-picker-container', className), ref: this._setContainer },
	        _react2.default.createElement(_TextField2.default, {
	          id: id,
	          style: textFieldStyle,
	          className: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, textFieldClassName),
	          inputStyle: inputStyle,
	          inputClassName: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, inputClassName),
	          active: active || visible,
	          error: error,
	          floating: floating || visible,
	          required: required,
	          disabled: disabled,
	          leftIcon: icon,
	          leftIconStateful: leftIconStateful,
	          rightIcon: rightIcon,
	          rightIconStateful: rightIconStateful,
	          inlineIndicator: inlineIndicator,
	          block: block,
	          paddedBlock: paddedBlock,
	          fullWidth: fullWidth,
	          lineDirection: lineDirection,
	          customSize: customSize,
	          helpText: helpText,
	          helpOnFocus: helpOnFocus,
	          errorText: errorText,
	          label: label,
	          placeholder: placeholder,
	          onClick: this._toggleOpen,
	          onKeyDown: this._handleKeyDown,
	          value: this._getFormattedValue(this.props, this.state),
	          readOnly: true
	        }),
	        content
	      );
	    }
	  }]);
	
	  return DatePickerContainer;
	}(_react.PureComponent);
	
	DatePickerContainer.propTypes = {
	  /**
	   * An id for the text field in the date picker. This is require for a11y.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An aria label for the dialog. This is required for a11y.
	   */
	  'aria-label': (0, _isRequiredForA11y2.default)(_propTypes2.default.string),
	
	  /**
	   * An optional style to apply to the date picker's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the date picker's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the date picker.
	   */
	  pickerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the date picker.
	   */
	  pickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the header of date picker.
	   */
	  pickerHeaderClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the content container of date picker.
	   */
	  pickerContentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the footer of date picker.
	   */
	  pickerFooterClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the calendar container of date picker.
	   */
	  calendarClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the year picker of date picker.
	   */
	  yearPickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the input tag.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the input tag.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the text field's container.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the text field's container.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional icon to display with the date picker.
	   *
	   * @see {@link TextFields/TextField#leftIcon}
	   */
	  icon: _propTypes2.default.node,
	
	  /**
	   * Boolean if the date picker is open by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * An optional label to be displayed in the date picker's text
	   * field.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder to be displayed in the date picker's text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * The value of the date picker. This will make the date picker
	   * be a controlled component. This value should either be a
	   * formatted date string or a date object.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional default value to give for the date picker. This should
	   * either be a formatted date string or a date object.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	
	  /**
	   * An optional date to use when the calendar is opened for the first time.
	   * If this is omitted, it will either be the `defaultValue`, `value`, or
	   * today.
	   */
	  defaultCalendarDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	
	  /**
	   * An optional function to call when the selected date is changed
	   * by hitting the OK button. The newly formatted date string,
	   * the new Date object, and the change event will be given.
	   *
	   * `onChange(dateString, dateObject, event)`.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * A function to format the dates since it should be formatted to the user's
	   * locale. This _should_ be the `Intl.DateTimeFormat` function. You
	   * can also create your own if you really wanted. Inadvisable though.
	   *
	   * See [intl-polyfill](https://github.com/andyearnshaw/Intl.js/) for more info.
	   */
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	
	  /**
	   * The locales to use for formatting the date. This will default to using
	   * the user's language in the browser or `'en-US'` when server rendering.
	   */
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	
	  /**
	   * The label to use for the ok button on the date picker.
	   */
	  okLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the ok button should be styled with the primary color.
	   */
	  okPrimary: _propTypes2.default.bool,
	
	  /**
	   * The label to use for the cancel button on the date picker.
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the cancel button should be styled with the primary color.
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * The initial mode to open the calendar in.
	   */
	  defaultCalendarMode: _propTypes2.default.oneOf(['calendar', 'year']),
	
	  /**
	   * The icon to use to display the previous month icon in the calendar.
	   */
	  previousIcon: _propTypes2.default.node,
	
	  /**
	   * The icon to use to display the next month icon in the calendar.
	   */
	  nextIcon: _propTypes2.default.node,
	
	  /**
	   * An optional min date to use for the date picker. This will prevent
	   * any dates before this time to be chosen.
	   */
	  minDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * An optional max date to use for the date picker. This will prevent
	   * any dates after this time to be chosen.
	   */
	  maxDate: function maxDate(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var err = _propTypes2.default.instanceOf(Date).apply(undefined, [props, propName, component].concat(others));
	    if (err || !props.minDate || !props[propName]) {
	      return err;
	    }
	
	    var minDate = props.minDate,
	        maxDate = props.maxDate;
	
	    if (minDate > maxDate) {
	      return new Error('The min date: \'' + minDate + '\' is greater than the max date: \'' + maxDate + '\'');
	    }
	
	    return null;
	  },
	
	  /**
	   * Boolean if the date should automatically be selected when a user clicks
	   * on a new date instead of making them hit the ok button.
	   */
	  autoOk: _propTypes2.default.bool,
	
	  /**
	   * The number of years to display.
	   */
	  yearsDisplayed: _propTypes2.default.number,
	
	  /**
	   * Boolean if the date picker should be displayed inline instead of in a
	   * dialog.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * An optional force of the display mode of the date picker.
	   * This _should_ not really be used since there are media queries
	   * to use the correct mode based on device orientation.
	   */
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * The DateTimeFormat options to apply to format the date.
	   */
	  formatOptions: _propTypes2.default.shape({
	    weekday: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	    day: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    hour: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    minute: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    second: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    timeZoneName: _propTypes2.default.oneOf(['short', 'long'])
	  }),
	
	  /**
	   * The timeZone to be used in all formatting operations.
	   * For a full list of possible timeZone values check https://www.iana.org/time-zones.
	   */
	  timeZone: _propTypes2.default.string.isRequired,
	
	  /**
	   * Boolean if the text field for the Date Picker should be displayed as full width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The direction that the text field divider expands from when the text field
	   * in the date picker gains focus.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']),
	
	  /**
	   * An optional boolean if the time picker is current visible by dialog or inline.
	   * If this is set, the `onOpenToggle` function is required.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the date picker is opened in either a dialog, or
	   * inline. The callback will include the next state.
	   *
	   * ```js
	   * onVisibilityChange(!visible, e);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the time picker is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be able to close if a keyboard user presses the escape key.
	   */
	  closeOnEsc: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the inline time picker's visibility should be animated.
	   */
	  animateInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the time is required.
	   *
	   * @see {@link TextFields/TextField#required}
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * @see {@link TextFields/TextField#block}
	   */
	  block: _TextField2.default.propTypes.block,
	
	  /**
	   * @see {@link TextFields/TextField#paddedBlock}
	   */
	  paddedBlock: _TextField2.default.propTypes.paddedBlock,
	
	  /**
	   * @see {@link TextFields/TextField#active}
	   */
	  active: _TextField2.default.propTypes.active,
	
	  /**
	   * @see {@link TextFields/TextField#error}
	   */
	  error: _TextField2.default.propTypes.error,
	
	  /**
	   * @see {@link TextFields/TextField#floating}
	   */
	  floating: _TextField2.default.propTypes.floating,
	
	  /**
	   * @see {@link TextFields/TextField#leftIconStateful}
	   */
	  leftIconStateful: _TextField2.default.propTypes.leftIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#rightIcon}
	   */
	  rightIcon: _TextField2.default.propTypes.rightIcon,
	
	  /**
	   * @see {@link TextFields/TextField#rightIconStateful}
	   */
	  rightIconStateful: _TextField2.default.propTypes.rightIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#customSize}
	   */
	  customSize: _TextField2.default.propTypes.customSize,
	
	  /**
	   * @see {@link TextFields/TextField#errorText}
	   */
	  errorText: _TextField2.default.propTypes.errorText,
	
	  /**
	   * @see {@link TextFields/TextField#helpText}
	   */
	  helpText: _TextField2.default.propTypes.helpText,
	
	  /**
	   * @see {@link TextFields/TextField#helpOnFocus}
	   */
	  helpOnFocus: _TextField2.default.propTypes.helpOnFocus,
	
	  /**
	   * @see {@link TextFields/TextField#inlineIndicator}
	   */
	  inlineIndicator: _TextField2.default.propTypes.inlineIndicator,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the dialog.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the dialog into. The default is to render as the first child
	   * in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the DatePicker should be read only. This will prevent the user from opening the picker
	   * and only display the current date in the text field.
	   */
	  readOnly: _propTypes2.default.bool,
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * True if dates from adjacent months should be shown in calendar.
	   */
	  showAllDays: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dates from adjacent months should be disabled. This will only
	   * do something if the `showAllDays` prop is enabled as well.
	   *
	   * This is really only helpful if youd like the other days to appear, but not be
	   * clickable until the user switches to that month.
	   *
	   * @see {@link #showAllDays}
	   */
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date in calendar.
	   */
	  calendarDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date from an adjacent month in calendar. This will be applied
	   * along with the `calendarDateClassName`.
	   *
	   * @see {@link #showAllDays}
	   * @see {@link #calendarDateClassName}
	   */
	  calendarOuterDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the title in calendar header.
	   */
	  calendarTitleClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat options to apply to format the title in calendar header.
	   */
	  calendarTitleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	
	  /**
	   * An optional className to apply to a weekday in calendar header.
	   */
	  calendarWeekdayClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat option to apply to format a weekday in calendar header.
	   */
	  calendarWeekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#disableScrollLocking}
	   */
	  disableScrollLocking: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be rendered as the last child of the `renderNode` or `body` instead
	   * of the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  previousIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `previousIcon` prop instead'),
	  previousIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `previousIcon` prop instead'),
	  nextIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'use the `nextIcon` prop instead'),
	  nextIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `nextIcon` prop instead'),
	  adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid for a text field'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initialCalendarDate: (0, _deprecated2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]), 'Use `defaultCalendarDate` instead'),
	  initialCalendarMode: (0, _deprecated2.default)(_propTypes2.default.oneOf(['calendar', 'year']), 'Use `defaultCalendarMode` instead'),
	  initialYearsDisplayed: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `yearsDisplayed` instead. I have not implemented infinite loading years')
	};
	DatePickerContainer.defaultProps = {
	  animateInline: true,
	  previousIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'chevron_left'
	  ),
	  nextIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'chevron_right'
	  ),
	  autoOk: false,
	  icon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'date_range'
	  ),
	  yearsDisplayed: 100,
	  defaultCalendarMode: 'calendar',
	  DateTimeFormat: _DateTimeFormat2.default, // eslint-disable-line object-shorthand
	  locales: typeof window !== 'undefined' ? window.navigator.userLanguage || window.navigator.language : 'en-US',
	  okLabel: 'Ok',
	  okPrimary: true,
	  cancelLabel: 'Cancel',
	  cancelPrimary: true,
	  closeOnEsc: true,
	  disableScrollLocking: false,
	  'aria-label': 'Pick a date',
	  timeZone: 'UTC'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    _this2._container = container;
	  };
	
	  this._closeOnEsc = function (e) {
	    if ((e.which || e.keyCode) === _keyCodes.ESC) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this2._container && !_this2._container.contains(e.target)) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._toggleOpen = function (e) {
	    if (_this2.props.disabled || _this2.props.readOnly) {
	      return;
	    }
	
	    var visible = !(typeof _this2.props.isOpen !== 'undefined' ? _this2.props.isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible'));
	
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(visible, e);
	    }
	
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    (0, _handleKeyboardAccessibility2.default)(e, _this2._toggleOpen, true, true);
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB && _this2.state.active) {
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleOkClick = function (e) {
	    var _props4 = _this2.props,
	        DateTimeFormat = _props4.DateTimeFormat,
	        locales = _props4.locales,
	        onChange = _props4.onChange,
	        onVisibilityChange = _props4.onVisibilityChange;
	
	    var value = DateTimeFormat(locales, _this2._getFormatOptions()).format(_this2.state.calendarTempDate);
	    if (onChange) {
	      onChange(value, new Date(_this2.state.calendarTempDate), e);
	    }
	
	    if (onVisibilityChange) {
	      onVisibilityChange(false, e);
	    }
	
	    var state = void 0;
	    if (typeof _this2.props.value === 'undefined') {
	      state = { value: value };
	    }
	
	    if (typeof _this2.props.visible === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
	      state = state || {};
	      state.visible = false;
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	
	  this._handleCancelClick = function (e) {
	    var state = { calendarTempDate: _this2.state.calendarDate };
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
	      state.visible = false;
	    }
	
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(false, e);
	    }
	
	    _this2.setState(state);
	  };
	
	  this._changeCalendarMode = function (calendarMode) {
	    if (_this2.state.calendarMode === calendarMode) {
	      return;
	    }
	
	    _this2.setState({ calendarMode: calendarMode });
	  };
	
	  this._previousMonth = function () {
	    var calendarDate = (0, _addDate2.default)(_this2.state.calendarDate, -1, 'M');
	    _this2.setState({ calendarDate: calendarDate });
	  };
	
	  this._nextMonth = function () {
	    var calendarDate = (0, _addDate2.default)(_this2.state.calendarDate, 1, 'M');
	    _this2.setState({ calendarDate: calendarDate });
	  };
	
	  this._setCalendarTempDate = function (calendarTempDate) {
	    var _props5 = _this2.props,
	        autoOk = _props5.autoOk,
	        DateTimeFormat = _props5.DateTimeFormat,
	        locales = _props5.locales,
	        onChange = _props5.onChange;
	
	
	    var state = { calendarTempDate: calendarTempDate };
	    if (autoOk) {
	      var value = DateTimeFormat(locales, _this2._getFormatOptions()).format(calendarTempDate);
	      if (onChange) {
	        onChange(value, new Date(calendarTempDate));
	      }
	
	      if (typeof _this2.props.value === 'undefined') {
	        state.value = value;
	      }
	
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        if (_this2.props.onVisibilityChange) {
	          _this2.props.onVisibilityChange(false);
	        }
	
	        if (typeof _this2.props.visible === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
	          _this2.setState({ visible: false });
	        }
	      });
	    }
	    _this2.setState(state);
	  };
	
	  this._setCalendarTempYear = function (year) {
	    var _state = _this2.state,
	        calendarTempDate = _state.calendarTempDate,
	        calendarDate = _state.calendarDate;
	
	    if (calendarTempDate.getFullYear() === year) {
	      return;
	    }
	
	    var _props6 = _this2.props,
	        minDate = _props6.minDate,
	        maxDate = _props6.maxDate;
	
	    var nextDate = new Date(calendarDate.setFullYear(year));
	    var nextTemp = new Date(calendarTempDate.setFullYear(year));
	
	    if (minDate && nextTemp < minDate) {
	      nextDate = new Date(minDate);
	      nextTemp = new Date(minDate);
	    }
	
	    if (maxDate && nextTemp > maxDate) {
	      nextDate = new Date(maxDate);
	      nextTemp = new Date(maxDate);
	    }
	
	    _this2.setState({
	      calendarDate: nextDate,
	      calendarTempDate: nextTemp
	    });
	  };
	};
	
	exports.default = DatePickerContainer;
	//# sourceMappingURL=DatePickerContainer.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PickerControl = __webpack_require__(95);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable new-cap */
	
	
	/**
	 * The `DatePickerHeader` component is the component that holds the
	 * current year and the current date. It allows the user to switch
	 * between calendar and year picker mode.
	 */
	var DatePickerHeader = function (_PureComponent) {
	  _inherits(DatePickerHeader, _PureComponent);
	
	  function DatePickerHeader(props) {
	    _classCallCheck(this, DatePickerHeader);
	
	    var _this = _possibleConstructorReturn(this, (DatePickerHeader.__proto__ || Object.getPrototypeOf(DatePickerHeader)).call(this, props));
	
	    _this._selectYear = function (e) {
	      _this.props.changeCalendarMode('year', e);
	    };
	
	    _this._selectCalendar = function (e) {
	      _this.props.changeCalendarMode('calendar', e);
	    };
	
	    _this.state = _this._getFormattedDate(props);
	    return _this;
	  }
	
	  _createClass(DatePickerHeader, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          calendarTempDate = _props.calendarTempDate,
	          changeCalendarMode = _props.changeCalendarMode;
	
	      if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || calendarTempDate !== nextProps.calendarTempDate || changeCalendarMode !== nextProps.changeCalendarMode) {
	        this.setState(this._getFormattedDate(nextProps));
	      }
	    }
	  }, {
	    key: '_getFormattedDate',
	    value: function _getFormattedDate(_ref) {
	      var DateTimeFormat = _ref.DateTimeFormat,
	          locales = _ref.locales,
	          calendarTempDate = _ref.calendarTempDate,
	          timeZone = _ref.timeZone;
	
	      return {
	        year: DateTimeFormat(locales, { year: 'numeric', timeZone: timeZone }).format(calendarTempDate),
	        weekday: DateTimeFormat(locales, { weekday: 'short', timeZone: timeZone }).format(calendarTempDate),
	        date: DateTimeFormat(locales, { month: 'short', day: '2-digit', timeZone: timeZone }).format(calendarTempDate)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          year = _state.year,
	          weekday = _state.weekday,
	          date = _state.date;
	      var _props2 = this.props,
	          calendarMode = _props2.calendarMode,
	          className = _props2.className;
	
	      return _react2.default.createElement(
	        'header',
	        { className: (0, _classnames2.default)('md-picker-header', className) },
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._selectYear, active: calendarMode === 'year' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'md-subheading-1' },
	            year
	          )
	        ),
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._selectCalendar, active: calendarMode === 'calendar' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'md-display-1' },
	            weekday + ',',
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'h4',
	            { className: 'md-display-1' },
	            date
	          )
	        )
	      );
	    }
	  }]);
	
	  return DatePickerHeader;
	}(_react.PureComponent);
	
	DatePickerHeader.propTypes = {
	  className: _propTypes2.default.string,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarMode: _propTypes2.default.oneOf(['calendar', 'year']).isRequired,
	  changeCalendarMode: _propTypes2.default.func.isRequired,
	  timeZone: _propTypes2.default.string.isRequired
	};
	exports.default = DatePickerHeader;
	//# sourceMappingURL=DatePickerHeader.js.map

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _addHours = __webpack_require__(353);
	
	var _addHours2 = _interopRequireDefault(_addHours);
	
	var _PickerControl = __webpack_require__(95);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component displays a section for switching between the AM
	 * and PM time periods.
	 */
	var TimePeriods = function (_PureComponent) {
	  _inherits(TimePeriods, _PureComponent);
	
	  function TimePeriods() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePeriods);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePeriods.__proto__ || Object.getPrototypeOf(TimePeriods)).call.apply(_ref, [this].concat(args))), _this), _this._setAM = function () {
	      if (_this.props.timePeriod !== 'AM') {
	        _this.props.setTempTime((0, _addHours2.default)(_this.props.tempTime, -12));
	      }
	    }, _this._setPM = function () {
	      if (_this.props.timePeriod !== 'PM') {
	        _this.props.setTempTime((0, _addHours2.default)(_this.props.tempTime, 12));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TimePeriods, [{
	    key: 'render',
	    value: function render() {
	      var timePeriod = this.props.timePeriod;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'md-time-periods' },
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._setAM, active: timePeriod === 'AM' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'md-time-period' },
	            'AM'
	          )
	        ),
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._setPM, active: timePeriod === 'PM' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'md-time-period' },
	            'PM'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TimePeriods;
	}(_react.PureComponent);
	
	TimePeriods.propTypes = {
	  /**
	   * The current time for the time picker.
	   */
	  tempTime: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * A function to update the time for the time picker.
	   */
	  setTempTime: _propTypes2.default.func.isRequired,
	
	  /**
	   * The current time period.
	   */
	  timePeriod: _propTypes2.default.string.isRequired
	};
	exports.default = TimePeriods;
	//# sourceMappingURL=TimePeriods.js.map

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ClockFace = __webpack_require__(294);
	
	var _ClockFace2 = _interopRequireDefault(_ClockFace);
	
	var _DialogFooter = __webpack_require__(69);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	var _TimePickerHeader = __webpack_require__(304);
	
	var _TimePickerHeader2 = _interopRequireDefault(_TimePickerHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TimePicker` component is used to display a time picker
	 * in the `TimePickerContainer` component.
	 */
	var TimePicker = function (_PureComponent) {
	  _inherits(TimePicker, _PureComponent);
	
	  function TimePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this._updateTime = function (newTime) {
	      var timePart = newTime;
	      var _this$props = _this.props,
	          tempTime = _this$props.tempTime,
	          setTempTime = _this$props.setTempTime,
	          timeMode = _this$props.timeMode,
	          timePeriod = _this$props.timePeriod;
	
	      var time = new Date(tempTime);
	      if (timeMode === 'hour') {
	        var isAM = timePeriod === 'AM';
	        var is12 = timePart === 12;
	        if (timePeriod && isAM && is12) {
	          timePart = 0;
	        } else if (timePeriod && !isAM && !is12) {
	          timePart += 12;
	        }
	
	        time.setHours(timePart);
	      } else {
	        time.setMinutes(timePart);
	      }
	
	      setTempTime(time);
	    }, _this._handleTimeChosen = function () {
	      var _this$props2 = _this.props,
	          hoverMode = _this$props2.hoverMode,
	          setTimeMode = _this$props2.setTimeMode,
	          onOkClick = _this$props2.onOkClick,
	          timeMode = _this$props2.timeMode;
	
	
	      if (hoverMode) {
	        if (timeMode === 'hour') {
	          setTimeMode('minute');
	        } else {
	          onOkClick();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Takes in the new time (number o'clock or minutes), updates the temp time
	   * with that new time, and then calls the setTempTime prop.
	   */
	
	
	  _createClass(TimePicker, [{
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          okLabel = _props.okLabel,
	          okPrimary = _props.okPrimary,
	          onOkClick = _props.onOkClick,
	          cancelLabel = _props.cancelLabel,
	          cancelPrimary = _props.cancelPrimary,
	          onCancelClick = _props.onCancelClick,
	          style = _props.style,
	          className = _props.className,
	          setTimeMode = _props.setTimeMode,
	          setTempTime = _props.setTempTime,
	          timeMode = _props.timeMode,
	          tempTime = _props.tempTime,
	          hours = _props.hours,
	          minutes = _props.minutes,
	          timePeriod = _props.timePeriod,
	          displayMode = _props.displayMode,
	          inline = _props.inline,
	          icon = _props.icon,
	          hoverMode = _props.hoverMode;
	
	
	      var hoursInt = parseInt(hours, 10);
	      var minutesInt = parseInt(minutes.replace(/[^0-9]/g, ''), 10);
	      var actions = [{
	        key: 'cancel',
	        onClick: onCancelClick,
	        primary: cancelPrimary,
	        secondary: !cancelPrimary,
	        label: cancelLabel
	      }, {
	        key: 'ok',
	        onClick: onOkClick,
	        primary: okPrimary,
	        secondary: !okPrimary,
	        label: okLabel
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-picker md-picker--time', (_cn = {}, _defineProperty(_cn, 'md-picker--' + displayMode, displayMode), _defineProperty(_cn, 'md-picker--inline', inline), _defineProperty(_cn, 'md-picker--inline-icon', inline && icon), _cn), className)
	        },
	        _react2.default.createElement(_TimePickerHeader2.default, {
	          tempTime: tempTime,
	          timeMode: timeMode,
	          setTimeMode: setTimeMode,
	          setTempTime: setTempTime,
	          hours: hours,
	          minutes: minutes,
	          timePeriod: timePeriod
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'md-picker-content-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'md-picker-content md-picker-content--clock' },
	            _react2.default.createElement(_ClockFace2.default, {
	              time: timeMode === 'hour' ? hoursInt : minutesInt,
	              minutes: timeMode === 'minute',
	              onChange: this._updateTime,
	              timePeriod: timePeriod,
	              hoverMode: hoverMode,
	              onTimeChosen: this._handleTimeChosen
	            })
	          ),
	          _react2.default.createElement(_DialogFooter2.default, { actions: actions })
	        )
	      );
	    }
	  }]);
	
	  return TimePicker;
	}(_react.PureComponent);
	
	TimePicker.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  okLabel: _propTypes2.default.node.isRequired,
	  okPrimary: _propTypes2.default.bool.isRequired,
	  onOkClick: _propTypes2.default.func.isRequired,
	  cancelLabel: _propTypes2.default.node.isRequired,
	  cancelPrimary: _propTypes2.default.bool.isRequired,
	  onCancelClick: _propTypes2.default.func.isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  icon: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * A function that will switch the state from hour to minute.
	   */
	  setTimeMode: _propTypes2.default.func.isRequired,
	
	  /**
	   * A function that will update the time for the TimePicker before
	   * the user selects ok. This function will be given a new Date object
	   * with a modified time.
	   */
	  setTempTime: _propTypes2.default.func.isRequired,
	
	  /**
	   * The current display mode of the time picker.
	   */
	  timeMode: _propTypes2.default.oneOf(['hour', 'minute']).isRequired,
	
	  /**
	   * The current time as a date object that is being displayed in the
	   * time picker.
	   */
	  tempTime: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * A string that is a representation of the hours in the user's locale.
	   */
	  hours: _propTypes2.default.string.isRequired,
	
	  /**
	   * A string that is a representation of the minutes in the user's locale.
	   * This will also include any separator the locale uses.
	   *
	   * Example: ':15' in '3:15 PM' for 'en-US'
	   */
	  minutes: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional time period if a user's locale uses it.
	   */
	  timePeriod: _propTypes2.default.string,
	
	  /**
	   * If true the hover mode of the Time Picker is activated.
	   * In hover mode no clicks are required to start selecting an hour
	   * and the timemode switches automatically when a time was chosen.
	   * When a minute is selected the chosen time is applied automatically.
	   */
	  hoverMode: _propTypes2.default.bool
	};
	exports.default = TimePicker;
	//# sourceMappingURL=TimePicker.js.map

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(9);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _handleWindowClickListeners = __webpack_require__(73);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _handleKeyboardAccessibility = __webpack_require__(53);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _DateTimeFormat = __webpack_require__(164);
	
	var _DateTimeFormat2 = _interopRequireDefault(_DateTimeFormat);
	
	var _formatTime = __webpack_require__(165);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	var _extractTimeParts = __webpack_require__(354);
	
	var _extractTimeParts2 = _interopRequireDefault(_extractTimeParts);
	
	var _DialogContainer = __webpack_require__(89);
	
	var _DialogContainer2 = _interopRequireDefault(_DialogContainer);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _TextField = __webpack_require__(48);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Collapse = __webpack_require__(35);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _TimePicker = __webpack_require__(302);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-shadow */
	
	
	/**
	 * The `TimePickerContainer` component is a wrapper for the main `TimePicker` component
	 * to manage the state and _logic_ for rendering the `TimePicker`. This component will
	 * either render inline or in a `Dialog` depending if the `inline` prop is set
	 * to `true`.
	 *
	 * NOTE: This component is actually exported as `TimePicker` when using the `import { member }` syntax.
	 * The following two lines are equivalent:
	 *
	 * ```js
	 * import { TimePicker } from 'react-md/lib/Pickers';
	 * import TimePicker from 'react-md/lib/Pickers/TimePickerContainer';
	 * ```
	 */
	var TimePickerContainer = function (_PureComponent) {
	  _inherits(TimePickerContainer, _PureComponent);
	
	  function TimePickerContainer(props) {
	    _classCallCheck(this, TimePickerContainer);
	
	    var _this = _possibleConstructorReturn(this, (TimePickerContainer.__proto__ || Object.getPrototypeOf(TimePickerContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var initialDate = void 0;
	    if (props.defaultValue) {
	      initialDate = new Date(props.defaultValue);
	    } else if (props.value) {
	      initialDate = new Date(props.value);
	    } else {
	      initialDate = new Date();
	    }
	
	    var visible = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultVisible;
	
	    _this.state = _extends({
	      visible: visible
	    }, _this._getTimeParts(initialDate, props), {
	      value: props.defaultValue,
	      time: initialDate,
	      timeMode: props.initialTimeMode || props.defaultTimeMode,
	      tempTime: initialDate
	    });
	    return _this;
	  }
	
	  _createClass(TimePickerContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var time = nextProps.value || new Date();
	        this.setState(_extends({ tempTime: time }, this._getTimeParts(time, nextProps)));
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props,
	          inline = _props.inline,
	          isOpen = _props.isOpen;
	
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	      var pVisible = typeof prevProps.isOpen !== 'undefined' ? prevProps.isOpen : (0, _getField2.default)(prevProps, prevState, 'visible');
	
	      if (visible === pVisible) {
	        return;
	      }
	
	      if (visible) {
	        if (inline) {
	          (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
	          window.addEventListener('keydown', this._closeOnEsc);
	        }
	      } else if (inline) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	        window.removeEventListener('keydown', this._closeOnEsc);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	      if (visible && this.props.inline) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	        window.removeEventListener('keydown', this._closeOnEsc);
	      }
	    }
	  }, {
	    key: '_getTimeParts',
	    value: function _getTimeParts(date, props) {
	      return (0, _extractTimeParts2.default)(props.DateTimeFormat, props.locales, date);
	    }
	  }, {
	    key: '_getTextFieldValue',
	    value: function _getTextFieldValue(props, state) {
	      var DateTimeFormat = props.DateTimeFormat,
	          locales = props.locales;
	
	      var value = (0, _getField2.default)(props, state, 'value');
	      if (!value) {
	        return '';
	      } else if (value instanceof Date) {
	        return (0, _formatTime2.default)(DateTimeFormat, locales, value);
	      } else {
	        // currently don't support value of string
	        return value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          timeMode = _state.timeMode,
	          tempTime = _state.tempTime,
	          hours = _state.hours,
	          minutes = _state.minutes,
	          timePeriod = _state.timePeriod;
	
	      var _props2 = this.props,
	          style = _props2.style,
	          className = _props2.className,
	          pickerStyle = _props2.pickerStyle,
	          pickerClassName = _props2.pickerClassName,
	          inputStyle = _props2.inputStyle,
	          inputClassName = _props2.inputClassName,
	          textFieldStyle = _props2.textFieldStyle,
	          textFieldClassName = _props2.textFieldClassName,
	          id = _props2.id,
	          disabled = _props2.disabled,
	          label = _props2.label,
	          placeholder = _props2.placeholder,
	          icon = _props2.icon,
	          inline = _props2.inline,
	          displayMode = _props2.displayMode,
	          fullWidth = _props2.fullWidth,
	          lineDirection = _props2.lineDirection,
	          closeOnEsc = _props2.closeOnEsc,
	          hoverMode = _props2.hoverMode,
	          portal = _props2.portal,
	          renderNode = _props2.renderNode,
	          lastChild = _props2.lastChild,
	          animateInline = _props2.animateInline,
	          block = _props2.block,
	          paddedBlock = _props2.paddedBlock,
	          active = _props2.active,
	          error = _props2.error,
	          floating = _props2.floating,
	          required = _props2.required,
	          leftIconStateful = _props2.leftIconStateful,
	          rightIcon = _props2.rightIcon,
	          rightIconStateful = _props2.rightIconStateful,
	          customSize = _props2.customSize,
	          errorText = _props2.errorText,
	          helpText = _props2.helpText,
	          helpOnFocus = _props2.helpOnFocus,
	          inlineIndicator = _props2.inlineIndicator,
	          disableScrollLocking = _props2.disableScrollLocking,
	          ariaLabel = _props2['aria-label'],
	          propValue = _props2.value,
	          propVisible = _props2.visible,
	          readOnly = _props2.readOnly,
	          defaultValue = _props2.defaultValue,
	          defaultVisible = _props2.defaultVisible,
	          defaultTimeMode = _props2.defaultTimeMode,
	          onVisibilityChange = _props2.onVisibilityChange,
	          isOpen = _props2.isOpen,
	          initialTimeMode = _props2.initialTimeMode,
	          initiallyOpen = _props2.initiallyOpen,
	          props = _objectWithoutProperties(_props2, ['style', 'className', 'pickerStyle', 'pickerClassName', 'inputStyle', 'inputClassName', 'textFieldStyle', 'textFieldClassName', 'id', 'disabled', 'label', 'placeholder', 'icon', 'inline', 'displayMode', 'fullWidth', 'lineDirection', 'closeOnEsc', 'hoverMode', 'portal', 'renderNode', 'lastChild', 'animateInline', 'block', 'paddedBlock', 'active', 'error', 'floating', 'required', 'leftIconStateful', 'rightIcon', 'rightIconStateful', 'customSize', 'errorText', 'helpText', 'helpOnFocus', 'inlineIndicator', 'disableScrollLocking', 'aria-label', 'value', 'visible', 'readOnly', 'defaultValue', 'defaultVisible', 'defaultTimeMode', 'onVisibilityChange', 'isOpen', 'initialTimeMode', 'initiallyOpen']);
	
	      var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	      var picker = _react2.default.createElement(_TimePicker2.default, _extends({}, props, {
	        inline: inline,
	        icon: !!icon,
	        tempTime: tempTime,
	        timeMode: timeMode,
	        hours: hours,
	        minutes: minutes,
	        timePeriod: timePeriod,
	        style: pickerStyle,
	        className: pickerClassName,
	        displayMode: displayMode,
	        onOkClick: this._handleOkClick,
	        onCancelClick: this._handleCancelClick,
	        setTimeMode: this._setTimeMode,
	        setTempTime: this._setTempTime,
	        hoverMode: hoverMode
	      }));
	
	      var content = void 0;
	      if (inline) {
	        content = _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: !visible, animate: animateInline },
	          picker
	        );
	      } else {
	        content = _react2.default.createElement(
	          _DialogContainer2.default,
	          {
	            id: id + '-dialog',
	            visible: visible,
	            onHide: this._handleCancelClick,
	            dialogClassName: 'md-dialog--picker',
	            contentClassName: 'md-dialog-content--picker',
	            'aria-label': ariaLabel,
	            closeOnEsc: closeOnEsc,
	            portal: portal,
	            lastChild: lastChild,
	            renderNode: renderNode,
	            focusOnMount: false,
	            disableScrollLocking: disableScrollLocking
	          },
	          picker
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: style, className: (0, _classnames2.default)('md-picker-container', className), ref: this._setContainer },
	        _react2.default.createElement(_TextField2.default, {
	          id: id,
	          style: textFieldStyle,
	          className: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, textFieldClassName),
	          inputStyle: inputStyle,
	          inputClassName: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, inputClassName),
	          active: active || visible,
	          error: error,
	          floating: floating || visible,
	          required: required,
	          disabled: disabled,
	          leftIcon: icon,
	          leftIconStateful: leftIconStateful,
	          rightIcon: rightIcon,
	          rightIconStateful: rightIconStateful,
	          inlineIndicator: inlineIndicator,
	          block: block,
	          paddedBlock: paddedBlock,
	          fullWidth: fullWidth,
	          lineDirection: lineDirection,
	          customSize: customSize,
	          helpText: helpText,
	          helpOnFocus: helpOnFocus,
	          errorText: errorText,
	          label: label,
	          placeholder: placeholder,
	          onClick: this._toggleOpen,
	          onKeyDown: this._handleKeyDown,
	          value: this._getTextFieldValue(this.props, this.state),
	          readOnly: true
	        }),
	        content
	      );
	    }
	  }]);
	
	  return TimePickerContainer;
	}(_react.PureComponent);
	
	TimePickerContainer.propTypes = {
	  /**
	   * An id for the text field in the time picker. This is require for a11y.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An aria-label to apply to the dialog when it has been opened. This is required for
	   * a11y.
	   */
	  'aria-label': (0, _isRequiredForA11y2.default)(_propTypes2.default.string),
	
	  /**
	   * An optional style to apply to the time picker's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the time picker's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the time picker.
	   */
	  pickerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the time picker.
	   */
	  pickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the input tag.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the input tag.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the text field's container.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the text field's container.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional icon to display with the time picker.
	   *
	   * @see {@link TextFields/TextField#leftIcon}
	   */
	  icon: _propTypes2.default.node,
	
	  /**
	   * Boolean if the time picker is open by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * An optional label to be displayed in the time picker's text
	   * field.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder to be displayed in the time picker's text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * The value of the time picker. This will make the time picker
	   * be a controlled component.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.instanceOf(Date), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional function to call when the selected date is changed
	   * by hitting the OK button. The newly formatted time string,
	   * the new Date object, and the change event will be given.
	   *
	   * `onChange(timeString, dateObject, event)`.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional default value to give for the year picker.
	   */
	  defaultValue: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * A function to format the dates since it should be formatted to the user's
	   * locale. This _should_ be the `Intl.DateTimeFormat` function. You
	   * can also create your own if you really wanted. Inadvisable though.
	   *
	   * See [intl-polyfill](https://github.com/andyearnshaw/Intl.js/) for more info.
	   */
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	
	  /**
	   * The locales to use for formatting the date. This will default to using
	   * the user's language in the browser or `'en-US'` when server rendering.
	   */
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	
	  /**
	   * The label to use for the ok button on the year picker.
	   */
	  okLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the ok button should be styled with the primary color.
	   */
	  okPrimary: _propTypes2.default.bool,
	
	  /**
	   * The label to use for the cancel button on the year picker.
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the cancel button should be styled with the primary color.
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * The default mode to open the time picker in.
	   */
	  defaultTimeMode: _propTypes2.default.oneOf(['hour', 'minute']),
	
	  /**
	   * Boolean if the date should automatically be selected when a user clicks
	   * on a new date instead of making them hit the ok button.
	   */
	  autoOk: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the date picker should be displayed inline instead of in a
	   * dialog.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * An optional force of the display mode of the date picker.
	   * This _should_ not really be used since there are media queries
	   * to use the correct mode based on device orientation.
	   */
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * Boolean if the text field for the Time Picker should be displayed as full width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The direction that the text field divider expands from when the text field
	   * in the date picker gains focus.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']),
	
	  /**
	   * An optional boolean if the time picker is current visible by dialog or inline.
	   * If this is set, the `onVisibilityChange` function is required.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the date picker is opened in either a dialog, or
	   * inline. The callback will include the next state.
	   *
	   * ```js
	   * onVisibilityChange(!visible, e);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the time picker is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be able to close if a keyboard user presses the escape key.
	   */
	  closeOnEsc: _propTypes2.default.bool,
	
	  /**
	   * If true the hover mode of the Time Picker is activated.
	   * In hover mode no clicks are required to start selecting an hour
	   * and the time mode switches automatically when a time was chosen.
	   * When a minute is selected the chosen time is applied automatically.
	   */
	  hoverMode: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the inline time picker's visibility should be animated.
	   */
	  animateInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the time is required.
	   *
	   * @see {@link TextFields/TextField#required}
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * @see {@link TextFields/TextField#block}
	   */
	  block: _TextField2.default.propTypes.block,
	
	  /**
	   * @see {@link TextFields/TextField#paddedBlock}
	   */
	  paddedBlock: _TextField2.default.propTypes.paddedBlock,
	
	  /**
	   * @see {@link TextFields/TextField#active}
	   */
	  active: _TextField2.default.propTypes.active,
	
	  /**
	   * @see {@link TextFields/TextField#error}
	   */
	  error: _TextField2.default.propTypes.error,
	
	  /**
	   * @see {@link TextFields/TextField#floating}
	   */
	  floating: _TextField2.default.propTypes.floating,
	
	  /**
	   * @see {@link TextFields/TextField#leftIconStateful}
	   */
	  leftIconStateful: _TextField2.default.propTypes.leftIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#rightIcon}
	   */
	  rightIcon: _TextField2.default.propTypes.rightIcon,
	
	  /**
	   * @see {@link TextFields/TextField#rightIconStateful}
	   */
	  rightIconStateful: _TextField2.default.propTypes.rightIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#customSize}
	   */
	  customSize: _TextField2.default.propTypes.customSize,
	
	  /**
	   * @see {@link TextFields/TextField#errorText}
	   */
	  errorText: _TextField2.default.propTypes.errorText,
	
	  /**
	   * @see {@link TextFields/TextField#helpText}
	   */
	  helpText: _TextField2.default.propTypes.helpText,
	
	  /**
	   * @see {@link TextFields/TextField#helpOnFocus}
	   */
	  helpOnFocus: _TextField2.default.propTypes.helpOnFocus,
	
	  /**
	   * @see {@link TextFields/TextField#inlineIndicator}
	   */
	  inlineIndicator: _TextField2.default.propTypes.inlineIndicator,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the dialog.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the dialog into. The default is to render as the first child
	   * in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the dialog should be rendered as the last child of the `renderNode` or `body` instead
	   * of the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Dialogs/DialogContainer#disableScrollLocking}
	   */
	  disableScrollLocking: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the TimePicker should be read only. This will prevent the user from opening the picker
	   * and only display the current date in the text field.
	   */
	  readOnly: _propTypes2.default.bool,
	
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initialTimeMode: (0, _deprecated2.default)(_propTypes2.default.oneOf(['hour', 'minute']), 'Use `defaultTimeMode` instead')
	};
	TimePickerContainer.defaultProps = {
	  animateInline: true,
	  defaultTimeMode: 'hour',
	  icon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'access_time'
	  ),
	  DateTimeFormat: _DateTimeFormat2.default, // eslint-disable-line object-shorthand
	  locales: typeof window !== 'undefined' ? window.navigator.userLanguage || window.navigator.language : 'en-US',
	  okLabel: 'Ok',
	  okPrimary: true,
	  cancelLabel: 'Cancel',
	  cancelPrimary: true,
	  closeOnEsc: true,
	  disableScrollLocking: false,
	  'aria-label': 'Select a time',
	  hoverMode: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    _this2._container = container;
	  };
	
	  this._closeOnEsc = function (e) {
	    if ((e.which || e.keyCode) === _keyCodes.ESC) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this2._container && !_this2._container.contains(e.target)) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._toggleOpen = function (e) {
	    if (_this2.props.disabled || _this2.props.readOnly) {
	      return;
	    }
	
	    var visible = !(typeof _this2.props.isOpen !== 'undefined' ? _this2.props.isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible'));
	
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(visible, e);
	    }
	
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      var hoverMode = _this2.props.hoverMode;
	
	
	      if (hoverMode) {
	        _this2._setTimeMode('hour');
	      }
	
	      _this2.setState({ visible: visible });
	    }
	  };
	
	  this._setTimeMode = function (timeMode) {
	    if (_this2.state.timeMode === timeMode) {
	      return;
	    }
	
	    _this2.setState({ timeMode: timeMode });
	  };
	
	  this._setTempTime = function (time) {
	    if (_this2.state.tempTime === time) {
	      return;
	    }
	
	    _this2.setState(_extends({ tempTime: time }, _this2._getTimeParts(time, _this2.props)));
	  };
	
	  this._handleKeyDown = function (e) {
	    (0, _handleKeyboardAccessibility2.default)(e, _this2._toggleOpen, true, true);
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB && _this2.state.active) {
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleOkClick = function (e) {
	    var _props3 = _this2.props,
	        onVisibilityChange = _props3.onVisibilityChange,
	        onChange = _props3.onChange,
	        DateTimeFormat = _props3.DateTimeFormat,
	        locales = _props3.locales;
	
	    var value = new Date(_this2.state.tempTime);
	    if (onChange) {
	      onChange((0, _formatTime2.default)(DateTimeFormat, locales, value), value, e);
	    }
	
	    if (onVisibilityChange) {
	      onVisibilityChange(false, e);
	    }
	
	    var state = _extends({ time: value }, _this2._getTimeParts(value, _this2.props));
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      state.visible = false;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleCancelClick = function (e) {
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(false, e);
	    }
	
	    var state = void 0;
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      state = { visible: false };
	    }
	
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    if (value) {
	      state = _extends({}, state, _this2._getTimeParts(value, _this2.props));
	      state.tempTime = _this2.state.time;
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	};
	
	exports.default = TimePickerContainer;
	//# sourceMappingURL=TimePickerContainer.js.map

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimePeriods = __webpack_require__(301);
	
	var _TimePeriods2 = _interopRequireDefault(_TimePeriods);
	
	var _PickerControl = __webpack_require__(95);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TimePickerHeader` component is used for rendering the
	 * current time for the `TimePicker` as well as switching between
	 * the different views for the time picker.
	 */
	var TimePickerHeader = function (_PureComponent) {
	  _inherits(TimePickerHeader, _PureComponent);
	
	  function TimePickerHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePickerHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePickerHeader.__proto__ || Object.getPrototypeOf(TimePickerHeader)).call.apply(_ref, [this].concat(args))), _this), _this._setHour = function () {
	      _this.props.setTimeMode('hour');
	    }, _this._setMinute = function () {
	      _this.props.setTimeMode('minute');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TimePickerHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          timeMode = _props.timeMode,
	          hours = _props.hours,
	          minutes = _props.minutes,
	          timePeriod = _props.timePeriod,
	          setTempTime = _props.setTempTime,
	          tempTime = _props.tempTime;
	
	      var timePeriods = void 0;
	      if (timePeriod) {
	        timePeriods = _react2.default.createElement(_TimePeriods2.default, { tempTime: tempTime, setTempTime: setTempTime, timePeriod: timePeriod });
	      }
	
	      return _react2.default.createElement(
	        'header',
	        { className: 'md-picker-header md-text-right' },
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._setHour, active: timeMode === 'hour' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'md-display-3' },
	            hours
	          )
	        ),
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._setMinute, active: timeMode === 'minute' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'md-display-3' },
	            minutes
	          )
	        ),
	        timePeriods
	      );
	    }
	  }]);
	
	  return TimePickerHeader;
	}(_react.PureComponent);
	
	TimePickerHeader.propTypes = {
	  /**
	   * The current time of the time picker.
	   */
	  tempTime: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * The current time type that is being changed.
	   */
	  timeMode: _propTypes2.default.oneOf(['hour', 'minute']).isRequired,
	
	  /**
	   * A function to update the time mode.
	   */
	  setTimeMode: _propTypes2.default.func.isRequired,
	
	  /**
	   * A function to update the time for the time picker.
	   */
	  setTempTime: _propTypes2.default.func.isRequired,
	
	  /**
	   * A formatted hours string for the user's locale. This
	   * would be '3' for en-US if the time was '3:15'
	   */
	  hours: _propTypes2.default.string.isRequired,
	
	  /**
	   * A formatted minutes string for the user's locale.
	   * This would be ':15' for en-US if the time was '3:15'.
	   */
	  minutes: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional time period to use for locales that use
	   * 12 hour clocks and AM/PM.
	   */
	  timePeriod: _propTypes2.default.string
	};
	exports.default = TimePickerHeader;
	//# sourceMappingURL=TimePickerHeader.js.map

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is a component for rendering a year in the Date Picker's Year picker
	 * list.
	 */
	var Year = function (_PureComponent) {
	  _inherits(Year, _PureComponent);
	
	  function Year() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Year);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Year.__proto__ || Object.getPrototypeOf(Year)).call.apply(_ref, [this].concat(args))), _this), _this.state = { desktopActive: false }, _this._setActiveFocus = function (btn) {
	      if (btn && _this.props.active) {
	        btn.focus();
	      }
	    }, _this._setActive = function () {
	      _this.setState({ desktopActive: true });
	    }, _this._setInactive = function () {
	      _this.setState({ desktopActive: false });
	    }, _this._handleClick = function (e) {
	      _this.props.onClick(_this.props.year, e);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Year, [{
	    key: 'render',
	    value: function render() {
	      var desktopActive = this.state.desktopActive;
	      var _props = this.props,
	          active = _props.active,
	          className = _props.className,
	          year = _props.year;
	
	      return _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          ref: this._setActiveFocus,
	          className: (0, _classnames2.default)('md-year', { 'md-year--active': active }, (0, _themeColors2.default)({
	            text: !active && !desktopActive,
	            primary: active || desktopActive
	          }), 'md-btn md-pointer--hover md-full-width', className),
	          onClick: this._handleClick
	        },
	        year
	      );
	    }
	  }]);
	
	  return Year;
	}(_react.PureComponent);
	
	Year.propTypes = {
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  year: _propTypes2.default.number.isRequired
	};
	exports.default = Year;
	//# sourceMappingURL=Year.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Year = __webpack_require__(305);
	
	var _Year2 = _interopRequireDefault(_Year);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `YearPicker` component is the Year view in a `DatePicker`. This
	 * will display a list of years to select from within the given range.
	 */
	var YearPicker = function (_PureComponent) {
	  _inherits(YearPicker, _PureComponent);
	
	  function YearPicker(props) {
	    _classCallCheck(this, YearPicker);
	
	    var _this = _possibleConstructorReturn(this, (YearPicker.__proto__ || Object.getPrototypeOf(YearPicker)).call(this, props));
	
	    _this.state = _this._getYearRange(props);
	    return _this;
	  }
	
	  _createClass(YearPicker, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.yearsDisplayed !== nextProps.yearsDisplayed) {
	        this.setState(this._getFullYear(nextProps));
	      }
	    }
	
	    /**
	     * Gets the current start and end years for the year picker.
	     *
	     * @param {Object} props - The current props to extract the year range from.
	     * @return {Object} an object containign the start and end years
	     */
	
	  }, {
	    key: '_getYearRange',
	    value: function _getYearRange(_ref) {
	      var minDate = _ref.minDate,
	          maxDate = _ref.maxDate,
	          yearsDisplayed = _ref.yearsDisplayed,
	          calendarTempDate = _ref.calendarTempDate;
	
	      var year = calendarTempDate.getFullYear();
	      var range = !minDate && !maxDate ? parseInt(yearsDisplayed / 2, 10) : yearsDisplayed;
	
	      var startYear = void 0;
	      var endYear = void 0;
	      if (minDate && maxDate) {
	        startYear = minDate.getFullYear();
	        endYear = maxDate.getFullYear();
	      } else if (!minDate && !maxDate) {
	        startYear = year - range;
	        endYear = year + range;
	        if (yearsDisplayed % 2 === 0) {
	          endYear -= 1;
	        }
	      } else if (!maxDate) {
	        startYear = minDate.getFullYear();
	        endYear = startYear + yearsDisplayed - 1;
	      } else {
	        endYear = maxDate.getFullYear();
	        startYear = endYear - yearsDisplayed + 1;
	      }
	
	      return { startYear: startYear, endYear: endYear };
	    }
	  }, {
	    key: '_setContainer',
	    value: function _setContainer(container) {
	      if (container === null) {
	        return;
	      }
	
	      var offsetHeight = container.offsetHeight,
	          offsetWidth = container.offsetWidth;
	
	      var _container$querySelec = container.querySelector('.md-year--active'),
	          top = _container$querySelec.offsetTop,
	          height = _container$querySelec.offsetHeight;
	
	      // Portrait seems to be 3/4 of the way while landscape is about 1/2
	
	
	      if (offsetHeight > offsetWidth) {
	        container.scrollTop = top - offsetHeight * 3 / 4;
	      } else {
	        container.scrollTop = top - offsetHeight / 2 + height / 2;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          startYear = _state.startYear,
	          endYear = _state.endYear;
	
	
	      var currentYear = this.props.calendarTempDate.getFullYear();
	      var years = [];
	      for (var year = startYear; year <= endYear; year++) {
	        years.push(_react2.default.createElement(_Year2.default, {
	          key: year,
	          year: year,
	          active: year === currentYear,
	          onClick: this.props.onCalendarYearClick
	        }));
	      }
	
	      return _react2.default.createElement(
	        'section',
	        {
	          className: (0, _classnames2.default)('md-picker-content md-picker-content--year', this.props.className),
	          ref: this._setContainer
	        },
	        _react2.default.createElement(
	          'ol',
	          { className: 'md-years' },
	          years
	        )
	      );
	    }
	  }]);
	
	  return YearPicker;
	}(_react.PureComponent);
	
	YearPicker.propTypes = {
	  className: _propTypes2.default.string,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  onCalendarYearClick: _propTypes2.default.func.isRequired,
	  yearsDisplayed: _propTypes2.default.number.isRequired,
	  minDate: _propTypes2.default.instanceOf(Date),
	  maxDate: _propTypes2.default.instanceOf(Date)
	};
	exports.default = YearPicker;
	//# sourceMappingURL=YearPicker.js.map

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimePickerContainer = exports.TimePicker = exports.DatePickerContainer = exports.DatePicker = undefined;
	
	var _DatePickerContainer2 = __webpack_require__(299);
	
	var _DatePickerContainer3 = _interopRequireDefault(_DatePickerContainer2);
	
	var _TimePickerContainer2 = __webpack_require__(303);
	
	var _TimePickerContainer3 = _interopRequireDefault(_TimePickerContainer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DatePicker = _DatePickerContainer3.default;
	exports.DatePickerContainer = _DatePickerContainer3.default;
	exports.TimePicker = _TimePickerContainer3.default;
	exports.TimePickerContainer = _TimePickerContainer3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _between = __webpack_require__(55);
	
	var _between2 = _interopRequireDefault(_between);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ROATE_DISTANCE = 360 * 1.75;
	var BASE_SIZE = 24; // font-icon font size
	
	/**
	 * The `CircularProgress` component is used to give visual feedback while your app
	 * is loading.
	 *
	 * There are two different types of circular progress bars: `Determinate` and `Indeterminate`.
	 *
	 * A `Determinate` circular progress bar should be used when you want to keep track of the current
	 * progress. An example would be downloading a file.
	 *
	 * An `Indeterminate` circular progress bar should be used when you can not keep track of the progress
	 * yourself. An example would be waiting for some API call to complete.
	 */
	
	var CircularProgress = function (_PureComponent) {
	  _inherits(CircularProgress, _PureComponent);
	
	  function CircularProgress() {
	    _classCallCheck(this, CircularProgress);
	
	    return _possibleConstructorReturn(this, (CircularProgress.__proto__ || Object.getPrototypeOf(CircularProgress)).apply(this, arguments));
	  }
	
	  _createClass(CircularProgress, [{
	    key: 'render',
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var _props = this.props,
	          scale = _props.scale,
	          style = _props.style,
	          className = _props.className,
	          value = _props.value,
	          determinateDashoffset = _props.determinateDashoffset,
	          centered = _props.centered,
	          props = _objectWithoutProperties(_props, ['scale', 'style', 'className', 'value', 'determinateDashoffset', 'centered']);
	
	      var isDeterminate = typeof value === 'number';
	      var circleStyle = void 0;
	      var svgStyle = style;
	      if (isDeterminate) {
	        var rotate = 'rotate3d(0, 0, 1, ' + ROATE_DISTANCE / 100 * value + 'deg)';
	        circleStyle = {
	          strokeDashoffset: determinateDashoffset - determinateDashoffset / 100 * value
	        };
	
	        svgStyle = Object.assign({}, style, {
	          WebkitTransform: (0, _classnames2.default)(style.WebkitTransform, rotate),
	          MozTransform: (0, _classnames2.default)(style.MozTransform, rotate),
	          transform: (0, _classnames2.default)(style.transform, rotate)
	        });
	      }
	
	      var accessibilityProps = {
	        role: 'progressbar',
	        'aria-valuemin': 0,
	        'aria-valuemax': 100
	      };
	
	      if (isDeterminate) {
	        accessibilityProps['aria-valuenow'] = value;
	      }
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, accessibilityProps, {
	          style: svgStyle,
	          className: (0, _classnames2.default)('md-progress md-progress--circular', {
	            'md-block-centered': centered,
	            'md-progress--circular-determinate': isDeterminate,
	            'md-progress--circular-indeterminate': !isDeterminate
	          }, className),
	          width: scale * BASE_SIZE,
	          height: scale * BASE_SIZE,
	          viewBox: '0 0 66 66'
	        }),
	        _react2.default.createElement('circle', {
	          className: (0, _classnames2.default)('md-circular-progress-path', {
	            'md-circular-progress-path--animated': !isDeterminate
	          }),
	          strokeWidth: '6',
	          strokeLinecap: 'round',
	          style: circleStyle,
	          cx: '33',
	          cy: '33',
	          r: '30'
	        })
	      );
	    }
	  }]);
	
	  return CircularProgress;
	}(_react.PureComponent);
	
	CircularProgress.propTypes = {
	  /**
	   * The `id` prop is required for accessibility concerns.
	   * [Progress Bar Role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_progressbar_role)
	   *
	   * > If the progressbar is describing the loading progress of a particular region of a page, the author
	   * __SHOULD__ use aria-describedby to point to the status, and set the aria-busy attribute to true on the
	   * region until it is finished loading. It is not possible for the user to alter the value of a progressbar
	   * because it is always readonly.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /* eslint-enable max-len */
	
	  /**
	   * A style object to apply to the SVG. If this is a determinate `CircularProgress`,
	   * the `transform` (and vendor prefixes) styles will be merged with the current
	   * progress rotation.
	   */
	  style: _propTypes2.default.object.isRequired,
	
	  /**
	   * An optional className to apply to the SVG.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The current value of the progress. If this value is defined, it will
	   * be converted to a determinate circular progress. The progress will not
	   * advance unless this value changes.
	   *
	   * This value should also be a number between 0 and 100.
	   */
	  value: (0, _between2.default)(_propTypes2.default.number, 0, 100),
	
	  /**
	   * The scale for the circular progress.
	   */
	  scale: _propTypes2.default.number.isRequired,
	
	  /**
	   * You probably don't want to update this. I'm not good at SVG. This should
	   * match the SCSS variable `$md-circular-progress-stroke-dashoffset`.
	   */
	  determinateDashoffset: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the progress should be centered in it's container.
	   */
	  centered: _propTypes2.default.bool
	};
	CircularProgress.defaultProps = {
	  style: {},
	  scale: 1,
	  determinateDashoffset: 187,
	  centered: true
	};
	exports.default = CircularProgress;
	//# sourceMappingURL=CircularProgress.js.map

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _between = __webpack_require__(55);
	
	var _between2 = _interopRequireDefault(_between);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * There are 3 different types of linear progress bars: `Determinate`,
	 * `Indeterminate`, and `Query Indeterminate`.
	 *
	 * A `Determinate` linear progress bar should be used when you can keep track of the
	 * progress and have a percentage complete you can work with. An example would be
	 * uploading/downloading a file.
	 *
	 * An `Indeterminate` linear progress bar should be used when you can not keep track
	 * of the progress yourself. An example might be waiting for an API call to complete.
	 *
	 * A `Query Indeterminate` linear progress bar is used when you are combining
	 * `Indeterminate` and `Determinate`. A Linear Progress component can be displayed
	 * as a query indeterminate progress bar by adding the prop `query={true}` to the
	 * component. Until a progress value is given, it will display the query linear
	 * progress animation. Afterwards, it will start the determinate animation of where
	 * you manually keep updating the value of the progress.
	 */
	var LinearProgress = function (_PureComponent) {
	  _inherits(LinearProgress, _PureComponent);
	
	  function LinearProgress() {
	    _classCallCheck(this, LinearProgress);
	
	    return _possibleConstructorReturn(this, (LinearProgress.__proto__ || Object.getPrototypeOf(LinearProgress)).apply(this, arguments));
	  }
	
	  _createClass(LinearProgress, [{
	    key: 'render',
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          progressClassName = _props.progressClassName,
	          progressStyle = _props.progressStyle,
	          value = _props.value,
	          query = _props.query,
	          centered = _props.centered,
	          props = _objectWithoutProperties(_props, ['className', 'progressClassName', 'progressStyle', 'value', 'query', 'centered']);
	
	      var isDeterminate = typeof value === 'number';
	
	      var accessibilityProps = {
	        role: 'progressbar',
	        'aria-valuemin': 0,
	        'aria-valuemax': 100
	      };
	
	      var style = void 0;
	      if (isDeterminate) {
	        style = { width: value + '%' };
	        accessibilityProps['aria-valuenow'] = value;
	      }
	      if (progressStyle) {
	        style = Object.assign(style || {}, typeof progressStyle === 'function' ? progressStyle(value, this) : progressStyle);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-progress md-progress--linear', { 'md-block-centered': centered }, className)
	        }),
	        _react2.default.createElement('div', _extends({}, accessibilityProps, {
	          style: style,
	          className: (0, _classnames2.default)('md-progress--linear-active', {
	            'md-progress--linear-query': query,
	            'md-progress--linear-determinate': isDeterminate,
	            'md-progress--linear-indeterminate': !isDeterminate
	          }, typeof progressClassName === 'function' ? progressClassName(value, this) : progressClassName)
	        }))
	      );
	    }
	  }]);
	
	  return LinearProgress;
	}(_react.PureComponent);
	
	LinearProgress.propTypes = {
	  /**
	   * The `id` prop is required for accessibility concerns.
	   * [Progress Bar Role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_progressbar_role)
	   *
	   * > If the progressbar is describing the loading progress of a particular region of a page, the author
	   * __SHOULD__ use aria-describedby to point to the status, and set the aria-busy attribute to true on the
	   * region until it is finished loading. It is not possible for the user to alter the value of a progressbar
	   * because it is always readonly.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /* eslint-enable max-len */
	  /**
	   * An optional className to apply to the linear progress container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the progress bar element.
	   *
	   * If a function is specified it will be called to get necessary className.
	   * Current progress value and reference to the component will be passed into the function.
	   */
	  progressClassName: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the progress bar element.
	   *
	   * If a function is specified it will be called to get necessary style.
	   * Current progress value and reference to the component will be passed into the function.
	   */
	  progressStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	
	  /**
	   * The current value of the progress. If this value is defined, it will
	   * be converted to a determinate circular progress. The progress will not
	   * advance unless this value changes.
	   *
	   * This value should also be a number between 0 and 100.
	   */
	  value: (0, _between2.default)(_propTypes2.default.number, 0, 100),
	
	  /**
	   * Boolean if this should be a query indeterminate progress bar.
	   */
	  query: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Linear Progress should be centered. This
	   * will only work if the `max-width` style is set.
	   */
	  centered: _propTypes2.default.bool
	};
	LinearProgress.defaultProps = {
	  query: false
	};
	exports.default = LinearProgress;
	//# sourceMappingURL=LinearProgress.js.map

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircularProgress = exports.LinearProgress = undefined;
	
	var _LinearProgress2 = __webpack_require__(309);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _CircularProgress2 = __webpack_require__(308);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.LinearProgress = _LinearProgress3.default;
	exports.CircularProgress = _CircularProgress3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `SVGIcon` component is used for rendering inline SVG icons or sprite-mapped SVGs
	 * as an icon.
	 */
	var SVGIcon = function (_PureComponent) {
	  _inherits(SVGIcon, _PureComponent);
	
	  function SVGIcon(props) {
	    _classCallCheck(this, SVGIcon);
	
	    var _this = _possibleConstructorReturn(this, (SVGIcon.__proto__ || Object.getPrototypeOf(SVGIcon)).call(this));
	
	    _this._getIds = function (_ref) {
	      var use = _ref.use,
	          labels = _ref['aria-labelledby'],
	          title = _ref.title,
	          desc = _ref.desc;
	
	      var titleId = null;
	      var descId = null;
	      var labelledBy = null;
	      if (title || desc) {
	        if (use) {
	          var baseId = use.replace(/.*#/, '');
	          titleId = baseId + '-title';
	          descId = baseId + '-desc';
	
	          if (title) {
	            labelledBy = baseId + '-title';
	          }
	
	          if (desc) {
	            labelledBy = '' + (labelledBy ? labelledBy + ' ' : '') + descId;
	          }
	        } else if (labels) {
	          var _labels$split = labels.split(' ');
	
	          var _labels$split2 = _slicedToArray(_labels$split, 2);
	
	          titleId = _labels$split2[0];
	          descId = _labels$split2[1];
	        }
	      }
	
	      return { titleId: titleId, descId: descId, labelledBy: labelledBy };
	    };
	
	    _this._mergeStyles = function (_ref2) {
	      var style = _ref2.style,
	          size = _ref2.size;
	
	      if (style && size) {
	        return _extends({ height: size, width: size }, style);
	      } else if (style) {
	        return style;
	      } else if (size) {
	        return { height: size, width: size };
	      }
	
	      return undefined;
	    };
	
	    _this.state = _extends({
	      styles: _this._mergeStyles(props)
	    }, _this._getIds(props));
	    return _this;
	  }
	
	  _createClass(SVGIcon, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          style = _props.style,
	          size = _props.size,
	          use = _props.use,
	          title = _props.title,
	          desc = _props.desc,
	          labels = _props['aria-labelledby'];
	
	      var nextState = void 0;
	      if (style !== nextProps.style || size !== nextProps.size) {
	        nextState = { styles: this._mergeStyles(nextProps) };
	      }
	
	      if (title !== nextProps.title || desc !== nextProps.desc || (nextProps.title || nextProps.desc) && (use !== nextProps.use || labels !== nextProps['aria-labelledby'])) {
	        nextState = _extends({}, nextState, this._getIds(nextProps));
	      }
	
	      if (nextState) {
	        this.setState(nextState);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          styles = _state.styles,
	          titleId = _state.titleId,
	          descId = _state.descId,
	          labelledBy = _state.labelledBy;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          use = _props2.use,
	          primary = _props2.primary,
	          secondary = _props2.secondary,
	          error = _props2.error,
	          inherit = _props2.inherit,
	          titleAttr = _props2.titleAttr,
	          ariaLabelledBy = _props2['aria-labelledby'],
	          size = _props2.size,
	          propTitle = _props2.title,
	          propDesc = _props2.desc,
	          propStyle = _props2.style,
	          propChildren = _props2.children,
	          props = _objectWithoutProperties(_props2, ['className', 'disabled', 'use', 'primary', 'secondary', 'error', 'inherit', 'titleAttr', 'aria-labelledby', 'size', 'title', 'desc', 'style', 'children']);
	
	      var _props3 = this.props,
	          children = _props3.children,
	          title = _props3.title,
	          desc = _props3.desc;
	
	      if (!children && use) {
	        children = _react2.default.createElement('use', { xlinkHref: use });
	      }
	
	      if (title) {
	        title = _react2.default.createElement(
	          'title',
	          { id: titleId },
	          title
	        );
	      }
	
	      if (desc) {
	        desc = _react2.default.createElement(
	          'desc',
	          { id: descId },
	          desc
	        );
	      }
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, {
	          title: titleAttr,
	          'aria-labelledby': ariaLabelledBy || labelledBy,
	          style: styles,
	          className: (0, _classnames2.default)('md-icon', (0, _themeColors2.default)({
	            disabled: disabled,
	            error: error,
	            inherit: inherit,
	            primary: primary,
	            secondary: secondary
	          }, className))
	        }),
	        title,
	        desc,
	        children
	      );
	    }
	  }]);
	
	  return SVGIcon;
	}(_react.PureComponent);
	
	SVGIcon.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the primary theme color should be applied.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the secondary theme color should be applied.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the icon is considered disabled and should inherit the
	   * disabled color.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the icon is considered errored and should inherit the error color.
	   */
	  error: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the color of the icon should be inherited by parent elements.
	   */
	  inherit: _propTypes2.default.bool,
	
	  /**
	   * The role to apply to the SVG. When using icons, it is generally recommended to leave it as the default
	   * `img` so that it is insured as a graphic.
	   */
	  role: _propTypes2.default.oneOf(['img', 'presentation']),
	
	  /**
	   * This prop is the title attribute to provide to the `<svg>` element itself. This should be used when you
	   * are using a spritesheet that has defined `<title>` with each SVG symbol.
	   */
	  titleAttr: _propTypes2.default.string,
	
	  /**
	   * An optional list of ids to use to label the SVG icon with. This is helpful to add when you use the `title`
	   * and `desc` props as this is used to create ids for those two props. This is super beneficial to screen readers.
	   *
	   * When this is defined, it is a space-delimited string of ids to provide to the title and desc (in order). If
	   * this is omitted and the `use` prop is defined, it will take everything after the `#` sign and append `-title` and
	   * `-desc` as a fallback. Check out the examples for more information about this.
	   *
	   * @see {@link #title}
	   * @see {@link #desc}
	   */
	  'aria-labelledby': _propTypes2.default.string,
	
	  /**
	   * An optional title to give to your SVG icon. This is generally recommended for accessibility when not using
	   * the `use` prop, or your spritemap does not contain `<title>` and `<desc>.
	   *
	   * @see {@link #aria-labelledby}
	   */
	  title: _propTypes2.default.string,
	
	  /**
	   * An optional description to give to your SVG icon. This is generally recommended for accessibility when not using
	   * the `use` prop, or your spritemap does not contain `<title>` and `<desc>.
	   *
	   * @see {@link #aria-labelledby}
	   */
	  desc: _propTypes2.default.string,
	
	  /**
	   * This should be a link to a part of an SVG spritemap. So normally one of the following:
	   * - `'#some-custom-svg'`
	   * - `'/images/spritemap.svg#some-custom-svg'`
	   *
	   * This prop **should not** be used with the `children` prop as only one will be rendered.
	   *
	   * > NOTE: IE **does not support** external SVGs. Please see the demo for more details.
	   */
	  use: _propTypes2.default.string,
	
	  /**
	   * Any `<svg>` children to render to create your icon. This can not be used with the `use` prop.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.node]),
	
	  /**
	   * Boolean if the SVG should gain the `focusable` attribute. This is disabled by default since IE11
	   * and Edge actually default this to true and keyboard's will tab focus all SVGs.
	   */
	  focusable: _propTypes2.default.string,
	
	  /**
	   * An optional size to apply to the SVG. This can be used to set both the
	   * `height` and `width` simultaneously. This will be provided as inline styles
	   * since the `height` and `width` are normally controlled by CSS, and CSS has
	   * higher precedence than the `height`/`width` attributes.
	   */
	  size: _propTypes2.default.number,
	
	  /**
	   * The `height` prop should not be used since the `height` and `width` are controlled by CSS and the CSS
	   * has a higher precedence than inline attributes. If you want to set the `height`, it should be done via
	   * CSS or the `size` prop.
	   *
	   * @see {@link #size}
	   */
	  height: (0, _deprecated2.default)(_propTypes2.default.number, 'Use the `size` prop instead.'),
	
	  /**
	   * The `width` prop should not be used since the `height` and `width` are controlled by CSS and the CSS
	   * has a higher precedence than inline attributes. If you want to set the `height`, it should be done via
	   * CSS or the `size` prop.
	   *
	   * @see {@link #size}
	   */
	  width: (0, _deprecated2.default)(_propTypes2.default.number, 'Use the `size` prop instead.'),
	
	  /**
	   * The viewBox attribute allows you to specify that a given set of graphics stretch to
	   * fit a particular container element.
	   *
	   * The value of the viewBox attribute is a list of four numbers min-x, min-y, width and
	   * height, separated by white space and/or a comma, which specify a rectangle in user
	   * space which should be mapped to the bounds of the viewport established by the given
	   * element, taking into account attribute preserveAspectRatio.
	   *
	   * Negative values for width or height are not permitted and a value of zero disables
	   * rendering of the element.An optional viewbox for the SVG.
	   *
	   * For example, if the SVG element is 250 (width) by 200 (height) and you provide
	   * `viewBox="0 0 25 20"`, the coordinates inside the SVG will go from the top left corner
	   * (0, 0) to the bottom right (25, 20) and each unit will be worth `10px`.
	   */
	  viewBox: _propTypes2.default.string,
	
	  /**
	   * An optional xmlns string to provide. The `use` prop will not work without this prop
	   * defined.
	   */
	  xmlns: _propTypes2.default.string
	};
	SVGIcon.defaultProps = {
	  role: 'img',
	  focusable: 'false',
	  xmlns: 'http://www.w3.org/2000/svg',
	  viewBox: '0 0 24 24'
	};
	exports.default = SVGIcon;
	//# sourceMappingURL=SVGIcon.js.map

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SVGIcon = undefined;
	
	var _SVGIcon2 = __webpack_require__(311);
	
	var _SVGIcon3 = _interopRequireDefault(_SVGIcon2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SVGIcon3.default;
	exports.SVGIcon = _SVGIcon3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroupTick = __webpack_require__(30);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _AccessibleFakeInkedButton = __webpack_require__(25);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _IconSeparator = __webpack_require__(44);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _Paper = __webpack_require__(29);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _TextFieldDivider = __webpack_require__(160);
	
	var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectFieldInput = function (_PureComponent) {
	  _inherits(SelectFieldInput, _PureComponent);
	
	  function SelectFieldInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SelectFieldInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectFieldInput.__proto__ || Object.getPrototypeOf(SelectFieldInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = { transition: null }, _this._timeout = null, _this._transitionNewValue = function () {
	      var _this$props = _this.props,
	          transitionTime = _this$props.transitionTime,
	          transitionName = _this$props.transitionName;
	
	      if (_this._timeout) {
	        clearTimeout(_this._timeout);
	      }
	
	      _this._timeout = setTimeout(function () {
	        _this._timeout = setTimeout(function () {
	          _this._timeout = null;
	          _this.setState({ transition: null });
	        }, transitionTime);
	
	        _this.setState({ transition: _this.state.transition + ' ' + transitionName + '-enter-active' });
	      }, _CSSTransitionGroupTick2.default);
	
	      _this.setState({ transition: transitionName + '-enter' });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SelectFieldInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        this._transitionNewValue();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          className = _props.className,
	          name = _props.name,
	          value = _props.value,
	          label = _props.label,
	          placeholder = _props.placeholder,
	          active = _props.active,
	          activeLabel = _props.activeLabel,
	          error = _props.error,
	          disabled = _props.disabled,
	          required = _props.required,
	          toolbar = _props.toolbar,
	          below = _props.below,
	          lineDirection = _props.lineDirection,
	          dropdownIcon = _props.dropdownIcon,
	          iconChildren = _props.iconChildren,
	          iconClassName = _props.iconClassName,
	          transitionName = _props.transitionName,
	          transitionTime = _props.transitionTime,
	          props = _objectWithoutProperties(_props, ['id', 'className', 'name', 'value', 'label', 'placeholder', 'active', 'activeLabel', 'error', 'disabled', 'required', 'toolbar', 'below', 'lineDirection', 'dropdownIcon', 'iconChildren', 'iconClassName', 'transitionName', 'transitionTime']);
	
	      var transition = this.state.transition;
	
	
	      var divider = void 0;
	      if (!below && !toolbar) {
	        divider = _react2.default.createElement(_TextFieldDivider2.default, {
	          key: 'text-divider',
	          active: active,
	          error: error,
	          lineDirection: lineDirection,
	          className: 'md-divider--select-field'
	        });
	      }
	
	      var visibleLabel = activeLabel;
	      if (!activeLabel && activeLabel !== 0) {
	        visibleLabel = (!label || active) && placeholder || '';
	      }
	
	      var labelActive = !!activeLabel || activeLabel === 0;
	
	      var icon = dropdownIcon;
	      if (iconClassName || iconChildren) {
	        icon = _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName },
	          iconChildren
	        );
	      }
	      icon = _react2.default.cloneElement(icon, { disabled: disabled });
	
	      return _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, props, {
	          id: id + '-toggle',
	          role: 'listbox',
	          disabled: disabled,
	          component: _Paper2.default,
	          zDepth: below && active ? 1 : 0,
	          inkDisabled: !below,
	          className: (0, _classnames2.default)('md-select-field', (0, _themeColors2.default)({
	            disabled: disabled,
	            hint: !labelActive && placeholder,
	            text: labelActive
	          }), className)
	        }),
	        _react2.default.createElement(
	          _IconSeparator2.default,
	          {
	            label: visibleLabel,
	            labelClassName: transition,
	            className: (0, _classnames2.default)('md-text-field', {
	              'md-text-field--margin': !below && !label,
	              'md-text-field--floating-margin': label,
	              'md-text-field--toolbar': toolbar && !below,
	              'md-select-field--text-field': !below,
	              'md-select-field--btn': below
	            })
	          },
	          icon
	        ),
	        divider,
	        _react2.default.createElement('input', {
	          key: 'value',
	          type: 'hidden',
	          id: id,
	          name: name,
	          value: value,
	          required: required,
	          disabled: disabled
	        })
	      );
	    }
	  }]);
	
	  return SelectFieldInput;
	}(_react.PureComponent);
	
	SelectFieldInput.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  disabled: _propTypes2.default.bool,
	  required: _propTypes2.default.bool,
	  label: _propTypes2.default.node,
	  placeholder: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  activeLabel: _propTypes2.default.node,
	  below: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  toolbar: _propTypes2.default.bool,
	  dropdownIcon: _propTypes2.default.element,
	  iconClassName: _propTypes2.default.string,
	  iconChildren: _propTypes2.default.node,
	  transitionName: _propTypes2.default.string.isRequired,
	  transitionTime: _propTypes2.default.number.isRequired,
	  lineDirection: _TextFieldDivider2.default.propTypes.lineDirection
	};
	SelectFieldInput.defaultProps = {
	  transitionName: 'md-drop',
	  transitionTime: 300
	};
	exports.default = SelectFieldInput;
	//# sourceMappingURL=SelectFieldInput.js.map

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addSuffix = __webpack_require__(174);
	
	var _addSuffix2 = _interopRequireDefault(_addSuffix);
	
	var _isValued = __webpack_require__(76);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	var _FloatingLabel = __webpack_require__(159);
	
	var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);
	
	var _TextFieldMessage = __webpack_require__(161);
	
	var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);
	
	var _SelectFieldInput = __webpack_require__(313);
	
	var _SelectFieldInput2 = _interopRequireDefault(_SelectFieldInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectFieldToggle = function (_PureComponent) {
	  _inherits(SelectFieldToggle, _PureComponent);
	
	  function SelectFieldToggle() {
	    _classCallCheck(this, SelectFieldToggle);
	
	    return _possibleConstructorReturn(this, (SelectFieldToggle.__proto__ || Object.getPrototypeOf(SelectFieldToggle)).apply(this, arguments));
	  }
	
	  _createClass(SelectFieldToggle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          style = _props.style,
	          className = _props.className,
	          inputStyle = _props.inputStyle,
	          inputClassName = _props.inputClassName,
	          required = _props.required,
	          disabled = _props.disabled,
	          active = _props.active,
	          error = _props.error,
	          errorText = _props.errorText,
	          helpText = _props.helpText,
	          helpOnFocus = _props.helpOnFocus,
	          visible = _props.visible,
	          activeLabel = _props.activeLabel,
	          propLabel = _props.label,
	          propPlaceholder = _props.placeholder,
	          props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'inputStyle', 'inputClassName', 'required', 'disabled', 'active', 'error', 'errorText', 'helpText', 'helpOnFocus', 'visible', 'activeLabel', 'label', 'placeholder']);
	
	      var _props2 = this.props,
	          label = _props2.label,
	          placeholder = _props2.placeholder;
	
	      if (required) {
	        if (label) {
	          label = (0, _addSuffix2.default)(label, '*');
	        }
	
	        if (placeholder && !label) {
	          placeholder = (0, _addSuffix2.default)(placeholder, '*');
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: style, className: (0, _classnames2.default)('md-select-field__toggle', className) },
	        _react2.default.createElement(_FloatingLabel2.default, {
	          label: label,
	          htmlFor: id,
	          active: active || visible,
	          error: error,
	          floating: (0, _isValued2.default)(activeLabel) || active || visible,
	          disabled: disabled
	        }),
	        _react2.default.createElement(_SelectFieldInput2.default, _extends({}, props, {
	          id: id,
	          style: inputStyle,
	          className: inputClassName,
	          label: label,
	          placeholder: placeholder,
	          activeLabel: activeLabel,
	          active: active,
	          error: error,
	          disabled: disabled
	        })),
	        _react2.default.createElement(_TextFieldMessage2.default, {
	          active: active || visible,
	          error: error,
	          errorText: errorText,
	          helpText: helpText,
	          helpOnFocus: helpOnFocus,
	          leftIcon: false,
	          rightIcon: false
	        })
	      );
	    }
	  }]);
	
	  return SelectFieldToggle;
	}(_react.PureComponent);
	
	SelectFieldToggle.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  inputStyle: _propTypes2.default.object,
	  inputClassName: _propTypes2.default.string,
	  activeLabel: _propTypes2.default.node,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  required: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  errorText: _propTypes2.default.node,
	  helpText: _propTypes2.default.node,
	  helpOnFocus: _propTypes2.default.bool,
	  below: _propTypes2.default.bool,
	  visible: _propTypes2.default.bool
	};
	exports.default = SelectFieldToggle;
	//# sourceMappingURL=SelectFieldToggle.js.map

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectField = undefined;
	
	var _SelectField2 = __webpack_require__(96);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField3.default;
	exports.SelectField = _SelectField3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _SelectionControl = __webpack_require__(47);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Checkbox` component is used for the selection of multiple options from a set.
	 */
	var Checkbox = function (_PureComponent) {
	  _inherits(Checkbox, _PureComponent);
	
	  function Checkbox() {
	    _classCallCheck(this, Checkbox);
	
	    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	  }
	
	  _createClass(Checkbox, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          uncheckedIcon = _props.uncheckedIcon,
	          checkedIconChildren = _props.checkedIconChildren,
	          checkedIconClassName = _props.checkedIconClassName,
	          uncheckedIconChildren = _props.uncheckedIconChildren,
	          uncheckedIconClassName = _props.uncheckedIconClassName,
	          props = _objectWithoutProperties(_props, ['checkedIcon', 'uncheckedIcon', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);
	
	      var checked = (0, _getDeprecatedIcon2.default)(checkedIconClassName, checkedIconChildren, checkedIcon);
	      var unchecked = (0, _getDeprecatedIcon2.default)(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon);
	
	      return _react2.default.createElement(_SelectionControl2.default, _extends({
	        type: 'checkbox',
	        checkedCheckboxIcon: checked,
	        uncheckedCheckboxIcon: unchecked,
	        __superSecreteProp: true
	      }, props));
	    }
	  }]);
	
	  return Checkbox;
	}(_react.PureComponent);
	
	Checkbox.propTypes = {
	  /**
	   * An id to use with the checkbox. This is used for accessibility and so that the label
	   * triggers the checkbox toggle.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional style to apply to the checkbox's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the checkbox's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A label to display with the checkbox. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the label should appear before the checkbox icon.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `Checkbox`. This is required for accessibility. If the checkbox is
	   * part of a group, it is recommended to make this a string ending in `[]` so that the
	   * value can be found from `document.querySelector('input[name="someName[]"]').value`.
	   */
	  name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * Boolean if the `Checkbox` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `checked` state of the `Checkbox` changes.
	   * The callback will include the new checked state and the changeEvent.
	   *
	   * ```js
	   * onChange(changeEvent.target.checked, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional value for the `Checkbox`. It is recommended to use a value though.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the `Checkbox` is checked by default.
	   */
	  defaultChecked: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the `Checkbox` is currently checked. This will required the `onChange` prop
	   * to be defined.
	   */
	  checked: (0, _controlled2.default)(_propTypes2.default.bool, 'onChange', 'defaultChecked'),
	
	  /**
	   * Boolean if the `Checkbox` should be displayed inline.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The icon to display when the checkbox is checked.
	   */
	  checkedIcon: _propTypes2.default.node,
	
	  /**
	   * The icon to display when the checkbox is unchecked.
	   */
	  uncheckedIcon: _propTypes2.default.node,
	
	  checkedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `checkedIcon` instead'),
	  checkedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `checkedIcon` instead'),
	  uncheckedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `uncheckedIcon` instead'),
	  uncheckedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `uncheckedIcon` instead')
	};
	Checkbox.defaultProps = {
	  checkedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box'
	  ),
	  uncheckedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box_outline_blank'
	  )
	};
	exports.default = Checkbox;
	//# sourceMappingURL=Checkbox.js.map

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _SelectionControl = __webpack_require__(47);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Radio` component is used for the selection of a single option from a set. Unfortunately
	 * the `Radio` component must always be controlled because of the `FontIcon` toggles and how
	 * the `radio` input type works. It is recommended to use the `SelectionControlGroup` component
	 * to manage the `radio`.
	 */
	var Radio = function (_PureComponent) {
	  _inherits(Radio, _PureComponent);
	
	  function Radio() {
	    _classCallCheck(this, Radio);
	
	    return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
	  }
	
	  _createClass(Radio, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          uncheckedIcon = _props.uncheckedIcon,
	          checkedIconChildren = _props.checkedIconChildren,
	          checkedIconClassName = _props.checkedIconClassName,
	          uncheckedIconChildren = _props.uncheckedIconChildren,
	          uncheckedIconClassName = _props.uncheckedIconClassName,
	          props = _objectWithoutProperties(_props, ['checkedIcon', 'uncheckedIcon', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);
	
	      var checked = (0, _getDeprecatedIcon2.default)(checkedIconClassName, checkedIconChildren, checkedIcon);
	      var unchecked = (0, _getDeprecatedIcon2.default)(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon);
	
	      return _react2.default.createElement(_SelectionControl2.default, _extends({
	        type: 'radio',
	        checkedCheckboxIcon: checked,
	        uncheckedCheckboxIcon: unchecked,
	        __superSecreteProp: true
	      }, props));
	    }
	  }]);
	
	  return Radio;
	}(_react.PureComponent);
	
	Radio.propTypes = {
	  /**
	   * An id to use with the radio. This is used for accessibility and so that the label
	   * triggers the radio toggle.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional style to apply to the radio's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the radio's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A label to display with the radio. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the label should appear before the radio icon.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `Radio`. This is required for accessibility.
	   */
	  name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * Boolean if the `Radio` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * A function to call when the `Radio` triggers the `change` event. The `onChange` callback
	   * will include the current value of the checked `radio` and the change event.
	   *
	   * ```js
	   * onChange(changeEvent.target.value, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * The value for the `Radio` component.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * A boolean if the `Radio` is currently checked.
	   */
	  checked: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Boolean if the `Radio` should be displayed inline.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The icon to display when the radio is checked/selected.
	   */
	  checkedIcon: _propTypes2.default.node.isRequired,
	
	  /**
	   * The icon to display when the radio is not checked/selected.
	   */
	  uncheckedIcon: _propTypes2.default.node.isRequired,
	  checkedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `checkedIcon` instead'),
	  checkedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `checkedIcon` instead'),
	  uncheckedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `uncheckedIcon` instead'),
	  uncheckedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `uncheckedIcon` instead')
	};
	Radio.defaultProps = {
	  checkedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_checked'
	  ),
	  uncheckedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_unchecked'
	  )
	};
	exports.default = Radio;
	//# sourceMappingURL=Radio.js.map

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _SelectionControlGroup = __webpack_require__(152);
	
	var _SelectionControlGroup2 = _interopRequireDefault(_SelectionControlGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars, no-shadow */
	
	
	// This will still work, but generate a lot of warnings
	
	/**
	 * The `RadioGroup` component is a state manager for the `Radio` component.
	 * It will automatically inject the name, an onChange function, and
	 * determine whether a radio is checked.
	 *
	 * This is just a simple wrapper to reduce some prop redundancy.
	 */
	var RadioGroup = function (_PureComponent) {
	  _inherits(RadioGroup, _PureComponent);
	
	  function RadioGroup() {
	    _classCallCheck(this, RadioGroup);
	
	    return _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).apply(this, arguments));
	  }
	
	  _createClass(RadioGroup, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['children']);
	
	      delete props.id;
	      delete props.defaultValue;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          defaultValue = _props2.defaultValue;
	
	      if (!id) {
	        id = props.name + '-radios-unique-please';
	      }
	
	      if (typeof props.value === 'undefined') {
	        if (typeof defaultValue === 'undefined') {
	          defaultValue = _react.Children.map(children, function (_ref) {
	            var value = _ref.props.value;
	            return value;
	          })[0];
	        }
	      }
	
	      var controls = _react.Children.map(children, function (radio) {
	        var props = Object.assign({}, radio.props);
	        delete props.checkedIcon;
	        delete props.uncheckedIcon;
	        delete props.checkedIconChildren;
	        delete props.checkedIconClassName;
	        delete props.uncheckedIconChildren;
	        delete props.uncheckedIconClassName;
	        return _extends({}, props);
	      });
	      return _react2.default.createElement(_SelectionControlGroup2.default, _extends({}, props, { id: id, defaultValue: defaultValue, type: 'radio', controls: controls }));
	    }
	  }]);
	
	  return RadioGroup;
	}(_react.PureComponent);
	
	RadioGroup.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  defaultValue: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.arrayOf(_propTypes2.default.node).isRequired,
	  inline: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  name: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	
	  _deprecated: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `SelectionControlGroup` component instead')
	};
	exports.default = RadioGroup;
	//# sourceMappingURL=RadioGroup.js.map

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _SelectionControl = __webpack_require__(47);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Switch = function (_PureComponent) {
	  _inherits(Switch, _PureComponent);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
	  }
	
	  _createClass(Switch, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          toggled = _props.toggled,
	          defaultToggled = _props.defaultToggled,
	          props = _objectWithoutProperties(_props, ['toggled', 'defaultToggled']);
	
	      if (typeof toggled !== 'undefined' && typeof props.checked === 'undefined') {
	        props.checked = toggled;
	      }
	
	      if (typeof defaultToggled !== 'undefined' && typeof props.defaultChecked === 'undefined') {
	        props.defaultChecked = defaultToggled;
	      }
	
	      return _react2.default.createElement(_SelectionControl2.default, _extends({ type: 'switch' }, props, { __superSecreteProp: true }));
	    }
	  }]);
	
	  return Switch;
	}(_react.PureComponent);
	
	Switch.propTypes = {
	  /**
	   * An id to use with the switch. This is used for accessibility and so that the label
	   * triggers the switch toggle.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional style to apply to the switch's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the switch's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A label to display with the switch. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the label should appear before the switch.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `Switch`. This is required for accessibility since behind the scenes
	   * the `Switch` is renders as an `<input type="checkbox" />`.
	   */
	  name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * Boolean if the `Switch` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `checked` state of the `Switch` changes.
	   * The callback will include the new checked state and the changeEvent.
	   *
	   * ```js
	   * onChange(changeEvent.target.checked, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional value for the `Switch`. It is recommended to use a value though.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the `Switch` is checked by default.
	   */
	  defaultChecked: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the `Switch` is currently checked. This will required the `onChange` prop
	   * to be defined.
	   */
	  checked: (0, _controlled2.default)(_propTypes2.default.bool, 'onChange', 'defaultChecked'),
	
	  defaultToggled: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `defaultChecked` prop instead'),
	  toggled: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `checked` prop instead')
	};
	exports.default = Switch;
	//# sourceMappingURL=Switch.js.map

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleFakeInkedButton = __webpack_require__(25);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DISABLED_INTERACTIONS = ['mouse'];
	
	/**
	 * This is the `Thumb` for the switch. The `ink` in the Thumb is only active on touch and keyboard
	 * interactions, so the `AccessibleFakeInkButton` does not work for this case.
	 *
	 * This component really just is used for custom inkage.
	 */
	
	var SwitchThumb = function (_PureComponent) {
	  _inherits(SwitchThumb, _PureComponent);
	
	  function SwitchThumb() {
	    _classCallCheck(this, SwitchThumb);
	
	    return _possibleConstructorReturn(this, (SwitchThumb.__proto__ || Object.getPrototypeOf(SwitchThumb)).apply(this, arguments));
	  }
	
	  _createClass(SwitchThumb, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          checked = _props.checked,
	          className = _props.className,
	          disabledInteractions = _props.disabledInteractions,
	          props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className', 'disabledInteractions']);
	
	      return _react2.default.createElement(_AccessibleFakeInkedButton2.default, _extends({}, props, {
	        disabled: disabled,
	        disabledInteractions: disabledInteractions || DISABLED_INTERACTIONS,
	        inkContainerClassName: 'md-ink-container--2x',
	        className: (0, _classnames2.default)('md-switch-thumb', {
	          'md-switch-thumb--disabled': disabled,
	          'md-switch-thumb--on': checked,
	          'md-switch-thumb--off': !checked
	        }, className)
	      }));
	    }
	  }]);
	
	  return SwitchThumb;
	}(_react.PureComponent);
	
	SwitchThumb.propTypes = {
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  checked: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'touch', 'mouse']))
	};
	exports.default = SwitchThumb;
	//# sourceMappingURL=SwitchThumb.js.map

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SwitchThumb = __webpack_require__(320);
	
	var _SwitchThumb2 = _interopRequireDefault(_SwitchThumb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwitchTrack = function (_PureComponent) {
	  _inherits(SwitchTrack, _PureComponent);
	
	  function SwitchTrack() {
	    _classCallCheck(this, SwitchTrack);
	
	    return _possibleConstructorReturn(this, (SwitchTrack.__proto__ || Object.getPrototypeOf(SwitchTrack)).apply(this, arguments));
	  }
	
	  _createClass(SwitchTrack, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          checked = _props.checked,
	          className = _props.className,
	          inkDisabled = _props.inkDisabled,
	          disabledInteractions = _props.disabledInteractions,
	          props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className', 'inkDisabled', 'disabledInteractions']);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-switch-track', {
	            'md-pointer--hover': !disabled,
	            'md-switch-track--disabled': disabled,
	            'md-switch-track--on': checked,
	            'md-switch-track--off': !checked
	          }, className)
	        }),
	        _react2.default.createElement(_SwitchThumb2.default, {
	          disabled: disabled,
	          checked: checked,
	          onClick: props.onClick,
	          inkDisabled: inkDisabled,
	          disabledInteractions: disabledInteractions
	        })
	      );
	    }
	  }]);
	
	  return SwitchTrack;
	}(_react.PureComponent);
	
	SwitchTrack.propTypes = {
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  checked: _propTypes2.default.bool,
	  inkDisabled: _propTypes2.default.bool,
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'touch', 'mouse']))
	};
	exports.default = SwitchTrack;
	//# sourceMappingURL=SwitchTrack.js.map

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Switch = exports.RadioGroup = exports.Radio = exports.Checkbox = exports.SelectionControlGroup = exports.SelectionControl = undefined;
	
	var _SelectionControl2 = __webpack_require__(47);
	
	var _SelectionControl3 = _interopRequireDefault(_SelectionControl2);
	
	var _SelectionControlGroup2 = __webpack_require__(152);
	
	var _SelectionControlGroup3 = _interopRequireDefault(_SelectionControlGroup2);
	
	var _Checkbox2 = __webpack_require__(316);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Radio2 = __webpack_require__(317);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _RadioGroup2 = __webpack_require__(318);
	
	var _RadioGroup3 = _interopRequireDefault(_RadioGroup2);
	
	var _Switch2 = __webpack_require__(319);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectionControl3.default;
	exports.SelectionControl = _SelectionControl3.default;
	exports.SelectionControlGroup = _SelectionControlGroup3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Radio = _Radio3.default;
	exports.RadioGroup = _RadioGroup3.default;
	exports.Switch = _Switch3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Drawer = __webpack_require__(91);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _componentDeprecated = __webpack_require__(36);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sidebar = function (_PureComponent) {
	  _inherits(Sidebar, _PureComponent);
	
	  function Sidebar() {
	    _classCallCheck(this, Sidebar);
	
	    return _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
	  }
	
	  _createClass(Sidebar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          header = _props.header,
	          overlay = _props.overlay,
	          children = _props.children,
	          onOverlayClick = _props.onOverlayClick,
	          align = _props.align,
	          items = _props.items,
	          fixed = _props.fixed,
	          props = _objectWithoutProperties(_props, ['isOpen', 'header', 'overlay', 'children', 'onOverlayClick', 'align', 'items', 'fixed']);
	
	      delete props.responsive;
	
	      return _react2.default.createElement(
	        _Drawer2.default,
	        _extends({}, props, {
	          visible: isOpen,
	          onVisibilityChange: onOverlayClick,
	          navItems: items,
	          position: align,
	          overflay: overlay,
	          header: header,
	          inline: !fixed
	        }),
	        children
	      );
	    }
	  }]);
	
	  return Sidebar;
	}(_react.PureComponent);
	
	Sidebar.propTypes = {
	  deprecated: (0, _componentDeprecated2.default)('All the functionality and responsiveness of a `Sidebar` can be handled by the `Drawer` instead.' + ' Switch to the `Drawer` component instead.'),
	
	  /**
	   * Boolean if the overlay should appear when opened.
	   */
	  overlay: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the sidebar is visible and open.
	   */
	  isOpen: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the sidebar is fixed to the side of the page.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if sidebar should be responsive.
	   */
	  responsive: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display above the children or list items.
	   */
	  header: _propTypes2.default.node,
	
	  /**
	   * Any children to display after the generated list of items.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The transition name to use for the overlay.
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * The enter timeout for the overlay transition.
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The leave timeout for the overlay transition.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * An optional function to call when the overlay is clicked.
	   * This should normally close the sidebar.
	   */
	  onOverlayClick: _propTypes2.default.func,
	
	  /**
	   * The position to align the sidebar of the screen to.
	   */
	  align: _propTypes2.default.oneOf(['left', 'right']),
	
	  /**
	   * A list of item props to convert into `ListItem`, `Divider`, or
	   * `Subheader` components.
	   *
	   * ##### Item Descriptions
	   */
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    /**
	     * Boolean if this item is a divider.
	     */
	    divider: _propTypes2.default.bool,
	
	    /**
	     * Boolean if this item is a subheader.
	     */
	    subheader: _propTypes2.default.bool,
	
	    /**
	     * The primary text to display in a `ListItem` or a `Subheader`.
	     */
	    primaryText: _propTypes2.default.node
	  }))
	};
	Sidebar.defaultProps = {
	  align: 'left'
	};
	exports.default = Sidebar;
	//# sourceMappingURL=Sidebar.js.map

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Sidebar = __webpack_require__(323);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sidebar2.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscreteValue = function (_PureComponent) {
	  _inherits(DiscreteValue, _PureComponent);
	
	  function DiscreteValue() {
	    _classCallCheck(this, DiscreteValue);
	
	    return _possibleConstructorReturn(this, (DiscreteValue.__proto__ || Object.getPrototypeOf(DiscreteValue)).apply(this, arguments));
	  }
	
	  _createClass(DiscreteValue, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          discrete = _props.discrete,
	          dragging = _props.dragging,
	          thumbLeft = _props.thumbLeft,
	          active = _props.active,
	          value = _props.value,
	          valuePrecision = _props.valuePrecision,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'discrete', 'dragging', 'thumbLeft', 'active', 'value', 'valuePrecision']);
	
	      if (!discrete || !active) {
	        return null;
	      }
	
	      var valueStr = value.toFixed(valuePrecision);
	      if (valuePrecision > 0) {
	        var _valueStr$split = valueStr.split('.'),
	            _valueStr$split2 = _slicedToArray(_valueStr$split, 2),
	            w = _valueStr$split2[0],
	            d = _valueStr$split2[1];
	
	        if (parseInt(d, 10) === 0) {
	          valueStr = w;
	        }
	      }
	      return _react2.default.createElement(
	        'span',
	        _extends({}, props, {
	          style: Object.assign({}, style, { left: thumbLeft }),
	          className: (0, _classnames2.default)('md-slider-discrete-value', className, {
	            'md-slider-discrete-value--dragging': dragging
	          })
	        }),
	        valueStr
	      );
	    }
	  }]);
	
	  return DiscreteValue;
	}(_react.PureComponent);
	
	DiscreteValue.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  discrete: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  value: _propTypes2.default.number.isRequired,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  valuePrecision: _propTypes2.default.number.isRequired
	};
	exports.default = DiscreteValue;
	//# sourceMappingURL=DiscreteValue.js.map

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(9);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _isValidClick = __webpack_require__(98);
	
	var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	var _touches = __webpack_require__(54);
	
	var _calculateValueDistance = __webpack_require__(361);
	
	var _calculateValueDistance2 = _interopRequireDefault(_calculateValueDistance);
	
	var _isWithinStep = __webpack_require__(362);
	
	var _isWithinStep2 = _interopRequireDefault(_isWithinStep);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _SliderLabel = __webpack_require__(327);
	
	var _SliderLabel2 = _interopRequireDefault(_SliderLabel);
	
	var _Track = __webpack_require__(330);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _TextField = __webpack_require__(48);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Slider` component is used to let users select a value from a continuous
	 * or discrete range of values by moving the slider thumb.
	 *
	 * When the user has finished dragging the Slider or increments the value by using
	 * the edit field/keyboard arrows, the value will be rounded to the nearest `step`.
	 */
	var Slider = function (_PureComponent) {
	  _inherits(Slider, _PureComponent);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var min = props.min,
	        max = props.max,
	        step = props.step;
	
	    var scale = Math.abs(max - min) / step;
	
	    var value = typeof props.value !== 'undefined' ? props.value : props.defaultValue;
	
	    if (typeof value === 'undefined') {
	      value = min;
	    }
	
	    var distance = _this._calcDistance(value, min, max);
	    var thumbLeft = _this._calcLeft(distance);
	    var trackFillWidth = distance + '%';
	
	    if (typeof props.value !== 'undefined') {
	      value = undefined;
	    }
	
	    var trackWidth = void 0;
	    if (props.label && !props.editable && !props.leftIcon && !props.rightIcon) {
	      trackWidth = '100%';
	    }
	
	    _this.state = {
	      value: value,
	      scale: scale,
	      distance: distance,
	      thumbLeft: thumbLeft,
	      trackWidth: trackWidth,
	      trackFillWidth: trackFillWidth,
	      active: false,
	      dragging: false,
	      maskInked: false
	    };
	    _this._dragAdded = false;
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          leftIcon = _props.leftIcon,
	          rightIcon = _props.rightIcon,
	          label = _props.label,
	          min = _props.min,
	          max = _props.max,
	          step = _props.step,
	          value = _props.value;
	
	      if (value !== nextProps.value) {
	        var distance = this._calcDistance(nextProps.value, nextProps.min, nextProps.max);
	        this.setState({ distance: distance, trackFillWidth: distance + '%', thumbLeft: this._calcLeft(distance) });
	      }
	
	      if (leftIcon !== nextProps.leftIcon || rightIcon !== nextProps.rightIcon || label !== nextProps.label) {
	        this._calcTrackWidth(nextProps);
	      }
	
	      if (min !== nextProps.min || max !== nextProps.max || step !== nextProps.step) {
	        this.setState({ scale: Math.abs(nextProps.max - nextProps.min) / nextProps.step });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _state = this.state,
	          active = _state.active,
	          manualIncrement = _state.manualIncrement;
	
	      var fn = window[(active ? 'add' : 'remove') + 'EventListener'];
	      if (active !== prevState.active) {
	        fn('click', this._blurOnOutsideClick);
	
	        if (active) {
	          this._focusThumb();
	        }
	      }
	
	      var addDrag = active && !manualIncrement;
	      fn = window[(addDrag ? 'add' : 'remove') + 'EventListener'];
	      if (this._dragAdded !== addDrag) {
	        fn('mousemove', this._handleDragMove);
	        fn('mouseup', this._handleDragEnd);
	        (0, _touches.setTouchEvent)(addDrag, window, 'move', this._handleDragMove);
	        (0, _touches.setTouchEvent)(addDrag, window, 'end', this._handleDragEnd);
	
	        this._dragAdded = addDrag;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var rm = window.removeEventListener;
	      rm('click', this._blurOnOutsideClick);
	      rm('mousemove', this._handleMouseMove);
	      rm('mouseup', this._handleMouseUp);
	      (0, _touches.removeTouchEvent)(window, 'move', this._handleDragMove);
	      (0, _touches.removeTouchEvent)(window, 'end', this._handleDragEnd);
	
	      if (this._inkTimeout) {
	        clearTimeout(this._inkTimeout);
	      }
	
	      if (this._focusTimeout) {
	        clearTimeout(this._focusTimeout);
	      }
	    }
	
	    /**
	     * Gets the `left` position for the thumb based on the value given.
	     *
	     * @param {number} value - The current value.
	     * @return {string} the `calc` string.
	     */
	
	  }, {
	    key: '_calcLeft',
	    value: function _calcLeft(value) {
	      return 'calc(' + value + '% - 6px)';
	    }
	  }, {
	    key: '_calcDistance',
	    value: function _calcDistance(value, min, max) {
	      return Math.max(0, Math.min(100, (value - min) / (max - min) * 100));
	    }
	
	    /**
	     * Checks if a classList does not contain all the *bad* class names.
	     *
	     * @param {function} classList - The classList to check.
	     * @return {Boolean} true if the classList does not contain any of the *bad* class names.
	     */
	
	  }, {
	    key: '_isValidClassList',
	    value: function _isValidClassList(classList) {
	      var invalid = false;
	      ['md-slider-label', 'md-slider-ind', 'md-icon'].some(function (cl) {
	        invalid = classList.contains(cl);
	        return invalid;
	      });
	
	      return !invalid;
	    }
	  }, {
	    key: '_isInTextField',
	    value: function _isInTextField(e) {
	      var className = e.target.className;
	
	      // SVG's className is an object instead of a string
	
	      return typeof className.match === 'function' && className.match(/text-field/);
	    }
	
	    /**
	     * Checks if the target is within the text field container.
	     *
	     * @param {Object} target - The event target.
	     * @return {Boolean} true if the target is in the text field.
	     */
	
	
	    /**
	     * Updates the slider's thumb position and the slider's track fill width based
	     * on the thumb's current x position on the screen.
	     *
	     * The slider distance will be *normalized* when:
	     *  - The user does a quick jump
	     *  - The user stops dragging with the mouse
	     *  - The user drops dragging with touch
	     *
	     * If the position is not *normalized*, the `onDragChange` prop will be called
	     * with the new distance percentage, the value, and the move event.
	     *
	     * The `onChange` function will always be called.
	     *
	     * @param {Object} e - The current event to extract an x location from
	     * @param {bool} normalize - Boolean if the distance should be normalized
	     *    to the current scale of the slider.
	     */
	
	
	    /**
	     * This will either allow a user to start dragging the slider or quickly
	     * jump to a new value on the slider if the slider is not disabled.
	     *
	     * This will handle the `touchstart` and `mousedown` events.
	     *
	     * @param {Object} e - The touchstart or mousedown event.
	     */
	
	
	    /**
	     * This will set the active state of the slider to false if the user
	     * clicks outside of the slider's container.
	     *
	     * @param {Object} e - The window's click event.
	     */
	
	
	    /**
	     * Updates the slider with the `step` prop and calls the `onChange`
	     * function with the new value.
	     *
	     * @param {number} incrementedValue - The newly incremented value of the slider.
	     * @param {Object} e - Either the text field's change event, mouse down event, or
	     *    touch start event.
	     * @param {bool} disableTransition - Boolean if the jump's transition should be disabled.
	     */
	
	
	    /**
	     * This will increment the Slider's value by the `step` prop. If the left or
	     * right key arrow is pressed.
	     *
	     * @param {Object} e - the keydown event.
	     */
	
	
	    /**
	     * This function will animate the discrete Slider's ink if it gains focus
	     * by a tab event.
	     *
	     * @param {Object} e - the key up event.
	     */
	
	
	    /**
	     * For some reason the width of the track gets set to 0 if the `Slider` has a label and
	     * does not include the `leftIcon`, `rightIcon`, and is not `editable` OR it is
	     * `editable` and does not include the `leftIcon`. All other cases the width works
	     * correctly.
	     *
	     * This function just checks these things, and sets the width accordingly.
	     */
	
	
	    /**
	     * The ink for a Discrete slider is only visible for a short time on initial
	     * focus. This function will handle the in/out transitions.
	     */
	
	
	    /**
	     * This is a helper function for focusing the Slider's thumb component. There
	     * is a short delay because the body sometimes gets focused immediately after
	     * if there is no timeout..
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          dragging = _state2.dragging,
	          active = _state2.active,
	          thumbLeft = _state2.thumbLeft,
	          trackFillWidth = _state2.trackFillWidth,
	          maskInked = _state2.maskInked,
	          trackWidth = _state2.trackWidth,
	          scale = _state2.scale,
	          distance = _state2.distance;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          min = _props2.min,
	          max = _props2.max,
	          disabled = _props2.disabled,
	          className = _props2.className,
	          trackStyle = _props2.trackStyle,
	          trackClassName = _props2.trackClassName,
	          thumbStyle = _props2.thumbStyle,
	          thumbClassName = _props2.thumbClassName,
	          discreteValueStyle = _props2.discreteValueStyle,
	          discreteValueClassName = _props2.discreteValueClassName,
	          label = _props2.label,
	          editable = _props2.editable,
	          step = _props2.step,
	          inputWidth = _props2.inputWidth,
	          leftIcon = _props2.leftIcon,
	          rightIcon = _props2.rightIcon,
	          discrete = _props2.discrete,
	          discreteTicks = _props2.discreteTicks,
	          tickWidth = _props2.tickWidth,
	          valuePrecision = _props2.valuePrecision,
	          propValue = _props2.value,
	          onChange = _props2.onChange,
	          onDragChange = _props2.onDragChange,
	          discreteInkTransitionTime = _props2.discreteInkTransitionTime,
	          stepPrecision = _props2.stepPrecision,
	          props = _objectWithoutProperties(_props2, ['id', 'min', 'max', 'disabled', 'className', 'trackStyle', 'trackClassName', 'thumbStyle', 'thumbClassName', 'discreteValueStyle', 'discreteValueClassName', 'label', 'editable', 'step', 'inputWidth', 'leftIcon', 'rightIcon', 'discrete', 'discreteTicks', 'tickWidth', 'valuePrecision', 'value', 'onChange', 'onDragChange', 'discreteInkTransitionTime', 'stepPrecision']);
	
	      var value = (0, _getField2.default)(this.props, this.state);
	      var rightChildren = rightIcon;
	      if (editable) {
	        rightChildren = _react2.default.createElement(_TextField2.default, {
	          id: id + '-editor',
	          ref: this._setField,
	          type: 'number',
	          value: value,
	          inputClassName: 'md-slider-editor',
	          style: { width: inputWidth },
	          onChange: this._handleTextFieldChange,
	          step: step
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          ref: this._setNode,
	          className: (0, _classnames2.default)('md-slider-container', className, {
	            'md-pointer--hover': !disabled
	          }),
	          onMouseDown: this._handleDragStart,
	          onTouchStart: this._handleDragStart
	        }),
	        _react2.default.createElement(
	          _SliderLabel2.default,
	          { htmlFor: id },
	          label
	        ),
	        _react2.default.createElement('input', {
	          id: id,
	          type: 'range',
	          className: 'md-slider-input',
	          readOnly: true,
	          min: min,
	          max: max,
	          value: value,
	          disabled: disabled
	        }),
	        leftIcon,
	        _react2.default.createElement(_Track2.default, {
	          ref: this._setTrack,
	          style: Object.assign({}, trackStyle, { width: trackWidth }),
	          className: (0, _classnames2.default)(trackClassName, {
	            'md-slider-track--ind-left': leftIcon,
	            'md-slider-track--ind-right': rightIcon
	          }),
	          thumbStyle: thumbStyle,
	          thumbClassName: thumbClassName,
	          discreteValueStyle: discreteValueStyle,
	          discreteValueClassName: discreteValueClassName,
	          active: active,
	          dragging: dragging,
	          disabled: disabled,
	          thumbLeft: thumbLeft,
	          trackFillWidth: trackFillWidth,
	          on: !disabled && distance > 0,
	          off: distance === 0,
	          maskInked: maskInked,
	          onThumbKeyUp: this._handleKeyUp,
	          onThumbKeyDown: this._handleKeyDown,
	          onThumbFocus: this._handleFocus,
	          discrete: discrete,
	          tickWidth: tickWidth,
	          discreteTicks: discreteTicks,
	          valuePrecision: valuePrecision,
	          step: step,
	          scale: scale,
	          value: value
	        }),
	        rightChildren
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react.PureComponent);
	
	Slider.propTypes = {
	  /**
	   * An id to use for the `Slider`. This is required if the `label` prop
	   * is defined.
	   */
	  id: function id(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    if (typeof props.label === 'undefined') {
	      return _propTypes2.default.string.apply(_propTypes2.default, [props, propName, component].concat(others));
	    }
	
	    return (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])).apply(undefined, [props, propName, component].concat(others));
	  },
	
	  /**
	   * An optional style to apply to the slider's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the slider's thumb.
	   */
	  thumbStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's thumb.
	   */
	  thumbClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the slider's track.
	   */
	  trackStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's track.
	   */
	  trackClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the slider's track fill.
	   */
	  trackFillStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's track fill.
	   */
	  trackFillClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to a discrete slider's value.
	   */
	  discreteValueStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to a discrete slider's value.
	   */
	  discreteValueClassName: _propTypes2.default.string,
	
	  /**
	   * The default value for the slider. This number must be between the min and max values if
	   * defined. If this is undefined, it's value will be set to the min value.
	   */
	  defaultValue: _propTypes2.default.number,
	
	  /**
	   * The min value for the slider. This value **must** be less than the `max` value.
	   */
	  min: function min(props, propName, component) {
	    for (var _len2 = arguments.length, others = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      others[_key2 - 3] = arguments[_key2];
	    }
	
	    var _PropTypes$number;
	
	    var err = (_PropTypes$number = _propTypes2.default.number).isRequired.apply(_PropTypes$number, [props, propName, component].concat(others));
	    if (!err) {
	      var min = props[propName];
	      var name = void 0;
	      if (min > props.value) {
	        name = 'value';
	      } else if (typeof props.defaultValue !== 'undefined' && min > props.defaultValue) {
	        name = 'defaultValue';
	      }
	
	      if (name) {
	        err = new Error('The \'' + propName + '\' prop must be less than or equal to the \'' + name + '\' prop for the \'' + component + '\' but ' + ('received: \'min: ' + min + '\' and \'' + name + ': ' + props[name] + '\''));
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * The max value for the slider. This value **must** be greater than the `min` value.
	   */
	  max: function max(props, propName, component) {
	    for (var _len3 = arguments.length, others = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	      others[_key3 - 3] = arguments[_key3];
	    }
	
	    var _PropTypes$number2;
	
	    var err = (_PropTypes$number2 = _propTypes2.default.number).isRequired.apply(_PropTypes$number2, [props, propName, component].concat(others));
	    if (!err) {
	      var max = props[propName];
	      var name = void 0;
	      if (max < props.value) {
	        name = 'value';
	      } else if (max < props.defaultValue) {
	        name = 'defaultValue';
	      }
	
	      if (name) {
	        err = new Error('The \'' + propName + '\' prop must be greater than or equal to the \'' + name + '\' prop for the \'' + component + '\' but ' + ('received: \'' + propName + ': ' + max + '\' and \'' + name + ': ' + props[name] + '\''));
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * Boolean if the slider is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional value for the slider. This will make the component controlled
	   * and require the `onChange` function.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.number, 'onChange'),
	
	  /**
	   * This is called when the slider's value gets updated. The value can be updated
	   * by one of the following:
	   *
	   * - Clicking a section of the slider
	   * - Dragging the slider with the mouse
	   * - Touching a section of the slider.
	   * - Dragging the slider with touch
	   * - Using the text field to update the value either by typing or incrementing
	   * - Using the left or right arrow keys to increment/decrement the value.
	   *
	   * The callback for this function is as follows:
	   *
	   * ```js
	   * onChange(value, event);
	   * ```
	   *
	   * where the event can either be:
	   * - a touch start event
	   * - a touch move event
	   * - a touch end event
	   * - a mouse down event
	   * - a mouse move event
	   * - a mouse up event
	   * - a key up event
	   * - a key down event
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * This is only called when the user is dragging the slider with either
	   * the mouse or touch. Probably not really useful. It just includes the
	   * new drag percentage while the `onChange` does not.
	   *
	   * The callback for this function is defined as:
	   *
	   * ```js
	   * onDragChange(dragPercentage, value, (touchMove || mouseMove) event);
	   * ```
	   */
	  onDragChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the slider's container has
	   * the mousedown event.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the slider's container has
	   * the touchstart event.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional icon or letter to place to the left of the slider.
	   * if you want to use a non-font icon or a letter, use the `md-slider-ind`
	   * className on your element.
	   */
	  leftIcon: _propTypes2.default.element,
	
	  /**
	   * An optional icon or letter to place to the right of the slider.
	   * if you want to use a non-font icon or a letter, use the `md-slider-ind`
	   * className on your element.
	   *
	   * > NOTE: This can not be used if the `editable` prop is true.
	   */
	  rightIcon: _propTypes2.default.element,
	
	  /**
	   * An optional label to display above the slider. If this prop
	   * is set, then an `id` must also be given.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * The incremental amount when the user hits left or right with the
	   * keyboard arrows, or the user hits the up or down buttons in the
	   * editable number text field. This number must be a number between
	   * 0 and 1 or a whole number above 1.
	   */
	  step: function step(props, propName, component) {
	    for (var _len4 = arguments.length, others = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
	      others[_key4 - 3] = arguments[_key4];
	    }
	
	    var _PropTypes$number3;
	
	    var err = (_PropTypes$number3 = _propTypes2.default.number).isRequired.apply(_PropTypes$number3, [props, propName, component].concat(others));
	    if (!err) {
	      var step = props[propName];
	      if (step <= 0) {
	        err = new Error('The \'' + propName + '\' for the \'' + component + '\' must be a number greater than 0. The ' + ('current value is \'' + step + '\'.'));
	      } else {
	        var valueDefined = typeof props.value !== 'undefined';
	        var defaultDefined = typeof props.defaultValue !== 'undefined';
	        var value = props.value;
	        if (!valueDefined) {
	          value = defaultDefined ? props.defaultValue : props.min;
	        }
	
	        var name = void 0;
	        if (!(0, _isWithinStep2.default)(value, step)) {
	          if (valueDefined) {
	            name = 'value';
	          } else if (defaultDefined) {
	            name = 'defaultValue';
	          } else {
	            name = 'min';
	          }
	        }
	
	        if (name) {
	          err = new Error('The \'' + name + '\' prop on \'' + component + '\' should be a number divisible by the ' + ('\'' + propName + '\' prop. The current value is \'' + props[name] + '\' and the \'' + propName + '\' ') + ('is \'' + step + '\'.'));
	        }
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * Boolean if the Slider should be editable. This will place a number text field
	   * to the right of the slider. If this prop is set to `true`, the `rightIcon`
	   * prop can not be set.
	   */
	  editable: function editable(props, propName, component) {
	    for (var _len5 = arguments.length, others = Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
	      others[_key5 - 3] = arguments[_key5];
	    }
	
	    var _PropTypes$bool;
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	
	    var err = (_PropTypes$bool = _propTypes2.default.bool).isRequired.apply(_PropTypes$bool, [props, propName, component].concat(others));
	    if (!err && typeof props.rightIcon !== 'undefined') {
	      err = new Error('The \'' + component + '\' is unable to be \'editable\' and include a \'rightIcon\'.');
	    }
	
	    return err;
	  },
	
	  /**
	   * The width for the number text field when the Slider is editable.
	   */
	  inputWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the slider should be discrete. This will update the slider to include a
	   * _balloon_ with the current value inside. It will also not allow the `Slider` to be
	   * editable.
	   */
	  discrete: function discrete(props, propName, component) {
	    for (var _len6 = arguments.length, others = Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
	      others[_key6 - 3] = arguments[_key6];
	    }
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	
	    var err = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, component].concat(others));
	    if (!err && typeof props.editable !== 'undefined') {
	      err = new Error('The \'' + component + '\' cannot be \'discrete\' and \'editable\'. Please choose one.');
	    }
	
	    return err;
	  },
	
	  /**
	   * The width of each tick for a discrete slider with ticks. This can either be a number
	   * which gets converted to `px`, or a valid CSS unit.
	   */
	  tickWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * This is number divisible by the total number of values included in the Slider. Every
	   * value that is divisible by this number will include a tick mark. It is common recommended
	   * to have this equal to the `step` prop.
	   *
	   * This prop is completely optional.
	   */
	  discreteTicks: function discreteTicks(props, propName, component) {
	    for (var _len7 = arguments.length, others = Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
	      others[_key7 - 3] = arguments[_key7];
	    }
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	
	    var err = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, component].concat(others));
	    if (!err) {
	      var min = props.min,
	          max = props.max,
	          step = props.step;
	
	      var range = Math.abs(max - min);
	
	      if (range / props[propName] % 1 !== 0) {
	        err = new Error('The \'' + propName + '\' must be a number divisible by the range set by the \'min\' and ' + ('\'max\' props. The current range is \'' + range + '\' by including the min: \'' + min + '\' and ') + ('max: \'' + max + '\' values. The current value of \'' + propName + '\' is \'' + props[propName] + '\'.'));
	      } else if (props[propName] % step !== 0) {
	        err = new Error('The \'step\' prop must be a number divisible by the \'' + propName + '\'. It is common to have ' + ('them as the same value. The current \'step\' is \'' + step + '\' and the \'' + propName + '\' is \'' + props[propName] + '\'.'));
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * The transition time for a discrete Slider's keyboard focus ink. This should match the
	   * `md-slider-discrete-ink-transition-time` value in your SCSS. This is used because
	   * the ink is only visible temporarily for a discrete slider when keyboard focusing.
	   */
	  discreteInkTransitionTime: _propTypes2.default.number.isRequired,
	
	  /**
	   * The precision that the value should be rounded to when the Slider is updated. This
	   * needs to be a whole number greater than or equal to 0.
	   */
	  valuePrecision: function valuePrecision(props, propName, component) {
	    for (var _len8 = arguments.length, others = Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
	      others[_key8 - 3] = arguments[_key8];
	    }
	
	    var _PropTypes$number4;
	
	    var err = (_PropTypes$number4 = _propTypes2.default.number).isRequired.apply(_PropTypes$number4, [props, propName, component].concat(others));
	    if (!err) {
	      var precision = props[propName];
	
	      if (precision % 1 !== 0 || precision < 0) {
	        err = new Error('The \'' + propName + '\' must be a positive whole number or 0 on the \'' + component + '\'. ' + ('The current \'' + propName + '\' is \'' + precision + '\''));
	      }
	    }
	
	    return err;
	  },
	
	  stepPrecision: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `step` and `valuePrecision` instead')
	};
	Slider.defaultProps = {
	  min: 0,
	  max: 100,
	  step: 1,
	  inputWidth: 40,
	  tickWidth: 6,
	  discreteInkTransitionTime: 300,
	  valuePrecision: 0
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._isTextField = function (target) {
	    return _this2._field && _this2._field.contains(target);
	  };
	
	  this._updatePosition = function (e, normalize) {
	    var x = (e.changedTouches ? e.changedTouches[0] : e).clientX;
	    var scale = _this2.state.scale;
	    var _props3 = _this2.props,
	        onChange = _props3.onChange,
	        onDragChange = _props3.onDragChange,
	        min = _props3.min,
	        max = _props3.max,
	        step = _props3.step;
	
	    var _calculateValueDistan = (0, _calculateValueDistance2.default)(x, _this2._track.offsetWidth, _this2._track.getBoundingClientRect().left, scale, step, min, max, normalize),
	        value = _calculateValueDistan.value,
	        distance = _calculateValueDistan.distance;
	
	    var isNewValue = (0, _getField2.default)(_this2.props, _this2.state, 'value') !== value;
	    if (onChange && isNewValue) {
	      onChange(value, e);
	    }
	
	    if (!normalize && onDragChange && (isNewValue || _this2.state.distance !== distance)) {
	      onDragChange(distance, value, e);
	    }
	
	    var state = {
	      active: true,
	      distance: distance,
	      manualIncrement: false,
	      dragging: !normalize,
	      thumbLeft: _this2._calcLeft(distance),
	      trackFillWidth: distance + '%'
	    };
	
	    if (e.type === 'touchend' || e.type === 'mousedown') {
	      state.maskInked = false;
	    }
	
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleDragStart = function (e) {
	    if (e.type === 'mousedown' && _this2.props.onMouseDown) {
	      _this2.props.onMouseDown(e);
	    } else if (e.type === 'touchstart' && _this2.props.onTouchStart) {
	      _this2.props.onTouchStart(e);
	    }
	
	    if (_this2.props.disabled || e.type === 'mousedown' && !(0, _isValidClick2.default)(e, 'mousedown') || _this2._isInTextField(e)) {
	      return;
	    }
	
	    var classList = e.target.classList;
	
	    var isDiscreteValue = classList.contains('md-slider-discrete-value');
	    if (classList.contains('md-slider-thumb') || isDiscreteValue) {
	      // Prevents text highlighting while dragging.
	      if (e.type.match(/mouse/)) {
	        e.preventDefault();
	      }
	      _this2.setState({ dragging: true, active: true, manualIncrement: false, maskInked: false });
	    } else if (!_this2._isTextField(e.target) && _this2._isValidClassList(classList)) {
	      _this2._updatePosition(e, true);
	    }
	  };
	
	  this._setNode = function (node) {
	    _this2._node = (0, _reactDom.findDOMNode)(node);
	  };
	
	  this._setTrack = function (track) {
	    _this2._track = (0, _reactDom.findDOMNode)(track);
	  };
	
	  this._setField = function (field) {
	    _this2._field = (0, _reactDom.findDOMNode)(field);
	    _this2._calcTrackWidth(_this2.props);
	  };
	
	  this._handleDragMove = function (e) {
	    if (_this2.props.disabled || !_this2.state.dragging) {
	      return;
	    }
	
	    // Stops the text highlighting while dragging
	    if (e.type.match(/mouse/)) {
	      e.preventDefault();
	    }
	
	    _this2._updatePosition(e, false);
	  };
	
	  this._handleDragEnd = function (e) {
	    if (!_this2.state.dragging || _this2.props.disabled || e.type === 'mouseup' && !(0, _isValidClick2.default)(e)) {
	      return;
	    }
	
	    _this2._updatePosition(e, true);
	  };
	
	  this._blurOnOutsideClick = function (e) {
	    if (_this2.state.dragging && !_this2.state.manualIncrement || _this2.props.disabled) {
	      return;
	    }
	
	    if (!_this2._node.contains(e.target)) {
	      _this2.setState({ active: false, maskInked: false });
	    }
	  };
	
	  this._handleIncrement = function (incrementedValue, e, disableTransition) {
	    var _props4 = _this2.props,
	        onChange = _props4.onChange,
	        min = _props4.min,
	        max = _props4.max,
	        discrete = _props4.discrete;
	
	
	    var value = Math.max(min, Math.min(max, incrementedValue));
	    var distance = _this2._calcDistance(value, min, max);
	
	    if (onChange) {
	      onChange(value, e);
	    }
	
	    var state = {
	      distance: distance,
	      manualIncrement: true,
	      thumbLeft: _this2._calcLeft(distance),
	      trackFillWidth: distance + '%',
	      dragging: Math.abs(_this2.state.distance - distance) < 2 && disableTransition
	    };
	
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    if (e.type === 'keydown' && !discrete) {
	      state.maskInked = true;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleTextFieldChange = function (newValue, e) {
	    _this2._handleIncrement(newValue, e, false);
	  };
	
	  this._handleKeyDown = function (e) {
	    var key = e.which || e.keyCode;
	    var _props5 = _this2.props,
	        min = _props5.min,
	        max = _props5.max,
	        step = _props5.step,
	        disabled = _props5.disabled;
	
	    if (disabled) {
	      return;
	    }
	
	    if (key === _keyCodes.TAB) {
	      _this2.setState({ active: false, maskInked: false });
	      return;
	    } else if (key !== _keyCodes.LEFT && key !== _keyCodes.RIGHT) {
	      return;
	    }
	
	    var nextValue = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    nextValue = Math.max(min, Math.min((key === _keyCodes.LEFT ? -step : step) + nextValue, max));
	
	    _this2._handleIncrement(nextValue, e, true);
	  };
	
	  this._handleKeyUp = function (e) {
	    if ((e.which || e.keyCode) !== _keyCodes.TAB) {
	      return;
	    }
	
	    if (_this2.props.discrete) {
	      _this2._animateDiscreteInk();
	    }
	
	    _this2.setState({ maskInked: true });
	  };
	
	  this._handleFocus = function () {
	    _this2.setState({ active: true });
	  };
	
	  this._calcTrackWidth = function (props) {
	    var editable = props.editable,
	        leftIcon = props.leftIcon,
	        rightIcon = props.rightIcon,
	        inputWidth = props.inputWidth,
	        label = props.label;
	
	
	    if (!label) {
	      _this2.setState({ trackWidth: null });
	      return;
	    }
	
	    var trackWidth = null;
	    if (!leftIcon && !rightIcon && !editable) {
	      trackWidth = '100%';
	    } else if (editable && !leftIcon) {
	      var cs = window.getComputedStyle(_this2._field);
	      var pl = parseInt(cs.getPropertyValue('padding-left'), 10);
	      var ml = parseInt(cs.getPropertyValue('margin-left'), 10);
	
	      trackWidth = pl + ml + inputWidth;
	    }
	
	    if (trackWidth) {
	      _this2.setState({ trackWidth: trackWidth });
	    }
	  };
	
	  this._animateDiscreteInk = function () {
	    var wait = _this2.props.discreteInkTransitionTime;
	    if (_this2._inkTimeout) {
	      clearTimeout(_this2._inkTimeout);
	    }
	
	    _this2._inkTimeout = setTimeout(function () {
	      _this2.setState({ leaving: true, maskInked: false });
	
	      _this2._inkTimeout = setTimeout(function () {
	        _this2._inkTimeout = null;
	        _this2.setState({ leaving: false });
	      }, wait);
	    }, wait);
	  };
	
	  this._focusThumb = function () {
	    if (_this2._focusTimeout) {
	      clearTimeout(_this2._focusTimeout);
	    }
	
	    _this2._focusTimeout = setTimeout(function () {
	      _this2._focusTimeout = null;
	      if (!_this2._thumb) {
	        _this2._thumb = _this2._node.querySelector('.md-slider-thumb');
	      }
	
	      _this2._thumb.focus();
	    }, 100);
	  };
	};
	
	exports.default = Slider;
	//# sourceMappingURL=Slider.js.map

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is just the label component for the slider. It will
	 * return null if there are no children to display.
	 */
	var SliderLabel = function (_PureComponent) {
	  _inherits(SliderLabel, _PureComponent);
	
	  function SliderLabel() {
	    _classCallCheck(this, SliderLabel);
	
	    return _possibleConstructorReturn(this, (SliderLabel.__proto__ || Object.getPrototypeOf(SliderLabel)).apply(this, arguments));
	  }
	
	  _createClass(SliderLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          htmlFor = _props.htmlFor,
	          props = _objectWithoutProperties(_props, ['children', 'className', 'htmlFor']);
	
	      if (!children) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'label',
	        _extends({}, props, {
	          htmlFor: htmlFor,
	          className: (0, _classnames2.default)('md-slider-label', (0, _themeColors2.default)({ text: true }), className)
	        }),
	        children
	      );
	    }
	  }]);
	
	  return SliderLabel;
	}(_react.PureComponent);
	
	SliderLabel.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  htmlFor: function htmlFor(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var _PropTypes$string;
	
	    if (typeof props.children === 'undefined') {
	      return null;
	    }
	
	    return (_PropTypes$string = _propTypes2.default.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(others));
	  }
	};
	exports.default = SliderLabel;
	//# sourceMappingURL=SliderLabel.js.map

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleFakeButton = __webpack_require__(50);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Thumb` component is the little ball for the slider.
	 */
	var Thumb = function (_PureComponent) {
	  _inherits(Thumb, _PureComponent);
	
	  function Thumb() {
	    _classCallCheck(this, Thumb);
	
	    return _possibleConstructorReturn(this, (Thumb.__proto__ || Object.getPrototypeOf(Thumb)).apply(this, arguments));
	  }
	
	  _createClass(Thumb, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          on = _props.on,
	          off = _props.off,
	          active = _props.active,
	          disabled = _props.disabled,
	          dragging = _props.dragging,
	          thumbLeft = _props.thumbLeft,
	          discrete = _props.discrete,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'on', 'off', 'active', 'disabled', 'dragging', 'thumbLeft', 'discrete']);
	
	      return _react2.default.createElement(_AccessibleFakeButton2.default, _extends({
	        disabled: disabled
	      }, props, {
	        style: Object.assign({}, style, { left: thumbLeft }),
	        className: (0, _classnames2.default)('md-slider-thumb', className, {
	          'md-slider-thumb--active': active,
	          'md-slider-thumb--dragging': dragging,
	          'md-slider-thumb--disabled': disabled,
	          'md-slider-thumb--on': on,
	          'md-slider-thumb--continuous-off': !discrete && off,
	          'md-slider-thumb--discrete': discrete,
	          'md-slider-thumb--discrete-on': discrete && active && on,
	          'md-slider-thumb--discrete-off': discrete && !disabled && off,
	          'md-slider-thumb--discrete-active': discrete && active,
	          'md-slider-thumb--discrete-active-off': discrete && active && off
	        })
	      }));
	    }
	  }]);
	
	  return Thumb;
	}(_react.PureComponent);
	
	Thumb.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  on: _propTypes2.default.bool,
	  off: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  discrete: _propTypes2.default.bool
	};
	exports.default = Thumb;
	//# sourceMappingURL=Thumb.js.map

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ThumbMask` component is used for either:
	 *
	 *  - rendering the ink behind the `Thumb` component when the `Thumb`
	 *  has keyboard focus or touch focus
	 *  - rendering a underlay to make the `Track` look broken for disabled
	 *  Sliders.
	 */
	var ThumbMask = function (_PureComponent) {
	  _inherits(ThumbMask, _PureComponent);
	
	  function ThumbMask() {
	    _classCallCheck(this, ThumbMask);
	
	    return _possibleConstructorReturn(this, (ThumbMask.__proto__ || Object.getPrototypeOf(ThumbMask)).apply(this, arguments));
	  }
	
	  _createClass(ThumbMask, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          thumbLeft = _props.thumbLeft,
	          disabled = _props.disabled,
	          dragging = _props.dragging,
	          maskInked = _props.maskInked,
	          discrete = _props.discrete,
	          leaving = _props.leaving,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'thumbLeft', 'disabled', 'dragging', 'maskInked', 'discrete', 'leaving']);
	
	      return _react2.default.createElement('span', _extends({}, props, {
	        style: Object.assign({}, style, { left: thumbLeft }),
	        className: (0, _classnames2.default)('md-slider-thumb md-slider-thumb--mask', className, {
	          'md-slider-thumb--dragging': dragging,
	          'md-slider-thumb--mask-inked': maskInked,
	          'md-slider-thumb--mask-disabled': disabled,
	          'md-slider-thumb--discrete-mask-inked': maskInked && discrete,
	          'md-slider-thumb--discrete-mask-leaving': discrete && leaving
	        })
	      }));
	    }
	  }]);
	
	  return ThumbMask;
	}(_react.PureComponent);
	
	ThumbMask.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  maskInked: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  discrete: _propTypes2.default.bool,
	  leaving: _propTypes2.default.bool
	};
	exports.default = ThumbMask;
	//# sourceMappingURL=ThumbMask.js.map

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _updateUnit = __webpack_require__(364);
	
	var _updateUnit2 = _interopRequireDefault(_updateUnit);
	
	var _TrackFill = __webpack_require__(331);
	
	var _TrackFill2 = _interopRequireDefault(_TrackFill);
	
	var _Thumb = __webpack_require__(328);
	
	var _Thumb2 = _interopRequireDefault(_Thumb);
	
	var _ThumbMask = __webpack_require__(329);
	
	var _ThumbMask2 = _interopRequireDefault(_ThumbMask);
	
	var _DiscreteValue = __webpack_require__(325);
	
	var _DiscreteValue2 = _interopRequireDefault(_DiscreteValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var half = function half(w) {
	  return w / 2;
	};
	
	/**
	 * The `Track` component is used for showing the current state of the slider.
	 * It will render the `TrackFill`, `Thumb`, and `ThumbMask` components.
	 */
	
	var Track = function (_PureComponent) {
	  _inherits(Track, _PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).apply(this, arguments));
	  }
	
	  _createClass(Track, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          on = _props.on,
	          off = _props.off,
	          active = _props.active,
	          disabled = _props.disabled,
	          dragging = _props.dragging,
	          className = _props.className,
	          thumbLeft = _props.thumbLeft,
	          trackFillWidth = _props.trackFillWidth,
	          trackFillStyle = _props.trackFillStyle,
	          trackFillClassName = _props.trackFillClassName,
	          discreteValueStyle = _props.discreteValueStyle,
	          discreteValueClassName = _props.discreteValueClassName,
	          maskInked = _props.maskInked,
	          maskLeaving = _props.maskLeaving,
	          thumbStyle = _props.thumbStyle,
	          thumbClassName = _props.thumbClassName,
	          discrete = _props.discrete,
	          onThumbFocus = _props.onThumbFocus,
	          onThumbKeyUp = _props.onThumbKeyUp,
	          onThumbKeyDown = _props.onThumbKeyDown,
	          value = _props.value,
	          tickWidth = _props.tickWidth,
	          discreteTicks = _props.discreteTicks,
	          scale = _props.scale,
	          step = _props.step,
	          valuePrecision = _props.valuePrecision,
	          props = _objectWithoutProperties(_props, ['on', 'off', 'active', 'disabled', 'dragging', 'className', 'thumbLeft', 'trackFillWidth', 'trackFillStyle', 'trackFillClassName', 'discreteValueStyle', 'discreteValueClassName', 'maskInked', 'maskLeaving', 'thumbStyle', 'thumbClassName', 'discrete', 'onThumbFocus', 'onThumbKeyUp', 'onThumbKeyDown', 'value', 'tickWidth', 'discreteTicks', 'scale', 'step', 'valuePrecision']);
	
	      var ticks = [];
	      if (typeof discreteTicks !== 'undefined' && !disabled && discrete) {
	        var amt = scale / (discreteTicks / step);
	        var offset = (0, _updateUnit2.default)(tickWidth, half, 'px');
	        var inc = 100 / amt;
	
	        for (var i = 0; i <= amt; i++) {
	          var left = i * inc + '%';
	          var width = tickWidth;
	          if (i === 0 || i === amt) {
	            width = (0, _updateUnit2.default)(tickWidth, half);
	          } else {
	            left = 'calc(' + left + ' - ' + offset + ')';
	          }
	
	          ticks.push(_react2.default.createElement('span', {
	            key: 'tick-' + i,
	            className: 'md-slider-discrete-tick',
	            style: { left: left, width: width }
	          }));
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: (0, _classnames2.default)('md-slider-track', className) }),
	        ticks,
	        _react2.default.createElement(_TrackFill2.default, {
	          style: trackFillStyle,
	          className: trackFillClassName,
	          disabled: disabled,
	          dragging: dragging,
	          trackFillWidth: trackFillWidth
	        }),
	        _react2.default.createElement(_Thumb2.default, {
	          style: thumbStyle,
	          className: thumbClassName,
	          on: on,
	          off: off,
	          disabled: disabled,
	          dragging: dragging,
	          active: active,
	          thumbLeft: thumbLeft,
	          onFocus: onThumbFocus,
	          onKeyUp: onThumbKeyUp,
	          onKeyDown: onThumbKeyDown,
	          discrete: discrete
	        }),
	        _react2.default.createElement(_DiscreteValue2.default, {
	          style: discreteValueStyle,
	          className: discreteValueClassName,
	          discrete: discrete,
	          dragging: dragging,
	          active: active,
	          value: value,
	          thumbLeft: thumbLeft,
	          valuePrecision: valuePrecision
	        }),
	        _react2.default.createElement(_ThumbMask2.default, {
	          dragging: dragging,
	          disabled: disabled,
	          thumbLeft: thumbLeft,
	          maskInked: maskInked,
	          discrete: discrete,
	          leaving: maskLeaving
	        })
	      );
	    }
	  }]);
	
	  return Track;
	}(_react.PureComponent);
	
	Track.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  thumbStyle: _propTypes2.default.object,
	  thumbClassName: _propTypes2.default.string,
	  trackFillStyle: _propTypes2.default.object,
	  trackFillClassName: _propTypes2.default.string,
	  discreteValueStyle: _propTypes2.default.object,
	  discreteValueClassName: _propTypes2.default.string,
	  on: _propTypes2.default.bool,
	  off: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  trackFillWidth: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.number.isRequired,
	  discrete: _propTypes2.default.bool,
	  maskInked: _propTypes2.default.bool,
	  maskLeaving: _propTypes2.default.bool,
	  onThumbKeyUp: _propTypes2.default.func.isRequired,
	  onThumbKeyDown: _propTypes2.default.func.isRequired,
	  onThumbFocus: _propTypes2.default.func.isRequired,
	  scale: _propTypes2.default.number,
	  step: _propTypes2.default.number,
	  discreteTicks: _propTypes2.default.number,
	  tickWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  valuePrecision: _propTypes2.default.number.isRequired
	};
	exports.default = Track;
	//# sourceMappingURL=Track.js.map

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TrackFill` component is used for showing a colored bar
	 * within the `Track` component to show the `Slider`'s position.
	 *
	 * If the `Slider` is disabled, this will just return null.
	 */
	var TrackFill = function (_PureComponent) {
	  _inherits(TrackFill, _PureComponent);
	
	  function TrackFill() {
	    _classCallCheck(this, TrackFill);
	
	    return _possibleConstructorReturn(this, (TrackFill.__proto__ || Object.getPrototypeOf(TrackFill)).apply(this, arguments));
	  }
	
	  _createClass(TrackFill, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          trackFillWidth = _props.trackFillWidth,
	          dragging = _props.dragging,
	          disabled = _props.disabled,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'trackFillWidth', 'dragging', 'disabled']);
	
	      if (disabled) {
	        return null;
	      }
	
	      return _react2.default.createElement('hr', _extends({}, props, {
	        style: Object.assign({}, style, { width: trackFillWidth }),
	        className: (0, _classnames2.default)('md-slider-track-fill', className, {
	          'md-slider-track-fill--dragging': dragging
	        })
	      }));
	    }
	  }]);
	
	  return TrackFill;
	}(_react.PureComponent);
	
	TrackFill.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  dragging: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  trackFillWidth: _propTypes2.default.string.isRequired
	};
	exports.default = TrackFill;
	//# sourceMappingURL=TrackFill.js.map

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _Slider2 = __webpack_require__(326);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider3.default;
	exports.Slider = _Slider3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _CSSTransitionGroupTick = __webpack_require__(30);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _isInvalidAnimate = __webpack_require__(154);
	
	var _isInvalidAnimate2 = _interopRequireDefault(_isInvalidAnimate);
	
	var _Portal = __webpack_require__(45);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Snackbar = __webpack_require__(153);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHAINED_TOAST_DELAY = 50;
	
	/**
	 * The `Snackbar` component is used for displaying a concise and small message to the user about
	 * an operation performed.
	 *
	 * > The main component for the `Snackbar` is actually named the `SnackbarContainer`, so you need
	 * to make sure the import is `react-md/lib/Snackbars` or `react-md/lib/Snackbars/SnackbarContainer`.
	 * The first import is preferable.
	 */
	
	var SnackbarContainer = function (_PureComponent) {
	  _inherits(SnackbarContainer, _PureComponent);
	
	  function SnackbarContainer(props) {
	    _classCallCheck(this, SnackbarContainer);
	
	    var _this = _possibleConstructorReturn(this, (SnackbarContainer.__proto__ || Object.getPrototypeOf(SnackbarContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visible = !!props.toasts.length;
	    _this.state = {
	      visible: visible,
	      toast: null
	    };
	    return _this;
	  }
	
	  _createClass(SnackbarContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var toasts = this.props.toasts;
	
	      if (toasts.length) {
	        this._initAndToast(toasts[0]);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _nextProps$toasts = _slicedToArray(nextProps.toasts, 1),
	          toast = _nextProps$toasts[0];
	
	      var _props$toasts = _slicedToArray(this.props.toasts, 1),
	          prevToast = _props$toasts[0];
	
	      if (toast === prevToast || toast === this.state.toast) {
	        return;
	      }
	
	      if (!toast) {
	        this._createLeaveTimer();
	      } else if (!this.state.visible) {
	        this._initAndToast(toast);
	      } else {
	        this._createSwapTimer(toast);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._initTimeout) {
	        clearTimeout(this._initTimeout);
	      }
	
	      if (this._leaveTimeout) {
	        clearTimeout(this._leaveTimeout);
	      }
	
	      if (this._swapTimeout) {
	        clearTimeout(this._swapTimeout);
	      }
	
	      if (this._dismissTimeout) {
	        clearTimeout(this._dismissTimeout);
	      }
	    }
	
	    /**
	     * This function takes in a new toast object and checks if the message will span
	     * multiple lines of text by creating the new snackbar before the `Snackbar` component
	     * gets made, checking the height of the message, and then removing the temporary
	     * snackbar.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          visible = _state.visible,
	          toast = _state.toast,
	          multiline = _state.multiline;
	
	      var _props = this.props,
	          transitionName = _props.transitionName,
	          transitionEnterTimeout = _props.transitionEnterTimeout,
	          transitionLeaveTimeout = _props.transitionLeaveTimeout,
	          dismiss = _props.dismiss,
	          onDismiss = _props.onDismiss,
	          lastChild = _props.lastChild,
	          portal = _props.portal,
	          propRenderNode = _props.renderNode,
	          toasts = _props.toasts,
	          props = _objectWithoutProperties(_props, ['transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'dismiss', 'onDismiss', 'lastChild', 'portal', 'renderNode', 'toasts']);
	
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	
	      var snackbar = void 0;
	      if (toast) {
	        snackbar = _react2.default.createElement(_Snackbar2.default, _extends({}, props, {
	          key: 'snackbar',
	          leaveTimeout: transitionLeaveTimeout,
	          toast: toast,
	          multiline: multiline,
	          onDismiss: onDismiss || dismiss
	        }));
	      }
	
	      var container = _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	          ref: this._setContainer,
	          key: 'container',
	          className: 'md-snackbar-container',
	          transitionName: transitionName,
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout
	        },
	        snackbar
	      );
	
	      if (!portal) {
	        return visible ? container : null;
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { visible: visible, renderNode: renderNode, lastChild: lastChild },
	        container
	      );
	    }
	  }]);
	
	  return SnackbarContainer;
	}(_react.PureComponent);
	
	SnackbarContainer.propTypes = {
	  /**
	   * An id for the Snackbar once a toast has been added and is visible. This is a recommended
	   * prop for accessibility concerns. If it is omitted, the id will become `'snackbar-alert'`
	   * when there is no action on the toast, or `'snackbar-alert-dialog'` when there is an action
	   * on the toast.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the snackbar once it appears.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the snackbar once it appears.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An immutable controlled queue of toasts that should appear in the snackbar.
	   * The snackbar will always display the first toast in this list. When the user has
	   * either clicked the action of the toast, or the `autohideTimeout` has been reached,
	   * the `onDismiss` function will be called. The `onDismiss` function should remove the
	   * first toast and return a new list of remaining toasts.
	   *
	   * ```js
	   * let toasts = [];
	   * const onDismiss = () => {
	   *   const [, ...remainingToasts] = toasts;
	   *   toasts = remainingToasts;
	   * };
	   * ```
	   */
	  toasts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    /**
	     * The text to display in the toast.
	     */
	    text: _propTypes2.default.node.isRequired,
	
	    /**
	     * An optional action to take. If this value is a string, the `label` for the
	     * button will be this value, Otherwise, all the keys in the action object will
	     * be applied to the `Button`.
	     */
	    action: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
	      onClick: _propTypes2.default.func,
	      children: _propTypes2.default.node,
	      // Deprecated
	      label: _propTypes2.default.node
	    })])
	  })).isRequired,
	
	  /**
	   * A function to call that will dismiss a toast. This will automatically be bound to
	   * any toast that has an `action` and it will also be called when the `autohideTimeout`
	   * has been reached.
	   */
	  onDismiss: _propTypes2.default.func.isRequired,
	
	  /**
	   * Boolean if the snackbar's toasts should automatically be dismissed after the
	   * `autohideTimeout` has been reached.
	   */
	  autohide: _propTypes2.default.bool,
	
	  /**
	   * The amount of time before the snackbar should be dequeued and the next toast
	   * should be displayed.
	   */
	  autohideTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition name to use for the snackbar appearing and disappearing.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition time for the snackbar to enter. This should match the `$md-snackbar-transition-time`
	   * sass variable.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition time for the snackbar to leave. This should match the `$md-snackbar-transition-time`
	   * sass variable.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * When the app contains a floating action button that is fixed to the bottom of the screen,
	   * you should set this to be a ref of the floating action button. When a snackbar appears,
	   * the FAB will be moved to not overlay the snackbar.
	   */
	  fab: function fab(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	    if (!propValue) {
	      return null;
	    }
	
	    if (propType !== 'object' || typeof propValue.render !== 'function' || (0, _isInvalidAnimate2.default)(propValue)) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	      return new Error('Invalid ' + location + ' `' + propFullNameSafe + '` supplied to `' + componentNameSafe + '`, expected a ' + 'ref to a floating `Button` component. This should not be a DOMElement from `findDOMNode` but instead ' + 'the React ref object.');
	    }
	
	    return null;
	  },
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the snackbar.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM node to render the Snackbar in. If this is omitted, it will render as the first
	   * child in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the snackbar should render as the last child in the `renderNode` or `body` instead of
	   * as the first.
	   */
	  lastChild: _propTypes2.default.bool,
	  dismiss: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onDismiss` instead')
	};
	SnackbarContainer.defaultProps = {
	  autohide: true,
	  toasts: [],
	  autohideTimeout: 3000,
	  transitionName: 'md-snackbar',
	  transitionEnterTimeout: 300,
	  transitionLeaveTimeout: 300
	};
	SnackbarContainer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    _this2._container = (0, _reactDom.findDOMNode)(container);
	  };
	
	  this._isMultiline = function (toast) {
	    var container = _this2._container;
	    if (container === null) {
	      return false;
	    }
	
	    var message = document.createElement('p');
	    message.classList.add('md-snackbar--toast');
	    message.innerHTML = toast.text;
	
	    var snackbar = void 0;
	    if (toast.action) {
	      message.classList.add('md-snackbar--action');
	
	      snackbar = document.createElement('section');
	      snackbar.className = 'md-snackbar';
	      snackbar.appendChild(message);
	
	      var action = document.createElement('button');
	      action.innerHTML = typeof toast.action === 'string' ? toast.action : toast.action.label;
	      action.className = 'md-btn md-btn--flat md-btn--text md-btn--snackbar';
	      snackbar.appendChild(action);
	    } else {
	      snackbar = message;
	    }
	
	    // Only style we really want from the .md-snackbar
	    snackbar.style.maxWidth = '568px';
	
	    container.appendChild(snackbar);
	    var multiline = message.offsetHeight > 20;
	    container.removeChild(snackbar);
	
	    return multiline;
	  };
	
	  this._initAndToast = function (toast) {
	    _this2._initTimeout = setTimeout(function () {
	      _this2._initTimeout = null;
	
	      _this2.setState({ toast: toast, multiline: _this2._isMultiline(toast) });
	    }, _CSSTransitionGroupTick2.default);
	
	    _this2.setState({ visible: true });
	  };
	
	  this._createLeaveTimer = function () {
	    var time = _this2.props.transitionLeaveTimeout;
	
	    _this2._leaveTimeout = setTimeout(function () {
	      _this2._leaveTimeout = null;
	
	      _this2.setState({ visible: false });
	    }, time + _CSSTransitionGroupTick2.default);
	
	    _this2.setState({ toast: null });
	  };
	
	  this._createSwapTimer = function (toast) {
	    _this2._swapTimeout = setTimeout(function () {
	      _this2._swapTimeout = null;
	
	      _this2.setState({ toast: toast, multiline: _this2._isMultiline(toast) });
	    }, _this2.props.transitionLeaveTimeout + CHAINED_TOAST_DELAY);
	
	    _this2.setState({ toast: null });
	  };
	};
	
	exports.default = SnackbarContainer;
	//# sourceMappingURL=SnackbarContainer.js.map

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Snackbar = undefined;
	
	var _SnackbarContainer = __webpack_require__(333);
	
	var _SnackbarContainer2 = _interopRequireDefault(_SnackbarContainer);
	
	var _Snackbar2 = __webpack_require__(153);
	
	var _Snackbar3 = _interopRequireDefault(_Snackbar2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SnackbarContainer2.default;
	exports.Snackbar = _Snackbar3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _oneRequired = __webpack_require__(173);
	
	var _oneRequired2 = _interopRequireDefault(_oneRequired);
	
	var _AccessibleFakeInkedButton = __webpack_require__(25);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Tab` component is used for rendering a single tab in the `Tabs` component.
	 * It can optionally have either a `label`, an `icon` or both.
	 */
	var Tab = function (_PureComponent) {
	  _inherits(Tab, _PureComponent);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tab.__proto__ || Object.getPrototypeOf(Tab)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(_this.props.index, _this.props.id, _this.props.controlsId, _this.props.children, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          id = _props.id,
	          controlsId = _props.controlsId,
	          className = _props.className,
	          activeClassName = _props.activeClassName,
	          inactiveClassName = _props.inactiveClassName,
	          active = _props.active,
	          propIcon = _props.icon,
	          propLabel = _props.label,
	          index = _props.index,
	          props = _objectWithoutProperties(_props, ['id', 'controlsId', 'className', 'activeClassName', 'inactiveClassName', 'active', 'icon', 'label', 'index']);
	
	      var _props2 = this.props,
	          icon = _props2.icon,
	          label = _props2.label;
	
	      if (icon) {
	        var iconEl = _react.Children.only(icon);
	        icon = (0, _react.cloneElement)(icon, {
	          className: (0, _classnames2.default)('md-icon--tab', iconEl.props.className)
	        });
	      }
	
	      if ((0, _react.isValidElement)(label)) {
	        var labelEl = _react.Children.only(label);
	        label = (0, _react.cloneElement)(label, {
	          className: (0, _classnames2.default)('md-tab-label', labelEl.props.className)
	        });
	      } else {
	        label = _react2.default.createElement(
	          'div',
	          { className: 'md-tab-label' },
	          label
	        );
	      }
	      return _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, props, {
	          id: id,
	          role: 'tab',
	          onClick: this._handleClick,
	          className: (0, _classnames2.default)('md-tab', (_cn = {
	            'md-tab--icon': label && icon
	          }, _defineProperty(_cn, activeClassName, activeClassName && active), _defineProperty(_cn, inactiveClassName, inactiveClassName && !active), _cn), className),
	          'aria-controls': controlsId,
	          'aria-selected': active
	        }),
	        icon,
	        label
	      );
	    }
	  }]);
	
	  return Tab;
	}(_react.PureComponent);
	
	Tab.propTypes = {
	  /**
	   * An id for the tab. This is required for a11y. If you use the `Tabs` component, this
	   * will automatically be generated for you and injected into this component.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An id for a `TabPanel` that holds the children from this tab. This is required for a11y.
	   * If you use the `Tabs` component, this will automatically be generated for you and injected
	   * into this component.
	   */
	  controlsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The className to use when the tab is currently active. The default className does
	   * not actually apply any styles.
	   *
	   * @see {@link Tabs/Tabs#activeTabClassName}
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * The className to use when the tab is not active. By default, this will set inactive
	   * tabs' color to `$md-white-base`. This works great if the tabs are placed on a
	   * colored toolbar but fails when the tabs are not colored or on a white background.
	   * In these cases, it is recommended to change this value to `md-text--secondary`
	   * or some other class name.
	   *
	   * @see {@link Tabs/Tabs#inactiveTabClassName}
	   */
	  inactiveClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Any children to display once the tab has been selected.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional icon to display in the tab. This can either be used alone, or it
	   * will be placed above the `label` if both are given.
	   */
	  icon: _propTypes2.default.element,
	
	  /**
	   * An optional label to display in the tab. This can either be used alone, or it
	   * will be placed below the `icon` if both are given.
	   */
	  label: (0, _oneRequired2.default)(_propTypes2.default.node, 'icon'),
	
	  /**
	   * An optional function to call when the tab is clicked. The callback includes this tab's index,
	   * id, controlsId, children, and finally click event. All the additional parameters are included
	   * if you are not using the `TabsContainer` component. The `id` and `controlsId` are mainly passed
	   * for accessibility.
	   *
	   * ```js
	   * onClick(index, id, controlsId, children, event);
	   * ```
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Boolean if the tab is currently active. If you use the `Tabs` component, this is automatically
	   * injected.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * Tab's index. If you use the `Tabs` component, this is automatically injected.
	   */
	  index: _propTypes2.default.number
	};
	Tab.defaultProps = {
	  component: 'li',
	  activeClassName: 'md-tab--active',
	  inactiveClassName: 'md-tab--inactive'
	};
	exports.default = Tab;
	//# sourceMappingURL=Tab.js.map

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabIndicator = function (_PureComponent) {
	  _inherits(TabIndicator, _PureComponent);
	
	  function TabIndicator() {
	    _classCallCheck(this, TabIndicator);
	
	    return _possibleConstructorReturn(this, (TabIndicator.__proto__ || Object.getPrototypeOf(TabIndicator)).apply(this, arguments));
	  }
	
	  _createClass(TabIndicator, [{
	    key: 'render',
	    value: function render() {
	      var visible = this.props.visible;
	
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        {
	          style: {
	            x: (0, _reactMotion.spring)(this.props.offset),
	            width: (0, _reactMotion.spring)(this.props.width),
	            height: (0, _reactMotion.spring)(visible ? 2 : 0)
	          }
	        },
	        function (_ref) {
	          var x = _ref.x,
	              height = _ref.height,
	              width = _ref.width;
	
	          var transform = 'translate3d(' + x + 'px, 0, 0)';
	          return _react2.default.createElement('span', {
	            style: {
	              height: height,
	              width: width,
	              WebkitTransform: transform,
	              MozTransform: transform,
	              msTransform: transform,
	              transform: transform
	            },
	            className: 'md-tab-indicator'
	          });
	        }
	      );
	    }
	  }]);
	
	  return TabIndicator;
	}(_react.PureComponent);
	
	TabIndicator.propTypes = {
	  offset: _propTypes2.default.number.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  visible: _propTypes2.default.bool
	};
	exports.default = TabIndicator;
	//# sourceMappingURL=TabIndicator.js.map

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabOverflowButton = function (_PureComponent) {
	  _inherits(TabOverflowButton, _PureComponent);
	
	  function TabOverflowButton() {
	    _classCallCheck(this, TabOverflowButton);
	
	    return _possibleConstructorReturn(this, (TabOverflowButton.__proto__ || Object.getPrototypeOf(TabOverflowButton)).apply(this, arguments));
	  }
	
	  _createClass(TabOverflowButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          left = _props.left,
	          icon = _props.icon,
	          props = _objectWithoutProperties(_props, ['left', 'icon']);
	
	      return _react2.default.createElement(_Button2.default, _extends({}, props, {
	        icon: true,
	        className: (0, _classnames2.default)('md-icon--inherit md-btn--tab-overflow', {
	          'md-btn--tab-overflow-left': left,
	          'md-btn--tab-overflow-right': !left,
	          'md-btn--tab-overflow-icon': icon
	        })
	      }));
	    }
	  }]);
	
	  return TabOverflowButton;
	}(_react.PureComponent);
	
	TabOverflowButton.propTypes = {
	  left: _propTypes2.default.bool,
	  icon: _propTypes2.default.bool
	};
	exports.default = TabOverflowButton;
	//# sourceMappingURL=TabOverflowButton.js.map

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(4);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(11);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _TabIndicator = __webpack_require__(336);
	
	var _TabIndicator2 = _interopRequireDefault(_TabIndicator);
	
	var _IconSeparator = __webpack_require__(44);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _ResizeObserver = __webpack_require__(28);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _FontIcon = __webpack_require__(8);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(17);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _MenuTab = __webpack_require__(157);
	
	var _MenuTab2 = _interopRequireDefault(_MenuTab);
	
	var _TabOverflowButton = __webpack_require__(337);
	
	var _TabOverflowButton2 = _interopRequireDefault(_TabOverflowButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MOBILE_PADDING = 72;
	var DESKTOP_PADDING = 80;
	var MOBILE_TAB_MIN_WIDTH = 72;
	var DESKTOP_TAB_MIN_WIDTH = 160;
	
	/**
	 * The `Tabs` component is used to manage the state of which tab is currently active.
	 */
	
	var Tabs = function (_PureComponent) {
	  _inherits(Tabs, _PureComponent);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
	
	    _this._setContainer = function (container) {
	      _this._container = container;
	      _this._positionElements(_this._container !== null);
	    };
	
	    _this._positionElements = function (initialRender) {
	      initialRender = typeof initialRender === 'boolean' && initialRender;
	      if (!_this._container) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          centered = _this$props.centered,
	          overflowMenu = _this$props.overflowMenu;
	      var mobile = _this.props.mobile;
	
	
	      var paddingLeft = void 0;
	      if (!centered && _this._shouldAlign(_this.props)) {
	        paddingLeft = _this._calcPaddingLeft(_this._container, mobile);
	      }
	
	      var overflowAtIndex = void 0;
	      if (!mobile) {
	        overflowAtIndex = _this._calcOverflowIndex(_this._container, paddingLeft, overflowMenu);
	      }
	
	      var indicatorPosition = _this._calcIndicatorPosition(_this._container, initialRender ? paddingLeft : 0);
	
	      _this.setState(_extends({ mobile: mobile, paddingLeft: paddingLeft, overflowAtIndex: overflowAtIndex }, indicatorPosition), _this._scrollActiveIntoView);
	    };
	
	    _this._scrollActiveIntoView = function () {
	      if (!_this._container || !_this.state.mobile) {
	        return;
	      }
	
	      var active = _this._container.querySelector('.md-tab--active');
	      if (!active) {
	        return;
	      }
	
	      var allTabs = Array.prototype.slice.call(_this._container.querySelectorAll('.md-tab'));
	      if (allTabs[0] === active) {
	        _this._container.scrollLeft = 0;
	        return;
	      }
	
	      var _this$_container = _this._container,
	          containerWidth = _this$_container.offsetWidth,
	          scrollLeft = _this$_container.scrollLeft;
	      var activeWidth = active.offsetWidth,
	          activeOffset = active.offsetLeft;
	
	      var inFullViewLeft = activeOffset - scrollLeft >= 0;
	      var inFullViewRight = activeOffset + activeWidth - (containerWidth + scrollLeft) <= 0;
	      if (inFullViewLeft && inFullViewRight) {
	        return;
	      }
	
	      var offset = 0;
	      allTabs.some(function (tab, i) {
	        if (i < _this.props.activeTabIndex) {
	          offset += tab.offsetWidth;
	        }
	
	        return i < _this.state.activeTabIndex;
	      });
	
	      _this._container.scrollLeft = offset;
	    };
	
	    _this._handleTabChange = function (index, tabId, tabControlsId, tabChildren, event) {
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(index, tabId, tabControlsId, tabChildren, event);
	      }
	
	      if (typeof _this.props.activeTabIndex === 'undefined') {
	        _this.setState(_extends({
	          activeTabIndex: index
	        }, _this._calcIndicatorPosition(_this._container, 0, index, _this.state.overflowAtIndex)));
	      }
	    };
	
	    _this._mapToOverflowTabProps = function (tab, i) {
	      var index = i + _this.state.overflowAtIndex;
	      var active = (0, _getField2.default)(_this.props, _this.state, 'activeTabIndex') === index;
	      var tabEl = _react.Children.only(tab);
	      var handleTabChange = _this._handleTabChange;
	
	      return {
	        active: active,
	        primaryText: tabEl.props.label,
	        onClick: function handleClick(event) {
	          var _tabEl$props = tabEl.props,
	              onClick = _tabEl$props.onClick,
	              id = _tabEl$props.id,
	              controlsId = _tabEl$props.controlsId,
	              children = _tabEl$props.children;
	
	          if (onClick) {
	            onClick(index, event);
	          }
	
	          handleTabChange(index, id, controlsId, children, event);
	        }
	      };
	    };
	
	    _this._nextIndexes = function (increment) {
	      var _this$state = _this.state,
	          overflowIndex = _this$state.overflowIndex,
	          overflowAtIndex = _this$state.overflowAtIndex;
	
	      var visibleAmt = (overflowAtIndex - overflowIndex) * (increment ? 1 : -1);
	
	      _this.setState({
	        overflowIndex: overflowIndex + visibleAmt,
	        overflowAtIndex: overflowAtIndex + visibleAmt
	      });
	    };
	
	    _this._showNextTabs = function () {
	      _this._nextIndexes(true);
	    };
	
	    _this._showPreviousTabs = function () {
	      _this._nextIndexes(false);
	    };
	
	    var defaultTabIndex = typeof props.activeTabIndex === 'undefined' ? props.defaultTabIndex : props.activeTabIndex;
	    var indicatorWidth = props.mobile ? MOBILE_TAB_MIN_WIDTH : DESKTOP_TAB_MIN_WIDTH;
	    _this.state = {
	      indicatorWidth: indicatorWidth,
	      indicatorOffset: indicatorWidth * defaultTabIndex,
	      indicatorVisible: true,
	      overflowIndex: 0
	    };
	
	    if (typeof props.activeTabIndex === 'undefined') {
	      _this.state.activeTabIndex = defaultTabIndex;
	    }
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.activeTabIndex !== nextProps.activeTabIndex) {
	        this.setState(_extends({}, this._calcIndicatorPosition(this._container, 0, nextProps.activeTabIndex, this.state.overflowAtIndex)), this._scrollActiveIntoView);
	      } else if (!this._shouldAlign(nextProps) && this._shouldAlign(this.props)) {
	        this.setState({ paddingLeft: null });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this._shouldAlign(this.props) && this.state.overflowAtIndex !== prevState.overflowAtIndex) {
	        var paddingLeft = this._calcPaddingLeft(this._container, this.state.mobile);
	        // Have to wait for the overflow menus to appear, then wop
	        /* eslint-disable react/no-did-update-set-state */
	        this.setState({ paddingLeft: paddingLeft });
	      } else {
	        var labels = _react.Children.map(_react.Children.toArray(this.props.children), function (_ref) {
	          var label = _ref.props.label;
	          return label;
	        });
	        var prevLabels = _react.Children.map(_react.Children.toArray(prevProps.children), function (_ref2) {
	          var label = _ref2.props.label;
	          return label;
	        });
	        if (labels.length !== prevLabels.length || labels.filter(function (_, i) {
	          return labels[i] !== prevLabels[i];
	        }).length) {
	          this.setState(_extends({}, this._calcIndicatorPosition(this._container, 0, this.props.activeTabIndex, this.state.overflowAtIndex)), this._scrollActiveIntoView);
	        }
	      }
	    }
	  }, {
	    key: '_shouldAlign',
	    value: function _shouldAlign(props) {
	      return typeof props.alignToKeyline === 'boolean' ? props.alignToKeyline : _react.Children.toArray(props.children).filter(function (child) {
	        return !!child;
	      }).length > 3;
	    }
	  }, {
	    key: '_calcPaddingLeft',
	    value: function _calcPaddingLeft(container, mobile) {
	      var mediaPadding = mobile ? MOBILE_PADDING : DESKTOP_PADDING;
	      var tab = container.querySelector('.md-tab');
	
	      var _tab$querySelector = tab.querySelector('.md-tab-label'),
	          labelOffset = _tab$querySelector.offsetLeft;
	
	      return mediaPadding - labelOffset;
	    }
	  }, {
	    key: '_calcOverflowIndex',
	    value: function _calcOverflowIndex(container) {
	      var paddingLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var menu = arguments[2];
	
	      var containerWidth = container.offsetWidth;
	      var overflowIndex = 0;
	      if (containerWidth < container.scrollWidth) {
	        var tabs = Array.prototype.slice.call(container.querySelectorAll('.md-tab'));
	        var totalWidth = 0;
	        tabs.some(function (tab, i) {
	          overflowIndex = i;
	          totalWidth += tab.offsetWidth;
	
	          return totalWidth > containerWidth;
	        });
	      }
	
	      return Math.max(0, overflowIndex - (menu ? 1 : 0));
	    }
	  }, {
	    key: '_calcIndicatorPosition',
	    value: function _calcIndicatorPosition(container) {
	      var paddingLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var activeTabIndex = arguments[2];
	      var overflowAtIndex = arguments[3];
	
	      var activeItem = void 0;
	      if (typeof activeTabIndex === 'number') {
	        if (overflowAtIndex > 0 && activeTabIndex >= overflowAtIndex) {
	          activeItem = container.querySelector('.md-menu--tab');
	        } else {
	          activeItem = container.querySelectorAll('.md-tab')[activeTabIndex];
	        }
	      } else {
	        activeItem = container.querySelector('.md-tab--active');
	      }
	
	      if (!activeItem) {
	        return { indicatorVisible: false };
	      }
	
	      var _activeItem = activeItem,
	          indicatorWidth = _activeItem.offsetWidth,
	          indicatorOffset = _activeItem.offsetLeft;
	
	      return {
	        indicatorWidth: indicatorWidth,
	        indicatorOffset: indicatorOffset + paddingLeft,
	        indicatorVisible: !overflowAtIndex || overflowAtIndex > activeTabIndex
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          indicatorOffset = _state.indicatorOffset,
	          indicatorWidth = _state.indicatorWidth,
	          indicatorVisible = _state.indicatorVisible,
	          overflowIndex = _state.overflowIndex,
	          overflowAtIndex = _state.overflowAtIndex,
	          paddingLeft = _state.paddingLeft;
	
	      var _props = this.props,
	          Component = _props.component,
	          style = _props.style,
	          className = _props.className,
	          activeTabClassName = _props.activeTabClassName,
	          inactiveTabClassName = _props.inactiveTabClassName,
	          colored = _props.colored,
	          centered = _props.centered,
	          tabId = _props.tabId,
	          overflowMenu = _props.overflowMenu,
	          overflowMenuLabel = _props.overflowMenuLabel,
	          nextIcon = _props.nextIcon,
	          previousIcon = _props.previousIcon,
	          overflowMenuIcon = _props.overflowMenuIcon,
	          overflowMenuIconChildren = _props.overflowMenuIconChildren,
	          overflowMenuIconClassName = _props.overflowMenuIconClassName,
	          nextIconChildren = _props.nextIconChildren,
	          nextIconClassName = _props.nextIconClassName,
	          previousIconChildren = _props.previousIconChildren,
	          previousIconClassName = _props.previousIconClassName,
	          propActiveIndex = _props.activeTabIndex,
	          defaultTabIndex = _props.defaultTabIndex,
	          onTabChange = _props.onTabChange,
	          alignToKeyline = _props.alignToKeyline,
	          mobile = _props.mobile,
	          defaultMedia = _props.defaultMedia,
	          desktopMinWidth = _props.desktopMinWidth,
	          props = _objectWithoutProperties(_props, ['component', 'style', 'className', 'activeTabClassName', 'inactiveTabClassName', 'colored', 'centered', 'tabId', 'overflowMenu', 'overflowMenuLabel', 'nextIcon', 'previousIcon', 'overflowMenuIcon', 'overflowMenuIconChildren', 'overflowMenuIconClassName', 'nextIconChildren', 'nextIconClassName', 'previousIconChildren', 'previousIconClassName', 'activeTabIndex', 'defaultTabIndex', 'onTabChange', 'alignToKeyline', 'mobile', 'defaultMedia', 'desktopMinWidth']);
	
	      var activeTabIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	      var icon = false;
	      var children = _react.Children.map(_react.Children.toArray(this.props.children), function (tab, index) {
	        var handleOnClick = function handleOnClick(tabIndex, id, tabControlsId, tabChildren, event) {
	          if (tab.props.onClick) {
	            tab.props.onClick(tabId, id, tabControlsId, tabChildren, event);
	          }
	
	          _this2._handleTabChange(tabIndex, id, tabControlsId, tabChildren, event);
	        };
	
	        if (tab.props.icon) {
	          icon = true;
	        }
	
	        return (0, _react.cloneElement)(tab, {
	          index: index,
	          activeClassName: activeTabClassName,
	          inactiveClassName: inactiveTabClassName,
	          id: tab.props.id || tabId + '-' + index,
	          controlsId: tab.props.controlsId || tabId + '-panel-' + index,
	          active: index === activeTabIndex,
	          onClick: handleOnClick
	        });
	      });
	
	      var overflow = void 0;
	      var nextControl = void 0;
	      var previousControl = void 0;
	      if (overflowAtIndex) {
	        var length = children.length;
	        if (overflowMenu) {
	          overflow = _react2.default.createElement(_MenuTab2.default, {
	            id: tabId + '-overflow-menu',
	            activeTabIndex: activeTabIndex,
	            overflowAtIndex: overflowAtIndex,
	            label: _react2.default.createElement(
	              _IconSeparator2.default,
	              { label: overflowMenuLabel },
	              (0, _getDeprecatedIcon2.default)(overflowMenuIconClassName, overflowMenuIconChildren, overflowMenuIcon)
	            ),
	            tabs: children.slice(overflowAtIndex, children.length).map(this._mapToOverflowTabProps)
	          });
	        }
	
	        children = children.slice(overflowIndex, overflowAtIndex);
	
	        if (!overflowMenu && overflowIndex > 0) {
	          previousControl = _react2.default.createElement(_TabOverflowButton2.default, {
	            left: true,
	            icon: icon,
	            iconEl: (0, _getDeprecatedIcon2.default)(previousIconClassName, previousIconChildren, previousIcon),
	            onClick: this._showPreviousTabs
	          });
	        }
	
	        if (!overflowMenu && length > 3 && overflowAtIndex + overflowIndex <= length) {
	          nextControl = _react2.default.createElement(_TabOverflowButton2.default, {
	            icon: icon,
	            onClick: this._showNextTabs,
	            iconEl: (0, _getDeprecatedIcon2.default)(nextIconClassName, nextIconChildren, nextIcon)
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          style: _extends({}, style, { paddingLeft: paddingLeft }),
	          className: (0, _classnames2.default)('md-tabs', {
	            'md-tabs--pagination': overflowAtIndex && !overflowMenu,
	            'md-tabs--centered': centered,
	            'md-background--primary': colored
	          }, className),
	          role: 'tablist'
	        }),
	        _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, watchHeight: true, onResize: this._positionElements, elRef: this._setContainer }),
	        previousControl,
	        children,
	        nextControl,
	        overflow,
	        _react2.default.createElement(_TabIndicator2.default, { offset: indicatorOffset, width: indicatorWidth, visible: indicatorVisible })
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react.PureComponent);
	
	Tabs.propTypes = {
	  /**
	   * A base id to use for each `Tab`. When the child tabs are created, they are cloned
	   * with some additional accessibility props. Each tab will get a prop with this and the
	   * current index of the tab.
	   */
	  tabId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The className to use when a tab is currently active. The default className does not
	   * actually apply any styles.
	   *
	   * If this prop is set, it will override any `activeClassName` props applied to the child
	   * `Tab`s. Either set a custom `activeClassName` on each `Tab`, or use this prop to apply
	   * the same `activeClassName` to each `Tab`.
	   *
	   * @see {@link Tabs/Tab#activeClassName}
	   */
	  activeTabClassName: _propTypes2.default.string,
	
	  /**
	   * The className to use when the tab is not active and not selected. By default,
	   * this will set inactive tabs' color to `$md-white-base`. This works great
	   * if the tabs are placed on a colored toolbar but fails when the tabs are not colored
	   * or on a white background. In these cases, it is recommended to change this value
	   * to `md-text--secondary` or some other class name.
	   *
	   * If this prop is set, it will override any `inactiveClassName` props applied to the child
	   * `Tab`s. Either set a custom `inactiveClassName` on each `Tab`, or use this prop to apply
	   * the same `inactiveClassName` to each `Tab`.
	   *
	   * @see {@link Tabs/Tab#inactiveClassName}
	   */
	  inactiveTabClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the tabs in.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * This should either be a single `Tab` component or a list of `Tab` components. Unfortunately,
	   * the child *must* be exactly a `Tab` component because this is unable to extract the correct
	   * `label` and `children` from a custom `Tab` component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired,
	
	  /**
	   * Boolean if the tabs should be centered instead of aligned to the keyline. The tabs will
	   * only be aligned to the keyline when there are more than 3 tabs and the `alignToKeyline`
	   * prop is `false`.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the tabs should align to a toolbar's title keyline. If this is undefined,
	   * the tabs will try to align to the keyline when there are more than 3 tabs.
	   */
	  alignToKeyline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the tabs should be colored with the primary color. If this is false or undefined,
	   * the tabs will be colored for the light or dark theme.
	   */
	  colored: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the overflow tabs on desktop displays should appear in a menu. If this is false,
	   * the additional tabs will be available by using pagination buttons.
	   */
	  overflowMenu: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the active tab is changed. The callback will include
	   * the new active tab index and a click event.
	   *
	   * ```js
	   * onTabChange(newTabIndex, event);
	   * ```
	   */
	  onTabChange: _propTypes2.default.func,
	
	  /**
	   * An optional active tab index to use. If this is defined, it will make the component controlled
	   * and require the `onTabChange` prop to be defined.
	   */
	  activeTabIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onTabChange', 'defaultTabIndex'),
	
	  /**
	   * The default tab index to use when the component is uncontrolled.
	   */
	  defaultTabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * When the `overflowMenu` prop is false, this will be used to render the "next slice of tabs"
	   * when there are too many tabs to display at once on desktop screens.
	   */
	  nextIcon: _propTypes2.default.element,
	
	  /**
	   * When the `overflowMenu` prop is false, this will be used to render the "previous slice of tabs"
	   * when there are too many tabs to display at once on desktop screens.
	   */
	  previousIcon: _propTypes2.default.element,
	
	  /**
	   * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
	   * This will be to render the icon to the right of the label.
	   */
	  overflowMenuIcon: _propTypes2.default.element,
	
	  /**
	   * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
	   * This will be the text that displays as a tab.
	   */
	  overflowMenuLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the tabs are currently rendered on a mobile or tablet device. This is used to calculate
	   * overflow/padding on the tabs.
	   */
	  mobile: _propTypes2.default.bool,
	  defaultMedia: (0, _deprecated2.default)(_propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']), 'Use `mobile` instead'),
	  desktopMinWidth: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `mobile` instead.'),
	  nextIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `nextIcon` prop instead'),
	  nextIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `nextIcon` prop instead'),
	  previousIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `previousIcon` prop instead'),
	  previousIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `previousIcon` prop instead'),
	  overflowMenuIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `overflowMenuIcon` prop instead'),
	  overflowMenuIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `overflowMenuIcon` prop instead')
	};
	Tabs.defaultProps = {
	  component: 'ul',
	  defaultTabIndex: 0,
	  nextIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_right'
	  ),
	  previousIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_left'
	  ),
	  overflowMenuLabel: 'More',
	  overflowMenuIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_drop_down'
	  )
	};
	exports.default = Tabs;
	//# sourceMappingURL=Tabs.js.map

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSwipeableViews = __webpack_require__(390);
	
	var _reactSwipeableViews2 = _interopRequireDefault(_reactSwipeableViews);
	
	var _getField = __webpack_require__(5);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(10);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _between = __webpack_require__(55);
	
	var _between2 = _interopRequireDefault(_between);
	
	var _ResizeObserver = __webpack_require__(28);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _Paper = __webpack_require__(29);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _TabPanel = __webpack_require__(158);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TabsContainer` component is used when you want to have your `Tabs` connected with
	 * the `SwipeableViews`. This component will traverse the children subtree and extract out
	 * the `children` from each tab, and render them in a swipeable container. However,
	 * since this is using the `React.Children` traversal, You will have to keep the `Tabs`
	 * and `Tab` component as a direct descendent. You are unable to make a separate component
	 * that encompasses the `Tab` component.
	 *
	 * ```js
	 * // valid
	 * <TabsContainer>
	 *   <Tabs>
	 *     <Tab />
	 *   </Tabs>
	 * </TabsContainer>
	 *
	 * // invalid
	 * <TabsContainer>
	 *   <Tabs>
	 *     <MyCustomTab />
	 *   </Tabs>
	 * </TabsContainer>
	 * ```
	 *
	 * This is because it seems you are unable to access the `MyCustomTab`'s child Tab props correctly.
	 * You can however have the tab's children as a separate component if you wish.
	 */
	var TabsContainer = function (_PureComponent) {
	  _inherits(TabsContainer, _PureComponent);
	
	  function TabsContainer(props) {
	    _classCallCheck(this, TabsContainer);
	
	    var _this = _possibleConstructorReturn(this, (TabsContainer.__proto__ || Object.getPrototypeOf(TabsContainer)).call(this, props));
	
	    _this._handleTabChange = function (index, tabId, tabControlsId, tabChildren, event) {
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(index, tabId, tabControlsId, tabChildren, event);
	      }
	
	      if (typeof _this.props.activeTabIndex === 'undefined') {
	        _this.setState({ activeTabIndex: index });
	      }
	    };
	
	    _this._handleSwipeChange = function (activeTabIndex) {
	      _this._handleTabChange(activeTabIndex);
	    };
	
	    _this._setContainer = function (container) {
	      _this._container = (0, _reactDom.findDOMNode)(container);
	    };
	
	    _this._resizePanel = function () {
	      if (!_this._container) {
	        return;
	      }
	
	      var activePanel = _this._container.querySelector('.md-tab-panel[aria-hidden=false]');
	      if (activePanel && _this.state.panelHeight !== activePanel.offsetHeight) {
	        _this.setState({ panelHeight: activePanel.offsetHeight });
	      }
	    };
	
	    _this.state = {};
	    if (typeof props.activeTabIndex === 'undefined') {
	      _this.state.activeTabIndex = props.defaultTabIndex;
	    }
	    return _this;
	  }
	
	  _createClass(TabsContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._resizePanel();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var prevIndex = (0, _getField2.default)(prevProps, prevState, 'activeTabIndex');
	      var currIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	      if (prevIndex !== currIndex) {
	        this._resizePanel();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var panelHeight = this.state.panelHeight;
	
	      var _props = this.props,
	          Component = _props.component,
	          style = _props.style,
	          className = _props.className,
	          panelStyle = _props.panelStyle,
	          panelClassName = _props.panelClassName,
	          panelComponent = _props.panelComponent,
	          headerStyle = _props.headerStyle,
	          headerClassName = _props.headerClassName,
	          slideStyle = _props.slideStyle,
	          slideHeightProp = _props.slideHeightProp,
	          swipeableViewsStyle = _props.swipeableViewsStyle,
	          swipeableViewsClassName = _props.swipeableViewsClassName,
	          headerComponent = _props.headerComponent,
	          headerZDepth = _props.headerZDepth,
	          children = _props.children,
	          colored = _props.colored,
	          fixed = _props.fixed,
	          labelAndIcon = _props.labelAndIcon,
	          swipeableViewsProps = _props.swipeableViewsProps,
	          themed = _props.themed,
	          propToolbar = _props.toolbar,
	          propActiveTabeIndex = _props.activeTabIndex,
	          onTabChange = _props.onTabChange,
	          defaultTabIndex = _props.defaultTabIndex,
	          props = _objectWithoutProperties(_props, ['component', 'style', 'className', 'panelStyle', 'panelClassName', 'panelComponent', 'headerStyle', 'headerClassName', 'slideStyle', 'slideHeightProp', 'swipeableViewsStyle', 'swipeableViewsClassName', 'headerComponent', 'headerZDepth', 'children', 'colored', 'fixed', 'labelAndIcon', 'swipeableViewsProps', 'themed', 'toolbar', 'activeTabIndex', 'onTabChange', 'defaultTabIndex']);
	
	      var toolbar = this.props.toolbar;
	
	
	      var activeTabIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	      var tabsEl = _react.Children.only(children);
	      var tabId = tabsEl.props.tabId;
	      var content = _react.Children.map(tabsEl.props.children, function (tab, index) {
	        if (!tab) {
	          return tab;
	        }
	
	        return _react2.default.createElement(
	          _TabPanel2.default,
	          {
	            id: tab.props.controlsId || tabId + '-panel-' + index,
	            active: activeTabIndex === index,
	            style: panelStyle,
	            className: panelClassName,
	            component: panelComponent,
	            controlledById: tab.props.id || tabId + '-' + index
	          },
	          _react2.default.createElement(_ResizeObserver2.default, { watchHeight: true, onResize: _this2._resizePanel }),
	          tab.props.children
	        );
	      });
	
	      var childrenProps = _react.Children.only(children).props;
	      var tabs = (0, _react.cloneElement)(children, {
	        colored: typeof childrenProps.colored !== 'undefined' ? childrenProps.colored : colored,
	        onTabChange: this._handleTabChange,
	        activeTabIndex: activeTabIndex
	      });
	
	      var prominentToolbar = false;
	      if (toolbar) {
	        var toolbarProps = _react.Children.only(toolbar).props;
	        toolbar = (0, _react.cloneElement)(toolbar, {
	          component: toolbarProps.component || 'div',
	          colored: typeof toolbarProps.colored !== 'undefined' ? childrenProps.colored : colored
	        });
	
	        prominentToolbar = toolbarProps.prominent || toolbarProps.prominentTitle;
	      }
	
	      var header = void 0;
	      if (fixed) {
	        header = _react2.default.createElement(
	          _Paper2.default,
	          {
	            style: headerStyle,
	            className: (0, _classnames2.default)('md-tabs-fixed-container', {
	              'md-toolbar--themed': themed
	            }, headerClassName),
	            zDepth: headerZDepth,
	            component: headerComponent
	          },
	          toolbar,
	          tabs
	        );
	      }
	
	      var baseSlideStyle = _defineProperty({}, slideHeightProp, panelHeight);
	
	      return _react2.default.createElement(
	        Component,
	        _extends({
	          style: style,
	          className: (0, _classnames2.default)('md-tabs-container', className)
	        }, props, {
	          ref: this._setContainer
	        }),
	        header,
	        header ? null : toolbar,
	        header ? null : tabs,
	        _react2.default.createElement(
	          _reactSwipeableViews2.default,
	          _extends({}, swipeableViewsProps, {
	            style: swipeableViewsStyle,
	            className: (0, _classnames2.default)('md-tabs-content', {
	              'md-tabs-content--offset': !toolbar && !labelAndIcon && fixed,
	              'md-tabs-content--offset-icon': !toolbar && fixed && labelAndIcon,
	              'md-tabs-content--offset-toolbar': toolbar && fixed && !prominentToolbar && !labelAndIcon,
	              'md-tabs-content--offset-toolbar-prominent': toolbar && fixed && prominentToolbar && !labelAndIcon,
	              'md-tabs-content--offset-toolbar-icon': fixed && toolbar && labelAndIcon && !prominentToolbar,
	              'md-tabs-content--offset-toolbar-prominent-icon': fixed && toolbar && labelAndIcon && prominentToolbar
	            }, swipeableViewsClassName),
	            slideStyle: _extends({}, baseSlideStyle, typeof slideStyle === 'function' ? slideStyle(baseSlideStyle, panelHeight) : slideStyle),
	            index: activeTabIndex,
	            onChangeIndex: this._handleSwipeChange
	          }),
	          content
	        )
	      );
	    }
	  }]);
	
	  return TabsContainer;
	}(_react.PureComponent);
	
	TabsContainer.propTypes = {
	  /**
	   * An optional style to apply to the container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to each `TabPanel` that gets generated. Each tab's children
	   * will get wrapped in a `TabPanel` component.
	   */
	  panelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to each each `TabPanel` that gets generated. Each tab's
	   * children will get wrapped in a `TabPanel` component.
	   */
	  panelClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the header component when the tabs are fixed to the top of the page.
	   * The optional toolbar and tabs get wrapped in a `Paper` component.
	   */
	  headerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the header component when the tabs are fixed to the top of the page.
	   * The optional toolbar and tabs get wrapped in a `Paper` component.
	   */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `SwipeableViews`.
	   *
	   * @see https://github.com/oliviertassinari/react-swipeable-views#user-content-swipeableviews-
	   */
	  swipeableViewsStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `SwipeableViews` container.
	   */
	  swipeableViewsClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to each slide component or a function that returns such style.
	   *
	   * Default style and height of slide component will be passed in the function.
	   * The function should return a style that will be merged with default style, or `null`.
	   *
	   * @see https://github.com/oliviertassinari/react-swipeable-views#user-content-swipeableviews-
	   */
	  slideStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	
	  /**
	   * The property that should be used to set height of a slide component.
	   */
	  slideHeightProp: _propTypes2.default.oneOf(['height', 'minHeight', 'maxHeight']),
	
	  /**
	   * This should be a `Tabs` component with children of `Tab`. This is used to figure out which
	   * tab's content is currently visible.
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * The component to render the container as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The component to render each `TabPanel` as.
	   */
	  panelComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	  /**
	   * An optional toolbar to render above the tabs.
	   */
	  toolbar: _propTypes2.default.element,
	
	  /**
	   * An optional active tab index to use. If this is defined, the component will be controlled
	   * and require the `onTabChange` prop to be defined.
	   */
	  activeTabIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onTabChange', 'defaultTabIndex'),
	
	  /**
	   * An optional function to call when a new tab is selected by swiping or clicking a tab. When
	   * a new tab has been clicked, the callback will include the active tab index, the tab's `id`,
	   * the tab's `controlsId`, the tab's `children`, and the click event.
	   *
	   * If the tab was changed by swiping, it will only contain the new active tab index.
	   *
	   * ```js
	   * onTabChange(newActiveTabIndex, tabId, tabControlsId, tabChildren, event);
	   * ```
	   */
	  onTabChange: _propTypes2.default.func,
	
	  /**
	   * The default tab index to use when the component is uncontrolled.
	   */
	  defaultTabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `toolbar` and `Tabs` should be cloned with `colored: true`.
	   */
	  colored: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `toolbar` should be applied with the theme color. This _really_ only
	   * applies when you create a `fixed` tabs container.
	   */
	  themed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the tabs and the optional toolbar should be fixed to the top of the page.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * A boolean if a `fixed` `TabsContainer` has tabs with a label and an icon.
	   */
	  labelAndIcon: _propTypes2.default.bool,
	
	  /**
	   * An optional component to render the fixed tabs header as.
	   */
	  headerComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	  /**
	   * The zDepth for the fixed tabs header.
	   */
	  headerZDepth: (0, _between2.default)(_propTypes2.default.number, 0, 5),
	
	  /**
	   * Any additional props to apply to the SwipeableViews component. View the
	   * [SwipeableViews API](https://github.com/oliviertassinari/react-swipeable-views#api)
	   * for valid attributes.
	   *
	   * You will not be able to set the `style`, `className`, `slideStyle`, `index`,
	   * or `onChangeIndex` props for the SwipeableViews.
	   *
	   * The styling and classnames can be updated with the other TabsContainer props.
	   */
	  swipeableViewsProps: _propTypes2.default.object
	};
	TabsContainer.defaultProps = {
	  component: 'section',
	  defaultTabIndex: 0,
	  headerZDepth: 1,
	  slideHeightProp: 'height'
	};
	exports.default = TabsContainer;
	//# sourceMappingURL=TabsContainer.js.map

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabPanel = exports.MenuTab = exports.Tab = exports.Tabs = exports.TabsContainer = undefined;
	
	var _TabsContainer2 = __webpack_require__(339);
	
	var _TabsContainer3 = _interopRequireDefault(_TabsContainer2);
	
	var _Tabs2 = __webpack_require__(338);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(335);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _MenuTab2 = __webpack_require__(157);
	
	var _MenuTab3 = _interopRequireDefault(_MenuTab2);
	
	var _TabPanel2 = __webpack_require__(158);
	
	var _TabPanel3 = _interopRequireDefault(_TabPanel2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TabsContainer3.default;
	exports.TabsContainer = _TabsContainer3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.MenuTab = _MenuTab3.default;
	exports.TabPanel = _TabPanel3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _TextArea = __webpack_require__(344);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component either renders a base `input` tag or the `TextArea` component.
	 */
	var InputField = function (_PureComponent) {
	  _inherits(InputField, _PureComponent);
	
	  function InputField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InputField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputField.__proto__ || Object.getPrototypeOf(InputField)).call.apply(_ref, [this].concat(args))), _this), _this.getField = function () {
	      // eslint-disable-line arrow-body-style
	      return typeof _this.props.rows === 'undefined' ? _this._field : _this._field.getField();
	    }, _this.getValue = function () {
	      if (typeof _this.props.rows === 'undefined') {
	        return _this._field.value;
	      }
	
	      return _this._field.getValue();
	    }, _this.focus = function () {
	      _this._field.focus();
	    }, _this.blur = function () {
	      _this._field.blur();
	    }, _this._setField = function (field) {
	      _this._field = field;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InputField, [{
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          className = _props.className,
	          rows = _props.rows,
	          label = _props.label,
	          customSize = _props.customSize,
	          fullWidth = _props.fullWidth,
	          type = _props.type,
	          passwordVisible = _props.passwordVisible,
	          block = _props.block,
	          inlineIndicator = _props.inlineIndicator,
	          maxRows = _props.maxRows,
	          props = _objectWithoutProperties(_props, ['className', 'rows', 'label', 'customSize', 'fullWidth', 'type', 'passwordVisible', 'block', 'inlineIndicator', 'maxRows']);
	
	      var multiline = typeof rows !== 'undefined';
	      var Component = multiline ? _TextArea2.default : 'input';
	      if (!multiline) {
	        props.type = passwordVisible ? 'text' : type;
	      } else {
	        props.label = label;
	        props.block = block;
	        props.maxRows = maxRows;
	      }
	
	      return (0, _react.createElement)(Component, _extends({}, props, {
	        rows: rows,
	        ref: this._setField,
	        className: (0, _classnames2.default)('md-text-field', (_cn = {
	          'md-text-field--inline-indicator': inlineIndicator || !multiline && type === 'password',
	          'md-text-field--multiline': multiline,
	          'md-text-field--margin': !block && !multiline && !label,
	          'md-text-field--floating-margin': !block && !multiline && label
	        }, _defineProperty(_cn, 'md-text-field--' + customSize, customSize), _defineProperty(_cn, 'md-full-width', fullWidth), _cn), (0, _themeColors2.default)({ disabled: props.disabled, text: !props.disabled }, className))
	      }));
	    }
	  }]);
	
	  return InputField;
	}(_react.PureComponent);
	
	InputField.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  block: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  rows: _propTypes2.default.number,
	  maxRows: _propTypes2.default.number,
	  label: _propTypes2.default.node,
	  fullWidth: _propTypes2.default.bool,
	  customSize: _propTypes2.default.string,
	  passwordVisible: _propTypes2.default.bool,
	  inlineIndicator: _propTypes2.default.bool
	};
	exports.default = InputField;
	//# sourceMappingURL=InputField.js.map

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Message = function (_PureComponent) {
	  _inherits(Message, _PureComponent);
	
	  function Message() {
	    _classCallCheck(this, Message);
	
	    return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
	  }
	
	  _createClass(Message, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className;
	
	
	      if (!children) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          'aria-hidden': !active,
	          className: (0, _classnames2.default)('md-text-field-message', 'md-text-field-message--' + (active ? '' : 'in') + 'active', className)
	        },
	        children
	      );
	    }
	  }]);
	
	  return Message;
	}(_react.PureComponent);
	
	Message.propTypes = {
	  active: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	exports.default = Message;
	//# sourceMappingURL=Message.js.map

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(9);
	
	var _themeColors = __webpack_require__(7);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PasswordButton = function (_PureComponent) {
	  _inherits(PasswordButton, _PureComponent);
	
	  function PasswordButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PasswordButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordButton.__proto__ || Object.getPrototypeOf(PasswordButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = { keyboardFocus: false }, _this._handleOutsideClick = function (e) {
	      if (_this._button && !_this._button.contains(e.target)) {
	        window.removeEventListener('click', _this._handleOutsideClick);
	        _this.setState({ keyboardFocus: false });
	      }
	    }, _this._handleBlur = function () {
	      if (_this.state.keyboardFocus) {
	        _this.setState({ keyboardFocus: false });
	      }
	    }, _this._handleKeyUp = function (e) {
	      var key = e.which || e.keyCode;
	      if (key === _keyCodes.TAB) {
	        _this.setState({ keyboardFocus: true });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PasswordButton, [{
	    key: 'render',
	    value: function render() {
	      var keyboardFocus = this.state.keyboardFocus;
	
	      var _props = this.props,
	          active = _props.active,
	          passwordVisible = _props.passwordVisible,
	          block = _props.block,
	          floating = _props.floating,
	          icon = _props.icon,
	          props = _objectWithoutProperties(_props, ['active', 'passwordVisible', 'block', 'floating', 'icon']);
	
	      return _react2.default.createElement(
	        'button',
	        _extends({}, props, {
	          onBlur: this._handleBlur,
	          onKeyUp: this._handleKeyUp,
	          type: 'button',
	          className: (0, _classnames2.default)('md-text-field-inline-indicator md-password-btn md-pointer--hover', {
	            'md-password-btn--focus': keyboardFocus,
	            'md-password-btn--invisible': active && !passwordVisible,
	            'md-text-field-inline-indicator--floating': floating,
	            'md-text-field-inline-indicator--block': block
	          }, (0, _themeColors2.default)({ disabled: !active, hint: active }))
	        }),
	        icon
	      );
	    }
	  }]);
	
	  return PasswordButton;
	}(_react.PureComponent);
	
	PasswordButton.propTypes = {
	  active: _propTypes2.default.bool,
	  passwordVisible: _propTypes2.default.bool,
	  icon: _propTypes2.default.element,
	  block: _propTypes2.default.bool,
	  floating: _propTypes2.default.bool
	};
	exports.default = PasswordButton;
	//# sourceMappingURL=PasswordButton.js.map

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ResizeObserver = __webpack_require__(28);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TextArea` component is used to allow a dynamic height for the
	 * `textarea`. The height will keep on changing until the maxRows prop
	 * is met or infinitely if it does not exist, or is 0.
	 */
	var TextArea = function (_PureComponent) {
	  _inherits(TextArea, _PureComponent);
	
	  function TextArea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TextArea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.state = { height: null }, _this.getField = function () {
	      return _this._field;
	    }, _this.getValue = function () {
	      return _this._field.value;
	    }, _this.focus = function () {
	      _this._field.focus();
	    }, _this.blur = function () {
	      _this._field.blur();
	    }, _this._calcRowHeight = function () {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props,
	          rows = _ref2.rows;
	
	      if (!_this._field) {
	        return 19;
	      }
	
	      var height = _this._field.style.height;
	      _this._field.style.height = 'auto';
	      var rowHeight = _this._field.offsetHeight / rows;
	      _this._field.style.height = height;
	      return rowHeight;
	    }, _this._setMask = function (mask) {
	      _this._mask = mask;
	    }, _this._setField = function (field) {
	      _this._field = field;
	    }, _this._handleResize = function () {
	      _this._rowHeight = _this._calcRowHeight();
	      _this._syncHeightWithMask();
	    }, _this._syncHeightWithMask = function (value) {
	      // The mask is always null in snapshot teseting
	      if (!_this._mask) {
	        return;
	      }
	
	      if (value !== undefined) {
	        _this._mask.value = value;
	      }
	
	      var height = _this._mask.scrollHeight;
	      if (height === undefined) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          rows = _this$props.rows,
	          maxRows = _this$props.maxRows;
	
	      if (maxRows && maxRows > 0) {
	        height = Math.min(height, _this._rowHeight * maxRows);
	      }
	
	      height = Math.max(_this._rowHeight * rows, height);
	      _this.setState({ height: height });
	    }, _this._handleChange = function (e) {
	      _this._syncHeightWithMask(e.target.value, e);
	
	      if (_this.props.onChange) {
	        _this.props.onChange(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TextArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._rowHeight = this._calcRowHeight();
	      this._syncHeightWithMask();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.rows !== nextProps.rows) {
	        this._rowHeight = this._calcRowHeight(nextProps);
	      }
	
	      if (this.props.value !== nextProps.value || this.props.maxRows !== nextProps.maxRows) {
	        this._syncHeightWithMask(nextProps.value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var height = this.state.height;
	
	      var _props = this.props,
	          style = _props.style,
	          defaultValue = _props.defaultValue,
	          value = _props.value,
	          className = _props.className,
	          label = _props.label,
	          block = _props.block,
	          maxRows = _props.maxRows,
	          onChange = _props.onChange,
	          props = _objectWithoutProperties(_props, ['style', 'defaultValue', 'value', 'className', 'label', 'block', 'maxRows', 'onChange']);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: { height: height && height + 5 },
	          className: (0, _classnames2.default)('md-text-field-multiline-container', {
	            'md-text-field--margin': !label && !block,
	            'md-text-field--floating-margin': label && !block
	          })
	        },
	        _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, onResize: this._handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: this._setMask,
	          className: (0, _classnames2.default)(className, 'md-text-field--multiline-mask'),
	          readOnly: true,
	          rows: props.rows,
	          tabIndex: -1,
	          style: style,
	          defaultValue: defaultValue,
	          'aria-hidden': true,
	          value: value
	        }),
	        _react2.default.createElement('textarea', _extends({}, props, {
	          ref: this._setField,
	          style: Object.assign({}, style, { height: height }),
	          className: className,
	          defaultValue: defaultValue,
	          value: value,
	          onChange: this._handleChange
	        }))
	      );
	    }
	  }]);
	
	  return TextArea;
	}(_react.PureComponent);
	
	TextArea.propTypes = {
	  id: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  rows: _propTypes2.default.number.isRequired,
	  maxRows: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  defaultValue: _propTypes2.default.string,
	  floatingLabel: _propTypes2.default.bool,
	  value: _propTypes2.default.string,
	  block: _propTypes2.default.bool,
	  label: _propTypes2.default.node
	};
	exports.default = TextArea;
	//# sourceMappingURL=TextArea.js.map

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextField = undefined;
	
	var _TextField2 = __webpack_require__(48);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField3.default;
	exports.TextField = _TextField3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolbarTitle = function (_PureComponent) {
	  _inherits(ToolbarTitle, _PureComponent);
	
	  function ToolbarTitle() {
	    _classCallCheck(this, ToolbarTitle);
	
	    return _possibleConstructorReturn(this, (ToolbarTitle.__proto__ || Object.getPrototypeOf(ToolbarTitle)).apply(this, arguments));
	  }
	
	  _createClass(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          className = _props.className,
	          prominent = _props.prominent,
	          offset = _props.offset,
	          props = _objectWithoutProperties(_props, ['title', 'className', 'prominent', 'offset']);
	
	      if (!title) {
	        return null;
	      }
	
	      var fullClassName = (0, _classnames2.default)('md-title md-title--toolbar', {
	        'md-title--toolbar-prominent': prominent,
	        'md-title--toolbar-offset': offset
	      }, className);
	
	      if ((0, _react.isValidElement)(title)) {
	        var titleEl = _react.Children.only(title);
	        return (0, _react.cloneElement)(title, _extends({}, props, {
	          id: titleEl.props.id || props.id,
	          className: (0, _classnames2.default)(fullClassName, titleEl.props.className)
	        }));
	      }
	
	      return _react2.default.createElement(
	        'h2',
	        _extends({}, props, {
	          className: fullClassName
	        }),
	        title
	      );
	    }
	  }]);
	
	  return ToolbarTitle;
	}(_react.PureComponent);
	
	ToolbarTitle.propTypes = {
	  className: _propTypes2.default.string,
	  prominent: _propTypes2.default.bool,
	  offset: _propTypes2.default.bool,
	  title: _propTypes2.default.node
	};
	exports.default = ToolbarTitle;
	//# sourceMappingURL=ToolbarTitle.js.map

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Toolbar = undefined;
	
	var _Toolbar2 = __webpack_require__(162);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toolbar3.default;
	exports.Toolbar = _Toolbar3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroupTick = __webpack_require__(30);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tooltip = function (_PureComponent) {
	  _inherits(Tooltip, _PureComponent);
	
	  function Tooltip(props) {
	    _classCallCheck(this, Tooltip);
	
	    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	    _this.state = {
	      entering: false,
	      leaving: false,
	      active: false,
	      visible: false
	    };
	
	    _this._timeout = null;
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(cb) {
	      var _this2 = this;
	
	      this._timeout = setTimeout(function () {
	        _this2._timeout = setTimeout(function () {
	          _this2._timeout = null;
	
	          cb();
	        }, _this2.props.enterTimeout);
	        _this2.setState({ active: true });
	      }, _CSSTransitionGroupTick2.default);
	
	      this.setState({ entering: true });
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setState({ entering: false, active: false, visible: true });
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(cb) {
	      var _this3 = this;
	
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      this._timeout = setTimeout(function () {
	        _this3._timeout = setTimeout(function () {
	          _this3._timeout = null;
	
	          cb();
	        }, _this3.props.leaveTimeout);
	
	        _this3.setState({ active: true, visible: false });
	      }, _CSSTransitionGroupTick2.default);
	
	      this.setState({ leaving: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          active = _state.active,
	          entering = _state.entering,
	          leaving = _state.leaving,
	          visible = _state.visible;
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          children = _props.children,
	          position = _props.position;
	
	
	      var direction = position === 'top' || position === 'bottom' ? 'horizontal' : 'vertical';
	      return _react2.default.createElement(
	        'span',
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-tooltip md-tooltip--' + position + ' md-tooltip--' + direction, _defineProperty({
	            'md-tooltip--active': active,
	            'md-tooltip--enter': entering,
	            'md-tooltip--enter-active': entering && active,
	            'md-tooltip--leave': leaving,
	            'md-tooltip--leave-active': leaving && active
	          }, 'md-tooltip--' + position + '-active', visible || entering && active), className)
	        },
	        children
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.PureComponent);
	
	Tooltip.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  position: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  children: _propTypes2.default.node.isRequired,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	Tooltip.defaultProps = {
	  position: 'bottom',
	  enterTimeout: 150,
	  leaveTimeout: 150
	};
	exports.default = Tooltip;
	//# sourceMappingURL=Tooltip.js.map

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Tooltipped;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TooltipContainer = __webpack_require__(163);
	
	var _TooltipContainer2 = _interopRequireDefault(_TooltipContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Adds a tooltip for a component/element given as the only child.
	 *
	 * The component should render its children, or the tooltip will not be shown.
	 * Also the component should be positioned by `className` or `style`
	 * (CSS property `position` should have value `relative`, `absolute` or `fixed`),
	 * or the tooltip can appear incorrectly.
	 * Use `setPosition={true}` to automatically add `position: 'relative'` to the `style` of the wrapped component.
	 *
	 * Besides of `children` and `setPosition` all props set for `Tooltipped` component are passed through
	 * to `TooltipContainer` that is added as a child of the wrapped component and controls the tooltip.
	 *
	 * ```js
	 * <Tooltipped
	 *   label="Tooltip for text"
	 *   position="left"
	 *   delay={1000}
	 * >
	 *   <span style={{position: 'absolute', top: '10px', left: '70%'}}>
	 *     Some text
	 *     <div>Another line of text</div>
	 *   </span>
	 * </Tooltipped>
	 * ```
	 *
	 * ```js
	 * <Tooltipped
	 *   setPosition={true}
	 *   label="Avatar's tooltip"
	 *   position="top"
	 * >
	 *   <span style={{marginLeft: '30px'}}>
	 *       <Avatar random>T</Avatar>
	 *   </span>
	 * </Tooltipped>
	 * ```
	 */
	function Tooltipped(_ref) {
	  var children = _ref.children,
	      setPosition = _ref.setPosition,
	      props = _objectWithoutProperties(_ref, ['children', 'setPosition']);
	
	  var target = _react2.default.Children.only(children);
	  var targetProps = target.props;
	
	  if (props.label) {
	    var clonedProps = targetProps;
	    if (setPosition) {
	      clonedProps = _extends({}, clonedProps, {
	        style: _extends({}, clonedProps.style, { position: 'relative' })
	      });
	    }
	
	    target = _react2.default.cloneElement(target, clonedProps, [targetProps.children, _react2.default.createElement(_TooltipContainer2.default, _extends({ key: 'tooltipContainer' }, props))]);
	  }
	
	  return target;
	}
	
	Tooltipped.displayName = 'Tooltipped';
	
	Tooltipped.propTypes = {
	  /**
	   * A component/element the tooltip should be linked to.
	   */
	  children: _propTypes2.default.element.isRequired,
	  /**
	   * Tooltip's content.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Whether `position: relative` should be added to the `style` property of the wrapped component.
	   */
	  setPosition: _propTypes2.default.bool
	};
	//# sourceMappingURL=Tooltipped.js.map

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tooltipped = exports.injectTooltip = undefined;
	
	var _injectTooltip2 = __webpack_require__(72);
	
	var _injectTooltip3 = _interopRequireDefault(_injectTooltip2);
	
	var _Tooltipped2 = __webpack_require__(349);
	
	var _Tooltipped3 = _interopRequireDefault(_Tooltipped2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _injectTooltip3.default;
	exports.injectTooltip = _injectTooltip3.default;
	exports.Tooltipped = _Tooltipped3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '1.2.11';
	//# sourceMappingURL=Version.js.map

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MOBILE_MIN_WIDTH = exports.MOBILE_MIN_WIDTH = 320;
	var TABLET_MIN_WIDTH = exports.TABLET_MIN_WIDTH = 768;
	var DESKTOP_MIN_WIDTH = exports.DESKTOP_MIN_WIDTH = 1025;
	//# sourceMappingURL=media.js.map

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	/** @module utils/DateUtils/addHours */
	
	/**
	 * Adds hours to a date.
	 *
	 * @param {Date} time the time to increment
	 * @param {number} hours the number of hours to increment by.
	 * @return a new Date with the new hours set.
	 */
	function addHours(time, hours) {
	  var t = new Date(time.getTime());
	  t.setHours(t.getHours() + hours);
	  return t;
	}
	//# sourceMappingURL=addHours.js.map

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @module utils/DateUtils/extractTimeParts */
	
	
	exports.default = extractTimeParts;
	
	var _formatTime = __webpack_require__(165);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	/**
	 * Extracts the hours, minutes, and optional time period from
	 * a date time.
	 *
	 * @param {function} DateTimeFormat the DateTimeFormat function to use.
	 * @param {string|string[]} locales the locales to use.
	 * @param {Date} time the time to extract from.
	 * @return {Object} an object of { hours, minutes, timePeriod }
	 */
	function extractTimeParts(DateTimeFormat, locales, time) {
	  var formatted = (0, _formatTime2.default)(DateTimeFormat, locales, time);
	
	  // IE does not like lookaheads or splitting on [^0-9]
	  // it will include the non-printable characters..
	
	  var _formatted$match = formatted.match(/[0-9]+/g),
	      _formatted$match2 = _slicedToArray(_formatted$match, 2),
	      hours = _formatted$match2[0],
	      minutes = _formatted$match2[1];
	
	  var _formatted$match3 = formatted.match(/[ ,.:A-z]+/g),
	      _formatted$match4 = _toArray(_formatted$match3),
	      separator = _formatted$match4[0],
	      remaining = _formatted$match4.slice(1);
	
	  var timePeriod = void 0;
	  if (remaining && remaining.length) {
	    timePeriod = remaining.join('').trim();
	  }
	
	  return {
	    hours: hours,
	    minutes: separator + minutes,
	    timePeriod: timePeriod
	  };
	}
	//# sourceMappingURL=extractTimeParts.js.map

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getLastDay;
	/** @module utils/DateUtils/getLastDay */
	
	/**
	 * Gets the last day in a month
	 *
	 * @param {Date} sourceDate the date to get the last day from.
	 * @return a new Date as the last day of the month.
	 */
	function getLastDay(sourceDate) {
	  return new Date(sourceDate.getFullYear(), sourceDate.getMonth() + 1, 0);
	}
	//# sourceMappingURL=getLastDay.js.map

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDateEqual;
	/** @module utils/DateUtils/isDateEqual */
	
	/**
	 * Checks if two dates are equal by comparing the exact time.
	 * This allows null or undefined.
	 *
	 * @param {Date} d1 - The first date to compare.
	 * @param {Date} d2 - The second date to compare.
	 * @return {bool} - true if the dates are equal.
	 */
	function isDateEqual(d1, d2) {
	  if (!d1 && !d2) {
	    return true;
	  } else if (!d1 && d2 || d1 && !d2) {
	    return false;
	  }
	
	  return d1.getTime() === d2.getTime();
	}
	//# sourceMappingURL=isDateEqual.js.map

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMonthBefore;
	
	var _stripTime = __webpack_require__(167);
	
	var _stripTime2 = _interopRequireDefault(_stripTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Checks if a date is the month before another date without time
	 *
	 * @param {Date} date the date to check if it is before the other
	 * @param {Date} toCompare the date to compare to
	 * @return true if the date is before the other date's first day of month.
	 */
	function isMonthBefore(date, toCompare) {
	  if (!date || !toCompare) {
	    return false;
	  }
	
	  var d1 = (0, _stripTime2.default)(new Date(date.getFullYear(), date.getMonth(), 1));
	  var d2 = (0, _stripTime2.default)(new Date(toCompare.getFullYear(), toCompare.getMonth() - 1, 1));
	  return d1 > d2;
	} /** @module utils/DateUtils/isMonthBefore */
	//# sourceMappingURL=isMonthBefore.js.map

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidFocusKeypress;
	
	var _keyCodes = __webpack_require__(9);
	
	/**
	 * Checks if a keydown or keyup event's key was the TAB key or any additional valid
	 * keys that were passed in.
	 *
	 * @param {Object} event - The event to check.
	 * @param {Array.<number>=} additionalKeys - An optional array of additional key codes
	 *    that are considered valid for a focus event.
	 */
	function isValidFocusKeypress(event, additionalKeys) {
	  var key = event.which || event.keyCode;
	  return key === _keyCodes.TAB || additionalKeys && additionalKeys.indexOf(key) !== -1;
	} /** @module utils/EventUtils/isValidFocusKeypress */
	//# sourceMappingURL=isValidFocusKeypress.js.map

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calcTimeFromPoint;
	/** @module utils/NumberUtils/calcTimeFromPoint */
	
	function isPointInCircle(cx, cy, r, x, y) {
	  var distance = Math.pow(cx - x, 2) + Math.pow(cy - y, 2);
	  return distance <= Math.pow(r, 2);
	}
	
	function toDegrees(radians) {
	  return radians * (180 / Math.PI);
	}
	
	/**
	 * Takes a point from a mouse or touch event and a center point of a circle to determine
	 * what the new time should be.
	 *
	 * If the point.y < center.y, the point is in the top half of the circle.
	 * If the point.x < center.x, the point is in the left half of the circle.
	 *
	 * @param {Object} point - The mouse or touch event's point that contains an x and y coordinate.
	 * @param {Object} center - The center point for the circle that contains an x and y coordinate.
	 * @param {Number} innerRadius - An inner radius for clocks that have 24 hour times. This is
	 *    a circle that contains hours 12-23.
	 * @param {Boolean} minutes - Boolena if the current time to be calculated is minutes instead of
	 *    hours.
	 * @param {Boolean} hour12 - Boolean if the clock is a 12 hour clock.
	 * @return {Number} the new time.
	 */
	function calcTimeFromPoint(point, center, innerRadius, minutes, hour12) {
	  var x = point.x - center.x;
	  var y = point.y - center.y;
	  var degrees = toDegrees(Math.atan2(y, x));
	  var sectors = minutes ? 60 : 12;
	  var sectorSize = 360 / sectors;
	  var time = Math.round(degrees / sectorSize);
	
	  // Since the css transform has 0π at π/2 place, we need to offset the
	  // time to that location.
	  time += minutes ? 15 : 3;
	
	  // If time is still negative, it is in the top half of the circle
	  if (time < 0) {
	    time += sectors;
	  }
	
	  // Finally, if it is a 24 hour clock, need to check if the point is actually
	  // selecting hours 13 - 24 (0).
	  if (!minutes && !hour12) {
	    var isInCircle = isPointInCircle(0, 0, innerRadius, x, y);
	
	    if (time === 0 && !isInCircle || time !== 0 && isInCircle) {
	      time += 12;
	    }
	  }
	
	  return time;
	}
	//# sourceMappingURL=calcTimeFromPoint.js.map

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateHypotenuse;
	/** @module utils/NumberUtils/calculateHypotenuse */
	
	/**
	 * Calculates the hypotenuse using the x and y coordinates given.
	 *
	 * @param {number} a the x coordinate
	 * @param {number} b the y coordinate
	 * @return {number} the hypotenuse length for the given x and y coordinates.
	 */
	function calculateHypotenuse(a, b) {
	  return Math.sqrt(a * a + b * b);
	}
	//# sourceMappingURL=calculateHypotenuse.js.map

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateValueDistance;
	/** @module utils/NumberUtils/calculateValueDistance */
	
	/**
	 * This calculates the distance from a screen x location to a position in some element
	 * by comparing the width of the element and the element's page position to the screen
	 * x position.
	 *
	 * If the distance is not _normalized_ the distance will be updated to be a percentage
	 * of the element's total width.
	 *
	 * @param {Number} x - the screen x location.
	 * @param {Number} width - the element's width
	 * @param {Number} left - the element's page x position.
	 * @param {Boolean} normalize - boolean if the distance should be a percentage.
	 *
	 * @return {Number} the distance from the element's left position to the page x
	 *    location.
	 */
	function calculateDistance(x, width, left, normalize) {
	  var distance = Math.min(width, Math.max(0, x - left));
	
	  return normalize ? distance : distance / width * 100;
	}
	
	/**
	 * This calculates the new value and distance for a slider. It will compare the page x
	 * location of a touch or mouse event to the slider's track page x position. If the
	 * final value and distance should be _normalized_, they will be updated to be rounded
	 * with the scale and steps in mind.
	 *
	 * The distance will always be contained within a percentage of 0 - 100 while the
	 * value will be contained within the min and max values.
	 *
	 * @param {Number} x - the page x location of the touch or mouse event.
	 * @param {Number} width - the slider's width
	 * @param {Number} left - the slider's left position in the page.
	 * @param {Number} scale - the total number values included in the slider.
	 * @param {Number} step - the amount to increment by.
	 * @param {Number} min - the min value for the slider.
	 * @param {Number} max - the max value for the slider.
	 * @param {Boolean} normalize - boolean if the vaue and distance should be _normalized_.
	 *
	 * @return {Object} an object with the value and distance.
	 */
	function calculateValueDistance(x, width, left, scale, step, min, max, normalize) {
	  var value = void 0;
	  var distance = calculateDistance(x, width, left, normalize);
	  if (normalize) {
	    value = Math.round(distance / (width / scale));
	    if (step < 1) {
	      var decimals = String(step).split('.')[1];
	      var corrector = typeof decimals !== 'undefined' && decimals.length > 0 ? Math.pow(10, decimals.length) : 1;
	
	      var modded = value * corrector % (step * corrector);
	      if (modded !== 0 && modded >= step / 2) {
	        value += step - modded;
	      } else if (modded !== 0) {
	        value -= modded;
	      }
	    }
	
	    distance = value / scale * 100;
	    value = value * step + min;
	  } else {
	    value = min + step * Math.round(distance / 100 * scale);
	  }
	
	  return {
	    distance: Math.max(0, Math.min(100, distance)),
	    value: Math.max(min, Math.min(max, value))
	  };
	}
	//# sourceMappingURL=calculateValueDistance.js.map

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinStep;
	/** @module utils/NumberUtils/isWithinStep */
	
	/**
	 * Checks if a provided value is within the current step. I don't remember the main
	 * usage for this, but it is for the Slider component.
	 *
	 * @param {number} value - the current value
	 * @param {number} step - the step value
	 * @return {Boolean} true if the vlaue is within the step
	 */
	function isWithinStep(value, step) {
	  var decimals = String(step).split('.')[1];
	  var corrector = typeof decimals !== 'undefined' && decimals.length > 0 ? Math.pow(10, decimals.length) : 1;
	
	  return value * corrector % (step * corrector) === 0;
	}
	//# sourceMappingURL=isWithinStep.js.map

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minMaxLoop;
	/** @module utils/NumberUtils/minMaxLoop */
	
	/**
	 * Keeps a number within the min and max values. When the number becomes less
	 * than the min, it will loop around and be the max value. When the number is
	 * greater than the max, it will loop around and be the min value.
	 *
	 * @param {Number} current - the current number
	 * @param {Number} min - the minimum number allowed
	 * @param {Number} max - the maximum number allowed
	 * @param {Boolean} increment - boolean if the value should be incremented or decremented by
	 *    1.
	 * @return {Number} the next number
	 */
	function minMaxLoop(current, min, max) {
	  var increment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  var next = current + (increment ? 1 : -1);
	  if (max < next) {
	    next = min;
	  } else if (next < min) {
	    next = max;
	  }
	
	  return next;
	}
	//# sourceMappingURL=minMaxLoop.js.map

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateUnit;
	/** @module utils/NumberUtils/updateUnit */
	
	/**
	 * Takes in a css unit (px, rem, em, etc) or a number and applies a function to the
	 * number part of the unit.
	 *
	 * If the unit was a number to start with and a `toUnit` is given, the number will
	 * be given the `toUnit`. Otherwise the number will be returned.
	 *
	 * If the unit was a string, the original units will be applied back to the updated
	 * unit's value.
	 *
	 * @param {number|String} unit - the unit to apply a function to.
	 * @param {function} fn - the function to apply to the number.
	 * @param {String=} toUnit - an optional unit to cast the updated unit to.
	 *
	 * @return {String|number} the updated unit.
	 */
	function updateUnit(unit, fn, toUnit) {
	  var updated = fn(parseInt(unit, 10));
	
	  if (typeof unit === 'number') {
	    return toUnit ? '' + updated + toUnit : updated;
	  }
	
	  return '' + updated + unit.replace(/[0-9]/g, '');
	}
	//# sourceMappingURL=updateUnit.js.map

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScroll;
	/** @module utils/Positioning/getScroll */
	
	/**
	 * A utility function to just get an element's scroll x and y
	 * values. This is really just needed because `window` uses
	 * different attributes.
	 *
	 * @param {Object} el - The element to get a scroll value from.
	 * @return {Object} an object containing the scrollX and scrollY of the element.
	 */
	function getScroll(el) {
	  if (typeof el.scrollX !== 'undefined' && typeof el.scrollY !== 'undefined') {
	    return { x: el.scrollX, y: el.scrollY };
	  } else if (typeof el.scrollLeft !== 'undefined' && typeof el.scrollTop !== 'undefined') {
	    return { x: el.scrollLeft, y: el.scrollTop };
	  }
	
	  return { x: 0, y: 0 };
	}
	//# sourceMappingURL=getScroll.js.map

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectedTextPosition;
	
	var _getSelectedText = __webpack_require__(376);
	
	var _getSelectedText2 = _interopRequireDefault(_getSelectedText);
	
	var _getTextWidth = __webpack_require__(99);
	
	var _getTextWidth2 = _interopRequireDefault(_getTextWidth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @module utils/Positoning/getSelectedTextPosition */
	var ZERO_WIDTH_CHARACTER = '\u200B';
	
	/**
	 * A utility function to attempt to get the current highlighted text position.
	 *
	 * When a context menu is opened, this function attempts to find the bounding client rect
	 * for the highlighted text. However, if the text is in the text field, some weird stuff
	 * happens and it is unable to get it correctly.
	 */
	function getSelectedTextPosition(e) {
	  var height = void 0;
	  var target = e.target,
	      clientX = e.clientX,
	      clientY = e.clientY;
	
	  var text = (0, _getSelectedText2.default)();
	  var width = Math.round((0, _getTextWidth2.default)(text, target) || 0);
	  if (!text || target.classList.contains('md-text-field')) {
	    height = parseInt(window.getComputedStyle(target).fontSize, 10);
	    return {
	      width: width,
	      height: height,
	      left: clientX - width,
	      top: clientY
	    };
	  }
	
	  // All browsers I am supporting have window.getSelection, but better safe than sorry
	  if (window.getSelection) {
	    var selection = window.getSelection();
	    if (selection.rangeCount) {
	      var range = selection.getRangeAt(0).cloneRange();
	      var rect = null;
	      if (range.getClientRects) {
	        var rects = range.getClientRects();
	        if (rects.length > 0) {
	          rect = rects[0];
	        }
	      }
	
	      if (!rect) {
	        var span = document.createElement('span');
	        span.appendChild(document.createTextNode(ZERO_WIDTH_CHARACTER));
	        range.insertNode(span);
	        rect = span.getBoundingClientRect();
	
	        var spanParent = span.parentNode;
	        spanParent.removeChild(span);
	        spanParent.normalize();
	      }
	
	      return rect;
	    }
	  }
	
	  return null;
	}
	//# sourceMappingURL=getSelectedTextPosition.js.map

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOutOfBounds;
	
	var _getScreenSize = __webpack_require__(171);
	
	var _getScreenSize2 = _interopRequireDefault(_getScreenSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isOutHorizontally(fixedTo, child, threshold) {
	  var _fixedTo$getBoundingC = fixedTo.getBoundingClientRect(),
	      fixedLeft = _fixedTo$getBoundingC.left,
	      fixedRight = _fixedTo$getBoundingC.right;
	
	  var _child$getBoundingCli = child.getBoundingClientRect(),
	      childLeft = _child$getBoundingCli.left,
	      childRight = _child$getBoundingCli.right;
	
	  var offset = child.offsetWidth * threshold;
	
	  var left = childLeft + offset;
	  var right = childRight - offset;
	
	  var screenEdge = childLeft === 0 || (0, _getScreenSize2.default)('Width') === childRight;
	  return fixedLeft > left || fixedRight < right || screenEdge;
	} /** @module utils/Positioning/isOutOfBounds */
	
	function isOutVertically(fixedTo, child, toggle, threshold) {
	  var _fixedTo$getBoundingC2 = fixedTo.getBoundingClientRect(),
	      fixedTop = _fixedTo$getBoundingC2.top,
	      fixedBottom = _fixedTo$getBoundingC2.bottom;
	
	  var _child$getBoundingCli2 = child.getBoundingClientRect(),
	      childTop = _child$getBoundingCli2.top,
	      childBottom = _child$getBoundingCli2.bottom;
	
	  var offset = toggle.offsetHeight * threshold;
	
	  var screenEdge = childTop === 0 || (0, _getScreenSize2.default)('Height') === childBottom;
	  return fixedTop > childTop + offset || fixedBottom < childTop - offset || screenEdge;
	}
	
	/**
	 * Checks if the fixedTo object for the Layover component is considered
	 * out of bounds relative to the container.
	 *
	 * @param {Object} fixedTo - The Layover's `fixedTo` prop.
	 * @param {Object} child - The Layover's `children` prop as a DOM element.
	 * @param {Object} toggle - The Layover's `toggle` prop as a DOM element.
	 * @param {number} verticalThreshold - The vertical threshold multiplier to apply.
	 * @param {number} horizontalThreshold - The horizontal threshold multiplier to apply.
	 * @return {boolean} true if the Layover's `fixedTo` prop is considered out of bounds.
	 */
	function isOutOfBounds(fixedTo, child, toggle, verticalThreshold, horizontalThreshold) {
	  if (fixedTo === window) {
	    return false;
	  } else if (fixedTo.x || fixedTo.y) {
	    var x = fixedTo.x,
	        y = fixedTo.y;
	
	    return !!y && isOutVertically(y, child, toggle, verticalThreshold) || !!x && isOutHorizontally(x, child, horizontalThreshold);
	  }
	
	  return isOutVertically(fixedTo, child, toggle, verticalThreshold) || isOutHorizontally(fixedTo, child, horizontalThreshold);
	}
	//# sourceMappingURL=isOutOfBounds.js.map

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minNumber;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Validates the a prop's value is greater than or equal to the minimum value.
	 *
	 * @param {Number} min - the minimum value for the prop.
	 * @param {Boolean} required - Boolean if the prop is required.
	 * @return {Error} an error or null.
	 */
	function minNumber(min, required) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    var validator = _propTypes2.default.number;
	    if (required) {
	      validator = validator.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!required && !err && props[propName] < min) {
	      err = new Error('The ' + location + ' `' + propFullNameSafe + '` must be greater than or equal to the min value ' + ('`' + min + '` but received `' + props[propName] + '` for the `' + componentNameSafe + '` component.'));
	    }
	
	    return err;
	  };
	} /** @module utils/PropTypes/minNumber */
	//# sourceMappingURL=minNumber.js.map

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = oneRequiredForA11yIf;
	/** @module utils/PropTypes/oneRequiredForA11yIf */
	
	/**
	 * A PropType validator to make sure that any of the other prop names have been defined
	 * if the current prop is also defined.
	 *
	 * This is mostly useful for when adding a prop requires additional accessibility props defined
	 * as well.
	 *
	 * @param {function} validator - The current prop's validator.
	 */
	function oneRequiredForA11yIf(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var filterUndefined = function filterUndefined(pn) {
	      return typeof props[pn] !== 'undefined';
	    };
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var defined = typeof props[propName] !== 'undefined';
	    var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && defined && !allPropNames.filter(filterUndefined).length) {
	      err = new Error('One of the following props are required to make `' + componentNameSafe + '` accessible ' + ('for users of assistive technologies such as screen readers when using the `' + propFullNameSafe + '` ') + ('prop. `' + allPropNames.join('`, `') + '`.'));
	    }
	
	    return err;
	  };
	}
	//# sourceMappingURL=oneRequiredForA11yIf.js.map

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredForA11yIfNot;
	/** @module utils/PropTypes/requiredForA11yIfNot */
	
	/**
	 * This validator checks that the current prop is valid and defined ONLY if
	 * any of the `otherPropNames` are not true or defined.
	 *
	 * @param {function} validator - The React PropTypes validator to use for the given prop.
	 * @param {String[]} otherPropNames - Any other prop names to validate against.
	 * @return {Error} an error or null
	 */
	function requiredForA11yIfNot(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var defined = typeof props[propName] !== 'undefined';
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && !defined && !otherPropNames.filter(function (pn) {
	      return !!props[pn];
	    }).length) {
	      err = new Error('The `' + propFullNameSafe + '` ' + location + ' is required to make `' + componentNameSafe + '` accessible ' + 'for users of assistive technologies such as screen readers.');
	    }
	
	    return err;
	  };
	}
	//# sourceMappingURL=requiredForA11yIfNot.js.map

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeFirst;
	/** @module utils/StringUtils/capitlizeFirst */
	
	/**
	 * Capitalizes the first letter of a string. If the string is falsish, it will be
	 * returned as is. If the string is only one letter long, it will be capitalized;
	 *
	 * @param {String} str - The string to capitalize.
	 * @return {String} the updated string or false-ish self.
	 */
	function capitalizeFirst(str) {
	  if (!str) {
	    return str;
	  } else if (str.length === 1) {
	    return str.toUpperCase();
	  }
	
	  return "" + str.charAt(0).toUpperCase() + str.substring(1, str.length);
	}
	//# sourceMappingURL=capitalizeFirst.js.map

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/caseInsensitiveFilter */
	
	
	exports.default = caseInsensitiveFilter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This function does a simple ignore case search of some `filterText` for every
	 * item in a `haystack`. It will only include items that are:
	 *  - not null or undefined
	 *  - valid React Components
	 *  - a number or string that contains each letter/number in exact order ignoring case
	 *  - an object's `dataLabel` value that contains each letter/number in exact order ignoring case.
	 *
	 * Example:
	 *
	 * ```js
	 * const haystack = ['Apple', 'Banana', 'Orange'];
	 * caseInsensitiveFilter(haystack, 'An') // ['Banana', 'Orange'];
	 * caseInsensitiveFilter(haystack, 'ae') // []
	 * ```
	 *
	 * @param {Array.<string|number|Object|function>} haystack - the haystack to search
	 * @param {string} filterText - the filter text to use.
	 * @param {string=} dataLabel - the data label to use if the element is an object.
	 *
	 * @return {Array.<string|number|Object|function>} a filtered list.
	 */
	function caseInsensitiveFilter(haystack, filterText, dataLabel) {
	  var needle = filterText.toLowerCase();
	
	  return haystack.filter(function (hay) {
	    if (hay === null || typeof hay === 'undefined') {
	      return false;
	    } else if (_react2.default.isValidElement(hay)) {
	      return true;
	    }
	
	    var value = void 0;
	    switch (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) {
	      case 'string':
	      case 'number':
	        value = hay.toString();
	        break;
	      default:
	        value = hay[dataLabel];
	    }
	
	    return value && value.toLowerCase().indexOf(needle) !== -1;
	  });
	}
	//# sourceMappingURL=caseInsensitiveFilter.js.map

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closest;
	/** @module utils/closest */
	
	/**
	 * A _very_ primitive polyfill for the Element.closest function. If this is a browser that doesn't
	 * support it (IE, Edge, etc), it will just keep searching the parent elements until the nodeName
	 * matches the provided type.
	 *
	 * @param {Element} el - the html element to find a closest node type for
	 * @param {String} type - the html element type to find.
	 * @return {Element} the found element or null.
	 */
	function closest(el, type) {
	  if (typeof el.closest === 'function') {
	    return el.closest(type);
	  }
	
	  var nodeType = type.toUpperCase();
	  var node = el.parentElement;
	  while (node && node.parentElement) {
	    if (node.nodeName === nodeType) {
	      return node;
	    }
	
	    node = node.parentElement;
	  }
	
	  return null;
	}
	//# sourceMappingURL=closest.js.map

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/findIgnoreCase */
	
	
	exports.default = findIgnoreCase;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This function finds the first item in a `haystack` that starts with every
	 * letter of the `value` in order. It will ignore:
	 *  - null or undefined
	 *  - valid React components
	 *
	 * @param {Array.<string|number|Object|function>} haystack - the haystack to search.
	 * @param {string} value - the current value to use.
	 * @param {string=} dataLabel - the object key to use to extract the comparing value.
	 *
	 * @return {string} the found element or the empty string.
	 */
	function findIgnoreCase(haystack, value, dataLabel) {
	  var needle = value ? value.toLowerCase() : '';
	
	  if (!needle) {
	    return needle;
	  }
	
	  var suggestion = '';
	  haystack.some(function (hay) {
	    if (hay === null || typeof hay === 'undefined' || _react2.default.isValidElement(hay)) {
	      return false;
	    }
	
	    var hayStr = (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) === 'object' ? hay[dataLabel] : hay.toString();
	
	    if (hayStr.toLowerCase().indexOf(needle) === 0) {
	      suggestion = hayStr;
	    }
	
	    return suggestion;
	  });
	
	  return suggestion;
	}
	//# sourceMappingURL=findIgnoreCase.js.map

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/fuzzyFilter */
	
	
	exports.default = fuzzyFilter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This function does a simple fuzzy search of some `needle` for every
	 * item in a `haystack`. It will only include items that are:
	 *  - not null or undefined
	 *  - valid React Components
	 *  - a number or string that contains each letter/number in order ignoring case
	 *  - an object's `dataLabel` value that contains each letter/number in order ignoring case.
	 *
	 * Example:
	 * ```js
	 * const haystack = ['Apple', 'Banana', 'Orange'];
	 * fuzzyFilter(haystack, 'An') // ['Banana', 'Orange'];
	 * fuzzyFilter(haystack, 'ae') // ['Apple']
	 * ```
	 *
	 * @param {Array.<string|number|Object|function>} haystack - the haystack to search
	 * @param {string} needle - the filter text to use.
	 * @param {string=} dataLabel - the data label to use if the element is an object.
	 *
	 * @return {Array.<string|number|Object|function>} a filtered list.
	 */
	function fuzzyFilter(haystack, needle, dataLabel) {
	  // Create an amazing regex that matches the letters in order
	  // and escapes any strings that could be part of a regex.
	  var reg = new RegExp(('' + needle).split('').join('\\w*').replace(/(\(|\||\)|\\(?!w\*)|\[|\|-|\.|\^|\+|\$|\?|^(?!w)\*)/g, '\\$1')
	  // Couldn't get the matching of two '*' working, so replace them here..
	  .replace(/\*\*/g, '*\\*'), 'i');
	
	  return haystack.filter(function (hay) {
	    if (hay === null || typeof hay === 'undefined') {
	      return false;
	    } else if (_react2.default.isValidElement(hay)) {
	      return true;
	    }
	
	    var value = void 0;
	    switch (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) {
	      case 'string':
	      case 'number':
	        value = hay.toString();
	        break;
	      default:
	        value = hay[dataLabel];
	    }
	
	    return value && value.match(reg);
	  });
	}
	//# sourceMappingURL=fuzzyFilter.js.map

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectedText;
	/** @module utils/getSelectedText */
	
	/**
	 * A utility function that gets the current selected text in the document. I think
	 * that all the browsers I support have `window.getSelection`, but it falls back to
	 * support others.
	 *
	 * @return {String} the current selection on the page
	 */
	function getSelectedText() {
	  if (typeof window.getSelection !== 'undefined') {
	    return window.getSelection().toString();
	  } else if (typeof document.selection !== 'undefined' && document.selection.type === 'Text') {
	    return document.selection.createRange().text;
	  }
	
	  return '';
	}
	//# sourceMappingURL=getSelectedText.js.map

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toggleScroll;
	
	var _getPagePosition = __webpack_require__(170);
	
	var _getPagePosition2 = _interopRequireDefault(_getPagePosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A utility function for toggling the overflow visibility on an element. This will either target
	 * the given `selector`, or the `body` tag to set a `className`.
	 *
	 * If the `visible` param is `undefined`, the className will be toggled.
	 * If the `visible` param is `true`, the className will be added.
	 * If the `visible` param is `false`, the className will be removed.
	 *
	 *
	 * > This depends on the `classList` attribute on elements.
	 *
	 * @param {bool=} visible - An optional boolean to determine how the `className` will be applied.
	 * @param {string|Object=} selector - An optional query selector string to use to select an element.
	 * @param {string=} className - The className to apply. Defaults to 'md-overflow-hidden'
	 */
	function toggleScroll(scrollable, selector) {
	  var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'md-no-scroll';
	
	  var queryable = !selector || typeof selector === 'string';
	  var el = void 0;
	  if (queryable) {
	    el = selector ? document.querySelector(selector) : document.querySelector('html');
	  } else {
	    el = selector;
	  }
	
	  if (!el) {
	    return;
	  }
	
	  if (typeof scrollable === 'undefined') {
	    scrollable = !el.classList.contains(className);
	  }
	
	  if (scrollable && !el.classList.contains(className)) {
	    el.style.top = '-' + (queryable ? (0, _getPagePosition2.default)('y') : el.scrollTop) + 'px';
	    el.classList.add(className);
	  } else if (!scrollable && el.classList.contains(className)) {
	    var scrollTop = Math.abs(parseInt(el.style.top, 10));
	    el.classList.remove(className);
	    el.style.top = null;
	
	    if (!selector) {
	      window.scrollTo(0, scrollTop);
	    } else {
	      el.scrollTop = scrollTop;
	    }
	  }
	} /** @module utils/toggleScroll */
	//# sourceMappingURL=toggleScroll.js.map

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(103);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(78);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(105);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(65);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(66);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(104);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(103);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(78);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(105);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(65);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(66);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(104);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(103);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(78);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(105);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(381);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(65);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(66);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(104);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(176);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _warning = __webpack_require__(41);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkIndexBounds = function checkIndexBounds(props) {
	  var index = props.index,
	      children = props.children;
	
	
	  var childrenCount = _react.Children.count(children);
	
	   false ? (0, _warning2.default)(index >= 0 && index <= childrenCount, 'react-swipeable-view: the new index: ' + index + ' is out of bounds: [0-' + childrenCount + '].') : void 0;
	};
	
	exports.default = checkIndexBounds;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = computeIndex;
	
	var _react = __webpack_require__(1);
	
	var _constant = __webpack_require__(178);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function computeIndex(params) {
	  var children = params.children,
	      startIndex = params.startIndex,
	      startX = params.startX,
	      pageX = params.pageX,
	      viewLength = params.viewLength,
	      resistance = params.resistance;
	
	
	  var indexMax = _react.Children.count(children) - 1;
	  var index = startIndex + (startX - pageX) / viewLength;
	  var newStartX = void 0;
	
	  if (!resistance) {
	    // Reset the starting point
	    if (index < 0) {
	      index = 0;
	      newStartX = (index - startIndex) * viewLength + pageX;
	    } else if (index > indexMax) {
	      index = indexMax;
	      newStartX = (index - startIndex) * viewLength + pageX;
	    }
	  } else if (index < 0) {
	    index = Math.exp(index * _constant2.default.RESISTANCE_COEF) - 1;
	  } else if (index > indexMax) {
	    index = indexMax + 1 - Math.exp((indexMax - index) * _constant2.default.RESISTANCE_COEF);
	  }
	
	  return {
	    index: index,
	    startX: newStartX
	  };
	}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
	  var displaySameSlide = false;
	
	  if (props.children.length && nextProps.children.length) {
	    var oldChildren = props.children[props.index];
	    var oldKey = oldChildren ? oldChildren.key : 'empty';
	
	    if (oldKey !== null) {
	      var newChildren = nextProps.children[nextProps.index];
	      var newKey = newChildren ? newChildren.key : 'empty';
	
	      if (oldKey === newKey) {
	        displaySameSlide = true;
	      }
	    }
	  }
	
	  return displaySameSlide;
	};
	
	exports.default = getDisplaySameSlide;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkIndexBounds = __webpack_require__(384);
	
	Object.defineProperty(exports, 'checkIndexBounds', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_checkIndexBounds).default;
	  }
	});
	
	var _computeIndex = __webpack_require__(385);
	
	Object.defineProperty(exports, 'computeIndex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_computeIndex).default;
	  }
	});
	
	var _constant = __webpack_require__(178);
	
	Object.defineProperty(exports, 'constant', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_constant).default;
	  }
	});
	
	var _getDisplaySameSlide = __webpack_require__(386);
	
	Object.defineProperty(exports, 'getDisplaySameSlide', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getDisplaySameSlide).default;
	  }
	});
	
	var _mod = __webpack_require__(388);
	
	Object.defineProperty(exports, 'mod', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_mod).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Extended version of % with negative integer support.
	function mod(n, m) {
	  var q = n % m;
	  return q < 0 ? q + m : q;
	}
	
	exports.default = mod;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(184);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(413);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(482);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(483);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getDomTreeShapes = getDomTreeShapes;
	exports.findNativeHandler = findNativeHandler;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(41);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _properties = __webpack_require__(207);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _on = __webpack_require__(427);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(426);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _reactSwipeableViewsCore = __webpack_require__(387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addEventListenerEnhanced(node, event, handler, options) {
	  (0, _on2.default)(node, event, handler, options);
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, options);
	    }
	  };
	}
	
	var styleInjected = false;
	
	// Support old version of iOS and IE 10.
	// To be deleted in 2019.
	function injectStyle() {
	  // Inject once for all the instances
	  if (!styleInjected) {
	    var style = document.createElement('style');
	    style.innerHTML = '\n      .react-swipeable-view-container {\n        display: -webkit-box;\n        display: -ms-flexbox;\n      }\n      .react-swipeable-view-container > div {\n        -ms-flex-negative: 0;\n      }\n    ';
	
	    if (document.body) {
	      document.body.appendChild(style);
	    }
	    styleInjected = true;
	  }
	}
	
	var styles = {
	  container: {
	    direction: 'ltr',
	    display: 'flex',
	    willChange: 'transform'
	  },
	  slide: {
	    width: '100%',
	    WebkitFlexShrink: 0,
	    flexShrink: 0,
	    overflow: 'auto'
	  }
	};
	
	var axisProperties = {
	  root: {
	    x: {
	      overflowX: 'hidden'
	    },
	    'x-reverse': {
	      overflowX: 'hidden'
	    },
	    y: {
	      overflowY: 'hidden'
	    },
	    'y-reverse': {
	      overflowY: 'hidden'
	    }
	  },
	  flexDirection: {
	    x: 'row',
	    'x-reverse': 'row-reverse',
	    y: 'column',
	    'y-reverse': 'column-reverse'
	  },
	  transform: {
	    x: function x(translate) {
	      return 'translate(' + -translate + '%, 0)';
	    },
	    'x-reverse': function xReverse(translate) {
	      return 'translate(' + translate + '%, 0)';
	    },
	    y: function y(translate) {
	      return 'translate(0, ' + -translate + '%)';
	    },
	    'y-reverse': function yReverse(translate) {
	      return 'translate(0, ' + translate + '%)';
	    }
	  },
	  length: {
	    x: 'width',
	    'x-reverse': 'width',
	    y: 'height',
	    'y-reverse': 'height'
	  },
	  rotationMatrix: {
	    x: {
	      x: [1, 0],
	      y: [0, 1]
	    },
	    'x-reverse': {
	      x: [-1, 0],
	      y: [0, 1]
	    },
	    y: {
	      x: [0, 1],
	      y: [1, 0]
	    },
	    'y-reverse': {
	      x: [0, -1],
	      y: [1, 0]
	    }
	  },
	  scrollPosition: {
	    x: 'scrollLeft',
	    'x-reverse': 'scrollLeft',
	    y: 'scrollTop',
	    'y-reverse': 'scrollTop'
	  },
	  scrollLength: {
	    x: 'scrollWidth',
	    'x-reverse': 'scrollWidth',
	    y: 'scrollHeight',
	    'y-reverse': 'scrollHeight'
	  },
	  clientLength: {
	    x: 'clientWidth',
	    'x-reverse': 'clientWidth',
	    y: 'clientHeight',
	    'y-reverse': 'clientHeight'
	  }
	};
	
	function createTransition(property, options) {
	  var duration = options.duration,
	      easeFunction = options.easeFunction,
	      delay = options.delay;
	
	
	  return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	}
	
	// We are using a 2x2 rotation matrix.
	function applyRotationMatrix(touch, axis) {
	  var rotationMatrix = axisProperties.rotationMatrix[axis];
	
	  return {
	    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
	    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
	  };
	}
	
	function adaptMouse(event) {
	  event.touches = [{ pageX: event.pageX, pageY: event.pageY }];
	  return event;
	}
	
	function getDomTreeShapes(element, rootNode) {
	  var domTreeShapes = [];
	
	  while (element && element !== rootNode) {
	    // We reach a Swipeable View, no need to look higher in the dom tree.
	    if (element.hasAttribute('data-swipeable')) {
	      break;
	    }
	
	    var style = window.getComputedStyle(element);
	
	    if (
	    // Ignore the scroll children if the element is absolute positioned.
	    style.getPropertyValue('position') === 'absolute' ||
	    // Ignore the scroll children if the element has an overflowX hidden
	    style.getPropertyValue('overflow-x') === 'hidden') {
	      domTreeShapes = [];
	    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
	      // Ignore the nodes that have no width.
	      // Keep elements with a scroll
	      domTreeShapes.push({
	        element: element,
	        scrollWidth: element.scrollWidth,
	        scrollHeight: element.scrollHeight,
	        clientWidth: element.clientWidth,
	        clientHeight: element.clientHeight,
	        scrollLeft: element.scrollLeft,
	        scrollTop: element.scrollTop
	      });
	    }
	
	    element = element.parentNode;
	  }
	
	  return domTreeShapes;
	}
	
	// We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	// That's why we use a singleton here.
	var nodeHowClaimedTheScroll = null;
	
	function findNativeHandler(params) {
	  var domTreeShapes = params.domTreeShapes,
	      pageX = params.pageX,
	      startX = params.startX,
	      axis = params.axis;
	
	
	  return domTreeShapes.some(function (shape) {
	    // Determine if we are going backward or forward.
	    var goingForward = pageX >= startX;
	    if (axis === 'x' || axis === 'y') {
	      goingForward = !goingForward;
	    }
	
	    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
	
	    var areNotAtStart = scrollPosition > 0;
	    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
	
	    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
	      nodeHowClaimedTheScroll = shape.element;
	      return true;
	    }
	
	    return false;
	  });
	}
	
	var SwipeableViews = function (_Component) {
	  (0, _inherits3.default)(SwipeableViews, _Component);
	
	  function SwipeableViews() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SwipeableViews);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwipeableViews.__proto__ || (0, _getPrototypeOf2.default)(SwipeableViews)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      indexLatest: null,
	      // Set to true as soon as the component is swiping.
	      // It's the state counter part of this.isSwiping.
	      isDragging: false,
	      // Help with SSR logic and lazy loading logic.
	      isFirstRender: true,
	      heightLatest: 0,
	      // Let the render method that we are going to display the same slide than previously.
	      displaySameSlide: true
	    }, _this.rootNode = null, _this.containerNode = null, _this.ignoreNextScrollEvents = false, _this.viewLength = 0, _this.startX = 0, _this.lastX = 0, _this.vx = 0, _this.startY = 0, _this.isSwiping = undefined, _this.started = false, _this.startIndex = 0, _this.transitionListener = null, _this.touchMoveListener = null, _this.activeSlide = null, _this.indexCurrent = null, _this.handleSwipeStart = function (event) {
	      var axis = _this.props.axis;
	
	      // Latency and rapid rerenders on some devices can leave
	      // a period where rootNode briefly equals null.
	
	      if (_this.rootNode === null) {
	        return;
	      }
	
	      var touch = applyRotationMatrix(event.touches[0], axis);
	
	      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
	      _this.startX = touch.pageX;
	      _this.lastX = touch.pageX;
	      _this.vx = 0;
	      _this.startY = touch.pageY;
	      _this.isSwiping = undefined;
	      _this.started = true;
	
	      var computedStyle = window.getComputedStyle(_this.containerNode);
	      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	
	      if (transform && transform !== 'none') {
	        var transformValues = transform.split('(')[1].split(')')[0].split(',');
	        var rootStyle = window.getComputedStyle(_this.rootNode);
	
	        var tranformNormalized = applyRotationMatrix({
	          pageX: parseInt(transformValues[4], 10),
	          pageY: parseInt(transformValues[5], 10)
	        }, axis);
	
	        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10));
	      }
	    }, _this.handleSwipeMove = function (event) {
	      // The touch start event can be cancel.
	      // Makes sure we set a starting point.
	      if (!_this.started) {
	        _this.handleTouchStart(event);
	        return;
	      }
	
	      // Latency and rapid rerenders on some devices
	      // can leave a period where rootNode briefly equals null.
	      if (_this.rootNode === null) {
	        return;
	      }
	
	      // We are not supposed to hanlde this touch move.
	      if (nodeHowClaimedTheScroll !== null && nodeHowClaimedTheScroll !== _this.rootNode) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          children = _this$props.children,
	          ignoreNativeScroll = _this$props.ignoreNativeScroll,
	          onSwitching = _this$props.onSwitching,
	          resistance = _this$props.resistance;
	
	
	      var touch = applyRotationMatrix(event.touches[0], axis);
	
	      // We don't know yet.
	      if (_this.isSwiping === undefined) {
	        var dx = Math.abs(_this.startX - touch.pageX);
	        var dy = Math.abs(_this.startY - touch.pageY);
	
	        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD;
	
	        // We let the parent handle the scroll.
	        if (!resistance && (axis === 'y' || axis === 'y-reverse') && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === _react.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
	          _this.isSwiping = false;
	          return;
	        }
	
	        // We are likely to be swiping, let's prevent the scroll event.
	        if (dx > dy) {
	          event.preventDefault();
	        }
	
	        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
	          _this.isSwiping = isSwiping;
	          _this.startX = touch.pageX; // Shift the starting point.
	
	          return; // Let's wait the next touch event to move something.
	        }
	      }
	
	      if (_this.isSwiping !== true) {
	        return;
	      }
	
	      // We are swiping, let's prevent the scroll event.
	      event.preventDefault();
	
	      // Low Pass filter.
	      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
	      _this.lastX = touch.pageX;
	
	      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
	        children: children,
	        resistance: resistance,
	        pageX: touch.pageX,
	        startIndex: _this.startIndex,
	        startX: _this.startX,
	        viewLength: _this.viewLength
	      }),
	          index = _computeIndex.index,
	          startX = _computeIndex.startX;
	
	      // Add support for native scroll elements.
	
	
	      if (nodeHowClaimedTheScroll === null && !ignoreNativeScroll) {
	        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
	        var hasFoundNativeHandler = findNativeHandler({
	          domTreeShapes: domTreeShapes,
	          startX: _this.startX,
	          pageX: touch.pageX,
	          axis: axis
	        });
	
	        // We abort the touch move handler.
	        if (hasFoundNativeHandler) {
	          return;
	        }
	      }
	
	      // We are moving toward the edges.
	      if (startX) {
	        _this.startX = startX;
	      } else if (nodeHowClaimedTheScroll === null) {
	        nodeHowClaimedTheScroll = _this.rootNode;
	      }
	
	      _this.setIndexCurrent(index);
	
	      var callback = function callback() {
	        if (onSwitching) {
	          onSwitching(index, 'move');
	        }
	      };
	
	      if (_this.state.displaySameSlide || !_this.state.isDragging) {
	        _this.setState({
	          displaySameSlide: false,
	          isDragging: true
	        }, callback);
	      }
	
	      callback();
	    }, _this.handleSwipeEnd = function () {
	      nodeHowClaimedTheScroll = null;
	
	      // The touch start event can be cancel.
	      // Makes sure that a starting point is set.
	      if (!_this.started) {
	        return;
	      }
	
	      _this.started = false;
	
	      if (_this.isSwiping !== true) {
	        return;
	      }
	
	      var indexLatest = _this.state.indexLatest;
	      var indexCurrent = _this.indexCurrent;
	      var delta = indexLatest - indexCurrent;
	
	      var indexNew = void 0;
	
	      // Quick movement
	      if (Math.abs(_this.vx) > _this.props.threshold) {
	        if (_this.vx > 0) {
	          indexNew = Math.floor(indexCurrent);
	        } else {
	          indexNew = Math.ceil(indexCurrent);
	        }
	      } else if (Math.abs(delta) > _this.props.hysteresis) {
	        // Some hysteresis with indexLatest.
	        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
	      } else {
	        indexNew = indexLatest;
	      }
	
	      var indexMax = _react.Children.count(_this.props.children) - 1;
	
	      if (indexNew < 0) {
	        indexNew = 0;
	      } else if (indexNew > indexMax) {
	        indexNew = indexMax;
	      }
	
	      _this.setIndexCurrent(indexNew);
	      _this.setState({
	        indexLatest: indexNew,
	        isDragging: false
	      }, function () {
	        if (_this.props.onSwitching) {
	          _this.props.onSwitching(indexNew, 'end');
	        }
	
	        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
	          _this.props.onChangeIndex(indexNew, indexLatest, {
	            reason: 'swipe'
	          });
	        }
	
	        // Manually calling handleTransitionEnd in that case as isn't otherwise.
	        if (indexCurrent === indexLatest) {
	          _this.handleTransitionEnd();
	        }
	      });
	    }, _this.handleTouchStart = function (event) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	      _this.handleSwipeStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	      _this.handleSwipeEnd(event);
	    }, _this.handleMouseDown = function (event) {
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	      event.persist();
	      _this.handleSwipeStart(adaptMouse(event));
	    }, _this.handleMouseUp = function (event) {
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	      _this.handleSwipeEnd(adaptMouse(event));
	    }, _this.handleMouseLeave = function (event) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	
	      // Filter out events
	      if (_this.started) {
	        _this.handleSwipeEnd(adaptMouse(event));
	      }
	    }, _this.handleMouseMove = function (event) {
	      if (_this.props.onMouseMove) {
	        _this.props.onMouseMove(event);
	      }
	
	      // Filter out events
	      if (_this.started) {
	        _this.handleSwipeMove(adaptMouse(event));
	      }
	    }, _this.handleScroll = function (event) {
	      if (_this.props.onScroll) {
	        _this.props.onScroll(event);
	      }
	
	      // Ignore events bubbling up.
	      if (event.target !== _this.rootNode) {
	        return;
	      }
	
	      if (_this.ignoreNextScrollEvents) {
	        _this.ignoreNextScrollEvents = false;
	        return;
	      }
	
	      var indexLatest = _this.state.indexLatest;
	      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
	
	      _this.ignoreNextScrollEvents = true;
	      // Reset the scroll position.
	      event.target.scrollLeft = 0;
	
	      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
	        _this.props.onChangeIndex(indexNew, indexLatest, {
	          reason: 'focus'
	        });
	      }
	    }, _this.updateHeight = function () {
	      if (_this.activeSlide !== null) {
	        var child = _this.activeSlide.children[0];
	        if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) {
	          _this.setState({
	            heightLatest: child.offsetHeight
	          });
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SwipeableViews, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _this2 = this;
	
	      return {
	        swipeableViews: {
	          slideUpdateHeight: function slideUpdateHeight() {
	            _this2.updateHeight();
	          }
	        }
	      };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (false) {
	        (0, _reactSwipeableViewsCore.checkIndexBounds)(this.props);
	      }
	
	      this.setIndexCurrent(this.props.index);
	      this.setState({
	        indexLatest: this.props.index
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      // Subscribe to transition end events.
	      this.transitionListener = addEventListenerEnhanced(this.containerNode, _properties2.default.end, function (event) {
	        if (event.target !== _this3.containerNode) {
	          return;
	        }
	
	        _this3.handleTransitionEnd();
	      });
	
	      // Block the thread to handle that event.
	      this.touchMoveListener = addEventListenerEnhanced(this.rootNode, 'touchmove', function (event) {
	        // Handling touch events is disabled.
	        if (_this3.props.disabled) {
	          return;
	        }
	        _this3.handleSwipeMove(event);
	      }, {
	        passive: false
	      });
	
	      // eslint-disable-next-line react/no-did-mount-set-state
	      this.setState({
	        isFirstRender: false
	      });
	
	      injectStyle();
	
	      // Send all functions in an object if action param is set.
	      if (this.props.action) {
	        this.props.action({
	          updateHeight: this.updateHeight
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var index = nextProps.index;
	
	
	      if (typeof index === 'number' && index !== this.props.index) {
	        if (false) {
	          (0, _reactSwipeableViewsCore.checkIndexBounds)(nextProps);
	        }
	
	        this.setIndexCurrent(index);
	        this.setState({
	          // If true, we are going to change the children. We shoudn't animate it.
	          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
	          indexLatest: index
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.transitionListener.remove();
	      this.touchMoveListener.remove();
	    }
	  }, {
	    key: 'setIndexCurrent',
	    value: function setIndexCurrent(indexCurrent) {
	      if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) {
	        this.handleTransitionEnd();
	      }
	
	      this.indexCurrent = indexCurrent;
	
	      if (this.containerNode) {
	        var axis = this.props.axis;
	
	        var transform = axisProperties.transform[axis](indexCurrent * 100);
	        this.containerNode.style.WebkitTransform = transform;
	        this.containerNode.style.transform = transform;
	      }
	    }
	  }, {
	    key: 'handleTransitionEnd',
	    value: function handleTransitionEnd() {
	      if (!this.props.onTransitionEnd) {
	        return;
	      }
	
	      // Filters out when changing the children
	      if (this.state.displaySameSlide) {
	        return;
	      }
	
	      // The rest callback is triggered when swiping. It's just noise.
	      // We filter it out.
	      if (!this.state.isDragging) {
	        this.props.onTransitionEnd();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          action = _props.action,
	          animateHeight = _props.animateHeight,
	          animateTransitions = _props.animateTransitions,
	          axis = _props.axis,
	          children = _props.children,
	          containerStyleProp = _props.containerStyle,
	          disabled = _props.disabled,
	          disableLazyLoading = _props.disableLazyLoading,
	          enableMouseEvents = _props.enableMouseEvents,
	          hysteresis = _props.hysteresis,
	          ignoreNativeScroll = _props.ignoreNativeScroll,
	          index = _props.index,
	          onChangeIndex = _props.onChangeIndex,
	          onSwitching = _props.onSwitching,
	          onTransitionEnd = _props.onTransitionEnd,
	          resistance = _props.resistance,
	          slideStyleProp = _props.slideStyle,
	          slideClassName = _props.slideClassName,
	          springConfig = _props.springConfig,
	          style = _props.style,
	          threshold = _props.threshold,
	          other = (0, _objectWithoutProperties3.default)(_props, ['action', 'animateHeight', 'animateTransitions', 'axis', 'children', 'containerStyle', 'disabled', 'disableLazyLoading', 'enableMouseEvents', 'hysteresis', 'ignoreNativeScroll', 'index', 'onChangeIndex', 'onSwitching', 'onTransitionEnd', 'resistance', 'slideStyle', 'slideClassName', 'springConfig', 'style', 'threshold']);
	      var _state = this.state,
	          displaySameSlide = _state.displaySameSlide,
	          heightLatest = _state.heightLatest,
	          isDragging = _state.isDragging,
	          isFirstRender = _state.isFirstRender,
	          indexLatest = _state.indexLatest;
	
	      var touchEvents = !disabled ? {
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd
	      } : {};
	      var mouseEvents = !disabled && enableMouseEvents ? {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseMove: this.handleMouseMove
	      } : {};
	
	      // There is no point to animate if we are already providing a height.
	       false ? (0, _warning2.default)(!animateHeight || !containerStyleProp || !containerStyleProp.height, 'react-swipeable-view: You are setting animateHeight to true but you are\nalso providing a custom height.\nThe custom height has a higher priority than the animateHeight property.\nSo animateHeight is most likely having no effect at all.') : void 0;
	
	      var slideStyle = (0, _extends3.default)({}, styles.slide, slideStyleProp);
	
	      var transition = void 0;
	      var WebkitTransition = void 0;
	
	      if (isDragging || !animateTransitions || displaySameSlide) {
	        transition = 'all 0s ease 0s';
	        WebkitTransition = 'all 0s ease 0s';
	      } else {
	        transition = createTransition('transform', springConfig);
	        WebkitTransition = createTransition('-webkit-transform', springConfig);
	
	        if (heightLatest !== 0) {
	          var additionalTranstion = ', ' + createTransition('height', springConfig);
	          transition += additionalTranstion;
	          WebkitTransition += additionalTranstion;
	        }
	      }
	
	      var containerStyle = {
	        height: null,
	        WebkitFlexDirection: axisProperties.flexDirection[axis],
	        flexDirection: axisProperties.flexDirection[axis],
	        WebkitTransition: WebkitTransition,
	        transition: transition
	      };
	
	      // Apply the styles for SSR considerations
	      if (disableLazyLoading || !isFirstRender) {
	        var transform = axisProperties.transform[axis](this.indexCurrent * 100);
	        containerStyle.WebkitTransform = transform;
	        containerStyle.transform = transform;
	      }
	
	      if (animateHeight) {
	        containerStyle.height = heightLatest;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          style: (0, _extends3.default)({}, axisProperties.root[axis], style)
	        }, other, touchEvents, mouseEvents, {
	          onScroll: this.handleScroll
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(node) {
	              _this4.containerNode = node;
	            },
	            style: (0, _extends3.default)({}, containerStyle, styles.container, containerStyleProp),
	            className: 'react-swipeable-view-container'
	          },
	          _react.Children.map(children, function (child, indexChild) {
	            if (!disableLazyLoading && isFirstRender && indexChild !== indexLatest) {
	              return null;
	            }
	
	             false ? (0, _warning2.default)((0, _react.isValidElement)(child), 'react-swipeable-view: one of the children provided is invalid: ' + child + '.\nWe are expecting a valid React Element') : void 0;
	
	            var ref = void 0;
	            var hidden = true;
	
	            if (indexChild === indexLatest) {
	              hidden = false;
	
	              if (animateHeight) {
	                ref = function ref(node) {
	                  _this4.activeSlide = node;
	                  _this4.updateHeight();
	                };
	                slideStyle.overflowY = 'hidden';
	              }
	            }
	
	            return _react2.default.createElement(
	              'div',
	              {
	                ref: ref,
	                style: slideStyle,
	                className: slideClassName,
	                'aria-hidden': hidden,
	                'data-swipeable': 'true'
	              },
	              child
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return SwipeableViews;
	}(_react.Component);
	
	// Added as an ads for people using the React dev tools in production.
	// So they know, the tool used to build the awesome UI they
	// are looking at/retro engineering.
	
	
	SwipeableViews.displayName = 'ReactSwipableView';
	
	SwipeableViews.propTypes =  false ? {
	  /**
	   * This is callback property. It's called by the component on mount.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports updateHeight() action.
	   *
	   * @param {object} actions This object contains all posible actions
	   * that can be triggered programmatically.
	   */
	  action: _propTypes2.default.func,
	  /**
	   * If `true`, the height of the container will be animated to match the current slide height.
	   * Animating another style property has a negative impact regarding performance.
	   */
	  animateHeight: _propTypes2.default.bool,
	  /**
	   * If `false`, changes to the index prop will not cause an animated transition.
	   */
	  animateTransitions: _propTypes2.default.bool,
	  /**
	   * The axis on which the slides will slide.
	   */
	  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * Use this property to provide your slides.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * This is the inlined style that will be applied
	   * to each slide container.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If `true`, it will disable touch events.
	   * This is useful when you want to prohibit the user from changing slides.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * This is the config used to disable lazyloding,
	   * if `true` will render all the views in first rendering.
	   */
	  disableLazyLoading: _propTypes2.default.bool,
	  /**
	   * If `true`, it will enable mouse events.
	   * This will allow the user to perform the relevant swipe actions with a mouse.
	   */
	  enableMouseEvents: _propTypes2.default.bool,
	  /**
	   * Configure hysteresis between slides. This value determines how far
	   * should user swipe to switch slide.
	   */
	  hysteresis: _propTypes2.default.number,
	  /**
	   * If `true`, it will ignore native scroll container.
	   * It can be used to filter out false positive that blocks the swipe.
	   */
	  ignoreNativeScroll: _propTypes2.default.bool,
	  /**
	   * This is the index of the slide to show.
	   * This is useful when you want to change the default slide shown.
	   * Or when you have tabs linked to each slide.
	   */
	  index: _propTypes2.default.number,
	  /**
	   * This is callback prop. It's call by the
	   * component when the shown slide change after a swipe made by the user.
	   * This is useful when you have tabs linked to each slide.
	   *
	   * @param {integer} index This is the current index of the slide.
	   * @param {integer} indexLatest This is the oldest index of the slide.
	   * @param {object} meta Meta data containing more information about the event.
	   */
	  onChangeIndex: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseMove: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onScroll: _propTypes2.default.func,
	  /**
	   * This is callback prop. It's called by the
	   * component when the slide switching.
	   * This is useful when you want to implement something corresponding
	   * to the current slide position.
	   *
	   * @param {integer} index This is the current index of the slide.
	   * @param {string} type Can be either `move` or `end`.
	   */
	  onSwitching: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * The callback that fires when the animation comes to a rest.
	   * This is useful to defer CPU intensive task.
	   */
	  onTransitionEnd: _propTypes2.default.func,
	  /**
	   * If `true`, it will add bounds effect on the edges.
	   */
	  resistance: _propTypes2.default.bool,
	  /**
	   * This is the className that will be applied
	   * on the slide component.
	   */
	  slideClassName: _propTypes2.default.string,
	  /**
	   * This is the inlined style that will be applied
	   * on the slide component.
	   */
	  slideStyle: _propTypes2.default.object,
	  /**
	   * This is the config used to create CSS transitions.
	   * This is useful to change the dynamic of the transition.
	   */
	  springConfig: _propTypes2.default.shape({
	    duration: _propTypes2.default.string,
	    easeFunction: _propTypes2.default.string,
	    delay: _propTypes2.default.string
	  }),
	  /**
	   * This is the inlined style that will be applied
	   * on the root component.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the threshold used for detecting a quick swipe.
	   * If the computed speed is above this value, the index change.
	   */
	  threshold: _propTypes2.default.number
	} : {};
	
	SwipeableViews.defaultProps = {
	  animateHeight: false,
	  animateTransitions: true,
	  axis: 'x',
	  disabled: false,
	  disableLazyLoading: false,
	  enableMouseEvents: false,
	  hysteresis: 0.6,
	  ignoreNativeScroll: false,
	  index: 0,
	  threshold: 5,
	  springConfig: {
	    duration: '0.35s',
	    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
	    delay: '0s'
	  },
	  resistance: false
	};
	
	SwipeableViews.childContextTypes = {
	  swipeableViews: _propTypes2.default.shape({
	    slideUpdateHeight: _propTypes2.default.func
	  })
	};
	
	exports.default = SwipeableViews;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwipeableViews = __webpack_require__(389);
	
	var _SwipeableViews2 = _interopRequireDefault(_SwipeableViews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SwipeableViews2.default;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(496);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(497);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(428);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(207);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _PropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(60);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isNaN2 = __webpack_require__(195);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isArray2 = __webpack_require__(24);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Area
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(63);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(107);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(84);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Area = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Area, _Component);
	
	  function Area() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Area.__proto__ || Object.getPrototypeOf(Area)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: true }, _this.id = (0, _DataUtils.uniqueId)('recharts-area-'), _this.cachePrevData = function (points, baseLine) {
	      _this.setState({
	        prevPoints: points,
	        prevBaseLine: baseLine
	      });
	    }, _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	
	      _this.setState({ isAnimationFinished: true });
	
	      if ((0, _isFunction3.default)(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    }, _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({ isAnimationFinished: false });
	
	      if ((0, _isFunction3.default)(onAnimationStart)) {
	        onAnimationStart();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Area, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points,
	          baseLine = _props.baseLine;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points, baseLine);
	      }
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          dot = _props2.dot,
	          points = _props2.points,
	          dataKey = _props2.dataKey;
	
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, areaProps, customDotProps, dotEvents, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderHorizontalRect',
	    value: function renderHorizontalRect(alpha) {
	      var _props3 = this.props,
	          baseLine = _props3.baseLine,
	          points = _props3.points,
	          strokeWidth = _props3.strokeWidth;
	
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = Math.max.apply(null, points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else if (baseLine && (0, _isArray3.default)(baseLine) && baseLine.length) {
	        maxY = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxY)) {
	        return _react2.default.createElement('rect', {
	          x: startX < endX ? startX : startX - width,
	          y: 0,
	          width: width,
	          height: maxY + (strokeWidth || 1)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderVerticalRect',
	    value: function renderVerticalRect(alpha) {
	      var _props4 = this.props,
	          baseLine = _props4.baseLine,
	          points = _props4.points,
	          strokeWidth = _props4.strokeWidth;
	
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = Math.max.apply(null, points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else if (baseLine && (0, _isArray3.default)(baseLine) && baseLine.length) {
	        maxX = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxX)) {
	        return _react2.default.createElement('rect', {
	          x: 0,
	          y: startY < endY ? startY : startY - height,
	          width: maxX + (strokeWidth || 1),
	          height: height
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderClipRect',
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: 'renderAreaStatically',
	    value: function renderAreaStatically(points, baseLine, needClip) {
	      var _props5 = this.props,
	          layout = _props5.layout,
	          type = _props5.type,
	          stroke = _props5.stroke,
	          connectNulls = _props5.connectNulls,
	          isRange = _props5.isRange;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null },
	        _react2.default.createElement(_Curve2.default, _extends({}, this.props, {
	          points: points,
	          baseLine: baseLine,
	          stroke: 'none',
	          className: 'recharts-area-area'
	        })),
	        stroke !== 'none' && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: points
	        })),
	        stroke !== 'none' && isRange && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: baseLine
	        }))
	      );
	    }
	  }, {
	    key: 'renderAreaWithAnimation',
	    value: function renderAreaWithAnimation(needClip) {
	      var _this3 = this;
	
	      var _props6 = this.props,
	          points = _props6.points,
	          baseLine = _props6.baseLine,
	          isAnimationActive = _props6.isAnimationActive,
	          animationBegin = _props6.animationBegin,
	          animationDuration = _props6.animationDuration,
	          animationEasing = _props6.animationEasing,
	          animationId = _props6.animationId,
	          id = _props6.id;
	      var _state = this.state,
	          prevPoints = _state.prevPoints,
	          prevBaseLine = _state.prevBaseLine;
	
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'area-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          if (prevPoints) {
	            // update animtaion
	            var stepPoints = points.map(function (entry, index) {
	              if (prevPoints[index]) {
	                var prev = prevPoints[index];
	                var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	                return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
	              }
	
	              return entry;
	            });
	            var stepBaseLine = void 0;
	
	            if ((0, _DataUtils.isNumber)(baseLine)) {
	              var interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, baseLine);
	              stepBaseLine = interpolator(t);
	            } else if ((0, _isNil3.default)(baseLine) || (0, _isNaN3.default)(baseLine)) {
	              var _interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, 0);
	              stepBaseLine = _interpolator(t);
	            } else {
	              stepBaseLine = baseLine.map(function (entry, index) {
	                if (prevBaseLine[index]) {
	                  var prev = prevBaseLine[index];
	                  var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                  var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	                  return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
	                }
	
	                return entry;
	              });
	            }
	
	            return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip);
	          }
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _react2.default.createElement(
	              'defs',
	              null,
	              _react2.default.createElement(
	                'clipPath',
	                { id: 'animationClipPath-' + clipPathId },
	                _this3.renderClipRect(t)
	              )
	            ),
	            _react2.default.createElement(
	              _Layer2.default,
	              { clipPath: 'url(#animationClipPath-' + clipPathId + ')' },
	              _this3.renderAreaStatically(points, baseLine, needClip)
	            )
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderArea',
	    value: function renderArea(needClip) {
	      var _props7 = this.props,
	          points = _props7.points,
	          baseLine = _props7.baseLine,
	          isAnimationActive = _props7.isAnimationActive;
	      var _state2 = this.state,
	          prevPoints = _state2.prevPoints,
	          prevBaseLine = _state2.prevBaseLine,
	          totalLength = _state2.totalLength;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual3.default)(prevPoints, points) || !(0, _isEqual3.default)(prevBaseLine, baseLine))) {
	        return this.renderAreaWithAnimation(needClip);
	      }
	
	      return this.renderAreaStatically(points, baseLine, needClip);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props8 = this.props,
	          hide = _props8.hide,
	          dot = _props8.dot,
	          points = _props8.points,
	          className = _props8.className,
	          top = _props8.top,
	          left = _props8.left,
	          xAxis = _props8.xAxis,
	          yAxis = _props8.yAxis,
	          width = _props8.width,
	          height = _props8.height,
	          isAnimationActive = _props8.isAnimationActive,
	          id = _props8.id;
	
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + clipPathId },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint ? this.renderArea(needClip) : null,
	        (dot || hasSinglePoint) && this.renderDots(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Area;
	}(_react.Component), _class2.displayName = 'Area', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  stackId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  connectNulls: _propTypes2.default.bool,
	
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  // dot configuration
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.bool]),
	  hide: _propTypes2.default.bool,
	  // have curve configuration
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  isRange: _propTypes2.default.bool,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array])
	  })),
	
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	  animationId: _propTypes2.default.number,
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	
	  id: _propTypes2.default.string
	}), _class2.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  activeDot: true,
	  hide: false,
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getBaseValue = function (props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	}, _class2.getComposedData = function (_ref3) {
	  var props = _ref3.props,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xAxisTicks = _ref3.xAxisTicks,
	      yAxisTicks = _ref3.yAxisTicks,
	      bandSize = _ref3.bandSize,
	      dataKey = _ref3.dataKey,
	      stackedData = _ref3.stackedData,
	      dataStartIndex = _ref3.dataStartIndex,
	      displayedData = _ref3.displayedData,
	      offset = _ref3.offset;
	  var layout = props.layout;
	
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	
	  var points = displayedData.map(function (entry, index) {
	    var value = void 0;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: xAxis, ticks: xAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value[1]) ? null : xAxis.scale(value[1]),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: yAxis, ticks: yAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	
	  var baseLine = void 0;
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      return {
	        x: layout === 'horizontal' ? entry.x : xAxis.scale(entry && entry.value[0]),
	        y: layout === 'horizontal' ? yAxis.scale(entry && entry.value[0]) : entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return _extends({ points: points, baseLine: baseLine, layout: layout, isRange: isRange }, offset);
	}, _class2.renderDotItem = function (option, props) {
	  var dotItem = void 0;
	
	  if (_react2.default.isValidElement(option)) {
	    dotItem = _react2.default.cloneElement(option, props);
	  } else if ((0, _isFunction3.default)(option)) {
	    dotItem = option(props);
	  } else {
	    dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-area-dot' }));
	  }
	
	  return dotItem;
	}, _temp2)) || _class;
	
	exports.default = Area;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isEqual2 = __webpack_require__(60);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(24);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(63);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ErrorBar = __webpack_require__(180);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _Cell = __webpack_require__(181);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _LabelList = __webpack_require__(84);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Bar, _Component);
	
	  function Bar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bar.__proto__ || Object.getPrototypeOf(Bar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-bar-'), _this.cachePrevData = function (data) {
	      _this.setState({ prevData: data });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Compose the data of each group
	   * @param {Object} props Props for the component
	   * @param {Object} item        An instance of Bar
	   * @param {Array} barPosition  The offset and size of each bar
	   * @param {Object} xAxis       The configuration of x-axis
	   * @param {Object} yAxis       The configuration of y-axis
	   * @param {Array} stackedData  The stacked data of a bar item
	   * @return{Array} Composed data
	   */
	
	
	  _createClass(Bar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          data = _props.data;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: 'renderRectangle',
	    value: function renderRectangle(option, props) {
	      var rectangle = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rectangle = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react2.default.createElement(_Rectangle2.default, props);
	      }
	
	      return rectangle;
	    }
	  }, {
	    key: 'renderRectanglesStatically',
	    value: function renderRectanglesStatically(data) {
	      var _this2 = this;
	
	      var shape = this.props.shape;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return data && data.map(function (entry, i) {
	        var props = _extends({}, baseProps, entry, { index: i });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-bar-rectangle'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	            key: 'rectangle-' + i
	          }),
	          _this2.renderRectangle(shape, props)
	        );
	      });
	    }
	  }, {
	    key: 'renderRectanglesWithAnimation',
	    value: function renderRectanglesWithAnimation() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          layout = _props2.layout,
	          isAnimationActive = _props2.isAnimationActive,
	          animationBegin = _props2.animationBegin,
	          animationDuration = _props2.animationDuration,
	          animationEasing = _props2.animationEasing,
	          animationId = _props2.animationId,
	          width = _props2.width;
	      var prevData = this.state.prevData;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'bar-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = data.map(function (entry, index) {
	            var prev = prevData && prevData[index];
	
	            if (prev) {
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              var interpolatorWidth = (0, _DataUtils.interpolateNumber)(prev.width, entry.width);
	              var interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	
	              return _extends({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t),
	                width: interpolatorWidth(t),
	                height: interpolatorHeight(t)
	              });
	            }
	
	            if (layout === 'horizontal') {
	              var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	              var h = _interpolatorHeight(t);
	
	              return _extends({}, entry, {
	                y: entry.y + entry.height - h,
	                height: h
	              });
	            }
	
	            var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.width);
	            var w = interpolator(t);
	
	            return _extends({}, entry, { width: w });
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this3.renderRectanglesStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderRectangles',
	    value: function renderRectangles() {
	      var _props3 = this.props,
	          data = _props3.data,
	          isAnimationActive = _props3.isAnimationActive;
	      var prevData = this.state.prevData;
	
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual3.default)(prevData, data))) {
	        return this.renderRectanglesWithAnimation();
	      }
	
	      return this.renderRectanglesStatically(data);
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground(sectors) {
	      var _this4 = this;
	
	      var data = this.props.data;
	
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	
	      return data.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ['value', 'background']);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _extends({}, rest, {
	          fill: '#eee'
	        }, background, backgroundProps, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: 'background-bar-' + i,
	          className: 'recharts-bar-background-rectangle'
	        });
	
	        return _this4.renderRectangle(background, props);
	      });
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          data = _props4.data,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          layout = _props4.layout,
	          children = _props4.children;
	
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react2.default.cloneElement(item, {
	          key: i,
	          data: data,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          offset: offset,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          hide = _props5.hide,
	          data = _props5.data,
	          className = _props5.className,
	          xAxis = _props5.xAxis,
	          yAxis = _props5.yAxis,
	          left = _props5.left,
	          top = _props5.top,
	          width = _props5.width,
	          height = _props5.height,
	          isAnimationActive = _props5.isAnimationActive,
	          background = _props5.background,
	          id = _props5.id;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + clipPathId },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        _react2.default.createElement(
	          _Layer2.default,
	          {
	            className: 'recharts-bar-rectangles',
	            clipPath: needClip ? 'url(#clipPath-' + clipPathId + ')' : null
	          },
	          background ? this.renderBackground() : null,
	          this.renderRectangles()
	        ),
	        this.renderErrorBar(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, data)
	      );
	    }
	  }]);
	
	  return Bar;
	}(_react.Component), _class2.displayName = 'Bar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  layout: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  stackId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  barSize: _propTypes2.default.number,
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  minPointSize: _propTypes2.default.number,
	  maxBarSize: _propTypes2.default.number,
	  hide: _propTypes2.default.bool,
	
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array])
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  animationId: _propTypes2.default.number,
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes2.default.string
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  hide: false,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _class2.getComposedData = function (_ref3) {
	  var props = _ref3.props,
	      item = _ref3.item,
	      barPosition = _ref3.barPosition,
	      bandSize = _ref3.bandSize,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xAxisTicks = _ref3.xAxisTicks,
	      yAxisTicks = _ref3.yAxisTicks,
	      stackedData = _ref3.stackedData,
	      dataStartIndex = _ref3.dataStartIndex,
	      displayedData = _ref3.displayedData,
	      offset = _ref3.offset;
	
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	  if (!pos) {
	    return [];
	  }
	
	  var layout = props.layout;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({ props: props, numericAxis: numericAxis });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  var rects = displayedData.map(function (entry, index) {
	    var value = void 0,
	        x = void 0,
	        y = void 0,
	        width = void 0,
	        height = void 0,
	        background = void 0;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	      x = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: xAxis,
	        ticks: xAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(value[1]);
	      width = pos.size;
	      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
	      background = { x: x, y: yAxis.y, width: width, height: yAxis.height };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(value[0]);
	      y = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
	      height = pos.size;
	      background = { x: xAxis.x, y: y, width: xAxis.width, height: height };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	        width += _delta;
	      }
	    }
	
	    return _extends({}, entry, {
	      x: x, y: y, width: width, height: height, value: stackedData ? value : value[1],
	      payload: entry,
	      background: background
	    }, cells && cells[index] && cells[index].props);
	  });
	
	  return _extends({ data: rects, layout: layout }, offset);
	}, _temp2)) || _class;
	
	exports.default = Bar;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(60);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Line
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(63);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(107);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(84);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _ErrorBar = __webpack_require__(180);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Line = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Line, _Component);
	
	  function Line() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Line.__proto__ || Object.getPrototypeOf(Line)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    }, _this.id = (0, _DataUtils.uniqueId)('recharts-line-'), _this.cachePrevData = function (points) {
	      _this.setState({ prevPoints: points });
	    }, _this.pathRef = function (node) {
	      _this.mainCurve = node;
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Compose the data of each group
	   * @param {Object} props The props from the component
	   * @param  {Object} xAxis   The configuration of x-axis
	   * @param  {Object} yAxis   The configuration of y-axis
	   * @param  {String} dataKey The unique key of a group
	   * @return {Array}  Composed data
	   */
	
	
	  _createClass(Line, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (!this.props.isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	      this.setState({ totalLength: totalLength });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: 'getTotalLength',
	    value: function getTotalLength() {
	      var curveDom = this.mainCurve;
	
	      try {
	        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	      } catch (err) {
	        return 0;
	      }
	    }
	  }, {
	    key: 'getStrokeDasharray',
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	
	      var remainLines = [];
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	
	      return [].concat(_toConsumableArray(this.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return line + 'px';
	      }).join(', ');
	    }
	  }, {
	    key: 'repeat',
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          points = _props2.points,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          layout = _props2.layout,
	          children = _props2.children;
	
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react2.default.cloneElement(item, {
	          key: i,
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        var className = (0, _classnames2.default)('recharts-line-dot', option ? option.className : '');
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: className }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props3 = this.props,
	          dot = _props3.dot,
	          points = _props3.points,
	          dataKey = _props3.dataKey;
	
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, lineProps, customDotProps, dotEvents, {
	          value: entry.value,
	          dataKey: dataKey,
	          cx: entry.x, cy: entry.y, index: i, payload: entry.payload
	        });
	
	        return _this2.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-dots', key: 'dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderCurveStatically',
	    value: function renderCurveStatically(points, needClip, props) {
	      var _props4 = this.props,
	          type = _props4.type,
	          layout = _props4.layout,
	          connectNulls = _props4.connectNulls,
	          id = _props4.id;
	
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	      var curveProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? 'url(#clipPath-' + clipPathId + ')' : null,
	        points: points
	      }, props, {
	        type: type, layout: layout, connectNulls: connectNulls
	      });
	
	      return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, { pathRef: this.pathRef }));
	    }
	  }, {
	    key: 'renderCurveWithAnimation',
	    value: function renderCurveWithAnimation(needClip) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          points = _props5.points,
	          strokeDasharray = _props5.strokeDasharray,
	          isAnimationActive = _props5.isAnimationActive,
	          animationBegin = _props5.animationBegin,
	          animationDuration = _props5.animationDuration,
	          animationEasing = _props5.animationEasing,
	          animationId = _props5.animationId,
	          width = _props5.width,
	          height = _props5.height,
	          other = _objectWithoutProperties(_props5, ['points', 'strokeDasharray', 'isAnimationActive', 'animationBegin', 'animationDuration', 'animationEasing', 'animationId', 'width', 'height']);
	
	      var _state = this.state,
	          prevPoints = _state.prevPoints,
	          totalLength = _state.totalLength;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'line-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          if (prevPoints) {
	            var stepData = points.map(function (entry, index) {
	              if (prevPoints[index]) {
	                var prev = prevPoints[index];
	                var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	                return _extends({}, entry, { x: _interpolatorX(t), y: _interpolatorY(t) });
	              }
	
	              // magic number of faking previous x and y location
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(width * 2, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(height / 2, entry.y);
	              return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
	            });
	            return _this3.renderCurveStatically(stepData, needClip);
	          }
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, totalLength);
	          var curLength = interpolator(t);
	          var currentStrokeDasharray = void 0;
	
	          if (strokeDasharray) {
	            var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	              return parseFloat(num);
	            });
	            currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
	          } else {
	            currentStrokeDasharray = curLength + 'px ' + (totalLength - curLength) + 'px';
	          }
	
	          return _this3.renderCurveStatically(points, needClip, {
	            strokeDasharray: currentStrokeDasharray
	          });
	        }
	      );
	    }
	  }, {
	    key: 'renderCurve',
	    value: function renderCurve(needClip) {
	      var _props6 = this.props,
	          points = _props6.points,
	          isAnimationActive = _props6.isAnimationActive;
	      var _state2 = this.state,
	          prevPoints = _state2.prevPoints,
	          totalLength = _state2.totalLength;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual3.default)(prevPoints, points))) {
	        return this.renderCurveWithAnimation(needClip);
	      }
	
	      return this.renderCurveStatically(points, needClip);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          hide = _props7.hide,
	          dot = _props7.dot,
	          points = _props7.points,
	          className = _props7.className,
	          xAxis = _props7.xAxis,
	          yAxis = _props7.yAxis,
	          top = _props7.top,
	          left = _props7.left,
	          width = _props7.width,
	          height = _props7.height,
	          isAnimationActive = _props7.isAnimationActive,
	          id = _props7.id;
	
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + clipPathId },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint && this.renderCurve(needClip),
	        this.renderErrorBar(),
	        (hasSinglePoint || dot) && this.renderDots(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Line;
	}(_react.Component), _class2.displayName = 'Line', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  connectNulls: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	
	  // whether have dot in line
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    value: _propTypes2.default.value
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _propTypes2.default.number,
	  id: _propTypes2.default.string
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  hide: false,
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _class2.getComposedData = function (_ref3) {
	  var props = _ref3.props,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xAxisTicks = _ref3.xAxisTicks,
	      yAxisTicks = _ref3.yAxisTicks,
	      dataKey = _ref3.dataKey,
	      bandSize = _ref3.bandSize,
	      displayedData = _ref3.displayedData,
	      offset = _ref3.offset;
	  var layout = props.layout;
	
	
	  var points = displayedData.map(function (entry, index) {
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: xAxis, ticks: xAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value) ? null : xAxis.scale(value),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: yAxis, ticks: yAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	
	  return _extends({ points: points, layout: layout }, offset);
	}, _temp2)) || _class;
	
	exports.default = Line;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(60);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of scatters
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(63);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(84);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _ZAxis = __webpack_require__(200);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Symbols = __webpack_require__(400);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ErrorBar = __webpack_require__(180);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _Cell = __webpack_require__(181);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scatter = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Scatter, _Component);
	
	  function Scatter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scatter.__proto__ || Object.getPrototypeOf(Scatter)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.cachePrevPoints = function (points) {
	      _this.setState({ prevPoints: points });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-'), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Compose the data of each group
	   * @param  {Object} xAxis   The configuration of x-axis
	   * @param  {Object} yAxis   The configuration of y-axis
	   * @param  {String} dataKey The unique key of a group
	   * @return {Array}  Composed data
	   */
	
	
	  _createClass(Scatter, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevPoints(points);
	      }
	    }
	  }, {
	    key: 'renderSymbolItem',
	    value: function renderSymbolItem(option, props) {
	      var symbol = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        symbol = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react2.default.createElement(_Symbols2.default, _extends({}, props, { type: option }));
	      }
	
	      return symbol;
	    }
	  }, {
	    key: 'renderSymbolsStatically',
	    value: function renderSymbolsStatically(points) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          shape = _props2.shape,
	          activeShape = _props2.activeShape,
	          activeIndex = _props2.activeIndex;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return points.map(function (entry, i) {
	        var props = _extends({ key: 'symbol-' + i }, baseProps, entry);
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-scatter-symbol'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	            key: 'symbol-' + i
	          }),
	          _this2.renderSymbolItem(activeIndex === i ? activeShape : shape, props)
	        );
	      });
	    }
	  }, {
	    key: 'renderSymbolsWithAnimation',
	    value: function renderSymbolsWithAnimation() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          points = _props3.points,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          animationId = _props3.animationId;
	      var prevPoints = this.state.prevPoints;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'pie-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = points.map(function (entry, index) {
	            var prev = prevPoints && prevPoints[index];
	
	            if (prev) {
	              var interpolatorCx = (0, _DataUtils.interpolateNumber)(prev.cx, entry.cx);
	              var interpolatorCy = (0, _DataUtils.interpolateNumber)(prev.cy, entry.cy);
	              var interpolatorSize = (0, _DataUtils.interpolateNumber)(prev.size, entry.size);
	
	              return _extends({}, entry, {
	                cx: interpolatorCx(t),
	                cy: interpolatorCy(t),
	                size: interpolatorSize(t)
	              });
	            }
	
	            var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.size);
	
	            return _extends({}, entry, { size: interpolator(t) });
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this3.renderSymbolsStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderSymbols',
	    value: function renderSymbols() {
	      var _props4 = this.props,
	          points = _props4.points,
	          isAnimationActive = _props4.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual3.default)(prevPoints, points))) {
	        return this.renderSymbolsWithAnimation();
	      }
	
	      return this.renderSymbolsStatically(points);
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          points = _props5.points,
	          xAxis = _props5.xAxis,
	          yAxis = _props5.yAxis,
	          children = _props5.children;
	
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.y,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.x,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	
	
	        return _react2.default.cloneElement(item, {
	          key: i,
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: 'renderLine',
	    value: function renderLine() {
	      var _props6 = this.props,
	          points = _props6.points,
	          line = _props6.line,
	          lineType = _props6.lineType,
	          lineJointType = _props6.lineJointType;
	
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints = void 0,
	          lineItem = void 0;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return { x: entry.cx, y: entry.cy };
	        });
	      } else if (lineType === 'fitting') {
	        var _getLinearRegression = (0, _DataUtils.getLinearRegression)(points),
	            xmin = _getLinearRegression.xmin,
	            xmax = _getLinearRegression.xmax,
	            a = _getLinearRegression.a,
	            b = _getLinearRegression.b;
	
	        var linearExp = function linearExp(x) {
	          return a * x + b;
	        };
	        linePoints = [{ x: xmin, y: linearExp(xmin) }, { x: xmax, y: linearExp(xmax) }];
	      }
	      var lineProps = _extends({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react2.default.isValidElement(line)) {
	        lineItem = _react2.default.cloneElement(line, lineProps);
	      } else if ((0, _isFunction3.default)(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react2.default.createElement(_Curve2.default, _extends({}, lineProps, { type: lineJointType }));
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-scatter-line', key: 'recharts-scatter-line' },
	        lineItem
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          hide = _props7.hide,
	          points = _props7.points,
	          line = _props7.line,
	          className = _props7.className,
	          xAxis = _props7.xAxis,
	          yAxis = _props7.yAxis,
	          left = _props7.left,
	          top = _props7.top,
	          width = _props7.width,
	          height = _props7.height,
	          id = _props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	      var _state = this.state,
	          isAnimationActive = _state.isAnimationActive,
	          isAnimationFinished = _state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          clipPath: needClip ? 'url(#clipPath-' + clipPathId + ')' : null
	        },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + clipPathId },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        line && this.renderLine(),
	        this.renderErrorBar(),
	        _react2.default.createElement(
	          _Layer2.default,
	          { key: 'recharts-scatter-symbols' },
	          this.renderSymbols()
	        ),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Scatter;
	}(_react.Component), _class2.displayName = 'Scatter', _class2.propTypes = _extends({}, _ReactUtils.EVENT_ATTRIBUTES, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  zAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  line: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  lineType: _propTypes2.default.oneOf(['fitting', 'joint']),
	  lineJointType: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  className: _propTypes2.default.string,
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  activeIndex: _propTypes2.default.number,
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _propTypes2.default.element, _propTypes2.default.func]),
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    size: _propTypes2.default.number,
	    node: _propTypes2.default.shape({
	      x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	      y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	      z: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	    }),
	    payload: _propTypes2.default.any
	  })),
	  hide: _propTypes2.default.bool,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	  hide: false,
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	}, _class2.getComposedData = function (_ref3) {
	  var xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      zAxis = _ref3.zAxis,
	      item = _ref3.item,
	      displayedData = _ref3.displayedData,
	      onItemMouseLeave = _ref3.onItemMouseLeave,
	      onItemMouseEnter = _ref3.onItemMouseEnter,
	      offset = _ref3.offset,
	      xAxisTicks = _ref3.xAxisTicks;
	
	  var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell2.default);
	  var xAxisDataKey = (0, _isNil3.default)(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
	  var yAxisDataKey = (0, _isNil3.default)(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
	  var zAxisDataKey = zAxis && zAxis.dataKey;
	  var defaultRangeZ = zAxis ? zAxis.range : _ZAxis2.default.defaultProps.range;
	  var defaultZ = defaultRangeZ && defaultRangeZ[0];
	  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
	  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
	  var points = displayedData.map(function (entry, index) {
	    var x = entry[xAxisDataKey];
	    var y = entry[yAxisDataKey];
	    var z = !(0, _isNil3.default)(zAxisDataKey) && entry[zAxisDataKey] || '-';
	    var tooltipPayload = [{ name: xAxis.name || xAxis.dataKey, unit: xAxis.unit || '', value: x, payload: entry }, { name: yAxis.name || yAxis.dataKey, unit: yAxis.unit || '', value: y, payload: entry }];
	
	    if (z !== '-') {
	      tooltipPayload.push({
	        name: zAxis.name || zAxis.dataKey, unit: zAxis.unit || '', value: z, payload: entry
	      });
	    }
	    var cx = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: xAxis, ticks: xAxisTicks, bandSize: xBandSize, entry: entry, index: index
	    });
	    var cy = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: yAxis, ticks: xAxisTicks, bandSize: yBandSize, entry: entry, index: index
	    });
	    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
	    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
	
	    return _extends({}, entry, { cx: cx, cy: cy,
	      x: cx - radius,
	      y: cy - radius,
	      xAxis: xAxis, yAxis: yAxis, zAxis: zAxis,
	      width: 2 * radius,
	      height: 2 * radius,
	      size: size,
	      node: { x: x, y: y, z: z },
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: { x: cx, y: cy },
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	
	  return _extends({
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter,
	    points: points
	  }, offset);
	}, _temp2)) || _class;
	
	exports.default = Scatter;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Legend
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DefaultLegendContent = __webpack_require__(740);
	
	var _DefaultLegendContent2 = _interopRequireDefault(_DefaultLegendContent);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultLegendContent2.default, props);
	};
	
	var EPS = 1;
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var Legend = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Legend, _Component);
	
	  function Legend() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Legend.__proto__ || Object.getPrototypeOf(Legend)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Legend, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'getBBox',
	    value: function getBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return { width: boxWidth, height: boxHeight };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getDefaultPosition',
	    value: function getDefaultPosition(style) {
	      var _props = this.props,
	          layout = _props.layout,
	          align = _props.align,
	          verticalAlign = _props.verticalAlign,
	          margin = _props.margin,
	          chartWidth = _props.chartWidth,
	          chartHeight = _props.chartHeight;
	
	      var hPos = void 0,
	          vPos = void 0;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || { width: 0 };
	          hPos = { left: ((chartWidth || 0) - box.width) / 2 };
	        } else {
	          hPos = align === 'right' ? { right: margin && margin.right || 0 } : { left: margin && margin.left || 0 };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || { height: 0 };
	          vPos = { top: ((chartHeight || 0) - _box.height) / 2 };
	        } else {
	          vPos = verticalAlign === 'bottom' ? { bottom: margin && margin.bottom || 0 } : { top: margin && margin.top || 0 };
	        }
	      }
	
	      return _extends({}, hPos, vPos);
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state2 = this.state,
	          boxWidth = _state2.boxWidth,
	          boxHeight = _state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          }, function () {
	            if (onBBoxUpdate) {
	              onBBoxUpdate(box);
	            }
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          content = _props2.content,
	          width = _props2.width,
	          height = _props2.height,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), wrapperStyle);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-legend-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, this.props)
	      );
	    }
	  }], [{
	    key: 'getWithHeight',
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      } else if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  wrapperStyle: _propTypes2.default.object,
	  chartWidth: _propTypes2.default.number,
	  chartHeight: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  iconSize: _propTypes2.default.number,
	  iconType: _propTypes2.default.oneOf(ICON_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes2.default.oneOf(['top', 'bottom', 'middle']),
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    left: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  }),
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    id: _propTypes2.default.any,
	    type: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  formatter: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onBBoxUpdate: _propTypes2.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	}, _temp2)) || _class;
	
	exports.default = Legend;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ComposedChart = exports.RadialBarChart = exports.AreaChart = exports.ScatterChart = exports.RadarChart = exports.Sankey = exports.Treemap = exports.PieChart = exports.BarChart = exports.LineChart = exports.ErrorBar = exports.ZAxis = exports.YAxis = exports.XAxis = exports.Scatter = exports.Bar = exports.Area = exports.Line = exports.CartesianGrid = exports.CartesianAxis = exports.ReferenceArea = exports.ReferenceDot = exports.ReferenceLine = exports.Brush = exports.RadialBar = exports.Radar = exports.Pie = exports.PolarAngleAxis = exports.PolarRadiusAxis = exports.PolarGrid = exports.Symbols = exports.Cross = exports.Dot = exports.Polygon = exports.Rectangle = exports.Curve = exports.Sector = exports.LabelList = exports.Label = exports.Text = exports.Cell = exports.ResponsiveContainer = exports.Tooltip = exports.Legend = exports.Layer = exports.Surface = undefined;
	
	__webpack_require__(744);
	
	var _Surface2 = __webpack_require__(182);
	
	var _Surface3 = _interopRequireDefault(_Surface2);
	
	var _Layer2 = __webpack_require__(26);
	
	var _Layer3 = _interopRequireDefault(_Layer2);
	
	var _Legend2 = __webpack_require__(397);
	
	var _Legend3 = _interopRequireDefault(_Legend2);
	
	var _Tooltip2 = __webpack_require__(201);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _ResponsiveContainer2 = __webpack_require__(742);
	
	var _ResponsiveContainer3 = _interopRequireDefault(_ResponsiveContainer2);
	
	var _Cell2 = __webpack_require__(181);
	
	var _Cell3 = _interopRequireDefault(_Cell2);
	
	var _Text2 = __webpack_require__(106);
	
	var _Text3 = _interopRequireDefault(_Text2);
	
	var _Label2 = __webpack_require__(83);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _LabelList2 = __webpack_require__(84);
	
	var _LabelList3 = _interopRequireDefault(_LabelList2);
	
	var _Sector2 = __webpack_require__(204);
	
	var _Sector3 = _interopRequireDefault(_Sector2);
	
	var _Curve2 = __webpack_require__(117);
	
	var _Curve3 = _interopRequireDefault(_Curve2);
	
	var _Rectangle2 = __webpack_require__(118);
	
	var _Rectangle3 = _interopRequireDefault(_Rectangle2);
	
	var _Polygon2 = __webpack_require__(399);
	
	var _Polygon3 = _interopRequireDefault(_Polygon2);
	
	var _Dot2 = __webpack_require__(107);
	
	var _Dot3 = _interopRequireDefault(_Dot2);
	
	var _Cross2 = __webpack_require__(476);
	
	var _Cross3 = _interopRequireDefault(_Cross2);
	
	var _Symbols2 = __webpack_require__(400);
	
	var _Symbols3 = _interopRequireDefault(_Symbols2);
	
	var _PolarGrid2 = __webpack_require__(743);
	
	var _PolarGrid3 = _interopRequireDefault(_PolarGrid2);
	
	var _PolarRadiusAxis2 = __webpack_require__(203);
	
	var _PolarRadiusAxis3 = _interopRequireDefault(_PolarRadiusAxis2);
	
	var _PolarAngleAxis2 = __webpack_require__(202);
	
	var _PolarAngleAxis3 = _interopRequireDefault(_PolarAngleAxis2);
	
	var _Pie2 = __webpack_require__(473);
	
	var _Pie3 = _interopRequireDefault(_Pie2);
	
	var _Radar2 = __webpack_require__(474);
	
	var _Radar3 = _interopRequireDefault(_Radar2);
	
	var _RadialBar2 = __webpack_require__(475);
	
	var _RadialBar3 = _interopRequireDefault(_RadialBar2);
	
	var _Brush2 = __webpack_require__(468);
	
	var _Brush3 = _interopRequireDefault(_Brush2);
	
	var _ReferenceLine2 = __webpack_require__(472);
	
	var _ReferenceLine3 = _interopRequireDefault(_ReferenceLine2);
	
	var _ReferenceDot2 = __webpack_require__(471);
	
	var _ReferenceDot3 = _interopRequireDefault(_ReferenceDot2);
	
	var _ReferenceArea2 = __webpack_require__(470);
	
	var _ReferenceArea3 = _interopRequireDefault(_ReferenceArea2);
	
	var _CartesianAxis2 = __webpack_require__(469);
	
	var _CartesianAxis3 = _interopRequireDefault(_CartesianAxis2);
	
	var _CartesianGrid2 = __webpack_require__(729);
	
	var _CartesianGrid3 = _interopRequireDefault(_CartesianGrid2);
	
	var _Line2 = __webpack_require__(395);
	
	var _Line3 = _interopRequireDefault(_Line2);
	
	var _Area2 = __webpack_require__(393);
	
	var _Area3 = _interopRequireDefault(_Area2);
	
	var _Bar2 = __webpack_require__(394);
	
	var _Bar3 = _interopRequireDefault(_Bar2);
	
	var _Scatter2 = __webpack_require__(396);
	
	var _Scatter3 = _interopRequireDefault(_Scatter2);
	
	var _XAxis2 = __webpack_require__(115);
	
	var _XAxis3 = _interopRequireDefault(_XAxis2);
	
	var _YAxis2 = __webpack_require__(116);
	
	var _YAxis3 = _interopRequireDefault(_YAxis2);
	
	var _ZAxis2 = __webpack_require__(200);
	
	var _ZAxis3 = _interopRequireDefault(_ZAxis2);
	
	var _ErrorBar2 = __webpack_require__(180);
	
	var _ErrorBar3 = _interopRequireDefault(_ErrorBar2);
	
	var _LineChart2 = __webpack_require__(733);
	
	var _LineChart3 = _interopRequireDefault(_LineChart2);
	
	var _BarChart2 = __webpack_require__(731);
	
	var _BarChart3 = _interopRequireDefault(_BarChart2);
	
	var _PieChart2 = __webpack_require__(734);
	
	var _PieChart3 = _interopRequireDefault(_PieChart2);
	
	var _Treemap2 = __webpack_require__(739);
	
	var _Treemap3 = _interopRequireDefault(_Treemap2);
	
	var _Sankey2 = __webpack_require__(737);
	
	var _Sankey3 = _interopRequireDefault(_Sankey2);
	
	var _RadarChart2 = __webpack_require__(735);
	
	var _RadarChart3 = _interopRequireDefault(_RadarChart2);
	
	var _ScatterChart2 = __webpack_require__(738);
	
	var _ScatterChart3 = _interopRequireDefault(_ScatterChart2);
	
	var _AreaChart2 = __webpack_require__(730);
	
	var _AreaChart3 = _interopRequireDefault(_AreaChart2);
	
	var _RadialBarChart2 = __webpack_require__(736);
	
	var _RadialBarChart3 = _interopRequireDefault(_RadialBarChart2);
	
	var _ComposedChart2 = __webpack_require__(732);
	
	var _ComposedChart3 = _interopRequireDefault(_ComposedChart2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Surface = _Surface3.default;
	exports.Layer = _Layer3.default;
	exports.Legend = _Legend3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.ResponsiveContainer = _ResponsiveContainer3.default;
	exports.Cell = _Cell3.default;
	exports.Text = _Text3.default;
	exports.Label = _Label3.default;
	exports.LabelList = _LabelList3.default;
	exports.Sector = _Sector3.default;
	exports.Curve = _Curve3.default;
	exports.Rectangle = _Rectangle3.default;
	exports.Polygon = _Polygon3.default;
	exports.Dot = _Dot3.default;
	exports.Cross = _Cross3.default;
	exports.Symbols = _Symbols3.default;
	exports.PolarGrid = _PolarGrid3.default;
	exports.PolarRadiusAxis = _PolarRadiusAxis3.default;
	exports.PolarAngleAxis = _PolarAngleAxis3.default;
	exports.Pie = _Pie3.default;
	exports.Radar = _Radar3.default;
	exports.RadialBar = _RadialBar3.default;
	exports.Brush = _Brush3.default;
	exports.ReferenceLine = _ReferenceLine3.default;
	exports.ReferenceDot = _ReferenceDot3.default;
	exports.ReferenceArea = _ReferenceArea3.default;
	exports.CartesianAxis = _CartesianAxis3.default;
	exports.CartesianGrid = _CartesianGrid3.default;
	exports.Line = _Line3.default;
	exports.Area = _Area3.default;
	exports.Bar = _Bar3.default;
	exports.Scatter = _Scatter3.default;
	exports.XAxis = _XAxis3.default;
	exports.YAxis = _YAxis3.default;
	exports.ZAxis = _ZAxis3.default;
	exports.ErrorBar = _ErrorBar3.default;
	exports.LineChart = _LineChart3.default;
	exports.BarChart = _BarChart3.default;
	exports.PieChart = _PieChart3.default;
	exports.Treemap = _Treemap3.default;
	exports.Sankey = _Sankey3.default;
	exports.RadarChart = _RadarChart3.default;
	exports.ScatterChart = _ScatterChart3.default;
	exports.AreaChart = _AreaChart3.default;
	exports.RadialBarChart = _RadialBarChart3.default;
	exports.ComposedChart = _ComposedChart3.default;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polygon
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Polygon, _Component);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          points = _props.points,
	          className = _props.className;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-polygon', className);
	
	      return _react2.default.createElement('polygon', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.Component), _class2.displayName = 'Polygon', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }))
	}), _temp)) || _class;
	
	exports.default = Polygon;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(213);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle, symbolCross: _d3Shape.symbolCross, symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare, symbolStar: _d3Shape.symbolStar, symbolTriangle: _d3Shape.symbolTriangle, symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = 'symbol' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	    case 'square':
	      return size * size;
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Symbols, _Component);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, (Symbols.__proto__ || Object.getPrototypeOf(Symbols)).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: 'getPath',
	
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          size = _props.size,
	          sizeType = _props.sizeType,
	          type = _props.type;
	
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	
	      return symbol();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          size = _props2.size;
	
	
	      if (cx === +cx && cy === +cy && size === +size) {
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames2.default)('recharts-symbols', className),
	          transform: 'translate(' + cx + ', ' + cy + ')',
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.Component), _class2.displayName = 'Symbols', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  size: _propTypes2.default.number,
	  sizeType: _propTypes2.default.oneOf(['area', 'diameter'])
	}), _class2.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	}, _temp)) || _class;
	
	exports.default = Symbols;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ReactUtils = __webpack_require__(12);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return value + 'px';
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
	    }
	
	    return [].concat(_toConsumableArray(result), [entry]);
	  }, []);
	
	  return formatStrs.join('');
	}
	
	var getStyleString = exports.getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return '' + result + camelToMiddleLine(s) + ':' + autoCompleteStyle(s, style[s]) + ';';
	  }, '');
	};
	
	var getStringSize = exports.getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return { width: 0, height: 0 };
	  }
	
	  var str = '' + text;
	  var styleString = getStyleString(style);
	  var cacheKey = str + '-' + styleString;
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    }
	    // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
	    // https://en.wikipedia.org/wiki/Content_Security_Policy
	    var measurementSpanStyle = _extends({}, SPAN_STYLE, style);
	    Object.keys(measurementSpanStyle).map(function (styleKey) {
	      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
	      return styleKey;
	    });
	
	    measurementSpan.textContent = str;
	
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = { width: rect.width, height: rect.height };
	
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return { width: 0, height: 0 };
	  }
	};
	
	var getOffset = exports.getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = { top: 0, left: 0 };
	
	  // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	var calculateChartCoordinate = exports.calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	__webpack_require__(684);
	
	var _TrendReportModal = __webpack_require__(523);
	
	var _TrendReportModal2 = _interopRequireDefault(_TrendReportModal);
	
	var _AttackInfoModal = __webpack_require__(511);
	
	var _AttackInfoModal2 = _interopRequireDefault(_AttackInfoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryCard = function (_Component) {
	  (0, _inherits3.default)(CategoryCard, _Component);
	
	  function CategoryCard() {
	    (0, _classCallCheck3.default)(this, CategoryCard);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  CategoryCard.prototype.render = function render() {
	    var dataComplianceSection = [];
	    dataComplianceSection.push(_react2.default.createElement(
	      _reactMd.Grid,
	      {
	        key: this.props.id + '-A',
	        className: 'expanded-category-grid'
	      },
	      _react2.default.createElement(
	        _reactMd.Cell,
	        { size: 5, className: 'expanded-title-cell' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'expanded-left-title' },
	          'Potential Data Leaked'
	        )
	      ),
	      _react2.default.createElement(_reactMd.Cell, { size: 2 }),
	      _react2.default.createElement(
	        _reactMd.Cell,
	        { size: 5, className: 'expanded-title-cell' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'expanded-right-title' },
	          'Compliance Risks'
	        )
	      ),
	      _react2.default.createElement(
	        _reactMd.Cell,
	        { size: 12 },
	        _react2.default.createElement('hr', { className: 'horizontal-rule' })
	      ),
	      _react2.default.createElement(
	        _reactMd.Cell,
	        { size: 5 },
	        _react2.default.createElement(
	          'h2',
	          { className: 'expanded-left-text' },
	          this.props.dataLeakedA
	        )
	      ),
	      _react2.default.createElement(
	        _reactMd.Cell,
	        { size: 2 },
	        _react2.default.createElement('img', { className: 'expanded-icon', src: this.props.iconA, alt: '' })
	      ),
	      _react2.default.createElement(
	        _reactMd.Cell,
	        { size: 5 },
	        _react2.default.createElement(
	          'h2',
	          { className: 'expanded-right-text' },
	          this.props.complianceA
	        )
	      )
	    ));
	
	    if (this.props.dataLeakedB) {
	      dataComplianceSection.push(_react2.default.createElement(
	        _reactMd.Grid,
	        { key: this.props.id + '-B', className: 'expanded-category-grid' },
	        _react2.default.createElement(
	          _reactMd.Cell,
	          { size: 5 },
	          _react2.default.createElement(
	            'h2',
	            { className: 'expanded-left-text' },
	            this.props.dataLeakedB
	          )
	        ),
	        _react2.default.createElement(
	          _reactMd.Cell,
	          { size: 2 },
	          _react2.default.createElement('img', { className: 'expanded-icon', src: this.props.iconB, alt: '' })
	        ),
	        _react2.default.createElement(
	          _reactMd.Cell,
	          { size: 5 },
	          _react2.default.createElement(
	            'h2',
	            { className: 'expanded-right-text' },
	            this.props.complianceB
	          )
	        )
	      ));
	    }
	
	    return _react2.default.createElement(
	      _reactMd.Card,
	      { key: this.props.title, className: 'md-block-centered category-card' },
	      _react2.default.createElement(
	        _reactMd.CardTitle,
	        {
	          title: '',
	          avatar: _react2.default.createElement(_reactMd.Avatar, { src: this.props.titleAvatar, role: 'presentation' })
	        },
	        _react2.default.createElement(
	          'h2',
	          { className: 'md-card-title--title md-text' },
	          this.props.title
	        ),
	        _react2.default.createElement(_AttackInfoModal2.default, {
	          id: this.props.id,
	          title: this.props.title,
	          whyText: this.props.whyText,
	          riskText: this.props.riskText,
	          riskScoreMalice: this.props.riskScoreMalice,
	          riskScoreExposure: this.props.riskScoreExposure,
	          riskScoreBreach: this.props.riskScoreBreach,
	          className: 'modal-button'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'alert-button-div' },
	          _react2.default.createElement(_TrendReportModal2.default, {
	            id: this.props.id,
	            title: this.props.title,
	            className: 'modal-button'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _reactMd.CardActions,
	        { expander: true },
	        _react2.default.createElement(
	          _reactMd.Grid,
	          { className: 'category-stats-grid' },
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'category-grid-cell zero-margin-cell' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'category-big-number category-grid-inside' },
	              this.props.percentage
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            {
	              size: 7,
	              className: 'category-grid-cell zero-margin-cell larger-prose-cell'
	            },
	            _react2.default.createElement(
	              'h3',
	              { className: 'category-grid-inside category-prose' },
	              this.props.prose
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactMd.CardText,
	        { expandable: true },
	        _react2.default.createElement(
	          _reactMd.Grid,
	          { className: 'category-stats-grid' },
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 6, className: 'zero-margin-cell' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'category-count-number' },
	              this.props.numTotalIncidents
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: 'category-count-text' },
	              'total incidents'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 6, className: 'zero-margin-cell' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'category-count-number' },
	              this.props.numMonthlyAvg
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: 'category-count-text' },
	              'monthly average incidents'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12 },
	            _react2.default.createElement('hr', { className: 'lighter-rule' })
	          )
	        ),
	        dataComplianceSection
	      )
	    );
	  };
	
	  return CategoryCard;
	}(_react.Component);
	
	exports.default = CategoryCard;
	module.exports = exports['default'];

/***/ }),
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(553), __webpack_require__(554), __webpack_require__(556), __webpack_require__(555), __webpack_require__(425), __webpack_require__(558), __webpack_require__(423)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.8. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(215),
	    setCacheAdd = __webpack_require__(647),
	    setCacheHas = __webpack_require__(648);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(189),
	    stackClear = __webpack_require__(652),
	    stackDelete = __webpack_require__(653),
	    stackGet = __webpack_require__(654),
	    stackHas = __webpack_require__(655),
	    stackSet = __webpack_require__(656);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(581),
	    createBaseEach = __webpack_require__(608);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(432),
	    isFlattenable = __webpack_require__(627);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(441),
	    toKey = __webpack_require__(194);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 436 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(433),
	    isArrayLike = __webpack_require__(125);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(113),
	    overRest = __webpack_require__(646),
	    setToString = __webpack_require__(650);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 440 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(24),
	    isKey = __webpack_require__(219),
	    stringToPath = __webpack_require__(658),
	    toString = __webpack_require__(677);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(429),
	    arraySome = __webpack_require__(577),
	    cacheHas = __webpack_require__(440);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(220),
	    isArrayLike = __webpack_require__(125),
	    isIndex = __webpack_require__(218),
	    isObject = __webpack_require__(61);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(61);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 447 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 448 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(61),
	    now = __webpack_require__(670),
	    toNumber = __webpack_require__(457);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(59),
	    stubFalse = __webpack_require__(673);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(480)(module)))

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(80),
	    getPrototype = __webpack_require__(616),
	    isObjectLike = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(591),
	    baseUnary = __webpack_require__(217),
	    nodeUtil = __webpack_require__(644);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(191),
	    baseGt = __webpack_require__(436),
	    baseIteratee = __webpack_require__(112);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(191),
	    baseLt = __webpack_require__(437),
	    identity = __webpack_require__(113);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(610);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(434),
	    baseOrderBy = __webpack_require__(595),
	    baseRest = __webpack_require__(439),
	    isIterateeCall = __webpack_require__(444);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(61),
	    isSymbol = __webpack_require__(114);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 458 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(60);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AnimateManager = __webpack_require__(720);
	
	var _AnimateManager2 = _interopRequireDefault(_AnimateManager);
	
	var _PureRender = __webpack_require__(721);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _easing = __webpack_require__(465);
	
	var _configUpdate = __webpack_require__(722);
	
	var _configUpdate2 = _interopRequireDefault(_configUpdate);
	
	var _util = __webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Animate = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate(props, context) {
	    _classCallCheck(this, Animate);
	
	    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props, context));
	
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	
	
	    _this.handleStyleChange = _this.handleStyleChange.bind(_this);
	    _this.changeStyle = _this.changeStyle.bind(_this);
	
	    if (!isActive) {
	      _this.state = { style: {} };
	
	      // if children is a function and animation is not active, set style to 'to'
	      if (typeof children === 'function') {
	        _this.state = { style: to };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = { style: steps[0].style };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	
	        return _possibleConstructorReturn(_this);
	      }
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = { style: {} };
	    }
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isActive = _props.isActive,
	          canBegin = _props.canBegin;
	
	
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isActive = nextProps.isActive,
	          canBegin = nextProps.canBegin,
	          attributeName = nextProps.attributeName,
	          shouldReAnimate = nextProps.shouldReAnimate;
	
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        this.setState({
	          style: attributeName ? _defineProperty({}, attributeName, nextProps.to) : nextProps.to
	        });
	
	        return;
	      }
	
	      var animateProps = ['to', 'canBegin', 'isActive'];
	
	      if ((0, _isEqual3.default)(this.props.to, nextProps.to) && this.props.canBegin && this.props.isActive) {
	        return;
	      }
	
	      var isTriggered = !this.props.canBegin || !this.props.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? nextProps.from : this.props.to;
	
	      this.setState({
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      });
	
	      this.runAnimation(_extends({}, nextProps, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: 'runJSAnimation',
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	
	      var startAnimation = (0, _configUpdate2.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'runStepAnimation',
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === undefined ? 0 : _steps$$duration;
	
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === undefined ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	
	
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return [].concat(_toConsumableArray(sequence), [_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	        var newStyle = _extends({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return [].concat(_toConsumableArray(sequence), [newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: 'runAnimation',
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager2.default)();
	      }
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsFrom = props.from,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	
	
	      var manager = this.manager;
	
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	
	      manager.start([onAnimationStart, begin, _extends({}, to, { transition: transition }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'handleStyleChange',
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: 'changeStyle',
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          begin = _props2.begin,
	          duration = _props2.duration,
	          attributeName = _props2.attributeName,
	          easing = _props2.easing,
	          isActive = _props2.isActive,
	          steps = _props2.steps,
	          from = _props2.from,
	          to = _props2.to,
	          canBegin = _props2.canBegin,
	          onAnimationEnd = _props2.onAnimationEnd,
	          shouldReAnimate = _props2.shouldReAnimate,
	          onAnimationReStart = _props2.onAnimationReStart,
	          others = _objectWithoutProperties(_props2, ['children', 'begin', 'duration', 'attributeName', 'easing', 'isActive', 'steps', 'from', 'to', 'canBegin', 'onAnimationEnd', 'shouldReAnimate', 'onAnimationReStart']);
	
	      var count = _react.Children.count(children);
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === undefined ? {} : _container$props$styl,
	            className = _container$props.className;
	
	
	        var res = (0, _react.cloneElement)(container, _extends({}, others, {
	          style: _extends({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        var onlyChild = _react.Children.only(children);
	
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react.Children.map(children, function (child) {
	          return cloneContainer(child);
	        })
	      );
	    }
	  }]);
	
	  return Animate;
	}(_react.Component), _class2.displayName = 'Animate', _class2.propTypes = {
	  from: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  to: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  attributeName: _propTypes2.default.string,
	  // animation duration
	  duration: _propTypes2.default.number,
	  begin: _propTypes2.default.number,
	  easing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    duration: _propTypes2.default.number.isRequired,
	    style: _propTypes2.default.object.isRequired,
	    easing: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes2.default.func]),
	    // transition css properties(dash case), optional
	    properties: _propTypes2.default.arrayOf('string'),
	    onAnimationEnd: _propTypes2.default.func
	  })),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  isActive: _propTypes2.default.bool,
	  canBegin: _propTypes2.default.bool,
	  onAnimationEnd: _propTypes2.default.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _propTypes2.default.bool,
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationReStart: _propTypes2.default.func
	}, _class2.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	}, _temp)) || _class;
	
	exports.default = Animate;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = undefined;
	
	var _util = __webpack_require__(198);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    var newParams = [].concat(_toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)), [0]);
	
	    return multyTime(newParams, t);
	  };
	};
	
	// calculate cubic-bezier using Newton's method
	var configBezier = exports.configBezier = function configBezier() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      default:
	        (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\', instead received %s', args);
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	
	  return bezier;
	};
	
	var configSpring = exports.configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === undefined ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === undefined ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === undefined ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	
	  return stepper;
	};
	
	var configEasing = exports.configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	      case 'spring':
	        return configSpring();
	      default:
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	
	  return null;
	};

/***/ }),
/* 466 */,
/* 467 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = exports.PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(undefined, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(undefined, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	
	      return fn.apply(undefined, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = exports.curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	var range = exports.range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	var map = exports.map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	
	var compose = exports.compose = function compose() {
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var reverse = exports.reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  }
	
	  // can be string
	  return arr.split('').reverse.join('');
	};
	
	var memoize = exports.memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	
	  return function () {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(undefined, args);
	
	    return lastResult;
	  };
	};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(455);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Brush
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(424);
	
	var _ChartUtils = __webpack_require__(33);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(106);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _DataUtils = __webpack_require__(19);
	
	var _CssPrefixUtils = __webpack_require__(745);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Brush = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Brush, _Component);
	
	  function Brush(props) {
	    _classCallCheck(this, Brush);
	
	    var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, 1000);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_this, 'endX')
	    };
	
	    _this.state = props.data && props.data.length ? _this.updateScale(props) : {};
	    return _this;
	  }
	
	  _createClass(Brush, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          x = _props.x,
	          travellerWidth = _props.travellerWidth,
	          updateId = _props.updateId;
	
	
	      if ((nextProps.data !== data || nextProps.updateId !== updateId) && nextProps.data && nextProps.data.length) {
	        this.setState(this.updateScale(nextProps));
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: 'getIndexInRange',
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	      var _props2 = this.props,
	          gap = _props2.gap,
	          data = _props2.data;
	
	      var lastIndex = data.length - 1;
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.getIndexInRange(this.scaleValues, max);
	      return {
	        startIndex: minIndex - minIndex % gap,
	        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
	      };
	    }
	  }, {
	    key: 'getTextOfTick',
	    value: function getTextOfTick(index) {
	      var _props3 = this.props,
	          data = _props3.data,
	          tickFormatter = _props3.tickFormatter,
	          dataKey = _props3.dataKey;
	
	      var text = (0, _ChartUtils.getValueByDataKey)(data[index], dataKey, index);
	
	      return (0, _isFunction3.default)(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: 'handleSlideDrag',
	    value: function handleSlideDrag(e) {
	      var _state = this.state,
	          slideMoveStartX = _state.slideMoveStartX,
	          startX = _state.startX,
	          endX = _state.endX;
	      var _props4 = this.props,
	          x = _props4.x,
	          width = _props4.width,
	          travellerWidth = _props4.travellerWidth,
	          startIndex = _props4.startIndex,
	          endIndex = _props4.endIndex,
	          onChange = _props4.onChange;
	
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerDragStart',
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerMove',
	    value: function handleTravellerMove(e) {
	      var _setState;
	
	      var _state2 = this.state,
	          brushMoveStartX = _state2.brushMoveStartX,
	          movingTravellerId = _state2.movingTravellerId,
	          endX = _state2.endX,
	          startX = _state2.startX;
	
	      var prevValue = this.state[movingTravellerId];
	
	      var _props5 = this.props,
	          x = _props5.x,
	          width = _props5.width,
	          travellerWidth = _props5.travellerWidth,
	          onChange = _props5.onChange,
	          gap = _props5.gap,
	          data = _props5.data;
	
	      var params = { startX: this.state.startX, endX: this.state.endX };
	
	      var delta = e.pageX - brushMoveStartX;
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	
	      var newIndex = this.getIndex(params);
	      var startIndex = newIndex.startIndex,
	          endIndex = newIndex.endIndex;
	
	      var isFullGap = function isFullGap() {
	        var lastIndex = data.length - 1;
	        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
	          return true;
	        }
	        return false;
	      };
	
	      this.setState((_setState = {}, _defineProperty(_setState, movingTravellerId, prevValue + delta), _defineProperty(_setState, 'brushMoveStartX', e.pageX), _setState), function () {
	        if (onChange) {
	          if (isFullGap()) {
	            onChange(newIndex);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'updateScale',
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	
	      var len = data.length;
	      this.scale = (0, _d3Scale.scalePoint)().domain((0, _range3.default)(0, len)).range([x, x + width - travellerWidth]);
	      this.scaleValues = this.scale.domain().map(function (entry) {
	        return _this3.scale(entry);
	      });
	      return {
	        isTextActive: false,
	        isSlideMoving: false,
	        isTravellerMoving: false,
	        startX: this.scale(startIndex),
	        endX: this.scale(endIndex)
	      };
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          fill = _props6.fill,
	          stroke = _props6.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: 'renderPanorama',
	    value: function renderPanorama() {
	      var _props7 = this.props,
	          x = _props7.x,
	          y = _props7.y,
	          width = _props7.width,
	          height = _props7.height,
	          data = _props7.data,
	          children = _props7.children,
	          padding = _props7.padding;
	
	      var chartElement = _react.Children.only(children);
	
	      if (!chartElement) {
	        return null;
	      }
	
	      return _react2.default.cloneElement(chartElement, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        margin: padding,
	        compact: true,
	        data: data
	      });
	    }
	  }, {
	    key: 'renderTraveller',
	    value: function renderTraveller(travellerX, id) {
	      var _props8 = this.props,
	          y = _props8.y,
	          travellerWidth = _props8.travellerWidth,
	          height = _props8.height,
	          stroke = _props8.stroke;
	
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(travellerX, this.props.x);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: 'recharts-brush-traveller',
	          onMouseEnter: this.handleEnterSlideOrTraveller,
	          onMouseLeave: this.handleLeaveSlideOrTraveller,
	          onMouseDown: this.travellerDragStartHandlers[id],
	          onTouchStart: this.travellerDragStartHandlers[id],
	          style: { cursor: 'col-resize' }
	        },
	        _react2.default.createElement('rect', {
	          x: x,
	          y: y,
	          width: travellerWidth,
	          height: height,
	          fill: stroke,
	          stroke: 'none'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY,
	          x2: x + travellerWidth - 1,
	          y2: lineY,
	          fill: 'none',
	          stroke: '#fff'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY + 2,
	          x2: x + travellerWidth - 1,
	          y2: lineY + 2,
	          fill: 'none',
	          stroke: '#fff'
	        })
	      );
	    }
	  }, {
	    key: 'renderSlide',
	    value: function renderSlide(startX, endX) {
	      var _props9 = this.props,
	          y = _props9.y,
	          height = _props9.height,
	          stroke = _props9.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        className: 'recharts-brush-slide',
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: { cursor: 'move' },
	        stroke: 'none',
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: 'renderText',
	    value: function renderText() {
	      var _props10 = this.props,
	          startIndex = _props10.startIndex,
	          endIndex = _props10.endIndex,
	          y = _props10.y,
	          height = _props10.height,
	          travellerWidth = _props10.travellerWidth,
	          stroke = _props10.stroke;
	      var _state3 = this.state,
	          startX = _state3.startX,
	          endX = _state3.endX;
	
	      var offset = 5;
	      var attrs = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-brush-texts' },
	        _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            textAnchor: 'end',
	            verticalAnchor: 'middle',
	            x: Math.min(startX, endX) - offset,
	            y: y + height / 2
	          }, attrs),
	          this.getTextOfTick(startIndex)
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            textAnchor: 'start',
	            verticalAnchor: 'middle',
	            x: Math.max(startX, endX) + travellerWidth + offset,
	            y: y + height / 2
	          }, attrs),
	          this.getTextOfTick(endIndex)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props11 = this.props,
	          data = _props11.data,
	          className = _props11.className,
	          children = _props11.children,
	          x = _props11.x,
	          y = _props11.y,
	          width = _props11.width,
	          height = _props11.height;
	      var _state4 = this.state,
	          startX = _state4.startX,
	          endX = _state4.endX,
	          isTextActive = _state4.isTextActive,
	          isSlideMoving = _state4.isSlideMoving,
	          isTravellerMoving = _state4.isTravellerMoving;
	
	
	      if (!data || !data.length || !(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || width <= 0 || height <= 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-brush', className);
	      var isPanoramic = _react2.default.Children.count(children) === 1;
	      var style = (0, _CssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          onMouseMove: this.handleDrag,
	          onMouseLeave: this.handleLeaveWrapper,
	          onMouseUp: this.handleDragEnd,
	          onTouchEnd: this.handleDragEnd,
	          onTouchMove: this.handleTouchMove,
	          style: style
	        },
	        this.renderBackground(),
	        isPanoramic && this.renderPanorama(),
	        this.renderSlide(startX, endX),
	        this.renderTraveller(startX, 'startX'),
	        this.renderTraveller(endX, 'endX'),
	        (isTextActive || isSlideMoving || isTravellerMoving) && this.renderText()
	      );
	    }
	  }]);
	
	  return Brush;
	}(_react.Component), _class2.displayName = 'Brush', _class2.propTypes = {
	  className: _propTypes2.default.string,
	
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number.isRequired,
	  travellerWidth: _propTypes2.default.number,
	  gap: _propTypes2.default.number,
	  padding: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  data: _propTypes2.default.array,
	  startIndex: _propTypes2.default.number,
	  endIndex: _propTypes2.default.number,
	  tickFormatter: _propTypes2.default.func,
	
	  children: _propTypes2.default.node,
	
	  onChange: _propTypes2.default.func,
	  updateId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _class2.defaultProps = {
	  height: 40,
	  travellerWidth: 5,
	  gap: 1,
	  fill: '#fff',
	  stroke: '#666',
	  padding: { top: 1, right: 1, bottom: 1, left: 1 }
	}, _temp)) || _class;
	
	exports.default = Brush;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Cartesian Axis
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _DOMUtils = __webpack_require__(401);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(106);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Label = __webpack_require__(83);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _DataUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianAxis = (_temp = _class = function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, (CartesianAxis.__proto__ || Object.getPrototypeOf(CartesianAxis)).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ['viewBox']);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _props = this.props,
	          viewBoxOld = _props.viewBox,
	          restPropsOld = _objectWithoutProperties(_props, ['viewBox']);
	
	      return !(0, _PureRender.shallowEqual)(viewBox, viewBoxOld) || !(0, _PureRender.shallowEqual)(restProps, restPropsOld) || !(0, _PureRender.shallowEqual)(state, this.state);
	    }
	
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: 'getTickLineCoord',
	    value: function getTickLineCoord(data) {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          width = _props2.width,
	          height = _props2.height,
	          orientation = _props2.orientation,
	          tickSize = _props2.tickSize,
	          mirror = _props2.mirror,
	          tickMargin = _props2.tickMargin;
	
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0,
	          tx = void 0,
	          ty = void 0;
	
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = y2 - sign * finalTickSize;
	          ty = y1 - sign * tickMargin;
	          tx = tickCoord;
	          break;
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = x2 - sign * finalTickSize;
	          tx = x1 - sign * tickMargin;
	          ty = tickCoord;
	          break;
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = x2 + sign * finalTickSize;
	          tx = x1 + sign * tickMargin;
	          ty = tickCoord;
	          break;
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = y2 + sign * finalTickSize;
	          ty = y1 + sign * tickMargin;
	          tx = tickCoord;
	          break;
	      }
	
	      return { line: { x1: x1, y1: y1, x2: x2, y2: y2 }, tick: { x: tx, y: ty } };
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var _props3 = this.props,
	          orientation = _props3.orientation,
	          mirror = _props3.mirror;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'getTickVerticalAnchor',
	    value: function getTickVerticalAnchor() {
	      var _props4 = this.props,
	          orientation = _props4.orientation,
	          mirror = _props4.mirror;
	
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props5 = this.props,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height,
	          orientation = _props5.orientation,
	          axisLine = _props5.axisLine,
	          mirror = _props5.mirror;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _extends({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _extends({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-cartesian-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-cartesian-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks(ticks) {
	      var _this2 = this;
	
	      var _props6 = this.props,
	          tickLine = _props6.tickLine,
	          stroke = _props6.stroke,
	          tick = _props6.tick,
	          tickFormatter = _props6.tickFormatter,
	          unit = _props6.unit;
	
	      var finalTicks = CartesianAxis.getTicks(_extends({}, this.props, { ticks: ticks }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	      var items = finalTicks.map(function (entry, i) {
	        var _getTickLineCoord = _this2.getTickLineCoord(entry),
	            lineCoord = _getTickLineCoord.line,
	            tickCoord = _getTickLineCoord.tick;
	
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, tickCoord, {
	          index: i, payload: entry,
	          visibleTicksCount: finalTicks.length
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-cartesian-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-cartesian-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, '' + ((0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value) + (unit || ''))
	        );
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          axisLine = _props7.axisLine,
	          width = _props7.width,
	          height = _props7.height,
	          ticksGenerator = _props7.ticksGenerator,
	          className = _props7.className,
	          hide = _props7.hide;
	
	
	      if (hide) {
	        return null;
	      }
	
	      var _props8 = this.props,
	          ticks = _props8.ticks,
	          noTicksProps = _objectWithoutProperties(_props8, ['ticks']);
	
	      var finalTicks = ticks;
	
	      if ((0, _isFunction3.default)(ticksGenerator)) {
	        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-cartesian-axis', className) },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks(finalTicks),
	        _Label2.default.renderCallByParent(this.props)
	      );
	    }
	  }], [{
	    key: 'getTicks',
	    value: function getTicks(props) {
	      var tick = props.tick,
	          ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter,
	          unit = props.unit;
	
	
	      if (!ticks || !ticks.length || !tick) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap, unit: unit
	        }, true);
	      } else if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap, unit: unit
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({
	        ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap, unit: unit
	      });
	    }
	  }, {
	    key: 'getNumberIntervalTicks',
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: 'getTicksStart',
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap,
	          unit = _ref2.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice();
	      var unitSize = unit ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey] + unitSize;
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _extends({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _extends({}, tail, { isShow: true });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	      for (var i = 0; i < count; i++) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: 'getTicksEnd',
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap,
	          unit = _ref3.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var unitSize = unit ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var i = len - 1; i >= 0; i--) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (i === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component), _class.displayName = 'CartesianAxis', _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  orientation: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  mirror: _propTypes2.default.bool,
	  tickMargin: _propTypes2.default.number.isRequired,
	
	  minTickGap: _propTypes2.default.number,
	  ticks: _propTypes2.default.array,
	  tickSize: _propTypes2.default.number,
	  stroke: _propTypes2.default.string,
	  tickFormatter: _propTypes2.default.func,
	  ticksGenerator: _propTypes2.default.func,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: { x: 0, y: 0, width: 0, height: 0 },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  tickMargin: 2,
	  interval: 'preserveEnd'
	}, _temp);
	exports.default = CartesianAxis;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Line
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Label = __webpack_require__(83);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(33);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceArea = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceArea, _Component);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, (ReferenceArea.__proto__ || Object.getPrototypeOf(ReferenceArea)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: 'getRect',
	    value: function getRect(hasX1, hasX2, hasY1, hasY2) {
	      var _props = this.props,
	          xValue1 = _props.x1,
	          xValue2 = _props.x2,
	          yValue1 = _props.y1,
	          yValue2 = _props.y2,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var xScale = xAxis.scale;
	      var yScale = yAxis.scale;
	      var xOffset = xScale.bandwidth ? xScale.bandwidth() / 2 : 0;
	      var yOffset = yScale.bandwidth ? yScale.bandwidth() / 2 : 0;
	      var xRange = xScale.range();
	      var yRange = yScale.range();
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0;
	
	      if (hasX1) {
	        x1 = xScale(xValue1) + xOffset;
	      } else {
	        x1 = xRange[0];
	      }
	
	      if (hasX2) {
	        x2 = xScale(xValue2) + xOffset;
	      } else {
	        x2 = xRange[1];
	      }
	
	      if (hasY1) {
	        y1 = yScale(yValue1) + yOffset;
	      } else {
	        y1 = yRange[0];
	      }
	
	      if (hasY2) {
	        y2 = yScale(yValue2) + yOffset;
	      } else {
	        y2 = yRange[1];
	      }
	
	      if ((0, _ChartUtils.validateCoordinateInRange)(x1, xScale) && (0, _ChartUtils.validateCoordinateInRange)(x2, xScale) && (0, _ChartUtils.validateCoordinateInRange)(y1, yScale) && (0, _ChartUtils.validateCoordinateInRange)(y2, yScale)) {
	        return {
	          x: Math.min(x1, x2),
	          y: Math.min(y1, y2),
	          width: Math.abs(x2 - x1),
	          height: Math.abs(y2 - y1)
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderRect',
	    value: function renderRect(option, props) {
	      var rect = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rect = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rect = option(props);
	      } else {
	        rect = _react2.default.createElement(_Rectangle2.default, _extends({}, props, {
	          className: 'recharts-reference-area-rect'
	        }));
	      }
	
	      return rect;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          x1 = _props2.x1,
	          x2 = _props2.x2,
	          y1 = _props2.y1,
	          y2 = _props2.y2,
	          className = _props2.className;
	
	
	      var hasX1 = (0, _DataUtils.isNumOrStr)(x1);
	      var hasX2 = (0, _DataUtils.isNumOrStr)(x2);
	      var hasY1 = (0, _DataUtils.isNumOrStr)(y1);
	      var hasY2 = (0, _DataUtils.isNumOrStr)(y2);
	
	      if (!hasX1 && !hasX2 && !hasY1 && !hasY2) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX1, hasX2, hasY1, hasY2);
	
	      if (!rect) {
	        return null;
	      }
	
	      var shape = this.props.shape;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-reference-area', className) },
	        this.renderRect(shape, _extends({}, this.props, rect)),
	        _Label2.default.renderCallByParent(this.props, rect)
	      );
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.Component), _class2.displayName = 'ReferenceArea', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x1: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  x2: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y1: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y2: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  className: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceArea;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Dot
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Dot = __webpack_require__(107);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _Label = __webpack_require__(83);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceDot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceDot, _Component);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, (ReferenceDot.__proto__ || Object.getPrototypeOf(ReferenceDot)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: 'getCoordinate',
	    value: function getCoordinate() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var xScale = xAxis.scale;
	      var yScale = yAxis.scale;
	      var result = {
	        cx: xScale(x) + (xScale.bandwidth ? xScale.bandwidth() / 2 : 0),
	        cy: yScale(y) + (yScale.bandwidth ? yScale.bandwidth() / 2 : 0)
	      };
	
	      if ((0, _ChartUtils.validateCoordinateInRange)(result.cx, xScale) && (0, _ChartUtils.validateCoordinateInRange)(result.cy, yScale)) {
	        return result;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderDot',
	    value: function renderDot(option, props) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react2.default.createElement(_Dot2.default, _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: 'recharts-reference-dot-dot'
	        }));
	      }
	
	      return dot;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          r = _props2.r;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          shape = _props3.shape,
	          className = _props3.className;
	
	
	      var dotProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), coordinate);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-reference-dot', className) },
	        this.renderDot(shape, dotProps),
	        _Label2.default.renderCallByParent(this.props, {
	          x: coordinate.cx - r,
	          y: coordinate.cy - r,
	          width: 2 * r,
	          height: 2 * r
	        })
	      );
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.Component), _class2.displayName = 'ReferenceDot', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  r: _propTypes2.default.number,
	
	  xAxis: _propTypes2.default.shape({ scale: _propTypes2.default.func }),
	  yAxis: _propTypes2.default.shape({ scale: _propTypes2.default.func }),
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  className: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceDot;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Reference Line
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _Label = __webpack_require__(83);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderLine = function renderLine(option, props) {
	  var line = void 0;
	
	  if (_react2.default.isValidElement(option)) {
	    line = _react2.default.cloneElement(option, props);
	  } else if ((0, _isFunction3.default)(option)) {
	    line = option(props);
	  } else {
	    line = _react2.default.createElement('line', _extends({}, props, {
	      className: 'recharts-reference-line-line'
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceLine, _Component);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, (ReferenceLine.__proto__ || Object.getPrototypeOf(ReferenceLine)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: 'getEndPoints',
	    value: function getEndPoints(isX, isY) {
	      var _props = this.props,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          viewBox = _props.viewBox;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	
	      if (isY) {
	        var value = this.props.y;
	        var scale = yAxis.scale;
	
	        var offset = scale.bandwidth ? scale.bandwidth() / 2 : 0;
	        var coord = scale(value) + offset;
	
	        if ((0, _ChartUtils.validateCoordinateInRange)(coord, scale)) {
	          return yAxis.orientation === 'left' ? [{ x: x, y: coord }, { x: x + width, y: coord }] : [{ x: x + width, y: coord }, { x: x, y: coord }];
	        }
	      } else if (isX) {
	        var _value = this.props.x;
	        var _scale = xAxis.scale;
	
	        var _offset = _scale.bandwidth ? _scale.bandwidth() / 2 : 0;
	        var _coord = _scale(_value) + _offset;
	
	        if ((0, _ChartUtils.validateCoordinateInRange)(_coord, _scale)) {
	          return xAxis.orientation === 'top' ? [{ x: _coord, y: y }, { x: _coord, y: y + height }] : [{ x: _coord, y: y + height }, { x: _coord, y: y }];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          shape = _props2.shape,
	          className = _props2.className;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX && !isY) {
	        return null;
	      }
	
	      var endPoints = this.getEndPoints(isX, isY);
	
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          start = _endPoints[0],
	          end = _endPoints[1];
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: start.x,
	        y1: start.y,
	        x2: end.x,
	        y2: end.y
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-reference-line', className) },
	        renderLine(shape, props),
	        _Label2.default.renderCallByParent(this.props, {
	          x: Math.min(props.x1, props.x2),
	          y: Math.min(props.y1, props.y2),
	          width: Math.abs(props.x2 - props.x1),
	          height: Math.abs(props.y2 - props.y1)
	        })
	      );
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.Component), _class2.displayName = 'ReferenceLine', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  className: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  shape: _propTypes2.default.func
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceLine;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(60);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isPlainObject2 = __webpack_require__(451);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(42);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render sectors of a pie
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(63);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Sector = __webpack_require__(204);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Curve = __webpack_require__(117);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Text = __webpack_require__(106);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Label = __webpack_require__(83);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _LabelList = __webpack_require__(84);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _Cell = __webpack_require__(181);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _PolarUtils = __webpack_require__(56);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(33);
	
	var _LogUtils = __webpack_require__(477);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pie = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Pie, _Component);
	
	  function Pie() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pie.__proto__ || Object.getPrototypeOf(Pie)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false, isAnimationStarted: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-pie-'), _this.cachePrevData = function (sectors) {
	      _this.setState({ prevSectors: sectors });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationStarted: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Pie, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          sectors = _props.sectors;
	
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(sectors);
	      }
	    }
	  }, {
	    key: 'getTextAnchor',
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      } else if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: 'isActiveIndex',
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: 'renderLabelLineItem',
	    value: function renderLabelLineItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Curve2.default, _extends({}, props, { type: 'linear', className: 'recharts-pie-label-line' }));
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      }
	      var label = value;
	      if ((0, _isFunction3.default)(option)) {
	        label = option(props);
	        if (_react2.default.isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react2.default.createElement(
	        _Text2.default,
	        _extends({}, props, {
	          alignmentBaseline: 'middle',
	          className: 'recharts-pie-label-text'
	        }),
	        label
	      );
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props2 = this.props,
	          label = _props2.label,
	          labelLine = _props2.labelLine,
	          dataKey = _props2.dataKey,
	          valueKey = _props2.valueKey;
	
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	        var labelProps = _extends({}, pieProps, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	        var lineProps = _extends({}, pieProps, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          index: i,
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
	        });
	        var realDataKey = dataKey;
	        // TODO: compatible to lower versions
	        if ((0, _isNil3.default)(dataKey) && (0, _isNil3.default)(valueKey)) {
	          realDataKey = 'value';
	        } else if ((0, _isNil3.default)(dataKey)) {
	          realDataKey = valueKey;
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          { key: 'label-' + i },
	          labelLine && _this2.renderLabelLineItem(labelLine, lineProps),
	          _this2.renderLabelItem(label, labelProps, (0, _ChartUtils.getValueByDataKey)(entry, realDataKey))
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-pie-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderSectorItem',
	    value: function renderSectorItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      } else if ((0, _isPlainObject3.default)(option)) {
	        return _react2.default.createElement(_Sector2.default, _extends({}, props, option));
	      }
	
	      return _react2.default.createElement(_Sector2.default, props);
	    }
	  }, {
	    key: 'renderSectorsStatically',
	    value: function renderSectorsStatically(sectors) {
	      var _this3 = this;
	
	      var activeShape = this.props.activeShape;
	
	
	      return sectors.map(function (entry, i) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-pie-sector'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	            key: 'sector-' + i
	          }),
	          _this3.renderSectorItem(_this3.isActiveIndex(i) ? activeShape : null, entry)
	        );
	      });
	    }
	  }, {
	    key: 'renderSectorsWithAnimation',
	    value: function renderSectorsWithAnimation() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          sectors = _props3.sectors,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          animationId = _props3.animationId;
	      var prevSectors = this.state.prevSectors;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'pie-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = [];
	          var first = sectors && sectors[0];
	          var curAngle = first.startAngle;
	
	          sectors.forEach(function (entry, index) {
	            var prev = prevSectors && prevSectors[index];
	            var paddingAngle = index > 0 ? entry.paddingAngle : 0;
	
	            if (prev) {
	              var angleIp = (0, _DataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
	              var latest = _extends({}, entry, {
	                startAngle: curAngle + paddingAngle,
	                endAngle: curAngle + angleIp(t) + paddingAngle
	              });
	
	              stepData.push(latest);
	              curAngle = latest.endAngle;
	            } else {
	              var endAngle = entry.endAngle,
	                  startAngle = entry.startAngle;
	
	              var interpolatorAngle = (0, _DataUtils.interpolateNumber)(0, endAngle - startAngle);
	              var deltaAngle = interpolatorAngle(t);
	              var _latest = _extends({}, entry, {
	                startAngle: curAngle + paddingAngle,
	                endAngle: curAngle + deltaAngle + paddingAngle
	              });
	
	              stepData.push(_latest);
	              curAngle = _latest.endAngle;
	            }
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this4.renderSectorsStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors() {
	      var _props4 = this.props,
	          sectors = _props4.sectors,
	          isAnimationActive = _props4.isAnimationActive;
	      var prevSectors = this.state.prevSectors;
	
	
	      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqual3.default)(prevSectors, sectors))) {
	        return this.renderSectorsWithAnimation();
	      }
	      return this.renderSectorsStatically(sectors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          hide = _props5.hide,
	          sectors = _props5.sectors,
	          className = _props5.className,
	          label = _props5.label,
	          cx = _props5.cx,
	          cy = _props5.cy,
	          innerRadius = _props5.innerRadius,
	          outerRadius = _props5.outerRadius,
	          isAnimationActive = _props5.isAnimationActive,
	          id = _props5.id;
	
	
	      if (hide || !sectors || !sectors.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-pie', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        _react2.default.createElement(
	          'g',
	          { clipPath: 'url(#' + ((0, _isNil3.default)(id) ? this.id : id) + ')' },
	          this.renderSectors()
	        ),
	        label && this.renderLabels(sectors),
	        _Label2.default.renderCallByParent(this.props, null, false),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, sectors, false)
	      );
	    }
	  }]);
	
	  return Pie;
	}(_react.Component), _class2.displayName = 'Pie', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  animationId: _propTypes2.default.number,
	  cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  paddingAngle: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  valueKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  minAngle: _propTypes2.default.number,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  maxRadius: _propTypes2.default.number,
	
	  sectors: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  hide: _propTypes2.default.bool,
	  labelLine: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.shape({
	    offsetRadius: _propTypes2.default.number
	  }), _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.bool]),
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  activeIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear']),
	  id: _propTypes2.default.string
	}), _class2.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  labelLine: true,
	  hide: false,
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name'
	}, _class2.parseDeltaAngle = function (_ref3) {
	  var startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	  return sign * deltaAngle;
	}, _class2.getRealPieData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _extends({
	        payload: entry
	      }, presentationProps, entry, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _extends({}, presentationProps, cell.props);
	    });
	  }
	
	  return [];
	}, _class2.parseCoordinateOfPie = function (item, offset) {
	  var top = offset.top,
	      left = offset.left,
	      width = offset.width,
	      height = offset.height;
	
	  var maxPieRadius = (0, _PolarUtils.getMaxRadius)(width, height);
	  var cx = left + (0, _DataUtils.getPercentValue)(item.props.cx, width, width / 2);
	  var cy = top + (0, _DataUtils.getPercentValue)(item.props.cy, height, height / 2);
	  var innerRadius = (0, _DataUtils.getPercentValue)(item.props.innerRadius, maxPieRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
	  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
	
	  return { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, maxRadius: maxRadius };
	}, _class2.getComposedData = function (_ref4) {
	  var item = _ref4.item,
	      offset = _ref4.offset,
	      onItemMouseLeave = _ref4.onItemMouseLeave,
	      onItemMouseEnter = _ref4.onItemMouseEnter;
	
	  var pieData = Pie.getRealPieData(item);
	  if (!pieData || !pieData.length) {
	    return [];
	  }
	
	  var _item$props2 = item.props,
	      cornerRadius = _item$props2.cornerRadius,
	      startAngle = _item$props2.startAngle,
	      endAngle = _item$props2.endAngle,
	      paddingAngle = _item$props2.paddingAngle,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      valueKey = _item$props2.valueKey;
	
	  var minAngle = Math.abs(item.props.minAngle);
	  var coordinate = Pie.parseCoordinateOfPie(item, offset);
	  var len = pieData.length;
	  var deltaAngle = Pie.parseDeltaAngle({ startAngle: startAngle, endAngle: endAngle });
	  var absDeltaAngle = Math.abs(deltaAngle);
	  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
	  var realDataKey = dataKey;
	
	  if ((0, _isNil3.default)(dataKey) && (0, _isNil3.default)(valueKey)) {
	    (0, _LogUtils.warn)(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
	    realDataKey = 'value';
	  } else if ((0, _isNil3.default)(dataKey)) {
	    (0, _LogUtils.warn)(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
	    realDataKey = valueKey;
	  }
	
	  var sum = pieData.reduce(function (result, entry) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	    return result + ((0, _DataUtils.isNumber)(val) ? val : 0);
	  }, 0);
	  var sectors = void 0;
	
	  if (sum > 0) {
	    var prev = void 0;
	    sectors = pieData.map(function (entry, i) {
	      var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	      var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	      var percent = ((0, _DataUtils.isNumber)(val) ? val : 0) / sum;
	      var tempStartAngle = void 0;
	
	      if (i) {
	        tempStartAngle = prev.endAngle + (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle;
	      } else {
	        tempStartAngle = startAngle;
	      }
	
	      var tempEndAngle = tempStartAngle + (0, _DataUtils.mathSign)(deltaAngle) * (minAngle + percent * realTotalAngle);
	      var midAngle = (tempStartAngle + tempEndAngle) / 2;
	      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
	      var tooltipPayload = [{ name: name, value: val, payload: entry }];
	      var tooltipPosition = (0, _PolarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
	
	      prev = _extends({
	        percent: percent, cornerRadius: cornerRadius, name: name, tooltipPayload: tooltipPayload, midAngle: midAngle, middleRadius: middleRadius, tooltipPosition: tooltipPosition
	      }, entry, coordinate, {
	        value: (0, _ChartUtils.getValueByDataKey)(entry, realDataKey),
	        startAngle: tempStartAngle,
	        endAngle: tempEndAngle,
	        payload: entry,
	        paddingAngle: (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle
	      });
	
	      return prev;
	    });
	  }
	
	  return _extends({}, coordinate, {
	    sectors: sectors,
	    data: pieData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  });
	}, _temp2)) || _class;
	
	exports.default = Pie;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(60);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(63);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DataUtils = __webpack_require__(19);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _PolarUtils = __webpack_require__(56);
	
	var _ChartUtils = __webpack_require__(33);
	
	var _Polygon = __webpack_require__(399);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Dot = __webpack_require__(107);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(84);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Radar, _Component);
	
	  function Radar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radar.__proto__ || Object.getPrototypeOf(Radar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.cachePrevData = function (points) {
	      _this.setState({ prevPoints: points });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    }, _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Radar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-radar-dot' }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots(points) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          dot = _props2.dot,
	          dataKey = _props2.dataKey;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, baseProps, customDotProps, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          playload: entry
	        });
	
	        return _this2.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderPolygonStatically',
	    value: function renderPolygonStatically(points) {
	      var _props3 = this.props,
	          shape = _props3.shape,
	          dot = _props3.dot;
	
	
	      var radar = void 0;
	      if (_react2.default.isValidElement(shape)) {
	        radar = _react2.default.cloneElement(shape, _extends({}, this.props, { points: points }));
	      } else if ((0, _isFunction3.default)(shape)) {
	        radar = shape(_extends({}, this.props, { points: points }));
	      } else {
	        radar = _react2.default.createElement(_Polygon2.default, _extends({}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave
	        }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          points: points
	        }));
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-polygon' },
	        radar,
	        dot ? this.renderDots(points) : null
	      );
	    }
	  }, {
	    key: 'renderPolygonWithAnimation',
	    value: function renderPolygonWithAnimation() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          points = _props4.points,
	          isAnimationActive = _props4.isAnimationActive,
	          animationBegin = _props4.animationBegin,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          animationId = _props4.animationId;
	      var prevPoints = this.state.prevPoints;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'radar-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = points.map(function (entry, index) {
	            var prev = prevPoints && prevPoints[index];
	
	            if (prev) {
	              var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	              return _extends({}, entry, {
	                x: _interpolatorX(t),
	                y: _interpolatorY(t)
	              });
	            }
	
	            var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.cx, entry.x);
	            var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.cy, entry.y);
	
	            return _extends({}, entry, {
	              x: interpolatorX(t),
	              y: interpolatorY(t)
	            });
	          });
	
	          return _this3.renderPolygonStatically(stepData);
	        }
	      );
	    }
	  }, {
	    key: 'renderPolygon',
	    value: function renderPolygon() {
	      var _props5 = this.props,
	          points = _props5.points,
	          isAnimationActive = _props5.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual3.default)(prevPoints, points))) {
	        return this.renderPolygonWithAnimation();
	      }
	
	      return this.renderPolygonStatically(points);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          hide = _props6.hide,
	          className = _props6.className,
	          points = _props6.points,
	          isAnimationActive = _props6.isAnimationActive;
	
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-radar', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        this.renderPolygon(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Radar;
	}(_react.Component), _class2.displayName = 'Radar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]).isRequired,
	  angleAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  radiusAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    angle: _propTypes2.default.number,
	    radius: _propTypes2.default.number,
	    value: _propTypes2.default.number,
	    payload: _propTypes2.default.object
	  })),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  // whether have dot in poly line
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.bool]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  hide: _propTypes2.default.bool,
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  isAnimationActive: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  hide: false,
	  activeDot: true,
	  dot: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getComposedData = function (_ref3) {
	  var radiusAxis = _ref3.radiusAxis,
	      angleAxis = _ref3.angleAxis,
	      displayedData = _ref3.displayedData,
	      dataKey = _ref3.dataKey,
	      bandSize = _ref3.bandSize;
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	
	  var points = displayedData.map(function (entry, i) {
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, angleAxis.dataKey, i);
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var angle = angleAxis.scale(name) + (bandSize || 0);
	    var radius = radiusAxis.scale(value);
	    return _extends({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	      name: name, value: value, cx: cx, cy: cy, radius: radius, angle: angle,
	      payload: entry
	    });
	  });
	
	  return { points: points };
	}, _temp2)) || _class;
	
	exports.default = Radar;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(60);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(24);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of radial bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(63);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Sector = __webpack_require__(204);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _LabelList = __webpack_require__(84);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _Cell = __webpack_require__(181);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadialBar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadialBar, _Component);
	
	  function RadialBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBar.__proto__ || Object.getPrototypeOf(RadialBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: false
	    }, _this.cachePrevData = function (data) {
	      _this.setState({ prevData: data });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadialBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          data = _props.data;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: 'getDeltaAngle',
	    value: function getDeltaAngle() {
	      var _props2 = this.props,
	          startAngle = _props2.startAngle,
	          endAngle = _props2.endAngle;
	
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	      return sign * deltaAngle;
	    }
	  }, {
	    key: 'renderSectorShape',
	    value: function renderSectorShape(shape, props) {
	      var sectorShape = void 0;
	
	      if (_react2.default.isValidElement(shape)) {
	        sectorShape = _react2.default.cloneElement(shape, props);
	      } else if ((0, _isFunction3.default)(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react2.default.createElement(_Sector2.default, props);
	      }
	
	      return sectorShape;
	    }
	  }, {
	    key: 'renderSectorsStatically',
	    value: function renderSectorsStatically(sectors) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          shape = _props3.shape,
	          activeShape = _props3.activeShape,
	          activeIndex = _props3.activeIndex,
	          cornerRadius = _props3.cornerRadius,
	          others = _objectWithoutProperties(_props3, ['shape', 'activeShape', 'activeIndex', 'cornerRadius']);
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return sectors.map(function (entry, i) {
	        var props = _extends({}, baseProps, {
	          cornerRadius: cornerRadius
	        }, entry, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: 'sector-' + i,
	          className: 'recharts-radial-bar-sector'
	        });
	
	        return _this2.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	      });
	    }
	  }, {
	    key: 'renderSectorsWithAnimation',
	    value: function renderSectorsWithAnimation() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          data = _props4.data,
	          isAnimationActive = _props4.isAnimationActive,
	          animationBegin = _props4.animationBegin,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          animationId = _props4.animationId;
	      var prevData = this.state.prevData;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'radialBar-' + animationId,
	          onAnimationStart: this.handleAnimationStart,
	          onAnimationEnd: this.handleAnimationEnd
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = data.map(function (entry, index) {
	            var prev = prevData && prevData[index];
	
	            if (prev) {
	              var interpolatorStartAngle = (0, _DataUtils.interpolateNumber)(prev.startAngle, entry.startAngle);
	              var interpolatorEndAngle = (0, _DataUtils.interpolateNumber)(prev.endAngle, entry.endAngle);
	
	              return _extends({}, entry, {
	                startAngle: interpolatorStartAngle(t),
	                endAngle: interpolatorEndAngle(t)
	              });
	            }
	            var endAngle = entry.endAngle,
	                startAngle = entry.startAngle;
	
	            var interpolator = (0, _DataUtils.interpolateNumber)(startAngle, endAngle);
	
	            return _extends({}, entry, { endAngle: interpolator(t) });
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this3.renderSectorsStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors() {
	      var _props5 = this.props,
	          data = _props5.data,
	          isAnimationActive = _props5.isAnimationActive;
	      var prevData = this.state.prevData;
	
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual3.default)(prevData, data))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(data);
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground(sectors) {
	      var _this4 = this;
	
	      var cornerRadius = this.props.cornerRadius;
	
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ['value', 'background']);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _extends({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, background, backgroundProps, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: 'sector-' + i,
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this4.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          hide = _props6.hide,
	          data = _props6.data,
	          className = _props6.className,
	          background = _props6.background,
	          isAnimationActive = _props6.isAnimationActive;
	
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        background && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-background' },
	          this.renderBackground(data)
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-sectors' },
	          this.renderSectors(data)
	        ),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(_extends({}, this.props, {
	          clockWise: this.getDeltaAngle() < 0
	        }), data)
	      );
	    }
	  }]);
	
	  return RadialBar;
	}(_react.Component), _class2.displayName = 'RadialBar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  angleAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  radiusAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  activeIndex: _propTypes2.default.number,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  minPointSize: _propTypes2.default.number,
	  maxBarSize: _propTypes2.default.number,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    innerRadius: _propTypes2.default.number,
	    outerRadius: _propTypes2.default.number,
	    value: _propTypes2.default.value
	  })),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object]),
	  background: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  hide: _propTypes2.default.bool,
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	}), _class2.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  minPointSize: 0,
	  hide: false,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getComposedData = function (_ref3) {
	  var item = _ref3.item,
	      props = _ref3.props,
	      radiusAxis = _ref3.radiusAxis,
	      radiusAxisTicks = _ref3.radiusAxisTicks,
	      angleAxis = _ref3.angleAxis,
	      angleAxisTicks = _ref3.angleAxisTicks,
	      displayedData = _ref3.displayedData,
	      dataKey = _ref3.dataKey,
	      stackedData = _ref3.stackedData,
	      barPosition = _ref3.barPosition,
	      bandSize = _ref3.bandSize,
	      dataStartIndex = _ref3.dataStartIndex;
	
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	  if (!pos) {
	    return [];
	  }
	
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var layout = props.layout;
	  var _item$props = item.props,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	
	  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({ props: props, numericAxis: numericAxis });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	  var sectors = displayedData.map(function (entry, index) {
	    var value = void 0,
	        innerRadius = void 0,
	        outerRadius = void 0,
	        startAngle = void 0,
	        endAngle = void 0,
	        backgroundSector = void 0;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'radial') {
	      innerRadius = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: radiusAxis,
	        ticks: radiusAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = angleAxis.scale(value[1]);
	      startAngle = angleAxis.scale(value[0]);
	      outerRadius = innerRadius + pos.size;
	      var deltaAngle = endAngle - startAngle;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
	
	        endAngle += delta;
	      }
	      backgroundSector = {
	        background: {
	          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: props.startAngle,
	          endAngle: props.endAngle
	        }
	      };
	    } else {
	      innerRadius = radiusAxis.scale(value[0]);
	      outerRadius = radiusAxis.scale(value[1]);
	      startAngle = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: angleAxis,
	        ticks: angleAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = startAngle + pos.size;
	      var deltaRadius = outerRadius - innerRadius;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
	        outerRadius += _delta;
	      }
	    }
	
	    return _extends({}, entry, backgroundSector, {
	      payload: entry,
	      value: stackedData ? value : value[1],
	      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    }, cells && cells[index] && cells[index].props);
	  });
	
	  return { data: sectors, layout: layout };
	}, _temp2)) || _class;
	
	exports.default = RadialBar;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cross
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(19);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cross = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Cross, _Component);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, (Cross.__proto__ || Object.getPrototypeOf(Cross)).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: 'getPath',
	    value: function getPath(x, y, width, height, top, left) {
	      return 'M' + x + ',' + top + 'v' + height + 'M' + left + ',' + y + 'h' + width;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          top = _props.top,
	          left = _props.left,
	          className = _props.className;
	
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames2.default)('recharts-cross', className),
	        d: this.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }]);
	
	  return Cross;
	}(_react.Component), _class2.displayName = 'Cross', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  className: _propTypes2.default.string
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	}, _temp)) || _class;
	
	exports.default = Cross;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.THREE = global.THREE || {})));
	}(this, (function (exports) { 'use strict';
	
		// Polyfills
	
		if ( Number.EPSILON === undefined ) {
	
			Number.EPSILON = Math.pow( 2, - 52 );
	
		}
	
		if ( Number.isInteger === undefined ) {
	
			// Missing in IE
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
	
			Number.isInteger = function ( value ) {
	
				return typeof value === 'number' && isFinite( value ) && Math.floor( value ) === value;
	
			};
	
		}
	
		//
	
		if ( Math.sign === undefined ) {
	
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
	
			Math.sign = function ( x ) {
	
				return ( x < 0 ) ? - 1 : ( x > 0 ) ? 1 : + x;
	
			};
	
		}
	
		if ( Function.prototype.name === undefined ) {
	
			// Missing in IE
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/name
	
			Object.defineProperty( Function.prototype, 'name', {
	
				get: function () {
	
					return this.toString().match( /^\s*function\s*([^\(\s]*)/ )[ 1 ];
	
				}
	
			} );
	
		}
	
		if ( Object.assign === undefined ) {
	
			// Missing in IE
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	
			( function () {
	
				Object.assign = function ( target ) {
	
					'use strict';
	
					if ( target === undefined || target === null ) {
	
						throw new TypeError( 'Cannot convert undefined or null to object' );
	
					}
	
					var output = Object( target );
	
					for ( var index = 1; index < arguments.length; index ++ ) {
	
						var source = arguments[ index ];
	
						if ( source !== undefined && source !== null ) {
	
							for ( var nextKey in source ) {
	
								if ( Object.prototype.hasOwnProperty.call( source, nextKey ) ) {
	
									output[ nextKey ] = source[ nextKey ];
	
								}
	
							}
	
						}
	
					}
	
					return output;
	
				};
	
			} )();
	
		}
	
		/**
		 * https://github.com/mrdoob/eventdispatcher.js/
		 */
	
		function EventDispatcher() {}
	
		Object.assign( EventDispatcher.prototype, {
	
			addEventListener: function ( type, listener ) {
	
				if ( this._listeners === undefined ) this._listeners = {};
	
				var listeners = this._listeners;
	
				if ( listeners[ type ] === undefined ) {
	
					listeners[ type ] = [];
	
				}
	
				if ( listeners[ type ].indexOf( listener ) === - 1 ) {
	
					listeners[ type ].push( listener );
	
				}
	
			},
	
			hasEventListener: function ( type, listener ) {
	
				if ( this._listeners === undefined ) return false;
	
				var listeners = this._listeners;
	
				return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;
	
			},
	
			removeEventListener: function ( type, listener ) {
	
				if ( this._listeners === undefined ) return;
	
				var listeners = this._listeners;
				var listenerArray = listeners[ type ];
	
				if ( listenerArray !== undefined ) {
	
					var index = listenerArray.indexOf( listener );
	
					if ( index !== - 1 ) {
	
						listenerArray.splice( index, 1 );
	
					}
	
				}
	
			},
	
			dispatchEvent: function ( event ) {
	
				if ( this._listeners === undefined ) return;
	
				var listeners = this._listeners;
				var listenerArray = listeners[ event.type ];
	
				if ( listenerArray !== undefined ) {
	
					event.target = this;
	
					var array = listenerArray.slice( 0 );
	
					for ( var i = 0, l = array.length; i < l; i ++ ) {
	
						array[ i ].call( this, event );
	
					}
	
				}
	
			}
	
		} );
	
		var REVISION = '87';
		var MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2 };
		var CullFaceNone = 0;
		var CullFaceBack = 1;
		var CullFaceFront = 2;
		var CullFaceFrontBack = 3;
		var FrontFaceDirectionCW = 0;
		var FrontFaceDirectionCCW = 1;
		var BasicShadowMap = 0;
		var PCFShadowMap = 1;
		var PCFSoftShadowMap = 2;
		var FrontSide = 0;
		var BackSide = 1;
		var DoubleSide = 2;
		var FlatShading = 1;
		var SmoothShading = 2;
		var NoColors = 0;
		var FaceColors = 1;
		var VertexColors = 2;
		var NoBlending = 0;
		var NormalBlending = 1;
		var AdditiveBlending = 2;
		var SubtractiveBlending = 3;
		var MultiplyBlending = 4;
		var CustomBlending = 5;
		var AddEquation = 100;
		var SubtractEquation = 101;
		var ReverseSubtractEquation = 102;
		var MinEquation = 103;
		var MaxEquation = 104;
		var ZeroFactor = 200;
		var OneFactor = 201;
		var SrcColorFactor = 202;
		var OneMinusSrcColorFactor = 203;
		var SrcAlphaFactor = 204;
		var OneMinusSrcAlphaFactor = 205;
		var DstAlphaFactor = 206;
		var OneMinusDstAlphaFactor = 207;
		var DstColorFactor = 208;
		var OneMinusDstColorFactor = 209;
		var SrcAlphaSaturateFactor = 210;
		var NeverDepth = 0;
		var AlwaysDepth = 1;
		var LessDepth = 2;
		var LessEqualDepth = 3;
		var EqualDepth = 4;
		var GreaterEqualDepth = 5;
		var GreaterDepth = 6;
		var NotEqualDepth = 7;
		var MultiplyOperation = 0;
		var MixOperation = 1;
		var AddOperation = 2;
		var NoToneMapping = 0;
		var LinearToneMapping = 1;
		var ReinhardToneMapping = 2;
		var Uncharted2ToneMapping = 3;
		var CineonToneMapping = 4;
		var UVMapping = 300;
		var CubeReflectionMapping = 301;
		var CubeRefractionMapping = 302;
		var EquirectangularReflectionMapping = 303;
		var EquirectangularRefractionMapping = 304;
		var SphericalReflectionMapping = 305;
		var CubeUVReflectionMapping = 306;
		var CubeUVRefractionMapping = 307;
		var RepeatWrapping = 1000;
		var ClampToEdgeWrapping = 1001;
		var MirroredRepeatWrapping = 1002;
		var NearestFilter = 1003;
		var NearestMipMapNearestFilter = 1004;
		var NearestMipMapLinearFilter = 1005;
		var LinearFilter = 1006;
		var LinearMipMapNearestFilter = 1007;
		var LinearMipMapLinearFilter = 1008;
		var UnsignedByteType = 1009;
		var ByteType = 1010;
		var ShortType = 1011;
		var UnsignedShortType = 1012;
		var IntType = 1013;
		var UnsignedIntType = 1014;
		var FloatType = 1015;
		var HalfFloatType = 1016;
		var UnsignedShort4444Type = 1017;
		var UnsignedShort5551Type = 1018;
		var UnsignedShort565Type = 1019;
		var UnsignedInt248Type = 1020;
		var AlphaFormat = 1021;
		var RGBFormat = 1022;
		var RGBAFormat = 1023;
		var LuminanceFormat = 1024;
		var LuminanceAlphaFormat = 1025;
		var RGBEFormat = RGBAFormat;
		var DepthFormat = 1026;
		var DepthStencilFormat = 1027;
		var RGB_S3TC_DXT1_Format = 2001;
		var RGBA_S3TC_DXT1_Format = 2002;
		var RGBA_S3TC_DXT3_Format = 2003;
		var RGBA_S3TC_DXT5_Format = 2004;
		var RGB_PVRTC_4BPPV1_Format = 2100;
		var RGB_PVRTC_2BPPV1_Format = 2101;
		var RGBA_PVRTC_4BPPV1_Format = 2102;
		var RGBA_PVRTC_2BPPV1_Format = 2103;
		var RGB_ETC1_Format = 2151;
		var LoopOnce = 2200;
		var LoopRepeat = 2201;
		var LoopPingPong = 2202;
		var InterpolateDiscrete = 2300;
		var InterpolateLinear = 2301;
		var InterpolateSmooth = 2302;
		var ZeroCurvatureEnding = 2400;
		var ZeroSlopeEnding = 2401;
		var WrapAroundEnding = 2402;
		var TrianglesDrawMode = 0;
		var TriangleStripDrawMode = 1;
		var TriangleFanDrawMode = 2;
		var LinearEncoding = 3000;
		var sRGBEncoding = 3001;
		var GammaEncoding = 3007;
		var RGBEEncoding = 3002;
		var LogLuvEncoding = 3003;
		var RGBM7Encoding = 3004;
		var RGBM16Encoding = 3005;
		var RGBDEncoding = 3006;
		var BasicDepthPacking = 3200;
		var RGBADepthPacking = 3201;
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var _Math = {
	
			DEG2RAD: Math.PI / 180,
			RAD2DEG: 180 / Math.PI,
	
			generateUUID: function () {
	
				// http://www.broofa.com/Tools/Math.uuid.htm
	
				var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split( '' );
				var uuid = new Array( 36 );
				var rnd = 0, r;
	
				return function generateUUID() {
	
					for ( var i = 0; i < 36; i ++ ) {
	
						if ( i === 8 || i === 13 || i === 18 || i === 23 ) {
	
							uuid[ i ] = '-';
	
						} else if ( i === 14 ) {
	
							uuid[ i ] = '4';
	
						} else {
	
							if ( rnd <= 0x02 ) rnd = 0x2000000 + ( Math.random() * 0x1000000 ) | 0;
							r = rnd & 0xf;
							rnd = rnd >> 4;
							uuid[ i ] = chars[ ( i === 19 ) ? ( r & 0x3 ) | 0x8 : r ];
	
						}
	
					}
	
					return uuid.join( '' );
	
				};
	
			}(),
	
			clamp: function ( value, min, max ) {
	
				return Math.max( min, Math.min( max, value ) );
	
			},
	
			// compute euclidian modulo of m % n
			// https://en.wikipedia.org/wiki/Modulo_operation
	
			euclideanModulo: function ( n, m ) {
	
				return ( ( n % m ) + m ) % m;
	
			},
	
			// Linear mapping from range <a1, a2> to range <b1, b2>
	
			mapLinear: function ( x, a1, a2, b1, b2 ) {
	
				return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );
	
			},
	
			// https://en.wikipedia.org/wiki/Linear_interpolation
	
			lerp: function ( x, y, t ) {
	
				return ( 1 - t ) * x + t * y;
	
			},
	
			// http://en.wikipedia.org/wiki/Smoothstep
	
			smoothstep: function ( x, min, max ) {
	
				if ( x <= min ) return 0;
				if ( x >= max ) return 1;
	
				x = ( x - min ) / ( max - min );
	
				return x * x * ( 3 - 2 * x );
	
			},
	
			smootherstep: function ( x, min, max ) {
	
				if ( x <= min ) return 0;
				if ( x >= max ) return 1;
	
				x = ( x - min ) / ( max - min );
	
				return x * x * x * ( x * ( x * 6 - 15 ) + 10 );
	
			},
	
			// Random integer from <low, high> interval
	
			randInt: function ( low, high ) {
	
				return low + Math.floor( Math.random() * ( high - low + 1 ) );
	
			},
	
			// Random float from <low, high> interval
	
			randFloat: function ( low, high ) {
	
				return low + Math.random() * ( high - low );
	
			},
	
			// Random float from <-range/2, range/2> interval
	
			randFloatSpread: function ( range ) {
	
				return range * ( 0.5 - Math.random() );
	
			},
	
			degToRad: function ( degrees ) {
	
				return degrees * _Math.DEG2RAD;
	
			},
	
			radToDeg: function ( radians ) {
	
				return radians * _Math.RAD2DEG;
	
			},
	
			isPowerOfTwo: function ( value ) {
	
				return ( value & ( value - 1 ) ) === 0 && value !== 0;
	
			},
	
			nearestPowerOfTwo: function ( value ) {
	
				return Math.pow( 2, Math.round( Math.log( value ) / Math.LN2 ) );
	
			},
	
			nextPowerOfTwo: function ( value ) {
	
				value --;
				value |= value >> 1;
				value |= value >> 2;
				value |= value >> 4;
				value |= value >> 8;
				value |= value >> 16;
				value ++;
	
				return value;
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author philogb / http://blog.thejit.org/
		 * @author egraether / http://egraether.com/
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 */
	
		function Vector2( x, y ) {
	
			this.x = x || 0;
			this.y = y || 0;
	
		}
	
		Object.defineProperties( Vector2.prototype, {
	
			"width" : {
	
				get: function () {
	
					return this.x;
	
				},
	
				set: function ( value ) {
	
					this.x = value;
	
				}
	
			},
	
			"height" : {
	
				get: function () {
	
					return this.y;
	
				},
	
				set: function ( value ) {
	
					this.y = value;
	
				}
	
			}
	
		} );
	
		Object.assign( Vector2.prototype, {
	
			isVector2: true,
	
			set: function ( x, y ) {
	
				this.x = x;
				this.y = y;
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.x = scalar;
				this.y = scalar;
	
				return this;
	
			},
	
			setX: function ( x ) {
	
				this.x = x;
	
				return this;
	
			},
	
			setY: function ( y ) {
	
				this.y = y;
	
				return this;
	
			},
	
			setComponent: function ( index, value ) {
	
				switch ( index ) {
	
					case 0: this.x = value; break;
					case 1: this.y = value; break;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
				return this;
	
			},
	
			getComponent: function ( index ) {
	
				switch ( index ) {
	
					case 0: return this.x;
					case 1: return this.y;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.x, this.y );
	
			},
	
			copy: function ( v ) {
	
				this.x = v.x;
				this.y = v.y;
	
				return this;
	
			},
	
			add: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
					return this.addVectors( v, w );
	
				}
	
				this.x += v.x;
				this.y += v.y;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.x += s;
				this.y += s;
	
				return this;
	
			},
	
			addVectors: function ( a, b ) {
	
				this.x = a.x + b.x;
				this.y = a.y + b.y;
	
				return this;
	
			},
	
			addScaledVector: function ( v, s ) {
	
				this.x += v.x * s;
				this.y += v.y * s;
	
				return this;
	
			},
	
			sub: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
					return this.subVectors( v, w );
	
				}
	
				this.x -= v.x;
				this.y -= v.y;
	
				return this;
	
			},
	
			subScalar: function ( s ) {
	
				this.x -= s;
				this.y -= s;
	
				return this;
	
			},
	
			subVectors: function ( a, b ) {
	
				this.x = a.x - b.x;
				this.y = a.y - b.y;
	
				return this;
	
			},
	
			multiply: function ( v ) {
	
				this.x *= v.x;
				this.y *= v.y;
	
				return this;
	
			},
	
			multiplyScalar: function ( scalar ) {
	
				this.x *= scalar;
				this.y *= scalar;
	
				return this;
	
			},
	
			divide: function ( v ) {
	
				this.x /= v.x;
				this.y /= v.y;
	
				return this;
	
			},
	
			divideScalar: function ( scalar ) {
	
				return this.multiplyScalar( 1 / scalar );
	
			},
	
			min: function ( v ) {
	
				this.x = Math.min( this.x, v.x );
				this.y = Math.min( this.y, v.y );
	
				return this;
	
			},
	
			max: function ( v ) {
	
				this.x = Math.max( this.x, v.x );
				this.y = Math.max( this.y, v.y );
	
				return this;
	
			},
	
			clamp: function ( min, max ) {
	
				// assumes min < max, componentwise
	
				this.x = Math.max( min.x, Math.min( max.x, this.x ) );
				this.y = Math.max( min.y, Math.min( max.y, this.y ) );
	
				return this;
	
			},
	
			clampScalar: function () {
	
				var min = new Vector2();
				var max = new Vector2();
	
				return function clampScalar( minVal, maxVal ) {
	
					min.set( minVal, minVal );
					max.set( maxVal, maxVal );
	
					return this.clamp( min, max );
	
				};
	
			}(),
	
			clampLength: function ( min, max ) {
	
				var length = this.length();
	
				return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );
	
			},
	
			floor: function () {
	
				this.x = Math.floor( this.x );
				this.y = Math.floor( this.y );
	
				return this;
	
			},
	
			ceil: function () {
	
				this.x = Math.ceil( this.x );
				this.y = Math.ceil( this.y );
	
				return this;
	
			},
	
			round: function () {
	
				this.x = Math.round( this.x );
				this.y = Math.round( this.y );
	
				return this;
	
			},
	
			roundToZero: function () {
	
				this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
				this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
	
				return this;
	
			},
	
			negate: function () {
	
				this.x = - this.x;
				this.y = - this.y;
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this.x * v.x + this.y * v.y;
	
			},
	
			lengthSq: function () {
	
				return this.x * this.x + this.y * this.y;
	
			},
	
			length: function () {
	
				return Math.sqrt( this.x * this.x + this.y * this.y );
	
			},
	
			lengthManhattan: function() {
	
				return Math.abs( this.x ) + Math.abs( this.y );
	
			},
	
			normalize: function () {
	
				return this.divideScalar( this.length() || 1 );
	
			},
	
			angle: function () {
	
				// computes the angle in radians with respect to the positive x-axis
	
				var angle = Math.atan2( this.y, this.x );
	
				if ( angle < 0 ) angle += 2 * Math.PI;
	
				return angle;
	
			},
	
			distanceTo: function ( v ) {
	
				return Math.sqrt( this.distanceToSquared( v ) );
	
			},
	
			distanceToSquared: function ( v ) {
	
				var dx = this.x - v.x, dy = this.y - v.y;
				return dx * dx + dy * dy;
	
			},
	
			distanceToManhattan: function ( v ) {
	
				return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );
	
			},
	
			setLength: function ( length ) {
	
				return this.normalize().multiplyScalar( length );
	
			},
	
			lerp: function ( v, alpha ) {
	
				this.x += ( v.x - this.x ) * alpha;
				this.y += ( v.y - this.y ) * alpha;
	
				return this;
	
			},
	
			lerpVectors: function ( v1, v2, alpha ) {
	
				return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );
	
			},
	
			equals: function ( v ) {
	
				return ( ( v.x === this.x ) && ( v.y === this.y ) );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.x = array[ offset ];
				this.y = array[ offset + 1 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.x;
				array[ offset + 1 ] = this.y;
	
				return array;
	
			},
	
			fromBufferAttribute: function ( attribute, index, offset ) {
	
				if ( offset !== undefined ) {
	
					console.warn( 'THREE.Vector2: offset has been removed from .fromBufferAttribute().' );
	
				}
	
				this.x = attribute.getX( index );
				this.y = attribute.getY( index );
	
				return this;
	
			},
	
			rotateAround: function ( center, angle ) {
	
				var c = Math.cos( angle ), s = Math.sin( angle );
	
				var x = this.x - center.x;
				var y = this.y - center.y;
	
				this.x = x * c - y * s + center.x;
				this.y = x * s + y * c + center.y;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author szimek / https://github.com/szimek/
		 */
	
		var textureId = 0;
	
		function Texture( image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {
	
			Object.defineProperty( this, 'id', { value: textureId ++ } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
	
			this.image = image !== undefined ? image : Texture.DEFAULT_IMAGE;
			this.mipmaps = [];
	
			this.mapping = mapping !== undefined ? mapping : Texture.DEFAULT_MAPPING;
	
			this.wrapS = wrapS !== undefined ? wrapS : ClampToEdgeWrapping;
			this.wrapT = wrapT !== undefined ? wrapT : ClampToEdgeWrapping;
	
			this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;
			this.minFilter = minFilter !== undefined ? minFilter : LinearMipMapLinearFilter;
	
			this.anisotropy = anisotropy !== undefined ? anisotropy : 1;
	
			this.format = format !== undefined ? format : RGBAFormat;
			this.type = type !== undefined ? type : UnsignedByteType;
	
			this.offset = new Vector2( 0, 0 );
			this.repeat = new Vector2( 1, 1 );
	
			this.generateMipmaps = true;
			this.premultiplyAlpha = false;
			this.flipY = true;
			this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
	
			// Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
			//
			// Also changing the encoding after already used by a Material will not automatically make the Material
			// update.  You need to explicitly call Material.needsUpdate to trigger it to recompile.
			this.encoding = encoding !== undefined ? encoding : LinearEncoding;
	
			this.version = 0;
			this.onUpdate = null;
	
		}
	
		Texture.DEFAULT_IMAGE = undefined;
		Texture.DEFAULT_MAPPING = UVMapping;
	
		Object.defineProperty( Texture.prototype, "needsUpdate", {
	
			set: function ( value ) {
	
				if ( value === true ) this.version ++;
	
			}
	
		} );
	
		Object.assign( Texture.prototype, EventDispatcher.prototype, {
	
			constructor: Texture,
	
			isTexture: true,
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.name = source.name;
	
				this.image = source.image;
				this.mipmaps = source.mipmaps.slice( 0 );
	
				this.mapping = source.mapping;
	
				this.wrapS = source.wrapS;
				this.wrapT = source.wrapT;
	
				this.magFilter = source.magFilter;
				this.minFilter = source.minFilter;
	
				this.anisotropy = source.anisotropy;
	
				this.format = source.format;
				this.type = source.type;
	
				this.offset.copy( source.offset );
				this.repeat.copy( source.repeat );
	
				this.generateMipmaps = source.generateMipmaps;
				this.premultiplyAlpha = source.premultiplyAlpha;
				this.flipY = source.flipY;
				this.unpackAlignment = source.unpackAlignment;
				this.encoding = source.encoding;
	
				return this;
	
			},
	
			toJSON: function ( meta ) {
	
				if ( meta.textures[ this.uuid ] !== undefined ) {
	
					return meta.textures[ this.uuid ];
	
				}
	
				function getDataURL( image ) {
	
					var canvas;
	
					if ( image instanceof HTMLCanvasElement ) {
	
						canvas = image;
	
					} else {
	
						canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
						canvas.width = image.width;
						canvas.height = image.height;
	
						var context = canvas.getContext( '2d' );
	
						if ( image instanceof ImageData ) {
	
							context.putImageData( image, 0, 0 );
	
						} else {
	
							context.drawImage( image, 0, 0, image.width, image.height );
	
						}
	
					}
	
					if ( canvas.width > 2048 || canvas.height > 2048 ) {
	
						return canvas.toDataURL( 'image/jpeg', 0.6 );
	
					} else {
	
						return canvas.toDataURL( 'image/png' );
	
					}
	
				}
	
				var output = {
					metadata: {
						version: 4.5,
						type: 'Texture',
						generator: 'Texture.toJSON'
					},
	
					uuid: this.uuid,
					name: this.name,
	
					mapping: this.mapping,
	
					repeat: [ this.repeat.x, this.repeat.y ],
					offset: [ this.offset.x, this.offset.y ],
					wrap: [ this.wrapS, this.wrapT ],
	
					minFilter: this.minFilter,
					magFilter: this.magFilter,
					anisotropy: this.anisotropy,
	
					flipY: this.flipY
				};
	
				if ( this.image !== undefined ) {
	
					// TODO: Move to THREE.Image
	
					var image = this.image;
	
					if ( image.uuid === undefined ) {
	
						image.uuid = _Math.generateUUID(); // UGH
	
					}
	
					if ( meta.images[ image.uuid ] === undefined ) {
	
						meta.images[ image.uuid ] = {
							uuid: image.uuid,
							url: getDataURL( image )
						};
	
					}
	
					output.image = image.uuid;
	
				}
	
				meta.textures[ this.uuid ] = output;
	
				return output;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			},
	
			transformUv: function ( uv ) {
	
				if ( this.mapping !== UVMapping ) return;
	
				uv.multiply( this.repeat );
				uv.add( this.offset );
	
				if ( uv.x < 0 || uv.x > 1 ) {
	
					switch ( this.wrapS ) {
	
						case RepeatWrapping:
	
							uv.x = uv.x - Math.floor( uv.x );
							break;
	
						case ClampToEdgeWrapping:
	
							uv.x = uv.x < 0 ? 0 : 1;
							break;
	
						case MirroredRepeatWrapping:
	
							if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {
	
								uv.x = Math.ceil( uv.x ) - uv.x;
	
							} else {
	
								uv.x = uv.x - Math.floor( uv.x );
	
							}
							break;
	
					}
	
				}
	
				if ( uv.y < 0 || uv.y > 1 ) {
	
					switch ( this.wrapT ) {
	
						case RepeatWrapping:
	
							uv.y = uv.y - Math.floor( uv.y );
							break;
	
						case ClampToEdgeWrapping:
	
							uv.y = uv.y < 0 ? 0 : 1;
							break;
	
						case MirroredRepeatWrapping:
	
							if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {
	
								uv.y = Math.ceil( uv.y ) - uv.y;
	
							} else {
	
								uv.y = uv.y - Math.floor( uv.y );
	
							}
							break;
	
					}
	
				}
	
				if ( this.flipY ) {
	
					uv.y = 1 - uv.y;
	
				}
	
			}
	
		} );
	
		/**
		 * @author supereggbert / http://www.paulbrunt.co.uk/
		 * @author philogb / http://blog.thejit.org/
		 * @author mikael emtinger / http://gomo.se/
		 * @author egraether / http://egraether.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Vector4( x, y, z, w ) {
	
			this.x = x || 0;
			this.y = y || 0;
			this.z = z || 0;
			this.w = ( w !== undefined ) ? w : 1;
	
		}
	
		Object.assign( Vector4.prototype, {
	
			isVector4: true,
	
			set: function ( x, y, z, w ) {
	
				this.x = x;
				this.y = y;
				this.z = z;
				this.w = w;
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.x = scalar;
				this.y = scalar;
				this.z = scalar;
				this.w = scalar;
	
				return this;
	
			},
	
			setX: function ( x ) {
	
				this.x = x;
	
				return this;
	
			},
	
			setY: function ( y ) {
	
				this.y = y;
	
				return this;
	
			},
	
			setZ: function ( z ) {
	
				this.z = z;
	
				return this;
	
			},
	
			setW: function ( w ) {
	
				this.w = w;
	
				return this;
	
			},
	
			setComponent: function ( index, value ) {
	
				switch ( index ) {
	
					case 0: this.x = value; break;
					case 1: this.y = value; break;
					case 2: this.z = value; break;
					case 3: this.w = value; break;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
				return this;
	
			},
	
			getComponent: function ( index ) {
	
				switch ( index ) {
	
					case 0: return this.x;
					case 1: return this.y;
					case 2: return this.z;
					case 3: return this.w;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.x, this.y, this.z, this.w );
	
			},
	
			copy: function ( v ) {
	
				this.x = v.x;
				this.y = v.y;
				this.z = v.z;
				this.w = ( v.w !== undefined ) ? v.w : 1;
	
				return this;
	
			},
	
			add: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
					return this.addVectors( v, w );
	
				}
	
				this.x += v.x;
				this.y += v.y;
				this.z += v.z;
				this.w += v.w;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.x += s;
				this.y += s;
				this.z += s;
				this.w += s;
	
				return this;
	
			},
	
			addVectors: function ( a, b ) {
	
				this.x = a.x + b.x;
				this.y = a.y + b.y;
				this.z = a.z + b.z;
				this.w = a.w + b.w;
	
				return this;
	
			},
	
			addScaledVector: function ( v, s ) {
	
				this.x += v.x * s;
				this.y += v.y * s;
				this.z += v.z * s;
				this.w += v.w * s;
	
				return this;
	
			},
	
			sub: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
					return this.subVectors( v, w );
	
				}
	
				this.x -= v.x;
				this.y -= v.y;
				this.z -= v.z;
				this.w -= v.w;
	
				return this;
	
			},
	
			subScalar: function ( s ) {
	
				this.x -= s;
				this.y -= s;
				this.z -= s;
				this.w -= s;
	
				return this;
	
			},
	
			subVectors: function ( a, b ) {
	
				this.x = a.x - b.x;
				this.y = a.y - b.y;
				this.z = a.z - b.z;
				this.w = a.w - b.w;
	
				return this;
	
			},
	
			multiplyScalar: function ( scalar ) {
	
				this.x *= scalar;
				this.y *= scalar;
				this.z *= scalar;
				this.w *= scalar;
	
				return this;
	
			},
	
			applyMatrix4: function ( m ) {
	
				var x = this.x, y = this.y, z = this.z, w = this.w;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] * w;
				this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] * w;
				this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] * w;
				this.w = e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] * w;
	
				return this;
	
			},
	
			divideScalar: function ( scalar ) {
	
				return this.multiplyScalar( 1 / scalar );
	
			},
	
			setAxisAngleFromQuaternion: function ( q ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
	
				// q is assumed to be normalized
	
				this.w = 2 * Math.acos( q.w );
	
				var s = Math.sqrt( 1 - q.w * q.w );
	
				if ( s < 0.0001 ) {
	
					 this.x = 1;
					 this.y = 0;
					 this.z = 0;
	
				} else {
	
					 this.x = q.x / s;
					 this.y = q.y / s;
					 this.z = q.z / s;
	
				}
	
				return this;
	
			},
	
			setAxisAngleFromRotationMatrix: function ( m ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				var angle, x, y, z,		// variables for result
					epsilon = 0.01,		// margin to allow for rounding errors
					epsilon2 = 0.1,		// margin to distinguish between 0 and 180 degrees
	
					te = m.elements,
	
					m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
					m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
					m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];
	
				if ( ( Math.abs( m12 - m21 ) < epsilon ) &&
				     ( Math.abs( m13 - m31 ) < epsilon ) &&
				     ( Math.abs( m23 - m32 ) < epsilon ) ) {
	
					// singularity found
					// first check for identity matrix which must have +1 for all terms
					// in leading diagonal and zero in other terms
	
					if ( ( Math.abs( m12 + m21 ) < epsilon2 ) &&
					     ( Math.abs( m13 + m31 ) < epsilon2 ) &&
					     ( Math.abs( m23 + m32 ) < epsilon2 ) &&
					     ( Math.abs( m11 + m22 + m33 - 3 ) < epsilon2 ) ) {
	
						// this singularity is identity matrix so angle = 0
	
						this.set( 1, 0, 0, 0 );
	
						return this; // zero angle, arbitrary axis
	
					}
	
					// otherwise this singularity is angle = 180
	
					angle = Math.PI;
	
					var xx = ( m11 + 1 ) / 2;
					var yy = ( m22 + 1 ) / 2;
					var zz = ( m33 + 1 ) / 2;
					var xy = ( m12 + m21 ) / 4;
					var xz = ( m13 + m31 ) / 4;
					var yz = ( m23 + m32 ) / 4;
	
					if ( ( xx > yy ) && ( xx > zz ) ) {
	
						// m11 is the largest diagonal term
	
						if ( xx < epsilon ) {
	
							x = 0;
							y = 0.707106781;
							z = 0.707106781;
	
						} else {
	
							x = Math.sqrt( xx );
							y = xy / x;
							z = xz / x;
	
						}
	
					} else if ( yy > zz ) {
	
						// m22 is the largest diagonal term
	
						if ( yy < epsilon ) {
	
							x = 0.707106781;
							y = 0;
							z = 0.707106781;
	
						} else {
	
							y = Math.sqrt( yy );
							x = xy / y;
							z = yz / y;
	
						}
	
					} else {
	
						// m33 is the largest diagonal term so base result on this
	
						if ( zz < epsilon ) {
	
							x = 0.707106781;
							y = 0.707106781;
							z = 0;
	
						} else {
	
							z = Math.sqrt( zz );
							x = xz / z;
							y = yz / z;
	
						}
	
					}
	
					this.set( x, y, z, angle );
	
					return this; // return 180 deg rotation
	
				}
	
				// as we have reached here there are no singularities so we can handle normally
	
				var s = Math.sqrt( ( m32 - m23 ) * ( m32 - m23 ) +
				                   ( m13 - m31 ) * ( m13 - m31 ) +
				                   ( m21 - m12 ) * ( m21 - m12 ) ); // used to normalize
	
				if ( Math.abs( s ) < 0.001 ) s = 1;
	
				// prevent divide by zero, should not happen if matrix is orthogonal and should be
				// caught by singularity test above, but I've left it in just in case
	
				this.x = ( m32 - m23 ) / s;
				this.y = ( m13 - m31 ) / s;
				this.z = ( m21 - m12 ) / s;
				this.w = Math.acos( ( m11 + m22 + m33 - 1 ) / 2 );
	
				return this;
	
			},
	
			min: function ( v ) {
	
				this.x = Math.min( this.x, v.x );
				this.y = Math.min( this.y, v.y );
				this.z = Math.min( this.z, v.z );
				this.w = Math.min( this.w, v.w );
	
				return this;
	
			},
	
			max: function ( v ) {
	
				this.x = Math.max( this.x, v.x );
				this.y = Math.max( this.y, v.y );
				this.z = Math.max( this.z, v.z );
				this.w = Math.max( this.w, v.w );
	
				return this;
	
			},
	
			clamp: function ( min, max ) {
	
				// assumes min < max, componentwise
	
				this.x = Math.max( min.x, Math.min( max.x, this.x ) );
				this.y = Math.max( min.y, Math.min( max.y, this.y ) );
				this.z = Math.max( min.z, Math.min( max.z, this.z ) );
				this.w = Math.max( min.w, Math.min( max.w, this.w ) );
	
				return this;
	
			},
	
			clampScalar: function () {
	
				var min, max;
	
				return function clampScalar( minVal, maxVal ) {
	
					if ( min === undefined ) {
	
						min = new Vector4();
						max = new Vector4();
	
					}
	
					min.set( minVal, minVal, minVal, minVal );
					max.set( maxVal, maxVal, maxVal, maxVal );
	
					return this.clamp( min, max );
	
				};
	
			}(),
	
			clampLength: function ( min, max ) {
	
				var length = this.length();
	
				return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );
	
			},
	
			floor: function () {
	
				this.x = Math.floor( this.x );
				this.y = Math.floor( this.y );
				this.z = Math.floor( this.z );
				this.w = Math.floor( this.w );
	
				return this;
	
			},
	
			ceil: function () {
	
				this.x = Math.ceil( this.x );
				this.y = Math.ceil( this.y );
				this.z = Math.ceil( this.z );
				this.w = Math.ceil( this.w );
	
				return this;
	
			},
	
			round: function () {
	
				this.x = Math.round( this.x );
				this.y = Math.round( this.y );
				this.z = Math.round( this.z );
				this.w = Math.round( this.w );
	
				return this;
	
			},
	
			roundToZero: function () {
	
				this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
				this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
				this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );
				this.w = ( this.w < 0 ) ? Math.ceil( this.w ) : Math.floor( this.w );
	
				return this;
	
			},
	
			negate: function () {
	
				this.x = - this.x;
				this.y = - this.y;
				this.z = - this.z;
				this.w = - this.w;
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
	
			},
	
			lengthSq: function () {
	
				return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
	
			},
	
			length: function () {
	
				return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );
	
			},
	
			lengthManhattan: function () {
	
				return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z ) + Math.abs( this.w );
	
			},
	
			normalize: function () {
	
				return this.divideScalar( this.length() || 1 );
	
			},
	
			setLength: function ( length ) {
	
				return this.normalize().multiplyScalar( length );
	
			},
	
			lerp: function ( v, alpha ) {
	
				this.x += ( v.x - this.x ) * alpha;
				this.y += ( v.y - this.y ) * alpha;
				this.z += ( v.z - this.z ) * alpha;
				this.w += ( v.w - this.w ) * alpha;
	
				return this;
	
			},
	
			lerpVectors: function ( v1, v2, alpha ) {
	
				return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );
	
			},
	
			equals: function ( v ) {
	
				return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) && ( v.w === this.w ) );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.x = array[ offset ];
				this.y = array[ offset + 1 ];
				this.z = array[ offset + 2 ];
				this.w = array[ offset + 3 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.x;
				array[ offset + 1 ] = this.y;
				array[ offset + 2 ] = this.z;
				array[ offset + 3 ] = this.w;
	
				return array;
	
			},
	
			fromBufferAttribute: function ( attribute, index, offset ) {
	
				if ( offset !== undefined ) {
	
					console.warn( 'THREE.Vector4: offset has been removed from .fromBufferAttribute().' );
	
				}
	
				this.x = attribute.getX( index );
				this.y = attribute.getY( index );
				this.z = attribute.getZ( index );
				this.w = attribute.getW( index );
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author szimek / https://github.com/szimek/
		 * @author alteredq / http://alteredqualia.com/
		 * @author Marius Kintel / https://github.com/kintel
		 */
	
		/*
		 In options, we can specify:
		 * Texture parameters for an auto-generated target texture
		 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
		*/
		function WebGLRenderTarget( width, height, options ) {
	
			this.uuid = _Math.generateUUID();
	
			this.width = width;
			this.height = height;
	
			this.scissor = new Vector4( 0, 0, width, height );
			this.scissorTest = false;
	
			this.viewport = new Vector4( 0, 0, width, height );
	
			options = options || {};
	
			if ( options.minFilter === undefined ) options.minFilter = LinearFilter;
	
			this.texture = new Texture( undefined, undefined, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding );
	
			this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
			this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : true;
			this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
	
		}
	
		Object.assign( WebGLRenderTarget.prototype, EventDispatcher.prototype, {
	
			isWebGLRenderTarget: true,
	
			setSize: function ( width, height ) {
	
				if ( this.width !== width || this.height !== height ) {
	
					this.width = width;
					this.height = height;
	
					this.dispose();
	
				}
	
				this.viewport.set( 0, 0, width, height );
				this.scissor.set( 0, 0, width, height );
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.width = source.width;
				this.height = source.height;
	
				this.viewport.copy( source.viewport );
	
				this.texture = source.texture.clone();
	
				this.depthBuffer = source.depthBuffer;
				this.stencilBuffer = source.stencilBuffer;
				this.depthTexture = source.depthTexture;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com
		 */
	
		function WebGLRenderTargetCube( width, height, options ) {
	
			WebGLRenderTarget.call( this, width, height, options );
	
			this.activeCubeFace = 0; // PX 0, NX 1, PY 2, NY 3, PZ 4, NZ 5
			this.activeMipMapLevel = 0;
	
		}
	
		WebGLRenderTargetCube.prototype = Object.create( WebGLRenderTarget.prototype );
		WebGLRenderTargetCube.prototype.constructor = WebGLRenderTargetCube;
	
		WebGLRenderTargetCube.prototype.isWebGLRenderTargetCube = true;
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author bhouston / http://clara.io
		 */
	
		function Quaternion( x, y, z, w ) {
	
			this._x = x || 0;
			this._y = y || 0;
			this._z = z || 0;
			this._w = ( w !== undefined ) ? w : 1;
	
		}
	
		Object.assign( Quaternion, {
	
			slerp: function ( qa, qb, qm, t ) {
	
				return qm.copy( qa ).slerp( qb, t );
	
			},
	
			slerpFlat: function ( dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {
	
				// fuzz-free, array-based Quaternion SLERP operation
	
				var x0 = src0[ srcOffset0 + 0 ],
					y0 = src0[ srcOffset0 + 1 ],
					z0 = src0[ srcOffset0 + 2 ],
					w0 = src0[ srcOffset0 + 3 ],
	
					x1 = src1[ srcOffset1 + 0 ],
					y1 = src1[ srcOffset1 + 1 ],
					z1 = src1[ srcOffset1 + 2 ],
					w1 = src1[ srcOffset1 + 3 ];
	
				if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {
	
					var s = 1 - t,
	
						cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
	
						dir = ( cos >= 0 ? 1 : - 1 ),
						sqrSin = 1 - cos * cos;
	
					// Skip the Slerp for tiny steps to avoid numeric problems:
					if ( sqrSin > Number.EPSILON ) {
	
						var sin = Math.sqrt( sqrSin ),
							len = Math.atan2( sin, cos * dir );
	
						s = Math.sin( s * len ) / sin;
						t = Math.sin( t * len ) / sin;
	
					}
	
					var tDir = t * dir;
	
					x0 = x0 * s + x1 * tDir;
					y0 = y0 * s + y1 * tDir;
					z0 = z0 * s + z1 * tDir;
					w0 = w0 * s + w1 * tDir;
	
					// Normalize in case we just did a lerp:
					if ( s === 1 - t ) {
	
						var f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );
	
						x0 *= f;
						y0 *= f;
						z0 *= f;
						w0 *= f;
	
					}
	
				}
	
				dst[ dstOffset ] = x0;
				dst[ dstOffset + 1 ] = y0;
				dst[ dstOffset + 2 ] = z0;
				dst[ dstOffset + 3 ] = w0;
	
			}
	
		} );
	
		Object.defineProperties( Quaternion.prototype, {
	
			x: {
	
				get: function () {
	
					return this._x;
	
				},
	
				set: function ( value ) {
	
					this._x = value;
					this.onChangeCallback();
	
				}
	
			},
	
			y: {
	
				get: function () {
	
					return this._y;
	
				},
	
				set: function ( value ) {
	
					this._y = value;
					this.onChangeCallback();
	
				}
	
			},
	
			z: {
	
				get: function () {
	
					return this._z;
	
				},
	
				set: function ( value ) {
	
					this._z = value;
					this.onChangeCallback();
	
				}
	
			},
	
			w: {
	
				get: function () {
	
					return this._w;
	
				},
	
				set: function ( value ) {
	
					this._w = value;
					this.onChangeCallback();
	
				}
	
			}
	
		} );
	
		Object.assign( Quaternion.prototype, {
	
			set: function ( x, y, z, w ) {
	
				this._x = x;
				this._y = y;
				this._z = z;
				this._w = w;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this._x, this._y, this._z, this._w );
	
			},
	
			copy: function ( quaternion ) {
	
				this._x = quaternion.x;
				this._y = quaternion.y;
				this._z = quaternion.z;
				this._w = quaternion.w;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromEuler: function ( euler, update ) {
	
				if ( ! ( euler && euler.isEuler ) ) {
	
					throw new Error( 'THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.' );
	
				}
	
				var x = euler._x, y = euler._y, z = euler._z, order = euler.order;
	
				// http://www.mathworks.com/matlabcentral/fileexchange/
				// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
				//	content/SpinCalc.m
	
				var cos = Math.cos;
				var sin = Math.sin;
	
				var c1 = cos( x / 2 );
				var c2 = cos( y / 2 );
				var c3 = cos( z / 2 );
	
				var s1 = sin( x / 2 );
				var s2 = sin( y / 2 );
				var s3 = sin( z / 2 );
	
				if ( order === 'XYZ' ) {
	
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
	
				} else if ( order === 'YXZ' ) {
	
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
	
				} else if ( order === 'ZXY' ) {
	
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
	
				} else if ( order === 'ZYX' ) {
	
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
	
				} else if ( order === 'YZX' ) {
	
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
	
				} else if ( order === 'XZY' ) {
	
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
	
				}
	
				if ( update !== false ) this.onChangeCallback();
	
				return this;
	
			},
	
			setFromAxisAngle: function ( axis, angle ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
	
				// assumes axis is normalized
	
				var halfAngle = angle / 2, s = Math.sin( halfAngle );
	
				this._x = axis.x * s;
				this._y = axis.y * s;
				this._z = axis.z * s;
				this._w = Math.cos( halfAngle );
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromRotationMatrix: function ( m ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				var te = m.elements,
	
					m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
					m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
					m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],
	
					trace = m11 + m22 + m33,
					s;
	
				if ( trace > 0 ) {
	
					s = 0.5 / Math.sqrt( trace + 1.0 );
	
					this._w = 0.25 / s;
					this._x = ( m32 - m23 ) * s;
					this._y = ( m13 - m31 ) * s;
					this._z = ( m21 - m12 ) * s;
	
				} else if ( m11 > m22 && m11 > m33 ) {
	
					s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );
	
					this._w = ( m32 - m23 ) / s;
					this._x = 0.25 * s;
					this._y = ( m12 + m21 ) / s;
					this._z = ( m13 + m31 ) / s;
	
				} else if ( m22 > m33 ) {
	
					s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );
	
					this._w = ( m13 - m31 ) / s;
					this._x = ( m12 + m21 ) / s;
					this._y = 0.25 * s;
					this._z = ( m23 + m32 ) / s;
	
				} else {
	
					s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );
	
					this._w = ( m21 - m12 ) / s;
					this._x = ( m13 + m31 ) / s;
					this._y = ( m23 + m32 ) / s;
					this._z = 0.25 * s;
	
				}
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromUnitVectors: function () {
	
				// assumes direction vectors vFrom and vTo are normalized
	
				var v1 = new Vector3();
				var r;
	
				var EPS = 0.000001;
	
				return function setFromUnitVectors( vFrom, vTo ) {
	
					if ( v1 === undefined ) v1 = new Vector3();
	
					r = vFrom.dot( vTo ) + 1;
	
					if ( r < EPS ) {
	
						r = 0;
	
						if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {
	
							v1.set( - vFrom.y, vFrom.x, 0 );
	
						} else {
	
							v1.set( 0, - vFrom.z, vFrom.y );
	
						}
	
					} else {
	
						v1.crossVectors( vFrom, vTo );
	
					}
	
					this._x = v1.x;
					this._y = v1.y;
					this._z = v1.z;
					this._w = r;
	
					return this.normalize();
	
				};
	
			}(),
	
			inverse: function () {
	
				return this.conjugate().normalize();
	
			},
	
			conjugate: function () {
	
				this._x *= - 1;
				this._y *= - 1;
				this._z *= - 1;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
	
			},
	
			lengthSq: function () {
	
				return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
	
			},
	
			length: function () {
	
				return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );
	
			},
	
			normalize: function () {
	
				var l = this.length();
	
				if ( l === 0 ) {
	
					this._x = 0;
					this._y = 0;
					this._z = 0;
					this._w = 1;
	
				} else {
	
					l = 1 / l;
	
					this._x = this._x * l;
					this._y = this._y * l;
					this._z = this._z * l;
					this._w = this._w * l;
	
				}
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			multiply: function ( q, p ) {
	
				if ( p !== undefined ) {
	
					console.warn( 'THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.' );
					return this.multiplyQuaternions( q, p );
	
				}
	
				return this.multiplyQuaternions( this, q );
	
			},
	
			premultiply: function ( q ) {
	
				return this.multiplyQuaternions( q, this );
	
			},
	
			multiplyQuaternions: function ( a, b ) {
	
				// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
	
				var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
				var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
	
				this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
				this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
				this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
				this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			slerp: function ( qb, t ) {
	
				if ( t === 0 ) return this;
				if ( t === 1 ) return this.copy( qb );
	
				var x = this._x, y = this._y, z = this._z, w = this._w;
	
				// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
	
				var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
	
				if ( cosHalfTheta < 0 ) {
	
					this._w = - qb._w;
					this._x = - qb._x;
					this._y = - qb._y;
					this._z = - qb._z;
	
					cosHalfTheta = - cosHalfTheta;
	
				} else {
	
					this.copy( qb );
	
				}
	
				if ( cosHalfTheta >= 1.0 ) {
	
					this._w = w;
					this._x = x;
					this._y = y;
					this._z = z;
	
					return this;
	
				}
	
				var sinHalfTheta = Math.sqrt( 1.0 - cosHalfTheta * cosHalfTheta );
	
				if ( Math.abs( sinHalfTheta ) < 0.001 ) {
	
					this._w = 0.5 * ( w + this._w );
					this._x = 0.5 * ( x + this._x );
					this._y = 0.5 * ( y + this._y );
					this._z = 0.5 * ( z + this._z );
	
					return this;
	
				}
	
				var halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
				var ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
					ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;
	
				this._w = ( w * ratioA + this._w * ratioB );
				this._x = ( x * ratioA + this._x * ratioB );
				this._y = ( y * ratioA + this._y * ratioB );
				this._z = ( z * ratioA + this._z * ratioB );
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			equals: function ( quaternion ) {
	
				return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this._x = array[ offset ];
				this._y = array[ offset + 1 ];
				this._z = array[ offset + 2 ];
				this._w = array[ offset + 3 ];
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this._x;
				array[ offset + 1 ] = this._y;
				array[ offset + 2 ] = this._z;
				array[ offset + 3 ] = this._w;
	
				return array;
	
			},
	
			onChange: function ( callback ) {
	
				this.onChangeCallback = callback;
	
				return this;
	
			},
	
			onChangeCallback: function () {}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author kile / http://kile.stravaganza.org/
		 * @author philogb / http://blog.thejit.org/
		 * @author mikael emtinger / http://gomo.se/
		 * @author egraether / http://egraether.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Vector3( x, y, z ) {
	
			this.x = x || 0;
			this.y = y || 0;
			this.z = z || 0;
	
		}
	
		Object.assign( Vector3.prototype, {
	
			isVector3: true,
	
			set: function ( x, y, z ) {
	
				this.x = x;
				this.y = y;
				this.z = z;
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.x = scalar;
				this.y = scalar;
				this.z = scalar;
	
				return this;
	
			},
	
			setX: function ( x ) {
	
				this.x = x;
	
				return this;
	
			},
	
			setY: function ( y ) {
	
				this.y = y;
	
				return this;
	
			},
	
			setZ: function ( z ) {
	
				this.z = z;
	
				return this;
	
			},
	
			setComponent: function ( index, value ) {
	
				switch ( index ) {
	
					case 0: this.x = value; break;
					case 1: this.y = value; break;
					case 2: this.z = value; break;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
				return this;
	
			},
	
			getComponent: function ( index ) {
	
				switch ( index ) {
	
					case 0: return this.x;
					case 1: return this.y;
					case 2: return this.z;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.x, this.y, this.z );
	
			},
	
			copy: function ( v ) {
	
				this.x = v.x;
				this.y = v.y;
				this.z = v.z;
	
				return this;
	
			},
	
			add: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
					return this.addVectors( v, w );
	
				}
	
				this.x += v.x;
				this.y += v.y;
				this.z += v.z;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.x += s;
				this.y += s;
				this.z += s;
	
				return this;
	
			},
	
			addVectors: function ( a, b ) {
	
				this.x = a.x + b.x;
				this.y = a.y + b.y;
				this.z = a.z + b.z;
	
				return this;
	
			},
	
			addScaledVector: function ( v, s ) {
	
				this.x += v.x * s;
				this.y += v.y * s;
				this.z += v.z * s;
	
				return this;
	
			},
	
			sub: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
					return this.subVectors( v, w );
	
				}
	
				this.x -= v.x;
				this.y -= v.y;
				this.z -= v.z;
	
				return this;
	
			},
	
			subScalar: function ( s ) {
	
				this.x -= s;
				this.y -= s;
				this.z -= s;
	
				return this;
	
			},
	
			subVectors: function ( a, b ) {
	
				this.x = a.x - b.x;
				this.y = a.y - b.y;
				this.z = a.z - b.z;
	
				return this;
	
			},
	
			multiply: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.' );
					return this.multiplyVectors( v, w );
	
				}
	
				this.x *= v.x;
				this.y *= v.y;
				this.z *= v.z;
	
				return this;
	
			},
	
			multiplyScalar: function ( scalar ) {
	
				this.x *= scalar;
				this.y *= scalar;
				this.z *= scalar;
	
				return this;
	
			},
	
			multiplyVectors: function ( a, b ) {
	
				this.x = a.x * b.x;
				this.y = a.y * b.y;
				this.z = a.z * b.z;
	
				return this;
	
			},
	
			applyEuler: function () {
	
				var quaternion = new Quaternion();
	
				return function applyEuler( euler ) {
	
					if ( ! ( euler && euler.isEuler ) ) {
	
						console.error( 'THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.' );
	
					}
	
					return this.applyQuaternion( quaternion.setFromEuler( euler ) );
	
				};
	
			}(),
	
			applyAxisAngle: function () {
	
				var quaternion = new Quaternion();
	
				return function applyAxisAngle( axis, angle ) {
	
					return this.applyQuaternion( quaternion.setFromAxisAngle( axis, angle ) );
	
				};
	
			}(),
	
			applyMatrix3: function ( m ) {
	
				var x = this.x, y = this.y, z = this.z;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
				this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
				this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;
	
				return this;
	
			},
	
			applyMatrix4: function ( m ) {
	
				var x = this.x, y = this.y, z = this.z;
				var e = m.elements;
	
				var w = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] );
	
				this.x = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z + e[ 12 ] ) * w;
				this.y = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z + e[ 13 ] ) * w;
				this.z = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * w;
	
				return this;
	
			},
	
			applyQuaternion: function ( q ) {
	
				var x = this.x, y = this.y, z = this.z;
				var qx = q.x, qy = q.y, qz = q.z, qw = q.w;
	
				// calculate quat * vector
	
				var ix =  qw * x + qy * z - qz * y;
				var iy =  qw * y + qz * x - qx * z;
				var iz =  qw * z + qx * y - qy * x;
				var iw = - qx * x - qy * y - qz * z;
	
				// calculate result * inverse quat
	
				this.x = ix * qw + iw * - qx + iy * - qz - iz * - qy;
				this.y = iy * qw + iw * - qy + iz * - qx - ix * - qz;
				this.z = iz * qw + iw * - qz + ix * - qy - iy * - qx;
	
				return this;
	
			},
	
			project: function () {
	
				var matrix = new Matrix4();
	
				return function project( camera ) {
	
					matrix.multiplyMatrices( camera.projectionMatrix, matrix.getInverse( camera.matrixWorld ) );
					return this.applyMatrix4( matrix );
	
				};
	
			}(),
	
			unproject: function () {
	
				var matrix = new Matrix4();
	
				return function unproject( camera ) {
	
					matrix.multiplyMatrices( camera.matrixWorld, matrix.getInverse( camera.projectionMatrix ) );
					return this.applyMatrix4( matrix );
	
				};
	
			}(),
	
			transformDirection: function ( m ) {
	
				// input: THREE.Matrix4 affine matrix
				// vector interpreted as a direction
	
				var x = this.x, y = this.y, z = this.z;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ]  * z;
				this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ]  * z;
				this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;
	
				return this.normalize();
	
			},
	
			divide: function ( v ) {
	
				this.x /= v.x;
				this.y /= v.y;
				this.z /= v.z;
	
				return this;
	
			},
	
			divideScalar: function ( scalar ) {
	
				return this.multiplyScalar( 1 / scalar );
	
			},
	
			min: function ( v ) {
	
				this.x = Math.min( this.x, v.x );
				this.y = Math.min( this.y, v.y );
				this.z = Math.min( this.z, v.z );
	
				return this;
	
			},
	
			max: function ( v ) {
	
				this.x = Math.max( this.x, v.x );
				this.y = Math.max( this.y, v.y );
				this.z = Math.max( this.z, v.z );
	
				return this;
	
			},
	
			clamp: function ( min, max ) {
	
				// assumes min < max, componentwise
	
				this.x = Math.max( min.x, Math.min( max.x, this.x ) );
				this.y = Math.max( min.y, Math.min( max.y, this.y ) );
				this.z = Math.max( min.z, Math.min( max.z, this.z ) );
	
				return this;
	
			},
	
			clampScalar: function () {
	
				var min = new Vector3();
				var max = new Vector3();
	
				return function clampScalar( minVal, maxVal ) {
	
					min.set( minVal, minVal, minVal );
					max.set( maxVal, maxVal, maxVal );
	
					return this.clamp( min, max );
	
				};
	
			}(),
	
			clampLength: function ( min, max ) {
	
				var length = this.length();
	
				return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );
	
			},
	
			floor: function () {
	
				this.x = Math.floor( this.x );
				this.y = Math.floor( this.y );
				this.z = Math.floor( this.z );
	
				return this;
	
			},
	
			ceil: function () {
	
				this.x = Math.ceil( this.x );
				this.y = Math.ceil( this.y );
				this.z = Math.ceil( this.z );
	
				return this;
	
			},
	
			round: function () {
	
				this.x = Math.round( this.x );
				this.y = Math.round( this.y );
				this.z = Math.round( this.z );
	
				return this;
	
			},
	
			roundToZero: function () {
	
				this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
				this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
				this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );
	
				return this;
	
			},
	
			negate: function () {
	
				this.x = - this.x;
				this.y = - this.y;
				this.z = - this.z;
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this.x * v.x + this.y * v.y + this.z * v.z;
	
			},
	
			// TODO lengthSquared?
	
			lengthSq: function () {
	
				return this.x * this.x + this.y * this.y + this.z * this.z;
	
			},
	
			length: function () {
	
				return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );
	
			},
	
			lengthManhattan: function () {
	
				return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );
	
			},
	
			normalize: function () {
	
				return this.divideScalar( this.length() || 1 );
	
			},
	
			setLength: function ( length ) {
	
				return this.normalize().multiplyScalar( length );
	
			},
	
			lerp: function ( v, alpha ) {
	
				this.x += ( v.x - this.x ) * alpha;
				this.y += ( v.y - this.y ) * alpha;
				this.z += ( v.z - this.z ) * alpha;
	
				return this;
	
			},
	
			lerpVectors: function ( v1, v2, alpha ) {
	
				return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );
	
			},
	
			cross: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.' );
					return this.crossVectors( v, w );
	
				}
	
				var x = this.x, y = this.y, z = this.z;
	
				this.x = y * v.z - z * v.y;
				this.y = z * v.x - x * v.z;
				this.z = x * v.y - y * v.x;
	
				return this;
	
			},
	
			crossVectors: function ( a, b ) {
	
				var ax = a.x, ay = a.y, az = a.z;
				var bx = b.x, by = b.y, bz = b.z;
	
				this.x = ay * bz - az * by;
				this.y = az * bx - ax * bz;
				this.z = ax * by - ay * bx;
	
				return this;
	
			},
	
			projectOnVector: function ( vector ) {
	
				var scalar = vector.dot( this ) / vector.lengthSq();
	
				return this.copy( vector ).multiplyScalar( scalar );
	
			},
	
			projectOnPlane: function () {
	
				var v1 = new Vector3();
	
				return function projectOnPlane( planeNormal ) {
	
					v1.copy( this ).projectOnVector( planeNormal );
	
					return this.sub( v1 );
	
				};
	
			}(),
	
			reflect: function () {
	
				// reflect incident vector off plane orthogonal to normal
				// normal is assumed to have unit length
	
				var v1 = new Vector3();
	
				return function reflect( normal ) {
	
					return this.sub( v1.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );
	
				};
	
			}(),
	
			angleTo: function ( v ) {
	
				var theta = this.dot( v ) / ( Math.sqrt( this.lengthSq() * v.lengthSq() ) );
	
				// clamp, to handle numerical problems
	
				return Math.acos( _Math.clamp( theta, - 1, 1 ) );
	
			},
	
			distanceTo: function ( v ) {
	
				return Math.sqrt( this.distanceToSquared( v ) );
	
			},
	
			distanceToSquared: function ( v ) {
	
				var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
	
				return dx * dx + dy * dy + dz * dz;
	
			},
	
			distanceToManhattan: function ( v ) {
	
				return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );
	
			},
	
			setFromSpherical: function ( s ) {
	
				var sinPhiRadius = Math.sin( s.phi ) * s.radius;
	
				this.x = sinPhiRadius * Math.sin( s.theta );
				this.y = Math.cos( s.phi ) * s.radius;
				this.z = sinPhiRadius * Math.cos( s.theta );
	
				return this;
	
			},
	
			setFromCylindrical: function ( c ) {
	
				this.x = c.radius * Math.sin( c.theta );
				this.y = c.y;
				this.z = c.radius * Math.cos( c.theta );
	
				return this;
	
			},
	
			setFromMatrixPosition: function ( m ) {
	
				var e = m.elements;
	
				this.x = e[ 12 ];
				this.y = e[ 13 ];
				this.z = e[ 14 ];
	
				return this;
	
			},
	
			setFromMatrixScale: function ( m ) {
	
				var sx = this.setFromMatrixColumn( m, 0 ).length();
				var sy = this.setFromMatrixColumn( m, 1 ).length();
				var sz = this.setFromMatrixColumn( m, 2 ).length();
	
				this.x = sx;
				this.y = sy;
				this.z = sz;
	
				return this;
	
			},
	
			setFromMatrixColumn: function ( m, index ) {
	
				return this.fromArray( m.elements, index * 4 );
	
			},
	
			equals: function ( v ) {
	
				return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.x = array[ offset ];
				this.y = array[ offset + 1 ];
				this.z = array[ offset + 2 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.x;
				array[ offset + 1 ] = this.y;
				array[ offset + 2 ] = this.z;
	
				return array;
	
			},
	
			fromBufferAttribute: function ( attribute, index, offset ) {
	
				if ( offset !== undefined ) {
	
					console.warn( 'THREE.Vector3: offset has been removed from .fromBufferAttribute().' );
	
				}
	
				this.x = attribute.getX( index );
				this.y = attribute.getY( index );
				this.z = attribute.getZ( index );
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author supereggbert / http://www.paulbrunt.co.uk/
		 * @author philogb / http://blog.thejit.org/
		 * @author jordi_ros / http://plattsoft.com
		 * @author D1plo1d / http://github.com/D1plo1d
		 * @author alteredq / http://alteredqualia.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author timknip / http://www.floorplanner.com/
		 * @author bhouston / http://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Matrix4() {
	
			this.elements = [
	
				1, 0, 0, 0,
				0, 1, 0, 0,
				0, 0, 1, 0,
				0, 0, 0, 1
	
			];
	
			if ( arguments.length > 0 ) {
	
				console.error( 'THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.' );
	
			}
	
		}
	
		Object.assign( Matrix4.prototype, {
	
			isMatrix4: true,
	
			set: function ( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {
	
				var te = this.elements;
	
				te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
				te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
				te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
				te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;
	
				return this;
	
			},
	
			identity: function () {
	
				this.set(
	
					1, 0, 0, 0,
					0, 1, 0, 0,
					0, 0, 1, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			clone: function () {
	
				return new Matrix4().fromArray( this.elements );
	
			},
	
			copy: function ( m ) {
	
				var te = this.elements;
				var me = m.elements;
	
				te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ]; te[ 3 ] = me[ 3 ];
				te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ]; te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ];
				te[ 8 ] = me[ 8 ]; te[ 9 ] = me[ 9 ]; te[ 10 ] = me[ 10 ]; te[ 11 ] = me[ 11 ];
				te[ 12 ] = me[ 12 ]; te[ 13 ] = me[ 13 ]; te[ 14 ] = me[ 14 ]; te[ 15 ] = me[ 15 ];
	
				return this;
	
			},
	
			copyPosition: function ( m ) {
	
				var te = this.elements, me = m.elements;
	
				te[ 12 ] = me[ 12 ];
				te[ 13 ] = me[ 13 ];
				te[ 14 ] = me[ 14 ];
	
				return this;
	
			},
	
			extractBasis: function ( xAxis, yAxis, zAxis ) {
	
				xAxis.setFromMatrixColumn( this, 0 );
				yAxis.setFromMatrixColumn( this, 1 );
				zAxis.setFromMatrixColumn( this, 2 );
	
				return this;
	
			},
	
			makeBasis: function ( xAxis, yAxis, zAxis ) {
	
				this.set(
					xAxis.x, yAxis.x, zAxis.x, 0,
					xAxis.y, yAxis.y, zAxis.y, 0,
					xAxis.z, yAxis.z, zAxis.z, 0,
					0,       0,       0,       1
				);
	
				return this;
	
			},
	
			extractRotation: function () {
	
				var v1 = new Vector3();
	
				return function extractRotation( m ) {
	
					var te = this.elements;
					var me = m.elements;
	
					var scaleX = 1 / v1.setFromMatrixColumn( m, 0 ).length();
					var scaleY = 1 / v1.setFromMatrixColumn( m, 1 ).length();
					var scaleZ = 1 / v1.setFromMatrixColumn( m, 2 ).length();
	
					te[ 0 ] = me[ 0 ] * scaleX;
					te[ 1 ] = me[ 1 ] * scaleX;
					te[ 2 ] = me[ 2 ] * scaleX;
	
					te[ 4 ] = me[ 4 ] * scaleY;
					te[ 5 ] = me[ 5 ] * scaleY;
					te[ 6 ] = me[ 6 ] * scaleY;
	
					te[ 8 ] = me[ 8 ] * scaleZ;
					te[ 9 ] = me[ 9 ] * scaleZ;
					te[ 10 ] = me[ 10 ] * scaleZ;
	
					return this;
	
				};
	
			}(),
	
			makeRotationFromEuler: function ( euler ) {
	
				if ( ! ( euler && euler.isEuler ) ) {
	
					console.error( 'THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.' );
	
				}
	
				var te = this.elements;
	
				var x = euler.x, y = euler.y, z = euler.z;
				var a = Math.cos( x ), b = Math.sin( x );
				var c = Math.cos( y ), d = Math.sin( y );
				var e = Math.cos( z ), f = Math.sin( z );
	
				if ( euler.order === 'XYZ' ) {
	
					var ae = a * e, af = a * f, be = b * e, bf = b * f;
	
					te[ 0 ] = c * e;
					te[ 4 ] = - c * f;
					te[ 8 ] = d;
	
					te[ 1 ] = af + be * d;
					te[ 5 ] = ae - bf * d;
					te[ 9 ] = - b * c;
	
					te[ 2 ] = bf - ae * d;
					te[ 6 ] = be + af * d;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'YXZ' ) {
	
					var ce = c * e, cf = c * f, de = d * e, df = d * f;
	
					te[ 0 ] = ce + df * b;
					te[ 4 ] = de * b - cf;
					te[ 8 ] = a * d;
	
					te[ 1 ] = a * f;
					te[ 5 ] = a * e;
					te[ 9 ] = - b;
	
					te[ 2 ] = cf * b - de;
					te[ 6 ] = df + ce * b;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'ZXY' ) {
	
					var ce = c * e, cf = c * f, de = d * e, df = d * f;
	
					te[ 0 ] = ce - df * b;
					te[ 4 ] = - a * f;
					te[ 8 ] = de + cf * b;
	
					te[ 1 ] = cf + de * b;
					te[ 5 ] = a * e;
					te[ 9 ] = df - ce * b;
	
					te[ 2 ] = - a * d;
					te[ 6 ] = b;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'ZYX' ) {
	
					var ae = a * e, af = a * f, be = b * e, bf = b * f;
	
					te[ 0 ] = c * e;
					te[ 4 ] = be * d - af;
					te[ 8 ] = ae * d + bf;
	
					te[ 1 ] = c * f;
					te[ 5 ] = bf * d + ae;
					te[ 9 ] = af * d - be;
	
					te[ 2 ] = - d;
					te[ 6 ] = b * c;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'YZX' ) {
	
					var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
	
					te[ 0 ] = c * e;
					te[ 4 ] = bd - ac * f;
					te[ 8 ] = bc * f + ad;
	
					te[ 1 ] = f;
					te[ 5 ] = a * e;
					te[ 9 ] = - b * e;
	
					te[ 2 ] = - d * e;
					te[ 6 ] = ad * f + bc;
					te[ 10 ] = ac - bd * f;
	
				} else if ( euler.order === 'XZY' ) {
	
					var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
	
					te[ 0 ] = c * e;
					te[ 4 ] = - f;
					te[ 8 ] = d * e;
	
					te[ 1 ] = ac * f + bd;
					te[ 5 ] = a * e;
					te[ 9 ] = ad * f - bc;
	
					te[ 2 ] = bc * f - ad;
					te[ 6 ] = b * e;
					te[ 10 ] = bd * f + ac;
	
				}
	
				// last column
				te[ 3 ] = 0;
				te[ 7 ] = 0;
				te[ 11 ] = 0;
	
				// bottom row
				te[ 12 ] = 0;
				te[ 13 ] = 0;
				te[ 14 ] = 0;
				te[ 15 ] = 1;
	
				return this;
	
			},
	
			makeRotationFromQuaternion: function ( q ) {
	
				var te = this.elements;
	
				var x = q._x, y = q._y, z = q._z, w = q._w;
				var x2 = x + x, y2 = y + y, z2 = z + z;
				var xx = x * x2, xy = x * y2, xz = x * z2;
				var yy = y * y2, yz = y * z2, zz = z * z2;
				var wx = w * x2, wy = w * y2, wz = w * z2;
	
				te[ 0 ] = 1 - ( yy + zz );
				te[ 4 ] = xy - wz;
				te[ 8 ] = xz + wy;
	
				te[ 1 ] = xy + wz;
				te[ 5 ] = 1 - ( xx + zz );
				te[ 9 ] = yz - wx;
	
				te[ 2 ] = xz - wy;
				te[ 6 ] = yz + wx;
				te[ 10 ] = 1 - ( xx + yy );
	
				// last column
				te[ 3 ] = 0;
				te[ 7 ] = 0;
				te[ 11 ] = 0;
	
				// bottom row
				te[ 12 ] = 0;
				te[ 13 ] = 0;
				te[ 14 ] = 0;
				te[ 15 ] = 1;
	
				return this;
	
			},
	
			lookAt: function () {
	
				var x = new Vector3();
				var y = new Vector3();
				var z = new Vector3();
	
				return function lookAt( eye, target, up ) {
	
					var te = this.elements;
	
					z.subVectors( eye, target );
	
					if ( z.lengthSq() === 0 ) {
	
						// eye and target are in the same position
	
						z.z = 1;
	
					}
	
					z.normalize();
					x.crossVectors( up, z );
	
					if ( x.lengthSq() === 0 ) {
	
						// up and z are parallel
	
						if ( Math.abs( up.z ) === 1 ) {
	
							z.x += 0.0001;
	
						} else {
	
							z.z += 0.0001;
	
						}
	
						z.normalize();
						x.crossVectors( up, z );
	
					}
	
					x.normalize();
					y.crossVectors( z, x );
	
					te[ 0 ] = x.x; te[ 4 ] = y.x; te[ 8 ] = z.x;
					te[ 1 ] = x.y; te[ 5 ] = y.y; te[ 9 ] = z.y;
					te[ 2 ] = x.z; te[ 6 ] = y.z; te[ 10 ] = z.z;
	
					return this;
	
				};
	
			}(),
	
			multiply: function ( m, n ) {
	
				if ( n !== undefined ) {
	
					console.warn( 'THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.' );
					return this.multiplyMatrices( m, n );
	
				}
	
				return this.multiplyMatrices( this, m );
	
			},
	
			premultiply: function ( m ) {
	
				return this.multiplyMatrices( m, this );
	
			},
	
			multiplyMatrices: function ( a, b ) {
	
				var ae = a.elements;
				var be = b.elements;
				var te = this.elements;
	
				var a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
				var a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
				var a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
				var a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];
	
				var b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
				var b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
				var b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
				var b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];
	
				te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
				te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
				te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
				te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
	
				te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
				te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
				te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
				te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
	
				te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
				te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
				te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
				te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
	
				te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
				te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
				te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
				te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
	
				return this;
	
			},
	
			multiplyScalar: function ( s ) {
	
				var te = this.elements;
	
				te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
				te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
				te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
				te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;
	
				return this;
	
			},
	
			applyToBufferAttribute: function () {
	
				var v1 = new Vector3();
	
				return function applyToBufferAttribute( attribute ) {
	
					for ( var i = 0, l = attribute.count; i < l; i ++ ) {
	
						v1.x = attribute.getX( i );
						v1.y = attribute.getY( i );
						v1.z = attribute.getZ( i );
	
						v1.applyMatrix4( this );
	
						attribute.setXYZ( i, v1.x, v1.y, v1.z );
	
					}
	
					return attribute;
	
				};
	
			}(),
	
			determinant: function () {
	
				var te = this.elements;
	
				var n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
				var n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
				var n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
				var n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];
	
				//TODO: make this more efficient
				//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
	
				return (
					n41 * (
						+ n14 * n23 * n32
						 - n13 * n24 * n32
						 - n14 * n22 * n33
						 + n12 * n24 * n33
						 + n13 * n22 * n34
						 - n12 * n23 * n34
					) +
					n42 * (
						+ n11 * n23 * n34
						 - n11 * n24 * n33
						 + n14 * n21 * n33
						 - n13 * n21 * n34
						 + n13 * n24 * n31
						 - n14 * n23 * n31
					) +
					n43 * (
						+ n11 * n24 * n32
						 - n11 * n22 * n34
						 - n14 * n21 * n32
						 + n12 * n21 * n34
						 + n14 * n22 * n31
						 - n12 * n24 * n31
					) +
					n44 * (
						- n13 * n22 * n31
						 - n11 * n23 * n32
						 + n11 * n22 * n33
						 + n13 * n21 * n32
						 - n12 * n21 * n33
						 + n12 * n23 * n31
					)
	
				);
	
			},
	
			transpose: function () {
	
				var te = this.elements;
				var tmp;
	
				tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
				tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
				tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;
	
				tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
				tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
				tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;
	
				return this;
	
			},
	
			setPosition: function ( v ) {
	
				var te = this.elements;
	
				te[ 12 ] = v.x;
				te[ 13 ] = v.y;
				te[ 14 ] = v.z;
	
				return this;
	
			},
	
			getInverse: function ( m, throwOnDegenerate ) {
	
				// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
				var te = this.elements,
					me = m.elements,
	
					n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ], n41 = me[ 3 ],
					n12 = me[ 4 ], n22 = me[ 5 ], n32 = me[ 6 ], n42 = me[ 7 ],
					n13 = me[ 8 ], n23 = me[ 9 ], n33 = me[ 10 ], n43 = me[ 11 ],
					n14 = me[ 12 ], n24 = me[ 13 ], n34 = me[ 14 ], n44 = me[ 15 ],
	
					t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
					t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
					t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
					t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
	
				var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
	
				if ( det === 0 ) {
	
					var msg = "THREE.Matrix4: .getInverse() can't invert matrix, determinant is 0";
	
					if ( throwOnDegenerate === true ) {
	
						throw new Error( msg );
	
					} else {
	
						console.warn( msg );
	
					}
	
					return this.identity();
	
				}
	
				var detInv = 1 / det;
	
				te[ 0 ] = t11 * detInv;
				te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
				te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
				te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;
	
				te[ 4 ] = t12 * detInv;
				te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
				te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
				te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;
	
				te[ 8 ] = t13 * detInv;
				te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
				te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
				te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;
	
				te[ 12 ] = t14 * detInv;
				te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
				te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
				te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;
	
				return this;
	
			},
	
			scale: function ( v ) {
	
				var te = this.elements;
				var x = v.x, y = v.y, z = v.z;
	
				te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
				te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
				te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
				te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;
	
				return this;
	
			},
	
			getMaxScaleOnAxis: function () {
	
				var te = this.elements;
	
				var scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
				var scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
				var scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];
	
				return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );
	
			},
	
			makeTranslation: function ( x, y, z ) {
	
				this.set(
	
					1, 0, 0, x,
					0, 1, 0, y,
					0, 0, 1, z,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationX: function ( theta ) {
	
				var c = Math.cos( theta ), s = Math.sin( theta );
	
				this.set(
	
					1, 0,  0, 0,
					0, c, - s, 0,
					0, s,  c, 0,
					0, 0,  0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationY: function ( theta ) {
	
				var c = Math.cos( theta ), s = Math.sin( theta );
	
				this.set(
	
					 c, 0, s, 0,
					 0, 1, 0, 0,
					- s, 0, c, 0,
					 0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationZ: function ( theta ) {
	
				var c = Math.cos( theta ), s = Math.sin( theta );
	
				this.set(
	
					c, - s, 0, 0,
					s,  c, 0, 0,
					0,  0, 1, 0,
					0,  0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationAxis: function ( axis, angle ) {
	
				// Based on http://www.gamedev.net/reference/articles/article1199.asp
	
				var c = Math.cos( angle );
				var s = Math.sin( angle );
				var t = 1 - c;
				var x = axis.x, y = axis.y, z = axis.z;
				var tx = t * x, ty = t * y;
	
				this.set(
	
					tx * x + c, tx * y - s * z, tx * z + s * y, 0,
					tx * y + s * z, ty * y + c, ty * z - s * x, 0,
					tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
					0, 0, 0, 1
	
				);
	
				 return this;
	
			},
	
			makeScale: function ( x, y, z ) {
	
				this.set(
	
					x, 0, 0, 0,
					0, y, 0, 0,
					0, 0, z, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeShear: function ( x, y, z ) {
	
				this.set(
	
					1, y, z, 0,
					x, 1, z, 0,
					x, y, 1, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			compose: function ( position, quaternion, scale ) {
	
				this.makeRotationFromQuaternion( quaternion );
				this.scale( scale );
				this.setPosition( position );
	
				return this;
	
			},
	
			decompose: function () {
	
				var vector = new Vector3();
				var matrix = new Matrix4();
	
				return function decompose( position, quaternion, scale ) {
	
					var te = this.elements;
	
					var sx = vector.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
					var sy = vector.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
					var sz = vector.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();
	
					// if determine is negative, we need to invert one scale
					var det = this.determinant();
					if ( det < 0 ) sx = - sx;
	
					position.x = te[ 12 ];
					position.y = te[ 13 ];
					position.z = te[ 14 ];
	
					// scale the rotation part
					matrix.copy( this );
	
					var invSX = 1 / sx;
					var invSY = 1 / sy;
					var invSZ = 1 / sz;
	
					matrix.elements[ 0 ] *= invSX;
					matrix.elements[ 1 ] *= invSX;
					matrix.elements[ 2 ] *= invSX;
	
					matrix.elements[ 4 ] *= invSY;
					matrix.elements[ 5 ] *= invSY;
					matrix.elements[ 6 ] *= invSY;
	
					matrix.elements[ 8 ] *= invSZ;
					matrix.elements[ 9 ] *= invSZ;
					matrix.elements[ 10 ] *= invSZ;
	
					quaternion.setFromRotationMatrix( matrix );
	
					scale.x = sx;
					scale.y = sy;
					scale.z = sz;
	
					return this;
	
				};
	
			}(),
	
			makePerspective: function ( left, right, top, bottom, near, far ) {
	
				if ( far === undefined ) {
	
					console.warn( 'THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.' );
	
				}
	
				var te = this.elements;
				var x = 2 * near / ( right - left );
				var y = 2 * near / ( top - bottom );
	
				var a = ( right + left ) / ( right - left );
				var b = ( top + bottom ) / ( top - bottom );
				var c = - ( far + near ) / ( far - near );
				var d = - 2 * far * near / ( far - near );
	
				te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a;	te[ 12 ] = 0;
				te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b;	te[ 13 ] = 0;
				te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c;	te[ 14 ] = d;
				te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;
	
				return this;
	
			},
	
			makeOrthographic: function ( left, right, top, bottom, near, far ) {
	
				var te = this.elements;
				var w = 1.0 / ( right - left );
				var h = 1.0 / ( top - bottom );
				var p = 1.0 / ( far - near );
	
				var x = ( right + left ) * w;
				var y = ( top + bottom ) * h;
				var z = ( far + near ) * p;
	
				te[ 0 ] = 2 * w;	te[ 4 ] = 0;	te[ 8 ] = 0;	te[ 12 ] = - x;
				te[ 1 ] = 0;	te[ 5 ] = 2 * h;	te[ 9 ] = 0;	te[ 13 ] = - y;
				te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = - 2 * p;	te[ 14 ] = - z;
				te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = 0;	te[ 15 ] = 1;
	
				return this;
	
			},
	
			equals: function ( matrix ) {
	
				var te = this.elements;
				var me = matrix.elements;
	
				for ( var i = 0; i < 16; i ++ ) {
	
					if ( te[ i ] !== me[ i ] ) return false;
	
				}
	
				return true;
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				for ( var i = 0; i < 16; i ++ ) {
	
					this.elements[ i ] = array[ i + offset ];
	
				}
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				var te = this.elements;
	
				array[ offset ] = te[ 0 ];
				array[ offset + 1 ] = te[ 1 ];
				array[ offset + 2 ] = te[ 2 ];
				array[ offset + 3 ] = te[ 3 ];
	
				array[ offset + 4 ] = te[ 4 ];
				array[ offset + 5 ] = te[ 5 ];
				array[ offset + 6 ] = te[ 6 ];
				array[ offset + 7 ] = te[ 7 ];
	
				array[ offset + 8 ] = te[ 8 ];
				array[ offset + 9 ] = te[ 9 ];
				array[ offset + 10 ] = te[ 10 ];
				array[ offset + 11 ] = te[ 11 ];
	
				array[ offset + 12 ] = te[ 12 ];
				array[ offset + 13 ] = te[ 13 ];
				array[ offset + 14 ] = te[ 14 ];
				array[ offset + 15 ] = te[ 15 ];
	
				return array;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function DataTexture( data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {
	
			Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );
	
			this.image = { data: data, width: width, height: height };
	
			this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
			this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
	
			this.generateMipmaps = false;
			this.flipY = false;
			this.unpackAlignment = 1;
	
		}
	
		DataTexture.prototype = Object.create( Texture.prototype );
		DataTexture.prototype.constructor = DataTexture;
	
		DataTexture.prototype.isDataTexture = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function CubeTexture( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {
	
			images = images !== undefined ? images : [];
			mapping = mapping !== undefined ? mapping : CubeReflectionMapping;
	
			Texture.call( this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );
	
			this.flipY = false;
	
		}
	
		CubeTexture.prototype = Object.create( Texture.prototype );
		CubeTexture.prototype.constructor = CubeTexture;
	
		CubeTexture.prototype.isCubeTexture = true;
	
		Object.defineProperty( CubeTexture.prototype, 'images', {
	
			get: function () {
	
				return this.image;
	
			},
	
			set: function ( value ) {
	
				this.image = value;
	
			}
	
		} );
	
		/**
		 * @author tschw
		 *
		 * Uniforms of a program.
		 * Those form a tree structure with a special top-level container for the root,
		 * which you get by calling 'new WebGLUniforms( gl, program, renderer )'.
		 *
		 *
		 * Properties of inner nodes including the top-level container:
		 *
		 * .seq - array of nested uniforms
		 * .map - nested uniforms by name
		 *
		 *
		 * Methods of all nodes except the top-level container:
		 *
		 * .setValue( gl, value, [renderer] )
		 *
		 * 		uploads a uniform value(s)
		 *  	the 'renderer' parameter is needed for sampler uniforms
		 *
		 *
		 * Static methods of the top-level container (renderer factorizations):
		 *
		 * .upload( gl, seq, values, renderer )
		 *
		 * 		sets uniforms in 'seq' to 'values[id].value'
		 *
		 * .seqWithValue( seq, values ) : filteredSeq
		 *
		 * 		filters 'seq' entries with corresponding entry in values
		 *
		 *
		 * Methods of the top-level container (renderer factorizations):
		 *
		 * .setValue( gl, name, value )
		 *
		 * 		sets uniform with  name 'name' to 'value'
		 *
		 * .set( gl, obj, prop )
		 *
		 * 		sets uniform from object and property with same name than uniform
		 *
		 * .setOptional( gl, obj, prop )
		 *
		 * 		like .set for an optional property of the object
		 *
		 */
	
		var emptyTexture = new Texture();
		var emptyCubeTexture = new CubeTexture();
	
		// --- Base for inner nodes (including the root) ---
	
		function UniformContainer() {
	
			this.seq = [];
			this.map = {};
	
		}
	
		// --- Utilities ---
	
		// Array Caches (provide typed arrays for temporary by size)
	
		var arrayCacheF32 = [];
		var arrayCacheI32 = [];
	
		// Float32Array caches used for uploading Matrix uniforms
	
		var mat4array = new Float32Array( 16 );
		var mat3array = new Float32Array( 9 );
	
		// Flattening for arrays of vectors and matrices
	
		function flatten( array, nBlocks, blockSize ) {
	
			var firstElem = array[ 0 ];
	
			if ( firstElem <= 0 || firstElem > 0 ) return array;
			// unoptimized: ! isNaN( firstElem )
			// see http://jacksondunstan.com/articles/983
	
			var n = nBlocks * blockSize,
				r = arrayCacheF32[ n ];
	
			if ( r === undefined ) {
	
				r = new Float32Array( n );
				arrayCacheF32[ n ] = r;
	
			}
	
			if ( nBlocks !== 0 ) {
	
				firstElem.toArray( r, 0 );
	
				for ( var i = 1, offset = 0; i !== nBlocks; ++ i ) {
	
					offset += blockSize;
					array[ i ].toArray( r, offset );
	
				}
	
			}
	
			return r;
	
		}
	
		// Texture unit allocation
	
		function allocTexUnits( renderer, n ) {
	
			var r = arrayCacheI32[ n ];
	
			if ( r === undefined ) {
	
				r = new Int32Array( n );
				arrayCacheI32[ n ] = r;
	
			}
	
			for ( var i = 0; i !== n; ++ i )
				r[ i ] = renderer.allocTextureUnit();
	
			return r;
	
		}
	
		// --- Setters ---
	
		// Note: Defining these methods externally, because they come in a bunch
		// and this way their names minify.
	
		// Single scalar
	
		function setValue1f( gl, v ) { gl.uniform1f( this.addr, v ); }
		function setValue1i( gl, v ) { gl.uniform1i( this.addr, v ); }
	
		// Single float vector (from flat array or THREE.VectorN)
	
		function setValue2fv( gl, v ) {
	
			if ( v.x === undefined ) gl.uniform2fv( this.addr, v );
			else gl.uniform2f( this.addr, v.x, v.y );
	
		}
	
		function setValue3fv( gl, v ) {
	
			if ( v.x !== undefined )
				gl.uniform3f( this.addr, v.x, v.y, v.z );
			else if ( v.r !== undefined )
				gl.uniform3f( this.addr, v.r, v.g, v.b );
			else
				gl.uniform3fv( this.addr, v );
	
		}
	
		function setValue4fv( gl, v ) {
	
			if ( v.x === undefined ) gl.uniform4fv( this.addr, v );
			else gl.uniform4f( this.addr, v.x, v.y, v.z, v.w );
	
		}
	
		// Single matrix (from flat array or MatrixN)
	
		function setValue2fm( gl, v ) {
	
			gl.uniformMatrix2fv( this.addr, false, v.elements || v );
	
		}
	
		function setValue3fm( gl, v ) {
	
			if ( v.elements === undefined ) {
	
				gl.uniformMatrix3fv( this.addr, false, v );
	
			} else {
	
				mat3array.set( v.elements );
				gl.uniformMatrix3fv( this.addr, false, mat3array );
	
			}
	
		}
	
		function setValue4fm( gl, v ) {
	
			if ( v.elements === undefined ) {
	
				gl.uniformMatrix4fv( this.addr, false, v );
	
			} else {
	
				mat4array.set( v.elements );
				gl.uniformMatrix4fv( this.addr, false, mat4array );
	
			}
	
		}
	
		// Single texture (2D / Cube)
	
		function setValueT1( gl, v, renderer ) {
	
			var unit = renderer.allocTextureUnit();
			gl.uniform1i( this.addr, unit );
			renderer.setTexture2D( v || emptyTexture, unit );
	
		}
	
		function setValueT6( gl, v, renderer ) {
	
			var unit = renderer.allocTextureUnit();
			gl.uniform1i( this.addr, unit );
			renderer.setTextureCube( v || emptyCubeTexture, unit );
	
		}
	
		// Integer / Boolean vectors or arrays thereof (always flat arrays)
	
		function setValue2iv( gl, v ) { gl.uniform2iv( this.addr, v ); }
		function setValue3iv( gl, v ) { gl.uniform3iv( this.addr, v ); }
		function setValue4iv( gl, v ) { gl.uniform4iv( this.addr, v ); }
	
		// Helper to pick the right setter for the singular case
	
		function getSingularSetter( type ) {
	
			switch ( type ) {
	
				case 0x1406: return setValue1f; // FLOAT
				case 0x8b50: return setValue2fv; // _VEC2
				case 0x8b51: return setValue3fv; // _VEC3
				case 0x8b52: return setValue4fv; // _VEC4
	
				case 0x8b5a: return setValue2fm; // _MAT2
				case 0x8b5b: return setValue3fm; // _MAT3
				case 0x8b5c: return setValue4fm; // _MAT4
	
				case 0x8b5e: case 0x8d66: return setValueT1; // SAMPLER_2D, SAMPLER_EXTERNAL_OES
				case 0x8b60: return setValueT6; // SAMPLER_CUBE
	
				case 0x1404: case 0x8b56: return setValue1i; // INT, BOOL
				case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
				case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
				case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4
	
			}
	
		}
	
		// Array of scalars
	
		function setValue1fv( gl, v ) { gl.uniform1fv( this.addr, v ); }
		function setValue1iv( gl, v ) { gl.uniform1iv( this.addr, v ); }
	
		// Array of vectors (flat or from THREE classes)
	
		function setValueV2a( gl, v ) {
	
			gl.uniform2fv( this.addr, flatten( v, this.size, 2 ) );
	
		}
	
		function setValueV3a( gl, v ) {
	
			gl.uniform3fv( this.addr, flatten( v, this.size, 3 ) );
	
		}
	
		function setValueV4a( gl, v ) {
	
			gl.uniform4fv( this.addr, flatten( v, this.size, 4 ) );
	
		}
	
		// Array of matrices (flat or from THREE clases)
	
		function setValueM2a( gl, v ) {
	
			gl.uniformMatrix2fv( this.addr, false, flatten( v, this.size, 4 ) );
	
		}
	
		function setValueM3a( gl, v ) {
	
			gl.uniformMatrix3fv( this.addr, false, flatten( v, this.size, 9 ) );
	
		}
	
		function setValueM4a( gl, v ) {
	
			gl.uniformMatrix4fv( this.addr, false, flatten( v, this.size, 16 ) );
	
		}
	
		// Array of textures (2D / Cube)
	
		function setValueT1a( gl, v, renderer ) {
	
			var n = v.length,
				units = allocTexUnits( renderer, n );
	
			gl.uniform1iv( this.addr, units );
	
			for ( var i = 0; i !== n; ++ i ) {
	
				renderer.setTexture2D( v[ i ] || emptyTexture, units[ i ] );
	
			}
	
		}
	
		function setValueT6a( gl, v, renderer ) {
	
			var n = v.length,
				units = allocTexUnits( renderer, n );
	
			gl.uniform1iv( this.addr, units );
	
			for ( var i = 0; i !== n; ++ i ) {
	
				renderer.setTextureCube( v[ i ] || emptyCubeTexture, units[ i ] );
	
			}
	
		}
	
		// Helper to pick the right setter for a pure (bottom-level) array
	
		function getPureArraySetter( type ) {
	
			switch ( type ) {
	
				case 0x1406: return setValue1fv; // FLOAT
				case 0x8b50: return setValueV2a; // _VEC2
				case 0x8b51: return setValueV3a; // _VEC3
				case 0x8b52: return setValueV4a; // _VEC4
	
				case 0x8b5a: return setValueM2a; // _MAT2
				case 0x8b5b: return setValueM3a; // _MAT3
				case 0x8b5c: return setValueM4a; // _MAT4
	
				case 0x8b5e: return setValueT1a; // SAMPLER_2D
				case 0x8b60: return setValueT6a; // SAMPLER_CUBE
	
				case 0x1404: case 0x8b56: return setValue1iv; // INT, BOOL
				case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
				case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
				case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4
	
			}
	
		}
	
		// --- Uniform Classes ---
	
		function SingleUniform( id, activeInfo, addr ) {
	
			this.id = id;
			this.addr = addr;
			this.setValue = getSingularSetter( activeInfo.type );
	
			// this.path = activeInfo.name; // DEBUG
	
		}
	
		function PureArrayUniform( id, activeInfo, addr ) {
	
			this.id = id;
			this.addr = addr;
			this.size = activeInfo.size;
			this.setValue = getPureArraySetter( activeInfo.type );
	
			// this.path = activeInfo.name; // DEBUG
	
		}
	
		function StructuredUniform( id ) {
	
			this.id = id;
	
			UniformContainer.call( this ); // mix-in
	
		}
	
		StructuredUniform.prototype.setValue = function ( gl, value ) {
	
			// Note: Don't need an extra 'renderer' parameter, since samplers
			// are not allowed in structured uniforms.
	
			var seq = this.seq;
	
			for ( var i = 0, n = seq.length; i !== n; ++ i ) {
	
				var u = seq[ i ];
				u.setValue( gl, value[ u.id ] );
	
			}
	
		};
	
		// --- Top-level ---
	
		// Parser - builds up the property tree from the path strings
	
		var RePathPart = /([\w\d_]+)(\])?(\[|\.)?/g;
	
		// extracts
		// 	- the identifier (member name or array index)
		//  - followed by an optional right bracket (found when array index)
		//  - followed by an optional left bracket or dot (type of subscript)
		//
		// Note: These portions can be read in a non-overlapping fashion and
		// allow straightforward parsing of the hierarchy that WebGL encodes
		// in the uniform names.
	
		function addUniform( container, uniformObject ) {
	
			container.seq.push( uniformObject );
			container.map[ uniformObject.id ] = uniformObject;
	
		}
	
		function parseUniform( activeInfo, addr, container ) {
	
			var path = activeInfo.name,
				pathLength = path.length;
	
			// reset RegExp object, because of the early exit of a previous run
			RePathPart.lastIndex = 0;
	
			for ( ; ; ) {
	
				var match = RePathPart.exec( path ),
					matchEnd = RePathPart.lastIndex,
	
					id = match[ 1 ],
					idIsIndex = match[ 2 ] === ']',
					subscript = match[ 3 ];
	
				if ( idIsIndex ) id = id | 0; // convert to integer
	
				if ( subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength ) {
	
					// bare name or "pure" bottom-level array "[0]" suffix
	
					addUniform( container, subscript === undefined ?
							new SingleUniform( id, activeInfo, addr ) :
							new PureArrayUniform( id, activeInfo, addr ) );
	
					break;
	
				} else {
	
					// step into inner node / create it in case it doesn't exist
	
					var map = container.map, next = map[ id ];
	
					if ( next === undefined ) {
	
						next = new StructuredUniform( id );
						addUniform( container, next );
	
					}
	
					container = next;
	
				}
	
			}
	
		}
	
		// Root Container
	
		function WebGLUniforms( gl, program, renderer ) {
	
			UniformContainer.call( this );
	
			this.renderer = renderer;
	
			var n = gl.getProgramParameter( program, gl.ACTIVE_UNIFORMS );
	
			for ( var i = 0; i < n; ++ i ) {
	
				var info = gl.getActiveUniform( program, i ),
					path = info.name,
					addr = gl.getUniformLocation( program, path );
	
				parseUniform( info, addr, this );
	
			}
	
		}
	
		WebGLUniforms.prototype.setValue = function ( gl, name, value ) {
	
			var u = this.map[ name ];
	
			if ( u !== undefined ) u.setValue( gl, value, this.renderer );
	
		};
	
		WebGLUniforms.prototype.setOptional = function ( gl, object, name ) {
	
			var v = object[ name ];
	
			if ( v !== undefined ) this.setValue( gl, name, v );
	
		};
	
	
		// Static interface
	
		WebGLUniforms.upload = function ( gl, seq, values, renderer ) {
	
			for ( var i = 0, n = seq.length; i !== n; ++ i ) {
	
				var u = seq[ i ],
					v = values[ u.id ];
	
				if ( v.needsUpdate !== false ) {
	
					// note: always updating when .needsUpdate is undefined
					u.setValue( gl, v.value, renderer );
	
				}
	
			}
	
		};
	
		WebGLUniforms.seqWithValue = function ( seq, values ) {
	
			var r = [];
	
			for ( var i = 0, n = seq.length; i !== n; ++ i ) {
	
				var u = seq[ i ];
				if ( u.id in values ) r.push( u );
	
			}
	
			return r;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var ColorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
			'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
			'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
			'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
			'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
			'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
			'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
			'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
			'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
			'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
			'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
			'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
			'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
			'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
			'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
			'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
			'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
			'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
			'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
			'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'rebeccapurple': 0x663399, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
			'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
			'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
			'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
			'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };
	
		function Color( r, g, b ) {
	
			if ( g === undefined && b === undefined ) {
	
				// r is THREE.Color, hex or string
				return this.set( r );
	
			}
	
			return this.setRGB( r, g, b );
	
		}
	
		Object.assign( Color.prototype, {
	
			isColor: true,
	
			r: 1, g: 1, b: 1,
	
			set: function ( value ) {
	
				if ( value && value.isColor ) {
	
					this.copy( value );
	
				} else if ( typeof value === 'number' ) {
	
					this.setHex( value );
	
				} else if ( typeof value === 'string' ) {
	
					this.setStyle( value );
	
				}
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.r = scalar;
				this.g = scalar;
				this.b = scalar;
	
				return this;
	
			},
	
			setHex: function ( hex ) {
	
				hex = Math.floor( hex );
	
				this.r = ( hex >> 16 & 255 ) / 255;
				this.g = ( hex >> 8 & 255 ) / 255;
				this.b = ( hex & 255 ) / 255;
	
				return this;
	
			},
	
			setRGB: function ( r, g, b ) {
	
				this.r = r;
				this.g = g;
				this.b = b;
	
				return this;
	
			},
	
			setHSL: function () {
	
				function hue2rgb( p, q, t ) {
	
					if ( t < 0 ) t += 1;
					if ( t > 1 ) t -= 1;
					if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
					if ( t < 1 / 2 ) return q;
					if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
					return p;
	
				}
	
				return function setHSL( h, s, l ) {
	
					// h,s,l ranges are in 0.0 - 1.0
					h = _Math.euclideanModulo( h, 1 );
					s = _Math.clamp( s, 0, 1 );
					l = _Math.clamp( l, 0, 1 );
	
					if ( s === 0 ) {
	
						this.r = this.g = this.b = l;
	
					} else {
	
						var p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
						var q = ( 2 * l ) - p;
	
						this.r = hue2rgb( q, p, h + 1 / 3 );
						this.g = hue2rgb( q, p, h );
						this.b = hue2rgb( q, p, h - 1 / 3 );
	
					}
	
					return this;
	
				};
	
			}(),
	
			setStyle: function ( style ) {
	
				function handleAlpha( string ) {
	
					if ( string === undefined ) return;
	
					if ( parseFloat( string ) < 1 ) {
	
						console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );
	
					}
	
				}
	
	
				var m;
	
				if ( m = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec( style ) ) {
	
					// rgb / hsl
	
					var color;
					var name = m[ 1 ];
					var components = m[ 2 ];
	
					switch ( name ) {
	
						case 'rgb':
						case 'rgba':
	
							if ( color = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {
	
								// rgb(255,0,0) rgba(255,0,0,0.5)
								this.r = Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255;
								this.g = Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255;
								this.b = Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255;
	
								handleAlpha( color[ 5 ] );
	
								return this;
	
							}
	
							if ( color = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {
	
								// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
								this.r = Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100;
								this.g = Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100;
								this.b = Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100;
	
								handleAlpha( color[ 5 ] );
	
								return this;
	
							}
	
							break;
	
						case 'hsl':
						case 'hsla':
	
							if ( color = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {
	
								// hsl(120,50%,50%) hsla(120,50%,50%,0.5)
								var h = parseFloat( color[ 1 ] ) / 360;
								var s = parseInt( color[ 2 ], 10 ) / 100;
								var l = parseInt( color[ 3 ], 10 ) / 100;
	
								handleAlpha( color[ 5 ] );
	
								return this.setHSL( h, s, l );
	
							}
	
							break;
	
					}
	
				} else if ( m = /^\#([A-Fa-f0-9]+)$/.exec( style ) ) {
	
					// hex color
	
					var hex = m[ 1 ];
					var size = hex.length;
	
					if ( size === 3 ) {
	
						// #ff0
						this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 0 ), 16 ) / 255;
						this.g = parseInt( hex.charAt( 1 ) + hex.charAt( 1 ), 16 ) / 255;
						this.b = parseInt( hex.charAt( 2 ) + hex.charAt( 2 ), 16 ) / 255;
	
						return this;
	
					} else if ( size === 6 ) {
	
						// #ff0000
						this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 1 ), 16 ) / 255;
						this.g = parseInt( hex.charAt( 2 ) + hex.charAt( 3 ), 16 ) / 255;
						this.b = parseInt( hex.charAt( 4 ) + hex.charAt( 5 ), 16 ) / 255;
	
						return this;
	
					}
	
				}
	
				if ( style && style.length > 0 ) {
	
					// color keywords
					var hex = ColorKeywords[ style ];
	
					if ( hex !== undefined ) {
	
						// red
						this.setHex( hex );
	
					} else {
	
						// unknown color
						console.warn( 'THREE.Color: Unknown color ' + style );
	
					}
	
				}
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this.r, this.g, this.b );
	
			},
	
			copy: function ( color ) {
	
				this.r = color.r;
				this.g = color.g;
				this.b = color.b;
	
				return this;
	
			},
	
			copyGammaToLinear: function ( color, gammaFactor ) {
	
				if ( gammaFactor === undefined ) gammaFactor = 2.0;
	
				this.r = Math.pow( color.r, gammaFactor );
				this.g = Math.pow( color.g, gammaFactor );
				this.b = Math.pow( color.b, gammaFactor );
	
				return this;
	
			},
	
			copyLinearToGamma: function ( color, gammaFactor ) {
	
				if ( gammaFactor === undefined ) gammaFactor = 2.0;
	
				var safeInverse = ( gammaFactor > 0 ) ? ( 1.0 / gammaFactor ) : 1.0;
	
				this.r = Math.pow( color.r, safeInverse );
				this.g = Math.pow( color.g, safeInverse );
				this.b = Math.pow( color.b, safeInverse );
	
				return this;
	
			},
	
			convertGammaToLinear: function () {
	
				var r = this.r, g = this.g, b = this.b;
	
				this.r = r * r;
				this.g = g * g;
				this.b = b * b;
	
				return this;
	
			},
	
			convertLinearToGamma: function () {
	
				this.r = Math.sqrt( this.r );
				this.g = Math.sqrt( this.g );
				this.b = Math.sqrt( this.b );
	
				return this;
	
			},
	
			getHex: function () {
	
				return ( this.r * 255 ) << 16 ^ ( this.g * 255 ) << 8 ^ ( this.b * 255 ) << 0;
	
			},
	
			getHexString: function () {
	
				return ( '000000' + this.getHex().toString( 16 ) ).slice( - 6 );
	
			},
	
			getHSL: function ( optionalTarget ) {
	
				// h,s,l ranges are in 0.0 - 1.0
	
				var hsl = optionalTarget || { h: 0, s: 0, l: 0 };
	
				var r = this.r, g = this.g, b = this.b;
	
				var max = Math.max( r, g, b );
				var min = Math.min( r, g, b );
	
				var hue, saturation;
				var lightness = ( min + max ) / 2.0;
	
				if ( min === max ) {
	
					hue = 0;
					saturation = 0;
	
				} else {
	
					var delta = max - min;
	
					saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );
	
					switch ( max ) {
	
						case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
						case g: hue = ( b - r ) / delta + 2; break;
						case b: hue = ( r - g ) / delta + 4; break;
	
					}
	
					hue /= 6;
	
				}
	
				hsl.h = hue;
				hsl.s = saturation;
				hsl.l = lightness;
	
				return hsl;
	
			},
	
			getStyle: function () {
	
				return 'rgb(' + ( ( this.r * 255 ) | 0 ) + ',' + ( ( this.g * 255 ) | 0 ) + ',' + ( ( this.b * 255 ) | 0 ) + ')';
	
			},
	
			offsetHSL: function ( h, s, l ) {
	
				var hsl = this.getHSL();
	
				hsl.h += h; hsl.s += s; hsl.l += l;
	
				this.setHSL( hsl.h, hsl.s, hsl.l );
	
				return this;
	
			},
	
			add: function ( color ) {
	
				this.r += color.r;
				this.g += color.g;
				this.b += color.b;
	
				return this;
	
			},
	
			addColors: function ( color1, color2 ) {
	
				this.r = color1.r + color2.r;
				this.g = color1.g + color2.g;
				this.b = color1.b + color2.b;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.r += s;
				this.g += s;
				this.b += s;
	
				return this;
	
			},
	
			sub: function( color ) {
	
				this.r = Math.max( 0, this.r - color.r );
				this.g = Math.max( 0, this.g - color.g );
				this.b = Math.max( 0, this.b - color.b );
	
				return this;
	
			},
	
			multiply: function ( color ) {
	
				this.r *= color.r;
				this.g *= color.g;
				this.b *= color.b;
	
				return this;
	
			},
	
			multiplyScalar: function ( s ) {
	
				this.r *= s;
				this.g *= s;
				this.b *= s;
	
				return this;
	
			},
	
			lerp: function ( color, alpha ) {
	
				this.r += ( color.r - this.r ) * alpha;
				this.g += ( color.g - this.g ) * alpha;
				this.b += ( color.b - this.b ) * alpha;
	
				return this;
	
			},
	
			equals: function ( c ) {
	
				return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.r = array[ offset ];
				this.g = array[ offset + 1 ];
				this.b = array[ offset + 2 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.r;
				array[ offset + 1 ] = this.g;
				array[ offset + 2 ] = this.b;
	
				return array;
	
			},
	
			toJSON: function () {
	
				return this.getHex();
	
			}
	
		} );
	
		/**
		 * Uniforms library for shared webgl shaders
		 */
	
		var UniformsLib = {
	
			common: {
	
				diffuse: { value: new Color( 0xeeeeee ) },
				opacity: { value: 1.0 },
	
				map: { value: null },
				offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) },
	
				alphaMap: { value: null },
	
			},
	
			specularmap: {
	
				specularMap: { value: null },
	
			},
	
			envmap: {
	
				envMap: { value: null },
				flipEnvMap: { value: - 1 },
				reflectivity: { value: 1.0 },
				refractionRatio: { value: 0.98 }
	
			},
	
			aomap: {
	
				aoMap: { value: null },
				aoMapIntensity: { value: 1 }
	
			},
	
			lightmap: {
	
				lightMap: { value: null },
				lightMapIntensity: { value: 1 }
	
			},
	
			emissivemap: {
	
				emissiveMap: { value: null }
	
			},
	
			bumpmap: {
	
				bumpMap: { value: null },
				bumpScale: { value: 1 }
	
			},
	
			normalmap: {
	
				normalMap: { value: null },
				normalScale: { value: new Vector2( 1, 1 ) }
	
			},
	
			displacementmap: {
	
				displacementMap: { value: null },
				displacementScale: { value: 1 },
				displacementBias: { value: 0 }
	
			},
	
			roughnessmap: {
	
				roughnessMap: { value: null }
	
			},
	
			metalnessmap: {
	
				metalnessMap: { value: null }
	
			},
	
			gradientmap: {
	
				gradientMap: { value: null }
	
			},
	
			fog: {
	
				fogDensity: { value: 0.00025 },
				fogNear: { value: 1 },
				fogFar: { value: 2000 },
				fogColor: { value: new Color( 0xffffff ) }
	
			},
	
			lights: {
	
				ambientLightColor: { value: [] },
	
				directionalLights: { value: [], properties: {
					direction: {},
					color: {},
	
					shadow: {},
					shadowBias: {},
					shadowRadius: {},
					shadowMapSize: {}
				} },
	
				directionalShadowMap: { value: [] },
				directionalShadowMatrix: { value: [] },
	
				spotLights: { value: [], properties: {
					color: {},
					position: {},
					direction: {},
					distance: {},
					coneCos: {},
					penumbraCos: {},
					decay: {},
	
					shadow: {},
					shadowBias: {},
					shadowRadius: {},
					shadowMapSize: {}
				} },
	
				spotShadowMap: { value: [] },
				spotShadowMatrix: { value: [] },
	
				pointLights: { value: [], properties: {
					color: {},
					position: {},
					decay: {},
					distance: {},
	
					shadow: {},
					shadowBias: {},
					shadowRadius: {},
					shadowMapSize: {},
					shadowCameraNear: {},
					shadowCameraFar: {}
				} },
	
				pointShadowMap: { value: [] },
				pointShadowMatrix: { value: [] },
	
				hemisphereLights: { value: [], properties: {
					direction: {},
					skyColor: {},
					groundColor: {}
				} },
	
				// TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
				rectAreaLights: { value: [], properties: {
					color: {},
					position: {},
					width: {},
					height: {}
				} }
	
			},
	
			points: {
	
				diffuse: { value: new Color( 0xeeeeee ) },
				opacity: { value: 1.0 },
				size: { value: 1.0 },
				scale: { value: 1.0 },
				map: { value: null },
				offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) }
	
			}
	
		};
	
		/**
		 * Uniform Utilities
		 */
	
		var UniformsUtils = {
	
			merge: function ( uniforms ) {
	
				var merged = {};
	
				for ( var u = 0; u < uniforms.length; u ++ ) {
	
					var tmp = this.clone( uniforms[ u ] );
	
					for ( var p in tmp ) {
	
						merged[ p ] = tmp[ p ];
	
					}
	
				}
	
				return merged;
	
			},
	
			clone: function ( uniforms_src ) {
	
				var uniforms_dst = {};
	
				for ( var u in uniforms_src ) {
	
					uniforms_dst[ u ] = {};
	
					for ( var p in uniforms_src[ u ] ) {
	
						var parameter_src = uniforms_src[ u ][ p ];
	
						if ( parameter_src && ( parameter_src.isColor ||
							parameter_src.isMatrix3 || parameter_src.isMatrix4 ||
							parameter_src.isVector2 || parameter_src.isVector3 || parameter_src.isVector4 ||
							parameter_src.isTexture ) ) {
	
							uniforms_dst[ u ][ p ] = parameter_src.clone();
	
						} else if ( Array.isArray( parameter_src ) ) {
	
							uniforms_dst[ u ][ p ] = parameter_src.slice();
	
						} else {
	
							uniforms_dst[ u ][ p ] = parameter_src;
	
						}
	
					}
	
				}
	
				return uniforms_dst;
	
			}
	
		};
	
		var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n";
	
		var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n";
	
		var alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n";
	
		var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n";
	
		var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
	
		var begin_vertex = "\nvec3 transformed = vec3( position );\n";
	
		var beginnormal_vertex = "\nvec3 objectNormal = vec3( normal );\n";
	
		var bsdfs = "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t}\n\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5 / LUT_SIZE;\n\tfloat theta = acos( dot( N, V ) );\n\tvec2 uv = vec2(\n\t\tsqrt( saturate( roughness ) ),\n\t\tsaturate( theta / ( 0.5 * PI ) ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.86267 + (0.49788 + 0.01436 * y ) * y;\n\tfloat b = 3.45068 + (4.18814 + y) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = (x > 0.0) ? v : 0.5 * inversesqrt( 1.0 - x * x ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tvec3 result = vec3( LTC_ClippedSphereFormFactor( vectorFormFactor ) );\n\treturn result;\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n";
	
		var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n";
	
		var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; ++ i ) {\n\t\tvec4 plane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t\t\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; ++ i ) {\n\t\t\tvec4 plane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t\n\t#endif\n#endif\n";
	
		var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n";
	
		var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n";
	
		var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n";
	
		var color_fragment = "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif";
	
		var color_pars_fragment = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n";
	
		var color_pars_vertex = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif";
	
		var color_vertex = "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif";
	
		var common = "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transpose( const in mat3 v ) {\n\tmat3 tmp;\n\ttmp[0] = vec3(v[0].x, v[1].x, v[2].x);\n\ttmp[1] = vec3(v[0].y, v[1].y, v[2].y);\n\ttmp[2] = vec3(v[0].z, v[1].z, v[2].z);\n\treturn tmp;\n}\n";
	
		var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV(vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n";
	
		var defaultnormal_vertex = "vec3 transformedNormal = normalMatrix * objectNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n";
	
		var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n";
	
		var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n";
	
		var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n";
	
		var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n";
	
		var encodings_fragment = "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n";
	
		var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM            = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat D      = max( maxRange / maxRGB, 1.0 );\n\tD            = min( floor( D ) / 255.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n\tvec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n\tXp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract(Le);\n\tvResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n\treturn vec4( max(vRGB, 0.0), 1.0 );\n}\n";
	
		var envmap_fragment = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\treflectVec = normalize( reflectVec );\n\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\treflectVec = normalize( reflectVec );\n\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n";
	
		var envmap_pars_fragment = "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n";
	
		var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n";
	
		var envmap_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n";
	
		var fog_vertex = "\n#ifdef USE_FOG\nfogDepth = -mvPosition.z;\n#endif";
	
		var fog_pars_vertex = "#ifdef USE_FOG\n  varying float fogDepth;\n#endif\n";
	
		var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n";
	
		var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif\n";
	
		var gradientmap_pars_fragment = "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n";
	
		var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n";
	
		var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
	
		var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n";
	
		var lights_pars = "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t\tfloat shadowCameraNear;\n\t\tfloat shadowCameraFar;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltcMat;\tuniform sampler2D ltcMag;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar - 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV(queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n";
	
		var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n";
	
		var lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n";
	
		var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n";
	
		var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos - halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos + halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos + halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos - halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tfloat norm = texture2D( ltcMag, uv ).a;\n\t\tvec4 t = texture2D( ltcMat, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3(   1,   0, t.y ),\n\t\t\tvec3(   0, t.z,   0 ),\n\t\t\tvec3( t.w,   0, t.x )\n\t\t);\n\t\treflectedLight.directSpecular += lightColor * material.specularColor * norm * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n";
	
		var lights_template = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tirradiance += getLightProbeIndirectIrradiance( geometry, 8 );\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tvec3 radiance = getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), 8 );\n\t#ifndef STANDARD\n\t\tvec3 clearCoatRadiance = getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), 8 );\n\t#else\n\t\tvec3 clearCoatRadiance = vec3( 0.0 );\n\t#endif\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n";
	
		var logdepthbuf_fragment = "#if defined(USE_LOGDEPTHBUF) && defined(USE_LOGDEPTHBUF_EXT)\n\tgl_FragDepthEXT = log2(vFragDepth) * logDepthBufFC * 0.5;\n#endif";
	
		var logdepthbuf_pars_fragment = "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n";
	
		var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif";
	
		var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tgl_Position.z = log2(max( EPSILON, gl_Position.w + 1.0 )) * logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = (gl_Position.z - 1.0) * gl_Position.w;\n\t#endif\n#endif\n";
	
		var map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n";
	
		var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n";
	
		var map_particle_fragment = "#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) * offsetRepeat.zw + offsetRepeat.xy );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n";
	
		var map_particle_pars_fragment = "#ifdef USE_MAP\n\tuniform vec4 offsetRepeat;\n\tuniform sampler2D map;\n#endif\n";
	
		var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif\n";
	
		var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
	
		var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n";
	
		var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";
	
		var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n";
	
		var normal_fragment = "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#endif\n#endif\n#ifdef USE_NORMALMAP\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n";
	
		var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 S = normalize( q0 * st1.t - q1 * st0.t );\n\t\tvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\n\t\tvec3 N = normalize( surf_norm );\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy = normalScale * mapN.xy;\n\t\tmat3 tsn = mat3( S, T, N );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif\n";
	
		var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 1.0 - 2.0 * rgb.xyz;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n";
	
		var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n";
	
		var project_vertex = "vec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\ngl_Position = projectionMatrix * mvPosition;\n";
	
		var dithering_fragment = "#if defined( DITHERING )\n  gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif\n";
	
		var dithering_pars_fragment = "#if defined( DITHERING )\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif\n";
	
		var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif\n";
	
		var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
	
		var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n";
	
		var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n#endif\n";
	
		var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n#endif\n";
	
		var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#endif\n\t#endif\n\treturn shadow;\n}\n";
	
		var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
	
		var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n";
	
		var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif\n";
	
		var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n";
	
		var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
	
		var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
	
		var tonemapping_fragment = "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n";
	
		var tonemapping_pars_fragment = "#define saturate(a) clamp( a, 0.0, 1.0 )\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n";
	
		var uv_pars_fragment = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif";
	
		var uv_pars_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform vec4 offsetRepeat;\n#endif\n";
	
		var uv_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = uv * offsetRepeat.zw + offsetRepeat.xy;\n#endif";
	
		var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
	
		var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif";
	
		var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif";
	
		var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( PHONG ) || defined( PHYSICAL ) || defined( LAMBERT ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP )\n\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n#endif\n";
	
		var cube_frag = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n";
	
		var cube_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";
	
		var depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n";
	
		var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n";
	
		var distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}\n";
	
		var distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}\n";
	
		var equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = asin( clamp( direction.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n";
	
		var equirect_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";
	
		var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";
	
		var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";
	
		var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshphysical_frag = "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <lights_pars>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";
	
		var meshphysical_vert = "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}\n";
	
		var normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n";
	
		var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <bsdfs>\n#include <lights_pars>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n}\n";
	
		var shadow_vert = "#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n";
	
		var ShaderChunk = {
			alphamap_fragment: alphamap_fragment,
			alphamap_pars_fragment: alphamap_pars_fragment,
			alphatest_fragment: alphatest_fragment,
			aomap_fragment: aomap_fragment,
			aomap_pars_fragment: aomap_pars_fragment,
			begin_vertex: begin_vertex,
			beginnormal_vertex: beginnormal_vertex,
			bsdfs: bsdfs,
			bumpmap_pars_fragment: bumpmap_pars_fragment,
			clipping_planes_fragment: clipping_planes_fragment,
			clipping_planes_pars_fragment: clipping_planes_pars_fragment,
			clipping_planes_pars_vertex: clipping_planes_pars_vertex,
			clipping_planes_vertex: clipping_planes_vertex,
			color_fragment: color_fragment,
			color_pars_fragment: color_pars_fragment,
			color_pars_vertex: color_pars_vertex,
			color_vertex: color_vertex,
			common: common,
			cube_uv_reflection_fragment: cube_uv_reflection_fragment,
			defaultnormal_vertex: defaultnormal_vertex,
			displacementmap_pars_vertex: displacementmap_pars_vertex,
			displacementmap_vertex: displacementmap_vertex,
			emissivemap_fragment: emissivemap_fragment,
			emissivemap_pars_fragment: emissivemap_pars_fragment,
			encodings_fragment: encodings_fragment,
			encodings_pars_fragment: encodings_pars_fragment,
			envmap_fragment: envmap_fragment,
			envmap_pars_fragment: envmap_pars_fragment,
			envmap_pars_vertex: envmap_pars_vertex,
			envmap_vertex: envmap_vertex,
			fog_vertex: fog_vertex,
			fog_pars_vertex: fog_pars_vertex,
			fog_fragment: fog_fragment,
			fog_pars_fragment: fog_pars_fragment,
			gradientmap_pars_fragment: gradientmap_pars_fragment,
			lightmap_fragment: lightmap_fragment,
			lightmap_pars_fragment: lightmap_pars_fragment,
			lights_lambert_vertex: lights_lambert_vertex,
			lights_pars: lights_pars,
			lights_phong_fragment: lights_phong_fragment,
			lights_phong_pars_fragment: lights_phong_pars_fragment,
			lights_physical_fragment: lights_physical_fragment,
			lights_physical_pars_fragment: lights_physical_pars_fragment,
			lights_template: lights_template,
			logdepthbuf_fragment: logdepthbuf_fragment,
			logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
			logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
			logdepthbuf_vertex: logdepthbuf_vertex,
			map_fragment: map_fragment,
			map_pars_fragment: map_pars_fragment,
			map_particle_fragment: map_particle_fragment,
			map_particle_pars_fragment: map_particle_pars_fragment,
			metalnessmap_fragment: metalnessmap_fragment,
			metalnessmap_pars_fragment: metalnessmap_pars_fragment,
			morphnormal_vertex: morphnormal_vertex,
			morphtarget_pars_vertex: morphtarget_pars_vertex,
			morphtarget_vertex: morphtarget_vertex,
			normal_fragment: normal_fragment,
			normalmap_pars_fragment: normalmap_pars_fragment,
			packing: packing,
			premultiplied_alpha_fragment: premultiplied_alpha_fragment,
			project_vertex: project_vertex,
			dithering_fragment: dithering_fragment,
			dithering_pars_fragment: dithering_pars_fragment,
			roughnessmap_fragment: roughnessmap_fragment,
			roughnessmap_pars_fragment: roughnessmap_pars_fragment,
			shadowmap_pars_fragment: shadowmap_pars_fragment,
			shadowmap_pars_vertex: shadowmap_pars_vertex,
			shadowmap_vertex: shadowmap_vertex,
			shadowmask_pars_fragment: shadowmask_pars_fragment,
			skinbase_vertex: skinbase_vertex,
			skinning_pars_vertex: skinning_pars_vertex,
			skinning_vertex: skinning_vertex,
			skinnormal_vertex: skinnormal_vertex,
			specularmap_fragment: specularmap_fragment,
			specularmap_pars_fragment: specularmap_pars_fragment,
			tonemapping_fragment: tonemapping_fragment,
			tonemapping_pars_fragment: tonemapping_pars_fragment,
			uv_pars_fragment: uv_pars_fragment,
			uv_pars_vertex: uv_pars_vertex,
			uv_vertex: uv_vertex,
			uv2_pars_fragment: uv2_pars_fragment,
			uv2_pars_vertex: uv2_pars_vertex,
			uv2_vertex: uv2_vertex,
			worldpos_vertex: worldpos_vertex,
	
			cube_frag: cube_frag,
			cube_vert: cube_vert,
			depth_frag: depth_frag,
			depth_vert: depth_vert,
			distanceRGBA_frag: distanceRGBA_frag,
			distanceRGBA_vert: distanceRGBA_vert,
			equirect_frag: equirect_frag,
			equirect_vert: equirect_vert,
			linedashed_frag: linedashed_frag,
			linedashed_vert: linedashed_vert,
			meshbasic_frag: meshbasic_frag,
			meshbasic_vert: meshbasic_vert,
			meshlambert_frag: meshlambert_frag,
			meshlambert_vert: meshlambert_vert,
			meshphong_frag: meshphong_frag,
			meshphong_vert: meshphong_vert,
			meshphysical_frag: meshphysical_frag,
			meshphysical_vert: meshphysical_vert,
			normal_frag: normal_frag,
			normal_vert: normal_vert,
			points_frag: points_frag,
			points_vert: points_vert,
			shadow_frag: shadow_frag,
			shadow_vert: shadow_vert
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author mikael emtinger / http://gomo.se/
		 */
	
		var ShaderLib = {
	
			basic: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.specularmap,
					UniformsLib.envmap,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.fog
				] ),
	
				vertexShader: ShaderChunk.meshbasic_vert,
				fragmentShader: ShaderChunk.meshbasic_frag
	
			},
	
			lambert: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.specularmap,
					UniformsLib.envmap,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.emissivemap,
					UniformsLib.fog,
					UniformsLib.lights,
					{
						emissive: { value: new Color( 0x000000 ) }
					}
				] ),
	
				vertexShader: ShaderChunk.meshlambert_vert,
				fragmentShader: ShaderChunk.meshlambert_frag
	
			},
	
			phong: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.specularmap,
					UniformsLib.envmap,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.emissivemap,
					UniformsLib.bumpmap,
					UniformsLib.normalmap,
					UniformsLib.displacementmap,
					UniformsLib.gradientmap,
					UniformsLib.fog,
					UniformsLib.lights,
					{
						emissive: { value: new Color( 0x000000 ) },
						specular: { value: new Color( 0x111111 ) },
						shininess: { value: 30 }
					}
				] ),
	
				vertexShader: ShaderChunk.meshphong_vert,
				fragmentShader: ShaderChunk.meshphong_frag
	
			},
	
			standard: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.envmap,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.emissivemap,
					UniformsLib.bumpmap,
					UniformsLib.normalmap,
					UniformsLib.displacementmap,
					UniformsLib.roughnessmap,
					UniformsLib.metalnessmap,
					UniformsLib.fog,
					UniformsLib.lights,
					{
						emissive: { value: new Color( 0x000000 ) },
						roughness: { value: 0.5 },
						metalness: { value: 0.5 },
						envMapIntensity: { value: 1 } // temporary
					}
				] ),
	
				vertexShader: ShaderChunk.meshphysical_vert,
				fragmentShader: ShaderChunk.meshphysical_frag
	
			},
	
			points: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.points,
					UniformsLib.fog
				] ),
	
				vertexShader: ShaderChunk.points_vert,
				fragmentShader: ShaderChunk.points_frag
	
			},
	
			dashed: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.fog,
					{
						scale: { value: 1 },
						dashSize: { value: 1 },
						totalSize: { value: 2 }
					}
				] ),
	
				vertexShader: ShaderChunk.linedashed_vert,
				fragmentShader: ShaderChunk.linedashed_frag
	
			},
	
			depth: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.displacementmap
				] ),
	
				vertexShader: ShaderChunk.depth_vert,
				fragmentShader: ShaderChunk.depth_frag
	
			},
	
			normal: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.bumpmap,
					UniformsLib.normalmap,
					UniformsLib.displacementmap,
					{
						opacity: { value: 1.0 }
					}
				] ),
	
				vertexShader: ShaderChunk.normal_vert,
				fragmentShader: ShaderChunk.normal_frag
	
			},
	
			/* -------------------------------------------------------------------------
			//	Cube map shader
			 ------------------------------------------------------------------------- */
	
			cube: {
	
				uniforms: {
					tCube: { value: null },
					tFlip: { value: - 1 },
					opacity: { value: 1.0 }
				},
	
				vertexShader: ShaderChunk.cube_vert,
				fragmentShader: ShaderChunk.cube_frag
	
			},
	
			equirect: {
	
				uniforms: {
					tEquirect: { value: null },
				},
	
				vertexShader: ShaderChunk.equirect_vert,
				fragmentShader: ShaderChunk.equirect_frag
	
			},
	
			distanceRGBA: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.displacementmap,
					{
						referencePosition: { value: new Vector3() },
						nearDistance: { value: 1 },
						farDistance: { value: 1000 }
					}
				] ),
	
				vertexShader: ShaderChunk.distanceRGBA_vert,
				fragmentShader: ShaderChunk.distanceRGBA_frag
	
			},
	
			shadow: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.lights,
					{
						color: { value: new Color( 0x00000 ) },
						opacity: { value: 1.0 }
					},
				] ),
	
				vertexShader: ShaderChunk.shadow_vert,
				fragmentShader: ShaderChunk.shadow_frag
	
			}
	
		};
	
		ShaderLib.physical = {
	
			uniforms: UniformsUtils.merge( [
				ShaderLib.standard.uniforms,
				{
					clearCoat: { value: 0 },
					clearCoatRoughness: { value: 0 }
				}
			] ),
	
			vertexShader: ShaderChunk.meshphysical_vert,
			fragmentShader: ShaderChunk.meshphysical_frag
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Box2( min, max ) {
	
			this.min = ( min !== undefined ) ? min : new Vector2( + Infinity, + Infinity );
			this.max = ( max !== undefined ) ? max : new Vector2( - Infinity, - Infinity );
	
		}
	
		Object.assign( Box2.prototype, {
	
			set: function ( min, max ) {
	
				this.min.copy( min );
				this.max.copy( max );
	
				return this;
	
			},
	
			setFromPoints: function ( points ) {
	
				this.makeEmpty();
	
				for ( var i = 0, il = points.length; i < il; i ++ ) {
	
					this.expandByPoint( points[ i ] );
	
				}
	
				return this;
	
			},
	
			setFromCenterAndSize: function () {
	
				var v1 = new Vector2();
	
				return function setFromCenterAndSize( center, size ) {
	
					var halfSize = v1.copy( size ).multiplyScalar( 0.5 );
					this.min.copy( center ).sub( halfSize );
					this.max.copy( center ).add( halfSize );
	
					return this;
	
				};
	
			}(),
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( box ) {
	
				this.min.copy( box.min );
				this.max.copy( box.max );
	
				return this;
	
			},
	
			makeEmpty: function () {
	
				this.min.x = this.min.y = + Infinity;
				this.max.x = this.max.y = - Infinity;
	
				return this;
	
			},
	
			isEmpty: function () {
	
				// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
	
				return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y );
	
			},
	
			getCenter: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector2();
				return this.isEmpty() ? result.set( 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );
	
			},
	
			getSize: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector2();
				return this.isEmpty() ? result.set( 0, 0 ) : result.subVectors( this.max, this.min );
	
			},
	
			expandByPoint: function ( point ) {
	
				this.min.min( point );
				this.max.max( point );
	
				return this;
	
			},
	
			expandByVector: function ( vector ) {
	
				this.min.sub( vector );
				this.max.add( vector );
	
				return this;
	
			},
	
			expandByScalar: function ( scalar ) {
	
				this.min.addScalar( - scalar );
				this.max.addScalar( scalar );
	
				return this;
	
			},
	
			containsPoint: function ( point ) {
	
				return point.x < this.min.x || point.x > this.max.x ||
					point.y < this.min.y || point.y > this.max.y ? false : true;
	
			},
	
			containsBox: function ( box ) {
	
				return this.min.x <= box.min.x && box.max.x <= this.max.x &&
					this.min.y <= box.min.y && box.max.y <= this.max.y;
	
			},
	
			getParameter: function ( point, optionalTarget ) {
	
				// This can potentially have a divide by zero if the box
				// has a size dimension of 0.
	
				var result = optionalTarget || new Vector2();
	
				return result.set(
					( point.x - this.min.x ) / ( this.max.x - this.min.x ),
					( point.y - this.min.y ) / ( this.max.y - this.min.y )
				);
	
			},
	
			intersectsBox: function ( box ) {
	
				// using 4 splitting planes to rule out intersections
	
				return box.max.x < this.min.x || box.min.x > this.max.x ||
					box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
	
			},
	
			clampPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector2();
				return result.copy( point ).clamp( this.min, this.max );
	
			},
	
			distanceToPoint: function () {
	
				var v1 = new Vector2();
	
				return function distanceToPoint( point ) {
	
					var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
					return clampedPoint.sub( point ).length();
	
				};
	
			}(),
	
			intersect: function ( box ) {
	
				this.min.max( box.min );
				this.max.min( box.max );
	
				return this;
	
			},
	
			union: function ( box ) {
	
				this.min.min( box.min );
				this.max.max( box.max );
	
				return this;
	
			},
	
			translate: function ( offset ) {
	
				this.min.add( offset );
				this.max.add( offset );
	
				return this;
	
			},
	
			equals: function ( box ) {
	
				return box.min.equals( this.min ) && box.max.equals( this.max );
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function WebGLFlareRenderer( renderer, gl, state, textures, capabilities ) {
	
			var vertexBuffer, elementBuffer;
			var shader, program, attributes, uniforms;
	
			var tempTexture, occlusionTexture;
	
			function init() {
	
				var vertices = new Float32Array( [
					- 1, - 1,  0, 0,
					 1, - 1,  1, 0,
					 1,  1,  1, 1,
					- 1,  1,  0, 1
				] );
	
				var faces = new Uint16Array( [
					0, 1, 2,
					0, 2, 3
				] );
	
				// buffers
	
				vertexBuffer     = gl.createBuffer();
				elementBuffer    = gl.createBuffer();
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
				gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );
	
				// textures
	
				tempTexture      = gl.createTexture();
				occlusionTexture = gl.createTexture();
	
				state.bindTexture( gl.TEXTURE_2D, tempTexture );
				gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGB, 16, 16, 0, gl.RGB, gl.UNSIGNED_BYTE, null );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
	
				state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
				gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGBA, 16, 16, 0, gl.RGBA, gl.UNSIGNED_BYTE, null );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
	
				shader = {
	
					vertexShader: [
	
						"uniform lowp int renderType;",
	
						"uniform vec3 screenPosition;",
						"uniform vec2 scale;",
						"uniform float rotation;",
	
						"uniform sampler2D occlusionMap;",
	
						"attribute vec2 position;",
						"attribute vec2 uv;",
	
						"varying vec2 vUV;",
						"varying float vVisibility;",
	
						"void main() {",
	
							"vUV = uv;",
	
							"vec2 pos = position;",
	
							"if ( renderType == 2 ) {",
	
								"vec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );",
								"visibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );",
	
								"vVisibility =        visibility.r / 9.0;",
								"vVisibility *= 1.0 - visibility.g / 9.0;",
								"vVisibility *=       visibility.b / 9.0;",
								"vVisibility *= 1.0 - visibility.a / 9.0;",
	
								"pos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;",
								"pos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;",
	
							"}",
	
							"gl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );",
	
						"}"
	
					].join( "\n" ),
	
					fragmentShader: [
	
						"uniform lowp int renderType;",
	
						"uniform sampler2D map;",
						"uniform float opacity;",
						"uniform vec3 color;",
	
						"varying vec2 vUV;",
						"varying float vVisibility;",
	
						"void main() {",
	
							// pink square
	
							"if ( renderType == 0 ) {",
	
								"gl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );",
	
							// restore
	
							"} else if ( renderType == 1 ) {",
	
								"gl_FragColor = texture2D( map, vUV );",
	
							// flare
	
							"} else {",
	
								"vec4 texture = texture2D( map, vUV );",
								"texture.a *= opacity * vVisibility;",
								"gl_FragColor = texture;",
								"gl_FragColor.rgb *= color;",
	
							"}",
	
						"}"
	
					].join( "\n" )
	
				};
	
				program = createProgram( shader );
	
				attributes = {
					vertex: gl.getAttribLocation ( program, "position" ),
					uv:     gl.getAttribLocation ( program, "uv" )
				};
	
				uniforms = {
					renderType:     gl.getUniformLocation( program, "renderType" ),
					map:            gl.getUniformLocation( program, "map" ),
					occlusionMap:   gl.getUniformLocation( program, "occlusionMap" ),
					opacity:        gl.getUniformLocation( program, "opacity" ),
					color:          gl.getUniformLocation( program, "color" ),
					scale:          gl.getUniformLocation( program, "scale" ),
					rotation:       gl.getUniformLocation( program, "rotation" ),
					screenPosition: gl.getUniformLocation( program, "screenPosition" )
				};
	
			}
	
			/*
			 * Render lens flares
			 * Method: renders 16x16 0xff00ff-colored points scattered over the light source area,
			 *         reads these back and calculates occlusion.
			 */
	
			this.render = function ( flares, scene, camera, viewport ) {
	
				if ( flares.length === 0 ) return;
	
				var tempPosition = new Vector3();
	
				var invAspect = viewport.w / viewport.z,
					halfViewportWidth = viewport.z * 0.5,
					halfViewportHeight = viewport.w * 0.5;
	
				var size = 16 / viewport.w,
					scale = new Vector2( size * invAspect, size );
	
				var screenPosition = new Vector3( 1, 1, 0 ),
					screenPositionPixels = new Vector2( 1, 1 );
	
				var validArea = new Box2();
	
				validArea.min.set( viewport.x, viewport.y );
				validArea.max.set( viewport.x + ( viewport.z - 16 ), viewport.y + ( viewport.w - 16 ) );
	
				if ( program === undefined ) {
	
					init();
	
				}
	
				state.useProgram( program );
	
				state.initAttributes();
				state.enableAttribute( attributes.vertex );
				state.enableAttribute( attributes.uv );
				state.disableUnusedAttributes();
	
				// loop through all lens flares to update their occlusion and positions
				// setup gl and common used attribs/uniforms
	
				gl.uniform1i( uniforms.occlusionMap, 0 );
				gl.uniform1i( uniforms.map, 1 );
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.vertexAttribPointer( attributes.vertex, 2, gl.FLOAT, false, 2 * 8, 0 );
				gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
	
				state.disable( gl.CULL_FACE );
				state.buffers.depth.setMask( false );
	
				for ( var i = 0, l = flares.length; i < l; i ++ ) {
	
					size = 16 / viewport.w;
					scale.set( size * invAspect, size );
	
					// calc object screen position
	
					var flare = flares[ i ];
	
					tempPosition.set( flare.matrixWorld.elements[ 12 ], flare.matrixWorld.elements[ 13 ], flare.matrixWorld.elements[ 14 ] );
	
					tempPosition.applyMatrix4( camera.matrixWorldInverse );
					tempPosition.applyMatrix4( camera.projectionMatrix );
	
					// setup arrays for gl programs
	
					screenPosition.copy( tempPosition );
	
					// horizontal and vertical coordinate of the lower left corner of the pixels to copy
	
					screenPositionPixels.x = viewport.x + ( screenPosition.x * halfViewportWidth ) + halfViewportWidth - 8;
					screenPositionPixels.y = viewport.y + ( screenPosition.y * halfViewportHeight ) + halfViewportHeight - 8;
	
					// screen cull
	
					if ( validArea.containsPoint( screenPositionPixels ) === true ) {
	
						// save current RGB to temp texture
	
						state.activeTexture( gl.TEXTURE0 );
						state.bindTexture( gl.TEXTURE_2D, null );
						state.activeTexture( gl.TEXTURE1 );
						state.bindTexture( gl.TEXTURE_2D, tempTexture );
						gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGB, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );
	
	
						// render pink quad
	
						gl.uniform1i( uniforms.renderType, 0 );
						gl.uniform2f( uniforms.scale, scale.x, scale.y );
						gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );
	
						state.disable( gl.BLEND );
						state.enable( gl.DEPTH_TEST );
	
						gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
	
						// copy result to occlusionMap
	
						state.activeTexture( gl.TEXTURE0 );
						state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
						gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGBA, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );
	
	
						// restore graphics
	
						gl.uniform1i( uniforms.renderType, 1 );
						state.disable( gl.DEPTH_TEST );
	
						state.activeTexture( gl.TEXTURE1 );
						state.bindTexture( gl.TEXTURE_2D, tempTexture );
						gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
	
						// update object positions
	
						flare.positionScreen.copy( screenPosition );
	
						if ( flare.customUpdateCallback ) {
	
							flare.customUpdateCallback( flare );
	
						} else {
	
							flare.updateLensFlares();
	
						}
	
						// render flares
	
						gl.uniform1i( uniforms.renderType, 2 );
						state.enable( gl.BLEND );
	
						for ( var j = 0, jl = flare.lensFlares.length; j < jl; j ++ ) {
	
							var sprite = flare.lensFlares[ j ];
	
							if ( sprite.opacity > 0.001 && sprite.scale > 0.001 ) {
	
								screenPosition.x = sprite.x;
								screenPosition.y = sprite.y;
								screenPosition.z = sprite.z;
	
								size = sprite.size * sprite.scale / viewport.w;
	
								scale.x = size * invAspect;
								scale.y = size;
	
								gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );
								gl.uniform2f( uniforms.scale, scale.x, scale.y );
								gl.uniform1f( uniforms.rotation, sprite.rotation );
	
								gl.uniform1f( uniforms.opacity, sprite.opacity );
								gl.uniform3f( uniforms.color, sprite.color.r, sprite.color.g, sprite.color.b );
	
								state.setBlending( sprite.blending, sprite.blendEquation, sprite.blendSrc, sprite.blendDst );
	
								textures.setTexture2D( sprite.texture, 1 );
	
								gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
							}
	
						}
	
					}
	
				}
	
				// restore gl
	
				state.enable( gl.CULL_FACE );
				state.enable( gl.DEPTH_TEST );
				state.buffers.depth.setMask( true );
	
				state.reset();
	
			};
	
			function createProgram( shader ) {
	
				var program = gl.createProgram();
	
				var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );
				var vertexShader = gl.createShader( gl.VERTEX_SHADER );
	
				var prefix = "precision " + capabilities.precision + " float;\n";
	
				gl.shaderSource( fragmentShader, prefix + shader.fragmentShader );
				gl.shaderSource( vertexShader, prefix + shader.vertexShader );
	
				gl.compileShader( fragmentShader );
				gl.compileShader( vertexShader );
	
				gl.attachShader( program, fragmentShader );
				gl.attachShader( program, vertexShader );
	
				gl.linkProgram( program );
	
				return program;
	
			}
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function CanvasTexture( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {
	
			Texture.call( this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );
	
			this.needsUpdate = true;
	
		}
	
		CanvasTexture.prototype = Object.create( Texture.prototype );
		CanvasTexture.prototype.constructor = CanvasTexture;
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function WebGLSpriteRenderer( renderer, gl, state, textures, capabilities ) {
	
			var vertexBuffer, elementBuffer;
			var program, attributes, uniforms;
	
			var texture;
	
			// decompose matrixWorld
	
			var spritePosition = new Vector3();
			var spriteRotation = new Quaternion();
			var spriteScale = new Vector3();
	
			function init() {
	
				var vertices = new Float32Array( [
					- 0.5, - 0.5,  0, 0,
					  0.5, - 0.5,  1, 0,
					  0.5,   0.5,  1, 1,
					- 0.5,   0.5,  0, 1
				] );
	
				var faces = new Uint16Array( [
					0, 1, 2,
					0, 2, 3
				] );
	
				vertexBuffer  = gl.createBuffer();
				elementBuffer = gl.createBuffer();
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
				gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );
	
				program = createProgram();
	
				attributes = {
					position:			gl.getAttribLocation ( program, 'position' ),
					uv:					gl.getAttribLocation ( program, 'uv' )
				};
	
				uniforms = {
					uvOffset:			gl.getUniformLocation( program, 'uvOffset' ),
					uvScale:			gl.getUniformLocation( program, 'uvScale' ),
	
					rotation:			gl.getUniformLocation( program, 'rotation' ),
					scale:				gl.getUniformLocation( program, 'scale' ),
	
					color:				gl.getUniformLocation( program, 'color' ),
					map:				gl.getUniformLocation( program, 'map' ),
					opacity:			gl.getUniformLocation( program, 'opacity' ),
	
					modelViewMatrix: 	gl.getUniformLocation( program, 'modelViewMatrix' ),
					projectionMatrix:	gl.getUniformLocation( program, 'projectionMatrix' ),
	
					fogType:			gl.getUniformLocation( program, 'fogType' ),
					fogDensity:			gl.getUniformLocation( program, 'fogDensity' ),
					fogNear:			gl.getUniformLocation( program, 'fogNear' ),
					fogFar:				gl.getUniformLocation( program, 'fogFar' ),
					fogColor:			gl.getUniformLocation( program, 'fogColor' ),
	
					alphaTest:			gl.getUniformLocation( program, 'alphaTest' )
				};
	
				var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
				canvas.width = 8;
				canvas.height = 8;
	
				var context = canvas.getContext( '2d' );
				context.fillStyle = 'white';
				context.fillRect( 0, 0, 8, 8 );
	
				texture = new CanvasTexture( canvas );
	
			}
	
			this.render = function ( sprites, scene, camera ) {
	
				if ( sprites.length === 0 ) return;
	
				// setup gl
	
				if ( program === undefined ) {
	
					init();
	
				}
	
				state.useProgram( program );
	
				state.initAttributes();
				state.enableAttribute( attributes.position );
				state.enableAttribute( attributes.uv );
				state.disableUnusedAttributes();
	
				state.disable( gl.CULL_FACE );
				state.enable( gl.BLEND );
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.vertexAttribPointer( attributes.position, 2, gl.FLOAT, false, 2 * 8, 0 );
				gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
	
				gl.uniformMatrix4fv( uniforms.projectionMatrix, false, camera.projectionMatrix.elements );
	
				state.activeTexture( gl.TEXTURE0 );
				gl.uniform1i( uniforms.map, 0 );
	
				var oldFogType = 0;
				var sceneFogType = 0;
				var fog = scene.fog;
	
				if ( fog ) {
	
					gl.uniform3f( uniforms.fogColor, fog.color.r, fog.color.g, fog.color.b );
	
					if ( fog.isFog ) {
	
						gl.uniform1f( uniforms.fogNear, fog.near );
						gl.uniform1f( uniforms.fogFar, fog.far );
	
						gl.uniform1i( uniforms.fogType, 1 );
						oldFogType = 1;
						sceneFogType = 1;
	
					} else if ( fog.isFogExp2 ) {
	
						gl.uniform1f( uniforms.fogDensity, fog.density );
	
						gl.uniform1i( uniforms.fogType, 2 );
						oldFogType = 2;
						sceneFogType = 2;
	
					}
	
				} else {
	
					gl.uniform1i( uniforms.fogType, 0 );
					oldFogType = 0;
					sceneFogType = 0;
	
				}
	
	
				// update positions and sort
	
				for ( var i = 0, l = sprites.length; i < l; i ++ ) {
	
					var sprite = sprites[ i ];
	
					sprite.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, sprite.matrixWorld );
					sprite.z = - sprite.modelViewMatrix.elements[ 14 ];
	
				}
	
				sprites.sort( painterSortStable );
	
				// render all sprites
	
				var scale = [];
	
				for ( var i = 0, l = sprites.length; i < l; i ++ ) {
	
					var sprite = sprites[ i ];
					var material = sprite.material;
	
					if ( material.visible === false ) continue;
	
					sprite.onBeforeRender( renderer, scene, camera, undefined, material, undefined );
	
					gl.uniform1f( uniforms.alphaTest, material.alphaTest );
					gl.uniformMatrix4fv( uniforms.modelViewMatrix, false, sprite.modelViewMatrix.elements );
	
					sprite.matrixWorld.decompose( spritePosition, spriteRotation, spriteScale );
	
					scale[ 0 ] = spriteScale.x;
					scale[ 1 ] = spriteScale.y;
	
					var fogType = 0;
	
					if ( scene.fog && material.fog ) {
	
						fogType = sceneFogType;
	
					}
	
					if ( oldFogType !== fogType ) {
	
						gl.uniform1i( uniforms.fogType, fogType );
						oldFogType = fogType;
	
					}
	
					if ( material.map !== null ) {
	
						gl.uniform2f( uniforms.uvOffset, material.map.offset.x, material.map.offset.y );
						gl.uniform2f( uniforms.uvScale, material.map.repeat.x, material.map.repeat.y );
	
					} else {
	
						gl.uniform2f( uniforms.uvOffset, 0, 0 );
						gl.uniform2f( uniforms.uvScale, 1, 1 );
	
					}
	
					gl.uniform1f( uniforms.opacity, material.opacity );
					gl.uniform3f( uniforms.color, material.color.r, material.color.g, material.color.b );
	
					gl.uniform1f( uniforms.rotation, material.rotation );
					gl.uniform2fv( uniforms.scale, scale );
	
					state.setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha );
					state.buffers.depth.setTest( material.depthTest );
					state.buffers.depth.setMask( material.depthWrite );
	
					textures.setTexture2D( material.map || texture, 0 );
	
					gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
					sprite.onAfterRender( renderer, scene, camera, undefined, material, undefined );
	
				}
	
				// restore gl
	
				state.enable( gl.CULL_FACE );
	
				state.reset();
	
			};
	
			function createProgram() {
	
				var program = gl.createProgram();
	
				var vertexShader = gl.createShader( gl.VERTEX_SHADER );
				var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );
	
				gl.shaderSource( vertexShader, [
	
					'precision ' + capabilities.precision + ' float;',
	
					'#define SHADER_NAME ' + 'SpriteMaterial',
	
					'uniform mat4 modelViewMatrix;',
					'uniform mat4 projectionMatrix;',
					'uniform float rotation;',
					'uniform vec2 scale;',
					'uniform vec2 uvOffset;',
					'uniform vec2 uvScale;',
	
					'attribute vec2 position;',
					'attribute vec2 uv;',
	
					'varying vec2 vUV;',
	
					'void main() {',
	
						'vUV = uvOffset + uv * uvScale;',
	
						'vec2 alignedPosition = position * scale;',
	
						'vec2 rotatedPosition;',
						'rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;',
						'rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;',
	
						'vec4 finalPosition;',
	
						'finalPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );',
						'finalPosition.xy += rotatedPosition;',
						'finalPosition = projectionMatrix * finalPosition;',
	
						'gl_Position = finalPosition;',
	
					'}'
	
				].join( '\n' ) );
	
				gl.shaderSource( fragmentShader, [
	
					'precision ' + capabilities.precision + ' float;',
	
					'#define SHADER_NAME ' + 'SpriteMaterial',
	
					'uniform vec3 color;',
					'uniform sampler2D map;',
					'uniform float opacity;',
	
					'uniform int fogType;',
					'uniform vec3 fogColor;',
					'uniform float fogDensity;',
					'uniform float fogNear;',
					'uniform float fogFar;',
					'uniform float alphaTest;',
	
					'varying vec2 vUV;',
	
					'void main() {',
	
						'vec4 texture = texture2D( map, vUV );',
	
						'if ( texture.a < alphaTest ) discard;',
	
						'gl_FragColor = vec4( color * texture.xyz, texture.a * opacity );',
	
						'if ( fogType > 0 ) {',
	
							'float depth = gl_FragCoord.z / gl_FragCoord.w;',
							'float fogFactor = 0.0;',
	
							'if ( fogType == 1 ) {',
	
								'fogFactor = smoothstep( fogNear, fogFar, depth );',
	
							'} else {',
	
								'const float LOG2 = 1.442695;',
								'fogFactor = exp2( - fogDensity * fogDensity * depth * depth * LOG2 );',
								'fogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );',
	
							'}',
	
							'gl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );',
	
						'}',
	
					'}'
	
				].join( '\n' ) );
	
				gl.compileShader( vertexShader );
				gl.compileShader( fragmentShader );
	
				gl.attachShader( program, vertexShader );
				gl.attachShader( program, fragmentShader );
	
				gl.linkProgram( program );
	
				return program;
	
			}
	
			function painterSortStable( a, b ) {
	
				if ( a.renderOrder !== b.renderOrder ) {
	
					return a.renderOrder - b.renderOrder;
	
				} else if ( a.z !== b.z ) {
	
					return b.z - a.z;
	
				} else {
	
					return b.id - a.id;
	
				}
	
			}
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		var materialId = 0;
	
		function Material() {
	
			Object.defineProperty( this, 'id', { value: materialId ++ } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'Material';
	
			this.fog = true;
			this.lights = true;
	
			this.blending = NormalBlending;
			this.side = FrontSide;
			this.flatShading = false;
			this.vertexColors = NoColors; // THREE.NoColors, THREE.VertexColors, THREE.FaceColors
	
			this.opacity = 1;
			this.transparent = false;
	
			this.blendSrc = SrcAlphaFactor;
			this.blendDst = OneMinusSrcAlphaFactor;
			this.blendEquation = AddEquation;
			this.blendSrcAlpha = null;
			this.blendDstAlpha = null;
			this.blendEquationAlpha = null;
	
			this.depthFunc = LessEqualDepth;
			this.depthTest = true;
			this.depthWrite = true;
	
			this.clippingPlanes = null;
			this.clipIntersection = false;
			this.clipShadows = false;
	
			this.colorWrite = true;
	
			this.precision = null; // override the renderer's default precision for this material
	
			this.polygonOffset = false;
			this.polygonOffsetFactor = 0;
			this.polygonOffsetUnits = 0;
	
			this.dithering = false;
	
			this.alphaTest = 0;
			this.premultipliedAlpha = false;
	
			this.overdraw = 0; // Overdrawn pixels (typically between 0 and 1) for fixing antialiasing gaps in CanvasRenderer
	
			this.visible = true;
	
			this.userData = {};
	
			this.needsUpdate = true;
	
		}
	
		Object.assign( Material.prototype, EventDispatcher.prototype, {
	
			isMaterial: true,
	
			onBeforeCompile: function () {},
	
			setValues: function ( values ) {
	
				if ( values === undefined ) return;
	
				for ( var key in values ) {
	
					var newValue = values[ key ];
	
					if ( newValue === undefined ) {
	
						console.warn( "THREE.Material: '" + key + "' parameter is undefined." );
						continue;
	
					}
	
					// for backward compatability if shading is set in the constructor
					if ( key === 'shading' ) {
	
						console.warn( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
						this.flatShading = ( newValue === FlatShading ) ? true : false;
						continue;
	
					}
	
					var currentValue = this[ key ];
	
					if ( currentValue === undefined ) {
	
						console.warn( "THREE." + this.type + ": '" + key + "' is not a property of this material." );
						continue;
	
					}
	
					if ( currentValue && currentValue.isColor ) {
	
						currentValue.set( newValue );
	
					} else if ( ( currentValue && currentValue.isVector3 ) && ( newValue && newValue.isVector3 ) ) {
	
						currentValue.copy( newValue );
	
					} else if ( key === 'overdraw' ) {
	
						// ensure overdraw is backwards-compatible with legacy boolean type
						this[ key ] = Number( newValue );
	
					} else {
	
						this[ key ] = newValue;
	
					}
	
				}
	
			},
	
			toJSON: function ( meta ) {
	
				var isRoot = meta === undefined;
	
				if ( isRoot ) {
	
					meta = {
						textures: {},
						images: {}
					};
	
				}
	
				var data = {
					metadata: {
						version: 4.5,
						type: 'Material',
						generator: 'Material.toJSON'
					}
				};
	
				// standard Material serialization
				data.uuid = this.uuid;
				data.type = this.type;
	
				if ( this.name !== '' ) data.name = this.name;
	
				if ( this.color && this.color.isColor ) data.color = this.color.getHex();
	
				if ( this.roughness !== undefined ) data.roughness = this.roughness;
				if ( this.metalness !== undefined ) data.metalness = this.metalness;
	
				if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
				if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
				if ( this.shininess !== undefined ) data.shininess = this.shininess;
				if ( this.clearCoat !== undefined ) data.clearCoat = this.clearCoat;
				if ( this.clearCoatRoughness !== undefined ) data.clearCoatRoughness = this.clearCoatRoughness;
	
				if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
				if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;
				if ( this.lightMap && this.lightMap.isTexture ) data.lightMap = this.lightMap.toJSON( meta ).uuid;
				if ( this.bumpMap && this.bumpMap.isTexture ) {
	
					data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
					data.bumpScale = this.bumpScale;
	
				}
				if ( this.normalMap && this.normalMap.isTexture ) {
	
					data.normalMap = this.normalMap.toJSON( meta ).uuid;
					data.normalScale = this.normalScale.toArray();
	
				}
				if ( this.displacementMap && this.displacementMap.isTexture ) {
	
					data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
					data.displacementScale = this.displacementScale;
					data.displacementBias = this.displacementBias;
	
				}
				if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
				if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;
	
				if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
				if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;
	
				if ( this.envMap && this.envMap.isTexture ) {
	
					data.envMap = this.envMap.toJSON( meta ).uuid;
					data.reflectivity = this.reflectivity; // Scale behind envMap
	
				}
	
				if ( this.gradientMap && this.gradientMap.isTexture ) {
	
					data.gradientMap = this.gradientMap.toJSON( meta ).uuid;
	
				}
	
				if ( this.size !== undefined ) data.size = this.size;
				if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;
	
				if ( this.blending !== NormalBlending ) data.blending = this.blending;
				if ( this.flatShading === true ) data.flatShading = this.flatShading;
				if ( this.side !== FrontSide ) data.side = this.side;
				if ( this.vertexColors !== NoColors ) data.vertexColors = this.vertexColors;
	
				if ( this.opacity < 1 ) data.opacity = this.opacity;
				if ( this.transparent === true ) data.transparent = this.transparent;
	
				data.depthFunc = this.depthFunc;
				data.depthTest = this.depthTest;
				data.depthWrite = this.depthWrite;
	
				if ( this.dithering === true ) data.dithering = true;
	
				if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
				if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = this.premultipliedAlpha;
	
				if ( this.wireframe === true ) data.wireframe = this.wireframe;
				if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
				if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
				if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;
	
				if ( this.morphTargets === true ) data.morphTargets = true;
				if ( this.skinning === true ) data.skinning = true;
	
				if ( this.visible === false ) data.visible = false;
				if ( JSON.stringify( this.userData ) !== '{}' ) data.userData = this.userData;
	
				// TODO: Copied from Object3D.toJSON
	
				function extractFromCache( cache ) {
	
					var values = [];
	
					for ( var key in cache ) {
	
						var data = cache[ key ];
						delete data.metadata;
						values.push( data );
	
					}
	
					return values;
	
				}
	
				if ( isRoot ) {
	
					var textures = extractFromCache( meta.textures );
					var images = extractFromCache( meta.images );
	
					if ( textures.length > 0 ) data.textures = textures;
					if ( images.length > 0 ) data.images = images;
	
				}
	
				return data;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.name = source.name;
	
				this.fog = source.fog;
				this.lights = source.lights;
	
				this.blending = source.blending;
				this.side = source.side;
				this.flatShading = source.flatShading;
				this.vertexColors = source.vertexColors;
	
				this.opacity = source.opacity;
				this.transparent = source.transparent;
	
				this.blendSrc = source.blendSrc;
				this.blendDst = source.blendDst;
				this.blendEquation = source.blendEquation;
				this.blendSrcAlpha = source.blendSrcAlpha;
				this.blendDstAlpha = source.blendDstAlpha;
				this.blendEquationAlpha = source.blendEquationAlpha;
	
				this.depthFunc = source.depthFunc;
				this.depthTest = source.depthTest;
				this.depthWrite = source.depthWrite;
	
				this.colorWrite = source.colorWrite;
	
				this.precision = source.precision;
	
				this.polygonOffset = source.polygonOffset;
				this.polygonOffsetFactor = source.polygonOffsetFactor;
				this.polygonOffsetUnits = source.polygonOffsetUnits;
	
				this.dithering = source.dithering;
	
				this.alphaTest = source.alphaTest;
				this.premultipliedAlpha = source.premultipliedAlpha;
	
				this.overdraw = source.overdraw;
	
				this.visible = source.visible;
				this.userData = JSON.parse( JSON.stringify( source.userData ) );
	
				this.clipShadows = source.clipShadows;
				this.clipIntersection = source.clipIntersection;
	
				var srcPlanes = source.clippingPlanes,
					dstPlanes = null;
	
				if ( srcPlanes !== null ) {
	
					var n = srcPlanes.length;
					dstPlanes = new Array( n );
	
					for ( var i = 0; i !== n; ++ i )
						dstPlanes[ i ] = srcPlanes[ i ].clone();
	
				}
	
				this.clippingPlanes = dstPlanes;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  defines: { "label" : "value" },
		 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
		 *
		 *  fragmentShader: <string>,
		 *  vertexShader: <string>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  lights: <bool>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function ShaderMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'ShaderMaterial';
	
			this.defines = {};
			this.uniforms = {};
	
			this.vertexShader = 'void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}';
			this.fragmentShader = 'void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}';
	
			this.linewidth = 1;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
	
			this.fog = false; // set to use scene fog
			this.lights = false; // set to use scene lights
			this.clipping = false; // set to use user-defined clipping planes
	
			this.skinning = false; // set to use skinning attribute streams
			this.morphTargets = false; // set to use morph targets
			this.morphNormals = false; // set to use morph normals
	
			this.extensions = {
				derivatives: false, // set to use derivatives
				fragDepth: false, // set to use fragment depth values
				drawBuffers: false, // set to use draw buffers
				shaderTextureLOD: false // set to use shader texture LOD
			};
	
			// When rendered geometry doesn't include these attributes but the material does,
			// use these default values in WebGL. This avoids errors when buffer data is missing.
			this.defaultAttributeValues = {
				'color': [ 1, 1, 1 ],
				'uv': [ 0, 0 ],
				'uv2': [ 0, 0 ]
			};
	
			this.index0AttributeName = undefined;
	
			if ( parameters !== undefined ) {
	
				if ( parameters.attributes !== undefined ) {
	
					console.error( 'THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.' );
	
				}
	
				this.setValues( parameters );
	
			}
	
		}
	
		ShaderMaterial.prototype = Object.create( Material.prototype );
		ShaderMaterial.prototype.constructor = ShaderMaterial;
	
		ShaderMaterial.prototype.isShaderMaterial = true;
	
		ShaderMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.fragmentShader = source.fragmentShader;
			this.vertexShader = source.vertexShader;
	
			this.uniforms = UniformsUtils.clone( source.uniforms );
	
			this.defines = source.defines;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
	
			this.lights = source.lights;
			this.clipping = source.clipping;
	
			this.skinning = source.skinning;
	
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			this.extensions = source.extensions;
	
			return this;
	
		};
	
		ShaderMaterial.prototype.toJSON = function ( meta ) {
	
			var data = Material.prototype.toJSON.call( this, meta );
	
			data.uniforms = this.uniforms;
			data.vertexShader = this.vertexShader;
			data.fragmentShader = this.fragmentShader;
	
			return data;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author bhouston / https://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>
		 * }
		 */
	
		function MeshDepthMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshDepthMaterial';
	
			this.depthPacking = BasicDepthPacking;
	
			this.skinning = false;
			this.morphTargets = false;
	
			this.map = null;
	
			this.alphaMap = null;
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
	
			this.fog = false;
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		MeshDepthMaterial.prototype = Object.create( Material.prototype );
		MeshDepthMaterial.prototype.constructor = MeshDepthMaterial;
	
		MeshDepthMaterial.prototype.isMeshDepthMaterial = true;
	
		MeshDepthMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.depthPacking = source.depthPacking;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
	
			this.map = source.map;
	
			this.alphaMap = source.alphaMap;
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
	
			return this;
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *
		 *  referencePosition: <float>,
		 *  nearDistance: <float>,
		 *  farDistance: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>
		 *
		 * }
		 */
	
		function MeshDistanceMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshDistanceMaterial';
	
			this.referencePosition = new Vector3();
			this.nearDistance = 1;
			this.farDistance = 1000;
	
			this.skinning = false;
			this.morphTargets = false;
	
			this.map = null;
	
			this.alphaMap = null;
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.fog = false;
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		MeshDistanceMaterial.prototype = Object.create( Material.prototype );
		MeshDistanceMaterial.prototype.constructor = MeshDistanceMaterial;
	
		MeshDistanceMaterial.prototype.isMeshDistanceMaterial = true;
	
		MeshDistanceMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.referencePosition.copy( source.referencePosition );
			this.nearDistance = source.nearDistance;
			this.farDistance = source.farDistance;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
	
			this.map = source.map;
	
			this.alphaMap = source.alphaMap;
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			return this;
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Box3( min, max ) {
	
			this.min = ( min !== undefined ) ? min : new Vector3( + Infinity, + Infinity, + Infinity );
			this.max = ( max !== undefined ) ? max : new Vector3( - Infinity, - Infinity, - Infinity );
	
		}
	
		Object.assign( Box3.prototype, {
	
			isBox3: true,
	
			set: function ( min, max ) {
	
				this.min.copy( min );
				this.max.copy( max );
	
				return this;
	
			},
	
			setFromArray: function ( array ) {
	
				var minX = + Infinity;
				var minY = + Infinity;
				var minZ = + Infinity;
	
				var maxX = - Infinity;
				var maxY = - Infinity;
				var maxZ = - Infinity;
	
				for ( var i = 0, l = array.length; i < l; i += 3 ) {
	
					var x = array[ i ];
					var y = array[ i + 1 ];
					var z = array[ i + 2 ];
	
					if ( x < minX ) minX = x;
					if ( y < minY ) minY = y;
					if ( z < minZ ) minZ = z;
	
					if ( x > maxX ) maxX = x;
					if ( y > maxY ) maxY = y;
					if ( z > maxZ ) maxZ = z;
	
				}
	
				this.min.set( minX, minY, minZ );
				this.max.set( maxX, maxY, maxZ );
	
				return this;
	
			},
	
			setFromBufferAttribute: function ( attribute ) {
	
				var minX = + Infinity;
				var minY = + Infinity;
				var minZ = + Infinity;
	
				var maxX = - Infinity;
				var maxY = - Infinity;
				var maxZ = - Infinity;
	
				for ( var i = 0, l = attribute.count; i < l; i ++ ) {
	
					var x = attribute.getX( i );
					var y = attribute.getY( i );
					var z = attribute.getZ( i );
	
					if ( x < minX ) minX = x;
					if ( y < minY ) minY = y;
					if ( z < minZ ) minZ = z;
	
					if ( x > maxX ) maxX = x;
					if ( y > maxY ) maxY = y;
					if ( z > maxZ ) maxZ = z;
	
				}
	
				this.min.set( minX, minY, minZ );
				this.max.set( maxX, maxY, maxZ );
	
				return this;
	
			},
	
			setFromPoints: function ( points ) {
	
				this.makeEmpty();
	
				for ( var i = 0, il = points.length; i < il; i ++ ) {
	
					this.expandByPoint( points[ i ] );
	
				}
	
				return this;
	
			},
	
			setFromCenterAndSize: function () {
	
				var v1 = new Vector3();
	
				return function setFromCenterAndSize( center, size ) {
	
					var halfSize = v1.copy( size ).multiplyScalar( 0.5 );
	
					this.min.copy( center ).sub( halfSize );
					this.max.copy( center ).add( halfSize );
	
					return this;
	
				};
	
			}(),
	
			setFromObject: function ( object ) {
	
				this.makeEmpty();
	
				return this.expandByObject( object );
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( box ) {
	
				this.min.copy( box.min );
				this.max.copy( box.max );
	
				return this;
	
			},
	
			makeEmpty: function () {
	
				this.min.x = this.min.y = this.min.z = + Infinity;
				this.max.x = this.max.y = this.max.z = - Infinity;
	
				return this;
	
			},
	
			isEmpty: function () {
	
				// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
	
				return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );
	
			},
	
			getCenter: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return this.isEmpty() ? result.set( 0, 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );
	
			},
	
			getSize: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return this.isEmpty() ? result.set( 0, 0, 0 ) : result.subVectors( this.max, this.min );
	
			},
	
			expandByPoint: function ( point ) {
	
				this.min.min( point );
				this.max.max( point );
	
				return this;
	
			},
	
			expandByVector: function ( vector ) {
	
				this.min.sub( vector );
				this.max.add( vector );
	
				return this;
	
			},
	
			expandByScalar: function ( scalar ) {
	
				this.min.addScalar( - scalar );
				this.max.addScalar( scalar );
	
				return this;
	
			},
	
			expandByObject: function () {
	
				// Computes the world-axis-aligned bounding box of an object (including its children),
				// accounting for both the object's, and children's, world transforms
	
				var v1 = new Vector3();
	
				return function expandByObject( object ) {
	
					var scope = this;
	
					object.updateMatrixWorld( true );
	
					object.traverse( function ( node ) {
	
						var i, l;
	
						var geometry = node.geometry;
	
						if ( geometry !== undefined ) {
	
							if ( geometry.isGeometry ) {
	
								var vertices = geometry.vertices;
	
								for ( i = 0, l = vertices.length; i < l; i ++ ) {
	
									v1.copy( vertices[ i ] );
									v1.applyMatrix4( node.matrixWorld );
	
									scope.expandByPoint( v1 );
	
								}
	
							} else if ( geometry.isBufferGeometry ) {
	
								var attribute = geometry.attributes.position;
	
								if ( attribute !== undefined ) {
	
									for ( i = 0, l = attribute.count; i < l; i ++ ) {
	
										v1.fromBufferAttribute( attribute, i ).applyMatrix4( node.matrixWorld );
	
										scope.expandByPoint( v1 );
	
									}
	
								}
	
							}
	
						}
	
					} );
	
					return this;
	
				};
	
			}(),
	
			containsPoint: function ( point ) {
	
				return point.x < this.min.x || point.x > this.max.x ||
					point.y < this.min.y || point.y > this.max.y ||
					point.z < this.min.z || point.z > this.max.z ? false : true;
	
			},
	
			containsBox: function ( box ) {
	
				return this.min.x <= box.min.x && box.max.x <= this.max.x &&
					this.min.y <= box.min.y && box.max.y <= this.max.y &&
					this.min.z <= box.min.z && box.max.z <= this.max.z;
	
			},
	
			getParameter: function ( point, optionalTarget ) {
	
				// This can potentially have a divide by zero if the box
				// has a size dimension of 0.
	
				var result = optionalTarget || new Vector3();
	
				return result.set(
					( point.x - this.min.x ) / ( this.max.x - this.min.x ),
					( point.y - this.min.y ) / ( this.max.y - this.min.y ),
					( point.z - this.min.z ) / ( this.max.z - this.min.z )
				);
	
			},
	
			intersectsBox: function ( box ) {
	
				// using 6 splitting planes to rule out intersections.
				return box.max.x < this.min.x || box.min.x > this.max.x ||
					box.max.y < this.min.y || box.min.y > this.max.y ||
					box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
	
			},
	
			intersectsSphere: ( function () {
	
				var closestPoint = new Vector3();
	
				return function intersectsSphere( sphere ) {
	
					// Find the point on the AABB closest to the sphere center.
					this.clampPoint( sphere.center, closestPoint );
	
					// If that point is inside the sphere, the AABB and sphere intersect.
					return closestPoint.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );
	
				};
	
			} )(),
	
			intersectsPlane: function ( plane ) {
	
				// We compute the minimum and maximum dot product values. If those values
				// are on the same side (back or front) of the plane, then there is no intersection.
	
				var min, max;
	
				if ( plane.normal.x > 0 ) {
	
					min = plane.normal.x * this.min.x;
					max = plane.normal.x * this.max.x;
	
				} else {
	
					min = plane.normal.x * this.max.x;
					max = plane.normal.x * this.min.x;
	
				}
	
				if ( plane.normal.y > 0 ) {
	
					min += plane.normal.y * this.min.y;
					max += plane.normal.y * this.max.y;
	
				} else {
	
					min += plane.normal.y * this.max.y;
					max += plane.normal.y * this.min.y;
	
				}
	
				if ( plane.normal.z > 0 ) {
	
					min += plane.normal.z * this.min.z;
					max += plane.normal.z * this.max.z;
	
				} else {
	
					min += plane.normal.z * this.max.z;
					max += plane.normal.z * this.min.z;
	
				}
	
				return ( min <= plane.constant && max >= plane.constant );
	
			},
	
			clampPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.copy( point ).clamp( this.min, this.max );
	
			},
	
			distanceToPoint: function () {
	
				var v1 = new Vector3();
	
				return function distanceToPoint( point ) {
	
					var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
					return clampedPoint.sub( point ).length();
	
				};
	
			}(),
	
			getBoundingSphere: function () {
	
				var v1 = new Vector3();
	
				return function getBoundingSphere( optionalTarget ) {
	
					var result = optionalTarget || new Sphere();
	
					this.getCenter( result.center );
	
					result.radius = this.getSize( v1 ).length() * 0.5;
	
					return result;
	
				};
	
			}(),
	
			intersect: function ( box ) {
	
				this.min.max( box.min );
				this.max.min( box.max );
	
				// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
				if( this.isEmpty() ) this.makeEmpty();
	
				return this;
	
			},
	
			union: function ( box ) {
	
				this.min.min( box.min );
				this.max.max( box.max );
	
				return this;
	
			},
	
			applyMatrix4: function () {
	
				var points = [
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3()
				];
	
				return function applyMatrix4( matrix ) {
	
					// transform of empty box is an empty box.
					if( this.isEmpty() ) return this;
	
					// NOTE: I am using a binary pattern to specify all 2^3 combinations below
					points[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
					points[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
					points[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
					points[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
					points[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
					points[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
					points[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
					points[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix );	// 111
	
					this.setFromPoints( points );
	
					return this;
	
				};
	
			}(),
	
			translate: function ( offset ) {
	
				this.min.add( offset );
				this.max.add( offset );
	
				return this;
	
			},
	
			equals: function ( box ) {
	
				return box.min.equals( this.min ) && box.max.equals( this.max );
	
			}
	
		} );
	
		/**
		 * @author bhouston / http://clara.io
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Sphere( center, radius ) {
	
			this.center = ( center !== undefined ) ? center : new Vector3();
			this.radius = ( radius !== undefined ) ? radius : 0;
	
		}
	
		Object.assign( Sphere.prototype, {
	
			set: function ( center, radius ) {
	
				this.center.copy( center );
				this.radius = radius;
	
				return this;
	
			},
	
			setFromPoints: function () {
	
				var box = new Box3();
	
				return function setFromPoints( points, optionalCenter ) {
	
					var center = this.center;
	
					if ( optionalCenter !== undefined ) {
	
						center.copy( optionalCenter );
	
					} else {
	
						box.setFromPoints( points ).getCenter( center );
	
					}
	
					var maxRadiusSq = 0;
	
					for ( var i = 0, il = points.length; i < il; i ++ ) {
	
						maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );
	
					}
	
					this.radius = Math.sqrt( maxRadiusSq );
	
					return this;
	
				};
	
			}(),
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( sphere ) {
	
				this.center.copy( sphere.center );
				this.radius = sphere.radius;
	
				return this;
	
			},
	
			empty: function () {
	
				return ( this.radius <= 0 );
	
			},
	
			containsPoint: function ( point ) {
	
				return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );
	
			},
	
			distanceToPoint: function ( point ) {
	
				return ( point.distanceTo( this.center ) - this.radius );
	
			},
	
			intersectsSphere: function ( sphere ) {
	
				var radiusSum = this.radius + sphere.radius;
	
				return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );
	
			},
	
			intersectsBox: function ( box ) {
	
				return box.intersectsSphere( this );
	
			},
	
			intersectsPlane: function ( plane ) {
	
				return Math.abs( plane.distanceToPoint( this.center ) ) <= this.radius;
	
			},
	
			clampPoint: function ( point, optionalTarget ) {
	
				var deltaLengthSq = this.center.distanceToSquared( point );
	
				var result = optionalTarget || new Vector3();
	
				result.copy( point );
	
				if ( deltaLengthSq > ( this.radius * this.radius ) ) {
	
					result.sub( this.center ).normalize();
					result.multiplyScalar( this.radius ).add( this.center );
	
				}
	
				return result;
	
			},
	
			getBoundingBox: function ( optionalTarget ) {
	
				var box = optionalTarget || new Box3();
	
				box.set( this.center, this.center );
				box.expandByScalar( this.radius );
	
				return box;
	
			},
	
			applyMatrix4: function ( matrix ) {
	
				this.center.applyMatrix4( matrix );
				this.radius = this.radius * matrix.getMaxScaleOnAxis();
	
				return this;
	
			},
	
			translate: function ( offset ) {
	
				this.center.add( offset );
	
				return this;
	
			},
	
			equals: function ( sphere ) {
	
				return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author bhouston / http://clara.io
		 * @author tschw
		 */
	
		function Matrix3() {
	
			this.elements = [
	
				1, 0, 0,
				0, 1, 0,
				0, 0, 1
	
			];
	
			if ( arguments.length > 0 ) {
	
				console.error( 'THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.' );
	
			}
	
		}
	
		Object.assign( Matrix3.prototype, {
	
			isMatrix3: true,
	
			set: function ( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {
	
				var te = this.elements;
	
				te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
				te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
				te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;
	
				return this;
	
			},
	
			identity: function () {
	
				this.set(
	
					1, 0, 0,
					0, 1, 0,
					0, 0, 1
	
				);
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().fromArray( this.elements );
	
			},
	
			copy: function ( m ) {
	
				var te = this.elements;
				var me = m.elements;
	
				te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ];
				te[ 3 ] = me[ 3 ]; te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ];
				te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ]; te[ 8 ] = me[ 8 ];
	
				return this;
	
			},
	
			setFromMatrix4: function ( m ) {
	
				var me = m.elements;
	
				this.set(
	
					me[ 0 ], me[ 4 ], me[  8 ],
					me[ 1 ], me[ 5 ], me[  9 ],
					me[ 2 ], me[ 6 ], me[ 10 ]
	
				);
	
				return this;
	
			},
	
			applyToBufferAttribute: function () {
	
				var v1 = new Vector3();
	
				return function applyToBufferAttribute( attribute ) {
	
					for ( var i = 0, l = attribute.count; i < l; i ++ ) {
	
						v1.x = attribute.getX( i );
						v1.y = attribute.getY( i );
						v1.z = attribute.getZ( i );
	
						v1.applyMatrix3( this );
	
						attribute.setXYZ( i, v1.x, v1.y, v1.z );
	
					}
	
					return attribute;
	
				};
	
			}(),
	
			multiply: function ( m ) {
	
				return this.multiplyMatrices( this, m );
	
			},
	
			premultiply: function ( m ) {
	
				return this.multiplyMatrices( m, this );
	
			},
	
			multiplyMatrices: function ( a, b ) {
	
				var ae = a.elements;
				var be = b.elements;
				var te = this.elements;
	
				var a11 = ae[ 0 ], a12 = ae[ 3 ], a13 = ae[ 6 ];
				var a21 = ae[ 1 ], a22 = ae[ 4 ], a23 = ae[ 7 ];
				var a31 = ae[ 2 ], a32 = ae[ 5 ], a33 = ae[ 8 ];
	
				var b11 = be[ 0 ], b12 = be[ 3 ], b13 = be[ 6 ];
				var b21 = be[ 1 ], b22 = be[ 4 ], b23 = be[ 7 ];
				var b31 = be[ 2 ], b32 = be[ 5 ], b33 = be[ 8 ];
	
				te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31;
				te[ 3 ] = a11 * b12 + a12 * b22 + a13 * b32;
				te[ 6 ] = a11 * b13 + a12 * b23 + a13 * b33;
	
				te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31;
				te[ 4 ] = a21 * b12 + a22 * b22 + a23 * b32;
				te[ 7 ] = a21 * b13 + a22 * b23 + a23 * b33;
	
				te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31;
				te[ 5 ] = a31 * b12 + a32 * b22 + a33 * b32;
				te[ 8 ] = a31 * b13 + a32 * b23 + a33 * b33;
	
				return this;
	
			},
	
			multiplyScalar: function ( s ) {
	
				var te = this.elements;
	
				te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
				te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
				te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;
	
				return this;
	
			},
	
			determinant: function () {
	
				var te = this.elements;
	
				var a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
					d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
					g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];
	
				return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
	
			},
	
			getInverse: function ( matrix, throwOnDegenerate ) {
	
				if ( matrix && matrix.isMatrix4 ) {
	
					console.error( "THREE.Matrix3: .getInverse() no longer takes a Matrix4 argument." );
	
				}
	
				var me = matrix.elements,
					te = this.elements,
	
					n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ],
					n12 = me[ 3 ], n22 = me[ 4 ], n32 = me[ 5 ],
					n13 = me[ 6 ], n23 = me[ 7 ], n33 = me[ 8 ],
	
					t11 = n33 * n22 - n32 * n23,
					t12 = n32 * n13 - n33 * n12,
					t13 = n23 * n12 - n22 * n13,
	
					det = n11 * t11 + n21 * t12 + n31 * t13;
	
				if ( det === 0 ) {
	
					var msg = "THREE.Matrix3: .getInverse() can't invert matrix, determinant is 0";
	
					if ( throwOnDegenerate === true ) {
	
						throw new Error( msg );
	
					} else {
	
						console.warn( msg );
	
					}
	
					return this.identity();
	
				}
	
				var detInv = 1 / det;
	
				te[ 0 ] = t11 * detInv;
				te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
				te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;
	
				te[ 3 ] = t12 * detInv;
				te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
				te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;
	
				te[ 6 ] = t13 * detInv;
				te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
				te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;
	
				return this;
	
			},
	
			transpose: function () {
	
				var tmp, m = this.elements;
	
				tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
				tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
				tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;
	
				return this;
	
			},
	
			getNormalMatrix: function ( matrix4 ) {
	
				return this.setFromMatrix4( matrix4 ).getInverse( this ).transpose();
	
			},
	
			transposeIntoArray: function ( r ) {
	
				var m = this.elements;
	
				r[ 0 ] = m[ 0 ];
				r[ 1 ] = m[ 3 ];
				r[ 2 ] = m[ 6 ];
				r[ 3 ] = m[ 1 ];
				r[ 4 ] = m[ 4 ];
				r[ 5 ] = m[ 7 ];
				r[ 6 ] = m[ 2 ];
				r[ 7 ] = m[ 5 ];
				r[ 8 ] = m[ 8 ];
	
				return this;
	
			},
	
			equals: function ( matrix ) {
	
				var te = this.elements;
				var me = matrix.elements;
	
				for ( var i = 0; i < 9; i ++ ) {
	
					if ( te[ i ] !== me[ i ] ) return false;
	
				}
	
				return true;
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				for ( var i = 0; i < 9; i ++ ) {
	
					this.elements[ i ] = array[ i + offset ];
	
				}
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				var te = this.elements;
	
				array[ offset ] = te[ 0 ];
				array[ offset + 1 ] = te[ 1 ];
				array[ offset + 2 ] = te[ 2 ];
	
				array[ offset + 3 ] = te[ 3 ];
				array[ offset + 4 ] = te[ 4 ];
				array[ offset + 5 ] = te[ 5 ];
	
				array[ offset + 6 ] = te[ 6 ];
				array[ offset + 7 ] = te[ 7 ];
				array[ offset + 8 ] = te[ 8 ];
	
				return array;
	
			}
	
		} );
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Plane( normal, constant ) {
	
			// normal is assumed to be normalized
	
			this.normal = ( normal !== undefined ) ? normal : new Vector3( 1, 0, 0 );
			this.constant = ( constant !== undefined ) ? constant : 0;
	
		}
	
		Object.assign( Plane.prototype, {
	
			set: function ( normal, constant ) {
	
				this.normal.copy( normal );
				this.constant = constant;
	
				return this;
	
			},
	
			setComponents: function ( x, y, z, w ) {
	
				this.normal.set( x, y, z );
				this.constant = w;
	
				return this;
	
			},
	
			setFromNormalAndCoplanarPoint: function ( normal, point ) {
	
				this.normal.copy( normal );
				this.constant = - point.dot( this.normal );
	
				return this;
	
			},
	
			setFromCoplanarPoints: function () {
	
				var v1 = new Vector3();
				var v2 = new Vector3();
	
				return function setFromCoplanarPoints( a, b, c ) {
	
					var normal = v1.subVectors( c, b ).cross( v2.subVectors( a, b ) ).normalize();
	
					// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
	
					this.setFromNormalAndCoplanarPoint( normal, a );
	
					return this;
	
				};
	
			}(),
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( plane ) {
	
				this.normal.copy( plane.normal );
				this.constant = plane.constant;
	
				return this;
	
			},
	
			normalize: function () {
	
				// Note: will lead to a divide by zero if the plane is invalid.
	
				var inverseNormalLength = 1.0 / this.normal.length();
				this.normal.multiplyScalar( inverseNormalLength );
				this.constant *= inverseNormalLength;
	
				return this;
	
			},
	
			negate: function () {
	
				this.constant *= - 1;
				this.normal.negate();
	
				return this;
	
			},
	
			distanceToPoint: function ( point ) {
	
				return this.normal.dot( point ) + this.constant;
	
			},
	
			distanceToSphere: function ( sphere ) {
	
				return this.distanceToPoint( sphere.center ) - sphere.radius;
	
			},
	
			projectPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				return result.copy( this.normal ).multiplyScalar( - this.distanceToPoint( point ) ).add( point );
	
			},
	
			intersectLine: function () {
	
				var v1 = new Vector3();
	
				return function intersectLine( line, optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					var direction = line.delta( v1 );
	
					var denominator = this.normal.dot( direction );
	
					if ( denominator === 0 ) {
	
						// line is coplanar, return origin
						if ( this.distanceToPoint( line.start ) === 0 ) {
	
							return result.copy( line.start );
	
						}
	
						// Unsure if this is the correct method to handle this case.
						return undefined;
	
					}
	
					var t = - ( line.start.dot( this.normal ) + this.constant ) / denominator;
	
					if ( t < 0 || t > 1 ) {
	
						return undefined;
	
					}
	
					return result.copy( direction ).multiplyScalar( t ).add( line.start );
	
				};
	
			}(),
	
			intersectsLine: function ( line ) {
	
				// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
	
				var startSign = this.distanceToPoint( line.start );
				var endSign = this.distanceToPoint( line.end );
	
				return ( startSign < 0 && endSign > 0 ) || ( endSign < 0 && startSign > 0 );
	
			},
	
			intersectsBox: function ( box ) {
	
				return box.intersectsPlane( this );
	
			},
	
			intersectsSphere: function ( sphere ) {
	
				return sphere.intersectsPlane( this );
	
			},
	
			coplanarPoint: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				return result.copy( this.normal ).multiplyScalar( - this.constant );
	
			},
	
			applyMatrix4: function () {
	
				var v1 = new Vector3();
				var m1 = new Matrix3();
	
				return function applyMatrix4( matrix, optionalNormalMatrix ) {
	
					var normalMatrix = optionalNormalMatrix || m1.getNormalMatrix( matrix );
	
					var referencePoint = this.coplanarPoint( v1 ).applyMatrix4( matrix );
	
					var normal = this.normal.applyMatrix3( normalMatrix ).normalize();
	
					this.constant = - referencePoint.dot( normal );
	
					return this;
	
				};
	
			}(),
	
			translate: function ( offset ) {
	
				this.constant -= offset.dot( this.normal );
	
				return this;
	
			},
	
			equals: function ( plane ) {
	
				return plane.normal.equals( this.normal ) && ( plane.constant === this.constant );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author bhouston / http://clara.io
		 */
	
		function Frustum( p0, p1, p2, p3, p4, p5 ) {
	
			this.planes = [
	
				( p0 !== undefined ) ? p0 : new Plane(),
				( p1 !== undefined ) ? p1 : new Plane(),
				( p2 !== undefined ) ? p2 : new Plane(),
				( p3 !== undefined ) ? p3 : new Plane(),
				( p4 !== undefined ) ? p4 : new Plane(),
				( p5 !== undefined ) ? p5 : new Plane()
	
			];
	
		}
	
		Object.assign( Frustum.prototype, {
	
			set: function ( p0, p1, p2, p3, p4, p5 ) {
	
				var planes = this.planes;
	
				planes[ 0 ].copy( p0 );
				planes[ 1 ].copy( p1 );
				planes[ 2 ].copy( p2 );
				planes[ 3 ].copy( p3 );
				planes[ 4 ].copy( p4 );
				planes[ 5 ].copy( p5 );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( frustum ) {
	
				var planes = this.planes;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					planes[ i ].copy( frustum.planes[ i ] );
	
				}
	
				return this;
	
			},
	
			setFromMatrix: function ( m ) {
	
				var planes = this.planes;
				var me = m.elements;
				var me0 = me[ 0 ], me1 = me[ 1 ], me2 = me[ 2 ], me3 = me[ 3 ];
				var me4 = me[ 4 ], me5 = me[ 5 ], me6 = me[ 6 ], me7 = me[ 7 ];
				var me8 = me[ 8 ], me9 = me[ 9 ], me10 = me[ 10 ], me11 = me[ 11 ];
				var me12 = me[ 12 ], me13 = me[ 13 ], me14 = me[ 14 ], me15 = me[ 15 ];
	
				planes[ 0 ].setComponents( me3 - me0, me7 - me4, me11 - me8, me15 - me12 ).normalize();
				planes[ 1 ].setComponents( me3 + me0, me7 + me4, me11 + me8, me15 + me12 ).normalize();
				planes[ 2 ].setComponents( me3 + me1, me7 + me5, me11 + me9, me15 + me13 ).normalize();
				planes[ 3 ].setComponents( me3 - me1, me7 - me5, me11 - me9, me15 - me13 ).normalize();
				planes[ 4 ].setComponents( me3 - me2, me7 - me6, me11 - me10, me15 - me14 ).normalize();
				planes[ 5 ].setComponents( me3 + me2, me7 + me6, me11 + me10, me15 + me14 ).normalize();
	
				return this;
	
			},
	
			intersectsObject: function () {
	
				var sphere = new Sphere();
	
				return function intersectsObject( object ) {
	
					var geometry = object.geometry;
	
					if ( geometry.boundingSphere === null )
						geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere )
						.applyMatrix4( object.matrixWorld );
	
					return this.intersectsSphere( sphere );
	
				};
	
			}(),
	
			intersectsSprite: function () {
	
				var sphere = new Sphere();
	
				return function intersectsSprite( sprite ) {
	
					sphere.center.set( 0, 0, 0 );
					sphere.radius = 0.7071067811865476;
					sphere.applyMatrix4( sprite.matrixWorld );
	
					return this.intersectsSphere( sphere );
	
				};
	
			}(),
	
			intersectsSphere: function ( sphere ) {
	
				var planes = this.planes;
				var center = sphere.center;
				var negRadius = - sphere.radius;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					var distance = planes[ i ].distanceToPoint( center );
	
					if ( distance < negRadius ) {
	
						return false;
	
					}
	
				}
	
				return true;
	
			},
	
			intersectsBox: function () {
	
				var p1 = new Vector3(),
					p2 = new Vector3();
	
				return function intersectsBox( box ) {
	
					var planes = this.planes;
	
					for ( var i = 0; i < 6; i ++ ) {
	
						var plane = planes[ i ];
	
						p1.x = plane.normal.x > 0 ? box.min.x : box.max.x;
						p2.x = plane.normal.x > 0 ? box.max.x : box.min.x;
						p1.y = plane.normal.y > 0 ? box.min.y : box.max.y;
						p2.y = plane.normal.y > 0 ? box.max.y : box.min.y;
						p1.z = plane.normal.z > 0 ? box.min.z : box.max.z;
						p2.z = plane.normal.z > 0 ? box.max.z : box.min.z;
	
						var d1 = plane.distanceToPoint( p1 );
						var d2 = plane.distanceToPoint( p2 );
	
						// if both outside plane, no intersection
	
						if ( d1 < 0 && d2 < 0 ) {
	
							return false;
	
						}
	
					}
	
					return true;
	
				};
	
			}(),
	
			containsPoint: function ( point ) {
	
				var planes = this.planes;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					if ( planes[ i ].distanceToPoint( point ) < 0 ) {
	
						return false;
	
					}
	
				}
	
				return true;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLShadowMap( _renderer, _objects, maxTextureSize ) {
	
			var _frustum = new Frustum(),
				_projScreenMatrix = new Matrix4(),
	
				_shadowMapSize = new Vector2(),
				_maxShadowMapSize = new Vector2( maxTextureSize, maxTextureSize ),
	
				_lookTarget = new Vector3(),
				_lightPositionWorld = new Vector3(),
	
				_MorphingFlag = 1,
				_SkinningFlag = 2,
	
				_NumberOfMaterialVariants = ( _MorphingFlag | _SkinningFlag ) + 1,
	
				_depthMaterials = new Array( _NumberOfMaterialVariants ),
				_distanceMaterials = new Array( _NumberOfMaterialVariants ),
	
				_materialCache = {};
	
			var cubeDirections = [
				new Vector3( 1, 0, 0 ), new Vector3( - 1, 0, 0 ), new Vector3( 0, 0, 1 ),
				new Vector3( 0, 0, - 1 ), new Vector3( 0, 1, 0 ), new Vector3( 0, - 1, 0 )
			];
	
			var cubeUps = [
				new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ),
				new Vector3( 0, 1, 0 ), new Vector3( 0, 0, 1 ),	new Vector3( 0, 0, - 1 )
			];
	
			var cube2DViewPorts = [
				new Vector4(), new Vector4(), new Vector4(),
				new Vector4(), new Vector4(), new Vector4()
			];
	
			// init
	
			for ( var i = 0; i !== _NumberOfMaterialVariants; ++ i ) {
	
				var useMorphing = ( i & _MorphingFlag ) !== 0;
				var useSkinning = ( i & _SkinningFlag ) !== 0;
	
				var depthMaterial = new MeshDepthMaterial( {
	
					depthPacking: RGBADepthPacking,
	
					morphTargets: useMorphing,
					skinning: useSkinning
	
				} );
	
				_depthMaterials[ i ] = depthMaterial;
	
				//
	
				var distanceMaterial = new MeshDistanceMaterial( {
	
					morphTargets: useMorphing,
					skinning: useSkinning
	
				} );
	
				_distanceMaterials[ i ] = distanceMaterial;
	
			}
	
			//
	
			var scope = this;
	
			this.enabled = false;
	
			this.autoUpdate = true;
			this.needsUpdate = false;
	
			this.type = PCFShadowMap;
	
			this.renderReverseSided = true;
			this.renderSingleSided = true;
	
			this.render = function ( lights, scene, camera ) {
	
				if ( scope.enabled === false ) return;
				if ( scope.autoUpdate === false && scope.needsUpdate === false ) return;
	
				if ( lights.length === 0 ) return;
	
				// TODO Clean up (needed in case of contextlost)
				var _gl = _renderer.context;
				var _state = _renderer.state;
	
				// Set GL state for depth map.
				_state.disable( _gl.BLEND );
				_state.buffers.color.setClear( 1, 1, 1, 1 );
				_state.buffers.depth.setTest( true );
				_state.setScissorTest( false );
	
				// render depth map
	
				var faceCount;
	
				for ( var i = 0, il = lights.length; i < il; i ++ ) {
	
					var light = lights[ i ];
					var shadow = light.shadow;
					var isPointLight = light && light.isPointLight;
	
					if ( shadow === undefined ) {
	
						console.warn( 'THREE.WebGLShadowMap:', light, 'has no shadow.' );
						continue;
	
					}
	
					var shadowCamera = shadow.camera;
	
					_shadowMapSize.copy( shadow.mapSize );
					_shadowMapSize.min( _maxShadowMapSize );
	
					if ( isPointLight ) {
	
						var vpWidth = _shadowMapSize.x;
						var vpHeight = _shadowMapSize.y;
	
						// These viewports map a cube-map onto a 2D texture with the
						// following orientation:
						//
						//  xzXZ
						//   y Y
						//
						// X - Positive x direction
						// x - Negative x direction
						// Y - Positive y direction
						// y - Negative y direction
						// Z - Positive z direction
						// z - Negative z direction
	
						// positive X
						cube2DViewPorts[ 0 ].set( vpWidth * 2, vpHeight, vpWidth, vpHeight );
						// negative X
						cube2DViewPorts[ 1 ].set( 0, vpHeight, vpWidth, vpHeight );
						// positive Z
						cube2DViewPorts[ 2 ].set( vpWidth * 3, vpHeight, vpWidth, vpHeight );
						// negative Z
						cube2DViewPorts[ 3 ].set( vpWidth, vpHeight, vpWidth, vpHeight );
						// positive Y
						cube2DViewPorts[ 4 ].set( vpWidth * 3, 0, vpWidth, vpHeight );
						// negative Y
						cube2DViewPorts[ 5 ].set( vpWidth, 0, vpWidth, vpHeight );
	
						_shadowMapSize.x *= 4.0;
						_shadowMapSize.y *= 2.0;
	
					}
	
					if ( shadow.map === null ) {
	
						var pars = { minFilter: NearestFilter, magFilter: NearestFilter, format: RGBAFormat };
	
						shadow.map = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y, pars );
						shadow.map.texture.name = light.name + ".shadowMap";
	
						shadowCamera.updateProjectionMatrix();
	
					}
	
					if ( shadow.isSpotLightShadow ) {
	
						shadow.update( light );
	
					}
	
					var shadowMap = shadow.map;
					var shadowMatrix = shadow.matrix;
	
					_lightPositionWorld.setFromMatrixPosition( light.matrixWorld );
					shadowCamera.position.copy( _lightPositionWorld );
	
					if ( isPointLight ) {
	
						faceCount = 6;
	
						// for point lights we set the shadow matrix to be a translation-only matrix
						// equal to inverse of the light's position
	
						shadowMatrix.makeTranslation( - _lightPositionWorld.x, - _lightPositionWorld.y, - _lightPositionWorld.z );
	
					} else {
	
						faceCount = 1;
	
						_lookTarget.setFromMatrixPosition( light.target.matrixWorld );
						shadowCamera.lookAt( _lookTarget );
						shadowCamera.updateMatrixWorld();
	
						// compute shadow matrix
	
						shadowMatrix.set(
							0.5, 0.0, 0.0, 0.5,
							0.0, 0.5, 0.0, 0.5,
							0.0, 0.0, 0.5, 0.5,
							0.0, 0.0, 0.0, 1.0
						);
	
						shadowMatrix.multiply( shadowCamera.projectionMatrix );
						shadowMatrix.multiply( shadowCamera.matrixWorldInverse );
	
					}
	
					_renderer.setRenderTarget( shadowMap );
					_renderer.clear();
	
					// render shadow map for each cube face (if omni-directional) or
					// run a single pass if not
	
					for ( var face = 0; face < faceCount; face ++ ) {
	
						if ( isPointLight ) {
	
							_lookTarget.copy( shadowCamera.position );
							_lookTarget.add( cubeDirections[ face ] );
							shadowCamera.up.copy( cubeUps[ face ] );
							shadowCamera.lookAt( _lookTarget );
							shadowCamera.updateMatrixWorld();
	
							var vpDimensions = cube2DViewPorts[ face ];
							_state.viewport( vpDimensions );
	
						}
	
						// update camera matrices and frustum
	
						_projScreenMatrix.multiplyMatrices( shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse );
						_frustum.setFromMatrix( _projScreenMatrix );
	
						// set object matrices & frustum culling
	
						renderObject( scene, camera, shadowCamera, isPointLight );
	
					}
	
				}
	
				scope.needsUpdate = false;
	
			};
	
			function getDepthMaterial( object, material, isPointLight, lightPositionWorld, shadowCameraNear, shadowCameraFar ) {
	
				var geometry = object.geometry;
	
				var result = null;
	
				var materialVariants = _depthMaterials;
				var customMaterial = object.customDepthMaterial;
	
				if ( isPointLight ) {
	
					materialVariants = _distanceMaterials;
					customMaterial = object.customDistanceMaterial;
	
				}
	
				if ( ! customMaterial ) {
	
					var useMorphing = false;
	
					if ( material.morphTargets ) {
	
						if ( geometry && geometry.isBufferGeometry ) {
	
							useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;
	
						} else if ( geometry && geometry.isGeometry ) {
	
							useMorphing = geometry.morphTargets && geometry.morphTargets.length > 0;
	
						}
	
					}
	
					if ( object.isSkinnedMesh && material.skinning === false ) {
	
						console.warn( 'THREE.WebGLShadowMap: THREE.SkinnedMesh with material.skinning set to false:', object );
	
					}
	
					var useSkinning = object.isSkinnedMesh && material.skinning;
	
					var variantIndex = 0;
	
					if ( useMorphing ) variantIndex |= _MorphingFlag;
					if ( useSkinning ) variantIndex |= _SkinningFlag;
	
					result = materialVariants[ variantIndex ];
	
				} else {
	
					result = customMaterial;
	
				}
	
				if ( _renderer.localClippingEnabled &&
						material.clipShadows === true &&
						material.clippingPlanes.length !== 0 ) {
	
					// in this case we need a unique material instance reflecting the
					// appropriate state
	
					var keyA = result.uuid, keyB = material.uuid;
	
					var materialsForVariant = _materialCache[ keyA ];
	
					if ( materialsForVariant === undefined ) {
	
						materialsForVariant = {};
						_materialCache[ keyA ] = materialsForVariant;
	
					}
	
					var cachedMaterial = materialsForVariant[ keyB ];
	
					if ( cachedMaterial === undefined ) {
	
						cachedMaterial = result.clone();
						materialsForVariant[ keyB ] = cachedMaterial;
	
					}
	
					result = cachedMaterial;
	
				}
	
				result.visible = material.visible;
				result.wireframe = material.wireframe;
	
				var side = material.side;
	
				if ( scope.renderSingleSided && side == DoubleSide ) {
	
					side = FrontSide;
	
				}
	
				if ( scope.renderReverseSided ) {
	
					if ( side === FrontSide ) side = BackSide;
					else if ( side === BackSide ) side = FrontSide;
	
				}
	
				result.side = side;
	
				result.clipShadows = material.clipShadows;
				result.clippingPlanes = material.clippingPlanes;
				result.clipIntersection = material.clipIntersection;
	
				result.wireframeLinewidth = material.wireframeLinewidth;
				result.linewidth = material.linewidth;
	
				if ( isPointLight && result.isMeshDistanceMaterial ) {
	
					result.referencePosition.copy( lightPositionWorld );
					result.nearDistance = shadowCameraNear;
					result.farDistance = shadowCameraFar;
	
				}
	
				return result;
	
			}
	
			function renderObject( object, camera, shadowCamera, isPointLight ) {
	
				if ( object.visible === false ) return;
	
				var visible = object.layers.test( camera.layers );
	
				if ( visible && ( object.isMesh || object.isLine || object.isPoints ) ) {
	
					if ( object.castShadow && ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) ) {
	
						object.modelViewMatrix.multiplyMatrices( shadowCamera.matrixWorldInverse, object.matrixWorld );
	
						var geometry = _objects.update( object );
						var material = object.material;
	
						if ( Array.isArray( material ) ) {
	
							var groups = geometry.groups;
	
							for ( var k = 0, kl = groups.length; k < kl; k ++ ) {
	
								var group = groups[ k ];
								var groupMaterial = material[ group.materialIndex ];
	
								if ( groupMaterial && groupMaterial.visible ) {
	
									var depthMaterial = getDepthMaterial( object, groupMaterial, isPointLight, _lightPositionWorld, shadowCamera.near, shadowCamera.far );
									_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, group );
	
								}
	
							}
	
						} else if ( material.visible ) {
	
							var depthMaterial = getDepthMaterial( object, material, isPointLight, _lightPositionWorld, shadowCamera.near, shadowCamera.far );
							_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, null );
	
						}
	
					}
	
				}
	
				var children = object.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					renderObject( children[ i ], camera, shadowCamera, isPointLight );
	
				}
	
			}
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLAttributes( gl ) {
	
			var buffers = {};
	
			function createBuffer( attribute, bufferType ) {
	
				var array = attribute.array;
				var usage = attribute.dynamic ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW;
	
				var buffer = gl.createBuffer();
	
				gl.bindBuffer( bufferType, buffer );
				gl.bufferData( bufferType, array, usage );
	
				attribute.onUploadCallback();
	
				var type = gl.FLOAT;
	
				if ( array instanceof Float32Array ) {
	
					type = gl.FLOAT;
	
				} else if ( array instanceof Float64Array ) {
	
					console.warn( 'THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.' );
	
				} else if ( array instanceof Uint16Array ) {
	
					type = gl.UNSIGNED_SHORT;
	
				} else if ( array instanceof Int16Array ) {
	
					type = gl.SHORT;
	
				} else if ( array instanceof Uint32Array ) {
	
					type = gl.UNSIGNED_INT;
	
				} else if ( array instanceof Int32Array ) {
	
					type = gl.INT;
	
				} else if ( array instanceof Int8Array ) {
	
					type = gl.BYTE;
	
				} else if ( array instanceof Uint8Array ) {
	
					type = gl.UNSIGNED_BYTE;
	
				}
	
				return {
					buffer: buffer,
					type: type,
					bytesPerElement: array.BYTES_PER_ELEMENT,
					version: attribute.version
				};
	
			}
	
			function updateBuffer( buffer, attribute, bufferType ) {
	
				var array = attribute.array;
				var updateRange = attribute.updateRange;
	
				gl.bindBuffer( bufferType, buffer );
	
				if ( attribute.dynamic === false ) {
	
					gl.bufferData( bufferType, array, gl.STATIC_DRAW );
	
				} else if ( updateRange.count === - 1 ) {
	
					// Not using update ranges
	
					gl.bufferSubData( bufferType, 0, array );
	
				} else if ( updateRange.count === 0 ) {
	
					console.error( 'THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.' );
	
				} else {
	
					gl.bufferSubData( bufferType, updateRange.offset * array.BYTES_PER_ELEMENT,
						array.subarray( updateRange.offset, updateRange.offset + updateRange.count ) );
	
					updateRange.count = -1; // reset range
	
				}
	
			}
	
			//
	
			function get( attribute ) {
	
				if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;
	
				return buffers[ attribute.uuid ];
	
			}
	
			function remove( attribute ) {
	
				if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;
				
				var data = buffers[ attribute.uuid ];
	
				if ( data ) {
	
					gl.deleteBuffer( data.buffer );
	
					delete buffers[ attribute.uuid ];
	
				}
	
			}
	
			function update( attribute, bufferType ) {
	
				if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;
	
				var data = buffers[ attribute.uuid ];
	
				if ( data === undefined ) {
	
					buffers[ attribute.uuid ] = createBuffer( attribute, bufferType );
	
				} else if ( data.version < attribute.version ) {
	
					updateBuffer( data.buffer, attribute, bufferType );
	
					data.version = attribute.version;
	
				}
	
			}
	
			return {
	
				get: get,
				remove: remove,
				update: update
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author bhouston / http://clara.io
		 */
	
		function Euler( x, y, z, order ) {
	
			this._x = x || 0;
			this._y = y || 0;
			this._z = z || 0;
			this._order = order || Euler.DefaultOrder;
	
		}
	
		Euler.RotationOrders = [ 'XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX' ];
	
		Euler.DefaultOrder = 'XYZ';
	
		Object.defineProperties( Euler.prototype, {
	
			x: {
	
				get: function () {
	
					return this._x;
	
				},
	
				set: function ( value ) {
	
					this._x = value;
					this.onChangeCallback();
	
				}
	
			},
	
			y: {
	
				get: function () {
	
					return this._y;
	
				},
	
				set: function ( value ) {
	
					this._y = value;
					this.onChangeCallback();
	
				}
	
			},
	
			z: {
	
				get: function () {
	
					return this._z;
	
				},
	
				set: function ( value ) {
	
					this._z = value;
					this.onChangeCallback();
	
				}
	
			},
	
			order: {
	
				get: function () {
	
					return this._order;
	
				},
	
				set: function ( value ) {
	
					this._order = value;
					this.onChangeCallback();
	
				}
	
			}
	
		} );
	
		Object.assign( Euler.prototype, {
	
			isEuler: true,
	
			set: function ( x, y, z, order ) {
	
				this._x = x;
				this._y = y;
				this._z = z;
				this._order = order || this._order;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this._x, this._y, this._z, this._order );
	
			},
	
			copy: function ( euler ) {
	
				this._x = euler._x;
				this._y = euler._y;
				this._z = euler._z;
				this._order = euler._order;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromRotationMatrix: function ( m, order, update ) {
	
				var clamp = _Math.clamp;
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				var te = m.elements;
				var m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
				var m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
				var m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];
	
				order = order || this._order;
	
				if ( order === 'XYZ' ) {
	
					this._y = Math.asin( clamp( m13, - 1, 1 ) );
	
					if ( Math.abs( m13 ) < 0.99999 ) {
	
						this._x = Math.atan2( - m23, m33 );
						this._z = Math.atan2( - m12, m11 );
	
					} else {
	
						this._x = Math.atan2( m32, m22 );
						this._z = 0;
	
					}
	
				} else if ( order === 'YXZ' ) {
	
					this._x = Math.asin( - clamp( m23, - 1, 1 ) );
	
					if ( Math.abs( m23 ) < 0.99999 ) {
	
						this._y = Math.atan2( m13, m33 );
						this._z = Math.atan2( m21, m22 );
	
					} else {
	
						this._y = Math.atan2( - m31, m11 );
						this._z = 0;
	
					}
	
				} else if ( order === 'ZXY' ) {
	
					this._x = Math.asin( clamp( m32, - 1, 1 ) );
	
					if ( Math.abs( m32 ) < 0.99999 ) {
	
						this._y = Math.atan2( - m31, m33 );
						this._z = Math.atan2( - m12, m22 );
	
					} else {
	
						this._y = 0;
						this._z = Math.atan2( m21, m11 );
	
					}
	
				} else if ( order === 'ZYX' ) {
	
					this._y = Math.asin( - clamp( m31, - 1, 1 ) );
	
					if ( Math.abs( m31 ) < 0.99999 ) {
	
						this._x = Math.atan2( m32, m33 );
						this._z = Math.atan2( m21, m11 );
	
					} else {
	
						this._x = 0;
						this._z = Math.atan2( - m12, m22 );
	
					}
	
				} else if ( order === 'YZX' ) {
	
					this._z = Math.asin( clamp( m21, - 1, 1 ) );
	
					if ( Math.abs( m21 ) < 0.99999 ) {
	
						this._x = Math.atan2( - m23, m22 );
						this._y = Math.atan2( - m31, m11 );
	
					} else {
	
						this._x = 0;
						this._y = Math.atan2( m13, m33 );
	
					}
	
				} else if ( order === 'XZY' ) {
	
					this._z = Math.asin( - clamp( m12, - 1, 1 ) );
	
					if ( Math.abs( m12 ) < 0.99999 ) {
	
						this._x = Math.atan2( m32, m22 );
						this._y = Math.atan2( m13, m11 );
	
					} else {
	
						this._x = Math.atan2( - m23, m33 );
						this._y = 0;
	
					}
	
				} else {
	
					console.warn( 'THREE.Euler: .setFromRotationMatrix() given unsupported order: ' + order );
	
				}
	
				this._order = order;
	
				if ( update !== false ) this.onChangeCallback();
	
				return this;
	
			},
	
			setFromQuaternion: function () {
	
				var matrix = new Matrix4();
	
				return function setFromQuaternion( q, order, update ) {
	
					matrix.makeRotationFromQuaternion( q );
	
					return this.setFromRotationMatrix( matrix, order, update );
	
				};
	
			}(),
	
			setFromVector3: function ( v, order ) {
	
				return this.set( v.x, v.y, v.z, order || this._order );
	
			},
	
			reorder: function () {
	
				// WARNING: this discards revolution information -bhouston
	
				var q = new Quaternion();
	
				return function reorder( newOrder ) {
	
					q.setFromEuler( this );
	
					return this.setFromQuaternion( q, newOrder );
	
				};
	
			}(),
	
			equals: function ( euler ) {
	
				return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );
	
			},
	
			fromArray: function ( array ) {
	
				this._x = array[ 0 ];
				this._y = array[ 1 ];
				this._z = array[ 2 ];
				if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this._x;
				array[ offset + 1 ] = this._y;
				array[ offset + 2 ] = this._z;
				array[ offset + 3 ] = this._order;
	
				return array;
	
			},
	
			toVector3: function ( optionalResult ) {
	
				if ( optionalResult ) {
	
					return optionalResult.set( this._x, this._y, this._z );
	
				} else {
	
					return new Vector3( this._x, this._y, this._z );
	
				}
	
			},
	
			onChange: function ( callback ) {
	
				this.onChangeCallback = callback;
	
				return this;
	
			},
	
			onChangeCallback: function () {}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Layers() {
	
			this.mask = 1 | 0;
	
		}
	
		Object.assign( Layers.prototype, {
	
			set: function ( channel ) {
	
				this.mask = 1 << channel | 0;
	
			},
	
			enable: function ( channel ) {
	
				this.mask |= 1 << channel | 0;
	
			},
	
			toggle: function ( channel ) {
	
				this.mask ^= 1 << channel | 0;
	
			},
	
			disable: function ( channel ) {
	
				this.mask &= ~ ( 1 << channel | 0 );
	
			},
	
			test: function ( layers ) {
	
				return ( this.mask & layers.mask ) !== 0;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author elephantatwork / www.elephantatwork.ch
		 */
	
		var object3DId = 0;
	
		function Object3D() {
	
			Object.defineProperty( this, 'id', { value: object3DId ++ } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'Object3D';
	
			this.parent = null;
			this.children = [];
	
			this.up = Object3D.DefaultUp.clone();
	
			var position = new Vector3();
			var rotation = new Euler();
			var quaternion = new Quaternion();
			var scale = new Vector3( 1, 1, 1 );
	
			function onRotationChange() {
	
				quaternion.setFromEuler( rotation, false );
	
			}
	
			function onQuaternionChange() {
	
				rotation.setFromQuaternion( quaternion, undefined, false );
	
			}
	
			rotation.onChange( onRotationChange );
			quaternion.onChange( onQuaternionChange );
	
			Object.defineProperties( this, {
				position: {
					enumerable: true,
					value: position
				},
				rotation: {
					enumerable: true,
					value: rotation
				},
				quaternion: {
					enumerable: true,
					value: quaternion
				},
				scale: {
					enumerable: true,
					value: scale
				},
				modelViewMatrix: {
					value: new Matrix4()
				},
				normalMatrix: {
					value: new Matrix3()
				}
			} );
	
			this.matrix = new Matrix4();
			this.matrixWorld = new Matrix4();
	
			this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
			this.matrixWorldNeedsUpdate = false;
	
			this.layers = new Layers();
			this.visible = true;
	
			this.castShadow = false;
			this.receiveShadow = false;
	
			this.frustumCulled = true;
			this.renderOrder = 0;
	
			this.userData = {};
		}
	
		Object3D.DefaultUp = new Vector3( 0, 1, 0 );
		Object3D.DefaultMatrixAutoUpdate = true;
	
		Object.assign( Object3D.prototype, EventDispatcher.prototype, {
	
			isObject3D: true,
	
			onBeforeRender: function () {},
			onAfterRender: function () {},
	
			applyMatrix: function ( matrix ) {
	
				this.matrix.multiplyMatrices( matrix, this.matrix );
	
				this.matrix.decompose( this.position, this.quaternion, this.scale );
	
			},
	
			applyQuaternion: function ( q ) {
	
				this.quaternion.premultiply( q );
	
				return this;
	
			},
	
			setRotationFromAxisAngle: function ( axis, angle ) {
	
				// assumes axis is normalized
	
				this.quaternion.setFromAxisAngle( axis, angle );
	
			},
	
			setRotationFromEuler: function ( euler ) {
	
				this.quaternion.setFromEuler( euler, true );
	
			},
	
			setRotationFromMatrix: function ( m ) {
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				this.quaternion.setFromRotationMatrix( m );
	
			},
	
			setRotationFromQuaternion: function ( q ) {
	
				// assumes q is normalized
	
				this.quaternion.copy( q );
	
			},
	
			rotateOnAxis: function () {
	
				// rotate object on axis in object space
				// axis is assumed to be normalized
	
				var q1 = new Quaternion();
	
				return function rotateOnAxis( axis, angle ) {
	
					q1.setFromAxisAngle( axis, angle );
	
					this.quaternion.multiply( q1 );
	
					return this;
	
				};
	
			}(),
	
			rotateX: function () {
	
				var v1 = new Vector3( 1, 0, 0 );
	
				return function rotateX( angle ) {
	
					return this.rotateOnAxis( v1, angle );
	
				};
	
			}(),
	
			rotateY: function () {
	
				var v1 = new Vector3( 0, 1, 0 );
	
				return function rotateY( angle ) {
	
					return this.rotateOnAxis( v1, angle );
	
				};
	
			}(),
	
			rotateZ: function () {
	
				var v1 = new Vector3( 0, 0, 1 );
	
				return function rotateZ( angle ) {
	
					return this.rotateOnAxis( v1, angle );
	
				};
	
			}(),
	
			translateOnAxis: function () {
	
				// translate object by distance along axis in object space
				// axis is assumed to be normalized
	
				var v1 = new Vector3();
	
				return function translateOnAxis( axis, distance ) {
	
					v1.copy( axis ).applyQuaternion( this.quaternion );
	
					this.position.add( v1.multiplyScalar( distance ) );
	
					return this;
	
				};
	
			}(),
	
			translateX: function () {
	
				var v1 = new Vector3( 1, 0, 0 );
	
				return function translateX( distance ) {
	
					return this.translateOnAxis( v1, distance );
	
				};
	
			}(),
	
			translateY: function () {
	
				var v1 = new Vector3( 0, 1, 0 );
	
				return function translateY( distance ) {
	
					return this.translateOnAxis( v1, distance );
	
				};
	
			}(),
	
			translateZ: function () {
	
				var v1 = new Vector3( 0, 0, 1 );
	
				return function translateZ( distance ) {
	
					return this.translateOnAxis( v1, distance );
	
				};
	
			}(),
	
			localToWorld: function ( vector ) {
	
				return vector.applyMatrix4( this.matrixWorld );
	
			},
	
			worldToLocal: function () {
	
				var m1 = new Matrix4();
	
				return function worldToLocal( vector ) {
	
					return vector.applyMatrix4( m1.getInverse( this.matrixWorld ) );
	
				};
	
			}(),
	
			lookAt: function () {
	
				// This method does not support objects with rotated and/or translated parent(s)
	
				var m1 = new Matrix4();
	
				return function lookAt( vector ) {
	
					if ( this.isCamera ) {
	
						m1.lookAt( this.position, vector, this.up );
	
					} else {
	
						m1.lookAt( vector, this.position, this.up );
	
					}
	
					this.quaternion.setFromRotationMatrix( m1 );
	
				};
	
			}(),
	
			add: function ( object ) {
	
				if ( arguments.length > 1 ) {
	
					for ( var i = 0; i < arguments.length; i ++ ) {
	
						this.add( arguments[ i ] );
	
					}
	
					return this;
	
				}
	
				if ( object === this ) {
	
					console.error( "THREE.Object3D.add: object can't be added as a child of itself.", object );
					return this;
	
				}
	
				if ( ( object && object.isObject3D ) ) {
	
					if ( object.parent !== null ) {
	
						object.parent.remove( object );
	
					}
	
					object.parent = this;
					object.dispatchEvent( { type: 'added' } );
	
					this.children.push( object );
	
				} else {
	
					console.error( "THREE.Object3D.add: object not an instance of THREE.Object3D.", object );
	
				}
	
				return this;
	
			},
	
			remove: function ( object ) {
	
				if ( arguments.length > 1 ) {
	
					for ( var i = 0; i < arguments.length; i ++ ) {
	
						this.remove( arguments[ i ] );
	
					}
	
					return this;
	
				}
	
				var index = this.children.indexOf( object );
	
				if ( index !== - 1 ) {
	
					object.parent = null;
	
					object.dispatchEvent( { type: 'removed' } );
	
					this.children.splice( index, 1 );
	
				}
	
				return this;
	
			},
	
			getObjectById: function ( id ) {
	
				return this.getObjectByProperty( 'id', id );
	
			},
	
			getObjectByName: function ( name ) {
	
				return this.getObjectByProperty( 'name', name );
	
			},
	
			getObjectByProperty: function ( name, value ) {
	
				if ( this[ name ] === value ) return this;
	
				for ( var i = 0, l = this.children.length; i < l; i ++ ) {
	
					var child = this.children[ i ];
					var object = child.getObjectByProperty( name, value );
	
					if ( object !== undefined ) {
	
						return object;
	
					}
	
				}
	
				return undefined;
	
			},
	
			getWorldPosition: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				this.updateMatrixWorld( true );
	
				return result.setFromMatrixPosition( this.matrixWorld );
	
			},
	
			getWorldQuaternion: function () {
	
				var position = new Vector3();
				var scale = new Vector3();
	
				return function getWorldQuaternion( optionalTarget ) {
	
					var result = optionalTarget || new Quaternion();
	
					this.updateMatrixWorld( true );
	
					this.matrixWorld.decompose( position, result, scale );
	
					return result;
	
				};
	
			}(),
	
			getWorldRotation: function () {
	
				var quaternion = new Quaternion();
	
				return function getWorldRotation( optionalTarget ) {
	
					var result = optionalTarget || new Euler();
	
					this.getWorldQuaternion( quaternion );
	
					return result.setFromQuaternion( quaternion, this.rotation.order, false );
	
				};
	
			}(),
	
			getWorldScale: function () {
	
				var position = new Vector3();
				var quaternion = new Quaternion();
	
				return function getWorldScale( optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					this.updateMatrixWorld( true );
	
					this.matrixWorld.decompose( position, quaternion, result );
	
					return result;
	
				};
	
			}(),
	
			getWorldDirection: function () {
	
				var quaternion = new Quaternion();
	
				return function getWorldDirection( optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					this.getWorldQuaternion( quaternion );
	
					return result.set( 0, 0, 1 ).applyQuaternion( quaternion );
	
				};
	
			}(),
	
			raycast: function () {},
	
			traverse: function ( callback ) {
	
				callback( this );
	
				var children = this.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					children[ i ].traverse( callback );
	
				}
	
			},
	
			traverseVisible: function ( callback ) {
	
				if ( this.visible === false ) return;
	
				callback( this );
	
				var children = this.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					children[ i ].traverseVisible( callback );
	
				}
	
			},
	
			traverseAncestors: function ( callback ) {
	
				var parent = this.parent;
	
				if ( parent !== null ) {
	
					callback( parent );
	
					parent.traverseAncestors( callback );
	
				}
	
			},
	
			updateMatrix: function () {
	
				this.matrix.compose( this.position, this.quaternion, this.scale );
	
				this.matrixWorldNeedsUpdate = true;
	
			},
	
			updateMatrixWorld: function ( force ) {
	
				if ( this.matrixAutoUpdate ) this.updateMatrix();
	
				if ( this.matrixWorldNeedsUpdate || force ) {
	
					if ( this.parent === null ) {
	
						this.matrixWorld.copy( this.matrix );
	
					} else {
	
						this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );
	
					}
	
					this.matrixWorldNeedsUpdate = false;
	
					force = true;
	
				}
	
				// update children
	
				var children = this.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					children[ i ].updateMatrixWorld( force );
	
				}
	
			},
	
			toJSON: function ( meta ) {
	
				// meta is '' when called from JSON.stringify
				var isRootObject = ( meta === undefined || meta === '' );
	
				var output = {};
	
				// meta is a hash used to collect geometries, materials.
				// not providing it implies that this is the root object
				// being serialized.
				if ( isRootObject ) {
	
					// initialize meta obj
					meta = {
						geometries: {},
						materials: {},
						textures: {},
						images: {}
					};
	
					output.metadata = {
						version: 4.5,
						type: 'Object',
						generator: 'Object3D.toJSON'
					};
	
				}
	
				// standard Object3D serialization
	
				var object = {};
	
				object.uuid = this.uuid;
				object.type = this.type;
	
				if ( this.name !== '' ) object.name = this.name;
				if ( this.castShadow === true ) object.castShadow = true;
				if ( this.receiveShadow === true ) object.receiveShadow = true;
				if ( this.visible === false ) object.visible = false;
				if ( JSON.stringify( this.userData ) !== '{}' ) object.userData = this.userData;
	
				object.matrix = this.matrix.toArray();
	
				//
	
				function serialize( library, element ) {
	
					if ( library[ element.uuid ] === undefined ) {
	
						library[ element.uuid ] = element.toJSON( meta );
	
					}
	
					return element.uuid;
	
				}
	
				if ( this.geometry !== undefined ) {
	
					object.geometry = serialize( meta.geometries, this.geometry );
	
				}
	
				if ( this.material !== undefined ) {
	
					if ( Array.isArray( this.material ) ) {
	
						var uuids = [];
	
						for ( var i = 0, l = this.material.length; i < l; i ++ ) {
	
							uuids.push( serialize( meta.materials, this.material[ i ] ) );
	
						}
	
						object.material = uuids;
	
					} else {
	
						object.material = serialize( meta.materials, this.material );
	
					}
	
				}
	
				//
	
				if ( this.children.length > 0 ) {
	
					object.children = [];
	
					for ( var i = 0; i < this.children.length; i ++ ) {
	
						object.children.push( this.children[ i ].toJSON( meta ).object );
	
					}
	
				}
	
				if ( isRootObject ) {
	
					var geometries = extractFromCache( meta.geometries );
					var materials = extractFromCache( meta.materials );
					var textures = extractFromCache( meta.textures );
					var images = extractFromCache( meta.images );
	
					if ( geometries.length > 0 ) output.geometries = geometries;
					if ( materials.length > 0 ) output.materials = materials;
					if ( textures.length > 0 ) output.textures = textures;
					if ( images.length > 0 ) output.images = images;
	
				}
	
				output.object = object;
	
				return output;
	
				// extract data from the cache hash
				// remove metadata on each item
				// and return as array
				function extractFromCache( cache ) {
	
					var values = [];
					for ( var key in cache ) {
	
						var data = cache[ key ];
						delete data.metadata;
						values.push( data );
	
					}
					return values;
	
				}
	
			},
	
			clone: function ( recursive ) {
	
				return new this.constructor().copy( this, recursive );
	
			},
	
			copy: function ( source, recursive ) {
	
				if ( recursive === undefined ) recursive = true;
	
				this.name = source.name;
	
				this.up.copy( source.up );
	
				this.position.copy( source.position );
				this.quaternion.copy( source.quaternion );
				this.scale.copy( source.scale );
	
				this.matrix.copy( source.matrix );
				this.matrixWorld.copy( source.matrixWorld );
	
				this.matrixAutoUpdate = source.matrixAutoUpdate;
				this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
	
				this.layers.mask = source.layers.mask;
				this.visible = source.visible;
	
				this.castShadow = source.castShadow;
				this.receiveShadow = source.receiveShadow;
	
				this.frustumCulled = source.frustumCulled;
				this.renderOrder = source.renderOrder;
	
				this.userData = JSON.parse( JSON.stringify( source.userData ) );
	
				if ( recursive === true ) {
	
					for ( var i = 0; i < source.children.length; i ++ ) {
	
						var child = source.children[ i ];
						this.add( child.clone() );
	
					}
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author WestLangley / http://github.com/WestLangley
		*/
	
		function Camera() {
	
			Object3D.call( this );
	
			this.type = 'Camera';
	
			this.matrixWorldInverse = new Matrix4();
			this.projectionMatrix = new Matrix4();
	
		}
	
		Camera.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Camera,
	
			isCamera: true,
	
			copy: function ( source, recursive ) {
	
				Object3D.prototype.copy.call( this, source, recursive );
	
				this.matrixWorldInverse.copy( source.matrixWorldInverse );
				this.projectionMatrix.copy( source.projectionMatrix );
	
				return this;
	
			},
	
			getWorldDirection: function () {
	
				var quaternion = new Quaternion();
	
				return function getWorldDirection( optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					this.getWorldQuaternion( quaternion );
	
					return result.set( 0, 0, - 1 ).applyQuaternion( quaternion );
	
				};
	
			}(),
	
			updateMatrixWorld: function ( force ) {
	
				Object3D.prototype.updateMatrixWorld.call( this, force );
	
				this.matrixWorldInverse.getInverse( this.matrixWorld );
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author arose / http://github.com/arose
		 */
	
		function OrthographicCamera( left, right, top, bottom, near, far ) {
	
			Camera.call( this );
	
			this.type = 'OrthographicCamera';
	
			this.zoom = 1;
			this.view = null;
	
			this.left = left;
			this.right = right;
			this.top = top;
			this.bottom = bottom;
	
			this.near = ( near !== undefined ) ? near : 0.1;
			this.far = ( far !== undefined ) ? far : 2000;
	
			this.updateProjectionMatrix();
	
		}
	
		OrthographicCamera.prototype = Object.assign( Object.create( Camera.prototype ), {
	
			constructor: OrthographicCamera,
	
			isOrthographicCamera: true,
	
			copy: function ( source, recursive ) {
	
				Camera.prototype.copy.call( this, source, recursive );
	
				this.left = source.left;
				this.right = source.right;
				this.top = source.top;
				this.bottom = source.bottom;
				this.near = source.near;
				this.far = source.far;
	
				this.zoom = source.zoom;
				this.view = source.view === null ? null : Object.assign( {}, source.view );
	
				return this;
	
			},
	
			setViewOffset: function( fullWidth, fullHeight, x, y, width, height ) {
	
				this.view = {
					fullWidth: fullWidth,
					fullHeight: fullHeight,
					offsetX: x,
					offsetY: y,
					width: width,
					height: height
				};
	
				this.updateProjectionMatrix();
	
			},
	
			clearViewOffset: function() {
	
				this.view = null;
				this.updateProjectionMatrix();
	
			},
	
			updateProjectionMatrix: function () {
	
				var dx = ( this.right - this.left ) / ( 2 * this.zoom );
				var dy = ( this.top - this.bottom ) / ( 2 * this.zoom );
				var cx = ( this.right + this.left ) / 2;
				var cy = ( this.top + this.bottom ) / 2;
	
				var left = cx - dx;
				var right = cx + dx;
				var top = cy + dy;
				var bottom = cy - dy;
	
				if ( this.view !== null ) {
	
					var zoomW = this.zoom / ( this.view.width / this.view.fullWidth );
					var zoomH = this.zoom / ( this.view.height / this.view.fullHeight );
					var scaleW = ( this.right - this.left ) / this.view.width;
					var scaleH = ( this.top - this.bottom ) / this.view.height;
	
					left += scaleW * ( this.view.offsetX / zoomW );
					right = left + scaleW * ( this.view.width / zoomW );
					top -= scaleH * ( this.view.offsetY / zoomH );
					bottom = top - scaleH * ( this.view.height / zoomH );
	
				}
	
				this.projectionMatrix.makeOrthographic( left, right, top, bottom, this.near, this.far );
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.zoom = this.zoom;
				data.object.left = this.left;
				data.object.right = this.right;
				data.object.top = this.top;
				data.object.bottom = this.bottom;
				data.object.near = this.near;
				data.object.far = this.far;
	
				if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author greggman / http://games.greggman.com/
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author tschw
		 */
	
		function PerspectiveCamera( fov, aspect, near, far ) {
	
			Camera.call( this );
	
			this.type = 'PerspectiveCamera';
	
			this.fov = fov !== undefined ? fov : 50;
			this.zoom = 1;
	
			this.near = near !== undefined ? near : 0.1;
			this.far = far !== undefined ? far : 2000;
			this.focus = 10;
	
			this.aspect = aspect !== undefined ? aspect : 1;
			this.view = null;
	
			this.filmGauge = 35;	// width of the film (default in millimeters)
			this.filmOffset = 0;	// horizontal film offset (same unit as gauge)
	
			this.updateProjectionMatrix();
	
		}
	
		PerspectiveCamera.prototype = Object.assign( Object.create( Camera.prototype ), {
	
			constructor: PerspectiveCamera,
	
			isPerspectiveCamera: true,
	
			copy: function ( source, recursive ) {
	
				Camera.prototype.copy.call( this, source, recursive );
	
				this.fov = source.fov;
				this.zoom = source.zoom;
	
				this.near = source.near;
				this.far = source.far;
				this.focus = source.focus;
	
				this.aspect = source.aspect;
				this.view = source.view === null ? null : Object.assign( {}, source.view );
	
				this.filmGauge = source.filmGauge;
				this.filmOffset = source.filmOffset;
	
				return this;
	
			},
	
			/**
			 * Sets the FOV by focal length in respect to the current .filmGauge.
			 *
			 * The default film gauge is 35, so that the focal length can be specified for
			 * a 35mm (full frame) camera.
			 *
			 * Values for focal length and film gauge must have the same unit.
			 */
			setFocalLength: function ( focalLength ) {
	
				// see http://www.bobatkins.com/photography/technical/field_of_view.html
				var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
	
				this.fov = _Math.RAD2DEG * 2 * Math.atan( vExtentSlope );
				this.updateProjectionMatrix();
	
			},
	
			/**
			 * Calculates the focal length from the current .fov and .filmGauge.
			 */
			getFocalLength: function () {
	
				var vExtentSlope = Math.tan( _Math.DEG2RAD * 0.5 * this.fov );
	
				return 0.5 * this.getFilmHeight() / vExtentSlope;
	
			},
	
			getEffectiveFOV: function () {
	
				return _Math.RAD2DEG * 2 * Math.atan(
						Math.tan( _Math.DEG2RAD * 0.5 * this.fov ) / this.zoom );
	
			},
	
			getFilmWidth: function () {
	
				// film not completely covered in portrait format (aspect < 1)
				return this.filmGauge * Math.min( this.aspect, 1 );
	
			},
	
			getFilmHeight: function () {
	
				// film not completely covered in landscape format (aspect > 1)
				return this.filmGauge / Math.max( this.aspect, 1 );
	
			},
	
			/**
			 * Sets an offset in a larger frustum. This is useful for multi-window or
			 * multi-monitor/multi-machine setups.
			 *
			 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
			 * the monitors are in grid like this
			 *
			 *   +---+---+---+
			 *   | A | B | C |
			 *   +---+---+---+
			 *   | D | E | F |
			 *   +---+---+---+
			 *
			 * then for each monitor you would call it like this
			 *
			 *   var w = 1920;
			 *   var h = 1080;
			 *   var fullWidth = w * 3;
			 *   var fullHeight = h * 2;
			 *
			 *   --A--
			 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
			 *   --B--
			 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
			 *   --C--
			 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
			 *   --D--
			 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
			 *   --E--
			 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
			 *   --F--
			 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
			 *
			 *   Note there is no reason monitors have to be the same size or in a grid.
			 */
			setViewOffset: function ( fullWidth, fullHeight, x, y, width, height ) {
	
				this.aspect = fullWidth / fullHeight;
	
				this.view = {
					fullWidth: fullWidth,
					fullHeight: fullHeight,
					offsetX: x,
					offsetY: y,
					width: width,
					height: height
				};
	
				this.updateProjectionMatrix();
	
			},
	
			clearViewOffset: function () {
	
				this.view = null;
				this.updateProjectionMatrix();
	
			},
	
			updateProjectionMatrix: function () {
	
				var near = this.near,
					top = near * Math.tan(
							_Math.DEG2RAD * 0.5 * this.fov ) / this.zoom,
					height = 2 * top,
					width = this.aspect * height,
					left = - 0.5 * width,
					view = this.view;
	
				if ( view !== null ) {
	
					var fullWidth = view.fullWidth,
						fullHeight = view.fullHeight;
	
					left += view.offsetX * width / fullWidth;
					top -= view.offsetY * height / fullHeight;
					width *= view.width / fullWidth;
					height *= view.height / fullHeight;
	
				}
	
				var skew = this.filmOffset;
				if ( skew !== 0 ) left += near * skew / this.getFilmWidth();
	
				this.projectionMatrix.makePerspective( left, left + width, top, top - height, near, this.far );
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.fov = this.fov;
				data.object.zoom = this.zoom;
	
				data.object.near = this.near;
				data.object.far = this.far;
				data.object.focus = this.focus;
	
				data.object.aspect = this.aspect;
	
				if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );
	
				data.object.filmGauge = this.filmGauge;
				data.object.filmOffset = this.filmOffset;
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Face3( a, b, c, normal, color, materialIndex ) {
	
			this.a = a;
			this.b = b;
			this.c = c;
	
			this.normal = ( normal && normal.isVector3 ) ? normal : new Vector3();
			this.vertexNormals = Array.isArray( normal ) ? normal : [];
	
			this.color = ( color && color.isColor ) ? color : new Color();
			this.vertexColors = Array.isArray( color ) ? color : [];
	
			this.materialIndex = materialIndex !== undefined ? materialIndex : 0;
	
		}
	
		Object.assign( Face3.prototype, {
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.a = source.a;
				this.b = source.b;
				this.c = source.c;
	
				this.normal.copy( source.normal );
				this.color.copy( source.color );
	
				this.materialIndex = source.materialIndex;
	
				for ( var i = 0, il = source.vertexNormals.length; i < il; i ++ ) {
	
					this.vertexNormals[ i ] = source.vertexNormals[ i ].clone();
	
				}
	
				for ( var i = 0, il = source.vertexColors.length; i < il; i ++ ) {
	
					this.vertexColors[ i ] = source.vertexColors[ i ].clone();
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author kile / http://kile.stravaganza.org/
		 * @author alteredq / http://alteredqualia.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author bhouston / http://clara.io
		 */
	
		var count = 0;
		function GeometryIdCount() { return count++; }
	
		function Geometry() {
	
			Object.defineProperty( this, 'id', { value: GeometryIdCount() } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'Geometry';
	
			this.vertices = [];
			this.colors = [];
			this.faces = [];
			this.faceVertexUvs = [[]];
	
			this.morphTargets = [];
			this.morphNormals = [];
	
			this.skinWeights = [];
			this.skinIndices = [];
	
			this.lineDistances = [];
	
			this.boundingBox = null;
			this.boundingSphere = null;
	
			// update flags
	
			this.elementsNeedUpdate = false;
			this.verticesNeedUpdate = false;
			this.uvsNeedUpdate = false;
			this.normalsNeedUpdate = false;
			this.colorsNeedUpdate = false;
			this.lineDistancesNeedUpdate = false;
			this.groupsNeedUpdate = false;
	
		}
	
		Object.assign( Geometry.prototype, EventDispatcher.prototype, {
	
			isGeometry: true,
	
			applyMatrix: function ( matrix ) {
	
				var normalMatrix = new Matrix3().getNormalMatrix( matrix );
	
				for ( var i = 0, il = this.vertices.length; i < il; i ++ ) {
	
					var vertex = this.vertices[ i ];
					vertex.applyMatrix4( matrix );
	
				}
	
				for ( var i = 0, il = this.faces.length; i < il; i ++ ) {
	
					var face = this.faces[ i ];
					face.normal.applyMatrix3( normalMatrix ).normalize();
	
					for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {
	
						face.vertexNormals[ j ].applyMatrix3( normalMatrix ).normalize();
	
					}
	
				}
	
				if ( this.boundingBox !== null ) {
	
					this.computeBoundingBox();
	
				}
	
				if ( this.boundingSphere !== null ) {
	
					this.computeBoundingSphere();
	
				}
	
				this.verticesNeedUpdate = true;
				this.normalsNeedUpdate = true;
	
				return this;
	
			},
	
			rotateX: function () {
	
				// rotate geometry around world x-axis
	
				var m1 = new Matrix4();
	
				return function rotateX( angle ) {
	
					m1.makeRotationX( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateY: function () {
	
				// rotate geometry around world y-axis
	
				var m1 = new Matrix4();
	
				return function rotateY( angle ) {
	
					m1.makeRotationY( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateZ: function () {
	
				// rotate geometry around world z-axis
	
				var m1 = new Matrix4();
	
				return function rotateZ( angle ) {
	
					m1.makeRotationZ( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			translate: function () {
	
				// translate geometry
	
				var m1 = new Matrix4();
	
				return function translate( x, y, z ) {
	
					m1.makeTranslation( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			scale: function () {
	
				// scale geometry
	
				var m1 = new Matrix4();
	
				return function scale( x, y, z ) {
	
					m1.makeScale( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			lookAt: function () {
	
				var obj = new Object3D();
	
				return function lookAt( vector ) {
	
					obj.lookAt( vector );
	
					obj.updateMatrix();
	
					this.applyMatrix( obj.matrix );
	
				};
	
			}(),
	
			fromBufferGeometry: function ( geometry ) {
	
				var scope = this;
	
				var indices = geometry.index !== null ? geometry.index.array : undefined;
				var attributes = geometry.attributes;
	
				var positions = attributes.position.array;
				var normals = attributes.normal !== undefined ? attributes.normal.array : undefined;
				var colors = attributes.color !== undefined ? attributes.color.array : undefined;
				var uvs = attributes.uv !== undefined ? attributes.uv.array : undefined;
				var uvs2 = attributes.uv2 !== undefined ? attributes.uv2.array : undefined;
	
				if ( uvs2 !== undefined ) this.faceVertexUvs[ 1 ] = [];
	
				var tempNormals = [];
				var tempUVs = [];
				var tempUVs2 = [];
	
				for ( var i = 0, j = 0; i < positions.length; i += 3, j += 2 ) {
	
					scope.vertices.push( new Vector3( positions[ i ], positions[ i + 1 ], positions[ i + 2 ] ) );
	
					if ( normals !== undefined ) {
	
						tempNormals.push( new Vector3( normals[ i ], normals[ i + 1 ], normals[ i + 2 ] ) );
	
					}
	
					if ( colors !== undefined ) {
	
						scope.colors.push( new Color( colors[ i ], colors[ i + 1 ], colors[ i + 2 ] ) );
	
					}
	
					if ( uvs !== undefined ) {
	
						tempUVs.push( new Vector2( uvs[ j ], uvs[ j + 1 ] ) );
	
					}
	
					if ( uvs2 !== undefined ) {
	
						tempUVs2.push( new Vector2( uvs2[ j ], uvs2[ j + 1 ] ) );
	
					}
	
				}
	
				function addFace( a, b, c, materialIndex ) {
	
					var vertexNormals = normals !== undefined ? [ tempNormals[ a ].clone(), tempNormals[ b ].clone(), tempNormals[ c ].clone() ] : [];
					var vertexColors = colors !== undefined ? [ scope.colors[ a ].clone(), scope.colors[ b ].clone(), scope.colors[ c ].clone() ] : [];
	
					var face = new Face3( a, b, c, vertexNormals, vertexColors, materialIndex );
	
					scope.faces.push( face );
	
					if ( uvs !== undefined ) {
	
						scope.faceVertexUvs[ 0 ].push( [ tempUVs[ a ].clone(), tempUVs[ b ].clone(), tempUVs[ c ].clone() ] );
	
					}
	
					if ( uvs2 !== undefined ) {
	
						scope.faceVertexUvs[ 1 ].push( [ tempUVs2[ a ].clone(), tempUVs2[ b ].clone(), tempUVs2[ c ].clone() ] );
	
					}
	
				}
	
				var groups = geometry.groups;
	
				if ( groups.length > 0 ) {
	
					for ( var i = 0; i < groups.length; i ++ ) {
	
						var group = groups[ i ];
	
						var start = group.start;
						var count = group.count;
	
						for ( var j = start, jl = start + count; j < jl; j += 3 ) {
	
							if ( indices !== undefined ) {
	
								addFace( indices[ j ], indices[ j + 1 ], indices[ j + 2 ], group.materialIndex );
	
							} else {
	
								addFace( j, j + 1, j + 2, group.materialIndex );
	
							}
	
						}
	
					}
	
				} else {
	
					if ( indices !== undefined ) {
	
						for ( var i = 0; i < indices.length; i += 3 ) {
	
							addFace( indices[ i ], indices[ i + 1 ], indices[ i + 2 ] );
	
						}
	
					} else {
	
						for ( var i = 0; i < positions.length / 3; i += 3 ) {
	
							addFace( i, i + 1, i + 2 );
	
						}
	
					}
	
				}
	
				this.computeFaceNormals();
	
				if ( geometry.boundingBox !== null ) {
	
					this.boundingBox = geometry.boundingBox.clone();
	
				}
	
				if ( geometry.boundingSphere !== null ) {
	
					this.boundingSphere = geometry.boundingSphere.clone();
	
				}
	
				return this;
	
			},
	
			center: function () {
	
				this.computeBoundingBox();
	
				var offset = this.boundingBox.getCenter().negate();
	
				this.translate( offset.x, offset.y, offset.z );
	
				return offset;
	
			},
	
			normalize: function () {
	
				this.computeBoundingSphere();
	
				var center = this.boundingSphere.center;
				var radius = this.boundingSphere.radius;
	
				var s = radius === 0 ? 1 : 1.0 / radius;
	
				var matrix = new Matrix4();
				matrix.set(
					s, 0, 0, - s * center.x,
					0, s, 0, - s * center.y,
					0, 0, s, - s * center.z,
					0, 0, 0, 1
				);
	
				this.applyMatrix( matrix );
	
				return this;
	
			},
	
			computeFaceNormals: function () {
	
				var cb = new Vector3(), ab = new Vector3();
	
				for ( var f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					var face = this.faces[ f ];
	
					var vA = this.vertices[ face.a ];
					var vB = this.vertices[ face.b ];
					var vC = this.vertices[ face.c ];
	
					cb.subVectors( vC, vB );
					ab.subVectors( vA, vB );
					cb.cross( ab );
	
					cb.normalize();
	
					face.normal.copy( cb );
	
				}
	
			},
	
			computeVertexNormals: function ( areaWeighted ) {
	
				if ( areaWeighted === undefined ) areaWeighted = true;
	
				var v, vl, f, fl, face, vertices;
	
				vertices = new Array( this.vertices.length );
	
				for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {
	
					vertices[ v ] = new Vector3();
	
				}
	
				if ( areaWeighted ) {
	
					// vertex normals weighted by triangle areas
					// http://www.iquilezles.org/www/articles/normals/normals.htm
	
					var vA, vB, vC;
					var cb = new Vector3(), ab = new Vector3();
	
					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
						face = this.faces[ f ];
	
						vA = this.vertices[ face.a ];
						vB = this.vertices[ face.b ];
						vC = this.vertices[ face.c ];
	
						cb.subVectors( vC, vB );
						ab.subVectors( vA, vB );
						cb.cross( ab );
	
						vertices[ face.a ].add( cb );
						vertices[ face.b ].add( cb );
						vertices[ face.c ].add( cb );
	
					}
	
				} else {
	
					this.computeFaceNormals();
	
					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
						face = this.faces[ f ];
	
						vertices[ face.a ].add( face.normal );
						vertices[ face.b ].add( face.normal );
						vertices[ face.c ].add( face.normal );
	
					}
	
				}
	
				for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {
	
					vertices[ v ].normalize();
	
				}
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					var vertexNormals = face.vertexNormals;
	
					if ( vertexNormals.length === 3 ) {
	
						vertexNormals[ 0 ].copy( vertices[ face.a ] );
						vertexNormals[ 1 ].copy( vertices[ face.b ] );
						vertexNormals[ 2 ].copy( vertices[ face.c ] );
	
					} else {
	
						vertexNormals[ 0 ] = vertices[ face.a ].clone();
						vertexNormals[ 1 ] = vertices[ face.b ].clone();
						vertexNormals[ 2 ] = vertices[ face.c ].clone();
	
					}
	
				}
	
				if ( this.faces.length > 0 ) {
	
					this.normalsNeedUpdate = true;
	
				}
	
			},
	
			computeFlatVertexNormals: function () {
	
				var f, fl, face;
	
				this.computeFaceNormals();
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					var vertexNormals = face.vertexNormals;
	
					if ( vertexNormals.length === 3 ) {
	
						vertexNormals[ 0 ].copy( face.normal );
						vertexNormals[ 1 ].copy( face.normal );
						vertexNormals[ 2 ].copy( face.normal );
	
					} else {
	
						vertexNormals[ 0 ] = face.normal.clone();
						vertexNormals[ 1 ] = face.normal.clone();
						vertexNormals[ 2 ] = face.normal.clone();
	
					}
	
				}
	
				if ( this.faces.length > 0 ) {
	
					this.normalsNeedUpdate = true;
	
				}
	
			},
	
			computeMorphNormals: function () {
	
				var i, il, f, fl, face;
	
				// save original normals
				// - create temp variables on first access
				//   otherwise just copy (for faster repeated calls)
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					if ( ! face.__originalFaceNormal ) {
	
						face.__originalFaceNormal = face.normal.clone();
	
					} else {
	
						face.__originalFaceNormal.copy( face.normal );
	
					}
	
					if ( ! face.__originalVertexNormals ) face.__originalVertexNormals = [];
	
					for ( i = 0, il = face.vertexNormals.length; i < il; i ++ ) {
	
						if ( ! face.__originalVertexNormals[ i ] ) {
	
							face.__originalVertexNormals[ i ] = face.vertexNormals[ i ].clone();
	
						} else {
	
							face.__originalVertexNormals[ i ].copy( face.vertexNormals[ i ] );
	
						}
	
					}
	
				}
	
				// use temp geometry to compute face and vertex normals for each morph
	
				var tmpGeo = new Geometry();
				tmpGeo.faces = this.faces;
	
				for ( i = 0, il = this.morphTargets.length; i < il; i ++ ) {
	
					// create on first access
	
					if ( ! this.morphNormals[ i ] ) {
	
						this.morphNormals[ i ] = {};
						this.morphNormals[ i ].faceNormals = [];
						this.morphNormals[ i ].vertexNormals = [];
	
						var dstNormalsFace = this.morphNormals[ i ].faceNormals;
						var dstNormalsVertex = this.morphNormals[ i ].vertexNormals;
	
						var faceNormal, vertexNormals;
	
						for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
							faceNormal = new Vector3();
							vertexNormals = { a: new Vector3(), b: new Vector3(), c: new Vector3() };
	
							dstNormalsFace.push( faceNormal );
							dstNormalsVertex.push( vertexNormals );
	
						}
	
					}
	
					var morphNormals = this.morphNormals[ i ];
	
					// set vertices to morph target
	
					tmpGeo.vertices = this.morphTargets[ i ].vertices;
	
					// compute morph normals
	
					tmpGeo.computeFaceNormals();
					tmpGeo.computeVertexNormals();
	
					// store morph normals
	
					var faceNormal, vertexNormals;
	
					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
						face = this.faces[ f ];
	
						faceNormal = morphNormals.faceNormals[ f ];
						vertexNormals = morphNormals.vertexNormals[ f ];
	
						faceNormal.copy( face.normal );
	
						vertexNormals.a.copy( face.vertexNormals[ 0 ] );
						vertexNormals.b.copy( face.vertexNormals[ 1 ] );
						vertexNormals.c.copy( face.vertexNormals[ 2 ] );
	
					}
	
				}
	
				// restore original normals
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					face.normal = face.__originalFaceNormal;
					face.vertexNormals = face.__originalVertexNormals;
	
				}
	
			},
	
			computeLineDistances: function () {
	
				var d = 0;
				var vertices = this.vertices;
	
				for ( var i = 0, il = vertices.length; i < il; i ++ ) {
	
					if ( i > 0 ) {
	
						d += vertices[ i ].distanceTo( vertices[ i - 1 ] );
	
					}
	
					this.lineDistances[ i ] = d;
	
				}
	
			},
	
			computeBoundingBox: function () {
	
				if ( this.boundingBox === null ) {
	
					this.boundingBox = new Box3();
	
				}
	
				this.boundingBox.setFromPoints( this.vertices );
	
			},
	
			computeBoundingSphere: function () {
	
				if ( this.boundingSphere === null ) {
	
					this.boundingSphere = new Sphere();
	
				}
	
				this.boundingSphere.setFromPoints( this.vertices );
	
			},
	
			merge: function ( geometry, matrix, materialIndexOffset ) {
	
				if ( ! ( geometry && geometry.isGeometry ) ) {
	
					console.error( 'THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.', geometry );
					return;
	
				}
	
				var normalMatrix,
					vertexOffset = this.vertices.length,
					vertices1 = this.vertices,
					vertices2 = geometry.vertices,
					faces1 = this.faces,
					faces2 = geometry.faces,
					uvs1 = this.faceVertexUvs[ 0 ],
					uvs2 = geometry.faceVertexUvs[ 0 ],
					colors1 = this.colors,
					colors2 = geometry.colors;
	
				if ( materialIndexOffset === undefined ) materialIndexOffset = 0;
	
				if ( matrix !== undefined ) {
	
					normalMatrix = new Matrix3().getNormalMatrix( matrix );
	
				}
	
				// vertices
	
				for ( var i = 0, il = vertices2.length; i < il; i ++ ) {
	
					var vertex = vertices2[ i ];
	
					var vertexCopy = vertex.clone();
	
					if ( matrix !== undefined ) vertexCopy.applyMatrix4( matrix );
	
					vertices1.push( vertexCopy );
	
				}
	
				// colors
	
				for ( var i = 0, il = colors2.length; i < il; i ++ ) {
	
					colors1.push( colors2[ i ].clone() );
	
				}
	
				// faces
	
				for ( i = 0, il = faces2.length; i < il; i ++ ) {
	
					var face = faces2[ i ], faceCopy, normal, color,
						faceVertexNormals = face.vertexNormals,
						faceVertexColors = face.vertexColors;
	
					faceCopy = new Face3( face.a + vertexOffset, face.b + vertexOffset, face.c + vertexOffset );
					faceCopy.normal.copy( face.normal );
	
					if ( normalMatrix !== undefined ) {
	
						faceCopy.normal.applyMatrix3( normalMatrix ).normalize();
	
					}
	
					for ( var j = 0, jl = faceVertexNormals.length; j < jl; j ++ ) {
	
						normal = faceVertexNormals[ j ].clone();
	
						if ( normalMatrix !== undefined ) {
	
							normal.applyMatrix3( normalMatrix ).normalize();
	
						}
	
						faceCopy.vertexNormals.push( normal );
	
					}
	
					faceCopy.color.copy( face.color );
	
					for ( var j = 0, jl = faceVertexColors.length; j < jl; j ++ ) {
	
						color = faceVertexColors[ j ];
						faceCopy.vertexColors.push( color.clone() );
	
					}
	
					faceCopy.materialIndex = face.materialIndex + materialIndexOffset;
	
					faces1.push( faceCopy );
	
				}
	
				// uvs
	
				for ( i = 0, il = uvs2.length; i < il; i ++ ) {
	
					var uv = uvs2[ i ], uvCopy = [];
	
					if ( uv === undefined ) {
	
						continue;
	
					}
	
					for ( var j = 0, jl = uv.length; j < jl; j ++ ) {
	
						uvCopy.push( uv[ j ].clone() );
	
					}
	
					uvs1.push( uvCopy );
	
				}
	
			},
	
			mergeMesh: function ( mesh ) {
	
				if ( ! ( mesh && mesh.isMesh ) ) {
	
					console.error( 'THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.', mesh );
					return;
	
				}
	
				mesh.matrixAutoUpdate && mesh.updateMatrix();
	
				this.merge( mesh.geometry, mesh.matrix );
	
			},
	
			/*
			 * Checks for duplicate vertices with hashmap.
			 * Duplicated vertices are removed
			 * and faces' vertices are updated.
			 */
	
			mergeVertices: function () {
	
				var verticesMap = {}; // Hashmap for looking up vertices by position coordinates (and making sure they are unique)
				var unique = [], changes = [];
	
				var v, key;
				var precisionPoints = 4; // number of decimal points, e.g. 4 for epsilon of 0.0001
				var precision = Math.pow( 10, precisionPoints );
				var i, il, face;
				var indices, j, jl;
	
				for ( i = 0, il = this.vertices.length; i < il; i ++ ) {
	
					v = this.vertices[ i ];
					key = Math.round( v.x * precision ) + '_' + Math.round( v.y * precision ) + '_' + Math.round( v.z * precision );
	
					if ( verticesMap[ key ] === undefined ) {
	
						verticesMap[ key ] = i;
						unique.push( this.vertices[ i ] );
						changes[ i ] = unique.length - 1;
	
					} else {
	
						//console.log('Duplicate vertex found. ', i, ' could be using ', verticesMap[key]);
						changes[ i ] = changes[ verticesMap[ key ] ];
	
					}
	
				}
	
	
				// if faces are completely degenerate after merging vertices, we
				// have to remove them from the geometry.
				var faceIndicesToRemove = [];
	
				for ( i = 0, il = this.faces.length; i < il; i ++ ) {
	
					face = this.faces[ i ];
	
					face.a = changes[ face.a ];
					face.b = changes[ face.b ];
					face.c = changes[ face.c ];
	
					indices = [ face.a, face.b, face.c ];
	
					// if any duplicate vertices are found in a Face3
					// we have to remove the face as nothing can be saved
					for ( var n = 0; n < 3; n ++ ) {
	
						if ( indices[ n ] === indices[ ( n + 1 ) % 3 ] ) {
	
							faceIndicesToRemove.push( i );
							break;
	
						}
	
					}
	
				}
	
				for ( i = faceIndicesToRemove.length - 1; i >= 0; i -- ) {
	
					var idx = faceIndicesToRemove[ i ];
	
					this.faces.splice( idx, 1 );
	
					for ( j = 0, jl = this.faceVertexUvs.length; j < jl; j ++ ) {
	
						this.faceVertexUvs[ j ].splice( idx, 1 );
	
					}
	
				}
	
				// Use unique set of vertices
	
				var diff = this.vertices.length - unique.length;
				this.vertices = unique;
				return diff;
	
			},
	
			sortFacesByMaterialIndex: function () {
	
				var faces = this.faces;
				var length = faces.length;
	
				// tag faces
	
				for ( var i = 0; i < length; i ++ ) {
	
					faces[ i ]._id = i;
	
				}
	
				// sort faces
	
				function materialIndexSort( a, b ) {
	
					return a.materialIndex - b.materialIndex;
	
				}
	
				faces.sort( materialIndexSort );
	
				// sort uvs
	
				var uvs1 = this.faceVertexUvs[ 0 ];
				var uvs2 = this.faceVertexUvs[ 1 ];
	
				var newUvs1, newUvs2;
	
				if ( uvs1 && uvs1.length === length ) newUvs1 = [];
				if ( uvs2 && uvs2.length === length ) newUvs2 = [];
	
				for ( var i = 0; i < length; i ++ ) {
	
					var id = faces[ i ]._id;
	
					if ( newUvs1 ) newUvs1.push( uvs1[ id ] );
					if ( newUvs2 ) newUvs2.push( uvs2[ id ] );
	
				}
	
				if ( newUvs1 ) this.faceVertexUvs[ 0 ] = newUvs1;
				if ( newUvs2 ) this.faceVertexUvs[ 1 ] = newUvs2;
	
			},
	
			toJSON: function () {
	
				var data = {
					metadata: {
						version: 4.5,
						type: 'Geometry',
						generator: 'Geometry.toJSON'
					}
				};
	
				// standard Geometry serialization
	
				data.uuid = this.uuid;
				data.type = this.type;
				if ( this.name !== '' ) data.name = this.name;
	
				if ( this.parameters !== undefined ) {
	
					var parameters = this.parameters;
	
					for ( var key in parameters ) {
	
						if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];
	
					}
	
					return data;
	
				}
	
				var vertices = [];
	
				for ( var i = 0; i < this.vertices.length; i ++ ) {
	
					var vertex = this.vertices[ i ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
				var faces = [];
				var normals = [];
				var normalsHash = {};
				var colors = [];
				var colorsHash = {};
				var uvs = [];
				var uvsHash = {};
	
				for ( var i = 0; i < this.faces.length; i ++ ) {
	
					var face = this.faces[ i ];
	
					var hasMaterial = true;
					var hasFaceUv = false; // deprecated
					var hasFaceVertexUv = this.faceVertexUvs[ 0 ][ i ] !== undefined;
					var hasFaceNormal = face.normal.length() > 0;
					var hasFaceVertexNormal = face.vertexNormals.length > 0;
					var hasFaceColor = face.color.r !== 1 || face.color.g !== 1 || face.color.b !== 1;
					var hasFaceVertexColor = face.vertexColors.length > 0;
	
					var faceType = 0;
	
					faceType = setBit( faceType, 0, 0 ); // isQuad
					faceType = setBit( faceType, 1, hasMaterial );
					faceType = setBit( faceType, 2, hasFaceUv );
					faceType = setBit( faceType, 3, hasFaceVertexUv );
					faceType = setBit( faceType, 4, hasFaceNormal );
					faceType = setBit( faceType, 5, hasFaceVertexNormal );
					faceType = setBit( faceType, 6, hasFaceColor );
					faceType = setBit( faceType, 7, hasFaceVertexColor );
	
					faces.push( faceType );
					faces.push( face.a, face.b, face.c );
					faces.push( face.materialIndex );
	
					if ( hasFaceVertexUv ) {
	
						var faceVertexUvs = this.faceVertexUvs[ 0 ][ i ];
	
						faces.push(
							getUvIndex( faceVertexUvs[ 0 ] ),
							getUvIndex( faceVertexUvs[ 1 ] ),
							getUvIndex( faceVertexUvs[ 2 ] )
						);
	
					}
	
					if ( hasFaceNormal ) {
	
						faces.push( getNormalIndex( face.normal ) );
	
					}
	
					if ( hasFaceVertexNormal ) {
	
						var vertexNormals = face.vertexNormals;
	
						faces.push(
							getNormalIndex( vertexNormals[ 0 ] ),
							getNormalIndex( vertexNormals[ 1 ] ),
							getNormalIndex( vertexNormals[ 2 ] )
						);
	
					}
	
					if ( hasFaceColor ) {
	
						faces.push( getColorIndex( face.color ) );
	
					}
	
					if ( hasFaceVertexColor ) {
	
						var vertexColors = face.vertexColors;
	
						faces.push(
							getColorIndex( vertexColors[ 0 ] ),
							getColorIndex( vertexColors[ 1 ] ),
							getColorIndex( vertexColors[ 2 ] )
						);
	
					}
	
				}
	
				function setBit( value, position, enabled ) {
	
					return enabled ? value | ( 1 << position ) : value & ( ~ ( 1 << position ) );
	
				}
	
				function getNormalIndex( normal ) {
	
					var hash = normal.x.toString() + normal.y.toString() + normal.z.toString();
	
					if ( normalsHash[ hash ] !== undefined ) {
	
						return normalsHash[ hash ];
	
					}
	
					normalsHash[ hash ] = normals.length / 3;
					normals.push( normal.x, normal.y, normal.z );
	
					return normalsHash[ hash ];
	
				}
	
				function getColorIndex( color ) {
	
					var hash = color.r.toString() + color.g.toString() + color.b.toString();
	
					if ( colorsHash[ hash ] !== undefined ) {
	
						return colorsHash[ hash ];
	
					}
	
					colorsHash[ hash ] = colors.length;
					colors.push( color.getHex() );
	
					return colorsHash[ hash ];
	
				}
	
				function getUvIndex( uv ) {
	
					var hash = uv.x.toString() + uv.y.toString();
	
					if ( uvsHash[ hash ] !== undefined ) {
	
						return uvsHash[ hash ];
	
					}
	
					uvsHash[ hash ] = uvs.length / 2;
					uvs.push( uv.x, uv.y );
	
					return uvsHash[ hash ];
	
				}
	
				data.data = {};
	
				data.data.vertices = vertices;
				data.data.normals = normals;
				if ( colors.length > 0 ) data.data.colors = colors;
				if ( uvs.length > 0 ) data.data.uvs = [ uvs ]; // temporal backward compatibility
				data.data.faces = faces;
	
				return data;
	
			},
	
			clone: function () {
	
				/*
				 // Handle primitives
	
				 var parameters = this.parameters;
	
				 if ( parameters !== undefined ) {
	
				 var values = [];
	
				 for ( var key in parameters ) {
	
				 values.push( parameters[ key ] );
	
				 }
	
				 var geometry = Object.create( this.constructor.prototype );
				 this.constructor.apply( geometry, values );
				 return geometry;
	
				 }
	
				 return new this.constructor().copy( this );
				 */
	
				return new Geometry().copy( this );
	
			},
	
			copy: function ( source ) {
	
				var i, il, j, jl, k, kl;
	
				// reset
	
				this.vertices = [];
				this.colors = [];
				this.faces = [];
				this.faceVertexUvs = [[]];
				this.morphTargets = [];
				this.morphNormals = [];
				this.skinWeights = [];
				this.skinIndices = [];
				this.lineDistances = [];
				this.boundingBox = null;
				this.boundingSphere = null;
	
				// name
	
				this.name = source.name;
	
				// vertices
	
				var vertices = source.vertices;
	
				for ( i = 0, il = vertices.length; i < il; i ++ ) {
	
					this.vertices.push( vertices[ i ].clone() );
	
				}
	
				// colors
	
				var colors = source.colors;
	
				for ( i = 0, il = colors.length; i < il; i ++ ) {
	
					this.colors.push( colors[ i ].clone() );
	
				}
	
				// faces
	
				var faces = source.faces;
	
				for ( i = 0, il = faces.length; i < il; i ++ ) {
	
					this.faces.push( faces[ i ].clone() );
	
				}
	
				// face vertex uvs
	
				for ( i = 0, il = source.faceVertexUvs.length; i < il; i ++ ) {
	
					var faceVertexUvs = source.faceVertexUvs[ i ];
	
					if ( this.faceVertexUvs[ i ] === undefined ) {
	
						this.faceVertexUvs[ i ] = [];
	
					}
	
					for ( j = 0, jl = faceVertexUvs.length; j < jl; j ++ ) {
	
						var uvs = faceVertexUvs[ j ], uvsCopy = [];
	
						for ( k = 0, kl = uvs.length; k < kl; k ++ ) {
	
							var uv = uvs[ k ];
	
							uvsCopy.push( uv.clone() );
	
						}
	
						this.faceVertexUvs[ i ].push( uvsCopy );
	
					}
	
				}
	
				// morph targets
	
				var morphTargets = source.morphTargets;
	
				for ( i = 0, il = morphTargets.length; i < il; i ++ ) {
	
					var morphTarget = {};
					morphTarget.name = morphTargets[ i ].name;
	
					// vertices
	
					if ( morphTargets[ i ].vertices !== undefined ) {
	
						morphTarget.vertices = [];
	
						for ( j = 0, jl = morphTargets[ i ].vertices.length; j < jl; j ++ ) {
	
							morphTarget.vertices.push( morphTargets[ i ].vertices[ j ].clone() );
	
						}
	
					}
	
					// normals
	
					if ( morphTargets[ i ].normals !== undefined ) {
	
						morphTarget.normals = [];
	
						for ( j = 0, jl = morphTargets[ i ].normals.length; j < jl; j ++ ) {
	
							morphTarget.normals.push( morphTargets[ i ].normals[ j ].clone() );
	
						}
	
					}
	
					this.morphTargets.push( morphTarget );
	
				}
	
				// morph normals
	
				var morphNormals = source.morphNormals;
	
				for ( i = 0, il = morphNormals.length; i < il; i ++ ) {
	
					var morphNormal = {};
	
					// vertex normals
	
					if ( morphNormals[ i ].vertexNormals !== undefined ) {
	
						morphNormal.vertexNormals = [];
	
						for ( j = 0, jl = morphNormals[ i ].vertexNormals.length; j < jl; j ++ ) {
	
							var srcVertexNormal = morphNormals[ i ].vertexNormals[ j ];
							var destVertexNormal = {};
	
							destVertexNormal.a = srcVertexNormal.a.clone();
							destVertexNormal.b = srcVertexNormal.b.clone();
							destVertexNormal.c = srcVertexNormal.c.clone();
	
							morphNormal.vertexNormals.push( destVertexNormal );
	
						}
	
					}
	
					// face normals
	
					if ( morphNormals[ i ].faceNormals !== undefined ) {
	
						morphNormal.faceNormals = [];
	
						for ( j = 0, jl = morphNormals[ i ].faceNormals.length; j < jl; j ++ ) {
	
							morphNormal.faceNormals.push( morphNormals[ i ].faceNormals[ j ].clone() );
	
						}
	
					}
	
					this.morphNormals.push( morphNormal );
	
				}
	
				// skin weights
	
				var skinWeights = source.skinWeights;
	
				for ( i = 0, il = skinWeights.length; i < il; i ++ ) {
	
					this.skinWeights.push( skinWeights[ i ].clone() );
	
				}
	
				// skin indices
	
				var skinIndices = source.skinIndices;
	
				for ( i = 0, il = skinIndices.length; i < il; i ++ ) {
	
					this.skinIndices.push( skinIndices[ i ].clone() );
	
				}
	
				// line distances
	
				var lineDistances = source.lineDistances;
	
				for ( i = 0, il = lineDistances.length; i < il; i ++ ) {
	
					this.lineDistances.push( lineDistances[ i ] );
	
				}
	
				// bounding box
	
				var boundingBox = source.boundingBox;
	
				if ( boundingBox !== null ) {
	
					this.boundingBox = boundingBox.clone();
	
				}
	
				// bounding sphere
	
				var boundingSphere = source.boundingSphere;
	
				if ( boundingSphere !== null ) {
	
					this.boundingSphere = boundingSphere.clone();
	
				}
	
				// update flags
	
				this.elementsNeedUpdate = source.elementsNeedUpdate;
				this.verticesNeedUpdate = source.verticesNeedUpdate;
				this.uvsNeedUpdate = source.uvsNeedUpdate;
				this.normalsNeedUpdate = source.normalsNeedUpdate;
				this.colorsNeedUpdate = source.colorsNeedUpdate;
				this.lineDistancesNeedUpdate = source.lineDistancesNeedUpdate;
				this.groupsNeedUpdate = source.groupsNeedUpdate;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function BufferAttribute( array, itemSize, normalized ) {
	
			if ( Array.isArray( array ) ) {
	
				throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );
	
			}
	
			this.uuid = _Math.generateUUID();
			this.name = '';
	
			this.array = array;
			this.itemSize = itemSize;
			this.count = array !== undefined ? array.length / itemSize : 0;
			this.normalized = normalized === true;
	
			this.dynamic = false;
			this.updateRange = { offset: 0, count: - 1 };
	
			this.onUploadCallback = function () {};
	
			this.version = 0;
	
		}
	
		Object.defineProperty( BufferAttribute.prototype, 'needsUpdate', {
	
			set: function ( value ) {
	
				if ( value === true ) this.version ++;
	
			}
	
		} );
	
		Object.assign( BufferAttribute.prototype, {
	
			isBufferAttribute: true,
	
			setArray: function ( array ) {
	
				if ( Array.isArray( array ) ) {
	
					throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );
	
				}
	
				this.count = array !== undefined ? array.length / this.itemSize : 0;
				this.array = array;
	
			},
	
			setDynamic: function ( value ) {
	
				this.dynamic = value;
	
				return this;
	
			},
	
			copy: function ( source ) {
	
				this.array = new source.array.constructor( source.array );
				this.itemSize = source.itemSize;
				this.count = source.count;
				this.normalized = source.normalized;
	
				this.dynamic = source.dynamic;
	
				return this;
	
			},
	
			copyAt: function ( index1, attribute, index2 ) {
	
				index1 *= this.itemSize;
				index2 *= attribute.itemSize;
	
				for ( var i = 0, l = this.itemSize; i < l; i ++ ) {
	
					this.array[ index1 + i ] = attribute.array[ index2 + i ];
	
				}
	
				return this;
	
			},
	
			copyArray: function ( array ) {
	
				this.array.set( array );
	
				return this;
	
			},
	
			copyColorsArray: function ( colors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = colors.length; i < l; i ++ ) {
	
					var color = colors[ i ];
	
					if ( color === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyColorsArray(): color is undefined', i );
						color = new Color();
	
					}
	
					array[ offset ++ ] = color.r;
					array[ offset ++ ] = color.g;
					array[ offset ++ ] = color.b;
	
				}
	
				return this;
	
			},
	
			copyIndicesArray: function ( indices ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = indices.length; i < l; i ++ ) {
	
					var index = indices[ i ];
	
					array[ offset ++ ] = index.a;
					array[ offset ++ ] = index.b;
					array[ offset ++ ] = index.c;
	
				}
	
				return this;
	
			},
	
			copyVector2sArray: function ( vectors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = vectors.length; i < l; i ++ ) {
	
					var vector = vectors[ i ];
	
					if ( vector === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i );
						vector = new Vector2();
	
					}
	
					array[ offset ++ ] = vector.x;
					array[ offset ++ ] = vector.y;
	
				}
	
				return this;
	
			},
	
			copyVector3sArray: function ( vectors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = vectors.length; i < l; i ++ ) {
	
					var vector = vectors[ i ];
	
					if ( vector === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i );
						vector = new Vector3();
	
					}
	
					array[ offset ++ ] = vector.x;
					array[ offset ++ ] = vector.y;
					array[ offset ++ ] = vector.z;
	
				}
	
				return this;
	
			},
	
			copyVector4sArray: function ( vectors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = vectors.length; i < l; i ++ ) {
	
					var vector = vectors[ i ];
	
					if ( vector === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i );
						vector = new Vector4();
	
					}
	
					array[ offset ++ ] = vector.x;
					array[ offset ++ ] = vector.y;
					array[ offset ++ ] = vector.z;
					array[ offset ++ ] = vector.w;
	
				}
	
				return this;
	
			},
	
			set: function ( value, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.array.set( value, offset );
	
				return this;
	
			},
	
			getX: function ( index ) {
	
				return this.array[ index * this.itemSize ];
	
			},
	
			setX: function ( index, x ) {
	
				this.array[ index * this.itemSize ] = x;
	
				return this;
	
			},
	
			getY: function ( index ) {
	
				return this.array[ index * this.itemSize + 1 ];
	
			},
	
			setY: function ( index, y ) {
	
				this.array[ index * this.itemSize + 1 ] = y;
	
				return this;
	
			},
	
			getZ: function ( index ) {
	
				return this.array[ index * this.itemSize + 2 ];
	
			},
	
			setZ: function ( index, z ) {
	
				this.array[ index * this.itemSize + 2 ] = z;
	
				return this;
	
			},
	
			getW: function ( index ) {
	
				return this.array[ index * this.itemSize + 3 ];
	
			},
	
			setW: function ( index, w ) {
	
				this.array[ index * this.itemSize + 3 ] = w;
	
				return this;
	
			},
	
			setXY: function ( index, x, y ) {
	
				index *= this.itemSize;
	
				this.array[ index + 0 ] = x;
				this.array[ index + 1 ] = y;
	
				return this;
	
			},
	
			setXYZ: function ( index, x, y, z ) {
	
				index *= this.itemSize;
	
				this.array[ index + 0 ] = x;
				this.array[ index + 1 ] = y;
				this.array[ index + 2 ] = z;
	
				return this;
	
			},
	
			setXYZW: function ( index, x, y, z, w ) {
	
				index *= this.itemSize;
	
				this.array[ index + 0 ] = x;
				this.array[ index + 1 ] = y;
				this.array[ index + 2 ] = z;
				this.array[ index + 3 ] = w;
	
				return this;
	
			},
	
			onUpload: function ( callback ) {
	
				this.onUploadCallback = callback;
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this.array, this.itemSize ).copy( this );
	
			}
	
		} );
	
		//
	
		function Int8BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Int8Array( array ), itemSize );
	
		}
	
		Int8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Int8BufferAttribute.prototype.constructor = Int8BufferAttribute;
	
	
		function Uint8BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Uint8Array( array ), itemSize );
	
		}
	
		Uint8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint8BufferAttribute.prototype.constructor = Uint8BufferAttribute;
	
	
		function Uint8ClampedBufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Uint8ClampedArray( array ), itemSize );
	
		}
	
		Uint8ClampedBufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint8ClampedBufferAttribute.prototype.constructor = Uint8ClampedBufferAttribute;
	
	
		function Int16BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Int16Array( array ), itemSize );
	
		}
	
		Int16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Int16BufferAttribute.prototype.constructor = Int16BufferAttribute;
	
	
		function Uint16BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Uint16Array( array ), itemSize );
	
		}
	
		Uint16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint16BufferAttribute.prototype.constructor = Uint16BufferAttribute;
	
	
		function Int32BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Int32Array( array ), itemSize );
	
		}
	
		Int32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Int32BufferAttribute.prototype.constructor = Int32BufferAttribute;
	
	
		function Uint32BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Uint32Array( array ), itemSize );
	
		}
	
		Uint32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint32BufferAttribute.prototype.constructor = Uint32BufferAttribute;
	
	
		function Float32BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Float32Array( array ), itemSize );
	
		}
	
		Float32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Float32BufferAttribute.prototype.constructor = Float32BufferAttribute;
	
	
		function Float64BufferAttribute( array, itemSize ) {
	
			BufferAttribute.call( this, new Float64Array( array ), itemSize );
	
		}
	
		Float64BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Float64BufferAttribute.prototype.constructor = Float64BufferAttribute;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function DirectGeometry() {
	
			this.indices = [];
			this.vertices = [];
			this.normals = [];
			this.colors = [];
			this.uvs = [];
			this.uvs2 = [];
	
			this.groups = [];
	
			this.morphTargets = {};
	
			this.skinWeights = [];
			this.skinIndices = [];
	
			// this.lineDistances = [];
	
			this.boundingBox = null;
			this.boundingSphere = null;
	
			// update flags
	
			this.verticesNeedUpdate = false;
			this.normalsNeedUpdate = false;
			this.colorsNeedUpdate = false;
			this.uvsNeedUpdate = false;
			this.groupsNeedUpdate = false;
	
		}
	
		Object.assign( DirectGeometry.prototype, {
	
			computeGroups: function ( geometry ) {
	
				var group;
				var groups = [];
				var materialIndex = undefined;
	
				var faces = geometry.faces;
	
				for ( var i = 0; i < faces.length; i ++ ) {
	
					var face = faces[ i ];
	
					// materials
	
					if ( face.materialIndex !== materialIndex ) {
	
						materialIndex = face.materialIndex;
	
						if ( group !== undefined ) {
	
							group.count = ( i * 3 ) - group.start;
							groups.push( group );
	
						}
	
						group = {
							start: i * 3,
							materialIndex: materialIndex
						};
	
					}
	
				}
	
				if ( group !== undefined ) {
	
					group.count = ( i * 3 ) - group.start;
					groups.push( group );
	
				}
	
				this.groups = groups;
	
			},
	
			fromGeometry: function ( geometry ) {
	
				var faces = geometry.faces;
				var vertices = geometry.vertices;
				var faceVertexUvs = geometry.faceVertexUvs;
	
				var hasFaceVertexUv = faceVertexUvs[ 0 ] && faceVertexUvs[ 0 ].length > 0;
				var hasFaceVertexUv2 = faceVertexUvs[ 1 ] && faceVertexUvs[ 1 ].length > 0;
	
				// morphs
	
				var morphTargets = geometry.morphTargets;
				var morphTargetsLength = morphTargets.length;
	
				var morphTargetsPosition;
	
				if ( morphTargetsLength > 0 ) {
	
					morphTargetsPosition = [];
	
					for ( var i = 0; i < morphTargetsLength; i ++ ) {
	
						morphTargetsPosition[ i ] = [];
	
					}
	
					this.morphTargets.position = morphTargetsPosition;
	
				}
	
				var morphNormals = geometry.morphNormals;
				var morphNormalsLength = morphNormals.length;
	
				var morphTargetsNormal;
	
				if ( morphNormalsLength > 0 ) {
	
					morphTargetsNormal = [];
	
					for ( var i = 0; i < morphNormalsLength; i ++ ) {
	
						morphTargetsNormal[ i ] = [];
	
					}
	
					this.morphTargets.normal = morphTargetsNormal;
	
				}
	
				// skins
	
				var skinIndices = geometry.skinIndices;
				var skinWeights = geometry.skinWeights;
	
				var hasSkinIndices = skinIndices.length === vertices.length;
				var hasSkinWeights = skinWeights.length === vertices.length;
	
				//
	
				for ( var i = 0; i < faces.length; i ++ ) {
	
					var face = faces[ i ];
	
					this.vertices.push( vertices[ face.a ], vertices[ face.b ], vertices[ face.c ] );
	
					var vertexNormals = face.vertexNormals;
	
					if ( vertexNormals.length === 3 ) {
	
						this.normals.push( vertexNormals[ 0 ], vertexNormals[ 1 ], vertexNormals[ 2 ] );
	
					} else {
	
						var normal = face.normal;
	
						this.normals.push( normal, normal, normal );
	
					}
	
					var vertexColors = face.vertexColors;
	
					if ( vertexColors.length === 3 ) {
	
						this.colors.push( vertexColors[ 0 ], vertexColors[ 1 ], vertexColors[ 2 ] );
	
					} else {
	
						var color = face.color;
	
						this.colors.push( color, color, color );
	
					}
	
					if ( hasFaceVertexUv === true ) {
	
						var vertexUvs = faceVertexUvs[ 0 ][ i ];
	
						if ( vertexUvs !== undefined ) {
	
							this.uvs.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );
	
						} else {
	
							console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ', i );
	
							this.uvs.push( new Vector2(), new Vector2(), new Vector2() );
	
						}
	
					}
	
					if ( hasFaceVertexUv2 === true ) {
	
						var vertexUvs = faceVertexUvs[ 1 ][ i ];
	
						if ( vertexUvs !== undefined ) {
	
							this.uvs2.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );
	
						} else {
	
							console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ', i );
	
							this.uvs2.push( new Vector2(), new Vector2(), new Vector2() );
	
						}
	
					}
	
					// morphs
	
					for ( var j = 0; j < morphTargetsLength; j ++ ) {
	
						var morphTarget = morphTargets[ j ].vertices;
	
						morphTargetsPosition[ j ].push( morphTarget[ face.a ], morphTarget[ face.b ], morphTarget[ face.c ] );
	
					}
	
					for ( var j = 0; j < morphNormalsLength; j ++ ) {
	
						var morphNormal = morphNormals[ j ].vertexNormals[ i ];
	
						morphTargetsNormal[ j ].push( morphNormal.a, morphNormal.b, morphNormal.c );
	
					}
	
					// skins
	
					if ( hasSkinIndices ) {
	
						this.skinIndices.push( skinIndices[ face.a ], skinIndices[ face.b ], skinIndices[ face.c ] );
	
					}
	
					if ( hasSkinWeights ) {
	
						this.skinWeights.push( skinWeights[ face.a ], skinWeights[ face.b ], skinWeights[ face.c ] );
	
					}
	
				}
	
				this.computeGroups( geometry );
	
				this.verticesNeedUpdate = geometry.verticesNeedUpdate;
				this.normalsNeedUpdate = geometry.normalsNeedUpdate;
				this.colorsNeedUpdate = geometry.colorsNeedUpdate;
				this.uvsNeedUpdate = geometry.uvsNeedUpdate;
				this.groupsNeedUpdate = geometry.groupsNeedUpdate;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function arrayMax( array ) {
	
			if ( array.length === 0 ) return - Infinity;
	
			var max = array[ 0 ];
	
			for ( var i = 1, l = array.length; i < l; ++ i ) {
	
				if ( array[ i ] > max ) max = array[ i ];
	
			}
	
			return max;
	
		}
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function BufferGeometry() {
	
			Object.defineProperty( this, 'id', { value: GeometryIdCount() } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'BufferGeometry';
	
			this.index = null;
			this.attributes = {};
	
			this.morphAttributes = {};
	
			this.groups = [];
	
			this.boundingBox = null;
			this.boundingSphere = null;
	
			this.drawRange = { start: 0, count: Infinity };
	
		}
	
		BufferGeometry.MaxIndex = 65535;
	
		Object.assign( BufferGeometry.prototype, EventDispatcher.prototype, {
	
			isBufferGeometry: true,
	
			getIndex: function () {
	
				return this.index;
	
			},
	
			setIndex: function ( index ) {
	
				if ( Array.isArray( index ) ) {
	
					this.index = new ( arrayMax( index ) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( index, 1 );
	
				} else {
	
					this.index = index;
	
				}
	
			},
	
			addAttribute: function ( name, attribute ) {
	
				if ( ! ( attribute && attribute.isBufferAttribute ) && ! ( attribute && attribute.isInterleavedBufferAttribute ) ) {
	
					console.warn( 'THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).' );
	
					this.addAttribute( name, new BufferAttribute( arguments[ 1 ], arguments[ 2 ] ) );
	
					return;
	
				}
	
				if ( name === 'index' ) {
	
					console.warn( 'THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.' );
					this.setIndex( attribute );
	
					return;
	
				}
	
				this.attributes[ name ] = attribute;
	
				return this;
	
			},
	
			getAttribute: function ( name ) {
	
				return this.attributes[ name ];
	
			},
	
			removeAttribute: function ( name ) {
	
				delete this.attributes[ name ];
	
				return this;
	
			},
	
			addGroup: function ( start, count, materialIndex ) {
	
				this.groups.push( {
	
					start: start,
					count: count,
					materialIndex: materialIndex !== undefined ? materialIndex : 0
	
				} );
	
			},
	
			clearGroups: function () {
	
				this.groups = [];
	
			},
	
			setDrawRange: function ( start, count ) {
	
				this.drawRange.start = start;
				this.drawRange.count = count;
	
			},
	
			applyMatrix: function ( matrix ) {
	
				var position = this.attributes.position;
	
				if ( position !== undefined ) {
	
					matrix.applyToBufferAttribute( position );
					position.needsUpdate = true;
	
				}
	
				var normal = this.attributes.normal;
	
				if ( normal !== undefined ) {
	
					var normalMatrix = new Matrix3().getNormalMatrix( matrix );
	
					normalMatrix.applyToBufferAttribute( normal );
					normal.needsUpdate = true;
	
				}
	
				if ( this.boundingBox !== null ) {
	
					this.computeBoundingBox();
	
				}
	
				if ( this.boundingSphere !== null ) {
	
					this.computeBoundingSphere();
	
				}
	
				return this;
	
			},
	
			rotateX: function () {
	
				// rotate geometry around world x-axis
	
				var m1 = new Matrix4();
	
				return function rotateX( angle ) {
	
					m1.makeRotationX( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateY: function () {
	
				// rotate geometry around world y-axis
	
				var m1 = new Matrix4();
	
				return function rotateY( angle ) {
	
					m1.makeRotationY( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateZ: function () {
	
				// rotate geometry around world z-axis
	
				var m1 = new Matrix4();
	
				return function rotateZ( angle ) {
	
					m1.makeRotationZ( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			translate: function () {
	
				// translate geometry
	
				var m1 = new Matrix4();
	
				return function translate( x, y, z ) {
	
					m1.makeTranslation( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			scale: function () {
	
				// scale geometry
	
				var m1 = new Matrix4();
	
				return function scale( x, y, z ) {
	
					m1.makeScale( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			lookAt: function () {
	
				var obj = new Object3D();
	
				return function lookAt( vector ) {
	
					obj.lookAt( vector );
	
					obj.updateMatrix();
	
					this.applyMatrix( obj.matrix );
	
				};
	
			}(),
	
			center: function () {
	
				this.computeBoundingBox();
	
				var offset = this.boundingBox.getCenter().negate();
	
				this.translate( offset.x, offset.y, offset.z );
	
				return offset;
	
			},
	
			setFromObject: function ( object ) {
	
				// console.log( 'THREE.BufferGeometry.setFromObject(). Converting', object, this );
	
				var geometry = object.geometry;
	
				if ( object.isPoints || object.isLine ) {
	
					var positions = new Float32BufferAttribute( geometry.vertices.length * 3, 3 );
					var colors = new Float32BufferAttribute( geometry.colors.length * 3, 3 );
	
					this.addAttribute( 'position', positions.copyVector3sArray( geometry.vertices ) );
					this.addAttribute( 'color', colors.copyColorsArray( geometry.colors ) );
	
					if ( geometry.lineDistances && geometry.lineDistances.length === geometry.vertices.length ) {
	
						var lineDistances = new Float32BufferAttribute( geometry.lineDistances.length, 1 );
	
						this.addAttribute( 'lineDistance', lineDistances.copyArray( geometry.lineDistances ) );
	
					}
	
					if ( geometry.boundingSphere !== null ) {
	
						this.boundingSphere = geometry.boundingSphere.clone();
	
					}
	
					if ( geometry.boundingBox !== null ) {
	
						this.boundingBox = geometry.boundingBox.clone();
	
					}
	
				} else if ( object.isMesh ) {
	
					if ( geometry && geometry.isGeometry ) {
	
						this.fromGeometry( geometry );
	
					}
	
				}
	
				return this;
	
			},
	
			updateFromObject: function ( object ) {
	
				var geometry = object.geometry;
	
				if ( object.isMesh ) {
	
					var direct = geometry.__directGeometry;
	
					if ( geometry.elementsNeedUpdate === true ) {
	
						direct = undefined;
						geometry.elementsNeedUpdate = false;
	
					}
	
					if ( direct === undefined ) {
	
						return this.fromGeometry( geometry );
	
					}
	
					direct.verticesNeedUpdate = geometry.verticesNeedUpdate;
					direct.normalsNeedUpdate = geometry.normalsNeedUpdate;
					direct.colorsNeedUpdate = geometry.colorsNeedUpdate;
					direct.uvsNeedUpdate = geometry.uvsNeedUpdate;
					direct.groupsNeedUpdate = geometry.groupsNeedUpdate;
	
					geometry.verticesNeedUpdate = false;
					geometry.normalsNeedUpdate = false;
					geometry.colorsNeedUpdate = false;
					geometry.uvsNeedUpdate = false;
					geometry.groupsNeedUpdate = false;
	
					geometry = direct;
	
				}
	
				var attribute;
	
				if ( geometry.verticesNeedUpdate === true ) {
	
					attribute = this.attributes.position;
	
					if ( attribute !== undefined ) {
	
						attribute.copyVector3sArray( geometry.vertices );
						attribute.needsUpdate = true;
	
					}
	
					geometry.verticesNeedUpdate = false;
	
				}
	
				if ( geometry.normalsNeedUpdate === true ) {
	
					attribute = this.attributes.normal;
	
					if ( attribute !== undefined ) {
	
						attribute.copyVector3sArray( geometry.normals );
						attribute.needsUpdate = true;
	
					}
	
					geometry.normalsNeedUpdate = false;
	
				}
	
				if ( geometry.colorsNeedUpdate === true ) {
	
					attribute = this.attributes.color;
	
					if ( attribute !== undefined ) {
	
						attribute.copyColorsArray( geometry.colors );
						attribute.needsUpdate = true;
	
					}
	
					geometry.colorsNeedUpdate = false;
	
				}
	
				if ( geometry.uvsNeedUpdate ) {
	
					attribute = this.attributes.uv;
	
					if ( attribute !== undefined ) {
	
						attribute.copyVector2sArray( geometry.uvs );
						attribute.needsUpdate = true;
	
					}
	
					geometry.uvsNeedUpdate = false;
	
				}
	
				if ( geometry.lineDistancesNeedUpdate ) {
	
					attribute = this.attributes.lineDistance;
	
					if ( attribute !== undefined ) {
	
						attribute.copyArray( geometry.lineDistances );
						attribute.needsUpdate = true;
	
					}
	
					geometry.lineDistancesNeedUpdate = false;
	
				}
	
				if ( geometry.groupsNeedUpdate ) {
	
					geometry.computeGroups( object.geometry );
					this.groups = geometry.groups;
	
					geometry.groupsNeedUpdate = false;
	
				}
	
				return this;
	
			},
	
			fromGeometry: function ( geometry ) {
	
				geometry.__directGeometry = new DirectGeometry().fromGeometry( geometry );
	
				return this.fromDirectGeometry( geometry.__directGeometry );
	
			},
	
			fromDirectGeometry: function ( geometry ) {
	
				var positions = new Float32Array( geometry.vertices.length * 3 );
				this.addAttribute( 'position', new BufferAttribute( positions, 3 ).copyVector3sArray( geometry.vertices ) );
	
				if ( geometry.normals.length > 0 ) {
	
					var normals = new Float32Array( geometry.normals.length * 3 );
					this.addAttribute( 'normal', new BufferAttribute( normals, 3 ).copyVector3sArray( geometry.normals ) );
	
				}
	
				if ( geometry.colors.length > 0 ) {
	
					var colors = new Float32Array( geometry.colors.length * 3 );
					this.addAttribute( 'color', new BufferAttribute( colors, 3 ).copyColorsArray( geometry.colors ) );
	
				}
	
				if ( geometry.uvs.length > 0 ) {
	
					var uvs = new Float32Array( geometry.uvs.length * 2 );
					this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ).copyVector2sArray( geometry.uvs ) );
	
				}
	
				if ( geometry.uvs2.length > 0 ) {
	
					var uvs2 = new Float32Array( geometry.uvs2.length * 2 );
					this.addAttribute( 'uv2', new BufferAttribute( uvs2, 2 ).copyVector2sArray( geometry.uvs2 ) );
	
				}
	
				if ( geometry.indices.length > 0 ) {
	
					var TypeArray = arrayMax( geometry.indices ) > 65535 ? Uint32Array : Uint16Array;
					var indices = new TypeArray( geometry.indices.length * 3 );
					this.setIndex( new BufferAttribute( indices, 1 ).copyIndicesArray( geometry.indices ) );
	
				}
	
				// groups
	
				this.groups = geometry.groups;
	
				// morphs
	
				for ( var name in geometry.morphTargets ) {
	
					var array = [];
					var morphTargets = geometry.morphTargets[ name ];
	
					for ( var i = 0, l = morphTargets.length; i < l; i ++ ) {
	
						var morphTarget = morphTargets[ i ];
	
						var attribute = new Float32BufferAttribute( morphTarget.length * 3, 3 );
	
						array.push( attribute.copyVector3sArray( morphTarget ) );
	
					}
	
					this.morphAttributes[ name ] = array;
	
				}
	
				// skinning
	
				if ( geometry.skinIndices.length > 0 ) {
	
					var skinIndices = new Float32BufferAttribute( geometry.skinIndices.length * 4, 4 );
					this.addAttribute( 'skinIndex', skinIndices.copyVector4sArray( geometry.skinIndices ) );
	
				}
	
				if ( geometry.skinWeights.length > 0 ) {
	
					var skinWeights = new Float32BufferAttribute( geometry.skinWeights.length * 4, 4 );
					this.addAttribute( 'skinWeight', skinWeights.copyVector4sArray( geometry.skinWeights ) );
	
				}
	
				//
	
				if ( geometry.boundingSphere !== null ) {
	
					this.boundingSphere = geometry.boundingSphere.clone();
	
				}
	
				if ( geometry.boundingBox !== null ) {
	
					this.boundingBox = geometry.boundingBox.clone();
	
				}
	
				return this;
	
			},
	
			computeBoundingBox: function () {
	
				if ( this.boundingBox === null ) {
	
					this.boundingBox = new Box3();
	
				}
	
				var position = this.attributes.position;
	
				if ( position !== undefined ) {
	
					this.boundingBox.setFromBufferAttribute( position );
	
				} else {
	
					this.boundingBox.makeEmpty();
	
				}
	
				if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {
	
					console.error( 'THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );
	
				}
	
			},
	
			computeBoundingSphere: function () {
	
				var box = new Box3();
				var vector = new Vector3();
	
				return function computeBoundingSphere() {
	
					if ( this.boundingSphere === null ) {
	
						this.boundingSphere = new Sphere();
	
					}
	
					var position = this.attributes.position;
	
					if ( position ) {
	
						var center = this.boundingSphere.center;
	
						box.setFromBufferAttribute( position );
						box.getCenter( center );
	
						// hoping to find a boundingSphere with a radius smaller than the
						// boundingSphere of the boundingBox: sqrt(3) smaller in the best case
	
						var maxRadiusSq = 0;
	
						for ( var i = 0, il = position.count; i < il; i ++ ) {
	
							vector.x = position.getX( i );
							vector.y = position.getY( i );
							vector.z = position.getZ( i );
							maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( vector ) );
	
						}
	
						this.boundingSphere.radius = Math.sqrt( maxRadiusSq );
	
						if ( isNaN( this.boundingSphere.radius ) ) {
	
							console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );
	
						}
	
					}
	
				};
	
			}(),
	
			computeFaceNormals: function () {
	
				// backwards compatibility
	
			},
	
			computeVertexNormals: function () {
	
				var index = this.index;
				var attributes = this.attributes;
				var groups = this.groups;
	
				if ( attributes.position ) {
	
					var positions = attributes.position.array;
	
					if ( attributes.normal === undefined ) {
	
						this.addAttribute( 'normal', new BufferAttribute( new Float32Array( positions.length ), 3 ) );
	
					} else {
	
						// reset existing normals to zero
	
						var array = attributes.normal.array;
	
						for ( var i = 0, il = array.length; i < il; i ++ ) {
	
							array[ i ] = 0;
	
						}
	
					}
	
					var normals = attributes.normal.array;
	
					var vA, vB, vC;
					var pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
					var cb = new Vector3(), ab = new Vector3();
	
					// indexed elements
	
					if ( index ) {
	
						var indices = index.array;
	
						if ( groups.length === 0 ) {
	
							this.addGroup( 0, indices.length );
	
						}
	
						for ( var j = 0, jl = groups.length; j < jl; ++ j ) {
	
							var group = groups[ j ];
	
							var start = group.start;
							var count = group.count;
	
							for ( var i = start, il = start + count; i < il; i += 3 ) {
	
								vA = indices[ i + 0 ] * 3;
								vB = indices[ i + 1 ] * 3;
								vC = indices[ i + 2 ] * 3;
	
								pA.fromArray( positions, vA );
								pB.fromArray( positions, vB );
								pC.fromArray( positions, vC );
	
								cb.subVectors( pC, pB );
								ab.subVectors( pA, pB );
								cb.cross( ab );
	
								normals[ vA ] += cb.x;
								normals[ vA + 1 ] += cb.y;
								normals[ vA + 2 ] += cb.z;
	
								normals[ vB ] += cb.x;
								normals[ vB + 1 ] += cb.y;
								normals[ vB + 2 ] += cb.z;
	
								normals[ vC ] += cb.x;
								normals[ vC + 1 ] += cb.y;
								normals[ vC + 2 ] += cb.z;
	
							}
	
						}
	
					} else {
	
						// non-indexed elements (unconnected triangle soup)
	
						for ( var i = 0, il = positions.length; i < il; i += 9 ) {
	
							pA.fromArray( positions, i );
							pB.fromArray( positions, i + 3 );
							pC.fromArray( positions, i + 6 );
	
							cb.subVectors( pC, pB );
							ab.subVectors( pA, pB );
							cb.cross( ab );
	
							normals[ i ] = cb.x;
							normals[ i + 1 ] = cb.y;
							normals[ i + 2 ] = cb.z;
	
							normals[ i + 3 ] = cb.x;
							normals[ i + 4 ] = cb.y;
							normals[ i + 5 ] = cb.z;
	
							normals[ i + 6 ] = cb.x;
							normals[ i + 7 ] = cb.y;
							normals[ i + 8 ] = cb.z;
	
						}
	
					}
	
					this.normalizeNormals();
	
					attributes.normal.needsUpdate = true;
	
				}
	
			},
	
			merge: function ( geometry, offset ) {
	
				if ( ! ( geometry && geometry.isBufferGeometry ) ) {
	
					console.error( 'THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry );
					return;
	
				}
	
				if ( offset === undefined ) offset = 0;
	
				var attributes = this.attributes;
	
				for ( var key in attributes ) {
	
					if ( geometry.attributes[ key ] === undefined ) continue;
	
					var attribute1 = attributes[ key ];
					var attributeArray1 = attribute1.array;
	
					var attribute2 = geometry.attributes[ key ];
					var attributeArray2 = attribute2.array;
	
					var attributeSize = attribute2.itemSize;
	
					for ( var i = 0, j = attributeSize * offset; i < attributeArray2.length; i ++, j ++ ) {
	
						attributeArray1[ j ] = attributeArray2[ i ];
	
					}
	
				}
	
				return this;
	
			},
	
			normalizeNormals: function () {
	
				var vector = new Vector3();
	
				return function normalizeNormals() {
	
					var normals = this.attributes.normal;
	
					for ( var i = 0, il = normals.count; i < il; i ++ ) {
	
						vector.x = normals.getX( i );
						vector.y = normals.getY( i );
						vector.z = normals.getZ( i );
	
						vector.normalize();
	
						normals.setXYZ( i, vector.x, vector.y, vector.z );
	
					}
	
				};
	
			}(),
	
			toNonIndexed: function () {
	
				if ( this.index === null ) {
	
					console.warn( 'THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed.' );
					return this;
	
				}
	
				var geometry2 = new BufferGeometry();
	
				var indices = this.index.array;
				var attributes = this.attributes;
	
				for ( var name in attributes ) {
	
					var attribute = attributes[ name ];
	
					var array = attribute.array;
					var itemSize = attribute.itemSize;
	
					var array2 = new array.constructor( indices.length * itemSize );
	
					var index = 0, index2 = 0;
	
					for ( var i = 0, l = indices.length; i < l; i ++ ) {
	
						index = indices[ i ] * itemSize;
	
						for ( var j = 0; j < itemSize; j ++ ) {
	
							array2[ index2 ++ ] = array[ index ++ ];
	
						}
	
					}
	
					geometry2.addAttribute( name, new BufferAttribute( array2, itemSize ) );
	
				}
	
				return geometry2;
	
			},
	
			toJSON: function () {
	
				var data = {
					metadata: {
						version: 4.5,
						type: 'BufferGeometry',
						generator: 'BufferGeometry.toJSON'
					}
				};
	
				// standard BufferGeometry serialization
	
				data.uuid = this.uuid;
				data.type = this.type;
				if ( this.name !== '' ) data.name = this.name;
	
				if ( this.parameters !== undefined ) {
	
					var parameters = this.parameters;
	
					for ( var key in parameters ) {
	
						if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];
	
					}
	
					return data;
	
				}
	
				data.data = { attributes: {} };
	
				var index = this.index;
	
				if ( index !== null ) {
	
					var array = Array.prototype.slice.call( index.array );
	
					data.data.index = {
						type: index.array.constructor.name,
						array: array
					};
	
				}
	
				var attributes = this.attributes;
	
				for ( var key in attributes ) {
	
					var attribute = attributes[ key ];
	
					var array = Array.prototype.slice.call( attribute.array );
	
					data.data.attributes[ key ] = {
						itemSize: attribute.itemSize,
						type: attribute.array.constructor.name,
						array: array,
						normalized: attribute.normalized
					};
	
				}
	
				var groups = this.groups;
	
				if ( groups.length > 0 ) {
	
					data.data.groups = JSON.parse( JSON.stringify( groups ) );
	
				}
	
				var boundingSphere = this.boundingSphere;
	
				if ( boundingSphere !== null ) {
	
					data.data.boundingSphere = {
						center: boundingSphere.center.toArray(),
						radius: boundingSphere.radius
					};
	
				}
	
				return data;
	
			},
	
			clone: function () {
	
				/*
				 // Handle primitives
	
				 var parameters = this.parameters;
	
				 if ( parameters !== undefined ) {
	
				 var values = [];
	
				 for ( var key in parameters ) {
	
				 values.push( parameters[ key ] );
	
				 }
	
				 var geometry = Object.create( this.constructor.prototype );
				 this.constructor.apply( geometry, values );
				 return geometry;
	
				 }
	
				 return new this.constructor().copy( this );
				 */
	
				return new BufferGeometry().copy( this );
	
			},
	
			copy: function ( source ) {
	
				var name, i, l;
	
				// reset
	
				this.index = null;
				this.attributes = {};
				this.morphAttributes = {};
				this.groups = [];
				this.boundingBox = null;
				this.boundingSphere = null;
	
				// name
	
				this.name = source.name;
	
				// index
	
				var index = source.index;
	
				if ( index !== null ) {
	
					this.setIndex( index.clone() );
	
				}
	
				// attributes
	
				var attributes = source.attributes;
	
				for ( name in attributes ) {
	
					var attribute = attributes[ name ];
					this.addAttribute( name, attribute.clone() );
	
				}
	
				// morph attributes
	
				var morphAttributes = source.morphAttributes;
	
				for ( name in morphAttributes ) {
	
					var array = [];
					var morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes
	
					for ( i = 0, l = morphAttribute.length; i < l; i ++ ) {
	
						array.push( morphAttribute[ i ].clone() );
	
					}
	
					this.morphAttributes[ name ] = array;
	
				}
	
				// groups
	
				var groups = source.groups;
	
				for ( i = 0, l = groups.length; i < l; i ++ ) {
	
					var group = groups[ i ];
					this.addGroup( group.start, group.count, group.materialIndex );
	
				}
	
				// bounding box
	
				var boundingBox = source.boundingBox;
	
				if ( boundingBox !== null ) {
	
					this.boundingBox = boundingBox.clone();
	
				}
	
				// bounding sphere
	
				var boundingSphere = source.boundingSphere;
	
				if ( boundingSphere !== null ) {
	
					this.boundingSphere = boundingSphere.clone();
	
				}
	
				// draw range
	
				this.drawRange.start = source.drawRange.start;
				this.drawRange.count = source.drawRange.count;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// BoxGeometry
	
		function BoxGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {
	
			Geometry.call( this );
	
			this.type = 'BoxGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				depth: depth,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				depthSegments: depthSegments
			};
	
			this.fromBufferGeometry( new BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) );
			this.mergeVertices();
	
		}
	
		BoxGeometry.prototype = Object.create( Geometry.prototype );
		BoxGeometry.prototype.constructor = BoxGeometry;
	
		// BoxBufferGeometry
	
		function BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {
	
			BufferGeometry.call( this );
	
			this.type = 'BoxBufferGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				depth: depth,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				depthSegments: depthSegments
			};
	
			var scope = this;
	
			// segments
	
			widthSegments = Math.floor( widthSegments ) || 1;
			heightSegments = Math.floor( heightSegments ) || 1;
			depthSegments = Math.floor( depthSegments ) || 1;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var numberOfVertices = 0;
			var groupStart = 0;
	
			// build each side of the box geometry
	
			buildPlane( 'z', 'y', 'x', - 1, - 1, depth, height,   width,  depthSegments, heightSegments, 0 ); // px
			buildPlane( 'z', 'y', 'x',   1, - 1, depth, height, - width,  depthSegments, heightSegments, 1 ); // nx
			buildPlane( 'x', 'z', 'y',   1,   1, width, depth,    height, widthSegments, depthSegments,  2 ); // py
			buildPlane( 'x', 'z', 'y',   1, - 1, width, depth,  - height, widthSegments, depthSegments,  3 ); // ny
			buildPlane( 'x', 'y', 'z',   1, - 1, width, height,   depth,  widthSegments, heightSegments, 4 ); // pz
			buildPlane( 'x', 'y', 'z', - 1, - 1, width, height, - depth,  widthSegments, heightSegments, 5 ); // nz
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex ) {
	
				var segmentWidth = width / gridX;
				var segmentHeight = height / gridY;
	
				var widthHalf = width / 2;
				var heightHalf = height / 2;
				var depthHalf = depth / 2;
	
				var gridX1 = gridX + 1;
				var gridY1 = gridY + 1;
	
				var vertexCounter = 0;
				var groupCount = 0;
	
				var ix, iy;
	
				var vector = new Vector3();
	
				// generate vertices, normals and uvs
	
				for ( iy = 0; iy < gridY1; iy ++ ) {
	
					var y = iy * segmentHeight - heightHalf;
	
					for ( ix = 0; ix < gridX1; ix ++ ) {
	
						var x = ix * segmentWidth - widthHalf;
	
						// set values to correct vector component
	
						vector[ u ] = x * udir;
						vector[ v ] = y * vdir;
						vector[ w ] = depthHalf;
	
						// now apply vector to vertex buffer
	
						vertices.push( vector.x, vector.y, vector.z );
	
						// set values to correct vector component
	
						vector[ u ] = 0;
						vector[ v ] = 0;
						vector[ w ] = depth > 0 ? 1 : - 1;
	
						// now apply vector to normal buffer
	
						normals.push( vector.x, vector.y, vector.z );
	
						// uvs
	
						uvs.push( ix / gridX );
						uvs.push( 1 - ( iy / gridY ) );
	
						// counters
	
						vertexCounter += 1;
	
					}
	
				}
	
				// indices
	
				// 1. you need three indices to draw a single face
				// 2. a single segment consists of two faces
				// 3. so we need to generate six (2*3) indices per segment
	
				for ( iy = 0; iy < gridY; iy ++ ) {
	
					for ( ix = 0; ix < gridX; ix ++ ) {
	
						var a = numberOfVertices + ix + gridX1 * iy;
						var b = numberOfVertices + ix + gridX1 * ( iy + 1 );
						var c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
						var d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;
	
						// faces
	
						indices.push( a, b, d );
						indices.push( b, c, d );
	
						// increase counter
	
						groupCount += 6;
	
					}
	
				}
	
				// add a group to the geometry. this will ensure multi material support
	
				scope.addGroup( groupStart, groupCount, materialIndex );
	
				// calculate new start value for groups
	
				groupStart += groupCount;
	
				// update total number of vertices
	
				numberOfVertices += vertexCounter;
	
			}
	
		}
	
		BoxBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		BoxBufferGeometry.prototype.constructor = BoxBufferGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// PlaneGeometry
	
		function PlaneGeometry( width, height, widthSegments, heightSegments ) {
	
			Geometry.call( this );
	
			this.type = 'PlaneGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				widthSegments: widthSegments,
				heightSegments: heightSegments
			};
	
			this.fromBufferGeometry( new PlaneBufferGeometry( width, height, widthSegments, heightSegments ) );
			this.mergeVertices();
	
		}
	
		PlaneGeometry.prototype = Object.create( Geometry.prototype );
		PlaneGeometry.prototype.constructor = PlaneGeometry;
	
		// PlaneBufferGeometry
	
		function PlaneBufferGeometry( width, height, widthSegments, heightSegments ) {
	
			BufferGeometry.call( this );
	
			this.type = 'PlaneBufferGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				widthSegments: widthSegments,
				heightSegments: heightSegments
			};
	
			var width_half = width / 2;
			var height_half = height / 2;
	
			var gridX = Math.floor( widthSegments ) || 1;
			var gridY = Math.floor( heightSegments ) || 1;
	
			var gridX1 = gridX + 1;
			var gridY1 = gridY + 1;
	
			var segment_width = width / gridX;
			var segment_height = height / gridY;
	
			var ix, iy;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// generate vertices, normals and uvs
	
			for ( iy = 0; iy < gridY1; iy ++ ) {
	
				var y = iy * segment_height - height_half;
	
				for ( ix = 0; ix < gridX1; ix ++ ) {
	
					var x = ix * segment_width - width_half;
	
					vertices.push( x, - y, 0 );
	
					normals.push( 0, 0, 1 );
	
					uvs.push( ix / gridX );
					uvs.push( 1 - ( iy / gridY ) );
	
				}
	
			}
	
			// indices
	
			for ( iy = 0; iy < gridY; iy ++ ) {
	
				for ( ix = 0; ix < gridX; ix ++ ) {
	
					var a = ix + gridX1 * iy;
					var b = ix + gridX1 * ( iy + 1 );
					var c = ( ix + 1 ) + gridX1 * ( iy + 1 );
					var d = ( ix + 1 ) + gridX1 * iy;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		PlaneBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		PlaneBufferGeometry.prototype.constructor = PlaneBufferGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  specularMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
		 *  combine: THREE.Multiply,
		 *  reflectivity: <float>,
		 *  refractionRatio: <float>,
		 *
		 *  depthTest: <bool>,
		 *  depthWrite: <bool>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>
		 * }
		 */
	
		function MeshBasicMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshBasicMaterial';
	
			this.color = new Color( 0xffffff ); // emissive
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.specularMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.combine = MultiplyOperation;
			this.reflectivity = 1;
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
	
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		MeshBasicMaterial.prototype = Object.create( Material.prototype );
		MeshBasicMaterial.prototype.constructor = MeshBasicMaterial;
	
		MeshBasicMaterial.prototype.isMeshBasicMaterial = true;
	
		MeshBasicMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.specularMap = source.specularMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
	
			return this;
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Ray( origin, direction ) {
	
			this.origin = ( origin !== undefined ) ? origin : new Vector3();
			this.direction = ( direction !== undefined ) ? direction : new Vector3();
	
		}
	
		Object.assign( Ray.prototype, {
	
			set: function ( origin, direction ) {
	
				this.origin.copy( origin );
				this.direction.copy( direction );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( ray ) {
	
				this.origin.copy( ray.origin );
				this.direction.copy( ray.direction );
	
				return this;
	
			},
	
			at: function ( t, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				return result.copy( this.direction ).multiplyScalar( t ).add( this.origin );
	
			},
	
			lookAt: function ( v ) {
	
				this.direction.copy( v ).sub( this.origin ).normalize();
	
				return this;
	
			},
	
			recast: function () {
	
				var v1 = new Vector3();
	
				return function recast( t ) {
	
					this.origin.copy( this.at( t, v1 ) );
	
					return this;
	
				};
	
			}(),
	
			closestPointToPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				result.subVectors( point, this.origin );
				var directionDistance = result.dot( this.direction );
	
				if ( directionDistance < 0 ) {
	
					return result.copy( this.origin );
	
				}
	
				return result.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );
	
			},
	
			distanceToPoint: function ( point ) {
	
				return Math.sqrt( this.distanceSqToPoint( point ) );
	
			},
	
			distanceSqToPoint: function () {
	
				var v1 = new Vector3();
	
				return function distanceSqToPoint( point ) {
	
					var directionDistance = v1.subVectors( point, this.origin ).dot( this.direction );
	
					// point behind the ray
	
					if ( directionDistance < 0 ) {
	
						return this.origin.distanceToSquared( point );
	
					}
	
					v1.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );
	
					return v1.distanceToSquared( point );
	
				};
	
			}(),
	
			distanceSqToSegment: function () {
	
				var segCenter = new Vector3();
				var segDir = new Vector3();
				var diff = new Vector3();
	
				return function distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {
	
					// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
					// It returns the min distance between the ray and the segment
					// defined by v0 and v1
					// It can also set two optional targets :
					// - The closest point on the ray
					// - The closest point on the segment
	
					segCenter.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
					segDir.copy( v1 ).sub( v0 ).normalize();
					diff.copy( this.origin ).sub( segCenter );
	
					var segExtent = v0.distanceTo( v1 ) * 0.5;
					var a01 = - this.direction.dot( segDir );
					var b0 = diff.dot( this.direction );
					var b1 = - diff.dot( segDir );
					var c = diff.lengthSq();
					var det = Math.abs( 1 - a01 * a01 );
					var s0, s1, sqrDist, extDet;
	
					if ( det > 0 ) {
	
						// The ray and segment are not parallel.
	
						s0 = a01 * b1 - b0;
						s1 = a01 * b0 - b1;
						extDet = segExtent * det;
	
						if ( s0 >= 0 ) {
	
							if ( s1 >= - extDet ) {
	
								if ( s1 <= extDet ) {
	
									// region 0
									// Minimum at interior points of ray and segment.
	
									var invDet = 1 / det;
									s0 *= invDet;
									s1 *= invDet;
									sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;
	
								} else {
	
									// region 1
	
									s1 = segExtent;
									s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
									sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
								}
	
							} else {
	
								// region 5
	
								s1 = - segExtent;
								s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
							}
	
						} else {
	
							if ( s1 <= - extDet ) {
	
								// region 4
	
								s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
								s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
							} else if ( s1 <= extDet ) {
	
								// region 3
	
								s0 = 0;
								s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
								sqrDist = s1 * ( s1 + 2 * b1 ) + c;
	
							} else {
	
								// region 2
	
								s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
								s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
							}
	
						}
	
					} else {
	
						// Ray and segment are parallel.
	
						s1 = ( a01 > 0 ) ? - segExtent : segExtent;
						s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
					}
	
					if ( optionalPointOnRay ) {
	
						optionalPointOnRay.copy( this.direction ).multiplyScalar( s0 ).add( this.origin );
	
					}
	
					if ( optionalPointOnSegment ) {
	
						optionalPointOnSegment.copy( segDir ).multiplyScalar( s1 ).add( segCenter );
	
					}
	
					return sqrDist;
	
				};
	
			}(),
	
			intersectSphere: function () {
	
				var v1 = new Vector3();
	
				return function intersectSphere( sphere, optionalTarget ) {
	
					v1.subVectors( sphere.center, this.origin );
					var tca = v1.dot( this.direction );
					var d2 = v1.dot( v1 ) - tca * tca;
					var radius2 = sphere.radius * sphere.radius;
	
					if ( d2 > radius2 ) return null;
	
					var thc = Math.sqrt( radius2 - d2 );
	
					// t0 = first intersect point - entrance on front of sphere
					var t0 = tca - thc;
	
					// t1 = second intersect point - exit point on back of sphere
					var t1 = tca + thc;
	
					// test to see if both t0 and t1 are behind the ray - if so, return null
					if ( t0 < 0 && t1 < 0 ) return null;
	
					// test to see if t0 is behind the ray:
					// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
					// in order to always return an intersect point that is in front of the ray.
					if ( t0 < 0 ) return this.at( t1, optionalTarget );
	
					// else t0 is in front of the ray, so return the first collision point scaled by t0
					return this.at( t0, optionalTarget );
	
				};
	
			}(),
	
			intersectsSphere: function ( sphere ) {
	
				return this.distanceToPoint( sphere.center ) <= sphere.radius;
	
			},
	
			distanceToPlane: function ( plane ) {
	
				var denominator = plane.normal.dot( this.direction );
	
				if ( denominator === 0 ) {
	
					// line is coplanar, return origin
					if ( plane.distanceToPoint( this.origin ) === 0 ) {
	
						return 0;
	
					}
	
					// Null is preferable to undefined since undefined means.... it is undefined
	
					return null;
	
				}
	
				var t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;
	
				// Return if the ray never intersects the plane
	
				return t >= 0 ? t :  null;
	
			},
	
			intersectPlane: function ( plane, optionalTarget ) {
	
				var t = this.distanceToPlane( plane );
	
				if ( t === null ) {
	
					return null;
	
				}
	
				return this.at( t, optionalTarget );
	
			},
	
			intersectsPlane: function ( plane ) {
	
				// check if the ray lies on the plane first
	
				var distToPoint = plane.distanceToPoint( this.origin );
	
				if ( distToPoint === 0 ) {
	
					return true;
	
				}
	
				var denominator = plane.normal.dot( this.direction );
	
				if ( denominator * distToPoint < 0 ) {
	
					return true;
	
				}
	
				// ray origin is behind the plane (and is pointing behind it)
	
				return false;
	
			},
	
			intersectBox: function ( box, optionalTarget ) {
	
				var tmin, tmax, tymin, tymax, tzmin, tzmax;
	
				var invdirx = 1 / this.direction.x,
					invdiry = 1 / this.direction.y,
					invdirz = 1 / this.direction.z;
	
				var origin = this.origin;
	
				if ( invdirx >= 0 ) {
	
					tmin = ( box.min.x - origin.x ) * invdirx;
					tmax = ( box.max.x - origin.x ) * invdirx;
	
				} else {
	
					tmin = ( box.max.x - origin.x ) * invdirx;
					tmax = ( box.min.x - origin.x ) * invdirx;
	
				}
	
				if ( invdiry >= 0 ) {
	
					tymin = ( box.min.y - origin.y ) * invdiry;
					tymax = ( box.max.y - origin.y ) * invdiry;
	
				} else {
	
					tymin = ( box.max.y - origin.y ) * invdiry;
					tymax = ( box.min.y - origin.y ) * invdiry;
	
				}
	
				if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;
	
				// These lines also handle the case where tmin or tmax is NaN
				// (result of 0 * Infinity). x !== x returns true if x is NaN
	
				if ( tymin > tmin || tmin !== tmin ) tmin = tymin;
	
				if ( tymax < tmax || tmax !== tmax ) tmax = tymax;
	
				if ( invdirz >= 0 ) {
	
					tzmin = ( box.min.z - origin.z ) * invdirz;
					tzmax = ( box.max.z - origin.z ) * invdirz;
	
				} else {
	
					tzmin = ( box.max.z - origin.z ) * invdirz;
					tzmax = ( box.min.z - origin.z ) * invdirz;
	
				}
	
				if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;
	
				if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;
	
				if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;
	
				//return point closest to the ray (positive side)
	
				if ( tmax < 0 ) return null;
	
				return this.at( tmin >= 0 ? tmin : tmax, optionalTarget );
	
			},
	
			intersectsBox: ( function () {
	
				var v = new Vector3();
	
				return function intersectsBox( box ) {
	
					return this.intersectBox( box, v ) !== null;
	
				};
	
			} )(),
	
			intersectTriangle: function () {
	
				// Compute the offset origin, edges, and normal.
				var diff = new Vector3();
				var edge1 = new Vector3();
				var edge2 = new Vector3();
				var normal = new Vector3();
	
				return function intersectTriangle( a, b, c, backfaceCulling, optionalTarget ) {
	
					// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
	
					edge1.subVectors( b, a );
					edge2.subVectors( c, a );
					normal.crossVectors( edge1, edge2 );
	
					// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
					// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
					//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
					//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
					//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
					var DdN = this.direction.dot( normal );
					var sign;
	
					if ( DdN > 0 ) {
	
						if ( backfaceCulling ) return null;
						sign = 1;
	
					} else if ( DdN < 0 ) {
	
						sign = - 1;
						DdN = - DdN;
	
					} else {
	
						return null;
	
					}
	
					diff.subVectors( this.origin, a );
					var DdQxE2 = sign * this.direction.dot( edge2.crossVectors( diff, edge2 ) );
	
					// b1 < 0, no intersection
					if ( DdQxE2 < 0 ) {
	
						return null;
	
					}
	
					var DdE1xQ = sign * this.direction.dot( edge1.cross( diff ) );
	
					// b2 < 0, no intersection
					if ( DdE1xQ < 0 ) {
	
						return null;
	
					}
	
					// b1+b2 > 1, no intersection
					if ( DdQxE2 + DdE1xQ > DdN ) {
	
						return null;
	
					}
	
					// Line intersects triangle, check if ray does.
					var QdN = - sign * diff.dot( normal );
	
					// t < 0, no intersection
					if ( QdN < 0 ) {
	
						return null;
	
					}
	
					// Ray intersects triangle.
					return this.at( QdN / DdN, optionalTarget );
	
				};
	
			}(),
	
			applyMatrix4: function ( matrix4 ) {
	
				this.origin.applyMatrix4( matrix4 );
				this.direction.transformDirection( matrix4 );
	
				return this;
	
			},
	
			equals: function ( ray ) {
	
				return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );
	
			}
	
		} );
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Line3( start, end ) {
	
			this.start = ( start !== undefined ) ? start : new Vector3();
			this.end = ( end !== undefined ) ? end : new Vector3();
	
		}
	
		Object.assign( Line3.prototype, {
	
			set: function ( start, end ) {
	
				this.start.copy( start );
				this.end.copy( end );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( line ) {
	
				this.start.copy( line.start );
				this.end.copy( line.end );
	
				return this;
	
			},
	
			getCenter: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.addVectors( this.start, this.end ).multiplyScalar( 0.5 );
	
			},
	
			delta: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.subVectors( this.end, this.start );
	
			},
	
			distanceSq: function () {
	
				return this.start.distanceToSquared( this.end );
	
			},
	
			distance: function () {
	
				return this.start.distanceTo( this.end );
	
			},
	
			at: function ( t, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				return this.delta( result ).multiplyScalar( t ).add( this.start );
	
			},
	
			closestPointToPointParameter: function () {
	
				var startP = new Vector3();
				var startEnd = new Vector3();
	
				return function closestPointToPointParameter( point, clampToLine ) {
	
					startP.subVectors( point, this.start );
					startEnd.subVectors( this.end, this.start );
	
					var startEnd2 = startEnd.dot( startEnd );
					var startEnd_startP = startEnd.dot( startP );
	
					var t = startEnd_startP / startEnd2;
	
					if ( clampToLine ) {
	
						t = _Math.clamp( t, 0, 1 );
	
					}
	
					return t;
	
				};
	
			}(),
	
			closestPointToPoint: function ( point, clampToLine, optionalTarget ) {
	
				var t = this.closestPointToPointParameter( point, clampToLine );
	
				var result = optionalTarget || new Vector3();
	
				return this.delta( result ).multiplyScalar( t ).add( this.start );
	
			},
	
			applyMatrix4: function ( matrix ) {
	
				this.start.applyMatrix4( matrix );
				this.end.applyMatrix4( matrix );
	
				return this;
	
			},
	
			equals: function ( line ) {
	
				return line.start.equals( this.start ) && line.end.equals( this.end );
	
			}
	
		} );
	
		/**
		 * @author bhouston / http://clara.io
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Triangle( a, b, c ) {
	
			this.a = ( a !== undefined ) ? a : new Vector3();
			this.b = ( b !== undefined ) ? b : new Vector3();
			this.c = ( c !== undefined ) ? c : new Vector3();
	
		}
	
		Object.assign( Triangle, {
	
			normal: function () {
	
				var v0 = new Vector3();
	
				return function normal( a, b, c, optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					result.subVectors( c, b );
					v0.subVectors( a, b );
					result.cross( v0 );
	
					var resultLengthSq = result.lengthSq();
					if ( resultLengthSq > 0 ) {
	
						return result.multiplyScalar( 1 / Math.sqrt( resultLengthSq ) );
	
					}
	
					return result.set( 0, 0, 0 );
	
				};
	
			}(),
	
			// static/instance method to calculate barycentric coordinates
			// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
			barycoordFromPoint: function () {
	
				var v0 = new Vector3();
				var v1 = new Vector3();
				var v2 = new Vector3();
	
				return function barycoordFromPoint( point, a, b, c, optionalTarget ) {
	
					v0.subVectors( c, a );
					v1.subVectors( b, a );
					v2.subVectors( point, a );
	
					var dot00 = v0.dot( v0 );
					var dot01 = v0.dot( v1 );
					var dot02 = v0.dot( v2 );
					var dot11 = v1.dot( v1 );
					var dot12 = v1.dot( v2 );
	
					var denom = ( dot00 * dot11 - dot01 * dot01 );
	
					var result = optionalTarget || new Vector3();
	
					// collinear or singular triangle
					if ( denom === 0 ) {
	
						// arbitrary location outside of triangle?
						// not sure if this is the best idea, maybe should be returning undefined
						return result.set( - 2, - 1, - 1 );
	
					}
	
					var invDenom = 1 / denom;
					var u = ( dot11 * dot02 - dot01 * dot12 ) * invDenom;
					var v = ( dot00 * dot12 - dot01 * dot02 ) * invDenom;
	
					// barycentric coordinates must always sum to 1
					return result.set( 1 - u - v, v, u );
	
				};
	
			}(),
	
			containsPoint: function () {
	
				var v1 = new Vector3();
	
				return function containsPoint( point, a, b, c ) {
	
					var result = Triangle.barycoordFromPoint( point, a, b, c, v1 );
	
					return ( result.x >= 0 ) && ( result.y >= 0 ) && ( ( result.x + result.y ) <= 1 );
	
				};
	
			}()
	
		} );
	
		Object.assign( Triangle.prototype, {
	
			set: function ( a, b, c ) {
	
				this.a.copy( a );
				this.b.copy( b );
				this.c.copy( c );
	
				return this;
	
			},
	
			setFromPointsAndIndices: function ( points, i0, i1, i2 ) {
	
				this.a.copy( points[ i0 ] );
				this.b.copy( points[ i1 ] );
				this.c.copy( points[ i2 ] );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( triangle ) {
	
				this.a.copy( triangle.a );
				this.b.copy( triangle.b );
				this.c.copy( triangle.c );
	
				return this;
	
			},
	
			area: function () {
	
				var v0 = new Vector3();
				var v1 = new Vector3();
	
				return function area() {
	
					v0.subVectors( this.c, this.b );
					v1.subVectors( this.a, this.b );
	
					return v0.cross( v1 ).length() * 0.5;
	
				};
	
			}(),
	
			midpoint: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.addVectors( this.a, this.b ).add( this.c ).multiplyScalar( 1 / 3 );
	
			},
	
			normal: function ( optionalTarget ) {
	
				return Triangle.normal( this.a, this.b, this.c, optionalTarget );
	
			},
	
			plane: function ( optionalTarget ) {
	
				var result = optionalTarget || new Plane();
	
				return result.setFromCoplanarPoints( this.a, this.b, this.c );
	
			},
	
			barycoordFromPoint: function ( point, optionalTarget ) {
	
				return Triangle.barycoordFromPoint( point, this.a, this.b, this.c, optionalTarget );
	
			},
	
			containsPoint: function ( point ) {
	
				return Triangle.containsPoint( point, this.a, this.b, this.c );
	
			},
	
			closestPointToPoint: function () {
	
				var plane = new Plane();
				var edgeList = [ new Line3(), new Line3(), new Line3() ];
				var projectedPoint = new Vector3();
				var closestPoint = new Vector3();
	
				return function closestPointToPoint( point, optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
					var minDistance = Infinity;
	
					// project the point onto the plane of the triangle
	
					plane.setFromCoplanarPoints( this.a, this.b, this.c );
					plane.projectPoint( point, projectedPoint );
	
					// check if the projection lies within the triangle
	
					if( this.containsPoint( projectedPoint ) === true ) {
	
						// if so, this is the closest point
	
						result.copy( projectedPoint );
	
					} else {
	
						// if not, the point falls outside the triangle. the result is the closest point to the triangle's edges or vertices
	
						edgeList[ 0 ].set( this.a, this.b );
						edgeList[ 1 ].set( this.b, this.c );
						edgeList[ 2 ].set( this.c, this.a );
	
						for( var i = 0; i < edgeList.length; i ++ ) {
	
							edgeList[ i ].closestPointToPoint( projectedPoint, true, closestPoint );
	
							var distance = projectedPoint.distanceToSquared( closestPoint );
	
							if( distance < minDistance ) {
	
								minDistance = distance;
	
								result.copy( closestPoint );
	
							}
	
						}
	
					}
	
					return result;
	
				};
	
			}(),
	
			equals: function ( triangle ) {
	
				return triangle.a.equals( this.a ) && triangle.b.equals( this.b ) && triangle.c.equals( this.c );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author jonobr1 / http://jonobr1.com/
		 */
	
		function Mesh( geometry, material ) {
	
			Object3D.call( this );
	
			this.type = 'Mesh';
	
			this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
			this.material = material !== undefined ? material : new MeshBasicMaterial( { color: Math.random() * 0xffffff } );
	
			this.drawMode = TrianglesDrawMode;
	
			this.updateMorphTargets();
	
		}
	
		Mesh.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Mesh,
	
			isMesh: true,
	
			setDrawMode: function ( value ) {
	
				this.drawMode = value;
	
			},
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source );
	
				this.drawMode = source.drawMode;
	
				return this;
	
			},
	
			updateMorphTargets: function () {
	
				var geometry = this.geometry;
				var m, ml, name;
	
				if ( geometry.isBufferGeometry ) {
	
					var morphAttributes = geometry.morphAttributes;
					var keys = Object.keys( morphAttributes );
	
					if ( keys.length > 0 ) {
	
						var morphAttribute = morphAttributes[ keys[ 0 ] ];
	
						if ( morphAttribute !== undefined ) {
	
							this.morphTargetInfluences = [];
							this.morphTargetDictionary = {};
	
							for ( m = 0, ml = morphAttribute.length; m < ml; m ++ ) {
	
								name = morphAttribute[ m ].name || String( m );
	
								this.morphTargetInfluences.push( 0 );
								this.morphTargetDictionary[ name ] = m;
	
							}
	
						}
	
					}
	
				} else {
	
					var morphTargets = geometry.morphTargets;
	
					if ( morphTargets !== undefined && morphTargets.length > 0 ) {
	
						this.morphTargetInfluences = [];
						this.morphTargetDictionary = {};
	
						for ( m = 0, ml = morphTargets.length; m < ml; m ++ ) {
	
							name = morphTargets[ m ].name || String( m );
	
							this.morphTargetInfluences.push( 0 );
							this.morphTargetDictionary[ name ] = m;
	
						}
	
					}
	
				}
	
			},
	
			raycast: ( function () {
	
				var inverseMatrix = new Matrix4();
				var ray = new Ray();
				var sphere = new Sphere();
	
				var vA = new Vector3();
				var vB = new Vector3();
				var vC = new Vector3();
	
				var tempA = new Vector3();
				var tempB = new Vector3();
				var tempC = new Vector3();
	
				var uvA = new Vector2();
				var uvB = new Vector2();
				var uvC = new Vector2();
	
				var barycoord = new Vector3();
	
				var intersectionPoint = new Vector3();
				var intersectionPointWorld = new Vector3();
	
				function uvIntersection( point, p1, p2, p3, uv1, uv2, uv3 ) {
	
					Triangle.barycoordFromPoint( point, p1, p2, p3, barycoord );
	
					uv1.multiplyScalar( barycoord.x );
					uv2.multiplyScalar( barycoord.y );
					uv3.multiplyScalar( barycoord.z );
	
					uv1.add( uv2 ).add( uv3 );
	
					return uv1.clone();
	
				}
	
				function checkIntersection( object, material, raycaster, ray, pA, pB, pC, point ) {
	
					var intersect;
	
					if ( material.side === BackSide ) {
	
						intersect = ray.intersectTriangle( pC, pB, pA, true, point );
	
					} else {
	
						intersect = ray.intersectTriangle( pA, pB, pC, material.side !== DoubleSide, point );
	
					}
	
					if ( intersect === null ) return null;
	
					intersectionPointWorld.copy( point );
					intersectionPointWorld.applyMatrix4( object.matrixWorld );
	
					var distance = raycaster.ray.origin.distanceTo( intersectionPointWorld );
	
					if ( distance < raycaster.near || distance > raycaster.far ) return null;
	
					return {
						distance: distance,
						point: intersectionPointWorld.clone(),
						object: object
					};
	
				}
	
				function checkBufferGeometryIntersection( object, raycaster, ray, position, uv, a, b, c ) {
	
					vA.fromBufferAttribute( position, a );
					vB.fromBufferAttribute( position, b );
					vC.fromBufferAttribute( position, c );
	
					var intersection = checkIntersection( object, object.material, raycaster, ray, vA, vB, vC, intersectionPoint );
	
					if ( intersection ) {
	
						if ( uv ) {
	
							uvA.fromBufferAttribute( uv, a );
							uvB.fromBufferAttribute( uv, b );
							uvC.fromBufferAttribute( uv, c );
	
							intersection.uv = uvIntersection( intersectionPoint, vA, vB, vC, uvA, uvB, uvC );
	
						}
	
						intersection.face = new Face3( a, b, c, Triangle.normal( vA, vB, vC ) );
						intersection.faceIndex = a;
	
					}
	
					return intersection;
	
				}
	
				return function raycast( raycaster, intersects ) {
	
					var geometry = this.geometry;
					var material = this.material;
					var matrixWorld = this.matrixWorld;
	
					if ( material === undefined ) return;
	
					// Checking boundingSphere distance to ray
	
					if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere );
					sphere.applyMatrix4( matrixWorld );
	
					if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;
	
					//
	
					inverseMatrix.getInverse( matrixWorld );
					ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );
	
					// Check boundingBox before continuing
	
					if ( geometry.boundingBox !== null ) {
	
						if ( ray.intersectsBox( geometry.boundingBox ) === false ) return;
	
					}
	
					var intersection;
	
					if ( geometry.isBufferGeometry ) {
	
						var a, b, c;
						var index = geometry.index;
						var position = geometry.attributes.position;
						var uv = geometry.attributes.uv;
						var i, l;
	
						if ( index !== null ) {
	
							// indexed buffer geometry
	
							for ( i = 0, l = index.count; i < l; i += 3 ) {
	
								a = index.getX( i );
								b = index.getX( i + 1 );
								c = index.getX( i + 2 );
	
								intersection = checkBufferGeometryIntersection( this, raycaster, ray, position, uv, a, b, c );
	
								if ( intersection ) {
	
									intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indices buffer semantics
									intersects.push( intersection );
	
								}
	
							}
	
						} else {
	
							// non-indexed buffer geometry
	
							for ( i = 0, l = position.count; i < l; i += 3 ) {
	
								a = i;
								b = i + 1;
								c = i + 2;
	
								intersection = checkBufferGeometryIntersection( this, raycaster, ray, position, uv, a, b, c );
	
								if ( intersection ) {
	
									intersection.index = a; // triangle number in positions buffer semantics
									intersects.push( intersection );
	
								}
	
							}
	
						}
	
					} else if ( geometry.isGeometry ) {
	
						var fvA, fvB, fvC;
						var isMultiMaterial = Array.isArray( material );
	
						var vertices = geometry.vertices;
						var faces = geometry.faces;
						var uvs;
	
						var faceVertexUvs = geometry.faceVertexUvs[ 0 ];
						if ( faceVertexUvs.length > 0 ) uvs = faceVertexUvs;
	
						for ( var f = 0, fl = faces.length; f < fl; f ++ ) {
	
							var face = faces[ f ];
							var faceMaterial = isMultiMaterial ? material[ face.materialIndex ] : material;
	
							if ( faceMaterial === undefined ) continue;
	
							fvA = vertices[ face.a ];
							fvB = vertices[ face.b ];
							fvC = vertices[ face.c ];
	
							if ( faceMaterial.morphTargets === true ) {
	
								var morphTargets = geometry.morphTargets;
								var morphInfluences = this.morphTargetInfluences;
	
								vA.set( 0, 0, 0 );
								vB.set( 0, 0, 0 );
								vC.set( 0, 0, 0 );
	
								for ( var t = 0, tl = morphTargets.length; t < tl; t ++ ) {
	
									var influence = morphInfluences[ t ];
	
									if ( influence === 0 ) continue;
	
									var targets = morphTargets[ t ].vertices;
	
									vA.addScaledVector( tempA.subVectors( targets[ face.a ], fvA ), influence );
									vB.addScaledVector( tempB.subVectors( targets[ face.b ], fvB ), influence );
									vC.addScaledVector( tempC.subVectors( targets[ face.c ], fvC ), influence );
	
								}
	
								vA.add( fvA );
								vB.add( fvB );
								vC.add( fvC );
	
								fvA = vA;
								fvB = vB;
								fvC = vC;
	
							}
	
							intersection = checkIntersection( this, faceMaterial, raycaster, ray, fvA, fvB, fvC, intersectionPoint );
	
							if ( intersection ) {
	
								if ( uvs && uvs[ f ] ) {
	
									var uvs_f = uvs[ f ];
									uvA.copy( uvs_f[ 0 ] );
									uvB.copy( uvs_f[ 1 ] );
									uvC.copy( uvs_f[ 2 ] );
	
									intersection.uv = uvIntersection( intersectionPoint, fvA, fvB, fvC, uvA, uvB, uvC );
	
								}
	
								intersection.face = face;
								intersection.faceIndex = f;
								intersects.push( intersection );
	
							}
	
						}
	
					}
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLBackground( renderer, state, geometries, premultipliedAlpha ) {
	
			var clearColor = new Color( 0x000000 );
			var clearAlpha = 0;
	
			var planeCamera, planeMesh;
			var boxMesh;
	
			function render( renderList, scene, camera, forceClear ) {
	
				var background = scene.background;
	
				if ( background === null ) {
	
					setClear( clearColor, clearAlpha );
	
				} else if ( background && background.isColor ) {
	
					setClear( background, 1 );
					forceClear = true;
	
				}
	
				if ( renderer.autoClear || forceClear ) {
	
					renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );
	
				}
	
				if ( background && background.isCubeTexture ) {
	
					if ( boxMesh === undefined ) {
	
						boxMesh = new Mesh(
							new BoxBufferGeometry( 1, 1, 1 ),
							new ShaderMaterial( {
								uniforms: ShaderLib.cube.uniforms,
								vertexShader: ShaderLib.cube.vertexShader,
								fragmentShader: ShaderLib.cube.fragmentShader,
								side: BackSide,
								depthTest: true,
								depthWrite: false,
								polygonOffset: true,
								fog: false
							} )
						);
	
						boxMesh.geometry.removeAttribute( 'normal' );
						boxMesh.geometry.removeAttribute( 'uv' );
	
						boxMesh.onBeforeRender = function ( renderer, scene, camera ) {
	
							var scale = camera.far;
	
							this.matrixWorld.makeScale( scale, scale, scale );
							this.matrixWorld.copyPosition( camera.matrixWorld );
	
							this.material.polygonOffsetUnits = scale * 10;
	
						};
	
						geometries.update( boxMesh.geometry );
	
					}
	
					boxMesh.material.uniforms.tCube.value = background;
	
					renderList.push( boxMesh, boxMesh.geometry, boxMesh.material, 0, null );
	
				} else if ( background && background.isTexture ) {
	
					if ( planeCamera === undefined ) {
	
						planeCamera = new OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
	
						planeMesh = new Mesh(
							new PlaneBufferGeometry( 2, 2 ),
							new MeshBasicMaterial( { depthTest: false, depthWrite: false, fog: false } )
						);
	
						geometries.update( planeMesh.geometry );
	
					}
	
					planeMesh.material.map = background;
	
					// TODO Push this to renderList
	
					renderer.renderBufferDirect( planeCamera, null, planeMesh.geometry, planeMesh.material, planeMesh, null );
	
				}
	
			}
	
			function setClear( color, alpha ) {
	
				state.buffers.color.setClear( color.r, color.g, color.b, alpha, premultipliedAlpha );
	
			}
	
			return {
	
				getClearColor: function () {
	
					return clearColor;
	
				},
				setClearColor: function ( color, alpha ) {
	
					clearColor.set( color );
					clearAlpha = alpha !== undefined ? alpha : 1;
					setClear( clearColor, clearAlpha );
	
				},
				getClearAlpha: function () {
	
					return clearAlpha;
	
				},
				setClearAlpha: function ( alpha ) {
	
					clearAlpha = alpha;
					setClear( clearColor, clearAlpha );
	
				},
				render: render
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function painterSortStable( a, b ) {
	
			if ( a.renderOrder !== b.renderOrder ) {
	
				return a.renderOrder - b.renderOrder;
	
			} else if ( a.program && b.program && a.program !== b.program ) {
	
				return a.program.id - b.program.id;
	
			} else if ( a.material.id !== b.material.id ) {
	
				return a.material.id - b.material.id;
	
			} else if ( a.z !== b.z ) {
	
				return a.z - b.z;
	
			} else {
	
				return a.id - b.id;
	
			}
	
		}
	
		function reversePainterSortStable( a, b ) {
	
			if ( a.renderOrder !== b.renderOrder ) {
	
				return a.renderOrder - b.renderOrder;
	
			} if ( a.z !== b.z ) {
	
				return b.z - a.z;
	
			} else {
	
				return a.id - b.id;
	
			}
	
		}
	
		function WebGLRenderList() {
	
			var renderItems = [];
			var renderItemsIndex = 0;
	
			var opaque = [];
			var transparent = [];
	
			function init() {
	
				renderItemsIndex = 0;
	
				opaque.length = 0;
				transparent.length = 0;
	
			}
	
			function push( object, geometry, material, z, group ) {
	
				var renderItem = renderItems[ renderItemsIndex ];
	
				if ( renderItem === undefined ) {
	
					renderItem = {
						id: object.id,
						object: object,
						geometry: geometry,
						material: material,
						program: material.program,
						renderOrder: object.renderOrder,
						z: z,
						group: group
					};
	
					renderItems[ renderItemsIndex ] = renderItem;
	
				} else {
	
					renderItem.id = object.id;
					renderItem.object = object;
					renderItem.geometry = geometry;
					renderItem.material = material;
					renderItem.program = material.program;
					renderItem.renderOrder = object.renderOrder;
					renderItem.z = z;
					renderItem.group = group;
	
				}
	
				( material.transparent === true ? transparent : opaque ).push( renderItem );
	
				renderItemsIndex ++;
	
			}
	
			function sort() {
	
				if ( opaque.length > 1 ) opaque.sort( painterSortStable );
				if ( transparent.length > 1 ) transparent.sort( reversePainterSortStable );
	
			}
	
			return {
				opaque: opaque,
				transparent: transparent,
	
				init: init,
				push: push,
	
				sort: sort
			};
	
		}
	
		function WebGLRenderLists() {
	
			var lists = {};
	
			function get( scene, camera ) {
	
				var hash = scene.id + ',' + camera.id;
				var list = lists[ hash ];
	
				if ( list === undefined ) {
	
					// console.log( 'THREE.WebGLRenderLists:', hash );
	
					list = new WebGLRenderList();
					lists[ hash ] = list;
	
				}
	
				return list;
	
			}
	
			function dispose() {
	
				lists = {};
	
			}
	
			return {
				get: get,
				dispose: dispose
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function absNumericalSort( a, b ) {
	
			return Math.abs( b[ 1 ] ) - Math.abs( a[ 1 ] );
	
		}
	
		function WebGLMorphtargets( gl ) {
	
			var influencesList = {};
			var morphInfluences = new Float32Array( 8 );
	
			function update( object, geometry, material, program ) {
	
				var objectInfluences = object.morphTargetInfluences;
	
				var length = objectInfluences.length;
	
				var influences = influencesList[ geometry.id ];
	
				if ( influences === undefined ) {
	
					// initialise list
	
					influences = [];
	
					for ( var i = 0; i < length; i ++ ) {
	
						influences[ i ] = [ i, 0 ];
	
					}
	
					influencesList[ geometry.id ] = influences;
	
				}
	
				var morphTargets = material.morphTargets && geometry.morphAttributes.position;
				var morphNormals = material.morphNormals && geometry.morphAttributes.normal;
	
				// Remove current morphAttributes
	
				for ( var i = 0; i < length; i ++ ) {
	
					var influence = influences[ i ];
	
					if ( influence[ 1 ] !== 0 ) {
	
						if ( morphTargets ) geometry.removeAttribute( 'morphTarget' + i );
						if ( morphNormals ) geometry.removeAttribute( 'morphNormal' + i );
	
					}
	
				}
	
				// Collect influences
	
				for ( var i = 0; i < length; i ++ ) {
	
					var influence = influences[ i ];
	
					influence[ 0 ] = i;
					influence[ 1 ] = objectInfluences[ i ];
	
				}
	
				influences.sort( absNumericalSort );
	
				// Add morphAttributes
	
				for ( var i = 0; i < 8; i ++ ) {
	
					var influence = influences[ i ];
	
					if ( influence ) {
	
						var index = influence[ 0 ];
						var value = influence[ 1 ];
	
						if ( value ) {
	
							if ( morphTargets ) geometry.addAttribute( 'morphTarget' + i, morphTargets[ index ] );
							if ( morphNormals ) geometry.addAttribute( 'morphNormal' + i, morphNormals[ index ] );
	
							morphInfluences[ i ] = value;
							continue;
	
						}
	
					}
	
					morphInfluences[ i ] = 0;
	
				}
	
				program.getUniforms().setValue( gl, 'morphTargetInfluences', morphInfluences );
	
			}
	
			return {
	
				update: update
	
			}
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLIndexedBufferRenderer( gl, extensions, infoRender ) {
	
			var mode;
	
			function setMode( value ) {
	
				mode = value;
	
			}
	
			var type, bytesPerElement;
	
			function setIndex( value ) {
	
				type = value.type;
				bytesPerElement = value.bytesPerElement;
	
			}
	
			function render( start, count ) {
	
				gl.drawElements( mode, count, type, start * bytesPerElement );
	
				infoRender.calls ++;
				infoRender.vertices += count;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;
				else if ( mode === gl.POINTS ) infoRender.points += count;
	
			}
	
			function renderInstances( geometry, start, count ) {
	
				var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
				if ( extension === null ) {
	
					console.error( 'THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
					return;
	
				}
	
				extension.drawElementsInstancedANGLE( mode, count, type, start * bytesPerElement, geometry.maxInstancedCount );
	
				infoRender.calls ++;
				infoRender.vertices += count * geometry.maxInstancedCount;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;
				else if ( mode === gl.POINTS ) infoRender.points += geometry.maxInstancedCount * count;
	
			}
	
			//
	
			this.setMode = setMode;
			this.setIndex = setIndex;
			this.render = render;
			this.renderInstances = renderInstances;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLBufferRenderer( gl, extensions, infoRender ) {
	
			var mode;
	
			function setMode( value ) {
	
				mode = value;
	
			}
	
			function render( start, count ) {
	
				gl.drawArrays( mode, start, count );
	
				infoRender.calls ++;
				infoRender.vertices += count;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;
				else if ( mode === gl.POINTS ) infoRender.points += count;
	
			}
	
			function renderInstances( geometry, start, count ) {
	
				var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
				if ( extension === null ) {
	
					console.error( 'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
					return;
	
				}
	
				var position = geometry.attributes.position;
	
				if ( position.isInterleavedBufferAttribute ) {
	
					count = position.data.count;
	
					extension.drawArraysInstancedANGLE( mode, 0, count, geometry.maxInstancedCount );
	
				} else {
	
					extension.drawArraysInstancedANGLE( mode, start, count, geometry.maxInstancedCount );
	
				}
	
				infoRender.calls ++;
				infoRender.vertices += count * geometry.maxInstancedCount;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;
				else if ( mode === gl.POINTS ) infoRender.points += geometry.maxInstancedCount * count;
	
			}
	
			//
	
			this.setMode = setMode;
			this.render = render;
			this.renderInstances = renderInstances;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLGeometries( gl, attributes, infoMemory ) {
	
			var geometries = {};
			var wireframeAttributes = {};
	
			function onGeometryDispose( event ) {
	
				var geometry = event.target;
				var buffergeometry = geometries[ geometry.id ];
	
				if ( buffergeometry.index !== null ) {
	
					attributes.remove( buffergeometry.index );
	
				}
	
				for ( var name in buffergeometry.attributes ) {
	
					attributes.remove( buffergeometry.attributes[ name ] );
	
				}
	
				geometry.removeEventListener( 'dispose', onGeometryDispose );
	
				delete geometries[ geometry.id ];
	
				// TODO Remove duplicate code
	
				var attribute = wireframeAttributes[ geometry.id ];
	
				if ( attribute ) {
	
					attributes.remove( attribute );
					delete wireframeAttributes[ geometry.id ];
	
				}
	
				attribute = wireframeAttributes[ buffergeometry.id ];
	
				if ( attribute ) {
	
					attributes.remove( attribute );
					delete wireframeAttributes[ buffergeometry.id ];
	
				}
	
				//
	
				infoMemory.geometries --;
	
			}
	
			function get( object, geometry ) {
	
				var buffergeometry = geometries[ geometry.id ];
	
				if ( buffergeometry ) return buffergeometry;
	
				geometry.addEventListener( 'dispose', onGeometryDispose );
	
				if ( geometry.isBufferGeometry ) {
	
					buffergeometry = geometry;
	
				} else if ( geometry.isGeometry ) {
	
					if ( geometry._bufferGeometry === undefined ) {
	
						geometry._bufferGeometry = new BufferGeometry().setFromObject( object );
	
					}
	
					buffergeometry = geometry._bufferGeometry;
	
				}
	
				geometries[ geometry.id ] = buffergeometry;
	
				infoMemory.geometries ++;
	
				return buffergeometry;
	
			}
	
			function update( geometry ) {
	
				var index = geometry.index;
				var geometryAttributes = geometry.attributes;
	
				if ( index !== null ) {
	
					attributes.update( index, gl.ELEMENT_ARRAY_BUFFER );
	
				}
	
				for ( var name in geometryAttributes ) {
	
					attributes.update( geometryAttributes[ name ], gl.ARRAY_BUFFER );
	
				}
	
				// morph targets
	
				var morphAttributes = geometry.morphAttributes;
	
				for ( var name in morphAttributes ) {
	
					var array = morphAttributes[ name ];
	
					for ( var i = 0, l = array.length; i < l; i ++ ) {
	
						attributes.update( array[ i ], gl.ARRAY_BUFFER );
	
					}
	
				}
	
			}
	
			function getWireframeAttribute( geometry ) {
	
				var attribute = wireframeAttributes[ geometry.id ];
	
				if ( attribute ) return attribute;
	
				var indices = [];
	
				var geometryIndex = geometry.index;
				var geometryAttributes = geometry.attributes;
	
				// console.time( 'wireframe' );
	
				if ( geometryIndex !== null ) {
	
					var array = geometryIndex.array;
	
					for ( var i = 0, l = array.length; i < l; i += 3 ) {
	
						var a = array[ i + 0 ];
						var b = array[ i + 1 ];
						var c = array[ i + 2 ];
	
						indices.push( a, b, b, c, c, a );
	
					}
	
				} else {
	
					var array = geometryAttributes.position.array;
	
					for ( var i = 0, l = ( array.length / 3 ) - 1; i < l; i += 3 ) {
	
						var a = i + 0;
						var b = i + 1;
						var c = i + 2;
	
						indices.push( a, b, b, c, c, a );
	
					}
	
				}
	
				// console.timeEnd( 'wireframe' );
	
				attribute = new ( arrayMax( indices ) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 );
	
				attributes.update( attribute, gl.ELEMENT_ARRAY_BUFFER );
	
				wireframeAttributes[ geometry.id ] = attribute;
	
				return attribute;
	
			}
	
			return {
	
				get: get,
				update: update,
	
				getWireframeAttribute: getWireframeAttribute
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function UniformsCache() {
	
			var lights = {};
	
			return {
	
				get: function ( light ) {
	
					if ( lights[ light.id ] !== undefined ) {
	
						return lights[ light.id ];
	
					}
	
					var uniforms;
	
					switch ( light.type ) {
	
						case 'DirectionalLight':
							uniforms = {
								direction: new Vector3(),
								color: new Color(),
	
								shadow: false,
								shadowBias: 0,
								shadowRadius: 1,
								shadowMapSize: new Vector2()
							};
							break;
	
						case 'SpotLight':
							uniforms = {
								position: new Vector3(),
								direction: new Vector3(),
								color: new Color(),
								distance: 0,
								coneCos: 0,
								penumbraCos: 0,
								decay: 0,
	
								shadow: false,
								shadowBias: 0,
								shadowRadius: 1,
								shadowMapSize: new Vector2()
							};
							break;
	
						case 'PointLight':
							uniforms = {
								position: new Vector3(),
								color: new Color(),
								distance: 0,
								decay: 0,
	
								shadow: false,
								shadowBias: 0,
								shadowRadius: 1,
								shadowMapSize: new Vector2(),
								shadowCameraNear: 1,
								shadowCameraFar: 1000
							};
							break;
	
						case 'HemisphereLight':
							uniforms = {
								direction: new Vector3(),
								skyColor: new Color(),
								groundColor: new Color()
							};
							break;
	
						case 'RectAreaLight':
							uniforms = {
								color: new Color(),
								position: new Vector3(),
								halfWidth: new Vector3(),
								halfHeight: new Vector3()
								// TODO (abelnation): set RectAreaLight shadow uniforms
							};
							break;
	
					}
	
					lights[ light.id ] = uniforms;
	
					return uniforms;
	
				}
	
			};
	
		}
	
		function WebGLLights() {
	
			var cache = new UniformsCache();
	
			var state = {
	
				hash: '',
	
				ambient: [ 0, 0, 0 ],
				directional: [],
				directionalShadowMap: [],
				directionalShadowMatrix: [],
				spot: [],
				spotShadowMap: [],
				spotShadowMatrix: [],
				rectArea: [],
				point: [],
				pointShadowMap: [],
				pointShadowMatrix: [],
				hemi: []
	
			};
	
			var vector3 = new Vector3();
			var matrix4 = new Matrix4();
			var matrix42 = new Matrix4();
	
			function setup( lights, shadows, camera ) {
	
				var r = 0, g = 0, b = 0;
	
				var directionalLength = 0;
				var pointLength = 0;
				var spotLength = 0;
				var rectAreaLength = 0;
				var hemiLength = 0;
	
				var viewMatrix = camera.matrixWorldInverse;
	
				for ( var i = 0, l = lights.length; i < l; i ++ ) {
	
					var light = lights[ i ];
	
					var color = light.color;
					var intensity = light.intensity;
					var distance = light.distance;
	
					var shadowMap = ( light.shadow && light.shadow.map ) ? light.shadow.map.texture : null;
	
					if ( light.isAmbientLight ) {
	
						r += color.r * intensity;
						g += color.g * intensity;
						b += color.b * intensity;
	
					} else if ( light.isDirectionalLight ) {
	
						var uniforms = cache.get( light );
	
						uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
						uniforms.direction.setFromMatrixPosition( light.matrixWorld );
						vector3.setFromMatrixPosition( light.target.matrixWorld );
						uniforms.direction.sub( vector3 );
						uniforms.direction.transformDirection( viewMatrix );
	
						uniforms.shadow = light.castShadow;
	
						if ( light.castShadow ) {
	
							var shadow = light.shadow;
	
							uniforms.shadowBias = shadow.bias;
							uniforms.shadowRadius = shadow.radius;
							uniforms.shadowMapSize = shadow.mapSize;
	
						}
	
						state.directionalShadowMap[ directionalLength ] = shadowMap;
						state.directionalShadowMatrix[ directionalLength ] = light.shadow.matrix;
						state.directional[ directionalLength ] = uniforms;
	
						directionalLength ++;
	
					} else if ( light.isSpotLight ) {
	
						var uniforms = cache.get( light );
	
						uniforms.position.setFromMatrixPosition( light.matrixWorld );
						uniforms.position.applyMatrix4( viewMatrix );
	
						uniforms.color.copy( color ).multiplyScalar( intensity );
						uniforms.distance = distance;
	
						uniforms.direction.setFromMatrixPosition( light.matrixWorld );
						vector3.setFromMatrixPosition( light.target.matrixWorld );
						uniforms.direction.sub( vector3 );
						uniforms.direction.transformDirection( viewMatrix );
	
						uniforms.coneCos = Math.cos( light.angle );
						uniforms.penumbraCos = Math.cos( light.angle * ( 1 - light.penumbra ) );
						uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;
	
						uniforms.shadow = light.castShadow;
	
						if ( light.castShadow ) {
	
							var shadow = light.shadow;
	
							uniforms.shadowBias = shadow.bias;
							uniforms.shadowRadius = shadow.radius;
							uniforms.shadowMapSize = shadow.mapSize;
	
						}
	
						state.spotShadowMap[ spotLength ] = shadowMap;
						state.spotShadowMatrix[ spotLength ] = light.shadow.matrix;
						state.spot[ spotLength ] = uniforms;
	
						spotLength ++;
	
					} else if ( light.isRectAreaLight ) {
	
						var uniforms = cache.get( light );
	
						// (a) intensity controls irradiance of entire light
						uniforms.color
							.copy( color )
							.multiplyScalar( intensity / ( light.width * light.height ) );
	
						// (b) intensity controls the radiance per light area
						// uniforms.color.copy( color ).multiplyScalar( intensity );
	
						uniforms.position.setFromMatrixPosition( light.matrixWorld );
						uniforms.position.applyMatrix4( viewMatrix );
	
						// extract local rotation of light to derive width/height half vectors
						matrix42.identity();
						matrix4.copy( light.matrixWorld );
						matrix4.premultiply( viewMatrix );
						matrix42.extractRotation( matrix4 );
	
						uniforms.halfWidth.set( light.width * 0.5,                0.0, 0.0 );
						uniforms.halfHeight.set(              0.0, light.height * 0.5, 0.0 );
	
						uniforms.halfWidth.applyMatrix4( matrix42 );
						uniforms.halfHeight.applyMatrix4( matrix42 );
	
						// TODO (abelnation): RectAreaLight distance?
						// uniforms.distance = distance;
	
						state.rectArea[ rectAreaLength ] = uniforms;
	
						rectAreaLength ++;
	
					} else if ( light.isPointLight ) {
	
						var uniforms = cache.get( light );
	
						uniforms.position.setFromMatrixPosition( light.matrixWorld );
						uniforms.position.applyMatrix4( viewMatrix );
	
						uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
						uniforms.distance = light.distance;
						uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;
	
						uniforms.shadow = light.castShadow;
	
						if ( light.castShadow ) {
	
							var shadow = light.shadow;
	
							uniforms.shadowBias = shadow.bias;
							uniforms.shadowRadius = shadow.radius;
							uniforms.shadowMapSize = shadow.mapSize;
							uniforms.shadowCameraNear = shadow.camera.near;
							uniforms.shadowCameraFar = shadow.camera.far;
	
						}
	
						state.pointShadowMap[ pointLength ] = shadowMap;
						state.pointShadowMatrix[ pointLength ] = light.shadow.matrix;
						state.point[ pointLength ] = uniforms;
	
						pointLength ++;
	
					} else if ( light.isHemisphereLight ) {
	
						var uniforms = cache.get( light );
	
						uniforms.direction.setFromMatrixPosition( light.matrixWorld );
						uniforms.direction.transformDirection( viewMatrix );
						uniforms.direction.normalize();
	
						uniforms.skyColor.copy( light.color ).multiplyScalar( intensity );
						uniforms.groundColor.copy( light.groundColor ).multiplyScalar( intensity );
	
						state.hemi[ hemiLength ] = uniforms;
	
						hemiLength ++;
	
					}
	
				}
	
				state.ambient[ 0 ] = r;
				state.ambient[ 1 ] = g;
				state.ambient[ 2 ] = b;
	
				state.directional.length = directionalLength;
				state.spot.length = spotLength;
				state.rectArea.length = rectAreaLength;
				state.point.length = pointLength;
				state.hemi.length = hemiLength;
	
				// TODO (sam-g-steel) why aren't we using join
				state.hash = directionalLength + ',' + pointLength + ',' + spotLength + ',' + rectAreaLength + ',' + hemiLength + ',' + shadows.length;
	
			}
	
			return {
				setup: setup,
				state: state
			}
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLObjects( geometries, infoRender ) {
	
			var updateList = {};
	
			function update( object ) {
	
				var frame = infoRender.frame;
	
				var geometry = object.geometry;
				var buffergeometry = geometries.get( object, geometry );
	
				// Update once per frame
	
				if ( updateList[ buffergeometry.id ] !== frame ) {
	
					if ( geometry.isGeometry ) {
	
						buffergeometry.updateFromObject( object );
	
					}
	
					geometries.update( buffergeometry );
	
					updateList[ buffergeometry.id ] = frame;
	
				}
	
				return buffergeometry;
	
			}
	
			function clear() {
	
				updateList = {};
	
			}
	
			return {
	
				update: update,
				clear: clear
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function addLineNumbers( string ) {
	
			var lines = string.split( '\n' );
	
			for ( var i = 0; i < lines.length; i ++ ) {
	
				lines[ i ] = ( i + 1 ) + ': ' + lines[ i ];
	
			}
	
			return lines.join( '\n' );
	
		}
	
		function WebGLShader( gl, type, string ) {
	
			var shader = gl.createShader( type );
	
			gl.shaderSource( shader, string );
			gl.compileShader( shader );
	
			if ( gl.getShaderParameter( shader, gl.COMPILE_STATUS ) === false ) {
	
				console.error( 'THREE.WebGLShader: Shader couldn\'t compile.' );
	
			}
	
			if ( gl.getShaderInfoLog( shader ) !== '' ) {
	
				console.warn( 'THREE.WebGLShader: gl.getShaderInfoLog()', type === gl.VERTEX_SHADER ? 'vertex' : 'fragment', gl.getShaderInfoLog( shader ), addLineNumbers( string ) );
	
			}
	
			// --enable-privileged-webgl-extension
			// console.log( type, gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
	
			return shader;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var programIdCount = 0;
	
		function getEncodingComponents( encoding ) {
	
			switch ( encoding ) {
	
				case LinearEncoding:
					return [ 'Linear','( value )' ];
				case sRGBEncoding:
					return [ 'sRGB','( value )' ];
				case RGBEEncoding:
					return [ 'RGBE','( value )' ];
				case RGBM7Encoding:
					return [ 'RGBM','( value, 7.0 )' ];
				case RGBM16Encoding:
					return [ 'RGBM','( value, 16.0 )' ];
				case RGBDEncoding:
					return [ 'RGBD','( value, 256.0 )' ];
				case GammaEncoding:
					return [ 'Gamma','( value, float( GAMMA_FACTOR ) )' ];
				default:
					throw new Error( 'unsupported encoding: ' + encoding );
	
			}
	
		}
	
		function getTexelDecodingFunction( functionName, encoding ) {
	
			var components = getEncodingComponents( encoding );
			return "vec4 " + functionName + "( vec4 value ) { return " + components[ 0 ] + "ToLinear" + components[ 1 ] + "; }";
	
		}
	
		function getTexelEncodingFunction( functionName, encoding ) {
	
			var components = getEncodingComponents( encoding );
			return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[ 0 ] + components[ 1 ] + "; }";
	
		}
	
		function getToneMappingFunction( functionName, toneMapping ) {
	
			var toneMappingName;
	
			switch ( toneMapping ) {
	
				case LinearToneMapping:
					toneMappingName = "Linear";
					break;
	
				case ReinhardToneMapping:
					toneMappingName = "Reinhard";
					break;
	
				case Uncharted2ToneMapping:
					toneMappingName = "Uncharted2";
					break;
	
				case CineonToneMapping:
					toneMappingName = "OptimizedCineon";
					break;
	
				default:
					throw new Error( 'unsupported toneMapping: ' + toneMapping );
	
			}
	
			return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
	
		}
	
		function generateExtensions( extensions, parameters, rendererExtensions ) {
	
			extensions = extensions || {};
	
			var chunks = [
				( extensions.derivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.normalMap || parameters.flatShading ) ? '#extension GL_OES_standard_derivatives : enable' : '',
				( extensions.fragDepth || parameters.logarithmicDepthBuffer ) && rendererExtensions.get( 'EXT_frag_depth' ) ? '#extension GL_EXT_frag_depth : enable' : '',
				( extensions.drawBuffers ) && rendererExtensions.get( 'WEBGL_draw_buffers' ) ? '#extension GL_EXT_draw_buffers : require' : '',
				( extensions.shaderTextureLOD || parameters.envMap ) && rendererExtensions.get( 'EXT_shader_texture_lod' ) ? '#extension GL_EXT_shader_texture_lod : enable' : ''
			];
	
			return chunks.filter( filterEmptyLine ).join( '\n' );
	
		}
	
		function generateDefines( defines ) {
	
			var chunks = [];
	
			for ( var name in defines ) {
	
				var value = defines[ name ];
	
				if ( value === false ) continue;
	
				chunks.push( '#define ' + name + ' ' + value );
	
			}
	
			return chunks.join( '\n' );
	
		}
	
		function fetchAttributeLocations( gl, program, identifiers ) {
	
			var attributes = {};
	
			var n = gl.getProgramParameter( program, gl.ACTIVE_ATTRIBUTES );
	
			for ( var i = 0; i < n; i ++ ) {
	
				var info = gl.getActiveAttrib( program, i );
				var name = info.name;
	
				// console.log("THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:", name, i );
	
				attributes[ name ] = gl.getAttribLocation( program, name );
	
			}
	
			return attributes;
	
		}
	
		function filterEmptyLine( string ) {
	
			return string !== '';
	
		}
	
		function replaceLightNums( string, parameters ) {
	
			return string
				.replace( /NUM_DIR_LIGHTS/g, parameters.numDirLights )
				.replace( /NUM_SPOT_LIGHTS/g, parameters.numSpotLights )
				.replace( /NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights )
				.replace( /NUM_POINT_LIGHTS/g, parameters.numPointLights )
				.replace( /NUM_HEMI_LIGHTS/g, parameters.numHemiLights );
	
		}
	
		function parseIncludes( string ) {
	
			var pattern = /^[ \t]*#include +<([\w\d.]+)>/gm;
	
			function replace( match, include ) {
	
				var replace = ShaderChunk[ include ];
	
				if ( replace === undefined ) {
	
					throw new Error( 'Can not resolve #include <' + include + '>' );
	
				}
	
				return parseIncludes( replace );
	
			}
	
			return string.replace( pattern, replace );
	
		}
	
		function unrollLoops( string ) {
	
			var pattern = /for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
	
			function replace( match, start, end, snippet ) {
	
				var unroll = '';
	
				for ( var i = parseInt( start ); i < parseInt( end ); i ++ ) {
	
					unroll += snippet.replace( /\[ i \]/g, '[ ' + i + ' ]' );
	
				}
	
				return unroll;
	
			}
	
			return string.replace( pattern, replace );
	
		}
	
		function WebGLProgram( renderer, extensions, code, material, shader, parameters ) {
	
			var gl = renderer.context;
	
			var defines = material.defines;
	
			var vertexShader = shader.vertexShader;
			var fragmentShader = shader.fragmentShader;
	
			var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
	
			if ( parameters.shadowMapType === PCFShadowMap ) {
	
				shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
	
			} else if ( parameters.shadowMapType === PCFSoftShadowMap ) {
	
				shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
	
			}
	
			var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
			var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
			var envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
	
			if ( parameters.envMap ) {
	
				switch ( material.envMap.mapping ) {
	
					case CubeReflectionMapping:
					case CubeRefractionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
						break;
	
					case CubeUVReflectionMapping:
					case CubeUVRefractionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
						break;
	
					case EquirectangularReflectionMapping:
					case EquirectangularRefractionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_EQUIREC';
						break;
	
					case SphericalReflectionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_SPHERE';
						break;
	
				}
	
				switch ( material.envMap.mapping ) {
	
					case CubeRefractionMapping:
					case EquirectangularRefractionMapping:
						envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
						break;
	
				}
	
				switch ( material.combine ) {
	
					case MultiplyOperation:
						envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
						break;
	
					case MixOperation:
						envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
						break;
	
					case AddOperation:
						envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
						break;
	
				}
	
			}
	
			var gammaFactorDefine = ( renderer.gammaFactor > 0 ) ? renderer.gammaFactor : 1.0;
	
			// console.log( 'building new program ' );
	
			//
	
			var customExtensions = generateExtensions( material.extensions, parameters, extensions );
	
			var customDefines = generateDefines( defines );
	
			//
	
			var program = gl.createProgram();
	
			var prefixVertex, prefixFragment;
	
			if ( material.isRawShaderMaterial ) {
	
				prefixVertex = [
	
					customDefines,
	
					'\n'
	
				].filter( filterEmptyLine ).join( '\n' );
	
				prefixFragment = [
	
					customExtensions,
					customDefines,
	
					'\n'
	
				].filter( filterEmptyLine ).join( '\n' );
	
			} else {
	
				prefixVertex = [
	
					'precision ' + parameters.precision + ' float;',
					'precision ' + parameters.precision + ' int;',
	
					'#define SHADER_NAME ' + shader.name,
	
					customDefines,
	
					parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',
	
					'#define GAMMA_FACTOR ' + gammaFactorDefine,
	
					'#define MAX_BONES ' + parameters.maxBones,
					( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
					( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',
	
					parameters.map ? '#define USE_MAP' : '',
					parameters.envMap ? '#define USE_ENVMAP' : '',
					parameters.envMap ? '#define ' + envMapModeDefine : '',
					parameters.lightMap ? '#define USE_LIGHTMAP' : '',
					parameters.aoMap ? '#define USE_AOMAP' : '',
					parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
					parameters.bumpMap ? '#define USE_BUMPMAP' : '',
					parameters.normalMap ? '#define USE_NORMALMAP' : '',
					parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
					parameters.specularMap ? '#define USE_SPECULARMAP' : '',
					parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
					parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
					parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
					parameters.vertexColors ? '#define USE_COLOR' : '',
	
					parameters.flatShading ? '#define FLAT_SHADED' : '',
	
					parameters.skinning ? '#define USE_SKINNING' : '',
					parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',
	
					parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
					parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
					parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
					parameters.flipSided ? '#define FLIP_SIDED' : '',
	
					'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,
	
					parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
					parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
	
					parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
	
					parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
					parameters.logarithmicDepthBuffer && extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',
	
					'uniform mat4 modelMatrix;',
					'uniform mat4 modelViewMatrix;',
					'uniform mat4 projectionMatrix;',
					'uniform mat4 viewMatrix;',
					'uniform mat3 normalMatrix;',
					'uniform vec3 cameraPosition;',
	
					'attribute vec3 position;',
					'attribute vec3 normal;',
					'attribute vec2 uv;',
	
					'#ifdef USE_COLOR',
	
					'	attribute vec3 color;',
	
					'#endif',
	
					'#ifdef USE_MORPHTARGETS',
	
					'	attribute vec3 morphTarget0;',
					'	attribute vec3 morphTarget1;',
					'	attribute vec3 morphTarget2;',
					'	attribute vec3 morphTarget3;',
	
					'	#ifdef USE_MORPHNORMALS',
	
					'		attribute vec3 morphNormal0;',
					'		attribute vec3 morphNormal1;',
					'		attribute vec3 morphNormal2;',
					'		attribute vec3 morphNormal3;',
	
					'	#else',
	
					'		attribute vec3 morphTarget4;',
					'		attribute vec3 morphTarget5;',
					'		attribute vec3 morphTarget6;',
					'		attribute vec3 morphTarget7;',
	
					'	#endif',
	
					'#endif',
	
					'#ifdef USE_SKINNING',
	
					'	attribute vec4 skinIndex;',
					'	attribute vec4 skinWeight;',
	
					'#endif',
	
					'\n'
	
				].filter( filterEmptyLine ).join( '\n' );
	
				prefixFragment = [
	
					customExtensions,
	
					'precision ' + parameters.precision + ' float;',
					'precision ' + parameters.precision + ' int;',
	
					'#define SHADER_NAME ' + shader.name,
	
					customDefines,
	
					parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest : '',
	
					'#define GAMMA_FACTOR ' + gammaFactorDefine,
	
					( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
					( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',
	
					parameters.map ? '#define USE_MAP' : '',
					parameters.envMap ? '#define USE_ENVMAP' : '',
					parameters.envMap ? '#define ' + envMapTypeDefine : '',
					parameters.envMap ? '#define ' + envMapModeDefine : '',
					parameters.envMap ? '#define ' + envMapBlendingDefine : '',
					parameters.lightMap ? '#define USE_LIGHTMAP' : '',
					parameters.aoMap ? '#define USE_AOMAP' : '',
					parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
					parameters.bumpMap ? '#define USE_BUMPMAP' : '',
					parameters.normalMap ? '#define USE_NORMALMAP' : '',
					parameters.specularMap ? '#define USE_SPECULARMAP' : '',
					parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
					parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
					parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
					parameters.vertexColors ? '#define USE_COLOR' : '',
	
					parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
	
					parameters.flatShading ? '#define FLAT_SHADED' : '',
	
					parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
					parameters.flipSided ? '#define FLIP_SIDED' : '',
	
					'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,
					'#define UNION_CLIPPING_PLANES ' + (parameters.numClippingPlanes - parameters.numClipIntersection),
	
					parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
					parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
	
					parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : '',
	
					parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : '',
	
					parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
					parameters.logarithmicDepthBuffer && extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',
	
					parameters.envMap && extensions.get( 'EXT_shader_texture_lod' ) ? '#define TEXTURE_LOD_EXT' : '',
	
					'uniform mat4 viewMatrix;',
					'uniform vec3 cameraPosition;',
	
					( parameters.toneMapping !== NoToneMapping ) ? "#define TONE_MAPPING" : '',
					( parameters.toneMapping !== NoToneMapping ) ? ShaderChunk[ 'tonemapping_pars_fragment' ] : '',  // this code is required here because it is used by the toneMapping() function defined below
					( parameters.toneMapping !== NoToneMapping ) ? getToneMappingFunction( "toneMapping", parameters.toneMapping ) : '',
	
					parameters.dithering ? '#define DITHERING' : '',
	
					( parameters.outputEncoding || parameters.mapEncoding || parameters.envMapEncoding || parameters.emissiveMapEncoding ) ? ShaderChunk[ 'encodings_pars_fragment' ] : '', // this code is required here because it is used by the various encoding/decoding function defined below
					parameters.mapEncoding ? getTexelDecodingFunction( 'mapTexelToLinear', parameters.mapEncoding ) : '',
					parameters.envMapEncoding ? getTexelDecodingFunction( 'envMapTexelToLinear', parameters.envMapEncoding ) : '',
					parameters.emissiveMapEncoding ? getTexelDecodingFunction( 'emissiveMapTexelToLinear', parameters.emissiveMapEncoding ) : '',
					parameters.outputEncoding ? getTexelEncodingFunction( "linearToOutputTexel", parameters.outputEncoding ) : '',
	
					parameters.depthPacking ? "#define DEPTH_PACKING " + material.depthPacking : '',
	
					'\n'
	
				].filter( filterEmptyLine ).join( '\n' );
	
			}
	
			vertexShader = parseIncludes( vertexShader );
			vertexShader = replaceLightNums( vertexShader, parameters );
	
			fragmentShader = parseIncludes( fragmentShader );
			fragmentShader = replaceLightNums( fragmentShader, parameters );
	
			if ( ! material.isShaderMaterial ) {
	
				vertexShader = unrollLoops( vertexShader );
				fragmentShader = unrollLoops( fragmentShader );
	
			}
	
			var vertexGlsl = prefixVertex + vertexShader;
			var fragmentGlsl = prefixFragment + fragmentShader;
	
			// console.log( '*VERTEX*', vertexGlsl );
			// console.log( '*FRAGMENT*', fragmentGlsl );
	
			var glVertexShader = WebGLShader( gl, gl.VERTEX_SHADER, vertexGlsl );
			var glFragmentShader = WebGLShader( gl, gl.FRAGMENT_SHADER, fragmentGlsl );
	
			gl.attachShader( program, glVertexShader );
			gl.attachShader( program, glFragmentShader );
	
			// Force a particular attribute to index 0.
	
			if ( material.index0AttributeName !== undefined ) {
	
				gl.bindAttribLocation( program, 0, material.index0AttributeName );
	
			} else if ( parameters.morphTargets === true ) {
	
				// programs with morphTargets displace position out of attribute 0
				gl.bindAttribLocation( program, 0, 'position' );
	
			}
	
			gl.linkProgram( program );
	
			var programLog = gl.getProgramInfoLog( program );
			var vertexLog = gl.getShaderInfoLog( glVertexShader );
			var fragmentLog = gl.getShaderInfoLog( glFragmentShader );
	
			var runnable = true;
			var haveDiagnostics = true;
	
			// console.log( '**VERTEX**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glVertexShader ) );
			// console.log( '**FRAGMENT**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glFragmentShader ) );
	
			if ( gl.getProgramParameter( program, gl.LINK_STATUS ) === false ) {
	
				runnable = false;
	
				console.error( 'THREE.WebGLProgram: shader error: ', gl.getError(), 'gl.VALIDATE_STATUS', gl.getProgramParameter( program, gl.VALIDATE_STATUS ), 'gl.getProgramInfoLog', programLog, vertexLog, fragmentLog );
	
			} else if ( programLog !== '' ) {
	
				console.warn( 'THREE.WebGLProgram: gl.getProgramInfoLog()', programLog );
	
			} else if ( vertexLog === '' || fragmentLog === '' ) {
	
				haveDiagnostics = false;
	
			}
	
			if ( haveDiagnostics ) {
	
				this.diagnostics = {
	
					runnable: runnable,
					material: material,
	
					programLog: programLog,
	
					vertexShader: {
	
						log: vertexLog,
						prefix: prefixVertex
	
					},
	
					fragmentShader: {
	
						log: fragmentLog,
						prefix: prefixFragment
	
					}
	
				};
	
			}
	
			// clean up
	
			gl.deleteShader( glVertexShader );
			gl.deleteShader( glFragmentShader );
	
			// set up caching for uniform locations
	
			var cachedUniforms;
	
			this.getUniforms = function () {
	
				if ( cachedUniforms === undefined ) {
	
					cachedUniforms = new WebGLUniforms( gl, program, renderer );
	
				}
	
				return cachedUniforms;
	
			};
	
			// set up caching for attribute locations
	
			var cachedAttributes;
	
			this.getAttributes = function () {
	
				if ( cachedAttributes === undefined ) {
	
					cachedAttributes = fetchAttributeLocations( gl, program );
	
				}
	
				return cachedAttributes;
	
			};
	
			// free resource
	
			this.destroy = function() {
	
				gl.deleteProgram( program );
				this.program = undefined;
	
			};
	
			// DEPRECATED
	
			Object.defineProperties( this, {
	
				uniforms: {
					get: function() {
	
						console.warn( 'THREE.WebGLProgram: .uniforms is now .getUniforms().' );
						return this.getUniforms();
	
					}
				},
	
				attributes: {
					get: function() {
	
						console.warn( 'THREE.WebGLProgram: .attributes is now .getAttributes().' );
						return this.getAttributes();
	
					}
				}
	
			} );
	
	
			//
	
			this.id = programIdCount ++;
			this.code = code;
			this.usedTimes = 1;
			this.program = program;
			this.vertexShader = glVertexShader;
			this.fragmentShader = glFragmentShader;
	
			return this;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLPrograms( renderer, extensions, capabilities ) {
	
			var programs = [];
	
			var shaderIDs = {
				MeshDepthMaterial: 'depth',
				MeshDistanceMaterial: 'distanceRGBA',
				MeshNormalMaterial: 'normal',
				MeshBasicMaterial: 'basic',
				MeshLambertMaterial: 'lambert',
				MeshPhongMaterial: 'phong',
				MeshToonMaterial: 'phong',
				MeshStandardMaterial: 'physical',
				MeshPhysicalMaterial: 'physical',
				LineBasicMaterial: 'basic',
				LineDashedMaterial: 'dashed',
				PointsMaterial: 'points',
				ShadowMaterial: 'shadow'
			};
	
			var parameterNames = [
				"precision", "supportsVertexTextures", "map", "mapEncoding", "envMap", "envMapMode", "envMapEncoding",
				"lightMap", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "displacementMap", "specularMap",
				"roughnessMap", "metalnessMap", "gradientMap",
				"alphaMap", "combine", "vertexColors", "fog", "useFog", "fogExp",
				"flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning",
				"maxBones", "useVertexTexture", "morphTargets", "morphNormals",
				"maxMorphTargets", "maxMorphNormals", "premultipliedAlpha",
				"numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights",
				"shadowMapEnabled", "shadowMapType", "toneMapping", 'physicallyCorrectLights',
				"alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking", "dithering"
			];
	
	
			function allocateBones( object ) {
	
				var skeleton = object.skeleton;
				var bones = skeleton.bones;
	
				if ( capabilities.floatVertexTextures ) {
	
					return 1024;
	
				} else {
	
					// default for when object is not specified
					// ( for example when prebuilding shader to be used with multiple objects )
					//
					//  - leave some extra space for other uniforms
					//  - limit here is ANGLE's 254 max uniform vectors
					//    (up to 54 should be safe)
	
					var nVertexUniforms = capabilities.maxVertexUniforms;
					var nVertexMatrices = Math.floor( ( nVertexUniforms - 20 ) / 4 );
	
					var maxBones = Math.min( nVertexMatrices, bones.length );
	
					if ( maxBones < bones.length ) {
	
						console.warn( 'THREE.WebGLRenderer: Skeleton has ' + bones.length + ' bones. This GPU supports ' + maxBones + '.' );
						return 0;
	
					}
	
					return maxBones;
	
				}
	
			}
	
			function getTextureEncodingFromMap( map, gammaOverrideLinear ) {
	
				var encoding;
	
				if ( ! map ) {
	
					encoding = LinearEncoding;
	
				} else if ( map.isTexture ) {
	
					encoding = map.encoding;
	
				} else if ( map.isWebGLRenderTarget ) {
	
					console.warn( "THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead." );
					encoding = map.texture.encoding;
	
				}
	
				// add backwards compatibility for WebGLRenderer.gammaInput/gammaOutput parameter, should probably be removed at some point.
				if ( encoding === LinearEncoding && gammaOverrideLinear ) {
	
					encoding = GammaEncoding;
	
				}
	
				return encoding;
	
			}
	
			this.getParameters = function ( material, lights, shadows, fog, nClipPlanes, nClipIntersection, object ) {
	
				var shaderID = shaderIDs[ material.type ];
	
				// heuristics to create shader parameters according to lights in the scene
				// (not to blow over maxLights budget)
	
				var maxBones = object.isSkinnedMesh ? allocateBones( object ) : 0;
				var precision = capabilities.precision;
	
				if ( material.precision !== null ) {
	
					precision = capabilities.getMaxPrecision( material.precision );
	
					if ( precision !== material.precision ) {
	
						console.warn( 'THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.' );
	
					}
	
				}
	
				var currentRenderTarget = renderer.getRenderTarget();
	
				var parameters = {
	
					shaderID: shaderID,
	
					precision: precision,
					supportsVertexTextures: capabilities.vertexTextures,
					outputEncoding: getTextureEncodingFromMap( ( ! currentRenderTarget ) ? null : currentRenderTarget.texture, renderer.gammaOutput ),
					map: !! material.map,
					mapEncoding: getTextureEncodingFromMap( material.map, renderer.gammaInput ),
					envMap: !! material.envMap,
					envMapMode: material.envMap && material.envMap.mapping,
					envMapEncoding: getTextureEncodingFromMap( material.envMap, renderer.gammaInput ),
					envMapCubeUV: ( !! material.envMap ) && ( ( material.envMap.mapping === CubeUVReflectionMapping ) || ( material.envMap.mapping === CubeUVRefractionMapping ) ),
					lightMap: !! material.lightMap,
					aoMap: !! material.aoMap,
					emissiveMap: !! material.emissiveMap,
					emissiveMapEncoding: getTextureEncodingFromMap( material.emissiveMap, renderer.gammaInput ),
					bumpMap: !! material.bumpMap,
					normalMap: !! material.normalMap,
					displacementMap: !! material.displacementMap,
					roughnessMap: !! material.roughnessMap,
					metalnessMap: !! material.metalnessMap,
					specularMap: !! material.specularMap,
					alphaMap: !! material.alphaMap,
	
					gradientMap: !! material.gradientMap,
	
					combine: material.combine,
	
					vertexColors: material.vertexColors,
	
					fog: !! fog,
					useFog: material.fog,
					fogExp: ( fog && fog.isFogExp2 ),
	
					flatShading: material.flatShading,
	
					sizeAttenuation: material.sizeAttenuation,
					logarithmicDepthBuffer: capabilities.logarithmicDepthBuffer,
	
					skinning: material.skinning && maxBones > 0,
					maxBones: maxBones,
					useVertexTexture: capabilities.floatVertexTextures,
	
					morphTargets: material.morphTargets,
					morphNormals: material.morphNormals,
					maxMorphTargets: renderer.maxMorphTargets,
					maxMorphNormals: renderer.maxMorphNormals,
	
					numDirLights: lights.directional.length,
					numPointLights: lights.point.length,
					numSpotLights: lights.spot.length,
					numRectAreaLights: lights.rectArea.length,
					numHemiLights: lights.hemi.length,
	
					numClippingPlanes: nClipPlanes,
					numClipIntersection: nClipIntersection,
	
					dithering: material.dithering,
	
					shadowMapEnabled: renderer.shadowMap.enabled && object.receiveShadow && shadows.length > 0,
					shadowMapType: renderer.shadowMap.type,
	
					toneMapping: renderer.toneMapping,
					physicallyCorrectLights: renderer.physicallyCorrectLights,
	
					premultipliedAlpha: material.premultipliedAlpha,
	
					alphaTest: material.alphaTest,
					doubleSided: material.side === DoubleSide,
					flipSided: material.side === BackSide,
	
					depthPacking: ( material.depthPacking !== undefined ) ? material.depthPacking : false
	
				};
	
				return parameters;
	
			};
	
			this.getProgramCode = function ( material, parameters ) {
	
				var array = [];
	
				if ( parameters.shaderID ) {
	
					array.push( parameters.shaderID );
	
				} else {
	
					array.push( material.fragmentShader );
					array.push( material.vertexShader );
	
				}
	
				if ( material.defines !== undefined ) {
	
					for ( var name in material.defines ) {
	
						array.push( name );
						array.push( material.defines[ name ] );
	
					}
	
				}
	
				for ( var i = 0; i < parameterNames.length; i ++ ) {
	
					array.push( parameters[ parameterNames[ i ] ] );
	
				}
	
				array.push( material.onBeforeCompile.toString() );
	
				array.push( renderer.gammaOutput );
	
				return array.join();
	
			};
	
			this.acquireProgram = function ( material, shader, parameters, code ) {
	
				var program;
	
				// Check if code has been already compiled
				for ( var p = 0, pl = programs.length; p < pl; p ++ ) {
	
					var programInfo = programs[ p ];
	
					if ( programInfo.code === code ) {
	
						program = programInfo;
						++ program.usedTimes;
	
						break;
	
					}
	
				}
	
				if ( program === undefined ) {
	
					program = new WebGLProgram( renderer, extensions, code, material, shader, parameters );
					programs.push( program );
	
				}
	
				return program;
	
			};
	
			this.releaseProgram = function ( program ) {
	
				if ( -- program.usedTimes === 0 ) {
	
					// Remove from unordered set
					var i = programs.indexOf( program );
					programs[ i ] = programs[ programs.length - 1 ];
					programs.pop();
	
					// Free WebGL resources
					program.destroy();
	
				}
	
			};
	
			// Exposed for resource monitoring & error feedback via renderer.info:
			this.programs = programs;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLTextures( _gl, extensions, state, properties, capabilities, utils, infoMemory ) {
	
			var _isWebGL2 = ( typeof WebGL2RenderingContext !== 'undefined' && _gl instanceof WebGL2RenderingContext );
	
			//
	
			function clampToMaxSize( image, maxSize ) {
	
				if ( image.width > maxSize || image.height > maxSize ) {
	
					// Warning: Scaling through the canvas will only work with images that use
					// premultiplied alpha.
	
					var scale = maxSize / Math.max( image.width, image.height );
	
					var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
					canvas.width = Math.floor( image.width * scale );
					canvas.height = Math.floor( image.height * scale );
	
					var context = canvas.getContext( '2d' );
					context.drawImage( image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height );
	
					console.warn( 'THREE.WebGLRenderer: image is too big (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );
	
					return canvas;
	
				}
	
				return image;
	
			}
	
			function isPowerOfTwo( image ) {
	
				return _Math.isPowerOfTwo( image.width ) && _Math.isPowerOfTwo( image.height );
	
			}
	
			function makePowerOfTwo( image ) {
	
				if ( image instanceof HTMLImageElement || image instanceof HTMLCanvasElement ) {
	
					var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
					canvas.width = _Math.nearestPowerOfTwo( image.width );
					canvas.height = _Math.nearestPowerOfTwo( image.height );
	
					var context = canvas.getContext( '2d' );
					context.drawImage( image, 0, 0, canvas.width, canvas.height );
	
					console.warn( 'THREE.WebGLRenderer: image is not power of two (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );
	
					return canvas;
	
				}
	
				return image;
	
			}
	
			function textureNeedsPowerOfTwo( texture ) {
	
				return ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) ||
					( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter );
	
			}
	
			function textureNeedsGenerateMipmaps( texture, isPowerOfTwo ) {
	
				return texture.generateMipmaps && isPowerOfTwo &&
					texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
	
			}
	
			// Fallback filters for non-power-of-2 textures
	
			function filterFallback( f ) {
	
				if ( f === NearestFilter || f === NearestMipMapNearestFilter || f === NearestMipMapLinearFilter ) {
	
					return _gl.NEAREST;
	
				}
	
				return _gl.LINEAR;
	
			}
	
			//
	
			function onTextureDispose( event ) {
	
				var texture = event.target;
	
				texture.removeEventListener( 'dispose', onTextureDispose );
	
				deallocateTexture( texture );
	
				infoMemory.textures --;
	
	
			}
	
			function onRenderTargetDispose( event ) {
	
				var renderTarget = event.target;
	
				renderTarget.removeEventListener( 'dispose', onRenderTargetDispose );
	
				deallocateRenderTarget( renderTarget );
	
				infoMemory.textures --;
	
			}
	
			//
	
			function deallocateTexture( texture ) {
	
				var textureProperties = properties.get( texture );
	
				if ( texture.image && textureProperties.__image__webglTextureCube ) {
	
					// cube texture
	
					_gl.deleteTexture( textureProperties.__image__webglTextureCube );
	
				} else {
	
					// 2D texture
	
					if ( textureProperties.__webglInit === undefined ) return;
	
					_gl.deleteTexture( textureProperties.__webglTexture );
	
				}
	
				// remove all webgl properties
				properties.remove( texture );
	
			}
	
			function deallocateRenderTarget( renderTarget ) {
	
				var renderTargetProperties = properties.get( renderTarget );
				var textureProperties = properties.get( renderTarget.texture );
	
				if ( ! renderTarget ) return;
	
				if ( textureProperties.__webglTexture !== undefined ) {
	
					_gl.deleteTexture( textureProperties.__webglTexture );
	
				}
	
				if ( renderTarget.depthTexture ) {
	
					renderTarget.depthTexture.dispose();
	
				}
	
				if ( renderTarget.isWebGLRenderTargetCube ) {
	
					for ( var i = 0; i < 6; i ++ ) {
	
						_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ] );
						if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer[ i ] );
	
					}
	
				} else {
	
					_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer );
					if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer );
	
				}
	
				properties.remove( renderTarget.texture );
				properties.remove( renderTarget );
	
			}
	
			//
	
	
	
			function setTexture2D( texture, slot ) {
	
				var textureProperties = properties.get( texture );
	
				if ( texture.version > 0 && textureProperties.__version !== texture.version ) {
	
					var image = texture.image;
	
					if ( image === undefined ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is undefined', texture );
	
					} else if ( image.complete === false ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is incomplete', texture );
	
					} else {
	
						uploadTexture( textureProperties, texture, slot );
						return;
	
					}
	
				}
	
				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
	
			}
	
			function setTextureCube( texture, slot ) {
	
				var textureProperties = properties.get( texture );
	
				if ( texture.image.length === 6 ) {
	
					if ( texture.version > 0 && textureProperties.__version !== texture.version ) {
	
						if ( ! textureProperties.__image__webglTextureCube ) {
	
							texture.addEventListener( 'dispose', onTextureDispose );
	
							textureProperties.__image__webglTextureCube = _gl.createTexture();
	
							infoMemory.textures ++;
	
						}
	
						state.activeTexture( _gl.TEXTURE0 + slot );
						state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );
	
						_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
	
						var isCompressed = ( texture && texture.isCompressedTexture );
						var isDataTexture = ( texture.image[ 0 ] && texture.image[ 0 ].isDataTexture );
	
						var cubeImage = [];
	
						for ( var i = 0; i < 6; i ++ ) {
	
							if ( ! isCompressed && ! isDataTexture ) {
	
								cubeImage[ i ] = clampToMaxSize( texture.image[ i ], capabilities.maxCubemapSize );
	
							} else {
	
								cubeImage[ i ] = isDataTexture ? texture.image[ i ].image : texture.image[ i ];
	
							}
	
						}
	
						var image = cubeImage[ 0 ],
						isPowerOfTwoImage = isPowerOfTwo( image ),
						glFormat = utils.convert( texture.format ),
						glType = utils.convert( texture.type );
	
						setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture, isPowerOfTwoImage );
	
						for ( var i = 0; i < 6; i ++ ) {
	
							if ( ! isCompressed ) {
	
								if ( isDataTexture ) {
	
									state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, cubeImage[ i ].width, cubeImage[ i ].height, 0, glFormat, glType, cubeImage[ i ].data );
	
								} else {
	
									state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, glFormat, glType, cubeImage[ i ] );
	
								}
	
							} else {
	
								var mipmap, mipmaps = cubeImage[ i ].mipmaps;
	
								for ( var j = 0, jl = mipmaps.length; j < jl; j ++ ) {
	
									mipmap = mipmaps[ j ];
	
									if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {
	
										if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {
	
											state.compressedTexImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );
	
										} else {
	
											console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()' );
	
										}
	
									} else {
	
										state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );
	
									}
	
								}
	
							}
	
						}
	
						if ( textureNeedsGenerateMipmaps( texture, isPowerOfTwoImage ) ) {
	
							_gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );
	
						}
	
						textureProperties.__version = texture.version;
	
						if ( texture.onUpdate ) texture.onUpdate( texture );
	
					} else {
	
						state.activeTexture( _gl.TEXTURE0 + slot );
						state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );
	
					}
	
				}
	
			}
	
			function setTextureCubeDynamic( texture, slot ) {
	
				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_CUBE_MAP, properties.get( texture ).__webglTexture );
	
			}
	
			function setTextureParameters( textureType, texture, isPowerOfTwoImage ) {
	
				var extension;
	
				if ( isPowerOfTwoImage ) {
	
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, utils.convert( texture.wrapS ) );
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, utils.convert( texture.wrapT ) );
	
					_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, utils.convert( texture.magFilter ) );
					_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, utils.convert( texture.minFilter ) );
	
				} else {
	
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE );
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE );
	
					if ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.', texture );
	
					}
	
					_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, filterFallback( texture.magFilter ) );
					_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, filterFallback( texture.minFilter ) );
	
					if ( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.', texture );
	
					}
	
				}
	
				extension = extensions.get( 'EXT_texture_filter_anisotropic' );
	
				if ( extension ) {
	
					if ( texture.type === FloatType && extensions.get( 'OES_texture_float_linear' ) === null ) return;
					if ( texture.type === HalfFloatType && extensions.get( 'OES_texture_half_float_linear' ) === null ) return;
	
					if ( texture.anisotropy > 1 || properties.get( texture ).__currentAnisotropy ) {
	
						_gl.texParameterf( textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min( texture.anisotropy, capabilities.getMaxAnisotropy() ) );
						properties.get( texture ).__currentAnisotropy = texture.anisotropy;
	
					}
	
				}
	
			}
	
			function uploadTexture( textureProperties, texture, slot ) {
	
				if ( textureProperties.__webglInit === undefined ) {
	
					textureProperties.__webglInit = true;
	
					texture.addEventListener( 'dispose', onTextureDispose );
	
					textureProperties.__webglTexture = _gl.createTexture();
	
					infoMemory.textures ++;
	
				}
	
				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
	
				_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
				_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
				_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );
	
				var image = clampToMaxSize( texture.image, capabilities.maxTextureSize );
	
				if ( textureNeedsPowerOfTwo( texture ) && isPowerOfTwo( image ) === false ) {
	
					image = makePowerOfTwo( image );
	
				}
	
				var isPowerOfTwoImage = isPowerOfTwo( image ),
				glFormat = utils.convert( texture.format ),
				glType = utils.convert( texture.type );
	
				setTextureParameters( _gl.TEXTURE_2D, texture, isPowerOfTwoImage );
	
				var mipmap, mipmaps = texture.mipmaps;
	
				if ( texture.isDepthTexture ) {
	
					// populate depth texture with dummy data
	
					var internalFormat = _gl.DEPTH_COMPONENT;
	
					if ( texture.type === FloatType ) {
	
						if ( !_isWebGL2 ) throw new Error('Float Depth Texture only supported in WebGL2.0');
						internalFormat = _gl.DEPTH_COMPONENT32F;
	
					} else if ( _isWebGL2 ) {
	
						// WebGL 2.0 requires signed internalformat for glTexImage2D
						internalFormat = _gl.DEPTH_COMPONENT16;
	
					}
	
					if ( texture.format === DepthFormat && internalFormat === _gl.DEPTH_COMPONENT ) {
	
						// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
						// DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
						// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
						if ( texture.type !== UnsignedShortType && texture.type !== UnsignedIntType ) {
	
						        console.warn( 'THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.' );
	
							texture.type = UnsignedShortType;
							glType = utils.convert( texture.type );
	
						}
	
					}
	
					// Depth stencil textures need the DEPTH_STENCIL internal format
					// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
					if ( texture.format === DepthStencilFormat ) {
	
						internalFormat = _gl.DEPTH_STENCIL;
	
						// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
						// DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
						// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
						if ( texture.type !== UnsignedInt248Type ) {
	
							console.warn( 'THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.' );
	
							texture.type = UnsignedInt248Type;
							glType = utils.convert( texture.type );
	
						}
	
					}
	
					state.texImage2D( _gl.TEXTURE_2D, 0, internalFormat, image.width, image.height, 0, glFormat, glType, null );
	
				} else if ( texture.isDataTexture ) {
	
					// use manually created mipmaps if available
					// if there are no manual mipmaps
					// set 0 level mipmap and then use GL to generate other mipmap levels
	
					if ( mipmaps.length > 0 && isPowerOfTwoImage ) {
	
						for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {
	
							mipmap = mipmaps[ i ];
							state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );
	
						}
	
						texture.generateMipmaps = false;
	
					} else {
	
						state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, image.width, image.height, 0, glFormat, glType, image.data );
	
					}
	
				} else if ( texture.isCompressedTexture ) {
	
					for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {
	
						mipmap = mipmaps[ i ];
	
						if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {
	
							if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {
	
								state.compressedTexImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );
	
							} else {
	
								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()' );
	
							}
	
						} else {
	
							state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );
	
						}
	
					}
	
				} else {
	
					// regular Texture (image, video, canvas)
	
					// use manually created mipmaps if available
					// if there are no manual mipmaps
					// set 0 level mipmap and then use GL to generate other mipmap levels
	
					if ( mipmaps.length > 0 && isPowerOfTwoImage ) {
	
						for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {
	
							mipmap = mipmaps[ i ];
							state.texImage2D( _gl.TEXTURE_2D, i, glFormat, glFormat, glType, mipmap );
	
						}
	
						texture.generateMipmaps = false;
	
					} else {
	
						state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, glFormat, glType, image );
	
					}
	
				}
	
				if ( textureNeedsGenerateMipmaps( texture, isPowerOfTwoImage ) ) _gl.generateMipmap( _gl.TEXTURE_2D );
	
				textureProperties.__version = texture.version;
	
				if ( texture.onUpdate ) texture.onUpdate( texture );
	
			}
	
			// Render targets
	
			// Setup storage for target texture and bind it to correct framebuffer
			function setupFrameBufferTexture( framebuffer, renderTarget, attachment, textureTarget ) {
	
				var glFormat = utils.convert( renderTarget.texture.format );
				var glType = utils.convert( renderTarget.texture.type );
				state.texImage2D( textureTarget, 0, glFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null );
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( renderTarget.texture ).__webglTexture, 0 );
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );
	
			}
	
			// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
			function setupRenderBufferStorage( renderbuffer, renderTarget ) {
	
				_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderbuffer );
	
				if ( renderTarget.depthBuffer && ! renderTarget.stencilBuffer ) {
	
					_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_COMPONENT16, renderTarget.width, renderTarget.height );
					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );
	
				} else if ( renderTarget.depthBuffer && renderTarget.stencilBuffer ) {
	
					_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height );
					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );
	
				} else {
	
					// FIXME: We don't support !depth !stencil
					_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.RGBA4, renderTarget.width, renderTarget.height );
	
				}
	
				_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );
	
			}
	
			// Setup resources for a Depth Texture for a FBO (needs an extension)
			function setupDepthTexture( framebuffer, renderTarget ) {
	
				var isCube = ( renderTarget && renderTarget.isWebGLRenderTargetCube );
				if ( isCube ) throw new Error( 'Depth Texture with cube render targets is not supported' );
	
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
	
				if ( !( renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture ) ) {
	
					throw new Error( 'renderTarget.depthTexture must be an instance of THREE.DepthTexture' );
	
				}
	
				// upload an empty depth texture with framebuffer size
				if ( !properties.get( renderTarget.depthTexture ).__webglTexture ||
						renderTarget.depthTexture.image.width !== renderTarget.width ||
						renderTarget.depthTexture.image.height !== renderTarget.height ) {
					renderTarget.depthTexture.image.width = renderTarget.width;
					renderTarget.depthTexture.image.height = renderTarget.height;
					renderTarget.depthTexture.needsUpdate = true;
				}
	
				setTexture2D( renderTarget.depthTexture, 0 );
	
				var webglDepthTexture = properties.get( renderTarget.depthTexture ).__webglTexture;
	
				if ( renderTarget.depthTexture.format === DepthFormat ) {
	
					_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );
	
				} else if ( renderTarget.depthTexture.format === DepthStencilFormat ) {
	
					_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );
	
				} else {
	
					throw new Error( 'Unknown depthTexture format' );
	
				}
	
			}
	
			// Setup GL resources for a non-texture depth buffer
			function setupDepthRenderbuffer( renderTarget ) {
	
				var renderTargetProperties = properties.get( renderTarget );
	
				var isCube = ( renderTarget.isWebGLRenderTargetCube === true );
	
				if ( renderTarget.depthTexture ) {
	
					if ( isCube ) throw new Error( 'target.depthTexture not supported in Cube render targets' );
	
					setupDepthTexture( renderTargetProperties.__webglFramebuffer, renderTarget );
	
				} else {
	
					if ( isCube ) {
	
						renderTargetProperties.__webglDepthbuffer = [];
	
						for ( var i = 0; i < 6; i ++ ) {
	
							_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[ i ] );
							renderTargetProperties.__webglDepthbuffer[ i ] = _gl.createRenderbuffer();
							setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer[ i ], renderTarget );
	
						}
	
					} else {
	
						_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
						renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
						setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer, renderTarget );
	
					}
	
				}
	
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );
	
			}
	
			// Set up GL resources for the render target
			function setupRenderTarget( renderTarget ) {
	
				var renderTargetProperties = properties.get( renderTarget );
				var textureProperties = properties.get( renderTarget.texture );
	
				renderTarget.addEventListener( 'dispose', onRenderTargetDispose );
	
				textureProperties.__webglTexture = _gl.createTexture();
	
				infoMemory.textures ++;
	
				var isCube = ( renderTarget.isWebGLRenderTargetCube === true );
				var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );
	
				// Setup framebuffer
	
				if ( isCube ) {
	
					renderTargetProperties.__webglFramebuffer = [];
	
					for ( var i = 0; i < 6; i ++ ) {
	
						renderTargetProperties.__webglFramebuffer[ i ] = _gl.createFramebuffer();
	
					}
	
				} else {
	
					renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
	
				}
	
				// Setup color buffer
	
				if ( isCube ) {
	
					state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture );
					setTextureParameters( _gl.TEXTURE_CUBE_MAP, renderTarget.texture, isTargetPowerOfTwo );
	
					for ( var i = 0; i < 6; i ++ ) {
	
						setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ], renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i );
	
					}
	
					if ( textureNeedsGenerateMipmaps( renderTarget.texture, isTargetPowerOfTwo ) ) _gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );
					state.bindTexture( _gl.TEXTURE_CUBE_MAP, null );
	
				} else {
	
					state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
					setTextureParameters( _gl.TEXTURE_2D, renderTarget.texture, isTargetPowerOfTwo );
					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D );
	
					if ( textureNeedsGenerateMipmaps( renderTarget.texture, isTargetPowerOfTwo ) ) _gl.generateMipmap( _gl.TEXTURE_2D );
					state.bindTexture( _gl.TEXTURE_2D, null );
	
				}
	
				// Setup depth and stencil buffers
	
				if ( renderTarget.depthBuffer ) {
	
					setupDepthRenderbuffer( renderTarget );
	
				}
	
			}
	
			function updateRenderTargetMipmap( renderTarget ) {
	
				var texture = renderTarget.texture;
				var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );
	
				if ( textureNeedsGenerateMipmaps( texture, isTargetPowerOfTwo ) ) {
	
					var target = renderTarget.isWebGLRenderTargetCube ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
					var webglTexture = properties.get( texture ).__webglTexture;
	
					state.bindTexture( target, webglTexture );
					_gl.generateMipmap( target );
					state.bindTexture( target, null );
	
				}
	
			}
	
			this.setTexture2D = setTexture2D;
			this.setTextureCube = setTextureCube;
			this.setTextureCubeDynamic = setTextureCubeDynamic;
			this.setupRenderTarget = setupRenderTarget;
			this.updateRenderTargetMipmap = updateRenderTargetMipmap;
	
		}
	
		/**
		 * @author fordacious / fordacious.github.io
		 */
	
		function WebGLProperties() {
	
			var properties = {};
	
			function get( object ) {
	
				var uuid = object.uuid;
				var map = properties[ uuid ];
	
				if ( map === undefined ) {
	
					map = {};
					properties[ uuid ] = map;
	
				}
	
				return map;
	
			}
	
			function remove( object ) {
	
				delete properties[ object.uuid ];
	
			}
	
			function clear() {
	
				properties = {};
	
			}
	
			return {
				get: get,
				remove: remove,
				clear: clear
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLState( gl, extensions, utils ) {
	
			function ColorBuffer() {
	
				var locked = false;
	
				var color = new Vector4();
				var currentColorMask = null;
				var currentColorClear = new Vector4( 0, 0, 0, 0 );
	
				return {
	
					setMask: function ( colorMask ) {
	
						if ( currentColorMask !== colorMask && ! locked ) {
	
							gl.colorMask( colorMask, colorMask, colorMask, colorMask );
							currentColorMask = colorMask;
	
						}
	
					},
	
					setLocked: function ( lock ) {
	
						locked = lock;
	
					},
	
					setClear: function ( r, g, b, a, premultipliedAlpha ) {
	
						if ( premultipliedAlpha === true ) {
	
							r *= a; g *= a; b *= a;
	
						}
	
						color.set( r, g, b, a );
	
						if ( currentColorClear.equals( color ) === false ) {
	
							gl.clearColor( r, g, b, a );
							currentColorClear.copy( color );
	
						}
	
					},
	
					reset: function () {
	
						locked = false;
	
						currentColorMask = null;
						currentColorClear.set( - 1, 0, 0, 0 ); // set to invalid state
	
					}
	
				};
	
			}
	
			function DepthBuffer() {
	
				var locked = false;
	
				var currentDepthMask = null;
				var currentDepthFunc = null;
				var currentDepthClear = null;
	
				return {
	
					setTest: function ( depthTest ) {
	
						if ( depthTest ) {
	
							enable( gl.DEPTH_TEST );
	
						} else {
	
							disable( gl.DEPTH_TEST );
	
						}
	
					},
	
					setMask: function ( depthMask ) {
	
						if ( currentDepthMask !== depthMask && ! locked ) {
	
							gl.depthMask( depthMask );
							currentDepthMask = depthMask;
	
						}
	
					},
	
					setFunc: function ( depthFunc ) {
	
						if ( currentDepthFunc !== depthFunc ) {
	
							if ( depthFunc ) {
	
								switch ( depthFunc ) {
	
									case NeverDepth:
	
										gl.depthFunc( gl.NEVER );
										break;
	
									case AlwaysDepth:
	
										gl.depthFunc( gl.ALWAYS );
										break;
	
									case LessDepth:
	
										gl.depthFunc( gl.LESS );
										break;
	
									case LessEqualDepth:
	
										gl.depthFunc( gl.LEQUAL );
										break;
	
									case EqualDepth:
	
										gl.depthFunc( gl.EQUAL );
										break;
	
									case GreaterEqualDepth:
	
										gl.depthFunc( gl.GEQUAL );
										break;
	
									case GreaterDepth:
	
										gl.depthFunc( gl.GREATER );
										break;
	
									case NotEqualDepth:
	
										gl.depthFunc( gl.NOTEQUAL );
										break;
	
									default:
	
										gl.depthFunc( gl.LEQUAL );
	
								}
	
							} else {
	
								gl.depthFunc( gl.LEQUAL );
	
							}
	
							currentDepthFunc = depthFunc;
	
						}
	
					},
	
					setLocked: function ( lock ) {
	
						locked = lock;
	
					},
	
					setClear: function ( depth ) {
	
						if ( currentDepthClear !== depth ) {
	
							gl.clearDepth( depth );
							currentDepthClear = depth;
	
						}
	
					},
	
					reset: function () {
	
						locked = false;
	
						currentDepthMask = null;
						currentDepthFunc = null;
						currentDepthClear = null;
	
					}
	
				};
	
			}
	
			function StencilBuffer() {
	
				var locked = false;
	
				var currentStencilMask = null;
				var currentStencilFunc = null;
				var currentStencilRef = null;
				var currentStencilFuncMask = null;
				var currentStencilFail = null;
				var currentStencilZFail = null;
				var currentStencilZPass = null;
				var currentStencilClear = null;
	
				return {
	
					setTest: function ( stencilTest ) {
	
						if ( stencilTest ) {
	
							enable( gl.STENCIL_TEST );
	
						} else {
	
							disable( gl.STENCIL_TEST );
	
						}
	
					},
	
					setMask: function ( stencilMask ) {
	
						if ( currentStencilMask !== stencilMask && ! locked ) {
	
							gl.stencilMask( stencilMask );
							currentStencilMask = stencilMask;
	
						}
	
					},
	
					setFunc: function ( stencilFunc, stencilRef, stencilMask ) {
	
						if ( currentStencilFunc !== stencilFunc ||
						     currentStencilRef 	!== stencilRef 	||
						     currentStencilFuncMask !== stencilMask ) {
	
							gl.stencilFunc( stencilFunc, stencilRef, stencilMask );
	
							currentStencilFunc = stencilFunc;
							currentStencilRef = stencilRef;
							currentStencilFuncMask = stencilMask;
	
						}
	
					},
	
					setOp: function ( stencilFail, stencilZFail, stencilZPass ) {
	
						if ( currentStencilFail	 !== stencilFail 	||
						     currentStencilZFail !== stencilZFail ||
						     currentStencilZPass !== stencilZPass ) {
	
							gl.stencilOp( stencilFail, stencilZFail, stencilZPass );
	
							currentStencilFail = stencilFail;
							currentStencilZFail = stencilZFail;
							currentStencilZPass = stencilZPass;
	
						}
	
					},
	
					setLocked: function ( lock ) {
	
						locked = lock;
	
					},
	
					setClear: function ( stencil ) {
	
						if ( currentStencilClear !== stencil ) {
	
							gl.clearStencil( stencil );
							currentStencilClear = stencil;
	
						}
	
					},
	
					reset: function () {
	
						locked = false;
	
						currentStencilMask = null;
						currentStencilFunc = null;
						currentStencilRef = null;
						currentStencilFuncMask = null;
						currentStencilFail = null;
						currentStencilZFail = null;
						currentStencilZPass = null;
						currentStencilClear = null;
	
					}
	
				};
	
			}
	
			//
	
			var colorBuffer = new ColorBuffer();
			var depthBuffer = new DepthBuffer();
			var stencilBuffer = new StencilBuffer();
	
			var maxVertexAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
			var newAttributes = new Uint8Array( maxVertexAttributes );
			var enabledAttributes = new Uint8Array( maxVertexAttributes );
			var attributeDivisors = new Uint8Array( maxVertexAttributes );
	
			var capabilities = {};
	
			var compressedTextureFormats = null;
	
			var currentProgram = null;
	
			var currentBlending = null;
			var currentBlendEquation = null;
			var currentBlendSrc = null;
			var currentBlendDst = null;
			var currentBlendEquationAlpha = null;
			var currentBlendSrcAlpha = null;
			var currentBlendDstAlpha = null;
			var currentPremultipledAlpha = false;
	
			var currentFlipSided = null;
			var currentCullFace = null;
	
			var currentLineWidth = null;
	
			var currentPolygonOffsetFactor = null;
			var currentPolygonOffsetUnits = null;
	
			var maxTextures = gl.getParameter( gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS );
	
			var version = parseFloat( /^WebGL\ ([0-9])/.exec( gl.getParameter( gl.VERSION ) )[ 1 ] );
			var lineWidthAvailable = parseFloat( version ) >= 1.0;
	
			var currentTextureSlot = null;
			var currentBoundTextures = {};
	
			var currentScissor = new Vector4();
			var currentViewport = new Vector4();
	
			function createTexture( type, target, count ) {
	
				var data = new Uint8Array( 4 ); // 4 is required to match default unpack alignment of 4.
				var texture = gl.createTexture();
	
				gl.bindTexture( type, texture );
				gl.texParameteri( type, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
				gl.texParameteri( type, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
	
				for ( var i = 0; i < count; i ++ ) {
	
					gl.texImage2D( target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );
	
				}
	
				return texture;
	
			}
	
			var emptyTextures = {};
			emptyTextures[ gl.TEXTURE_2D ] = createTexture( gl.TEXTURE_2D, gl.TEXTURE_2D, 1 );
			emptyTextures[ gl.TEXTURE_CUBE_MAP ] = createTexture( gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6 );
	
			// init
	
			colorBuffer.setClear( 0, 0, 0, 1 );
			depthBuffer.setClear( 1 );
			stencilBuffer.setClear( 0 );
	
			enable( gl.DEPTH_TEST );
			depthBuffer.setFunc( LessEqualDepth );
	
			setFlipSided( false );
			setCullFace( CullFaceBack );
			enable( gl.CULL_FACE );
	
			enable( gl.BLEND );
			setBlending( NormalBlending );
	
			//
	
			function initAttributes() {
	
				for ( var i = 0, l = newAttributes.length; i < l; i ++ ) {
	
					newAttributes[ i ] = 0;
	
				}
	
			}
	
			function enableAttribute( attribute ) {
	
				newAttributes[ attribute ] = 1;
	
				if ( enabledAttributes[ attribute ] === 0 ) {
	
					gl.enableVertexAttribArray( attribute );
					enabledAttributes[ attribute ] = 1;
	
				}
	
				if ( attributeDivisors[ attribute ] !== 0 ) {
	
					var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
					extension.vertexAttribDivisorANGLE( attribute, 0 );
					attributeDivisors[ attribute ] = 0;
	
				}
	
			}
	
			function enableAttributeAndDivisor( attribute, meshPerAttribute ) {
	
				newAttributes[ attribute ] = 1;
	
				if ( enabledAttributes[ attribute ] === 0 ) {
	
					gl.enableVertexAttribArray( attribute );
					enabledAttributes[ attribute ] = 1;
	
				}
	
				if ( attributeDivisors[ attribute ] !== meshPerAttribute ) {
	
					var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
					extension.vertexAttribDivisorANGLE( attribute, meshPerAttribute );
					attributeDivisors[ attribute ] = meshPerAttribute;
	
				}
	
			}
	
			function disableUnusedAttributes() {
	
				for ( var i = 0, l = enabledAttributes.length; i !== l; ++ i ) {
	
					if ( enabledAttributes[ i ] !== newAttributes[ i ] ) {
	
						gl.disableVertexAttribArray( i );
						enabledAttributes[ i ] = 0;
	
					}
	
				}
	
			}
	
			function enable( id ) {
	
				if ( capabilities[ id ] !== true ) {
	
					gl.enable( id );
					capabilities[ id ] = true;
	
				}
	
			}
	
			function disable( id ) {
	
				if ( capabilities[ id ] !== false ) {
	
					gl.disable( id );
					capabilities[ id ] = false;
	
				}
	
			}
	
			function getCompressedTextureFormats() {
	
				if ( compressedTextureFormats === null ) {
	
					compressedTextureFormats = [];
	
					if ( extensions.get( 'WEBGL_compressed_texture_pvrtc' ) ||
					     extensions.get( 'WEBGL_compressed_texture_s3tc' ) ||
					     extensions.get( 'WEBGL_compressed_texture_etc1' ) ) {
	
						var formats = gl.getParameter( gl.COMPRESSED_TEXTURE_FORMATS );
	
						for ( var i = 0; i < formats.length; i ++ ) {
	
							compressedTextureFormats.push( formats[ i ] );
	
						}
	
					}
	
				}
	
				return compressedTextureFormats;
	
			}
	
			function useProgram( program ) {
	
				if ( currentProgram !== program ) {
	
					gl.useProgram( program );
	
					currentProgram = program;
	
					return true;
	
				}
	
				return false;
	
			}
	
			function setBlending( blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha ) {
	
				if ( blending !== NoBlending ) {
	
					enable( gl.BLEND );
	
				} else {
	
					disable( gl.BLEND );
	
				}
	
				if ( blending !== CustomBlending ) {
	
					if ( blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha ) {
	
						switch ( blending ) {
	
							case AdditiveBlending:
	
								if ( premultipliedAlpha ) {
	
									gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
									gl.blendFuncSeparate( gl.ONE, gl.ONE, gl.ONE, gl.ONE );
	
								} else {
	
									gl.blendEquation( gl.FUNC_ADD );
									gl.blendFunc( gl.SRC_ALPHA, gl.ONE );
	
								}
								break;
	
							case SubtractiveBlending:
	
								if ( premultipliedAlpha ) {
	
									gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
									gl.blendFuncSeparate( gl.ZERO, gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ONE_MINUS_SRC_ALPHA );
	
								} else {
	
									gl.blendEquation( gl.FUNC_ADD );
									gl.blendFunc( gl.ZERO, gl.ONE_MINUS_SRC_COLOR );
	
								}
								break;
	
							case MultiplyBlending:
	
								if ( premultipliedAlpha ) {
	
									gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
									gl.blendFuncSeparate( gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA );
	
								} else {
	
									gl.blendEquation( gl.FUNC_ADD );
									gl.blendFunc( gl.ZERO, gl.SRC_COLOR );
	
								}
								break;
	
							default:
	
								if ( premultipliedAlpha ) {
	
									gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
									gl.blendFuncSeparate( gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
	
								} else {
	
									gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
									gl.blendFuncSeparate( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
	
								}
	
						}
	
					}
	
					currentBlendEquation = null;
					currentBlendSrc = null;
					currentBlendDst = null;
					currentBlendEquationAlpha = null;
					currentBlendSrcAlpha = null;
					currentBlendDstAlpha = null;
	
				} else {
	
					blendEquationAlpha = blendEquationAlpha || blendEquation;
					blendSrcAlpha = blendSrcAlpha || blendSrc;
					blendDstAlpha = blendDstAlpha || blendDst;
	
					if ( blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha ) {
	
						gl.blendEquationSeparate( utils.convert( blendEquation ), utils.convert( blendEquationAlpha ) );
	
						currentBlendEquation = blendEquation;
						currentBlendEquationAlpha = blendEquationAlpha;
	
					}
	
					if ( blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha ) {
	
						gl.blendFuncSeparate( utils.convert( blendSrc ), utils.convert( blendDst ), utils.convert( blendSrcAlpha ), utils.convert( blendDstAlpha ) );
	
						currentBlendSrc = blendSrc;
						currentBlendDst = blendDst;
						currentBlendSrcAlpha = blendSrcAlpha;
						currentBlendDstAlpha = blendDstAlpha;
	
					}
	
				}
	
				currentBlending = blending;
				currentPremultipledAlpha = premultipliedAlpha;
	
			}
	
			function setMaterial( material ) {
	
				material.side === DoubleSide
					? disable( gl.CULL_FACE )
					: enable( gl.CULL_FACE );
	
				setFlipSided( material.side === BackSide );
	
				material.transparent === true
					? setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha )
					: setBlending( NoBlending );
	
				depthBuffer.setFunc( material.depthFunc );
				depthBuffer.setTest( material.depthTest );
				depthBuffer.setMask( material.depthWrite );
				colorBuffer.setMask( material.colorWrite );
	
				setPolygonOffset( material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits );
	
			}
	
			//
	
			function setFlipSided( flipSided ) {
	
				if ( currentFlipSided !== flipSided ) {
	
					if ( flipSided ) {
	
						gl.frontFace( gl.CW );
	
					} else {
	
						gl.frontFace( gl.CCW );
	
					}
	
					currentFlipSided = flipSided;
	
				}
	
			}
	
			function setCullFace( cullFace ) {
	
				if ( cullFace !== CullFaceNone ) {
	
					enable( gl.CULL_FACE );
	
					if ( cullFace !== currentCullFace ) {
	
						if ( cullFace === CullFaceBack ) {
	
							gl.cullFace( gl.BACK );
	
						} else if ( cullFace === CullFaceFront ) {
	
							gl.cullFace( gl.FRONT );
	
						} else {
	
							gl.cullFace( gl.FRONT_AND_BACK );
	
						}
	
					}
	
				} else {
	
					disable( gl.CULL_FACE );
	
				}
	
				currentCullFace = cullFace;
	
			}
	
			function setLineWidth( width ) {
	
				if ( width !== currentLineWidth ) {
	
					if ( lineWidthAvailable ) gl.lineWidth( width );
	
					currentLineWidth = width;
	
				}
	
			}
	
			function setPolygonOffset( polygonOffset, factor, units ) {
	
				if ( polygonOffset ) {
	
					enable( gl.POLYGON_OFFSET_FILL );
	
					if ( currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units ) {
	
						gl.polygonOffset( factor, units );
	
						currentPolygonOffsetFactor = factor;
						currentPolygonOffsetUnits = units;
	
					}
	
				} else {
	
					disable( gl.POLYGON_OFFSET_FILL );
	
				}
	
			}
	
			function setScissorTest( scissorTest ) {
	
				if ( scissorTest ) {
	
					enable( gl.SCISSOR_TEST );
	
				} else {
	
					disable( gl.SCISSOR_TEST );
	
				}
	
			}
	
			// texture
	
			function activeTexture( webglSlot ) {
	
				if ( webglSlot === undefined ) webglSlot = gl.TEXTURE0 + maxTextures - 1;
	
				if ( currentTextureSlot !== webglSlot ) {
	
					gl.activeTexture( webglSlot );
					currentTextureSlot = webglSlot;
	
				}
	
			}
	
			function bindTexture( webglType, webglTexture ) {
	
				if ( currentTextureSlot === null ) {
	
					activeTexture();
	
				}
	
				var boundTexture = currentBoundTextures[ currentTextureSlot ];
	
				if ( boundTexture === undefined ) {
	
					boundTexture = { type: undefined, texture: undefined };
					currentBoundTextures[ currentTextureSlot ] = boundTexture;
	
				}
	
				if ( boundTexture.type !== webglType || boundTexture.texture !== webglTexture ) {
	
					gl.bindTexture( webglType, webglTexture || emptyTextures[ webglType ] );
	
					boundTexture.type = webglType;
					boundTexture.texture = webglTexture;
	
				}
	
			}
	
			function compressedTexImage2D() {
	
				try {
	
					gl.compressedTexImage2D.apply( gl, arguments );
	
				} catch ( error ) {
	
					console.error( 'THREE.WebGLState:', error );
	
				}
	
			}
	
			function texImage2D() {
	
				try {
	
					gl.texImage2D.apply( gl, arguments );
	
				} catch ( error ) {
	
					console.error( 'THREE.WebGLState:', error );
	
				}
	
			}
	
			//
	
			function scissor( scissor ) {
	
				if ( currentScissor.equals( scissor ) === false ) {
	
					gl.scissor( scissor.x, scissor.y, scissor.z, scissor.w );
					currentScissor.copy( scissor );
	
				}
	
			}
	
			function viewport( viewport ) {
	
				if ( currentViewport.equals( viewport ) === false ) {
	
					gl.viewport( viewport.x, viewport.y, viewport.z, viewport.w );
					currentViewport.copy( viewport );
	
				}
	
			}
	
			//
	
			function reset() {
	
				for ( var i = 0; i < enabledAttributes.length; i ++ ) {
	
					if ( enabledAttributes[ i ] === 1 ) {
	
						gl.disableVertexAttribArray( i );
						enabledAttributes[ i ] = 0;
	
					}
	
				}
	
				capabilities = {};
	
				compressedTextureFormats = null;
	
				currentTextureSlot = null;
				currentBoundTextures = {};
	
				currentProgram = null;
	
				currentBlending = null;
	
				currentFlipSided = null;
				currentCullFace = null;
	
				colorBuffer.reset();
				depthBuffer.reset();
				stencilBuffer.reset();
	
			}
	
			return {
	
				buffers: {
					color: colorBuffer,
					depth: depthBuffer,
					stencil: stencilBuffer
				},
	
				initAttributes: initAttributes,
				enableAttribute: enableAttribute,
				enableAttributeAndDivisor: enableAttributeAndDivisor,
				disableUnusedAttributes: disableUnusedAttributes,
				enable: enable,
				disable: disable,
				getCompressedTextureFormats: getCompressedTextureFormats,
	
				useProgram: useProgram,
	
				setBlending: setBlending,
				setMaterial: setMaterial,
	
				setFlipSided: setFlipSided,
				setCullFace: setCullFace,
	
				setLineWidth: setLineWidth,
				setPolygonOffset: setPolygonOffset,
	
				setScissorTest: setScissorTest,
	
				activeTexture: activeTexture,
				bindTexture: bindTexture,
				compressedTexImage2D: compressedTexImage2D,
				texImage2D: texImage2D,
	
				scissor: scissor,
				viewport: viewport,
	
				reset: reset
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLCapabilities( gl, extensions, parameters ) {
	
			var maxAnisotropy;
	
			function getMaxAnisotropy() {
	
				if ( maxAnisotropy !== undefined ) return maxAnisotropy;
	
				var extension = extensions.get( 'EXT_texture_filter_anisotropic' );
	
				if ( extension !== null ) {
	
					maxAnisotropy = gl.getParameter( extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT );
	
				} else {
	
					maxAnisotropy = 0;
	
				}
	
				return maxAnisotropy;
	
			}
	
			function getMaxPrecision( precision ) {
	
				if ( precision === 'highp' ) {
	
					if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.HIGH_FLOAT ).precision > 0 &&
					     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.HIGH_FLOAT ).precision > 0 ) {
	
						return 'highp';
	
					}
	
					precision = 'mediump';
	
				}
	
				if ( precision === 'mediump' ) {
	
					if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.MEDIUM_FLOAT ).precision > 0 &&
					     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT ).precision > 0 ) {
	
						return 'mediump';
	
					}
	
				}
	
				return 'lowp';
	
			}
	
			var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
			var maxPrecision = getMaxPrecision( precision );
	
			if ( maxPrecision !== precision ) {
	
				console.warn( 'THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.' );
				precision = maxPrecision;
	
			}
	
			var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true && !! extensions.get( 'EXT_frag_depth' );
	
			var maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
			var maxVertexTextures = gl.getParameter( gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS );
			var maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE );
			var maxCubemapSize = gl.getParameter( gl.MAX_CUBE_MAP_TEXTURE_SIZE );
	
			var maxAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
			var maxVertexUniforms = gl.getParameter( gl.MAX_VERTEX_UNIFORM_VECTORS );
			var maxVaryings = gl.getParameter( gl.MAX_VARYING_VECTORS );
			var maxFragmentUniforms = gl.getParameter( gl.MAX_FRAGMENT_UNIFORM_VECTORS );
	
			var vertexTextures = maxVertexTextures > 0;
			var floatFragmentTextures = !! extensions.get( 'OES_texture_float' );
			var floatVertexTextures = vertexTextures && floatFragmentTextures;
	
			return {
	
				getMaxAnisotropy: getMaxAnisotropy,
				getMaxPrecision: getMaxPrecision,
	
				precision: precision,
				logarithmicDepthBuffer: logarithmicDepthBuffer,
	
				maxTextures: maxTextures,
				maxVertexTextures: maxVertexTextures,
				maxTextureSize: maxTextureSize,
				maxCubemapSize: maxCubemapSize,
	
				maxAttributes: maxAttributes,
				maxVertexUniforms: maxVertexUniforms,
				maxVaryings: maxVaryings,
				maxFragmentUniforms: maxFragmentUniforms,
	
				vertexTextures: vertexTextures,
				floatFragmentTextures: floatFragmentTextures,
				floatVertexTextures: floatVertexTextures
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function ArrayCamera( array ) {
	
			PerspectiveCamera.call( this );
	
			this.cameras = array || [];
	
		}
	
		ArrayCamera.prototype = Object.assign( Object.create( PerspectiveCamera.prototype ), {
	
			constructor: ArrayCamera,
	
			isArrayCamera: true
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebVRManager( renderer ) {
	
			var scope = this;
	
			var device = null;
			var frameData = null;
	
			if ( 'VRFrameData' in window ) {
	
				frameData = new window.VRFrameData();
	
			}
	
			var matrixWorldInverse = new Matrix4();
	
			var standingMatrix = new Matrix4();
			var standingMatrixInverse = new Matrix4();
	
			var cameraL = new PerspectiveCamera();
			cameraL.bounds = new Vector4( 0.0, 0.0, 0.5, 1.0 );
			cameraL.layers.enable( 1 );
	
			var cameraR = new PerspectiveCamera();
			cameraR.bounds = new Vector4( 0.5, 0.0, 0.5, 1.0 );
			cameraR.layers.enable( 2 );
	
			var cameraVR = new ArrayCamera( [ cameraL, cameraR ] );
			cameraVR.layers.enable( 1 );
			cameraVR.layers.enable( 2 );
	
			//
	
			var currentSize, currentPixelRatio;
	
			function onVRDisplayPresentChange() {
	
				if ( device !== null && device.isPresenting ) {
	
					var eyeParameters = device.getEyeParameters( 'left' );
					var renderWidth = eyeParameters.renderWidth;
					var renderHeight = eyeParameters.renderHeight;
	
					currentPixelRatio = renderer.getPixelRatio();
					currentSize = renderer.getSize();
	
					renderer.setDrawingBufferSize( renderWidth * 2, renderHeight, 1 );
	
				} else if ( scope.enabled ) {
	
					renderer.setDrawingBufferSize( currentSize.width, currentSize.height, currentPixelRatio );
	
				}
	
			}
	
			window.addEventListener( 'vrdisplaypresentchange', onVRDisplayPresentChange, false );
	
			//
	
			this.enabled = false;
			this.standing = false;
	
			this.getDevice = function () {
	
				return device;
	
			};
	
			this.setDevice = function ( value ) {
	
				if ( value !== undefined ) device = value;
	
			};
	
			this.getCamera = function ( camera ) {
	
				if ( device === null ) return camera;
	
				device.depthNear = camera.near;
				device.depthFar = camera.far;
	
				device.getFrameData( frameData );
	
				//
	
				var pose = frameData.pose;
	
				if ( pose.position !== null ) {
	
					camera.position.fromArray( pose.position );
	
				} else {
	
					camera.position.set( 0, 0, 0 );
	
				}
	
				if ( pose.orientation !== null ) {
	
					camera.quaternion.fromArray( pose.orientation );
	
				}
	
				camera.updateMatrixWorld();
	
				var stageParameters = device.stageParameters;
	
				if ( this.standing && stageParameters ) {
	
					standingMatrix.fromArray( stageParameters.sittingToStandingTransform );
					standingMatrixInverse.getInverse( standingMatrix );
	
					camera.matrixWorld.multiply( standingMatrix );
					camera.matrixWorldInverse.multiply( standingMatrixInverse );
	
				}
	
				if ( device.isPresenting === false ) return camera;
	
				//
	
				cameraL.near = camera.near;
				cameraR.near = camera.near;
	
				cameraL.far = camera.far;
				cameraR.far = camera.far;
	
				cameraVR.matrixWorld.copy( camera.matrixWorld );
				cameraVR.matrixWorldInverse.copy( camera.matrixWorldInverse );
	
				cameraL.matrixWorldInverse.fromArray( frameData.leftViewMatrix );
				cameraR.matrixWorldInverse.fromArray( frameData.rightViewMatrix );
	
				if ( this.standing && stageParameters ) {
	
					cameraL.matrixWorldInverse.multiply( standingMatrixInverse );
					cameraR.matrixWorldInverse.multiply( standingMatrixInverse );
	
				}
	
				var parent = camera.parent;
	
				if ( parent !== null ) {
	
					matrixWorldInverse.getInverse( parent.matrixWorld );
	
					cameraL.matrixWorldInverse.multiply( matrixWorldInverse );
					cameraR.matrixWorldInverse.multiply( matrixWorldInverse );
	
				}
	
				// envMap and Mirror needs camera.matrixWorld
	
				cameraL.matrixWorld.getInverse( cameraL.matrixWorldInverse );
				cameraR.matrixWorld.getInverse( cameraR.matrixWorldInverse );
	
				cameraL.projectionMatrix.fromArray( frameData.leftProjectionMatrix );
				cameraR.projectionMatrix.fromArray( frameData.rightProjectionMatrix );
	
				// HACK @mrdoob
				// https://github.com/w3c/webvr/issues/203
	
				cameraVR.projectionMatrix.copy( cameraL.projectionMatrix );
	
				//
	
				var layers = device.getLayers();
	
				if ( layers.length ) {
	
					var layer = layers[ 0 ];
	
					if ( layer.leftBounds !== null && layer.leftBounds.length === 4 ) {
	
						cameraL.bounds.fromArray( layer.leftBounds );
	
					}
	
					if ( layer.rightBounds !== null && layer.rightBounds.length === 4 ) {
	
						cameraR.bounds.fromArray( layer.rightBounds );
	
					}
	
				}
	
				return cameraVR;
	
			};
	
			this.getStandingMatrix = function () {
	
				return standingMatrix;
	
			};
	
			this.submitFrame = function () {
	
				if ( device && device.isPresenting ) device.submitFrame();
	
			};
	
			this.dispose = function() {
	
				window.removeEventListener( 'vrdisplaypresentchange', onVRDisplayPresentChange );
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLExtensions( gl ) {
	
			var extensions = {};
	
			return {
	
				get: function ( name ) {
	
					if ( extensions[ name ] !== undefined ) {
	
						return extensions[ name ];
	
					}
	
					var extension;
	
					switch ( name ) {
	
						case 'WEBGL_depth_texture':
							extension = gl.getExtension( 'WEBGL_depth_texture' ) || gl.getExtension( 'MOZ_WEBGL_depth_texture' ) || gl.getExtension( 'WEBKIT_WEBGL_depth_texture' );
							break;
	
						case 'EXT_texture_filter_anisotropic':
							extension = gl.getExtension( 'EXT_texture_filter_anisotropic' ) || gl.getExtension( 'MOZ_EXT_texture_filter_anisotropic' ) || gl.getExtension( 'WEBKIT_EXT_texture_filter_anisotropic' );
							break;
	
						case 'WEBGL_compressed_texture_s3tc':
							extension = gl.getExtension( 'WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'MOZ_WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_s3tc' );
							break;
	
						case 'WEBGL_compressed_texture_pvrtc':
							extension = gl.getExtension( 'WEBGL_compressed_texture_pvrtc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_pvrtc' );
							break;
	
						case 'WEBGL_compressed_texture_etc1':
							extension = gl.getExtension( 'WEBGL_compressed_texture_etc1' );
							break;
	
						default:
							extension = gl.getExtension( name );
	
					}
	
					if ( extension === null ) {
	
						console.warn( 'THREE.WebGLRenderer: ' + name + ' extension not supported.' );
	
					}
	
					extensions[ name ] = extension;
	
					return extension;
	
				}
	
			};
	
		}
	
		/**
		 * @author tschw
		 */
	
		function WebGLClipping() {
	
			var scope = this,
	
				globalState = null,
				numGlobalPlanes = 0,
				localClippingEnabled = false,
				renderingShadows = false,
	
				plane = new Plane(),
				viewNormalMatrix = new Matrix3(),
	
				uniform = { value: null, needsUpdate: false };
	
			this.uniform = uniform;
			this.numPlanes = 0;
			this.numIntersection = 0;
	
			this.init = function( planes, enableLocalClipping, camera ) {
	
				var enabled =
					planes.length !== 0 ||
					enableLocalClipping ||
					// enable state of previous frame - the clipping code has to
					// run another frame in order to reset the state:
					numGlobalPlanes !== 0 ||
					localClippingEnabled;
	
				localClippingEnabled = enableLocalClipping;
	
				globalState = projectPlanes( planes, camera, 0 );
				numGlobalPlanes = planes.length;
	
				return enabled;
	
			};
	
			this.beginShadows = function() {
	
				renderingShadows = true;
				projectPlanes( null );
	
			};
	
			this.endShadows = function() {
	
				renderingShadows = false;
				resetGlobalState();
	
			};
	
			this.setState = function( planes, clipIntersection, clipShadows, camera, cache, fromCache ) {
	
				if ( ! localClippingEnabled ||
						planes === null || planes.length === 0 ||
						renderingShadows && ! clipShadows ) {
					// there's no local clipping
	
					if ( renderingShadows ) {
						// there's no global clipping
	
						projectPlanes( null );
	
					} else {
	
						resetGlobalState();
					}
	
				} else {
	
					var nGlobal = renderingShadows ? 0 : numGlobalPlanes,
						lGlobal = nGlobal * 4,
	
						dstArray = cache.clippingState || null;
	
					uniform.value = dstArray; // ensure unique state
	
					dstArray = projectPlanes( planes, camera, lGlobal, fromCache );
	
					for ( var i = 0; i !== lGlobal; ++ i ) {
	
						dstArray[ i ] = globalState[ i ];
	
					}
	
					cache.clippingState = dstArray;
					this.numIntersection = clipIntersection ? this.numPlanes : 0;
					this.numPlanes += nGlobal;
	
				}
	
	
			};
	
			function resetGlobalState() {
	
				if ( uniform.value !== globalState ) {
	
					uniform.value = globalState;
					uniform.needsUpdate = numGlobalPlanes > 0;
	
				}
	
				scope.numPlanes = numGlobalPlanes;
				scope.numIntersection = 0;
	
			}
	
			function projectPlanes( planes, camera, dstOffset, skipTransform ) {
	
				var nPlanes = planes !== null ? planes.length : 0,
					dstArray = null;
	
				if ( nPlanes !== 0 ) {
	
					dstArray = uniform.value;
	
					if ( skipTransform !== true || dstArray === null ) {
	
						var flatSize = dstOffset + nPlanes * 4,
							viewMatrix = camera.matrixWorldInverse;
	
						viewNormalMatrix.getNormalMatrix( viewMatrix );
	
						if ( dstArray === null || dstArray.length < flatSize ) {
	
							dstArray = new Float32Array( flatSize );
	
						}
	
						for ( var i = 0, i4 = dstOffset;
											i !== nPlanes; ++ i, i4 += 4 ) {
	
							plane.copy( planes[ i ] ).
									applyMatrix4( viewMatrix, viewNormalMatrix );
	
							plane.normal.toArray( dstArray, i4 );
							dstArray[ i4 + 3 ] = plane.constant;
	
						}
	
					}
	
					uniform.value = dstArray;
					uniform.needsUpdate = true;
	
				}
	
				scope.numPlanes = nPlanes;
				
				return dstArray;
	
			}
	
		}
	
		/**
		 * @author thespite / http://www.twitter.com/thespite
		 */
	
		function WebGLUtils ( gl, extensions ) {
	
			function convert ( p ) {
	
				var extension;
	
				if ( p === RepeatWrapping ) return gl.REPEAT;
				if ( p === ClampToEdgeWrapping ) return gl.CLAMP_TO_EDGE;
				if ( p === MirroredRepeatWrapping ) return gl.MIRRORED_REPEAT;
	
				if ( p === NearestFilter ) return gl.NEAREST;
				if ( p === NearestMipMapNearestFilter ) return gl.NEAREST_MIPMAP_NEAREST;
				if ( p === NearestMipMapLinearFilter ) return gl.NEAREST_MIPMAP_LINEAR;
	
				if ( p === LinearFilter ) return gl.LINEAR;
				if ( p === LinearMipMapNearestFilter ) return gl.LINEAR_MIPMAP_NEAREST;
				if ( p === LinearMipMapLinearFilter ) return gl.LINEAR_MIPMAP_LINEAR;
	
				if ( p === UnsignedByteType ) return gl.UNSIGNED_BYTE;
				if ( p === UnsignedShort4444Type ) return gl.UNSIGNED_SHORT_4_4_4_4;
				if ( p === UnsignedShort5551Type ) return gl.UNSIGNED_SHORT_5_5_5_1;
				if ( p === UnsignedShort565Type ) return gl.UNSIGNED_SHORT_5_6_5;
	
				if ( p === ByteType ) return gl.BYTE;
				if ( p === ShortType ) return gl.SHORT;
				if ( p === UnsignedShortType ) return gl.UNSIGNED_SHORT;
				if ( p === IntType ) return gl.INT;
				if ( p === UnsignedIntType ) return gl.UNSIGNED_INT;
				if ( p === FloatType ) return gl.FLOAT;
	
				if ( p === HalfFloatType ) {
	
					extension = extensions.get( 'OES_texture_half_float' );
	
					if ( extension !== null ) return extension.HALF_FLOAT_OES;
	
				}
	
				if ( p === AlphaFormat ) return gl.ALPHA;
				if ( p === RGBFormat ) return gl.RGB;
				if ( p === RGBAFormat ) return gl.RGBA;
				if ( p === LuminanceFormat ) return gl.LUMINANCE;
				if ( p === LuminanceAlphaFormat ) return gl.LUMINANCE_ALPHA;
				if ( p === DepthFormat ) return gl.DEPTH_COMPONENT;
				if ( p === DepthStencilFormat ) return gl.DEPTH_STENCIL;
	
				if ( p === AddEquation ) return gl.FUNC_ADD;
				if ( p === SubtractEquation ) return gl.FUNC_SUBTRACT;
				if ( p === ReverseSubtractEquation ) return gl.FUNC_REVERSE_SUBTRACT;
	
				if ( p === ZeroFactor ) return gl.ZERO;
				if ( p === OneFactor ) return gl.ONE;
				if ( p === SrcColorFactor ) return gl.SRC_COLOR;
				if ( p === OneMinusSrcColorFactor ) return gl.ONE_MINUS_SRC_COLOR;
				if ( p === SrcAlphaFactor ) return gl.SRC_ALPHA;
				if ( p === OneMinusSrcAlphaFactor ) return gl.ONE_MINUS_SRC_ALPHA;
				if ( p === DstAlphaFactor ) return gl.DST_ALPHA;
				if ( p === OneMinusDstAlphaFactor ) return gl.ONE_MINUS_DST_ALPHA;
	
				if ( p === DstColorFactor ) return gl.DST_COLOR;
				if ( p === OneMinusDstColorFactor ) return gl.ONE_MINUS_DST_COLOR;
				if ( p === SrcAlphaSaturateFactor ) return gl.SRC_ALPHA_SATURATE;
	
				if ( p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format ||
					p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format ) {
	
					extension = extensions.get( 'WEBGL_compressed_texture_s3tc' );
	
					if ( extension !== null ) {
	
						if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
						if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
						if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
						if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
	
					}
	
				}
	
				if ( p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format ||
					p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format ) {
	
					extension = extensions.get( 'WEBGL_compressed_texture_pvrtc' );
	
					if ( extension !== null ) {
	
						if ( p === RGB_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
						if ( p === RGB_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
						if ( p === RGBA_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
						if ( p === RGBA_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
	
					}
	
				}
	
				if ( p === RGB_ETC1_Format ) {
	
					extension = extensions.get( 'WEBGL_compressed_texture_etc1' );
	
					if ( extension !== null ) return extension.COMPRESSED_RGB_ETC1_WEBGL;
	
				}
	
				if ( p === MinEquation || p === MaxEquation ) {
	
					extension = extensions.get( 'EXT_blend_minmax' );
	
					if ( extension !== null ) {
	
						if ( p === MinEquation ) return extension.MIN_EXT;
						if ( p === MaxEquation ) return extension.MAX_EXT;
	
					}
	
				}
	
				if ( p === UnsignedInt248Type ) {
	
					extension = extensions.get( 'WEBGL_depth_texture' );
	
					if ( extension !== null ) return extension.UNSIGNED_INT_24_8_WEBGL;
	
				}
	
				return 0;
	
			}
	
			return { convert: convert }
	
		}
	
		// import { Sphere } from '../math/Sphere';
		/**
		 * @author supereggbert / http://www.paulbrunt.co.uk/
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author szimek / https://github.com/szimek/
		 * @author tschw
		 */
	
		function WebGLRenderer( parameters ) {
	
			console.log( 'THREE.WebGLRenderer', REVISION );
	
			parameters = parameters || {};
	
			var _canvas = parameters.canvas !== undefined ? parameters.canvas : document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' ),
				_context = parameters.context !== undefined ? parameters.context : null,
	
				_alpha = parameters.alpha !== undefined ? parameters.alpha : false,
				_depth = parameters.depth !== undefined ? parameters.depth : true,
				_stencil = parameters.stencil !== undefined ? parameters.stencil : true,
				_antialias = parameters.antialias !== undefined ? parameters.antialias : false,
				_premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true,
				_preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false;
	
			var lightsArray = [];
			var shadowsArray = [];
	
			var currentRenderList = null;
	
			var spritesArray = [];
			var flaresArray = [];
	
			// public properties
	
			this.domElement = _canvas;
			this.context = null;
	
			// clearing
	
			this.autoClear = true;
			this.autoClearColor = true;
			this.autoClearDepth = true;
			this.autoClearStencil = true;
	
			// scene graph
	
			this.sortObjects = true;
	
			// user-defined clipping
	
			this.clippingPlanes = [];
			this.localClippingEnabled = false;
	
			// physically based shading
	
			this.gammaFactor = 2.0;	// for backwards compatibility
			this.gammaInput = false;
			this.gammaOutput = false;
	
			// physical lights
	
			this.physicallyCorrectLights = false;
	
			// tone mapping
	
			this.toneMapping = LinearToneMapping;
			this.toneMappingExposure = 1.0;
			this.toneMappingWhitePoint = 1.0;
	
			// morphs
	
			this.maxMorphTargets = 8;
			this.maxMorphNormals = 4;
	
			// internal properties
	
			var _this = this,
	
				_isContextLost = false,
	
				// internal state cache
	
				_currentRenderTarget = null,
				_currentFramebuffer = null,
				_currentMaterialId = - 1,
				_currentGeometryProgram = '',
	
				_currentCamera = null,
				_currentArrayCamera = null,
	
				_currentViewport = new Vector4(),
				_currentScissor = new Vector4(),
				_currentScissorTest = null,
	
				//
	
				_usedTextureUnits = 0,
	
				//
	
				_width = _canvas.width,
				_height = _canvas.height,
	
				_pixelRatio = 1,
	
				_viewport = new Vector4( 0, 0, _width, _height ),
				_scissor = new Vector4( 0, 0, _width, _height ),
				_scissorTest = false,
	
				// frustum
	
				_frustum = new Frustum(),
	
				// clipping
	
				_clipping = new WebGLClipping(),
				_clippingEnabled = false,
				_localClippingEnabled = false,
	
				// camera matrices cache
	
				_projScreenMatrix = new Matrix4(),
	
				_vector3 = new Vector3(),
	
				// info
	
				_infoMemory = {
					geometries: 0,
					textures: 0
				},
	
				_infoRender = {
	
					frame: 0,
					calls: 0,
					vertices: 0,
					faces: 0,
					points: 0
	
				};
	
			this.info = {
	
				render: _infoRender,
				memory: _infoMemory,
				programs: null
	
			};
	
			function getTargetPixelRatio() {
	
				return _currentRenderTarget === null ? _pixelRatio : 1;
	
			}
	
			// initialize
	
			var _gl;
	
			try {
	
				var contextAttributes = {
					alpha: _alpha,
					depth: _depth,
					stencil: _stencil,
					antialias: _antialias,
					premultipliedAlpha: _premultipliedAlpha,
					preserveDrawingBuffer: _preserveDrawingBuffer
				};
	
				_gl = _context || _canvas.getContext( 'webgl', contextAttributes ) || _canvas.getContext( 'experimental-webgl', contextAttributes );
	
				if ( _gl === null ) {
	
					if ( _canvas.getContext( 'webgl' ) !== null ) {
	
						throw 'Error creating WebGL context with your selected attributes.';
	
					} else {
	
						throw 'Error creating WebGL context.';
	
					}
	
				}
	
				// Some experimental-webgl implementations do not have getShaderPrecisionFormat
	
				if ( _gl.getShaderPrecisionFormat === undefined ) {
	
					_gl.getShaderPrecisionFormat = function () {
	
						return { 'rangeMin': 1, 'rangeMax': 1, 'precision': 1 };
	
					};
	
				}
	
				_canvas.addEventListener( 'webglcontextlost', onContextLost, false );
				_canvas.addEventListener( 'webglcontextrestored', onContextRestore, false );
	
			} catch ( error ) {
	
				console.error( 'THREE.WebGLRenderer: ' + error );
	
			}
	
			var extensions, capabilities, state;
			var properties, textures, attributes, geometries, objects, lights;
			var programCache, renderLists;
	
			var background, morphtargets, bufferRenderer, indexedBufferRenderer;
			var flareRenderer, spriteRenderer;
	
			var utils;
	
			function initGLContext() {
	
				extensions = new WebGLExtensions( _gl );
				extensions.get( 'WEBGL_depth_texture' );
				extensions.get( 'OES_texture_float' );
				extensions.get( 'OES_texture_float_linear' );
				extensions.get( 'OES_texture_half_float' );
				extensions.get( 'OES_texture_half_float_linear' );
				extensions.get( 'OES_standard_derivatives' );
				extensions.get( 'ANGLE_instanced_arrays' );
	
				if ( extensions.get( 'OES_element_index_uint' ) ) {
	
					BufferGeometry.MaxIndex = 4294967296;
	
				}
	
				utils = new WebGLUtils( _gl, extensions );
	
				capabilities = new WebGLCapabilities( _gl, extensions, parameters );
	
				state = new WebGLState( _gl, extensions, utils );
				state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );
				state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );
	
				properties = new WebGLProperties();
				textures = new WebGLTextures( _gl, extensions, state, properties, capabilities, utils, _infoMemory );
				attributes = new WebGLAttributes( _gl );
				geometries = new WebGLGeometries( _gl, attributes, _infoMemory );
				objects = new WebGLObjects( geometries, _infoRender );
				morphtargets = new WebGLMorphtargets( _gl );
				programCache = new WebGLPrograms( _this, extensions, capabilities );
				lights = new WebGLLights();
				renderLists = new WebGLRenderLists();
	
				background = new WebGLBackground( _this, state, geometries, _premultipliedAlpha );
	
				bufferRenderer = new WebGLBufferRenderer( _gl, extensions, _infoRender );
				indexedBufferRenderer = new WebGLIndexedBufferRenderer( _gl, extensions, _infoRender );
	
				flareRenderer = new WebGLFlareRenderer( _this, _gl, state, textures, capabilities );
				spriteRenderer = new WebGLSpriteRenderer( _this, _gl, state, textures, capabilities );
	
				_this.info.programs = programCache.programs;
	
				_this.context = _gl;
				_this.capabilities = capabilities;
				_this.extensions = extensions;
				_this.properties = properties;
				_this.renderLists = renderLists;
				_this.state = state;
	
			}
	
			initGLContext();
	
			// vr
	
			var vr = new WebVRManager( _this );
	
			this.vr = vr;
	
			// shadow map
	
			var shadowMap = new WebGLShadowMap( _this, objects, capabilities.maxTextureSize );
	
			this.shadowMap = shadowMap;
	
			// API
	
			this.getContext = function () {
	
				return _gl;
	
			};
	
			this.getContextAttributes = function () {
	
				return _gl.getContextAttributes();
	
			};
	
			this.forceContextLoss = function () {
	
				var extension = extensions.get( 'WEBGL_lose_context' );
				if ( extension ) extension.loseContext();
	
			};
	
			this.forceContextRestore = function () {
	
				var extension = extensions.get( 'WEBGL_lose_context' );
				if ( extension ) extension.restoreContext();
	
			};
	
			this.getPixelRatio = function () {
	
				return _pixelRatio;
	
			};
	
			this.setPixelRatio = function ( value ) {
	
				if ( value === undefined ) return;
	
				_pixelRatio = value;
	
				this.setSize( _width, _height, false );
	
			};
	
			this.getSize = function () {
	
				return {
					width: _width,
					height: _height
				};
	
			};
	
			this.setSize = function ( width, height, updateStyle ) {
	
				var device = vr.getDevice();
	
				if ( device && device.isPresenting ) {
	
					console.warn( 'THREE.WebGLRenderer: Can\'t change size while VR device is presenting.' );
					return;
	
				}
	
				_width = width;
				_height = height;
	
				_canvas.width = width * _pixelRatio;
				_canvas.height = height * _pixelRatio;
	
				if ( updateStyle !== false ) {
	
					_canvas.style.width = width + 'px';
					_canvas.style.height = height + 'px';
	
				}
	
				this.setViewport( 0, 0, width, height );
	
			};
	
			this.getDrawingBufferSize = function () {
	
				return {
					width: _width * _pixelRatio,
					height: _height * _pixelRatio
				};
	
			};
	
			this.setDrawingBufferSize = function ( width, height, pixelRatio ) {
	
				_width = width;
				_height = height;
	
				_pixelRatio = pixelRatio;
	
				_canvas.width = width * pixelRatio;
				_canvas.height = height * pixelRatio;
	
				this.setViewport( 0, 0, width, height );
	
			};
	
			this.setViewport = function ( x, y, width, height ) {
	
				_viewport.set( x, _height - y - height, width, height );
				state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );
	
			};
	
			this.setScissor = function ( x, y, width, height ) {
	
				_scissor.set( x, _height - y - height, width, height );
				state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );
	
			};
	
			this.setScissorTest = function ( boolean ) {
	
				state.setScissorTest( _scissorTest = boolean );
	
			};
	
			// Clearing
	
			this.getClearColor = background.getClearColor;
			this.setClearColor = background.setClearColor;
			this.getClearAlpha = background.getClearAlpha;
			this.setClearAlpha = background.setClearAlpha;
	
			this.clear = function ( color, depth, stencil ) {
	
				var bits = 0;
	
				if ( color === undefined || color ) bits |= _gl.COLOR_BUFFER_BIT;
				if ( depth === undefined || depth ) bits |= _gl.DEPTH_BUFFER_BIT;
				if ( stencil === undefined || stencil ) bits |= _gl.STENCIL_BUFFER_BIT;
	
				_gl.clear( bits );
	
			};
	
			this.clearColor = function () {
	
				this.clear( true, false, false );
	
			};
	
			this.clearDepth = function () {
	
				this.clear( false, true, false );
	
			};
	
			this.clearStencil = function () {
	
				this.clear( false, false, true );
	
			};
	
			this.clearTarget = function ( renderTarget, color, depth, stencil ) {
	
				this.setRenderTarget( renderTarget );
				this.clear( color, depth, stencil );
	
			};
	
			//
	
			this.dispose = function () {
	
				_canvas.removeEventListener( 'webglcontextlost', onContextLost, false );
				_canvas.removeEventListener( 'webglcontextrestored', onContextRestore, false );
	
				renderLists.dispose();
	
				vr.dispose();
	
			};
	
			// Events
	
			function onContextLost( event ) {
	
				event.preventDefault();
	
				console.log( 'THREE.WebGLRenderer: Context Lost.' );
	
				_isContextLost = true;
	
			}
	
			function onContextRestore( event ) {
	
				console.log( 'THREE.WebGLRenderer: Context Restored.' );
	
				_isContextLost = false;
	
				initGLContext();
	
			}
	
			function onMaterialDispose( event ) {
	
				var material = event.target;
	
				material.removeEventListener( 'dispose', onMaterialDispose );
	
				deallocateMaterial( material );
	
			}
	
			// Buffer deallocation
	
			function deallocateMaterial( material ) {
	
				releaseMaterialProgramReference( material );
	
				properties.remove( material );
	
			}
	
	
			function releaseMaterialProgramReference( material ) {
	
				var programInfo = properties.get( material ).program;
	
				material.program = undefined;
	
				if ( programInfo !== undefined ) {
	
					programCache.releaseProgram( programInfo );
	
				}
	
			}
	
			// Buffer rendering
	
			function renderObjectImmediate( object, program, material ) {
	
				object.render( function ( object ) {
	
					_this.renderBufferImmediate( object, program, material );
	
				} );
	
			}
	
			this.renderBufferImmediate = function ( object, program, material ) {
	
				state.initAttributes();
	
				var buffers = properties.get( object );
	
				if ( object.hasPositions && ! buffers.position ) buffers.position = _gl.createBuffer();
				if ( object.hasNormals && ! buffers.normal ) buffers.normal = _gl.createBuffer();
				if ( object.hasUvs && ! buffers.uv ) buffers.uv = _gl.createBuffer();
				if ( object.hasColors && ! buffers.color ) buffers.color = _gl.createBuffer();
	
				var programAttributes = program.getAttributes();
	
				if ( object.hasPositions ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.position );
					_gl.bufferData( _gl.ARRAY_BUFFER, object.positionArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( programAttributes.position );
					_gl.vertexAttribPointer( programAttributes.position, 3, _gl.FLOAT, false, 0, 0 );
	
				}
	
				if ( object.hasNormals ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.normal );
	
					if ( ! material.isMeshPhongMaterial &&
						! material.isMeshStandardMaterial &&
						! material.isMeshNormalMaterial &&
						material.flatShading === true ) {
	
						for ( var i = 0, l = object.count * 3; i < l; i += 9 ) {
	
							var array = object.normalArray;
	
							var nx = ( array[ i + 0 ] + array[ i + 3 ] + array[ i + 6 ] ) / 3;
							var ny = ( array[ i + 1 ] + array[ i + 4 ] + array[ i + 7 ] ) / 3;
							var nz = ( array[ i + 2 ] + array[ i + 5 ] + array[ i + 8 ] ) / 3;
	
							array[ i + 0 ] = nx;
							array[ i + 1 ] = ny;
							array[ i + 2 ] = nz;
	
							array[ i + 3 ] = nx;
							array[ i + 4 ] = ny;
							array[ i + 5 ] = nz;
	
							array[ i + 6 ] = nx;
							array[ i + 7 ] = ny;
							array[ i + 8 ] = nz;
	
						}
	
					}
	
					_gl.bufferData( _gl.ARRAY_BUFFER, object.normalArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( programAttributes.normal );
	
					_gl.vertexAttribPointer( programAttributes.normal, 3, _gl.FLOAT, false, 0, 0 );
	
				}
	
				if ( object.hasUvs && material.map ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.uv );
					_gl.bufferData( _gl.ARRAY_BUFFER, object.uvArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( programAttributes.uv );
	
					_gl.vertexAttribPointer( programAttributes.uv, 2, _gl.FLOAT, false, 0, 0 );
	
				}
	
				if ( object.hasColors && material.vertexColors !== NoColors ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.color );
					_gl.bufferData( _gl.ARRAY_BUFFER, object.colorArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( programAttributes.color );
	
					_gl.vertexAttribPointer( programAttributes.color, 3, _gl.FLOAT, false, 0, 0 );
	
				}
	
				state.disableUnusedAttributes();
	
				_gl.drawArrays( _gl.TRIANGLES, 0, object.count );
	
				object.count = 0;
	
			};
	
			this.renderBufferDirect = function ( camera, fog, geometry, material, object, group ) {
	
				state.setMaterial( material );
	
				var program = setProgram( camera, fog, material, object );
				var geometryProgram = geometry.id + '_' + program.id + '_' + ( material.wireframe === true );
	
				var updateBuffers = false;
	
				if ( geometryProgram !== _currentGeometryProgram ) {
	
					_currentGeometryProgram = geometryProgram;
					updateBuffers = true;
	
				}
	
				if ( object.morphTargetInfluences ) {
	
					morphtargets.update( object, geometry, material, program );
	
					updateBuffers = true;
	
				}
	
				//
	
				var index = geometry.index;
				var position = geometry.attributes.position;
				var rangeFactor = 1;
	
				if ( material.wireframe === true ) {
	
					index = geometries.getWireframeAttribute( geometry );
					rangeFactor = 2;
	
				}
	
				var attribute;
				var renderer = bufferRenderer;
	
				if ( index !== null ) {
	
					attribute = attributes.get( index );
	
					renderer = indexedBufferRenderer;
					renderer.setIndex( attribute );
	
				}
	
				if ( updateBuffers ) {
	
					setupVertexAttributes( material, program, geometry );
	
					if ( index !== null ) {
	
						_gl.bindBuffer( _gl.ELEMENT_ARRAY_BUFFER, attribute.buffer );
	
					}
	
				}
	
				//
	
				var dataCount = 0;
	
				if ( index !== null ) {
	
					dataCount = index.count;
	
				} else if ( position !== undefined ) {
	
					dataCount = position.count;
	
				}
	
				var rangeStart = geometry.drawRange.start * rangeFactor;
				var rangeCount = geometry.drawRange.count * rangeFactor;
	
				var groupStart = group !== null ? group.start * rangeFactor : 0;
				var groupCount = group !== null ? group.count * rangeFactor : Infinity;
	
				var drawStart = Math.max( rangeStart, groupStart );
				var drawEnd = Math.min( dataCount, rangeStart + rangeCount, groupStart + groupCount ) - 1;
	
				var drawCount = Math.max( 0, drawEnd - drawStart + 1 );
	
				if ( drawCount === 0 ) return;
	
				//
	
				if ( object.isMesh ) {
	
					if ( material.wireframe === true ) {
	
						state.setLineWidth( material.wireframeLinewidth * getTargetPixelRatio() );
						renderer.setMode( _gl.LINES );
	
					} else {
	
						switch ( object.drawMode ) {
	
							case TrianglesDrawMode:
								renderer.setMode( _gl.TRIANGLES );
								break;
	
							case TriangleStripDrawMode:
								renderer.setMode( _gl.TRIANGLE_STRIP );
								break;
	
							case TriangleFanDrawMode:
								renderer.setMode( _gl.TRIANGLE_FAN );
								break;
	
						}
	
					}
	
	
				} else if ( object.isLine ) {
	
					var lineWidth = material.linewidth;
	
					if ( lineWidth === undefined ) lineWidth = 1; // Not using Line*Material
	
					state.setLineWidth( lineWidth * getTargetPixelRatio() );
	
					if ( object.isLineSegments ) {
	
						renderer.setMode( _gl.LINES );
	
					} else if ( object.isLineLoop ) {
	
						renderer.setMode( _gl.LINE_LOOP );
	
					} else {
	
						renderer.setMode( _gl.LINE_STRIP );
	
					}
	
				} else if ( object.isPoints ) {
	
					renderer.setMode( _gl.POINTS );
	
				}
	
				if ( geometry && geometry.isInstancedBufferGeometry ) {
	
					if ( geometry.maxInstancedCount > 0 ) {
	
						renderer.renderInstances( geometry, drawStart, drawCount );
	
					}
	
				} else {
	
					renderer.render( drawStart, drawCount );
	
				}
	
			};
	
			function setupVertexAttributes( material, program, geometry, startIndex ) {
	
				if ( geometry && geometry.isInstancedBufferGeometry ) {
	
					if ( extensions.get( 'ANGLE_instanced_arrays' ) === null ) {
	
						console.error( 'THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
						return;
	
					}
	
				}
	
				if ( startIndex === undefined ) startIndex = 0;
	
				state.initAttributes();
	
				var geometryAttributes = geometry.attributes;
	
				var programAttributes = program.getAttributes();
	
				var materialDefaultAttributeValues = material.defaultAttributeValues;
	
				for ( var name in programAttributes ) {
	
					var programAttribute = programAttributes[ name ];
	
					if ( programAttribute >= 0 ) {
	
						var geometryAttribute = geometryAttributes[ name ];
	
						if ( geometryAttribute !== undefined ) {
	
							var normalized = geometryAttribute.normalized;
							var size = geometryAttribute.itemSize;
	
							var attribute = attributes.get( geometryAttribute );
	
							// TODO Attribute may not be available on context restore
	
							if ( attribute === undefined ) continue;
	
							var buffer = attribute.buffer;
							var type = attribute.type;
							var bytesPerElement = attribute.bytesPerElement;
	
							if ( geometryAttribute.isInterleavedBufferAttribute ) {
	
								var data = geometryAttribute.data;
								var stride = data.stride;
								var offset = geometryAttribute.offset;
	
								if ( data && data.isInstancedInterleavedBuffer ) {
	
									state.enableAttributeAndDivisor( programAttribute, data.meshPerAttribute );
	
									if ( geometry.maxInstancedCount === undefined ) {
	
										geometry.maxInstancedCount = data.meshPerAttribute * data.count;
	
									}
	
								} else {
	
									state.enableAttribute( programAttribute );
	
								}
	
								_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
								_gl.vertexAttribPointer( programAttribute, size, type, normalized, stride * bytesPerElement, ( startIndex * stride + offset ) * bytesPerElement );
	
							} else {
	
								if ( geometryAttribute.isInstancedBufferAttribute ) {
	
									state.enableAttributeAndDivisor( programAttribute, geometryAttribute.meshPerAttribute );
	
									if ( geometry.maxInstancedCount === undefined ) {
	
										geometry.maxInstancedCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
	
									}
	
								} else {
	
									state.enableAttribute( programAttribute );
	
								}
	
								_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
								_gl.vertexAttribPointer( programAttribute, size, type, normalized, 0, startIndex * size * bytesPerElement );
	
							}
	
						} else if ( materialDefaultAttributeValues !== undefined ) {
	
							var value = materialDefaultAttributeValues[ name ];
	
							if ( value !== undefined ) {
	
								switch ( value.length ) {
	
									case 2:
										_gl.vertexAttrib2fv( programAttribute, value );
										break;
	
									case 3:
										_gl.vertexAttrib3fv( programAttribute, value );
										break;
	
									case 4:
										_gl.vertexAttrib4fv( programAttribute, value );
										break;
	
									default:
										_gl.vertexAttrib1fv( programAttribute, value );
	
								}
	
							}
	
						}
	
					}
	
				}
	
				state.disableUnusedAttributes();
	
			}
	
			// Compile
	
			this.compile = function ( scene, camera ) {
	
				lightsArray.length = 0;
				shadowsArray.length = 0;
	
				scene.traverse( function ( object ) {
	
					if ( object.isLight ) {
	
						lightsArray.push( object );
	
						if ( object.castShadow ) {
	
							shadowsArray.push( object );
	
						}
	
					}
	
				} );
	
				lights.setup( lightsArray, shadowsArray, camera );
	
				scene.traverse( function ( object ) {
	
					if ( object.material ) {
	
						if ( Array.isArray( object.material ) ) {
	
							for ( var i = 0; i < object.material.length; i ++ ) {
	
								initMaterial( object.material[ i ], scene.fog, object );
	
							}
	
						} else {
	
							initMaterial( object.material, scene.fog, object );
	
						}
	
					}
	
				} );
	
			};
	
			// Animation Loop
	
			var isAnimating = false;
			var onAnimationFrame = null;
	
			function start() {
	
				if ( isAnimating ) return;
				( vr.getDevice() || window ).requestAnimationFrame( loop );
				isAnimating = true;
	
			}
	
			function loop( time ) {
	
				if ( onAnimationFrame !== null ) onAnimationFrame( time );
				( vr.getDevice() || window ).requestAnimationFrame( loop );
	
			}
	
			this.animate = function ( callback ) {
	
				onAnimationFrame = callback;
				start();
	
			};
	
			// Rendering
	
			this.render = function ( scene, camera, renderTarget, forceClear ) {
	
				if ( ! ( camera && camera.isCamera ) ) {
	
					console.error( 'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.' );
					return;
	
				}
	
				if ( _isContextLost ) return;
	
				// reset caching for this frame
	
				_currentGeometryProgram = '';
				_currentMaterialId = - 1;
				_currentCamera = null;
	
				// update scene graph
	
				if ( scene.autoUpdate === true ) scene.updateMatrixWorld();
	
				// update camera matrices and frustum
	
				if ( camera.parent === null ) camera.updateMatrixWorld();
	
				if ( vr.enabled ) {
	
					camera = vr.getCamera( camera );
	
				}
	
				_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
				_frustum.setFromMatrix( _projScreenMatrix );
	
				lightsArray.length = 0;
				shadowsArray.length = 0;
	
				spritesArray.length = 0;
				flaresArray.length = 0;
	
				_localClippingEnabled = this.localClippingEnabled;
				_clippingEnabled = _clipping.init( this.clippingPlanes, _localClippingEnabled, camera );
	
				currentRenderList = renderLists.get( scene, camera );
				currentRenderList.init();
	
				projectObject( scene, camera, _this.sortObjects );
	
				if ( _this.sortObjects === true ) {
	
					currentRenderList.sort();
	
				}
	
				//
	
				if ( _clippingEnabled ) _clipping.beginShadows();
	
				shadowMap.render( shadowsArray, scene, camera );
	
				lights.setup( lightsArray, shadowsArray, camera );
	
				if ( _clippingEnabled ) _clipping.endShadows();
	
				//
	
				_infoRender.frame ++;
				_infoRender.calls = 0;
				_infoRender.vertices = 0;
				_infoRender.faces = 0;
				_infoRender.points = 0;
	
				if ( renderTarget === undefined ) {
	
					renderTarget = null;
	
				}
	
				this.setRenderTarget( renderTarget );
	
				//
	
				background.render( currentRenderList, scene, camera, forceClear );
	
				// render scene
	
				var opaqueObjects = currentRenderList.opaque;
				var transparentObjects = currentRenderList.transparent;
	
				if ( scene.overrideMaterial ) {
	
					var overrideMaterial = scene.overrideMaterial;
	
					if ( opaqueObjects.length ) renderObjects( opaqueObjects, scene, camera, overrideMaterial );
					if ( transparentObjects.length ) renderObjects( transparentObjects, scene, camera, overrideMaterial );
	
				} else {
	
					// opaque pass (front-to-back order)
	
					if ( opaqueObjects.length ) renderObjects( opaqueObjects, scene, camera );
	
					// transparent pass (back-to-front order)
	
					if ( transparentObjects.length ) renderObjects( transparentObjects, scene, camera );
	
				}
	
				// custom renderers
	
				spriteRenderer.render( spritesArray, scene, camera );
				flareRenderer.render( flaresArray, scene, camera, _currentViewport );
	
				// Generate mipmap if we're using any kind of mipmap filtering
	
				if ( renderTarget ) {
	
					textures.updateRenderTargetMipmap( renderTarget );
	
				}
	
				// Ensure depth buffer writing is enabled so it can be cleared on next render
	
				state.buffers.depth.setTest( true );
				state.buffers.depth.setMask( true );
				state.buffers.color.setMask( true );
	
				state.setPolygonOffset( false );
	
				if ( vr.enabled ) {
	
					vr.submitFrame();
	
				}
	
				// _gl.finish();
	
			};
	
			/*
			// TODO Duplicated code (Frustum)
	
			var _sphere = new Sphere();
	
			function isObjectViewable( object ) {
	
				var geometry = object.geometry;
	
				if ( geometry.boundingSphere === null )
					geometry.computeBoundingSphere();
	
				_sphere.copy( geometry.boundingSphere ).
				applyMatrix4( object.matrixWorld );
	
				return isSphereViewable( _sphere );
	
			}
	
			function isSpriteViewable( sprite ) {
	
				_sphere.center.set( 0, 0, 0 );
				_sphere.radius = 0.7071067811865476;
				_sphere.applyMatrix4( sprite.matrixWorld );
	
				return isSphereViewable( _sphere );
	
			}
	
			function isSphereViewable( sphere ) {
	
				if ( ! _frustum.intersectsSphere( sphere ) ) return false;
	
				var numPlanes = _clipping.numPlanes;
	
				if ( numPlanes === 0 ) return true;
	
				var planes = _this.clippingPlanes,
	
					center = sphere.center,
					negRad = - sphere.radius,
					i = 0;
	
				do {
	
					// out when deeper than radius in the negative halfspace
					if ( planes[ i ].distanceToPoint( center ) < negRad ) return false;
	
				} while ( ++ i !== numPlanes );
	
				return true;
	
			}
			*/
	
			function projectObject( object, camera, sortObjects ) {
	
				if ( ! object.visible ) return;
	
				var visible = object.layers.test( camera.layers );
	
				if ( visible ) {
	
					if ( object.isLight ) {
	
						lightsArray.push( object );
	
						if ( object.castShadow ) {
	
							shadowsArray.push( object );
	
						}
	
					} else if ( object.isSprite ) {
	
						if ( ! object.frustumCulled || _frustum.intersectsSprite( object ) ) {
	
							spritesArray.push( object );
	
						}
	
					} else if ( object.isLensFlare ) {
	
						flaresArray.push( object );
	
					} else if ( object.isImmediateRenderObject ) {
	
						if ( sortObjects ) {
	
							_vector3.setFromMatrixPosition( object.matrixWorld )
								.applyMatrix4( _projScreenMatrix );
	
						}
	
						currentRenderList.push( object, null, object.material, _vector3.z, null );
	
					} else if ( object.isMesh || object.isLine || object.isPoints ) {
	
						if ( object.isSkinnedMesh ) {
	
							object.skeleton.update();
	
						}
	
						if ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) {
	
							if ( sortObjects ) {
	
								_vector3.setFromMatrixPosition( object.matrixWorld )
									.applyMatrix4( _projScreenMatrix );
	
							}
	
							var geometry = objects.update( object );
							var material = object.material;
	
							if ( Array.isArray( material ) ) {
	
								var groups = geometry.groups;
	
								for ( var i = 0, l = groups.length; i < l; i ++ ) {
	
									var group = groups[ i ];
									var groupMaterial = material[ group.materialIndex ];
	
									if ( groupMaterial && groupMaterial.visible ) {
	
										currentRenderList.push( object, geometry, groupMaterial, _vector3.z, group );
	
									}
	
								}
	
							} else if ( material.visible ) {
	
								currentRenderList.push( object, geometry, material, _vector3.z, null );
	
							}
	
						}
	
					}
	
				}
	
				var children = object.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					projectObject( children[ i ], camera, sortObjects );
	
				}
	
			}
	
			function renderObjects( renderList, scene, camera, overrideMaterial ) {
	
				for ( var i = 0, l = renderList.length; i < l; i ++ ) {
	
					var renderItem = renderList[ i ];
	
					var object = renderItem.object;
					var geometry = renderItem.geometry;
					var material = overrideMaterial === undefined ? renderItem.material : overrideMaterial;
					var group = renderItem.group;
	
					if ( camera.isArrayCamera ) {
	
						_currentArrayCamera = camera;
	
						var cameras = camera.cameras;
	
						for ( var j = 0, jl = cameras.length; j < jl; j ++ ) {
	
							var camera2 = cameras[ j ];
	
							if ( object.layers.test( camera2.layers ) ) {
	
								var bounds = camera2.bounds;
	
								var x = bounds.x * _width;
								var y = bounds.y * _height;
								var width = bounds.z * _width;
								var height = bounds.w * _height;
	
								state.viewport( _currentViewport.set( x, y, width, height ).multiplyScalar( _pixelRatio ) );
	
								renderObject( object, scene, camera2, geometry, material, group );
	
							}
	
						}
	
					} else {
	
						_currentArrayCamera = null;
	
						renderObject( object, scene, camera, geometry, material, group );
	
					}
	
				}
	
			}
	
			function renderObject( object, scene, camera, geometry, material, group ) {
	
				object.onBeforeRender( _this, scene, camera, geometry, material, group );
	
				object.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, object.matrixWorld );
				object.normalMatrix.getNormalMatrix( object.modelViewMatrix );
	
				if ( object.isImmediateRenderObject ) {
	
					state.setMaterial( material );
	
					var program = setProgram( camera, scene.fog, material, object );
	
					_currentGeometryProgram = '';
	
					renderObjectImmediate( object, program, material );
	
				} else {
	
					_this.renderBufferDirect( camera, scene.fog, geometry, material, object, group );
	
				}
	
				object.onAfterRender( _this, scene, camera, geometry, material, group );
	
			}
	
			function initMaterial( material, fog, object ) {
	
				var materialProperties = properties.get( material );
	
				var parameters = programCache.getParameters(
					material, lights.state, shadowsArray, fog, _clipping.numPlanes, _clipping.numIntersection, object );
	
				var code = programCache.getProgramCode( material, parameters );
	
				var program = materialProperties.program;
				var programChange = true;
	
				if ( program === undefined ) {
	
					// new material
					material.addEventListener( 'dispose', onMaterialDispose );
	
				} else if ( program.code !== code ) {
	
					// changed glsl or parameters
					releaseMaterialProgramReference( material );
	
				} else if ( parameters.shaderID !== undefined ) {
	
					// same glsl and uniform list
					return;
	
				} else {
	
					// only rebuild uniform list
					programChange = false;
	
				}
	
				if ( programChange ) {
	
					if ( parameters.shaderID ) {
	
						var shader = ShaderLib[ parameters.shaderID ];
	
						materialProperties.shader = {
							name: material.type,
							uniforms: UniformsUtils.clone( shader.uniforms ),
							vertexShader: shader.vertexShader,
							fragmentShader: shader.fragmentShader
						};
	
					} else {
	
						materialProperties.shader = {
							name: material.type,
							uniforms: material.uniforms,
							vertexShader: material.vertexShader,
							fragmentShader: material.fragmentShader
						};
	
					}
	
					material.onBeforeCompile( materialProperties.shader );
	
					program = programCache.acquireProgram( material, materialProperties.shader, parameters, code );
	
					materialProperties.program = program;
					material.program = program;
	
				}
	
				var programAttributes = program.getAttributes();
	
				if ( material.morphTargets ) {
	
					material.numSupportedMorphTargets = 0;
	
					for ( var i = 0; i < _this.maxMorphTargets; i ++ ) {
	
						if ( programAttributes[ 'morphTarget' + i ] >= 0 ) {
	
							material.numSupportedMorphTargets ++;
	
						}
	
					}
	
				}
	
				if ( material.morphNormals ) {
	
					material.numSupportedMorphNormals = 0;
	
					for ( var i = 0; i < _this.maxMorphNormals; i ++ ) {
	
						if ( programAttributes[ 'morphNormal' + i ] >= 0 ) {
	
							material.numSupportedMorphNormals ++;
	
						}
	
					}
	
				}
	
				var uniforms = materialProperties.shader.uniforms;
	
				if ( ! material.isShaderMaterial &&
					! material.isRawShaderMaterial ||
					material.clipping === true ) {
	
					materialProperties.numClippingPlanes = _clipping.numPlanes;
					materialProperties.numIntersection = _clipping.numIntersection;
					uniforms.clippingPlanes = _clipping.uniform;
	
				}
	
				materialProperties.fog = fog;
	
				// store the light setup it was created for
	
				materialProperties.lightsHash = lights.state.hash;
	
				if ( material.lights ) {
	
					// wire up the material to this renderer's lighting state
	
					uniforms.ambientLightColor.value = lights.state.ambient;
					uniforms.directionalLights.value = lights.state.directional;
					uniforms.spotLights.value = lights.state.spot;
					uniforms.rectAreaLights.value = lights.state.rectArea;
					uniforms.pointLights.value = lights.state.point;
					uniforms.hemisphereLights.value = lights.state.hemi;
	
					uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
					uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
					uniforms.spotShadowMap.value = lights.state.spotShadowMap;
					uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
					uniforms.pointShadowMap.value = lights.state.pointShadowMap;
					uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
					// TODO (abelnation): add area lights shadow info to uniforms
	
				}
	
				var progUniforms = materialProperties.program.getUniforms(),
					uniformsList =
						WebGLUniforms.seqWithValue( progUniforms.seq, uniforms );
	
				materialProperties.uniformsList = uniformsList;
	
			}
	
			function setProgram( camera, fog, material, object ) {
	
				_usedTextureUnits = 0;
	
				var materialProperties = properties.get( material );
	
				if ( _clippingEnabled ) {
	
					if ( _localClippingEnabled || camera !== _currentCamera ) {
	
						var useCache =
							camera === _currentCamera &&
							material.id === _currentMaterialId;
	
						// we might want to call this function with some ClippingGroup
						// object instead of the material, once it becomes feasible
						// (#8465, #8379)
						_clipping.setState(
							material.clippingPlanes, material.clipIntersection, material.clipShadows,
							camera, materialProperties, useCache );
	
					}
	
				}
	
				if ( material.needsUpdate === false ) {
	
					if ( materialProperties.program === undefined ) {
	
						material.needsUpdate = true;
	
					} else if ( material.fog && materialProperties.fog !== fog ) {
	
						material.needsUpdate = true;
	
					} else if ( material.lights && materialProperties.lightsHash !== lights.state.hash ) {
	
						material.needsUpdate = true;
	
					} else if ( materialProperties.numClippingPlanes !== undefined &&
						( materialProperties.numClippingPlanes !== _clipping.numPlanes ||
						materialProperties.numIntersection !== _clipping.numIntersection ) ) {
	
						material.needsUpdate = true;
	
					}
	
				}
	
				if ( material.needsUpdate ) {
	
					initMaterial( material, fog, object );
					material.needsUpdate = false;
	
				}
	
				var refreshProgram = false;
				var refreshMaterial = false;
				var refreshLights = false;
	
				var program = materialProperties.program,
					p_uniforms = program.getUniforms(),
					m_uniforms = materialProperties.shader.uniforms;
	
				if ( state.useProgram( program.program ) ) {
	
					refreshProgram = true;
					refreshMaterial = true;
					refreshLights = true;
	
				}
	
				if ( material.id !== _currentMaterialId ) {
	
					_currentMaterialId = material.id;
	
					refreshMaterial = true;
	
				}
	
				if ( refreshProgram || camera !== _currentCamera ) {
	
					p_uniforms.setValue( _gl, 'projectionMatrix', camera.projectionMatrix );
	
					if ( capabilities.logarithmicDepthBuffer ) {
	
						p_uniforms.setValue( _gl, 'logDepthBufFC',
							2.0 / ( Math.log( camera.far + 1.0 ) / Math.LN2 ) );
	
					}
	
					// Avoid unneeded uniform updates per ArrayCamera's sub-camera
	
					if ( _currentCamera !== ( _currentArrayCamera || camera ) ) {
	
						_currentCamera = ( _currentArrayCamera || camera );
	
						// lighting uniforms depend on the camera so enforce an update
						// now, in case this material supports lights - or later, when
						// the next material that does gets activated:
	
						refreshMaterial = true;		// set to true on material change
						refreshLights = true;		// remains set until update done
	
					}
	
					// load material specific uniforms
					// (shader material also gets them for the sake of genericity)
	
					if ( material.isShaderMaterial ||
						material.isMeshPhongMaterial ||
						material.isMeshStandardMaterial ||
						material.envMap ) {
	
						var uCamPos = p_uniforms.map.cameraPosition;
	
						if ( uCamPos !== undefined ) {
	
							uCamPos.setValue( _gl,
								_vector3.setFromMatrixPosition( camera.matrixWorld ) );
	
						}
	
					}
	
					if ( material.isMeshPhongMaterial ||
						material.isMeshLambertMaterial ||
						material.isMeshBasicMaterial ||
						material.isMeshStandardMaterial ||
						material.isShaderMaterial ||
						material.skinning ) {
	
						p_uniforms.setValue( _gl, 'viewMatrix', camera.matrixWorldInverse );
	
					}
	
				}
	
				// skinning uniforms must be set even if material didn't change
				// auto-setting of texture unit for bone texture must go before other textures
				// not sure why, but otherwise weird things happen
	
				if ( material.skinning ) {
	
					p_uniforms.setOptional( _gl, object, 'bindMatrix' );
					p_uniforms.setOptional( _gl, object, 'bindMatrixInverse' );
	
					var skeleton = object.skeleton;
	
					if ( skeleton ) {
	
						var bones = skeleton.bones;
	
						if ( capabilities.floatVertexTextures ) {
	
							if ( skeleton.boneTexture === undefined ) {
	
								// layout (1 matrix = 4 pixels)
								//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
								//  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
								//       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
								//       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
								//       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
	
	
								var size = Math.sqrt( bones.length * 4 ); // 4 pixels needed for 1 matrix
								size = _Math.nextPowerOfTwo( Math.ceil( size ) );
								size = Math.max( size, 4 );
	
								var boneMatrices = new Float32Array( size * size * 4 ); // 4 floats per RGBA pixel
								boneMatrices.set( skeleton.boneMatrices ); // copy current values
	
								var boneTexture = new DataTexture( boneMatrices, size, size, RGBAFormat, FloatType );
	
								skeleton.boneMatrices = boneMatrices;
								skeleton.boneTexture = boneTexture;
								skeleton.boneTextureSize = size;
	
							}
	
							p_uniforms.setValue( _gl, 'boneTexture', skeleton.boneTexture );
							p_uniforms.setValue( _gl, 'boneTextureSize', skeleton.boneTextureSize );
	
						} else {
	
							p_uniforms.setOptional( _gl, skeleton, 'boneMatrices' );
	
						}
	
					}
	
				}
	
				if ( refreshMaterial ) {
	
					p_uniforms.setValue( _gl, 'toneMappingExposure', _this.toneMappingExposure );
					p_uniforms.setValue( _gl, 'toneMappingWhitePoint', _this.toneMappingWhitePoint );
	
					if ( material.lights ) {
	
						// the current material requires lighting info
	
						// note: all lighting uniforms are always set correctly
						// they simply reference the renderer's state for their
						// values
						//
						// use the current material's .needsUpdate flags to set
						// the GL state when required
	
						markUniformsLightsNeedsUpdate( m_uniforms, refreshLights );
	
					}
	
					// refresh uniforms common to several materials
	
					if ( fog && material.fog ) {
	
						refreshUniformsFog( m_uniforms, fog );
	
					}
	
					if ( material.isMeshBasicMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
	
					} else if ( material.isMeshLambertMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
						refreshUniformsLambert( m_uniforms, material );
	
					} else if ( material.isMeshPhongMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
	
						if ( material.isMeshToonMaterial ) {
	
							refreshUniformsToon( m_uniforms, material );
	
						} else {
	
							refreshUniformsPhong( m_uniforms, material );
	
						}
	
					} else if ( material.isMeshStandardMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
	
						if ( material.isMeshPhysicalMaterial ) {
	
							refreshUniformsPhysical( m_uniforms, material );
	
						} else {
	
							refreshUniformsStandard( m_uniforms, material );
	
						}
	
					} else if ( material.isMeshDepthMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
						refreshUniformsDepth( m_uniforms, material );
	
					} else if ( material.isMeshDistanceMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
						refreshUniformsDistance( m_uniforms, material );
	
					} else if ( material.isMeshNormalMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
						refreshUniformsNormal( m_uniforms, material );
	
					} else if ( material.isLineBasicMaterial ) {
	
						refreshUniformsLine( m_uniforms, material );
	
						if ( material.isLineDashedMaterial ) {
	
							refreshUniformsDash( m_uniforms, material );
	
						}
	
					} else if ( material.isPointsMaterial ) {
	
						refreshUniformsPoints( m_uniforms, material );
	
					} else if ( material.isShadowMaterial ) {
	
						m_uniforms.color.value = material.color;
						m_uniforms.opacity.value = material.opacity;
	
					}
	
					// RectAreaLight Texture
					// TODO (mrdoob): Find a nicer implementation
	
					if ( m_uniforms.ltcMat !== undefined ) m_uniforms.ltcMat.value = UniformsLib.LTC_MAT_TEXTURE;
					if ( m_uniforms.ltcMag !== undefined ) m_uniforms.ltcMag.value = UniformsLib.LTC_MAG_TEXTURE;
	
					WebGLUniforms.upload(
						_gl, materialProperties.uniformsList, m_uniforms, _this );
	
				}
	
	
				// common matrices
	
				p_uniforms.setValue( _gl, 'modelViewMatrix', object.modelViewMatrix );
				p_uniforms.setValue( _gl, 'normalMatrix', object.normalMatrix );
				p_uniforms.setValue( _gl, 'modelMatrix', object.matrixWorld );
	
				return program;
	
			}
	
			// Uniforms (refresh uniforms objects)
	
			function refreshUniformsCommon( uniforms, material ) {
	
				uniforms.opacity.value = material.opacity;
	
				if ( material.color ) {
	
					uniforms.diffuse.value = material.color;
	
				}
	
				if ( material.emissive ) {
	
					uniforms.emissive.value.copy( material.emissive ).multiplyScalar( material.emissiveIntensity );
	
				}
	
				if ( material.map ) {
	
					uniforms.map.value = material.map;
	
				}
	
				if ( material.alphaMap ) {
	
					uniforms.alphaMap.value = material.alphaMap;
	
				}
	
				if ( material.specularMap ) {
	
					uniforms.specularMap.value = material.specularMap;
	
				}
	
				if ( material.envMap ) {
	
					uniforms.envMap.value = material.envMap;
	
					// don't flip CubeTexture envMaps, flip everything else:
					//  WebGLRenderTargetCube will be flipped for backwards compatibility
					//  WebGLRenderTargetCube.texture will be flipped because it's a Texture and NOT a CubeTexture
					// this check must be handled differently, or removed entirely, if WebGLRenderTargetCube uses a CubeTexture in the future
					uniforms.flipEnvMap.value = ( ! ( material.envMap && material.envMap.isCubeTexture ) ) ? 1 : - 1;
	
					uniforms.reflectivity.value = material.reflectivity;
					uniforms.refractionRatio.value = material.refractionRatio;
	
				}
	
				if ( material.lightMap ) {
	
					uniforms.lightMap.value = material.lightMap;
					uniforms.lightMapIntensity.value = material.lightMapIntensity;
	
				}
	
				if ( material.aoMap ) {
	
					uniforms.aoMap.value = material.aoMap;
					uniforms.aoMapIntensity.value = material.aoMapIntensity;
	
				}
	
				// uv repeat and offset setting priorities
				// 1. color map
				// 2. specular map
				// 3. normal map
				// 4. bump map
				// 5. alpha map
				// 6. emissive map
	
				var uvScaleMap;
	
				if ( material.map ) {
	
					uvScaleMap = material.map;
	
				} else if ( material.specularMap ) {
	
					uvScaleMap = material.specularMap;
	
				} else if ( material.displacementMap ) {
	
					uvScaleMap = material.displacementMap;
	
				} else if ( material.normalMap ) {
	
					uvScaleMap = material.normalMap;
	
				} else if ( material.bumpMap ) {
	
					uvScaleMap = material.bumpMap;
	
				} else if ( material.roughnessMap ) {
	
					uvScaleMap = material.roughnessMap;
	
				} else if ( material.metalnessMap ) {
	
					uvScaleMap = material.metalnessMap;
	
				} else if ( material.alphaMap ) {
	
					uvScaleMap = material.alphaMap;
	
				} else if ( material.emissiveMap ) {
	
					uvScaleMap = material.emissiveMap;
	
				}
	
				if ( uvScaleMap !== undefined ) {
	
					// backwards compatibility
					if ( uvScaleMap.isWebGLRenderTarget ) {
	
						uvScaleMap = uvScaleMap.texture;
	
					}
	
					var offset = uvScaleMap.offset;
					var repeat = uvScaleMap.repeat;
	
					uniforms.offsetRepeat.value.set( offset.x, offset.y, repeat.x, repeat.y );
	
				}
	
			}
	
			function refreshUniformsLine( uniforms, material ) {
	
				uniforms.diffuse.value = material.color;
				uniforms.opacity.value = material.opacity;
	
			}
	
			function refreshUniformsDash( uniforms, material ) {
	
				uniforms.dashSize.value = material.dashSize;
				uniforms.totalSize.value = material.dashSize + material.gapSize;
				uniforms.scale.value = material.scale;
	
			}
	
			function refreshUniformsPoints( uniforms, material ) {
	
				uniforms.diffuse.value = material.color;
				uniforms.opacity.value = material.opacity;
				uniforms.size.value = material.size * _pixelRatio;
				uniforms.scale.value = _height * 0.5;
	
				uniforms.map.value = material.map;
	
				if ( material.map !== null ) {
	
					var offset = material.map.offset;
					var repeat = material.map.repeat;
	
					uniforms.offsetRepeat.value.set( offset.x, offset.y, repeat.x, repeat.y );
	
				}
	
			}
	
			function refreshUniformsFog( uniforms, fog ) {
	
				uniforms.fogColor.value = fog.color;
	
				if ( fog.isFog ) {
	
					uniforms.fogNear.value = fog.near;
					uniforms.fogFar.value = fog.far;
	
				} else if ( fog.isFogExp2 ) {
	
					uniforms.fogDensity.value = fog.density;
	
				}
	
			}
	
			function refreshUniformsLambert( uniforms, material ) {
	
				if ( material.emissiveMap ) {
	
					uniforms.emissiveMap.value = material.emissiveMap;
	
				}
	
			}
	
			function refreshUniformsPhong( uniforms, material ) {
	
				uniforms.specular.value = material.specular;
				uniforms.shininess.value = Math.max( material.shininess, 1e-4 ); // to prevent pow( 0.0, 0.0 )
	
				if ( material.emissiveMap ) {
	
					uniforms.emissiveMap.value = material.emissiveMap;
	
				}
	
				if ( material.bumpMap ) {
	
					uniforms.bumpMap.value = material.bumpMap;
					uniforms.bumpScale.value = material.bumpScale;
	
				}
	
				if ( material.normalMap ) {
	
					uniforms.normalMap.value = material.normalMap;
					uniforms.normalScale.value.copy( material.normalScale );
	
				}
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
			}
	
			function refreshUniformsToon( uniforms, material ) {
	
				refreshUniformsPhong( uniforms, material );
	
				if ( material.gradientMap ) {
	
					uniforms.gradientMap.value = material.gradientMap;
	
				}
	
			}
	
			function refreshUniformsStandard( uniforms, material ) {
	
				uniforms.roughness.value = material.roughness;
				uniforms.metalness.value = material.metalness;
	
				if ( material.roughnessMap ) {
	
					uniforms.roughnessMap.value = material.roughnessMap;
	
				}
	
				if ( material.metalnessMap ) {
	
					uniforms.metalnessMap.value = material.metalnessMap;
	
				}
	
				if ( material.emissiveMap ) {
	
					uniforms.emissiveMap.value = material.emissiveMap;
	
				}
	
				if ( material.bumpMap ) {
	
					uniforms.bumpMap.value = material.bumpMap;
					uniforms.bumpScale.value = material.bumpScale;
	
				}
	
				if ( material.normalMap ) {
	
					uniforms.normalMap.value = material.normalMap;
					uniforms.normalScale.value.copy( material.normalScale );
	
				}
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
				if ( material.envMap ) {
	
					//uniforms.envMap.value = material.envMap; // part of uniforms common
					uniforms.envMapIntensity.value = material.envMapIntensity;
	
				}
	
			}
	
			function refreshUniformsPhysical( uniforms, material ) {
	
				uniforms.clearCoat.value = material.clearCoat;
				uniforms.clearCoatRoughness.value = material.clearCoatRoughness;
	
				refreshUniformsStandard( uniforms, material );
	
			}
	
			function refreshUniformsDepth( uniforms, material ) {
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
			}
	
			function refreshUniformsDistance( uniforms, material ) {
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
				uniforms.referencePosition.value.copy( material.referencePosition );
				uniforms.nearDistance.value = material.nearDistance;
				uniforms.farDistance.value = material.farDistance;
	
			}
	
			function refreshUniformsNormal( uniforms, material ) {
	
				if ( material.bumpMap ) {
	
					uniforms.bumpMap.value = material.bumpMap;
					uniforms.bumpScale.value = material.bumpScale;
	
				}
	
				if ( material.normalMap ) {
	
					uniforms.normalMap.value = material.normalMap;
					uniforms.normalScale.value.copy( material.normalScale );
	
				}
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
			}
	
			// If uniforms are marked as clean, they don't need to be loaded to the GPU.
	
			function markUniformsLightsNeedsUpdate( uniforms, value ) {
	
				uniforms.ambientLightColor.needsUpdate = value;
	
				uniforms.directionalLights.needsUpdate = value;
				uniforms.pointLights.needsUpdate = value;
				uniforms.spotLights.needsUpdate = value;
				uniforms.rectAreaLights.needsUpdate = value;
				uniforms.hemisphereLights.needsUpdate = value;
	
			}
	
			// GL state setting
	
			this.setFaceCulling = function ( cullFace, frontFaceDirection ) {
	
				state.setCullFace( cullFace );
				state.setFlipSided( frontFaceDirection === FrontFaceDirectionCW );
	
			};
	
			// Textures
	
			function allocTextureUnit() {
	
				var textureUnit = _usedTextureUnits;
	
				if ( textureUnit >= capabilities.maxTextures ) {
	
					console.warn( 'THREE.WebGLRenderer: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures );
	
				}
	
				_usedTextureUnits += 1;
	
				return textureUnit;
	
			}
	
			this.allocTextureUnit = allocTextureUnit;
	
			// this.setTexture2D = setTexture2D;
			this.setTexture2D = ( function () {
	
				var warned = false;
	
				// backwards compatibility: peel texture.texture
				return function setTexture2D( texture, slot ) {
	
					if ( texture && texture.isWebGLRenderTarget ) {
	
						if ( ! warned ) {
	
							console.warn( "THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead." );
							warned = true;
	
						}
	
						texture = texture.texture;
	
					}
	
					textures.setTexture2D( texture, slot );
	
				};
	
			}() );
	
			this.setTexture = ( function () {
	
				var warned = false;
	
				return function setTexture( texture, slot ) {
	
					if ( ! warned ) {
	
						console.warn( "THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead." );
						warned = true;
	
					}
	
					textures.setTexture2D( texture, slot );
	
				};
	
			}() );
	
			this.setTextureCube = ( function () {
	
				var warned = false;
	
				return function setTextureCube( texture, slot ) {
	
					// backwards compatibility: peel texture.texture
					if ( texture && texture.isWebGLRenderTargetCube ) {
	
						if ( ! warned ) {
	
							console.warn( "THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead." );
							warned = true;
	
						}
	
						texture = texture.texture;
	
					}
	
					// currently relying on the fact that WebGLRenderTargetCube.texture is a Texture and NOT a CubeTexture
					// TODO: unify these code paths
					if ( ( texture && texture.isCubeTexture ) ||
						( Array.isArray( texture.image ) && texture.image.length === 6 ) ) {
	
						// CompressedTexture can have Array in image :/
	
						// this function alone should take care of cube textures
						textures.setTextureCube( texture, slot );
	
					} else {
	
						// assumed: texture property of THREE.WebGLRenderTargetCube
	
						textures.setTextureCubeDynamic( texture, slot );
	
					}
	
				};
	
			}() );
	
			this.getRenderTarget = function () {
	
				return _currentRenderTarget;
	
			};
	
			this.setRenderTarget = function ( renderTarget ) {
	
				_currentRenderTarget = renderTarget;
	
				if ( renderTarget && properties.get( renderTarget ).__webglFramebuffer === undefined ) {
	
					textures.setupRenderTarget( renderTarget );
	
				}
	
				var framebuffer = null;
				var isCube = false;
	
				if ( renderTarget ) {
	
					var __webglFramebuffer = properties.get( renderTarget ).__webglFramebuffer;
	
					if ( renderTarget.isWebGLRenderTargetCube ) {
	
						framebuffer = __webglFramebuffer[ renderTarget.activeCubeFace ];
						isCube = true;
	
					} else {
	
						framebuffer = __webglFramebuffer;
	
					}
	
					_currentViewport.copy( renderTarget.viewport );
					_currentScissor.copy( renderTarget.scissor );
					_currentScissorTest = renderTarget.scissorTest;
	
				} else {
	
					_currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio );
					_currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio );
					_currentScissorTest = _scissorTest;
	
				}
	
				if ( _currentFramebuffer !== framebuffer ) {
	
					_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
					_currentFramebuffer = framebuffer;
	
				}
	
				state.viewport( _currentViewport );
				state.scissor( _currentScissor );
				state.setScissorTest( _currentScissorTest );
	
				if ( isCube ) {
	
					var textureProperties = properties.get( renderTarget.texture );
					_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + renderTarget.activeCubeFace, textureProperties.__webglTexture, renderTarget.activeMipMapLevel );
	
				}
	
			};
	
			this.readRenderTargetPixels = function ( renderTarget, x, y, width, height, buffer ) {
	
				if ( ! ( renderTarget && renderTarget.isWebGLRenderTarget ) ) {
	
					console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );
					return;
	
				}
	
				var framebuffer = properties.get( renderTarget ).__webglFramebuffer;
	
				if ( framebuffer ) {
	
					var restore = false;
	
					if ( framebuffer !== _currentFramebuffer ) {
	
						_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
	
						restore = true;
	
					}
	
					try {
	
						var texture = renderTarget.texture;
						var textureFormat = texture.format;
						var textureType = texture.type;
	
						if ( textureFormat !== RGBAFormat && utils.convert( textureFormat ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_FORMAT ) ) {
	
							console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.' );
							return;
	
						}
	
						if ( textureType !== UnsignedByteType && utils.convert( textureType ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_TYPE ) && // IE11, Edge and Chrome Mac < 52 (#9513)
							! ( textureType === FloatType && ( extensions.get( 'OES_texture_float' ) || extensions.get( 'WEBGL_color_buffer_float' ) ) ) && // Chrome Mac >= 52 and Firefox
							! ( textureType === HalfFloatType && extensions.get( 'EXT_color_buffer_half_float' ) ) ) {
	
							console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.' );
							return;
	
						}
	
						if ( _gl.checkFramebufferStatus( _gl.FRAMEBUFFER ) === _gl.FRAMEBUFFER_COMPLETE ) {
	
							// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
	
							if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {
	
								_gl.readPixels( x, y, width, height, utils.convert( textureFormat ), utils.convert( textureType ), buffer );
	
							}
	
						} else {
	
							console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.' );
	
						}
	
					} finally {
	
						if ( restore ) {
	
							_gl.bindFramebuffer( _gl.FRAMEBUFFER, _currentFramebuffer );
	
						}
	
					}
	
				}
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function FogExp2 ( color, density ) {
	
			this.name = '';
	
			this.color = new Color( color );
			this.density = ( density !== undefined ) ? density : 0.00025;
	
		}
	
		FogExp2.prototype.isFogExp2 = true;
	
		FogExp2.prototype.clone = function () {
	
			return new FogExp2( this.color.getHex(), this.density );
	
		};
	
		FogExp2.prototype.toJSON = function ( meta ) {
	
			return {
				type: 'FogExp2',
				color: this.color.getHex(),
				density: this.density
			};
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Fog ( color, near, far ) {
	
			this.name = '';
	
			this.color = new Color( color );
	
			this.near = ( near !== undefined ) ? near : 1;
			this.far = ( far !== undefined ) ? far : 1000;
	
		}
	
		Fog.prototype.isFog = true;
	
		Fog.prototype.clone = function () {
	
			return new Fog( this.color.getHex(), this.near, this.far );
	
		};
	
		Fog.prototype.toJSON = function ( meta ) {
	
			return {
				type: 'Fog',
				color: this.color.getHex(),
				near: this.near,
				far: this.far
			};
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Scene () {
	
			Object3D.call( this );
	
			this.type = 'Scene';
	
			this.background = null;
			this.fog = null;
			this.overrideMaterial = null;
	
			this.autoUpdate = true; // checked by the renderer
	
		}
	
		Scene.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Scene,
	
			copy: function ( source, recursive ) {
	
				Object3D.prototype.copy.call( this, source, recursive );
	
				if ( source.background !== null ) this.background = source.background.clone();
				if ( source.fog !== null ) this.fog = source.fog.clone();
				if ( source.overrideMaterial !== null ) this.overrideMaterial = source.overrideMaterial.clone();
	
				this.autoUpdate = source.autoUpdate;
				this.matrixAutoUpdate = source.matrixAutoUpdate;
	
				return this;
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				if ( this.background !== null ) data.object.background = this.background.toJSON( meta );
				if ( this.fog !== null ) data.object.fog = this.fog.toJSON();
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function LensFlare( texture, size, distance, blending, color ) {
	
			Object3D.call( this );
	
			this.lensFlares = [];
	
			this.positionScreen = new Vector3();
			this.customUpdateCallback = undefined;
	
			if ( texture !== undefined ) {
	
				this.add( texture, size, distance, blending, color );
	
			}
	
		}
	
		LensFlare.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: LensFlare,
	
			isLensFlare: true,
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source );
	
				this.positionScreen.copy( source.positionScreen );
				this.customUpdateCallback = source.customUpdateCallback;
	
				for ( var i = 0, l = source.lensFlares.length; i < l; i ++ ) {
	
					this.lensFlares.push( source.lensFlares[ i ] );
	
				}
	
				return this;
	
			},
	
			add: function ( texture, size, distance, blending, color, opacity ) {
	
				if ( size === undefined ) size = - 1;
				if ( distance === undefined ) distance = 0;
				if ( opacity === undefined ) opacity = 1;
				if ( color === undefined ) color = new Color( 0xffffff );
				if ( blending === undefined ) blending = NormalBlending;
	
				distance = Math.min( distance, Math.max( 0, distance ) );
	
				this.lensFlares.push( {
					texture: texture,	// THREE.Texture
					size: size, 		// size in pixels (-1 = use texture.width)
					distance: distance, 	// distance (0-1) from light source (0=at light source)
					x: 0, y: 0, z: 0,	// screen position (-1 => 1) z = 0 is in front z = 1 is back
					scale: 1, 		// scale
					rotation: 0, 		// rotation
					opacity: opacity,	// opacity
					color: color,		// color
					blending: blending	// blending
				} );
	
			},
	
			/*
			 * Update lens flares update positions on all flares based on the screen position
			 * Set myLensFlare.customUpdateCallback to alter the flares in your project specific way.
			 */
	
			updateLensFlares: function () {
	
				var f, fl = this.lensFlares.length;
				var flare;
				var vecX = - this.positionScreen.x * 2;
				var vecY = - this.positionScreen.y * 2;
	
				for ( f = 0; f < fl; f ++ ) {
	
					flare = this.lensFlares[ f ];
	
					flare.x = this.positionScreen.x + vecX * flare.distance;
					flare.y = this.positionScreen.y + vecY * flare.distance;
	
					flare.wantedRotation = flare.x * Math.PI * 0.25;
					flare.rotation += ( flare.wantedRotation - flare.rotation ) * 0.25;
	
				}
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *	uvOffset: new THREE.Vector2(),
		 *	uvScale: new THREE.Vector2()
		 * }
		 */
	
		function SpriteMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'SpriteMaterial';
	
			this.color = new Color( 0xffffff );
			this.map = null;
	
			this.rotation = 0;
	
			this.fog = false;
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		SpriteMaterial.prototype = Object.create( Material.prototype );
		SpriteMaterial.prototype.constructor = SpriteMaterial;
		SpriteMaterial.prototype.isSpriteMaterial = true;
	
		SpriteMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
			this.map = source.map;
	
			this.rotation = source.rotation;
	
			return this;
	
		};
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Sprite( material ) {
	
			Object3D.call( this );
	
			this.type = 'Sprite';
	
			this.material = ( material !== undefined ) ? material : new SpriteMaterial();
	
		}
	
		Sprite.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Sprite,
	
			isSprite: true,
	
			raycast: ( function () {
	
				var intersectPoint = new Vector3();
				var worldPosition = new Vector3();
				var worldScale = new Vector3();
	
				return function raycast( raycaster, intersects ) {
	
					worldPosition.setFromMatrixPosition( this.matrixWorld );
					raycaster.ray.closestPointToPoint( worldPosition, intersectPoint );
	
					worldScale.setFromMatrixScale( this.matrixWorld );
					var guessSizeSq = worldScale.x * worldScale.y / 4;
	
					if ( worldPosition.distanceToSquared( intersectPoint ) > guessSizeSq ) return;
	
					var distance = raycaster.ray.origin.distanceTo( intersectPoint );
	
					if ( distance < raycaster.near || distance > raycaster.far ) return;
	
					intersects.push( {
	
						distance: distance,
						point: intersectPoint.clone(),
						face: null,
						object: this
	
					} );
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LOD() {
	
			Object3D.call( this );
	
			this.type = 'LOD';
	
			Object.defineProperties( this, {
				levels: {
					enumerable: true,
					value: []
				}
			} );
	
		}
	
		LOD.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: LOD,
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source, false );
	
				var levels = source.levels;
	
				for ( var i = 0, l = levels.length; i < l; i ++ ) {
	
					var level = levels[ i ];
	
					this.addLevel( level.object.clone(), level.distance );
	
				}
	
				return this;
	
			},
	
			addLevel: function ( object, distance ) {
	
				if ( distance === undefined ) distance = 0;
	
				distance = Math.abs( distance );
	
				var levels = this.levels;
	
				for ( var l = 0; l < levels.length; l ++ ) {
	
					if ( distance < levels[ l ].distance ) {
	
						break;
	
					}
	
				}
	
				levels.splice( l, 0, { distance: distance, object: object } );
	
				this.add( object );
	
			},
	
			getObjectForDistance: function ( distance ) {
	
				var levels = this.levels;
	
				for ( var i = 1, l = levels.length; i < l; i ++ ) {
	
					if ( distance < levels[ i ].distance ) {
	
						break;
	
					}
	
				}
	
				return levels[ i - 1 ].object;
	
			},
	
			raycast: ( function () {
	
				var matrixPosition = new Vector3();
	
				return function raycast( raycaster, intersects ) {
	
					matrixPosition.setFromMatrixPosition( this.matrixWorld );
	
					var distance = raycaster.ray.origin.distanceTo( matrixPosition );
	
					this.getObjectForDistance( distance ).raycast( raycaster, intersects );
	
				};
	
			}() ),
	
			update: function () {
	
				var v1 = new Vector3();
				var v2 = new Vector3();
	
				return function update( camera ) {
	
					var levels = this.levels;
	
					if ( levels.length > 1 ) {
	
						v1.setFromMatrixPosition( camera.matrixWorld );
						v2.setFromMatrixPosition( this.matrixWorld );
	
						var distance = v1.distanceTo( v2 );
	
						levels[ 0 ].object.visible = true;
	
						for ( var i = 1, l = levels.length; i < l; i ++ ) {
	
							if ( distance >= levels[ i ].distance ) {
	
								levels[ i - 1 ].object.visible = false;
								levels[ i ].object.visible = true;
	
							} else {
	
								break;
	
							}
	
						}
	
						for ( ; i < l; i ++ ) {
	
							levels[ i ].object.visible = false;
	
						}
	
					}
	
				};
	
			}(),
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.levels = [];
	
				var levels = this.levels;
	
				for ( var i = 0, l = levels.length; i < l; i ++ ) {
	
					var level = levels[ i ];
	
					data.object.levels.push( {
						object: level.object.uuid,
						distance: level.distance
					} );
	
				}
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author michael guerrero / http://realitymeltdown.com
		 * @author ikerr / http://verold.com
		 */
	
		function Skeleton( bones, boneInverses ) {
	
			// copy the bone array
	
			bones = bones || [];
	
			this.bones = bones.slice( 0 );
			this.boneMatrices = new Float32Array( this.bones.length * 16 );
	
			// use the supplied bone inverses or calculate the inverses
	
			if ( boneInverses === undefined ) {
	
				this.calculateInverses();
	
			} else {
	
				if ( this.bones.length === boneInverses.length ) {
	
					this.boneInverses = boneInverses.slice( 0 );
	
				} else {
	
					console.warn( 'THREE.Skeleton boneInverses is the wrong length.' );
	
					this.boneInverses = [];
	
					for ( var i = 0, il = this.bones.length; i < il; i ++ ) {
	
						this.boneInverses.push( new Matrix4() );
	
					}
	
				}
	
			}
	
		}
	
		Object.assign( Skeleton.prototype, {
	
			calculateInverses: function () {
	
				this.boneInverses = [];
	
				for ( var i = 0, il = this.bones.length; i < il; i ++ ) {
	
					var inverse = new Matrix4();
	
					if ( this.bones[ i ] ) {
	
						inverse.getInverse( this.bones[ i ].matrixWorld );
	
					}
	
					this.boneInverses.push( inverse );
	
				}
	
			},
	
			pose: function () {
	
				var bone, i, il;
	
				// recover the bind-time world matrices
	
				for ( i = 0, il = this.bones.length; i < il; i ++ ) {
	
					bone = this.bones[ i ];
	
					if ( bone ) {
	
						bone.matrixWorld.getInverse( this.boneInverses[ i ] );
	
					}
	
				}
	
				// compute the local matrices, positions, rotations and scales
	
				for ( i = 0, il = this.bones.length; i < il; i ++ ) {
	
					bone = this.bones[ i ];
	
					if ( bone ) {
	
						if ( bone.parent && bone.parent.isBone ) {
	
							bone.matrix.getInverse( bone.parent.matrixWorld );
							bone.matrix.multiply( bone.matrixWorld );
	
						} else {
	
							bone.matrix.copy( bone.matrixWorld );
	
						}
	
						bone.matrix.decompose( bone.position, bone.quaternion, bone.scale );
	
					}
	
				}
	
			},
	
			update: ( function () {
	
				var offsetMatrix = new Matrix4();
				var identityMatrix = new Matrix4();
	
				return function update() {
	
					var bones = this.bones;
					var boneInverses = this.boneInverses;
					var boneMatrices = this.boneMatrices;
					var boneTexture = this.boneTexture;
	
					// flatten bone matrices to array
	
					for ( var i = 0, il = bones.length; i < il; i ++ ) {
	
						// compute the offset between the current and the original transform
	
						var matrix = bones[ i ] ? bones[ i ].matrixWorld : identityMatrix;
	
						offsetMatrix.multiplyMatrices( matrix, boneInverses[ i ] );
						offsetMatrix.toArray( boneMatrices, i * 16 );
	
					}
	
					if ( boneTexture !== undefined ) {
	
						boneTexture.needsUpdate = true;
	
					}
	
				};
	
			} )(),
	
			clone: function () {
	
				return new Skeleton( this.bones, this.boneInverses );
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author ikerr / http://verold.com
		 */
	
		function Bone() {
	
			Object3D.call( this );
	
			this.type = 'Bone';
	
		}
	
		Bone.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Bone,
	
			isBone: true
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author ikerr / http://verold.com
		 */
	
		function SkinnedMesh( geometry, material ) {
	
			Mesh.call( this, geometry, material );
	
			this.type = 'SkinnedMesh';
	
			this.bindMode = 'attached';
			this.bindMatrix = new Matrix4();
			this.bindMatrixInverse = new Matrix4();
	
			var bones = this.initBones();
			var skeleton = new Skeleton( bones );
	
			this.bind( skeleton, this.matrixWorld );
	
			this.normalizeSkinWeights();
	
		}
	
		SkinnedMesh.prototype = Object.assign( Object.create( Mesh.prototype ), {
	
			constructor: SkinnedMesh,
	
			isSkinnedMesh: true,
	
			initBones: function () {
	
				var bones = [], bone, gbone;
				var i, il;
	
				if ( this.geometry && this.geometry.bones !== undefined ) {
	
					// first, create array of 'Bone' objects from geometry data
	
					for ( i = 0, il = this.geometry.bones.length; i < il; i ++ ) {
	
						gbone = this.geometry.bones[ i ];
	
						// create new 'Bone' object
	
						bone = new Bone();
						bones.push( bone );
	
						// apply values
	
						bone.name = gbone.name;
						bone.position.fromArray( gbone.pos );
						bone.quaternion.fromArray( gbone.rotq );
						if ( gbone.scl !== undefined ) bone.scale.fromArray( gbone.scl );
	
					}
	
					// second, create bone hierarchy
	
					for ( i = 0, il = this.geometry.bones.length; i < il; i ++ ) {
	
						gbone = this.geometry.bones[ i ];
	
						if ( ( gbone.parent !== - 1 ) && ( gbone.parent !== null ) && ( bones[ gbone.parent ] !== undefined ) ) {
	
							// subsequent bones in the hierarchy
	
							bones[ gbone.parent ].add( bones[ i ] );
	
						} else {
	
							// topmost bone, immediate child of the skinned mesh
	
							this.add( bones[ i ] );
	
						}
	
					}
	
				}
	
				// now the bones are part of the scene graph and children of the skinned mesh.
				// let's update the corresponding matrices
	
				this.updateMatrixWorld( true );
	
				return bones;
	
			},
	
			bind: function ( skeleton, bindMatrix ) {
	
				this.skeleton = skeleton;
	
				if ( bindMatrix === undefined ) {
	
					this.updateMatrixWorld( true );
	
					this.skeleton.calculateInverses();
	
					bindMatrix = this.matrixWorld;
	
				}
	
				this.bindMatrix.copy( bindMatrix );
				this.bindMatrixInverse.getInverse( bindMatrix );
	
			},
	
			pose: function () {
	
				this.skeleton.pose();
	
			},
	
			normalizeSkinWeights: function () {
	
				var scale, i;
	
				if ( this.geometry && this.geometry.isGeometry ) {
	
					for ( i = 0; i < this.geometry.skinWeights.length; i ++ ) {
	
						var sw = this.geometry.skinWeights[ i ];
	
						scale = 1.0 / sw.lengthManhattan();
	
						if ( scale !== Infinity ) {
	
							sw.multiplyScalar( scale );
	
						} else {
	
							sw.set( 1, 0, 0, 0 ); // do something reasonable
	
						}
	
					}
	
				} else if ( this.geometry && this.geometry.isBufferGeometry ) {
	
					var vec = new Vector4();
	
					var skinWeight = this.geometry.attributes.skinWeight;
	
					for ( i = 0; i < skinWeight.count; i ++ ) {
	
						vec.x = skinWeight.getX( i );
						vec.y = skinWeight.getY( i );
						vec.z = skinWeight.getZ( i );
						vec.w = skinWeight.getW( i );
	
						scale = 1.0 / vec.lengthManhattan();
	
						if ( scale !== Infinity ) {
	
							vec.multiplyScalar( scale );
	
						} else {
	
							vec.set( 1, 0, 0, 0 ); // do something reasonable
	
						}
	
						skinWeight.setXYZW( i, vec.x, vec.y, vec.z, vec.w );
	
					}
	
				}
	
			},
	
			updateMatrixWorld: function ( force ) {
	
				Mesh.prototype.updateMatrixWorld.call( this, force );
	
				if ( this.bindMode === 'attached' ) {
	
					this.bindMatrixInverse.getInverse( this.matrixWorld );
	
				} else if ( this.bindMode === 'detached' ) {
	
					this.bindMatrixInverse.getInverse( this.bindMatrix );
	
				} else {
	
					console.warn( 'THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *
		 *  linewidth: <float>,
		 *  linecap: "round",
		 *  linejoin: "round"
		 * }
		 */
	
		function LineBasicMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'LineBasicMaterial';
	
			this.color = new Color( 0xffffff );
	
			this.linewidth = 1;
			this.linecap = 'round';
			this.linejoin = 'round';
	
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		LineBasicMaterial.prototype = Object.create( Material.prototype );
		LineBasicMaterial.prototype.constructor = LineBasicMaterial;
	
		LineBasicMaterial.prototype.isLineBasicMaterial = true;
	
		LineBasicMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.linewidth = source.linewidth;
			this.linecap = source.linecap;
			this.linejoin = source.linejoin;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Line( geometry, material, mode ) {
	
			if ( mode === 1 ) {
	
				console.warn( 'THREE.Line: parameter THREE.LinePieces no longer supported. Created THREE.LineSegments instead.' );
				return new LineSegments( geometry, material );
	
			}
	
			Object3D.call( this );
	
			this.type = 'Line';
	
			this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
			this.material = material !== undefined ? material : new LineBasicMaterial( { color: Math.random() * 0xffffff } );
	
		}
	
		Line.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Line,
	
			isLine: true,
	
			raycast: ( function () {
	
				var inverseMatrix = new Matrix4();
				var ray = new Ray();
				var sphere = new Sphere();
	
				return function raycast( raycaster, intersects ) {
	
					var precision = raycaster.linePrecision;
					var precisionSq = precision * precision;
	
					var geometry = this.geometry;
					var matrixWorld = this.matrixWorld;
	
					// Checking boundingSphere distance to ray
	
					if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere );
					sphere.applyMatrix4( matrixWorld );
	
					if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;
	
					//
	
					inverseMatrix.getInverse( matrixWorld );
					ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );
	
					var vStart = new Vector3();
					var vEnd = new Vector3();
					var interSegment = new Vector3();
					var interRay = new Vector3();
					var step = (this && this.isLineSegments) ? 2 : 1;
	
					if ( geometry.isBufferGeometry ) {
	
						var index = geometry.index;
						var attributes = geometry.attributes;
						var positions = attributes.position.array;
	
						if ( index !== null ) {
	
							var indices = index.array;
	
							for ( var i = 0, l = indices.length - 1; i < l; i += step ) {
	
								var a = indices[ i ];
								var b = indices[ i + 1 ];
	
								vStart.fromArray( positions, a * 3 );
								vEnd.fromArray( positions, b * 3 );
	
								var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );
	
								if ( distSq > precisionSq ) continue;
	
								interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation
	
								var distance = raycaster.ray.origin.distanceTo( interRay );
	
								if ( distance < raycaster.near || distance > raycaster.far ) continue;
	
								intersects.push( {
	
									distance: distance,
									// What do we want? intersection point on the ray or on the segment??
									// point: raycaster.ray.at( distance ),
									point: interSegment.clone().applyMatrix4( this.matrixWorld ),
									index: i,
									face: null,
									faceIndex: null,
									object: this
	
								} );
	
							}
	
						} else {
	
							for ( var i = 0, l = positions.length / 3 - 1; i < l; i += step ) {
	
								vStart.fromArray( positions, 3 * i );
								vEnd.fromArray( positions, 3 * i + 3 );
	
								var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );
	
								if ( distSq > precisionSq ) continue;
	
								interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation
	
								var distance = raycaster.ray.origin.distanceTo( interRay );
	
								if ( distance < raycaster.near || distance > raycaster.far ) continue;
	
								intersects.push( {
	
									distance: distance,
									// What do we want? intersection point on the ray or on the segment??
									// point: raycaster.ray.at( distance ),
									point: interSegment.clone().applyMatrix4( this.matrixWorld ),
									index: i,
									face: null,
									faceIndex: null,
									object: this
	
								} );
	
							}
	
						}
	
					} else if ( geometry.isGeometry ) {
	
						var vertices = geometry.vertices;
						var nbVertices = vertices.length;
	
						for ( var i = 0; i < nbVertices - 1; i += step ) {
	
							var distSq = ray.distanceSqToSegment( vertices[ i ], vertices[ i + 1 ], interRay, interSegment );
	
							if ( distSq > precisionSq ) continue;
	
							interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation
	
							var distance = raycaster.ray.origin.distanceTo( interRay );
	
							if ( distance < raycaster.near || distance > raycaster.far ) continue;
	
							intersects.push( {
	
								distance: distance,
								// What do we want? intersection point on the ray or on the segment??
								// point: raycaster.ray.at( distance ),
								point: interSegment.clone().applyMatrix4( this.matrixWorld ),
								index: i,
								face: null,
								faceIndex: null,
								object: this
	
							} );
	
						}
	
					}
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LineSegments( geometry, material ) {
	
			Line.call( this, geometry, material );
	
			this.type = 'LineSegments';
	
		}
	
		LineSegments.prototype = Object.assign( Object.create( Line.prototype ), {
	
			constructor: LineSegments,
	
			isLineSegments: true
	
		} );
	
		/**
		 * @author mgreter / http://github.com/mgreter
		 */
	
		function LineLoop( geometry, material ) {
	
			Line.call( this, geometry, material );
	
			this.type = 'LineLoop';
	
		}
	
		LineLoop.prototype = Object.assign( Object.create( Line.prototype ), {
	
			constructor: LineLoop,
	
			isLineLoop: true,
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  size: <float>,
		 *  sizeAttenuation: <bool>
		 * }
		 */
	
		function PointsMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'PointsMaterial';
	
			this.color = new Color( 0xffffff );
	
			this.map = null;
	
			this.size = 1;
			this.sizeAttenuation = true;
	
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		PointsMaterial.prototype = Object.create( Material.prototype );
		PointsMaterial.prototype.constructor = PointsMaterial;
	
		PointsMaterial.prototype.isPointsMaterial = true;
	
		PointsMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.map = source.map;
	
			this.size = source.size;
			this.sizeAttenuation = source.sizeAttenuation;
	
			return this;
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Points( geometry, material ) {
	
			Object3D.call( this );
	
			this.type = 'Points';
	
			this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
			this.material = material !== undefined ? material : new PointsMaterial( { color: Math.random() * 0xffffff } );
	
		}
	
		Points.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Points,
	
			isPoints: true,
	
			raycast: ( function () {
	
				var inverseMatrix = new Matrix4();
				var ray = new Ray();
				var sphere = new Sphere();
	
				return function raycast( raycaster, intersects ) {
	
					var object = this;
					var geometry = this.geometry;
					var matrixWorld = this.matrixWorld;
					var threshold = raycaster.params.Points.threshold;
	
					// Checking boundingSphere distance to ray
	
					if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere );
					sphere.applyMatrix4( matrixWorld );
					sphere.radius += threshold;
	
					if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;
	
					//
	
					inverseMatrix.getInverse( matrixWorld );
					ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );
	
					var localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
					var localThresholdSq = localThreshold * localThreshold;
					var position = new Vector3();
	
					function testPoint( point, index ) {
	
						var rayPointDistanceSq = ray.distanceSqToPoint( point );
	
						if ( rayPointDistanceSq < localThresholdSq ) {
	
							var intersectPoint = ray.closestPointToPoint( point );
							intersectPoint.applyMatrix4( matrixWorld );
	
							var distance = raycaster.ray.origin.distanceTo( intersectPoint );
	
							if ( distance < raycaster.near || distance > raycaster.far ) return;
	
							intersects.push( {
	
								distance: distance,
								distanceToRay: Math.sqrt( rayPointDistanceSq ),
								point: intersectPoint.clone(),
								index: index,
								face: null,
								object: object
	
							} );
	
						}
	
					}
	
					if ( geometry.isBufferGeometry ) {
	
						var index = geometry.index;
						var attributes = geometry.attributes;
						var positions = attributes.position.array;
	
						if ( index !== null ) {
	
							var indices = index.array;
	
							for ( var i = 0, il = indices.length; i < il; i ++ ) {
	
								var a = indices[ i ];
	
								position.fromArray( positions, a * 3 );
	
								testPoint( position, a );
	
							}
	
						} else {
	
							for ( var i = 0, l = positions.length / 3; i < l; i ++ ) {
	
								position.fromArray( positions, i * 3 );
	
								testPoint( position, i );
	
							}
	
						}
	
					} else {
	
						var vertices = geometry.vertices;
	
						for ( var i = 0, l = vertices.length; i < l; i ++ ) {
	
							testPoint( vertices[ i ], i );
	
						}
	
					}
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Group() {
	
			Object3D.call( this );
	
			this.type = 'Group';
	
		}
	
		Group.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Group
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function VideoTexture( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {
	
			Texture.call( this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );
	
			this.generateMipmaps = false;
	
			var scope = this;
	
			function update() {
	
				requestAnimationFrame( update );
	
				if ( video.readyState >= video.HAVE_CURRENT_DATA ) {
	
					scope.needsUpdate = true;
	
				}
	
			}
	
			update();
	
		}
	
		VideoTexture.prototype = Object.create( Texture.prototype );
		VideoTexture.prototype.constructor = VideoTexture;
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function CompressedTexture( mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {
	
			Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );
	
			this.image = { width: width, height: height };
			this.mipmaps = mipmaps;
	
			// no flipping for cube textures
			// (also flipping doesn't work for compressed textures )
	
			this.flipY = false;
	
			// can't generate mipmaps for compressed textures
			// mips must be embedded in DDS files
	
			this.generateMipmaps = false;
	
		}
	
		CompressedTexture.prototype = Object.create( Texture.prototype );
		CompressedTexture.prototype.constructor = CompressedTexture;
	
		CompressedTexture.prototype.isCompressedTexture = true;
	
		/**
		 * @author Matt DesLauriers / @mattdesl
		 * @author atix / arthursilber.de
		 */
	
		function DepthTexture( width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format ) {
	
			format = format !== undefined ? format : DepthFormat;
	
			if ( format !== DepthFormat && format !== DepthStencilFormat ) {
	
				throw new Error( 'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat' );
	
			}
	
			if ( type === undefined && format === DepthFormat ) type = UnsignedShortType;
			if ( type === undefined && format === DepthStencilFormat ) type = UnsignedInt248Type;
	
			Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );
	
			this.image = { width: width, height: height };
	
			this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
			this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
	
			this.flipY = false;
			this.generateMipmaps	= false;
	
		}
	
		DepthTexture.prototype = Object.create( Texture.prototype );
		DepthTexture.prototype.constructor = DepthTexture;
		DepthTexture.prototype.isDepthTexture = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function WireframeGeometry( geometry ) {
	
			BufferGeometry.call( this );
	
			this.type = 'WireframeGeometry';
	
			// buffer
	
			var vertices = [];
	
			// helper variables
	
			var i, j, l, o, ol;
			var edge = [ 0, 0 ], edges = {}, e, edge1, edge2;
			var key, keys = [ 'a', 'b', 'c' ];
			var vertex;
	
			// different logic for Geometry and BufferGeometry
	
			if ( geometry && geometry.isGeometry ) {
	
				// create a data structure that contains all edges without duplicates
	
				var faces = geometry.faces;
	
				for ( i = 0, l = faces.length; i < l; i ++ ) {
	
					var face = faces[ i ];
	
					for ( j = 0; j < 3; j ++ ) {
	
						edge1 = face[ keys[ j ] ];
						edge2 = face[ keys[ ( j + 1 ) % 3 ] ];
						edge[ 0 ] = Math.min( edge1, edge2 ); // sorting prevents duplicates
						edge[ 1 ] = Math.max( edge1, edge2 );
	
						key = edge[ 0 ] + ',' + edge[ 1 ];
	
						if ( edges[ key ] === undefined ) {
	
							edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ] };
	
						}
	
					}
	
				}
	
				// generate vertices
	
				for ( key in edges ) {
	
					e = edges[ key ];
	
					vertex = geometry.vertices[ e.index1 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					vertex = geometry.vertices[ e.index2 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
			} else if ( geometry && geometry.isBufferGeometry ) {
	
				var position, indices, groups;
				var group, start, count;
				var index1, index2;
	
				vertex = new Vector3();
	
				if ( geometry.index !== null ) {
	
					// indexed BufferGeometry
	
					position = geometry.attributes.position;
					indices = geometry.index;
					groups = geometry.groups;
	
					if ( groups.length === 0 ) {
	
						groups = [ { start: 0, count: indices.count, materialIndex: 0 } ];
	
					}
	
					// create a data structure that contains all eges without duplicates
	
					for ( o = 0, ol = groups.length; o < ol; ++ o ) {
	
						group = groups[ o ];
	
						start = group.start;
						count = group.count;
	
						for ( i = start, l = ( start + count ); i < l; i += 3 ) {
	
							for ( j = 0; j < 3; j ++ ) {
	
								edge1 = indices.getX( i + j );
								edge2 = indices.getX( i + ( j + 1 ) % 3 );
								edge[ 0 ] = Math.min( edge1, edge2 ); // sorting prevents duplicates
								edge[ 1 ] = Math.max( edge1, edge2 );
	
								key = edge[ 0 ] + ',' + edge[ 1 ];
	
								if ( edges[ key ] === undefined ) {
	
									edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ] };
	
								}
	
							}
	
						}
	
					}
	
					// generate vertices
	
					for ( key in edges ) {
	
						e = edges[ key ];
	
						vertex.fromBufferAttribute( position, e.index1 );
						vertices.push( vertex.x, vertex.y, vertex.z );
	
						vertex.fromBufferAttribute( position, e.index2 );
						vertices.push( vertex.x, vertex.y, vertex.z );
	
					}
	
				} else {
	
					// non-indexed BufferGeometry
	
					position = geometry.attributes.position;
	
					for ( i = 0, l = ( position.count / 3 ); i < l; i ++ ) {
	
						for ( j = 0; j < 3; j ++ ) {
	
							// three edges per triangle, an edge is represented as (index1, index2)
							// e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
	
							index1 = 3 * i + j;
							vertex.fromBufferAttribute( position, index1 );
							vertices.push( vertex.x, vertex.y, vertex.z );
	
							index2 = 3 * i + ( ( j + 1 ) % 3 );
							vertex.fromBufferAttribute( position, index2 );
							vertices.push( vertex.x, vertex.y, vertex.z );
	
						}
	
					}
	
				}
	
			}
	
			// build geometry
	
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	
		}
	
		WireframeGeometry.prototype = Object.create( BufferGeometry.prototype );
		WireframeGeometry.prototype.constructor = WireframeGeometry;
	
		/**
		 * @author zz85 / https://github.com/zz85
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 * Parametric Surfaces Geometry
		 * based on the brilliant article by @prideout http://prideout.net/blog/?p=44
		 */
	
		// ParametricGeometry
	
		function ParametricGeometry( func, slices, stacks ) {
	
			Geometry.call( this );
	
			this.type = 'ParametricGeometry';
	
			this.parameters = {
				func: func,
				slices: slices,
				stacks: stacks
			};
	
			this.fromBufferGeometry( new ParametricBufferGeometry( func, slices, stacks ) );
			this.mergeVertices();
	
		}
	
		ParametricGeometry.prototype = Object.create( Geometry.prototype );
		ParametricGeometry.prototype.constructor = ParametricGeometry;
	
		// ParametricBufferGeometry
	
		function ParametricBufferGeometry( func, slices, stacks ) {
	
			BufferGeometry.call( this );
	
			this.type = 'ParametricBufferGeometry';
	
			this.parameters = {
				func: func,
				slices: slices,
				stacks: stacks
			};
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			var EPS = 0.00001;
	
			var normal = new Vector3();
	
			var p0 = new Vector3(), p1 = new Vector3();
			var pu = new Vector3(), pv = new Vector3();
	
			var i, j;
	
			// generate vertices, normals and uvs
	
			var sliceCount = slices + 1;
	
			for ( i = 0; i <= stacks; i ++ ) {
	
				var v = i / stacks;
	
				for ( j = 0; j <= slices; j ++ ) {
	
					var u = j / slices;
	
					// vertex
	
					p0 = func( u, v, p0 );
					vertices.push( p0.x, p0.y, p0.z );
	
					// normal
	
					// approximate tangent vectors via finite differences
	
					if ( u - EPS >= 0 ) {
	
						p1 = func( u - EPS, v, p1 );
						pu.subVectors( p0, p1 );
	
					} else {
	
						p1 = func( u + EPS, v, p1 );
						pu.subVectors( p1, p0 );
	
					}
	
					if ( v - EPS >= 0 ) {
	
						p1 = func( u, v - EPS, p1 );
						pv.subVectors( p0, p1 );
	
					} else {
	
						p1 = func( u, v + EPS, p1 );
						pv.subVectors( p1, p0 );
	
					}
	
					// cross product of tangent vectors returns surface normal
	
					normal.crossVectors( pu, pv ).normalize();
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( u, v );
	
				}
	
			}
	
			// generate indices
	
			for ( i = 0; i < stacks; i ++ ) {
	
				for ( j = 0; j < slices; j ++ ) {
	
					var a = i * sliceCount + j;
					var b = i * sliceCount + j + 1;
					var c = ( i + 1 ) * sliceCount + j + 1;
					var d = ( i + 1 ) * sliceCount + j;
	
					// faces one and two
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		ParametricBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		ParametricBufferGeometry.prototype.constructor = ParametricBufferGeometry;
	
		/**
		 * @author clockworkgeek / https://github.com/clockworkgeek
		 * @author timothypratley / https://github.com/timothypratley
		 * @author WestLangley / http://github.com/WestLangley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// PolyhedronGeometry
	
		function PolyhedronGeometry( vertices, indices, radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'PolyhedronGeometry';
	
			this.parameters = {
				vertices: vertices,
				indices: indices,
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new PolyhedronBufferGeometry( vertices, indices, radius, detail ) );
			this.mergeVertices();
	
		}
	
		PolyhedronGeometry.prototype = Object.create( Geometry.prototype );
		PolyhedronGeometry.prototype.constructor = PolyhedronGeometry;
	
		// PolyhedronBufferGeometry
	
		function PolyhedronBufferGeometry( vertices, indices, radius, detail ) {
	
			BufferGeometry.call( this );
	
			this.type = 'PolyhedronBufferGeometry';
	
			this.parameters = {
				vertices: vertices,
				indices: indices,
				radius: radius,
				detail: detail
			};
	
			radius = radius || 1;
			detail = detail || 0;
	
			// default buffer data
	
			var vertexBuffer = [];
			var uvBuffer = [];
	
			// the subdivision creates the vertex buffer data
	
			subdivide( detail );
	
			// all vertices should lie on a conceptual sphere with a given radius
	
			appplyRadius( radius );
	
			// finally, create the uv data
	
			generateUVs();
	
			// build non-indexed geometry
	
			this.addAttribute( 'position', new Float32BufferAttribute( vertexBuffer, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( vertexBuffer.slice(), 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvBuffer, 2 ) );
	
			if ( detail === 0 ) {
	
				this.computeVertexNormals(); // flat normals
	
			} else {
	
				this.normalizeNormals(); // smooth normals
	
			}
	
			// helper functions
	
			function subdivide( detail ) {
	
				var a = new Vector3();
				var b = new Vector3();
				var c = new Vector3();
	
				// iterate over all faces and apply a subdivison with the given detail value
	
				for ( var i = 0; i < indices.length; i += 3 ) {
	
					// get the vertices of the face
	
					getVertexByIndex( indices[ i + 0 ], a );
					getVertexByIndex( indices[ i + 1 ], b );
					getVertexByIndex( indices[ i + 2 ], c );
	
					// perform subdivision
	
					subdivideFace( a, b, c, detail );
	
				}
	
			}
	
			function subdivideFace( a, b, c, detail ) {
	
				var cols = Math.pow( 2, detail );
	
				// we use this multidimensional array as a data structure for creating the subdivision
	
				var v = [];
	
				var i, j;
	
				// construct all of the vertices for this subdivision
	
				for ( i = 0; i <= cols; i ++ ) {
	
					v[ i ] = [];
	
					var aj = a.clone().lerp( c, i / cols );
					var bj = b.clone().lerp( c, i / cols );
	
					var rows = cols - i;
	
					for ( j = 0; j <= rows; j ++ ) {
	
						if ( j === 0 && i === cols ) {
	
							v[ i ][ j ] = aj;
	
						} else {
	
							v[ i ][ j ] = aj.clone().lerp( bj, j / rows );
	
						}
	
					}
	
				}
	
				// construct all of the faces
	
				for ( i = 0; i < cols; i ++ ) {
	
					for ( j = 0; j < 2 * ( cols - i ) - 1; j ++ ) {
	
						var k = Math.floor( j / 2 );
	
						if ( j % 2 === 0 ) {
	
							pushVertex( v[ i ][ k + 1 ] );
							pushVertex( v[ i + 1 ][ k ] );
							pushVertex( v[ i ][ k ] );
	
						} else {
	
							pushVertex( v[ i ][ k + 1 ] );
							pushVertex( v[ i + 1 ][ k + 1 ] );
							pushVertex( v[ i + 1 ][ k ] );
	
						}
	
					}
	
				}
	
			}
	
			function appplyRadius( radius ) {
	
				var vertex = new Vector3();
	
				// iterate over the entire buffer and apply the radius to each vertex
	
				for ( var i = 0; i < vertexBuffer.length; i += 3 ) {
	
					vertex.x = vertexBuffer[ i + 0 ];
					vertex.y = vertexBuffer[ i + 1 ];
					vertex.z = vertexBuffer[ i + 2 ];
	
					vertex.normalize().multiplyScalar( radius );
	
					vertexBuffer[ i + 0 ] = vertex.x;
					vertexBuffer[ i + 1 ] = vertex.y;
					vertexBuffer[ i + 2 ] = vertex.z;
	
				}
	
			}
	
			function generateUVs() {
	
				var vertex = new Vector3();
	
				for ( var i = 0; i < vertexBuffer.length; i += 3 ) {
	
					vertex.x = vertexBuffer[ i + 0 ];
					vertex.y = vertexBuffer[ i + 1 ];
					vertex.z = vertexBuffer[ i + 2 ];
	
					var u = azimuth( vertex ) / 2 / Math.PI + 0.5;
					var v = inclination( vertex ) / Math.PI + 0.5;
					uvBuffer.push( u, 1 - v );
	
				}
	
				correctUVs();
	
				correctSeam();
	
			}
	
			function correctSeam() {
	
				// handle case when face straddles the seam, see #3269
	
				for ( var i = 0; i < uvBuffer.length; i += 6 ) {
	
					// uv data of a single face
	
					var x0 = uvBuffer[ i + 0 ];
					var x1 = uvBuffer[ i + 2 ];
					var x2 = uvBuffer[ i + 4 ];
	
					var max = Math.max( x0, x1, x2 );
					var min = Math.min( x0, x1, x2 );
	
					// 0.9 is somewhat arbitrary
	
					if ( max > 0.9 && min < 0.1 ) {
	
						if ( x0 < 0.2 ) uvBuffer[ i + 0 ] += 1;
						if ( x1 < 0.2 ) uvBuffer[ i + 2 ] += 1;
						if ( x2 < 0.2 ) uvBuffer[ i + 4 ] += 1;
	
					}
	
				}
	
			}
	
			function pushVertex( vertex ) {
	
				vertexBuffer.push( vertex.x, vertex.y, vertex.z );
	
			}
	
			function getVertexByIndex( index, vertex ) {
	
				var stride = index * 3;
	
				vertex.x = vertices[ stride + 0 ];
				vertex.y = vertices[ stride + 1 ];
				vertex.z = vertices[ stride + 2 ];
	
			}
	
			function correctUVs() {
	
				var a = new Vector3();
				var b = new Vector3();
				var c = new Vector3();
	
				var centroid = new Vector3();
	
				var uvA = new Vector2();
				var uvB = new Vector2();
				var uvC = new Vector2();
	
				for ( var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6 ) {
	
					a.set( vertexBuffer[ i + 0 ], vertexBuffer[ i + 1 ], vertexBuffer[ i + 2 ] );
					b.set( vertexBuffer[ i + 3 ], vertexBuffer[ i + 4 ], vertexBuffer[ i + 5 ] );
					c.set( vertexBuffer[ i + 6 ], vertexBuffer[ i + 7 ], vertexBuffer[ i + 8 ] );
	
					uvA.set( uvBuffer[ j + 0 ], uvBuffer[ j + 1 ] );
					uvB.set( uvBuffer[ j + 2 ], uvBuffer[ j + 3 ] );
					uvC.set( uvBuffer[ j + 4 ], uvBuffer[ j + 5 ] );
	
					centroid.copy( a ).add( b ).add( c ).divideScalar( 3 );
	
					var azi = azimuth( centroid );
	
					correctUV( uvA, j + 0, a, azi );
					correctUV( uvB, j + 2, b, azi );
					correctUV( uvC, j + 4, c, azi );
	
				}
	
			}
	
			function correctUV( uv, stride, vector, azimuth ) {
	
				if ( ( azimuth < 0 ) && ( uv.x === 1 ) ) {
	
					uvBuffer[ stride ] = uv.x - 1;
	
				}
	
				if ( ( vector.x === 0 ) && ( vector.z === 0 ) ) {
	
					uvBuffer[ stride ] = azimuth / 2 / Math.PI + 0.5;
	
				}
	
			}
	
			// Angle around the Y axis, counter-clockwise when looking from above.
	
			function azimuth( vector ) {
	
				return Math.atan2( vector.z, - vector.x );
	
			}
	
	
			// Angle above the XZ plane.
	
			function inclination( vector ) {
	
				return Math.atan2( - vector.y, Math.sqrt( ( vector.x * vector.x ) + ( vector.z * vector.z ) ) );
	
			}
	
		}
	
		PolyhedronBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		PolyhedronBufferGeometry.prototype.constructor = PolyhedronBufferGeometry;
	
		/**
		 * @author timothypratley / https://github.com/timothypratley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// TetrahedronGeometry
	
		function TetrahedronGeometry( radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'TetrahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new TetrahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		TetrahedronGeometry.prototype = Object.create( Geometry.prototype );
		TetrahedronGeometry.prototype.constructor = TetrahedronGeometry;
	
		// TetrahedronBufferGeometry
	
		function TetrahedronBufferGeometry( radius, detail ) {
	
			var vertices = [
				1,  1,  1,   - 1, - 1,  1,   - 1,  1, - 1,    1, - 1, - 1
			];
	
			var indices = [
				2,  1,  0,    0,  3,  2,    1,  3,  0,    2,  3,  1
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'TetrahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		TetrahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		TetrahedronBufferGeometry.prototype.constructor = TetrahedronBufferGeometry;
	
		/**
		 * @author timothypratley / https://github.com/timothypratley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// OctahedronGeometry
	
		function OctahedronGeometry( radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'OctahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new OctahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		OctahedronGeometry.prototype = Object.create( Geometry.prototype );
		OctahedronGeometry.prototype.constructor = OctahedronGeometry;
	
		// OctahedronBufferGeometry
	
		function OctahedronBufferGeometry( radius, detail ) {
	
			var vertices = [
				1, 0, 0,   - 1, 0, 0,    0, 1, 0,    0, - 1, 0,    0, 0, 1,    0, 0, - 1
			];
	
			var indices = [
				0, 2, 4,    0, 4, 3,    0, 3, 5,    0, 5, 2,    1, 2, 5,    1, 5, 3,    1, 3, 4,    1, 4, 2
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'OctahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		OctahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		OctahedronBufferGeometry.prototype.constructor = OctahedronBufferGeometry;
	
		/**
		 * @author timothypratley / https://github.com/timothypratley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// IcosahedronGeometry
	
		function IcosahedronGeometry( radius, detail ) {
	
		 	Geometry.call( this );
	
			this.type = 'IcosahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new IcosahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		IcosahedronGeometry.prototype = Object.create( Geometry.prototype );
		IcosahedronGeometry.prototype.constructor = IcosahedronGeometry;
	
		// IcosahedronBufferGeometry
	
		function IcosahedronBufferGeometry( radius, detail ) {
	
			var t = ( 1 + Math.sqrt( 5 ) ) / 2;
	
			var vertices = [
				- 1,  t,  0,    1,  t,  0,   - 1, - t,  0,    1, - t,  0,
				 0, - 1,  t,    0,  1,  t,    0, - 1, - t,    0,  1, - t,
				 t,  0, - 1,    t,  0,  1,   - t,  0, - 1,   - t,  0,  1
			];
	
			var indices = [
				 0, 11,  5,    0,  5,  1,    0,  1,  7,    0,  7, 10,    0, 10, 11,
				 1,  5,  9,    5, 11,  4,   11, 10,  2,   10,  7,  6,    7,  1,  8,
				 3,  9,  4,    3,  4,  2,    3,  2,  6,    3,  6,  8,    3,  8,  9,
				 4,  9,  5,    2,  4, 11,    6,  2, 10,    8,  6,  7,    9,  8,  1
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'IcosahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		IcosahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		IcosahedronBufferGeometry.prototype.constructor = IcosahedronBufferGeometry;
	
		/**
		 * @author Abe Pazos / https://hamoid.com
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// DodecahedronGeometry
	
		function DodecahedronGeometry( radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'DodecahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new DodecahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		DodecahedronGeometry.prototype = Object.create( Geometry.prototype );
		DodecahedronGeometry.prototype.constructor = DodecahedronGeometry;
	
		// DodecahedronBufferGeometry
	
		function DodecahedronBufferGeometry( radius, detail ) {
	
			var t = ( 1 + Math.sqrt( 5 ) ) / 2;
			var r = 1 / t;
	
			var vertices = [
	
				// (±1, ±1, ±1)
				- 1, - 1, - 1,    - 1, - 1,  1,
				- 1,  1, - 1,    - 1,  1,  1,
				  1, - 1, - 1,     1, - 1,  1,
				  1,  1, - 1,     1,  1,  1,
	
				// (0, ±1/φ, ±φ)
				 0, - r, - t,     0, - r,  t,
				 0,  r, - t,     0,  r,  t,
	
				// (±1/φ, ±φ, 0)
				- r, - t,  0,    - r,  t,  0,
				 r, - t,  0,     r,  t,  0,
	
				// (±φ, 0, ±1/φ)
				- t,  0, - r,     t,  0, - r,
				- t,  0,  r,     t,  0,  r
			];
	
			var indices = [
				 3, 11,  7,      3,  7, 15,      3, 15, 13,
				 7, 19, 17,      7, 17,  6,      7,  6, 15,
				17,  4,  8,     17,  8, 10,     17, 10,  6,
				 8,  0, 16,      8, 16,  2,      8,  2, 10,
				 0, 12,  1,      0,  1, 18,      0, 18, 16,
				 6, 10,  2,      6,  2, 13,      6, 13, 15,
				 2, 16, 18,      2, 18,  3,      2,  3, 13,
				18,  1,  9,     18,  9, 11,     18, 11,  3,
				 4, 14, 12,      4, 12,  0,      4,  0,  8,
				11,  9,  5,     11,  5, 19,     11, 19,  7,
				19,  5, 14,     19, 14,  4,     19,  4, 17,
				 1, 12, 14,      1, 14,  5,      1,  5,  9
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'DodecahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		DodecahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		DodecahedronBufferGeometry.prototype.constructor = DodecahedronBufferGeometry;
	
		/**
		 * @author oosmoxiecode / https://github.com/oosmoxiecode
		 * @author WestLangley / https://github.com/WestLangley
		 * @author zz85 / https://github.com/zz85
		 * @author miningold / https://github.com/miningold
		 * @author jonobr1 / https://github.com/jonobr1
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 */
	
		// TubeGeometry
	
		function TubeGeometry( path, tubularSegments, radius, radialSegments, closed, taper ) {
	
			Geometry.call( this );
	
			this.type = 'TubeGeometry';
	
			this.parameters = {
				path: path,
				tubularSegments: tubularSegments,
				radius: radius,
				radialSegments: radialSegments,
				closed: closed
			};
	
			if ( taper !== undefined ) console.warn( 'THREE.TubeGeometry: taper has been removed.' );
	
			var bufferGeometry = new TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed );
	
			// expose internals
	
			this.tangents = bufferGeometry.tangents;
			this.normals = bufferGeometry.normals;
			this.binormals = bufferGeometry.binormals;
	
			// create geometry
	
			this.fromBufferGeometry( bufferGeometry );
			this.mergeVertices();
	
		}
	
		TubeGeometry.prototype = Object.create( Geometry.prototype );
		TubeGeometry.prototype.constructor = TubeGeometry;
	
		// TubeBufferGeometry
	
		function TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed ) {
	
			BufferGeometry.call( this );
	
			this.type = 'TubeBufferGeometry';
	
			this.parameters = {
				path: path,
				tubularSegments: tubularSegments,
				radius: radius,
				radialSegments: radialSegments,
				closed: closed
			};
	
			tubularSegments = tubularSegments || 64;
			radius = radius || 1;
			radialSegments = radialSegments || 8;
			closed = closed || false;
	
			var frames = path.computeFrenetFrames( tubularSegments, closed );
	
			// expose internals
	
			this.tangents = frames.tangents;
			this.normals = frames.normals;
			this.binormals = frames.binormals;
	
			// helper variables
	
			var vertex = new Vector3();
			var normal = new Vector3();
			var uv = new Vector2();
	
			var i, j;
	
			// buffer
	
			var vertices = [];
			var normals = [];
			var uvs = [];
			var indices = [];
	
			// create buffer data
	
			generateBufferData();
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			// functions
	
			function generateBufferData() {
	
				for ( i = 0; i < tubularSegments; i ++ ) {
	
					generateSegment( i );
	
				}
	
				// if the geometry is not closed, generate the last row of vertices and normals
				// at the regular position on the given path
				//
				// if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
	
				generateSegment( ( closed === false ) ? tubularSegments : 0 );
	
				// uvs are generated in a separate function.
				// this makes it easy compute correct values for closed geometries
	
				generateUVs();
	
				// finally create faces
	
				generateIndices();
	
			}
	
			function generateSegment( i ) {
	
				// we use getPointAt to sample evenly distributed points from the given path
	
				var P = path.getPointAt( i / tubularSegments );
	
				// retrieve corresponding normal and binormal
	
				var N = frames.normals[ i ];
				var B = frames.binormals[ i ];
	
				// generate normals and vertices for the current segment
	
				for ( j = 0; j <= radialSegments; j ++ ) {
	
					var v = j / radialSegments * Math.PI * 2;
	
					var sin =   Math.sin( v );
					var cos = - Math.cos( v );
	
					// normal
	
					normal.x = ( cos * N.x + sin * B.x );
					normal.y = ( cos * N.y + sin * B.y );
					normal.z = ( cos * N.z + sin * B.z );
					normal.normalize();
	
					normals.push( normal.x, normal.y, normal.z );
	
					// vertex
	
					vertex.x = P.x + radius * normal.x;
					vertex.y = P.y + radius * normal.y;
					vertex.z = P.z + radius * normal.z;
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
			}
	
			function generateIndices() {
	
				for ( j = 1; j <= tubularSegments; j ++ ) {
	
					for ( i = 1; i <= radialSegments; i ++ ) {
	
						var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
						var b = ( radialSegments + 1 ) * j + ( i - 1 );
						var c = ( radialSegments + 1 ) * j + i;
						var d = ( radialSegments + 1 ) * ( j - 1 ) + i;
	
						// faces
	
						indices.push( a, b, d );
						indices.push( b, c, d );
	
					}
	
				}
	
			}
	
			function generateUVs() {
	
				for ( i = 0; i <= tubularSegments; i ++ ) {
	
					for ( j = 0; j <= radialSegments; j ++ ) {
	
						uv.x = i / tubularSegments;
						uv.y = j / radialSegments;
	
						uvs.push( uv.x, uv.y );
	
					}
	
				}
	
			}
	
		}
	
		TubeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		TubeBufferGeometry.prototype.constructor = TubeBufferGeometry;
	
		/**
		 * @author oosmoxiecode
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 * based on http://www.blackpawn.com/texts/pqtorus/
		 */
	
		// TorusKnotGeometry
	
		function TorusKnotGeometry( radius, tube, tubularSegments, radialSegments, p, q, heightScale ) {
	
			Geometry.call( this );
	
			this.type = 'TorusKnotGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				tubularSegments: tubularSegments,
				radialSegments: radialSegments,
				p: p,
				q: q
			};
	
			if ( heightScale !== undefined ) console.warn( 'THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead.' );
	
			this.fromBufferGeometry( new TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) );
			this.mergeVertices();
	
		}
	
		TorusKnotGeometry.prototype = Object.create( Geometry.prototype );
		TorusKnotGeometry.prototype.constructor = TorusKnotGeometry;
	
		// TorusKnotBufferGeometry
	
		function TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) {
	
			BufferGeometry.call( this );
	
			this.type = 'TorusKnotBufferGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				tubularSegments: tubularSegments,
				radialSegments: radialSegments,
				p: p,
				q: q
			};
	
			radius = radius || 100;
			tube = tube || 40;
			tubularSegments = Math.floor( tubularSegments ) || 64;
			radialSegments = Math.floor( radialSegments ) || 8;
			p = p || 2;
			q = q || 3;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var i, j;
	
			var vertex = new Vector3();
			var normal = new Vector3();
	
			var P1 = new Vector3();
			var P2 = new Vector3();
	
			var B = new Vector3();
			var T = new Vector3();
			var N = new Vector3();
	
			// generate vertices, normals and uvs
	
			for ( i = 0; i <= tubularSegments; ++ i ) {
	
				// the radian "u" is used to calculate the position on the torus curve of the current tubular segement
	
				var u = i / tubularSegments * p * Math.PI * 2;
	
				// now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
				// these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
	
				calculatePositionOnCurve( u, p, q, radius, P1 );
				calculatePositionOnCurve( u + 0.01, p, q, radius, P2 );
	
				// calculate orthonormal basis
	
				T.subVectors( P2, P1 );
				N.addVectors( P2, P1 );
				B.crossVectors( T, N );
				N.crossVectors( B, T );
	
				// normalize B, N. T can be ignored, we don't use it
	
				B.normalize();
				N.normalize();
	
				for ( j = 0; j <= radialSegments; ++ j ) {
	
					// now calculate the vertices. they are nothing more than an extrusion of the torus curve.
					// because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
	
					var v = j / radialSegments * Math.PI * 2;
					var cx = - tube * Math.cos( v );
					var cy = tube * Math.sin( v );
	
					// now calculate the final vertex position.
					// first we orient the extrusion with our basis vectos, then we add it to the current position on the curve
	
					vertex.x = P1.x + ( cx * N.x + cy * B.x );
					vertex.y = P1.y + ( cx * N.y + cy * B.y );
					vertex.z = P1.z + ( cx * N.z + cy * B.z );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
	
					normal.subVectors( vertex, P1 ).normalize();
	
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( i / tubularSegments );
					uvs.push( j / radialSegments );
	
				}
	
			}
	
			// generate indices
	
			for ( j = 1; j <= tubularSegments; j ++ ) {
	
				for ( i = 1; i <= radialSegments; i ++ ) {
	
					// indices
	
					var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
					var b = ( radialSegments + 1 ) * j + ( i - 1 );
					var c = ( radialSegments + 1 ) * j + i;
					var d = ( radialSegments + 1 ) * ( j - 1 ) + i;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			// this function calculates the current position on the torus curve
	
			function calculatePositionOnCurve( u, p, q, radius, position ) {
	
				var cu = Math.cos( u );
				var su = Math.sin( u );
				var quOverP = q / p * u;
				var cs = Math.cos( quOverP );
	
				position.x = radius * ( 2 + cs ) * 0.5 * cu;
				position.y = radius * ( 2 + cs ) * su * 0.5;
				position.z = radius * Math.sin( quOverP ) * 0.5;
	
			}
	
		}
	
		TorusKnotBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		TorusKnotBufferGeometry.prototype.constructor = TorusKnotBufferGeometry;
	
		/**
		 * @author oosmoxiecode
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// TorusGeometry
	
		function TorusGeometry( radius, tube, radialSegments, tubularSegments, arc ) {
	
			Geometry.call( this );
	
			this.type = 'TorusGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				radialSegments: radialSegments,
				tubularSegments: tubularSegments,
				arc: arc
			};
	
			this.fromBufferGeometry( new TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) );
			this.mergeVertices();
	
		}
	
		TorusGeometry.prototype = Object.create( Geometry.prototype );
		TorusGeometry.prototype.constructor = TorusGeometry;
	
		// TorusBufferGeometry
	
		function TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) {
	
			BufferGeometry.call( this );
	
			this.type = 'TorusBufferGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				radialSegments: radialSegments,
				tubularSegments: tubularSegments,
				arc: arc
			};
	
			radius = radius || 100;
			tube = tube || 40;
			radialSegments = Math.floor( radialSegments ) || 8;
			tubularSegments = Math.floor( tubularSegments ) || 6;
			arc = arc || Math.PI * 2;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var center = new Vector3();
			var vertex = new Vector3();
			var normal = new Vector3();
	
			var j, i;
	
			// generate vertices, normals and uvs
	
			for ( j = 0; j <= radialSegments; j ++ ) {
	
				for ( i = 0; i <= tubularSegments; i ++ ) {
	
					var u = i / tubularSegments * arc;
					var v = j / radialSegments * Math.PI * 2;
	
					// vertex
	
					vertex.x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
					vertex.y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
					vertex.z = tube * Math.sin( v );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					center.x = radius * Math.cos( u );
					center.y = radius * Math.sin( u );
					normal.subVectors( vertex, center ).normalize();
	
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( i / tubularSegments );
					uvs.push( j / radialSegments );
	
				}
	
			}
	
			// generate indices
	
			for ( j = 1; j <= radialSegments; j ++ ) {
	
				for ( i = 1; i <= tubularSegments; i ++ ) {
	
					// indices
	
					var a = ( tubularSegments + 1 ) * j + i - 1;
					var b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
					var c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
					var d = ( tubularSegments + 1 ) * j + i;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		TorusBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		TorusBufferGeometry.prototype.constructor = TorusBufferGeometry;
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 */
	
		var ShapeUtils = {
	
			// calculate area of the contour polygon
	
			area: function ( contour ) {
	
				var n = contour.length;
				var a = 0.0;
	
				for ( var p = n - 1, q = 0; q < n; p = q ++ ) {
	
					a += contour[ p ].x * contour[ q ].y - contour[ q ].x * contour[ p ].y;
	
				}
	
				return a * 0.5;
	
			},
	
			triangulate: ( function () {
	
				/**
				 * This code is a quick port of code written in C++ which was submitted to
				 * flipcode.com by John W. Ratcliff  // July 22, 2000
				 * See original code and more information here:
				 * http://www.flipcode.com/archives/Efficient_Polygon_Triangulation.shtml
				 *
				 * ported to actionscript by Zevan Rosser
				 * www.actionsnippet.com
				 *
				 * ported to javascript by Joshua Koo
				 * http://www.lab4games.net/zz85/blog
				 *
				 */
	
				function snip( contour, u, v, w, n, verts ) {
	
					var p;
					var ax, ay, bx, by;
					var cx, cy, px, py;
	
					ax = contour[ verts[ u ] ].x;
					ay = contour[ verts[ u ] ].y;
	
					bx = contour[ verts[ v ] ].x;
					by = contour[ verts[ v ] ].y;
	
					cx = contour[ verts[ w ] ].x;
					cy = contour[ verts[ w ] ].y;
	
					if ( ( bx - ax ) * ( cy - ay ) - ( by - ay ) * ( cx - ax ) <= 0 ) return false;
	
					var aX, aY, bX, bY, cX, cY;
					var apx, apy, bpx, bpy, cpx, cpy;
					var cCROSSap, bCROSScp, aCROSSbp;
	
					aX = cx - bx;  aY = cy - by;
					bX = ax - cx;  bY = ay - cy;
					cX = bx - ax;  cY = by - ay;
	
					for ( p = 0; p < n; p ++ ) {
	
						px = contour[ verts[ p ] ].x;
						py = contour[ verts[ p ] ].y;
	
						if ( ( ( px === ax ) && ( py === ay ) ) ||
							 ( ( px === bx ) && ( py === by ) ) ||
							 ( ( px === cx ) && ( py === cy ) ) )	continue;
	
						apx = px - ax;  apy = py - ay;
						bpx = px - bx;  bpy = py - by;
						cpx = px - cx;  cpy = py - cy;
	
						// see if p is inside triangle abc
	
						aCROSSbp = aX * bpy - aY * bpx;
						cCROSSap = cX * apy - cY * apx;
						bCROSScp = bX * cpy - bY * cpx;
	
						if ( ( aCROSSbp >= - Number.EPSILON ) && ( bCROSScp >= - Number.EPSILON ) && ( cCROSSap >= - Number.EPSILON ) ) return false;
	
					}
	
					return true;
	
				}
	
				// takes in an contour array and returns
	
				return function triangulate( contour, indices ) {
	
					var n = contour.length;
	
					if ( n < 3 ) return null;
	
					var result = [],
						verts = [],
						vertIndices = [];
	
					/* we want a counter-clockwise polygon in verts */
	
					var u, v, w;
	
					if ( ShapeUtils.area( contour ) > 0.0 ) {
	
						for ( v = 0; v < n; v ++ ) verts[ v ] = v;
	
					} else {
	
						for ( v = 0; v < n; v ++ ) verts[ v ] = ( n - 1 ) - v;
	
					}
	
					var nv = n;
	
					/*  remove nv - 2 vertices, creating 1 triangle every time */
	
					var count = 2 * nv;   /* error detection */
	
					for ( v = nv - 1; nv > 2; ) {
	
						/* if we loop, it is probably a non-simple polygon */
	
						if ( ( count -- ) <= 0 ) {
	
							//** Triangulate: ERROR - probable bad polygon!
	
							//throw ( "Warning, unable to triangulate polygon!" );
							//return null;
							// Sometimes warning is fine, especially polygons are triangulated in reverse.
							console.warn( 'THREE.ShapeUtils: Unable to triangulate polygon! in triangulate()' );
	
							if ( indices ) return vertIndices;
							return result;
	
						}
	
						/* three consecutive vertices in current polygon, <u,v,w> */
	
						u = v; 	 	if ( nv <= u ) u = 0;     /* previous */
						v = u + 1;  if ( nv <= v ) v = 0;     /* new v    */
						w = v + 1;  if ( nv <= w ) w = 0;     /* next     */
	
						if ( snip( contour, u, v, w, nv, verts ) ) {
	
							var a, b, c, s, t;
	
							/* true names of the vertices */
	
							a = verts[ u ];
							b = verts[ v ];
							c = verts[ w ];
	
							/* output Triangle */
	
							result.push( [ contour[ a ],
								contour[ b ],
								contour[ c ] ] );
	
	
							vertIndices.push( [ verts[ u ], verts[ v ], verts[ w ] ] );
	
							/* remove v from the remaining polygon */
	
							for ( s = v, t = v + 1; t < nv; s ++, t ++ ) {
	
								verts[ s ] = verts[ t ];
	
							}
	
							nv --;
	
							/* reset error detection counter */
	
							count = 2 * nv;
	
						}
	
					}
	
					if ( indices ) return vertIndices;
					return result;
	
				};
	
			} )(),
	
			triangulateShape: function ( contour, holes ) {
	
				function removeDupEndPts(points) {
	
					var l = points.length;
	
					if ( l > 2 && points[ l - 1 ].equals( points[ 0 ] ) ) {
	
						points.pop();
	
					}
	
				}
	
				removeDupEndPts( contour );
				holes.forEach( removeDupEndPts );
	
				function point_in_segment_2D_colin( inSegPt1, inSegPt2, inOtherPt ) {
	
					// inOtherPt needs to be collinear to the inSegment
					if ( inSegPt1.x !== inSegPt2.x ) {
	
						if ( inSegPt1.x < inSegPt2.x ) {
	
							return	( ( inSegPt1.x <= inOtherPt.x ) && ( inOtherPt.x <= inSegPt2.x ) );
	
						} else {
	
							return	( ( inSegPt2.x <= inOtherPt.x ) && ( inOtherPt.x <= inSegPt1.x ) );
	
						}
	
					} else {
	
						if ( inSegPt1.y < inSegPt2.y ) {
	
							return	( ( inSegPt1.y <= inOtherPt.y ) && ( inOtherPt.y <= inSegPt2.y ) );
	
						} else {
	
							return	( ( inSegPt2.y <= inOtherPt.y ) && ( inOtherPt.y <= inSegPt1.y ) );
	
						}
	
					}
	
				}
	
				function intersect_segments_2D( inSeg1Pt1, inSeg1Pt2, inSeg2Pt1, inSeg2Pt2, inExcludeAdjacentSegs ) {
	
					var seg1dx = inSeg1Pt2.x - inSeg1Pt1.x,   seg1dy = inSeg1Pt2.y - inSeg1Pt1.y;
					var seg2dx = inSeg2Pt2.x - inSeg2Pt1.x,   seg2dy = inSeg2Pt2.y - inSeg2Pt1.y;
	
					var seg1seg2dx = inSeg1Pt1.x - inSeg2Pt1.x;
					var seg1seg2dy = inSeg1Pt1.y - inSeg2Pt1.y;
	
					var limit		= seg1dy * seg2dx - seg1dx * seg2dy;
					var perpSeg1	= seg1dy * seg1seg2dx - seg1dx * seg1seg2dy;
	
					if ( Math.abs( limit ) > Number.EPSILON ) {
	
						// not parallel
	
						var perpSeg2;
						if ( limit > 0 ) {
	
							if ( ( perpSeg1 < 0 ) || ( perpSeg1 > limit ) ) 		return [];
							perpSeg2 = seg2dy * seg1seg2dx - seg2dx * seg1seg2dy;
							if ( ( perpSeg2 < 0 ) || ( perpSeg2 > limit ) ) 		return [];
	
						} else {
	
							if ( ( perpSeg1 > 0 ) || ( perpSeg1 < limit ) ) 		return [];
							perpSeg2 = seg2dy * seg1seg2dx - seg2dx * seg1seg2dy;
							if ( ( perpSeg2 > 0 ) || ( perpSeg2 < limit ) ) 		return [];
	
						}
	
						// i.e. to reduce rounding errors
						// intersection at endpoint of segment#1?
						if ( perpSeg2 === 0 ) {
	
							if ( ( inExcludeAdjacentSegs ) &&
								 ( ( perpSeg1 === 0 ) || ( perpSeg1 === limit ) ) )		return [];
							return [ inSeg1Pt1 ];
	
						}
						if ( perpSeg2 === limit ) {
	
							if ( ( inExcludeAdjacentSegs ) &&
								 ( ( perpSeg1 === 0 ) || ( perpSeg1 === limit ) ) )		return [];
							return [ inSeg1Pt2 ];
	
						}
						// intersection at endpoint of segment#2?
						if ( perpSeg1 === 0 )		return [ inSeg2Pt1 ];
						if ( perpSeg1 === limit )	return [ inSeg2Pt2 ];
	
						// return real intersection point
						var factorSeg1 = perpSeg2 / limit;
						return	[ { x: inSeg1Pt1.x + factorSeg1 * seg1dx,
									y: inSeg1Pt1.y + factorSeg1 * seg1dy } ];
	
					} else {
	
						// parallel or collinear
						if ( ( perpSeg1 !== 0 ) ||
							 ( seg2dy * seg1seg2dx !== seg2dx * seg1seg2dy ) ) 			return [];
	
						// they are collinear or degenerate
						var seg1Pt = ( ( seg1dx === 0 ) && ( seg1dy === 0 ) );	// segment1 is just a point?
						var seg2Pt = ( ( seg2dx === 0 ) && ( seg2dy === 0 ) );	// segment2 is just a point?
						// both segments are points
						if ( seg1Pt && seg2Pt ) {
	
							if ( ( inSeg1Pt1.x !== inSeg2Pt1.x ) ||
								 ( inSeg1Pt1.y !== inSeg2Pt1.y ) )		return [];	// they are distinct  points
							return [ inSeg1Pt1 ];                 						// they are the same point
	
						}
						// segment#1  is a single point
						if ( seg1Pt ) {
	
							if ( ! point_in_segment_2D_colin( inSeg2Pt1, inSeg2Pt2, inSeg1Pt1 ) )		return [];		// but not in segment#2
							return [ inSeg1Pt1 ];
	
						}
						// segment#2  is a single point
						if ( seg2Pt ) {
	
							if ( ! point_in_segment_2D_colin( inSeg1Pt1, inSeg1Pt2, inSeg2Pt1 ) )		return [];		// but not in segment#1
							return [ inSeg2Pt1 ];
	
						}
	
						// they are collinear segments, which might overlap
						var seg1min, seg1max, seg1minVal, seg1maxVal;
						var seg2min, seg2max, seg2minVal, seg2maxVal;
						if ( seg1dx !== 0 ) {
	
							// the segments are NOT on a vertical line
							if ( inSeg1Pt1.x < inSeg1Pt2.x ) {
	
								seg1min = inSeg1Pt1; seg1minVal = inSeg1Pt1.x;
								seg1max = inSeg1Pt2; seg1maxVal = inSeg1Pt2.x;
	
							} else {
	
								seg1min = inSeg1Pt2; seg1minVal = inSeg1Pt2.x;
								seg1max = inSeg1Pt1; seg1maxVal = inSeg1Pt1.x;
	
							}
							if ( inSeg2Pt1.x < inSeg2Pt2.x ) {
	
								seg2min = inSeg2Pt1; seg2minVal = inSeg2Pt1.x;
								seg2max = inSeg2Pt2; seg2maxVal = inSeg2Pt2.x;
	
							} else {
	
								seg2min = inSeg2Pt2; seg2minVal = inSeg2Pt2.x;
								seg2max = inSeg2Pt1; seg2maxVal = inSeg2Pt1.x;
	
							}
	
						} else {
	
							// the segments are on a vertical line
							if ( inSeg1Pt1.y < inSeg1Pt2.y ) {
	
								seg1min = inSeg1Pt1; seg1minVal = inSeg1Pt1.y;
								seg1max = inSeg1Pt2; seg1maxVal = inSeg1Pt2.y;
	
							} else {
	
								seg1min = inSeg1Pt2; seg1minVal = inSeg1Pt2.y;
								seg1max = inSeg1Pt1; seg1maxVal = inSeg1Pt1.y;
	
							}
							if ( inSeg2Pt1.y < inSeg2Pt2.y ) {
	
								seg2min = inSeg2Pt1; seg2minVal = inSeg2Pt1.y;
								seg2max = inSeg2Pt2; seg2maxVal = inSeg2Pt2.y;
	
							} else {
	
								seg2min = inSeg2Pt2; seg2minVal = inSeg2Pt2.y;
								seg2max = inSeg2Pt1; seg2maxVal = inSeg2Pt1.y;
	
							}
	
						}
						if ( seg1minVal <= seg2minVal ) {
	
							if ( seg1maxVal <  seg2minVal )	return [];
							if ( seg1maxVal === seg2minVal )	{
	
								if ( inExcludeAdjacentSegs )		return [];
								return [ seg2min ];
	
							}
							if ( seg1maxVal <= seg2maxVal )	return [ seg2min, seg1max ];
							return	[ seg2min, seg2max ];
	
						} else {
	
							if ( seg1minVal >  seg2maxVal )	return [];
							if ( seg1minVal === seg2maxVal )	{
	
								if ( inExcludeAdjacentSegs )		return [];
								return [ seg1min ];
	
							}
							if ( seg1maxVal <= seg2maxVal )	return [ seg1min, seg1max ];
							return	[ seg1min, seg2max ];
	
						}
	
					}
	
				}
	
				function isPointInsideAngle( inVertex, inLegFromPt, inLegToPt, inOtherPt ) {
	
					// The order of legs is important
	
					// translation of all points, so that Vertex is at (0,0)
					var legFromPtX	= inLegFromPt.x - inVertex.x,  legFromPtY	= inLegFromPt.y - inVertex.y;
					var legToPtX	= inLegToPt.x	- inVertex.x,  legToPtY		= inLegToPt.y	- inVertex.y;
					var otherPtX	= inOtherPt.x	- inVertex.x,  otherPtY		= inOtherPt.y	- inVertex.y;
	
					// main angle >0: < 180 deg.; 0: 180 deg.; <0: > 180 deg.
					var from2toAngle	= legFromPtX * legToPtY - legFromPtY * legToPtX;
					var from2otherAngle	= legFromPtX * otherPtY - legFromPtY * otherPtX;
	
					if ( Math.abs( from2toAngle ) > Number.EPSILON ) {
	
						// angle != 180 deg.
	
						var other2toAngle		= otherPtX * legToPtY - otherPtY * legToPtX;
						// console.log( "from2to: " + from2toAngle + ", from2other: " + from2otherAngle + ", other2to: " + other2toAngle );
	
						if ( from2toAngle > 0 ) {
	
							// main angle < 180 deg.
							return	( ( from2otherAngle >= 0 ) && ( other2toAngle >= 0 ) );
	
						} else {
	
							// main angle > 180 deg.
							return	( ( from2otherAngle >= 0 ) || ( other2toAngle >= 0 ) );
	
						}
	
					} else {
	
						// angle == 180 deg.
						// console.log( "from2to: 180 deg., from2other: " + from2otherAngle  );
						return	( from2otherAngle > 0 );
	
					}
	
				}
	
	
				function removeHoles( contour, holes ) {
	
					var shape = contour.concat(); // work on this shape
					var hole;
	
					function isCutLineInsideAngles( inShapeIdx, inHoleIdx ) {
	
						// Check if hole point lies within angle around shape point
						var lastShapeIdx = shape.length - 1;
	
						var prevShapeIdx = inShapeIdx - 1;
						if ( prevShapeIdx < 0 )			prevShapeIdx = lastShapeIdx;
	
						var nextShapeIdx = inShapeIdx + 1;
						if ( nextShapeIdx > lastShapeIdx )	nextShapeIdx = 0;
	
						var insideAngle = isPointInsideAngle( shape[ inShapeIdx ], shape[ prevShapeIdx ], shape[ nextShapeIdx ], hole[ inHoleIdx ] );
						if ( ! insideAngle ) {
	
							// console.log( "Vertex (Shape): " + inShapeIdx + ", Point: " + hole[inHoleIdx].x + "/" + hole[inHoleIdx].y );
							return	false;
	
						}
	
						// Check if shape point lies within angle around hole point
						var lastHoleIdx = hole.length - 1;
	
						var prevHoleIdx = inHoleIdx - 1;
						if ( prevHoleIdx < 0 )			prevHoleIdx = lastHoleIdx;
	
						var nextHoleIdx = inHoleIdx + 1;
						if ( nextHoleIdx > lastHoleIdx )	nextHoleIdx = 0;
	
						insideAngle = isPointInsideAngle( hole[ inHoleIdx ], hole[ prevHoleIdx ], hole[ nextHoleIdx ], shape[ inShapeIdx ] );
						if ( ! insideAngle ) {
	
							// console.log( "Vertex (Hole): " + inHoleIdx + ", Point: " + shape[inShapeIdx].x + "/" + shape[inShapeIdx].y );
							return	false;
	
						}
	
						return	true;
	
					}
	
					function intersectsShapeEdge( inShapePt, inHolePt ) {
	
						// checks for intersections with shape edges
						var sIdx, nextIdx, intersection;
						for ( sIdx = 0; sIdx < shape.length; sIdx ++ ) {
	
							nextIdx = sIdx + 1; nextIdx %= shape.length;
							intersection = intersect_segments_2D( inShapePt, inHolePt, shape[ sIdx ], shape[ nextIdx ], true );
							if ( intersection.length > 0 )		return	true;
	
						}
	
						return	false;
	
					}
	
					var indepHoles = [];
	
					function intersectsHoleEdge( inShapePt, inHolePt ) {
	
						// checks for intersections with hole edges
						var ihIdx, chkHole,
							hIdx, nextIdx, intersection;
						for ( ihIdx = 0; ihIdx < indepHoles.length; ihIdx ++ ) {
	
							chkHole = holes[ indepHoles[ ihIdx ] ];
							for ( hIdx = 0; hIdx < chkHole.length; hIdx ++ ) {
	
								nextIdx = hIdx + 1; nextIdx %= chkHole.length;
								intersection = intersect_segments_2D( inShapePt, inHolePt, chkHole[ hIdx ], chkHole[ nextIdx ], true );
								if ( intersection.length > 0 )		return	true;
	
							}
	
						}
						return	false;
	
					}
	
					var holeIndex, shapeIndex,
						shapePt, holePt,
						holeIdx, cutKey, failedCuts = [],
						tmpShape1, tmpShape2,
						tmpHole1, tmpHole2;
	
					for ( var h = 0, hl = holes.length; h < hl; h ++ ) {
	
						indepHoles.push( h );
	
					}
	
					var minShapeIndex = 0;
					var counter = indepHoles.length * 2;
					while ( indepHoles.length > 0 ) {
	
						counter --;
						if ( counter < 0 ) {
	
							console.log( 'THREE.ShapeUtils: Infinite Loop! Holes left:" + indepHoles.length + ", Probably Hole outside Shape!' );
							break;
	
						}
	
						// search for shape-vertex and hole-vertex,
						// which can be connected without intersections
						for ( shapeIndex = minShapeIndex; shapeIndex < shape.length; shapeIndex ++ ) {
	
							shapePt = shape[ shapeIndex ];
							holeIndex	= - 1;
	
							// search for hole which can be reached without intersections
							for ( var h = 0; h < indepHoles.length; h ++ ) {
	
								holeIdx = indepHoles[ h ];
	
								// prevent multiple checks
								cutKey = shapePt.x + ':' + shapePt.y + ':' + holeIdx;
								if ( failedCuts[ cutKey ] !== undefined )			continue;
	
								hole = holes[ holeIdx ];
								for ( var h2 = 0; h2 < hole.length; h2 ++ ) {
	
									holePt = hole[ h2 ];
									if ( ! isCutLineInsideAngles( shapeIndex, h2 ) )		continue;
									if ( intersectsShapeEdge( shapePt, holePt ) )		continue;
									if ( intersectsHoleEdge( shapePt, holePt ) )		continue;
	
									holeIndex = h2;
									indepHoles.splice( h, 1 );
	
									tmpShape1 = shape.slice( 0, shapeIndex + 1 );
									tmpShape2 = shape.slice( shapeIndex );
									tmpHole1 = hole.slice( holeIndex );
									tmpHole2 = hole.slice( 0, holeIndex + 1 );
	
									shape = tmpShape1.concat( tmpHole1 ).concat( tmpHole2 ).concat( tmpShape2 );
	
									minShapeIndex = shapeIndex;
	
									// Debug only, to show the selected cuts
									// glob_CutLines.push( [ shapePt, holePt ] );
	
									break;
	
								}
								if ( holeIndex >= 0 )	break;		// hole-vertex found
	
								failedCuts[ cutKey ] = true;			// remember failure
	
							}
							if ( holeIndex >= 0 )	break;		// hole-vertex found
	
						}
	
					}
	
					return shape; 			/* shape with no holes */
	
				}
	
	
				var i, il, f, face,
					key, index,
					allPointsMap = {};
	
				// To maintain reference to old shape, one must match coordinates, or offset the indices from original arrays. It's probably easier to do the first.
	
				var allpoints = contour.concat();
	
				for ( var h = 0, hl = holes.length; h < hl; h ++ ) {
	
					Array.prototype.push.apply( allpoints, holes[ h ] );
	
				}
	
				//console.log( "allpoints",allpoints, allpoints.length );
	
				// prepare all points map
	
				for ( i = 0, il = allpoints.length; i < il; i ++ ) {
	
					key = allpoints[ i ].x + ':' + allpoints[ i ].y;
	
					if ( allPointsMap[ key ] !== undefined ) {
	
						console.warn( 'THREE.ShapeUtils: Duplicate point', key, i );
	
					}
	
					allPointsMap[ key ] = i;
	
				}
	
				// remove holes by cutting paths to holes and adding them to the shape
				var shapeWithoutHoles = removeHoles( contour, holes );
	
				var triangles = ShapeUtils.triangulate( shapeWithoutHoles, false ); // True returns indices for points of spooled shape
				//console.log( "triangles",triangles, triangles.length );
	
				// check all face vertices against all points map
	
				for ( i = 0, il = triangles.length; i < il; i ++ ) {
	
					face = triangles[ i ];
	
					for ( f = 0; f < 3; f ++ ) {
	
						key = face[ f ].x + ':' + face[ f ].y;
	
						index = allPointsMap[ key ];
	
						if ( index !== undefined ) {
	
							face[ f ] = index;
	
						}
	
					}
	
				}
	
				return triangles.concat();
	
			},
	
			isClockWise: function ( pts ) {
	
				return ShapeUtils.area( pts ) < 0;
	
			}
	
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 *
		 * Creates extruded geometry from a path shape.
		 *
		 * parameters = {
		 *
		 *  curveSegments: <int>, // number of points on the curves
		 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
		 *  amount: <int>, // Depth to extrude the shape
		 *
		 *  bevelEnabled: <bool>, // turn on bevel
		 *  bevelThickness: <float>, // how deep into the original shape bevel goes
		 *  bevelSize: <float>, // how far from shape outline is bevel
		 *  bevelSegments: <int>, // number of bevel layers
		 *
		 *  extrudePath: <THREE.Curve> // curve to extrude shape along
		 *  frames: <Object> // containing arrays of tangents, normals, binormals
		 *
		 *  UVGenerator: <Object> // object that provides UV generator functions
		 *
		 * }
		 */
	
		// ExtrudeGeometry
	
		function ExtrudeGeometry( shapes, options ) {
	
			Geometry.call( this );
	
			this.type = 'ExtrudeGeometry';
	
			this.parameters = {
				shapes: shapes,
				options: options
			};
	
			this.fromBufferGeometry( new ExtrudeBufferGeometry( shapes, options ) );
			this.mergeVertices();
	
		}
	
		ExtrudeGeometry.prototype = Object.create( Geometry.prototype );
		ExtrudeGeometry.prototype.constructor = ExtrudeGeometry;
	
		// ExtrudeBufferGeometry
	
		function ExtrudeBufferGeometry( shapes, options ) {
	
			if ( typeof ( shapes ) === "undefined" ) {
	
				return;
	
			}
	
			BufferGeometry.call( this );
	
			this.type = 'ExtrudeBufferGeometry';
	
			shapes = Array.isArray( shapes ) ? shapes : [ shapes ];
	
			this.addShapeList( shapes, options );
	
			this.computeVertexNormals();
	
			// can't really use automatic vertex normals
			// as then front and back sides get smoothed too
			// should do separate smoothing just for sides
	
			//this.computeVertexNormals();
	
			//console.log( "took", ( Date.now() - startTime ) );
	
		}
	
		ExtrudeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		ExtrudeBufferGeometry.prototype.constructor = ExtrudeBufferGeometry;
	
		ExtrudeBufferGeometry.prototype.getArrays = function () {
	
			var positionAttribute = this.getAttribute( "position" );
			var verticesArray = positionAttribute ? Array.prototype.slice.call( positionAttribute.array ) : [];
	
			var uvAttribute = this.getAttribute( "uv" );
			var uvArray = uvAttribute ? Array.prototype.slice.call( uvAttribute.array ) : [];
	
			var IndexAttribute = this.index;
			var indicesArray = IndexAttribute ? Array.prototype.slice.call( IndexAttribute.array ) : [];
	
			return {
				position: verticesArray,
				uv: uvArray,
				index: indicesArray
			};
	
		};
	
		ExtrudeBufferGeometry.prototype.addShapeList = function ( shapes, options ) {
	
			var sl = shapes.length;
			options.arrays = this.getArrays();
	
			for ( var s = 0; s < sl; s ++ ) {
	
				var shape = shapes[ s ];
				this.addShape( shape, options );
	
			}
	
			this.setIndex( options.arrays.index );
			this.addAttribute( 'position', new Float32BufferAttribute( options.arrays.position, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( options.arrays.uv, 2 ) );
	
		};
	
		ExtrudeBufferGeometry.prototype.addShape = function ( shape, options ) {
	
			var arrays = options.arrays ? options.arrays : this.getArrays();
			var verticesArray = arrays.position;
			var indicesArray = arrays.index;
			var uvArray = arrays.uv;
	
			var placeholder = [];
	
	
			var amount = options.amount !== undefined ? options.amount : 100;
	
			var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6; // 10
			var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2; // 8
			var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
	
			var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true; // false
	
			var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
	
			var steps = options.steps !== undefined ? options.steps : 1;
	
			var extrudePath = options.extrudePath;
			var extrudePts, extrudeByPath = false;
	
			// Use default WorldUVGenerator if no UV generators are specified.
			var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : ExtrudeGeometry.WorldUVGenerator;
	
			var splineTube, binormal, normal, position2;
			if ( extrudePath ) {
	
				extrudePts = extrudePath.getSpacedPoints( steps );
	
				extrudeByPath = true;
				bevelEnabled = false; // bevels not supported for path extrusion
	
				// SETUP TNB variables
	
				// TODO1 - have a .isClosed in spline?
	
				splineTube = options.frames !== undefined ? options.frames : extrudePath.computeFrenetFrames( steps, false );
	
				// console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
	
				binormal = new Vector3();
				normal = new Vector3();
				position2 = new Vector3();
	
			}
	
			// Safeguards if bevels are not enabled
	
			if ( ! bevelEnabled ) {
	
				bevelSegments = 0;
				bevelThickness = 0;
				bevelSize = 0;
	
			}
	
			// Variables initialization
	
			var ahole, h, hl; // looping of holes
			var scope = this;
	
			var shapePoints = shape.extractPoints( curveSegments );
	
			var vertices = shapePoints.shape;
			var holes = shapePoints.holes;
	
			var reverse = ! ShapeUtils.isClockWise( vertices );
	
			if ( reverse ) {
	
				vertices = vertices.reverse();
	
				// Maybe we should also check if holes are in the opposite direction, just to be safe ...
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
	
					if ( ShapeUtils.isClockWise( ahole ) ) {
	
						holes[ h ] = ahole.reverse();
	
					}
	
				}
	
			}
	
	
			var faces = ShapeUtils.triangulateShape( vertices, holes );
	
			/* Vertices */
	
			var contour = vertices; // vertices has all points but contour has only points of circumference
	
			for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
				ahole = holes[ h ];
	
				vertices = vertices.concat( ahole );
	
			}
	
	
			function scalePt2( pt, vec, size ) {
	
				if ( ! vec ) console.error( "THREE.ExtrudeGeometry: vec does not exist" );
	
				return vec.clone().multiplyScalar( size ).add( pt );
	
			}
	
			var b, bs, t, z,
				vert, vlen = vertices.length,
				face, flen = faces.length;
	
	
			// Find directions for point movement
	
	
			function getBevelVec( inPt, inPrev, inNext ) {
	
				// computes for inPt the corresponding point inPt' on a new contour
				//   shifted by 1 unit (length of normalized vector) to the left
				// if we walk along contour clockwise, this new contour is outside the old one
				//
				// inPt' is the intersection of the two lines parallel to the two
				//  adjacent edges of inPt at a distance of 1 unit on the left side.
	
				var v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
	
				// good reading for geometry algorithms (here: line-line intersection)
				// http://geomalgorithms.com/a05-_intersect-1.html
	
				var v_prev_x = inPt.x - inPrev.x,
					v_prev_y = inPt.y - inPrev.y;
				var v_next_x = inNext.x - inPt.x,
					v_next_y = inNext.y - inPt.y;
	
				var v_prev_lensq = ( v_prev_x * v_prev_x + v_prev_y * v_prev_y );
	
				// check for collinear edges
				var collinear0 = ( v_prev_x * v_next_y - v_prev_y * v_next_x );
	
				if ( Math.abs( collinear0 ) > Number.EPSILON ) {
	
					// not collinear
	
					// length of vectors for normalizing
	
					var v_prev_len = Math.sqrt( v_prev_lensq );
					var v_next_len = Math.sqrt( v_next_x * v_next_x + v_next_y * v_next_y );
	
					// shift adjacent points by unit vectors to the left
	
					var ptPrevShift_x = ( inPrev.x - v_prev_y / v_prev_len );
					var ptPrevShift_y = ( inPrev.y + v_prev_x / v_prev_len );
	
					var ptNextShift_x = ( inNext.x - v_next_y / v_next_len );
					var ptNextShift_y = ( inNext.y + v_next_x / v_next_len );
	
					// scaling factor for v_prev to intersection point
	
					var sf = ( ( ptNextShift_x - ptPrevShift_x ) * v_next_y -
							( ptNextShift_y - ptPrevShift_y ) * v_next_x ) /
						( v_prev_x * v_next_y - v_prev_y * v_next_x );
	
					// vector from inPt to intersection point
	
					v_trans_x = ( ptPrevShift_x + v_prev_x * sf - inPt.x );
					v_trans_y = ( ptPrevShift_y + v_prev_y * sf - inPt.y );
	
					// Don't normalize!, otherwise sharp corners become ugly
					//  but prevent crazy spikes
					var v_trans_lensq = ( v_trans_x * v_trans_x + v_trans_y * v_trans_y );
					if ( v_trans_lensq <= 2 ) {
	
						return new Vector2( v_trans_x, v_trans_y );
	
					} else {
	
						shrink_by = Math.sqrt( v_trans_lensq / 2 );
	
					}
	
				} else {
	
					// handle special case of collinear edges
	
					var direction_eq = false; // assumes: opposite
					if ( v_prev_x > Number.EPSILON ) {
	
						if ( v_next_x > Number.EPSILON ) {
	
							direction_eq = true;
	
						}
	
					} else {
	
						if ( v_prev_x < - Number.EPSILON ) {
	
							if ( v_next_x < - Number.EPSILON ) {
	
								direction_eq = true;
	
							}
	
						} else {
	
							if ( Math.sign( v_prev_y ) === Math.sign( v_next_y ) ) {
	
								direction_eq = true;
	
							}
	
						}
	
					}
	
					if ( direction_eq ) {
	
						// console.log("Warning: lines are a straight sequence");
						v_trans_x = - v_prev_y;
						v_trans_y = v_prev_x;
						shrink_by = Math.sqrt( v_prev_lensq );
	
					} else {
	
						// console.log("Warning: lines are a straight spike");
						v_trans_x = v_prev_x;
						v_trans_y = v_prev_y;
						shrink_by = Math.sqrt( v_prev_lensq / 2 );
	
					}
	
				}
	
				return new Vector2( v_trans_x / shrink_by, v_trans_y / shrink_by );
	
			}
	
	
			var contourMovements = [];
	
			for ( var i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {
	
				if ( j === il ) j = 0;
				if ( k === il ) k = 0;
	
				//  (j)---(i)---(k)
				// console.log('i,j,k', i, j , k)
	
				contourMovements[ i ] = getBevelVec( contour[ i ], contour[ j ], contour[ k ] );
	
			}
	
			var holesMovements = [],
				oneHoleMovements, verticesMovements = contourMovements.concat();
	
			for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
				ahole = holes[ h ];
	
				oneHoleMovements = [];
	
				for ( i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {
	
					if ( j === il ) j = 0;
					if ( k === il ) k = 0;
	
					//  (j)---(i)---(k)
					oneHoleMovements[ i ] = getBevelVec( ahole[ i ], ahole[ j ], ahole[ k ] );
	
				}
	
				holesMovements.push( oneHoleMovements );
				verticesMovements = verticesMovements.concat( oneHoleMovements );
	
			}
	
	
			// Loop bevelSegments, 1 for the front, 1 for the back
	
			for ( b = 0; b < bevelSegments; b ++ ) {
	
				//for ( b = bevelSegments; b > 0; b -- ) {
	
				t = b / bevelSegments;
				z = bevelThickness * Math.cos( t * Math.PI / 2 );
				bs = bevelSize * Math.sin( t * Math.PI / 2 );
	
				// contract shape
	
				for ( i = 0, il = contour.length; i < il; i ++ ) {
	
					vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
	
					v( vert.x, vert.y, - z );
	
				}
	
				// expand holes
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
					oneHoleMovements = holesMovements[ h ];
	
					for ( i = 0, il = ahole.length; i < il; i ++ ) {
	
						vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );
	
						v( vert.x, vert.y, - z );
	
					}
	
				}
	
			}
	
			bs = bevelSize;
	
			// Back facing vertices
	
			for ( i = 0; i < vlen; i ++ ) {
	
				vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];
	
				if ( ! extrudeByPath ) {
	
					v( vert.x, vert.y, 0 );
	
				} else {
	
					// v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
	
					normal.copy( splineTube.normals[ 0 ] ).multiplyScalar( vert.x );
					binormal.copy( splineTube.binormals[ 0 ] ).multiplyScalar( vert.y );
	
					position2.copy( extrudePts[ 0 ] ).add( normal ).add( binormal );
	
					v( position2.x, position2.y, position2.z );
	
				}
	
			}
	
			// Add stepped vertices...
			// Including front facing vertices
	
			var s;
	
			for ( s = 1; s <= steps; s ++ ) {
	
				for ( i = 0; i < vlen; i ++ ) {
	
					vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];
	
					if ( ! extrudeByPath ) {
	
						v( vert.x, vert.y, amount / steps * s );
	
					} else {
	
						// v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
	
						normal.copy( splineTube.normals[ s ] ).multiplyScalar( vert.x );
						binormal.copy( splineTube.binormals[ s ] ).multiplyScalar( vert.y );
	
						position2.copy( extrudePts[ s ] ).add( normal ).add( binormal );
	
						v( position2.x, position2.y, position2.z );
	
					}
	
				}
	
			}
	
	
			// Add bevel segments planes
	
			//for ( b = 1; b <= bevelSegments; b ++ ) {
			for ( b = bevelSegments - 1; b >= 0; b -- ) {
	
				t = b / bevelSegments;
				z = bevelThickness * Math.cos( t * Math.PI / 2 );
				bs = bevelSize * Math.sin( t * Math.PI / 2 );
	
				// contract shape
	
				for ( i = 0, il = contour.length; i < il; i ++ ) {
	
					vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
					v( vert.x, vert.y, amount + z );
	
				}
	
				// expand holes
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
					oneHoleMovements = holesMovements[ h ];
	
					for ( i = 0, il = ahole.length; i < il; i ++ ) {
	
						vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );
	
						if ( ! extrudeByPath ) {
	
							v( vert.x, vert.y, amount + z );
	
						} else {
	
							v( vert.x, vert.y + extrudePts[ steps - 1 ].y, extrudePts[ steps - 1 ].x + z );
	
						}
	
					}
	
				}
	
			}
	
			/* Faces */
	
			// Top and bottom faces
	
			buildLidFaces();
	
			// Sides faces
	
			buildSideFaces();
	
	
			/////  Internal functions
	
			function buildLidFaces() {
	
				var start = verticesArray.length/3;
	
				if ( bevelEnabled ) {
	
					var layer = 0; // steps + 1
					var offset = vlen * layer;
	
					// Bottom faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 2 ] + offset, face[ 1 ] + offset, face[ 0 ] + offset );
	
					}
	
					layer = steps + bevelSegments * 2;
					offset = vlen * layer;
	
					// Top faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 0 ] + offset, face[ 1 ] + offset, face[ 2 ] + offset );
	
					}
	
				} else {
	
					// Bottom faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 2 ], face[ 1 ], face[ 0 ] );
	
					}
	
					// Top faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 0 ] + vlen * steps, face[ 1 ] + vlen * steps, face[ 2 ] + vlen * steps );
	
					}
	
				}
	
				scope.addGroup( start, verticesArray.length/3 -start, options.material !== undefined ? options.material : 0);
	
			}
	
			// Create faces for the z-sides of the shape
	
			function buildSideFaces() {
	
				var start = verticesArray.length/3;
				var layeroffset = 0;
				sidewalls( contour, layeroffset );
				layeroffset += contour.length;
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
					sidewalls( ahole, layeroffset );
	
					//, true
					layeroffset += ahole.length;
	
				}
	
	
				scope.addGroup( start, verticesArray.length/3 -start, options.extrudeMaterial !== undefined ? options.extrudeMaterial : 1);
	
	
			}
	
			function sidewalls( contour, layeroffset ) {
	
				var j, k;
				i = contour.length;
	
				while ( -- i >= 0 ) {
	
					j = i;
					k = i - 1;
					if ( k < 0 ) k = contour.length - 1;
	
					//console.log('b', i,j, i-1, k,vertices.length);
	
					var s = 0,
						sl = steps + bevelSegments * 2;
	
					for ( s = 0; s < sl; s ++ ) {
	
						var slen1 = vlen * s;
						var slen2 = vlen * ( s + 1 );
	
						var a = layeroffset + j + slen1,
							b = layeroffset + k + slen1,
							c = layeroffset + k + slen2,
							d = layeroffset + j + slen2;
	
						f4( a, b, c, d, contour, s, sl, j, k );
	
					}
	
				}
	
			}
	
			function v( x, y, z ) {
	
				placeholder.push( x );
				placeholder.push( y );
				placeholder.push( z );
	
			}
	
	
			function f3( a, b, c ) {
	
				addVertex( a );
				addVertex( b );
				addVertex( c );
	
				var nextIndex = verticesArray.length / 3;
				var uvs = uvgen.generateTopUV( scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1 );
	
				addUV( uvs[ 0 ] );
				addUV( uvs[ 1 ] );
				addUV( uvs[ 2 ] );
	
			}
	
			function f4( a, b, c, d, wallContour, stepIndex, stepsLength, contourIndex1, contourIndex2 ) {
	
				addVertex( a );
				addVertex( b );
				addVertex( d );
	
				addVertex( b );
				addVertex( c );
				addVertex( d );
	
	
				var nextIndex = verticesArray.length / 3;
				var uvs = uvgen.generateSideWallUV( scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1 );
	
				addUV( uvs[ 0 ] );
				addUV( uvs[ 1 ] );
				addUV( uvs[ 3 ] );
	
				addUV( uvs[ 1 ] );
				addUV( uvs[ 2 ] );
				addUV( uvs[ 3 ] );
	
			}
	
			function addVertex( index ) {
	
				indicesArray.push( verticesArray.length / 3 );
				verticesArray.push( placeholder[ index * 3 + 0 ] );
				verticesArray.push( placeholder[ index * 3 + 1 ] );
				verticesArray.push( placeholder[ index * 3 + 2 ] );
	
			}
	
	
			function addUV( vector2 ) {
	
				uvArray.push( vector2.x );
				uvArray.push( vector2.y );
	
			}
	
			if ( ! options.arrays ) {
	
				this.setIndex( indicesArray );
				this.addAttribute( 'position', new Float32BufferAttribute( verticesArray, 3 ) );
				this.addAttribute( 'uv', new Float32BufferAttribute( options.arrays.uv, 2 ) );
	
			}
	
		};
	
		ExtrudeGeometry.WorldUVGenerator = {
	
			generateTopUV: function ( geometry, vertices, indexA, indexB, indexC ) {
	
				var a_x = vertices[ indexA * 3 ];
				var a_y = vertices[ indexA * 3 + 1 ];
				var b_x = vertices[ indexB * 3 ];
				var b_y = vertices[ indexB * 3 + 1 ];
				var c_x = vertices[ indexC * 3 ];
				var c_y = vertices[ indexC * 3 + 1 ];
	
				return [
					new Vector2( a_x, a_y ),
					new Vector2( b_x, b_y ),
					new Vector2( c_x, c_y )
				];
	
			},
	
			generateSideWallUV: function ( geometry, vertices, indexA, indexB, indexC, indexD ) {
	
				var a_x = vertices[ indexA * 3 ];
				var a_y = vertices[ indexA * 3 + 1 ];
				var a_z = vertices[ indexA * 3 + 2 ];
				var b_x = vertices[ indexB * 3 ];
				var b_y = vertices[ indexB * 3 + 1 ];
				var b_z = vertices[ indexB * 3 + 2 ];
				var c_x = vertices[ indexC * 3 ];
				var c_y = vertices[ indexC * 3 + 1 ];
				var c_z = vertices[ indexC * 3 + 2 ];
				var d_x = vertices[ indexD * 3 ];
				var d_y = vertices[ indexD * 3 + 1 ];
				var d_z = vertices[ indexD * 3 + 2 ];
	
				if ( Math.abs( a_y - b_y ) < 0.01 ) {
	
					return [
						new Vector2( a_x, 1 - a_z ),
						new Vector2( b_x, 1 - b_z ),
						new Vector2( c_x, 1 - c_z ),
						new Vector2( d_x, 1 - d_z )
					];
	
				} else {
	
					return [
						new Vector2( a_y, 1 - a_z ),
						new Vector2( b_y, 1 - b_z ),
						new Vector2( c_y, 1 - c_z ),
						new Vector2( d_y, 1 - d_z )
					];
	
				}
	
			}
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * Text = 3D Text
		 *
		 * parameters = {
		 *  font: <THREE.Font>, // font
		 *
		 *  size: <float>, // size of the text
		 *  height: <float>, // thickness to extrude text
		 *  curveSegments: <int>, // number of points on the curves
		 *
		 *  bevelEnabled: <bool>, // turn on bevel
		 *  bevelThickness: <float>, // how deep into text bevel goes
		 *  bevelSize: <float> // how far from text outline is bevel
		 * }
		 */
	
		// TextGeometry
	
		function TextGeometry(  text, parameters ) {
	
			Geometry.call( this );
	
			this.type = 'TextGeometry';
	
			this.parameters = {
				text: text,
				parameters: parameters
			};
	
			this.fromBufferGeometry( new TextBufferGeometry( text, parameters ) );
			this.mergeVertices();
	
		}
	
		TextGeometry.prototype = Object.create( Geometry.prototype );
		TextGeometry.prototype.constructor = TextGeometry;
	
		// TextBufferGeometry
	
		function TextBufferGeometry( text, parameters ) {
	
			parameters = parameters || {};
	
			var font = parameters.font;
	
			if ( ! ( font && font.isFont ) ) {
	
				console.error( 'THREE.TextGeometry: font parameter is not an instance of THREE.Font.' );
				return new Geometry();
	
			}
	
			var shapes = font.generateShapes( text, parameters.size, parameters.curveSegments );
	
			// translate parameters to ExtrudeGeometry API
	
			parameters.amount = parameters.height !== undefined ? parameters.height : 50;
	
			// defaults
	
			if ( parameters.bevelThickness === undefined ) parameters.bevelThickness = 10;
			if ( parameters.bevelSize === undefined ) parameters.bevelSize = 8;
			if ( parameters.bevelEnabled === undefined ) parameters.bevelEnabled = false;
	
			ExtrudeBufferGeometry.call( this, shapes, parameters );
	
			this.type = 'TextBufferGeometry';
	
		}
	
		TextBufferGeometry.prototype = Object.create( ExtrudeBufferGeometry.prototype );
		TextBufferGeometry.prototype.constructor = TextBufferGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author benaadams / https://twitter.com/ben_a_adams
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// SphereGeometry
	
		function SphereGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'SphereGeometry';
	
			this.parameters = {
				radius: radius,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				phiStart: phiStart,
				phiLength: phiLength,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) );
			this.mergeVertices();
	
		}
	
		SphereGeometry.prototype = Object.create( Geometry.prototype );
		SphereGeometry.prototype.constructor = SphereGeometry;
	
		// SphereBufferGeometry
	
		function SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'SphereBufferGeometry';
	
			this.parameters = {
				radius: radius,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				phiStart: phiStart,
				phiLength: phiLength,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			radius = radius || 50;
	
			widthSegments = Math.max( 3, Math.floor( widthSegments ) || 8 );
			heightSegments = Math.max( 2, Math.floor( heightSegments ) || 6 );
	
			phiStart = phiStart !== undefined ? phiStart : 0;
			phiLength = phiLength !== undefined ? phiLength : Math.PI * 2;
	
			thetaStart = thetaStart !== undefined ? thetaStart : 0;
			thetaLength = thetaLength !== undefined ? thetaLength : Math.PI;
	
			var thetaEnd = thetaStart + thetaLength;
	
			var ix, iy;
	
			var index = 0;
			var grid = [];
	
			var vertex = new Vector3();
			var normal = new Vector3();
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// generate vertices, normals and uvs
	
			for ( iy = 0; iy <= heightSegments; iy ++ ) {
	
				var verticesRow = [];
	
				var v = iy / heightSegments;
	
				for ( ix = 0; ix <= widthSegments; ix ++ ) {
	
					var u = ix / widthSegments;
	
					// vertex
	
					vertex.x = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
					vertex.y = radius * Math.cos( thetaStart + v * thetaLength );
					vertex.z = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					normal.set( vertex.x, vertex.y, vertex.z ).normalize();
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( u, 1 - v );
	
					verticesRow.push( index ++ );
	
				}
	
				grid.push( verticesRow );
	
			}
	
			// indices
	
			for ( iy = 0; iy < heightSegments; iy ++ ) {
	
				for ( ix = 0; ix < widthSegments; ix ++ ) {
	
					var a = grid[ iy ][ ix + 1 ];
					var b = grid[ iy ][ ix ];
					var c = grid[ iy + 1 ][ ix ];
					var d = grid[ iy + 1 ][ ix + 1 ];
	
					if ( iy !== 0 || thetaStart > 0 ) indices.push( a, b, d );
					if ( iy !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		SphereBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		SphereBufferGeometry.prototype.constructor = SphereBufferGeometry;
	
		/**
		 * @author Kaleb Murphy
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// RingGeometry
	
		function RingGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'RingGeometry';
	
			this.parameters = {
				innerRadius: innerRadius,
				outerRadius: outerRadius,
				thetaSegments: thetaSegments,
				phiSegments: phiSegments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) );
			this.mergeVertices();
	
		}
	
		RingGeometry.prototype = Object.create( Geometry.prototype );
		RingGeometry.prototype.constructor = RingGeometry;
	
		// RingBufferGeometry
	
		function RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'RingBufferGeometry';
	
			this.parameters = {
				innerRadius: innerRadius,
				outerRadius: outerRadius,
				thetaSegments: thetaSegments,
				phiSegments: phiSegments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			innerRadius = innerRadius || 20;
			outerRadius = outerRadius || 50;
	
			thetaStart = thetaStart !== undefined ? thetaStart : 0;
			thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;
	
			thetaSegments = thetaSegments !== undefined ? Math.max( 3, thetaSegments ) : 8;
			phiSegments = phiSegments !== undefined ? Math.max( 1, phiSegments ) : 1;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// some helper variables
	
			var segment;
			var radius = innerRadius;
			var radiusStep = ( ( outerRadius - innerRadius ) / phiSegments );
			var vertex = new Vector3();
			var uv = new Vector2();
			var j, i;
	
			// generate vertices, normals and uvs
	
			for ( j = 0; j <= phiSegments; j ++ ) {
	
				for ( i = 0; i <= thetaSegments; i ++ ) {
	
					// values are generate from the inside of the ring to the outside
	
					segment = thetaStart + i / thetaSegments * thetaLength;
	
					// vertex
	
					vertex.x = radius * Math.cos( segment );
					vertex.y = radius * Math.sin( segment );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					normals.push( 0, 0, 1 );
	
					// uv
	
					uv.x = ( vertex.x / outerRadius + 1 ) / 2;
					uv.y = ( vertex.y / outerRadius + 1 ) / 2;
	
					uvs.push( uv.x, uv.y );
	
				}
	
				// increase the radius for next row of vertices
	
				radius += radiusStep;
	
			}
	
			// indices
	
			for ( j = 0; j < phiSegments; j ++ ) {
	
				var thetaSegmentLevel = j * ( thetaSegments + 1 );
	
				for ( i = 0; i < thetaSegments; i ++ ) {
	
					segment = i + thetaSegmentLevel;
	
					var a = segment;
					var b = segment + thetaSegments + 1;
					var c = segment + thetaSegments + 2;
					var d = segment + 1;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		RingBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		RingBufferGeometry.prototype.constructor = RingBufferGeometry;
	
		/**
		 * @author astrodud / http://astrodud.isgreat.org/
		 * @author zz85 / https://github.com/zz85
		 * @author bhouston / http://clara.io
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// LatheGeometry
	
		function LatheGeometry( points, segments, phiStart, phiLength ) {
	
			Geometry.call( this );
	
			this.type = 'LatheGeometry';
	
			this.parameters = {
				points: points,
				segments: segments,
				phiStart: phiStart,
				phiLength: phiLength
			};
	
			this.fromBufferGeometry( new LatheBufferGeometry( points, segments, phiStart, phiLength ) );
			this.mergeVertices();
	
		}
	
		LatheGeometry.prototype = Object.create( Geometry.prototype );
		LatheGeometry.prototype.constructor = LatheGeometry;
	
		// LatheBufferGeometry
	
		function LatheBufferGeometry( points, segments, phiStart, phiLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'LatheBufferGeometry';
	
			this.parameters = {
				points: points,
				segments: segments,
				phiStart: phiStart,
				phiLength: phiLength
			};
	
			segments = Math.floor( segments ) || 12;
			phiStart = phiStart || 0;
			phiLength = phiLength || Math.PI * 2;
	
			// clamp phiLength so it's in range of [ 0, 2PI ]
	
			phiLength = _Math.clamp( phiLength, 0, Math.PI * 2 );
	
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var uvs = [];
	
			// helper variables
	
			var base;
			var inverseSegments = 1.0 / segments;
			var vertex = new Vector3();
			var uv = new Vector2();
			var i, j;
	
			// generate vertices and uvs
	
			for ( i = 0; i <= segments; i ++ ) {
	
				var phi = phiStart + i * inverseSegments * phiLength;
	
				var sin = Math.sin( phi );
				var cos = Math.cos( phi );
	
				for ( j = 0; j <= ( points.length - 1 ); j ++ ) {
	
					// vertex
	
					vertex.x = points[ j ].x * sin;
					vertex.y = points[ j ].y;
					vertex.z = points[ j ].x * cos;
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// uv
	
					uv.x = i / segments;
					uv.y = j / ( points.length - 1 );
	
					uvs.push( uv.x, uv.y );
	
	
				}
	
			}
	
			// indices
	
			for ( i = 0; i < segments; i ++ ) {
	
				for ( j = 0; j < ( points.length - 1 ); j ++ ) {
	
					base = j + i * points.length;
	
					var a = base;
					var b = base + points.length;
					var c = base + points.length + 1;
					var d = base + 1;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			// generate normals
	
			this.computeVertexNormals();
	
			// if the geometry is closed, we need to average the normals along the seam.
			// because the corresponding vertices are identical (but still have different UVs).
	
			if ( phiLength === Math.PI * 2 ) {
	
				var normals = this.attributes.normal.array;
				var n1 = new Vector3();
				var n2 = new Vector3();
				var n = new Vector3();
	
				// this is the buffer offset for the last line of vertices
	
				base = segments * points.length * 3;
	
				for ( i = 0, j = 0; i < points.length; i ++, j += 3 ) {
	
					// select the normal of the vertex in the first line
	
					n1.x = normals[ j + 0 ];
					n1.y = normals[ j + 1 ];
					n1.z = normals[ j + 2 ];
	
					// select the normal of the vertex in the last line
	
					n2.x = normals[ base + j + 0 ];
					n2.y = normals[ base + j + 1 ];
					n2.z = normals[ base + j + 2 ];
	
					// average normals
	
					n.addVectors( n1, n2 ).normalize();
	
					// assign the new values to both normals
	
					normals[ j + 0 ] = normals[ base + j + 0 ] = n.x;
					normals[ j + 1 ] = normals[ base + j + 1 ] = n.y;
					normals[ j + 2 ] = normals[ base + j + 2 ] = n.z;
	
				}
	
			}
	
		}
	
		LatheBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		LatheBufferGeometry.prototype.constructor = LatheBufferGeometry;
	
		/**
		 * @author jonobr1 / http://jonobr1.com
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// ShapeGeometry
	
		function ShapeGeometry( shapes, curveSegments ) {
	
			Geometry.call( this );
	
			this.type = 'ShapeGeometry';
	
			if ( typeof curveSegments === 'object' ) {
	
				console.warn( 'THREE.ShapeGeometry: Options parameter has been removed.' );
	
				curveSegments = curveSegments.curveSegments;
	
			}
	
			this.parameters = {
				shapes: shapes,
				curveSegments: curveSegments
			};
	
			this.fromBufferGeometry( new ShapeBufferGeometry( shapes, curveSegments ) );
			this.mergeVertices();
	
		}
	
		ShapeGeometry.prototype = Object.create( Geometry.prototype );
		ShapeGeometry.prototype.constructor = ShapeGeometry;
	
		// ShapeBufferGeometry
	
		function ShapeBufferGeometry( shapes, curveSegments ) {
	
			BufferGeometry.call( this );
	
			this.type = 'ShapeBufferGeometry';
	
			this.parameters = {
				shapes: shapes,
				curveSegments: curveSegments
			};
	
			curveSegments = curveSegments || 12;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var groupStart = 0;
			var groupCount = 0;
	
			// allow single and array values for "shapes" parameter
	
			if ( Array.isArray( shapes ) === false ) {
	
				addShape( shapes );
	
			} else {
	
				for ( var i = 0; i < shapes.length; i ++ ) {
	
					addShape( shapes[ i ] );
	
					this.addGroup( groupStart, groupCount, i ); // enables MultiMaterial support
	
					groupStart += groupCount;
					groupCount = 0;
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
	
			// helper functions
	
			function addShape( shape ) {
	
				var i, l, shapeHole;
	
				var indexOffset = vertices.length / 3;
				var points = shape.extractPoints( curveSegments );
	
				var shapeVertices = points.shape;
				var shapeHoles = points.holes;
	
				// check direction of vertices
	
				if ( ShapeUtils.isClockWise( shapeVertices ) === false ) {
	
					shapeVertices = shapeVertices.reverse();
	
					// also check if holes are in the opposite direction
	
					for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {
	
						shapeHole = shapeHoles[ i ];
	
						if ( ShapeUtils.isClockWise( shapeHole ) === true ) {
	
							shapeHoles[ i ] = shapeHole.reverse();
	
						}
	
					}
	
				}
	
				var faces = ShapeUtils.triangulateShape( shapeVertices, shapeHoles );
	
				// join vertices of inner and outer paths to a single array
	
				for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {
	
					shapeHole = shapeHoles[ i ];
					shapeVertices = shapeVertices.concat( shapeHole );
	
				}
	
				// vertices, normals, uvs
	
				for ( i = 0, l = shapeVertices.length; i < l; i ++ ) {
	
					var vertex = shapeVertices[ i ];
	
					vertices.push( vertex.x, vertex.y, 0 );
					normals.push( 0, 0, 1 );
					uvs.push( vertex.x, vertex.y ); // world uvs
	
				}
	
				// incides
	
				for ( i = 0, l = faces.length; i < l; i ++ ) {
	
					var face = faces[ i ];
	
					var a = face[ 0 ] + indexOffset;
					var b = face[ 1 ] + indexOffset;
					var c = face[ 2 ] + indexOffset;
	
					indices.push( a, b, c );
					groupCount += 3;
	
				}
	
			}
	
		}
	
		ShapeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		ShapeBufferGeometry.prototype.constructor = ShapeBufferGeometry;
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function EdgesGeometry( geometry, thresholdAngle ) {
	
			BufferGeometry.call( this );
	
			this.type = 'EdgesGeometry';
	
			this.parameters = {
				thresholdAngle: thresholdAngle
			};
	
			thresholdAngle = ( thresholdAngle !== undefined ) ? thresholdAngle : 1;
	
			// buffer
	
			var vertices = [];
	
			// helper variables
	
			var thresholdDot = Math.cos( _Math.DEG2RAD * thresholdAngle );
			var edge = [ 0, 0 ], edges = {}, edge1, edge2;
			var key, keys = [ 'a', 'b', 'c' ];
	
			// prepare source geometry
	
			var geometry2;
	
			if ( geometry.isBufferGeometry ) {
	
				geometry2 = new Geometry();
				geometry2.fromBufferGeometry( geometry );
	
			} else {
	
				geometry2 = geometry.clone();
	
			}
	
			geometry2.mergeVertices();
			geometry2.computeFaceNormals();
	
			var sourceVertices = geometry2.vertices;
			var faces = geometry2.faces;
	
			// now create a data structure where each entry represents an edge with its adjoining faces
	
			for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
				var face = faces[ i ];
	
				for ( var j = 0; j < 3; j ++ ) {
	
					edge1 = face[ keys[ j ] ];
					edge2 = face[ keys[ ( j + 1 ) % 3 ] ];
					edge[ 0 ] = Math.min( edge1, edge2 );
					edge[ 1 ] = Math.max( edge1, edge2 );
	
					key = edge[ 0 ] + ',' + edge[ 1 ];
	
					if ( edges[ key ] === undefined ) {
	
						edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ], face1: i, face2: undefined };
	
					} else {
	
						edges[ key ].face2 = i;
	
					}
	
				}
	
			}
	
			// generate vertices
	
			for ( key in edges ) {
	
				var e = edges[ key ];
	
				// an edge is only rendered if the angle (in degrees) between the face normals of the adjoining faces exceeds this value. default = 1 degree.
	
				if ( e.face2 === undefined || faces[ e.face1 ].normal.dot( faces[ e.face2 ].normal ) <= thresholdDot ) {
	
					var vertex = sourceVertices[ e.index1 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					vertex = sourceVertices[ e.index2 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
			}
	
			// build geometry
	
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	
		}
	
		EdgesGeometry.prototype = Object.create( BufferGeometry.prototype );
		EdgesGeometry.prototype.constructor = EdgesGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// CylinderGeometry
	
		function CylinderGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'CylinderGeometry';
	
			this.parameters = {
				radiusTop: radiusTop,
				radiusBottom: radiusBottom,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) );
			this.mergeVertices();
	
		}
	
		CylinderGeometry.prototype = Object.create( Geometry.prototype );
		CylinderGeometry.prototype.constructor = CylinderGeometry;
	
		// CylinderBufferGeometry
	
		function CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'CylinderBufferGeometry';
	
			this.parameters = {
				radiusTop: radiusTop,
				radiusBottom: radiusBottom,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			var scope = this;
	
			radiusTop = radiusTop !== undefined ? radiusTop : 20;
			radiusBottom = radiusBottom !== undefined ? radiusBottom : 20;
			height = height !== undefined ? height : 100;
	
			radialSegments = Math.floor( radialSegments ) || 8;
			heightSegments = Math.floor( heightSegments ) || 1;
	
			openEnded = openEnded !== undefined ? openEnded : false;
			thetaStart = thetaStart !== undefined ? thetaStart : 0.0;
			thetaLength = thetaLength !== undefined ? thetaLength : 2.0 * Math.PI;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var index = 0;
			var indexArray = [];
			var halfHeight = height / 2;
			var groupStart = 0;
	
			// generate geometry
	
			generateTorso();
	
			if ( openEnded === false ) {
	
				if ( radiusTop > 0 ) generateCap( true );
				if ( radiusBottom > 0 ) generateCap( false );
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			function generateTorso() {
	
				var x, y;
				var normal = new Vector3();
				var vertex = new Vector3();
	
				var groupCount = 0;
	
				// this will be used to calculate the normal
				var slope = ( radiusBottom - radiusTop ) / height;
	
				// generate vertices, normals and uvs
	
				for ( y = 0; y <= heightSegments; y ++ ) {
	
					var indexRow = [];
	
					var v = y / heightSegments;
	
					// calculate the radius of the current row
	
					var radius = v * ( radiusBottom - radiusTop ) + radiusTop;
	
					for ( x = 0; x <= radialSegments; x ++ ) {
	
						var u = x / radialSegments;
	
						var theta = u * thetaLength + thetaStart;
	
						var sinTheta = Math.sin( theta );
						var cosTheta = Math.cos( theta );
	
						// vertex
	
						vertex.x = radius * sinTheta;
						vertex.y = - v * height + halfHeight;
						vertex.z = radius * cosTheta;
						vertices.push( vertex.x, vertex.y, vertex.z );
	
						// normal
	
						normal.set( sinTheta, slope, cosTheta ).normalize();
						normals.push( normal.x, normal.y, normal.z );
	
						// uv
	
						uvs.push( u, 1 - v );
	
						// save index of vertex in respective row
	
						indexRow.push( index ++ );
	
					}
	
					// now save vertices of the row in our index array
	
					indexArray.push( indexRow );
	
				}
	
				// generate indices
	
				for ( x = 0; x < radialSegments; x ++ ) {
	
					for ( y = 0; y < heightSegments; y ++ ) {
	
						// we use the index array to access the correct indices
	
						var a = indexArray[ y ][ x ];
						var b = indexArray[ y + 1 ][ x ];
						var c = indexArray[ y + 1 ][ x + 1 ];
						var d = indexArray[ y ][ x + 1 ];
	
						// faces
	
						indices.push( a, b, d );
						indices.push( b, c, d );
	
						// update group counter
	
						groupCount += 6;
	
					}
	
				}
	
				// add a group to the geometry. this will ensure multi material support
	
				scope.addGroup( groupStart, groupCount, 0 );
	
				// calculate new start value for groups
	
				groupStart += groupCount;
	
			}
	
			function generateCap( top ) {
	
				var x, centerIndexStart, centerIndexEnd;
	
				var uv = new Vector2();
				var vertex = new Vector3();
	
				var groupCount = 0;
	
				var radius = ( top === true ) ? radiusTop : radiusBottom;
				var sign = ( top === true ) ? 1 : - 1;
	
				// save the index of the first center vertex
				centerIndexStart = index;
	
				// first we generate the center vertex data of the cap.
				// because the geometry needs one set of uvs per face,
				// we must generate a center vertex per face/segment
	
				for ( x = 1; x <= radialSegments; x ++ ) {
	
					// vertex
	
					vertices.push( 0, halfHeight * sign, 0 );
	
					// normal
	
					normals.push( 0, sign, 0 );
	
					// uv
	
					uvs.push( 0.5, 0.5 );
	
					// increase index
	
					index ++;
	
				}
	
				// save the index of the last center vertex
	
				centerIndexEnd = index;
	
				// now we generate the surrounding vertices, normals and uvs
	
				for ( x = 0; x <= radialSegments; x ++ ) {
	
					var u = x / radialSegments;
					var theta = u * thetaLength + thetaStart;
	
					var cosTheta = Math.cos( theta );
					var sinTheta = Math.sin( theta );
	
					// vertex
	
					vertex.x = radius * sinTheta;
					vertex.y = halfHeight * sign;
					vertex.z = radius * cosTheta;
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					normals.push( 0, sign, 0 );
	
					// uv
	
					uv.x = ( cosTheta * 0.5 ) + 0.5;
					uv.y = ( sinTheta * 0.5 * sign ) + 0.5;
					uvs.push( uv.x, uv.y );
	
					// increase index
	
					index ++;
	
				}
	
				// generate indices
	
				for ( x = 0; x < radialSegments; x ++ ) {
	
					var c = centerIndexStart + x;
					var i = centerIndexEnd + x;
	
					if ( top === true ) {
	
						// face top
	
						indices.push( i, i + 1, c );
	
					} else {
	
						// face bottom
	
						indices.push( i + 1, i, c );
	
					}
	
					groupCount += 3;
	
				}
	
				// add a group to the geometry. this will ensure multi material support
	
				scope.addGroup( groupStart, groupCount, top === true ? 1 : 2 );
	
				// calculate new start value for groups
	
				groupStart += groupCount;
	
			}
	
		}
	
		CylinderBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		CylinderBufferGeometry.prototype.constructor = CylinderBufferGeometry;
	
		/**
		 * @author abelnation / http://github.com/abelnation
		 */
	
		// ConeGeometry
	
		function ConeGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			CylinderGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );
	
			this.type = 'ConeGeometry';
	
			this.parameters = {
				radius: radius,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
		}
	
		ConeGeometry.prototype = Object.create( CylinderGeometry.prototype );
		ConeGeometry.prototype.constructor = ConeGeometry;
	
		// ConeBufferGeometry
	
		function ConeBufferGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			CylinderBufferGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );
	
			this.type = 'ConeBufferGeometry';
	
			this.parameters = {
				radius: radius,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
		}
	
		ConeBufferGeometry.prototype = Object.create( CylinderBufferGeometry.prototype );
		ConeBufferGeometry.prototype.constructor = ConeBufferGeometry;
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 * @author Mugen87 / https://github.com/Mugen87
		 * @author hughes
		 */
	
		// CircleGeometry
	
		function CircleGeometry( radius, segments, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'CircleGeometry';
	
			this.parameters = {
				radius: radius,
				segments: segments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) );
			this.mergeVertices();
	
		}
	
		CircleGeometry.prototype = Object.create( Geometry.prototype );
		CircleGeometry.prototype.constructor = CircleGeometry;
	
		// CircleBufferGeometry
	
		function CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'CircleBufferGeometry';
	
			this.parameters = {
				radius: radius,
				segments: segments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			radius = radius || 50;
			segments = segments !== undefined ? Math.max( 3, segments ) : 8;
	
			thetaStart = thetaStart !== undefined ? thetaStart : 0;
			thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var i, s;
			var vertex = new Vector3();
			var uv = new Vector2();
	
			// center point
	
			vertices.push( 0, 0, 0 );
			normals.push( 0, 0, 1 );
			uvs.push( 0.5, 0.5 );
	
			for ( s = 0, i = 3; s <= segments; s ++, i += 3 ) {
	
				var segment = thetaStart + s / segments * thetaLength;
	
				// vertex
	
				vertex.x = radius * Math.cos( segment );
				vertex.y = radius * Math.sin( segment );
	
				vertices.push( vertex.x, vertex.y, vertex.z );
	
				// normal
	
				normals.push( 0, 0, 1 );
	
				// uvs
	
				uv.x = ( vertices[ i ] / radius + 1 ) / 2;
				uv.y = ( vertices[ i + 1 ] / radius + 1 ) / 2;
	
				uvs.push( uv.x, uv.y );
	
			}
	
			// indices
	
			for ( i = 1; i <= segments; i ++ ) {
	
				indices.push( i, i + 1, 0 );
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		CircleBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		CircleBufferGeometry.prototype.constructor = CircleBufferGeometry;
	
	
	
		var Geometries = Object.freeze({
			WireframeGeometry: WireframeGeometry,
			ParametricGeometry: ParametricGeometry,
			ParametricBufferGeometry: ParametricBufferGeometry,
			TetrahedronGeometry: TetrahedronGeometry,
			TetrahedronBufferGeometry: TetrahedronBufferGeometry,
			OctahedronGeometry: OctahedronGeometry,
			OctahedronBufferGeometry: OctahedronBufferGeometry,
			IcosahedronGeometry: IcosahedronGeometry,
			IcosahedronBufferGeometry: IcosahedronBufferGeometry,
			DodecahedronGeometry: DodecahedronGeometry,
			DodecahedronBufferGeometry: DodecahedronBufferGeometry,
			PolyhedronGeometry: PolyhedronGeometry,
			PolyhedronBufferGeometry: PolyhedronBufferGeometry,
			TubeGeometry: TubeGeometry,
			TubeBufferGeometry: TubeBufferGeometry,
			TorusKnotGeometry: TorusKnotGeometry,
			TorusKnotBufferGeometry: TorusKnotBufferGeometry,
			TorusGeometry: TorusGeometry,
			TorusBufferGeometry: TorusBufferGeometry,
			TextGeometry: TextGeometry,
			TextBufferGeometry: TextBufferGeometry,
			SphereGeometry: SphereGeometry,
			SphereBufferGeometry: SphereBufferGeometry,
			RingGeometry: RingGeometry,
			RingBufferGeometry: RingBufferGeometry,
			PlaneGeometry: PlaneGeometry,
			PlaneBufferGeometry: PlaneBufferGeometry,
			LatheGeometry: LatheGeometry,
			LatheBufferGeometry: LatheBufferGeometry,
			ShapeGeometry: ShapeGeometry,
			ShapeBufferGeometry: ShapeBufferGeometry,
			ExtrudeGeometry: ExtrudeGeometry,
			ExtrudeBufferGeometry: ExtrudeBufferGeometry,
			EdgesGeometry: EdgesGeometry,
			ConeGeometry: ConeGeometry,
			ConeBufferGeometry: ConeBufferGeometry,
			CylinderGeometry: CylinderGeometry,
			CylinderBufferGeometry: CylinderBufferGeometry,
			CircleGeometry: CircleGeometry,
			CircleBufferGeometry: CircleBufferGeometry,
			BoxGeometry: BoxGeometry,
			BoxBufferGeometry: BoxBufferGeometry
		});
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 *
		 * parameters = {
		 *  color: <THREE.Color>,
		 *  opacity: <float>
		 * }
		 */
	
		function ShadowMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'ShadowMaterial';
	
			this.color = new Color( 0x000000 );
			this.opacity = 1.0;
	
			this.lights = true;
			this.transparent = true;
	
			this.setValues( parameters );
	
		}
	
		ShadowMaterial.prototype = Object.create( Material.prototype );
		ShadowMaterial.prototype.constructor = ShadowMaterial;
	
		ShadowMaterial.prototype.isShadowMaterial = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function RawShaderMaterial( parameters ) {
	
			ShaderMaterial.call( this, parameters );
	
			this.type = 'RawShaderMaterial';
	
		}
	
		RawShaderMaterial.prototype = Object.create( ShaderMaterial.prototype );
		RawShaderMaterial.prototype.constructor = RawShaderMaterial;
	
		RawShaderMaterial.prototype.isRawShaderMaterial = true;
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  roughness: <float>,
		 *  metalness: <float>,
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  emissive: <hex>,
		 *  emissiveIntensity: <float>
		 *  emissiveMap: new THREE.Texture( <Image> ),
		 *
		 *  bumpMap: new THREE.Texture( <Image> ),
		 *  bumpScale: <float>,
		 *
		 *  normalMap: new THREE.Texture( <Image> ),
		 *  normalScale: <Vector2>,
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  roughnessMap: new THREE.Texture( <Image> ),
		 *
		 *  metalnessMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
		 *  envMapIntensity: <float>
		 *
		 *  refractionRatio: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshStandardMaterial( parameters ) {
	
			Material.call( this );
	
			this.defines = { 'STANDARD': '' };
	
			this.type = 'MeshStandardMaterial';
	
			this.color = new Color( 0xffffff ); // diffuse
			this.roughness = 0.5;
			this.metalness = 0.5;
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.emissive = new Color( 0x000000 );
			this.emissiveIntensity = 1.0;
			this.emissiveMap = null;
	
			this.bumpMap = null;
			this.bumpScale = 1;
	
			this.normalMap = null;
			this.normalScale = new Vector2( 1, 1 );
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.roughnessMap = null;
	
			this.metalnessMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.envMapIntensity = 1.0;
	
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshStandardMaterial.prototype = Object.create( Material.prototype );
		MeshStandardMaterial.prototype.constructor = MeshStandardMaterial;
	
		MeshStandardMaterial.prototype.isMeshStandardMaterial = true;
	
		MeshStandardMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.defines = { 'STANDARD': '' };
	
			this.color.copy( source.color );
			this.roughness = source.roughness;
			this.metalness = source.metalness;
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.emissive.copy( source.emissive );
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;
	
			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;
	
			this.normalMap = source.normalMap;
			this.normalScale.copy( source.normalScale );
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.roughnessMap = source.roughnessMap;
	
			this.metalnessMap = source.metalnessMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.envMapIntensity = source.envMapIntensity;
	
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *  reflectivity: <float>
		 * }
		 */
	
		function MeshPhysicalMaterial( parameters ) {
	
			MeshStandardMaterial.call( this );
	
			this.defines = { 'PHYSICAL': '' };
	
			this.type = 'MeshPhysicalMaterial';
	
			this.reflectivity = 0.5; // maps to F0 = 0.04
	
			this.clearCoat = 0.0;
			this.clearCoatRoughness = 0.0;
	
			this.setValues( parameters );
	
		}
	
		MeshPhysicalMaterial.prototype = Object.create( MeshStandardMaterial.prototype );
		MeshPhysicalMaterial.prototype.constructor = MeshPhysicalMaterial;
	
		MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;
	
		MeshPhysicalMaterial.prototype.copy = function ( source ) {
	
			MeshStandardMaterial.prototype.copy.call( this, source );
	
			this.defines = { 'PHYSICAL': '' };
	
			this.reflectivity = source.reflectivity;
	
			this.clearCoat = source.clearCoat;
			this.clearCoatRoughness = source.clearCoatRoughness;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  specular: <hex>,
		 *  shininess: <float>,
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  emissive: <hex>,
		 *  emissiveIntensity: <float>
		 *  emissiveMap: new THREE.Texture( <Image> ),
		 *
		 *  bumpMap: new THREE.Texture( <Image> ),
		 *  bumpScale: <float>,
		 *
		 *  normalMap: new THREE.Texture( <Image> ),
		 *  normalScale: <Vector2>,
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  specularMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
		 *  combine: THREE.Multiply,
		 *  reflectivity: <float>,
		 *  refractionRatio: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshPhongMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshPhongMaterial';
	
			this.color = new Color( 0xffffff ); // diffuse
			this.specular = new Color( 0x111111 );
			this.shininess = 30;
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.emissive = new Color( 0x000000 );
			this.emissiveIntensity = 1.0;
			this.emissiveMap = null;
	
			this.bumpMap = null;
			this.bumpScale = 1;
	
			this.normalMap = null;
			this.normalScale = new Vector2( 1, 1 );
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.specularMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.combine = MultiplyOperation;
			this.reflectivity = 1;
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshPhongMaterial.prototype = Object.create( Material.prototype );
		MeshPhongMaterial.prototype.constructor = MeshPhongMaterial;
	
		MeshPhongMaterial.prototype.isMeshPhongMaterial = true;
	
		MeshPhongMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
			this.specular.copy( source.specular );
			this.shininess = source.shininess;
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.emissive.copy( source.emissive );
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;
	
			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;
	
			this.normalMap = source.normalMap;
			this.normalScale.copy( source.normalScale );
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.specularMap = source.specularMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author takahirox / http://github.com/takahirox
		 *
		 * parameters = {
		 *  gradientMap: new THREE.Texture( <Image> )
		 * }
		 */
	
		function MeshToonMaterial( parameters ) {
	
			MeshPhongMaterial.call( this );
	
			this.defines = { 'TOON': '' };
	
			this.type = 'MeshToonMaterial';
	
			this.gradientMap = null;
	
			this.setValues( parameters );
	
		}
	
		MeshToonMaterial.prototype = Object.create( MeshPhongMaterial.prototype );
		MeshToonMaterial.prototype.constructor = MeshToonMaterial;
	
		MeshToonMaterial.prototype.isMeshToonMaterial = true;
	
		MeshToonMaterial.prototype.copy = function ( source ) {
	
			MeshPhongMaterial.prototype.copy.call( this, source );
	
			this.gradientMap = source.gradientMap;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *  opacity: <float>,
		 *
		 *  bumpMap: new THREE.Texture( <Image> ),
		 *  bumpScale: <float>,
		 *
		 *  normalMap: new THREE.Texture( <Image> ),
		 *  normalScale: <Vector2>,
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshNormalMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshNormalMaterial';
	
			this.bumpMap = null;
			this.bumpScale = 1;
	
			this.normalMap = null;
			this.normalScale = new Vector2( 1, 1 );
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
	
			this.fog = false;
			this.lights = false;
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshNormalMaterial.prototype = Object.create( Material.prototype );
		MeshNormalMaterial.prototype.constructor = MeshNormalMaterial;
	
		MeshNormalMaterial.prototype.isMeshNormalMaterial = true;
	
		MeshNormalMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;
	
			this.normalMap = source.normalMap;
			this.normalScale.copy( source.normalScale );
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  emissive: <hex>,
		 *  emissiveIntensity: <float>
		 *  emissiveMap: new THREE.Texture( <Image> ),
		 *
		 *  specularMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
		 *  combine: THREE.Multiply,
		 *  reflectivity: <float>,
		 *  refractionRatio: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshLambertMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshLambertMaterial';
	
			this.color = new Color( 0xffffff ); // diffuse
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.emissive = new Color( 0x000000 );
			this.emissiveIntensity = 1.0;
			this.emissiveMap = null;
	
			this.specularMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.combine = MultiplyOperation;
			this.reflectivity = 1;
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshLambertMaterial.prototype = Object.create( Material.prototype );
		MeshLambertMaterial.prototype.constructor = MeshLambertMaterial;
	
		MeshLambertMaterial.prototype.isMeshLambertMaterial = true;
	
		MeshLambertMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.emissive.copy( source.emissive );
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;
	
			this.specularMap = source.specularMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *
		 *  linewidth: <float>,
		 *
		 *  scale: <float>,
		 *  dashSize: <float>,
		 *  gapSize: <float>
		 * }
		 */
	
		function LineDashedMaterial( parameters ) {
	
			LineBasicMaterial.call( this );
	
			this.type = 'LineDashedMaterial';
	
			this.scale = 1;
			this.dashSize = 3;
			this.gapSize = 1;
	
			this.setValues( parameters );
	
		}
	
		LineDashedMaterial.prototype = Object.create( LineBasicMaterial.prototype );
		LineDashedMaterial.prototype.constructor = LineDashedMaterial;
	
		LineDashedMaterial.prototype.isLineDashedMaterial = true;
	
		LineDashedMaterial.prototype.copy = function ( source ) {
	
			LineBasicMaterial.prototype.copy.call( this, source );
	
			this.scale = source.scale;
			this.dashSize = source.dashSize;
			this.gapSize = source.gapSize;
	
			return this;
	
		};
	
	
	
		var Materials = Object.freeze({
			ShadowMaterial: ShadowMaterial,
			SpriteMaterial: SpriteMaterial,
			RawShaderMaterial: RawShaderMaterial,
			ShaderMaterial: ShaderMaterial,
			PointsMaterial: PointsMaterial,
			MeshPhysicalMaterial: MeshPhysicalMaterial,
			MeshStandardMaterial: MeshStandardMaterial,
			MeshPhongMaterial: MeshPhongMaterial,
			MeshToonMaterial: MeshToonMaterial,
			MeshNormalMaterial: MeshNormalMaterial,
			MeshLambertMaterial: MeshLambertMaterial,
			MeshDepthMaterial: MeshDepthMaterial,
			MeshDistanceMaterial: MeshDistanceMaterial,
			MeshBasicMaterial: MeshBasicMaterial,
			LineDashedMaterial: LineDashedMaterial,
			LineBasicMaterial: LineBasicMaterial,
			Material: Material
		});
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var Cache = {
	
			enabled: false,
	
			files: {},
	
			add: function ( key, file ) {
	
				if ( this.enabled === false ) return;
	
				// console.log( 'THREE.Cache', 'Adding key:', key );
	
				this.files[ key ] = file;
	
			},
	
			get: function ( key ) {
	
				if ( this.enabled === false ) return;
	
				// console.log( 'THREE.Cache', 'Checking key:', key );
	
				return this.files[ key ];
	
			},
	
			remove: function ( key ) {
	
				delete this.files[ key ];
	
			},
	
			clear: function () {
	
				this.files = {};
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LoadingManager( onLoad, onProgress, onError ) {
	
			var scope = this;
	
			var isLoading = false, itemsLoaded = 0, itemsTotal = 0;
	
			this.onStart = undefined;
			this.onLoad = onLoad;
			this.onProgress = onProgress;
			this.onError = onError;
	
			this.itemStart = function ( url ) {
	
				itemsTotal ++;
	
				if ( isLoading === false ) {
	
					if ( scope.onStart !== undefined ) {
	
						scope.onStart( url, itemsLoaded, itemsTotal );
	
					}
	
				}
	
				isLoading = true;
	
			};
	
			this.itemEnd = function ( url ) {
	
				itemsLoaded ++;
	
				if ( scope.onProgress !== undefined ) {
	
					scope.onProgress( url, itemsLoaded, itemsTotal );
	
				}
	
				if ( itemsLoaded === itemsTotal ) {
	
					isLoading = false;
	
					if ( scope.onLoad !== undefined ) {
	
						scope.onLoad();
	
					}
	
				}
	
			};
	
			this.itemError = function ( url ) {
	
				if ( scope.onError !== undefined ) {
	
					scope.onError( url );
	
				}
	
			};
	
		}
	
		var DefaultLoadingManager = new LoadingManager();
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function FileLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( FileLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				if ( url === undefined ) url = '';
	
				if ( this.path !== undefined ) url = this.path + url;
	
				var scope = this;
	
				var cached = Cache.get( url );
	
				if ( cached !== undefined ) {
	
					scope.manager.itemStart( url );
	
					setTimeout( function () {
	
						if ( onLoad ) onLoad( cached );
	
						scope.manager.itemEnd( url );
	
					}, 0 );
	
					return cached;
	
				}
	
				// Check for data: URI
				var dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
				var dataUriRegexResult = url.match( dataUriRegex );
	
				// Safari can not handle Data URIs through XMLHttpRequest so process manually
				if ( dataUriRegexResult ) {
	
					var mimeType = dataUriRegexResult[ 1 ];
					var isBase64 = !! dataUriRegexResult[ 2 ];
					var data = dataUriRegexResult[ 3 ];
	
					data = window.decodeURIComponent( data );
	
					if ( isBase64 ) data = window.atob( data );
	
					try {
	
						var response;
						var responseType = ( this.responseType || '' ).toLowerCase();
	
						switch ( responseType ) {
	
							case 'arraybuffer':
							case 'blob':
	
							 	response = new ArrayBuffer( data.length );
	
								var view = new Uint8Array( response );
	
								for ( var i = 0; i < data.length; i ++ ) {
	
									view[ i ] = data.charCodeAt( i );
	
								}
	
								if ( responseType === 'blob' ) {
	
									response = new Blob( [ response ], { type: mimeType } );
	
								}
	
								break;
	
							case 'document':
	
								var parser = new DOMParser();
								response = parser.parseFromString( data, mimeType );
	
								break;
	
							case 'json':
	
								response = JSON.parse( data );
	
								break;
	
							default: // 'text' or other
	
								response = data;
	
								break;
	
						}
	
						// Wait for next browser tick
						window.setTimeout( function () {
	
							if ( onLoad ) onLoad( response );
	
							scope.manager.itemEnd( url );
	
						}, 0 );
	
					} catch ( error ) {
	
						// Wait for next browser tick
						window.setTimeout( function () {
	
							if ( onError ) onError( error );
	
							scope.manager.itemEnd( url );
							scope.manager.itemError( url );
	
						}, 0 );
	
					}
	
				} else {
	
					var request = new XMLHttpRequest();
					request.open( 'GET', url, true );
	
					request.addEventListener( 'load', function ( event ) {
	
						var response = event.target.response;
	
						Cache.add( url, response );
	
						if ( this.status === 200 ) {
	
							if ( onLoad ) onLoad( response );
	
							scope.manager.itemEnd( url );
	
						} else if ( this.status === 0 ) {
	
							// Some browsers return HTTP Status 0 when using non-http protocol
							// e.g. 'file://' or 'data://'. Handle as success.
	
							console.warn( 'THREE.FileLoader: HTTP Status 0 received.' );
	
							if ( onLoad ) onLoad( response );
	
							scope.manager.itemEnd( url );
	
						} else {
	
							if ( onError ) onError( event );
	
							scope.manager.itemEnd( url );
							scope.manager.itemError( url );
	
						}
	
					}, false );
	
					if ( onProgress !== undefined ) {
	
						request.addEventListener( 'progress', function ( event ) {
	
							onProgress( event );
	
						}, false );
	
					}
	
					request.addEventListener( 'error', function ( event ) {
	
						if ( onError ) onError( event );
	
						scope.manager.itemEnd( url );
						scope.manager.itemError( url );
	
					}, false );
	
					if ( this.responseType !== undefined ) request.responseType = this.responseType;
					if ( this.withCredentials !== undefined ) request.withCredentials = this.withCredentials;
	
					if ( request.overrideMimeType ) request.overrideMimeType( this.mimeType !== undefined ? this.mimeType : 'text/plain' );
	
					for ( var header in this.requestHeader ) {
	
						request.setRequestHeader( header, this.requestHeader[ header ] );
	
					}
	
					request.send( null );
	
				}
	
				scope.manager.itemStart( url );
	
				return request;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			},
	
			setResponseType: function ( value ) {
	
				this.responseType = value;
				return this;
	
			},
	
			setWithCredentials: function ( value ) {
	
				this.withCredentials = value;
				return this;
	
			},
	
			setMimeType: function ( value ) {
	
				this.mimeType = value;
				return this;
	
			},
	
			setRequestHeader: function ( value ) {
	
				this.requestHeader = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 *
		 * Abstract Base class to block based textures loader (dds, pvr, ...)
		 */
	
		function CompressedTextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
			// override in sub classes
			this._parser = null;
	
		}
	
		Object.assign( CompressedTextureLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var images = [];
	
				var texture = new CompressedTexture();
				texture.image = images;
	
				var loader = new FileLoader( this.manager );
				loader.setPath( this.path );
				loader.setResponseType( 'arraybuffer' );
	
				function loadTexture( i ) {
	
					loader.load( url[ i ], function ( buffer ) {
	
						var texDatas = scope._parser( buffer, true );
	
						images[ i ] = {
							width: texDatas.width,
							height: texDatas.height,
							format: texDatas.format,
							mipmaps: texDatas.mipmaps
						};
	
						loaded += 1;
	
						if ( loaded === 6 ) {
	
							if ( texDatas.mipmapCount === 1 )
								texture.minFilter = LinearFilter;
	
							texture.format = texDatas.format;
							texture.needsUpdate = true;
	
							if ( onLoad ) onLoad( texture );
	
						}
	
					}, onProgress, onError );
	
				}
	
				if ( Array.isArray( url ) ) {
	
					var loaded = 0;
	
					for ( var i = 0, il = url.length; i < il; ++ i ) {
	
						loadTexture( i );
	
					}
	
				} else {
	
					// compressed cubemap texture stored in a single DDS file
	
					loader.load( url, function ( buffer ) {
	
						var texDatas = scope._parser( buffer, true );
	
						if ( texDatas.isCubemap ) {
	
							var faces = texDatas.mipmaps.length / texDatas.mipmapCount;
	
							for ( var f = 0; f < faces; f ++ ) {
	
								images[ f ] = { mipmaps : [] };
	
								for ( var i = 0; i < texDatas.mipmapCount; i ++ ) {
	
									images[ f ].mipmaps.push( texDatas.mipmaps[ f * texDatas.mipmapCount + i ] );
									images[ f ].format = texDatas.format;
									images[ f ].width = texDatas.width;
									images[ f ].height = texDatas.height;
	
								}
	
							}
	
						} else {
	
							texture.image.width = texDatas.width;
							texture.image.height = texDatas.height;
							texture.mipmaps = texDatas.mipmaps;
	
						}
	
						if ( texDatas.mipmapCount === 1 ) {
	
							texture.minFilter = LinearFilter;
	
						}
	
						texture.format = texDatas.format;
						texture.needsUpdate = true;
	
						if ( onLoad ) onLoad( texture );
	
					}, onProgress, onError );
	
				}
	
				return texture;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author Nikos M. / https://github.com/foo123/
		 *
		 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
		 */
	
		function DataTextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
			// override in sub classes
			this._parser = null;
	
		}
	
		Object.assign( DataTextureLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var texture = new DataTexture();
	
				var loader = new FileLoader( this.manager );
				loader.setResponseType( 'arraybuffer' );
	
				loader.load( url, function ( buffer ) {
	
					var texData = scope._parser( buffer );
	
					if ( ! texData ) return;
	
					if ( undefined !== texData.image ) {
	
						texture.image = texData.image;
	
					} else if ( undefined !== texData.data ) {
	
						texture.image.width = texData.width;
						texture.image.height = texData.height;
						texture.image.data = texData.data;
	
					}
	
					texture.wrapS = undefined !== texData.wrapS ? texData.wrapS : ClampToEdgeWrapping;
					texture.wrapT = undefined !== texData.wrapT ? texData.wrapT : ClampToEdgeWrapping;
	
					texture.magFilter = undefined !== texData.magFilter ? texData.magFilter : LinearFilter;
					texture.minFilter = undefined !== texData.minFilter ? texData.minFilter : LinearMipMapLinearFilter;
	
					texture.anisotropy = undefined !== texData.anisotropy ? texData.anisotropy : 1;
	
					if ( undefined !== texData.format ) {
	
						texture.format = texData.format;
	
					}
					if ( undefined !== texData.type ) {
	
						texture.type = texData.type;
	
					}
	
					if ( undefined !== texData.mipmaps ) {
	
						texture.mipmaps = texData.mipmaps;
	
					}
	
					if ( 1 === texData.mipmapCount ) {
	
						texture.minFilter = LinearFilter;
	
					}
	
					texture.needsUpdate = true;
	
					if ( onLoad ) onLoad( texture, texData );
	
				}, onProgress, onError );
	
	
				return texture;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function ImageLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( ImageLoader.prototype, {
	
			crossOrigin: 'Anonymous',
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				if ( url === undefined ) url = '';
	
				if ( this.path !== undefined ) url = this.path + url;
	
				var scope = this;
	
				var cached = Cache.get( url );
	
				if ( cached !== undefined ) {
	
					scope.manager.itemStart( url );
	
					setTimeout( function () {
	
						if ( onLoad ) onLoad( cached );
	
						scope.manager.itemEnd( url );
	
					}, 0 );
	
					return cached;
	
				}
	
				var image = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'img' );
	
				image.addEventListener( 'load', function () {
	
					Cache.add( url, this );
	
					if ( onLoad ) onLoad( this );
	
					scope.manager.itemEnd( url );
	
				}, false );
	
				/*
				image.addEventListener( 'progress', function ( event ) {
	
					if ( onProgress ) onProgress( event );
	
				}, false );
				*/
	
				image.addEventListener( 'error', function ( event ) {
	
					if ( onError ) onError( event );
	
					scope.manager.itemEnd( url );
					scope.manager.itemError( url );
	
				}, false );
	
				if ( url.substr( 0, 5 ) !== 'data:' ) {
	
					if ( this.crossOrigin !== undefined ) image.crossOrigin = this.crossOrigin;
	
				}
	
				scope.manager.itemStart( url );
	
				image.src = url;
	
				return image;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
				return this;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function CubeTextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( CubeTextureLoader.prototype, {
	
			crossOrigin: 'Anonymous',
	
			load: function ( urls, onLoad, onProgress, onError ) {
	
				var texture = new CubeTexture();
	
				var loader = new ImageLoader( this.manager );
				loader.setCrossOrigin( this.crossOrigin );
				loader.setPath( this.path );
	
				var loaded = 0;
	
				function loadTexture( i ) {
	
					loader.load( urls[ i ], function ( image ) {
	
						texture.images[ i ] = image;
	
						loaded ++;
	
						if ( loaded === 6 ) {
	
							texture.needsUpdate = true;
	
							if ( onLoad ) onLoad( texture );
	
						}
	
					}, undefined, onError );
	
				}
	
				for ( var i = 0; i < urls.length; ++ i ) {
	
					loadTexture( i );
	
				}
	
				return texture;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
				return this;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function TextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( TextureLoader.prototype, {
	
			crossOrigin: 'Anonymous',
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var loader = new ImageLoader( this.manager );
				loader.setCrossOrigin( this.crossOrigin );
				loader.setPath( this.path );
	
				var texture = new Texture();
				texture.image = loader.load( url, function () {
	
					// JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
					var isJPEG = url.search( /\.(jpg|jpeg)$/ ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;
	
					texture.format = isJPEG ? RGBFormat : RGBAFormat;
					texture.needsUpdate = true;
	
					if ( onLoad !== undefined ) {
	
						onLoad( texture );
	
					}
	
				}, onProgress, onError );
	
				return texture;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
				return this;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Light( color, intensity ) {
	
			Object3D.call( this );
	
			this.type = 'Light';
	
			this.color = new Color( color );
			this.intensity = intensity !== undefined ? intensity : 1;
	
			this.receiveShadow = undefined;
	
		}
	
		Light.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Light,
	
			isLight: true,
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source );
	
				this.color.copy( source.color );
				this.intensity = source.intensity;
	
				return this;
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.color = this.color.getHex();
				data.object.intensity = this.intensity;
	
				if ( this.groundColor !== undefined ) data.object.groundColor = this.groundColor.getHex();
	
				if ( this.distance !== undefined ) data.object.distance = this.distance;
				if ( this.angle !== undefined ) data.object.angle = this.angle;
				if ( this.decay !== undefined ) data.object.decay = this.decay;
				if ( this.penumbra !== undefined ) data.object.penumbra = this.penumbra;
	
				if ( this.shadow !== undefined ) data.object.shadow = this.shadow.toJSON();
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function HemisphereLight( skyColor, groundColor, intensity ) {
	
			Light.call( this, skyColor, intensity );
	
			this.type = 'HemisphereLight';
	
			this.castShadow = undefined;
	
			this.position.copy( Object3D.DefaultUp );
			this.updateMatrix();
	
			this.groundColor = new Color( groundColor );
	
		}
	
		HemisphereLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: HemisphereLight,
	
			isHemisphereLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.groundColor.copy( source.groundColor );
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LightShadow( camera ) {
	
			this.camera = camera;
	
			this.bias = 0;
			this.radius = 1;
	
			this.mapSize = new Vector2( 512, 512 );
	
			this.map = null;
			this.matrix = new Matrix4();
	
		}
	
		Object.assign( LightShadow.prototype, {
	
			copy: function ( source ) {
	
				this.camera = source.camera.clone();
	
				this.bias = source.bias;
				this.radius = source.radius;
	
				this.mapSize.copy( source.mapSize );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			toJSON: function () {
	
				var object = {};
	
				if ( this.bias !== 0 ) object.bias = this.bias;
				if ( this.radius !== 1 ) object.radius = this.radius;
				if ( this.mapSize.x !== 512 || this.mapSize.y !== 512 ) object.mapSize = this.mapSize.toArray();
	
				object.camera = this.camera.toJSON( false ).object;
				delete object.camera.matrix;
	
				return object;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function SpotLightShadow() {
	
			LightShadow.call( this, new PerspectiveCamera( 50, 1, 0.5, 500 ) );
	
		}
	
		SpotLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {
	
			constructor: SpotLightShadow,
	
			isSpotLightShadow: true,
	
			update: function ( light ) {
	
				var camera = this.camera;
	
				var fov = _Math.RAD2DEG * 2 * light.angle;
				var aspect = this.mapSize.width / this.mapSize.height;
				var far = light.distance || camera.far;
	
				if ( fov !== camera.fov || aspect !== camera.aspect || far !== camera.far ) {
	
					camera.fov = fov;
					camera.aspect = aspect;
					camera.far = far;
					camera.updateProjectionMatrix();
	
				}
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function SpotLight( color, intensity, distance, angle, penumbra, decay ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'SpotLight';
	
			this.position.copy( Object3D.DefaultUp );
			this.updateMatrix();
	
			this.target = new Object3D();
	
			Object.defineProperty( this, 'power', {
				get: function () {
					// intensity = power per solid angle.
					// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					return this.intensity * Math.PI;
				},
				set: function ( power ) {
					// intensity = power per solid angle.
					// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					this.intensity = power / Math.PI;
				}
			} );
	
			this.distance = ( distance !== undefined ) ? distance : 0;
			this.angle = ( angle !== undefined ) ? angle : Math.PI / 3;
			this.penumbra = ( penumbra !== undefined ) ? penumbra : 0;
			this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.
	
			this.shadow = new SpotLightShadow();
	
		}
	
		SpotLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: SpotLight,
	
			isSpotLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.distance = source.distance;
				this.angle = source.angle;
				this.penumbra = source.penumbra;
				this.decay = source.decay;
	
				this.target = source.target.clone();
	
				this.shadow = source.shadow.clone();
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
	
		function PointLight( color, intensity, distance, decay ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'PointLight';
	
			Object.defineProperty( this, 'power', {
				get: function () {
					// intensity = power per solid angle.
					// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					return this.intensity * 4 * Math.PI;
	
				},
				set: function ( power ) {
					// intensity = power per solid angle.
					// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					this.intensity = power / ( 4 * Math.PI );
				}
			} );
	
			this.distance = ( distance !== undefined ) ? distance : 0;
			this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.
	
			this.shadow = new LightShadow( new PerspectiveCamera( 90, 1, 0.5, 500 ) );
	
		}
	
		PointLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: PointLight,
	
			isPointLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.distance = source.distance;
				this.decay = source.decay;
	
				this.shadow = source.shadow.clone();
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function DirectionalLightShadow( ) {
	
			LightShadow.call( this, new OrthographicCamera( - 5, 5, 5, - 5, 0.5, 500 ) );
	
		}
	
		DirectionalLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {
	
			constructor: DirectionalLightShadow
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function DirectionalLight( color, intensity ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'DirectionalLight';
	
			this.position.copy( Object3D.DefaultUp );
			this.updateMatrix();
	
			this.target = new Object3D();
	
			this.shadow = new DirectionalLightShadow();
	
		}
	
		DirectionalLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: DirectionalLight,
	
			isDirectionalLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.target = source.target.clone();
	
				this.shadow = source.shadow.clone();
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AmbientLight( color, intensity ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'AmbientLight';
	
			this.castShadow = undefined;
	
		}
	
		AmbientLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: AmbientLight,
	
			isAmbientLight: true
	
		} );
	
		/**
		 * @author abelnation / http://github.com/abelnation
		 */
	
		function RectAreaLight( color, intensity, width, height ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'RectAreaLight';
	
			this.position.set( 0, 1, 0 );
			this.updateMatrix();
	
			this.width = ( width !== undefined ) ? width : 10;
			this.height = ( height !== undefined ) ? height : 10;
	
			// TODO (abelnation): distance/decay
	
			// TODO (abelnation): update method for RectAreaLight to update transform to lookat target
	
			// TODO (abelnation): shadows
	
		}
	
		// TODO (abelnation): RectAreaLight update when light shape is changed
		RectAreaLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: RectAreaLight,
	
			isRectAreaLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.width = source.width;
				this.height = source.height;
	
				return this;
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Light.prototype.toJSON.call( this, meta );
	
				data.object.width = this.width;
				data.object.height = this.height;
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author tschw
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 */
	
		var AnimationUtils = {
	
			// same as Array.prototype.slice, but also works on typed arrays
			arraySlice: function ( array, from, to ) {
	
				if ( AnimationUtils.isTypedArray( array ) ) {
	
					// in ios9 array.subarray(from, undefined) will return empty array
					// but array.subarray(from) or array.subarray(from, len) is correct
					return new array.constructor( array.subarray( from, to !== undefined ? to : array.length ) );
	
				}
	
				return array.slice( from, to );
	
			},
	
			// converts an array to a specific type
			convertArray: function ( array, type, forceClone ) {
	
				if ( ! array || // let 'undefined' and 'null' pass
						! forceClone && array.constructor === type ) return array;
	
				if ( typeof type.BYTES_PER_ELEMENT === 'number' ) {
	
					return new type( array ); // create typed array
	
				}
	
				return Array.prototype.slice.call( array ); // create Array
	
			},
	
			isTypedArray: function ( object ) {
	
				return ArrayBuffer.isView( object ) &&
						! ( object instanceof DataView );
	
			},
	
			// returns an array by which times and values can be sorted
			getKeyframeOrder: function ( times ) {
	
				function compareTime( i, j ) {
	
					return times[ i ] - times[ j ];
	
				}
	
				var n = times.length;
				var result = new Array( n );
				for ( var i = 0; i !== n; ++ i ) result[ i ] = i;
	
				result.sort( compareTime );
	
				return result;
	
			},
	
			// uses the array previously returned by 'getKeyframeOrder' to sort data
			sortedArray: function ( values, stride, order ) {
	
				var nValues = values.length;
				var result = new values.constructor( nValues );
	
				for ( var i = 0, dstOffset = 0; dstOffset !== nValues; ++ i ) {
	
					var srcOffset = order[ i ] * stride;
	
					for ( var j = 0; j !== stride; ++ j ) {
	
						result[ dstOffset ++ ] = values[ srcOffset + j ];
	
					}
	
				}
	
				return result;
	
			},
	
			// function for parsing AOS keyframe formats
			flattenJSON: function ( jsonKeys, times, values, valuePropertyName ) {
	
				var i = 1, key = jsonKeys[ 0 ];
	
				while ( key !== undefined && key[ valuePropertyName ] === undefined ) {
	
					key = jsonKeys[ i ++ ];
	
				}
	
				if ( key === undefined ) return; // no data
	
				var value = key[ valuePropertyName ];
				if ( value === undefined ) return; // no data
	
				if ( Array.isArray( value ) ) {
	
					do {
	
						value = key[ valuePropertyName ];
	
						if ( value !== undefined ) {
	
							times.push( key.time );
							values.push.apply( values, value ); // push all elements
	
						}
	
						key = jsonKeys[ i ++ ];
	
					} while ( key !== undefined );
	
				} else if ( value.toArray !== undefined ) {
	
					// ...assume THREE.Math-ish
	
					do {
	
						value = key[ valuePropertyName ];
	
						if ( value !== undefined ) {
	
							times.push( key.time );
							value.toArray( values, values.length );
	
						}
	
						key = jsonKeys[ i ++ ];
	
					} while ( key !== undefined );
	
				} else {
	
					// otherwise push as-is
	
					do {
	
						value = key[ valuePropertyName ];
	
						if ( value !== undefined ) {
	
							times.push( key.time );
							values.push( value );
	
						}
	
						key = jsonKeys[ i ++ ];
	
					} while ( key !== undefined );
	
				}
	
			}
	
		};
	
		/**
		 * Abstract base class of interpolants over parametric samples.
		 *
		 * The parameter domain is one dimensional, typically the time or a path
		 * along a curve defined by the data.
		 *
		 * The sample values can have any dimensionality and derived classes may
		 * apply special interpretations to the data.
		 *
		 * This class provides the interval seek in a Template Method, deferring
		 * the actual interpolation to derived classes.
		 *
		 * Time complexity is O(1) for linear access crossing at most two points
		 * and O(log N) for random access, where N is the number of positions.
		 *
		 * References:
		 *
		 * 		http://www.oodesign.com/template-method-pattern.html
		 *
		 * @author tschw
		 */
	
		function Interpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			this.parameterPositions = parameterPositions;
			this._cachedIndex = 0;
	
			this.resultBuffer = resultBuffer !== undefined ?
					resultBuffer : new sampleValues.constructor( sampleSize );
			this.sampleValues = sampleValues;
			this.valueSize = sampleSize;
	
		}
	
		Object.assign( Interpolant.prototype, {
	
			evaluate: function( t ) {
	
				var pp = this.parameterPositions,
					i1 = this._cachedIndex,
	
					t1 = pp[   i1   ],
					t0 = pp[ i1 - 1 ];
	
				validate_interval: {
	
					seek: {
	
						var right;
	
						linear_scan: {
							//- See http://jsperf.com/comparison-to-undefined/3
							//- slower code:
							//-
							//- 				if ( t >= t1 || t1 === undefined ) {
							forward_scan: if ( ! ( t < t1 ) ) {
	
								for ( var giveUpAt = i1 + 2; ;) {
	
									if ( t1 === undefined ) {
	
										if ( t < t0 ) break forward_scan;
	
										// after end
	
										i1 = pp.length;
										this._cachedIndex = i1;
										return this.afterEnd_( i1 - 1, t, t0 );
	
									}
	
									if ( i1 === giveUpAt ) break; // this loop
	
									t0 = t1;
									t1 = pp[ ++ i1 ];
	
									if ( t < t1 ) {
	
										// we have arrived at the sought interval
										break seek;
	
									}
	
								}
	
								// prepare binary search on the right side of the index
								right = pp.length;
								break linear_scan;
	
							}
	
							//- slower code:
							//-					if ( t < t0 || t0 === undefined ) {
							if ( ! ( t >= t0 ) ) {
	
								// looping?
	
								var t1global = pp[ 1 ];
	
								if ( t < t1global ) {
	
									i1 = 2; // + 1, using the scan for the details
									t0 = t1global;
	
								}
	
								// linear reverse scan
	
								for ( var giveUpAt = i1 - 2; ;) {
	
									if ( t0 === undefined ) {
	
										// before start
	
										this._cachedIndex = 0;
										return this.beforeStart_( 0, t, t1 );
	
									}
	
									if ( i1 === giveUpAt ) break; // this loop
	
									t1 = t0;
									t0 = pp[ -- i1 - 1 ];
	
									if ( t >= t0 ) {
	
										// we have arrived at the sought interval
										break seek;
	
									}
	
								}
	
								// prepare binary search on the left side of the index
								right = i1;
								i1 = 0;
								break linear_scan;
	
							}
	
							// the interval is valid
	
							break validate_interval;
	
						} // linear scan
	
						// binary search
	
						while ( i1 < right ) {
	
							var mid = ( i1 + right ) >>> 1;
	
							if ( t < pp[ mid ] ) {
	
								right = mid;
	
							} else {
	
								i1 = mid + 1;
	
							}
	
						}
	
						t1 = pp[   i1   ];
						t0 = pp[ i1 - 1 ];
	
						// check boundary cases, again
	
						if ( t0 === undefined ) {
	
							this._cachedIndex = 0;
							return this.beforeStart_( 0, t, t1 );
	
						}
	
						if ( t1 === undefined ) {
	
							i1 = pp.length;
							this._cachedIndex = i1;
							return this.afterEnd_( i1 - 1, t0, t );
	
						}
	
					} // seek
	
					this._cachedIndex = i1;
	
					this.intervalChanged_( i1, t0, t1 );
	
				} // validate_interval
	
				return this.interpolate_( i1, t0, t, t1 );
	
			},
	
			settings: null, // optional, subclass-specific settings structure
			// Note: The indirection allows central control of many interpolants.
	
			// --- Protected interface
	
			DefaultSettings_: {},
	
			getSettings_: function() {
	
				return this.settings || this.DefaultSettings_;
	
			},
	
			copySampleValue_: function( index ) {
	
				// copies a sample value to the result buffer
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
					offset = index * stride;
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					result[ i ] = values[ offset + i ];
	
				}
	
				return result;
	
			},
	
			// Template methods for derived classes:
	
			interpolate_: function( i1, t0, t, t1 ) {
	
				throw new Error( "call to abstract method" );
				// implementations shall return this.resultBuffer
	
			},
	
			intervalChanged_: function( i1, t0, t1 ) {
	
				// empty
	
			}
	
		} );
	
		//!\ DECLARE ALIAS AFTER assign prototype !
		Object.assign( Interpolant.prototype, {
	
			//( 0, t, t0 ), returns this.resultBuffer
			beforeStart_: Interpolant.prototype.copySampleValue_,
	
			//( N-1, tN-1, t ), returns this.resultBuffer
			afterEnd_: Interpolant.prototype.copySampleValue_,
	
		} );
	
		/**
		 * Fast and simple cubic spline interpolant.
		 *
		 * It was derived from a Hermitian construction setting the first derivative
		 * at each sample position to the linear slope between neighboring positions
		 * over their parameter interval.
		 *
		 * @author tschw
		 */
	
		function CubicInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call(
					this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
			this._weightPrev = -0;
			this._offsetPrev = -0;
			this._weightNext = -0;
			this._offsetNext = -0;
	
		}
	
		CubicInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: CubicInterpolant,
	
			DefaultSettings_: {
	
				endingStart: 	ZeroCurvatureEnding,
				endingEnd:		ZeroCurvatureEnding
	
			},
	
			intervalChanged_: function( i1, t0, t1 ) {
	
				var pp = this.parameterPositions,
					iPrev = i1 - 2,
					iNext = i1 + 1,
	
					tPrev = pp[ iPrev ],
					tNext = pp[ iNext ];
	
				if ( tPrev === undefined ) {
	
					switch ( this.getSettings_().endingStart ) {
	
						case ZeroSlopeEnding:
	
							// f'(t0) = 0
							iPrev = i1;
							tPrev = 2 * t0 - t1;
	
							break;
	
						case WrapAroundEnding:
	
							// use the other end of the curve
							iPrev = pp.length - 2;
							tPrev = t0 + pp[ iPrev ] - pp[ iPrev + 1 ];
	
							break;
	
						default: // ZeroCurvatureEnding
	
							// f''(t0) = 0 a.k.a. Natural Spline
							iPrev = i1;
							tPrev = t1;
	
					}
	
				}
	
				if ( tNext === undefined ) {
	
					switch ( this.getSettings_().endingEnd ) {
	
						case ZeroSlopeEnding:
	
							// f'(tN) = 0
							iNext = i1;
							tNext = 2 * t1 - t0;
	
							break;
	
						case WrapAroundEnding:
	
							// use the other end of the curve
							iNext = 1;
							tNext = t1 + pp[ 1 ] - pp[ 0 ];
	
							break;
	
						default: // ZeroCurvatureEnding
	
							// f''(tN) = 0, a.k.a. Natural Spline
							iNext = i1 - 1;
							tNext = t0;
	
					}
	
				}
	
				var halfDt = ( t1 - t0 ) * 0.5,
					stride = this.valueSize;
	
				this._weightPrev = halfDt / ( t0 - tPrev );
				this._weightNext = halfDt / ( tNext - t1 );
				this._offsetPrev = iPrev * stride;
				this._offsetNext = iNext * stride;
	
			},
	
			interpolate_: function( i1, t0, t, t1 ) {
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
	
					o1 = i1 * stride,		o0 = o1 - stride,
					oP = this._offsetPrev, 	oN = this._offsetNext,
					wP = this._weightPrev,	wN = this._weightNext,
	
					p = ( t - t0 ) / ( t1 - t0 ),
					pp = p * p,
					ppp = pp * p;
	
				// evaluate polynomials
	
				var sP =     - wP   * ppp   +         2 * wP    * pp    -          wP   * p;
				var s0 = ( 1 + wP ) * ppp   + (-1.5 - 2 * wP )  * pp    + ( -0.5 + wP ) * p     + 1;
				var s1 = (-1 - wN ) * ppp   + ( 1.5 +   wN   )  * pp    +    0.5        * p;
				var sN =       wN   * ppp   -           wN      * pp;
	
				// combine data linearly
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					result[ i ] =
							sP * values[ oP + i ] +
							s0 * values[ o0 + i ] +
							s1 * values[ o1 + i ] +
							sN * values[ oN + i ];
	
				}
	
				return result;
	
			}
	
		} );
	
		/**
		 * @author tschw
		 */
	
		function LinearInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
		}
	
		LinearInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: LinearInterpolant,
	
			interpolate_: function( i1, t0, t, t1 ) {
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
	
					offset1 = i1 * stride,
					offset0 = offset1 - stride,
	
					weight1 = ( t - t0 ) / ( t1 - t0 ),
					weight0 = 1 - weight1;
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					result[ i ] =
							values[ offset0 + i ] * weight0 +
							values[ offset1 + i ] * weight1;
	
				}
	
				return result;
	
			}
	
		} );
	
		/**
		 *
		 * Interpolant that evaluates to the sample value at the position preceeding
		 * the parameter.
		 *
		 * @author tschw
		 */
	
		function DiscreteInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
		}
	
		DiscreteInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: DiscreteInterpolant,
	
			interpolate_: function( i1, t0, t, t1 ) {
	
				return this.copySampleValue_( i1 - 1 );
	
			}
	
		} );
	
		var KeyframeTrackPrototype;
	
		KeyframeTrackPrototype = {
	
			TimeBufferType: Float32Array,
			ValueBufferType: Float32Array,
	
			DefaultInterpolation: InterpolateLinear,
	
			InterpolantFactoryMethodDiscrete: function ( result ) {
	
				return new DiscreteInterpolant(
						this.times, this.values, this.getValueSize(), result );
	
			},
	
			InterpolantFactoryMethodLinear: function ( result ) {
	
				return new LinearInterpolant(
						this.times, this.values, this.getValueSize(), result );
	
			},
	
			InterpolantFactoryMethodSmooth: function ( result ) {
	
				return new CubicInterpolant(
						this.times, this.values, this.getValueSize(), result );
	
			},
	
			setInterpolation: function ( interpolation ) {
	
				var factoryMethod;
	
				switch ( interpolation ) {
	
					case InterpolateDiscrete:
	
						factoryMethod = this.InterpolantFactoryMethodDiscrete;
	
						break;
	
					case InterpolateLinear:
	
						factoryMethod = this.InterpolantFactoryMethodLinear;
	
						break;
	
					case InterpolateSmooth:
	
						factoryMethod = this.InterpolantFactoryMethodSmooth;
	
						break;
	
				}
	
				if ( factoryMethod === undefined ) {
	
					var message = "unsupported interpolation for " +
							this.ValueTypeName + " keyframe track named " + this.name;
	
					if ( this.createInterpolant === undefined ) {
	
						// fall back to default, unless the default itself is messed up
						if ( interpolation !== this.DefaultInterpolation ) {
	
							this.setInterpolation( this.DefaultInterpolation );
	
						} else {
	
							throw new Error( message ); // fatal, in this case
	
						}
	
					}
	
					console.warn( 'THREE.KeyframeTrackPrototype:', message );
					return;
	
				}
	
				this.createInterpolant = factoryMethod;
	
			},
	
			getInterpolation: function () {
	
				switch ( this.createInterpolant ) {
	
					case this.InterpolantFactoryMethodDiscrete:
	
						return InterpolateDiscrete;
	
					case this.InterpolantFactoryMethodLinear:
	
						return InterpolateLinear;
	
					case this.InterpolantFactoryMethodSmooth:
	
						return InterpolateSmooth;
	
				}
	
			},
	
			getValueSize: function () {
	
				return this.values.length / this.times.length;
	
			},
	
			// move all keyframes either forwards or backwards in time
			shift: function ( timeOffset ) {
	
				if ( timeOffset !== 0.0 ) {
	
					var times = this.times;
	
					for ( var i = 0, n = times.length; i !== n; ++ i ) {
	
						times[ i ] += timeOffset;
	
					}
	
				}
	
				return this;
	
			},
	
			// scale all keyframe times by a factor (useful for frame <-> seconds conversions)
			scale: function ( timeScale ) {
	
				if ( timeScale !== 1.0 ) {
	
					var times = this.times;
	
					for ( var i = 0, n = times.length; i !== n; ++ i ) {
	
						times[ i ] *= timeScale;
	
					}
	
				}
	
				return this;
	
			},
	
			// removes keyframes before and after animation without changing any values within the range [startTime, endTime].
			// IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
			trim: function ( startTime, endTime ) {
	
				var times = this.times,
					nKeys = times.length,
					from = 0,
					to = nKeys - 1;
	
				while ( from !== nKeys && times[ from ] < startTime ) ++ from;
				while ( to !== - 1 && times[ to ] > endTime ) -- to;
	
				++ to; // inclusive -> exclusive bound
	
				if ( from !== 0 || to !== nKeys ) {
	
					// empty tracks are forbidden, so keep at least one keyframe
					if ( from >= to ) to = Math.max( to, 1 ), from = to - 1;
	
					var stride = this.getValueSize();
					this.times = AnimationUtils.arraySlice( times, from, to );
					this.values = AnimationUtils.
							arraySlice( this.values, from * stride, to * stride );
	
				}
	
				return this;
	
			},
	
			// ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
			validate: function () {
	
				var valid = true;
	
				var valueSize = this.getValueSize();
				if ( valueSize - Math.floor( valueSize ) !== 0 ) {
	
					console.error( 'THREE.KeyframeTrackPrototype: Invalid value size in track.', this );
					valid = false;
	
				}
	
				var times = this.times,
					values = this.values,
	
					nKeys = times.length;
	
				if ( nKeys === 0 ) {
	
					console.error( 'THREE.KeyframeTrackPrototype: Track is empty.', this );
					valid = false;
	
				}
	
				var prevTime = null;
	
				for ( var i = 0; i !== nKeys; i ++ ) {
	
					var currTime = times[ i ];
	
					if ( typeof currTime === 'number' && isNaN( currTime ) ) {
	
						console.error( 'THREE.KeyframeTrackPrototype: Time is not a valid number.', this, i, currTime );
						valid = false;
						break;
	
					}
	
					if ( prevTime !== null && prevTime > currTime ) {
	
						console.error( 'THREE.KeyframeTrackPrototype: Out of order keys.', this, i, currTime, prevTime );
						valid = false;
						break;
	
					}
	
					prevTime = currTime;
	
				}
	
				if ( values !== undefined ) {
	
					if ( AnimationUtils.isTypedArray( values ) ) {
	
						for ( var i = 0, n = values.length; i !== n; ++ i ) {
	
							var value = values[ i ];
	
							if ( isNaN( value ) ) {
	
								console.error( 'THREE.KeyframeTrackPrototype: Value is not a valid number.', this, i, value );
								valid = false;
								break;
	
							}
	
						}
	
					}
	
				}
	
				return valid;
	
			},
	
			// removes equivalent sequential keys as common in morph target sequences
			// (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
			optimize: function () {
	
				var times = this.times,
					values = this.values,
					stride = this.getValueSize(),
	
					smoothInterpolation = this.getInterpolation() === InterpolateSmooth,
	
					writeIndex = 1,
					lastIndex = times.length - 1;
	
				for ( var i = 1; i < lastIndex; ++ i ) {
	
					var keep = false;
	
					var time = times[ i ];
					var timeNext = times[ i + 1 ];
	
					// remove adjacent keyframes scheduled at the same time
	
					if ( time !== timeNext && ( i !== 1 || time !== time[ 0 ] ) ) {
	
						if ( ! smoothInterpolation ) {
	
							// remove unnecessary keyframes same as their neighbors
	
							var offset = i * stride,
								offsetP = offset - stride,
								offsetN = offset + stride;
	
							for ( var j = 0; j !== stride; ++ j ) {
	
								var value = values[ offset + j ];
	
								if ( value !== values[ offsetP + j ] ||
										value !== values[ offsetN + j ] ) {
	
									keep = true;
									break;
	
								}
	
							}
	
						} else keep = true;
	
					}
	
					// in-place compaction
	
					if ( keep ) {
	
						if ( i !== writeIndex ) {
	
							times[ writeIndex ] = times[ i ];
	
							var readOffset = i * stride,
								writeOffset = writeIndex * stride;
	
							for ( var j = 0; j !== stride; ++ j )
	
								values[ writeOffset + j ] = values[ readOffset + j ];
	
						}
	
						++ writeIndex;
	
					}
	
				}
	
				// flush last keyframe (compaction looks ahead)
	
				if ( lastIndex > 0 ) {
	
					times[ writeIndex ] = times[ lastIndex ];
	
					for ( var readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++ j )
	
						values[ writeOffset + j ] = values[ readOffset + j ];
	
					++ writeIndex;
	
				}
	
				if ( writeIndex !== times.length ) {
	
					this.times = AnimationUtils.arraySlice( times, 0, writeIndex );
					this.values = AnimationUtils.arraySlice( values, 0, writeIndex * stride );
	
				}
	
				return this;
	
			}
	
		};
	
		function KeyframeTrackConstructor( name, times, values, interpolation ) {
	
			if ( name === undefined ) throw new Error( "track name is undefined" );
	
			if ( times === undefined || times.length === 0 ) {
	
				throw new Error( "no keyframes in track named " + name );
	
			}
	
			this.name = name;
	
			this.times = AnimationUtils.convertArray( times, this.TimeBufferType );
			this.values = AnimationUtils.convertArray( values, this.ValueBufferType );
	
			this.setInterpolation( interpolation || this.DefaultInterpolation );
	
			this.validate();
			this.optimize();
	
		}
	
		/**
		 *
		 * A Track of vectored keyframe values.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function VectorKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.call( this, name, times, values, interpolation );
	
		}
	
		VectorKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: VectorKeyframeTrack,
	
			ValueTypeName: 'vector'
	
			// ValueBufferType is inherited
	
			// DefaultInterpolation is inherited
	
		} );
	
		/**
		 * Spherical linear unit quaternion interpolant.
		 *
		 * @author tschw
		 */
	
		function QuaternionLinearInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
		}
	
		QuaternionLinearInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: QuaternionLinearInterpolant,
	
			interpolate_: function( i1, t0, t, t1 ) {
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
	
					offset = i1 * stride,
	
					alpha = ( t - t0 ) / ( t1 - t0 );
	
				for ( var end = offset + stride; offset !== end; offset += 4 ) {
	
					Quaternion.slerpFlat( result, 0,
							values, offset - stride, values, offset, alpha );
	
				}
	
				return result;
	
			}
	
		} );
	
		/**
		 *
		 * A Track of quaternion keyframe values.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function QuaternionKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.call( this, name, times, values, interpolation );
	
		}
	
		QuaternionKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: QuaternionKeyframeTrack,
	
			ValueTypeName: 'quaternion',
	
			// ValueBufferType is inherited
	
			DefaultInterpolation: InterpolateLinear,
	
			InterpolantFactoryMethodLinear: function( result ) {
	
				return new QuaternionLinearInterpolant(
						this.times, this.values, this.getValueSize(), result );
	
			},
	
			InterpolantFactoryMethodSmooth: undefined // not yet implemented
	
		} );
	
		/**
		 *
		 * A Track of numeric keyframe values.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function NumberKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.call( this, name, times, values, interpolation );
	
		}
	
		NumberKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: NumberKeyframeTrack,
	
			ValueTypeName: 'number'
	
			// ValueBufferType is inherited
	
			// DefaultInterpolation is inherited
	
		} );
	
		/**
		 *
		 * A Track that interpolates Strings
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function StringKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.call( this, name, times, values, interpolation );
	
		}
	
		StringKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: StringKeyframeTrack,
	
			ValueTypeName: 'string',
			ValueBufferType: Array,
	
			DefaultInterpolation: InterpolateDiscrete,
	
			InterpolantFactoryMethodLinear: undefined,
	
			InterpolantFactoryMethodSmooth: undefined
	
		} );
	
		/**
		 *
		 * A Track of Boolean keyframe values.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function BooleanKeyframeTrack( name, times, values ) {
	
			KeyframeTrackConstructor.call( this, name, times, values );
	
		}
	
		BooleanKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: BooleanKeyframeTrack,
	
			ValueTypeName: 'bool',
			ValueBufferType: Array,
	
			DefaultInterpolation: InterpolateDiscrete,
	
			InterpolantFactoryMethodLinear: undefined,
			InterpolantFactoryMethodSmooth: undefined
	
			// Note: Actually this track could have a optimized / compressed
			// representation of a single value and a custom interpolant that
			// computes "firstValue ^ isOdd( index )".
	
		} );
	
		/**
		 *
		 * A Track of keyframe values that represent color.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function ColorKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.call( this, name, times, values, interpolation );
	
		}
	
		ColorKeyframeTrack.prototype =
				Object.assign( Object.create( KeyframeTrackPrototype ), {
	
			constructor: ColorKeyframeTrack,
	
			ValueTypeName: 'color'
	
			// ValueBufferType is inherited
	
			// DefaultInterpolation is inherited
	
	
			// Note: Very basic implementation and nothing special yet.
			// However, this is the place for color space parameterization.
	
		} );
	
		/**
		 *
		 * A timed sequence of keyframes for a specific property.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function KeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrackConstructor.apply( this, arguments );
	
		}
	
		KeyframeTrack.prototype = KeyframeTrackPrototype;
		KeyframeTrackPrototype.constructor = KeyframeTrack;
	
		// Static methods:
	
		Object.assign( KeyframeTrack, {
	
			// Serialization (in static context, because of constructor invocation
			// and automatic invocation of .toJSON):
	
			parse: function( json ) {
	
				if( json.type === undefined ) {
	
					throw new Error( "track type undefined, can not parse" );
	
				}
	
				var trackType = KeyframeTrack._getTrackTypeForValueTypeName( json.type );
	
				if ( json.times === undefined ) {
	
					var times = [], values = [];
	
					AnimationUtils.flattenJSON( json.keys, times, values, 'value' );
	
					json.times = times;
					json.values = values;
	
				}
	
				// derived classes can define a static parse method
				if ( trackType.parse !== undefined ) {
	
					return trackType.parse( json );
	
				} else {
	
					// by default, we assume a constructor compatible with the base
					return new trackType(
							json.name, json.times, json.values, json.interpolation );
	
				}
	
			},
	
			toJSON: function( track ) {
	
				var trackType = track.constructor;
	
				var json;
	
				// derived classes can define a static toJSON method
				if ( trackType.toJSON !== undefined ) {
	
					json = trackType.toJSON( track );
	
				} else {
	
					// by default, we assume the data can be serialized as-is
					json = {
	
						'name': track.name,
						'times': AnimationUtils.convertArray( track.times, Array ),
						'values': AnimationUtils.convertArray( track.values, Array )
	
					};
	
					var interpolation = track.getInterpolation();
	
					if ( interpolation !== track.DefaultInterpolation ) {
	
						json.interpolation = interpolation;
	
					}
	
				}
	
				json.type = track.ValueTypeName; // mandatory
	
				return json;
	
			},
	
			_getTrackTypeForValueTypeName: function( typeName ) {
	
				switch( typeName.toLowerCase() ) {
	
					case "scalar":
					case "double":
					case "float":
					case "number":
					case "integer":
	
						return NumberKeyframeTrack;
	
					case "vector":
					case "vector2":
					case "vector3":
					case "vector4":
	
						return VectorKeyframeTrack;
	
					case "color":
	
						return ColorKeyframeTrack;
	
					case "quaternion":
	
						return QuaternionKeyframeTrack;
	
					case "bool":
					case "boolean":
	
						return BooleanKeyframeTrack;
	
					case "string":
	
						return StringKeyframeTrack;
	
				}
	
				throw new Error( "Unsupported typeName: " + typeName );
	
			}
	
		} );
	
		/**
		 *
		 * Reusable set of Tracks that represent an animation.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 */
	
		function AnimationClip( name, duration, tracks ) {
	
			this.name = name;
			this.tracks = tracks;
			this.duration = ( duration !== undefined ) ? duration : - 1;
	
			this.uuid = _Math.generateUUID();
	
			// this means it should figure out its duration by scanning the tracks
			if ( this.duration < 0 ) {
	
				this.resetDuration();
	
			}
	
			this.optimize();
	
		}
	
		Object.assign( AnimationClip, {
	
			parse: function ( json ) {
	
				var tracks = [],
					jsonTracks = json.tracks,
					frameTime = 1.0 / ( json.fps || 1.0 );
	
				for ( var i = 0, n = jsonTracks.length; i !== n; ++ i ) {
	
					tracks.push( KeyframeTrack.parse( jsonTracks[ i ] ).scale( frameTime ) );
	
				}
	
				return new AnimationClip( json.name, json.duration, tracks );
	
			},
	
			toJSON: function ( clip ) {
	
				var tracks = [],
					clipTracks = clip.tracks;
	
				var json = {
	
					'name': clip.name,
					'duration': clip.duration,
					'tracks': tracks
	
				};
	
				for ( var i = 0, n = clipTracks.length; i !== n; ++ i ) {
	
					tracks.push( KeyframeTrack.toJSON( clipTracks[ i ] ) );
	
				}
	
				return json;
	
			},
	
			CreateFromMorphTargetSequence: function ( name, morphTargetSequence, fps, noLoop ) {
	
				var numMorphTargets = morphTargetSequence.length;
				var tracks = [];
	
				for ( var i = 0; i < numMorphTargets; i ++ ) {
	
					var times = [];
					var values = [];
	
					times.push(
							( i + numMorphTargets - 1 ) % numMorphTargets,
							i,
							( i + 1 ) % numMorphTargets );
	
					values.push( 0, 1, 0 );
	
					var order = AnimationUtils.getKeyframeOrder( times );
					times = AnimationUtils.sortedArray( times, 1, order );
					values = AnimationUtils.sortedArray( values, 1, order );
	
					// if there is a key at the first frame, duplicate it as the
					// last frame as well for perfect loop.
					if ( ! noLoop && times[ 0 ] === 0 ) {
	
						times.push( numMorphTargets );
						values.push( values[ 0 ] );
	
					}
	
					tracks.push(
							new NumberKeyframeTrack(
								'.morphTargetInfluences[' + morphTargetSequence[ i ].name + ']',
								times, values
							).scale( 1.0 / fps ) );
	
				}
	
				return new AnimationClip( name, - 1, tracks );
	
			},
	
			findByName: function ( objectOrClipArray, name ) {
	
				var clipArray = objectOrClipArray;
	
				if ( ! Array.isArray( objectOrClipArray ) ) {
	
					var o = objectOrClipArray;
					clipArray = o.geometry && o.geometry.animations || o.animations;
	
				}
	
				for ( var i = 0; i < clipArray.length; i ++ ) {
	
					if ( clipArray[ i ].name === name ) {
	
						return clipArray[ i ];
	
					}
	
				}
	
				return null;
	
			},
	
			CreateClipsFromMorphTargetSequences: function ( morphTargets, fps, noLoop ) {
	
				var animationToMorphTargets = {};
	
				// tested with https://regex101.com/ on trick sequences
				// such flamingo_flyA_003, flamingo_run1_003, crdeath0059
				var pattern = /^([\w-]*?)([\d]+)$/;
	
				// sort morph target names into animation groups based
				// patterns like Walk_001, Walk_002, Run_001, Run_002
				for ( var i = 0, il = morphTargets.length; i < il; i ++ ) {
	
					var morphTarget = morphTargets[ i ];
					var parts = morphTarget.name.match( pattern );
	
					if ( parts && parts.length > 1 ) {
	
						var name = parts[ 1 ];
	
						var animationMorphTargets = animationToMorphTargets[ name ];
						if ( ! animationMorphTargets ) {
	
							animationToMorphTargets[ name ] = animationMorphTargets = [];
	
						}
	
						animationMorphTargets.push( morphTarget );
	
					}
	
				}
	
				var clips = [];
	
				for ( var name in animationToMorphTargets ) {
	
					clips.push( AnimationClip.CreateFromMorphTargetSequence( name, animationToMorphTargets[ name ], fps, noLoop ) );
	
				}
	
				return clips;
	
			},
	
			// parse the animation.hierarchy format
			parseAnimation: function ( animation, bones ) {
	
				if ( ! animation ) {
	
					console.error( 'THREE.AnimationClip: No animation in JSONLoader data.' );
					return null;
	
				}
	
				var addNonemptyTrack = function ( trackType, trackName, animationKeys, propertyName, destTracks ) {
	
					// only return track if there are actually keys.
					if ( animationKeys.length !== 0 ) {
	
						var times = [];
						var values = [];
	
						AnimationUtils.flattenJSON( animationKeys, times, values, propertyName );
	
						// empty keys are filtered out, so check again
						if ( times.length !== 0 ) {
	
							destTracks.push( new trackType( trackName, times, values ) );
	
						}
	
					}
	
				};
	
				var tracks = [];
	
				var clipName = animation.name || 'default';
				// automatic length determination in AnimationClip.
				var duration = animation.length || - 1;
				var fps = animation.fps || 30;
	
				var hierarchyTracks = animation.hierarchy || [];
	
				for ( var h = 0; h < hierarchyTracks.length; h ++ ) {
	
					var animationKeys = hierarchyTracks[ h ].keys;
	
					// skip empty tracks
					if ( ! animationKeys || animationKeys.length === 0 ) continue;
	
					// process morph targets
					if ( animationKeys[ 0 ].morphTargets ) {
	
						// figure out all morph targets used in this track
						var morphTargetNames = {};
	
						for ( var k = 0; k < animationKeys.length; k ++ ) {
	
							if ( animationKeys[ k ].morphTargets ) {
	
								for ( var m = 0; m < animationKeys[ k ].morphTargets.length; m ++ ) {
	
									morphTargetNames[ animationKeys[ k ].morphTargets[ m ] ] = - 1;
	
								}
	
							}
	
						}
	
						// create a track for each morph target with all zero
						// morphTargetInfluences except for the keys in which
						// the morphTarget is named.
						for ( var morphTargetName in morphTargetNames ) {
	
							var times = [];
							var values = [];
	
							for ( var m = 0; m !== animationKeys[ k ].morphTargets.length; ++ m ) {
	
								var animationKey = animationKeys[ k ];
	
								times.push( animationKey.time );
								values.push( ( animationKey.morphTarget === morphTargetName ) ? 1 : 0 );
	
							}
	
							tracks.push( new NumberKeyframeTrack( '.morphTargetInfluence[' + morphTargetName + ']', times, values ) );
	
						}
	
						duration = morphTargetNames.length * ( fps || 1.0 );
	
					} else {
	
						// ...assume skeletal animation
	
						var boneName = '.bones[' + bones[ h ].name + ']';
	
						addNonemptyTrack(
								VectorKeyframeTrack, boneName + '.position',
								animationKeys, 'pos', tracks );
	
						addNonemptyTrack(
								QuaternionKeyframeTrack, boneName + '.quaternion',
								animationKeys, 'rot', tracks );
	
						addNonemptyTrack(
								VectorKeyframeTrack, boneName + '.scale',
								animationKeys, 'scl', tracks );
	
					}
	
				}
	
				if ( tracks.length === 0 ) {
	
					return null;
	
				}
	
				var clip = new AnimationClip( clipName, duration, tracks );
	
				return clip;
	
			}
	
		} );
	
		Object.assign( AnimationClip.prototype, {
	
			resetDuration: function () {
	
				var tracks = this.tracks, duration = 0;
	
				for ( var i = 0, n = tracks.length; i !== n; ++ i ) {
	
					var track = this.tracks[ i ];
	
					duration = Math.max( duration, track.times[ track.times.length - 1 ] );
	
				}
	
				this.duration = duration;
	
			},
	
			trim: function () {
	
				for ( var i = 0; i < this.tracks.length; i ++ ) {
	
					this.tracks[ i ].trim( 0, this.duration );
	
				}
	
				return this;
	
			},
	
			optimize: function () {
	
				for ( var i = 0; i < this.tracks.length; i ++ ) {
	
					this.tracks[ i ].optimize();
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function MaterialLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
			this.textures = {};
	
		}
	
		Object.assign( MaterialLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var loader = new FileLoader( scope.manager );
				loader.load( url, function ( text ) {
	
					onLoad( scope.parse( JSON.parse( text ) ) );
	
				}, onProgress, onError );
	
			},
	
			setTextures: function ( value ) {
	
				this.textures = value;
	
			},
	
			parse: function ( json ) {
	
				var textures = this.textures;
	
				function getTexture( name ) {
	
					if ( textures[ name ] === undefined ) {
	
						console.warn( 'THREE.MaterialLoader: Undefined texture', name );
	
					}
	
					return textures[ name ];
	
				}
	
				var material = new Materials[ json.type ]();
	
				if ( json.uuid !== undefined ) material.uuid = json.uuid;
				if ( json.name !== undefined ) material.name = json.name;
				if ( json.color !== undefined ) material.color.setHex( json.color );
				if ( json.roughness !== undefined ) material.roughness = json.roughness;
				if ( json.metalness !== undefined ) material.metalness = json.metalness;
				if ( json.emissive !== undefined ) material.emissive.setHex( json.emissive );
				if ( json.specular !== undefined ) material.specular.setHex( json.specular );
				if ( json.shininess !== undefined ) material.shininess = json.shininess;
				if ( json.clearCoat !== undefined ) material.clearCoat = json.clearCoat;
				if ( json.clearCoatRoughness !== undefined ) material.clearCoatRoughness = json.clearCoatRoughness;
				if ( json.uniforms !== undefined ) material.uniforms = json.uniforms;
				if ( json.vertexShader !== undefined ) material.vertexShader = json.vertexShader;
				if ( json.fragmentShader !== undefined ) material.fragmentShader = json.fragmentShader;
				if ( json.vertexColors !== undefined ) material.vertexColors = json.vertexColors;
				if ( json.fog !== undefined ) material.fog = json.fog;
				if ( json.flatShading !== undefined ) material.flatShading = json.flatShading;
				if ( json.blending !== undefined ) material.blending = json.blending;
				if ( json.side !== undefined ) material.side = json.side;
				if ( json.opacity !== undefined ) material.opacity = json.opacity;
				if ( json.transparent !== undefined ) material.transparent = json.transparent;
				if ( json.alphaTest !== undefined ) material.alphaTest = json.alphaTest;
				if ( json.depthTest !== undefined ) material.depthTest = json.depthTest;
				if ( json.depthWrite !== undefined ) material.depthWrite = json.depthWrite;
				if ( json.colorWrite !== undefined ) material.colorWrite = json.colorWrite;
				if ( json.wireframe !== undefined ) material.wireframe = json.wireframe;
				if ( json.wireframeLinewidth !== undefined ) material.wireframeLinewidth = json.wireframeLinewidth;
				if ( json.wireframeLinecap !== undefined ) material.wireframeLinecap = json.wireframeLinecap;
				if ( json.wireframeLinejoin !== undefined ) material.wireframeLinejoin = json.wireframeLinejoin;
	
				if ( json.skinning !== undefined ) material.skinning = json.skinning;
				if ( json.morphTargets !== undefined ) material.morphTargets = json.morphTargets;
				if ( json.dithering !== undefined ) material.dithering = json.dithering;
	
				if ( json.visible !== undefined ) material.visible = json.visible;
				if ( json.userData !== undefined ) material.userData = json.userData;
	
				// Deprecated
	
				if ( json.shading !== undefined ) material.flatShading = json.shading === 1; // THREE.FlatShading
	
				// for PointsMaterial
	
				if ( json.size !== undefined ) material.size = json.size;
				if ( json.sizeAttenuation !== undefined ) material.sizeAttenuation = json.sizeAttenuation;
	
				// maps
	
				if ( json.map !== undefined ) material.map = getTexture( json.map );
	
				if ( json.alphaMap !== undefined ) {
	
					material.alphaMap = getTexture( json.alphaMap );
					material.transparent = true;
	
				}
	
				if ( json.bumpMap !== undefined ) material.bumpMap = getTexture( json.bumpMap );
				if ( json.bumpScale !== undefined ) material.bumpScale = json.bumpScale;
	
				if ( json.normalMap !== undefined ) material.normalMap = getTexture( json.normalMap );
				if ( json.normalScale !== undefined ) {
	
					var normalScale = json.normalScale;
	
					if ( Array.isArray( normalScale ) === false ) {
	
						// Blender exporter used to export a scalar. See #7459
	
						normalScale = [ normalScale, normalScale ];
	
					}
	
					material.normalScale = new Vector2().fromArray( normalScale );
	
				}
	
				if ( json.displacementMap !== undefined ) material.displacementMap = getTexture( json.displacementMap );
				if ( json.displacementScale !== undefined ) material.displacementScale = json.displacementScale;
				if ( json.displacementBias !== undefined ) material.displacementBias = json.displacementBias;
	
				if ( json.roughnessMap !== undefined ) material.roughnessMap = getTexture( json.roughnessMap );
				if ( json.metalnessMap !== undefined ) material.metalnessMap = getTexture( json.metalnessMap );
	
				if ( json.emissiveMap !== undefined ) material.emissiveMap = getTexture( json.emissiveMap );
				if ( json.emissiveIntensity !== undefined ) material.emissiveIntensity = json.emissiveIntensity;
	
				if ( json.specularMap !== undefined ) material.specularMap = getTexture( json.specularMap );
	
				if ( json.envMap !== undefined ) material.envMap = getTexture( json.envMap );
	
				if ( json.reflectivity !== undefined ) material.reflectivity = json.reflectivity;
	
				if ( json.lightMap !== undefined ) material.lightMap = getTexture( json.lightMap );
				if ( json.lightMapIntensity !== undefined ) material.lightMapIntensity = json.lightMapIntensity;
	
				if ( json.aoMap !== undefined ) material.aoMap = getTexture( json.aoMap );
				if ( json.aoMapIntensity !== undefined ) material.aoMapIntensity = json.aoMapIntensity;
	
				if ( json.gradientMap !== undefined ) material.gradientMap = getTexture( json.gradientMap );
	
				return material;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function BufferGeometryLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( BufferGeometryLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var loader = new FileLoader( scope.manager );
				loader.load( url, function ( text ) {
	
					onLoad( scope.parse( JSON.parse( text ) ) );
	
				}, onProgress, onError );
	
			},
	
			parse: function ( json ) {
	
				var geometry = new BufferGeometry();
	
				var index = json.data.index;
	
				if ( index !== undefined ) {
	
					var typedArray = new TYPED_ARRAYS[ index.type ]( index.array );
					geometry.setIndex( new BufferAttribute( typedArray, 1 ) );
	
				}
	
				var attributes = json.data.attributes;
	
				for ( var key in attributes ) {
	
					var attribute = attributes[ key ];
					var typedArray = new TYPED_ARRAYS[ attribute.type ]( attribute.array );
	
					geometry.addAttribute( key, new BufferAttribute( typedArray, attribute.itemSize, attribute.normalized ) );
	
				}
	
				var groups = json.data.groups || json.data.drawcalls || json.data.offsets;
	
				if ( groups !== undefined ) {
	
					for ( var i = 0, n = groups.length; i !== n; ++ i ) {
	
						var group = groups[ i ];
	
						geometry.addGroup( group.start, group.count, group.materialIndex );
	
					}
	
				}
	
				var boundingSphere = json.data.boundingSphere;
	
				if ( boundingSphere !== undefined ) {
	
					var center = new Vector3();
	
					if ( boundingSphere.center !== undefined ) {
	
						center.fromArray( boundingSphere.center );
	
					}
	
					geometry.boundingSphere = new Sphere( center, boundingSphere.radius );
	
				}
	
				return geometry;
	
			}
	
		} );
	
		var TYPED_ARRAYS = {
			Int8Array: Int8Array,
			Uint8Array: Uint8Array,
			// Workaround for IE11 pre KB2929437. See #11440
			Uint8ClampedArray: typeof Uint8ClampedArray !== 'undefined' ? Uint8ClampedArray : Uint8Array,
			Int16Array: Int16Array,
			Uint16Array: Uint16Array,
			Int32Array: Int32Array,
			Uint32Array: Uint32Array,
			Float32Array: Float32Array,
			Float64Array: Float64Array
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Loader() {
	
			this.onLoadStart = function () {};
			this.onLoadProgress = function () {};
			this.onLoadComplete = function () {};
	
		}
	
		Loader.Handlers = {
	
			handlers: [],
	
			add: function ( regex, loader ) {
	
				this.handlers.push( regex, loader );
	
			},
	
			get: function ( file ) {
	
				var handlers = this.handlers;
	
				for ( var i = 0, l = handlers.length; i < l; i += 2 ) {
	
					var regex = handlers[ i ];
					var loader = handlers[ i + 1 ];
	
					if ( regex.test( file ) ) {
	
						return loader;
	
					}
	
				}
	
				return null;
	
			}
	
		};
	
		Object.assign( Loader.prototype, {
	
			crossOrigin: undefined,
	
			extractUrlBase: function ( url ) {
	
				var parts = url.split( '/' );
	
				if ( parts.length === 1 ) return './';
	
				parts.pop();
	
				return parts.join( '/' ) + '/';
	
			},
	
			initMaterials: function ( materials, texturePath, crossOrigin ) {
	
				var array = [];
	
				for ( var i = 0; i < materials.length; ++ i ) {
	
					array[ i ] = this.createMaterial( materials[ i ], texturePath, crossOrigin );
	
				}
	
				return array;
	
			},
	
			createMaterial: ( function () {
	
				var BlendingMode = {
					NoBlending: NoBlending,
					NormalBlending: NormalBlending,
					AdditiveBlending: AdditiveBlending,
					SubtractiveBlending: SubtractiveBlending,
					MultiplyBlending: MultiplyBlending,
					CustomBlending: CustomBlending
				};
	
				var color = new Color();
				var textureLoader = new TextureLoader();
				var materialLoader = new MaterialLoader();
	
				return function createMaterial( m, texturePath, crossOrigin ) {
	
					// convert from old material format
	
					var textures = {};
	
					function loadTexture( path, repeat, offset, wrap, anisotropy ) {
	
						var fullPath = texturePath + path;
						var loader = Loader.Handlers.get( fullPath );
	
						var texture;
	
						if ( loader !== null ) {
	
							texture = loader.load( fullPath );
	
						} else {
	
							textureLoader.setCrossOrigin( crossOrigin );
							texture = textureLoader.load( fullPath );
	
						}
	
						if ( repeat !== undefined ) {
	
							texture.repeat.fromArray( repeat );
	
							if ( repeat[ 0 ] !== 1 ) texture.wrapS = RepeatWrapping;
							if ( repeat[ 1 ] !== 1 ) texture.wrapT = RepeatWrapping;
	
						}
	
						if ( offset !== undefined ) {
	
							texture.offset.fromArray( offset );
	
						}
	
						if ( wrap !== undefined ) {
	
							if ( wrap[ 0 ] === 'repeat' ) texture.wrapS = RepeatWrapping;
							if ( wrap[ 0 ] === 'mirror' ) texture.wrapS = MirroredRepeatWrapping;
	
							if ( wrap[ 1 ] === 'repeat' ) texture.wrapT = RepeatWrapping;
							if ( wrap[ 1 ] === 'mirror' ) texture.wrapT = MirroredRepeatWrapping;
	
						}
	
						if ( anisotropy !== undefined ) {
	
							texture.anisotropy = anisotropy;
	
						}
	
						var uuid = _Math.generateUUID();
	
						textures[ uuid ] = texture;
	
						return uuid;
	
					}
	
					//
	
					var json = {
						uuid: _Math.generateUUID(),
						type: 'MeshLambertMaterial'
					};
	
					for ( var name in m ) {
	
						var value = m[ name ];
	
						switch ( name ) {
	
							case 'DbgColor':
							case 'DbgIndex':
							case 'opticalDensity':
							case 'illumination':
								break;
							case 'DbgName':
								json.name = value;
								break;
							case 'blending':
								json.blending = BlendingMode[ value ];
								break;
							case 'colorAmbient':
							case 'mapAmbient':
								console.warn( 'THREE.Loader.createMaterial:', name, 'is no longer supported.' );
								break;
							case 'colorDiffuse':
								json.color = color.fromArray( value ).getHex();
								break;
							case 'colorSpecular':
								json.specular = color.fromArray( value ).getHex();
								break;
							case 'colorEmissive':
								json.emissive = color.fromArray( value ).getHex();
								break;
							case 'specularCoef':
								json.shininess = value;
								break;
							case 'shading':
								if ( value.toLowerCase() === 'basic' ) json.type = 'MeshBasicMaterial';
								if ( value.toLowerCase() === 'phong' ) json.type = 'MeshPhongMaterial';
								if ( value.toLowerCase() === 'standard' ) json.type = 'MeshStandardMaterial';
								break;
							case 'mapDiffuse':
								json.map = loadTexture( value, m.mapDiffuseRepeat, m.mapDiffuseOffset, m.mapDiffuseWrap, m.mapDiffuseAnisotropy );
								break;
							case 'mapDiffuseRepeat':
							case 'mapDiffuseOffset':
							case 'mapDiffuseWrap':
							case 'mapDiffuseAnisotropy':
								break;
							case 'mapEmissive':
								json.emissiveMap = loadTexture( value, m.mapEmissiveRepeat, m.mapEmissiveOffset, m.mapEmissiveWrap, m.mapEmissiveAnisotropy );
								break;
							case 'mapEmissiveRepeat':
							case 'mapEmissiveOffset':
							case 'mapEmissiveWrap':
							case 'mapEmissiveAnisotropy':
								break;
							case 'mapLight':
								json.lightMap = loadTexture( value, m.mapLightRepeat, m.mapLightOffset, m.mapLightWrap, m.mapLightAnisotropy );
								break;
							case 'mapLightRepeat':
							case 'mapLightOffset':
							case 'mapLightWrap':
							case 'mapLightAnisotropy':
								break;
							case 'mapAO':
								json.aoMap = loadTexture( value, m.mapAORepeat, m.mapAOOffset, m.mapAOWrap, m.mapAOAnisotropy );
								break;
							case 'mapAORepeat':
							case 'mapAOOffset':
							case 'mapAOWrap':
							case 'mapAOAnisotropy':
								break;
							case 'mapBump':
								json.bumpMap = loadTexture( value, m.mapBumpRepeat, m.mapBumpOffset, m.mapBumpWrap, m.mapBumpAnisotropy );
								break;
							case 'mapBumpScale':
								json.bumpScale = value;
								break;
							case 'mapBumpRepeat':
							case 'mapBumpOffset':
							case 'mapBumpWrap':
							case 'mapBumpAnisotropy':
								break;
							case 'mapNormal':
								json.normalMap = loadTexture( value, m.mapNormalRepeat, m.mapNormalOffset, m.mapNormalWrap, m.mapNormalAnisotropy );
								break;
							case 'mapNormalFactor':
								json.normalScale = [ value, value ];
								break;
							case 'mapNormalRepeat':
							case 'mapNormalOffset':
							case 'mapNormalWrap':
							case 'mapNormalAnisotropy':
								break;
							case 'mapSpecular':
								json.specularMap = loadTexture( value, m.mapSpecularRepeat, m.mapSpecularOffset, m.mapSpecularWrap, m.mapSpecularAnisotropy );
								break;
							case 'mapSpecularRepeat':
							case 'mapSpecularOffset':
							case 'mapSpecularWrap':
							case 'mapSpecularAnisotropy':
								break;
							case 'mapMetalness':
								json.metalnessMap = loadTexture( value, m.mapMetalnessRepeat, m.mapMetalnessOffset, m.mapMetalnessWrap, m.mapMetalnessAnisotropy );
								break;
							case 'mapMetalnessRepeat':
							case 'mapMetalnessOffset':
							case 'mapMetalnessWrap':
							case 'mapMetalnessAnisotropy':
								break;
							case 'mapRoughness':
								json.roughnessMap = loadTexture( value, m.mapRoughnessRepeat, m.mapRoughnessOffset, m.mapRoughnessWrap, m.mapRoughnessAnisotropy );
								break;
							case 'mapRoughnessRepeat':
							case 'mapRoughnessOffset':
							case 'mapRoughnessWrap':
							case 'mapRoughnessAnisotropy':
								break;
							case 'mapAlpha':
								json.alphaMap = loadTexture( value, m.mapAlphaRepeat, m.mapAlphaOffset, m.mapAlphaWrap, m.mapAlphaAnisotropy );
								break;
							case 'mapAlphaRepeat':
							case 'mapAlphaOffset':
							case 'mapAlphaWrap':
							case 'mapAlphaAnisotropy':
								break;
							case 'flipSided':
								json.side = BackSide;
								break;
							case 'doubleSided':
								json.side = DoubleSide;
								break;
							case 'transparency':
								console.warn( 'THREE.Loader.createMaterial: transparency has been renamed to opacity' );
								json.opacity = value;
								break;
							case 'depthTest':
							case 'depthWrite':
							case 'colorWrite':
							case 'opacity':
							case 'reflectivity':
							case 'transparent':
							case 'visible':
							case 'wireframe':
								json[ name ] = value;
								break;
							case 'vertexColors':
								if ( value === true ) json.vertexColors = VertexColors;
								if ( value === 'face' ) json.vertexColors = FaceColors;
								break;
							default:
								console.error( 'THREE.Loader.createMaterial: Unsupported', name, value );
								break;
	
						}
	
					}
	
					if ( json.type === 'MeshBasicMaterial' ) delete json.emissive;
					if ( json.type !== 'MeshPhongMaterial' ) delete json.specular;
	
					if ( json.opacity < 1 ) json.transparent = true;
	
					materialLoader.setTextures( textures );
	
					return materialLoader.parse( json );
	
				};
	
			} )()
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function JSONLoader( manager ) {
	
			if ( typeof manager === 'boolean' ) {
	
				console.warn( 'THREE.JSONLoader: showStatus parameter has been removed from constructor.' );
				manager = undefined;
	
			}
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
			this.withCredentials = false;
	
		}
	
		Object.assign( JSONLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var texturePath = this.texturePath && ( typeof this.texturePath === "string" ) ? this.texturePath : Loader.prototype.extractUrlBase( url );
	
				var loader = new FileLoader( this.manager );
				loader.setWithCredentials( this.withCredentials );
				loader.load( url, function ( text ) {
	
					var json = JSON.parse( text );
					var metadata = json.metadata;
	
					if ( metadata !== undefined ) {
	
						var type = metadata.type;
	
						if ( type !== undefined ) {
	
							if ( type.toLowerCase() === 'object' ) {
	
								console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.ObjectLoader instead.' );
								return;
	
							}
	
							if ( type.toLowerCase() === 'scene' ) {
	
								console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.SceneLoader instead.' );
								return;
	
							}
	
						}
	
					}
	
					var object = scope.parse( json, texturePath );
					onLoad( object.geometry, object.materials );
	
				}, onProgress, onError );
	
			},
	
			setTexturePath: function ( value ) {
	
				this.texturePath = value;
	
			},
	
			parse: ( function () {
	
				function parseModel( json, geometry ) {
	
					function isBitSet( value, position ) {
	
						return value & ( 1 << position );
	
					}
	
					var i, j, fi,
	
						offset, zLength,
	
						colorIndex, normalIndex, uvIndex, materialIndex,
	
						type,
						isQuad,
						hasMaterial,
						hasFaceVertexUv,
						hasFaceNormal, hasFaceVertexNormal,
						hasFaceColor, hasFaceVertexColor,
	
						vertex, face, faceA, faceB, hex, normal,
	
						uvLayer, uv, u, v,
	
						faces = json.faces,
						vertices = json.vertices,
						normals = json.normals,
						colors = json.colors,
	
						scale = json.scale,
	
						nUvLayers = 0;
	
	
					if ( json.uvs !== undefined ) {
	
						// disregard empty arrays
	
						for ( i = 0; i < json.uvs.length; i ++ ) {
	
							if ( json.uvs[ i ].length ) nUvLayers ++;
	
						}
	
						for ( i = 0; i < nUvLayers; i ++ ) {
	
							geometry.faceVertexUvs[ i ] = [];
	
						}
	
					}
	
					offset = 0;
					zLength = vertices.length;
	
					while ( offset < zLength ) {
	
						vertex = new Vector3();
	
						vertex.x = vertices[ offset ++ ] * scale;
						vertex.y = vertices[ offset ++ ] * scale;
						vertex.z = vertices[ offset ++ ] * scale;
	
						geometry.vertices.push( vertex );
	
					}
	
					offset = 0;
					zLength = faces.length;
	
					while ( offset < zLength ) {
	
						type = faces[ offset ++ ];
	
						isQuad = isBitSet( type, 0 );
						hasMaterial = isBitSet( type, 1 );
						hasFaceVertexUv = isBitSet( type, 3 );
						hasFaceNormal = isBitSet( type, 4 );
						hasFaceVertexNormal = isBitSet( type, 5 );
						hasFaceColor = isBitSet( type, 6 );
						hasFaceVertexColor = isBitSet( type, 7 );
	
						// console.log("type", type, "bits", isQuad, hasMaterial, hasFaceVertexUv, hasFaceNormal, hasFaceVertexNormal, hasFaceColor, hasFaceVertexColor);
	
						if ( isQuad ) {
	
							faceA = new Face3();
							faceA.a = faces[ offset ];
							faceA.b = faces[ offset + 1 ];
							faceA.c = faces[ offset + 3 ];
	
							faceB = new Face3();
							faceB.a = faces[ offset + 1 ];
							faceB.b = faces[ offset + 2 ];
							faceB.c = faces[ offset + 3 ];
	
							offset += 4;
	
							if ( hasMaterial ) {
	
								materialIndex = faces[ offset ++ ];
								faceA.materialIndex = materialIndex;
								faceB.materialIndex = materialIndex;
	
							}
	
							// to get face <=> uv index correspondence
	
							fi = geometry.faces.length;
	
							if ( hasFaceVertexUv ) {
	
								for ( i = 0; i < nUvLayers; i ++ ) {
	
									uvLayer = json.uvs[ i ];
	
									geometry.faceVertexUvs[ i ][ fi ] = [];
									geometry.faceVertexUvs[ i ][ fi + 1 ] = [];
	
									for ( j = 0; j < 4; j ++ ) {
	
										uvIndex = faces[ offset ++ ];
	
										u = uvLayer[ uvIndex * 2 ];
										v = uvLayer[ uvIndex * 2 + 1 ];
	
										uv = new Vector2( u, v );
	
										if ( j !== 2 ) geometry.faceVertexUvs[ i ][ fi ].push( uv );
										if ( j !== 0 ) geometry.faceVertexUvs[ i ][ fi + 1 ].push( uv );
	
									}
	
								}
	
							}
	
							if ( hasFaceNormal ) {
	
								normalIndex = faces[ offset ++ ] * 3;
	
								faceA.normal.set(
									normals[ normalIndex ++ ],
									normals[ normalIndex ++ ],
									normals[ normalIndex ]
								);
	
								faceB.normal.copy( faceA.normal );
	
							}
	
							if ( hasFaceVertexNormal ) {
	
								for ( i = 0; i < 4; i ++ ) {
	
									normalIndex = faces[ offset ++ ] * 3;
	
									normal = new Vector3(
										normals[ normalIndex ++ ],
										normals[ normalIndex ++ ],
										normals[ normalIndex ]
									);
	
	
									if ( i !== 2 ) faceA.vertexNormals.push( normal );
									if ( i !== 0 ) faceB.vertexNormals.push( normal );
	
								}
	
							}
	
	
							if ( hasFaceColor ) {
	
								colorIndex = faces[ offset ++ ];
								hex = colors[ colorIndex ];
	
								faceA.color.setHex( hex );
								faceB.color.setHex( hex );
	
							}
	
	
							if ( hasFaceVertexColor ) {
	
								for ( i = 0; i < 4; i ++ ) {
	
									colorIndex = faces[ offset ++ ];
									hex = colors[ colorIndex ];
	
									if ( i !== 2 ) faceA.vertexColors.push( new Color( hex ) );
									if ( i !== 0 ) faceB.vertexColors.push( new Color( hex ) );
	
								}
	
							}
	
							geometry.faces.push( faceA );
							geometry.faces.push( faceB );
	
						} else {
	
							face = new Face3();
							face.a = faces[ offset ++ ];
							face.b = faces[ offset ++ ];
							face.c = faces[ offset ++ ];
	
							if ( hasMaterial ) {
	
								materialIndex = faces[ offset ++ ];
								face.materialIndex = materialIndex;
	
							}
	
							// to get face <=> uv index correspondence
	
							fi = geometry.faces.length;
	
							if ( hasFaceVertexUv ) {
	
								for ( i = 0; i < nUvLayers; i ++ ) {
	
									uvLayer = json.uvs[ i ];
	
									geometry.faceVertexUvs[ i ][ fi ] = [];
	
									for ( j = 0; j < 3; j ++ ) {
	
										uvIndex = faces[ offset ++ ];
	
										u = uvLayer[ uvIndex * 2 ];
										v = uvLayer[ uvIndex * 2 + 1 ];
	
										uv = new Vector2( u, v );
	
										geometry.faceVertexUvs[ i ][ fi ].push( uv );
	
									}
	
								}
	
							}
	
							if ( hasFaceNormal ) {
	
								normalIndex = faces[ offset ++ ] * 3;
	
								face.normal.set(
									normals[ normalIndex ++ ],
									normals[ normalIndex ++ ],
									normals[ normalIndex ]
								);
	
							}
	
							if ( hasFaceVertexNormal ) {
	
								for ( i = 0; i < 3; i ++ ) {
	
									normalIndex = faces[ offset ++ ] * 3;
	
									normal = new Vector3(
										normals[ normalIndex ++ ],
										normals[ normalIndex ++ ],
										normals[ normalIndex ]
									);
	
									face.vertexNormals.push( normal );
	
								}
	
							}
	
	
							if ( hasFaceColor ) {
	
								colorIndex = faces[ offset ++ ];
								face.color.setHex( colors[ colorIndex ] );
	
							}
	
	
							if ( hasFaceVertexColor ) {
	
								for ( i = 0; i < 3; i ++ ) {
	
									colorIndex = faces[ offset ++ ];
									face.vertexColors.push( new Color( colors[ colorIndex ] ) );
	
								}
	
							}
	
							geometry.faces.push( face );
	
						}
	
					}
	
				}
	
				function parseSkin( json, geometry ) {
	
					var influencesPerVertex = ( json.influencesPerVertex !== undefined ) ? json.influencesPerVertex : 2;
	
					if ( json.skinWeights ) {
	
						for ( var i = 0, l = json.skinWeights.length; i < l; i += influencesPerVertex ) {
	
							var x = json.skinWeights[ i ];
							var y = ( influencesPerVertex > 1 ) ? json.skinWeights[ i + 1 ] : 0;
							var z = ( influencesPerVertex > 2 ) ? json.skinWeights[ i + 2 ] : 0;
							var w = ( influencesPerVertex > 3 ) ? json.skinWeights[ i + 3 ] : 0;
	
							geometry.skinWeights.push( new Vector4( x, y, z, w ) );
	
						}
	
					}
	
					if ( json.skinIndices ) {
	
						for ( var i = 0, l = json.skinIndices.length; i < l; i += influencesPerVertex ) {
	
							var a = json.skinIndices[ i ];
							var b = ( influencesPerVertex > 1 ) ? json.skinIndices[ i + 1 ] : 0;
							var c = ( influencesPerVertex > 2 ) ? json.skinIndices[ i + 2 ] : 0;
							var d = ( influencesPerVertex > 3 ) ? json.skinIndices[ i + 3 ] : 0;
	
							geometry.skinIndices.push( new Vector4( a, b, c, d ) );
	
						}
	
					}
	
					geometry.bones = json.bones;
	
					if ( geometry.bones && geometry.bones.length > 0 && ( geometry.skinWeights.length !== geometry.skinIndices.length || geometry.skinIndices.length !== geometry.vertices.length ) ) {
	
						console.warn( 'When skinning, number of vertices (' + geometry.vertices.length + '), skinIndices (' +
							geometry.skinIndices.length + '), and skinWeights (' + geometry.skinWeights.length + ') should match.' );
	
					}
	
				}
	
				function parseMorphing( json, geometry ) {
	
					var scale = json.scale;
	
					if ( json.morphTargets !== undefined ) {
	
						for ( var i = 0, l = json.morphTargets.length; i < l; i ++ ) {
	
							geometry.morphTargets[ i ] = {};
							geometry.morphTargets[ i ].name = json.morphTargets[ i ].name;
							geometry.morphTargets[ i ].vertices = [];
	
							var dstVertices = geometry.morphTargets[ i ].vertices;
							var srcVertices = json.morphTargets[ i ].vertices;
	
							for ( var v = 0, vl = srcVertices.length; v < vl; v += 3 ) {
	
								var vertex = new Vector3();
								vertex.x = srcVertices[ v ] * scale;
								vertex.y = srcVertices[ v + 1 ] * scale;
								vertex.z = srcVertices[ v + 2 ] * scale;
	
								dstVertices.push( vertex );
	
							}
	
						}
	
					}
	
					if ( json.morphColors !== undefined && json.morphColors.length > 0 ) {
	
						console.warn( 'THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.' );
	
						var faces = geometry.faces;
						var morphColors = json.morphColors[ 0 ].colors;
	
						for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
							faces[ i ].color.fromArray( morphColors, i * 3 );
	
						}
	
					}
	
				}
	
				function parseAnimations( json, geometry ) {
	
					var outputAnimations = [];
	
					// parse old style Bone/Hierarchy animations
					var animations = [];
	
					if ( json.animation !== undefined ) {
	
						animations.push( json.animation );
	
					}
	
					if ( json.animations !== undefined ) {
	
						if ( json.animations.length ) {
	
							animations = animations.concat( json.animations );
	
						} else {
	
							animations.push( json.animations );
	
						}
	
					}
	
					for ( var i = 0; i < animations.length; i ++ ) {
	
						var clip = AnimationClip.parseAnimation( animations[ i ], geometry.bones );
						if ( clip ) outputAnimations.push( clip );
	
					}
	
					// parse implicit morph animations
					if ( geometry.morphTargets ) {
	
						// TODO: Figure out what an appropraite FPS is for morph target animations -- defaulting to 10, but really it is completely arbitrary.
						var morphAnimationClips = AnimationClip.CreateClipsFromMorphTargetSequences( geometry.morphTargets, 10 );
						outputAnimations = outputAnimations.concat( morphAnimationClips );
	
					}
	
					if ( outputAnimations.length > 0 ) geometry.animations = outputAnimations;
	
				}
	
				return function ( json, texturePath ) {
	
					if ( json.data !== undefined ) {
	
						// Geometry 4.0 spec
						json = json.data;
	
					}
	
					if ( json.scale !== undefined ) {
	
						json.scale = 1.0 / json.scale;
	
					} else {
	
						json.scale = 1.0;
	
					}
	
					var geometry = new Geometry();
	
					parseModel( json, geometry );
					parseSkin( json, geometry );
					parseMorphing( json, geometry );
					parseAnimations( json, geometry );
	
					geometry.computeFaceNormals();
					geometry.computeBoundingSphere();
	
					if ( json.materials === undefined || json.materials.length === 0 ) {
	
						return { geometry: geometry };
	
					} else {
	
						var materials = Loader.prototype.initMaterials( json.materials, texturePath, this.crossOrigin );
	
						return { geometry: geometry, materials: materials };
	
					}
	
				};
	
			} )()
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function ObjectLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
			this.texturePath = '';
	
		}
	
		Object.assign( ObjectLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				if ( this.texturePath === '' ) {
	
					this.texturePath = url.substring( 0, url.lastIndexOf( '/' ) + 1 );
	
				}
	
				var scope = this;
	
				var loader = new FileLoader( scope.manager );
				loader.load( url, function ( text ) {
	
					var json = null;
	
					try {
	
						json = JSON.parse( text );
	
					} catch ( error ) {
	
						if ( onError !== undefined ) onError( error );
	
						console.error( 'THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message );
	
						return;
	
					}
	
					var metadata = json.metadata;
	
					if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {
	
						console.error( 'THREE.ObjectLoader: Can\'t load ' + url + '. Use THREE.JSONLoader instead.' );
						return;
	
					}
	
					scope.parse( json, onLoad );
	
				}, onProgress, onError );
	
			},
	
			setTexturePath: function ( value ) {
	
				this.texturePath = value;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
	
			},
	
			parse: function ( json, onLoad ) {
	
				var geometries = this.parseGeometries( json.geometries );
	
				var images = this.parseImages( json.images, function () {
	
					if ( onLoad !== undefined ) onLoad( object );
	
				} );
	
				var textures = this.parseTextures( json.textures, images );
				var materials = this.parseMaterials( json.materials, textures );
	
				var object = this.parseObject( json.object, geometries, materials );
	
				if ( json.animations ) {
	
					object.animations = this.parseAnimations( json.animations );
	
				}
	
				if ( json.images === undefined || json.images.length === 0 ) {
	
					if ( onLoad !== undefined ) onLoad( object );
	
				}
	
				return object;
	
			},
	
			parseGeometries: function ( json ) {
	
				var geometries = {};
	
				if ( json !== undefined ) {
	
					var geometryLoader = new JSONLoader();
					var bufferGeometryLoader = new BufferGeometryLoader();
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var geometry;
						var data = json[ i ];
	
						switch ( data.type ) {
	
							case 'PlaneGeometry':
							case 'PlaneBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.width,
									data.height,
									data.widthSegments,
									data.heightSegments
								);
	
								break;
	
							case 'BoxGeometry':
							case 'BoxBufferGeometry':
							case 'CubeGeometry': // backwards compatible
	
								geometry = new Geometries[ data.type ](
									data.width,
									data.height,
									data.depth,
									data.widthSegments,
									data.heightSegments,
									data.depthSegments
								);
	
								break;
	
							case 'CircleGeometry':
							case 'CircleBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.segments,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'CylinderGeometry':
							case 'CylinderBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radiusTop,
									data.radiusBottom,
									data.height,
									data.radialSegments,
									data.heightSegments,
									data.openEnded,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'ConeGeometry':
							case 'ConeBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.height,
									data.radialSegments,
									data.heightSegments,
									data.openEnded,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'SphereGeometry':
							case 'SphereBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.widthSegments,
									data.heightSegments,
									data.phiStart,
									data.phiLength,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'DodecahedronGeometry':
							case 'IcosahedronGeometry':
							case 'OctahedronGeometry':
							case 'TetrahedronGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.detail
								);
	
								break;
	
							case 'RingGeometry':
							case 'RingBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.innerRadius,
									data.outerRadius,
									data.thetaSegments,
									data.phiSegments,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'TorusGeometry':
							case 'TorusBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.tube,
									data.radialSegments,
									data.tubularSegments,
									data.arc
								);
	
								break;
	
							case 'TorusKnotGeometry':
							case 'TorusKnotBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.tube,
									data.tubularSegments,
									data.radialSegments,
									data.p,
									data.q
								);
	
								break;
	
							case 'LatheGeometry':
							case 'LatheBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.points,
									data.segments,
									data.phiStart,
									data.phiLength
								);
	
								break;
	
							case 'BufferGeometry':
	
								geometry = bufferGeometryLoader.parse( data );
	
								break;
	
							case 'Geometry':
	
								geometry = geometryLoader.parse( data, this.texturePath ).geometry;
	
								break;
	
							default:
	
								console.warn( 'THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"' );
	
								continue;
	
						}
	
						geometry.uuid = data.uuid;
	
						if ( data.name !== undefined ) geometry.name = data.name;
	
						geometries[ data.uuid ] = geometry;
	
					}
	
				}
	
				return geometries;
	
			},
	
			parseMaterials: function ( json, textures ) {
	
				var materials = {};
	
				if ( json !== undefined ) {
	
					var loader = new MaterialLoader();
					loader.setTextures( textures );
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var data = json[ i ];
	
						if ( data.type === 'MultiMaterial' ) {
	
							// Deprecated
	
							var array = [];
	
							for ( var j = 0; j < data.materials.length; j ++ ) {
	
								array.push( loader.parse( data.materials[ j ] ) );
	
							}
	
							materials[ data.uuid ] = array;
	
						} else {
	
							materials[ data.uuid ] = loader.parse( data );
	
						}
	
					}
	
				}
	
				return materials;
	
			},
	
			parseAnimations: function ( json ) {
	
				var animations = [];
	
				for ( var i = 0; i < json.length; i ++ ) {
	
					var clip = AnimationClip.parse( json[ i ] );
	
					animations.push( clip );
	
				}
	
				return animations;
	
			},
	
			parseImages: function ( json, onLoad ) {
	
				var scope = this;
				var images = {};
	
				function loadImage( url ) {
	
					scope.manager.itemStart( url );
	
					return loader.load( url, function () {
	
						scope.manager.itemEnd( url );
	
					}, undefined, function () {
	
						scope.manager.itemEnd( url );
						scope.manager.itemError( url );
	
					} );
	
				}
	
				if ( json !== undefined && json.length > 0 ) {
	
					var manager = new LoadingManager( onLoad );
	
					var loader = new ImageLoader( manager );
					loader.setCrossOrigin( this.crossOrigin );
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var image = json[ i ];
						var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( image.url ) ? image.url : scope.texturePath + image.url;
	
						images[ image.uuid ] = loadImage( path );
	
					}
	
				}
	
				return images;
	
			},
	
			parseTextures: function ( json, images ) {
	
				function parseConstant( value, type ) {
	
					if ( typeof( value ) === 'number' ) return value;
	
					console.warn( 'THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value );
	
					return type[ value ];
	
				}
	
				var textures = {};
	
				if ( json !== undefined ) {
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var data = json[ i ];
	
						if ( data.image === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: No "image" specified for', data.uuid );
	
						}
	
						if ( images[ data.image ] === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: Undefined image', data.image );
	
						}
	
						var texture = new Texture( images[ data.image ] );
						texture.needsUpdate = true;
	
						texture.uuid = data.uuid;
	
						if ( data.name !== undefined ) texture.name = data.name;
	
						if ( data.mapping !== undefined ) texture.mapping = parseConstant( data.mapping, TEXTURE_MAPPING );
	
						if ( data.offset !== undefined ) texture.offset.fromArray( data.offset );
						if ( data.repeat !== undefined ) texture.repeat.fromArray( data.repeat );
						if ( data.wrap !== undefined ) {
	
							texture.wrapS = parseConstant( data.wrap[ 0 ], TEXTURE_WRAPPING );
							texture.wrapT = parseConstant( data.wrap[ 1 ], TEXTURE_WRAPPING );
	
						}
	
						if ( data.minFilter !== undefined ) texture.minFilter = parseConstant( data.minFilter, TEXTURE_FILTER );
						if ( data.magFilter !== undefined ) texture.magFilter = parseConstant( data.magFilter, TEXTURE_FILTER );
						if ( data.anisotropy !== undefined ) texture.anisotropy = data.anisotropy;
	
						if ( data.flipY !== undefined ) texture.flipY = data.flipY;
	
						textures[ data.uuid ] = texture;
	
					}
	
				}
	
				return textures;
	
			},
	
			parseObject: function () {
	
				var matrix = new Matrix4();
	
				return function parseObject( data, geometries, materials ) {
	
					var object;
	
					function getGeometry( name ) {
	
						if ( geometries[ name ] === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: Undefined geometry', name );
	
						}
	
						return geometries[ name ];
	
					}
	
					function getMaterial( name ) {
	
						if ( name === undefined ) return undefined;
	
						if ( Array.isArray( name ) ) {
	
							var array = [];
	
							for ( var i = 0, l = name.length; i < l; i ++ ) {
	
								var uuid = name[ i ];
	
								if ( materials[ uuid ] === undefined ) {
	
									console.warn( 'THREE.ObjectLoader: Undefined material', uuid );
	
								}
	
								array.push( materials[ uuid ] );
	
							}
	
							return array;
	
						}
	
						if ( materials[ name ] === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: Undefined material', name );
	
						}
	
						return materials[ name ];
	
					}
	
					switch ( data.type ) {
	
						case 'Scene':
	
							object = new Scene();
	
							if ( data.background !== undefined ) {
	
								if ( Number.isInteger( data.background ) ) {
	
									object.background = new Color( data.background );
	
								}
	
							}
	
							if ( data.fog !== undefined ) {
	
								if ( data.fog.type === 'Fog' ) {
	
									object.fog = new Fog( data.fog.color, data.fog.near, data.fog.far );
	
								} else if ( data.fog.type === 'FogExp2' ) {
	
									object.fog = new FogExp2( data.fog.color, data.fog.density );
	
								}
	
							}
	
							break;
	
						case 'PerspectiveCamera':
	
							object = new PerspectiveCamera( data.fov, data.aspect, data.near, data.far );
	
							if ( data.focus !== undefined ) object.focus = data.focus;
							if ( data.zoom !== undefined ) object.zoom = data.zoom;
							if ( data.filmGauge !== undefined ) object.filmGauge = data.filmGauge;
							if ( data.filmOffset !== undefined ) object.filmOffset = data.filmOffset;
							if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );
	
							break;
	
						case 'OrthographicCamera':
	
							object = new OrthographicCamera( data.left, data.right, data.top, data.bottom, data.near, data.far );
	
							break;
	
						case 'AmbientLight':
	
							object = new AmbientLight( data.color, data.intensity );
	
							break;
	
						case 'DirectionalLight':
	
							object = new DirectionalLight( data.color, data.intensity );
	
							break;
	
						case 'PointLight':
	
							object = new PointLight( data.color, data.intensity, data.distance, data.decay );
	
							break;
	
						case 'RectAreaLight':
	
							object = new RectAreaLight( data.color, data.intensity, data.width, data.height );
	
							break;
	
						case 'SpotLight':
	
							object = new SpotLight( data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay );
	
							break;
	
						case 'HemisphereLight':
	
							object = new HemisphereLight( data.color, data.groundColor, data.intensity );
	
							break;
	
						case 'SkinnedMesh':
	
							console.warn( 'THREE.ObjectLoader.parseObject() does not support SkinnedMesh yet.' );
	
						case 'Mesh':
	
							var geometry = getGeometry( data.geometry );
							var material = getMaterial( data.material );
	
							if ( geometry.bones && geometry.bones.length > 0 ) {
	
								object = new SkinnedMesh( geometry, material );
	
							} else {
	
								object = new Mesh( geometry, material );
	
							}
	
							break;
	
						case 'LOD':
	
							object = new LOD();
	
							break;
	
						case 'Line':
	
							object = new Line( getGeometry( data.geometry ), getMaterial( data.material ), data.mode );
	
							break;
	
						case 'LineLoop':
	
							object = new LineLoop( getGeometry( data.geometry ), getMaterial( data.material ) );
	
							break;
	
						case 'LineSegments':
	
							object = new LineSegments( getGeometry( data.geometry ), getMaterial( data.material ) );
	
							break;
	
						case 'PointCloud':
						case 'Points':
	
							object = new Points( getGeometry( data.geometry ), getMaterial( data.material ) );
	
							break;
	
						case 'Sprite':
	
							object = new Sprite( getMaterial( data.material ) );
	
							break;
	
						case 'Group':
	
							object = new Group();
	
							break;
	
						default:
	
							object = new Object3D();
	
					}
	
					object.uuid = data.uuid;
	
					if ( data.name !== undefined ) object.name = data.name;
					if ( data.matrix !== undefined ) {
	
						matrix.fromArray( data.matrix );
						matrix.decompose( object.position, object.quaternion, object.scale );
	
					} else {
	
						if ( data.position !== undefined ) object.position.fromArray( data.position );
						if ( data.rotation !== undefined ) object.rotation.fromArray( data.rotation );
						if ( data.quaternion !== undefined ) object.quaternion.fromArray( data.quaternion );
						if ( data.scale !== undefined ) object.scale.fromArray( data.scale );
	
					}
	
					if ( data.castShadow !== undefined ) object.castShadow = data.castShadow;
					if ( data.receiveShadow !== undefined ) object.receiveShadow = data.receiveShadow;
	
					if ( data.shadow ) {
	
						if ( data.shadow.bias !== undefined ) object.shadow.bias = data.shadow.bias;
						if ( data.shadow.radius !== undefined ) object.shadow.radius = data.shadow.radius;
						if ( data.shadow.mapSize !== undefined ) object.shadow.mapSize.fromArray( data.shadow.mapSize );
						if ( data.shadow.camera !== undefined ) object.shadow.camera = this.parseObject( data.shadow.camera );
	
					}
	
					if ( data.visible !== undefined ) object.visible = data.visible;
					if ( data.userData !== undefined ) object.userData = data.userData;
	
					if ( data.children !== undefined ) {
	
						var children = data.children;
	
						for ( var  i = 0; i < children.length; i ++ ) {
	
							object.add( this.parseObject( children[ i ], geometries, materials ) );
	
						}
	
					}
	
					if ( data.type === 'LOD' ) {
	
						var levels = data.levels;
	
						for ( var l = 0; l < levels.length; l ++ ) {
	
							var level = levels[ l ];
							var child = object.getObjectByProperty( 'uuid', level.object );
	
							if ( child !== undefined ) {
	
								object.addLevel( child, level.distance );
	
							}
	
						}
	
					}
	
					return object;
	
				};
	
			}()
	
		} );
	
		var TEXTURE_MAPPING = {
			UVMapping: UVMapping,
			CubeReflectionMapping: CubeReflectionMapping,
			CubeRefractionMapping: CubeRefractionMapping,
			EquirectangularReflectionMapping: EquirectangularReflectionMapping,
			EquirectangularRefractionMapping: EquirectangularRefractionMapping,
			SphericalReflectionMapping: SphericalReflectionMapping,
			CubeUVReflectionMapping: CubeUVReflectionMapping,
			CubeUVRefractionMapping: CubeUVRefractionMapping
		};
	
		var TEXTURE_WRAPPING = {
			RepeatWrapping: RepeatWrapping,
			ClampToEdgeWrapping: ClampToEdgeWrapping,
			MirroredRepeatWrapping: MirroredRepeatWrapping
		};
	
		var TEXTURE_FILTER = {
			NearestFilter: NearestFilter,
			NearestMipMapNearestFilter: NearestMipMapNearestFilter,
			NearestMipMapLinearFilter: NearestMipMapLinearFilter,
			LinearFilter: LinearFilter,
			LinearMipMapNearestFilter: LinearMipMapNearestFilter,
			LinearMipMapLinearFilter: LinearMipMapLinearFilter
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 *
		 * Bezier Curves formulas obtained from
		 * http://en.wikipedia.org/wiki/Bézier_curve
		 */
	
		function CatmullRom( t, p0, p1, p2, p3 ) {
	
			var v0 = ( p2 - p0 ) * 0.5;
			var v1 = ( p3 - p1 ) * 0.5;
			var t2 = t * t;
			var t3 = t * t2;
			return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;
	
		}
	
		//
	
		function QuadraticBezierP0( t, p ) {
	
			var k = 1 - t;
			return k * k * p;
	
		}
	
		function QuadraticBezierP1( t, p ) {
	
			return 2 * ( 1 - t ) * t * p;
	
		}
	
		function QuadraticBezierP2( t, p ) {
	
			return t * t * p;
	
		}
	
		function QuadraticBezier( t, p0, p1, p2 ) {
	
			return QuadraticBezierP0( t, p0 ) + QuadraticBezierP1( t, p1 ) +
				QuadraticBezierP2( t, p2 );
	
		}
	
		//
	
		function CubicBezierP0( t, p ) {
	
			var k = 1 - t;
			return k * k * k * p;
	
		}
	
		function CubicBezierP1( t, p ) {
	
			var k = 1 - t;
			return 3 * k * k * t * p;
	
		}
	
		function CubicBezierP2( t, p ) {
	
			return 3 * ( 1 - t ) * t * t * p;
	
		}
	
		function CubicBezierP3( t, p ) {
	
			return t * t * t * p;
	
		}
	
		function CubicBezier( t, p0, p1, p2, p3 ) {
	
			return CubicBezierP0( t, p0 ) + CubicBezierP1( t, p1 ) + CubicBezierP2( t, p2 ) +
				CubicBezierP3( t, p3 );
	
		}
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * Extensible curve object
		 *
		 * Some common of curve methods:
		 * .getPoint(t), getTangent(t)
		 * .getPointAt(u), getTangentAt(u)
		 * .getPoints(), .getSpacedPoints()
		 * .getLength()
		 * .updateArcLengths()
		 *
		 * This following curves inherit from THREE.Curve:
		 *
		 * -- 2D curves --
		 * THREE.ArcCurve
		 * THREE.CubicBezierCurve
		 * THREE.EllipseCurve
		 * THREE.LineCurve
		 * THREE.QuadraticBezierCurve
		 * THREE.SplineCurve
		 *
		 * -- 3D curves --
		 * THREE.CatmullRomCurve3
		 * THREE.CubicBezierCurve3
		 * THREE.LineCurve3
		 * THREE.QuadraticBezierCurve3
		 *
		 * A series of curves can be represented as a THREE.CurvePath.
		 *
		 **/
	
		/**************************************************************
		 *	Abstract Curve base class
		 **************************************************************/
	
		function Curve() {
	
			this.arcLengthDivisions = 200;
	
		}
	
		Object.assign( Curve.prototype, {
	
			// Virtual base class method to overwrite and implement in subclasses
			//	- t [0 .. 1]
	
			getPoint: function () {
	
				console.warn( 'THREE.Curve: .getPoint() not implemented.' );
				return null;
	
			},
	
			// Get point at relative position in curve according to arc length
			// - u [0 .. 1]
	
			getPointAt: function ( u ) {
	
				var t = this.getUtoTmapping( u );
				return this.getPoint( t );
	
			},
	
			// Get sequence of points using getPoint( t )
	
			getPoints: function ( divisions ) {
	
				if ( divisions === undefined ) divisions = 5;
	
				var points = [];
	
				for ( var d = 0; d <= divisions; d ++ ) {
	
					points.push( this.getPoint( d / divisions ) );
	
				}
	
				return points;
	
			},
	
			// Get sequence of points using getPointAt( u )
	
			getSpacedPoints: function ( divisions ) {
	
				if ( divisions === undefined ) divisions = 5;
	
				var points = [];
	
				for ( var d = 0; d <= divisions; d ++ ) {
	
					points.push( this.getPointAt( d / divisions ) );
	
				}
	
				return points;
	
			},
	
			// Get total curve arc length
	
			getLength: function () {
	
				var lengths = this.getLengths();
				return lengths[ lengths.length - 1 ];
	
			},
	
			// Get list of cumulative segment lengths
	
			getLengths: function ( divisions ) {
	
				if ( divisions === undefined ) divisions = this.arcLengthDivisions;
	
				if ( this.cacheArcLengths &&
					( this.cacheArcLengths.length === divisions + 1 ) &&
					! this.needsUpdate ) {
	
					return this.cacheArcLengths;
	
				}
	
				this.needsUpdate = false;
	
				var cache = [];
				var current, last = this.getPoint( 0 );
				var p, sum = 0;
	
				cache.push( 0 );
	
				for ( p = 1; p <= divisions; p ++ ) {
	
					current = this.getPoint( p / divisions );
					sum += current.distanceTo( last );
					cache.push( sum );
					last = current;
	
				}
	
				this.cacheArcLengths = cache;
	
				return cache; // { sums: cache, sum: sum }; Sum is in the last element.
	
			},
	
			updateArcLengths: function () {
	
				this.needsUpdate = true;
				this.getLengths();
	
			},
	
			// Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
	
			getUtoTmapping: function ( u, distance ) {
	
				var arcLengths = this.getLengths();
	
				var i = 0, il = arcLengths.length;
	
				var targetArcLength; // The targeted u distance value to get
	
				if ( distance ) {
	
					targetArcLength = distance;
	
				} else {
	
					targetArcLength = u * arcLengths[ il - 1 ];
	
				}
	
				// binary search for the index with largest value smaller than target u distance
	
				var low = 0, high = il - 1, comparison;
	
				while ( low <= high ) {
	
					i = Math.floor( low + ( high - low ) / 2 ); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
	
					comparison = arcLengths[ i ] - targetArcLength;
	
					if ( comparison < 0 ) {
	
						low = i + 1;
	
					} else if ( comparison > 0 ) {
	
						high = i - 1;
	
					} else {
	
						high = i;
						break;
	
						// DONE
	
					}
	
				}
	
				i = high;
	
				if ( arcLengths[ i ] === targetArcLength ) {
	
					return i / ( il - 1 );
	
				}
	
				// we could get finer grain at lengths, or use simple interpolation between two points
	
				var lengthBefore = arcLengths[ i ];
				var lengthAfter = arcLengths[ i + 1 ];
	
				var segmentLength = lengthAfter - lengthBefore;
	
				// determine where we are between the 'before' and 'after' points
	
				var segmentFraction = ( targetArcLength - lengthBefore ) / segmentLength;
	
				// add that fractional amount to t
	
				var t = ( i + segmentFraction ) / ( il - 1 );
	
				return t;
	
			},
	
			// Returns a unit vector tangent at t
			// In case any sub curve does not implement its tangent derivation,
			// 2 points a small delta apart will be used to find its gradient
			// which seems to give a reasonable approximation
	
			getTangent: function ( t ) {
	
				var delta = 0.0001;
				var t1 = t - delta;
				var t2 = t + delta;
	
				// Capping in case of danger
	
				if ( t1 < 0 ) t1 = 0;
				if ( t2 > 1 ) t2 = 1;
	
				var pt1 = this.getPoint( t1 );
				var pt2 = this.getPoint( t2 );
	
				var vec = pt2.clone().sub( pt1 );
				return vec.normalize();
	
			},
	
			getTangentAt: function ( u ) {
	
				var t = this.getUtoTmapping( u );
				return this.getTangent( t );
	
			},
	
			computeFrenetFrames: function ( segments, closed ) {
	
				// see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
	
				var normal = new Vector3();
	
				var tangents = [];
				var normals = [];
				var binormals = [];
	
				var vec = new Vector3();
				var mat = new Matrix4();
	
				var i, u, theta;
	
				// compute the tangent vectors for each segment on the curve
	
				for ( i = 0; i <= segments; i ++ ) {
	
					u = i / segments;
	
					tangents[ i ] = this.getTangentAt( u );
					tangents[ i ].normalize();
	
				}
	
				// select an initial normal vector perpendicular to the first tangent vector,
				// and in the direction of the minimum tangent xyz component
	
				normals[ 0 ] = new Vector3();
				binormals[ 0 ] = new Vector3();
				var min = Number.MAX_VALUE;
				var tx = Math.abs( tangents[ 0 ].x );
				var ty = Math.abs( tangents[ 0 ].y );
				var tz = Math.abs( tangents[ 0 ].z );
	
				if ( tx <= min ) {
	
					min = tx;
					normal.set( 1, 0, 0 );
	
				}
	
				if ( ty <= min ) {
	
					min = ty;
					normal.set( 0, 1, 0 );
	
				}
	
				if ( tz <= min ) {
	
					normal.set( 0, 0, 1 );
	
				}
	
				vec.crossVectors( tangents[ 0 ], normal ).normalize();
	
				normals[ 0 ].crossVectors( tangents[ 0 ], vec );
				binormals[ 0 ].crossVectors( tangents[ 0 ], normals[ 0 ] );
	
	
				// compute the slowly-varying normal and binormal vectors for each segment on the curve
	
				for ( i = 1; i <= segments; i ++ ) {
	
					normals[ i ] = normals[ i - 1 ].clone();
	
					binormals[ i ] = binormals[ i - 1 ].clone();
	
					vec.crossVectors( tangents[ i - 1 ], tangents[ i ] );
	
					if ( vec.length() > Number.EPSILON ) {
	
						vec.normalize();
	
						theta = Math.acos( _Math.clamp( tangents[ i - 1 ].dot( tangents[ i ] ), - 1, 1 ) ); // clamp for floating pt errors
	
						normals[ i ].applyMatrix4( mat.makeRotationAxis( vec, theta ) );
	
					}
	
					binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );
	
				}
	
				// if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
	
				if ( closed === true ) {
	
					theta = Math.acos( _Math.clamp( normals[ 0 ].dot( normals[ segments ] ), - 1, 1 ) );
					theta /= segments;
	
					if ( tangents[ 0 ].dot( vec.crossVectors( normals[ 0 ], normals[ segments ] ) ) > 0 ) {
	
						theta = - theta;
	
					}
	
					for ( i = 1; i <= segments; i ++ ) {
	
						// twist a little...
						normals[ i ].applyMatrix4( mat.makeRotationAxis( tangents[ i ], theta * i ) );
						binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );
	
					}
	
				}
	
				return {
					tangents: tangents,
					normals: normals,
					binormals: binormals
				};
	
			}
	
		} );
	
		function LineCurve( v1, v2 ) {
	
			Curve.call( this );
	
			this.v1 = v1;
			this.v2 = v2;
	
		}
	
		LineCurve.prototype = Object.create( Curve.prototype );
		LineCurve.prototype.constructor = LineCurve;
	
		LineCurve.prototype.isLineCurve = true;
	
		LineCurve.prototype.getPoint = function ( t ) {
	
			if ( t === 1 ) {
	
				return this.v2.clone();
	
			}
	
			var point = this.v2.clone().sub( this.v1 );
			point.multiplyScalar( t ).add( this.v1 );
	
			return point;
	
		};
	
		// Line curve is linear, so we can overwrite default getPointAt
	
		LineCurve.prototype.getPointAt = function ( u ) {
	
			return this.getPoint( u );
	
		};
	
		LineCurve.prototype.getTangent = function ( t ) {
	
			var tangent = this.v2.clone().sub( this.v1 );
	
			return tangent.normalize();
	
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 *
		 **/
	
		/**************************************************************
		 *	Curved Path - a curve path is simply a array of connected
		 *  curves, but retains the api of a curve
		 **************************************************************/
	
		function CurvePath() {
	
			Curve.call( this );
	
			this.curves = [];
	
			this.autoClose = false; // Automatically closes the path
	
		}
	
		CurvePath.prototype = Object.assign( Object.create( Curve.prototype ), {
	
			constructor: CurvePath,
	
			add: function ( curve ) {
	
				this.curves.push( curve );
	
			},
	
			closePath: function () {
	
				// Add a line curve if start and end of lines are not connected
				var startPoint = this.curves[ 0 ].getPoint( 0 );
				var endPoint = this.curves[ this.curves.length - 1 ].getPoint( 1 );
	
				if ( ! startPoint.equals( endPoint ) ) {
	
					this.curves.push( new LineCurve( endPoint, startPoint ) );
	
				}
	
			},
	
			// To get accurate point with reference to
			// entire path distance at time t,
			// following has to be done:
	
			// 1. Length of each sub path have to be known
			// 2. Locate and identify type of curve
			// 3. Get t for the curve
			// 4. Return curve.getPointAt(t')
	
			getPoint: function ( t ) {
	
				var d = t * this.getLength();
				var curveLengths = this.getCurveLengths();
				var i = 0;
	
				// To think about boundaries points.
	
				while ( i < curveLengths.length ) {
	
					if ( curveLengths[ i ] >= d ) {
	
						var diff = curveLengths[ i ] - d;
						var curve = this.curves[ i ];
	
						var segmentLength = curve.getLength();
						var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
	
						return curve.getPointAt( u );
	
					}
	
					i ++;
	
				}
	
				return null;
	
				// loop where sum != 0, sum > d , sum+1 <d
	
			},
	
			// We cannot use the default THREE.Curve getPoint() with getLength() because in
			// THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
			// getPoint() depends on getLength
	
			getLength: function () {
	
				var lens = this.getCurveLengths();
				return lens[ lens.length - 1 ];
	
			},
	
			// cacheLengths must be recalculated.
			updateArcLengths: function () {
	
				this.needsUpdate = true;
				this.cacheLengths = null;
				this.getCurveLengths();
	
			},
	
			// Compute lengths and cache them
			// We cannot overwrite getLengths() because UtoT mapping uses it.
	
			getCurveLengths: function () {
	
				// We use cache values if curves and cache array are same length
	
				if ( this.cacheLengths && this.cacheLengths.length === this.curves.length ) {
	
					return this.cacheLengths;
	
				}
	
				// Get length of sub-curve
				// Push sums into cached array
	
				var lengths = [], sums = 0;
	
				for ( var i = 0, l = this.curves.length; i < l; i ++ ) {
	
					sums += this.curves[ i ].getLength();
					lengths.push( sums );
	
				}
	
				this.cacheLengths = lengths;
	
				return lengths;
	
			},
	
			getSpacedPoints: function ( divisions ) {
	
				if ( divisions === undefined ) divisions = 40;
	
				var points = [];
	
				for ( var i = 0; i <= divisions; i ++ ) {
	
					points.push( this.getPoint( i / divisions ) );
	
				}
	
				if ( this.autoClose ) {
	
					points.push( points[ 0 ] );
	
				}
	
				return points;
	
			},
	
			getPoints: function ( divisions ) {
	
				divisions = divisions || 12;
	
				var points = [], last;
	
				for ( var i = 0, curves = this.curves; i < curves.length; i ++ ) {
	
					var curve = curves[ i ];
					var resolution = (curve && curve.isEllipseCurve) ? divisions * 2
						: (curve && curve.isLineCurve) ? 1
						: (curve && curve.isSplineCurve) ? divisions * curve.points.length
						: divisions;
	
					var pts = curve.getPoints( resolution );
	
					for ( var j = 0; j < pts.length; j++ ) {
	
						var point = pts[ j ];
	
						if ( last && last.equals( point ) ) continue; // ensures no consecutive points are duplicates
	
						points.push( point );
						last = point;
	
					}
	
				}
	
				if ( this.autoClose && points.length > 1 && !points[ points.length - 1 ].equals( points[ 0 ] ) ) {
	
					points.push( points[ 0 ] );
	
				}
	
				return points;
	
			},
	
			/**************************************************************
			 *	Create Geometries Helpers
			 **************************************************************/
	
			/// Generate geometry from path points (for Line or Points objects)
	
			createPointsGeometry: function ( divisions ) {
	
				var pts = this.getPoints( divisions );
				return this.createGeometry( pts );
	
			},
	
			// Generate geometry from equidistant sampling along the path
	
			createSpacedPointsGeometry: function ( divisions ) {
	
				var pts = this.getSpacedPoints( divisions );
				return this.createGeometry( pts );
	
			},
	
			createGeometry: function ( points ) {
	
				var geometry = new Geometry();
	
				for ( var i = 0, l = points.length; i < l; i ++ ) {
	
					var point = points[ i ];
					geometry.vertices.push( new Vector3( point.x, point.y, point.z || 0 ) );
	
				}
	
				return geometry;
	
			}
	
		} );
	
		function EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {
	
			Curve.call( this );
	
			this.aX = aX;
			this.aY = aY;
	
			this.xRadius = xRadius;
			this.yRadius = yRadius;
	
			this.aStartAngle = aStartAngle;
			this.aEndAngle = aEndAngle;
	
			this.aClockwise = aClockwise;
	
			this.aRotation = aRotation || 0;
	
		}
	
		EllipseCurve.prototype = Object.create( Curve.prototype );
		EllipseCurve.prototype.constructor = EllipseCurve;
	
		EllipseCurve.prototype.isEllipseCurve = true;
	
		EllipseCurve.prototype.getPoint = function ( t ) {
	
			var twoPi = Math.PI * 2;
			var deltaAngle = this.aEndAngle - this.aStartAngle;
			var samePoints = Math.abs( deltaAngle ) < Number.EPSILON;
	
			// ensures that deltaAngle is 0 .. 2 PI
			while ( deltaAngle < 0 ) deltaAngle += twoPi;
			while ( deltaAngle > twoPi ) deltaAngle -= twoPi;
	
			if ( deltaAngle < Number.EPSILON ) {
	
				if ( samePoints ) {
	
					deltaAngle = 0;
	
				} else {
	
					deltaAngle = twoPi;
	
				}
	
			}
	
			if ( this.aClockwise === true && ! samePoints ) {
	
				if ( deltaAngle === twoPi ) {
	
					deltaAngle = - twoPi;
	
				} else {
	
					deltaAngle = deltaAngle - twoPi;
	
				}
	
			}
	
			var angle = this.aStartAngle + t * deltaAngle;
			var x = this.aX + this.xRadius * Math.cos( angle );
			var y = this.aY + this.yRadius * Math.sin( angle );
	
			if ( this.aRotation !== 0 ) {
	
				var cos = Math.cos( this.aRotation );
				var sin = Math.sin( this.aRotation );
	
				var tx = x - this.aX;
				var ty = y - this.aY;
	
				// Rotate the point about the center of the ellipse.
				x = tx * cos - ty * sin + this.aX;
				y = tx * sin + ty * cos + this.aY;
	
			}
	
			return new Vector2( x, y );
	
		};
	
		function SplineCurve( points /* array of Vector2 */ ) {
	
			Curve.call( this );
	
			this.points = ( points === undefined ) ? [] : points;
	
		}
	
		SplineCurve.prototype = Object.create( Curve.prototype );
		SplineCurve.prototype.constructor = SplineCurve;
	
		SplineCurve.prototype.isSplineCurve = true;
	
		SplineCurve.prototype.getPoint = function ( t ) {
	
			var points = this.points;
			var point = ( points.length - 1 ) * t;
	
			var intPoint = Math.floor( point );
			var weight = point - intPoint;
	
			var point0 = points[ intPoint === 0 ? intPoint : intPoint - 1 ];
			var point1 = points[ intPoint ];
			var point2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
			var point3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];
	
			return new Vector2(
				CatmullRom( weight, point0.x, point1.x, point2.x, point3.x ),
				CatmullRom( weight, point0.y, point1.y, point2.y, point3.y )
			);
	
		};
	
		function CubicBezierCurve( v0, v1, v2, v3 ) {
	
			Curve.call( this );
	
			this.v0 = v0;
			this.v1 = v1;
			this.v2 = v2;
			this.v3 = v3;
	
		}
	
		CubicBezierCurve.prototype = Object.create( Curve.prototype );
		CubicBezierCurve.prototype.constructor = CubicBezierCurve;
	
		CubicBezierCurve.prototype.getPoint = function ( t ) {
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
	
			return new Vector2(
				CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
				CubicBezier( t, v0.y, v1.y, v2.y, v3.y )
			);
	
		};
	
		function QuadraticBezierCurve( v0, v1, v2 ) {
	
			Curve.call( this );
	
			this.v0 = v0;
			this.v1 = v1;
			this.v2 = v2;
	
		}
	
		QuadraticBezierCurve.prototype = Object.create( Curve.prototype );
		QuadraticBezierCurve.prototype.constructor = QuadraticBezierCurve;
	
		QuadraticBezierCurve.prototype.getPoint = function ( t ) {
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2;
	
			return new Vector2(
				QuadraticBezier( t, v0.x, v1.x, v2.x ),
				QuadraticBezier( t, v0.y, v1.y, v2.y )
			);
	
		};
	
		var PathPrototype = Object.assign( Object.create( CurvePath.prototype ), {
	
			fromPoints: function ( vectors ) {
	
				this.moveTo( vectors[ 0 ].x, vectors[ 0 ].y );
	
				for ( var i = 1, l = vectors.length; i < l; i ++ ) {
	
					this.lineTo( vectors[ i ].x, vectors[ i ].y );
	
				}
	
			},
	
			moveTo: function ( x, y ) {
	
				this.currentPoint.set( x, y ); // TODO consider referencing vectors instead of copying?
	
			},
	
			lineTo: function ( x, y ) {
	
				var curve = new LineCurve( this.currentPoint.clone(), new Vector2( x, y ) );
				this.curves.push( curve );
	
				this.currentPoint.set( x, y );
	
			},
	
			quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {
	
				var curve = new QuadraticBezierCurve(
					this.currentPoint.clone(),
					new Vector2( aCPx, aCPy ),
					new Vector2( aX, aY )
				);
	
				this.curves.push( curve );
	
				this.currentPoint.set( aX, aY );
	
			},
	
			bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {
	
				var curve = new CubicBezierCurve(
					this.currentPoint.clone(),
					new Vector2( aCP1x, aCP1y ),
					new Vector2( aCP2x, aCP2y ),
					new Vector2( aX, aY )
				);
	
				this.curves.push( curve );
	
				this.currentPoint.set( aX, aY );
	
			},
	
			splineThru: function ( pts /*Array of Vector*/ ) {
	
				var npts = [ this.currentPoint.clone() ].concat( pts );
	
				var curve = new SplineCurve( npts );
				this.curves.push( curve );
	
				this.currentPoint.copy( pts[ pts.length - 1 ] );
	
			},
	
			arc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {
	
				var x0 = this.currentPoint.x;
				var y0 = this.currentPoint.y;
	
				this.absarc( aX + x0, aY + y0, aRadius,
					aStartAngle, aEndAngle, aClockwise );
	
			},
	
			absarc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {
	
				this.absellipse( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );
	
			},
	
			ellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {
	
				var x0 = this.currentPoint.x;
				var y0 = this.currentPoint.y;
	
				this.absellipse( aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );
	
			},
	
			absellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {
	
				var curve = new EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );
	
				if ( this.curves.length > 0 ) {
	
					// if a previous curve is present, attempt to join
					var firstPoint = curve.getPoint( 0 );
	
					if ( ! firstPoint.equals( this.currentPoint ) ) {
	
						this.lineTo( firstPoint.x, firstPoint.y );
	
					}
	
				}
	
				this.curves.push( curve );
	
				var lastPoint = curve.getPoint( 1 );
				this.currentPoint.copy( lastPoint );
	
			}
	
		} );
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * Creates free form 2d path using series of points, lines or curves.
		 **/
	
		function Path( points ) {
	
			CurvePath.call( this );
			this.currentPoint = new Vector2();
	
			if ( points ) {
	
				this.fromPoints( points );
	
			}
	
		}
	
		Path.prototype = PathPrototype;
		PathPrototype.constructor = Path;
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * Defines a 2d shape plane using paths.
		 **/
	
		// STEP 1 Create a path.
		// STEP 2 Turn path into shape.
		// STEP 3 ExtrudeGeometry takes in Shape/Shapes
		// STEP 3a - Extract points from each shape, turn to vertices
		// STEP 3b - Triangulate each shape, add faces.
	
		function Shape() {
	
			Path.apply( this, arguments );
	
			this.holes = [];
	
		}
	
		Shape.prototype = Object.assign( Object.create( PathPrototype ), {
	
			constructor: Shape,
	
			getPointsHoles: function ( divisions ) {
	
				var holesPts = [];
	
				for ( var i = 0, l = this.holes.length; i < l; i ++ ) {
	
					holesPts[ i ] = this.holes[ i ].getPoints( divisions );
	
				}
	
				return holesPts;
	
			},
	
			// Get points of shape and holes (keypoints based on segments parameter)
	
			extractAllPoints: function ( divisions ) {
	
				return {
	
					shape: this.getPoints( divisions ),
					holes: this.getPointsHoles( divisions )
	
				};
	
			},
	
			extractPoints: function ( divisions ) {
	
				return this.extractAllPoints( divisions );
	
			}
	
		} );
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * minimal class for proxing functions to Path. Replaces old "extractSubpaths()"
		 **/
	
		function ShapePath() {
	
			this.subPaths = [];
			this.currentPath = null;
	
		}
	
		Object.assign( ShapePath.prototype, {
	
			moveTo: function ( x, y ) {
	
				this.currentPath = new Path();
				this.subPaths.push( this.currentPath );
				this.currentPath.moveTo( x, y );
	
			},
	
			lineTo: function ( x, y ) {
	
				this.currentPath.lineTo( x, y );
	
			},
	
			quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {
	
				this.currentPath.quadraticCurveTo( aCPx, aCPy, aX, aY );
	
			},
	
			bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {
	
				this.currentPath.bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY );
	
			},
	
			splineThru: function ( pts ) {
	
				this.currentPath.splineThru( pts );
	
			},
	
			toShapes: function ( isCCW, noHoles ) {
	
				function toShapesNoHoles( inSubpaths ) {
	
					var shapes = [];
	
					for ( var i = 0, l = inSubpaths.length; i < l; i ++ ) {
	
						var tmpPath = inSubpaths[ i ];
	
						var tmpShape = new Shape();
						tmpShape.curves = tmpPath.curves;
	
						shapes.push( tmpShape );
	
					}
	
					return shapes;
	
				}
	
				function isPointInsidePolygon( inPt, inPolygon ) {
	
					var polyLen = inPolygon.length;
	
					// inPt on polygon contour => immediate success    or
					// toggling of inside/outside at every single! intersection point of an edge
					//  with the horizontal line through inPt, left of inPt
					//  not counting lowerY endpoints of edges and whole edges on that line
					var inside = false;
					for ( var p = polyLen - 1, q = 0; q < polyLen; p = q ++ ) {
	
						var edgeLowPt  = inPolygon[ p ];
						var edgeHighPt = inPolygon[ q ];
	
						var edgeDx = edgeHighPt.x - edgeLowPt.x;
						var edgeDy = edgeHighPt.y - edgeLowPt.y;
	
						if ( Math.abs( edgeDy ) > Number.EPSILON ) {
	
							// not parallel
							if ( edgeDy < 0 ) {
	
								edgeLowPt  = inPolygon[ q ]; edgeDx = - edgeDx;
								edgeHighPt = inPolygon[ p ]; edgeDy = - edgeDy;
	
							}
							if ( ( inPt.y < edgeLowPt.y ) || ( inPt.y > edgeHighPt.y ) ) 		continue;
	
							if ( inPt.y === edgeLowPt.y ) {
	
								if ( inPt.x === edgeLowPt.x )		return	true;		// inPt is on contour ?
								// continue;				// no intersection or edgeLowPt => doesn't count !!!
	
							} else {
	
								var perpEdge = edgeDy * ( inPt.x - edgeLowPt.x ) - edgeDx * ( inPt.y - edgeLowPt.y );
								if ( perpEdge === 0 )				return	true;		// inPt is on contour ?
								if ( perpEdge < 0 ) 				continue;
								inside = ! inside;		// true intersection left of inPt
	
							}
	
						} else {
	
							// parallel or collinear
							if ( inPt.y !== edgeLowPt.y ) 		continue;			// parallel
							// edge lies on the same horizontal line as inPt
							if ( ( ( edgeHighPt.x <= inPt.x ) && ( inPt.x <= edgeLowPt.x ) ) ||
								 ( ( edgeLowPt.x <= inPt.x ) && ( inPt.x <= edgeHighPt.x ) ) )		return	true;	// inPt: Point on contour !
							// continue;
	
						}
	
					}
	
					return	inside;
	
				}
	
				var isClockWise = ShapeUtils.isClockWise;
	
				var subPaths = this.subPaths;
				if ( subPaths.length === 0 ) return [];
	
				if ( noHoles === true )	return	toShapesNoHoles( subPaths );
	
	
				var solid, tmpPath, tmpShape, shapes = [];
	
				if ( subPaths.length === 1 ) {
	
					tmpPath = subPaths[ 0 ];
					tmpShape = new Shape();
					tmpShape.curves = tmpPath.curves;
					shapes.push( tmpShape );
					return shapes;
	
				}
	
				var holesFirst = ! isClockWise( subPaths[ 0 ].getPoints() );
				holesFirst = isCCW ? ! holesFirst : holesFirst;
	
				// console.log("Holes first", holesFirst);
	
				var betterShapeHoles = [];
				var newShapes = [];
				var newShapeHoles = [];
				var mainIdx = 0;
				var tmpPoints;
	
				newShapes[ mainIdx ] = undefined;
				newShapeHoles[ mainIdx ] = [];
	
				for ( var i = 0, l = subPaths.length; i < l; i ++ ) {
	
					tmpPath = subPaths[ i ];
					tmpPoints = tmpPath.getPoints();
					solid = isClockWise( tmpPoints );
					solid = isCCW ? ! solid : solid;
	
					if ( solid ) {
	
						if ( ( ! holesFirst ) && ( newShapes[ mainIdx ] ) )	mainIdx ++;
	
						newShapes[ mainIdx ] = { s: new Shape(), p: tmpPoints };
						newShapes[ mainIdx ].s.curves = tmpPath.curves;
	
						if ( holesFirst )	mainIdx ++;
						newShapeHoles[ mainIdx ] = [];
	
						//console.log('cw', i);
	
					} else {
	
						newShapeHoles[ mainIdx ].push( { h: tmpPath, p: tmpPoints[ 0 ] } );
	
						//console.log('ccw', i);
	
					}
	
				}
	
				// only Holes? -> probably all Shapes with wrong orientation
				if ( ! newShapes[ 0 ] )	return	toShapesNoHoles( subPaths );
	
	
				if ( newShapes.length > 1 ) {
	
					var ambiguous = false;
					var toChange = [];
	
					for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {
	
						betterShapeHoles[ sIdx ] = [];
	
					}
	
					for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {
	
						var sho = newShapeHoles[ sIdx ];
	
						for ( var hIdx = 0; hIdx < sho.length; hIdx ++ ) {
	
							var ho = sho[ hIdx ];
							var hole_unassigned = true;
	
							for ( var s2Idx = 0; s2Idx < newShapes.length; s2Idx ++ ) {
	
								if ( isPointInsidePolygon( ho.p, newShapes[ s2Idx ].p ) ) {
	
									if ( sIdx !== s2Idx )	toChange.push( { froms: sIdx, tos: s2Idx, hole: hIdx } );
									if ( hole_unassigned ) {
	
										hole_unassigned = false;
										betterShapeHoles[ s2Idx ].push( ho );
	
									} else {
	
										ambiguous = true;
	
									}
	
								}
	
							}
							if ( hole_unassigned ) {
	
								betterShapeHoles[ sIdx ].push( ho );
	
							}
	
						}
	
					}
					// console.log("ambiguous: ", ambiguous);
					if ( toChange.length > 0 ) {
	
						// console.log("to change: ", toChange);
						if ( ! ambiguous )	newShapeHoles = betterShapeHoles;
	
					}
	
				}
	
				var tmpHoles;
	
				for ( var i = 0, il = newShapes.length; i < il; i ++ ) {
	
					tmpShape = newShapes[ i ].s;
					shapes.push( tmpShape );
					tmpHoles = newShapeHoles[ i ];
	
					for ( var j = 0, jl = tmpHoles.length; j < jl; j ++ ) {
	
						tmpShape.holes.push( tmpHoles[ j ].h );
	
					}
	
				}
	
				//console.log("shape", shapes);
	
				return shapes;
	
			}
	
		} );
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Font( data ) {
	
			this.data = data;
	
		}
	
		Object.assign( Font.prototype, {
	
			isFont: true,
	
			generateShapes: function ( text, size, divisions ) {
	
				function createPaths( text ) {
	
					var chars = String( text ).split( '' );
					var scale = size / data.resolution;
					var line_height = ( data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness ) * scale;
	
					var offsetX = 0, offsetY = 0;
	
					var paths = [];
	
					for ( var i = 0; i < chars.length; i ++ ) {
	
						var char = chars[ i ];
	
						if ( char === '\n' ) {
	
							offsetX = 0;
							offsetY -= line_height;
	
						} else {
	
							var ret = createPath( char, scale, offsetX, offsetY );
							offsetX += ret.offsetX;
							paths.push( ret.path );
	
						}
	
					}
	
					return paths;
	
				}
	
				function createPath( c, scale, offsetX, offsetY ) {
	
					var glyph = data.glyphs[ c ] || data.glyphs[ '?' ];
	
					if ( ! glyph ) return;
	
					var path = new ShapePath();
	
					var pts = [];
					var x, y, cpx, cpy, cpx0, cpy0, cpx1, cpy1, cpx2, cpy2, laste;
	
					if ( glyph.o ) {
	
						var outline = glyph._cachedOutline || ( glyph._cachedOutline = glyph.o.split( ' ' ) );
	
						for ( var i = 0, l = outline.length; i < l; ) {
	
							var action = outline[ i ++ ];
	
							switch ( action ) {
	
								case 'm': // moveTo
	
									x = outline[ i ++ ] * scale + offsetX;
									y = outline[ i ++ ] * scale + offsetY;
	
									path.moveTo( x, y );
	
									break;
	
								case 'l': // lineTo
	
									x = outline[ i ++ ] * scale + offsetX;
									y = outline[ i ++ ] * scale + offsetY;
	
									path.lineTo( x, y );
	
									break;
	
								case 'q': // quadraticCurveTo
	
									cpx  = outline[ i ++ ] * scale + offsetX;
									cpy  = outline[ i ++ ] * scale + offsetY;
									cpx1 = outline[ i ++ ] * scale + offsetX;
									cpy1 = outline[ i ++ ] * scale + offsetY;
	
									path.quadraticCurveTo( cpx1, cpy1, cpx, cpy );
	
									laste = pts[ pts.length - 1 ];
	
									if ( laste ) {
	
										cpx0 = laste.x;
										cpy0 = laste.y;
	
										for ( var i2 = 1; i2 <= divisions; i2 ++ ) {
	
											var t = i2 / divisions;
											QuadraticBezier( t, cpx0, cpx1, cpx );
											QuadraticBezier( t, cpy0, cpy1, cpy );
	
										}
	
									}
	
									break;
	
								case 'b': // bezierCurveTo
	
									cpx  = outline[ i ++ ] * scale + offsetX;
									cpy  = outline[ i ++ ] * scale + offsetY;
									cpx1 = outline[ i ++ ] * scale + offsetX;
									cpy1 = outline[ i ++ ] * scale + offsetY;
									cpx2 = outline[ i ++ ] * scale + offsetX;
									cpy2 = outline[ i ++ ] * scale + offsetY;
	
									path.bezierCurveTo( cpx1, cpy1, cpx2, cpy2, cpx, cpy );
	
									laste = pts[ pts.length - 1 ];
	
									if ( laste ) {
	
										cpx0 = laste.x;
										cpy0 = laste.y;
	
										for ( var i2 = 1; i2 <= divisions; i2 ++ ) {
	
											var t = i2 / divisions;
											CubicBezier( t, cpx0, cpx1, cpx2, cpx );
											CubicBezier( t, cpy0, cpy1, cpy2, cpy );
	
										}
	
									}
	
									break;
	
							}
	
						}
	
					}
	
					return { offsetX: glyph.ha * scale, path: path };
	
				}
	
				//
	
				if ( size === undefined ) size = 100;
				if ( divisions === undefined ) divisions = 4;
	
				var data = this.data;
	
				var paths = createPaths( text );
				var shapes = [];
	
				for ( var p = 0, pl = paths.length; p < pl; p ++ ) {
	
					Array.prototype.push.apply( shapes, paths[ p ].toShapes() );
	
				}
	
				return shapes;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function FontLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( FontLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var loader = new FileLoader( this.manager );
				loader.load( url, function ( text ) {
	
					var json;
	
					try {
	
						json = JSON.parse( text );
	
					} catch ( e ) {
	
						console.warn( 'THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.' );
						json = JSON.parse( text.substring( 65, text.length - 2 ) );
	
					}
	
					var font = scope.parse( json );
	
					if ( onLoad ) onLoad( font );
	
				}, onProgress, onError );
	
			},
	
			parse: function ( json ) {
	
				return new Font( json );
	
			}
	
		} );
	
		var context;
	
		var AudioContext = {
	
			getContext: function () {
	
				if ( context === undefined ) {
	
					context = new ( window.AudioContext || window.webkitAudioContext )();
	
				}
	
				return context;
	
			},
	
			setContext: function ( value ) {
	
				context = value;
	
			}
	
		};
	
		/**
		 * @author Reece Aaron Lecrivain / http://reecenotes.com/
		 */
	
		function AudioLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( AudioLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var loader = new FileLoader( this.manager );
				loader.setResponseType( 'arraybuffer' );
				loader.load( url, function ( buffer ) {
	
					var context = AudioContext.getContext();
	
					context.decodeAudioData( buffer, function ( audioBuffer ) {
	
						onLoad( audioBuffer );
	
					} );
	
				}, onProgress, onError );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function StereoCamera() {
	
			this.type = 'StereoCamera';
	
			this.aspect = 1;
	
			this.eyeSep = 0.064;
	
			this.cameraL = new PerspectiveCamera();
			this.cameraL.layers.enable( 1 );
			this.cameraL.matrixAutoUpdate = false;
	
			this.cameraR = new PerspectiveCamera();
			this.cameraR.layers.enable( 2 );
			this.cameraR.matrixAutoUpdate = false;
	
		}
	
		Object.assign( StereoCamera.prototype, {
	
			update: ( function () {
	
				var instance, focus, fov, aspect, near, far, zoom, eyeSep;
	
				var eyeRight = new Matrix4();
				var eyeLeft = new Matrix4();
	
				return function update( camera ) {
	
					var needsUpdate = instance !== this || focus !== camera.focus || fov !== camera.fov ||
														aspect !== camera.aspect * this.aspect || near !== camera.near ||
														far !== camera.far || zoom !== camera.zoom || eyeSep !== this.eyeSep;
	
					if ( needsUpdate ) {
	
						instance = this;
						focus = camera.focus;
						fov = camera.fov;
						aspect = camera.aspect * this.aspect;
						near = camera.near;
						far = camera.far;
						zoom = camera.zoom;
	
						// Off-axis stereoscopic effect based on
						// http://paulbourke.net/stereographics/stereorender/
	
						var projectionMatrix = camera.projectionMatrix.clone();
						eyeSep = this.eyeSep / 2;
						var eyeSepOnProjection = eyeSep * near / focus;
						var ymax = ( near * Math.tan( _Math.DEG2RAD * fov * 0.5 ) ) / zoom;
						var xmin, xmax;
	
						// translate xOffset
	
						eyeLeft.elements[ 12 ] = - eyeSep;
						eyeRight.elements[ 12 ] = eyeSep;
	
						// for left eye
	
						xmin = - ymax * aspect + eyeSepOnProjection;
						xmax = ymax * aspect + eyeSepOnProjection;
	
						projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
						projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );
	
						this.cameraL.projectionMatrix.copy( projectionMatrix );
	
						// for right eye
	
						xmin = - ymax * aspect - eyeSepOnProjection;
						xmax = ymax * aspect - eyeSepOnProjection;
	
						projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
						projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );
	
						this.cameraR.projectionMatrix.copy( projectionMatrix );
	
					}
	
					this.cameraL.matrixWorld.copy( camera.matrixWorld ).multiply( eyeLeft );
					this.cameraR.matrixWorld.copy( camera.matrixWorld ).multiply( eyeRight );
	
				};
	
			} )()
	
		} );
	
		/**
		 * Camera for rendering cube maps
		 *	- renders scene into axis-aligned cube
		 *
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function CubeCamera( near, far, cubeResolution ) {
	
			Object3D.call( this );
	
			this.type = 'CubeCamera';
	
			var fov = 90, aspect = 1;
	
			var cameraPX = new PerspectiveCamera( fov, aspect, near, far );
			cameraPX.up.set( 0, - 1, 0 );
			cameraPX.lookAt( new Vector3( 1, 0, 0 ) );
			this.add( cameraPX );
	
			var cameraNX = new PerspectiveCamera( fov, aspect, near, far );
			cameraNX.up.set( 0, - 1, 0 );
			cameraNX.lookAt( new Vector3( - 1, 0, 0 ) );
			this.add( cameraNX );
	
			var cameraPY = new PerspectiveCamera( fov, aspect, near, far );
			cameraPY.up.set( 0, 0, 1 );
			cameraPY.lookAt( new Vector3( 0, 1, 0 ) );
			this.add( cameraPY );
	
			var cameraNY = new PerspectiveCamera( fov, aspect, near, far );
			cameraNY.up.set( 0, 0, - 1 );
			cameraNY.lookAt( new Vector3( 0, - 1, 0 ) );
			this.add( cameraNY );
	
			var cameraPZ = new PerspectiveCamera( fov, aspect, near, far );
			cameraPZ.up.set( 0, - 1, 0 );
			cameraPZ.lookAt( new Vector3( 0, 0, 1 ) );
			this.add( cameraPZ );
	
			var cameraNZ = new PerspectiveCamera( fov, aspect, near, far );
			cameraNZ.up.set( 0, - 1, 0 );
			cameraNZ.lookAt( new Vector3( 0, 0, - 1 ) );
			this.add( cameraNZ );
	
			var options = { format: RGBFormat, magFilter: LinearFilter, minFilter: LinearFilter };
	
			this.renderTarget = new WebGLRenderTargetCube( cubeResolution, cubeResolution, options );
			this.renderTarget.texture.name = "CubeCamera";
	
			this.update = function ( renderer, scene ) {
	
				if ( this.parent === null ) this.updateMatrixWorld();
	
				var renderTarget = this.renderTarget;
				var generateMipmaps = renderTarget.texture.generateMipmaps;
	
				renderTarget.texture.generateMipmaps = false;
	
				renderTarget.activeCubeFace = 0;
				renderer.render( scene, cameraPX, renderTarget );
	
				renderTarget.activeCubeFace = 1;
				renderer.render( scene, cameraNX, renderTarget );
	
				renderTarget.activeCubeFace = 2;
				renderer.render( scene, cameraPY, renderTarget );
	
				renderTarget.activeCubeFace = 3;
				renderer.render( scene, cameraNY, renderTarget );
	
				renderTarget.activeCubeFace = 4;
				renderer.render( scene, cameraPZ, renderTarget );
	
				renderTarget.texture.generateMipmaps = generateMipmaps;
	
				renderTarget.activeCubeFace = 5;
				renderer.render( scene, cameraNZ, renderTarget );
	
				renderer.setRenderTarget( null );
	
			};
	
			this.clear = function ( renderer, color, depth, stencil ) {
	
				var renderTarget = this.renderTarget;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					renderTarget.activeCubeFace = i;
					renderer.setRenderTarget( renderTarget );
	
					renderer.clear( color, depth, stencil );
	
				}
	
				renderer.setRenderTarget( null );
	
			};
	
		}
	
		CubeCamera.prototype = Object.create( Object3D.prototype );
		CubeCamera.prototype.constructor = CubeCamera;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AudioListener() {
	
			Object3D.call( this );
	
			this.type = 'AudioListener';
	
			this.context = AudioContext.getContext();
	
			this.gain = this.context.createGain();
			this.gain.connect( this.context.destination );
	
			this.filter = null;
	
		}
	
		AudioListener.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: AudioListener,
	
			getInput: function () {
	
				return this.gain;
	
			},
	
			removeFilter: function ( ) {
	
				if ( this.filter !== null ) {
	
					this.gain.disconnect( this.filter );
					this.filter.disconnect( this.context.destination );
					this.gain.connect( this.context.destination );
					this.filter = null;
	
				}
	
			},
	
			getFilter: function () {
	
				return this.filter;
	
			},
	
			setFilter: function ( value ) {
	
				if ( this.filter !== null ) {
	
					this.gain.disconnect( this.filter );
					this.filter.disconnect( this.context.destination );
	
				} else {
	
					this.gain.disconnect( this.context.destination );
	
				}
	
				this.filter = value;
				this.gain.connect( this.filter );
				this.filter.connect( this.context.destination );
	
			},
	
			getMasterVolume: function () {
	
				return this.gain.gain.value;
	
			},
	
			setMasterVolume: function ( value ) {
	
				this.gain.gain.value = value;
	
			},
	
			updateMatrixWorld: ( function () {
	
				var position = new Vector3();
				var quaternion = new Quaternion();
				var scale = new Vector3();
	
				var orientation = new Vector3();
	
				return function updateMatrixWorld( force ) {
	
					Object3D.prototype.updateMatrixWorld.call( this, force );
	
					var listener = this.context.listener;
					var up = this.up;
	
					this.matrixWorld.decompose( position, quaternion, scale );
	
					orientation.set( 0, 0, - 1 ).applyQuaternion( quaternion );
	
					if ( listener.positionX ) {
	
						listener.positionX.setValueAtTime( position.x, this.context.currentTime );
						listener.positionY.setValueAtTime( position.y, this.context.currentTime );
						listener.positionZ.setValueAtTime( position.z, this.context.currentTime );
						listener.forwardX.setValueAtTime( orientation.x, this.context.currentTime );
						listener.forwardY.setValueAtTime( orientation.y, this.context.currentTime );
						listener.forwardZ.setValueAtTime( orientation.z, this.context.currentTime );
						listener.upX.setValueAtTime( up.x, this.context.currentTime );
						listener.upY.setValueAtTime( up.y, this.context.currentTime );
						listener.upZ.setValueAtTime( up.z, this.context.currentTime );
	
					} else {
	
						listener.setPosition( position.x, position.y, position.z );
						listener.setOrientation( orientation.x, orientation.y, orientation.z, up.x, up.y, up.z );
	
					}
	
				};
	
			} )()
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Reece Aaron Lecrivain / http://reecenotes.com/
		 */
	
		function Audio( listener ) {
	
			Object3D.call( this );
	
			this.type = 'Audio';
	
			this.context = listener.context;
	
			this.gain = this.context.createGain();
			this.gain.connect( listener.getInput() );
	
			this.autoplay = false;
	
			this.buffer = null;
			this.loop = false;
			this.startTime = 0;
			this.playbackRate = 1;
			this.isPlaying = false;
			this.hasPlaybackControl = true;
			this.sourceType = 'empty';
	
			this.filters = [];
	
		}
	
		Audio.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Audio,
	
			getOutput: function () {
	
				return this.gain;
	
			},
	
			setNodeSource: function ( audioNode ) {
	
				this.hasPlaybackControl = false;
				this.sourceType = 'audioNode';
				this.source = audioNode;
				this.connect();
	
				return this;
	
			},
	
			setBuffer: function ( audioBuffer ) {
	
				this.buffer = audioBuffer;
				this.sourceType = 'buffer';
	
				if ( this.autoplay ) this.play();
	
				return this;
	
			},
	
			play: function () {
	
				if ( this.isPlaying === true ) {
	
					console.warn( 'THREE.Audio: Audio is already playing.' );
					return;
	
				}
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				var source = this.context.createBufferSource();
	
				source.buffer = this.buffer;
				source.loop = this.loop;
				source.onended = this.onEnded.bind( this );
				source.playbackRate.setValueAtTime( this.playbackRate, this.startTime );
				source.start( 0, this.startTime );
	
				this.isPlaying = true;
	
				this.source = source;
	
				return this.connect();
	
			},
	
			pause: function () {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.source.stop();
				this.startTime = this.context.currentTime;
				this.isPlaying = false;
	
				return this;
	
			},
	
			stop: function () {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.source.stop();
				this.startTime = 0;
				this.isPlaying = false;
	
				return this;
	
			},
	
			connect: function () {
	
				if ( this.filters.length > 0 ) {
	
					this.source.connect( this.filters[ 0 ] );
	
					for ( var i = 1, l = this.filters.length; i < l; i ++ ) {
	
						this.filters[ i - 1 ].connect( this.filters[ i ] );
	
					}
	
					this.filters[ this.filters.length - 1 ].connect( this.getOutput() );
	
				} else {
	
					this.source.connect( this.getOutput() );
	
				}
	
				return this;
	
			},
	
			disconnect: function () {
	
				if ( this.filters.length > 0 ) {
	
					this.source.disconnect( this.filters[ 0 ] );
	
					for ( var i = 1, l = this.filters.length; i < l; i ++ ) {
	
						this.filters[ i - 1 ].disconnect( this.filters[ i ] );
	
					}
	
					this.filters[ this.filters.length - 1 ].disconnect( this.getOutput() );
	
				} else {
	
					this.source.disconnect( this.getOutput() );
	
				}
	
				return this;
	
			},
	
			getFilters: function () {
	
				return this.filters;
	
			},
	
			setFilters: function ( value ) {
	
				if ( ! value ) value = [];
	
				if ( this.isPlaying === true ) {
	
					this.disconnect();
					this.filters = value;
					this.connect();
	
				} else {
	
					this.filters = value;
	
				}
	
				return this;
	
			},
	
			getFilter: function () {
	
				return this.getFilters()[ 0 ];
	
			},
	
			setFilter: function ( filter ) {
	
				return this.setFilters( filter ? [ filter ] : [] );
	
			},
	
			setPlaybackRate: function ( value ) {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.playbackRate = value;
	
				if ( this.isPlaying === true ) {
	
					this.source.playbackRate.setValueAtTime( this.playbackRate, this.context.currentTime );
	
				}
	
				return this;
	
			},
	
			getPlaybackRate: function () {
	
				return this.playbackRate;
	
			},
	
			onEnded: function () {
	
				this.isPlaying = false;
	
			},
	
			getLoop: function () {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return false;
	
				}
	
				return this.loop;
	
			},
	
			setLoop: function ( value ) {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.loop = value;
	
				if ( this.isPlaying === true ) {
	
					this.source.loop = this.loop;
	
				}
	
				return this;
	
			},
	
			getVolume: function () {
	
				return this.gain.gain.value;
	
			},
	
			setVolume: function ( value ) {
	
				this.gain.gain.value = value;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function PositionalAudio( listener ) {
	
			Audio.call( this, listener );
	
			this.panner = this.context.createPanner();
			this.panner.connect( this.gain );
	
		}
	
		PositionalAudio.prototype = Object.assign( Object.create( Audio.prototype ), {
	
			constructor: PositionalAudio,
	
			getOutput: function () {
	
				return this.panner;
	
			},
	
			getRefDistance: function () {
	
				return this.panner.refDistance;
	
			},
	
			setRefDistance: function ( value ) {
	
				this.panner.refDistance = value;
	
			},
	
			getRolloffFactor: function () {
	
				return this.panner.rolloffFactor;
	
			},
	
			setRolloffFactor: function ( value ) {
	
				this.panner.rolloffFactor = value;
	
			},
	
			getDistanceModel: function () {
	
				return this.panner.distanceModel;
	
			},
	
			setDistanceModel: function ( value ) {
	
				this.panner.distanceModel = value;
	
			},
	
			getMaxDistance: function () {
	
				return this.panner.maxDistance;
	
			},
	
			setMaxDistance: function ( value ) {
	
				this.panner.maxDistance = value;
	
			},
	
			updateMatrixWorld: ( function () {
	
				var position = new Vector3();
	
				return function updateMatrixWorld( force ) {
	
					Object3D.prototype.updateMatrixWorld.call( this, force );
	
					position.setFromMatrixPosition( this.matrixWorld );
	
					this.panner.setPosition( position.x, position.y, position.z );
	
				};
	
			} )()
	
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AudioAnalyser( audio, fftSize ) {
	
			this.analyser = audio.context.createAnalyser();
			this.analyser.fftSize = fftSize !== undefined ? fftSize : 2048;
	
			this.data = new Uint8Array( this.analyser.frequencyBinCount );
	
			audio.getOutput().connect( this.analyser );
	
		}
	
		Object.assign( AudioAnalyser.prototype, {
	
			getFrequencyData: function () {
	
				this.analyser.getByteFrequencyData( this.data );
	
				return this.data;
	
			},
	
			getAverageFrequency: function () {
	
				var value = 0, data = this.getFrequencyData();
	
				for ( var i = 0; i < data.length; i ++ ) {
	
					value += data[ i ];
	
				}
	
				return value / data.length;
	
			}
	
		} );
	
		/**
		 *
		 * Buffered scene graph property that allows weighted accumulation.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function PropertyMixer( binding, typeName, valueSize ) {
	
			this.binding = binding;
			this.valueSize = valueSize;
	
			var bufferType = Float64Array,
				mixFunction;
	
			switch ( typeName ) {
	
				case 'quaternion':
					mixFunction = this._slerp;
					break;
	
				case 'string':
				case 'bool':
					bufferType = Array;
					mixFunction = this._select;
					break;
	
				default:
					mixFunction = this._lerp;
	
			}
	
			this.buffer = new bufferType( valueSize * 4 );
			// layout: [ incoming | accu0 | accu1 | orig ]
			//
			// interpolators can use .buffer as their .result
			// the data then goes to 'incoming'
			//
			// 'accu0' and 'accu1' are used frame-interleaved for
			// the cumulative result and are compared to detect
			// changes
			//
			// 'orig' stores the original state of the property
	
			this._mixBufferRegion = mixFunction;
	
			this.cumulativeWeight = 0;
	
			this.useCount = 0;
			this.referenceCount = 0;
	
		}
	
		Object.assign( PropertyMixer.prototype, {
	
			// accumulate data in the 'incoming' region into 'accu<i>'
			accumulate: function ( accuIndex, weight ) {
	
				// note: happily accumulating nothing when weight = 0, the caller knows
				// the weight and shouldn't have made the call in the first place
	
				var buffer = this.buffer,
					stride = this.valueSize,
					offset = accuIndex * stride + stride,
	
					currentWeight = this.cumulativeWeight;
	
				if ( currentWeight === 0 ) {
	
					// accuN := incoming * weight
	
					for ( var i = 0; i !== stride; ++ i ) {
	
						buffer[ offset + i ] = buffer[ i ];
	
					}
	
					currentWeight = weight;
	
				} else {
	
					// accuN := accuN + incoming * weight
	
					currentWeight += weight;
					var mix = weight / currentWeight;
					this._mixBufferRegion( buffer, offset, 0, mix, stride );
	
				}
	
				this.cumulativeWeight = currentWeight;
	
			},
	
			// apply the state of 'accu<i>' to the binding when accus differ
			apply: function ( accuIndex ) {
	
				var stride = this.valueSize,
					buffer = this.buffer,
					offset = accuIndex * stride + stride,
	
					weight = this.cumulativeWeight,
	
					binding = this.binding;
	
				this.cumulativeWeight = 0;
	
				if ( weight < 1 ) {
	
					// accuN := accuN + original * ( 1 - cumulativeWeight )
	
					var originalValueOffset = stride * 3;
	
					this._mixBufferRegion(
						buffer, offset, originalValueOffset, 1 - weight, stride );
	
				}
	
				for ( var i = stride, e = stride + stride; i !== e; ++ i ) {
	
					if ( buffer[ i ] !== buffer[ i + stride ] ) {
	
						// value has changed -> update scene graph
	
						binding.setValue( buffer, offset );
						break;
	
					}
	
				}
	
			},
	
			// remember the state of the bound property and copy it to both accus
			saveOriginalState: function () {
	
				var binding = this.binding;
	
				var buffer = this.buffer,
					stride = this.valueSize,
	
					originalValueOffset = stride * 3;
	
				binding.getValue( buffer, originalValueOffset );
	
				// accu[0..1] := orig -- initially detect changes against the original
				for ( var i = stride, e = originalValueOffset; i !== e; ++ i ) {
	
					buffer[ i ] = buffer[ originalValueOffset + ( i % stride ) ];
	
				}
	
				this.cumulativeWeight = 0;
	
			},
	
			// apply the state previously taken via 'saveOriginalState' to the binding
			restoreOriginalState: function () {
	
				var originalValueOffset = this.valueSize * 3;
				this.binding.setValue( this.buffer, originalValueOffset );
	
			},
	
	
			// mix functions
	
			_select: function ( buffer, dstOffset, srcOffset, t, stride ) {
	
				if ( t >= 0.5 ) {
	
					for ( var i = 0; i !== stride; ++ i ) {
	
						buffer[ dstOffset + i ] = buffer[ srcOffset + i ];
	
					}
	
				}
	
			},
	
			_slerp: function ( buffer, dstOffset, srcOffset, t ) {
	
				Quaternion.slerpFlat( buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t );
	
			},
	
			_lerp: function ( buffer, dstOffset, srcOffset, t, stride ) {
	
				var s = 1 - t;
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					var j = dstOffset + i;
	
					buffer[ j ] = buffer[ j ] * s + buffer[ srcOffset + i ] * t;
	
				}
	
			}
	
		} );
	
		/**
		 *
		 * A reference to a real property in the scene graph.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function Composite( targetGroup, path, optionalParsedPath ) {
	
			var parsedPath = optionalParsedPath || PropertyBinding.parseTrackName( path );
	
			this._targetGroup = targetGroup;
			this._bindings = targetGroup.subscribe_( path, parsedPath );
	
		}
	
		Object.assign( Composite.prototype, {
	
			getValue: function ( array, offset ) {
	
				this.bind(); // bind all binding
	
				var firstValidIndex = this._targetGroup.nCachedObjects_,
					binding = this._bindings[ firstValidIndex ];
	
				// and only call .getValue on the first
				if ( binding !== undefined ) binding.getValue( array, offset );
	
			},
	
			setValue: function ( array, offset ) {
	
				var bindings = this._bindings;
	
				for ( var i = this._targetGroup.nCachedObjects_,
						  n = bindings.length; i !== n; ++ i ) {
	
					bindings[ i ].setValue( array, offset );
	
				}
	
			},
	
			bind: function () {
	
				var bindings = this._bindings;
	
				for ( var i = this._targetGroup.nCachedObjects_,
						  n = bindings.length; i !== n; ++ i ) {
	
					bindings[ i ].bind();
	
				}
	
			},
	
			unbind: function () {
	
				var bindings = this._bindings;
	
				for ( var i = this._targetGroup.nCachedObjects_,
						  n = bindings.length; i !== n; ++ i ) {
	
					bindings[ i ].unbind();
	
				}
	
			}
	
		} );
	
	
		function PropertyBinding( rootNode, path, parsedPath ) {
	
			this.path = path;
			this.parsedPath = parsedPath || PropertyBinding.parseTrackName( path );
	
			this.node = PropertyBinding.findNode( rootNode, this.parsedPath.nodeName ) || rootNode;
	
			this.rootNode = rootNode;
	
		}
	
		Object.assign( PropertyBinding, {
	
			Composite: Composite,
	
			create: function ( root, path, parsedPath ) {
	
				if ( ! ( root && root.isAnimationObjectGroup ) ) {
	
					return new PropertyBinding( root, path, parsedPath );
	
				} else {
	
					return new PropertyBinding.Composite( root, path, parsedPath );
	
				}
	
			},
	
			/**
			 * Replaces spaces with underscores and removes unsupported characters from
			 * node names, to ensure compatibility with parseTrackName().
			 *
			 * @param  {string} name Node name to be sanitized.
			 * @return {string}
			 */
			sanitizeNodeName: function ( name ) {
	
				return name.replace( /\s/g, '_' ).replace( /[^\w-]/g, '' );
	
			},
	
			parseTrackName: function () {
	
				// Parent directories, delimited by '/' or ':'. Currently unused, but must
				// be matched to parse the rest of the track name.
				var directoryRe = /((?:[\w-]+[\/:])*)/;
	
				// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
				var nodeRe = /([\w-\.]+)?/;
	
				// Object on target node, and accessor. Name may contain only word
				// characters. Accessor may contain any character except closing bracket.
				var objectRe = /(?:\.([\w-]+)(?:\[(.+)\])?)?/;
	
				// Property and accessor. May contain only word characters. Accessor may
				// contain any non-bracket characters.
				var propertyRe = /\.([\w-]+)(?:\[(.+)\])?/;
	
				var trackRe = new RegExp(''
					+ '^'
					+ directoryRe.source
					+ nodeRe.source
					+ objectRe.source
					+ propertyRe.source
					+ '$'
				);
	
				var supportedObjectNames = [ 'material', 'materials', 'bones' ];
	
				return function ( trackName ) {
	
						var matches = trackRe.exec( trackName );
	
						if ( ! matches ) {
	
							throw new Error( 'PropertyBinding: Cannot parse trackName: ' + trackName );
	
						}
	
						var results = {
							// directoryName: matches[ 1 ], // (tschw) currently unused
							nodeName: matches[ 2 ],
							objectName: matches[ 3 ],
							objectIndex: matches[ 4 ],
							propertyName: matches[ 5 ],     // required
							propertyIndex: matches[ 6 ]
						};
	
						var lastDot = results.nodeName && results.nodeName.lastIndexOf( '.' );
	
						if ( lastDot !== undefined && lastDot !== -1 ) {
	
							var objectName = results.nodeName.substring( lastDot + 1 );
	
							// Object names must be checked against a whitelist. Otherwise, there
							// is no way to parse 'foo.bar.baz': 'baz' must be a property, but
							// 'bar' could be the objectName, or part of a nodeName (which can
							// include '.' characters).
							if ( supportedObjectNames.indexOf( objectName ) !== -1 ) {
	
								results.nodeName = results.nodeName.substring( 0, lastDot );
								results.objectName = objectName;
	
							}
	
						}
	
						if ( results.propertyName === null || results.propertyName.length === 0 ) {
	
							throw new Error( 'PropertyBinding: can not parse propertyName from trackName: ' + trackName );
	
						}
	
						return results;
	
					};
	
			}(),
	
			findNode: function ( root, nodeName ) {
	
				if ( ! nodeName || nodeName === "" || nodeName === "root" || nodeName === "." || nodeName === - 1 || nodeName === root.name || nodeName === root.uuid ) {
	
					return root;
	
				}
	
				// search into skeleton bones.
				if ( root.skeleton ) {
	
					var searchSkeleton = function ( skeleton ) {
	
						for ( var i = 0; i < skeleton.bones.length; i ++ ) {
	
							var bone = skeleton.bones[ i ];
	
							if ( bone.name === nodeName ) {
	
								return bone;
	
							}
	
						}
	
						return null;
	
					};
	
					var bone = searchSkeleton( root.skeleton );
	
					if ( bone ) {
	
						return bone;
	
					}
	
				}
	
				// search into node subtree.
				if ( root.children ) {
	
					var searchNodeSubtree = function ( children ) {
	
						for ( var i = 0; i < children.length; i ++ ) {
	
							var childNode = children[ i ];
	
							if ( childNode.name === nodeName || childNode.uuid === nodeName ) {
	
								return childNode;
	
							}
	
							var result = searchNodeSubtree( childNode.children );
	
							if ( result ) return result;
	
						}
	
						return null;
	
					};
	
					var subTreeNode = searchNodeSubtree( root.children );
	
					if ( subTreeNode ) {
	
						return subTreeNode;
	
					}
	
				}
	
				return null;
	
			}
	
		} );
	
		Object.assign( PropertyBinding.prototype, { // prototype, continued
	
			// these are used to "bind" a nonexistent property
			_getValue_unavailable: function () {},
			_setValue_unavailable: function () {},
	
			BindingType: {
				Direct: 0,
				EntireArray: 1,
				ArrayElement: 2,
				HasFromToArray: 3
			},
	
			Versioning: {
				None: 0,
				NeedsUpdate: 1,
				MatrixWorldNeedsUpdate: 2
			},
	
			GetterByBindingType: [
	
				function getValue_direct( buffer, offset ) {
	
					buffer[ offset ] = this.node[ this.propertyName ];
	
				},
	
				function getValue_array( buffer, offset ) {
	
					var source = this.resolvedProperty;
	
					for ( var i = 0, n = source.length; i !== n; ++ i ) {
	
						buffer[ offset ++ ] = source[ i ];
	
					}
	
				},
	
				function getValue_arrayElement( buffer, offset ) {
	
					buffer[ offset ] = this.resolvedProperty[ this.propertyIndex ];
	
				},
	
				function getValue_toArray( buffer, offset ) {
	
					this.resolvedProperty.toArray( buffer, offset );
	
				}
	
			],
	
			SetterByBindingTypeAndVersioning: [
	
				[
					// Direct
	
					function setValue_direct( buffer, offset ) {
	
						this.node[ this.propertyName ] = buffer[ offset ];
	
					},
	
					function setValue_direct_setNeedsUpdate( buffer, offset ) {
	
						this.node[ this.propertyName ] = buffer[ offset ];
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_direct_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						this.node[ this.propertyName ] = buffer[ offset ];
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				], [
	
					// EntireArray
	
					function setValue_array( buffer, offset ) {
	
						var dest = this.resolvedProperty;
	
						for ( var i = 0, n = dest.length; i !== n; ++ i ) {
	
							dest[ i ] = buffer[ offset ++ ];
	
						}
	
					},
	
					function setValue_array_setNeedsUpdate( buffer, offset ) {
	
						var dest = this.resolvedProperty;
	
						for ( var i = 0, n = dest.length; i !== n; ++ i ) {
	
							dest[ i ] = buffer[ offset ++ ];
	
						}
	
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_array_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						var dest = this.resolvedProperty;
	
						for ( var i = 0, n = dest.length; i !== n; ++ i ) {
	
							dest[ i ] = buffer[ offset ++ ];
	
						}
	
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				], [
	
					// ArrayElement
	
					function setValue_arrayElement( buffer, offset ) {
	
						this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
	
					},
	
					function setValue_arrayElement_setNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_arrayElement_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				], [
	
					// HasToFromArray
	
					function setValue_fromArray( buffer, offset ) {
	
						this.resolvedProperty.fromArray( buffer, offset );
	
					},
	
					function setValue_fromArray_setNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty.fromArray( buffer, offset );
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_fromArray_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty.fromArray( buffer, offset );
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				]
	
			],
	
			getValue: function getValue_unbound( targetArray, offset ) {
	
				this.bind();
				this.getValue( targetArray, offset );
	
				// Note: This class uses a State pattern on a per-method basis:
				// 'bind' sets 'this.getValue' / 'setValue' and shadows the
				// prototype version of these methods with one that represents
				// the bound state. When the property is not found, the methods
				// become no-ops.
	
			},
	
			setValue: function getValue_unbound( sourceArray, offset ) {
	
				this.bind();
				this.setValue( sourceArray, offset );
	
			},
	
			// create getter / setter pair for a property in the scene graph
			bind: function () {
	
				var targetObject = this.node,
					parsedPath = this.parsedPath,
	
					objectName = parsedPath.objectName,
					propertyName = parsedPath.propertyName,
					propertyIndex = parsedPath.propertyIndex;
	
				if ( ! targetObject ) {
	
					targetObject = PropertyBinding.findNode(
							this.rootNode, parsedPath.nodeName ) || this.rootNode;
	
					this.node = targetObject;
	
				}
	
				// set fail state so we can just 'return' on error
				this.getValue = this._getValue_unavailable;
				this.setValue = this._setValue_unavailable;
	
				// ensure there is a value node
				if ( ! targetObject ) {
	
					console.error( 'THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.' );
					return;
	
				}
	
				if ( objectName ) {
	
					var objectIndex = parsedPath.objectIndex;
	
					// special cases were we need to reach deeper into the hierarchy to get the face materials....
					switch ( objectName ) {
	
						case 'materials':
	
							if ( ! targetObject.material ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to material as node does not have a material.', this );
								return;
	
							}
	
							if ( ! targetObject.material.materials ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this );
								return;
	
							}
	
							targetObject = targetObject.material.materials;
	
							break;
	
						case 'bones':
	
							if ( ! targetObject.skeleton ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this );
								return;
	
							}
	
							// potential future optimization: skip this if propertyIndex is already an integer
							// and convert the integer string to a true integer.
	
							targetObject = targetObject.skeleton.bones;
	
							// support resolving morphTarget names into indices.
							for ( var i = 0; i < targetObject.length; i ++ ) {
	
								if ( targetObject[ i ].name === objectIndex ) {
	
									objectIndex = i;
									break;
	
								}
	
							}
	
							break;
	
						default:
	
							if ( targetObject[ objectName ] === undefined ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to objectName of node undefined.', this );
								return;
	
							}
	
							targetObject = targetObject[ objectName ];
	
					}
	
	
					if ( objectIndex !== undefined ) {
	
						if ( targetObject[ objectIndex ] === undefined ) {
	
							console.error( 'THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject );
							return;
	
						}
	
						targetObject = targetObject[ objectIndex ];
	
					}
	
				}
	
				// resolve property
				var nodeProperty = targetObject[ propertyName ];
	
				if ( nodeProperty === undefined ) {
	
					var nodeName = parsedPath.nodeName;
	
					console.error( 'THREE.PropertyBinding: Trying to update property for track: ' + nodeName +
						'.' + propertyName + ' but it wasn\'t found.', targetObject );
					return;
	
				}
	
				// determine versioning scheme
				var versioning = this.Versioning.None;
	
				if ( targetObject.needsUpdate !== undefined ) { // material
	
					versioning = this.Versioning.NeedsUpdate;
					this.targetObject = targetObject;
	
				} else if ( targetObject.matrixWorldNeedsUpdate !== undefined ) { // node transform
	
					versioning = this.Versioning.MatrixWorldNeedsUpdate;
					this.targetObject = targetObject;
	
				}
	
				// determine how the property gets bound
				var bindingType = this.BindingType.Direct;
	
				if ( propertyIndex !== undefined ) {
	
					// access a sub element of the property array (only primitives are supported right now)
	
					if ( propertyName === "morphTargetInfluences" ) {
	
						// potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
	
						// support resolving morphTarget names into indices.
						if ( ! targetObject.geometry ) {
	
							console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this );
							return;
	
						}
	
						if ( targetObject.geometry.isBufferGeometry ) {
	
							if ( ! targetObject.geometry.morphAttributes ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this );
								return;
	
							}
	
							for ( var i = 0; i < this.node.geometry.morphAttributes.position.length; i ++ ) {
	
								if ( targetObject.geometry.morphAttributes.position[ i ].name === propertyIndex ) {
	
									propertyIndex = i;
									break;
	
								}
	
							}
	
	
						} else {
	
							if ( ! targetObject.geometry.morphTargets ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphTargets.', this );
								return;
	
							}
	
							for ( var i = 0; i < this.node.geometry.morphTargets.length; i ++ ) {
	
								if ( targetObject.geometry.morphTargets[ i ].name === propertyIndex ) {
	
									propertyIndex = i;
									break;
	
								}
	
							}
	
						}
	
					}
	
					bindingType = this.BindingType.ArrayElement;
	
					this.resolvedProperty = nodeProperty;
					this.propertyIndex = propertyIndex;
	
				} else if ( nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined ) {
	
					// must use copy for Object3D.Euler/Quaternion
	
					bindingType = this.BindingType.HasFromToArray;
	
					this.resolvedProperty = nodeProperty;
	
				} else if ( Array.isArray( nodeProperty ) ) {
	
					bindingType = this.BindingType.EntireArray;
	
					this.resolvedProperty = nodeProperty;
	
				} else {
	
					this.propertyName = propertyName;
	
				}
	
				// select getter / setter
				this.getValue = this.GetterByBindingType[ bindingType ];
				this.setValue = this.SetterByBindingTypeAndVersioning[ bindingType ][ versioning ];
	
			},
	
			unbind: function () {
	
				this.node = null;
	
				// back to the prototype version of getValue / setValue
				// note: avoiding to mutate the shape of 'this' via 'delete'
				this.getValue = this._getValue_unbound;
				this.setValue = this._setValue_unbound;
	
			}
	
		} );
	
		//!\ DECLARE ALIAS AFTER assign prototype !
		Object.assign( PropertyBinding.prototype, {
	
			// initial state of these methods that calls 'bind'
			_getValue_unbound: PropertyBinding.prototype.getValue,
			_setValue_unbound: PropertyBinding.prototype.setValue,
	
		} );
	
		/**
		 *
		 * A group of objects that receives a shared animation state.
		 *
		 * Usage:
		 *
		 * 	-	Add objects you would otherwise pass as 'root' to the
		 * 		constructor or the .clipAction method of AnimationMixer.
		 *
		 * 	-	Instead pass this object as 'root'.
		 *
		 * 	-	You can also add and remove objects later when the mixer
		 * 		is running.
		 *
		 * Note:
		 *
		 *  	Objects of this class appear as one object to the mixer,
		 *  	so cache control of the individual objects must be done
		 *  	on the group.
		 *
		 * Limitation:
		 *
		 * 	- 	The animated properties must be compatible among the
		 * 		all objects in the group.
		 *
		 *  -	A single property can either be controlled through a
		 *  	target group or directly, but not both.
		 *
		 * @author tschw
		 */
	
		function AnimationObjectGroup( var_args ) {
	
			this.uuid = _Math.generateUUID();
	
			// cached objects followed by the active ones
			this._objects = Array.prototype.slice.call( arguments );
	
			this.nCachedObjects_ = 0;			// threshold
			// note: read by PropertyBinding.Composite
	
			var indices = {};
			this._indicesByUUID = indices;		// for bookkeeping
	
			for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
				indices[ arguments[ i ].uuid ] = i;
	
			}
	
			this._paths = [];					// inside: string
			this._parsedPaths = [];				// inside: { we don't care, here }
			this._bindings = []; 				// inside: Array< PropertyBinding >
			this._bindingsIndicesByPath = {}; 	// inside: indices in these arrays
	
			var scope = this;
	
			this.stats = {
	
				objects: {
					get total() { return scope._objects.length; },
					get inUse() { return this.total - scope.nCachedObjects_; }
				},
	
				get bindingsPerObject() { return scope._bindings.length; }
	
			};
	
		}
	
		Object.assign( AnimationObjectGroup.prototype, {
	
			isAnimationObjectGroup: true,
	
			add: function( var_args ) {
	
				var objects = this._objects,
					nObjects = objects.length,
					nCachedObjects = this.nCachedObjects_,
					indicesByUUID = this._indicesByUUID,
					paths = this._paths,
					parsedPaths = this._parsedPaths,
					bindings = this._bindings,
					nBindings = bindings.length;
	
				for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
					var object = arguments[ i ],
						uuid = object.uuid,
						index = indicesByUUID[ uuid ],
						knownObject = undefined;
	
					if ( index === undefined ) {
	
						// unknown object -> add it to the ACTIVE region
	
						index = nObjects ++;
						indicesByUUID[ uuid ] = index;
						objects.push( object );
	
						// accounting is done, now do the same for all bindings
	
						for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
							bindings[ j ].push(
									new PropertyBinding(
										object, paths[ j ], parsedPaths[ j ] ) );
	
						}
	
					} else if ( index < nCachedObjects ) {
	
						knownObject = objects[ index ];
	
						// move existing object to the ACTIVE region
	
						var firstActiveIndex = -- nCachedObjects,
							lastCachedObject = objects[ firstActiveIndex ];
	
						indicesByUUID[ lastCachedObject.uuid ] = index;
						objects[ index ] = lastCachedObject;
	
						indicesByUUID[ uuid ] = firstActiveIndex;
						objects[ firstActiveIndex ] = object;
	
						// accounting is done, now do the same for all bindings
	
						for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
							var bindingsForPath = bindings[ j ],
								lastCached = bindingsForPath[ firstActiveIndex ],
								binding = bindingsForPath[ index ];
	
							bindingsForPath[ index ] = lastCached;
	
							if ( binding === undefined ) {
	
								// since we do not bother to create new bindings
								// for objects that are cached, the binding may
								// or may not exist
	
								binding = new PropertyBinding(
										object, paths[ j ], parsedPaths[ j ] );
	
							}
	
							bindingsForPath[ firstActiveIndex ] = binding;
	
						}
	
					} else if ( objects[ index ] !== knownObject ) {
	
						console.error( 'THREE.AnimationObjectGroup: Different objects with the same UUID ' +
								'detected. Clean the caches or recreate your infrastructure when reloading scenes.' );
	
					} // else the object is already where we want it to be
	
				} // for arguments
	
				this.nCachedObjects_ = nCachedObjects;
	
			},
	
			remove: function( var_args ) {
	
				var objects = this._objects,
					nCachedObjects = this.nCachedObjects_,
					indicesByUUID = this._indicesByUUID,
					bindings = this._bindings,
					nBindings = bindings.length;
	
				for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
					var object = arguments[ i ],
						uuid = object.uuid,
						index = indicesByUUID[ uuid ];
	
					if ( index !== undefined && index >= nCachedObjects ) {
	
						// move existing object into the CACHED region
	
						var lastCachedIndex = nCachedObjects ++,
							firstActiveObject = objects[ lastCachedIndex ];
	
						indicesByUUID[ firstActiveObject.uuid ] = index;
						objects[ index ] = firstActiveObject;
	
						indicesByUUID[ uuid ] = lastCachedIndex;
						objects[ lastCachedIndex ] = object;
	
						// accounting is done, now do the same for all bindings
	
						for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
							var bindingsForPath = bindings[ j ],
								firstActive = bindingsForPath[ lastCachedIndex ],
								binding = bindingsForPath[ index ];
	
							bindingsForPath[ index ] = firstActive;
							bindingsForPath[ lastCachedIndex ] = binding;
	
						}
	
					}
	
				} // for arguments
	
				this.nCachedObjects_ = nCachedObjects;
	
			},
	
			// remove & forget
			uncache: function( var_args ) {
	
				var objects = this._objects,
					nObjects = objects.length,
					nCachedObjects = this.nCachedObjects_,
					indicesByUUID = this._indicesByUUID,
					bindings = this._bindings,
					nBindings = bindings.length;
	
				for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
					var object = arguments[ i ],
						uuid = object.uuid,
						index = indicesByUUID[ uuid ];
	
					if ( index !== undefined ) {
	
						delete indicesByUUID[ uuid ];
	
						if ( index < nCachedObjects ) {
	
							// object is cached, shrink the CACHED region
	
							var firstActiveIndex = -- nCachedObjects,
								lastCachedObject = objects[ firstActiveIndex ],
								lastIndex = -- nObjects,
								lastObject = objects[ lastIndex ];
	
							// last cached object takes this object's place
							indicesByUUID[ lastCachedObject.uuid ] = index;
							objects[ index ] = lastCachedObject;
	
							// last object goes to the activated slot and pop
							indicesByUUID[ lastObject.uuid ] = firstActiveIndex;
							objects[ firstActiveIndex ] = lastObject;
							objects.pop();
	
							// accounting is done, now do the same for all bindings
	
							for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
								var bindingsForPath = bindings[ j ],
									lastCached = bindingsForPath[ firstActiveIndex ],
									last = bindingsForPath[ lastIndex ];
	
								bindingsForPath[ index ] = lastCached;
								bindingsForPath[ firstActiveIndex ] = last;
								bindingsForPath.pop();
	
							}
	
						} else {
	
							// object is active, just swap with the last and pop
	
							var lastIndex = -- nObjects,
								lastObject = objects[ lastIndex ];
	
							indicesByUUID[ lastObject.uuid ] = index;
							objects[ index ] = lastObject;
							objects.pop();
	
							// accounting is done, now do the same for all bindings
	
							for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
								var bindingsForPath = bindings[ j ];
	
								bindingsForPath[ index ] = bindingsForPath[ lastIndex ];
								bindingsForPath.pop();
	
							}
	
						} // cached or active
	
					} // if object is known
	
				} // for arguments
	
				this.nCachedObjects_ = nCachedObjects;
	
			},
	
			// Internal interface used by befriended PropertyBinding.Composite:
	
			subscribe_: function ( path, parsedPath ) {
	
				// returns an array of bindings for the given path that is changed
				// according to the contained objects in the group
	
				var indicesByPath = this._bindingsIndicesByPath,
					index = indicesByPath[ path ],
					bindings = this._bindings;
	
				if ( index !== undefined ) return bindings[ index ];
	
				var paths = this._paths,
					parsedPaths = this._parsedPaths,
					objects = this._objects,
					nObjects = objects.length,
					nCachedObjects = this.nCachedObjects_,
					bindingsForPath = new Array( nObjects );
	
				index = bindings.length;
	
				indicesByPath[ path ] = index;
	
				paths.push( path );
				parsedPaths.push( parsedPath );
				bindings.push( bindingsForPath );
	
				for ( var i = nCachedObjects, n = objects.length; i !== n; ++ i ) {
	
					var object = objects[ i ];
					bindingsForPath[ i ] = new PropertyBinding( object, path, parsedPath );
	
				}
	
				return bindingsForPath;
	
			},
	
			unsubscribe_: function ( path ) {
	
				// tells the group to forget about a property path and no longer
				// update the array previously obtained with 'subscribe_'
	
				var indicesByPath = this._bindingsIndicesByPath,
					index = indicesByPath[ path ];
	
				if ( index !== undefined ) {
	
					var paths = this._paths,
						parsedPaths = this._parsedPaths,
						bindings = this._bindings,
						lastBindingsIndex = bindings.length - 1,
						lastBindings = bindings[ lastBindingsIndex ],
						lastBindingsPath = path[ lastBindingsIndex ];
	
					indicesByPath[ lastBindingsPath ] = index;
	
					bindings[ index ] = lastBindings;
					bindings.pop();
	
					parsedPaths[ index ] = parsedPaths[ lastBindingsIndex ];
					parsedPaths.pop();
	
					paths[ index ] = paths[ lastBindingsIndex ];
					paths.pop();
	
				}
	
			}
	
		} );
	
		/**
		 *
		 * Action provided by AnimationMixer for scheduling clip playback on specific
		 * objects.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 *
		 */
	
		function AnimationAction( mixer, clip, localRoot ) {
	
			this._mixer = mixer;
			this._clip = clip;
			this._localRoot = localRoot || null;
	
			var tracks = clip.tracks,
				nTracks = tracks.length,
				interpolants = new Array( nTracks );
	
			var interpolantSettings = {
					endingStart: 	ZeroCurvatureEnding,
					endingEnd:		ZeroCurvatureEnding
			};
	
			for ( var i = 0; i !== nTracks; ++ i ) {
	
				var interpolant = tracks[ i ].createInterpolant( null );
				interpolants[ i ] = interpolant;
				interpolant.settings = interpolantSettings;
	
			}
	
			this._interpolantSettings = interpolantSettings;
	
			this._interpolants = interpolants;	// bound by the mixer
	
			// inside: PropertyMixer (managed by the mixer)
			this._propertyBindings = new Array( nTracks );
	
			this._cacheIndex = null;			// for the memory manager
			this._byClipCacheIndex = null;		// for the memory manager
	
			this._timeScaleInterpolant = null;
			this._weightInterpolant = null;
	
			this.loop = LoopRepeat;
			this._loopCount = -1;
	
			// global mixer time when the action is to be started
			// it's set back to 'null' upon start of the action
			this._startTime = null;
	
			// scaled local time of the action
			// gets clamped or wrapped to 0..clip.duration according to loop
			this.time = 0;
	
			this.timeScale = 1;
			this._effectiveTimeScale = 1;
	
			this.weight = 1;
			this._effectiveWeight = 1;
	
			this.repetitions = Infinity; 		// no. of repetitions when looping
	
			this.paused = false;				// true -> zero effective time scale
			this.enabled = true;				// false -> zero effective weight
	
			this.clampWhenFinished 	= false;	// keep feeding the last frame?
	
			this.zeroSlopeAtStart 	= true;		// for smooth interpolation w/o separate
			this.zeroSlopeAtEnd		= true;		// clips for start, loop and end
	
		}
	
		Object.assign( AnimationAction.prototype, {
	
			// State & Scheduling
	
			play: function() {
	
				this._mixer._activateAction( this );
	
				return this;
	
			},
	
			stop: function() {
	
				this._mixer._deactivateAction( this );
	
				return this.reset();
	
			},
	
			reset: function() {
	
				this.paused = false;
				this.enabled = true;
	
				this.time = 0;			// restart clip
				this._loopCount = -1;	// forget previous loops
				this._startTime = null;	// forget scheduling
	
				return this.stopFading().stopWarping();
	
			},
	
			isRunning: function() {
	
				return this.enabled && ! this.paused && this.timeScale !== 0 &&
						this._startTime === null && this._mixer._isActiveAction( this );
	
			},
	
			// return true when play has been called
			isScheduled: function() {
	
				return this._mixer._isActiveAction( this );
	
			},
	
			startAt: function( time ) {
	
				this._startTime = time;
	
				return this;
	
			},
	
			setLoop: function( mode, repetitions ) {
	
				this.loop = mode;
				this.repetitions = repetitions;
	
				return this;
	
			},
	
			// Weight
	
			// set the weight stopping any scheduled fading
			// although .enabled = false yields an effective weight of zero, this
			// method does *not* change .enabled, because it would be confusing
			setEffectiveWeight: function( weight ) {
	
				this.weight = weight;
	
				// note: same logic as when updated at runtime
				this._effectiveWeight = this.enabled ? weight : 0;
	
				return this.stopFading();
	
			},
	
			// return the weight considering fading and .enabled
			getEffectiveWeight: function() {
	
				return this._effectiveWeight;
	
			},
	
			fadeIn: function( duration ) {
	
				return this._scheduleFading( duration, 0, 1 );
	
			},
	
			fadeOut: function( duration ) {
	
				return this._scheduleFading( duration, 1, 0 );
	
			},
	
			crossFadeFrom: function( fadeOutAction, duration, warp ) {
	
				fadeOutAction.fadeOut( duration );
				this.fadeIn( duration );
	
				if( warp ) {
	
					var fadeInDuration = this._clip.duration,
						fadeOutDuration = fadeOutAction._clip.duration,
	
						startEndRatio = fadeOutDuration / fadeInDuration,
						endStartRatio = fadeInDuration / fadeOutDuration;
	
					fadeOutAction.warp( 1.0, startEndRatio, duration );
					this.warp( endStartRatio, 1.0, duration );
	
				}
	
				return this;
	
			},
	
			crossFadeTo: function( fadeInAction, duration, warp ) {
	
				return fadeInAction.crossFadeFrom( this, duration, warp );
	
			},
	
			stopFading: function() {
	
				var weightInterpolant = this._weightInterpolant;
	
				if ( weightInterpolant !== null ) {
	
					this._weightInterpolant = null;
					this._mixer._takeBackControlInterpolant( weightInterpolant );
	
				}
	
				return this;
	
			},
	
			// Time Scale Control
	
			// set the time scale stopping any scheduled warping
			// although .paused = true yields an effective time scale of zero, this
			// method does *not* change .paused, because it would be confusing
			setEffectiveTimeScale: function( timeScale ) {
	
				this.timeScale = timeScale;
				this._effectiveTimeScale = this.paused ? 0 :timeScale;
	
				return this.stopWarping();
	
			},
	
			// return the time scale considering warping and .paused
			getEffectiveTimeScale: function() {
	
				return this._effectiveTimeScale;
	
			},
	
			setDuration: function( duration ) {
	
				this.timeScale = this._clip.duration / duration;
	
				return this.stopWarping();
	
			},
	
			syncWith: function( action ) {
	
				this.time = action.time;
				this.timeScale = action.timeScale;
	
				return this.stopWarping();
	
			},
	
			halt: function( duration ) {
	
				return this.warp( this._effectiveTimeScale, 0, duration );
	
			},
	
			warp: function( startTimeScale, endTimeScale, duration ) {
	
				var mixer = this._mixer, now = mixer.time,
					interpolant = this._timeScaleInterpolant,
	
					timeScale = this.timeScale;
	
				if ( interpolant === null ) {
	
					interpolant = mixer._lendControlInterpolant();
					this._timeScaleInterpolant = interpolant;
	
				}
	
				var times = interpolant.parameterPositions,
					values = interpolant.sampleValues;
	
				times[ 0 ] = now;
				times[ 1 ] = now + duration;
	
				values[ 0 ] = startTimeScale / timeScale;
				values[ 1 ] = endTimeScale / timeScale;
	
				return this;
	
			},
	
			stopWarping: function() {
	
				var timeScaleInterpolant = this._timeScaleInterpolant;
	
				if ( timeScaleInterpolant !== null ) {
	
					this._timeScaleInterpolant = null;
					this._mixer._takeBackControlInterpolant( timeScaleInterpolant );
	
				}
	
				return this;
	
			},
	
			// Object Accessors
	
			getMixer: function() {
	
				return this._mixer;
	
			},
	
			getClip: function() {
	
				return this._clip;
	
			},
	
			getRoot: function() {
	
				return this._localRoot || this._mixer._root;
	
			},
	
			// Interna
	
			_update: function( time, deltaTime, timeDirection, accuIndex ) {
	
				// called by the mixer
	
				if ( ! this.enabled ) {
	
					// call ._updateWeight() to update ._effectiveWeight
	
					this._updateWeight( time );
					return;
	
				}
	
				var startTime = this._startTime;
	
				if ( startTime !== null ) {
	
					// check for scheduled start of action
	
					var timeRunning = ( time - startTime ) * timeDirection;
					if ( timeRunning < 0 || timeDirection === 0 ) {
	
						return; // yet to come / don't decide when delta = 0
	
					}
	
					// start
	
					this._startTime = null; // unschedule
					deltaTime = timeDirection * timeRunning;
	
				}
	
				// apply time scale and advance time
	
				deltaTime *= this._updateTimeScale( time );
				var clipTime = this._updateTime( deltaTime );
	
				// note: _updateTime may disable the action resulting in
				// an effective weight of 0
	
				var weight = this._updateWeight( time );
	
				if ( weight > 0 ) {
	
					var interpolants = this._interpolants;
					var propertyMixers = this._propertyBindings;
	
					for ( var j = 0, m = interpolants.length; j !== m; ++ j ) {
	
						interpolants[ j ].evaluate( clipTime );
						propertyMixers[ j ].accumulate( accuIndex, weight );
	
					}
	
				}
	
			},
	
			_updateWeight: function( time ) {
	
				var weight = 0;
	
				if ( this.enabled ) {
	
					weight = this.weight;
					var interpolant = this._weightInterpolant;
	
					if ( interpolant !== null ) {
	
						var interpolantValue = interpolant.evaluate( time )[ 0 ];
	
						weight *= interpolantValue;
	
						if ( time > interpolant.parameterPositions[ 1 ] ) {
	
							this.stopFading();
	
							if ( interpolantValue === 0 ) {
	
								// faded out, disable
								this.enabled = false;
	
							}
	
						}
	
					}
	
				}
	
				this._effectiveWeight = weight;
				return weight;
	
			},
	
			_updateTimeScale: function( time ) {
	
				var timeScale = 0;
	
				if ( ! this.paused ) {
	
					timeScale = this.timeScale;
	
					var interpolant = this._timeScaleInterpolant;
	
					if ( interpolant !== null ) {
	
						var interpolantValue = interpolant.evaluate( time )[ 0 ];
	
						timeScale *= interpolantValue;
	
						if ( time > interpolant.parameterPositions[ 1 ] ) {
	
							this.stopWarping();
	
							if ( timeScale === 0 ) {
	
								// motion has halted, pause
								this.paused = true;
	
							} else {
	
								// warp done - apply final time scale
								this.timeScale = timeScale;
	
							}
	
						}
	
					}
	
				}
	
				this._effectiveTimeScale = timeScale;
				return timeScale;
	
			},
	
			_updateTime: function( deltaTime ) {
	
				var time = this.time + deltaTime;
	
				if ( deltaTime === 0 ) return time;
	
				var duration = this._clip.duration,
	
					loop = this.loop,
					loopCount = this._loopCount;
	
				if ( loop === LoopOnce ) {
	
					if ( loopCount === -1 ) {
						// just started
	
						this._loopCount = 0;
						this._setEndings( true, true, false );
	
					}
	
					handle_stop: {
	
						if ( time >= duration ) {
	
							time = duration;
	
						} else if ( time < 0 ) {
	
							time = 0;
	
						} else break handle_stop;
	
						if ( this.clampWhenFinished ) this.paused = true;
						else this.enabled = false;
	
						this._mixer.dispatchEvent( {
							type: 'finished', action: this,
							direction: deltaTime < 0 ? -1 : 1
						} );
	
					}
	
				} else { // repetitive Repeat or PingPong
	
					var pingPong = ( loop === LoopPingPong );
	
					if ( loopCount === -1 ) {
						// just started
	
						if ( deltaTime >= 0 ) {
	
							loopCount = 0;
	
							this._setEndings(
									true, this.repetitions === 0, pingPong );
	
						} else {
	
							// when looping in reverse direction, the initial
							// transition through zero counts as a repetition,
							// so leave loopCount at -1
	
							this._setEndings(
									this.repetitions === 0, true, pingPong );
	
						}
	
					}
	
					if ( time >= duration || time < 0 ) {
						// wrap around
	
						var loopDelta = Math.floor( time / duration ); // signed
						time -= duration * loopDelta;
	
						loopCount += Math.abs( loopDelta );
	
						var pending = this.repetitions - loopCount;
	
						if ( pending < 0 ) {
							// have to stop (switch state, clamp time, fire event)
	
							if ( this.clampWhenFinished ) this.paused = true;
							else this.enabled = false;
	
							time = deltaTime > 0 ? duration : 0;
	
							this._mixer.dispatchEvent( {
								type: 'finished', action: this,
								direction: deltaTime > 0 ? 1 : -1
							} );
	
						} else {
							// keep running
	
							if ( pending === 0 ) {
								// entering the last round
	
								var atStart = deltaTime < 0;
								this._setEndings( atStart, ! atStart, pingPong );
	
							} else {
	
								this._setEndings( false, false, pingPong );
	
							}
	
							this._loopCount = loopCount;
	
							this._mixer.dispatchEvent( {
								type: 'loop', action: this, loopDelta: loopDelta
							} );
	
						}
	
					}
	
					if ( pingPong && ( loopCount & 1 ) === 1 ) {
						// invert time for the "pong round"
	
						this.time = time;
						return duration - time;
	
					}
	
				}
	
				this.time = time;
				return time;
	
			},
	
			_setEndings: function( atStart, atEnd, pingPong ) {
	
				var settings = this._interpolantSettings;
	
				if ( pingPong ) {
	
					settings.endingStart 	= ZeroSlopeEnding;
					settings.endingEnd		= ZeroSlopeEnding;
	
				} else {
	
					// assuming for LoopOnce atStart == atEnd == true
	
					if ( atStart ) {
	
						settings.endingStart = this.zeroSlopeAtStart ?
								ZeroSlopeEnding : ZeroCurvatureEnding;
	
					} else {
	
						settings.endingStart = WrapAroundEnding;
	
					}
	
					if ( atEnd ) {
	
						settings.endingEnd = this.zeroSlopeAtEnd ?
								ZeroSlopeEnding : ZeroCurvatureEnding;
	
					} else {
	
						settings.endingEnd 	 = WrapAroundEnding;
	
					}
	
				}
	
			},
	
			_scheduleFading: function( duration, weightNow, weightThen ) {
	
				var mixer = this._mixer, now = mixer.time,
					interpolant = this._weightInterpolant;
	
				if ( interpolant === null ) {
	
					interpolant = mixer._lendControlInterpolant();
					this._weightInterpolant = interpolant;
	
				}
	
				var times = interpolant.parameterPositions,
					values = interpolant.sampleValues;
	
				times[ 0 ] = now; 				values[ 0 ] = weightNow;
				times[ 1 ] = now + duration;	values[ 1 ] = weightThen;
	
				return this;
	
			}
	
		} );
	
		/**
		 *
		 * Player for AnimationClips.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function AnimationMixer( root ) {
	
			this._root = root;
			this._initMemoryManager();
			this._accuIndex = 0;
	
			this.time = 0;
	
			this.timeScale = 1.0;
	
		}
	
		Object.assign( AnimationMixer.prototype, EventDispatcher.prototype, {
	
			_bindAction: function ( action, prototypeAction ) {
	
				var root = action._localRoot || this._root,
					tracks = action._clip.tracks,
					nTracks = tracks.length,
					bindings = action._propertyBindings,
					interpolants = action._interpolants,
					rootUuid = root.uuid,
					bindingsByRoot = this._bindingsByRootAndName,
					bindingsByName = bindingsByRoot[ rootUuid ];
	
				if ( bindingsByName === undefined ) {
	
					bindingsByName = {};
					bindingsByRoot[ rootUuid ] = bindingsByName;
	
				}
	
				for ( var i = 0; i !== nTracks; ++ i ) {
	
					var track = tracks[ i ],
						trackName = track.name,
						binding = bindingsByName[ trackName ];
	
					if ( binding !== undefined ) {
	
						bindings[ i ] = binding;
	
					} else {
	
						binding = bindings[ i ];
	
						if ( binding !== undefined ) {
	
							// existing binding, make sure the cache knows
	
							if ( binding._cacheIndex === null ) {
	
								++ binding.referenceCount;
								this._addInactiveBinding( binding, rootUuid, trackName );
	
							}
	
							continue;
	
						}
	
						var path = prototypeAction && prototypeAction.
								_propertyBindings[ i ].binding.parsedPath;
	
						binding = new PropertyMixer(
							PropertyBinding.create( root, trackName, path ),
							track.ValueTypeName, track.getValueSize() );
	
						++ binding.referenceCount;
						this._addInactiveBinding( binding, rootUuid, trackName );
	
						bindings[ i ] = binding;
	
					}
	
					interpolants[ i ].resultBuffer = binding.buffer;
	
				}
	
			},
	
			_activateAction: function ( action ) {
	
				if ( ! this._isActiveAction( action ) ) {
	
					if ( action._cacheIndex === null ) {
	
						// this action has been forgotten by the cache, but the user
						// appears to be still using it -> rebind
	
						var rootUuid = ( action._localRoot || this._root ).uuid,
							clipUuid = action._clip.uuid,
							actionsForClip = this._actionsByClip[ clipUuid ];
	
						this._bindAction( action,
							actionsForClip && actionsForClip.knownActions[ 0 ] );
	
						this._addInactiveAction( action, clipUuid, rootUuid );
	
					}
	
					var bindings = action._propertyBindings;
	
					// increment reference counts / sort out state
					for ( var i = 0, n = bindings.length; i !== n; ++ i ) {
	
						var binding = bindings[ i ];
	
						if ( binding.useCount ++ === 0 ) {
	
							this._lendBinding( binding );
							binding.saveOriginalState();
	
						}
	
					}
	
					this._lendAction( action );
	
				}
	
			},
	
			_deactivateAction: function ( action ) {
	
				if ( this._isActiveAction( action ) ) {
	
					var bindings = action._propertyBindings;
	
					// decrement reference counts / sort out state
					for ( var i = 0, n = bindings.length; i !== n; ++ i ) {
	
						var binding = bindings[ i ];
	
						if ( -- binding.useCount === 0 ) {
	
							binding.restoreOriginalState();
							this._takeBackBinding( binding );
	
						}
	
					}
	
					this._takeBackAction( action );
	
				}
	
			},
	
			// Memory manager
	
			_initMemoryManager: function () {
	
				this._actions = []; // 'nActiveActions' followed by inactive ones
				this._nActiveActions = 0;
	
				this._actionsByClip = {};
				// inside:
				// {
				// 		knownActions: Array< AnimationAction >	- used as prototypes
				// 		actionByRoot: AnimationAction			- lookup
				// }
	
	
				this._bindings = []; // 'nActiveBindings' followed by inactive ones
				this._nActiveBindings = 0;
	
				this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
	
	
				this._controlInterpolants = []; // same game as above
				this._nActiveControlInterpolants = 0;
	
				var scope = this;
	
				this.stats = {
	
					actions: {
						get total() { return scope._actions.length; },
						get inUse() { return scope._nActiveActions; }
					},
					bindings: {
						get total() { return scope._bindings.length; },
						get inUse() { return scope._nActiveBindings; }
					},
					controlInterpolants: {
						get total() { return scope._controlInterpolants.length; },
						get inUse() { return scope._nActiveControlInterpolants; }
					}
	
				};
	
			},
	
			// Memory management for AnimationAction objects
	
			_isActiveAction: function ( action ) {
	
				var index = action._cacheIndex;
				return index !== null && index < this._nActiveActions;
	
			},
	
			_addInactiveAction: function ( action, clipUuid, rootUuid ) {
	
				var actions = this._actions,
					actionsByClip = this._actionsByClip,
					actionsForClip = actionsByClip[ clipUuid ];
	
				if ( actionsForClip === undefined ) {
	
					actionsForClip = {
	
						knownActions: [ action ],
						actionByRoot: {}
	
					};
	
					action._byClipCacheIndex = 0;
	
					actionsByClip[ clipUuid ] = actionsForClip;
	
				} else {
	
					var knownActions = actionsForClip.knownActions;
	
					action._byClipCacheIndex = knownActions.length;
					knownActions.push( action );
	
				}
	
				action._cacheIndex = actions.length;
				actions.push( action );
	
				actionsForClip.actionByRoot[ rootUuid ] = action;
	
			},
	
			_removeInactiveAction: function ( action ) {
	
				var actions = this._actions,
					lastInactiveAction = actions[ actions.length - 1 ],
					cacheIndex = action._cacheIndex;
	
				lastInactiveAction._cacheIndex = cacheIndex;
				actions[ cacheIndex ] = lastInactiveAction;
				actions.pop();
	
				action._cacheIndex = null;
	
	
				var clipUuid = action._clip.uuid,
					actionsByClip = this._actionsByClip,
					actionsForClip = actionsByClip[ clipUuid ],
					knownActionsForClip = actionsForClip.knownActions,
	
					lastKnownAction =
						knownActionsForClip[ knownActionsForClip.length - 1 ],
	
					byClipCacheIndex = action._byClipCacheIndex;
	
				lastKnownAction._byClipCacheIndex = byClipCacheIndex;
				knownActionsForClip[ byClipCacheIndex ] = lastKnownAction;
				knownActionsForClip.pop();
	
				action._byClipCacheIndex = null;
	
	
				var actionByRoot = actionsForClip.actionByRoot,
					rootUuid = ( action._localRoot || this._root ).uuid;
	
				delete actionByRoot[ rootUuid ];
	
				if ( knownActionsForClip.length === 0 ) {
	
					delete actionsByClip[ clipUuid ];
	
				}
	
				this._removeInactiveBindingsForAction( action );
	
			},
	
			_removeInactiveBindingsForAction: function ( action ) {
	
				var bindings = action._propertyBindings;
				for ( var i = 0, n = bindings.length; i !== n; ++ i ) {
	
					var binding = bindings[ i ];
	
					if ( -- binding.referenceCount === 0 ) {
	
						this._removeInactiveBinding( binding );
	
					}
	
				}
	
			},
	
			_lendAction: function ( action ) {
	
				// [ active actions |  inactive actions  ]
				// [  active actions >| inactive actions ]
				//                 s        a
				//                  <-swap->
				//                 a        s
	
				var actions = this._actions,
					prevIndex = action._cacheIndex,
	
					lastActiveIndex = this._nActiveActions ++,
	
					firstInactiveAction = actions[ lastActiveIndex ];
	
				action._cacheIndex = lastActiveIndex;
				actions[ lastActiveIndex ] = action;
	
				firstInactiveAction._cacheIndex = prevIndex;
				actions[ prevIndex ] = firstInactiveAction;
	
			},
	
			_takeBackAction: function ( action ) {
	
				// [  active actions  | inactive actions ]
				// [ active actions |< inactive actions  ]
				//        a        s
				//         <-swap->
				//        s        a
	
				var actions = this._actions,
					prevIndex = action._cacheIndex,
	
					firstInactiveIndex = -- this._nActiveActions,
	
					lastActiveAction = actions[ firstInactiveIndex ];
	
				action._cacheIndex = firstInactiveIndex;
				actions[ firstInactiveIndex ] = action;
	
				lastActiveAction._cacheIndex = prevIndex;
				actions[ prevIndex ] = lastActiveAction;
	
			},
	
			// Memory management for PropertyMixer objects
	
			_addInactiveBinding: function ( binding, rootUuid, trackName ) {
	
				var bindingsByRoot = this._bindingsByRootAndName,
					bindingByName = bindingsByRoot[ rootUuid ],
	
					bindings = this._bindings;
	
				if ( bindingByName === undefined ) {
	
					bindingByName = {};
					bindingsByRoot[ rootUuid ] = bindingByName;
	
				}
	
				bindingByName[ trackName ] = binding;
	
				binding._cacheIndex = bindings.length;
				bindings.push( binding );
	
			},
	
			_removeInactiveBinding: function ( binding ) {
	
				var bindings = this._bindings,
					propBinding = binding.binding,
					rootUuid = propBinding.rootNode.uuid,
					trackName = propBinding.path,
					bindingsByRoot = this._bindingsByRootAndName,
					bindingByName = bindingsByRoot[ rootUuid ],
	
					lastInactiveBinding = bindings[ bindings.length - 1 ],
					cacheIndex = binding._cacheIndex;
	
				lastInactiveBinding._cacheIndex = cacheIndex;
				bindings[ cacheIndex ] = lastInactiveBinding;
				bindings.pop();
	
				delete bindingByName[ trackName ];
	
				remove_empty_map: {
	
					for ( var _ in bindingByName ) break remove_empty_map;
	
					delete bindingsByRoot[ rootUuid ];
	
				}
	
			},
	
			_lendBinding: function ( binding ) {
	
				var bindings = this._bindings,
					prevIndex = binding._cacheIndex,
	
					lastActiveIndex = this._nActiveBindings ++,
	
					firstInactiveBinding = bindings[ lastActiveIndex ];
	
				binding._cacheIndex = lastActiveIndex;
				bindings[ lastActiveIndex ] = binding;
	
				firstInactiveBinding._cacheIndex = prevIndex;
				bindings[ prevIndex ] = firstInactiveBinding;
	
			},
	
			_takeBackBinding: function ( binding ) {
	
				var bindings = this._bindings,
					prevIndex = binding._cacheIndex,
	
					firstInactiveIndex = -- this._nActiveBindings,
	
					lastActiveBinding = bindings[ firstInactiveIndex ];
	
				binding._cacheIndex = firstInactiveIndex;
				bindings[ firstInactiveIndex ] = binding;
	
				lastActiveBinding._cacheIndex = prevIndex;
				bindings[ prevIndex ] = lastActiveBinding;
	
			},
	
	
			// Memory management of Interpolants for weight and time scale
	
			_lendControlInterpolant: function () {
	
				var interpolants = this._controlInterpolants,
					lastActiveIndex = this._nActiveControlInterpolants ++,
					interpolant = interpolants[ lastActiveIndex ];
	
				if ( interpolant === undefined ) {
	
					interpolant = new LinearInterpolant(
						new Float32Array( 2 ), new Float32Array( 2 ),
						1, this._controlInterpolantsResultBuffer );
	
					interpolant.__cacheIndex = lastActiveIndex;
					interpolants[ lastActiveIndex ] = interpolant;
	
				}
	
				return interpolant;
	
			},
	
			_takeBackControlInterpolant: function ( interpolant ) {
	
				var interpolants = this._controlInterpolants,
					prevIndex = interpolant.__cacheIndex,
	
					firstInactiveIndex = -- this._nActiveControlInterpolants,
	
					lastActiveInterpolant = interpolants[ firstInactiveIndex ];
	
				interpolant.__cacheIndex = firstInactiveIndex;
				interpolants[ firstInactiveIndex ] = interpolant;
	
				lastActiveInterpolant.__cacheIndex = prevIndex;
				interpolants[ prevIndex ] = lastActiveInterpolant;
	
			},
	
			_controlInterpolantsResultBuffer: new Float32Array( 1 ),
	
			// return an action for a clip optionally using a custom root target
			// object (this method allocates a lot of dynamic memory in case a
			// previously unknown clip/root combination is specified)
			clipAction: function ( clip, optionalRoot ) {
	
				var root = optionalRoot || this._root,
					rootUuid = root.uuid,
	
					clipObject = typeof clip === 'string' ?
						AnimationClip.findByName( root, clip ) : clip,
	
					clipUuid = clipObject !== null ? clipObject.uuid : clip,
	
					actionsForClip = this._actionsByClip[ clipUuid ],
					prototypeAction = null;
	
				if ( actionsForClip !== undefined ) {
	
					var existingAction =
							actionsForClip.actionByRoot[ rootUuid ];
	
					if ( existingAction !== undefined ) {
	
						return existingAction;
	
					}
	
					// we know the clip, so we don't have to parse all
					// the bindings again but can just copy
					prototypeAction = actionsForClip.knownActions[ 0 ];
	
					// also, take the clip from the prototype action
					if ( clipObject === null )
						clipObject = prototypeAction._clip;
	
				}
	
				// clip must be known when specified via string
				if ( clipObject === null ) return null;
	
				// allocate all resources required to run it
				var newAction = new AnimationAction( this, clipObject, optionalRoot );
	
				this._bindAction( newAction, prototypeAction );
	
				// and make the action known to the memory manager
				this._addInactiveAction( newAction, clipUuid, rootUuid );
	
				return newAction;
	
			},
	
			// get an existing action
			existingAction: function ( clip, optionalRoot ) {
	
				var root = optionalRoot || this._root,
					rootUuid = root.uuid,
	
					clipObject = typeof clip === 'string' ?
						AnimationClip.findByName( root, clip ) : clip,
	
					clipUuid = clipObject ? clipObject.uuid : clip,
	
					actionsForClip = this._actionsByClip[ clipUuid ];
	
				if ( actionsForClip !== undefined ) {
	
					return actionsForClip.actionByRoot[ rootUuid ] || null;
	
				}
	
				return null;
	
			},
	
			// deactivates all previously scheduled actions
			stopAllAction: function () {
	
				var actions = this._actions,
					nActions = this._nActiveActions,
					bindings = this._bindings,
					nBindings = this._nActiveBindings;
	
				this._nActiveActions = 0;
				this._nActiveBindings = 0;
	
				for ( var i = 0; i !== nActions; ++ i ) {
	
					actions[ i ].reset();
	
				}
	
				for ( var i = 0; i !== nBindings; ++ i ) {
	
					bindings[ i ].useCount = 0;
	
				}
	
				return this;
	
			},
	
			// advance the time and update apply the animation
			update: function ( deltaTime ) {
	
				deltaTime *= this.timeScale;
	
				var actions = this._actions,
					nActions = this._nActiveActions,
	
					time = this.time += deltaTime,
					timeDirection = Math.sign( deltaTime ),
	
					accuIndex = this._accuIndex ^= 1;
	
				// run active actions
	
				for ( var i = 0; i !== nActions; ++ i ) {
	
					var action = actions[ i ];
	
					action._update( time, deltaTime, timeDirection, accuIndex );
	
				}
	
				// update scene graph
	
				var bindings = this._bindings,
					nBindings = this._nActiveBindings;
	
				for ( var i = 0; i !== nBindings; ++ i ) {
	
					bindings[ i ].apply( accuIndex );
	
				}
	
				return this;
	
			},
	
			// return this mixer's root target object
			getRoot: function () {
	
				return this._root;
	
			},
	
			// free all resources specific to a particular clip
			uncacheClip: function ( clip ) {
	
				var actions = this._actions,
					clipUuid = clip.uuid,
					actionsByClip = this._actionsByClip,
					actionsForClip = actionsByClip[ clipUuid ];
	
				if ( actionsForClip !== undefined ) {
	
					// note: just calling _removeInactiveAction would mess up the
					// iteration state and also require updating the state we can
					// just throw away
	
					var actionsToRemove = actionsForClip.knownActions;
	
					for ( var i = 0, n = actionsToRemove.length; i !== n; ++ i ) {
	
						var action = actionsToRemove[ i ];
	
						this._deactivateAction( action );
	
						var cacheIndex = action._cacheIndex,
							lastInactiveAction = actions[ actions.length - 1 ];
	
						action._cacheIndex = null;
						action._byClipCacheIndex = null;
	
						lastInactiveAction._cacheIndex = cacheIndex;
						actions[ cacheIndex ] = lastInactiveAction;
						actions.pop();
	
						this._removeInactiveBindingsForAction( action );
	
					}
	
					delete actionsByClip[ clipUuid ];
	
				}
	
			},
	
			// free all resources specific to a particular root target object
			uncacheRoot: function ( root ) {
	
				var rootUuid = root.uuid,
					actionsByClip = this._actionsByClip;
	
				for ( var clipUuid in actionsByClip ) {
	
					var actionByRoot = actionsByClip[ clipUuid ].actionByRoot,
						action = actionByRoot[ rootUuid ];
	
					if ( action !== undefined ) {
	
						this._deactivateAction( action );
						this._removeInactiveAction( action );
	
					}
	
				}
	
				var bindingsByRoot = this._bindingsByRootAndName,
					bindingByName = bindingsByRoot[ rootUuid ];
	
				if ( bindingByName !== undefined ) {
	
					for ( var trackName in bindingByName ) {
	
						var binding = bindingByName[ trackName ];
						binding.restoreOriginalState();
						this._removeInactiveBinding( binding );
	
					}
	
				}
	
			},
	
			// remove a targeted clip from the cache
			uncacheAction: function ( clip, optionalRoot ) {
	
				var action = this.existingAction( clip, optionalRoot );
	
				if ( action !== null ) {
	
					this._deactivateAction( action );
					this._removeInactiveAction( action );
	
				}
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Uniform( value ) {
	
			if ( typeof value === 'string' ) {
	
				console.warn( 'THREE.Uniform: Type parameter is no longer needed.' );
				value = arguments[ 1 ];
	
			}
	
			this.value = value;
	
		}
	
		Uniform.prototype.clone = function () {
	
			return new Uniform( this.value.clone === undefined ? this.value : this.value.clone() );
	
		};
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InstancedBufferGeometry() {
	
			BufferGeometry.call( this );
	
			this.type = 'InstancedBufferGeometry';
			this.maxInstancedCount = undefined;
	
		}
	
		InstancedBufferGeometry.prototype = Object.assign( Object.create( BufferGeometry.prototype ), {
	
			constructor: InstancedBufferGeometry,
	
			isInstancedBufferGeometry: true,
	
			addGroup: function ( start, count, materialIndex ) {
	
				this.groups.push( {
	
					start: start,
					count: count,
					materialIndex: materialIndex
	
				} );
	
			},
	
			copy: function ( source ) {
	
				var index = source.index;
	
				if ( index !== null ) {
	
					this.setIndex( index.clone() );
	
				}
	
				var attributes = source.attributes;
	
				for ( var name in attributes ) {
	
					var attribute = attributes[ name ];
					this.addAttribute( name, attribute.clone() );
	
				}
	
				var groups = source.groups;
	
				for ( var i = 0, l = groups.length; i < l; i ++ ) {
	
					var group = groups[ i ];
					this.addGroup( group.start, group.count, group.materialIndex );
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InterleavedBufferAttribute( interleavedBuffer, itemSize, offset, normalized ) {
	
			this.uuid = _Math.generateUUID();
	
			this.data = interleavedBuffer;
			this.itemSize = itemSize;
			this.offset = offset;
	
			this.normalized = normalized === true;
	
		}
	
		Object.defineProperties( InterleavedBufferAttribute.prototype, {
	
			count: {
	
				get: function () {
	
					return this.data.count;
	
				}
	
			},
	
			array: {
	
				get: function () {
	
					return this.data.array;
	
				}
	
			}
	
		} );
	
		Object.assign( InterleavedBufferAttribute.prototype, {
	
			isInterleavedBufferAttribute: true,
	
			setX: function ( index, x ) {
	
				this.data.array[ index * this.data.stride + this.offset ] = x;
	
				return this;
	
			},
	
			setY: function ( index, y ) {
	
				this.data.array[ index * this.data.stride + this.offset + 1 ] = y;
	
				return this;
	
			},
	
			setZ: function ( index, z ) {
	
				this.data.array[ index * this.data.stride + this.offset + 2 ] = z;
	
				return this;
	
			},
	
			setW: function ( index, w ) {
	
				this.data.array[ index * this.data.stride + this.offset + 3 ] = w;
	
				return this;
	
			},
	
			getX: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset ];
	
			},
	
			getY: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset + 1 ];
	
			},
	
			getZ: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset + 2 ];
	
			},
	
			getW: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset + 3 ];
	
			},
	
			setXY: function ( index, x, y ) {
	
				index = index * this.data.stride + this.offset;
	
				this.data.array[ index + 0 ] = x;
				this.data.array[ index + 1 ] = y;
	
				return this;
	
			},
	
			setXYZ: function ( index, x, y, z ) {
	
				index = index * this.data.stride + this.offset;
	
				this.data.array[ index + 0 ] = x;
				this.data.array[ index + 1 ] = y;
				this.data.array[ index + 2 ] = z;
	
				return this;
	
			},
	
			setXYZW: function ( index, x, y, z, w ) {
	
				index = index * this.data.stride + this.offset;
	
				this.data.array[ index + 0 ] = x;
				this.data.array[ index + 1 ] = y;
				this.data.array[ index + 2 ] = z;
				this.data.array[ index + 3 ] = w;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InterleavedBuffer( array, stride ) {
	
			this.uuid = _Math.generateUUID();
	
			this.array = array;
			this.stride = stride;
			this.count = array !== undefined ? array.length / stride : 0;
	
			this.dynamic = false;
			this.updateRange = { offset: 0, count: - 1 };
	
			this.onUploadCallback = function () {};
	
			this.version = 0;
	
		}
	
		Object.defineProperty( InterleavedBuffer.prototype, 'needsUpdate', {
	
			set: function ( value ) {
	
				if ( value === true ) this.version ++;
	
			}
	
		} );
	
		Object.assign( InterleavedBuffer.prototype, {
	
			isInterleavedBuffer: true,
	
			setArray: function ( array ) {
	
				if ( Array.isArray( array ) ) {
	
					throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );
	
				}
	
				this.count = array !== undefined ? array.length / this.stride : 0;
				this.array = array;
	
			},
	
			setDynamic: function ( value ) {
	
				this.dynamic = value;
	
				return this;
	
			},
	
			copy: function ( source ) {
	
				this.array = new source.array.constructor( source.array );
				this.count = source.count;
				this.stride = source.stride;
				this.dynamic = source.dynamic;
	
				return this;
	
			},
	
			copyAt: function ( index1, attribute, index2 ) {
	
				index1 *= this.stride;
				index2 *= attribute.stride;
	
				for ( var i = 0, l = this.stride; i < l; i ++ ) {
	
					this.array[ index1 + i ] = attribute.array[ index2 + i ];
	
				}
	
				return this;
	
			},
	
			set: function ( value, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.array.set( value, offset );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			onUpload: function ( callback ) {
	
				this.onUploadCallback = callback;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InstancedInterleavedBuffer( array, stride, meshPerAttribute ) {
	
			InterleavedBuffer.call( this, array, stride );
	
			this.meshPerAttribute = meshPerAttribute || 1;
	
		}
	
		InstancedInterleavedBuffer.prototype = Object.assign( Object.create( InterleavedBuffer.prototype ), {
	
			constructor: InstancedInterleavedBuffer,
	
			isInstancedInterleavedBuffer: true,
	
			copy: function ( source ) {
	
				InterleavedBuffer.prototype.copy.call( this, source );
	
				this.meshPerAttribute = source.meshPerAttribute;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InstancedBufferAttribute( array, itemSize, meshPerAttribute ) {
	
			BufferAttribute.call( this, array, itemSize );
	
			this.meshPerAttribute = meshPerAttribute || 1;
	
		}
	
		InstancedBufferAttribute.prototype = Object.assign( Object.create( BufferAttribute.prototype ), {
	
			constructor: InstancedBufferAttribute,
	
			isInstancedBufferAttribute: true,
	
			copy: function ( source ) {
	
				BufferAttribute.prototype.copy.call( this, source );
	
				this.meshPerAttribute = source.meshPerAttribute;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author bhouston / http://clara.io/
		 * @author stephomi / http://stephaneginier.com/
		 */
	
		function Raycaster( origin, direction, near, far ) {
	
			this.ray = new Ray( origin, direction );
			// direction is assumed to be normalized (for accurate distance calculations)
	
			this.near = near || 0;
			this.far = far || Infinity;
	
			this.params = {
				Mesh: {},
				Line: {},
				LOD: {},
				Points: { threshold: 1 },
				Sprite: {}
			};
	
			Object.defineProperties( this.params, {
				PointCloud: {
					get: function () {
						console.warn( 'THREE.Raycaster: params.PointCloud has been renamed to params.Points.' );
						return this.Points;
					}
				}
			} );
	
		}
	
		function ascSort( a, b ) {
	
			return a.distance - b.distance;
	
		}
	
		function intersectObject( object, raycaster, intersects, recursive ) {
	
			if ( object.visible === false ) return;
	
			object.raycast( raycaster, intersects );
	
			if ( recursive === true ) {
	
				var children = object.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					intersectObject( children[ i ], raycaster, intersects, true );
	
				}
	
			}
	
		}
	
		Object.assign( Raycaster.prototype, {
	
			linePrecision: 1,
	
			set: function ( origin, direction ) {
	
				// direction is assumed to be normalized (for accurate distance calculations)
	
				this.ray.set( origin, direction );
	
			},
	
			setFromCamera: function ( coords, camera ) {
	
				if ( ( camera && camera.isPerspectiveCamera ) ) {
	
					this.ray.origin.setFromMatrixPosition( camera.matrixWorld );
					this.ray.direction.set( coords.x, coords.y, 0.5 ).unproject( camera ).sub( this.ray.origin ).normalize();
	
				} else if ( ( camera && camera.isOrthographicCamera ) ) {
	
					this.ray.origin.set( coords.x, coords.y, ( camera.near + camera.far ) / ( camera.near - camera.far ) ).unproject( camera ); // set origin in plane of camera
					this.ray.direction.set( 0, 0, - 1 ).transformDirection( camera.matrixWorld );
	
				} else {
	
					console.error( 'THREE.Raycaster: Unsupported camera type.' );
	
				}
	
			},
	
			intersectObject: function ( object, recursive ) {
	
				var intersects = [];
	
				intersectObject( object, this, intersects, recursive );
	
				intersects.sort( ascSort );
	
				return intersects;
	
			},
	
			intersectObjects: function ( objects, recursive ) {
	
				var intersects = [];
	
				if ( Array.isArray( objects ) === false ) {
	
					console.warn( 'THREE.Raycaster.intersectObjects: objects is not an Array.' );
					return intersects;
	
				}
	
				for ( var i = 0, l = objects.length; i < l; i ++ ) {
	
					intersectObject( objects[ i ], this, intersects, recursive );
	
				}
	
				intersects.sort( ascSort );
	
				return intersects;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Clock( autoStart ) {
	
			this.autoStart = ( autoStart !== undefined ) ? autoStart : true;
	
			this.startTime = 0;
			this.oldTime = 0;
			this.elapsedTime = 0;
	
			this.running = false;
	
		}
	
		Object.assign( Clock.prototype, {
	
			start: function () {
	
				this.startTime = ( typeof performance === 'undefined' ? Date : performance ).now(); // see #10732
	
				this.oldTime = this.startTime;
				this.elapsedTime = 0;
				this.running = true;
	
			},
	
			stop: function () {
	
				this.getElapsedTime();
				this.running = false;
				this.autoStart = false;
	
			},
	
			getElapsedTime: function () {
	
				this.getDelta();
				return this.elapsedTime;
	
			},
	
			getDelta: function () {
	
				var diff = 0;
	
				if ( this.autoStart && ! this.running ) {
	
					this.start();
					return 0;
	
				}
	
				if ( this.running ) {
	
					var newTime = ( typeof performance === 'undefined' ? Date : performance ).now();
	
					diff = ( newTime - this.oldTime ) / 1000;
					this.oldTime = newTime;
	
					this.elapsedTime += diff;
	
				}
	
				return diff;
	
			}
	
		} );
	
		/**
		 * @author bhouston / http://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
		 *
		 * The poles (phi) are at the positive and negative y axis.
		 * The equator starts at positive z.
		 */
	
		function Spherical( radius, phi, theta ) {
	
			this.radius = ( radius !== undefined ) ? radius : 1.0;
			this.phi = ( phi !== undefined ) ? phi : 0; // up / down towards top and bottom pole
			this.theta = ( theta !== undefined ) ? theta : 0; // around the equator of the sphere
	
			return this;
	
		}
	
		Object.assign( Spherical.prototype, {
	
			set: function ( radius, phi, theta ) {
	
				this.radius = radius;
				this.phi = phi;
				this.theta = theta;
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( other ) {
	
				this.radius = other.radius;
				this.phi = other.phi;
				this.theta = other.theta;
	
				return this;
	
			},
	
			// restrict phi to be betwee EPS and PI-EPS
			makeSafe: function() {
	
				var EPS = 0.000001;
				this.phi = Math.max( EPS, Math.min( Math.PI - EPS, this.phi ) );
	
				return this;
	
			},
	
			setFromVector3: function( vec3 ) {
	
				this.radius = vec3.length();
	
				if ( this.radius === 0 ) {
	
					this.theta = 0;
					this.phi = 0;
	
				} else {
	
					this.theta = Math.atan2( vec3.x, vec3.z ); // equator angle around y-up axis
					this.phi = Math.acos( _Math.clamp( vec3.y / this.radius, - 1, 1 ) ); // polar angle
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
		 *
		 */
	
		function Cylindrical( radius, theta, y ) {
	
			this.radius = ( radius !== undefined ) ? radius : 1.0; // distance from the origin to a point in the x-z plane
			this.theta = ( theta !== undefined ) ? theta : 0; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
			this.y = ( y !== undefined ) ? y : 0; // height above the x-z plane
	
			return this;
	
		}
	
		Object.assign( Cylindrical.prototype, {
	
			set: function ( radius, theta, y ) {
	
				this.radius = radius;
				this.theta = theta;
				this.y = y;
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( other ) {
	
				this.radius = other.radius;
				this.theta = other.theta;
				this.y = other.y;
	
				return this;
	
			},
	
			setFromVector3: function( vec3 ) {
	
				this.radius = Math.sqrt( vec3.x * vec3.x + vec3.z * vec3.z );
				this.theta = Math.atan2( vec3.x, vec3.z );
				this.y = vec3.y;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function ImmediateRenderObject( material ) {
	
			Object3D.call( this );
	
			this.material = material;
			this.render = function ( renderCallback ) {};
	
		}
	
		ImmediateRenderObject.prototype = Object.create( Object3D.prototype );
		ImmediateRenderObject.prototype.constructor = ImmediateRenderObject;
	
		ImmediateRenderObject.prototype.isImmediateRenderObject = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function VertexNormalsHelper( object, size, hex, linewidth ) {
	
			this.object = object;
	
			this.size = ( size !== undefined ) ? size : 1;
	
			var color = ( hex !== undefined ) ? hex : 0xff0000;
	
			var width = ( linewidth !== undefined ) ? linewidth : 1;
	
			//
	
			var nNormals = 0;
	
			var objGeometry = this.object.geometry;
	
			if ( objGeometry && objGeometry.isGeometry ) {
	
				nNormals = objGeometry.faces.length * 3;
	
			} else if ( objGeometry && objGeometry.isBufferGeometry ) {
	
				nNormals = objGeometry.attributes.normal.count;
	
			}
	
			//
	
			var geometry = new BufferGeometry();
	
			var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );
	
			geometry.addAttribute( 'position', positions );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );
	
			//
	
			this.matrixAutoUpdate = false;
	
			this.update();
	
		}
	
		VertexNormalsHelper.prototype = Object.create( LineSegments.prototype );
		VertexNormalsHelper.prototype.constructor = VertexNormalsHelper;
	
		VertexNormalsHelper.prototype.update = ( function () {
	
			var v1 = new Vector3();
			var v2 = new Vector3();
			var normalMatrix = new Matrix3();
	
			return function update() {
	
				var keys = [ 'a', 'b', 'c' ];
	
				this.object.updateMatrixWorld( true );
	
				normalMatrix.getNormalMatrix( this.object.matrixWorld );
	
				var matrixWorld = this.object.matrixWorld;
	
				var position = this.geometry.attributes.position;
	
				//
	
				var objGeometry = this.object.geometry;
	
				if ( objGeometry && objGeometry.isGeometry ) {
	
					var vertices = objGeometry.vertices;
	
					var faces = objGeometry.faces;
	
					var idx = 0;
	
					for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
						var face = faces[ i ];
	
						for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {
	
							var vertex = vertices[ face[ keys[ j ] ] ];
	
							var normal = face.vertexNormals[ j ];
	
							v1.copy( vertex ).applyMatrix4( matrixWorld );
	
							v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );
	
							position.setXYZ( idx, v1.x, v1.y, v1.z );
	
							idx = idx + 1;
	
							position.setXYZ( idx, v2.x, v2.y, v2.z );
	
							idx = idx + 1;
	
						}
	
					}
	
				} else if ( objGeometry && objGeometry.isBufferGeometry ) {
	
					var objPos = objGeometry.attributes.position;
	
					var objNorm = objGeometry.attributes.normal;
	
					var idx = 0;
	
					// for simplicity, ignore index and drawcalls, and render every normal
	
					for ( var j = 0, jl = objPos.count; j < jl; j ++ ) {
	
						v1.set( objPos.getX( j ), objPos.getY( j ), objPos.getZ( j ) ).applyMatrix4( matrixWorld );
	
						v2.set( objNorm.getX( j ), objNorm.getY( j ), objNorm.getZ( j ) );
	
						v2.applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );
	
						position.setXYZ( idx, v1.x, v1.y, v1.z );
	
						idx = idx + 1;
	
						position.setXYZ( idx, v2.x, v2.y, v2.z );
	
						idx = idx + 1;
	
					}
	
				}
	
				position.needsUpdate = true;
	
			};
	
		}() );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function SpotLightHelper( light, color ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.color = color;
	
			var geometry = new BufferGeometry();
	
			var positions = [
				0, 0, 0,   0,   0,   1,
				0, 0, 0,   1,   0,   1,
				0, 0, 0, - 1,   0,   1,
				0, 0, 0,   0,   1,   1,
				0, 0, 0,   0, - 1,   1
			];
	
			for ( var i = 0, j = 1, l = 32; i < l; i ++, j ++ ) {
	
				var p1 = ( i / l ) * Math.PI * 2;
				var p2 = ( j / l ) * Math.PI * 2;
	
				positions.push(
					Math.cos( p1 ), Math.sin( p1 ), 1,
					Math.cos( p2 ), Math.sin( p2 ), 1
				);
	
			}
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
	
			var material = new LineBasicMaterial( { fog: false } );
	
			this.cone = new LineSegments( geometry, material );
			this.add( this.cone );
	
			this.update();
	
		}
	
		SpotLightHelper.prototype = Object.create( Object3D.prototype );
		SpotLightHelper.prototype.constructor = SpotLightHelper;
	
		SpotLightHelper.prototype.dispose = function () {
	
			this.cone.geometry.dispose();
			this.cone.material.dispose();
	
		};
	
		SpotLightHelper.prototype.update = function () {
	
			var vector = new Vector3();
			var vector2 = new Vector3();
	
			return function update() {
	
				this.light.updateMatrixWorld();
	
				var coneLength = this.light.distance ? this.light.distance : 1000;
				var coneWidth = coneLength * Math.tan( this.light.angle );
	
				this.cone.scale.set( coneWidth, coneWidth, coneLength );
	
				vector.setFromMatrixPosition( this.light.matrixWorld );
				vector2.setFromMatrixPosition( this.light.target.matrixWorld );
	
				this.cone.lookAt( vector2.sub( vector ) );
	
				if ( this.color !== undefined ) {
	
					this.cone.material.color.set( this.color );
	
				} else {
	
					this.cone.material.color.copy( this.light.color );
	
				}
	
			};
	
		}();
	
		/**
		 * @author Sean Griffin / http://twitter.com/sgrif
		 * @author Michael Guerrero / http://realitymeltdown.com
		 * @author mrdoob / http://mrdoob.com/
		 * @author ikerr / http://verold.com
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function getBoneList( object ) {
	
			var boneList = [];
	
			if ( object && object.isBone ) {
	
				boneList.push( object );
	
			}
	
			for ( var i = 0; i < object.children.length; i ++ ) {
	
				boneList.push.apply( boneList, getBoneList( object.children[ i ] ) );
	
			}
	
			return boneList;
	
		}
	
		function SkeletonHelper( object ) {
	
			var bones = getBoneList( object );
	
			var geometry = new BufferGeometry();
	
			var vertices = [];
			var colors = [];
	
			var color1 = new Color( 0, 0, 1 );
			var color2 = new Color( 0, 1, 0 );
	
			for ( var i = 0; i < bones.length; i ++ ) {
	
				var bone = bones[ i ];
	
				if ( bone.parent && bone.parent.isBone ) {
	
					vertices.push( 0, 0, 0 );
					vertices.push( 0, 0, 0 );
					colors.push( color1.r, color1.g, color1.b );
					colors.push( color2.r, color2.g, color2.b );
	
				}
	
			}
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors, depthTest: false, depthWrite: false, transparent: true } );
	
			LineSegments.call( this, geometry, material );
	
			this.root = object;
			this.bones = bones;
	
			this.matrix = object.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.onBeforeRender();
	
		}
	
		SkeletonHelper.prototype = Object.create( LineSegments.prototype );
		SkeletonHelper.prototype.constructor = SkeletonHelper;
	
		SkeletonHelper.prototype.onBeforeRender = function () {
	
			var vector = new Vector3();
	
			var boneMatrix = new Matrix4();
			var matrixWorldInv = new Matrix4();
	
			return function onBeforeRender() {
	
				var bones = this.bones;
	
				var geometry = this.geometry;
				var position = geometry.getAttribute( 'position' );
	
				matrixWorldInv.getInverse( this.root.matrixWorld );
	
				for ( var i = 0, j = 0; i < bones.length; i ++ ) {
	
					var bone = bones[ i ];
	
					if ( bone.parent && bone.parent.isBone ) {
	
						boneMatrix.multiplyMatrices( matrixWorldInv, bone.matrixWorld );
						vector.setFromMatrixPosition( boneMatrix );
						position.setXYZ( j, vector.x, vector.y, vector.z );
	
						boneMatrix.multiplyMatrices( matrixWorldInv, bone.parent.matrixWorld );
						vector.setFromMatrixPosition( boneMatrix );
						position.setXYZ( j + 1, vector.x, vector.y, vector.z );
	
						j += 2;
	
					}
	
				}
	
				geometry.getAttribute( 'position' ).needsUpdate = true;
	
			};
	
		}();
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function PointLightHelper( light, sphereSize, color ) {
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.color = color;
	
			var geometry = new SphereBufferGeometry( sphereSize, 4, 2 );
			var material = new MeshBasicMaterial( { wireframe: true, fog: false } );
	
			Mesh.call( this, geometry, material );
	
			this.matrix = this.light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.update();
	
	
			/*
			var distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
			var distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );
	
			this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
			this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );
	
			var d = light.distance;
	
			if ( d === 0.0 ) {
	
				this.lightDistance.visible = false;
	
			} else {
	
				this.lightDistance.scale.set( d, d, d );
	
			}
	
			this.add( this.lightDistance );
			*/
	
		}
	
		PointLightHelper.prototype = Object.create( Mesh.prototype );
		PointLightHelper.prototype.constructor = PointLightHelper;
	
		PointLightHelper.prototype.dispose = function () {
	
			this.geometry.dispose();
			this.material.dispose();
	
		};
	
		PointLightHelper.prototype.update = function () {
	
			if ( this.color !== undefined ) {
	
				this.material.color.set( this.color );
	
			} else {
	
				this.material.color.copy( this.light.color );
	
			}
	
			/*
			var d = this.light.distance;
	
			if ( d === 0.0 ) {
	
				this.lightDistance.visible = false;
	
			} else {
	
				this.lightDistance.visible = true;
				this.lightDistance.scale.set( d, d, d );
	
			}
			*/
	
		};
	
		/**
		 * @author abelnation / http://github.com/abelnation
		 * @author Mugen87 / http://github.com/Mugen87
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function RectAreaLightHelper( light, color ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.color = color;
	
			var material = new LineBasicMaterial( { fog: false } );
	
			var geometry = new BufferGeometry();
	
			geometry.addAttribute( 'position', new BufferAttribute( new Float32Array( 5 * 3 ), 3 ) );
	
			this.line = new Line( geometry, material );
			this.add( this.line );
	
	
			this.update();
	
		}
	
		RectAreaLightHelper.prototype = Object.create( Object3D.prototype );
		RectAreaLightHelper.prototype.constructor = RectAreaLightHelper;
	
		RectAreaLightHelper.prototype.dispose = function () {
	
			this.children[ 0 ].geometry.dispose();
			this.children[ 0 ].material.dispose();
	
		};
	
		RectAreaLightHelper.prototype.update = function () {
	
			// calculate new dimensions of the helper
	
			var hx = this.light.width * 0.5;
			var hy = this.light.height * 0.5;
	
			var position = this.line.geometry.attributes.position;
			var array = position.array;
	
			// update vertices
	
			array[  0 ] =   hx; array[  1 ] = - hy; array[  2 ] = 0;
			array[  3 ] =   hx; array[  4 ] =   hy; array[  5 ] = 0;
			array[  6 ] = - hx; array[  7 ] =   hy; array[  8 ] = 0;
			array[  9 ] = - hx; array[ 10 ] = - hy; array[ 11 ] = 0;
			array[ 12 ] =   hx; array[ 13 ] = - hy; array[ 14 ] = 0;
	
			position.needsUpdate = true;
	
			if ( this.color !== undefined ) {
	
				this.line.material.color.set( this.color );
	
			} else {
	
				this.line.material.color.copy( this.light.color );
	
			}
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function HemisphereLightHelper( light, size, color ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.color = color;
	
			var geometry = new OctahedronBufferGeometry( size );
			geometry.rotateY( Math.PI * 0.5 );
	
			this.material = new MeshBasicMaterial( { wireframe: true, fog: false } );
			if ( this.color === undefined ) this.material.vertexColors = VertexColors;
	
			var position = geometry.getAttribute( 'position' );
			var colors = new Float32Array( position.count * 3 );
	
			geometry.addAttribute( 'color', new BufferAttribute( colors, 3 ) );
	
			this.add( new Mesh( geometry, this.material ) );
	
			this.update();
	
		}
	
		HemisphereLightHelper.prototype = Object.create( Object3D.prototype );
		HemisphereLightHelper.prototype.constructor = HemisphereLightHelper;
	
		HemisphereLightHelper.prototype.dispose = function () {
	
			this.children[ 0 ].geometry.dispose();
			this.children[ 0 ].material.dispose();
	
		};
	
		HemisphereLightHelper.prototype.update = function () {
	
			var vector = new Vector3();
	
			var color1 = new Color();
			var color2 = new Color();
	
			return function update() {
	
				var mesh = this.children[ 0 ];
	
				if ( this.color !== undefined ) {
	
					this.material.color.set( this.color );
	
				} else {
	
					var colors = mesh.geometry.getAttribute( 'color' );
	
					color1.copy( this.light.color );
					color2.copy( this.light.groundColor );
	
					for ( var i = 0, l = colors.count; i < l; i ++ ) {
	
						var color = ( i < ( l / 2 ) ) ? color1 : color2;
	
						colors.setXYZ( i, color.r, color.g, color.b );
	
					}
	
					colors.needsUpdate = true;
	
				}
	
				mesh.lookAt( vector.setFromMatrixPosition( this.light.matrixWorld ).negate() );
	
			};
	
		}();
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function GridHelper( size, divisions, color1, color2 ) {
	
			size = size || 10;
			divisions = divisions || 10;
			color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
			color2 = new Color( color2 !== undefined ? color2 : 0x888888 );
	
			var center = divisions / 2;
			var step = size / divisions;
			var halfSize = size / 2;
	
			var vertices = [], colors = [];
	
			for ( var i = 0, j = 0, k = - halfSize; i <= divisions; i ++, k += step ) {
	
				vertices.push( - halfSize, 0, k, halfSize, 0, k );
				vertices.push( k, 0, - halfSize, k, 0, halfSize );
	
				var color = i === center ? color1 : color2;
	
				color.toArray( colors, j ); j += 3;
				color.toArray( colors, j ); j += 3;
				color.toArray( colors, j ); j += 3;
				color.toArray( colors, j ); j += 3;
	
			}
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors } );
	
			LineSegments.call( this, geometry, material );
	
		}
	
		GridHelper.prototype = Object.create( LineSegments.prototype );
		GridHelper.prototype.constructor = GridHelper;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / http://github.com/Mugen87
		 * @author Hectate / http://www.github.com/Hectate
		 */
	
		function PolarGridHelper( radius, radials, circles, divisions, color1, color2 ) {
	
			radius = radius || 10;
			radials = radials || 16;
			circles = circles || 8;
			divisions = divisions || 64;
			color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
			color2 = new Color( color2 !== undefined ? color2 : 0x888888 );
	
			var vertices = [];
			var colors = [];
	
			var x, z;
			var v, i, j, r, color;
	
			// create the radials
	
			for ( i = 0; i <= radials; i ++ ) {
	
				v = ( i / radials ) * ( Math.PI * 2 );
	
				x = Math.sin( v ) * radius;
				z = Math.cos( v ) * radius;
	
				vertices.push( 0, 0, 0 );
				vertices.push( x, 0, z );
	
				color = ( i & 1 ) ? color1 : color2;
	
				colors.push( color.r, color.g, color.b );
				colors.push( color.r, color.g, color.b );
	
			}
	
			// create the circles
	
			for ( i = 0; i <= circles; i ++ ) {
	
				color = ( i & 1 ) ? color1 : color2;
	
				r = radius - ( radius / circles * i );
	
				for ( j = 0; j < divisions; j ++ ) {
	
					// first vertex
	
					v = ( j / divisions ) * ( Math.PI * 2 );
	
					x = Math.sin( v ) * r;
					z = Math.cos( v ) * r;
	
					vertices.push( x, 0, z );
					colors.push( color.r, color.g, color.b );
	
					// second vertex
	
					v = ( ( j + 1 ) / divisions ) * ( Math.PI * 2 );
	
					x = Math.sin( v ) * r;
					z = Math.cos( v ) * r;
	
					vertices.push( x, 0, z );
					colors.push( color.r, color.g, color.b );
	
				}
	
			}
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors } );
	
			LineSegments.call( this, geometry, material );
	
		}
	
		PolarGridHelper.prototype = Object.create( LineSegments.prototype );
		PolarGridHelper.prototype.constructor = PolarGridHelper;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function FaceNormalsHelper( object, size, hex, linewidth ) {
	
			// FaceNormalsHelper only supports THREE.Geometry
	
			this.object = object;
	
			this.size = ( size !== undefined ) ? size : 1;
	
			var color = ( hex !== undefined ) ? hex : 0xffff00;
	
			var width = ( linewidth !== undefined ) ? linewidth : 1;
	
			//
	
			var nNormals = 0;
	
			var objGeometry = this.object.geometry;
	
			if ( objGeometry && objGeometry.isGeometry ) {
	
				nNormals = objGeometry.faces.length;
	
			} else {
	
				console.warn( 'THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.' );
	
			}
	
			//
	
			var geometry = new BufferGeometry();
	
			var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );
	
			geometry.addAttribute( 'position', positions );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );
	
			//
	
			this.matrixAutoUpdate = false;
			this.update();
	
		}
	
		FaceNormalsHelper.prototype = Object.create( LineSegments.prototype );
		FaceNormalsHelper.prototype.constructor = FaceNormalsHelper;
	
		FaceNormalsHelper.prototype.update = ( function () {
	
			var v1 = new Vector3();
			var v2 = new Vector3();
			var normalMatrix = new Matrix3();
	
			return function update() {
	
				this.object.updateMatrixWorld( true );
	
				normalMatrix.getNormalMatrix( this.object.matrixWorld );
	
				var matrixWorld = this.object.matrixWorld;
	
				var position = this.geometry.attributes.position;
	
				//
	
				var objGeometry = this.object.geometry;
	
				var vertices = objGeometry.vertices;
	
				var faces = objGeometry.faces;
	
				var idx = 0;
	
				for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
					var face = faces[ i ];
	
					var normal = face.normal;
	
					v1.copy( vertices[ face.a ] )
						.add( vertices[ face.b ] )
						.add( vertices[ face.c ] )
						.divideScalar( 3 )
						.applyMatrix4( matrixWorld );
	
					v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );
	
					position.setXYZ( idx, v1.x, v1.y, v1.z );
	
					idx = idx + 1;
	
					position.setXYZ( idx, v2.x, v2.y, v2.z );
	
					idx = idx + 1;
	
				}
	
				position.needsUpdate = true;
	
			};
	
		}() );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function DirectionalLightHelper( light, size, color ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.color = color;
	
			if ( size === undefined ) size = 1;
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( [
				- size,   size, 0,
				  size,   size, 0,
				  size, - size, 0,
				- size, - size, 0,
				- size,   size, 0
			], 3 ) );
	
			var material = new LineBasicMaterial( { fog: false } );
	
			this.lightPlane = new Line( geometry, material );
			this.add( this.lightPlane );
	
			geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1 ], 3 ) );
	
			this.targetLine = new Line( geometry, material );
			this.add( this.targetLine );
	
			this.update();
	
		}
	
		DirectionalLightHelper.prototype = Object.create( Object3D.prototype );
		DirectionalLightHelper.prototype.constructor = DirectionalLightHelper;
	
		DirectionalLightHelper.prototype.dispose = function () {
	
			this.lightPlane.geometry.dispose();
			this.lightPlane.material.dispose();
			this.targetLine.geometry.dispose();
			this.targetLine.material.dispose();
	
		};
	
		DirectionalLightHelper.prototype.update = function () {
	
			var v1 = new Vector3();
			var v2 = new Vector3();
			var v3 = new Vector3();
	
			return function update() {
	
				v1.setFromMatrixPosition( this.light.matrixWorld );
				v2.setFromMatrixPosition( this.light.target.matrixWorld );
				v3.subVectors( v2, v1 );
	
				this.lightPlane.lookAt( v3 );
	
				if ( this.color !== undefined ) {
	
					this.lightPlane.material.color.set( this.color );
					this.targetLine.material.color.set( this.color );
	
				} else {
	
					this.lightPlane.material.color.copy( this.light.color );
					this.targetLine.material.color.copy( this.light.color );
	
				}
	
				this.targetLine.lookAt( v3 );
				this.targetLine.scale.z = v3.length();
	
			};
	
		}();
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 *	- shows frustum, line of sight and up of the camera
		 *	- suitable for fast updates
		 * 	- based on frustum visualization in lightgl.js shadowmap example
		 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
		 */
	
		function CameraHelper( camera ) {
	
			var geometry = new BufferGeometry();
			var material = new LineBasicMaterial( { color: 0xffffff, vertexColors: FaceColors } );
	
			var vertices = [];
			var colors = [];
	
			var pointMap = {};
	
			// colors
	
			var colorFrustum = new Color( 0xffaa00 );
			var colorCone = new Color( 0xff0000 );
			var colorUp = new Color( 0x00aaff );
			var colorTarget = new Color( 0xffffff );
			var colorCross = new Color( 0x333333 );
	
			// near
	
			addLine( "n1", "n2", colorFrustum );
			addLine( "n2", "n4", colorFrustum );
			addLine( "n4", "n3", colorFrustum );
			addLine( "n3", "n1", colorFrustum );
	
			// far
	
			addLine( "f1", "f2", colorFrustum );
			addLine( "f2", "f4", colorFrustum );
			addLine( "f4", "f3", colorFrustum );
			addLine( "f3", "f1", colorFrustum );
	
			// sides
	
			addLine( "n1", "f1", colorFrustum );
			addLine( "n2", "f2", colorFrustum );
			addLine( "n3", "f3", colorFrustum );
			addLine( "n4", "f4", colorFrustum );
	
			// cone
	
			addLine( "p", "n1", colorCone );
			addLine( "p", "n2", colorCone );
			addLine( "p", "n3", colorCone );
			addLine( "p", "n4", colorCone );
	
			// up
	
			addLine( "u1", "u2", colorUp );
			addLine( "u2", "u3", colorUp );
			addLine( "u3", "u1", colorUp );
	
			// target
	
			addLine( "c", "t", colorTarget );
			addLine( "p", "c", colorCross );
	
			// cross
	
			addLine( "cn1", "cn2", colorCross );
			addLine( "cn3", "cn4", colorCross );
	
			addLine( "cf1", "cf2", colorCross );
			addLine( "cf3", "cf4", colorCross );
	
			function addLine( a, b, color ) {
	
				addPoint( a, color );
				addPoint( b, color );
	
			}
	
			function addPoint( id, color ) {
	
				vertices.push( 0, 0, 0 );
				colors.push( color.r, color.g, color.b );
	
				if ( pointMap[ id ] === undefined ) {
	
					pointMap[ id ] = [];
	
				}
	
				pointMap[ id ].push( ( vertices.length / 3 ) - 1 );
	
			}
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			LineSegments.call( this, geometry, material );
	
			this.camera = camera;
			if ( this.camera.updateProjectionMatrix ) this.camera.updateProjectionMatrix();
	
			this.matrix = camera.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.pointMap = pointMap;
	
			this.update();
	
		}
	
		CameraHelper.prototype = Object.create( LineSegments.prototype );
		CameraHelper.prototype.constructor = CameraHelper;
	
		CameraHelper.prototype.update = function () {
	
			var geometry, pointMap;
	
			var vector = new Vector3();
			var camera = new Camera();
	
			function setPoint( point, x, y, z ) {
	
				vector.set( x, y, z ).unproject( camera );
	
				var points = pointMap[ point ];
	
				if ( points !== undefined ) {
	
					var position = geometry.getAttribute( 'position' );
	
					for ( var i = 0, l = points.length; i < l; i ++ ) {
	
						position.setXYZ( points[ i ], vector.x, vector.y, vector.z );
	
					}
	
				}
	
			}
	
			return function update() {
	
				geometry = this.geometry;
				pointMap = this.pointMap;
	
				var w = 1, h = 1;
	
				// we need just camera projection matrix
				// world matrix must be identity
	
				camera.projectionMatrix.copy( this.camera.projectionMatrix );
	
				// center / target
	
				setPoint( "c", 0, 0, - 1 );
				setPoint( "t", 0, 0,  1 );
	
				// near
	
				setPoint( "n1", - w, - h, - 1 );
				setPoint( "n2",   w, - h, - 1 );
				setPoint( "n3", - w,   h, - 1 );
				setPoint( "n4",   w,   h, - 1 );
	
				// far
	
				setPoint( "f1", - w, - h, 1 );
				setPoint( "f2",   w, - h, 1 );
				setPoint( "f3", - w,   h, 1 );
				setPoint( "f4",   w,   h, 1 );
	
				// up
	
				setPoint( "u1",   w * 0.7, h * 1.1, - 1 );
				setPoint( "u2", - w * 0.7, h * 1.1, - 1 );
				setPoint( "u3",         0, h * 2,   - 1 );
	
				// cross
	
				setPoint( "cf1", - w,   0, 1 );
				setPoint( "cf2",   w,   0, 1 );
				setPoint( "cf3",   0, - h, 1 );
				setPoint( "cf4",   0,   h, 1 );
	
				setPoint( "cn1", - w,   0, - 1 );
				setPoint( "cn2",   w,   0, - 1 );
				setPoint( "cn3",   0, - h, - 1 );
				setPoint( "cn4",   0,   h, - 1 );
	
				geometry.getAttribute( 'position' ).needsUpdate = true;
	
			};
	
		}();
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / http://github.com/Mugen87
		 */
	
		function BoxHelper( object, color ) {
	
			this.object = object;
	
			if ( color === undefined ) color = 0xffff00;
	
			var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
			var positions = new Float32Array( 8 * 3 );
	
			var geometry = new BufferGeometry();
			geometry.setIndex( new BufferAttribute( indices, 1 ) );
			geometry.addAttribute( 'position', new BufferAttribute( positions, 3 ) );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );
	
			this.matrixAutoUpdate = false;
	
			this.update();
	
		}
	
		BoxHelper.prototype = Object.create( LineSegments.prototype );
		BoxHelper.prototype.constructor = BoxHelper;
	
		BoxHelper.prototype.update = ( function () {
	
			var box = new Box3();
	
			return function update( object ) {
	
				if ( object !== undefined ) {
	
					console.warn( 'THREE.BoxHelper: .update() has no longer arguments.' );
	
				}
	
				if ( this.object !== undefined ) {
	
					box.setFromObject( this.object );
	
				}
	
				if ( box.isEmpty() ) return;
	
				var min = box.min;
				var max = box.max;
	
				/*
				  5____4
				1/___0/|
				| 6__|_7
				2/___3/
	
				0: max.x, max.y, max.z
				1: min.x, max.y, max.z
				2: min.x, min.y, max.z
				3: max.x, min.y, max.z
				4: max.x, max.y, min.z
				5: min.x, max.y, min.z
				6: min.x, min.y, min.z
				7: max.x, min.y, min.z
				*/
	
				var position = this.geometry.attributes.position;
				var array = position.array;
	
				array[  0 ] = max.x; array[  1 ] = max.y; array[  2 ] = max.z;
				array[  3 ] = min.x; array[  4 ] = max.y; array[  5 ] = max.z;
				array[  6 ] = min.x; array[  7 ] = min.y; array[  8 ] = max.z;
				array[  9 ] = max.x; array[ 10 ] = min.y; array[ 11 ] = max.z;
				array[ 12 ] = max.x; array[ 13 ] = max.y; array[ 14 ] = min.z;
				array[ 15 ] = min.x; array[ 16 ] = max.y; array[ 17 ] = min.z;
				array[ 18 ] = min.x; array[ 19 ] = min.y; array[ 20 ] = min.z;
				array[ 21 ] = max.x; array[ 22 ] = min.y; array[ 23 ] = min.z;
	
				position.needsUpdate = true;
	
				this.geometry.computeBoundingSphere();
	
			};
	
		} )();
	
		BoxHelper.prototype.setFromObject = function ( object ) {
	
			this.object = object;
			this.update();
	
			return this;
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Box3Helper( box, hex ) {
	
			this.type = 'Box3Helper';
	
			this.box = box;
	
			var color = ( hex !== undefined ) ? hex : 0xffff00;
	
			var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
	
			var positions = [ 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, - 1, 1, 1, 1, - 1, - 1, 1, - 1, - 1, - 1, - 1, 1, - 1, - 1 ];
	
			var geometry = new BufferGeometry();
	
			geometry.setIndex( new BufferAttribute( indices, 1 ) );
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );
	
			this.geometry.computeBoundingSphere();
	
			this.onBeforeRender();
	
		}
	
		Box3Helper.prototype = Object.create( LineSegments.prototype );
		Box3Helper.prototype.constructor = Box3Helper;
	
		Box3Helper.prototype.onBeforeRender = function () {
	
			var box = this.box;
	
			if ( box.isEmpty() ) return;
	
			box.getCenter( this.position );
	
			box.getSize( this.scale );
	
			this.scale.multiplyScalar( 0.5 );
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function PlaneHelper( plane, size, hex ) {
	
			this.type = 'PlaneHelper';
	
			this.plane = plane;
	
			this.size = ( size === undefined ) ? 1 : size;
	
			var color = ( hex !== undefined ) ? hex : 0xffff00;
	
			var positions = [ 1, - 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, - 1, 1, 1, 1, 1, 0, 0, 1, 0, 0, 0 ];
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
			geometry.computeBoundingSphere();
	
			Line.call( this, geometry, new LineBasicMaterial( { color: color } ) );
	
			//
	
			var positions2 = [ 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, 1, 1, - 1, - 1, 1, 1, - 1, 1 ];
	
			var geometry2 = new BufferGeometry();
			geometry2.addAttribute( 'position', new Float32BufferAttribute( positions2, 3 ) );
			geometry2.computeBoundingSphere();
	
			this.add( new Mesh( geometry2, new MeshBasicMaterial( { color: color, opacity: 0.2, transparent: true, depthWrite: false } ) ) );
	
			//
	
			this.onBeforeRender();
	
		}
	
		PlaneHelper.prototype = Object.create( Line.prototype );
		PlaneHelper.prototype.constructor = PlaneHelper;
	
		PlaneHelper.prototype.onBeforeRender = function () {
	
			var scale = - this.plane.constant;
	
			if ( Math.abs( scale ) < 1e-8 ) scale = 1e-8; // sign does not matter
	
			this.scale.set( 0.5 * this.size, 0.5 * this.size, scale );
	
			this.lookAt( this.plane.normal );
	
			this.updateMatrixWorld();
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 * @author zz85 / http://github.com/zz85
		 * @author bhouston / http://clara.io
		 *
		 * Creates an arrow for visualizing directions
		 *
		 * Parameters:
		 *  dir - Vector3
		 *  origin - Vector3
		 *  length - Number
		 *  color - color in hex value
		 *  headLength - Number
		 *  headWidth - Number
		 */
	
		var lineGeometry;
		var coneGeometry;
	
		function ArrowHelper( dir, origin, length, color, headLength, headWidth ) {
	
			// dir is assumed to be normalized
	
			Object3D.call( this );
	
			if ( color === undefined ) color = 0xffff00;
			if ( length === undefined ) length = 1;
			if ( headLength === undefined ) headLength = 0.2 * length;
			if ( headWidth === undefined ) headWidth = 0.2 * headLength;
	
			if ( lineGeometry === undefined ) {
	
				lineGeometry = new BufferGeometry();
				lineGeometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 1, 0 ], 3 ) );
	
				coneGeometry = new CylinderBufferGeometry( 0, 0.5, 1, 5, 1 );
				coneGeometry.translate( 0, - 0.5, 0 );
	
			}
	
			this.position.copy( origin );
	
			this.line = new Line( lineGeometry, new LineBasicMaterial( { color: color } ) );
			this.line.matrixAutoUpdate = false;
			this.add( this.line );
	
			this.cone = new Mesh( coneGeometry, new MeshBasicMaterial( { color: color } ) );
			this.cone.matrixAutoUpdate = false;
			this.add( this.cone );
	
			this.setDirection( dir );
			this.setLength( length, headLength, headWidth );
	
		}
	
		ArrowHelper.prototype = Object.create( Object3D.prototype );
		ArrowHelper.prototype.constructor = ArrowHelper;
	
		ArrowHelper.prototype.setDirection = ( function () {
	
			var axis = new Vector3();
			var radians;
	
			return function setDirection( dir ) {
	
				// dir is assumed to be normalized
	
				if ( dir.y > 0.99999 ) {
	
					this.quaternion.set( 0, 0, 0, 1 );
	
				} else if ( dir.y < - 0.99999 ) {
	
					this.quaternion.set( 1, 0, 0, 0 );
	
				} else {
	
					axis.set( dir.z, 0, - dir.x ).normalize();
	
					radians = Math.acos( dir.y );
	
					this.quaternion.setFromAxisAngle( axis, radians );
	
				}
	
			};
	
		}() );
	
		ArrowHelper.prototype.setLength = function ( length, headLength, headWidth ) {
	
			if ( headLength === undefined ) headLength = 0.2 * length;
			if ( headWidth === undefined ) headWidth = 0.2 * headLength;
	
			this.line.scale.set( 1, Math.max( 0, length - headLength ), 1 );
			this.line.updateMatrix();
	
			this.cone.scale.set( headWidth, headLength, headWidth );
			this.cone.position.y = length;
			this.cone.updateMatrix();
	
		};
	
		ArrowHelper.prototype.setColor = function ( color ) {
	
			this.line.material.color.copy( color );
			this.cone.material.color.copy( color );
	
		};
	
		/**
		 * @author sroucheray / http://sroucheray.org/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AxisHelper( size ) {
	
			size = size || 1;
	
			var vertices = [
				0, 0, 0,  size, 0, 0,
				0, 0, 0,  0, size, 0,
				0, 0, 0,  0, 0, size
			];
	
			var colors = [
				1, 0, 0,  1, 0.6, 0,
				0, 1, 0,  0.6, 1, 0,
				0, 0, 1,  0, 0.6, 1
			];
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors } );
	
			LineSegments.call( this, geometry, material );
	
		}
	
		AxisHelper.prototype = Object.create( LineSegments.prototype );
		AxisHelper.prototype.constructor = AxisHelper;
	
		/**
		 * @author zz85 https://github.com/zz85
		 *
		 * Centripetal CatmullRom Curve - which is useful for avoiding
		 * cusps and self-intersections in non-uniform catmull rom curves.
		 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
		 *
		 * curve.type accepts centripetal(default), chordal and catmullrom
		 * curve.tension is used for catmullrom which defaults to 0.5
		 */
	
	
		/*
		Based on an optimized c++ solution in
		 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
		 - http://ideone.com/NoEbVM
	
		This CubicPoly class could be used for reusing some variables and calculations,
		but for three.js curve use, it could be possible inlined and flatten into a single function call
		which can be placed in CurveUtils.
		*/
	
		function CubicPoly() {
	
			var c0 = 0, c1 = 0, c2 = 0, c3 = 0;
	
			/*
			 * Compute coefficients for a cubic polynomial
			 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
			 * such that
			 *   p(0) = x0, p(1) = x1
			 *  and
			 *   p'(0) = t0, p'(1) = t1.
			 */
			function init( x0, x1, t0, t1 ) {
	
				c0 = x0;
				c1 = t0;
				c2 = - 3 * x0 + 3 * x1 - 2 * t0 - t1;
				c3 = 2 * x0 - 2 * x1 + t0 + t1;
	
			}
	
			return {
	
				initCatmullRom: function ( x0, x1, x2, x3, tension ) {
	
					init( x1, x2, tension * ( x2 - x0 ), tension * ( x3 - x1 ) );
	
				},
	
				initNonuniformCatmullRom: function ( x0, x1, x2, x3, dt0, dt1, dt2 ) {
	
					// compute tangents when parameterized in [t1,t2]
					var t1 = ( x1 - x0 ) / dt0 - ( x2 - x0 ) / ( dt0 + dt1 ) + ( x2 - x1 ) / dt1;
					var t2 = ( x2 - x1 ) / dt1 - ( x3 - x1 ) / ( dt1 + dt2 ) + ( x3 - x2 ) / dt2;
	
					// rescale tangents for parametrization in [0,1]
					t1 *= dt1;
					t2 *= dt1;
	
					init( x1, x2, t1, t2 );
	
				},
	
				calc: function ( t ) {
	
					var t2 = t * t;
					var t3 = t2 * t;
					return c0 + c1 * t + c2 * t2 + c3 * t3;
	
				}
	
			};
	
		}
	
		//
	
		var tmp = new Vector3();
		var px = new CubicPoly();
		var py = new CubicPoly();
		var pz = new CubicPoly();
	
		function CatmullRomCurve3( points ) {
	
			Curve.call( this );
	
			if ( points.length < 2 ) console.warn( 'THREE.CatmullRomCurve3: Points array needs at least two entries.' );
	
			this.points = points || [];
			this.closed = false;
	
		}
	
		CatmullRomCurve3.prototype = Object.create( Curve.prototype );
		CatmullRomCurve3.prototype.constructor = CatmullRomCurve3;
	
		CatmullRomCurve3.prototype.getPoint = function ( t ) {
	
			var points = this.points;
			var l = points.length;
	
			var point = ( l - ( this.closed ? 0 : 1 ) ) * t;
			var intPoint = Math.floor( point );
			var weight = point - intPoint;
	
			if ( this.closed ) {
	
				intPoint += intPoint > 0 ? 0 : ( Math.floor( Math.abs( intPoint ) / points.length ) + 1 ) * points.length;
	
			} else if ( weight === 0 && intPoint === l - 1 ) {
	
				intPoint = l - 2;
				weight = 1;
	
			}
	
			var p0, p1, p2, p3; // 4 points
	
			if ( this.closed || intPoint > 0 ) {
	
				p0 = points[ ( intPoint - 1 ) % l ];
	
			} else {
	
				// extrapolate first point
				tmp.subVectors( points[ 0 ], points[ 1 ] ).add( points[ 0 ] );
				p0 = tmp;
	
			}
	
			p1 = points[ intPoint % l ];
			p2 = points[ ( intPoint + 1 ) % l ];
	
			if ( this.closed || intPoint + 2 < l ) {
	
				p3 = points[ ( intPoint + 2 ) % l ];
	
			} else {
	
				// extrapolate last point
				tmp.subVectors( points[ l - 1 ], points[ l - 2 ] ).add( points[ l - 1 ] );
				p3 = tmp;
	
			}
	
			if ( this.type === undefined || this.type === 'centripetal' || this.type === 'chordal' ) {
	
				// init Centripetal / Chordal Catmull-Rom
				var pow = this.type === 'chordal' ? 0.5 : 0.25;
				var dt0 = Math.pow( p0.distanceToSquared( p1 ), pow );
				var dt1 = Math.pow( p1.distanceToSquared( p2 ), pow );
				var dt2 = Math.pow( p2.distanceToSquared( p3 ), pow );
	
				// safety check for repeated points
				if ( dt1 < 1e-4 ) dt1 = 1.0;
				if ( dt0 < 1e-4 ) dt0 = dt1;
				if ( dt2 < 1e-4 ) dt2 = dt1;
	
				px.initNonuniformCatmullRom( p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2 );
				py.initNonuniformCatmullRom( p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2 );
				pz.initNonuniformCatmullRom( p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2 );
	
			} else if ( this.type === 'catmullrom' ) {
	
				var tension = this.tension !== undefined ? this.tension : 0.5;
				px.initCatmullRom( p0.x, p1.x, p2.x, p3.x, tension );
				py.initCatmullRom( p0.y, p1.y, p2.y, p3.y, tension );
				pz.initCatmullRom( p0.z, p1.z, p2.z, p3.z, tension );
	
			}
	
			return new Vector3( px.calc( weight ), py.calc( weight ), pz.calc( weight ) );
	
		};
	
		function CubicBezierCurve3( v0, v1, v2, v3 ) {
	
			Curve.call( this );
	
			this.v0 = v0;
			this.v1 = v1;
			this.v2 = v2;
			this.v3 = v3;
	
		}
	
		CubicBezierCurve3.prototype = Object.create( Curve.prototype );
		CubicBezierCurve3.prototype.constructor = CubicBezierCurve3;
	
		CubicBezierCurve3.prototype.getPoint = function ( t ) {
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
	
			return new Vector3(
				CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
				CubicBezier( t, v0.y, v1.y, v2.y, v3.y ),
				CubicBezier( t, v0.z, v1.z, v2.z, v3.z )
			);
	
		};
	
		function QuadraticBezierCurve3( v0, v1, v2 ) {
	
			Curve.call( this );
	
			this.v0 = v0;
			this.v1 = v1;
			this.v2 = v2;
	
		}
	
		QuadraticBezierCurve3.prototype = Object.create( Curve.prototype );
		QuadraticBezierCurve3.prototype.constructor = QuadraticBezierCurve3;
	
		QuadraticBezierCurve3.prototype.getPoint = function ( t ) {
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2;
	
			return new Vector3(
				QuadraticBezier( t, v0.x, v1.x, v2.x ),
				QuadraticBezier( t, v0.y, v1.y, v2.y ),
				QuadraticBezier( t, v0.z, v1.z, v2.z )
			);
	
		};
	
		function LineCurve3( v1, v2 ) {
	
			Curve.call( this );
	
			this.v1 = v1;
			this.v2 = v2;
	
		}
	
		LineCurve3.prototype = Object.create( Curve.prototype );
		LineCurve3.prototype.constructor = LineCurve3;
	
		LineCurve3.prototype.getPoint = function ( t ) {
	
			if ( t === 1 ) {
	
				return this.v2.clone();
	
			}
	
			var vector = new Vector3();
	
			vector.subVectors( this.v2, this.v1 ); // diff
			vector.multiplyScalar( t );
			vector.add( this.v1 );
	
			return vector;
	
		};
	
		function ArcCurve( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {
	
			EllipseCurve.call( this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );
	
		}
	
		ArcCurve.prototype = Object.create( EllipseCurve.prototype );
		ArcCurve.prototype.constructor = ArcCurve;
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		var SceneUtils = {
	
			createMultiMaterialObject: function ( geometry, materials ) {
	
				var group = new Group();
	
				for ( var i = 0, l = materials.length; i < l; i ++ ) {
	
					group.add( new Mesh( geometry, materials[ i ] ) );
	
				}
	
				return group;
	
			},
	
			detach: function ( child, parent, scene ) {
	
				child.applyMatrix( parent.matrixWorld );
				parent.remove( child );
				scene.add( child );
	
			},
	
			attach: function ( child, scene, parent ) {
	
				child.applyMatrix( new Matrix4().getInverse( parent.matrixWorld ) );
	
				scene.remove( child );
				parent.add( child );
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Face4( a, b, c, d, normal, color, materialIndex ) {
	
			console.warn( 'THREE.Face4 has been removed. A THREE.Face3 will be created instead.' );
			return new Face3( a, b, c, normal, color, materialIndex );
	
		}
	
		var LineStrip = 0;
	
		var LinePieces = 1;
	
		function MeshFaceMaterial( materials ) {
	
			console.warn( 'THREE.MeshFaceMaterial has been removed. Use an Array instead.' );
			return materials;
	
		}
	
		function MultiMaterial( materials ) {
	
			if ( materials === undefined ) materials = [];
	
			console.warn( 'THREE.MultiMaterial has been removed. Use an Array instead.' );
			materials.isMultiMaterial = true;
			materials.materials = materials;
			materials.clone = function () {
	
				return materials.slice();
	
			};
			return materials;
	
		}
	
		function PointCloud( geometry, material ) {
	
			console.warn( 'THREE.PointCloud has been renamed to THREE.Points.' );
			return new Points( geometry, material );
	
		}
	
		function Particle( material ) {
	
			console.warn( 'THREE.Particle has been renamed to THREE.Sprite.' );
			return new Sprite( material );
	
		}
	
		function ParticleSystem( geometry, material ) {
	
			console.warn( 'THREE.ParticleSystem has been renamed to THREE.Points.' );
			return new Points( geometry, material );
	
		}
	
		function PointCloudMaterial( parameters ) {
	
			console.warn( 'THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.' );
			return new PointsMaterial( parameters );
	
		}
	
		function ParticleBasicMaterial( parameters ) {
	
			console.warn( 'THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.' );
			return new PointsMaterial( parameters );
	
		}
	
		function ParticleSystemMaterial( parameters ) {
	
			console.warn( 'THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.' );
			return new PointsMaterial( parameters );
	
		}
	
		function Vertex( x, y, z ) {
	
			console.warn( 'THREE.Vertex has been removed. Use THREE.Vector3 instead.' );
			return new Vector3( x, y, z );
	
		}
	
		//
	
		function DynamicBufferAttribute( array, itemSize ) {
	
			console.warn( 'THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setDynamic( true ) instead.' );
			return new BufferAttribute( array, itemSize ).setDynamic( true );
	
		}
	
		function Int8Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.' );
			return new Int8BufferAttribute( array, itemSize );
	
		}
	
		function Uint8Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.' );
			return new Uint8BufferAttribute( array, itemSize );
	
		}
	
		function Uint8ClampedAttribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.' );
			return new Uint8ClampedBufferAttribute( array, itemSize );
	
		}
	
		function Int16Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.' );
			return new Int16BufferAttribute( array, itemSize );
	
		}
	
		function Uint16Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.' );
			return new Uint16BufferAttribute( array, itemSize );
	
		}
	
		function Int32Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.' );
			return new Int32BufferAttribute( array, itemSize );
	
		}
	
		function Uint32Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.' );
			return new Uint32BufferAttribute( array, itemSize );
	
		}
	
		function Float32Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.' );
			return new Float32BufferAttribute( array, itemSize );
	
		}
	
		function Float64Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.' );
			return new Float64BufferAttribute( array, itemSize );
	
		}
	
		//
	
		Curve.create = function ( construct, getPoint ) {
	
			console.log( 'THREE.Curve.create() has been deprecated' );
	
			construct.prototype = Object.create( Curve.prototype );
			construct.prototype.constructor = construct;
			construct.prototype.getPoint = getPoint;
	
			return construct;
	
		};
	
		//
	
		function ClosedSplineCurve3( points ) {
	
			console.warn( 'THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );
	
			CatmullRomCurve3.call( this, points );
			this.type = 'catmullrom';
			this.closed = true;
	
		}
	
		ClosedSplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );
	
		//
	
		function SplineCurve3( points ) {
	
			console.warn( 'THREE.SplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );
	
			CatmullRomCurve3.call( this, points );
			this.type = 'catmullrom';
	
		}
	
		SplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );
	
		//
	
		function Spline( points ) {
	
			console.warn( 'THREE.Spline has been removed. Use THREE.CatmullRomCurve3 instead.' );
	
			CatmullRomCurve3.call( this, points );
			this.type = 'catmullrom';
	
		}
	
		Spline.prototype = Object.create( CatmullRomCurve3.prototype );
	
		Object.assign( Spline.prototype, {
	
			initFromArray: function ( a ) {
	
				console.error( 'THREE.Spline: .initFromArray() has been removed.' );
	
			},
			getControlPointsArray: function ( optionalTarget ) {
	
				console.error( 'THREE.Spline: .getControlPointsArray() has been removed.' );
	
			},
			reparametrizeByArcLength: function ( samplingCoef ) {
	
				console.error( 'THREE.Spline: .reparametrizeByArcLength() has been removed.' );
	
			}
	
		} );
	
		//
		function BoundingBoxHelper( object, color ) {
	
			console.warn( 'THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.' );
			return new BoxHelper( object, color );
	
		}
	
		function EdgesHelper( object, hex ) {
	
			console.warn( 'THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.' );
			return new LineSegments( new EdgesGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );
	
		}
	
		GridHelper.prototype.setColors = function () {
	
			console.error( 'THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.' );
	
		};
	
		SkeletonHelper.prototype.update = function () {
	
			console.error( 'THREE.SkeletonHelper: update() no longer needs to be called.' );
	
		};
	
		function WireframeHelper( object, hex ) {
	
			console.warn( 'THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.' );
			return new LineSegments( new WireframeGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );
	
		}
	
		//
	
		function XHRLoader( manager ) {
	
			console.warn( 'THREE.XHRLoader has been renamed to THREE.FileLoader.' );
			return new FileLoader( manager );
	
		}
	
		function BinaryTextureLoader( manager ) {
	
			console.warn( 'THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.' );
			return new DataTextureLoader( manager );
	
		}
	
		//
	
		Object.assign( Box2.prototype, {
	
			center: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box2: .center() has been renamed to .getCenter().' );
				return this.getCenter( optionalTarget );
	
			},
			empty: function () {
	
				console.warn( 'THREE.Box2: .empty() has been renamed to .isEmpty().' );
				return this.isEmpty();
	
			},
			isIntersectionBox: function ( box ) {
	
				console.warn( 'THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().' );
				return this.intersectsBox( box );
	
			},
			size: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box2: .size() has been renamed to .getSize().' );
				return this.getSize( optionalTarget );
	
			}
		} );
	
		Object.assign( Box3.prototype, {
	
			center: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box3: .center() has been renamed to .getCenter().' );
				return this.getCenter( optionalTarget );
	
			},
			empty: function () {
	
				console.warn( 'THREE.Box3: .empty() has been renamed to .isEmpty().' );
				return this.isEmpty();
	
			},
			isIntersectionBox: function ( box ) {
	
				console.warn( 'THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().' );
				return this.intersectsBox( box );
	
			},
			isIntersectionSphere: function ( sphere ) {
	
				console.warn( 'THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
				return this.intersectsSphere( sphere );
	
			},
			size: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box3: .size() has been renamed to .getSize().' );
				return this.getSize( optionalTarget );
	
			}
		} );
	
		Line3.prototype.center = function ( optionalTarget ) {
	
			console.warn( 'THREE.Line3: .center() has been renamed to .getCenter().' );
			return this.getCenter( optionalTarget );
	
		};
	
		_Math.random16 = function () {
	
			console.warn( 'THREE.Math.random16() has been deprecated. Use Math.random() instead.' );
			return Math.random();
	
		};
	
		Object.assign( Matrix3.prototype, {
	
			flattenToArrayOffset: function ( array, offset ) {
	
				console.warn( "THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
				return this.toArray( array, offset );
	
			},
			multiplyVector3: function ( vector ) {
	
				console.warn( 'THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.' );
				return vector.applyMatrix3( this );
	
			},
			multiplyVector3Array: function ( a ) {
	
				console.error( 'THREE.Matrix3: .multiplyVector3Array() has been removed.'  );
	
			},
			applyToBuffer: function( buffer, offset, length ) {
	
				console.warn( 'THREE.Matrix3: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
				return this.applyToBufferAttribute( buffer );
	
			},
			applyToVector3Array: function( array, offset, length ) {
	
				console.error( 'THREE.Matrix3: .applyToVector3Array() has been removed.' );
	
			}
	
		} );
	
		Object.assign( Matrix4.prototype, {
	
			extractPosition: function ( m ) {
	
				console.warn( 'THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().' );
				return this.copyPosition( m );
	
			},
			flattenToArrayOffset: function ( array, offset ) {
	
				console.warn( "THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
				return this.toArray( array, offset );
	
			},
			getPosition: function () {
	
				var v1;
	
				return function getPosition() {
	
					if ( v1 === undefined ) v1 = new Vector3();
					console.warn( 'THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.' );
					return v1.setFromMatrixColumn( this, 3 );
	
				};
	
			}(),
			setRotationFromQuaternion: function ( q ) {
	
				console.warn( 'THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().' );
				return this.makeRotationFromQuaternion( q );
	
			},
			multiplyToArray: function () {
	
				console.warn( 'THREE.Matrix4: .multiplyToArray() has been removed.' );
	
			},
			multiplyVector3: function ( vector ) {
	
				console.warn( 'THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
				return vector.applyMatrix4( this );
	
			},
			multiplyVector4: function ( vector ) {
	
				console.warn( 'THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
				return vector.applyMatrix4( this );
	
			},
			multiplyVector3Array: function ( a ) {
	
				console.error( 'THREE.Matrix4: .multiplyVector3Array() has been removed.'  );
	
			},
			rotateAxis: function ( v ) {
	
				console.warn( 'THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.' );
				v.transformDirection( this );
	
			},
			crossVector: function ( vector ) {
	
				console.warn( 'THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
				return vector.applyMatrix4( this );
	
			},
			translate: function () {
	
				console.error( 'THREE.Matrix4: .translate() has been removed.' );
	
			},
			rotateX: function () {
	
				console.error( 'THREE.Matrix4: .rotateX() has been removed.' );
	
			},
			rotateY: function () {
	
				console.error( 'THREE.Matrix4: .rotateY() has been removed.' );
	
			},
			rotateZ: function () {
	
				console.error( 'THREE.Matrix4: .rotateZ() has been removed.' );
	
			},
			rotateByAxis: function () {
	
				console.error( 'THREE.Matrix4: .rotateByAxis() has been removed.' );
	
			},
			applyToBuffer: function( buffer, offset, length ) {
	
				console.warn( 'THREE.Matrix4: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
				return this.applyToBufferAttribute( buffer );
	
			},
			applyToVector3Array: function( array, offset, length ) {
	
				console.error( 'THREE.Matrix4: .applyToVector3Array() has been removed.' );
	
			},
			makeFrustum: function( left, right, bottom, top, near, far ) {
	
				console.warn( 'THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.' );
				return this.makePerspective( left, right, top, bottom, near, far );
	
			}
	
		} );
	
		Plane.prototype.isIntersectionLine = function ( line ) {
	
			console.warn( 'THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().' );
			return this.intersectsLine( line );
	
		};
	
		Quaternion.prototype.multiplyVector3 = function ( vector ) {
	
			console.warn( 'THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.' );
			return vector.applyQuaternion( this );
	
		};
	
		Object.assign( Ray.prototype, {
	
			isIntersectionBox: function ( box ) {
	
				console.warn( 'THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().' );
				return this.intersectsBox( box );
	
			},
			isIntersectionPlane: function ( plane ) {
	
				console.warn( 'THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().' );
				return this.intersectsPlane( plane );
	
			},
			isIntersectionSphere: function ( sphere ) {
	
				console.warn( 'THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
				return this.intersectsSphere( sphere );
	
			}
	
		} );
	
		Object.assign( Shape.prototype, {
	
			extrude: function ( options ) {
	
				console.warn( 'THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.' );
				return new ExtrudeGeometry( this, options );
	
			},
			makeGeometry: function ( options ) {
	
				console.warn( 'THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.' );
				return new ShapeGeometry( this, options );
	
			}
	
		} );
	
		Object.assign( Vector2.prototype, {
	
			fromAttribute: function ( attribute, index, offset ) {
	
				console.error( 'THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().' );
				return this.fromBufferAttribute( attribute, index, offset );
	
			}
	
		} );
	
		Object.assign( Vector3.prototype, {
	
			setEulerFromRotationMatrix: function () {
	
				console.error( 'THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.' );
	
			},
			setEulerFromQuaternion: function () {
	
				console.error( 'THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.' );
	
			},
			getPositionFromMatrix: function ( m ) {
	
				console.warn( 'THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().' );
				return this.setFromMatrixPosition( m );
	
			},
			getScaleFromMatrix: function ( m ) {
	
				console.warn( 'THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().' );
				return this.setFromMatrixScale( m );
	
			},
			getColumnFromMatrix: function ( index, matrix ) {
	
				console.warn( 'THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().' );
				return this.setFromMatrixColumn( matrix, index );
	
			},
			applyProjection: function ( m ) {
	
				console.warn( 'THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.' );
				return this.applyMatrix4( m );
	
			},
			fromAttribute: function ( attribute, index, offset ) {
	
				console.error( 'THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().' );
				return this.fromBufferAttribute( attribute, index, offset );
	
			}
	
		} );
	
		Object.assign( Vector4.prototype, {
	
			fromAttribute: function ( attribute, index, offset ) {
	
				console.error( 'THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().' );
				return this.fromBufferAttribute( attribute, index, offset );
	
			}
	
		} );
	
		//
	
		Geometry.prototype.computeTangents = function () {
	
			console.warn( 'THREE.Geometry: .computeTangents() has been removed.' );
	
		};
	
		Object.assign( Object3D.prototype, {
	
			getChildByName: function ( name ) {
	
				console.warn( 'THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().' );
				return this.getObjectByName( name );
	
			},
			renderDepth: function () {
	
				console.warn( 'THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.' );
	
			},
			translate: function ( distance, axis ) {
	
				console.warn( 'THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.' );
				return this.translateOnAxis( axis, distance );
	
			}
	
		} );
	
		Object.defineProperties( Object3D.prototype, {
	
			eulerOrder: {
				get: function () {
	
					console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
					return this.rotation.order;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
					this.rotation.order = value;
	
				}
			},
			useQuaternion: {
				get: function () {
	
					console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );
	
				},
				set: function () {
	
					console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );
	
				}
			}
	
		} );
	
		Object.defineProperties( LOD.prototype, {
	
			objects: {
				get: function () {
	
					console.warn( 'THREE.LOD: .objects has been renamed to .levels.' );
					return this.levels;
	
				}
			}
	
		} );
	
		Object.defineProperty( Skeleton.prototype, 'useVertexTexture', {
	
			get: function () {
	
				console.warn( 'THREE.Skeleton: useVertexTexture has been removed.' );
	
			},
			set: function () {
	
				console.warn( 'THREE.Skeleton: useVertexTexture has been removed.' );
	
			}
	
		} );
	
		Object.defineProperty( Curve.prototype, '__arcLengthDivisions', {
	
			get: function () {
	
				console.warn( 'THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.' );
				return this.arcLengthDivisions;
	
			},
			set: function ( value ) {
	
				console.warn( 'THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.' );
				this.arcLengthDivisions = value;
	
			}
	
		} );
	
		//
	
		PerspectiveCamera.prototype.setLens = function ( focalLength, filmGauge ) {
	
			console.warn( "THREE.PerspectiveCamera.setLens is deprecated. " +
					"Use .setFocalLength and .filmGauge for a photographic setup." );
	
			if ( filmGauge !== undefined ) this.filmGauge = filmGauge;
			this.setFocalLength( focalLength );
	
		};
	
		//
	
		Object.defineProperties( Light.prototype, {
			onlyShadow: {
				set: function () {
	
					console.warn( 'THREE.Light: .onlyShadow has been removed.' );
	
				}
			},
			shadowCameraFov: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraFov is now .shadow.camera.fov.' );
					this.shadow.camera.fov = value;
	
				}
			},
			shadowCameraLeft: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraLeft is now .shadow.camera.left.' );
					this.shadow.camera.left = value;
	
				}
			},
			shadowCameraRight: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraRight is now .shadow.camera.right.' );
					this.shadow.camera.right = value;
	
				}
			},
			shadowCameraTop: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraTop is now .shadow.camera.top.' );
					this.shadow.camera.top = value;
	
				}
			},
			shadowCameraBottom: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.' );
					this.shadow.camera.bottom = value;
	
				}
			},
			shadowCameraNear: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraNear is now .shadow.camera.near.' );
					this.shadow.camera.near = value;
	
				}
			},
			shadowCameraFar: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraFar is now .shadow.camera.far.' );
					this.shadow.camera.far = value;
	
				}
			},
			shadowCameraVisible: {
				set: function () {
	
					console.warn( 'THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.' );
	
				}
			},
			shadowBias: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowBias is now .shadow.bias.' );
					this.shadow.bias = value;
	
				}
			},
			shadowDarkness: {
				set: function () {
	
					console.warn( 'THREE.Light: .shadowDarkness has been removed.' );
	
				}
			},
			shadowMapWidth: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.' );
					this.shadow.mapSize.width = value;
	
				}
			},
			shadowMapHeight: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.' );
					this.shadow.mapSize.height = value;
	
				}
			}
		} );
	
		//
	
		Object.defineProperties( BufferAttribute.prototype, {
	
			length: {
				get: function () {
	
					console.warn( 'THREE.BufferAttribute: .length has been deprecated. Use .count instead.' );
					return this.array.length;
	
				}
			}
	
		} );
	
		Object.assign( BufferGeometry.prototype, {
	
			addIndex: function ( index ) {
	
				console.warn( 'THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().' );
				this.setIndex( index );
	
			},
			addDrawCall: function ( start, count, indexOffset ) {
	
				if ( indexOffset !== undefined ) {
	
					console.warn( 'THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.' );
	
				}
				console.warn( 'THREE.BufferGeometry: .addDrawCall() is now .addGroup().' );
				this.addGroup( start, count );
	
			},
			clearDrawCalls: function () {
	
				console.warn( 'THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().' );
				this.clearGroups();
	
			},
			computeTangents: function () {
	
				console.warn( 'THREE.BufferGeometry: .computeTangents() has been removed.' );
	
			},
			computeOffsets: function () {
	
				console.warn( 'THREE.BufferGeometry: .computeOffsets() has been removed.' );
	
			}
	
		} );
	
		Object.defineProperties( BufferGeometry.prototype, {
	
			drawcalls: {
				get: function () {
	
					console.error( 'THREE.BufferGeometry: .drawcalls has been renamed to .groups.' );
					return this.groups;
	
				}
			},
			offsets: {
				get: function () {
	
					console.warn( 'THREE.BufferGeometry: .offsets has been renamed to .groups.' );
					return this.groups;
	
				}
			}
	
		} );
	
		//
	
		Object.defineProperties( Uniform.prototype, {
	
			dynamic: {
				set: function () {
	
					console.warn( 'THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.' );
	
				}
			},
			onUpdate: {
				value: function () {
	
					console.warn( 'THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.' );
					return this;
	
				}
			}
	
		} );
	
		//
	
		Object.defineProperties( Material.prototype, {
	
			wrapAround: {
				get: function () {
	
					console.warn( 'THREE.Material: .wrapAround has been removed.' );
	
				},
				set: function () {
	
					console.warn( 'THREE.Material: .wrapAround has been removed.' );
	
				}
			},
			wrapRGB: {
				get: function () {
	
					console.warn( 'THREE.Material: .wrapRGB has been removed.' );
					return new Color();
	
				}
			},
	
			shading: {
				get: function () {
	
					console.error( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
					this.flatShading = ( value === FlatShading );
	
				}
			}
	
		} );
	
		Object.defineProperties( MeshPhongMaterial.prototype, {
	
			metal: {
				get: function () {
	
					console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead.' );
					return false;
	
				},
				set: function () {
	
					console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead' );
	
				}
			}
	
		} );
	
		Object.defineProperties( ShaderMaterial.prototype, {
	
			derivatives: {
				get: function () {
	
					console.warn( 'THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
					return this.extensions.derivatives;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
					this.extensions.derivatives = value;
	
				}
			}
	
		} );
	
		//
	
		Object.assign( WebGLRenderer.prototype, {
	
			getCurrentRenderTarget: function () {
	
				console.warn( 'THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().' );
				return this.getRenderTarget();
	
			},
	
			getMaxAnisotropy: function () {
	
				console.warn( 'THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().' );
				return this.capabilities.getMaxAnisotropy();
	
			},
	
			getPrecision: function () {
	
				console.warn( 'THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.' );
				return this.capabilities.precision;
	
			},
	
			supportsFloatTextures: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).' );
				return this.extensions.get( 'OES_texture_float' );
	
			},
			supportsHalfFloatTextures: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).' );
				return this.extensions.get( 'OES_texture_half_float' );
	
			},
			supportsStandardDerivatives: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).' );
				return this.extensions.get( 'OES_standard_derivatives' );
	
			},
			supportsCompressedTextureS3TC: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).' );
				return this.extensions.get( 'WEBGL_compressed_texture_s3tc' );
	
			},
			supportsCompressedTexturePVRTC: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).' );
				return this.extensions.get( 'WEBGL_compressed_texture_pvrtc' );
	
			},
			supportsBlendMinMax: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).' );
				return this.extensions.get( 'EXT_blend_minmax' );
	
			},
			supportsVertexTextures: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.' );
				return this.capabilities.vertexTextures;
	
			},
			supportsInstancedArrays: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).' );
				return this.extensions.get( 'ANGLE_instanced_arrays' );
	
			},
			enableScissorTest: function ( boolean ) {
	
				console.warn( 'THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().' );
				this.setScissorTest( boolean );
	
			},
			initMaterial: function () {
	
				console.warn( 'THREE.WebGLRenderer: .initMaterial() has been removed.' );
	
			},
			addPrePlugin: function () {
	
				console.warn( 'THREE.WebGLRenderer: .addPrePlugin() has been removed.' );
	
			},
			addPostPlugin: function () {
	
				console.warn( 'THREE.WebGLRenderer: .addPostPlugin() has been removed.' );
	
			},
			updateShadowMap: function () {
	
				console.warn( 'THREE.WebGLRenderer: .updateShadowMap() has been removed.' );
	
			}
	
		} );
	
		Object.defineProperties( WebGLRenderer.prototype, {
	
			shadowMapEnabled: {
				get: function () {
	
					return this.shadowMap.enabled;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.' );
					this.shadowMap.enabled = value;
	
				}
			},
			shadowMapType: {
				get: function () {
	
					return this.shadowMap.type;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.' );
					this.shadowMap.type = value;
	
				}
			},
			shadowMapCullFace: {
				get: function () {
	
					return this.shadowMap.cullFace;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderer: .shadowMapCullFace is now .shadowMap.cullFace.' );
					this.shadowMap.cullFace = value;
	
				}
			}
		} );
	
		Object.defineProperties( WebGLShadowMap.prototype, {
	
			cullFace: {
				get: function () {
	
					return this.renderReverseSided ? CullFaceFront : CullFaceBack;
	
				},
				set: function ( cullFace ) {
	
					var value = ( cullFace !== CullFaceBack );
					console.warn( "WebGLRenderer: .shadowMap.cullFace is deprecated. Set .shadowMap.renderReverseSided to " + value + "." );
					this.renderReverseSided = value;
	
				}
			}
	
		} );
	
		//
	
		Object.defineProperties( WebGLRenderTarget.prototype, {
	
			wrapS: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
					return this.texture.wrapS;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
					this.texture.wrapS = value;
	
				}
			},
			wrapT: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
					return this.texture.wrapT;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
					this.texture.wrapT = value;
	
				}
			},
			magFilter: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
					return this.texture.magFilter;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
					this.texture.magFilter = value;
	
				}
			},
			minFilter: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
					return this.texture.minFilter;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
					this.texture.minFilter = value;
	
				}
			},
			anisotropy: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
					return this.texture.anisotropy;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
					this.texture.anisotropy = value;
	
				}
			},
			offset: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
					return this.texture.offset;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
					this.texture.offset = value;
	
				}
			},
			repeat: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
					return this.texture.repeat;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
					this.texture.repeat = value;
	
				}
			},
			format: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
					return this.texture.format;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
					this.texture.format = value;
	
				}
			},
			type: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
					return this.texture.type;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
					this.texture.type = value;
	
				}
			},
			generateMipmaps: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
					return this.texture.generateMipmaps;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
					this.texture.generateMipmaps = value;
	
				}
			}
	
		} );
	
		//
	
		Audio.prototype.load = function ( file ) {
	
			console.warn( 'THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.' );
			var scope = this;
			var audioLoader = new AudioLoader();
			audioLoader.load( file, function ( buffer ) {
	
				scope.setBuffer( buffer );
	
			} );
			return this;
	
		};
	
		AudioAnalyser.prototype.getData = function () {
	
			console.warn( 'THREE.AudioAnalyser: .getData() is now .getFrequencyData().' );
			return this.getFrequencyData();
	
		};
	
		//
	
		CubeCamera.prototype.updateCubeMap = function ( renderer, scene ) {
	
			console.warn( 'THREE.CubeCamera: .updateCubeMap() is now .update().' );
			return this.update( renderer, scene );
	
		};
	
		//
	
		var GeometryUtils = {
	
			merge: function ( geometry1, geometry2, materialIndexOffset ) {
	
				console.warn( 'THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.' );
				var matrix;
	
				if ( geometry2.isMesh ) {
	
					geometry2.matrixAutoUpdate && geometry2.updateMatrix();
	
					matrix = geometry2.matrix;
					geometry2 = geometry2.geometry;
	
				}
	
				geometry1.merge( geometry2, matrix, materialIndexOffset );
	
			},
	
			center: function ( geometry ) {
	
				console.warn( 'THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.' );
				return geometry.center();
	
			}
	
		};
	
		var ImageUtils = {
	
			crossOrigin: undefined,
	
			loadTexture: function ( url, mapping, onLoad, onError ) {
	
				console.warn( 'THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.' );
	
				var loader = new TextureLoader();
				loader.setCrossOrigin( this.crossOrigin );
	
				var texture = loader.load( url, onLoad, undefined, onError );
	
				if ( mapping ) texture.mapping = mapping;
	
				return texture;
	
			},
	
			loadTextureCube: function ( urls, mapping, onLoad, onError ) {
	
				console.warn( 'THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.' );
	
				var loader = new CubeTextureLoader();
				loader.setCrossOrigin( this.crossOrigin );
	
				var texture = loader.load( urls, onLoad, undefined, onError );
	
				if ( mapping ) texture.mapping = mapping;
	
				return texture;
	
			},
	
			loadCompressedTexture: function () {
	
				console.error( 'THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.' );
	
			},
	
			loadCompressedTextureCube: function () {
	
				console.error( 'THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.' );
	
			}
	
		};
	
		//
	
		function Projector() {
	
			console.error( 'THREE.Projector has been moved to /examples/js/renderers/Projector.js.' );
	
			this.projectVector = function ( vector, camera ) {
	
				console.warn( 'THREE.Projector: .projectVector() is now vector.project().' );
				vector.project( camera );
	
			};
	
			this.unprojectVector = function ( vector, camera ) {
	
				console.warn( 'THREE.Projector: .unprojectVector() is now vector.unproject().' );
				vector.unproject( camera );
	
			};
	
			this.pickingRay = function () {
	
				console.error( 'THREE.Projector: .pickingRay() is now raycaster.setFromCamera().' );
	
			};
	
		}
	
		//
	
		function CanvasRenderer() {
	
			console.error( 'THREE.CanvasRenderer has been moved to /examples/js/renderers/CanvasRenderer.js' );
	
			this.domElement = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
			this.clear = function () {};
			this.render = function () {};
			this.setClearColor = function () {};
			this.setSize = function () {};
	
		}
	
		exports.WebGLRenderTargetCube = WebGLRenderTargetCube;
		exports.WebGLRenderTarget = WebGLRenderTarget;
		exports.WebGLRenderer = WebGLRenderer;
		exports.ShaderLib = ShaderLib;
		exports.UniformsLib = UniformsLib;
		exports.UniformsUtils = UniformsUtils;
		exports.ShaderChunk = ShaderChunk;
		exports.FogExp2 = FogExp2;
		exports.Fog = Fog;
		exports.Scene = Scene;
		exports.LensFlare = LensFlare;
		exports.Sprite = Sprite;
		exports.LOD = LOD;
		exports.SkinnedMesh = SkinnedMesh;
		exports.Skeleton = Skeleton;
		exports.Bone = Bone;
		exports.Mesh = Mesh;
		exports.LineSegments = LineSegments;
		exports.LineLoop = LineLoop;
		exports.Line = Line;
		exports.Points = Points;
		exports.Group = Group;
		exports.VideoTexture = VideoTexture;
		exports.DataTexture = DataTexture;
		exports.CompressedTexture = CompressedTexture;
		exports.CubeTexture = CubeTexture;
		exports.CanvasTexture = CanvasTexture;
		exports.DepthTexture = DepthTexture;
		exports.Texture = Texture;
		exports.CompressedTextureLoader = CompressedTextureLoader;
		exports.DataTextureLoader = DataTextureLoader;
		exports.CubeTextureLoader = CubeTextureLoader;
		exports.TextureLoader = TextureLoader;
		exports.ObjectLoader = ObjectLoader;
		exports.MaterialLoader = MaterialLoader;
		exports.BufferGeometryLoader = BufferGeometryLoader;
		exports.DefaultLoadingManager = DefaultLoadingManager;
		exports.LoadingManager = LoadingManager;
		exports.JSONLoader = JSONLoader;
		exports.ImageLoader = ImageLoader;
		exports.FontLoader = FontLoader;
		exports.FileLoader = FileLoader;
		exports.Loader = Loader;
		exports.Cache = Cache;
		exports.AudioLoader = AudioLoader;
		exports.SpotLightShadow = SpotLightShadow;
		exports.SpotLight = SpotLight;
		exports.PointLight = PointLight;
		exports.RectAreaLight = RectAreaLight;
		exports.HemisphereLight = HemisphereLight;
		exports.DirectionalLightShadow = DirectionalLightShadow;
		exports.DirectionalLight = DirectionalLight;
		exports.AmbientLight = AmbientLight;
		exports.LightShadow = LightShadow;
		exports.Light = Light;
		exports.StereoCamera = StereoCamera;
		exports.PerspectiveCamera = PerspectiveCamera;
		exports.OrthographicCamera = OrthographicCamera;
		exports.CubeCamera = CubeCamera;
		exports.ArrayCamera = ArrayCamera;
		exports.Camera = Camera;
		exports.AudioListener = AudioListener;
		exports.PositionalAudio = PositionalAudio;
		exports.AudioContext = AudioContext;
		exports.AudioAnalyser = AudioAnalyser;
		exports.Audio = Audio;
		exports.VectorKeyframeTrack = VectorKeyframeTrack;
		exports.StringKeyframeTrack = StringKeyframeTrack;
		exports.QuaternionKeyframeTrack = QuaternionKeyframeTrack;
		exports.NumberKeyframeTrack = NumberKeyframeTrack;
		exports.ColorKeyframeTrack = ColorKeyframeTrack;
		exports.BooleanKeyframeTrack = BooleanKeyframeTrack;
		exports.PropertyMixer = PropertyMixer;
		exports.PropertyBinding = PropertyBinding;
		exports.KeyframeTrack = KeyframeTrack;
		exports.AnimationUtils = AnimationUtils;
		exports.AnimationObjectGroup = AnimationObjectGroup;
		exports.AnimationMixer = AnimationMixer;
		exports.AnimationClip = AnimationClip;
		exports.Uniform = Uniform;
		exports.InstancedBufferGeometry = InstancedBufferGeometry;
		exports.BufferGeometry = BufferGeometry;
		exports.GeometryIdCount = GeometryIdCount;
		exports.Geometry = Geometry;
		exports.InterleavedBufferAttribute = InterleavedBufferAttribute;
		exports.InstancedInterleavedBuffer = InstancedInterleavedBuffer;
		exports.InterleavedBuffer = InterleavedBuffer;
		exports.InstancedBufferAttribute = InstancedBufferAttribute;
		exports.Face3 = Face3;
		exports.Object3D = Object3D;
		exports.Raycaster = Raycaster;
		exports.Layers = Layers;
		exports.EventDispatcher = EventDispatcher;
		exports.Clock = Clock;
		exports.QuaternionLinearInterpolant = QuaternionLinearInterpolant;
		exports.LinearInterpolant = LinearInterpolant;
		exports.DiscreteInterpolant = DiscreteInterpolant;
		exports.CubicInterpolant = CubicInterpolant;
		exports.Interpolant = Interpolant;
		exports.Triangle = Triangle;
		exports.Math = _Math;
		exports.Spherical = Spherical;
		exports.Cylindrical = Cylindrical;
		exports.Plane = Plane;
		exports.Frustum = Frustum;
		exports.Sphere = Sphere;
		exports.Ray = Ray;
		exports.Matrix4 = Matrix4;
		exports.Matrix3 = Matrix3;
		exports.Box3 = Box3;
		exports.Box2 = Box2;
		exports.Line3 = Line3;
		exports.Euler = Euler;
		exports.Vector4 = Vector4;
		exports.Vector3 = Vector3;
		exports.Vector2 = Vector2;
		exports.Quaternion = Quaternion;
		exports.Color = Color;
		exports.ImmediateRenderObject = ImmediateRenderObject;
		exports.VertexNormalsHelper = VertexNormalsHelper;
		exports.SpotLightHelper = SpotLightHelper;
		exports.SkeletonHelper = SkeletonHelper;
		exports.PointLightHelper = PointLightHelper;
		exports.RectAreaLightHelper = RectAreaLightHelper;
		exports.HemisphereLightHelper = HemisphereLightHelper;
		exports.GridHelper = GridHelper;
		exports.PolarGridHelper = PolarGridHelper;
		exports.FaceNormalsHelper = FaceNormalsHelper;
		exports.DirectionalLightHelper = DirectionalLightHelper;
		exports.CameraHelper = CameraHelper;
		exports.BoxHelper = BoxHelper;
		exports.Box3Helper = Box3Helper;
		exports.PlaneHelper = PlaneHelper;
		exports.ArrowHelper = ArrowHelper;
		exports.AxisHelper = AxisHelper;
		exports.CatmullRomCurve3 = CatmullRomCurve3;
		exports.CubicBezierCurve3 = CubicBezierCurve3;
		exports.QuadraticBezierCurve3 = QuadraticBezierCurve3;
		exports.LineCurve3 = LineCurve3;
		exports.ArcCurve = ArcCurve;
		exports.EllipseCurve = EllipseCurve;
		exports.SplineCurve = SplineCurve;
		exports.CubicBezierCurve = CubicBezierCurve;
		exports.QuadraticBezierCurve = QuadraticBezierCurve;
		exports.LineCurve = LineCurve;
		exports.Shape = Shape;
		exports.Path = Path;
		exports.ShapePath = ShapePath;
		exports.Font = Font;
		exports.CurvePath = CurvePath;
		exports.Curve = Curve;
		exports.ShapeUtils = ShapeUtils;
		exports.SceneUtils = SceneUtils;
		exports.WebGLUtils = WebGLUtils;
		exports.WireframeGeometry = WireframeGeometry;
		exports.ParametricGeometry = ParametricGeometry;
		exports.ParametricBufferGeometry = ParametricBufferGeometry;
		exports.TetrahedronGeometry = TetrahedronGeometry;
		exports.TetrahedronBufferGeometry = TetrahedronBufferGeometry;
		exports.OctahedronGeometry = OctahedronGeometry;
		exports.OctahedronBufferGeometry = OctahedronBufferGeometry;
		exports.IcosahedronGeometry = IcosahedronGeometry;
		exports.IcosahedronBufferGeometry = IcosahedronBufferGeometry;
		exports.DodecahedronGeometry = DodecahedronGeometry;
		exports.DodecahedronBufferGeometry = DodecahedronBufferGeometry;
		exports.PolyhedronGeometry = PolyhedronGeometry;
		exports.PolyhedronBufferGeometry = PolyhedronBufferGeometry;
		exports.TubeGeometry = TubeGeometry;
		exports.TubeBufferGeometry = TubeBufferGeometry;
		exports.TorusKnotGeometry = TorusKnotGeometry;
		exports.TorusKnotBufferGeometry = TorusKnotBufferGeometry;
		exports.TorusGeometry = TorusGeometry;
		exports.TorusBufferGeometry = TorusBufferGeometry;
		exports.TextGeometry = TextGeometry;
		exports.TextBufferGeometry = TextBufferGeometry;
		exports.SphereGeometry = SphereGeometry;
		exports.SphereBufferGeometry = SphereBufferGeometry;
		exports.RingGeometry = RingGeometry;
		exports.RingBufferGeometry = RingBufferGeometry;
		exports.PlaneGeometry = PlaneGeometry;
		exports.PlaneBufferGeometry = PlaneBufferGeometry;
		exports.LatheGeometry = LatheGeometry;
		exports.LatheBufferGeometry = LatheBufferGeometry;
		exports.ShapeGeometry = ShapeGeometry;
		exports.ShapeBufferGeometry = ShapeBufferGeometry;
		exports.ExtrudeGeometry = ExtrudeGeometry;
		exports.ExtrudeBufferGeometry = ExtrudeBufferGeometry;
		exports.EdgesGeometry = EdgesGeometry;
		exports.ConeGeometry = ConeGeometry;
		exports.ConeBufferGeometry = ConeBufferGeometry;
		exports.CylinderGeometry = CylinderGeometry;
		exports.CylinderBufferGeometry = CylinderBufferGeometry;
		exports.CircleGeometry = CircleGeometry;
		exports.CircleBufferGeometry = CircleBufferGeometry;
		exports.BoxGeometry = BoxGeometry;
		exports.BoxBufferGeometry = BoxBufferGeometry;
		exports.ShadowMaterial = ShadowMaterial;
		exports.SpriteMaterial = SpriteMaterial;
		exports.RawShaderMaterial = RawShaderMaterial;
		exports.ShaderMaterial = ShaderMaterial;
		exports.PointsMaterial = PointsMaterial;
		exports.MeshPhysicalMaterial = MeshPhysicalMaterial;
		exports.MeshStandardMaterial = MeshStandardMaterial;
		exports.MeshPhongMaterial = MeshPhongMaterial;
		exports.MeshToonMaterial = MeshToonMaterial;
		exports.MeshNormalMaterial = MeshNormalMaterial;
		exports.MeshLambertMaterial = MeshLambertMaterial;
		exports.MeshDepthMaterial = MeshDepthMaterial;
		exports.MeshDistanceMaterial = MeshDistanceMaterial;
		exports.MeshBasicMaterial = MeshBasicMaterial;
		exports.LineDashedMaterial = LineDashedMaterial;
		exports.LineBasicMaterial = LineBasicMaterial;
		exports.Material = Material;
		exports.Float64BufferAttribute = Float64BufferAttribute;
		exports.Float32BufferAttribute = Float32BufferAttribute;
		exports.Uint32BufferAttribute = Uint32BufferAttribute;
		exports.Int32BufferAttribute = Int32BufferAttribute;
		exports.Uint16BufferAttribute = Uint16BufferAttribute;
		exports.Int16BufferAttribute = Int16BufferAttribute;
		exports.Uint8ClampedBufferAttribute = Uint8ClampedBufferAttribute;
		exports.Uint8BufferAttribute = Uint8BufferAttribute;
		exports.Int8BufferAttribute = Int8BufferAttribute;
		exports.BufferAttribute = BufferAttribute;
		exports.REVISION = REVISION;
		exports.MOUSE = MOUSE;
		exports.CullFaceNone = CullFaceNone;
		exports.CullFaceBack = CullFaceBack;
		exports.CullFaceFront = CullFaceFront;
		exports.CullFaceFrontBack = CullFaceFrontBack;
		exports.FrontFaceDirectionCW = FrontFaceDirectionCW;
		exports.FrontFaceDirectionCCW = FrontFaceDirectionCCW;
		exports.BasicShadowMap = BasicShadowMap;
		exports.PCFShadowMap = PCFShadowMap;
		exports.PCFSoftShadowMap = PCFSoftShadowMap;
		exports.FrontSide = FrontSide;
		exports.BackSide = BackSide;
		exports.DoubleSide = DoubleSide;
		exports.FlatShading = FlatShading;
		exports.SmoothShading = SmoothShading;
		exports.NoColors = NoColors;
		exports.FaceColors = FaceColors;
		exports.VertexColors = VertexColors;
		exports.NoBlending = NoBlending;
		exports.NormalBlending = NormalBlending;
		exports.AdditiveBlending = AdditiveBlending;
		exports.SubtractiveBlending = SubtractiveBlending;
		exports.MultiplyBlending = MultiplyBlending;
		exports.CustomBlending = CustomBlending;
		exports.AddEquation = AddEquation;
		exports.SubtractEquation = SubtractEquation;
		exports.ReverseSubtractEquation = ReverseSubtractEquation;
		exports.MinEquation = MinEquation;
		exports.MaxEquation = MaxEquation;
		exports.ZeroFactor = ZeroFactor;
		exports.OneFactor = OneFactor;
		exports.SrcColorFactor = SrcColorFactor;
		exports.OneMinusSrcColorFactor = OneMinusSrcColorFactor;
		exports.SrcAlphaFactor = SrcAlphaFactor;
		exports.OneMinusSrcAlphaFactor = OneMinusSrcAlphaFactor;
		exports.DstAlphaFactor = DstAlphaFactor;
		exports.OneMinusDstAlphaFactor = OneMinusDstAlphaFactor;
		exports.DstColorFactor = DstColorFactor;
		exports.OneMinusDstColorFactor = OneMinusDstColorFactor;
		exports.SrcAlphaSaturateFactor = SrcAlphaSaturateFactor;
		exports.NeverDepth = NeverDepth;
		exports.AlwaysDepth = AlwaysDepth;
		exports.LessDepth = LessDepth;
		exports.LessEqualDepth = LessEqualDepth;
		exports.EqualDepth = EqualDepth;
		exports.GreaterEqualDepth = GreaterEqualDepth;
		exports.GreaterDepth = GreaterDepth;
		exports.NotEqualDepth = NotEqualDepth;
		exports.MultiplyOperation = MultiplyOperation;
		exports.MixOperation = MixOperation;
		exports.AddOperation = AddOperation;
		exports.NoToneMapping = NoToneMapping;
		exports.LinearToneMapping = LinearToneMapping;
		exports.ReinhardToneMapping = ReinhardToneMapping;
		exports.Uncharted2ToneMapping = Uncharted2ToneMapping;
		exports.CineonToneMapping = CineonToneMapping;
		exports.UVMapping = UVMapping;
		exports.CubeReflectionMapping = CubeReflectionMapping;
		exports.CubeRefractionMapping = CubeRefractionMapping;
		exports.EquirectangularReflectionMapping = EquirectangularReflectionMapping;
		exports.EquirectangularRefractionMapping = EquirectangularRefractionMapping;
		exports.SphericalReflectionMapping = SphericalReflectionMapping;
		exports.CubeUVReflectionMapping = CubeUVReflectionMapping;
		exports.CubeUVRefractionMapping = CubeUVRefractionMapping;
		exports.RepeatWrapping = RepeatWrapping;
		exports.ClampToEdgeWrapping = ClampToEdgeWrapping;
		exports.MirroredRepeatWrapping = MirroredRepeatWrapping;
		exports.NearestFilter = NearestFilter;
		exports.NearestMipMapNearestFilter = NearestMipMapNearestFilter;
		exports.NearestMipMapLinearFilter = NearestMipMapLinearFilter;
		exports.LinearFilter = LinearFilter;
		exports.LinearMipMapNearestFilter = LinearMipMapNearestFilter;
		exports.LinearMipMapLinearFilter = LinearMipMapLinearFilter;
		exports.UnsignedByteType = UnsignedByteType;
		exports.ByteType = ByteType;
		exports.ShortType = ShortType;
		exports.UnsignedShortType = UnsignedShortType;
		exports.IntType = IntType;
		exports.UnsignedIntType = UnsignedIntType;
		exports.FloatType = FloatType;
		exports.HalfFloatType = HalfFloatType;
		exports.UnsignedShort4444Type = UnsignedShort4444Type;
		exports.UnsignedShort5551Type = UnsignedShort5551Type;
		exports.UnsignedShort565Type = UnsignedShort565Type;
		exports.UnsignedInt248Type = UnsignedInt248Type;
		exports.AlphaFormat = AlphaFormat;
		exports.RGBFormat = RGBFormat;
		exports.RGBAFormat = RGBAFormat;
		exports.LuminanceFormat = LuminanceFormat;
		exports.LuminanceAlphaFormat = LuminanceAlphaFormat;
		exports.RGBEFormat = RGBEFormat;
		exports.DepthFormat = DepthFormat;
		exports.DepthStencilFormat = DepthStencilFormat;
		exports.RGB_S3TC_DXT1_Format = RGB_S3TC_DXT1_Format;
		exports.RGBA_S3TC_DXT1_Format = RGBA_S3TC_DXT1_Format;
		exports.RGBA_S3TC_DXT3_Format = RGBA_S3TC_DXT3_Format;
		exports.RGBA_S3TC_DXT5_Format = RGBA_S3TC_DXT5_Format;
		exports.RGB_PVRTC_4BPPV1_Format = RGB_PVRTC_4BPPV1_Format;
		exports.RGB_PVRTC_2BPPV1_Format = RGB_PVRTC_2BPPV1_Format;
		exports.RGBA_PVRTC_4BPPV1_Format = RGBA_PVRTC_4BPPV1_Format;
		exports.RGBA_PVRTC_2BPPV1_Format = RGBA_PVRTC_2BPPV1_Format;
		exports.RGB_ETC1_Format = RGB_ETC1_Format;
		exports.LoopOnce = LoopOnce;
		exports.LoopRepeat = LoopRepeat;
		exports.LoopPingPong = LoopPingPong;
		exports.InterpolateDiscrete = InterpolateDiscrete;
		exports.InterpolateLinear = InterpolateLinear;
		exports.InterpolateSmooth = InterpolateSmooth;
		exports.ZeroCurvatureEnding = ZeroCurvatureEnding;
		exports.ZeroSlopeEnding = ZeroSlopeEnding;
		exports.WrapAroundEnding = WrapAroundEnding;
		exports.TrianglesDrawMode = TrianglesDrawMode;
		exports.TriangleStripDrawMode = TriangleStripDrawMode;
		exports.TriangleFanDrawMode = TriangleFanDrawMode;
		exports.LinearEncoding = LinearEncoding;
		exports.sRGBEncoding = sRGBEncoding;
		exports.GammaEncoding = GammaEncoding;
		exports.RGBEEncoding = RGBEEncoding;
		exports.LogLuvEncoding = LogLuvEncoding;
		exports.RGBM7Encoding = RGBM7Encoding;
		exports.RGBM16Encoding = RGBM16Encoding;
		exports.RGBDEncoding = RGBDEncoding;
		exports.BasicDepthPacking = BasicDepthPacking;
		exports.RGBADepthPacking = RGBADepthPacking;
		exports.CubeGeometry = BoxGeometry;
		exports.Face4 = Face4;
		exports.LineStrip = LineStrip;
		exports.LinePieces = LinePieces;
		exports.MeshFaceMaterial = MeshFaceMaterial;
		exports.MultiMaterial = MultiMaterial;
		exports.PointCloud = PointCloud;
		exports.Particle = Particle;
		exports.ParticleSystem = ParticleSystem;
		exports.PointCloudMaterial = PointCloudMaterial;
		exports.ParticleBasicMaterial = ParticleBasicMaterial;
		exports.ParticleSystemMaterial = ParticleSystemMaterial;
		exports.Vertex = Vertex;
		exports.DynamicBufferAttribute = DynamicBufferAttribute;
		exports.Int8Attribute = Int8Attribute;
		exports.Uint8Attribute = Uint8Attribute;
		exports.Uint8ClampedAttribute = Uint8ClampedAttribute;
		exports.Int16Attribute = Int16Attribute;
		exports.Uint16Attribute = Uint16Attribute;
		exports.Int32Attribute = Int32Attribute;
		exports.Uint32Attribute = Uint32Attribute;
		exports.Float32Attribute = Float32Attribute;
		exports.Float64Attribute = Float64Attribute;
		exports.ClosedSplineCurve3 = ClosedSplineCurve3;
		exports.SplineCurve3 = SplineCurve3;
		exports.Spline = Spline;
		exports.BoundingBoxHelper = BoundingBoxHelper;
		exports.EdgesHelper = EdgesHelper;
		exports.WireframeHelper = WireframeHelper;
		exports.XHRLoader = XHRLoader;
		exports.BinaryTextureLoader = BinaryTextureLoader;
		exports.GeometryUtils = GeometryUtils;
		exports.ImageUtils = ImageUtils;
		exports.Projector = Projector;
		exports.CanvasRenderer = CanvasRenderer;
	
		Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/unsecured-shield.34dcae4b.png";

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperties = __webpack_require__(765);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _create = __webpack_require__(527);
	
	var _create2 = _interopRequireDefault(_create);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Customized for DataTheorem TrustKit Analytics Dashboard
	
	module.exports = function (THREE) {
	
		var MOUSE = THREE.MOUSE;
		if (!MOUSE) MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2 };
		/**
	  * @author qiao / https://github.com/qiao
	  * @author mrdoob / http://mrdoob.com
	  * @author alteredq / http://alteredqualia.com/
	  * @author WestLangley / http://github.com/WestLangley
	  * @author erich666 / http://erichaines.com
	  */
		/*global THREE, console */
	
		function OrbitConstraint(object) {
	
			this.object = object;
	
			// "target" sets the location of focus, where the object orbits around
			// and where it pans with respect to.
			this.target = new THREE.Vector3();
	
			// Limits to how far you can dolly in and out ( PerspectiveCamera only )
			this.minDistance = 0;
			this.maxDistance = Infinity;
	
			// Limits to how far you can zoom in and out ( OrthographicCamera only )
			this.minZoom = 0;
			this.maxZoom = Infinity;
	
			// How far you can orbit vertically, upper and lower limits.
			// Range is 0 to Math.PI radians.
			this.minPolarAngle = 0; // radians
			this.maxPolarAngle = Math.PI; // radians
	
			// How far you can orbit horizontally, upper and lower limits.
			// If set, must be a sub-interval of the interval [ - Math.PI, Math.PI ].
			this.minAzimuthAngle = -Infinity; // radians
			this.maxAzimuthAngle = Infinity; // radians
	
			// Set to true to enable damping (inertia)
			// If damping is enabled, you must call controls.update() in your animation loop
			this.enableDamping = false;
			this.dampingFactor = 0.25;
	
			////////////
			// internals
	
			var scope = this;
	
			var EPS = 0.000001;
	
			// Current position in spherical coordinate system.
			var theta = 0;
			var phi = 0;
	
			// Pending changes
			var phiDelta = 0;
			var thetaDelta = 0;
			var scale = 1;
			var panOffset = new THREE.Vector3();
			var zoomChanged = false;
	
			// API
	
			this.getPolarAngle = function () {
	
				return phi;
			};
	
			this.getAzimuthalAngle = function () {
	
				return theta;
			};
	
			this.setPolarAngle = function (angle) {
	
				phi = angle;
				this.forceUpdate();
			};
	
			this.setAzimuthalAngle = function (angle) {
				theta = angle;
				this.forceUpdate();
			};
	
			this.rotateLeft = function (angle) {
	
				thetaDelta -= angle;
			};
	
			this.rotateUp = function (angle) {
	
				phiDelta -= angle;
			};
	
			// pass in distance in world space to move left
			this.panLeft = function () {
	
				var v = new THREE.Vector3();
	
				return function panLeft(distance) {
	
					var te = this.object.matrix.elements;
	
					// get X column of matrix
					v.set(te[0], te[1], te[2]);
					v.multiplyScalar(-distance);
	
					panOffset.add(v);
				};
			}();
	
			// pass in distance in world space to move up
			this.panUp = function () {
	
				var v = new THREE.Vector3();
	
				return function panUp(distance) {
	
					var te = this.object.matrix.elements;
	
					// get Y column of matrix
					v.set(te[4], te[5], te[6]);
					v.multiplyScalar(distance);
	
					panOffset.add(v);
				};
			}();
	
			// pass in x,y of change desired in pixel space,
			// right and down are positive
			this.pan = function (deltaX, deltaY, screenWidth, screenHeight) {
	
				if (scope.object instanceof THREE.PerspectiveCamera) {
	
					// perspective
					var position = scope.object.position;
					var offset = position.clone().sub(scope.target);
					var targetDistance = offset.length();
	
					// half of the fov is center to top of screen
					targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0);
	
					// we actually don't use screenWidth, since perspective camera is fixed to screen height
					scope.panLeft(2 * deltaX * targetDistance / screenHeight);
					scope.panUp(2 * deltaY * targetDistance / screenHeight);
				} else if (scope.object instanceof THREE.OrthographicCamera) {
	
					// orthographic
					scope.panLeft(deltaX * (scope.object.right - scope.object.left) / screenWidth);
					scope.panUp(deltaY * (scope.object.top - scope.object.bottom) / screenHeight);
				} else {
	
					// camera neither orthographic or perspective
					console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
				}
			};
	
			this.dollyIn = function (dollyScale) {
	
				if (scope.object instanceof THREE.PerspectiveCamera) {
	
					scale /= dollyScale;
				} else if (scope.object instanceof THREE.OrthographicCamera) {
	
					scope.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom * dollyScale));
					scope.object.updateProjectionMatrix();
					zoomChanged = true;
				} else {
	
					console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
				}
			};
	
			this.dollyOut = function (dollyScale) {
	
				if (scope.object instanceof THREE.PerspectiveCamera) {
	
					scale *= dollyScale;
				} else if (scope.object instanceof THREE.OrthographicCamera) {
	
					scope.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / dollyScale));
					scope.object.updateProjectionMatrix();
					zoomChanged = true;
				} else {
	
					console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
				}
			};
	
			this.forceUpdate = function () {
	
				var offset = new THREE.Vector3();
	
				// so camera.up is the orbit axis
				var quat = new THREE.Quaternion().setFromUnitVectors(object.up, new THREE.Vector3(0, 1, 0));
				var quatInverse = quat.clone().inverse();
	
				var lastPosition = new THREE.Vector3();
				var lastQuaternion = new THREE.Quaternion();
	
				return function () {
	
					var position = this.object.position;
	
					offset.copy(position).sub(this.target);
	
					// rotate offset to "y-axis-is-up" space
					offset.applyQuaternion(quat);
	
					// restrict theta to be between desired limits
					theta = Math.max(this.minAzimuthAngle, Math.min(this.maxAzimuthAngle, theta));
	
					// restrict phi to be between desired limits
					phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, phi));
	
					// restrict phi to be betwee EPS and PI-EPS
					phi = Math.max(EPS, Math.min(Math.PI - EPS, phi));
	
					var radius = offset.length() * scale;
	
					// restrict radius to be between desired limits
					radius = Math.max(this.minDistance, Math.min(this.maxDistance, radius));
	
					// move target to panned location
					this.target.add(panOffset);
	
					offset.x = radius * Math.sin(phi) * Math.sin(theta);
					offset.y = radius * Math.cos(phi);
					offset.z = radius * Math.sin(phi) * Math.cos(theta);
	
					// rotate offset back to "camera-up-vector-is-up" space
					offset.applyQuaternion(quatInverse);
	
					position.copy(this.target).add(offset);
	
					this.object.lookAt(this.target);
	
					if (this.enableDamping === true) {
	
						thetaDelta *= 1 - this.dampingFactor;
						phiDelta *= 1 - this.dampingFactor;
					} else {
	
						thetaDelta = 0;
						phiDelta = 0;
					}
	
					scale = 1;
					panOffset.set(0, 0, 0);
	
					// update condition is:
					// min(camera displacement, camera rotation in radians)^2 > EPS
					// using small-angle approximation cos(x/2) = 1 - x^2 / 8
	
					if (zoomChanged || lastPosition.distanceToSquared(this.object.position) > EPS || 8 * (1 - lastQuaternion.dot(this.object.quaternion)) > EPS) {
	
						lastPosition.copy(this.object.position);
						lastQuaternion.copy(this.object.quaternion);
						zoomChanged = false;
	
						return true;
					}
	
					return false;
				};
			}();
	
			this.update = function () {
	
				var offset = new THREE.Vector3();
	
				// so camera.up is the orbit axis
				var quat = new THREE.Quaternion().setFromUnitVectors(object.up, new THREE.Vector3(0, 1, 0));
				var quatInverse = quat.clone().inverse();
	
				var lastPosition = new THREE.Vector3();
				var lastQuaternion = new THREE.Quaternion();
	
				return function () {
	
					var position = this.object.position;
	
					offset.copy(position).sub(this.target);
	
					// rotate offset to "y-axis-is-up" space
					offset.applyQuaternion(quat);
	
					// angle from z-axis around y-axis
	
					theta = Math.atan2(offset.x, offset.z);
	
					// angle from y-axis
	
					phi = Math.atan2(Math.sqrt(offset.x * offset.x + offset.z * offset.z), offset.y);
	
					theta += thetaDelta;
					phi += phiDelta;
	
					// restrict theta to be between desired limits
					theta = Math.max(this.minAzimuthAngle, Math.min(this.maxAzimuthAngle, theta));
	
					// restrict phi to be between desired limits
					phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, phi));
	
					// restrict phi to be betwee EPS and PI-EPS
					phi = Math.max(EPS, Math.min(Math.PI - EPS, phi));
	
					var radius = offset.length() * scale;
	
					// restrict radius to be between desired limits
					radius = Math.max(this.minDistance, Math.min(this.maxDistance, radius));
	
					// move target to panned location
					this.target.add(panOffset);
	
					offset.x = radius * Math.sin(phi) * Math.sin(theta);
					offset.y = radius * Math.cos(phi);
					offset.z = radius * Math.sin(phi) * Math.cos(theta);
	
					// rotate offset back to "camera-up-vector-is-up" space
					offset.applyQuaternion(quatInverse);
	
					position.copy(this.target).add(offset);
	
					this.object.lookAt(this.target);
	
					if (this.enableDamping === true) {
	
						thetaDelta *= 1 - this.dampingFactor;
						phiDelta *= 1 - this.dampingFactor;
					} else {
	
						thetaDelta = 0;
						phiDelta = 0;
					}
	
					scale = 1;
					panOffset.set(0, 0, 0);
	
					// update condition is:
					// min(camera displacement, camera rotation in radians)^2 > EPS
					// using small-angle approximation cos(x/2) = 1 - x^2 / 8
	
					if (zoomChanged || lastPosition.distanceToSquared(this.object.position) > EPS || 8 * (1 - lastQuaternion.dot(this.object.quaternion)) > EPS) {
	
						lastPosition.copy(this.object.position);
						lastQuaternion.copy(this.object.quaternion);
						zoomChanged = false;
	
						return true;
					}
	
					return false;
				};
			}();
		};
	
		// This set of controls performs orbiting, dollying (zooming), and panning. It maintains
		// the "up" direction as +Y, unlike the TrackballControls. Touch on tablet and phones is
		// supported.
		//
		//    Orbit - left mouse / touch: one finger move
		//    Zoom - middle mouse, or mousewheel / touch: two finger spread or squish
		//    Pan - right mouse, or arrow keys / touch: three finter swipe
	
		function OrbitControls(object, domElement) {
	
			var constraint = new OrbitConstraint(object);
	
			this.domElement = domElement !== undefined ? domElement : document;
	
			// API
	
			Object.defineProperty(this, 'constraint', {
	
				get: function get() {
	
					return constraint;
				}
	
			});
	
			this.getPolarAngle = function () {
	
				return constraint.getPolarAngle();
			};
	
			this.getAzimuthalAngle = function () {
	
				return constraint.getAzimuthalAngle();
			};
	
			this.setPolarAngle = function (angle) {
	
				return constraint.setPolarAngle(angle);
			};
	
			this.setAzimuthalAngle = function (angle) {
	
				return constraint.setAzimuthalAngle(angle);
			};
	
			// Set to false to disable this control
			this.enabled = true;
	
			// center is old, deprecated; use "target" instead
			this.center = this.target;
	
			// This option actually enables dollying in and out; left as "zoom" for
			// backwards compatibility.
			// Set to false to disable zooming
			this.enableZoom = true;
			this.zoomSpeed = 1.0;
	
			// Set to false to disable rotating
			this.enableRotate = true;
			this.rotateSpeed = 1.0;
	
			// Set to false to disable panning
			this.enablePan = true;
			this.keyPanSpeed = 7.0; // pixels moved per arrow key push
	
			// Set to true to automatically rotate around the target
			// If auto-rotate is enabled, you must call controls.update() in your animation loop
			this.autoRotate = false;
			this.autoRotateSpeed = 2.0; // 30 seconds per round when fps is 60
	
			// Set to false to disable use of the keys
			this.enableKeys = true;
	
			// The four arrow keys
			this.keys = { LEFT: 37, UP: 38, RIGHT: 39, BOTTOM: 40 };
	
			// Mouse buttons
			this.mouseButtons = { ORBIT: THREE.MOUSE.LEFT, ZOOM: THREE.MOUSE.MIDDLE, PAN: THREE.MOUSE.RIGHT };
	
			////////////
			// internals
	
			var scope = this;
	
			var rotateStart = new THREE.Vector2();
			var rotateEnd = new THREE.Vector2();
			var rotateDelta = new THREE.Vector2();
	
			var panStart = new THREE.Vector2();
			var panEnd = new THREE.Vector2();
			var panDelta = new THREE.Vector2();
	
			var dollyStart = new THREE.Vector2();
			var dollyEnd = new THREE.Vector2();
			var dollyDelta = new THREE.Vector2();
	
			var STATE = { NONE: -1, ROTATE: 0, DOLLY: 1, PAN: 2, TOUCH_ROTATE: 3, TOUCH_DOLLY: 4, TOUCH_PAN: 5 };
	
			var state = STATE.NONE;
	
			// for reset
	
			this.target0 = this.target.clone();
			this.position0 = this.object.position.clone();
			this.zoom0 = this.object.zoom;
	
			// events
	
			var changeEvent = { type: 'change' };
			var startEvent = { type: 'start' };
			var endEvent = { type: 'end' };
	
			// pass in x,y of change desired in pixel space,
			// right and down are positive
			function pan(deltaX, deltaY) {
	
				var element = scope.domElement === document ? scope.domElement.body : scope.domElement;
	
				constraint.pan(deltaX, deltaY, element.clientWidth, element.clientHeight);
			}
	
			this.update = function () {
	
				if (this.autoRotate && state === STATE.NONE) {
	
					constraint.rotateLeft(getAutoRotationAngle());
				}
	
				if (constraint.update() === true) {
	
					this.dispatchEvent(changeEvent);
				}
			};
	
			this.reset = function () {
	
				state = STATE.NONE;
	
				this.target.copy(this.target0);
				this.object.position.copy(this.position0);
				this.object.zoom = this.zoom0;
	
				this.object.updateProjectionMatrix();
				this.dispatchEvent(changeEvent);
	
				this.update();
			};
	
			function getAutoRotationAngle() {
	
				return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
			}
	
			function getZoomScale() {
	
				return Math.pow(0.95, scope.zoomSpeed);
			}
	
			function onMouseDown(event) {
	
				if (scope.enabled === false) return;
	
				event.preventDefault();
	
				if (event.button === scope.mouseButtons.ORBIT) {
	
					if (scope.enableRotate === false) return;
	
					state = STATE.ROTATE;
	
					rotateStart.set(event.clientX, event.clientY);
				} else if (event.button === scope.mouseButtons.ZOOM) {
	
					if (scope.enableZoom === false) return;
	
					state = STATE.DOLLY;
	
					dollyStart.set(event.clientX, event.clientY);
				} else if (event.button === scope.mouseButtons.PAN) {
	
					if (scope.enablePan === false) return;
	
					state = STATE.PAN;
	
					panStart.set(event.clientX, event.clientY);
				}
	
				if (state !== STATE.NONE) {
	
					document.addEventListener('mousemove', onMouseMove, false);
					document.addEventListener('mouseup', onMouseUp, false);
					scope.dispatchEvent(startEvent);
				}
			}
	
			function onMouseMove(event) {
	
				if (scope.enabled === false) return;
	
				event.preventDefault();
	
				var element = scope.domElement === document ? scope.domElement.body : scope.domElement;
	
				if (state === STATE.ROTATE) {
	
					if (scope.enableRotate === false) return;
	
					rotateEnd.set(event.clientX, event.clientY);
					rotateDelta.subVectors(rotateEnd, rotateStart);
	
					// rotating across whole screen goes 360 degrees around
					constraint.rotateLeft(2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed);
	
					// rotating up and down along whole screen attempts to go 360, but limited to 180
					constraint.rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed);
	
					rotateStart.copy(rotateEnd);
				} else if (state === STATE.DOLLY) {
	
					if (scope.enableZoom === false) return;
	
					dollyEnd.set(event.clientX, event.clientY);
					dollyDelta.subVectors(dollyEnd, dollyStart);
	
					if (dollyDelta.y > 0) {
	
						constraint.dollyIn(getZoomScale());
					} else if (dollyDelta.y < 0) {
	
						constraint.dollyOut(getZoomScale());
					}
	
					dollyStart.copy(dollyEnd);
				} else if (state === STATE.PAN) {
	
					if (scope.enablePan === false) return;
	
					panEnd.set(event.clientX, event.clientY);
					panDelta.subVectors(panEnd, panStart);
	
					pan(panDelta.x, panDelta.y);
	
					panStart.copy(panEnd);
				}
	
				if (state !== STATE.NONE) scope.update();
			}
	
			function onMouseUp() /* event */{
	
				if (scope.enabled === false) return;
	
				document.removeEventListener('mousemove', onMouseMove, false);
				document.removeEventListener('mouseup', onMouseUp, false);
				scope.dispatchEvent(endEvent);
				state = STATE.NONE;
			}
	
			function onMouseWheel(event) {
	
				if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE) return;
	
				event.preventDefault();
				event.stopPropagation();
	
				var delta = 0;
	
				if (event.wheelDelta !== undefined) {
	
					// WebKit / Opera / Explorer 9
	
					delta = event.wheelDelta;
				} else if (event.detail !== undefined) {
	
					// Firefox
	
					delta = -event.detail;
				}
	
				if (delta > 0) {
	
					constraint.dollyOut(getZoomScale());
				} else if (delta < 0) {
	
					constraint.dollyIn(getZoomScale());
				}
	
				scope.update();
				scope.dispatchEvent(startEvent);
				scope.dispatchEvent(endEvent);
			}
	
			function onKeyDown(event) {
	
				if (scope.enabled === false || scope.enableKeys === false || scope.enablePan === false) return;
	
				switch (event.keyCode) {
	
					case scope.keys.UP:
						pan(0, scope.keyPanSpeed);
						scope.update();
						break;
	
					case scope.keys.BOTTOM:
						pan(0, -scope.keyPanSpeed);
						scope.update();
						break;
	
					case scope.keys.LEFT:
						pan(scope.keyPanSpeed, 0);
						scope.update();
						break;
	
					case scope.keys.RIGHT:
						pan(-scope.keyPanSpeed, 0);
						scope.update();
						break;
	
				}
			}
	
			function touchstart(event) {
	
				if (scope.enabled === false) return;
	
				switch (event.touches.length) {
	
					case 1:
						// one-fingered touch: rotate
	
						if (scope.enableRotate === false) return;
	
						state = STATE.TOUCH_ROTATE;
	
						rotateStart.set(event.touches[0].pageX, event.touches[0].pageY);
						break;
	
					case 2:
						// two-fingered touch: dolly
	
						if (scope.enableZoom === false) return;
	
						state = STATE.TOUCH_DOLLY;
	
						var dx = event.touches[0].pageX - event.touches[1].pageX;
						var dy = event.touches[0].pageY - event.touches[1].pageY;
						var distance = Math.sqrt(dx * dx + dy * dy);
						dollyStart.set(0, distance);
						break;
	
					case 3:
						// three-fingered touch: pan
	
						if (scope.enablePan === false) return;
	
						state = STATE.TOUCH_PAN;
	
						panStart.set(event.touches[0].pageX, event.touches[0].pageY);
						break;
	
					default:
	
						state = STATE.NONE;
	
				}
	
				if (state !== STATE.NONE) scope.dispatchEvent(startEvent);
			}
	
			function touchmove(event) {
	
				if (scope.enabled === false) return;
	
				event.preventDefault();
				event.stopPropagation();
	
				var element = scope.domElement === document ? scope.domElement.body : scope.domElement;
	
				switch (event.touches.length) {
	
					case 1:
						// one-fingered touch: rotate
	
						if (scope.enableRotate === false) return;
						if (state !== STATE.TOUCH_ROTATE) return;
	
						rotateEnd.set(event.touches[0].pageX, event.touches[0].pageY);
						rotateDelta.subVectors(rotateEnd, rotateStart);
	
						// rotating across whole screen goes 360 degrees around
						constraint.rotateLeft(2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed);
						// rotating up and down along whole screen attempts to go 360, but limited to 180
						constraint.rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed);
	
						rotateStart.copy(rotateEnd);
	
						scope.update();
						break;
	
					case 2:
						// two-fingered touch: dolly
	
						if (scope.enableZoom === false) return;
						if (state !== STATE.TOUCH_DOLLY) return;
	
						var dx = event.touches[0].pageX - event.touches[1].pageX;
						var dy = event.touches[0].pageY - event.touches[1].pageY;
						var distance = Math.sqrt(dx * dx + dy * dy);
	
						dollyEnd.set(0, distance);
						dollyDelta.subVectors(dollyEnd, dollyStart);
	
						if (dollyDelta.y > 0) {
	
							constraint.dollyOut(getZoomScale());
						} else if (dollyDelta.y < 0) {
	
							constraint.dollyIn(getZoomScale());
						}
	
						dollyStart.copy(dollyEnd);
	
						scope.update();
						break;
	
					case 3:
						// three-fingered touch: pan
	
						if (scope.enablePan === false) return;
						if (state !== STATE.TOUCH_PAN) return;
	
						panEnd.set(event.touches[0].pageX, event.touches[0].pageY);
						panDelta.subVectors(panEnd, panStart);
	
						pan(panDelta.x, panDelta.y);
	
						panStart.copy(panEnd);
	
						scope.update();
						break;
	
					default:
	
						state = STATE.NONE;
	
				}
			}
	
			function touchend() /* event */{
	
				if (scope.enabled === false) return;
	
				scope.dispatchEvent(endEvent);
				state = STATE.NONE;
			}
	
			function contextmenu(event) {
	
				event.preventDefault();
			}
	
			this.dispose = function () {
	
				this.domElement.removeEventListener('contextmenu', contextmenu, false);
				this.domElement.removeEventListener('mousedown', onMouseDown, false);
				this.domElement.removeEventListener('mousewheel', onMouseWheel, false);
				this.domElement.removeEventListener('MozMousePixelScroll', onMouseWheel, false); // firefox
	
				this.domElement.removeEventListener('touchstart', touchstart, false);
				this.domElement.removeEventListener('touchend', touchend, false);
				this.domElement.removeEventListener('touchmove', touchmove, false);
	
				document.removeEventListener('mousemove', onMouseMove, false);
				document.removeEventListener('mouseup', onMouseUp, false);
	
				window.removeEventListener('keydown', onKeyDown, false);
			};
	
			this.domElement.addEventListener('contextmenu', contextmenu, false);
	
			this.domElement.addEventListener('mousedown', onMouseDown, false);
			this.domElement.addEventListener('mousewheel', onMouseWheel, false);
			this.domElement.addEventListener('MozMousePixelScroll', onMouseWheel, false); // firefox
	
			this.domElement.addEventListener('touchstart', touchstart, false);
			this.domElement.addEventListener('touchend', touchend, false);
			this.domElement.addEventListener('touchmove', touchmove, false);
	
			window.addEventListener('keydown', onKeyDown, false);
	
			// force an update at start
			this.update();
		};
	
		OrbitControls.prototype = (0, _create2.default)(THREE.EventDispatcher.prototype);
		OrbitControls.prototype.constructor = OrbitControls;
	
		(0, _defineProperties2.default)(OrbitControls.prototype, {
	
			object: {
	
				get: function get() {
	
					return this.constraint.object;
				}
	
			},
	
			target: {
	
				get: function get() {
	
					return this.constraint.target;
				},
	
				set: function set(value) {
	
					console.warn('THREE.OrbitControls: target is now immutable. Use target.set() instead.');
					this.constraint.target.copy(value);
				}
	
			},
	
			minDistance: {
	
				get: function get() {
	
					return this.constraint.minDistance;
				},
	
				set: function set(value) {
	
					this.constraint.minDistance = value;
				}
	
			},
	
			maxDistance: {
	
				get: function get() {
	
					return this.constraint.maxDistance;
				},
	
				set: function set(value) {
	
					this.constraint.maxDistance = value;
				}
	
			},
	
			minZoom: {
	
				get: function get() {
	
					return this.constraint.minZoom;
				},
	
				set: function set(value) {
	
					this.constraint.minZoom = value;
				}
	
			},
	
			maxZoom: {
	
				get: function get() {
	
					return this.constraint.maxZoom;
				},
	
				set: function set(value) {
	
					this.constraint.maxZoom = value;
				}
	
			},
	
			minPolarAngle: {
	
				get: function get() {
	
					return this.constraint.minPolarAngle;
				},
	
				set: function set(value) {
	
					this.constraint.minPolarAngle = value;
				}
	
			},
	
			maxPolarAngle: {
	
				get: function get() {
	
					return this.constraint.maxPolarAngle;
				},
	
				set: function set(value) {
	
					this.constraint.maxPolarAngle = value;
				}
	
			},
	
			minAzimuthAngle: {
	
				get: function get() {
	
					return this.constraint.minAzimuthAngle;
				},
	
				set: function set(value) {
	
					this.constraint.minAzimuthAngle = value;
				}
	
			},
	
			maxAzimuthAngle: {
	
				get: function get() {
	
					return this.constraint.maxAzimuthAngle;
				},
	
				set: function set(value) {
	
					this.constraint.maxAzimuthAngle = value;
				}
	
			},
	
			enableDamping: {
	
				get: function get() {
	
					return this.constraint.enableDamping;
				},
	
				set: function set(value) {
	
					this.constraint.enableDamping = value;
				}
	
			},
	
			dampingFactor: {
	
				get: function get() {
	
					return this.constraint.dampingFactor;
				},
	
				set: function set(value) {
	
					this.constraint.dampingFactor = value;
				}
	
			},
	
			// backward compatibility
	
			noZoom: {
	
				get: function get() {
	
					console.warn('THREE.OrbitControls: .noZoom has been deprecated. Use .enableZoom instead.');
					return !this.enableZoom;
				},
	
				set: function set(value) {
	
					console.warn('THREE.OrbitControls: .noZoom has been deprecated. Use .enableZoom instead.');
					this.enableZoom = !value;
				}
	
			},
	
			noRotate: {
	
				get: function get() {
	
					console.warn('THREE.OrbitControls: .noRotate has been deprecated. Use .enableRotate instead.');
					return !this.enableRotate;
				},
	
				set: function set(value) {
	
					console.warn('THREE.OrbitControls: .noRotate has been deprecated. Use .enableRotate instead.');
					this.enableRotate = !value;
				}
	
			},
	
			noPan: {
	
				get: function get() {
	
					console.warn('THREE.OrbitControls: .noPan has been deprecated. Use .enablePan instead.');
					return !this.enablePan;
				},
	
				set: function set(value) {
	
					console.warn('THREE.OrbitControls: .noPan has been deprecated. Use .enablePan instead.');
					this.enablePan = !value;
				}
	
			},
	
			noKeys: {
	
				get: function get() {
	
					console.warn('THREE.OrbitControls: .noKeys has been deprecated. Use .enableKeys instead.');
					return !this.enableKeys;
				},
	
				set: function set(value) {
	
					console.warn('THREE.OrbitControls: .noKeys has been deprecated. Use .enableKeys instead.');
					this.enableKeys = !value;
				}
	
			},
	
			staticMoving: {
	
				get: function get() {
	
					console.warn('THREE.OrbitControls: .staticMoving has been deprecated. Use .enableDamping instead.');
					return !this.constraint.enableDamping;
				},
	
				set: function set(value) {
	
					console.warn('THREE.OrbitControls: .staticMoving has been deprecated. Use .enableDamping instead.');
					this.constraint.enableDamping = !value;
				}
	
			},
	
			dynamicDampingFactor: {
	
				get: function get() {
	
					console.warn('THREE.OrbitControls: .dynamicDampingFactor has been renamed. Use .dampingFactor instead.');
					return this.constraint.dampingFactor;
				},
	
				set: function set(value) {
	
					console.warn('THREE.OrbitControls: .dynamicDampingFactor has been renamed. Use .dampingFactor instead.');
					this.constraint.dampingFactor = value;
				}
	
			}
	
		});
	
		return OrbitControls;
	};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _analytics = __webpack_require__(57);
	
	var _alarmColor = __webpack_require__(752);
	
	var _alarmColor2 = _interopRequireDefault(_alarmColor);
	
	__webpack_require__(458);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertSignupCard = function (_PureComponent) {
	  (0, _inherits3.default)(AlertSignupCard, _PureComponent);
	
	  function AlertSignupCard() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AlertSignupCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { visible: false, toasts: [] }, _this.addToast = function (text, action) {
	      var autohide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      _this.setState(function (state) {
	        var toasts = state.toasts.slice();
	        toasts.push({ text: text, action: action });
	        return { toasts: toasts, autohide: autohide };
	      });
	    }, _this.toastConfirmation = function () {
	      _this.addToast('Thank you for signing up. We will be in touch shortly.');
	      _this.setState({ visible: false });
	      window.open('//bit.ly/2EdPSf2', '_blank', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,width=700,height=480', '');
	      (0, _analytics.trackEvent)({
	        category: 'Alert Signup',
	        action: 'Signup',
	        label: 'Primary'
	      });
	    }, _this.dismissToast = function () {
	      var _this$state$toasts = _this.state.toasts,
	          toasts = _this$state$toasts.slice(1);
	
	      _this.setState({ toasts: toasts });
	    }, _this.show = function () {
	      _this.setState({ visible: true });
	      (0, _analytics.trackEvent)({
	        category: 'Alert Signup',
	        action: 'Clicked',
	        label: 'Primary'
	      });
	    }, _this.hide = function () {
	      _this.setState({ visible: false });
	      window.open('//bit.ly/2uFJDRF', '_blank', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,width=700,height=480', '');
	      (0, _analytics.trackEvent)({
	        category: 'Alert Signup',
	        action: 'No Thanks',
	        label: 'Primary'
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  AlertSignupCard.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        visible = _state.visible,
	        toasts = _state.toasts;
	
	
	    var actions = [{
	      onClick: this.toastConfirmation,
	      primary: true,
	      children: 'Sign up'
	    }, {
	      onClick: this.hide,
	      primary: true,
	      children: 'No thanks'
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'signup-container md-grid mobile-fix' },
	        _react2.default.createElement(
	          _reactMd.Card,
	          {
	            className: 'md-block-centered signup-card',
	            onClick: function onClick() {
	              _this2.show();
	            }
	          },
	          _react2.default.createElement(
	            _reactMd.Grid,
	            { className: 'signup-grid' },
	            _react2.default.createElement(
	              _reactMd.Cell,
	              { size: 4, className: 'icon-container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'icon-cell' },
	                _react2.default.createElement('img', { className: 'alarm-clock-icon', src: _alarmColor2.default, alt: '' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactMd.Cell,
	              { size: 7, className: 'text-container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ssl-signup-text' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'ssl-signup-header' },
	                  _react2.default.createElement(
	                    'a',
	                    { style: { color: '#BD2031' } },
	                    'Enable Critical Alerts Now'
	                  )
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'ssl-signup-subheader' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'ssl-signup-subheader-list' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      '\xA0\xA0\xA0Avoid\xA0',
	                      _react2.default.createElement(
	                        'b',
	                        { className: 'emphasis' },
	                        'Irreversible Downtime'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      '\xA0\xA0\xA0Detect\xA0',
	                      _react2.default.createElement(
	                        'b',
	                        { className: 'emphasis' },
	                        'Malicious Domains'
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactMd.Cell,
	              { size: 12 },
	              _react2.default.createElement(
	                'div',
	                { className: 'button-container' },
	                _react2.default.createElement(
	                  _reactMd.Button,
	                  {
	                    raised: true,
	                    primary: true,
	                    className: 'create-alerts-button',
	                    style: { background: '#BD2031' }
	                  },
	                  'Create Alerts'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactMd.DialogContainer,
	        {
	          portal: true,
	          id: 'signup-alert-modal',
	          visible: visible,
	          title: 'Enable Critical Alerts',
	          onHide: this.hide,
	          'aria-describedby': 'signup-alert-description',
	          modal: true,
	          actions: actions
	        },
	        _react2.default.createElement(
	          _reactMd.Grid,
	          { className: 'dialog-outer' },
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 6, style: { backgroundColor: '#EFF4FC' } },
	            _react2.default.createElement(
	              'p',
	              { className: 'alerts-tier-title', style: { fontWeight: 700 } },
	              '\xA0\xA0Critical Alerts'
	            ),
	            _react2.default.createElement(
	              _reactMd.Grid,
	              { className: 'dialog-inner' },
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'timelapse'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Prevent irreversible downtime due to SSL pinning mistakes'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'bug_report'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Detect malicious domains forging your SSL certificates'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'healing'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Avoid embarrassment due to expired SSL certificates'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 6 },
	            _react2.default.createElement(
	              'p',
	              { className: 'alerts-tier-title' },
	              '\xA0\xA0Scheduled Reports'
	            ),
	            _react2.default.createElement(
	              _reactMd.Grid,
	              { className: 'dialog-inner' },
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'trending_up'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Discover trends in eavesdropping attempts across your user base'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'description'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Details of eavesdropping attempts on encrypted user sessions'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'https'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Set policies to detect violations of user privacy and compliance'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_reactMd.Snackbar, {
	        id: 'alertsignup-snackbar',
	        toasts: toasts,
	        autohide: true,
	        onDismiss: this.dismissToast
	      })
	    );
	  };
	
	  return AlertSignupCard;
	}(_react.PureComponent);
	
	exports.default = AlertSignupCard;
	module.exports = exports['default'];

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(196);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _CategoryCard = __webpack_require__(412);
	
	var _CategoryCard2 = _interopRequireDefault(_CategoryCard);
	
	__webpack_require__(459);
	
	var _phone = __webpack_require__(756);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _creditCard = __webpack_require__(753);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _team = __webpack_require__(759);
	
	var _team2 = _interopRequireDefault(_team);
	
	var _employees = __webpack_require__(754);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	var _wifi = __webpack_require__(760);
	
	var _wifi2 = _interopRequireDefault(_wifi);
	
	var _profile = __webpack_require__(757);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _login = __webpack_require__(755);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _unsecuredShield = __webpack_require__(479);
	
	var _unsecuredShield2 = _interopRequireDefault(_unsecuredShield);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AttackCategories = function (_Component) {
	  (0, _inherits3.default)(AttackCategories, _Component);
	
	  function AttackCategories() {
	    (0, _classCallCheck3.default)(this, AttackCategories);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  AttackCategories.prototype.getAllTimeCount = function getAllTimeCount(cat, monthly, allTimeCatCount) {
	    var count = 0;
	    monthly.forEach(function (mth) {
	      if (mth[cat] > 0) {
	        count += mth[cat];
	      }
	    });
	    return Math.max(count, allTimeCatCount);
	  };
	
	  AttackCategories.prototype.formatNum = function formatNum(n) {
	    return (0, _numeral2.default)(n).format('0,0');
	  };
	
	  AttackCategories.prototype.monthlyAvg = function monthlyAvg(monthly, cat) {
	    var numMonths = 0;
	    var count = 0;
	    monthly.forEach(function (mth) {
	      if (mth[cat] > 0) {
	        count += mth[cat];
	        numMonths += 1;
	      }
	    });
	    if (numMonths === 0) return 0;
	    return this.formatNum(count / numMonths);
	  };
	
	  AttackCategories.prototype.catPercentage = function catPercentage(catTotal, catCount) {
	    return (0, _numeral2.default)(catCount / catTotal).format('0.0%');
	  };
	
	  AttackCategories.prototype.render = function render() {
	    var allTime = this.props.bundleSummary.attack_cat_all_time;
	    var monthly = this.props.bundleSummary.attack_cat_monthly;
	
	    if (!monthly || !allTime) {
	      return null;
	    }
	
	    var allTimeCorrected = {};
	    var catTotal = 0;
	    for (var k in allTime) {
	      if (!allTime.hasOwnProperty(k)) continue;
	      var curCount = this.getAllTimeCount(k, monthly, allTime[k]);
	      allTimeCorrected[k] = curCount;
	      catTotal += curCount;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'categories-container md-grid mobile-fix' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'whos-spying' },
	        'Who\'s eavesdropping on your users?'
	      ),
	      _react2.default.createElement(_CategoryCard2.default, {
	        id: 'spyware',
	        title: 'User Device Spyware',
	        titleAvatar: _phone2.default,
	        numTotalIncidents: this.formatNum(allTimeCorrected.device_spyware),
	        numMonthlyAvg: this.monthlyAvg(monthly, 'device_spyware'),
	        percentage: this.catPercentage(catTotal, allTimeCorrected.device_spyware),
	        prose: 'due to spyware on user devices potentially stealing their data through your app',
	        dataLeakedA: 'User payment information',
	        iconA: _creditCard2.default,
	        complianceA: 'PCI DSS',
	        dataLeakedB: 'User private details',
	        iconB: _team2.default,
	        complianceB: 'GDPR Information Assurance',
	        whyText: 'Some third-party software installed on your users\' devices have the ability to intercept private communication between your app and servers. By tricking users into installing non-official SSL certificates, this software can decrypt encrypted traffic that your app sends out if SSL certificate pinning validation is not enforced.',
	        riskText: 'This type of spyware typically claims to be doing "market research" on users, but put themselves in a position to steal the most sensitive information that users are sharing through your app.',
	        riskScoreMalice: 8.0,
	        riskScoreExposure: 9.5,
	        riskScoreBreach: 8.0
	      }),
	      _react2.default.createElement(_CategoryCard2.default, {
	        id: 'employer',
	        title: 'Employer Eavesdropping',
	        titleAvatar: _employees2.default,
	        numTotalIncidents: this.formatNum(allTimeCorrected.corporate_appliance),
	        numMonthlyAvg: this.monthlyAvg(monthly, 'corporate_appliance'),
	        percentage: this.catPercentage(catTotal, allTimeCorrected.corporate_appliance),
	        prose: 'due to employers listening in on their employees\' private communications with your service',
	        dataLeakedA: 'All private communications',
	        iconA: _unsecuredShield2.default,
	        complianceA: 'SOC 2',
	        dataLeakedB: 'User payment information',
	        iconB: _creditCard2.default,
	        complianceB: 'PCI DSS',
	        whyText: 'Employers often install network proxy devices in the workplace and require employees to install trusted profiles on devices before allowing them on the network. This allows employers to inspect their employees\' Internet browsing behavior even if traffic is encrypted.',
	        riskText: 'Companies do this to prevent malicious activity within the company network, but at the cost of employees\' privacy. Company IT administrators could potentially have access to private data that your users are sharing with you.',
	        riskScoreMalice: 2.0,
	        riskScoreExposure: 6.0,
	        riskScoreBreach: 3.0
	      }),
	      _react2.default.createElement(_CategoryCard2.default, {
	        id: 'wifi',
	        title: 'Insecure Public WiFi',
	        titleAvatar: _wifi2.default,
	        numTotalIncidents: this.formatNum(allTimeCorrected.captive_portal),
	        numMonthlyAvg: this.monthlyAvg(monthly, 'captive_portal'),
	        percentage: this.catPercentage(catTotal, allTimeCorrected.captive_portal),
	        prose: 'due to users using your app over public WiFi networks that intercepted their connection',
	        dataLeakedA: 'All private communications',
	        iconA: _unsecuredShield2.default,
	        complianceA: 'SOC 2',
	        dataLeakedB: 'User login credentials',
	        iconB: _login2.default,
	        complianceB: 'GDPR PII protection violation',
	        whyText: 'When users connect to public WiFi networks, they are often faced with "captive portals", a mechanism to force users to authenticate before granting them access to the network. Captive portals intercept, impersonate, and alter the connection between the client and server, which causes the SSL certificate validation error that we see.',
	        riskText: 'Most public WiFi networks at your local coffee shop or mall are not trying to steal your users\' private information. However, this same mechanism can easily be exploited by attackers who masquerade as pubic WiFi networks and tap into your users\' communication channels with you.',
	        riskScoreMalice: 5.0,
	        riskScoreExposure: 7.5,
	        riskScoreBreach: 9.0
	      }),
	      _react2.default.createElement(_CategoryCard2.default, {
	        id: 'unknown',
	        title: 'Unknown Actors',
	        titleAvatar: _profile2.default,
	        numTotalIncidents: this.formatNum(allTimeCorrected.unknown),
	        numMonthlyAvg: this.monthlyAvg(monthly, 'unknown'),
	        percentage: this.catPercentage(catTotal, allTimeCorrected.unknown),
	        prose: 'connections intercepted by 3rd parties that we were unable to identify',
	        dataLeakedA: 'All private communications',
	        iconA: _unsecuredShield2.default,
	        complianceA: 'SOC 2',
	        whyText: 'We see a lot of different types of SSL certificate validation failures, but it is impossible to attribute all of them to one of the other categories. This category of attacks represents all the instances of a certificate that you did not authorize attempting to decrypt users\' communication channels with you.',
	        riskText: 'This type of SSL failure is risky because it is difficult to know the underlying intent of the interceptors.',
	        riskScoreMalice: 9.9,
	        riskScoreExposure: 5.0,
	        riskScoreBreach: 5.0
	      })
	    );
	  };
	
	  return AttackCategories;
	}(_react.Component);
	
	exports.default = AttackCategories;
	module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _recharts = __webpack_require__(398);
	
	var _analytics = __webpack_require__(57);
	
	__webpack_require__(683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AttackInfoModal = function (_PureComponent) {
	  (0, _inherits3.default)(AttackInfoModal, _PureComponent);
	
	  function AttackInfoModal() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AttackInfoModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { visible: false }, _this.data = [{ name: '', value: 10, fill: '#FFFFFF' }, // Hidden max-value used to scale other bars
	    { name: 'Maliciousness', value: 0, fill: '#B80C09' }, { name: 'Data Exposure', value: 0, fill: '#183446' }, { name: 'Chance of Causing Breach', value: 0, fill: '#F6AA1C' }], _this.show = function () {
	      _this.setState({ visible: true });
	      (0, _analytics.trackEvent)({
	        category: 'Attack Info',
	        action: 'Opened',
	        label: _this.props.title
	      });
	    }, _this.hide = function () {
	      _this.setState({ visible: false });
	      (0, _analytics.trackEvent)({
	        category: 'Attack Info',
	        action: 'Closed',
	        label: _this.props.title
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  AttackInfoModal.prototype.render = function render() {
	    var visible = this.state.visible;
	
	    var actions = [{
	      onClick: this.hide,
	      primary: true,
	      children: 'OK'
	    }];
	
	    if (this.props.riskScoreMalice) {
	      this.data[1].value = this.props.riskScoreMalice;
	    }
	    if (this.props.riskScoreExposure) {
	      this.data[2].value = this.props.riskScoreExposure;
	    }
	    if (this.props.riskScoreBreach) {
	      this.data[3].value = this.props.riskScoreBreach;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactMd.Button,
	        { onClick: this.show, icon: true },
	        'info_outline'
	      ),
	      _react2.default.createElement(
	        _reactMd.DialogContainer,
	        {
	          portal: true,
	          id: 'attack-info-' + this.props.id,
	          visible: visible,
	          title: this.props.title,
	          onHide: this.hide,
	          'aria-describedby': 'attack-info-' + this.props.id + '-description',
	          modal: true,
	          actions: actions
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'dialog-inner' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              null,
	              'question_answer'
	            ),
	            ' How does this happen?'
	          ),
	          _react2.default.createElement(
	            'p',
	            {
	              id: 'attack-info-' + this.props.id + '-description-why',
	              className: 'md-color--secondary-text'
	            },
	            this.props.whyText
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dialog-inner' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              null,
	              'warning'
	            ),
	            ' Risk to your users'
	          ),
	          _react2.default.createElement(
	            'p',
	            {
	              id: 'attack-info-' + this.props.id + '-description-risk',
	              className: 'md-color--secondary-text'
	            },
	            this.props.riskText
	          ),
	          _react2.default.createElement(
	            _recharts.ResponsiveContainer,
	            { width: '100%', height: 120 },
	            _react2.default.createElement(
	              _recharts.RadialBarChart,
	              {
	                cx: '35%',
	                cy: '100%',
	                innerRadius: 25,
	                outerRadius: 130,
	                startAngle: 180,
	                endAngle: 0,
	                barSize: 23,
	                data: this.data
	              },
	              _react2.default.createElement(_recharts.RadialBar, {
	                minAngle: 15,
	                label: { fill: '#FFF', position: 'insideStart' },
	                background: true,
	                clockWise: true,
	                dataKey: 'value'
	              }),
	              _react2.default.createElement(_recharts.Legend, {
	                iconSize: 10,
	                width: 200,
	                height: 80,
	                layout: 'vertical',
	                verticalAlign: 'middle',
	                align: 'right'
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return AttackInfoModal;
	}(_react.PureComponent);
	
	exports.default = AttackInfoModal;
	module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _recharts = __webpack_require__(398);
	
	var _siteConfig = __webpack_require__(121);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	__webpack_require__(685);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// color palette https://coolors.co/
	
	var ChartCard = function (_Component) {
	  (0, _inherits3.default)(ChartCard, _Component);
	
	  function ChartCard(props) {
	    (0, _classCallCheck3.default)(this, ChartCard);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));
	
	    var tog = {};
	    var allTime = _this.props.bundleSummary.attack_cat_all_time;
	    for (var k in allTime) {
	      if (!allTime.hasOwnProperty(k)) continue;
	      if (k === 'misconfiguration') {
	        tog[k] = false;
	      } else {
	        tog[k] = true;
	      }
	    }
	    _this.state = {
	      toggleState: tog
	    };
	    return _this;
	  }
	
	  ChartCard.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setState({ toggleState: nextProps.toggleState });
	  };
	
	  ChartCard.prototype.getLastMonthMult = function getLastMonthMult(timeUpdated) {
	    var dateUpdated = new Date(parseInt(timeUpdated, 10) * 1000);
	    var daysInMonth = new Date(dateUpdated.getFullYear(), dateUpdated.getMonth() + 1, 0).getDate();
	    return daysInMonth / dateUpdated.getDate();
	  };
	
	  ChartCard.prototype.render = function render() {
	    var toggleState = this.state.toggleState;
	
	    var catMapping = _siteConfig2.default.attacks.catMapping;
	    var catColors = _siteConfig2.default.attacks.catColors;
	
	    var data = this.props.bundleSummary.attack_cat_monthly;
	    var allTime = this.props.bundleSummary.attack_cat_all_time;
	
	    if (!data || !allTime) {
	      return null;
	    }
	
	    data.forEach(function (o) {
	      for (var k in o) {
	        if (o.hasOwnProperty(k)) {
	          // Replace nulls with 0 so recharts can plot series without issue
	          if (o[k] == null) o[k] = 0;
	        }
	      }
	    });
	
	    // Calculate multiplier for last month stats extrapolation
	    var lastMonthMult = this.getLastMonthMult(this.props.bundleSummary.updated);
	    if (lastMonthMult > 1 && toggleState) {
	      var lastMonthSum = 0;
	      if (toggleState.device_spyware) {
	        lastMonthSum += data[data.length - 1].device_spyware;
	      }
	      if (toggleState.captive_portal) {
	        lastMonthSum += data[data.length - 1].captive_portal;
	      }
	      if (toggleState.misconfiguration) {
	        lastMonthSum += data[data.length - 1].misconfiguration;
	      }
	      if (toggleState.corporate_appliance) {
	        lastMonthSum += data[data.length - 1].corporate_appliance;
	      }
	      if (toggleState.unknown) {
	        lastMonthSum += data[data.length - 1].unknown;
	      }
	      // Clip sum to 0
	      lastMonthSum = Math.max(0, lastMonthSum);
	      data[data.length - 1].projection = Math.round(lastMonthSum * (lastMonthMult - 1));
	    }
	
	    // Update labels with human-readable names (modifiying local copy)
	    var localData = [];
	    data.forEach(function (o) {
	      var localMonth = {};
	      for (var k in o) {
	        if (o.hasOwnProperty(k)) {
	          if (k === 'name') localMonth.name = o[k];
	          if (!toggleState || toggleState[k] || k === 'projection') {
	            localMonth[catMapping[k]] = o[k];
	          }
	        }
	      }
	      localData.push(localMonth);
	    });
	
	    var chartAreas = [];
	    for (var k in allTime) {
	      if (!allTime.hasOwnProperty(k)) continue;
	      chartAreas.push(_react2.default.createElement(_recharts.Area, {
	        type: 'monotone',
	        dataKey: catMapping[k],
	        stackId: '1',
	        stroke: catColors[k],
	        fill: catColors[k],
	        dot: { stroke: catColors[k], strokeWidth: 0.5 },
	        key: 'chart-area-' + k
	      }));
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'chart-container md-grid mobile-fix' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'spying-breakdown' },
	        'Eavesdropping attempts on your users'
	      ),
	      _react2.default.createElement(
	        _reactMd.Card,
	        { className: 'md-block-centered' },
	        _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: '100%', height: 300 },
	          _react2.default.createElement(
	            _recharts.AreaChart,
	            {
	              data: localData,
	              margin: {
	                top: 20,
	                right: 40,
	                left: 0,
	                bottom: 5
	              }
	            },
	            _react2.default.createElement(_recharts.CartesianGrid, { strokeDasharray: '3 3' }),
	            _react2.default.createElement(_recharts.XAxis, { dataKey: 'name' }),
	            _react2.default.createElement(_recharts.YAxis, null),
	            _react2.default.createElement(_recharts.Tooltip, null),
	            chartAreas,
	            _react2.default.createElement(_recharts.Area, {
	              type: 'monotone',
	              dataKey: catMapping.projection,
	              stackId: '1',
	              stroke: '#D0D0D0',
	              fill: '#FBEBE0'
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return ChartCard;
	}(_react.Component);
	
	exports.default = ChartCard;
	module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isCountryCode = isCountryCode;
	exports.convertCountryCode = convertCountryCode;
	var isoCountries = {
	  AF: {
	    name: 'Afghanistan'
	  },
	  AX: {
	    name: 'Aland Islands'
	  },
	  AL: {
	    name: 'Albania'
	  },
	  DZ: {
	    name: 'Algeria'
	  },
	  AS: {
	    name: 'American Samoa'
	  },
	  AD: {
	    name: 'Andorra'
	  },
	  AO: {
	    name: 'Angola'
	  },
	  AI: {
	    name: 'Anguilla'
	  },
	  AQ: {
	    name: 'Antarctica'
	  },
	  AG: {
	    name: 'Antigua And Barbuda'
	  },
	  AR: {
	    name: 'Argentina'
	  },
	  AM: {
	    name: 'Armenia'
	  },
	  AW: {
	    name: 'Aruba'
	  },
	  AU: {
	    name: 'Australia'
	  },
	  AT: {
	    name: 'Austria'
	  },
	  AZ: {
	    name: 'Azerbaijan'
	  },
	  BS: {
	    name: 'Bahamas'
	  },
	  BH: {
	    name: 'Bahrain'
	  },
	  BD: {
	    name: 'Bangladesh'
	  },
	  BB: {
	    name: 'Barbados'
	  },
	  BY: {
	    name: 'Belarus'
	  },
	  BE: {
	    name: 'Belgium'
	  },
	  BZ: {
	    name: 'Belize'
	  },
	  BJ: {
	    name: 'Benin'
	  },
	  BM: {
	    name: 'Bermuda'
	  },
	  BT: {
	    name: 'Bhutan'
	  },
	  BO: {
	    name: 'Bolivia'
	  },
	  BA: {
	    name: 'Bosnia And Herzegovina'
	  },
	  BW: {
	    name: 'Botswana'
	  },
	  BV: {
	    name: 'Bouvet Island'
	  },
	  BR: {
	    name: 'Brazil'
	  },
	  IO: {
	    name: 'British Indian Ocean Territory'
	  },
	  BN: {
	    name: 'Brunei Darussalam'
	  },
	  BG: {
	    name: 'Bulgaria'
	  },
	  BF: {
	    name: 'Burkina Faso'
	  },
	  BI: {
	    name: 'Burundi'
	  },
	  KH: {
	    name: 'Cambodia'
	  },
	  CM: {
	    name: 'Cameroon'
	  },
	  CA: {
	    name: 'Canada'
	  },
	  CV: {
	    name: 'Cape Verde'
	  },
	  KY: {
	    name: 'Cayman Islands'
	  },
	  CF: {
	    name: 'Central African Republic'
	  },
	  TD: {
	    name: 'Chad'
	  },
	  CL: {
	    name: 'Chile'
	  },
	  CN: {
	    name: 'China'
	  },
	  CX: {
	    name: 'Christmas Island'
	  },
	  CC: {
	    name: 'Cocos (Keeling) Islands'
	  },
	  CO: {
	    name: 'Colombia'
	  },
	  KM: {
	    name: 'Comoros'
	  },
	  CG: {
	    name: 'Congo'
	  },
	  CD: {
	    name: 'Congo, Democratic Republic'
	  },
	  CK: {
	    name: 'Cook Islands'
	  },
	  CR: {
	    name: 'Costa Rica'
	  },
	  CI: {
	    name: "Cote D'Ivoire"
	  },
	  HR: {
	    name: 'Croatia'
	  },
	  CU: {
	    name: 'Cuba'
	  },
	  CY: {
	    name: 'Cyprus'
	  },
	  CZ: {
	    name: 'Czech Republic'
	  },
	  DK: {
	    name: 'Denmark'
	  },
	  DJ: {
	    name: 'Djibouti'
	  },
	  DM: {
	    name: 'Dominica'
	  },
	  DO: {
	    name: 'Dominican Republic'
	  },
	  EC: {
	    name: 'Ecuador'
	  },
	  EG: {
	    name: 'Egypt'
	  },
	  SV: {
	    name: 'El Salvador'
	  },
	  GQ: {
	    name: 'Equatorial Guinea'
	  },
	  ER: {
	    name: 'Eritrea'
	  },
	  EE: {
	    name: 'Estonia'
	  },
	  ET: {
	    name: 'Ethiopia'
	  },
	  FK: {
	    name: 'Falkland Islands (Malvinas)'
	  },
	  FO: {
	    name: 'Faroe Islands'
	  },
	  FJ: {
	    name: 'Fiji'
	  },
	  FI: {
	    name: 'Finland'
	  },
	  FR: {
	    name: 'France'
	  },
	  GF: {
	    name: 'French Guiana'
	  },
	  PF: {
	    name: 'French Polynesia'
	  },
	  TF: {
	    name: 'French Southern Territories'
	  },
	  GA: {
	    name: 'Gabon'
	  },
	  GM: {
	    name: 'Gambia'
	  },
	  GE: {
	    name: 'Georgia'
	  },
	  DE: {
	    name: 'Germany'
	  },
	  GH: {
	    name: 'Ghana'
	  },
	  GI: {
	    name: 'Gibraltar'
	  },
	  GR: {
	    name: 'Greece'
	  },
	  GL: {
	    name: 'Greenland'
	  },
	  GD: {
	    name: 'Grenada'
	  },
	  GP: {
	    name: 'Guadeloupe'
	  },
	  GU: {
	    name: 'Guam'
	  },
	  GT: {
	    name: 'Guatemala'
	  },
	  GG: {
	    name: 'Guernsey'
	  },
	  GN: {
	    name: 'Guinea'
	  },
	  GW: {
	    name: 'Guinea-Bissau'
	  },
	  GY: {
	    name: 'Guyana'
	  },
	  HT: {
	    name: 'Haiti'
	  },
	  HM: {
	    name: 'Heard Island & Mcdonald Islands'
	  },
	  VA: {
	    name: 'Holy See (Vatican City State)'
	  },
	  HN: {
	    name: 'Honduras'
	  },
	  HK: {
	    name: 'Hong Kong'
	  },
	  HU: {
	    name: 'Hungary'
	  },
	  IS: {
	    name: 'Iceland'
	  },
	  IN: {
	    name: 'India'
	  },
	  ID: {
	    name: 'Indonesia'
	  },
	  IR: {
	    name: 'Iran, Islamic Republic Of'
	  },
	  IQ: {
	    name: 'Iraq'
	  },
	  IE: {
	    name: 'Ireland'
	  },
	  IM: {
	    name: 'Isle Of Man'
	  },
	  IL: {
	    name: 'Israel'
	  },
	  IT: {
	    name: 'Italy'
	  },
	  JM: {
	    name: 'Jamaica'
	  },
	  JP: {
	    name: 'Japan'
	  },
	  JE: {
	    name: 'Jersey'
	  },
	  JO: {
	    name: 'Jordan'
	  },
	  KZ: {
	    name: 'Kazakhstan'
	  },
	  KE: {
	    name: 'Kenya'
	  },
	  KI: {
	    name: 'Kiribati'
	  },
	  KR: {
	    name: 'Korea'
	  },
	  KW: {
	    name: 'Kuwait'
	  },
	  KG: {
	    name: 'Kyrgyzstan'
	  },
	  LA: {
	    name: "Lao People's Democratic Republic"
	  },
	  LV: {
	    name: 'Latvia'
	  },
	  LB: {
	    name: 'Lebanon'
	  },
	  LS: {
	    name: 'Lesotho'
	  },
	  LR: {
	    name: 'Liberia'
	  },
	  LY: {
	    name: 'Libyan Arab Jamahiriya'
	  },
	  LI: {
	    name: 'Liechtenstein'
	  },
	  LT: {
	    name: 'Lithuania'
	  },
	  LU: {
	    name: 'Luxembourg'
	  },
	  MO: {
	    name: 'Macao'
	  },
	  MK: {
	    name: 'Macedonia'
	  },
	  MG: {
	    name: 'Madagascar'
	  },
	  MW: {
	    name: 'Malawi'
	  },
	  MY: {
	    name: 'Malaysia'
	  },
	  MV: {
	    name: 'Maldives'
	  },
	  ML: {
	    name: 'Mali'
	  },
	  MT: {
	    name: 'Malta'
	  },
	  MH: {
	    name: 'Marshall Islands'
	  },
	  MQ: {
	    name: 'Martinique'
	  },
	  MR: {
	    name: 'Mauritania'
	  },
	  MU: {
	    name: 'Mauritius'
	  },
	  YT: {
	    name: 'Mayotte'
	  },
	  MX: {
	    name: 'Mexico'
	  },
	  FM: {
	    name: 'Micronesia, Federated States Of'
	  },
	  MD: {
	    name: 'Moldova'
	  },
	  MC: {
	    name: 'Monaco'
	  },
	  MN: {
	    name: 'Mongolia'
	  },
	  ME: {
	    name: 'Montenegro'
	  },
	  MS: {
	    name: 'Montserrat'
	  },
	  MA: {
	    name: 'Morocco'
	  },
	  MZ: {
	    name: 'Mozambique'
	  },
	  MM: {
	    name: 'Myanmar'
	  },
	  NA: {
	    name: 'Namibia'
	  },
	  NR: {
	    name: 'Nauru'
	  },
	  NP: {
	    name: 'Nepal'
	  },
	  NL: {
	    name: 'Netherlands'
	  },
	  AN: {
	    name: 'Netherlands Antilles'
	  },
	  NC: {
	    name: 'New Caledonia'
	  },
	  NZ: {
	    name: 'New Zealand'
	  },
	  NI: {
	    name: 'Nicaragua'
	  },
	  NE: {
	    name: 'Niger'
	  },
	  NG: {
	    name: 'Nigeria'
	  },
	  NU: {
	    name: 'Niue'
	  },
	  NF: {
	    name: 'Norfolk Island'
	  },
	  MP: {
	    name: 'Northern Mariana Islands'
	  },
	  NO: {
	    name: 'Norway'
	  },
	  OM: {
	    name: 'Oman'
	  },
	  PK: {
	    name: 'Pakistan'
	  },
	  PW: {
	    name: 'Palau'
	  },
	  PS: {
	    name: 'Palestinian Territory, Occupied'
	  },
	  PA: {
	    name: 'Panama'
	  },
	  PG: {
	    name: 'Papua New Guinea'
	  },
	  PY: {
	    name: 'Paraguay'
	  },
	  PE: {
	    name: 'Peru'
	  },
	  PH: {
	    name: 'Philippines'
	  },
	  PN: {
	    name: 'Pitcairn'
	  },
	  PL: {
	    name: 'Poland'
	  },
	  PT: {
	    name: 'Portugal'
	  },
	  PR: {
	    name: 'Puerto Rico'
	  },
	  QA: {
	    name: 'Qatar'
	  },
	  RE: {
	    name: 'Reunion'
	  },
	  RO: {
	    name: 'Romania'
	  },
	  RU: {
	    name: 'Russian Federation'
	  },
	  RW: {
	    name: 'Rwanda'
	  },
	  BL: {
	    name: 'Saint Barthelemy'
	  },
	  SH: {
	    name: 'Saint Helena'
	  },
	  KN: {
	    name: 'Saint Kitts And Nevis'
	  },
	  LC: {
	    name: 'Saint Lucia'
	  },
	  MF: {
	    name: 'Saint Martin'
	  },
	  PM: {
	    name: 'Saint Pierre And Miquelon'
	  },
	  VC: {
	    name: 'Saint Vincent And Grenadines'
	  },
	  WS: {
	    name: 'Samoa'
	  },
	  SM: {
	    name: 'San Marino'
	  },
	  ST: {
	    name: 'Sao Tome And Principe'
	  },
	  SA: {
	    name: 'Saudi Arabia'
	  },
	  SN: {
	    name: 'Senegal'
	  },
	  RS: {
	    name: 'Serbia'
	  },
	  SC: {
	    name: 'Seychelles'
	  },
	  SL: {
	    name: 'Sierra Leone'
	  },
	  SG: {
	    name: 'Singapore'
	  },
	  SK: {
	    name: 'Slovakia'
	  },
	  SI: {
	    name: 'Slovenia'
	  },
	  SB: {
	    name: 'Solomon Islands'
	  },
	  SO: {
	    name: 'Somalia'
	  },
	  ZA: {
	    name: 'South Africa'
	  },
	  GS: {
	    name: 'South Georgia And Sandwich Isl.'
	  },
	  ES: {
	    name: 'Spain'
	  },
	  LK: {
	    name: 'Sri Lanka'
	  },
	  SD: {
	    name: 'Sudan'
	  },
	  SR: {
	    name: 'Suriname'
	  },
	  SJ: {
	    name: 'Svalbard And Jan Mayen'
	  },
	  SZ: {
	    name: 'Swaziland'
	  },
	  SE: {
	    name: 'Sweden'
	  },
	  CH: {
	    name: 'Switzerland'
	  },
	  SY: {
	    name: 'Syrian Arab Republic'
	  },
	  TW: {
	    name: 'Taiwan'
	  },
	  TJ: {
	    name: 'Tajikistan'
	  },
	  TZ: {
	    name: 'Tanzania'
	  },
	  TH: {
	    name: 'Thailand'
	  },
	  TL: {
	    name: 'Timor-Leste'
	  },
	  TG: {
	    name: 'Togo'
	  },
	  TK: {
	    name: 'Tokelau'
	  },
	  TO: {
	    name: 'Tonga'
	  },
	  TT: {
	    name: 'Trinidad And Tobago'
	  },
	  TN: {
	    name: 'Tunisia'
	  },
	  TR: {
	    name: 'Turkey'
	  },
	  TM: {
	    name: 'Turkmenistan'
	  },
	  TC: {
	    name: 'Turks And Caicos Islands'
	  },
	  TV: {
	    name: 'Tuvalu'
	  },
	  UG: {
	    name: 'Uganda'
	  },
	  UA: {
	    name: 'Ukraine'
	  },
	  AE: {
	    name: 'United Arab Emirates'
	  },
	  GB: {
	    name: 'United Kingdom'
	  },
	  US: {
	    name: 'United States'
	  },
	  UM: {
	    name: 'United States Outlying Islands'
	  },
	  UY: {
	    name: 'Uruguay'
	  },
	  UZ: {
	    name: 'Uzbekistan'
	  },
	  VU: {
	    name: 'Vanuatu'
	  },
	  VE: {
	    name: 'Venezuela'
	  },
	  VN: {
	    name: 'Viet Nam'
	  },
	  VG: {
	    name: 'Virgin Islands, British'
	  },
	  VI: {
	    name: 'Virgin Islands, U.S.'
	  },
	  WF: {
	    name: 'Wallis And Futuna'
	  },
	  EH: {
	    name: 'Western Sahara'
	  },
	  YE: {
	    name: 'Yemen'
	  },
	  ZM: {
	    name: 'Zambia'
	  },
	  ZW: {
	    name: 'Zimbabwe'
	  }
	};
	
	function isCountryCode(code) {
	  return code in isoCountries;
	}
	
	function convertCountryCode(code) {
	  return isoCountries[code].name;
	}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.updateAnimationToggle = updateAnimationToggle;
	exports.updateDots = updateDots;
	exports.installGlobe = installGlobe;
	
	var _gatsbyLink = __webpack_require__(805);
	
	var _countryMapping = __webpack_require__(513);
	
	var _siteConfig = __webpack_require__(121);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var THREE = __webpack_require__(478);
	var OrbitControls = __webpack_require__(508)(THREE);
	var MeshLine = __webpack_require__(751);
	
	var canvas = void 0,
	    scene = void 0,
	    renderer = void 0,
	    data = void 0,
	    globe = void 0;
	
	// Cache DOM selectors
	var container = void 0;
	
	// Object for geolocation HTML elements and variables
	var elements = {};
	
	// Three group objects
	var groups = {
	  main: null, // A group containing everything
	  globe: null, // A group containing the globe sphere (and globe dots)
	  globeDots: null, // A group containing the globe dots
	  lines: null, // A group containing the lines between each geolocation
	  lineDots: null // A group containing the line dots
	};
	
	// Map properties for creation and rendering
	var props = {
	  // Toolbar header height
	  headerHeight: 64,
	  mapSize: {
	    // Size of the map from the intial source image (on which the dots are positioned on)
	    width: 1024,
	    height: 512
	  },
	  globeRadius: 200, // Radius of the globe (used for many calculations)
	  dotsAmount: 30, // Amount of dots to generate and animate randomly across the lines
	  colours: {
	    lines: new THREE.Color('#E54530'),
	    lineDots: new THREE.Color('#FFA9A3')
	  },
	  alphas: {
	    // Transparency
	    globe: 0.3,
	    lines: 1.0
	  },
	  hqLoc: null,
	  citiesData: null,
	  toggleState: null
	};
	
	// Angles used for animating the camera
	var camera = {
	  object: null, // Three object of the camera
	  controls: null, // Three object of the orbital controls
	  angles: {
	    // Object of the camera angles for animating
	    current: {
	      azimuthal: null,
	      polar: null
	    },
	    target: {
	      azimuthal: null,
	      polar: null
	    }
	  }
	};
	
	// Booleans and values for animations
	var animations = {
	  finishedIntro: false, // Boolean of when the intro animations have finished
	  dots: {
	    current: 0, // Animation frames of the globe dots introduction animation
	    total: 170, // Total frames (duration) of the globe dots introduction animation,
	    points: [] // Array to clone the globe dots coordinates to
	  },
	  globe: {
	    current: 0, // Animation frames of the globe introduction animation
	    total: 80 // Total frames (duration) of the globe introduction animation,
	  },
	  geolocations: {
	    atHq: true,
	    active: false, // Boolean if the geolocation elements have been added and made active
	    animating: false, // Boolean if the geolocations are currently being animated
	    current: 0, // Animation frames of geolocation elements introduction animation
	    total: 240, // Total frames (duration) of the geolocation elements introduction animation
	    selected: null, // Three group object of the currently selected geolocation
	    index: null, // Index of the geolocation in the data array
	    timeout: null, // Timeout object for cycling to the next geolocation
	    initialDuration: 2000, // Initial timeout duration before starting the geolocation cycle
	    duration: 1000 // Timeout duration between cycling to the next geolocation
	  }
	};
	
	// Boolean to enable or disable rendering when window is in or out of focus
	var isHidden = false;
	
	function setupScene() {
	  container = document.getElementsByClassName('js-globe')[0];
	  canvas = container.getElementsByClassName('js-canvas')[0];
	
	  scene = new THREE.Scene();
	  renderer = new THREE.WebGLRenderer({
	    canvas: canvas,
	    antialias: true,
	    alpha: true,
	    shadowMapEnabled: false
	  });
	  renderer.setSize(canvas.clientWidth / 2, canvas.clientHeight - props.headerHeight);
	  renderer.setPixelRatio(1);
	  renderer.setClearColor(0x000000, 0);
	
	  // Main group that contains everything
	  groups.main = new THREE.Group();
	  groups.main.name = 'Main';
	
	  // Group that contains lines for each geolocation
	  groups.lines = new THREE.Group();
	  groups.lines.name = 'Lines';
	  groups.main.add(groups.lines);
	
	  // Group that contains dynamically created dots
	  groups.lineDots = new THREE.Group();
	  groups.lineDots.name = 'Dots';
	  groups.main.add(groups.lineDots);
	
	  // Add the main group to the scene
	  scene.add(groups.main);
	
	  // Render camera and add orbital controls
	  addCamera();
	  addControls();
	
	  // Render objects
	  addGlobe();
	  addLines();
	  createListElements();
	
	  // Start the requestAnimationFrame loop
	  render();
	  animate();
	
	  var canvasResizeBehaviour = function canvasResizeBehaviour() {
	    container.width = window.innerWidth / 2;
	    container.height = window.innerHeight - props.headerHeight;
	    container.style.width = window.innerWidth + 'px';
	    container.style.height = window.innerHeight + 'px';
	
	    var effecOffsetWidth = container.offsetWidth;
	    var effecOffsetHeight = container.offsetHeight - props.headerHeight;
	
	    camera.object.aspect = effecOffsetWidth / effecOffsetHeight;
	    camera.object.updateProjectionMatrix();
	    renderer.setSize(effecOffsetWidth, effecOffsetHeight);
	  };
	
	  window.addEventListener('resize', canvasResizeBehaviour);
	  window.addEventListener('orientationchange', function () {
	    setTimeout(canvasResizeBehaviour, 0);
	  });
	  canvasResizeBehaviour();
	}
	
	function addCamera() {
	  camera.object = new THREE.PerspectiveCamera(60, canvas.clientWidth / 2 / (canvas.clientHeight - props.headerHeight), 1, 10000);
	  camera.object.position.z = props.globeRadius * 2.2;
	}
	
	function addControls() {
	  camera.controls = new OrbitControls(camera.object, canvas);
	  camera.controls.enableKeys = false;
	  camera.controls.enablePan = false;
	  camera.controls.enableZoom = true;
	  camera.controls.enableDamping = false;
	  camera.controls.enableRotate = true;
	
	  camera.zoom = 0.5;
	  camera.controls.zoomSpeed = 0.5;
	  camera.controls.minDistance = 250;
	  camera.controls.maxDistance = 600;
	
	  // Set the initial camera angles to something crazy for the introduction animation
	  camera.angles.current.azimuthal = -Math.PI;
	  camera.angles.current.polar = 0;
	}
	
	function render() {
	  renderer.render(scene, camera.object);
	}
	
	function onFocusChange(event) {
	  var visible = 'visible';
	  var hidden = 'hidden';
	  var eventMap = {
	    focus: visible,
	    focusin: visible,
	    pageshow: visible,
	    blur: hidden,
	    focusout: hidden,
	    pagehide: hidden
	  };
	
	  event = event || window.event;
	
	  if (event.type in eventMap) {
	    isHidden = true;
	  } else {
	    isHidden = false;
	  }
	}
	
	function animate() {
	  if (isHidden === false) {
	    requestAnimationFrame(animate);
	  }
	
	  if (groups.globeDots) {
	    introAnimate();
	  }
	
	  if (animations.finishedIntro === true) {
	    animateDots();
	  }
	
	  if (animations.geolocations.animating === true) {
	    animateGeolocationCycle();
	  }
	
	  positionElements();
	  camera.controls.update();
	  render();
	}
	
	function addGlobe() {
	  var textureLoader = new THREE.TextureLoader();
	  textureLoader.setCrossOrigin(true);
	
	  var radius = props.globeRadius - props.globeRadius * 0.02;
	  var segments = 64;
	  var rings = 64;
	
	  var canvasSize = 128;
	  var textureCanvas = document.createElement('canvas');
	  textureCanvas.width = canvasSize;
	  textureCanvas.height = canvasSize;
	  var canvasContext = textureCanvas.getContext('2d');
	  canvasContext.rect(0, 0, canvasSize, canvasSize);
	
	  // Make texture
	  var texture = new THREE.Texture(textureCanvas);
	  texture.needsUpdate = true;
	
	  var geometry = new THREE.SphereGeometry(radius, segments, rings);
	
	  var material = new THREE.MeshPhongMaterial({
	    map: textureLoader.load((0, _gatsbyLink.withPrefix)('/img/2_no_clouds_8k.jpg')),
	    bumpMap: textureLoader.load((0, _gatsbyLink.withPrefix)('/img/elev_bump_8k.jpg')),
	    bumpScale: 0.5,
	    specularMap: textureLoader.load((0, _gatsbyLink.withPrefix)('/img/water_8k.png')),
	    specular: new THREE.Color('grey')
	  });
	
	  scene.add(new THREE.AmbientLight(0xf0f0f0));
	
	  var light = new THREE.DirectionalLight(0x404040, 0.3);
	  light.position.set(5, 3, 5);
	  scene.add(light);
	
	  globe = new THREE.Mesh(geometry, material);
	
	  groups.globe = new THREE.Group();
	  groups.globe.name = 'Globe';
	
	  groups.globe.add(globe);
	  groups.main.add(groups.globe);
	
	  addGlobeDots();
	}
	
	function addGlobeDots() {
	  var geometry = new THREE.Geometry();
	
	  // Make circle
	  var canvasSize = 16;
	  var halfSize = canvasSize / 2;
	  var textureCanvas = document.createElement('canvas');
	  textureCanvas.width = canvasSize;
	  textureCanvas.height = canvasSize;
	  var canvasContext = textureCanvas.getContext('2d');
	  canvasContext.beginPath();
	  canvasContext.arc(halfSize, halfSize, halfSize, 0, 2 * Math.PI);
	  canvasContext.fillStyle = props.colours.globeDots;
	  canvasContext.fill();
	
	  // Make texture
	  var texture = new THREE.Texture(textureCanvas);
	  texture.needsUpdate = true;
	
	  var material = new THREE.PointsMaterial({
	    map: texture,
	    size: props.globeRadius / 90
	  });
	
	  var addDot = function addDot(targetX, targetY) {
	    // Add a point with zero coordinates
	    var point = new THREE.Vector3(0, 0, 0);
	    geometry.vertices.push(point);
	
	    // Add the coordinates to a new array for the intro animation
	    var result = latLongToVector3(targetX, targetY);
	    animations.dots.points.push(new THREE.Vector3(result.x, result.y, result.z));
	  };
	
	  addDot(props.hqLoc.lat, props.hqLoc.long);
	
	  for (var i in props.citiesData) {
	    addDot(props.citiesData[i].lat, props.citiesData[i].long);
	  }
	
	  // Add the points to the scene
	  groups.globeDots = new THREE.Points(geometry, material);
	  groups.globe.add(groups.globeDots);
	}
	
	/* COUNTRY LINES AND DOTS */
	
	function addLines() {
	  // Create the geometry
	  var geometry = new THREE.Geometry();
	  var group = new THREE.Group();
	  group.name = 'hq';
	
	  for (var i in props.citiesData) {
	    var cityEnd = props.citiesData[i];
	    var isOutsideUS = cityEnd.city == cityEnd.city.toUpperCase() && cityEnd.city.length == 2;
	
	    // Get the spatial coordinates
	    var result = returnCurveCoordinates(props.hqLoc.lat, props.hqLoc.long, cityEnd.lat, cityEnd.long, isOutsideUS);
	
	    // Calculate the curve in order to get points from start to end
	    var curve = new THREE.QuadraticBezierCurve3(new THREE.Vector3(result.start.x, result.start.y, result.start.z), new THREE.Vector3(result.mid.x, result.mid.y, result.mid.z), new THREE.Vector3(result.end.x, result.end.y, result.end.z));
	
	    // Get verticies from curve
	    geometry.vertices = curve.getPoints(200);
	
	    // Create mesh line using plugin and set its geometry
	    var line = new MeshLine.MeshLine();
	    line.setGeometry(geometry);
	
	    // Create the mesh line material using the plugin
	    var material = new MeshLine.MeshLineMaterial({
	      color: props.colours.lines,
	      transparent: true,
	      opacity: props.alphas.lines,
	      lineWidth: 0.4
	    });
	
	    // Create the final object to add to the scene
	    var curveObject = new THREE.Mesh(line.geometry, material);
	    curveObject._path = geometry.vertices;
	
	    group.add(curveObject);
	  }
	  group.visible = false;
	  groups.lines.add(group);
	}
	
	function addLineDots() {
	  var radius = props.globeRadius / 180;
	  var segments = 8;
	  var rings = 8;
	
	  var geometry = new THREE.SphereGeometry(radius, segments, rings);
	  var material = new THREE.MeshBasicMaterial({
	    color: props.colours.lineDots
	  });
	
	  // Returns a sphere geometry positioned at coordinates
	  var returnLineDot = function returnLineDot() {
	    var sphere = new THREE.Mesh(geometry, material);
	    return sphere;
	  };
	
	  for (var i = 0; i < props.dotsAmount; i++) {
	    // Get the city path geometry vertices and create the dot at the first vertex
	    var targetDot = returnLineDot();
	    targetDot.visible = false;
	
	    // Add custom variables for custom path coordinates and index
	    targetDot._pathIndex = null;
	    targetDot._path = null;
	
	    // Add the dot to the dots group
	    groups.lineDots.add(targetDot);
	  }
	}
	
	function assignDotsToRandomLine(target) {
	  // Get a random line from the current geolocation
	  var randomLine = Math.random() * (animations.geolocations.selected.children.length - 1);
	  randomLine = animations.geolocations.selected.children[randomLine.toFixed(0)];
	  // Assign the random geolocation path to the dot and set the index at 0
	  target._path = randomLine._path;
	}
	
	function reassignDotsToNewLines() {
	  for (var i = 0; i < groups.lineDots.children.length; i++) {
	    var target = groups.lineDots.children[i];
	    if (target._path !== null && target._pathIndex !== null) {
	      assignDotsToRandomLine(target);
	    }
	  }
	}
	
	function animateDots() {
	  // Loop through the dots children group
	  for (var i = 0; i < groups.lineDots.children.length; i++) {
	    var dot = groups.lineDots.children[i];
	    if (dot._path === null) {
	      // Create a random seed as a pseudo-delay
	      var seed = Math.random();
	      if (seed > 0.99) {
	        assignDotsToRandomLine(dot);
	        dot._pathIndex = dot._path.length - 1;
	      }
	    } else if (dot._path !== null && dot._pathIndex > 0) {
	      // Show the dot
	      if (dot.visible === false) {
	        dot.visible = true;
	      }
	      // Move the dot along the path vertice coordinates
	      dot.position.x = dot._path[dot._pathIndex].x;
	      dot.position.y = dot._path[dot._pathIndex].y;
	      dot.position.z = dot._path[dot._pathIndex].z;
	      // Advance the dot along the path (in reverse)
	      dot._pathIndex--;
	    } else {
	      // Hide the dot
	      dot.visible = false;
	      // Remove the path assignment
	      dot._path = null;
	    }
	  }
	}
	
	var list = void 0;
	
	function createListElements() {
	  list = document.getElementsByClassName('js-list')[0];
	
	  var toTitleCase = function toTitleCase(str) {
	    return str.replace(/\w\S*/g, function (txt) {
	      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	    });
	  };
	
	  var pushObject = function pushObject(coordinates, target) {
	    // Create the element
	    var element = document.createElement('li');
	    var placeLabel = void 0;
	    if (target == 'HQ') {
	      placeLabel = target;
	    } else if ((0, _countryMapping.isCountryCode)(target)) {
	      placeLabel = (0, _countryMapping.convertCountryCode)(target);
	    } else {
	      placeLabel = toTitleCase(target);
	    }
	    element.innerHTML = '<span class="place-label">' + placeLabel + '</span>';
	    var object = {
	      position: coordinates,
	      element: element
	    };
	    // Add the element to the DOM and add the object to the array
	    list.appendChild(element);
	    elements[target] = object;
	  };
	
	  var hqLocLatRounded = Math.round(props.hqLoc.lat * 10) / 10;
	  var hqLocLongRounded = Math.round(props.hqLoc.long * 10) / 10;
	
	  // Create location labels
	  for (var i in props.citiesData) {
	    var cityData = props.citiesData[i];
	    // If HQ coordinates (rounded to 1dp) is same as one of the cities, print 'HQ' instead of city name
	    if (Math.round(cityData.lat * 10) / 10 == hqLocLatRounded && Math.round(cityData.long * 10) / 10 == hqLocLongRounded) {
	      continue;
	    }
	    var coordinates = latLongToVector3(cityData.lat, cityData.long);
	    pushObject(new THREE.Vector3(coordinates.x, coordinates.y, coordinates.z), cityData.city);
	  }
	
	  var coordinates = latLongToVector3(props.hqLoc.lat, props.hqLoc.long);
	  pushObject(new THREE.Vector3(coordinates.x, coordinates.y, coordinates.z), 'HQ');
	
	  // Set the geolocation cycle index and selected line object for the starting geolocation
	  animations.geolocations.index = props.citiesData.length;
	  animations.geolocations.selected = groups.lines.getObjectByName('hq');
	  // Set the line opacity to 0 so they can be faded-in during the introduction animation
	  var lineGroup = animations.geolocations.selected;
	  lineGroup.visible = true;
	  for (var ii = 0; ii < lineGroup.children.length; ii++) {
	    lineGroup.children[ii].material.uniforms.opacity.value = 0;
	  }
	  // Set the target camera angles for the starting geolocation for the introduction animation
	  var angles = returnCameraAngles(props.hqLoc.lat, props.hqLoc.long);
	  camera.angles.target.azimuthal = angles.azimuthal;
	  camera.angles.target.polar = angles.polar;
	}
	
	function positionElements() {
	  var widthHalf = canvas.clientWidth / 2;
	  var heightHalf = canvas.clientHeight / 2;
	
	  // Loop through the elements array and reposition the elements
	  for (var key in elements) {
	    var targetElement = elements[key];
	    var position = getProjectedPosition(widthHalf, heightHalf, targetElement.position);
	    // Construct the X and Y position strings
	    var positionX = position.x + 'px';
	    var positionY = position.y + 'px';
	
	    var elementStyle = targetElement.element.style;
	
	    // Hide the dot/label if overflows canvas
	    var labelElement = targetElement.element.getElementsByClassName('place-label')[0];
	    // This magic number '32' is obtained from corresponding style-sheet variable $dotSizeLarge
	    if (position.x < labelElement.clientWidth + 32) {
	      elementStyle.visibility = 'hidden';
	    } else {
	      elementStyle.visibility = 'visible';
	    }
	
	    // Construct the 3D translate string
	    elementStyle.webkitTransform = 'translate3D(' + positionX + ', ' + positionY + ', 0)';
	    elementStyle.WebkitTransform = 'translate3D(' + positionX + ', ' + positionY + ', 0)';
	    elementStyle.mozTransform = 'translate3D(' + positionX + ', ' + positionY + ', 0)';
	    elementStyle.msTransform = 'translate3D(' + positionX + ', ' + positionY + ', 0)';
	    elementStyle.oTransform = 'translate3D(' + positionX + ', ' + positionY + ', 0)';
	    elementStyle.transform = 'translate3D(' + positionX + ', ' + positionY + ', 0)';
	  }
	}
	
	/* INTRO ANIMATIONS */
	// Easing reference: https://gist.github.com/gre/1650294
	
	var easeInOutCubic = function easeInOutCubic(t) {
	  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	};
	
	var easeOutCubic = function easeOutCubic(t) {
	  return --t * t * t + 1;
	};
	
	var easeInOutQuad = function easeInOutQuad(t) {
	  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	};
	
	function introAnimate() {
	  if (animations.dots.current <= animations.dots.total) {
	    var points = groups.globeDots.geometry.vertices;
	    var totalLength = points.length;
	
	    for (var i = 0; i < totalLength; i++) {
	      // Get ease value
	      var dotProgress = easeInOutCubic(animations.dots.current / animations.dots.total);
	
	      // Add delay based on loop iteration
	      dotProgress += dotProgress * (i / totalLength);
	
	      if (dotProgress > 1) {
	        dotProgress = 1;
	      }
	
	      // Move the point
	      points[i].x = animations.dots.points[i].x * dotProgress;
	      points[i].y = animations.dots.points[i].y * dotProgress;
	      points[i].z = animations.dots.points[i].z * dotProgress;
	
	      // Animate the camera at the same rate as the first dot
	      if (i === 0) {
	        var azimuthalDifference = (camera.angles.current.azimuthal - camera.angles.target.azimuthal) * dotProgress;
	        azimuthalDifference = camera.angles.current.azimuthal - azimuthalDifference;
	        camera.controls.setAzimuthalAngle(azimuthalDifference);
	
	        var polarDifference = (camera.angles.current.polar - camera.angles.target.polar) * dotProgress;
	        polarDifference = camera.angles.current.polar - polarDifference;
	        camera.controls.setPolarAngle(polarDifference);
	      }
	    }
	    animations.dots.current++;
	
	    // Update verticies
	    groups.globeDots.geometry.verticesNeedUpdate = true;
	  }
	
	  if (animations.dots.current >= animations.dots.total * 0.65 && animations.globe.current <= animations.globe.total) {
	    var globeProgress = easeOutCubic(animations.globe.current / animations.globe.total);
	    globe.material.opacity = props.alphas.globe * globeProgress;
	
	    // Fade-in the geolocation lines
	    var lines = animations.geolocations.selected.children;
	    for (var ii = 0; ii < lines.length; ii++) {
	      lines[ii].material.uniforms.opacity.value = props.alphas.lines * globeProgress;
	    }
	
	    animations.globe.current++;
	  }
	
	  if (animations.dots.current >= animations.dots.total * 0.7 && animations.geolocations.active === false) {
	    list.classList.add('active');
	    animations.geolocations.active = true;
	  }
	
	  if (animations.geolocations.active === true && animations.finishedIntro === false) {
	    animations.finishedIntro = true;
	    // Start geolocation cycle
	    animations.geolocations.timeout = setTimeout(showNextGeolocation, animations.geolocations.initialDuration);
	    addLineDots();
	  }
	}
	
	function changeGeolocation(city, init) {
	  if (init !== true) {
	    camera.angles.current.azimuthal = camera.controls.getAzimuthalAngle();
	    camera.angles.current.polar = camera.controls.getPolarAngle();
	
	    var targetAngles = returnCameraAngles(city.lat, city.long);
	    camera.angles.target.azimuthal = targetAngles.azimuthal;
	    camera.angles.target.polar = targetAngles.polar;
	
	    animations.geolocations.animating = true;
	  }
	}
	
	function animateGeolocationCycle() {
	  if (animations.geolocations.current <= animations.geolocations.total) {
	    var progress = easeInOutQuad(animations.geolocations.current / animations.geolocations.total);
	
	    var azimuthalDifference = (camera.angles.current.azimuthal - camera.angles.target.azimuthal) * progress;
	    azimuthalDifference = camera.angles.current.azimuthal - azimuthalDifference;
	    camera.controls.setAzimuthalAngle(azimuthalDifference);
	
	    var polarDifference = (camera.angles.current.polar - camera.angles.target.polar) * progress;
	    polarDifference = camera.angles.current.polar - polarDifference;
	    camera.controls.setPolarAngle(polarDifference);
	
	    animations.geolocations.current++;
	  } else {
	    animations.geolocations.animating = false;
	    animations.geolocations.current = 0;
	    animations.geolocations.timeout = setTimeout(showNextGeolocation, animations.geolocations.duration);
	  }
	}
	
	function showNextGeolocation() {
	  var city = void 0;
	  if (animations.geolocations.atHq) {
	    animations.geolocations.index++;
	    if (animations.geolocations.index >= props.citiesData.length) {
	      animations.geolocations.index = 0;
	    }
	    city = props.citiesData[animations.geolocations.index];
	    animations.geolocations.atHq = false;
	  } else {
	    city = props.hqLoc;
	    animations.geolocations.atHq = true;
	  }
	  changeGeolocation(city, false);
	}
	
	/* COORDINATE CALCULATIONS */
	
	function latLongToVector3(lat, lon) {
	  var radius = props.globeRadius - props.globeRadius * 0.02;
	  var phi = lat * Math.PI / 180;
	  var theta = (lon - 180) * Math.PI / 180;
	
	  var x = -radius * Math.cos(phi) * Math.cos(theta);
	  var y = radius * Math.sin(phi);
	  var z = radius * Math.cos(phi) * Math.sin(theta);
	
	  return { x: x, y: y, z: z };
	}
	
	// Reference: https://codepen.io/ya7gisa0/pen/pisrm?editors=0010
	function returnCurveCoordinates(latitudeA, longitudeA, latitudeB, longitudeB, isOutsideUS) {
	  // Calculate the starting point
	  var start = latLongToVector3(latitudeA, longitudeA);
	
	  // Calculate the end point
	  var end = latLongToVector3(latitudeB, longitudeB);
	
	  // Calculate the mid-point
	  var midPointX = (start.x + end.x) / 2;
	  var midPointY = (start.y + end.y) / 2;
	  var midPointZ = (start.z + end.z) / 2;
	
	  // Calculate the distance between the two coordinates
	  var distance = Math.pow(end.x - start.x, 2);
	  distance += Math.pow(end.y - start.y, 2);
	  distance += Math.pow(end.z - start.z, 2);
	  distance = Math.sqrt(distance);
	
	  // Calculate the multiplication value
	  var multipleVal = Math.pow(midPointX, 2);
	  multipleVal += Math.pow(midPointY, 2);
	  multipleVal += Math.pow(midPointZ, 2);
	  multipleVal = Math.pow(distance, 2) / multipleVal;
	
	  if (isOutsideUS) {
	    multipleVal *= 0.3;
	  } else {
	    multipleVal *= 2.0;
	  }
	
	  // Apply the vector length to get new mid-points
	  var midX = midPointX + multipleVal * midPointX;
	  var midY = midPointY + multipleVal * midPointY;
	  var midZ = midPointZ + multipleVal * midPointZ;
	
	  // Return set of coordinates
	  return {
	    start: {
	      x: start.x,
	      y: start.y,
	      z: start.z
	    },
	    mid: {
	      x: midX,
	      y: midY,
	      z: midZ
	    },
	    end: {
	      x: end.x,
	      y: end.y,
	      z: end.z
	    }
	  };
	}
	
	// Returns an object of 2D coordinates for projected 3D position
	function getProjectedPosition(width, height, position) {
	  /*
	    Using the coordinates of a geolocation in the 3D space, this function will
	    return the 2D coordinates using the camera projection method.
	  */
	  position = position.clone();
	  var projected = position.project(camera.object);
	
	  return {
	    x: projected.x * width + width,
	    y: -(projected.y * height) + height
	  };
	}
	
	// Returns an object of the azimuthal and polar angles of a given map latitude and longitude
	function returnCameraAngles(latitude, longitude) {
	  /*
	    Note that the azimuthal angle ranges from 0 to PI, whereas the polar angle
	    ranges from -PI (negative PI) to PI (positive PI).
	    A small offset is added to the azimuthal angle as angling the camera directly on top of a point makes the lines appear flat.
	  */
	  var targetAzimuthalAngle = (longitude + 90) * Math.PI / 180;
	  var targetPolarAngle = (90 - latitude) * Math.PI / 180;
	
	  return {
	    azimuthal: targetAzimuthalAngle + 0.05,
	    polar: targetPolarAngle + 0.05
	  };
	}
	
	function updateAnimationToggle(animationOn) {
	  animations.geolocations.animating = animationOn;
	}
	
	function updateDots(toggleState) {
	  props.toggleState = toggleState;
	  console.log(toggleState);
	}
	
	function installGlobe(hqLoc, citiesData) {
	  if (!document || !window.WebGLRenderingContext) {
	    throw new Error('Browser does not reach minimum requirements for globe (WebGL suport)');
	  }
	
	  props.hqLoc = hqLoc;
	  props.citiesData = citiesData;
	
	  if ('hidden' in document) {
	    document.addEventListener('visibilitychange', onFocusChange);
	  } else if ('mozHidden' in document) {
	    document.addEventListener('mozvisibilitychange', onFocusChange);
	  } else if ('webkitHidden' in document) {
	    document.addEventListener('webkitvisibilitychange', onFocusChange);
	  } else if ('msHidden' in document) {
	    document.addEventListener('msvisibilitychange', onFocusChange);
	  } else if ('onfocusin' in document) {
	    document.onfocusin = document.onfocusout = onFocusChange;
	  } else {
	    window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onFocusChange;
	  }
	
	  setupScene();
	}

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	__webpack_require__(687);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapLegend = function (_Component) {
	  (0, _inherits3.default)(MapLegend, _Component);
	
	  function MapLegend() {
	    (0, _classCallCheck3.default)(this, MapLegend);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  MapLegend.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'maplegend-container md-grid mobile-fix' },
	      _react2.default.createElement(
	        _reactMd.Card,
	        { className: 'md-block-centered' },
	        _react2.default.createElement(
	          _reactMd.Grid,
	          { className: 'legend-grid' },
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'legend-icon-cell' },
	            _react2.default.createElement(
	              'svg',
	              { height: '40', width: '40' },
	              _react2.default.createElement('circle', { cx: '20', cy: '20', r: '10', fill: '#00FFD3', opacity: '0.75' }),
	              _react2.default.createElement('circle', { cx: '20', cy: '20', r: '15', fill: '#00FFD3', opacity: '0.25' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 9, className: 'legend-text-cell' },
	            _react2.default.createElement(
	              'div',
	              { className: 'legend-text' },
	              'Largest sources of compromised devices connecting to server-side APIs (represented by HQ)'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'legend-icon-cell' },
	            _react2.default.createElement(
	              'svg',
	              { height: '25', width: '40' },
	              _react2.default.createElement('circle', { cx: '20', cy: '12', r: '6', fill: '#FFBEBA', opacity: '1.0' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 9, className: 'legend-text-cell' },
	            _react2.default.createElement(
	              'div',
	              { className: 'legend-text' },
	              'Eavesdropping attacks (Intercepted SSL/TLS request)'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'legend-icon-cell' },
	            _react2.default.createElement(
	              'svg',
	              { height: '25', width: '40' },
	              _react2.default.createElement('rect', { height: '3', width: '32', x: '6', y: '11', fill: '#FF0000' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 9, className: 'legend-text-cell' },
	            _react2.default.createElement(
	              'div',
	              { className: 'legend-text' },
	              'Network connections between mobile apps and server side APIs'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return MapLegend;
	}(_react.Component);
	
	exports.default = MapLegend;
	module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(196);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _CategoryCard = __webpack_require__(412);
	
	var _CategoryCard2 = _interopRequireDefault(_CategoryCard);
	
	__webpack_require__(459);
	
	var _settings = __webpack_require__(758);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _unsecuredShield = __webpack_require__(479);
	
	var _unsecuredShield2 = _interopRequireDefault(_unsecuredShield);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AttackCategories = function (_Component) {
	  (0, _inherits3.default)(AttackCategories, _Component);
	
	  function AttackCategories() {
	    (0, _classCallCheck3.default)(this, AttackCategories);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  AttackCategories.prototype.getAllTimeCount = function getAllTimeCount(cat, monthly, allTimeCatCount) {
	    var count = 0;
	    monthly.forEach(function (mth) {
	      if (mth[cat] > 0) {
	        count += mth[cat];
	      }
	    });
	    return Math.max(count, allTimeCatCount);
	  };
	
	  AttackCategories.prototype.monthlyAvg = function monthlyAvg(monthly, cat) {
	    var numMonths = 0;
	    var count = 0;
	    monthly.forEach(function (mth) {
	      if (mth[cat] > 0) {
	        count += mth[cat];
	        numMonths += 1;
	      }
	    });
	    if (numMonths === 0) return 0;
	    return this.formatNum(count / numMonths);
	  };
	
	  AttackCategories.prototype.formatNum = function formatNum(n) {
	    return (0, _numeral2.default)(n).format('0,0');
	  };
	
	  AttackCategories.prototype.catPercentage = function catPercentage(catTotal, catCount) {
	    return (0, _numeral2.default)(catCount / catTotal).format('0.0%');
	  };
	
	  AttackCategories.prototype.render = function render() {
	    var allTime = this.props.bundleSummary.attack_cat_all_time;
	    var monthly = this.props.bundleSummary.attack_cat_monthly;
	
	    if (!allTime || !monthly) {
	      return null;
	    }
	
	    var allTimeCorrected = {};
	    var catTotal = 0;
	    for (var k in allTime) {
	      if (!allTime.hasOwnProperty(k)) continue;
	      var curCount = this.getAllTimeCount(k, monthly, allTime[k]);
	      allTimeCorrected[k] = curCount;
	      catTotal += curCount;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'categories-container md-grid mobile-fix misconfig-container' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'whos-spying' },
	        'Potential downtime due to misconfiguration'
	      ),
	      _react2.default.createElement(_CategoryCard2.default, {
	        id: 'misconfig',
	        title: 'App Misconfiguration',
	        titleAvatar: _settings2.default,
	        numTotalIncidents: this.formatNum(allTimeCorrected.misconfiguration),
	        numMonthlyAvg: this.monthlyAvg(monthly, 'misconfiguration'),
	        percentage: this.catPercentage(catTotal, allTimeCorrected.misconfiguration),
	        prose: 'due to app problems that cause users to be unable to establish secure connections to your servers',
	        dataLeakedA: 'All private communications',
	        iconA: _unsecuredShield2.default,
	        complianceA: 'SOC 2',
	        whyText: 'Various forms of misconfigurations on the client or server can cause SSL certificate validation errors to occur. If these occurrences are high, it is usually due to server misconfigurations that you should and can easily fix.',
	        riskText: 'SSL misconfigurations are more common than you might think, and leave a gaping hole for snooping attackers to exploit.',
	        riskScoreMalice: 1.0,
	        riskScoreExposure: 10.0,
	        riskScoreBreach: 9.0
	      })
	    );
	  };
	
	  return AttackCategories;
	}(_react.Component);
	
	exports.default = AttackCategories;
	module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _numeral = __webpack_require__(196);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _recharts = __webpack_require__(398);
	
	var _analytics = __webpack_require__(57);
	
	__webpack_require__(688);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PercentCard = function (_Component) {
	  (0, _inherits3.default)(PercentCard, _Component);
	
	  function PercentCard(props) {
	    (0, _classCallCheck3.default)(this, PercentCard);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));
	
	    _this.handleClickLearnMore = function () {
	      window.open('https://www.datatheorem.com/products/protection/', '_blank');
	      (0, _analytics.trackEvent)({
	        category: 'External',
	        action: 'App Protection'
	      });
	    };
	
	    var attacksBlocked = props.bundleSummary.attacks_blocked;
	    var reportsReceived = props.bundleSummary.reports_received;
	    // Clip min-value to 0 - error case protection
	    var attacksNotBlocked = Math.max(reportsReceived - attacksBlocked, 0);
	
	    var data = [{ name: 'Blocked', value: attacksBlocked }, { name: 'Unblocked', value: attacksNotBlocked }];
	
	    var colors = ['#385A9A', // blue
	    '#BD2031'];
	
	    _this.state = {
	      data: data,
	      colors: colors,
	      ratioBlocked: attacksBlocked / reportsReceived
	    };
	    return _this;
	  }
	
	  PercentCard.prototype.formatPercent = function formatPercent(ratio) {
	    return (0, _numeral2.default)(ratio).format('0.0%');
	  };
	
	  PercentCard.prototype.render = function render() {
	    var _this2 = this;
	
	    var isActiveMode = this.state.ratioBlocked >= 0.3;
	    var judgmentMessage = isActiveMode ? 'Congratulations! Eavesdropping attacks on private communication are blocked; however, 30+ additional items should be considered to fully protect your app.' : 'You have configured TrustKit to allow attackers to eavesdrop on private communications within your app.';
	    var baseFillColor = this.state.colors[isActiveMode ? 0 : 1];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'percent-container md-grid mobile-fix' },
	      _react2.default.createElement(
	        _reactMd.Card,
	        { className: 'md-block-centered' },
	        _react2.default.createElement(
	          _reactMd.Grid,
	          { className: 'percent-grid' },
	          isActiveMode && _react2.default.createElement(
	            _reactMd.Grid,
	            { className: 'percent-grid' },
	            _react2.default.createElement(
	              _reactMd.Cell,
	              { size: 2, className: 'percent-grid-cell' },
	              _react2.default.createElement(
	                'div',
	                { className: 'percent-grid-inside' },
	                _react2.default.createElement(
	                  _recharts.PieChart,
	                  { width: 70, height: 70 },
	                  _react2.default.createElement(
	                    _recharts.Pie,
	                    {
	                      data: this.state.data,
	                      dataKey: 'value',
	                      nameKey: 'name',
	                      cx: '50%',
	                      cy: '50%',
	                      outerRadius: 30,
	                      fill: baseFillColor,
	                      isAnimationActive: false
	                    },
	                    this.state.data.map(function (entry, index) {
	                      return _react2.default.createElement(_reactMd.Cell, {
	                        key: 'cell-' + index,
	                        fill: _this2.state.colors[index]
	                      });
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactMd.Cell,
	              { size: 3, className: 'percent-grid-cell' },
	              _react2.default.createElement(
	                'div',
	                { className: 'percent-focus percent-grid-inside' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'percent-num' },
	                  this.formatPercent(this.state.ratioBlocked)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactMd.Cell,
	              { size: 6, className: 'percent-grid-cell percent-prose-two' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'percent-subheading percent-grid-inside' },
	                'of eavesdropping attacks blocked by TrustKit'
	              )
	            ),
	            _react2.default.createElement(
	              _reactMd.Cell,
	              { size: 12 },
	              _react2.default.createElement('hr', { className: 'horizontal-rule' })
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12, className: 'percent-prose-cell' },
	            _react2.default.createElement(
	              'div',
	              { className: 'percent-prose-container' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'percent-prose' },
	                judgmentMessage
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12 },
	            _react2.default.createElement(
	              'div',
	              { className: 'button-container' },
	              _react2.default.createElement(
	                _reactMd.Button,
	                {
	                  raised: true,
	                  primary: true,
	                  className: 'learn-more-button',
	                  style: { background: 'grey' },
	                  onClick: this.handleClickLearnMore
	                },
	                'Learn more'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PercentCard;
	}(_react.Component);
	
	exports.default = PercentCard;
	module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	__webpack_require__(689);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScrollButtons = function (_Component) {
	  (0, _inherits3.default)(ScrollButtons, _Component);
	
	  function ScrollButtons() {
	    (0, _classCallCheck3.default)(this, ScrollButtons);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  ScrollButtons.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'scroll-container' },
	      _react2.default.createElement(
	        _reactMd.Button,
	        {
	          icon: true,
	          onClick: function onClick() {
	            document.getElementsByClassName('SplitPane  vertical disabled')[0].scrollTop -= 50;
	          }
	        },
	        'keyboard_arrow_up'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        _reactMd.Button,
	        {
	          icon: true,
	          onClick: function onClick() {
	            document.getElementsByClassName('SplitPane  vertical disabled')[0].scrollTop += 50;
	          }
	        },
	        'keyboard_arrow_down'
	      )
	    );
	  };
	
	  return ScrollButtons;
	}(_react.Component);
	
	exports.default = ScrollButtons;
	module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _numeral = __webpack_require__(196);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _analytics = __webpack_require__(57);
	
	__webpack_require__(690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StarsCard = function (_Component) {
	  (0, _inherits3.default)(StarsCard, _Component);
	
	  function StarsCard() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, StarsCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { visible: false }, _this.show = function () {
	      _this.setState({ visible: true });
	      (0, _analytics.trackEvent)({
	        category: 'Stars',
	        action: 'Show'
	      });
	    }, _this.hide = function () {
	      _this.setState({ visible: false });
	      (0, _analytics.trackEvent)({
	        category: 'Stars',
	        action: 'Hide'
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  StarsCard.prototype.render = function render() {
	    var _this2 = this;
	
	    var visible = this.state.visible;
	
	
	    var actions = [{
	      onClick: this.hide,
	      primary: true,
	      children: 'OK'
	    }];
	
	    var attacksBlocked = this.props.bundleSummary.attacks_blocked;
	    var reportsReceived = this.props.bundleSummary.reports_received;
	    var isAppProtectionCustomer = this.props.bundleSummary.is_app_protection_customer;
	
	    var StarsContent = _react2.default.createClass({
	      displayName: 'StarsContent',
	
	      formatCount: function formatCount(count) {
	        if (count < 1000) {
	          return count.toString();
	        } else if (count % 100 === 0) {
	          return (0, _numeral2.default)(count).format('0.0a');
	        }
	        return (0, _numeral2.default)((0, _numeral2.default)(count).format('0.0a')).format('0,0');
	      },
	
	      render: function render() {
	        var isActiveMode = attacksBlocked / reportsReceived > 0.3;
	        var numberOfStars = 0;
	
	        if (this.props.forceFiveStar) {
	          numberOfStars = 5;
	        } else {
	          if (isAppProtectionCustomer) {
	            numberOfStars += 1;
	          }
	
	          if (isActiveMode) {
	            numberOfStars += 3;
	          }
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactMd.Tooltipped,
	            {
	              label: 'Learn how we calculate your app safety rating',
	              setPosition: true
	            },
	            _react2.default.createElement(
	              _reactMd.Grid,
	              { className: 'stars-grid' },
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 5, className: 'stars-grid-cell' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'stars-focus stars-grid-inside' },
	                  _react2.default.createElement(
	                    'h2',
	                    {
	                      className: 'stars-num ' + (isActiveMode ? 'gold' : 'red') + '-stars'
	                    },
	                    Array(numberOfStars).fill().map(function (_, i) {
	                      return _react2.default.createElement(
	                        _reactMd.FontIcon,
	                        { key: i },
	                        'star'
	                      );
	                    }),
	                    Array(5 - numberOfStars).fill().map(function (_, i) {
	                      return _react2.default.createElement(
	                        _reactMd.FontIcon,
	                        { key: i },
	                        'star_border'
	                      );
	                    })
	                  ),
	                  'APP SAFETY RATING'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 7, className: 'stars-grid-cell' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'stars-prose stars-grid-inside' },
	                  isActiveMode ? 'Over ' + this.formatCount(reportsReceived) + ' eavesdropping attacks\n                  are being blocked by TrustKit' : this.formatCount(reportsReceived) + ' of user connections were\n                  eavesdropped on by an untrusted 3rd party'
	                )
	              )
	            )
	          )
	        );
	      }
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'stars-container md-grid mobile-fix' },
	        _react2.default.createElement(
	          _reactMd.Card,
	          {
	            className: 'md-block-centered',
	            onClick: function onClick() {
	              _this2.show();
	            }
	          },
	          _react2.default.createElement(StarsContent, {
	            attacksBlocked: attacksBlocked,
	            reportsReceived: reportsReceived,
	            forceFiveStar: this.props.forceFiveStar
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _reactMd.DialogContainer,
	        {
	          portal: true,
	          id: 'signup-alert-modal',
	          visible: visible,
	          title: 'App Safety Rating System',
	          onHide: this.hide,
	          'aria-describedby': 'signup-alert-description',
	          modal: true,
	          actions: actions
	        },
	        _react2.default.createElement(
	          _reactMd.Grid,
	          { className: 'star-legend-grid' },
	          _react2.default.createElement(_reactMd.Cell, { size: 3, className: 'star-legend-icon' }),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              'b',
	              null,
	              'TrustKit'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Critical Alerts'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              'b',
	              { style: { whiteSpace: 'nowrap' } },
	              'App Protection'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-icon' },
	            ' ',
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            'Active'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { style: { color: 'green' } },
	              'check'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { style: { color: 'green' } },
	              'check'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-icon' },
	            ' ',
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            'Active'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            '-'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { style: { color: 'green' } },
	              'check'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-icon' },
	            ' ',
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_half'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            'Active'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { style: { color: 'green' } },
	              'check'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            '-'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-icon' },
	            ' ',
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            'Active'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            '-'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            '-'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-icon' },
	            ' ',
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_half'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            'Passive'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { style: { color: 'green' } },
	              'check'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { style: { color: 'green' } },
	              'check'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-icon' },
	            ' ',
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            'Passive'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            '-'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { style: { color: 'green' } },
	              'check'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-icon' },
	            ' ',
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_half'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            'Passive'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { style: { color: 'green' } },
	              'check'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            '-'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-icon' },
	            ' ',
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            ),
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'small-star' },
	              'star_border'
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            'Passive'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            '-'
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 3, className: 'star-legend-prose' },
	            '-'
	          )
	        )
	      )
	    );
	  };
	
	  return StarsCard;
	}(_react.Component);
	
	exports.default = StarsCard;
	module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _analytics = __webpack_require__(57);
	
	__webpack_require__(691);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Summary = function (_Component) {
	  (0, _inherits3.default)(Summary, _Component);
	
	  function Summary() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Summary);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleClick = function () {
	      var app_url = _this.props.bundleSummary.app_url;
	
	      if (!app_url) {
	        window.open('https://www.datatheorem.com/about/contact/', '_blank');
	      }
	
	      window.open(app_url, '_blank');
	      (0, _analytics.trackEvent)({
	        category: 'External',
	        action: 'Bundle Clicked'
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  Summary.prototype.render = function render() {
	    var _props$bundleSummary = this.props.bundleSummary,
	        platform = _props$bundleSummary.platform,
	        company = _props$bundleSummary.company,
	        name = _props$bundleSummary.app_name,
	        bundle = _props$bundleSummary.bundle_id;
	
	
	    var platformLabel = platform === 1 ? 'iOS' : 'Android';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'summary-wrapper' },
	      _react2.default.createElement(
	        _reactMd.Grid,
	        null,
	        _react2.default.createElement(
	          _reactMd.Cell,
	          { size: 8, className: 'summary-cell' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'company-name' },
	            company
	          )
	        ),
	        _react2.default.createElement(
	          _reactMd.Cell,
	          { size: 4, className: 'bundle-cell' },
	          _react2.default.createElement(
	            'h4',
	            {
	              className: 'app-name',
	              onClick: this.handleClick,
	              onKeyPress: this.handleClick
	            },
	            _react2.default.createElement(
	              _reactMd.FontIcon,
	              { className: 'icon-proper' },
	              'link'
	            ),
	            '\xA0',
	            name
	          ),
	          _react2.default.createElement(
	            'h4',
	            { className: 'bundle-summary' },
	            platformLabel,
	            ' app: ',
	            bundle
	          )
	        )
	      )
	    );
	  };
	
	  return Summary;
	}(_react.Component);
	
	exports.default = Summary;
	module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	__webpack_require__(692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleAnimation = function (_Component) {
	  (0, _inherits3.default)(ToggleAnimation, _Component);
	
	  function ToggleAnimation() {
	    (0, _classCallCheck3.default)(this, ToggleAnimation);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  ToggleAnimation.prototype.render = function render() {
	    var self = this;
	    return _react2.default.createElement(
	      'div',
	      { className: 'togani-container md-grid mobile-fix' },
	      _react2.default.createElement(
	        _reactMd.Card,
	        { className: 'md-block-centered' },
	        _react2.default.createElement(
	          _reactMd.CardActions,
	          null,
	          _react2.default.createElement(_reactMd.Switch, {
	            id: 'animation-switch',
	            key: 'animation-switch',
	            label: 'Globe rotation',
	            name: 'animation-switch',
	            defaultChecked: true,
	            onChange: function onChange(checked) {
	              self.props.handleToggleAnimation(checked);
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return ToggleAnimation;
	}(_react.Component);
	
	exports.default = ToggleAnimation;
	module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _analytics = __webpack_require__(57);
	
	var _siteConfig = __webpack_require__(121);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	__webpack_require__(693);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCard = function (_Component) {
	  (0, _inherits3.default)(ToggleCard, _Component);
	
	  function ToggleCard(props) {
	    (0, _classCallCheck3.default)(this, ToggleCard);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));
	
	    var tog = {};
	    var allTime = _this.props.bundleSummary.attack_cat_all_time;
	    for (var k in allTime) {
	      if (!allTime.hasOwnProperty(k)) continue;
	      if (k === 'misconfiguration') {
	        tog[k] = false;
	      } else {
	        tog[k] = true;
	      }
	    }
	    _this.state = {
	      toggleState: tog
	    };
	    return _this;
	  }
	
	  ToggleCard.prototype.render = function render() {
	    var toggleState = this.state.toggleState;
	
	    var execSection = [];
	    var catMapping = _siteConfig2.default.attacks.catMapping;
	    var funArr = {};
	
	    var self = this; // For scoping within callback fn
	
	    _siteConfig2.default.attacks.ordering.forEach(function (k) {
	      var defaultChecked;
	
	      funArr[k] = function (checked) {
	        toggleState[k] = checked;
	        self.setState({ toggleState: toggleState });
	        // Pushing state change to parent component
	        self.props.toggleCallback(toggleState);
	        (0, _analytics.trackEvent)({
	          category: 'Category Toggle',
	          action: checked ? 'Toggled On' : 'Toggled Off',
	          label: catMapping[k]
	        });
	      };
	
	      if (k === 'misconfiguration') {
	        defaultChecked = false;
	      } else {
	        defaultChecked = true;
	      }
	      execSection.push(_react2.default.createElement(_reactMd.Switch, {
	        id: 'switch-' + k,
	        key: 'switch-' + k,
	        label: catMapping[k],
	        name: 'switch' + k,
	        defaultChecked: defaultChecked,
	        onChange: funArr[k],
	        ref: 'switch-' + k
	      }));
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'toggle-container md-grid mobile-fix' },
	      _react2.default.createElement(
	        _reactMd.Card,
	        { className: 'md-block-centered' },
	        _react2.default.createElement(
	          _reactMd.CardActions,
	          null,
	          execSection
	        )
	      )
	    );
	  };
	
	  return ToggleCard;
	}(_react.Component);
	
	exports.default = ToggleCard;
	module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _analytics = __webpack_require__(57);
	
	__webpack_require__(458);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrendReportModal = function (_PureComponent) {
	  (0, _inherits3.default)(TrendReportModal, _PureComponent);
	
	  function TrendReportModal() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TrendReportModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { visible: false, toasts: [] }, _this.addToast = function (text, action) {
	      var autohide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      _this.setState(function (state) {
	        var toasts = state.toasts.slice();
	        toasts.push({ text: text, action: action });
	        return { toasts: toasts, autohide: autohide };
	      });
	    }, _this.toastConfirmation = function () {
	      _this.addToast('Thank you for signing up. We will be in touch shortly.');
	      _this.setState({ visible: false });
	      window.open('//bit.ly/2EdPSf2', '_blank', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,width=700,height=480', '');
	      (0, _analytics.trackEvent)({
	        category: 'Alert Signup',
	        action: 'Signup',
	        label: _this.props.title
	      });
	    }, _this.dismissToast = function () {
	      var _this$state$toasts = _this.state.toasts,
	          toasts = _this$state$toasts.slice(1);
	
	      _this.setState({ toasts: toasts });
	    }, _this.show = function () {
	      _this.setState({ visible: true });
	      (0, _analytics.trackEvent)({
	        category: 'Alert Signup',
	        action: 'Click',
	        label: _this.props.title
	      });
	    }, _this.hide = function () {
	      _this.setState({ visible: false });
	      window.open('//bit.ly/2uFJDRF', '_blank', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,width=700,height=480', '');
	      (0, _analytics.trackEvent)({
	        category: 'Alert Signup',
	        action: 'No Thanks',
	        label: _this.props.title
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  TrendReportModal.prototype.render = function render() {
	    var _state = this.state,
	        visible = _state.visible,
	        toasts = _state.toasts;
	
	
	    var actions = [{
	      onClick: this.toastConfirmation,
	      primary: true,
	      children: 'Sign up'
	    }, {
	      onClick: this.hide,
	      primary: true,
	      children: 'No thanks'
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactMd.Button,
	        { onClick: this.show, icon: true, style: { color: '#385A9A' } },
	        'add_alert'
	      ),
	      _react2.default.createElement(
	        _reactMd.DialogContainer,
	        {
	          portal: true,
	          id: 'signup-alert-modal',
	          visible: visible,
	          title: 'Enable Critical Alerts',
	          onHide: this.hide,
	          'aria-describedby': 'signup-alert-description',
	          modal: true,
	          actions: actions
	        },
	        _react2.default.createElement(
	          _reactMd.Grid,
	          { className: 'dialog-outer' },
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 6, style: { backgroundColor: '#EFF4FC' } },
	            _react2.default.createElement(
	              'p',
	              { className: 'alerts-tier-title', style: { fontWeight: 700 } },
	              '\xA0\xA0Critical Alerts'
	            ),
	            _react2.default.createElement(
	              _reactMd.Grid,
	              { className: 'dialog-inner' },
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'timelapse'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Prevent irreversible downtime due to SSL pinning mistakes'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'bug_report'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Detect malicious domains forging your SSL certificates'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'healing'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Avoid embarrassment due to expired SSL certificates'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 6 },
	            _react2.default.createElement(
	              'p',
	              { className: 'alerts-tier-title' },
	              '\xA0\xA0Scheduled Reports'
	            ),
	            _react2.default.createElement(
	              _reactMd.Grid,
	              { className: 'dialog-inner' },
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'trending_up'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Discover trends in eavesdropping attempts across your user base'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'description'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Details of eavesdropping attempts on encrypted user sessions'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 1, className: 'icon-wrapper' },
	                _react2.default.createElement(
	                  _reactMd.FontIcon,
	                  { className: 'icon-proper' },
	                  'https'
	                )
	              ),
	              _react2.default.createElement(
	                _reactMd.Cell,
	                { size: 11 },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'alert-item-text' },
	                  'Set policies to detect violations of user privacy and compliance'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_reactMd.Snackbar, {
	        id: 'alertsignup-snackbar',
	        toasts: toasts,
	        autohide: true,
	        onDismiss: this.dismissToast
	      })
	    );
	  };
	
	  return TrendReportModal;
	}(_react.PureComponent);
	
	exports.default = TrendReportModal;
	module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      { style: { textAlign: 'center' } },
	      '404: Page not found'
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _bundleSummary = __webpack_require__(524);
	
	var _bundleSummary2 = _interopRequireDefault(_bundleSummary);
	
	var _Summary = __webpack_require__(520);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _AttackCategories = __webpack_require__(510);
	
	var _AttackCategories2 = _interopRequireDefault(_AttackCategories);
	
	var _MisconfigCategories = __webpack_require__(516);
	
	var _MisconfigCategories2 = _interopRequireDefault(_MisconfigCategories);
	
	var _PercentCard = __webpack_require__(517);
	
	var _PercentCard2 = _interopRequireDefault(_PercentCard);
	
	var _StarsCard = __webpack_require__(519);
	
	var _StarsCard2 = _interopRequireDefault(_StarsCard);
	
	var _ChartCard = __webpack_require__(512);
	
	var _ChartCard2 = _interopRequireDefault(_ChartCard);
	
	var _ToggleCard = __webpack_require__(522);
	
	var _ToggleCard2 = _interopRequireDefault(_ToggleCard);
	
	var _ToggleAnimation = __webpack_require__(521);
	
	var _ToggleAnimation2 = _interopRequireDefault(_ToggleAnimation);
	
	var _AlertSignupCard = __webpack_require__(509);
	
	var _AlertSignupCard2 = _interopRequireDefault(_AlertSignupCard);
	
	var _MapLegend = __webpack_require__(515);
	
	var _MapLegend2 = _interopRequireDefault(_MapLegend);
	
	var _ScrollButtons = __webpack_require__(518);
	
	var _ScrollButtons2 = _interopRequireDefault(_ScrollButtons);
	
	var _analytics = __webpack_require__(57);
	
	var _mapAnimation = __webpack_require__(514);
	
	__webpack_require__(686);
	
	var _siteConfig = __webpack_require__(121);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* import Management from '../components/Management/Management'; */
	var Index = function (_React$Component) {
	  (0, _inherits3.default)(Index, _React$Component);
	
	  function Index() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Index);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      toggleState: null,
	      globeEnabled: true
	    }, _this.disableGlobe = function () {
	      return _this.setState({ globeEnabled: false });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  Index.prototype.componentDidMount = function componentDidMount() {
	    var _props$data$bundleSum = this.props.data.bundleSummary,
	        geo = _props$data$bundleSum.geo,
	        cities = _props$data$bundleSum.cities;
	    var globeEnabled = this.state.globeEnabled;
	
	
	    if (globeEnabled) {
	      try {
	        (0, _mapAnimation.installGlobe)(geo, cities);
	      } catch (ex) {
	        this.disableGlobe();
	      }
	    }
	  };
	
	  Index.prototype.handleToggleChange = function handleToggleChange(toggleState) {
	    this.setState({ toggleState: toggleState });
	    (0, _mapAnimation.updateDots)(toggleState);
	  };
	
	  Index.prototype.handleToggleAnimation = function handleToggleAnimation(animationOn) {
	    (0, _mapAnimation.updateAnimationToggle)(animationOn);
	    (0, _analytics.trackEvent)({
	      category: 'Globe',
	      action: 'Animation ' + (animationOn ? 'Enabled' : 'Disabled')
	    });
	  };
	
	  Index.prototype.render = function render() {
	    var _state = this.state,
	        toggleState = _state.toggleState,
	        globeEnabled = _state.globeEnabled;
	
	    var bundleSummary = this.props.data.bundleSummary;
	    var hasBundleSummary = bundleSummary && bundleSummary.length > 0;
	    return _react2.default.createElement(
	      'div',
	      { className: 'splitPane' },
	      _react2.default.createElement(
	        'div',
	        { className: 'left-panel', id: 'left-panel' },
	        _react2.default.createElement(
	          'title',
	          null,
	          _siteConfig2.default.siteTitle + ' - ' + bundleSummary.company
	        ),
	        _react2.default.createElement(
	          _reactMd.Grid,
	          { className: 'main-grid', id: 'main-grid' },
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12, className: 'summary-cell' },
	            _react2.default.createElement(_Summary2.default, { bundleSummary: bundleSummary })
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12 },
	            _react2.default.createElement(_StarsCard2.default, {
	              bundleSummary: bundleSummary,
	              forceFiveStar: this.props.forceFiveStar
	            })
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12 },
	            _react2.default.createElement(_AlertSignupCard2.default, null)
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12 },
	            _react2.default.createElement(_PercentCard2.default, { bundleSummary: bundleSummary })
	          ),
	          hasBundleSummary && _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12 },
	            _react2.default.createElement(_ChartCard2.default, {
	              bundleSummary: bundleSummary,
	              toggleState: toggleState
	            })
	          ),
	          hasBundleSummary && _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12 },
	            _react2.default.createElement(_ToggleCard2.default, {
	              bundleSummary: bundleSummary,
	              toggleCallback: this.handleToggleChange.bind(this)
	            })
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12 },
	            _react2.default.createElement(_AttackCategories2.default, { bundleSummary: bundleSummary })
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12 },
	            _react2.default.createElement(_MisconfigCategories2.default, { bundleSummary: bundleSummary })
	          )
	        ),
	        _react2.default.createElement(_ScrollButtons2.default, null)
	      ),
	      globeEnabled && _react2.default.createElement(
	        'div',
	        { className: 'right-panel globe js-globe' },
	        _react2.default.createElement('ul', { className: 'globe-list js-list' }),
	        _react2.default.createElement('canvas', { className: 'globe-canvas js-canvas' }),
	        _react2.default.createElement(_MapLegend2.default, null),
	        _react2.default.createElement(_ToggleAnimation2.default, {
	          handleToggleAnimation: this.handleToggleAnimation.bind(this)
	        })
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.2.2. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(423)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(425)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 559 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),
/* 565 */,
/* 566 */,
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(85),
	    root = __webpack_require__(59);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(622),
	    hashDelete = __webpack_require__(623),
	    hashGet = __webpack_require__(624),
	    hashHas = __webpack_require__(625),
	    hashSet = __webpack_require__(626);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(85),
	    root = __webpack_require__(59);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(85),
	    root = __webpack_require__(59);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(59);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(85),
	    root = __webpack_require__(59);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 573 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(584);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(602),
	    isArguments = __webpack_require__(222),
	    isArray = __webpack_require__(24),
	    isBuffer = __webpack_require__(450),
	    isIndex = __webpack_require__(218),
	    isTypedArray = __webpack_require__(452);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(433);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 579 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(609);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(580),
	    keys = __webpack_require__(226);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(432),
	    isArray = __webpack_require__(24);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 583 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(579),
	    baseIsNaN = __webpack_require__(589),
	    strictIndexOf = __webpack_require__(657);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(429),
	    arrayIncludes = __webpack_require__(574),
	    arrayIncludesWith = __webpack_require__(575),
	    arrayMap = __webpack_require__(124),
	    baseUnary = __webpack_require__(217),
	    cacheHas = __webpack_require__(440);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(80),
	    isObjectLike = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(430),
	    equalArrays = __webpack_require__(442),
	    equalByTag = __webpack_require__(612),
	    equalObjects = __webpack_require__(613),
	    getTag = __webpack_require__(619),
	    isArray = __webpack_require__(24),
	    isBuffer = __webpack_require__(450),
	    isTypedArray = __webpack_require__(452);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(430),
	    baseIsEqual = __webpack_require__(216);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 589 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(16),
	    isMasked = __webpack_require__(629),
	    isObject = __webpack_require__(61),
	    toSource = __webpack_require__(448);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(80),
	    isLength = __webpack_require__(223),
	    isObjectLike = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(630),
	    nativeKeys = __webpack_require__(643);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(588),
	    getMatchData = __webpack_require__(615),
	    matchesStrictComparable = __webpack_require__(446);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(216),
	    get = __webpack_require__(221),
	    hasIn = __webpack_require__(662),
	    isKey = __webpack_require__(219),
	    isStrictComparable = __webpack_require__(445),
	    matchesStrictComparable = __webpack_require__(446),
	    toKey = __webpack_require__(194);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(124),
	    baseIteratee = __webpack_require__(112),
	    baseMap = __webpack_require__(438),
	    baseSortBy = __webpack_require__(600),
	    baseUnary = __webpack_require__(217),
	    compareMultiple = __webpack_require__(606),
	    identity = __webpack_require__(113);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 596 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(435);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 598 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(659),
	    defineProperty = __webpack_require__(611),
	    identity = __webpack_require__(113);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 600 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ }),
/* 602 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(123),
	    arrayMap = __webpack_require__(124),
	    isArray = __webpack_require__(24),
	    isSymbol = __webpack_require__(114);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(664);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(114);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(605);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(59);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(125);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 609 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(598),
	    isIterateeCall = __webpack_require__(444),
	    toFinite = __webpack_require__(676);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(85);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(123),
	    Uint8Array = __webpack_require__(571),
	    eq = __webpack_require__(220),
	    equalArrays = __webpack_require__(442),
	    mapToArray = __webpack_require__(641),
	    setToArray = __webpack_require__(649);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(614);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(582),
	    getSymbols = __webpack_require__(618),
	    keys = __webpack_require__(226);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(445),
	    keys = __webpack_require__(226);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(447);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(123);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(431),
	    stubArray = __webpack_require__(672);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(567),
	    Map = __webpack_require__(214),
	    Promise = __webpack_require__(569),
	    Set = __webpack_require__(570),
	    WeakMap = __webpack_require__(572),
	    baseGetTag = __webpack_require__(80),
	    toSource = __webpack_require__(448);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 620 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(441),
	    isArguments = __webpack_require__(222),
	    isArray = __webpack_require__(24),
	    isIndex = __webpack_require__(218),
	    isLength = __webpack_require__(223),
	    toKey = __webpack_require__(194);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(193);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 623 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(193);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(193);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(193);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(123),
	    isArguments = __webpack_require__(222),
	    isArray = __webpack_require__(24);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 628 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(607);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 630 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 631 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(190);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(190);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(190);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(190);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(568),
	    ListCache = __webpack_require__(189),
	    Map = __webpack_require__(214);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(192);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(192);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(192);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(192);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(668);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(447);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(443);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(480)(module)))

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(573);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 647 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 648 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 649 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(599),
	    shortOut = __webpack_require__(651);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 651 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(189);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 654 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 655 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(189),
	    Map = __webpack_require__(214),
	    MapCache = __webpack_require__(215);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 657 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(642);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 659 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(431),
	    baseFilter = __webpack_require__(578),
	    baseIteratee = __webpack_require__(112),
	    isArray = __webpack_require__(24);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(434),
	    map = __webpack_require__(666);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(583),
	    hasPath = __webpack_require__(621);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(124),
	    baseIntersection = __webpack_require__(585),
	    baseRest = __webpack_require__(439),
	    castArrayLikeObject = __webpack_require__(604);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(125),
	    isObjectLike = __webpack_require__(64);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 665 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(124),
	    baseIteratee = __webpack_require__(112),
	    baseMap = __webpack_require__(438),
	    isArray = __webpack_require__(24);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(191),
	    baseGt = __webpack_require__(436),
	    identity = __webpack_require__(113);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseGt)
	    : undefined;
	}
	
	module.exports = max;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(215);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(191),
	    baseIteratee = __webpack_require__(112),
	    baseLt = __webpack_require__(437);
	
	/**
	 * This method is like `_.min` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.minBy(objects, function(o) { return o.n; });
	 * // => { 'n': 1 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.minBy(objects, 'n');
	 * // => { 'n': 1 }
	 */
	function minBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
	    : undefined;
	}
	
	module.exports = minBy;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(59);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(596),
	    basePropertyDeep = __webpack_require__(597),
	    isKey = __webpack_require__(219),
	    toKey = __webpack_require__(194);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 672 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 673 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(112),
	    baseSum = __webpack_require__(601);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(449),
	    isObject = __webpack_require__(61);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(457);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(603);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(682);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(680);
		function inc(arr,val){
			for(var i=0;i<arr.length;i++)
				arr[i]+=val;
			return arr;
		}
		var token=['sin','cos','tan','pi','(',')','P','C',
			  'asin','acos','atan','7','8','9','int',
			  'cosh','acosh','ln','^','root','4','5','6','/','!',
			  'tanh','atanh','Mod','1','2','3','*',
			  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
		var show=['sin','cos','tan','&pi;','(',')','P','C',
			'asin','acos','atan','7','8','9','Int',
			'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
			'tanh','atanh',' Mod ','1','2','3','&times;',
			'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
		var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
			Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
			Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
			Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
			Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
		var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
		var type=[0,0,0,3,4,5,10,10,
			0,0,0,1,1,1,0,
			0,0,0,10,0,1,1,1,2,7,
			0,0,2,1,1,1,2,
			0,0,3,0,1,6,9,9,11,12,13,12,8];
		 /*
		0 : function with syntax function_name(Maths_exp)
		1 : numbers
		2 : binary operators like * / Mod left associate and same precedence
		3 : Math constant values like e,pi,Cruncher ans
		4 : opening bracket
		5 : closing bracket
		6 : decimal
		7 : function with syntax (Math_exp)function_name
		8: function with syntax function_name(Math_exp1,Math_exp2)
		9 : binary operator like +,-
		10: binary operator like P C or ^
		11: ,
		12: function with , seperated three parameters
		13: variable of Sigma function
		 */
		var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
		type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
		type_1={0:true,3:true,4:true,8:true,12:true,13:true},
		empty={},
		type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
		type6={1:true},
		newAr=[[],
				["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
				["pi","ln","Pi"],
				["sin","cos","tan","Del","int","Mod","log","pow"],
				["asin","acos","atan","cosh","root","tanh","sinh"],
				["acosh","atanh","asinh","Sigma"]];
		function match(str1,str2,i,x){
			for(var f=0;f<x;f++){
				if (str1[i+f]!==str2[f])
					return false;
			}
			return true;
		}
		Mexp.addToken=function(tokens){
			for(i=0;i<tokens.length;i++){
				x=tokens[i].token.length;
				var temp=-1;
	
				//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on
	
				if (x<newAr.length)	//match to check if token is really huge and not existing
									//if not checked it will break in next line as undefined index
					for(y=0;y<newAr[x].length;y++){
						if (tokens[i].token===newAr[x][y]){
							temp=token.indexOf(newAr[x][y]);
							break;
						}
					}
				if (temp===-1) {
					token.push(tokens[i].token);
					type.push(tokens[i].type);
					if(newAr.length<=tokens[i].token.length)
						newAr[tokens[i].token.length]=[];
					newAr[tokens[i].token.length].push(tokens[i].token);
					eva.push(tokens[i].value);
					show.push(tokens[i].show);
				}
				else {
					token[temp]=tokens[i].token;
					type[temp]=tokens[i].type;
					eva[temp]=tokens[i].value;
					show[temp]=tokens[i].show;
				}
			}
		};
		Mexp.lex=function(inp,tokens){
			'use strict';
			var str=[{type:4,value:"(",show:"(",pre:0}];
			var ptc=[];	//Parenthesis to close at the beginning is after one token
			var inpStr=inp;
			var key;
	        var pcounter=0;
			var allowed=type0;
			var bracToClose=0;
			var asterick=empty;
			var prevKey='';
			var i,x,y;
			if(typeof tokens!=="undefined")
				Mexp.addToken(tokens);
			var obj={};
			for(i=0;i<inpStr.length;i++){
				if (inpStr[i]==' ') {
					continue;
				}
				key='';
				sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
					for(y=0;y<newAr[x].length;y++){
						if (match(inpStr,newAr[x][y],i,x)){
							key=newAr[x][y];
							break sec;
						}
					}
				}
				i+=key.length-1;
				if(key===''){
					throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
				}
				var index=token.indexOf(key);
				var cToken=key;
				var cType=type[index];
				var cEv=eva[index];
				var cPre=preced[cType];
				var	cShow=show[index];
				var pre=str[str.length-1];
				for(j=ptc.length;j--;){	//loop over ptc
					if(ptc[j]===0){
						if([0,2,3,5,9,11,12,13].indexOf(cType)!==-1){
							if(allowed[cType]!==true){
								throw(new Mexp.exception(key+" is not allowed after "+prevKey));
							}
							str.push({value:")",type:5,pre:0,show:")"});
							allowed=type1;
							asterick=type_3;
							inc(ptc,-1).pop();
						}
					}
				}
				if(allowed[cType]!==true){
					throw(new Mexp.exception(key+" is not allowed after "+prevKey));
				}
				if(asterick[cType]===true){
					cType=2;
					cEv=Mexp.math.mul;
					cShow="&times;";
					cPre=3;
					i=i-key.length;
			 	}
				obj={value:cEv,type:cType,pre:cPre,show:cShow};
				if(cType===0){
					allowed=type0;
					asterick=empty;
					inc(ptc,2).push(2);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===1){
					if(pre.type===1){
						pre.value+=cEv;
						inc(ptc,1);
					}
					else {
						str.push(obj);
					}
					allowed=type1;
					asterick=type_1;
				}
				else if(cType===2){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===3){//constant
					str.push(obj);
					allowed=type1;
					asterick=type_3;
				}
				else if(cType===4){
	                pcounter+=ptc.length;
	                ptc=[];
					bracToClose++;
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===5){
					if(!bracToClose){
						throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
					}
	                while(pcounter--){	//loop over ptc
	    						str.push({value:")",type:5,pre:0,show:")"});
	    			}
	                pcounter=0;
					bracToClose--;
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				else if(cType===6){
					if(pre.hasDec){
						throw(new Mexp.exception("Two decimals are not allowed in one number"));
					}
					if(pre.type!==1){
						pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
						str.push(pre);
						inc(ptc,-1);
					}
					allowed=type6;
					inc(ptc,1);
					asterick=empty;
					pre.value+=cEv;
					pre.hasDec=true;
				}
				else if(cType===7){
					allowed=type1;
					asterick=type_3;
					inc(ptc,1);
					str.push(obj);
				}
				if(cType===8){
					allowed=type0;
					asterick=empty;
					inc(ptc,4).push(4);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===9){
					if(pre.type===9){
						if(pre.value===Mexp.math.add){
							pre.value=cEv;
							pre.show=cShow;
							inc(ptc,1);
						}
						else if(pre.value===Mexp.math.sub&&cShow==='-'){
							pre.value=Mexp.math.add;
							pre.show='+';
							inc(ptc,1);
						}
					}
					else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found
						if(cToken==='-'){//do nothing for + token
										//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
							allowed=type0;
							asterick=empty;
							inc(ptc,2).push(2);
							str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
							str.push({value:"(",type:4,pre:0,show:"("});
						}
					}
					else{
						str.push(obj);
						inc(ptc,2);
					}
					allowed=type0;
					asterick=empty;
				}
				else if(cType===10){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===11){
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===12){
					allowed=type0;
					asterick=empty;
					inc(ptc,6).push(6);
					str.push(obj);
					str.push({value:"(",type:4,pre:0});
				}
				else if(cType===13){
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				inc(ptc,-1);
				prevKey=key;
			}
			for(var j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
	
					str.push({value:")",show:")",type:5,pre:3});
					inc(ptc,-1).pop();
				}
			}
			if (allowed[5]!==true) {
				throw(new Mexp.exception("complete the expression"));
			}
			while(bracToClose--)
				str.push({value:")",show:")",type:5,pre:3});
	
			str.push({type:5,value:")",show:")",pre:0});
	//        console.log(str);
			return new Mexp(str);
		};
	    module.exports=Mexp;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

		var Mexp=function(parsed){
			this.value=parsed;
	
		};
	
		Mexp.math={
			isDegree:true, //mode of calculator
			acos:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
			},
			add:function(a,b){
				return a+b;
			},
			asin:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
			},
			atan:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
			},
			acosh:function(x){
				return Math.log(x+Math.sqrt(x*x-1));
			},
			asinh:function(x){
				return Math.log(x+Math.sqrt(x*x+1));
			},
			atanh:function(x){
				return Math.log((1+x)/(1-x));
			},
			C:function(n,r){
				var pro=1,other=n-r,choice=r;
				if(choice<other){
				choice=other;
				other=r;
				}
				for(var i=choice+1;i<=n;i++)
					pro*=i;
				return pro/Mexp.math.fact(other);
			},
			changeSign:function(x){
				return -x;
			},
			cos:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.cos(x);
			},
			cosh:function(x){
				return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
			},
			div:function(a,b){
			return a/b;
			},
			fact:function(n) {
			if(n%1!==0)return "NAN";
				var pro=1;
				for(var i=2;i<=n;i++)
					pro*=i;
				return pro;
			},
			inverse:function(x){
				return 1/x;
			},
			log:function(i){
				return Math.log(i)/Math.log(10);
			},
			mod:function(a,b){
			return a%b;
			},
			mul:function(a,b){
			return a*b;
			},
			P:function(n,r){var pro=1;
				 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
						pro*=i;
						return pro;
	
			},
			Pi:function(low,high,ex){
				var pro=1;
				for(var i=low;i<=high;i++){
					pro*=Number(ex.postfixEval({n:i}));
				}
				return pro;
			},
			pow10x:function(e){
				var x=1;
				while(e--){x*=10;}
				return x;
			},
			sigma:function(low,high,ex){
				var sum=0;
				for(var i=low;i<=high;i++){
					sum+=Number(ex.postfixEval({n:i}));
				}
				return sum;
			},
			sin:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.sin(x);
			},
			sinh:function(x){
				return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
			},
			sub:function(a,b){
			return a-b;
			},
			tan:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.tan(x);
			},
			tanh:function(x){
				return Mexp.sinha(x)/Mexp.cosha(x);
			},
			toRadian:function(x){
				return x*Math.PI/180;
			}
		};
		Mexp.exception=function(message){
			this.message=message;
		};
	    module.exports=Mexp;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	
	    var Mexp=__webpack_require__(679);
	
		Mexp.prototype.toPostfix = function () {
			'use strict';
			var post=[],elem,popped,prep,pre,ele;
	    	var stack=[{value:"(",type:4,pre:0}];
			var arr=this.value;
			for (var i=1; i < arr.length; i++) {
				if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
					if(arr[i].type===1)
						arr[i].value=Number(arr[i].value);
					post.push(arr[i]);
				}
				else if(arr[i].type===4){
					stack.push(arr[i]);
				}
				else if(arr[i].type===5){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
				}
				else if(arr[i].type===11){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
					stack.push(popped);
				}
				else {
					elem=arr[i];
					pre=elem.pre;
					ele=stack[stack.length-1];
					prep=ele.pre;
					var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
					if(pre>prep)stack.push(elem);
					else {
						while(prep>=pre&&!flag||flag&&pre<prep){
							popped=stack.pop();
							ele=stack[stack.length-1];
							post.push(popped);
							prep=ele.pre;
							flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
						}
						stack.push(elem);
					}
				}
			}
			return new Mexp(post);
		};
	    module.exports=Mexp;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(681);
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict';
		UserDefined=UserDefined||{};
		UserDefined.PI=Math.PI;
		UserDefined.E=Math.E;
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		var bool=(typeof UserDefined.n!=="undefined");
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1){
				stack.push({value:arr[i].value,type:1});
			}
			else if(arr[i].type===3){
				stack.push({value:UserDefined[arr[i].value],type:1});
			}
			else if(arr[i].type===0){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===7){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===8){
				pop1=stack.pop();
				pop2=stack.pop();
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
			else if(arr[i].type===10){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
					pop2.value=pop2.concat(pop1);
					pop2.value.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
	            }
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
	                console.log(pop2);
					pop2=pop2.concat(pop1);
					pop2.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
				}
			}
			else if(arr[i].type===12){
				pop1=stack.pop();
				if (typeof pop1.type!=="undefined") {
					pop1=[pop1];
				}
				pop2=stack.pop();
				pop3=stack.pop();
				stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
			}
			else if(arr[i].type===13){
				if(bool){
					stack.push({value:UserDefined[arr[i].value],type:3});
				}
				else stack.push([arr[i]]);
			}
		}
		if (stack.length>1) {
			throw(new Mexp.exception("Uncaught Syntax error"));
		}
		return stack[0].value>1000000000000000?"Infinity":parseFloat(stack[0].value.toFixed(15));
	};
	Mexp.eval=function(str,tokens,obj){
		if (typeof tokens==="undefined") {
			return this.lex(str).toPostfix().postfixEval();
		}
		else if (typeof obj==="undefined") {
			if (typeof tokens.length!=="undefined") 
				return this.lex(str,tokens).toPostfix().postfixEval();
			else
				return this.lex(str).toPostfix().postfixEval(tokens);
		}
		else
			return this.lex(str,tokens).toPostfix().postfixEval(obj);
	};
	module.exports=Mexp;

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 686 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeDetectorStyles = __webpack_require__(713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResizeDetector = function (_Component) {
	  _inherits(ResizeDetector, _Component);
	
	  function ResizeDetector() {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this));
	
	    _this.state = {
	      expandChildHeight: 0,
	      expandChildWidth: 0,
	      expandScrollLeft: 0,
	      expandScrollTop: 0,
	      shrinkScrollTop: 0,
	      shrinkScrollLeft: 0,
	      lastWidth: 0,
	      lastHeight: 0
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _containerSize = this.containerSize(),
	          _containerSize2 = _slicedToArray(_containerSize, 2),
	          width = _containerSize2[0],
	          height = _containerSize2[1];
	
	      this.reset(width, height);
	      this.props.onResize(width, height);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props !== nextProps || this.state !== nextState;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.expand.scrollLeft = this.expand.scrollWidth;
	      this.expand.scrollTop = this.expand.scrollHeight;
	
	      this.shrink.scrollLeft = this.shrink.scrollWidth;
	      this.shrink.scrollTop = this.shrink.scrollHeight;
	    }
	  }, {
	    key: 'containerSize',
	    value: function containerSize() {
	      return [this.props.handleWidth && this.container.parentElement.offsetWidth, this.props.handleHeight && this.container.parentElement.offsetHeight];
	    }
	  }, {
	    key: 'reset',
	    value: function reset(containerWidth, containerHeight) {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var parent = this.container.parentElement;
	
	      var position = 'static';
	      if (parent.currentStyle) {
	        position = parent.currentStyle.position;
	      } else if (window.getComputedStyle) {
	        position = window.getComputedStyle(parent).position;
	      }
	      if (position === 'static') {
	        parent.style.position = 'relative';
	      }
	
	      this.setState({
	        expandChildHeight: this.expand.offsetHeight + 10,
	        expandChildWidth: this.expand.offsetWidth + 10,
	        lastWidth: containerWidth,
	        lastHeight: containerHeight
	      });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(e) {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      e.preventDefault();
	      e.stopPropagation();
	
	      var state = this.state;
	
	      var _containerSize3 = this.containerSize(),
	          _containerSize4 = _slicedToArray(_containerSize3, 2),
	          width = _containerSize4[0],
	          height = _containerSize4[1];
	
	      if (width !== state.lastWidth || height !== state.lastHeight) {
	        this.props.onResize(width, height);
	      }
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var state = this.state;
	
	
	      var expandStyle = _extends({}, _resizeDetectorStyles.expandChildStyle, {
	        width: state.expandChildWidth,
	        height: state.expandChildHeight
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: _resizeDetectorStyles.parentStyle, ref: function ref(e) {
	            _this2.container = e;
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.expand = e;
	            } },
	          _react2.default.createElement('div', { style: expandStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.shrink = e;
	            } },
	          _react2.default.createElement('div', { style: _resizeDetectorStyles.shrinkChildStyle })
	        )
	      );
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.Component);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var parentStyle = exports.parentStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  right: 0,
	  bottom: 0,
	  overflow: 'hidden',
	  zIndex: -1,
	  visibility: 'hidden'
	};
	
	var shrinkChildStyle = exports.shrinkChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '200%',
	  height: '200%'
	};
	
	var expandChildStyle = exports.expandChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '100%',
	  height: '100%'
	};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(712);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ }),
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TransitionGroup = __webpack_require__(81);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AnimateGroupChild = __webpack_require__(719);
	
	var _AnimateGroupChild2 = _interopRequireDefault(_AnimateGroupChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimateGroup = (_temp = _class = function (_Component) {
	  _inherits(AnimateGroup, _Component);
	
	  function AnimateGroup() {
	    _classCallCheck(this, AnimateGroup);
	
	    return _possibleConstructorReturn(this, (AnimateGroup.__proto__ || Object.getPrototypeOf(AnimateGroup)).apply(this, arguments));
	  }
	
	  _createClass(AnimateGroup, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          component = _props.component,
	          children = _props.children,
	          appear = _props.appear,
	          enter = _props.enter,
	          leave = _props.leave;
	
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        { component: component },
	        _react.Children.map(children, function (child, index) {
	          return _react2.default.createElement(
	            _AnimateGroupChild2.default,
	            {
	              appearOptions: appear,
	              enterOptions: enter,
	              leaveOptions: leave,
	              key: 'child-' + index
	            },
	            child
	          );
	        })
	      );
	    }
	  }]);
	
	  return AnimateGroup;
	}(_react.Component), _class.propTypes = {
	  appear: _propTypes2.default.object,
	  enter: _propTypes2.default.object,
	  leave: _propTypes2.default.object,
	
	  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
	  component: _propTypes2.default.any
	}, _class.defaultProps = {
	  component: 'span'
	}, _temp);
	exports.default = AnimateGroup;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNumber2 = __webpack_require__(224);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(724);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Animate = __webpack_require__(464);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var steps = options.steps,
	      duration = options.duration;
	
	
	  if (steps && steps.length) {
	    return steps.reduce(function (result, entry) {
	      return result + ((0, _isNumber3.default)(entry.duration) && entry.duration > 0 ? entry.duration : 0);
	    }, 0);
	  }
	
	  if ((0, _isNumber3.default)(duration)) {
	    return duration;
	  }
	
	  return 0;
	};
	
	var AnimateGroupChild = (_temp2 = _class = function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimateGroupChild.__proto__ || Object.getPrototypeOf(AnimateGroupChild)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isActive: false
	    }, _this.handleEnter = function (node, isAppearing) {
	      var _this$props = _this.props,
	          appearOptions = _this$props.appearOptions,
	          enterOptions = _this$props.enterOptions;
	
	
	      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
	    }, _this.handleExit = function () {
	      _this.handleStyleActive(_this.props.leaveOptions);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: 'handleStyleActive',
	    value: function handleStyleActive(style) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	        } : null;
	
	        this.setState(_extends({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      }
	    }
	  }, {
	    key: 'parseTimeout',
	    value: function parseTimeout() {
	      var _props = this.props,
	          appearOptions = _props.appearOptions,
	          enterOptions = _props.enterOptions,
	          leaveOptions = _props.leaveOptions;
	
	
	      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          appearOptions = _props2.appearOptions,
	          enterOptions = _props2.enterOptions,
	          leaveOptions = _props2.leaveOptions,
	          props = _objectWithoutProperties(_props2, ['children', 'appearOptions', 'enterOptions', 'leaveOptions']);
	
	      return _react2.default.createElement(
	        _Transition2.default,
	        _extends({}, props, {
	          onEnter: this.handleEnter,
	          onExit: this.handleExit,
	          timeout: this.parseTimeout()
	        }),
	        function (transitionState) {
	          return _react2.default.createElement(
	            _Animate2.default,
	            _this2.state,
	            _react.Children.only(children)
	          );
	        }
	      );
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component), _class.propTypes = {
	  appearOptions: _propTypes2.default.object,
	  enterOptions: _propTypes2.default.object,
	  leaveOptions: _propTypes2.default.object,
	  children: _propTypes2.default.element
	}, _temp2);
	exports.default = AnimateGroupChild;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = createAnimateManager;
	
	var _setRafTimeout = __webpack_require__(723);
	
	var _setRafTimeout2 = _interopRequireDefault(_setRafTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function createAnimateManager() {
	  var currStyle = {};
	  var handleChange = function handleChange() {
	    return null;
	  };
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles), curr);
	
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if ((typeof _style === 'undefined' ? 'undefined' : _typeof(_style)) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = undefined;
	
	var _isPlainObject2 = __webpack_require__(451);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isEqual2 = __webpack_require__(60);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isArray2 = __webpack_require__(24);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    var keyA = keysA[i];
	
	    if (objA[keyA] === objB[keyA]) {
	      continue;
	    }
	
	    // special diff with Array or Object
	    if ((0, _isArray3.default)(objA[keyA])) {
	      if (!(0, _isArray3.default)(objB[keyA]) || objA[keyA].length !== objB[keyA].length) {
	        return false;
	      } else if (!(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if ((0, _isPlainObject3.default)(objA[keyA])) {
	      if (!(0, _isPlainObject3.default)(objB[keyA]) || !(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	function shouldComponentUpdate(nextProps, nextState) {
	  return shallowCompare(this, nextProps, nextState);
	}
	/* eslint-disable no-param-reassign */
	function pureRenderDecorator(component) {
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filter2 = __webpack_require__(660);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _raf = __webpack_require__(66);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _util = __webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _extends({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _extends({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	};
	
	// configure update function
	
	exports.default = function (from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime = void 0;
	  var beginTime = void 0;
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter3.default)(stepperStyle, needContinue).length;
	  };
	
	  // stepper timing function like spring
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	
	    stepperStyle = calStepperVals(easing, stepperStyle, steps);
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, getCurrStyle(stepperStyle)));
	
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf2.default)(update);
	    }
	  };
	
	  // t => val timing function like cubic-bezier
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(undefined, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle);
	
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf2.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(undefined, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	
	      render(_extends({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate;
	
	  // return start animation method
	  return function () {
	    (0, _raf2.default)(update);
	
	    // return stop animation method
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = __webpack_require__(66);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf2.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf2.default)(shouldUpdate);
	}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(725);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @fileOverview calculate tick values of scale
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @author xile611, arcthur
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @date 2015-09-17
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
	
	var _utils = __webpack_require__(467);
	
	var _arithmetic = __webpack_require__(728);
	
	var _arithmetic2 = _interopRequireDefault(_arithmetic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max;
	
	  // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Number}  roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Number}  The step which is easy to understand between two ticks
	 */
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep <= 0) {
	    return 0;
	  }
	
	  var digitCount = _arithmetic2.default.getDigitCount(roughStep);
	  // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	  var stepRatio = roughStep / Math.pow(10, digitCount);
	  // When an integer and a float multiplied, the accuracy of result may be wrong
	  var amendStepRatio = digitCount !== 1 ? _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.05) + correctionFactor, 0.05) : _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.1) + correctionFactor, 0.1);
	
	  var formatStep = _arithmetic2.default.multiply(amendStepRatio, Math.pow(10, digitCount));
	
	  return allowDecimals ? formatStep : Math.ceil(formatStep);
	}
	
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var isFlt = _arithmetic2.default.isFloat(value);
	  var step = 1;
	  // calculate the middle value of ticks
	  var middle = value;
	
	  if (isFlt && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = Math.pow(10, _arithmetic2.default.getDigitCount(value) - 1);
	
	      middle = _arithmetic2.default.multiply(Math.floor(value / step), step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = Math.floor(value);
	    }
	  } else if (value === 0) {
	    middle = Math.floor((tickCount - 1) / 2);
	  } else if (!allowDecimals) {
	    middle = Math.floor(value);
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(n - middleIndex, step));
	  }), _utils.range);
	
	  return fn(0, tickCount);
	}
	
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // The step which is easy to understand between two ticks
	  var step = getFormatStep((max - min) / (tickCount - 1), allowDecimals, correctionFactor);
	
	  // A medial value of ticks
	  var middle = void 0;
	
	  // When 0 is inside the interval, 0 should be a tick
	  if (min <= 0 && max >= 0) {
	    middle = 0;
	  } else {
	    // calculate the middle value
	    middle = _arithmetic2.default.divide(_arithmetic2.default.sum(min, max), 2);
	    // minus modulo value
	    middle = _arithmetic2.default.minus(middle, _arithmetic2.default.modulo(middle, step));
	    // strip
	    middle = _arithmetic2.default.strip(middle, 16);
	  }
	
	  var belowCount = Math.ceil((middle - min) / step);
	  var upCount = Math.ceil((max - middle) / step);
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  } else if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: _arithmetic2.default.minus(middle, _arithmetic2.default.multiply(belowCount, step)),
	    tickMax: _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(upCount, step))
	  };
	}
	/**
	 * Calculate the ticks of an interval
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  // Get the step between two ticks
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic2.default.rangeStep(tickMin, tickMax + 0.1 * step, step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return cormin + n * step;
	  }), _utils.range);
	
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	  var values = [].concat(_toConsumableArray(_arithmetic2.default.rangeStep(cormin, cormax - 0.99 * step, step)), [cormax]);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = exports.getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	var getTickValues = exports.getTickValues = (0, _utils.memoize)(getTickValuesFn);
	var getTickValuesFixedDomain = exports.getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getNiceTickValues = __webpack_require__(726);
	
	Object.defineProperty(exports, 'getTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, 'getNiceTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, 'getTickValuesFixedDomain', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(467);
	
	/**
	 * 把错误的数据转正
	 * strip(0.09999999999999998)=0.1
	 * @param {Number} num       输入值
	 * @param {Number} precision 精度
	 * @return {Number} 数值
	 */
	function strip(num) {
	  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
	
	  return +parseFloat(num.toPrecision(precision));
	}
	
	/**
	 * 判断数据是否为浮点类型
	 *
	 * @param {Number} num 输入值
	 * @return {Boolean} 是否是浮点类型
	 */
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	function isFloat(num) {
	  return (/^([+-]?)\d*\.\d+$/.test(num)
	  );
	}
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	function getDigitCount(value) {
	  var abs = Math.abs(value);
	  var result = void 0;
	
	  if (value === 0) {
	    result = 1;
	  } else {
	    result = Math.floor(Math.log(abs) / Math.log(10)) + 1;
	  }
	
	  return result;
	}
	/**
	 * 计算数值的小数点后的位数
	 * @param  {Number} a 数值，可能为整数，也可能为浮点数
	 * @return {Integer}   位数
	 */
	function getDecimalDigitCount(a) {
	  var str = a ? '' + a : '';
	
	  // scientific notation
	  if (str.indexOf('e') >= 0) {
	    return Math.abs(parseInt(str.slice(str.indexOf('e') + 1), 10));
	  }
	  var ary = str.split('.');
	
	  return ary.length > 1 ? ary[1].length : 0;
	}
	/**
	 * 乘法运算，解决了js运算的精度问题
	 * @param  {Number} a 被乘数
	 * @param  {Number} b 乘数
	 * @return {Number}   积
	 */
	function multiply(a, b) {
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	  var count = getDecimalDigitCount(a) + getDecimalDigitCount(b);
	
	  return intA * intB / Math.pow(10, count);
	}
	/**
	 * 加法运算，解决了js运算的精度问题
	 * @param  {Number} a 被加数
	 * @param  {Number} b 加数
	 * @return {Number}   和
	 */
	function sum(a, b) {
	  var count = Math.max(getDecimalDigitCount(a), getDecimalDigitCount(b));
	
	  count = Math.pow(10, count);
	  return (multiply(a, count) + multiply(b, count)) / count;
	}
	/**
	 * 减法运算，解决了js运算的精度问题
	 * @param  {Number} a 被减数
	 * @param  {Number} b 减数
	 * @return {Number}   差
	 */
	function minus(a, b) {
	  return sum(a, -b);
	}
	/**
	 * 除法运算，解决了js运算的精度问题
	 * @param  {Number} a 被除数
	 * @param  {Number} b 除数
	 * @return {Number}   结果
	 */
	function divide(a, b) {
	  var ca = getDecimalDigitCount(a);
	  var cb = getDecimalDigitCount(b);
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	
	  return intA / intB * Math.pow(10, cb - ca);
	}
	
	function modulo(a, b) {
	  var mod = Math.abs(b);
	
	  if (b <= 0) {
	    return a;
	  }
	
	  var cnt = Math.floor(a / mod);
	
	  return minus(a, multiply(mod, cnt));
	}
	
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Number} start 起点
	 * @param  {Number} end   终点，不包含该值
	 * @param  {Number} step  步长
	 * @return {Array}        若干数值
	 */
	function rangeStep(start, end, step) {
	  var num = start;
	  var result = [];
	
	  while (num < end) {
	    result.push(num);
	
	    num = sum(num, step);
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	
	exports.default = {
	  rangeStep: rangeStep,
	  isFloat: isFloat,
	  getDigitCount: getDigitCount,
	  getDecimalDigitCount: getDecimalDigitCount,
	
	  sum: sum,
	  minus: minus,
	  multiply: multiply,
	  divide: divide,
	  modulo: modulo,
	  strip: strip,
	
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cartesian Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _DataUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CartesianGrid, _Component);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, (CartesianGrid.__proto__ || Object.getPrototypeOf(CartesianGrid)).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: 'renderLineItem',
	    value: function renderLineItem(option, props) {
	      var lineItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        lineItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            others = _objectWithoutProperties(props, ['x1', 'y1', 'x2', 'y2', 'key']);
	
	        lineItem = _react2.default.createElement('line', _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: 'none',
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	
	  }, {
	    key: 'renderHorizontal',
	    value: function renderHorizontal(horizontalPoints) {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          width = _props.width,
	          horizontal = _props.horizontal;
	
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _extends({}, _this2.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this2.renderLineItem(horizontal, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-horizontal' },
	        items
	      );
	    }
	
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: 'renderVertical',
	    value: function renderVertical(verticalPoints) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          y = _props2.y,
	          height = _props2.height,
	          vertical = _props2.vertical;
	
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _extends({}, _this3.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this3.renderLineItem(vertical, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-vertical' },
	        items
	      );
	    }
	
	    /**
	     * Draw vertical grid stripes filled by colors
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical stripes
	     */
	
	  }, {
	    key: 'renderVerticalStripes',
	    value: function renderVerticalStripes(verticalPoints) {
	      var verticalFill = this.props.verticalFill;
	
	      if (!verticalFill || !verticalFill.length) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          fillOpacity = _props3.fillOpacity,
	          x = _props3.x,
	          y = _props3.y,
	          width = _props3.width,
	          height = _props3.height;
	
	      var verticalPointsUpdated = verticalPoints.slice().sort(function (a, b) {
	        return a - b > 0;
	      });
	
	      if (x !== verticalPointsUpdated[0]) {
	        verticalPointsUpdated.unshift(0);
	      }
	
	      var items = verticalPointsUpdated.map(function (entry, i) {
	        var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;
	        if (lineWidth <= 0) {
	          return null;
	        }
	        var colorIndex = i % verticalFill.length;
	        return _react2.default.createElement('rect', {
	          key: i,
	          x: Math.round(entry + x - x),
	          y: y,
	          width: lineWidth,
	          height: height,
	          stroke: 'none',
	          fill: verticalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: 'recharts-cartesian-grid-bg'
	        });
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-gridstripes-vertical' },
	        items
	      );
	    }
	
	    /**
	     * Draw horizontal grid stripes filled by colors
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal stripes
	     */
	
	  }, {
	    key: 'renderHorizontalStripes',
	    value: function renderHorizontalStripes(horizontalPoints) {
	      var horizontalFill = this.props.horizontalFill;
	
	      if (!horizontalFill || !horizontalFill.length) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          fillOpacity = _props4.fillOpacity,
	          x = _props4.x,
	          y = _props4.y,
	          width = _props4.width,
	          height = _props4.height;
	
	      var horizontalPointsUpdated = horizontalPoints.slice().sort(function (a, b) {
	        return a - b > 0;
	      });
	      if (y !== horizontalPointsUpdated[0]) {
	        horizontalPointsUpdated.unshift(0);
	      }
	
	      var items = horizontalPointsUpdated.map(function (entry, i) {
	        var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;
	        if (lineHeight <= 0) {
	          return null;
	        }
	        var colorIndex = i % horizontalFill.length;
	        return _react2.default.createElement('rect', {
	          key: i,
	          y: Math.round(entry + y - y),
	          x: x,
	          height: lineHeight,
	          width: width,
	          stroke: 'none',
	          fill: horizontalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: 'recharts-cartesian-grid-bg'
	        });
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-gridstripes-horizontal' },
	        items
	      );
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _props5 = this.props,
	          fillOpacity = _props5.fillOpacity,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height;
	
	
	      return _react2.default.createElement('rect', {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: 'none',
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: 'recharts-cartesian-grid-bg'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          horizontal = _props6.horizontal,
	          vertical = _props6.vertical,
	          horizontalCoordinatesGenerator = _props6.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _props6.verticalCoordinatesGenerator,
	          xAxis = _props6.xAxis,
	          yAxis = _props6.yAxis,
	          offset = _props6.offset,
	          chartWidth = _props6.chartWidth,
	          chartHeight = _props6.chartHeight;
	
	
	      if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0 || !(0, _DataUtils.isNumber)(x) || x !== +x || !(0, _DataUtils.isNumber)(y) || y !== +y) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          horizontalPoints = _props7.horizontalPoints,
	          verticalPoints = _props7.verticalPoints;
	
	      // No horizontal points are specified
	
	      if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunction3.default)(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({ yAxis: yAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      // No vertical points are specified
	      if ((!verticalPoints || !verticalPoints.length) && (0, _isFunction3.default)(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({ xAxis: xAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid' },
	        this.renderBackground(),
	        horizontal && this.renderHorizontal(horizontalPoints),
	        vertical && this.renderVertical(verticalPoints),
	        horizontal && this.renderHorizontalStripes(horizontalPoints),
	        vertical && this.renderVerticalStripes(verticalPoints)
	      );
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.Component), _class2.displayName = 'CartesianGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  horizontal: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  vertical: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  horizontalPoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  verticalPoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  horizontalCoordinatesGenerator: _propTypes2.default.func,
	  verticalCoordinatesGenerator: _propTypes2.default.func,
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  chartWidth: _propTypes2.default.number,
	  chartHeight: _propTypes2.default.number,
	  verticalFill: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  horizontalFill: _propTypes2.default.arrayOf(_propTypes2.default.string)
	}), _class2.defaultProps = {
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	
	  stroke: '#ccc',
	  fill: 'none',
	  // The fill of colors of grid lines
	  verticalFill: [],
	  horizontalFill: []
	}, _temp)) || _class;
	
	exports.default = CartesianGrid;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(82);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Area = __webpack_require__(393);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _XAxis = __webpack_require__(115);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(116);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _CartesianUtils = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'AreaChart',
	  GraphicalChild: _Area2.default,
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Area Chart
	     */

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(82);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Bar = __webpack_require__(394);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _XAxis = __webpack_require__(115);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(116);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _CartesianUtils = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'BarChart',
	  GraphicalChild: _Bar2.default,
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Bar Chart
	     */

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(82);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Area = __webpack_require__(393);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _Bar = __webpack_require__(394);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _Line = __webpack_require__(395);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _Scatter = __webpack_require__(396);
	
	var _Scatter2 = _interopRequireDefault(_Scatter);
	
	var _XAxis = __webpack_require__(115);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(116);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _ZAxis = __webpack_require__(200);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _CartesianUtils = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'ComposedChart',
	  GraphicalChild: [_Line2.default, _Area2.default, _Bar2.default, _Scatter2.default],
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }, { axisType: 'zAxis', AxisComp: _ZAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Composed Chart
	     */

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(82);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Line = __webpack_require__(395);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _XAxis = __webpack_require__(115);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(116);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _CartesianUtils = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'LineChart',
	  GraphicalChild: _Line2.default,
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Line Chart
	     */

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generateCategoricalChart = __webpack_require__(82);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _PolarAngleAxis = __webpack_require__(202);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(203);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _PolarUtils = __webpack_require__(56);
	
	var _Pie = __webpack_require__(473);
	
	var _Pie2 = _interopRequireDefault(_Pie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Pie Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'PieChart',
	  GraphicalChild: _Pie2.default,
	  eventType: 'item',
	  legendContent: 'children',
	  axisComponents: [{ axisType: 'angleAxis', AxisComp: _PolarAngleAxis2.default }, { axisType: 'radiusAxis', AxisComp: _PolarRadiusAxis2.default }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes2.default.oneOf(['centric']),
	    startAngle: _propTypes2.default.number,
	    endAngle: _propTypes2.default.number,
	    cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }
	});

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generateCategoricalChart = __webpack_require__(82);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Radar = __webpack_require__(474);
	
	var _Radar2 = _interopRequireDefault(_Radar);
	
	var _PolarAngleAxis = __webpack_require__(202);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(203);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _PolarUtils = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Radar Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'RadarChart',
	  GraphicalChild: _Radar2.default,
	  axisComponents: [{ axisType: 'angleAxis', AxisComp: _PolarAngleAxis2.default }, { axisType: 'radiusAxis', AxisComp: _PolarRadiusAxis2.default }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 90,
	    endAngle: -270,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes2.default.oneOf(['centric']),
	    startAngle: _propTypes2.default.number,
	    endAngle: _propTypes2.default.number,
	    cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }
	});

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generateCategoricalChart = __webpack_require__(82);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _PolarAngleAxis = __webpack_require__(202);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(203);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _PolarUtils = __webpack_require__(56);
	
	var _RadialBar = __webpack_require__(475);
	
	var _RadialBar2 = _interopRequireDefault(_RadialBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Radar Bar Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'RadialBarChart',
	  GraphicalChild: _RadialBar2.default,
	  legendContent: 'children',
	  axisComponents: [{ axisType: 'angleAxis', AxisComp: _PolarAngleAxis2.default }, { axisType: 'radiusAxis', AxisComp: _PolarRadiusAxis2.default }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'radial',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes2.default.oneOf(['radial']),
	    startAngle: _propTypes2.default.number,
	    endAngle: _propTypes2.default.number,
	    cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }
	});

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _sumBy2 = __webpack_require__(674);
	
	var _sumBy3 = _interopRequireDefault(_sumBy2);
	
	var _min2 = __webpack_require__(454);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _maxBy2 = __webpack_require__(453);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @file TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(182);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(201);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultCoordinateOfTooltip = { x: 0, y: 0 };
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return { sourceNodes: sourceNodes, sourceLinks: sourceLinks, targetLinks: targetLinks, targetNodes: targetNodes };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	
	    return _extends({}, entry, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	  var maxDepth = (0, _maxBy3.default)(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return { tree: tree, maxDepth: maxDepth };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min3.default)(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy3.default)(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _extends({}, link, { dy: getValue(link) * yRatio });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length;
	
	    // Sort by the value of y
	    nodes.sort(ascendingY);
	
	    var y0 = 0;
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	
	  resolveCollisions(depthTree, height, nodePadding);
	
	  var alpha = 1;
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	
	    resolveCollisions(depthTree, height, nodePadding);
	
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	
	  return { nodes: tree, links: newLinks };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return { x: el.x + el.width / 2, y: el.y + el.height / 2 };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _ChartUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	  if (payload.source && payload.target) {
	    var sourceName = (0, _ChartUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _ChartUtils.getValueByDataKey)(payload.target, nameKey, '');
	
	    return [{
	      payload: el,
	      name: sourceName + ' - ' + targetName,
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sankey, _Component);
	
	  function Sankey(props) {
	    _classCallCheck(this, Sankey);
	
	    var _this = _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).call(this, props));
	
	    _this.state = _this.createDefaultState(props);
	    return _this;
	  }
	
	  _createClass(Sankey, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          height = _props.height,
	          margin = _props.margin,
	          iterations = _props.iterations,
	          nodeWidth = _props.nodeWidth,
	          nodePadding = _props.nodePadding,
	          nameKey = _props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _PureRender.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.createDefaultState(nextProps));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations, nodeWidth: nodeWidth, nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes, links: links
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(el, type, e) {
	      var _props2 = this.props,
	          onMouseEnter = _props2.onMouseEnter,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(el, type, e) {
	      var _props3 = this.props,
	          onMouseLeave = _props3.onMouseLeave,
	          children = _props3.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: 'renderLinkItem',
	    value: function renderLinkItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ['sourceX', 'sourceY', 'sourceControlX', 'targetX', 'targetY', 'targetControlX', 'linkWidth']);
	
	      return _react2.default.createElement('path', _extends({
	        className: 'recharts-sankey-link',
	        d: '\n          M' + sourceX + ',' + sourceY + '\n          C' + sourceControlX + ',' + sourceY + ' ' + targetControlX + ',' + targetY + ' ' + targetX + ',' + targetY + '\n        ',
	        fill: 'none',
	        stroke: '#333',
	        strokeWidth: linkWidth,
	        strokeOpacity: '0.2'
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: 'renderLinks',
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          linkCurvature = _props4.linkCurvature,
	          linkContent = _props4.link,
	          margin = _props4.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-links', key: 'recharts-sankey-links' },
	        links.map(function (link, i) {
	          var sourceRelativeY = link.sy,
	              targetRelativeY = link.ty,
	              linkWidth = link.dy;
	
	          var source = nodes[link.source];
	          var target = nodes[link.target];
	          var sourceX = source.x + source.dx + left;
	          var targetX = target.x + left;
	          var interpolationFunc = interpolationGenerator(sourceX, targetX);
	          var sourceControlX = interpolationFunc(linkCurvature);
	          var targetControlX = interpolationFunc(1 - linkCurvature);
	          var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	          var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	          var linkProps = _extends({
	            sourceX: sourceX, targetX: targetX,
	            sourceY: sourceY, targetY: targetY,
	            sourceControlX: sourceControlX, targetControlX: targetControlX,
	            sourceRelativeY: sourceRelativeY, targetRelativeY: targetRelativeY,
	            linkWidth: linkWidth,
	            index: i,
	            payload: _extends({}, link, { source: source, target: target })
	          }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	          var events = {
	            onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	            onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'link' + i }, events),
	            _this2.renderLinkItem(linkContent, linkProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderNodeItem',
	    value: function renderNodeItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        className: 'recharts-sankey-node',
	        fill: '#0088fe',
	        fillOpacity: '0.8'
	      }, props));
	    }
	  }, {
	    key: 'renderNodes',
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          nodeContent = _props5.node,
	          margin = _props5.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-nodes', key: 'recharts-sankey-nodes' },
	        nodes.map(function (node, i) {
	          var x = node.x,
	              y = node.y,
	              dx = node.dx,
	              dy = node.dy;
	
	          var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	            x: x + left,
	            y: y + top,
	            width: dx,
	            height: dy,
	            index: i,
	            payload: node
	          });
	          var events = {
	            onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	            onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'node' + i }, events),
	            _this3.renderNodeItem(nodeContent, nodeProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props6 = this.props,
	          children = _props6.children,
	          width = _props6.width,
	          height = _props6.height,
	          nameKey = _props6.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeElement = _state.activeElement,
	          activeElementType = _state.activeElementType;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var _state2 = this.state,
	          links = _state2.links,
	          nodes = _state2.nodes;
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          (0, _ReactUtils.filterSvgElements)(children),
	          this.renderLinks(links, nodes),
	          this.renderNodes(nodes)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Sankey;
	}(_react.Component), _class2.displayName = 'Sankey', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.shape({
	    nodes: _propTypes2.default.array,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      target: _propTypes2.default.number,
	      source: _propTypes2.default.number,
	      value: _propTypes2.default.number
	    }))
	  }),
	
	  nodePadding: _propTypes2.default.number,
	  nodeWidth: _propTypes2.default.number,
	  linkCurvature: _propTypes2.default.number,
	  iterations: _propTypes2.default.number,
	
	  node: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	  link: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  })
	}), _class2.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: { top: 5, right: 5, bottom: 5, left: 5 }
	}, _temp)) || _class;
	
	exports.default = Sankey;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(82);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Scatter = __webpack_require__(396);
	
	var _Scatter2 = _interopRequireDefault(_Scatter);
	
	var _XAxis = __webpack_require__(115);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(116);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _ZAxis = __webpack_require__(200);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _CartesianUtils = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Scatter Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'ScatterChart',
	  GraphicalChild: _Scatter2.default,
	  eventType: 'single',
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }, { axisType: 'zAxis', AxisComp: _ZAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(16);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNaN2 = __webpack_require__(195);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(63);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(182);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(26);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Rectangle = __webpack_require__(118);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _ReactUtils = __webpack_require__(12);
	
	var _Tooltip = __webpack_require__(201);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ChartUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({ depth: childDepth, node: child, index: i, valueKey: valueKey });
	  }) : null;
	  var value = void 0;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = (0, _isNaN3.default)(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _extends({}, node, {
	    children: computedChildren,
	    value: value, depth: depth, index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return { x: node.x, y: node.y, width: node.width, height: node.height };
	};
	
	// Compute the area for each child based on value & scale.
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	
	  return children.map(function (child) {
	    var area = child.value * ratio;
	
	    return _extends({}, child, {
	      area: (0, _isNaN3.default)(area) || area <= 0 ? 0 : area
	    });
	  });
	};
	
	// Computes the score for the specified row, as the worst aspect ratio.
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, { min: Infinity, max: 0 }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  }
	  // what's z
	  child.z = true;
	  // add the remain x to the last one of row
	  child.width += parentRect.x + parentRect.width - curX;
	
	  return _extends({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	
	  return _extends({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	};
	
	// Recursively arranges the specified node's children into squarified rows.
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	    var child = void 0,
	        score = void 0; // the current row score
	    var size = Math.min(rect.width, rect.height); // initial orientation
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	
	      score = getWorstScore(row, size, aspectRatio);
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _extends({}, node, { children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      }) });
	  }
	
	  return node;
	};
	
	var Treemap = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Treemap, _Component);
	
	  function Treemap() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Treemap, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        activeNode: null
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(node, e) {
	      var _props = this.props,
	          onMouseEnter = _props.onMouseEnter,
	          children = _props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(node, e) {
	      var _props2 = this.props,
	          onMouseLeave = _props2.onMouseLeave,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(node) {
	      var onClick = this.props.onClick;
	
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: 'renderAnimatedItem',
	    value: function renderAnimatedItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          isUpdateAnimationActive = _props3.isUpdateAnimationActive;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y;
	
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf) {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: { x: x, y: y, width: width, height: height },
	          to: { x: x, y: y, width: width, height: height },
	          duration: animationDuration,
	          easing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref3) {
	          var currX = _ref3.x,
	              currY = _ref3.y,
	              currWidth = _ref3.width,
	              currHeight = _ref3.height;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              from: 'translate(' + translateX + 'px, ' + translateX + 'px)',
	              to: 'translate(0, 0)',
	              attributeName: 'transform',
	              begin: animationBegin,
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration
	            },
	            _react2.default.createElement(
	              _Layer2.default,
	              event,
	              _this2.renderContentItem(content, _extends({}, nodeProps, {
	                isAnimationActive: isAnimationActive,
	                isUpdateAnimationActive: !isUpdateAnimationActive,
	                width: currWidth,
	                height: currHeight,
	                x: currX,
	                y: currY
	              }))
	            )
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderContentItem',
	    value: function renderContentItem(content, nodeProps) {
	      if (_react2.default.isValidElement(content)) {
	        return _react2.default.cloneElement(content, nodeProps);
	      } else if ((0, _isFunction3.default)(content)) {
	        return content(nodeProps);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        fill: '#fff',
	        stroke: '#000'
	      }, nodeProps));
	    }
	  }, {
	    key: 'renderNode',
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var content = this.props.content;
	
	      var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), node, { root: root });
	      var isLeaf = !node.children || !node.children.length;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { key: 'recharts-treemap-node-' + i, className: 'recharts-treemap-depth-' + node.depth },
	        this.renderAnimatedItem(content, nodeProps, isLeaf),
	        node.children && node.children.length ? node.children.map(function (child, index) {
	          return _this3.renderNode(node, child, index);
	        }) : null
	      );
	    }
	  }, {
	    key: 'renderAllNodes',
	    value: function renderAllNodes() {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          data = _props4.data,
	          dataKey = _props4.dataKey,
	          aspectRatio = _props4.aspectRatio;
	
	
	      var root = computeNode({
	        depth: 0,
	        node: { children: data, x: 0, y: 0, width: width, height: height },
	        index: 0,
	        valueKey: dataKey
	      });
	
	      var formatRoot = squarify(root, aspectRatio);
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props5 = this.props,
	          children = _props5.children,
	          nameKey = _props5.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height,
	          dataKey = _props6.dataKey;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeNode = _state.activeNode;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _ChartUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _ChartUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderAllNodes(),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Treemap;
	}(_react.Component), _class2.displayName = 'Treemap', _class2.propTypes = {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  style: _propTypes2.default.object,
	  aspectRatio: _propTypes2.default.number,
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  isUpdateAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}, _class2.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear'
	}, _temp2)) || _class;
	
	exports.default = Treemap;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Legend Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Surface = __webpack_require__(182);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Symbols = __webpack_require__(400);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SIZE = 32;
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var DefaultLegendContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultLegendContent, _Component);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, (DefaultLegendContent.__proto__ || Object.getPrototypeOf(DefaultLegendContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: 'renderIcon',
	
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var inactiveColor = this.props.inactiveColor;
	
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	      var color = data.inactive ? inactiveColor : data.color;
	
	      if (data.type === 'plainline') {
	        return _react2.default.createElement('line', {
	          strokeWidth: 4,
	          fill: 'none',
	          stroke: color,
	          strokeDasharray: data.payload.strokeDasharray,
	          x1: 0,
	          y1: halfSize,
	          x2: SIZE,
	          y2: halfSize,
	          className: 'recharts-legend-icon'
	        });
	      } else if (data.type === 'line') {
	        return _react2.default.createElement('path', {
	          strokeWidth: 4,
	          fill: 'none',
	          stroke: color,
	          d: 'M0,' + halfSize + 'h' + thirdSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + 2 * thirdSize + ',' + halfSize + '\n            H' + SIZE + 'M' + 2 * thirdSize + ',' + halfSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + thirdSize + ',' + halfSize,
	          className: 'recharts-legend-icon'
	        });
	      } else if (data.type === 'rect') {
	        return _react2.default.createElement('path', {
	          stroke: 'none',
	          fill: color,
	          d: 'M0,' + SIZE / 8 + 'h' + SIZE + 'v' + SIZE * 3 / 4 + 'h' + -SIZE + 'z',
	          className: 'recharts-legend-icon'
	        });
	      }
	
	      return _react2.default.createElement(_Symbols2.default, {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: 'diameter',
	        type: data.type
	      });
	    }
	
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          iconSize = _props.iconSize,
	          layout = _props.layout,
	          formatter = _props.formatter;
	
	      var viewBox = { x: 0, y: 0, width: SIZE, height: SIZE };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 };
	
	      return payload.map(function (entry, i) {
	        var _classNames;
	
	        var finalFormatter = entry.formatter || formatter;
	        var className = (0, _classnames2.default)((_classNames = {
	          'recharts-legend-item': true
	        }, _defineProperty(_classNames, 'legend-item-' + i, true), _defineProperty(_classNames, 'inactive', entry.inactive), _classNames));
	
	        if (entry.type === 'none') {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'li',
	          _extends({
	            className: className,
	            style: itemStyle,
	            key: 'legend-item-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _react2.default.createElement(
	            _Surface2.default,
	            { width: iconSize, height: iconSize, viewBox: viewBox, style: svgStyle },
	            _this2.renderIcon(entry)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'recharts-legend-item-text' },
	            finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          payload = _props2.payload,
	          layout = _props2.layout,
	          align = _props2.align;
	
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'recharts-default-legend', style: finalStyle },
	        this.renderItems()
	      );
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes2.default.element,
	  iconSize: _propTypes2.default.number,
	  iconType: _propTypes2.default.oneOf(ICON_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes2.default.oneOf(['top', 'bottom', 'middle']),
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    id: _propTypes2.default.any,
	    type: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  inactiveColor: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle',
	  inactiveColor: '#ccc'
	}, _temp)) || _class;
	
	exports.default = DefaultLegendContent;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(24);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Tooltip Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray3.default)(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultTooltipContent, _Component);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, (DefaultTooltipContent.__proto__ || Object.getPrototypeOf(DefaultTooltipContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props = this.props,
	          payload = _props.payload,
	          separator = _props.separator,
	          formatter = _props.formatter,
	          itemStyle = _props.itemStyle,
	          itemSorter = _props.itemSorter;
	
	
	      if (payload && payload.length) {
	        var listStyle = { padding: 0, margin: 0 };
	
	        var items = payload.sort(itemSorter).map(function (entry, i) {
	          var finalItemStyle = _extends({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	          var hasName = (0, _DataUtils.isNumOrStr)(entry.name);
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	
	          return _react2.default.createElement(
	            'li',
	            { className: 'recharts-tooltip-item', key: 'tooltip-item-' + i, style: finalItemStyle },
	            hasName ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-name' },
	              entry.name
	            ) : null,
	            hasName ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-separator' },
	              separator
	            ) : null,
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-value' },
	              finalFormatter ? finalFormatter(entry.value, entry.name, entry, i) : entry.value
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-unit' },
	              entry.unit || ''
	            )
	          );
	        });
	
	        return _react2.default.createElement(
	          'ul',
	          { className: 'recharts-tooltip-item-list', style: listStyle },
	          items
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          labelStyle = _props2.labelStyle,
	          label = _props2.label,
	          labelFormatter = _props2.labelFormatter,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var finalStyle = _extends({
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      }, wrapperStyle);
	      var finalLabelStyle = _extends({
	        margin: 0
	      }, labelStyle);
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'recharts-default-tooltip', style: finalStyle },
	        _react2.default.createElement(
	          'p',
	          { className: 'recharts-tooltip-label', style: finalLabelStyle },
	          finalLabel
	        ),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.Component), _class2.displayName = 'DefaultTooltipContent', _class2.propTypes = {
	  separator: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  wrapperStyle: _propTypes2.default.object,
	  itemStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  labelFormatter: _propTypes2.default.func,
	  label: _propTypes2.default.any,
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.any,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    unit: _propTypes2.default.any
	  })),
	  itemSorter: _propTypes2.default.func
	}, _class2.defaultProps = {
	  separator: ' : ',
	  itemStyle: {},
	  labelStyle: {}
	}, _temp)) || _class;
	
	exports.default = DefaultTooltipContent;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(449);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactResizeDetector = __webpack_require__(714);
	
	var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);
	
	var _DataUtils = __webpack_require__(19);
	
	var _LogUtils = __webpack_require__(477);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResponsiveContainer = (_temp = _class = function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    _classCallCheck(this, ResponsiveContainer);
	
	    var _this = _possibleConstructorReturn(this, (ResponsiveContainer.__proto__ || Object.getPrototypeOf(ResponsiveContainer)).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	
	    _this.handleResize = props.debounce > 0 ? (0, _debounce3.default)(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'getContainerSize',
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: 'renderChart',
	    value: function renderChart() {
	      var _state = this.state,
	          containerWidth = _state.containerWidth,
	          containerHeight = _state.containerHeight;
	
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _props = this.props,
	          aspect = _props.aspect,
	          width = _props.width,
	          height = _props.height,
	          minWidth = _props.minWidth,
	          minHeight = _props.minHeight,
	          maxHeight = _props.maxHeight,
	          children = _props.children;
	
	
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), 'The width(%s) and height(%s) are both fixed numbers,\n       maybe you don\'t need to use a ResponsiveContainer.', width, height);
	
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        calculatedHeight = calculatedWidth / aspect;
	        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, 'The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.', calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	
	      return _react2.default.cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          minWidth = _props2.minWidth,
	          minHeight = _props2.minHeight,
	          width = _props2.width,
	          height = _props2.height,
	          maxHeight = _props2.maxHeight,
	          id = _props2.id,
	          className = _props2.className;
	
	      var style = { width: width, height: height, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          id: id,
	          className: (0, _classnames2.default)('recharts-responsive-container', className),
	          style: style,
	          ref: function ref(node) {
	            _this2.container = node;
	          }
	        },
	        this.renderChart(),
	        _react2.default.createElement(_reactResizeDetector2.default, { handleWidth: true, handleHeight: true, onResize: this.handleResize })
	      );
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component), _class.displayName = 'ResponsiveContainer', _class.propTypes = {
	  aspect: _propTypes2.default.number,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  minHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  minWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  children: _propTypes2.default.node.isRequired,
	  debounce: _propTypes2.default.number,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _class.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	}, _temp);
	exports.default = ResponsiveContainer;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polar Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(13);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _PolarUtils = __webpack_require__(56);
	
	var _ReactUtils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarGrid, _Component);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, (PolarGrid.__proto__ || Object.getPrototypeOf(PolarGrid)).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: 'getPolygonPath',
	    value: function getPolygonPath(radius) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          polarAngles = _props.polarAngles;
	
	
	      var path = '';
	
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += 'L ' + point.x + ',' + point.y;
	        } else {
	          path += 'M ' + point.x + ',' + point.y;
	        }
	      });
	      path += 'Z';
	
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: 'renderPolarAngles',
	    value: function renderPolarAngles() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          innerRadius = _props2.innerRadius,
	          outerRadius = _props2.outerRadius,
	          polarAngles = _props2.polarAngles;
	
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-angle' },
	        polarAngles.map(function (entry, i) {
	          var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	          var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	
	          return _react2.default.createElement('line', _extends({}, props, {
	            key: 'line-' + i,
	            x1: start.x,
	            y1: start.y,
	            x2: end.x,
	            y2: end.y
	          }));
	        })
	      );
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: 'renderConcentricCircle',
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy;
	
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('circle', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-circle',
	        key: 'circle-' + index,
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: 'renderConcentricPolygon',
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('path', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-polygon',
	        key: 'path-' + index,
	        d: this.getPolygonPath(radius)
	      }));
	    }
	
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: 'renderConcentricPath',
	    value: function renderConcentricPath() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          polarRadius = _props4.polarRadius,
	          gridType = _props4.gridType;
	
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-concentric' },
	        polarRadius.map(function (entry, i) {
	          return gridType === 'circle' ? _this2.renderConcentricCircle(entry, i) : _this2.renderConcentricPolygon(entry, i);
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid' },
	        this.renderPolarAngles(),
	        this.renderConcentricPath()
	      );
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.Component), _class2.displayName = 'PolarGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	
	  polarAngles: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  polarRadius: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  gridType: _propTypes2.default.oneOf(['polygon', 'circle'])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	}, _temp)) || _class;
	
	exports.default = PolarGrid;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(768);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	  Object.getPrototypeOf = function (object) {
	    if (object.__proto__) {
	      return object.__proto__;
	    }
	
	    return nativeGetPrototypeOf.call(Object, object);
	  };
	}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	
	var generatePrefixStyle = exports.generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (!name) {
	    return null;
	  }
	
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var result = PREFIX_LIST.reduce(function (res, entry) {
	    return _extends({}, res, _defineProperty({}, entry + camelName, value));
	  }, {});
	
	  result[name] = value;
	
	  return result;
	};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = undefined;
	
	var _events = __webpack_require__(559);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventCenter = new _events2.default();
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	exports.eventCenter = eventCenter;
	var SYNC_EVENT = exports.SYNC_EVENT = 'recharts.syncMouseEvents';

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(748)
	var reduceFunctionCall = __webpack_require__(749)
	var mexp = __webpack_require__(678)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ }),
/* 748 */
/***/ (function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(750)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	;(function() {
	
	"use strict";
	
	var root = this
	
	var has_require = "function" !== 'undefined'
	
	var THREE = root.THREE || has_require && __webpack_require__(478)
	if( !THREE )
		throw new Error( 'EquirectangularToCubemap requires three.js' )
	
	function MeshLine() {
	
		this.positions = [];
	
		this.previous = [];
		this.next = [];
		this.side = [];
		this.width = [];
		this.indices_array = [];
		this.uvs = [];
		this.counters = [];
		this.geometry = new THREE.BufferGeometry();
	
		this.widthCallback = null;
	
	}
	
	MeshLine.prototype.setGeometry = function( g, c ) {
	
		this.widthCallback = c;
	
		this.positions = [];
		this.counters = [];
	
		if( g instanceof THREE.Geometry ) {
			for( var j = 0; j < g.vertices.length; j++ ) {
				var v = g.vertices[ j ];
				var c = j/g.vertices.length;
				this.positions.push( v.x, v.y, v.z );
				this.positions.push( v.x, v.y, v.z );
				this.counters.push(c);
				this.counters.push(c);
			}
		}
	
		if( g instanceof THREE.BufferGeometry ) {
			// read attribute positions ?
		}
	
		if( g instanceof Float32Array || g instanceof Array ) {
			for( var j = 0; j < g.length; j += 3 ) {
				var c = j/g.length;
				this.positions.push( g[ j ], g[ j + 1 ], g[ j + 2 ] );
				this.positions.push( g[ j ], g[ j + 1 ], g[ j + 2 ] );
				this.counters.push(c);
				this.counters.push(c);
			}
		}
	
		this.process();
	
	}
	
	MeshLine.prototype.compareV3 = function( a, b ) {
	
		var aa = a * 6;
		var ab = b * 6;
		return ( this.positions[ aa ] === this.positions[ ab ] ) && ( this.positions[ aa + 1 ] === this.positions[ ab + 1 ] ) && ( this.positions[ aa + 2 ] === this.positions[ ab + 2 ] );
	
	}
	
	MeshLine.prototype.copyV3 = function( a ) {
	
		var aa = a * 6;
		return [ this.positions[ aa ], this.positions[ aa + 1 ], this.positions[ aa + 2 ] ];
	
	}
	
	MeshLine.prototype.process = function() {
	
		var l = this.positions.length / 6;
	
		this.previous = [];
		this.next = [];
		this.side = [];
		this.width = [];
		this.indices_array = [];
		this.uvs = [];
	
		for( var j = 0; j < l; j++ ) {
			this.side.push( 1 );
			this.side.push( -1 );
		}
	
		var w;
		for( var j = 0; j < l; j++ ) {
			if( this.widthCallback ) w = this.widthCallback( j / ( l -1 ) );
			else w = 1;
			this.width.push( w );
			this.width.push( w );
		}
	
		for( var j = 0; j < l; j++ ) {
			this.uvs.push( j / ( l - 1 ), 0 );
			this.uvs.push( j / ( l - 1 ), 1 );
		}
	
		var v;
	
		if( this.compareV3( 0, l - 1 ) ){
			v = this.copyV3( l - 2 );
		} else {
			v = this.copyV3( 0 );
		}
		this.previous.push( v[ 0 ], v[ 1 ], v[ 2 ] );
		this.previous.push( v[ 0 ], v[ 1 ], v[ 2 ] );
		for( var j = 0; j < l - 1; j++ ) {
			v = this.copyV3( j );
			this.previous.push( v[ 0 ], v[ 1 ], v[ 2 ] );
			this.previous.push( v[ 0 ], v[ 1 ], v[ 2 ] );
		}
	
		for( var j = 1; j < l; j++ ) {
			v = this.copyV3( j );
			this.next.push( v[ 0 ], v[ 1 ], v[ 2 ] );
			this.next.push( v[ 0 ], v[ 1 ], v[ 2 ] );
		}
	
		if( this.compareV3( l - 1, 0 ) ){
			v = this.copyV3( 1 );
		} else {
			v = this.copyV3( l - 1 );
		}
		this.next.push( v[ 0 ], v[ 1 ], v[ 2 ] );
		this.next.push( v[ 0 ], v[ 1 ], v[ 2 ] );
	
		for( var j = 0; j < l - 1; j++ ) {
			var n = j * 2;
			this.indices_array.push( n, n + 1, n + 2 );
			this.indices_array.push( n + 2, n + 1, n + 3 );
		}
	
		if (!this.attributes) {
			this.attributes = {
				position: new THREE.BufferAttribute( new Float32Array( this.positions ), 3 ),
				previous: new THREE.BufferAttribute( new Float32Array( this.previous ), 3 ),
				next: new THREE.BufferAttribute( new Float32Array( this.next ), 3 ),
				side: new THREE.BufferAttribute( new Float32Array( this.side ), 1 ),
				width: new THREE.BufferAttribute( new Float32Array( this.width ), 1 ),
				uv: new THREE.BufferAttribute( new Float32Array( this.uvs ), 2 ),
				index: new THREE.BufferAttribute( new Uint16Array( this.indices_array ), 1 ),
				counters: new THREE.BufferAttribute( new Float32Array( this.counters ), 1 )
			}
		} else {
			this.attributes.position.copyArray(new Float32Array(this.positions));
			this.attributes.position.needsUpdate = true;
			this.attributes.previous.copyArray(new Float32Array(this.previous));
			this.attributes.previous.needsUpdate = true;
			this.attributes.next.copyArray(new Float32Array(this.next));
			this.attributes.next.needsUpdate = true;
			this.attributes.side.copyArray(new Float32Array(this.side));
			this.attributes.side.needsUpdate = true;
			this.attributes.width.copyArray(new Float32Array(this.width));
			this.attributes.width.needsUpdate = true;
			this.attributes.uv.copyArray(new Float32Array(this.uvs));
			this.attributes.uv.needsUpdate = true;
			this.attributes.index.copyArray(new Uint16Array(this.indices_array));
			this.attributes.index.needsUpdate = true;
	    }
	
		this.geometry.addAttribute( 'position', this.attributes.position );
		this.geometry.addAttribute( 'previous', this.attributes.previous );
		this.geometry.addAttribute( 'next', this.attributes.next );
		this.geometry.addAttribute( 'side', this.attributes.side );
		this.geometry.addAttribute( 'width', this.attributes.width );
		this.geometry.addAttribute( 'uv', this.attributes.uv );
		this.geometry.addAttribute( 'counters', this.attributes.counters );
	
		this.geometry.setIndex( this.attributes.index );
	
	}
	
	function memcpy (src, srcOffset, dst, dstOffset, length) {
		var i
	
		src = src.subarray || src.slice ? src : src.buffer
		dst = dst.subarray || dst.slice ? dst : dst.buffer
	
		src = srcOffset ? src.subarray ?
		src.subarray(srcOffset, length && srcOffset + length) :
		src.slice(srcOffset, length && srcOffset + length) : src
	
		if (dst.set) {
			dst.set(src, dstOffset)
		} else {
			for (i=0; i<src.length; i++) {
				dst[i + dstOffset] = src[i]
			}
		}
	
		return dst
	}
	
	/**
	 * Fast method to advance the line by one position.  The oldest position is removed.
	 * @param position
	 */
	MeshLine.prototype.advance = function(position) {
	
		var positions = this.attributes.position.array;
		var previous = this.attributes.previous.array;
		var next = this.attributes.next.array;
		var l = positions.length;
	
		// PREVIOUS
		memcpy( positions, 0, previous, 0, l );
	
		// POSITIONS
		memcpy( positions, 6, positions, 0, l - 6 );
	
		positions[l - 6] = position.x;
		positions[l - 5] = position.y;
		positions[l - 4] = position.z;
		positions[l - 3] = position.x;
		positions[l - 2] = position.y;
		positions[l - 1] = position.z;
	
	    // NEXT
		memcpy( positions, 6, next, 0, l - 6 );
	
		next[l - 6]  = position.x;
		next[l - 5]  = position.y;
		next[l - 4]  = position.z;
		next[l - 3]  = position.x;
		next[l - 2]  = position.y;
		next[l - 1]  = position.z;
	
		this.attributes.position.needsUpdate = true;
		this.attributes.previous.needsUpdate = true;
		this.attributes.next.needsUpdate = true;
	
	};
	
	function MeshLineMaterial( parameters ) {
	
		var vertexShaderSource = [
	'precision highp float;',
	'',
	'attribute vec3 position;',
	'attribute vec3 previous;',
	'attribute vec3 next;',
	'attribute float side;',
	'attribute float width;',
	'attribute vec2 uv;',
	'attribute float counters;',
	'',
	'uniform mat4 projectionMatrix;',
	'uniform mat4 modelViewMatrix;',
	'uniform vec2 resolution;',
	'uniform float lineWidth;',
	'uniform vec3 color;',
	'uniform float opacity;',
	'uniform float near;',
	'uniform float far;',
	'uniform float sizeAttenuation;',
	'',
	'varying vec2 vUV;',
	'varying vec4 vColor;',
	'varying float vCounters;',
	'',
	'vec2 fix( vec4 i, float aspect ) {',
	'',
	'    vec2 res = i.xy / i.w;',
	'    res.x *= aspect;',
	'	 vCounters = counters;',
	'    return res;',
	'',
	'}',
	'',
	'void main() {',
	'',
	'    float aspect = resolution.x / resolution.y;',
	'	 float pixelWidthRatio = 1. / (resolution.x * projectionMatrix[0][0]);',
	'',
	'    vColor = vec4( color, opacity );',
	'    vUV = uv;',
	'',
	'    mat4 m = projectionMatrix * modelViewMatrix;',
	'    vec4 finalPosition = m * vec4( position, 1.0 );',
	'    vec4 prevPos = m * vec4( previous, 1.0 );',
	'    vec4 nextPos = m * vec4( next, 1.0 );',
	'',
	'    vec2 currentP = fix( finalPosition, aspect );',
	'    vec2 prevP = fix( prevPos, aspect );',
	'    vec2 nextP = fix( nextPos, aspect );',
	'',
	'	 float pixelWidth = finalPosition.w * pixelWidthRatio;',
	'    float w = 1.8 * pixelWidth * lineWidth * width;',
	'',
	'    if( sizeAttenuation == 1. ) {',
	'        w = 1.8 * lineWidth * width;',
	'    }',
	'',
	'    vec2 dir;',
	'    if( nextP == currentP ) dir = normalize( currentP - prevP );',
	'    else if( prevP == currentP ) dir = normalize( nextP - currentP );',
	'    else {',
	'        vec2 dir1 = normalize( currentP - prevP );',
	'        vec2 dir2 = normalize( nextP - currentP );',
	'        dir = normalize( dir1 + dir2 );',
	'',
	'        vec2 perp = vec2( -dir1.y, dir1.x );',
	'        vec2 miter = vec2( -dir.y, dir.x );',
	'        //w = clamp( w / dot( miter, perp ), 0., 4. * lineWidth * width );',
	'',
	'    }',
	'',
	'    //vec2 normal = ( cross( vec3( dir, 0. ), vec3( 0., 0., 1. ) ) ).xy;',
	'    vec2 normal = vec2( -dir.y, dir.x );',
	'    normal.x /= aspect;',
	'    normal *= .5 * w;',
	'',
	'    vec4 offset = vec4( normal * side, 0.0, 1.0 );',
	'    finalPosition.xy += offset.xy;',
	'',
	'    gl_Position = finalPosition;',
	'',
	'}' ];
	
		var fragmentShaderSource = [
			'#extension GL_OES_standard_derivatives : enable',
	'precision mediump float;',
	'',
	'uniform sampler2D map;',
	'uniform sampler2D alphaMap;',
	'uniform float useMap;',
	'uniform float useAlphaMap;',
	'uniform float useDash;',
	'uniform vec2 dashArray;',
	'uniform float visibility;',
	'uniform float alphaTest;',
	'uniform vec2 repeat;',
	'',
	'varying vec2 vUV;',
	'varying vec4 vColor;',
	'varying float vCounters;',
	'',
	'void main() {',
	'',
	'    vec4 c = vColor;',
	'    if( useMap == 1. ) c *= texture2D( map, vUV * repeat );',
	'    if( useAlphaMap == 1. ) c.a *= texture2D( alphaMap, vUV * repeat ).a;',
	'	 if( c.a < alphaTest ) discard;',
	'	 if( useDash == 1. ){',
	'	 	 ',
	'	 }',
	'    gl_FragColor = c;',
	'	 gl_FragColor.a *= step(vCounters,visibility);',
	'}' ];
	
		function check( v, d ) {
			if( v === undefined ) return d;
			return v;
		}
	
		THREE.Material.call( this );
	
		parameters = parameters || {};
	
		this.lineWidth = check( parameters.lineWidth, 1 );
		this.map = check( parameters.map, null );
		this.useMap = check( parameters.useMap, 0 );
		this.alphaMap = check( parameters.alphaMap, null );
		this.useAlphaMap = check( parameters.useAlphaMap, 0 );
		this.color = check( parameters.color, new THREE.Color( 0xffffff ) );
		this.opacity = check( parameters.opacity, 1 );
		this.resolution = check( parameters.resolution, new THREE.Vector2( 1, 1 ) );
		this.sizeAttenuation = check( parameters.sizeAttenuation, 1 );
		this.near = check( parameters.near, 1 );
		this.far = check( parameters.far, 1 );
		this.dashArray = check( parameters.dashArray, [] );
		this.useDash = ( this.dashArray !== [] ) ? 1 : 0;
		this.visibility = check( parameters.visibility, 1 );
		this.alphaTest = check( parameters.alphaTest, 0 );
		this.repeat = check( parameters.repeat, new THREE.Vector2( 1, 1 ) );
	
		var material = new THREE.RawShaderMaterial( {
			uniforms:{
				lineWidth: { type: 'f', value: this.lineWidth },
				map: { type: 't', value: this.map },
				useMap: { type: 'f', value: this.useMap },
				alphaMap: { type: 't', value: this.alphaMap },
				useAlphaMap: { type: 'f', value: this.useAlphaMap },
				color: { type: 'c', value: this.color },
				opacity: { type: 'f', value: this.opacity },
				resolution: { type: 'v2', value: this.resolution },
				sizeAttenuation: { type: 'f', value: this.sizeAttenuation },
				near: { type: 'f', value: this.near },
				far: { type: 'f', value: this.far },
				dashArray: { type: 'v2', value: new THREE.Vector2( this.dashArray[ 0 ], this.dashArray[ 1 ] ) },
				useDash: { type: 'f', value: this.useDash },
				visibility: {type: 'f', value: this.visibility},
				alphaTest: {type: 'f', value: this.alphaTest},
				repeat: { type: 'v2', value: this.repeat }
			},
			vertexShader: vertexShaderSource.join( '\r\n' ),
			fragmentShader: fragmentShaderSource.join( '\r\n' )
		});
	
		delete parameters.lineWidth;
		delete parameters.map;
		delete parameters.useMap;
		delete parameters.alphaMap;
		delete parameters.useAlphaMap;
		delete parameters.color;
		delete parameters.opacity;
		delete parameters.resolution;
		delete parameters.sizeAttenuation;
		delete parameters.near;
		delete parameters.far;
		delete parameters.dashArray;
		delete parameters.visibility;
		delete parameters.alphaTest;
		delete parameters.repeat;
	
		material.type = 'MeshLineMaterial';
	
		material.setValues( parameters );
	
		return material;
	
	};
	
	MeshLineMaterial.prototype = Object.create( THREE.Material.prototype );
	MeshLineMaterial.prototype.constructor = MeshLineMaterial;
	
	MeshLineMaterial.prototype.copy = function ( source ) {
	
		THREE.Material.prototype.copy.call( this, source );
	
		this.lineWidth = source.lineWidth;
		this.map = source.map;
		this.useMap = source.useMap;
		this.alphaMap = source.alphaMap;
		this.useAlphaMap = source.useAlphaMap;
		this.color.copy( source.color );
		this.opacity = source.opacity;
		this.resolution.copy( source.resolution );
		this.sizeAttenuation = source.sizeAttenuation;
		this.near = source.near;
		this.far = source.far;
		this.dashArray.copy( source.dashArray );
		this.useDash = source.useDash;
		this.visibility = source.visibility;
		this.alphaTest = source.alphaTest;
		this.repeat.copy( source.repeat );
	
		return this;
	
	};
	
	if( true ) {
		if( typeof module !== 'undefined' && module.exports ) {
			exports = module.exports = { MeshLine: MeshLine, MeshLineMaterial: MeshLineMaterial };
		}
		exports.MeshLine = MeshLine;
		exports.MeshLineMaterial = MeshLineMaterial;
	}
	else {
		root.MeshLine = MeshLine;
		root.MeshLineMaterial = MeshLineMaterial;
	}
	
	}).call(this);
	


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/alarm-color.81acc0b1.png";

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/employees.da00ccf4.png";

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/login.41f8cc89.png";

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/team.a6c2cdac.png";

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 761 */,
/* 762 */,
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _regenerator = __webpack_require__(868);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(867);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _emailerServer = __webpack_require__(859);
	
	var _emailerServer2 = _interopRequireDefault(_emailerServer);
	
	var _analytics = __webpack_require__(57);
	
	__webpack_require__(1098);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailLookup = function (_PureComponent) {
	  (0, _inherits3.default)(EmailLookup, _PureComponent);
	
	  function EmailLookup() {
	    (0, _classCallCheck3.default)(this, EmailLookup);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call(this));
	
	    _this.state = {
	      email: '',
	      apps: '',
	
	      loading: false,
	      found: false,
	      step: 1,
	      error: false
	    };
	
	    _this.handleChange = function (state) {
	      return function (_ref) {
	        var _this$setState;
	
	        var value = _ref.target.value;
	        return _this.setState((_this$setState = {}, _this$setState[state] = value, _this$setState));
	      };
	    };
	
	    _this.renderStep1 = function () {
	      var email = _this.state.email;
	
	
	      return ['In order to review your TrustKit dashboard, please enter your corporate email address below', _react2.default.createElement(
	        'form',
	        { key: 'form', onSubmit: _this.handleSubmit, className: 'inputWrapper' },
	        _react2.default.createElement('input', {
	          type: 'email',
	          id: 'email',
	          name: 'email',
	          label: 'Email',
	          required: true,
	          placeholder: 'you@example.com',
	          onChange: _this.handleChange('email'),
	          value: email
	        }),
	        _react2.default.createElement(
	          _reactMd.Button,
	          {
	            flat: true,
	            style: { marginLeft: 10, minWidth: 'unset', padding: '0' },
	            onClick: _this.handleSubmit,
	            primary: true,
	            disabled: email.length < 1
	          },
	          _react2.default.createElement(
	            _reactMd.FontIcon,
	            { className: 'inputButtonFont' },
	            'navigate_next'
	          )
	        )
	      )];
	    };
	
	    _this.renderStep2 = function () {
	      var _this$state = _this.state,
	          apps = _this$state.apps,
	          found = _this$state.found;
	
	
	      if (found) {
	        // If emailer server returned 204
	        // email exist on our system
	        return _react2.default.createElement(
	          'div',
	          { className: 'result' },
	          'A link for your dashboard has been sent to your email!'
	        );
	      }
	
	      return ['We were unable to cross link your email address with TrustKit data.', _react2.default.createElement('br', { key: 'br' }), 'Please enter your app link or bundle id below', _react2.default.createElement(
	        'form',
	        { key: 'form', onSubmit: _this.handleSubmit, className: 'inputWrapper' },
	        _react2.default.createElement('textarea', {
	          rows: '3',
	          required: true,
	          placeholder: 'https://itunes.apple.com/us/app/apple-store/id375380948?mt=8 https://play.google.com/store/apps/details?id=com.datatheorem.android.p1app ',
	          onChange: _this.handleChange('apps'),
	          value: apps
	        }),
	        _react2.default.createElement(
	          _reactMd.Button,
	          {
	            flat: true,
	            primary: true,
	            disabled: apps.length < 1,
	            onClick: _this.handleSubmit
	          },
	          'Go'
	        )
	      )];
	    };
	
	    _this.renderStep3 = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'result' },
	        'Thank you. We will get in contact with you shortly.'
	      );
	    };
	
	    _this.renderContent = function () {
	      var _this$state2 = _this.state,
	          step = _this$state2.step,
	          error = _this$state2.error;
	
	
	      var errorMessage = _react2.default.createElement(
	        'div',
	        { className: 'result' },
	        'An error occurred. Sorry about that! Try again later.'
	      );
	
	      if (error) {
	        return errorMessage;
	      }
	
	      if (step === 1) return _this.renderStep1();
	      if (step === 2) return _this.renderStep2();
	      if (step === 3) return _this.renderStep3();
	      return errorMessage;
	    };
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  // Apparently, babel is messing up with async arrow functions
	  // as class methods. So we use the old way
	  EmailLookup.prototype.handleSubmit = function () {
	    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
	      var _state, email, apps, step, postData, _ref3, ok;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              e.preventDefault();
	
	              _state = this.state, email = _state.email, apps = _state.apps, step = _state.step;
	
	
	              this.setState({
	                loading: true,
	                found: false
	              });
	
	              postData = {
	                email: email,
	                apps: apps
	              };
	              _context.prev = 4;
	              _context.next = 7;
	              return _emailerServer2.default.send(postData);
	
	            case 7:
	              _ref3 = _context.sent;
	              ok = _ref3.ok;
	
	
	              // Grab analytics only on step 1 for discovery
	              if (step === 1) {
	                (0, _analytics.trackEvent)(ok ? { category: 'Discovery', action: 'Discovery Success' } : { category: 'Discovery', action: 'Discovery Failure - Domain' });
	              }
	
	              if (step === 2) {
	                (0, _analytics.trackEvent)({
	                  category: 'Discovery',
	                  action: 'Discovery Submit App'
	                });
	              }
	
	              // EmailerServer returns 400 if email is not registered or validation error.
	              // We should prob verify using `data` if there is a validation error
	              this.setState({
	                found: ok
	              });
	              _context.next = 18;
	              break;
	
	            case 14:
	              _context.prev = 14;
	              _context.t0 = _context['catch'](4);
	
	              (0, _analytics.trackEvent)({
	                category: 'Discovery',
	                action: 'Discovery Failure - Connection'
	              });
	              this.setState({
	                error: true
	              });
	
	            case 18:
	              _context.prev = 18;
	
	              // Not loading anymore, go to next step
	              this.setState(function (state) {
	                return {
	                  loading: false,
	                  step: state.step + 1
	                };
	              });
	              return _context.finish(18);
	
	            case 21:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[4, 14, 18, 21]]);
	    }));
	
	    function handleSubmit(_x) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return handleSubmit;
	  }();
	
	  EmailLookup.prototype.render = function render() {
	    var loading = this.state.loading;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'emailLookup' },
	      loading && _react2.default.createElement(_reactMd.LinearProgress, { id: 'loading' }),
	      !loading && this.renderContent()
	    );
	  };
	
	  return EmailLookup;
	}(_react.PureComponent);
	
	exports.default = EmailLookup;
	module.exports = exports['default'];

/***/ }),
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Portal = __webpack_require__(1169);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _LegacyPortal = __webpack_require__(1168);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portal = void 0;
	
	if (_reactDom2.default.createPortal) {
	  Portal = _Portal2.default;
	} else {
	  Portal = _LegacyPortal2.default;
	}
	
	exports.default = Portal;

/***/ }),
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _analytics = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentExperiment = function (_PureComponent) {
	  (0, _inherits3.default)(ContentExperiment, _PureComponent);
	
	  function ContentExperiment() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ContentExperiment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
	      variationIndex: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  ContentExperiment.prototype.componentDidMount = function componentDidMount() {
	    var contentExperimentsAPI = typeof window === 'object' ? window.cxApi : null;
	    if (contentExperimentsAPI && contentExperimentsAPI.chooseVariation) {
	      this.setState({
	        variationIndex: contentExperimentsAPI.chooseVariation()
	      });
	
	      // If this occurs after the google analytics plugin records the page
	      // view (which it probably does), then we need to send some sort of
	      // activity to Google Analytics for it to record the result of the
	      // experiment. Here we use a "non-interactive" event.
	      // https://developers.google.com/analytics/solutions/experiments-client-side
	      // https://www.lunametrics.com/blog/2014/05/06/noninteraction-events-google-analytics/
	      (0, _analytics.trackEvent)({
	        category: 'ContentExperiment',
	        action: 'Viewed',
	        fieldsObject: { nonInteraction: 1 }
	      });
	    }
	  };
	
	  ContentExperiment.prototype.render = function render() {
	    var _props = this.props,
	        renderVariations = _props.renderVariations,
	        _props$renderLoading = _props.renderLoading,
	        renderLoading = _props$renderLoading === undefined ? function () {
	      return null;
	    } : _props$renderLoading,
	        _props$renderError = _props.renderError,
	        renderError = _props$renderError === undefined ? function () {
	      return null;
	    } : _props$renderError;
	    var variationIndex = this.state.variationIndex;
	
	
	    if (variationIndex === null) {
	      return renderLoading({ renderVariations: renderVariations });
	    }
	
	    if (!renderVariations || typeof renderVariations[variationIndex] !== 'function') {
	      return renderError({ renderVariations: renderVariations, variationIndex: variationIndex });
	    }
	
	    return renderVariations[variationIndex]();
	  };
	
	  return ContentExperiment;
	}(_react.PureComponent);
	
	exports.default = ContentExperiment;
	module.exports = exports['default'];

/***/ }),
/* 851 */,
/* 852 */,
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortal = __webpack_require__(1171);
	
	var _EmailLookup = __webpack_require__(763);
	
	var _EmailLookup2 = _interopRequireDefault(_EmailLookup);
	
	__webpack_require__(1100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeaserBanner = function (_PureComponent) {
	  (0, _inherits3.default)(TeaserBanner, _PureComponent);
	
	  function TeaserBanner() {
	    (0, _classCallCheck3.default)(this, TeaserBanner);
	    return (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
	  }
	
	  TeaserBanner.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactPortal.Portal,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'TeaserBanner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'TeaserInner' },
	          'The data you are viewing breaks down TrustKit analysis for a sample app. ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_EmailLookup2.default, null)
	        )
	      )
	    );
	  };
	
	  return TeaserBanner;
	}(_react.PureComponent);
	
	exports.default = TeaserBanner;
	module.exports = exports['default'];

/***/ }),
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(21);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(184);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(34);
	
	var _index = __webpack_require__(526);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ContentExperiment = __webpack_require__(850);
	
	var _ContentExperiment2 = _interopRequireDefault(_ContentExperiment);
	
	var _EmailLookup = __webpack_require__(763);
	
	var _EmailLookup2 = _interopRequireDefault(_EmailLookup);
	
	var _ = __webpack_require__(525);
	
	var _2 = _interopRequireDefault(_);
	
	var _TeaserBanner = __webpack_require__(853);
	
	var _TeaserBanner2 = _interopRequireDefault(_TeaserBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFakeBundleSummary(fromBundle) {
	  return (0, _extends3.default)({}, fromBundle, {
	    app_name: 'Your App',
	    app_url: null,
	    bundle_id: 'com.yourcompany.app',
	    company: 'Your Company (Sample)',
	    management: []
	  });
	}
	
	var Wrapper = function Wrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { style: { margin: '200px auto 50px auto', maxWidth: 600 } },
	    children
	  );
	};
	
	var IndexPage = function (_PureComponent) {
	  (0, _inherits3.default)(IndexPage, _PureComponent);
	
	  function IndexPage() {
	    (0, _classCallCheck3.default)(this, IndexPage);
	    return (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var sampleReport = function sampleReport() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'sample-report' },
	        _react2.default.createElement(_index2.default, (0, _extends3.default)({}, _this2.props, {
	          forceFiveStar: true,
	          data: {
	            bundleSummary: getFakeBundleSummary(_this2.props.data.bundleSummary)
	          }
	        })),
	        _react2.default.createElement(_TeaserBanner2.default, null)
	      );
	    };
	
	    return _react2.default.createElement(_ContentExperiment2.default, {
	      renderLoading: function renderLoading() {
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(_reactMd.CircularProgress, { id: 'loading' })
	        );
	      },
	      renderError: function renderError() {
	        return _react2.default.createElement(_2.default, null);
	      },
	      renderVariations: [sampleReport, function () {
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(_EmailLookup2.default, null)
	        );
	      }, sampleReport]
	    });
	  };
	
	  return IndexPage;
	}(_react.PureComponent);
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),
/* 858 */,
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _stringify = __webpack_require__(764);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	__webpack_require__(1210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* ::
	  type EmailerPostBody {
	    email: string,
	    apps?: string
	   };
	*/
	
	exports.default = {
	  send: function send(data /* :EmailerPostBody */) {
	    return fetch('https://trustkit-analytics-emailer.appspot.com/', {
	      method: 'POST',
	      headers: {
	        'Content-Type': 'application/json; charset=utf-8'
	      },
	      body: (0, _stringify2.default)(data)
	    });
	  }
	  // .then(request => request.json()),
	};
	module.exports = exports['default'];

/***/ }),
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 1099 */,
/* 1100 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file is a fallback for a consumer who is not yet on React 16
	// as createPortal was introduced in React 16
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDom2.default.unmountComponentAtNode(this.defaultNode || this.props.node);
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	      this.portal = null;
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	
	      var children = this.props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof this.props.children.type === 'function') {
	        children = _react2.default.cloneElement(this.props.children);
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(1172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!_utils.canUseDOM) {
	        return null;
	      }
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	      return _reactDom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};
	
	exports.default = Portal;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PortalCompat = __webpack_require__(833);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var PortalWithState = function (_React$Component) {
	  _inherits(PortalWithState, _React$Component);
	
	  function PortalWithState(props) {
	    _classCallCheck(this, PortalWithState);
	
	    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
	
	    _this.portalNode = null;
	    _this.state = { active: !!props.defaultOpen };
	    _this.openPortal = _this.openPortal.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass(PortalWithState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (this.state.active) {
	        return;
	      }
	      if (e && e.nativeEvent) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	      this.setState({ active: true }, this.props.onOpen);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (!this.state.active) {
	        return;
	      }
	      this.setState({ active: false }, this.props.onClose);
	    }
	  }, {
	    key: 'wrapWithPortal',
	    value: function wrapWithPortal(children) {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _PortalCompat2.default,
	        {
	          node: this.props.node,
	          key: 'react-portal',
	          ref: function ref(portalNode) {
	            return _this2.portalNode = portalNode;
	          }
	        },
	        children
	      );
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      var root = this.portalNode.props.node || this.portalNode.defaultNode;
	      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        openPortal: this.openPortal,
	        closePortal: this.closePortal,
	        portal: this.wrapWithPortal,
	        isOpen: this.state.active
	      });
	    }
	  }]);
	
	  return PortalWithState;
	}(_react2.default.Component);
	
	PortalWithState.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  defaultOpen: _propTypes2.default.bool,
	  node: _propTypes2.default.any,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func
	};
	
	PortalWithState.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {}
	};
	
	exports.default = PortalWithState;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PortalWithState = exports.Portal = undefined;
	
	var _PortalCompat = __webpack_require__(833);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	var _PortalWithState = __webpack_require__(1170);
	
	var _PortalWithState2 = _interopRequireDefault(_PortalWithState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Portal = _PortalCompat2.default;
	exports.PortalWithState = _PortalWithState2.default;

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1203);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-jsx-2a7959ea061257b3cad4.js